import * as React from 'react';
import React__default, { useState, useEffect, useRef, useMemo, useCallback, useLayoutEffect, createRef, Fragment } from 'react';
import { createTheme, makeStyles, styled, withStyles as withStyles$1, withTheme as withTheme$1, StylesProvider, ThemeProvider } from '@material-ui/core/styles';
import { alpha } from '@material-ui/core/styles/colorManipulator';
import get$1 from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { MenuItem, Box as Box$1, ClickAwayListener, useMediaQuery as useMediaQuery$1, MenuList, Slide, Grid as Grid$1, Typography as Typography$1, makeStyles as makeStyles$1, Portal, Collapse as Collapse$1, alpha as alpha$1, TextField as TextField$1 } from '@material-ui/core';
import debounce$1 from '@material-ui/core/utils/debounce';
import { animateScroll, scroller } from 'react-scroll';
import PropTypes from 'prop-types';
import capitalize from '@material-ui/core/utils/capitalize';
import withStyles from '@material-ui/core/styles/withStyles';
import MatLink from '@material-ui/core/Link';
import SvgIcon$1 from '@material-ui/core/SvgIcon';
import { styleFunctionSx, compose, borders as borders$1, display, flexbox, positions, palette, shadows, sizing, spacing, typography } from '@material-ui/system';
import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import debounce from 'lodash/debounce';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { duration } from '@material-ui/core/styles/transitions';
import { createHistory, navigate } from '@reach/router';
import Paper from '@material-ui/core/Paper';
import ButtonBase from '@material-ui/core/ButtonBase';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import MenuItem$1 from '@material-ui/core/MenuItem';
import PopperProxy from '@material-ui/core/Popper';
import Collapse from '@material-ui/core/Collapse';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import ReactResizeDetector from 'react-resize-detector';
import Accordion$1 from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Tooltip from '@material-ui/core/Tooltip';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import Select$1 from '@material-ui/core/Select/Select';
import MenuItem$2 from '@material-ui/core/MenuItem/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import ListSubheader from '@material-ui/core/ListSubheader';
import Chip$1 from '@material-ui/core/Chip';
import setRef from '@material-ui/core/utils/setRef';
import useEventCallback from '@material-ui/core/utils/useEventCallback';
import values from 'lodash/values';
import transform from 'lodash/transform';
import LinearProgress$1 from '@material-ui/core/LinearProgress';
import QRCode from 'qrcode.react';
import defaultsDeep from 'lodash/defaultsDeep';
import ReactPlayerLoader from '@brightcove/react-player-loader';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import useVisibilitySensor from '@rooks/use-visibility-sensor';
import findIndex from 'lodash/findIndex';
import times from 'lodash/times';
import has from 'lodash/has';
import set from 'lodash/set';
import NoSsr from '@material-ui/core/NoSsr';
import Slider from 'react-slick';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import kebabCase from 'lodash/kebabCase';
import find from 'lodash/find';
import lowerCase from 'lodash/lowerCase';
import startCase from 'lodash/startCase';
import pick from 'lodash/pick';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import Truncate from 'react-truncate';
import TruncateMarkup from 'react-truncate-markup';
import CardContent from '@material-ui/core/CardContent';
import Box$2 from '@material-ui/core/Box';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var noRadius = '0';
var smallRadius = '4px';
var mediumRadius = '16px';
var largeRadius = '24px';
var xLargeRadius = '40px';
var circleRadius = '50%';
var borders = {
  '.noBorderRadiusTopLeft': {
    borderTopLeftRadius: noRadius
  },
  '.noBorderRadiusTopRight': {
    borderTopRightRadius: noRadius
  },
  '.noBorderRadiusBottomLeft': {
    borderBottomLeftRadius: noRadius
  },
  '.noBorderRadiusBottomRight': {
    borderBottomRightRadius: noRadius
  },
  '.borderRadiusSmallTopLeft': {
    borderTopLeftRadius: smallRadius
  },
  '.borderRadiusSmallTopRight': {
    borderTopRightRadius: smallRadius
  },
  '.borderRadiusSmallBottomLeft': {
    borderBottomLeftRadius: smallRadius
  },
  '.borderRadiusSmallBottomRight': {
    borderBottomRightRadius: smallRadius
  },
  '.borderRadiusMediumTopLeft': {
    borderTopLeftRadius: mediumRadius
  },
  '.borderRadiusMediumTopRight': {
    borderTopRightRadius: mediumRadius
  },
  '.borderRadiusMediumBottomLeft': {
    borderBottomLeftRadius: mediumRadius
  },
  '.borderRadiusMediumBottomRight': {
    borderBottomRightRadius: mediumRadius
  },
  '.borderRadiusLargeTopLeft': {
    borderTopLeftRadius: largeRadius
  },
  '.borderRadiusLargeTopRight': {
    borderTopRightRadius: largeRadius
  },
  '.borderRadiusLargeBottomLeft': {
    borderBottomLeftRadius: largeRadius
  },
  '.borderRadiusLargeBottomRight': {
    borderBottomRightRadius: largeRadius
  },
  '.borderRadiusCircleTopLeft': {
    borderTopLeftRadius: circleRadius
  },
  '.borderRadiusCircleTopRight': {
    borderTopRightRadius: circleRadius
  },
  '.borderRadiusCircleBottomLeft': {
    borderBottomLeftRadius: circleRadius
  },
  '.borderRadiusCircleBottomRight': {
    borderBottomRightRadius: circleRadius
  },
  '.borderRadiusXLargeTopLeft': {
    borderTopLeftRadius: xLargeRadius
  },
  '.borderRadiusXLargeTopRight': {
    borderTopRightRadius: xLargeRadius
  },
  '.borderRadiusXLargeBottomLeft': {
    borderBottomLeftRadius: xLargeRadius
  },
  '.borderRadiusXLargeBottomRight': {
    borderBottomRightRadius: xLargeRadius
  },
  '.allBorderRadiusSmall': {
    borderRadius: smallRadius
  },
  '.allBorderRadiusMedium': {
    borderRadius: mediumRadius
  },
  '.allBorderRadiusLarge': {
    borderRadius: largeRadius
  },
  '.allBorderRadiusCircle': {
    borderRadius: circleRadius
  },
  '.allBorderRadiusXLarge': {
    borderRadius: xLargeRadius
  },
  '.noBorderRadius': {
    borderRadius: noRadius
  }
};

var padding = {
  '.paddingTopNone': {
    paddingTop: '0'
  },
  '.paddingBottomNone': {
    paddingBottom: '0'
  },
  '.paddingTopMedium': {
    paddingTop: '64px',
    '@media (max-width: 600px)': {
      paddingTop: '48px'
    }
  },
  '.paddingBottomMedium': {
    paddingBottom: '64px',
    '@media (max-width: 600px)': {
      paddingBottom: '48px'
    }
  },
  '.paddingTopLarge': {
    paddingTop: '96px',
    '@media (max-width: 600px)': {
      paddingTop: '64px'
    }
  },
  '.paddingBottomLarge': {
    paddingBottom: '96px',
    '@media (max-width: 600px)': {
      paddingBottom: '64px'
    }
  }
};

var languages = [{
  code: 'lang-EN'
}, {
  code: 'lang-TH'
}, {
  code: 'lang-ZH-HK'
}, {
  code: 'lang-JA-JP'
}, {
  code: 'lang-ID'
}];
var siteCodes = {
  th: 'NotoSansThai',
  hk: 'NotoSansTC',
  vi: 'CircularViet',
  jp: 'NotoSansJP'
};
var fontStyles$1 = {};
languages.forEach(function (language) {
  fontStyles$1[".".concat(language.code)] = getFontStyles(language.code);
});

function getFontStyles(code) {
  var font = 'FWDCircularWeb, Arial !important';

  if (code === 'lang-EN') {
    font = 'FWDCircularWeb, sans-serif !important';
  } else if (code === 'lang-VI') {
    font = 'CircularViet, sans-serif !important';
  } else if (code === 'lang-TH') {
    font = 'NotoSansThai, NotoSans, sans-serif !important';
  } else if (code === 'lang-ZH-HK') {
    font = 'NotoSansTC, NotoSans, sans-serif !important';
  } else if (code === 'lang-JA-JP') {
    font = 'FWDCircularWeb, NotoSansJP, NotoSans, sans-serif !important';
  }

  var marketEN = {};
  Object.keys(siteCodes).map(function (siteCode) {
    return marketEN["&.".concat(siteCode, " *")] = {
      fontFamily: font.replace('FWDCircularWeb,', "FWDCircularWeb, ".concat(siteCodes[siteCode], ","))
    };
  });

  var styles = _objectSpread2({
    '& *': {
      fontFamily: "".concat(font)
    }
  }, code === 'lang-EN' ? marketEN : {});

  return styles;
}

var getMapFont = function getMapFont(code) {
  var mapFontFamily = 'FWDCircularWeb, Arial !important';

  if (code === 'lang-EN') {
    mapFontFamily = 'FWDCircularWeb, sans-serif !important';
  } else if (code === 'lang-VI') {
    mapFontFamily = 'CircularViet, sans-serif !important';
  } else if (code === 'lang-TH') {
    mapFontFamily = 'NotoSansThai, NotoSans, sans-serif !important';
  } else if (code === 'lang-ZH-HK') {
    mapFontFamily = 'NotoSansTC, NotoSans, sans-serif !important';
  } else if (code === 'lang-JA-JP') {
    mapFontFamily = 'FWDCircularWeb, NotoSansJP, NotoSans, sans-serif !important';
  }

  return mapFontFamily;
};

var globals = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, borders), padding), fontStyles$1), {}, {
  body: {
    margin: '0',
    overflowX: 'hidden',
    fontSynthesis: 'none' //for safari only

  },
  section: {
    position: 'relative'
  },
  '.mergedContainer + section .MuiContainer-root': {
    paddingTop: '64px'
  },
  '@media only screen and (max-width: 600px)': {
    '.mergedContainer + section .MuiContainer-root': {
      paddingTop: '48px'
    }
  },
  '*, ::after, ::before': {
    boxSizing: 'border-box'
  },

  /* added global svg dimension*/
  svg: {
    maxWidth: '96px',
    maxHeight: '96px'
  }
});

function getTypographyClasses(brandings, theme, colors, color) {
  //For background & text colors
  brandings[".bgText-color-".concat(color)] = {
    backgroundColor: colors[color].main,
    '& [data-locator="Form-Section-Checkbox"] .MuiTypography-root.MuiTypography-body1 a': {
      color: colors[color].contrastText,
      '&:hover': {
        color: colors[color].contrastTextAction
      }
    }
  }; //For text colors

  brandings[".text-color-".concat(color)] = {
    color: colors[color].contrastText,
    '& svg': {
      color: colors[color].contrastTextAction,
      '& path': {
        fill: colors[color].contrastTextAction
      }
    }
  }; //For label colors

  brandings[".label-color-".concat(color)] = {
    color: colors[color].contrastTextLabel
  }; //For caption colors

  brandings[".caption-color-".concat(color)] = {
    color: colors[color].contrastTextCaption
  };
}

/* Const defination */
var BASE_FONT_SIZE = 16;
var SPACING_MULTIPLIER = 8;
var fontWeights = {
  normal: '300',
  bold: '500',
  bolder: '700'
};
var fontStyles = {
  normal: 'normal',
  italic: 'italic'
};
/* Function */

var pxToRem = function pxToRem(pixelValue) {
  return "".concat(pixelValue / BASE_FONT_SIZE, "rem");
};
var space = function space() {
  var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return suffix ? "".concat(num * SPACING_MULTIPLIER, "px") : num * SPACING_MULTIPLIER;
};
var fontSize = {
  T0: pxToRem(61),
  T1: pxToRem(49),
  T2: pxToRem(39),
  T3: pxToRem(31),
  T4: pxToRem(25),
  T5: pxToRem(20),
  T6: pxToRem(16),
  T7: pxToRem(13),
  T8: pxToRem(10),
  T9: pxToRem(8),
  T10: pxToRem(24),
  T11: pxToRem(14)
};
var lineHeight = {
  L0: pxToRem(76),
  L1: pxToRem(61),
  L2: pxToRem(49),
  L3: pxToRem(39),
  L4: pxToRem(38),
  L5: pxToRem(30),
  L6: pxToRem(31),
  L7: pxToRem(24),
  L8: pxToRem(25),
  L9: pxToRem(20),
  L10: pxToRem(16),
  L11: pxToRem(42),
  L12: pxToRem(40),
  L13: pxToRem(13),
  L14: pxToRem(21),
  L15: pxToRem(18),
  L16: pxToRem(10)
};
var breakpoints = {
  keys: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl'],
  values: {
    xs: 0,
    sm: 600,
    md: 720,
    lg: 960,
    xl: 1288,
    xxl: 1680,
    xxxl: 1920
  }
};
var easing = function easing(ease) {
  var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
  var easingArr = {
    in: "".concat(prop, " 0.3s cubic-bezier(0.755, 0.050, 0.855, 0.060)"),
    out: "".concat(prop, " 0.3s cubic-bezier(0.230, 1.000, 0.320, 1.000)"),
    inOut: "".concat(prop, " 0.3s cubic-bezier(0.860, 0.000, 0.070, 1.000)")
  };
  return easingArr[ease];
};
var fwdColors = {
  orange: '#E87722',
  orangeLight: '#FAE4D3',
  orangeDark: '#804113',
  orangeLighter: '#FEF9F4',
  white: '#FFFFFF',
  darkGreen: '#183028',
  grey: '#dbdfe1',
  greyDark: '#B3B6B8',
  greyDarker: '#8B8E8F',
  greyDarkest: '#636566',
  red: '#B30909',
  redLight: '#FEF3F3',
  green: '#038752',
  greenLight: '#F2F9F7',
  fwdLogo: '#25484C',
  black: '#000000'
};

function getIconClasses(brandings, theme, colors, color) {
  var brandingIcon = theme.palette[colors[color].icon].icon.brandingIcon;
  var brandingIconPrimary = theme.palette[colors[color].icon].icon.brandingIconPrimary;
  var brandingIconSecondary = theme.palette[colors[color].icon].icon.brandingIconSecondary;
  brandings[".icon-simple-".concat(color)] = {
    '& svg': {
      color: colors[color].contrastTextAction,
      '& path': {
        fill: colors[color].contrastTextAction
      }
    }
  };
  brandings[".icon-action-dropDown-".concat(color)] = {
    color: colors[color].contrastText,
    '& svg': {
      '& path': {
        fill: colors[color].contrastTextAction
      }
    },
    '&:hover': {
      '& path': {
        fill: colors[color].main
      }
    }
  };
  brandings[".icon-action-".concat(color)] = {
    '& svg': {
      color: colors[color].contrastTextAction,
      '& path': {
        fill: colors[color].contrastTextAction
      },
      '&:hover': {
        backgroundColor: alpha(fwdColors.orange, 0.2)
      }
    }
  };
  brandings['.icon-two-tone'] = {
    '& circle': {
      fill: fwdColors.orange
    },
    '& path': {
      transform: 'translate(8px, 8px) scale(0.7)',
      fill: fwdColors.white
    },
    '&:hover': {
      '& circle': {
        fill: fwdColors.white
      },
      '& path': {
        fill: fwdColors.orange
      }
    }
  };
  brandings[".branding-icon-primary-".concat(color)] = {
    backgroundColor: brandingIconPrimary.background.default,
    color: brandingIconPrimary.contrastText.default,
    '& svg': {
      color: brandingIconPrimary.contrastText.default
    }
  };
  brandings[".branding-icon-primary-".concat(color, "-hovered")] = {
    backgroundColor: brandingIconPrimary.background.hover,
    color: brandingIconPrimary.contrastText.hover,
    '& svg': {
      color: brandingIconPrimary.contrastText.hover
    }
  };
  brandings[".branding-icon-primary-".concat(color, "-default")] = {
    color: colors[color].contrastTextAction,
    '& svg': {
      color: colors[color].contrastTextAction
    }
  };
  brandings[".branding-icon-primary-".concat(color, "-hovered-default")] = {
    border: "2px solid ".concat(alpha(colors[color].contrastTextAction, 0.2)),
    '& svg': {
      backgroundColor: alpha(colors[color].contrastTextAction, 0.2)
    }
  };
  brandings[".branding-icon-secondary-".concat(color)] = {
    backgroundColor: brandingIconSecondary.background.default,
    color: brandingIconSecondary.contrastText.default,
    '& svg': {
      color: brandingIconSecondary.contrastText.default
    }
  };
  brandings[".branding-icon-secondary-".concat(color, "-hovered")] = {
    backgroundColor: brandingIconSecondary.background.hover,
    color: brandingIconSecondary.contrastText.hover,
    '& svg': {
      color: brandingIconSecondary.contrastText.hover
    }
  };
  brandings[".branding-icon-secondary-".concat(color, "-default")] = {
    color: colors[color].contrastText,
    '& svg': {
      color: colors[color].contrastText
    }
  };
  brandings[".branding-icon-secondary-".concat(color, "-hovered-default")] = {
    border: "2px solid ".concat(alpha(colors[color].contrastTextAction, 0.2)),
    '& svg': {
      backgroundColor: alpha(colors[color].contrastTextAction, 0.2)
    }
  };
  brandings['.branding-icon-circle'] = {
    boxShadow: brandingIcon.shadowCircle.default
  };
  brandings['.branding-icon-square'] = {
    boxShadow: brandingIcon.shadowSquare.default
  };
  brandings['.branding-icon-hovered-circle'] = {
    boxShadow: brandingIcon.shadowCircle.hover
  };
  brandings['.branding-icon-hovered-square'] = {
    boxShadow: brandingIcon.shadowSquare.hover
  };
  brandings[".icon-close-".concat(color)] = {
    '& .MuiDialog-closeButton': {
      '& svg': {
        color: colors[color].closeBtn,
        '& path': {
          fill: colors[color].closeBtn
        },
        '&:hover': {
          backgroundColor: alpha(colors[color].contrastTextAction, 0.2),
          '& path': {
            fill: colors[color].closeBtn
          }
        }
      }
    }
  };
}

function getLinksClasses(brandings, theme, colors, color) {
  var _brandings$LinkCapt;

  //For link of action type
  brandings[".link-action-".concat(color)] = {
    color: colors[color].contrastTextAction,
    fontWeight: theme.typography.fontWeights.bolder,
    borderRadius: '4px',
    border: '4px solid transparent',
    '& a': {
      color: colors[color].contrastTextAction
    },
    '& path': {
      fill: colors[color].contrastTextAction
    },
    '@media (hover: hover), all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
      '&:hover': {
        backgroundColor: alpha(colors[color].contrastTextAction, 0.2)
      }
    }
  }; //For link of caption type

  brandings[".link-caption-".concat(color)] = (_brandings$LinkCapt = {
    borderRadius: '4px',
    color: colors[color].contrastText,
    fontWeight: theme.typography.fontWeights.bolder
  }, _defineProperty(_brandings$LinkCapt, theme.breakpoints.up('sm'), {
    border: '4px solid transparent',
    '&:hover': {
      backgroundColor: alpha(colors[color].contrastTextAction, 0.2)
    }
  }), _defineProperty(_brandings$LinkCapt, '& a', {
    color: colors[color].contrastText
  }), _defineProperty(_brandings$LinkCapt, '& svg', {
    '& path': {
      fill: colors[color].contrastTextAction
    }
  }), _brandings$LinkCapt); //For link of hyperlink type

  brandings[".hyperlink-".concat(color)] = {
    '&:hover': _defineProperty({
      color: colors[color].contrastTextAction
    }, "& .text-color-".concat(color), {
      color: colors[color].contrastTextAction
    })
  };
  brandings['.richtext-link-common'] = {
    '& a': _defineProperty({
      borderRadius: '4px',
      padding: theme.spacing(0.5),
      marginLeft: '-2px',
      marginRight: '-2px'
    }, "&.link-action-".concat(color), {
      padding: 0,
      textDecoration: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      '& img': {
        marginRight: theme.spacing(0.5)
      }
    })
  };
  brandings[".richtext-link-".concat(color)] = {
    color: colors[color].contrastText,
    '& a': {
      color: colors[color].contrastText,
      '@media (hover: hover), all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        '&:hover': {
          color: colors[color].contrastTextAction
        }
      }
    }
  };
}

var transitionFunction = {
  easeIn: 'cubic-bezier(0.755, 0.050, 0.855, 0.060)',
  easeOut: 'cubic-bezier(0.230, 1.000, 0.320, 1.000)',
  easeInOut: 'cubic-bezier(0.860, 0.000, 0.070, 1.000)'
};
var timings = {
  smaller: '0.2s',
  small: '0.3s',
  large: '0.4s',
  larger: '0.6s'
};
var animations = {
  moveUpAndFadeIn: {
    desktop: "moveUpAndFadeIn ".concat(timings.larger, " ").concat(transitionFunction.easeIn),
    mobile: "moveUpAndFadeIn ".concat(timings.large, " ").concat(transitionFunction.easeIn)
  },
  moveUpAndFadeOut: {
    desktop: "moveUpAndFadeOut ".concat(timings.larger, " ").concat(transitionFunction.easeOut),
    mobile: "moveUpAndFadeOut ".concat(timings.large, " ").concat(transitionFunction.easeOut)
  },
  moveDownAndFadeIn: {
    desktop: "moveDownAndFadeIn ".concat(timings.larger, " ").concat(transitionFunction.easeIn),
    mobile: "moveDownAndFadeIn ".concat(timings.large, " ").concat(transitionFunction.easeIn)
  },
  moveDownAndFadeOut: {
    desktop: "moveDownAndFadeOut ".concat(timings.larger, " ").concat(transitionFunction.easeOut),
    mobile: "moveDownAndFadeOut ".concat(timings.large, " ").concat(transitionFunction.easeOut)
  },
  moveDownAndFadeInTop: {
    desktop: "moveDownAndFadeInTop ".concat(timings.larger, " ").concat(transitionFunction.easeIn),
    mobile: "moveDownAndFadeInTop ".concat(timings.large, " ").concat(transitionFunction.easeIn)
  },
  scaleUpAndFadeIn: {
    desktop: "scaleUpAndFadeIn ".concat(timings.larger, " ").concat(transitionFunction.easeInOut),
    mobile: "scaleUpAndFadeIn ".concat(timings.large, " ").concat(transitionFunction.easeInOut)
  },
  scaleDownAndFadeOut: {
    desktop: "scaleDownAndFadeOut ".concat(timings.larger, " ").concat(transitionFunction.easeOut),
    mobile: "scaleDownAndFadeOut ".concat(timings.large, " ").concat(transitionFunction.easeOut)
  },
  modalOpening: {
    desktop: "modalOpening ".concat(timings.larger, " ").concat(transitionFunction.easeInOut),
    mobile: "modalOpening ".concat(timings.large, " ").concat(transitionFunction.easeInOut)
  },
  modalClosing: {
    desktop: "modalClosing ".concat(timings.larger, " ").concat(transitionFunction.easeOut),
    mobile: "modalClosing ".concat(timings.large, " ").concat(transitionFunction.easeOut)
  },
  fadeOut: "fadeOut ".concat(timings.small, " ").concat(transitionFunction.easeOut),
  fadeIn: "fadeIn ".concat(timings.small, " ").concat(transitionFunction.easeOut),
  fadeOutMobileDesktop: {
    desktop: "fadeOut ".concat(timings.larger, " ").concat(transitionFunction.easeOut),
    mobile: "fadeOut ".concat(timings.large, " ").concat(transitionFunction.easeOut)
  },
  pulse: 'pulse 1.2s ease infinite'
};
var motionTypes = {
  expand: {
    up: "all ".concat(timings.small, " ").concat(transitionFunction.easeInOut),
    down: "all ".concat(timings.smaller, " ").concat(transitionFunction.easeOut),
    properties: 'height, width, max-width, max-height, min-width, max-width'
  },
  fade: {
    in: "opacity ".concat(timings.small, " ").concat(transitionFunction.easeOut),
    out: "opacity ".concat(timings.small, " ").concat(transitionFunction.easeOut)
  },
  elevate: {
    up: "all ".concat(timings.small, " ").concat(transitionFunction.easeOut),
    down: "all ".concat(timings.smaller, " ").concat(transitionFunction.easeOut),
    properties: 'box-shadow , border-color '
  },
  moveLarge: {
    in: "transform ".concat(timings.larger, " ").concat(transitionFunction.easeOut),
    out: "transform ".concat(timings.larger, " ").concat(transitionFunction.easeOut)
  },
  moveSmall: {
    in: "transform ".concat(timings.small, " ").concat(transitionFunction.easeOut),
    out: "transform ".concat(timings.small, " ").concat(transitionFunction.easeOut)
  },
  scale: {
    up: "transform ".concat(timings.small, " ").concat(transitionFunction.easeInOut),
    down: "transform ".concat(timings.smaller, " ").concat(transitionFunction.easeOut)
  },
  moveUpAndFade: {
    in: "all ".concat(timings.large, " ").concat(transitionFunction.easeOut),
    out: "all ".concat(timings.small, " ").concat(transitionFunction.easeOut),
    properties: 'opacity, transform'
  },
  moveDownAndFade: {
    in: "all ".concat(timings.large, " ").concat(transitionFunction.easeOut),
    out: "all ".concat(timings.small, " ").concat(transitionFunction.easeOut),
    properties: 'opacity, transform'
  },
  moveAndScale: {
    desktop: "transform ".concat(timings.larger, " ").concat(transitionFunction.easeInOut),
    mobile: "transform ".concat(timings.large, " ").concat(transitionFunction.easeInOut)
  },
  colorTransition: "all ".concat(timings.large, " ").concat(transitionFunction.easeOut),
  margin: {
    bottom: 'margin-bottom 200ms ' + transitionFunction.easeOut
  }
};

function getButtonsDefaultClasses(brandings, theme, colors, color) {
  var defaultButton = theme.palette[colors[color].button].button.default; //For default button

  brandings['.btn-color-common-default'] = {
    border: 'none',
    opacity: '1',
    '&:disabled': {
      opacity: '0.5'
    }
  };
  brandings[".btn-color-".concat(color, "-default")] = {
    color: defaultButton.contrastText.default,
    backgroundColor: defaultButton.background.default,
    boxShadow: defaultButton.shadow.default,
    '& .MuiButton-label svg path': {
      fill: defaultButton.contrastText.default
    },
    '&.rippleEffect': {
      '&.unHovered': {
        animation: "buttonDefaultColorChangeMouseOut-".concat(color, " ").concat(timings.large, " ").concat(transitionFunction.easeOut, " 1"),
        '&:before': {
          animation: "buttonMouseOut ".concat(timings.large, " ").concat(transitionFunction.easeOut, " 1"),
          backgroundColor: defaultButton.background.default
        }
      },
      '&:hover': {
        animation: "buttonDefaultColorChangeMouseIn-".concat(color, " ").concat(timings.large, " ").concat(transitionFunction.easeOut, " 1"),
        '&:before': {
          animation: "buttonMouseIn ".concat(timings.large, " ").concat(transitionFunction.easeOut, " 1"),
          backgroundColor: defaultButton.background.hover
        }
      }
    },
    '&:not(.disabled)': {
      '&:hover': {
        color: defaultButton.contrastText.hover,
        backgroundColor: defaultButton.background.hover,
        boxShadow: defaultButton.shadow.hover,
        '& path': {
          fill: defaultButton.contrastText.hover
        }
      }
    },
    '&:disabled': {
      color: defaultButton.contrastText.disabled,
      backgroundColor: defaultButton.background.disabled,
      boxShadow: defaultButton.shadow.disabled,
      '& path': {
        fill: defaultButton.contrastText.disabled
      }
    },
    '&:active': {
      color: defaultButton.contrastText.active,
      boxShadow: defaultButton.shadow.active,
      '& path': {
        fill: defaultButton.contrastText.active
      }
    },
    '&.iconButton': {
      '&.disabled': {
        background: fwdColors.orangeDark,
        opacity: 1,
        '& .MuiButton-startIcon': {
          opacity: 0.5
        }
      }
    }
  };
  brandings["@keyframes buttonDefaultColorChangeMouseIn-".concat(color)] = {
    '0%': {
      backgroundColor: defaultButton.background.default
    },
    '50%': {
      backgroundColor: defaultButton.background.default
    },
    '51%': {
      backgroundColor: defaultButton.background.hover
    },
    '100%': {
      backgroundColor: defaultButton.background.hover
    }
  };
  brandings["@keyframes buttonDefaultColorChangeMouseOut-".concat(color)] = {
    '0%': {
      backgroundColor: defaultButton.background.hover
    },
    '50%': {
      backgroundColor: defaultButton.background.hover
    },
    '51%': {
      backgroundColor: defaultButton.background.default
    },
    '100%': {
      backgroundColor: defaultButton.background.default
    }
  };
}

function getButtonsOutlinedClasses(brandings, theme, colors, color) {
  var outlinedButton = theme.palette[colors[color].button].button.outlined; //For outlined button

  brandings['.btn-color-common-outlined'] = {
    border: outlinedButton.border.default,
    opacity: '1',
    '&:disabled': {
      opacity: '0.5'
    }
  };
  brandings[".btn-color-".concat(color, "-outlined")] = {
    color: outlinedButton.contrastText.default,
    borderColor: outlinedButton.contrastText.default,
    backgroundColor: outlinedButton.background.default,
    boxShadow: outlinedButton.shadow.default,
    paddingTop: '6px',
    paddingBottom: '6px',
    '& path': {
      fill: outlinedButton.contrastText.default
    },
    '&.rippleEffect': {
      '&.unHovered': {
        animation: "buttonOutlinedColorChangeMouseOut-".concat(color, " ").concat(timings.large, " ").concat(transitionFunction.easeOut, " 1"),
        '&:before': {
          animation: "buttonMouseOut ".concat(timings.large, " ").concat(transitionFunction.easeOut, " 1"),
          backgroundColor: colors[color].main
        }
      },
      '&:hover': {
        animation: "buttonOutlinedColorChangeMouseIn-".concat(color, " ").concat(timings.large, " ").concat(transitionFunction.easeOut, " 1"),
        '&:before': {
          animation: "buttonMouseIn ".concat(timings.large, " ").concat(transitionFunction.easeOut, " 1"),
          backgroundColor: outlinedButton.background.hover
        }
      }
    },
    '&:not(.disabled)': {
      '&:hover': {
        color: outlinedButton.contrastText.hover,
        backgroundColor: outlinedButton.background.hover,
        boxShadow: outlinedButton.shadow.hover,
        '& path': {
          fill: outlinedButton.contrastText.hover
        }
      }
    },
    '&:disabled': {
      color: outlinedButton.contrastText.disabled,
      backgroundColor: outlinedButton.background.disabled,
      boxShadow: outlinedButton.shadow.disabled,
      '& path': {
        fill: outlinedButton.contrastText.disabled
      }
    },
    '&:active': {
      color: outlinedButton.contrastText.active,
      boxShadow: outlinedButton.shadow.active,
      '& path': {
        fill: outlinedButton.contrastText.active
      }
    }
  };
  brandings["@keyframes buttonOutlinedColorChangeMouseIn-".concat(color)] = {
    '0%': {
      backgroundColor: outlinedButton.background.default
    },
    '50%': {
      backgroundColor: outlinedButton.background.default
    },
    '51%': {
      backgroundColor: outlinedButton.background.hover
    },
    '100%': {
      backgroundColor: outlinedButton.background.hover
    }
  };
  brandings["@keyframes buttonOutlinedColorChangeMouseOut-".concat(color)] = {
    '0%': {
      backgroundColor: outlinedButton.background.hover
    },
    '50%': {
      backgroundColor: outlinedButton.background.hover
    },
    '51%': {
      backgroundColor: outlinedButton.background.default
    },
    '100%': {
      backgroundColor: outlinedButton.background.default
    }
  };
}

function getTooltipClasses(brandings, theme, colors, color) {
  var toolTipIcon = theme.palette[colors[color].icon].icon.toolTipIcon; //For tooltip icon

  brandings[".toolTipIcon-color-".concat(color)] = {
    '& path:nth-child(1)': {
      fill: toolTipIcon.border.default
    },
    '& path:nth-child(2)': {
      fill: toolTipIcon.background.default
    },
    '& path:nth-child(n+3)': {
      fill: toolTipIcon.contrastText.default
    },
    '&:hover,&:active': {
      '& path:nth-child(1)': {
        fill: toolTipIcon.border.hover
      },
      '& path:nth-child(2)': {
        fill: toolTipIcon.background.hover
      },
      '& path:nth-child(n+3)': {
        fill: toolTipIcon.contrastText.hover
      }
    },
    '&:focus': {
      outline: 'none'
    }
  };
}

function getFormFieldsClasses(brandings, theme, colors, color) {
  var defaultButton = theme.palette[colors[color].button].button.default;
  var switchRadioParam = theme.palette[colors[color].switchRadio].switchRadio;
  var conversationRadioButton = theme.palette[colors[color].button].radioButton.conversation;
  var regularRadioButton = theme.palette[colors[color].button].radioButton.regular;
  var regularCheckbox = theme.palette[colors[color].button].checkbox.regular;
  var conversationDropdown = theme.palette[colors[color].button].dropdown.conversation;
  var regularDropdown = theme.palette[colors[color].button].dropdown.regular;
  brandings[".value-control-".concat(color)] = {
    backgroundColor: defaultButton.background.default,
    '& path': {
      fill: defaultButton.contrastText.default
    },
    '&:hover': {
      backgroundColor: defaultButton.background.hover,
      '& path': {
        fill: defaultButton.contrastText.hover
      }
    }
  };
  brandings[".switchRadio-".concat(color)] = {
    border: "2px solid ".concat(switchRadioParam.lineBorderFill.default),
    '& #rollerEl': {
      border: "1px solid ".concat(switchRadioParam.rollerBorder.default),
      backgroundColor: switchRadioParam.rollerFill.default,
      '&:after': {
        backgroundColor: switchRadioParam.rollerCenter.default
      }
    },
    '&:hover': {
      borderColor: switchRadioParam.lineBorderFill.hover,
      '& #rollerEl': {
        borderColor: switchRadioParam.rollerBorder.hover,
        backgroundColor: switchRadioParam.rollerFill.hover,
        '&:after': {
          backgroundColor: switchRadioParam.rollerCenter.hover
        }
      },
      '&.active': {
        borderColor: switchRadioParam.lineBorderFill.selected,
        '& #rollerEl': {
          borderColor: switchRadioParam.rollerBorder.selected,
          backgroundColor: switchRadioParam.rollerFill.selected,
          '&:after': {
            backgroundColor: switchRadioParam.rollerCenter.selected
          }
        }
      }
    },
    '&.active': {
      borderColor: switchRadioParam.lineBorderFill.selected,
      '& #rollerEl': {
        borderColor: switchRadioParam.rollerBorder.selected,
        backgroundColor: switchRadioParam.rollerFill.selected,
        '&:after': {
          backgroundColor: switchRadioParam.rollerCenter.selected
        }
      }
    }
  };
  brandings[".radioBtn-".concat(color, "-conversation")] = {
    color: conversationRadioButton.contrastText.default,
    border: conversationRadioButton.border.default,
    boxShadow: conversationRadioButton.shadow.default,
    opacity: conversationRadioButton.opacity.default,
    '&.Mui-checked': {
      backgroundColor: conversationRadioButton.background.hover
    },
    '&.Mui-checked ~ .MuiFormControlLabel-label': {
      color: conversationRadioButton.contrastText.default
    },
    '& .checkedIcon': {
      backgroundColor: conversationRadioButton.background.default
    },
    '&.rippleEffect': {
      background: "linear-gradient(to right, ".concat(conversationRadioButton.background.default, " 1px, ").concat(conversationRadioButton.background.hover, " 0px, ").concat(conversationRadioButton.background.hover, " 50%, ").concat(conversationRadioButton.background.default, " 50%)")
    },
    '&:hover': {
      '& ~ .MuiFormControlLabel-label': {
        color: conversationRadioButton.contrastText.default,
        pointerEvents: 'none'
      },
      color: conversationRadioButton.contrastText.hover,
      backgroundColor: conversationRadioButton.background.hover + ' !important',
      border: conversationRadioButton.border.hover,
      boxShadow: conversationRadioButton.shadow.hover,
      opacity: conversationRadioButton.opacity.hover
    },
    '&:disabled': {
      color: conversationRadioButton.contrastText.disabled,
      backgroundColor: conversationRadioButton.background.disabled,
      border: conversationRadioButton.border.disabled,
      boxShadow: conversationRadioButton.shadow.disabled,
      opacity: conversationRadioButton.opacity.disabled
    },
    '&:active': {
      color: conversationRadioButton.contrastText.active,
      border: conversationRadioButton.border.active,
      boxShadow: conversationRadioButton.shadow.active,
      opacity: conversationRadioButton.opacity.active
    }
  };
  brandings[".radioBtn-".concat(color, "-regular")] = {
    color: regularRadioButton.contrastText.default,
    backgroundColor: regularRadioButton.background.default,
    boxShadow: regularRadioButton.shadow.default,
    opacity: regularRadioButton.opacity.default,
    '& .icon': {
      boxShadow: "inset 0 0 0 2px ".concat(regularRadioButton.background.default)
    },
    '& .checkedIcon': {
      backgroundColor: regularRadioButton.background.default,
      '&:before': {
        border: "4px solid ".concat(theme.palette.colors.white.main)
      }
    },
    '&.rippleEffect': {
      background: "linear-gradient(to right, ".concat(regularRadioButton.background.default, " 1px, ").concat(regularRadioButton.background.hover, " 0px, ").concat(regularRadioButton.background.hover, " 50%, ").concat(regularRadioButton.background.default, " 50%)")
    },
    '&:hover': {
      color: regularRadioButton.contrastText.hover,
      backgroundColor: regularRadioButton.background.hover,
      boxShadow: regularRadioButton.shadow.hover,
      opacity: regularRadioButton.opacity.hover,
      '& .icon': {
        backgroundColor: regularCheckbox.background.default
      }
    },
    '&:disabled': {
      color: regularRadioButton.contrastText.disabled,
      backgroundColor: regularRadioButton.background.disabled,
      boxShadow: regularRadioButton.shadow.disabled,
      opacity: regularRadioButton.opacity.disabled
    },
    '&:active': {
      color: regularRadioButton.contrastText.active,
      boxShadow: regularRadioButton.shadow.active,
      opacity: regularRadioButton.opacity.active
    }
  };
  brandings[".checkbox-".concat(color)] = {
    color: regularCheckbox.contrastText.default,
    opacity: regularCheckbox.opacity.default,
    '& .icon': {
      border: regularCheckbox.border.default
    },
    '& .checkedIcon': {
      backgroundColor: regularCheckbox.background.default,
      color: regularCheckbox.contrastText.default,
      'input:hover ~ &': {
        backgroundColor: regularCheckbox.background.default
      }
    },
    '&.rippleEffect': {
      background: "linear-gradient(to right, ".concat(regularCheckbox.background.default, " 1px, ").concat(regularCheckbox.background.hover, " 0px, ").concat(regularCheckbox.background.hover, " 50%, ").concat(regularCheckbox.background.default, " 50%)")
    },
    '&:hover': {
      '& .icon': {
        backgroundColor: regularCheckbox.background.default
      },
      opacity: regularCheckbox.opacity.hover
    },
    '&:disabled': {
      opacity: regularCheckbox.opacity.disabled
    },
    '&:active': {
      opacity: regularCheckbox.opacity.active
    }
  };
  brandings[".dropdown-form-".concat(color)] = {
    '&.dropdownShadow': {
      '& .MuiMenu-list': {
        '& .MuiMenuItem-root': {
          color: theme.palette.colors[color].contrastText
        },
        '& .MuiMenuItem-root:hover': {
          background: conversationDropdown.background.default,
          color: conversationDropdown.contrastText.default
        },
        '& .Mui-selected': {
          color: conversationDropdown.background.default,
          background: 'transparent'
        }
      }
    }
  };
  brandings[".forms-".concat(color, "-conversation")] = {
    '& .MuiFormLabel-filled ~ .MuiInput-underline:before': {
      borderColor: theme.palette.colors[color].contrastText
    }
  };
  brandings[".dropdown-form-".concat(color, "-conversation")] = {
    color: conversationDropdown.contrastText.default,
    boxShadow: conversationDropdown.shadow.default,
    opacity: conversationDropdown.opacity.default,
    '& path': {
      fill: conversationDropdown.background.default
    },
    '&.MuiInput-underline:before': {
      borderColor: theme.palette.colors[color].line.textFieldDefault
    },
    '&.rippleEffect': {
      background: "linear-gradient(to right, ".concat(conversationDropdown.background.default, " 1px, ").concat(conversationDropdown.background.hover, " 0px, ").concat(conversationDropdown.background.hover, " 50%, ").concat(conversationDropdown.background.default, " 50%)")
    },
    '&:hover': {
      boxShadow: conversationDropdown.shadow.hover,
      opacity: conversationDropdown.opacity.hover
    },
    '&:disabled': {
      color: conversationDropdown.contrastText.disabled,
      backgroundColor: conversationDropdown.background.disabled,
      boxShadow: conversationDropdown.shadow.disabled,
      opacity: conversationDropdown.opacity.disabled
    },
    '&:active': {
      color: conversationDropdown.contrastText.active,
      boxShadow: conversationDropdown.shadow.active,
      opacity: conversationDropdown.opacity.active
    }
  };
  brandings[".dropdown-form-".concat(color, "-regular")] = {
    color: theme.palette.colors.white.contrastTextCaption,
    boxShadow: regularDropdown.shadow.default,
    opacity: regularDropdown.opacity.default,
    '&:before': {
      borderColor: theme.palette.colors[color].line.textFieldDefault
    },
    '& path': {
      fill: regularDropdown.background.default
    },
    '&.MuiInput-underline.Mui-focused:before': {
      borderColor: regularDropdown.background.default
    },
    '&.nonEmptyField': {
      border: regularDropdown.border.default,
      borderColor: theme.palette.colors[color].line.textFieldDefault,
      '&.Mui-focused': {
        border: regularDropdown.border.default
      }
    },
    '&.rippleEffect': {
      background: "linear-gradient(to right, ".concat(regularDropdown.background.default, " 1px, ").concat(regularDropdown.background.hover, " 0px, ").concat(regularDropdown.background.hover, " 50%, ").concat(regularDropdown.background.default, " 50%)")
    },
    '&:hover': {
      boxShadow: regularDropdown.shadow.hover,
      opacity: regularDropdown.opacity.hover,
      color: theme.palette.colors.white.contrastTextCaption
    },
    '&:disabled': {
      color: regularDropdown.contrastText.disabled,
      backgroundColor: regularDropdown.background.disabled,
      boxShadow: regularDropdown.shadow.disabled,
      opacity: regularDropdown.opacity.disabled
    },
    '&:active': {
      color: regularDropdown.contrastText.active,
      boxShadow: regularDropdown.shadow.active,
      opacity: regularDropdown.opacity.active
    }
  };
  brandings[".datalistUl-".concat(color)] = {
    '&:hover': {
      background: conversationDropdown.background.default,
      color: conversationDropdown.contrastText.default
    }
  };
  brandings['.MuiAutocomplete-paper'] = {
    borderRadius: theme.spacing(0, 0, 0.5, 0.5),
    boxShadow: '0 0 8px 0 rgba(0,0,0,0.24)'
  };
  brandings['.autoDropdown'] = {
    padding: theme.spacing(1, 0),
    margin: 0,
    '& .MuiAutocomplete-option:hover': {
      background: conversationDropdown.background.default,
      color: conversationDropdown.contrastText.default
    }
  };
  brandings[".datalist-".concat(color, "-conversation")] = {
    color: conversationDropdown.contrastText.default,
    boxShadow: conversationDropdown.shadow.default,
    opacity: conversationDropdown.opacity.default,
    '& svg': {
      color: conversationDropdown.background.default
    },
    '&.rippleEffect': {
      background: "linear-gradient(to right, ".concat(conversationDropdown.background.default, " 1px, ").concat(conversationDropdown.background.hover, " 0px, ").concat(conversationDropdown.background.hover, " 50%, ").concat(conversationDropdown.background.default, " 50%)")
    },
    '&:hover': {
      boxShadow: conversationDropdown.shadow.hover,
      opacity: conversationDropdown.opacity.hover
    },
    '&:disabled': {
      color: conversationDropdown.contrastText.disabled,
      backgroundColor: conversationDropdown.background.disabled,
      boxShadow: conversationDropdown.shadow.disabled,
      opacity: conversationDropdown.opacity.disabled
    },
    '&:active': {
      color: conversationDropdown.contrastText.active,
      boxShadow: conversationDropdown.shadow.active,
      opacity: conversationDropdown.opacity.active
    }
  };
  brandings[".datalist-".concat(color, "-regular")] = {
    color: regularDropdown.contrastText.default,
    backgroundColor: regularDropdown.background.default,
    border: regularDropdown.border.default,
    boxShadow: regularDropdown.shadow.default,
    opacity: regularDropdown.opacity.default,
    '&.rippleEffect': {
      background: "linear-gradient(to right, ".concat(regularDropdown.background.default, " 1px, ").concat(regularDropdown.background.hover, " 0px, ").concat(regularDropdown.background.hover, " 50%, ").concat(regularDropdown.background.default, " 50%)")
    },
    '&:hover': {
      color: regularDropdown.contrastText.hover,
      backgroundColor: regularDropdown.background.hover,
      border: regularDropdown.border.hover,
      boxShadow: regularDropdown.shadow.hover,
      opacity: regularDropdown.opacity.hover
    },
    '&:disabled': {
      color: regularDropdown.contrastText.disabled,
      backgroundColor: regularDropdown.background.disabled,
      border: regularDropdown.border.disabled,
      boxShadow: regularDropdown.shadow.disabled,
      opacity: regularDropdown.opacity.disabled
    },
    '&:active': {
      color: regularDropdown.contrastText.active,
      border: regularDropdown.border.active,
      boxShadow: regularDropdown.shadow.active,
      opacity: regularDropdown.opacity.active
    }
  };
  brandings[".dropdown-".concat(color)] = {
    '& path': {
      fill: colors[color].contrastTextLabel
    },
    '& .MuiSelect-root': {
      color: colors[color].contrastTextLabel
    },
    color: colors[color].contrastTextLabel,
    '&.MuiInput-underline:before': {
      borderBottom: '1px solid ' + colors[color].contrastTextLabel
    },
    '&.MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: '1px solid ' + colors[color].contrastTextLabel
    }
  };
  brandings[".dropdown-secondary-".concat(color)] = {
    '& path': {
      fill: colors[color].contrastText
    },
    '& .MuiSelect-root': {
      color: colors[color].contrastText
    },
    color: colors[color].contrastText,
    '&.MuiInput-underline:before': {
      borderBottom: '1px solid ' + colors[color].contrastText
    },
    '&.MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: '1px solid ' + colors[color].contrastText
    }
  };
  brandings[".border-color-".concat(color)] = {
    borderColor: colors[color].line.divider
  };
}

function getBackgroundClasses(brandings, theme, colors, color) {
  //For background colors
  brandings[".bg-color-".concat(color)] = {
    backgroundColor: colors[color].main,
    '& hr': {
      backgroundColor: colors[color].line.divider
    }
  };
  brandings['body .MuiSkeleton-root'] = {
    backgroundColor: colors.grey.main
  };
}

function getChipsClasses(brandings, theme, colors, color) {
  var chip = theme.palette[colors[color].chip].chip.outlined; //For chip colors

  brandings[".chipColor-".concat(color)] = {
    backgroundColor: chip.background.default,
    color: chip.contrastText.default,
    border: chip.border.default,
    boxShadow: chip.shadow.default,
    "&:link, &:visited, &:focus, a&": {
      backgroundColor: chip.background.default,
      color: chip.contrastText.default,
      border: chip.border.default,
      boxShadow: chip.shadow.default
    },
    "@media (hover: hover), all and (-ms-high-contrast: none), (-ms-high-contrast: active) ": {
      "&:hover": {
        backgroundColor: chip.background.hover,
        color: chip.contrastText.hover,
        border: chip.border.hover,
        boxShadow: chip.shadow.hover
      }
    },
    "&.active": {
      backgroundColor: chip.background.hover,
      color: chip.contrastText.hover,
      border: chip.border.hover
    },
    "&.disabled": {
      opacity: 0.5,
      pointerEvents: "none"
    },
    "&.MuiChip-clickable": {
      "&:hover": {
        backgroundColor: chip.background.hover
      }
    }
  };
}

function getExpansionPanelClasses(brandings, theme, colors, color) {
  brandings[".expansion-panel-".concat(color)] = {
    backgroundColor: colors[color].main,
    borderBottom: '1px solid',
    borderBottomColor: colors[color].line.divider,
    '& .MuiAccordionSummary-root': {
      backgroundColor: colors[color].main
    },
    '& .Mui-expanded': {
      borderBottomColor: colors[color].line.textFieldFocus
    }
  };
}

function getCarouselClasses(brandings, theme, colors, color) {
  brandings[".carouselarrowbutton-".concat(color)] = {
    '&.slick-arrow, &.slick-next, &.slick-prev': {
      backgroundColor: theme.palette.colors[color].contrastTextAction,
      '& path': {
        fill: theme.palette.colors[color].main
      },
      '&:hover': {
        backgroundColor: theme.palette.colors[color].main,
        '& path': {
          fill: theme.palette.colors[color].contrastTextAction
        }
      }
    }
  };
}

function getBordersClasses(brandings, theme, colors, color) {
  brandings[".divider-line-".concat(color)] = {
    borderBottom: '1px solid',
    borderBottomColor: colors[color].line.divider
  };
}

function getFeedbackBtnClasses(brandings, theme) {
  brandings['.kampyle_vertical_button#nebula_div_btn'] = {
    boxShadow: theme.shadows[5],
    zIndex: '999 !important',
    borderRadius: "0 0 ".concat(theme.spacing(3 / 8), "px ").concat(theme.spacing(3 / 8), "px"),
    '&:hover .kampyle_button': {
      background: "".concat(theme.palette.colors.orange.main, " !important")
    },
    '&:hover .kampyle_button-text': {
      color: "".concat(theme.palette.colors.white.main, " !important")
    },
    '& .kampyle_button': {
      background: "".concat(theme.palette.colors.white.main, " !important"),
      transition: "background ".concat(timings.smaller, " ").concat(transitionFunction.easeInOut)
    },
    '& .kampyle_button-text': {
      color: "".concat(theme.palette.colors.orange.main, " !important"),
      lineHeight: "".concat(theme.spacing(2.25), "px !important"),
      fontWeight: "".concat(theme.typography.fontWeights.bold, " !important"),
      transition: "color ".concat(timings.smaller, " ").concat(transitionFunction.easeInOut)
    }
  };
}

function getComponentDividerClasses(brandings, theme, colors, color) {
  brandings[".component-divider-".concat(color)] = {
    '&:after': {
      content: '""',
      height: '1px',
      position: 'absolute',
      width: '100%',
      left: '0',
      right: '0',
      bottom: '0',
      margin: 'auto',
      maxWidth: '1224px',
      backgroundColor: colors[color].line.divider,
      '@media (max-width: 1279px)': {
        maxWidth: 'calc(100vw - 64px)'
      },
      '@media (max-width: 600px)': {
        maxWidth: 'calc(100vw - 32px)'
      }
    },
    '&.component-divider--contrast': {
      '&:after': {
        backgroundColor: colors[color].contrastTextAction
      }
    }
  };
}

function getRTEStylingClasses(brandings, theme, colors, color) {
  brandings['.richtext-styling-common'] = {
    '& .modal-heading, .article-heading': {
      fontSize: theme.typography.T2,
      lineHeight: theme.typography.lineHeight.L2,
      fontWeight: theme.typography.fontWeights.bolder
    },
    '& .modal-heading': _defineProperty({}, theme.breakpoints.down('lg'), {
      fontSize: theme.typography.T3,
      lineHeight: theme.typography.lineHeight.L3
    }),
    '& .article-heading': _defineProperty({}, theme.breakpoints.down('lg'), {
      fontSize: theme.typography.T4,
      lineHeight: theme.typography.lineHeight.L6
    }),
    '& .modal-section-heading, .article-subheading-medium': _defineProperty({
      fontSize: theme.typography.T4,
      lineHeight: theme.typography.lineHeight.L6,
      fontWeight: theme.typography.fontWeights.bolder
    }, theme.breakpoints.down('lg'), {
      fontSize: theme.typography.T5,
      lineHeight: theme.typography.lineHeight.L8
    }),
    '& .modal-body, .modal-body-bullets,.modal-body-number-1,.modal-body-number-2,.article-description': _defineProperty({
      fontSize: theme.typography.T5,
      lineHeight: theme.typography.lineHeight.L5,
      fontWeight: theme.typography.fontWeights.normal
    }, theme.breakpoints.down('lg'), {
      fontSize: theme.typography.T6,
      lineHeight: theme.typography.lineHeight.L7
    }),
    '& .modal-body-number-1': {
      fontWeight: theme.typography.fontWeights.bold
    },
    '& .modal-excerpts,.article-caption, .modal-caption': {
      fontSize: theme.typography.T11,
      lineHeight: theme.typography.lineHeight.L14,
      fontWeight: theme.typography.fontWeights.normal
    },
    '& .modal-excerpts': {
      '& span:last-child': _defineProperty({
        fontSize: theme.typography.T5,
        lineHeight: theme.typography.lineHeight.L5,
        display: 'block'
      }, theme.breakpoints.down('lg'), {
        fontSize: theme.typography.T6,
        lineHeight: theme.typography.lineHeight.L7
      }),
      '&:before, &:after': {
        content: '""',
        display: 'block',
        width: '100%',
        height: '1px'
      },
      '&:after': {
        marginTop: theme.spacing(3)
      },
      '&:before': {
        marginBottom: theme.spacing(3)
      }
    },
    '& .modal-text-link, .article-subheading-small': {
      fontSize: theme.typography.T6,
      lineHeight: theme.typography.lineHeight.L9,
      fontWeight: theme.typography.fontWeights.bolder
    },
    '& .modal-text-link': {
      display: 'flex',
      paddingRight: theme.spacing(1),
      width: 'fit-content',
      paddingLeft: '2px',
      '& a': {
        textDecoration: 'none',
        padding: '2px 0px'
      },
      '& img': {
        margin: '4px 0px'
      }
    },
    '& .modal-text-link:hover': {
      backgroundColor: alpha(theme.palette.colors.orange.main, 0.2),
      borderRadius: '4px',
      '& a:hover': {
        backgroundColor: 'transparent'
      }
    },
    '& .article-subheading-large': _defineProperty({
      fontSize: theme.typography.T4,
      lineHeight: theme.typography.lineHeight.L4,
      fontWeight: theme.typography.fontWeights.normal
    }, theme.breakpoints.down('lg'), {
      fontSize: theme.typography.T5,
      lineHeight: theme.typography.lineHeight.L5
    }),
    '& .article-quote': _defineProperty({
      fontSize: theme.typography.T3,
      lineHeight: theme.typography.lineHeight.L3,
      fontWeight: theme.typography.fontWeights.bolder
    }, theme.breakpoints.down('lg'), {
      fontSize: theme.typography.T4,
      lineHeight: theme.typography.lineHeight.L6
    })
  };
  brandings[".richtext-styling-".concat(color)] = {
    color: colors[color].contrastText,
    '& .article-quote': {
      color: colors[color].contrastTextLabel
    },
    '& .modal-excerpts': {
      '& span:first-child': {
        color: theme.palette.colors[color].contrastTextCaption
      },
      '& span:last-child': {
        color: colors[color].contrastText
      },
      '&:before, &:after': {
        backgroundColor: colors[color].line.divider
      }
    },
    '& .modal-text-link:hover': {
      '& a': {
        color: colors[color].contrastText
      }
    }
  };
}

function getTableStylingClasses(brandings, theme) {
  var _inner, _inner2;

  brandings['.table-styling-common'] = {
    '&.customScrollbar': {
      '&::-webkit-scrollbar': {
        appearance: 'none',
        '-webkit-appearance': 'none'
      },
      '&::-webkit-scrollbar:vertical': {
        width: theme.spacing(1),
        visibility: 'visible',
        display: 'block !important'
      },
      '&::-webkit-scrollbar:horizontal': {
        height: theme.spacing(1),
        visibility: 'visible',
        display: 'block !important'
      },
      '&::-webkit-scrollbar-track': {
        borderRadius: theme.spacing(0.5),
        display: 'block !important'
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: theme.spacing(0.5)
      }
    },
    '& table': {
      borderCollapse: 'collapse',
      borderSpacing: 0,
      display: 'block',
      position: 'relative',
      overflow: 'hidden'
    },
    '& td': {
      position: 'relative',
      padding: 0,
      border: 0,
      '& .link-action-white': {
        margin: theme.spacing(-0.75, -0.5)
      },
      '&:last-child': {
        '& .inner': {
          '&:after': {
            display: 'none'
          },
          '&:before': {
            width: "calc(100% - ".concat(theme.spacing(3), "px)")
          }
        }
      },
      '&:first-child': {
        '& .inner': {
          '&:before': _defineProperty({
            left: 0,
            width: '100%'
          }, theme.breakpoints.up('sm'), {
            left: 'auto',
            width: "calc(100% - ".concat(theme.spacing(3), "px)")
          })
        }
      },
      '& .inner': (_inner = {
        width: '100%',
        height: '100%',
        padding: theme.spacing(2),
        position: 'relative',
        minHeight: theme.spacing(7)
      }, _defineProperty(_inner, theme.breakpoints.up('sm'), {
        padding: theme.spacing(2, 3)
      }), _defineProperty(_inner, '&:before, &:after', {
        content: '""',
        display: 'block',
        position: 'absolute'
      }), _defineProperty(_inner, '&:after', {
        width: '1px',
        height: "calc(100% - ".concat(theme.spacing(4), "px)"),
        top: theme.spacing(2),
        bottom: theme.spacing(2),
        right: 0
      }), _defineProperty(_inner, '&:before', {
        width: '100%',
        height: '1px',
        bottom: 0,
        left: 0
      }), _defineProperty(_inner, '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)', {
        __expression__: 'all and (-ms-high-contrast: none), (-ms-high-contrast: active)',
        padding: "".concat(theme.spacing(2, 2.75, 2, 3), " !important")
      }), _inner),
      '&.header': {
        /* exception declaration of inline lineHeight due to whole take is dynamically generated */
        lineHeight: theme.typography.pxToRem(20),
        fontWeight: 700,
        '& .inner': (_inner2 = {}, _defineProperty(_inner2, theme.breakpoints.down('sm'), {
          padding: theme.spacing(1, 2),
          minHeight: theme.spacing(4)
        }), _defineProperty(_inner2, '&:after', _defineProperty({
          height: "calc(100% - ".concat(theme.spacing(2), "px)"),
          top: theme.spacing(1),
          bottom: theme.spacing(1)
        }, theme.breakpoints.up('sm'), {
          top: theme.spacing(2),
          bottom: theme.spacing(2),
          height: "calc(100% - ".concat(theme.spacing(4), "px)")
        })), _inner2),
        '&:last-child': {
          '& .inner': {
            '&:before': {
              display: 'none'
            }
          }
        }
      }
    },
    '& tr': {
      '&:last-child': {
        '& td': {
          '& .inner': {
            '&:before': {
              display: 'none'
            }
          }
        }
      }
    },
    '& .mainTable': _defineProperty({
      borderRadius: theme.spacing(2),
      margin: theme.spacing(0, 2)
    }, theme.breakpoints.up('sm'), {
      margin: theme.spacing(0)
    })
  };
}

function getBrandingClasses(theme) {
  var colors = theme.palette.colors || {};
  var brandings = {};
  Object.keys(colors).forEach(function (color) {
    getBackgroundClasses(brandings, theme, colors, color);
    getTypographyClasses(brandings, theme, colors, color);
    getIconClasses(brandings, theme, colors, color);
    getTooltipClasses(brandings, theme, colors, color);
    getButtonsDefaultClasses(brandings, theme, colors, color);
    getButtonsOutlinedClasses(brandings, theme, colors, color);
    getLinksClasses(brandings, theme, colors, color);
    getFormFieldsClasses(brandings, theme, colors, color);
    getChipsClasses(brandings, theme, colors, color);
    getExpansionPanelClasses(brandings, theme, colors, color);
    getBordersClasses(brandings, theme, colors, color);
    getCarouselClasses(brandings, theme, colors, color);
    getFeedbackBtnClasses(brandings, theme);
    getComponentDividerClasses(brandings, theme, colors, color);
    getRTEStylingClasses(brandings, theme, colors, color);
    getTableStylingClasses(brandings, theme);
  });
  return brandings;
}

var getButtonStyle = function getButtonStyle(mainColor, contrastColor) {
  return {
    default: {
      background: {
        default: mainColor,
        hover: contrastColor,
        active: contrastColor,
        disabled: mainColor
      },
      contrastText: {
        default: contrastColor,
        hover: mainColor,
        active: mainColor,
        disabled: contrastColor
      },
      shadow: {
        default: 'none',
        hover: '0 6px 8px 0 rgba(0,0,0,0.2)',
        active: '0 6px 8px 0 rgba(0,0,0,0.2)',
        disabled: 'none'
      },
      border: {
        default: 'none',
        hover: 'none',
        active: 'none',
        disabled: 'none'
      },
      opacity: {
        default: 1,
        hover: 1,
        active: 1,
        disabled: 0.5
      }
    },
    outlined: {
      background: {
        default: 'transparent',
        hover: mainColor,
        active: mainColor,
        disabled: 'transparent'
      },
      contrastText: {
        default: mainColor,
        hover: contrastColor,
        active: contrastColor,
        disabled: mainColor
      },
      shadow: {
        default: 'none',
        hover: '0 6px 8px 0 rgba(0,0,0,0.2)',
        active: '0 6px 8px 0 rgba(0,0,0,0.2)',
        disabled: 'none'
      },
      border: {
        default: "2px solid ".concat(mainColor),
        hover: "2px solid ".concat(mainColor),
        active: "2px solid ".concat(mainColor),
        disabled: "2px solid ".concat(mainColor)
      },
      opacity: {
        default: 1,
        hover: 1,
        active: 1,
        disabled: 0.5
      }
    }
  };
};

var getRadioButtonStyle = function getRadioButtonStyle(mainColor, contrastColor) {
  return {
    conversation: {
      background: {
        default: mainColor,
        hover: mainColor,
        active: contrastColor,
        disabled: mainColor
      },
      contrastText: {
        default: contrastColor,
        hover: mainColor,
        active: mainColor,
        disabled: contrastColor
      },
      shadow: {
        default: 'none',
        hover: 'none',
        active: 'none',
        disabled: 'none'
      },
      border: {
        default: "1px solid ".concat(mainColor),
        hover: "1px solid ".concat(mainColor),
        active: "1px solid ".concat(mainColor),
        disabled: "1px solid ".concat(mainColor)
      },
      opacity: {
        default: 1,
        hover: 1,
        active: 1,
        disabled: 0.5
      }
    },
    regular: {
      background: {
        default: mainColor,
        hover: mainColor,
        active: contrastColor,
        disabled: mainColor
      },
      contrastText: {
        default: contrastColor,
        hover: mainColor,
        active: mainColor,
        disabled: contrastColor
      },
      shadow: {
        default: 'none',
        hover: 'none',
        active: 'none',
        disabled: 'none'
      },
      border: {
        default: "1px solid ".concat(mainColor),
        hover: "1px solid ".concat(mainColor),
        active: "1px solid ".concat(mainColor),
        disabled: "1px solid ".concat(mainColor)
      },
      opacity: {
        default: 1,
        hover: 1,
        active: 1,
        disabled: 0.5
      }
    }
  };
};

var getDropdownStyle = function getDropdownStyle(mainColor, contrastColor) {
  return {
    conversation: {
      background: {
        default: mainColor,
        hover: contrastColor,
        active: contrastColor,
        disabled: mainColor
      },
      contrastText: {
        default: contrastColor,
        hover: mainColor,
        active: mainColor,
        disabled: contrastColor
      },
      shadow: {
        default: 'none',
        hover: 'none',
        active: 'none',
        disabled: 'none'
      },
      border: {
        default: "1px solid ".concat(mainColor),
        hover: "1px solid ".concat(mainColor),
        active: "1px solid ".concat(mainColor),
        disabled: "1px solid ".concat(mainColor)
      },
      opacity: {
        default: 1,
        hover: 1,
        active: 1,
        disabled: 0.5
      }
    },
    regular: {
      background: {
        default: mainColor,
        hover: contrastColor,
        active: contrastColor,
        disabled: mainColor
      },
      contrastText: {
        default: contrastColor,
        hover: mainColor,
        active: mainColor,
        disabled: contrastColor
      },
      shadow: {
        default: 'none',
        hover: 'none',
        active: 'none',
        disabled: 'none'
      },
      border: {
        default: "1px solid ".concat(mainColor),
        hover: "1px solid ".concat(mainColor),
        active: "1px solid ".concat(mainColor),
        disabled: "1px solid ".concat(mainColor)
      },
      opacity: {
        default: 1,
        hover: 1,
        active: 1,
        disabled: 0.5
      }
    }
  };
};

var getCheckboxStyle = function getCheckboxStyle(mainColor, contrastColor) {
  return {
    conversation: {
      background: {
        default: mainColor,
        hover: contrastColor,
        active: contrastColor,
        disabled: mainColor
      },
      contrastText: {
        default: contrastColor,
        hover: mainColor,
        active: mainColor,
        disabled: contrastColor
      },
      shadow: {
        default: 'none',
        hover: 'none',
        active: 'none',
        disabled: 'none'
      },
      border: {
        default: "2px solid ".concat(mainColor),
        hover: "2px solid ".concat(mainColor),
        active: "2px solid ".concat(mainColor),
        disabled: "2px solid ".concat(mainColor)
      },
      opacity: {
        default: 1,
        hover: 1,
        active: 1,
        disabled: 0.5
      }
    },
    regular: {
      background: {
        default: mainColor,
        hover: contrastColor,
        active: contrastColor,
        disabled: mainColor
      },
      contrastText: {
        default: contrastColor,
        hover: mainColor,
        active: mainColor,
        disabled: contrastColor
      },
      shadow: {
        default: 'none',
        hover: 'none',
        active: 'none',
        disabled: 'none'
      },
      border: {
        default: "2px solid ".concat(mainColor),
        hover: "2px solid ".concat(mainColor),
        active: "2px solid ".concat(mainColor),
        disabled: "2px solid ".concat(mainColor)
      },
      opacity: {
        default: 1,
        hover: 1,
        active: 1,
        disabled: 0.5
      }
    }
  };
};

var getIconStyle = function getIconStyle(mainColor, contrastColor, _ref) {
  var toolTipIconText = _ref.toolTipIconText,
      buttonIconSecondaryColor = _ref.buttonIconSecondaryColor;
  return {
    textIcon: {
      action: mainColor,
      information: mainColor
    },
    brandingIcon: {
      shadowCircle: {
        default: 'none',
        hover: '0 2px 4px 0 rgba(0,0,0,0.2)'
      },
      shadowSquare: {
        default: 'none',
        hover: '0 6px 8px 0 rgba(0,0,0,0.2)'
      }
    },
    brandingIconPrimary: {
      background: {
        default: mainColor,
        hover: contrastColor
      },
      contrastText: {
        default: contrastColor,
        hover: mainColor
      }
    },
    brandingIconSecondary: {
      background: {
        default: toolTipIconText,
        hover: buttonIconSecondaryColor
      },
      contrastText: {
        default: buttonIconSecondaryColor,
        hover: toolTipIconText
      }
    },
    videoIcon: {
      background: {
        default: mainColor,
        hover: contrastColor,
        active: contrastColor
      },
      contrastText: {
        default: contrastColor,
        hover: mainColor,
        active: mainColor
      },
      shadow: {
        default: 'none',
        hover: '0 2px 4px 0 rgba(0,0,0,0.2)',
        active: '0 2px 4px 0 rgba(0,0,0,0.2)'
      },
      border: {
        default: 'none',
        hover: 'none',
        active: 'none'
      },
      opacity: {
        default: 1,
        hover: 1,
        active: 1
      }
    },
    carousel: {
      background: {
        default: mainColor,
        hover: contrastColor,
        active: contrastColor
      },
      contrastText: {
        default: contrastColor,
        hover: mainColor,
        active: mainColor
      },
      shadow: {
        default: 'none',
        hover: '0 2px 4px 0 rgba(0,0,0,0.2)',
        active: '0 2px 4px 0 rgba(0,0,0,0.2)'
      },
      border: {
        default: 'none',
        hover: 'none',
        active: 'none'
      },
      opacity: {
        default: 1,
        hover: 1,
        active: 1
      }
    },
    toolTipIcon: {
      background: {
        default: 'transparent',
        hover: mainColor,
        active: mainColor,
        selected: mainColor
      },
      contrastText: {
        default: toolTipIconText,
        hover: contrastColor,
        active: contrastColor,
        selected: contrastColor
      },
      shadow: {
        default: 'none',
        hover: 'none',
        active: 'none',
        selected: 'none'
      },
      border: {
        default: toolTipIconText,
        hover: mainColor,
        active: mainColor,
        selected: mainColor
      },
      opacity: {
        default: 1,
        hover: 1,
        active: 1,
        selected: 1
      }
    }
  };
};

var getChipStyle = function getChipStyle(mainColor, contrastColor) {
  return {
    default: {
      background: {
        default: mainColor,
        hover: contrastColor,
        active: contrastColor,
        disabled: mainColor
      },
      contrastText: {
        default: contrastColor,
        hover: mainColor,
        active: mainColor,
        disabled: contrastColor
      },
      shadow: {
        default: 'none',
        hover: '0 2px 4px 0 rgba(0,0,0,0.2)',
        active: '0 2px 4px 0 rgba(0,0,0,0.2)',
        disabled: 'none'
      },
      border: {
        default: 'none',
        hover: 'none',
        active: 'none',
        disabled: 'none'
      },
      opacity: {
        default: 1,
        hover: 1,
        active: 1,
        disabled: 0.5
      }
    },
    outlined: {
      background: {
        default: 'transparent',
        hover: mainColor,
        active: mainColor,
        disabled: 'transparent'
      },
      contrastText: {
        default: mainColor,
        hover: contrastColor,
        active: contrastColor,
        disabled: mainColor
      },
      shadow: {
        default: 'none',
        hover: '0 2px 4px 0 rgba(0,0,0,0.2)',
        active: '0 2px 4px 0 rgba(0,0,0,0.2)',
        disabled: 'none'
      },
      border: {
        default: "1px solid ".concat(mainColor),
        hover: "1px solid ".concat(mainColor),
        active: "1px solid ".concat(mainColor),
        disabled: "1px solid ".concat(mainColor)
      },
      opacity: {
        default: 1,
        hover: 1,
        active: 1,
        disabled: 0.5
      }
    }
  };
};

var getSwitchRadioStyle = function getSwitchRadioStyle(mainColor, contrastColor, switchRadioColor) {
  return {
    rollerBorder: {
      default: switchRadioColor.rollerBorder,
      hover: switchRadioColor.rollerBorder,
      selected: mainColor
    },
    rollerFill: {
      default: switchRadioColor.rollerFill,
      hover: switchRadioColor.lineBorderFill,
      selected: mainColor
    },
    rollerCenter: {
      default: switchRadioColor.rollerCenter,
      hover: switchRadioColor.lineBorderFill,
      selected: switchRadioColor.rollerCenterSelected
    },
    lineBorderFill: {
      default: switchRadioColor.lineBorderFill,
      hover: switchRadioColor.lineBorderFill,
      selected: mainColor
    }
  };
};

/**
 * @function getColors - function to separate the background color and surface color for theming.
 * @param {String} color - combination of background and surface color names separated by '-'.
 * @returns {object} - object containing background and surface colors.
 */

var getColors = function getColors(color) {
  var colors = color.split('-');
  var bgColor = colors[0];
  var surfaceColor = bgColor;

  if (colors.length > 1 && colors[1] !== '') {
    surfaceColor = colors[1];
  }

  if (bgColor === '') {
    bgColor = surfaceColor;
  }

  return {
    bgColor: bgColor,
    surfaceColor: surfaceColor
  };
};
/**
 * @function getBorderRadius - function to get the classes to be applied for border radius.
 * @param {String} borders - array containing borders for all 4 sides or for only one side
 * @returns {String} - String of class names to apply for border radius.
 */

var getBorderRadius = function getBorderRadius() {
  var borderRadiusClasses = '';

  for (var _len = arguments.length, borders = new Array(_len), _key = 0; _key < _len; _key++) {
    borders[_key] = arguments[_key];
  }

  if (borders.length === 1) {
    // Logic in case there is single value
    switch (borders[0].toString().toLowerCase().trim()) {
      case 'small':
        return 'allBorderRadiusSmall';

      case 'medium':
        return 'allBorderRadiusMedium';

      case 'large':
        return 'allBorderRadiusLarge';

      case 'xlarge':
        return 'allBorderRadiusXLarge';

      case 'circle':
        return 'allBorderRadiusXLarge';
      // to make circle using border

      default:
        return 'noBorderRadius';
    }
  } // Logic in case there are multiple values


  switch (borders[0].toString().toLowerCase().trim()) {
    case 'small':
      borderRadiusClasses += 'borderRadiusSmallTopLeft ';
      break;

    case 'medium':
      borderRadiusClasses += 'borderRadiusMediumTopLeft ';
      break;

    case 'large':
      borderRadiusClasses += 'borderRadiusLargeTopLeft ';
      break;

    case 'xlarge':
      borderRadiusClasses += 'borderRadiusXLargeTopLeft ';
      break;

    case 'circle':
      borderRadiusClasses += 'borderRadiusCircleTopLeft ';
      break;

    default:
      borderRadiusClasses += 'noBorderRadiusTopLeft ';
  }

  switch (borders[1].toString().toLowerCase().trim()) {
    case 'small':
      borderRadiusClasses += 'borderRadiusSmallTopRight ';
      break;

    case 'medium':
      borderRadiusClasses += 'borderRadiusMediumTopRight ';
      break;

    case 'large':
      borderRadiusClasses += 'borderRadiusLargeTopRight ';
      break;

    case 'xlarge':
      borderRadiusClasses += 'borderRadiusXLargeTopRight ';
      break;

    case 'circle':
      borderRadiusClasses += 'borderRadiusCircleTopRight ';
      break;

    default:
      borderRadiusClasses += 'noBorderRadiusTopRight ';
  }

  switch (borders[2].toString().toLowerCase().trim()) {
    case 'small':
      borderRadiusClasses += 'borderRadiusSmallBottomRight ';
      break;

    case 'medium':
      borderRadiusClasses += 'borderRadiusMediumBottomRight ';
      break;

    case 'large':
      borderRadiusClasses += 'borderRadiusLargeBottomRight ';
      break;

    case 'xlarge':
      borderRadiusClasses += 'borderRadiusXLargeBottomRight ';
      break;

    case 'circle':
      borderRadiusClasses += 'borderRadiusCircleBottomRight ';
      break;

    default:
      borderRadiusClasses += 'noBorderRadiusBottomRight ';
  }

  switch (borders[3].toString().toLowerCase().trim()) {
    case 'small':
      borderRadiusClasses += 'borderRadiusSmallBottomLeft ';
      break;

    case 'medium':
      borderRadiusClasses += 'borderRadiusMediumBottomLeft ';
      break;

    case 'large':
      borderRadiusClasses += 'borderRadiusLargeBottomLeft ';
      break;

    case 'xlarge':
      borderRadiusClasses += 'borderRadiusXLargeBottomLeft ';
      break;

    case 'circle':
      borderRadiusClasses += 'borderRadiusCircleBottomLeft ';
      break;

    default:
      borderRadiusClasses += 'noBorderRadiusBottomLeft ';
  }

  return borderRadiusClasses.trim();
};
/**
 * @function getThemes - function to get the themes.
 * @param {String} mainColor - main color name of the theme
 * @param {String} contrastColor - contrast color name of the theme
 * @param {String} supportTextHover - text color name for hover on support component
 * @param {Object} iconColors - icon colors
 * @param {Object} switchRadioColors -border color for switch radio
 * @returns {object} - object containing theme colors for atoms and molecules.
 */

var getThemes = function getThemes(mainColor, contrastColor, supportTextHover, iconColors, switchRadioColors) {
  return {
    /*
     * TODO: To be deleted
     */
    light: '#f2f2f2',
    dark: '#8f8f8f',
    color: mainColor,
    main: mainColor,
    contrastText: contrastColor,
    button: getButtonStyle(mainColor, contrastColor),
    radioButton: getRadioButtonStyle(mainColor, contrastColor),
    dropdown: getDropdownStyle(mainColor, contrastColor),
    checkbox: getCheckboxStyle(mainColor, contrastColor),
    icon: getIconStyle(mainColor, contrastColor, iconColors),
    chip: getChipStyle(mainColor, contrastColor),
    switchRadio: getSwitchRadioStyle(mainColor, contrastColor, switchRadioColors),
    supportTextHover: supportTextHover
  };
};
var getHeadings = function getHeadings() {
  return {
    h0: {
      margin: 0,
      fontSize: fontSize.T0,
      lineHeight: lineHeight.L0,
      fontWeight: fontWeights.bolder,
      '@media (max-width:600px)': {
        fontSize: fontSize.T3,
        lineHeight: lineHeight.L3
      }
    },
    h1: {
      margin: 0,
      fontSize: fontSize.T1,
      lineHeight: lineHeight.L1,
      fontWeight: fontWeights.bold,
      marginBottom: space(2),
      '@media (max-width:600px)': {
        fontSize: fontSize.T2,
        lineHeight: lineHeight.L2
      }
    },
    h2: {
      fontSize: fontSize.T2,
      lineHeight: lineHeight.L2,
      margin: 0,
      fontWeight: fontWeights.bold,
      marginBottom: space(2),
      letterSpacing: 0,
      '@media (max-width:600px)': {
        fontSize: fontSize.T3,
        lineHeight: lineHeight.L3
      }
    },
    h2A: {
      fontSize: fontSize.T3,
      lineHeight: lineHeight.L3,
      margin: 0,
      fontWeight: fontWeights.bolder,
      marginBottom: space(2)
    },
    h3: {
      fontWeight: fontWeights.bold,
      fontSize: fontSize.T3,
      lineHeight: lineHeight.L3,
      margin: 0,
      marginBottom: space(2),
      '@media (max-width:600px)': {
        fontSize: fontSize.T4,
        lineHeight: lineHeight.L6
      }
    },
    h3A: {
      fontWeight: fontWeights.bolder,
      fontSize: fontSize.T4,
      lineHeight: lineHeight.L6,
      margin: 0,
      marginBottom: space(2)
    },
    h3B: {
      fontWeight: fontWeights.bolder,
      fontSize: fontSize.T2,
      lineHeight: lineHeight.L2,
      margin: 0,
      marginBottom: space(2),
      '@media (max-width:600px)': {
        fontSize: fontSize.T4,
        lineHeight: lineHeight.L6
      }
    },
    h4: {
      fontSize: fontSize.T4,
      lineHeight: lineHeight.L6,
      margin: 0,
      fontWeight: fontWeights.bolder,
      marginBottom: space(2),
      '@media (max-width:600px)': {
        fontSize: fontSize.T5,
        lineHeight: lineHeight.L8
      }
    },
    h4A: {
      fontWeight: fontWeights.bolder,
      fontSize: fontSize.T5,
      lineHeight: lineHeight.L8,
      margin: 0,
      marginBottom: space(2)
    },
    h4B: {
      fontWeight: fontWeights.bolder,
      fontSize: fontSize.T3,
      lineHeight: lineHeight.L3,
      margin: 0,
      marginBottom: space(2),
      '@media (max-width:600px)': {
        fontSize: fontSize.T5,
        lineHeight: lineHeight.L8
      }
    },
    h4C: {
      fontSize: fontSize.T5,
      fontWeight: fontWeights.bold,
      lineHeight: lineHeight.L5,
      '@media (max-width:600px)': {
        fontSize: fontSize.T6,
        lineHeight: lineHeight.L9
      }
    },
    h5: {
      fontSize: fontSize.T5,
      lineHeight: lineHeight.L8,
      margin: 0,
      fontWeight: fontWeights.bolder,
      marginBottom: space(2),
      '@media (max-width:600px)': {
        fontSize: fontSize.T6,
        lineHeight: lineHeight.L9
      }
    },
    h5A: {
      fontWeight: fontWeights.bolder,
      fontSize: fontSize.T6,
      lineHeight: lineHeight.L9,
      margin: 0,
      marginBottom: space(2)
    },
    h5B: {
      fontWeight: fontWeights.bolder,
      fontSize: fontSize.T4,
      lineHeight: lineHeight.L6,
      margin: 0,
      marginBottom: space(2),
      '@media (max-width:600px)': {
        fontSize: fontSize.T6,
        lineHeight: lineHeight.L9
      }
    },
    h6: {
      fontSize: fontSize.T6,
      lineHeight: lineHeight.L9,
      margin: 0,
      fontWeight: fontWeights.bolder,
      marginBottom: space(2)
    },
    h6A: {
      fontWeight: fontWeights.bolder,
      fontSize: fontSize.T7,
      lineHeight: lineHeight.L10,
      margin: 0,
      marginBottom: space(2)
    },
    h6B: {
      fontWeight: fontWeights.bolder,
      fontSize: fontSize.T5,
      lineHeight: lineHeight.L8,
      margin: 0,
      marginBottom: space(2),
      '@media (max-width:600px)': {
        fontSize: fontSize.T7,
        lineHeight: lineHeight.L10
      }
    },
    h6C: {
      fontSize: fontSize.T6,
      fontWeight: fontWeights.bolder,
      lineHeight: lineHeight.L9,
      '@media (max-width:600px)': {
        fontSize: fontSize.T7,
        lineHeight: lineHeight.L10
      }
    },
    h6D: {
      fontSize: fontSize.T6,
      lineHeight: lineHeight.L9,
      '@media (max-width:600px)': {
        fontSize: fontSize.T11,
        lineHeight: lineHeight.L15
      }
    },
    h7: {
      fontSize: fontSize.T7,
      lineHeight: lineHeight.L10,
      margin: 0,
      fontWeight: fontWeights.bold,
      letterSpacing: '0.6px'
    },
    h8: {
      fontSize: fontSize.T4,
      lineHeight: lineHeight.L4,
      fontWeight: fontWeights.normal,
      margin: 0,
      '@media (max-width:600px)': {
        fontSize: fontSize.T5,
        lineHeight: lineHeight.L5
      }
    },
    h9: {
      fontSize: fontSize.T2,
      lineHeight: lineHeight.L2,
      fontWeight: fontWeights.bolder,
      margin: 0,
      '@media (max-width:600px)': {
        fontSize: fontSize.T4,
        lineHeight: lineHeight.L6
      }
    },
    h10: {
      fontSize: fontSize.T11,
      lineHeight: lineHeight.L15,
      margin: 0,
      fontWeight: fontWeights.bold
    },
    body1: {
      fontSize: fontSize.T6,
      fontWeight: fontWeights.normal,
      lineHeight: lineHeight.L7,
      letterSpacing: 0
    },
    body1A: {
      fontSize: fontSize.T6,
      fontWeight: fontWeights.normal,
      lineHeight: lineHeight.L9
    },
    body2: {
      fontSize: fontSize.T7,
      fontWeight: fontWeights.normal,
      lineHeight: lineHeight.L10
    },
    body3: {
      fontSize: fontSize.T11,
      fontWeight: fontWeights.normal,
      lineHeight: lineHeight.L14
    },
    body4: {
      fontSize: fontSize.T5,
      fontWeight: fontWeights.normal,
      lineHeight: lineHeight.L5,
      '@media (max-width:600px)': {
        fontSize: fontSize.T6,
        lineHeight: lineHeight.L7
      }
    },
    body4B: {
      fontSize: fontSize.T5,
      fontWeight: fontWeights.normal,
      lineHeight: lineHeight.L5,
      '@media (max-width:600px)': {
        fontSize: fontSize.T6,
        lineHeight: lineHeight.L9
      }
    },
    body5: {
      fontSize: fontSize.T6,
      fontWeight: fontWeights.bolder,
      lineHeight: lineHeight.L9,
      '@media (max-width:600px)': {
        fontSize: fontSize.T11,
        lineHeight: lineHeight.L15
      }
    },
    bodyxs1: {
      fontSize: fontSize.T6,
      fontWeight: fontWeights.normal,
      lineHeight: lineHeight.L7,
      '@media (max-width:600px)': {
        fontSize: fontSize.T11,
        lineHeight: lineHeight.L14
      }
    },
    bodymd1: {
      fontSize: fontSize.T4,
      fontWeight: fontWeights.normal,
      lineHeight: lineHeight.L4,
      '@media (max-width:600px)': {
        fontSize: fontSize.T5,
        lineHeight: lineHeight.L5
      }
    },
    body6: {
      fontSize: fontSize.T11,
      fontWeight: fontWeights.normal,
      lineHeight: lineHeight.L14
    },
    searchRemoveBtn: {
      fontSize: fontSize.T7,
      fontWeight: fontWeights.normal,
      lineHeight: lineHeight.L9,
      '@media (max-width:600px)': {
        lineHeight: lineHeight.L10
      }
    },
    quote: {
      fontSize: fontSize.T5,
      fontWeight: fontWeights.normal,
      lineHeight: lineHeight.L5,
      fontStyle: fontStyles.italic
    },
    button: {
      fontWeight: fontWeights.bolder,
      fontSize: fontSize.T6,
      lineHeight: lineHeight.L9,
      letterSpacing: '0.6px',
      textTransform: 'initial'
    },
    button2: {
      fontWeight: fontWeights.bold,
      fontSize: fontSize.T7,
      lineHeight: lineHeight.L10,
      letterSpacing: '0.6px',
      textTransform: 'initial'
    },
    radioButton: {
      fontWeight: fontWeights.bold,
      fontSize: fontSize.T6,
      lineHeight: lineHeight.L9,
      '@media (max-width:600px)': {
        lineHeight: lineHeight.L7
      }
    },
    checkBox: {
      fontWeight: fontWeights.normal,
      fontSize: fontSize.T7,
      lineHeight: lineHeight.L9
    },
    small: {
      fontSize: fontSize.T8,
      lineHeight: 1.25
    },
    selectBox: {
      fontWeight: fontWeights.normal,
      fontSize: fontSize.T7,
      lineHeight: lineHeight.L9
    },
    conversionFormLabel: {
      fontWeight: fontWeights.normal,
      fontSize: fontSize.T4,
      lineHeight: lineHeight.L4,
      '@media (max-width:600px)': {
        fontSize: fontSize.T5,
        lineHeight: lineHeight.L5
      }
    },
    conversionFormInput: {
      fontWeight: fontWeights.bolder,
      fontSize: fontSize.T4,
      lineHeight: lineHeight.L11,
      '@media (max-width:900px)': {
        fontSize: fontSize.T5,
        lineHeight: lineHeight.L12
      }
    },
    conversionFormTextarea: {
      fontWeight: fontWeights.bolder,
      fontSize: fontSize.T4,
      lineHeight: lineHeight.L4,
      '@media (max-width:600px)': {
        fontSize: fontSize.T5,
        lineHeight: lineHeight.L5
      }
    }
  };
};
var getPaddingString = function getPaddingString(_ref) {
  var _ref$paddingTop = _ref.paddingTop,
      paddingTop = _ref$paddingTop === void 0 ? 'large' : _ref$paddingTop,
      _ref$paddingBottom = _ref.paddingBottom,
      paddingBottom = _ref$paddingBottom === void 0 ? 'large' : _ref$paddingBottom;
  var paddingString = '';

  switch (paddingTop.toString().toLowerCase().trim()) {
    case 'medium':
      paddingString += 'paddingTopMedium ';
      break;

    case 'large':
      paddingString += 'paddingTopLarge ';
      break;

    default:
      paddingString += 'paddingTopNone ';
  }

  switch (paddingBottom.toString().toLowerCase().trim()) {
    case 'medium':
      paddingString += 'paddingBottomMedium ';
      break;

    case 'large':
      paddingString += 'paddingBottomLarge ';
      break;

    default:
      paddingString += 'paddingBottomNone ';
  }

  return paddingString;
};

var primary = getThemes(fwdColors.orange, fwdColors.white, fwdColors.white, {
  toolTipIconText: fwdColors.darkGreen,
  buttonIconSecondaryColor: fwdColors.white
}, {
  rollerBorder: fwdColors.greyDarker,
  rollerFill: fwdColors.greyDarker,
  rollerCenter: fwdColors.white,
  rollerCenterSelected: fwdColors.white,
  lineBorderFill: fwdColors.greyDarker
});
var secondary = getThemes(fwdColors.white, fwdColors.orange, fwdColors.darkGreen, {
  toolTipIconText: fwdColors.white,
  buttonIconSecondaryColor: fwdColors.darkGreen
}, {
  rollerBorder: fwdColors.white,
  rollerFill: fwdColors.orange,
  rollerCenter: fwdColors.white,
  rollerCenterSelected: fwdColors.orange,
  lineBorderFill: fwdColors.white
}); //to generate backgrounds for flexicontainer

function generateBackgrounds(theme) {
  var colors = theme.palette.colors;
  var backgrounds = {};
  var pseudoElm = {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: 0,
    bottom: 0,
    zIndex: -1,
    boxSizing: 'border-box'
  };
  Object.keys(colors).forEach(function (color) {
    /** For Default */
    [3, 4, 5, 6, 7, 8, 9].forEach(function (col) {
      var _objectSpread2$1, _backgrounds$grid$co, _objectSpread3, _backgrounds$grid$co2;

      backgrounds["grid-".concat(1, "-", col, "-").concat(color)] = (_backgrounds$grid$co = {
        '& a, a:visited, a:link ': {
          color: colors[color].linkColor
        },
        hr: {
          backgroundColor: colors[color].contrastText
        }
      }, _defineProperty(_backgrounds$grid$co, theme.breakpoints.down('xs'), {
        position: 'relative'
      }), _defineProperty(_backgrounds$grid$co, '&::before', _objectSpread2(_objectSpread2({}, pseudoElm), {}, (_objectSpread2$1 = {
        position: 'absolute',
        zIndex: 0,
        left: '-4px',
        right: '-4px',
        top: theme.spacing(-8),
        color: colors[color].contrastText,
        backgroundColor: colors[color].main
      }, _defineProperty(_objectSpread2$1, theme.breakpoints.up('sm'), {
        // +1px to fix browser rendering issues despite correct calculation
        left: '-1px',
        right: "calc((12 - ".concat(col, ") / 12 * 100vw)"),
        top: 0
      }), _defineProperty(_objectSpread2$1, theme.breakpoints.up('lg'), {
        left: 0,
        right: "calc((100% - (960px - 64px + 24px))/2 + ((12 - ".concat(col, ") / 12 * (960px - 64px + 24px)))")
      }), _defineProperty(_objectSpread2$1, theme.breakpoints.up('xl'), {
        left: 0,
        right: "calc((100% - (1288px - 64px + 24px))/2 + ((12 - ".concat(col, ") / 12 * (1288px - 64px + 24px)))")
      }), _objectSpread2$1))), _backgrounds$grid$co);
      backgrounds["grid-".concat(2, "-", col, "-").concat(color)] = (_backgrounds$grid$co2 = {
        '& a': {
          color: colors[color].linkText
        },
        '& hr': {
          backgroundColor: colors[color].contrastText
        }
      }, _defineProperty(_backgrounds$grid$co2, theme.breakpoints.down('xs'), {
        position: 'relative'
      }), _defineProperty(_backgrounds$grid$co2, theme.breakpoints.between('md', 'lg'), {
        position: 'static'
      }), _defineProperty(_backgrounds$grid$co2, '&::before', _objectSpread2(_objectSpread2({}, pseudoElm), {}, (_objectSpread3 = {
        position: 'absolute',
        zIndex: 0,
        left: '-4px',
        right: '-4px',
        bottom: 0,
        color: colors[color].contrastText,
        backgroundColor: colors[color].main
      }, _defineProperty(_objectSpread3, theme.breakpoints.up('sm'), {
        // +1px to fix browser rendering issues despite correct calculation
        left: "calc((12 - ".concat(col, ") / 12 * 100vw)"),
        right: '1px',
        bottom: 0
      }), _defineProperty(_objectSpread3, theme.breakpoints.up('lg'), {
        // FWDS-5157 background color is not align with the content when using two column Flexi Container.
        // The previous calculation will not work when using two column 7-5, 8-4, 9-3.
        // Update calculation to support all column sizes.
        left: "calc((12 - ".concat(col, ") / 12 * 100vw)"),
        right: 0
      }), _defineProperty(_objectSpread3, theme.breakpoints.up('xl'), {
        left: "calc((100% - (1288px - 64px + 24px))/2 + ((12 - ".concat(col, ") / 12 * (1288px - 64px + 24px)))"),
        right: 0
      }), _objectSpread3))), _backgrounds$grid$co2);
    });
  });
  return backgrounds;
}

function theming(lang) {
  var headings = getHeadings();
  var palette = {
    primary: primary,
    secondary: secondary,
    colors: {
      /*
       * TODO: Delete param 'theme' from the colors.
       */
      orange: {
        main: fwdColors.orange,
        contrastTextAction: fwdColors.white,
        contrastTextLabel: fwdColors.white,
        contrastText: fwdColors.white,
        contrastTextCaption: fwdColors.white,
        closeBtn: fwdColors.white,
        line: {
          divider: alpha(fwdColors.white, 0.2),
          textFieldDefault: fwdColors.white,
          textFieldFocus: fwdColors.white,
          textFieldFilled: fwdColors.white
        },
        slick: {
          dotsDefault: fwdColors.white,
          dotsActive: fwdColors.white
        },
        stepper: {
          dot: fwdColors.grey,
          connector: fwdColors.greyDark
        },
        searchInput: {
          background: 'white'
        },
        tabsBackground: fwdColors.orangeLighter,
        supportHover: 'secondary',
        secondaryIcon: fwdColors.white,
        button: 'secondary',
        icon: 'secondary',
        chip: 'secondary',
        switchRadio: 'secondary'
      },
      white: {
        main: fwdColors.white,
        contrastTextAction: fwdColors.orange,
        contrastTextLabel: fwdColors.orange,
        contrastText: fwdColors.darkGreen,
        contrastTextCaption: fwdColors.greyDarkest,
        closeBtn: fwdColors.darkGreen,
        line: {
          divider: fwdColors.grey,
          textFieldDefault: fwdColors.greyDarker,
          textFieldFocus: fwdColors.orange,
          textFieldFilled: fwdColors.darkGreen
        },
        searchInput: {
          background: 'orange'
        },
        slick: {
          dotsDefault: fwdColors.grey,
          dotsActive: fwdColors.orange
        },
        stepper: {
          dot: fwdColors.grey,
          connector: fwdColors.greyDark
        },
        tabsBackground: fwdColors.orangeLighter,
        //  intially for close button in dialogs
        supportHover: 'primary',
        secondaryIcon: fwdColors.darkGreen,
        button: 'primary',
        icon: 'primary',
        chip: 'primary',
        switchRadio: 'primary'
      },
      orangeLight: {
        main: fwdColors.orangeLight,
        contrastTextAction: fwdColors.orange,
        contrastTextLabel: fwdColors.orange,
        contrastText: fwdColors.darkGreen,
        contrastTextCaption: fwdColors.greyDarkest,
        closeBtn: fwdColors.darkGreen,
        line: {
          divider: fwdColors.greyDark,
          textFieldDefault: fwdColors.greyDarker,
          textFieldFocus: fwdColors.orange,
          textFieldFilled: fwdColors.darkGreen
        },
        searchInput: {
          background: 'orange'
        },
        slick: {
          dotsDefault: fwdColors.grey,
          dotsActive: fwdColors.orange
        },
        stepper: {
          dot: fwdColors.white,
          connector: fwdColors.white
        },
        tabsBackground: fwdColors.orangeLighter,
        //  intially for close button in dialogs
        supportHover: 'primary',
        secondaryIcon: fwdColors.darkGreen,
        button: 'primary',
        icon: 'primary',
        chip: 'primary',
        switchRadio: 'primary'
      },
      orangeLighter: {
        main: fwdColors.orangeLighter,
        contrastTextAction: fwdColors.orange,
        contrastTextLabel: fwdColors.orange,
        contrastText: fwdColors.darkGreen,
        contrastTextCaption: fwdColors.greyDarkest,
        closeBtn: fwdColors.darkGreen,
        line: {
          divider: fwdColors.grey,
          textFieldDefault: fwdColors.greyDarker,
          textFieldFocus: fwdColors.orange,
          textFieldFilled: fwdColors.darkGreen
        },
        searchInput: {
          background: 'orange'
        },
        slick: {
          dotsDefault: fwdColors.grey,
          dotsActive: fwdColors.orange
        },
        stepper: {
          dot: fwdColors.white,
          connector: fwdColors.white
        },
        tabsBackground: fwdColors.orangeLighter,
        //  intially for close button in dialogs
        secondaryIcon: fwdColors.darkGreen,
        supportHover: 'primary',
        button: 'primary',
        icon: 'primary',
        chip: 'primary',
        switchRadio: 'primary'
      },
      grey: {
        main: fwdColors.grey,
        contrastTextAction: fwdColors.orange,
        contrastTextLabel: fwdColors.orange,
        contrastText: fwdColors.darkGreen,
        contrastTextCaption: fwdColors.greyDarkest,
        closeBtn: fwdColors.darkGreen,
        line: {
          divider: fwdColors.greyDark,
          textFieldDefault: fwdColors.greyDarker,
          textFieldFocus: fwdColors.orange,
          textFieldFilled: fwdColors.darkGreen
        },
        searchInput: {
          background: 'orange'
        },
        slick: {
          dotsDefault: fwdColors.white,
          dotsActive: fwdColors.orange
        },
        stepper: {
          dot: fwdColors.white,
          connector: fwdColors.greyDark
        },
        tabsBackground: fwdColors.orangeLighter,
        //  intially for close button in dialogs
        supportHover: 'primary',
        secondaryIcon: fwdColors.darkGreen,
        button: 'primary',
        icon: 'primary',
        chip: 'primary',
        switchRadio: 'primary'
      },
      darkGreen: {
        main: fwdColors.darkGreen,
        contrastTextAction: fwdColors.orange,
        contrastTextLabel: fwdColors.orange,
        contrastText: fwdColors.white,
        contrastTextCaption: fwdColors.white,
        closeBtn: fwdColors.white,
        line: {
          divider: alpha(fwdColors.white, 0.2),
          textFieldDefault: fwdColors.grey,
          textFieldFocus: fwdColors.orange,
          textFieldFilled: fwdColors.white
        },
        slick: {
          dotsDefault: alpha(fwdColors.white, 0.2),
          dotsActive: fwdColors.white
        },
        stepper: {
          dot: fwdColors.white,
          connector: fwdColors.greyDark
        },
        searchInput: {
          background: 'white'
        },
        tabsBackground: fwdColors.orangeLighter,
        secondaryIcon: fwdColors.white,
        supportHover: 'primary',
        button: 'primary',
        icon: 'primary',
        chip: 'primary',
        switchRadio: 'primary'
      }
    },
    border: {
      tagBorder: '1px solid #8C8C8C',
      border200: '1px solid #B3B3B3',
      border300: '1px solid #000000',
      border400: '1px solid #E6E6E6',
      border500: '1px solid #333333'
    },
    error: {
      main: fwdColors.red,
      background: fwdColors.redLight
    },
    background: {
      paper: '#fff',
      default: '#f5f5f5',
      chip: '#f2f2f2'
    },
    text: {
      light: '#8c8c8c',
      normal: '#333333'
    },
    toolTip: {
      background: fwdColors.orangeLighter,
      contrastText: fwdColors.darkGreen,
      shadow: "0 0 8px 0 ".concat(alpha(fwdColors.black, 0.2))
    },
    fwdLogo: {
      main: fwdColors.fwdLogo
    }
  };
  var theme = createTheme({
    palette: palette,
    typography: _objectSpread2(_objectSpread2(_objectSpread2({}, headings), fontSize), {}, {
      lineHeight: lineHeight,
      fontWeights: fontWeights
    }),
    shadows: ['none', '0 4px 16px 0 rgba(0,0,0,0.08)', 'inset 9px 0px 5px -5px rgb(211,211,211)', 'inset 9px 0px 5px -5px rgba(64, 57, 57, 0.13)', '0 6px 8px 0 rgba(0,0,0,0.2)', '0 2px 4px 0 rgba(0,0,0,0.2)', '2px 0 4px 0 rgba(0,0,0,0.2)'],
    breakpoints: breakpoints,
    easing: easing
  });
  var backgrounds = generateBackgrounds(theme);
  Object.assign(theme, {
    backgrounds: backgrounds
  });
  return theme;
}

function generateGlobals(thm) {
  var brandings = getBrandingClasses(thm);
  return {
    '@global': _objectSpread2(_objectSpread2({}, brandings), globals)
  };
}

var theme$1 = function theme(siteName, lang) {
  var thm = theming();
  thm.globals = generateGlobals(thm);
  return thm;
};

var headerStyles = makeStyles(function (theme) {
  var _item, _link, _rightContent, _MuiButtonRootBtn, _rightContentButton, _primaryNav, _primaryLink, _secondaryNav, _MuiButtonBaseRoot;

  var colors = theme.palette.colors || {};
  var theming = {};
  Object.keys(colors).forEach(function (color) {
    /** For Default */
    theming["header-".concat(color)] = {
      "&$state--component-below": {
        "&$fluidHeader": {
          "& $headerWrapper": {
            "&:before": {
              boxShadow: "0 0 0 0 rgba(0, 0, 0, 0.0)",
              borderBottom: "1px solid ".concat(theme.palette.colors[color].line.divider)
            }
          }
        }
      },
      "& $active": _defineProperty({}, theme.breakpoints.up("xl"), {
        "&:before": {
          backgroundColor: theme.palette.colors[color].contrastTextAction
        }
      }),
      "& $borderColor": {
        borderColor: theme.palette.colors[color].line.divider
      },
      "& $primaryLink": {
        color: theme.palette.colors[color].contrastText,
        "&:hover": {
          color: theme.palette.colors[color].contrastTextAction
        },
        "& .startIcon": {
          "& .MuiSvgIcon-root path": {
            fill: theme.palette.colors[color].contrastTextAction
          }
        }
      },
      "& $secondaryNav": {
        borderColor: theme.palette.colors[color].line.divider,
        "&:before": _defineProperty({}, theme.breakpoints.up("xl"), {
          backgroundColor: theme.palette.colors[color].line.divider
        })
      },
      "& $secondaryLink": {
        color: theme.palette.colors[color].contrastTextCaption,

        /* tablet fix, defining styles inline */
        "&:hover": {
          color: theme.palette.colors[color].contrastTextAction
        }
      },
      "& $icon": {
        "&.MuiSvgIcon-root, &>.MuiSvgIcon-root": {
          "& path": {
            fill: theme.palette.colors[color].contrastTextAction
          }
        }
      },
      "& $countrySelectorLeadingText": {
        color: theme.palette.colors[color].line.textFieldDefault
      },
      "& $item": {
        "&.hasBorderLeft": {
          borderColor: theme.palette.colors[color].line.divider
        }
      }
    };
    theming["menuItem-".concat(color)] = {
      "& .startIcon": {
        "& .MuiSvgIcon-root": {
          "& path": {
            fill: theme.palette.colors[color].contrastTextAction
          }
        }
      },
      "&:hover": {
        // overriding material's .MuiListItem-button:hover
        backgroundColor: "".concat(theme.palette.colors[color].contrastTextAction, " !important"),
        "& .startIcon": {
          "& .MuiSvgIcon-root": {
            "& path": {
              fill: theme.palette.colors[color].main
            }
          }
        },
        "& .MuiTypography-root": {
          /* overriding global */
          color: "".concat(theme.palette.colors[color].main, " !important")
        }
      }
    };
  });
  return _objectSpread2({
    fixed: {},
    scrolled: {},
    enableMargin: {},
    fluidHeader: {
      "& $headerWrapper": {
        "&:before": {
          left: 0,
          borderBottomLeftRadius: 0
        }
      }
    },
    searchForm: _defineProperty({
      paddingLeft: "0",
      paddingRight: "0"
    }, theme.breakpoints.up("sm"), {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5)
    }),
    containerWidth: {
      display: "flex",
      alignItems: "center",
      padding: "".concat(theme.spacing(3), "px ").concat(theme.spacing(2), "px ").concat(theme.spacing(3), "px ").concat(theme.spacing(2), "px "),
      margin: "0 ".concat(theme.spacing(-2), "px")
    },
    header: {
      width: "100%",
      position: "absolute",
      zIndex: 1000,
      "&$scrolled": {
        pointerEvents: "none",
        "& $headerWrapper": {
          transform: "translateY(-100%)",
          "&:before": {
            boxShadow: "0 0 0 0 rgba(0, 0, 0, 0.0)"
          }
        }
      },
      "&$fixed": {
        position: "fixed",
        top: 0
      },
      "&$enableMargin": {
        "&+*": _defineProperty({
          marginTop: theme.spacing(7)
        }, theme.breakpoints.up("xl"), {
          marginTop: theme.spacing(9)
        })
      }
    },
    headerWrapper: {
      display: "flex",
      transition: "transform 400ms ".concat(transitionFunction.easeIn),
      transform: "translateY(0%)",
      "&:before": _defineProperty({
        content: "close-quote",
        position: "absolute",
        left: theme.spacing(7),
        top: 0,
        right: 0,
        height: theme.spacing(7),
        borderBottomLeftRadius: theme.spacing(2),
        backgroundColor: "white",
        boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.1)",
        transition: "all ".concat(timings.large, " ").concat(transitionFunction.easeIn)
      }, theme.breakpoints.up("xl"), {
        height: theme.spacing(9),
        left: theme.typography.pxToRem(71)
      })
    },
    "state--component-below": {},
    menuOpen: {
      "&$fluidHeader": {
        "& $headerWrapper": {
          transform: "translateY(0%)",
          "&:before": {
            left: theme.spacing(7),
            borderBottomLeftRadius: theme.spacing(2),
            boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.1)",
            borderBottom: "none"
          }
        }
      }
    },
    item: (_item = {
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      height: theme.spacing(7),
      transition: "height ".concat(timings.large, " ").concat(transitionFunction.easeIn)
    }, _defineProperty(_item, theme.breakpoints.up("xl"), {
      height: theme.spacing(9)
    }), _defineProperty(_item, "&.hasBorderLeft", _defineProperty({}, theme.breakpoints.up("xl"), {
      paddingLeft: theme.spacing(1.5),
      borderLeft: "1px solid"
    })), _item),
    mobileHeaderLanguageSwitchItem: {
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      transition: "height ".concat(timings.large, " ").concat(transitionFunction.easeIn),
      "&.hasBorderLeft": _defineProperty({}, theme.breakpoints.up("xl"), {
        paddingLeft: theme.spacing(1.5),
        borderLeft: "1px solid"
      })
    },
    link: (_link = {}, _defineProperty(_link, theme.breakpoints.up("xl"), {
      marginLeft: theme.spacing(2.5),
      "&:first-child": {
        marginLeft: 0
      }
    }), _defineProperty(_link, "&$active", {}), _link),
    mobileCheck: _defineProperty({
      display: "none"
    }, theme.breakpoints.up("xl"), {
      display: "inline-flex",
      width: theme.spacing(6),
      justifyContent: "flex-end"
    }),
    active: _defineProperty({}, theme.breakpoints.up("xl"), {
      position: "relative",
      "&:before": {
        content: "close-quote",
        width: "100%",
        height: theme.spacing(0.5),
        position: "absolute",
        bottom: 0
      }
    }),
    borderColor: {
      zIndex: 1
    },
    mobileView: {
      "&$rightContentButton": _defineProperty({
        display: "inline-flex"
      }, theme.breakpoints.up("xl"), {
        display: "none"
      })
    },
    desktopView: {
      "&$rightContentButton": _defineProperty({
        display: "none"
      }, theme.breakpoints.up("xl"), {
        display: "inline-flex"
      })
    },
    leftContent: _defineProperty({
      zIndex: 0,
      paddingLeft: theme.spacing(2),
      transition: "paddingLeft ".concat(timings.large, " ").concat(transitionFunction.easeIn)
    }, theme.breakpoints.up("xl"), {
      paddingLeft: theme.spacing(4)
    }),
    rightContent: (_rightContent = {
      position: "absolute",
      right: 0,
      top: 0,
      display: "flex",
      marginRight: theme.spacing(2)
    }, _defineProperty(_rightContent, theme.breakpoints.up("xl"), {
      marginRight: theme.spacing(1)
    }), _defineProperty(_rightContent, "& $item", {
      marginLeft: theme.spacing(2.5),
      "&:first-child": {
        marginLeft: 0
      }
    }), _defineProperty(_rightContent, ".modal--open &", _defineProperty({}, theme.breakpoints.up("xl"), {
      right: theme.typography.pxToRem(15)
    })), _defineProperty(_rightContent, "&.portalOffset", _defineProperty({}, theme.breakpoints.up("xl"), {
      right: theme.typography.pxToRem(15)
    })), _rightContent),
    rightContentButton: (_rightContentButton = {
      fontWeight: theme.typography.fontWeights.bolder,
      lineHeight: theme.typography.lineHeight.L9
    }, _defineProperty(_rightContentButton, theme.breakpoints.down("lg"), {
      lineHeight: theme.typography.lineHeight.L9,
      marginLeft: theme.spacing(-1),
      marginRight: theme.spacing(-1),
      "&:hover": {
        backgroundColor: "transparent"
      }
    }), _defineProperty(_rightContentButton, "& .MuiButton-rootBtn", (_MuiButtonRootBtn = {
      minWidth: "auto"
    }, _defineProperty(_MuiButtonRootBtn, theme.breakpoints.up("xl"), {
      padding: "".concat(theme.spacing(0.75), "px ").concat(theme.spacing(2), "px"),
      height: theme.spacing(4)
    }), _defineProperty(_MuiButtonRootBtn, "& .MuiButton-buttonText", {
      fontWeight: theme.typography.fontWeights.bolder,
      lineHeight: "100%"
    }), _MuiButtonRootBtn)), _rightContentButton),
    hideMobile: {},
    mobileNav: {},
    primaryNav: (_primaryNav = {
      paddingLeft: 0,
      display: "flex",
      flexDirection: "column"
    }, _defineProperty(_primaryNav, theme.breakpoints.up("xl"), {
      flexDirection: "row",
      alignItems: "center",
      height: "100%",
      paddingLeft: theme.spacing(4)
    }), _defineProperty(_primaryNav, "& $link", _defineProperty({
      marginTop: theme.spacing(2),
      "&:first-child": _defineProperty({
        marginTop: 0
      }, theme.breakpoints.up("xl"), {
        marginLeft: 0
      })
    }, theme.breakpoints.up("xl"), {
      marginTop: 0,
      marginLeft: theme.spacing(2.5)
    })), _defineProperty(_primaryNav, "&.hideMobile", _defineProperty({}, theme.breakpoints.down("lg"), {
      display: "none"
    })), _primaryNav),
    primaryLink: (_primaryLink = {
      display: "inline-flex",
      fontSize: theme.typography.T5,
      lineHeight: theme.typography.lineHeight.L8,
      fontWeight: theme.typography.fontWeights.bolder,
      letterSpacing: "normal"
    }, _defineProperty(_primaryLink, theme.breakpoints.up("xl"), _objectSpread2(_objectSpread2({}, theme.typography.h6D), {}, {
      fontWeight: theme.typography.fontWeights.bolder,
      textAlign: "center"
    })), _defineProperty(_primaryLink, "&:hover", {}), _defineProperty(_primaryLink, "& .startIcon", {
      height: theme.spacing(4),
      marginRight: theme.spacing(2),
      "& .MuiSvgIcon-root": {
        /* overriding material default */
        height: "".concat(theme.spacing(3), "px !important"),
        width: "".concat(theme.spacing(3), "px !important")
      }
    }), _primaryLink),
    secondaryNav: (_secondaryNav = {
      paddingLeft: 0,
      marginLeft: 0,
      marginTop: theme.spacing(3),
      paddingTop: theme.spacing(3),
      borderTop: "1px solid",
      display: "flex",
      flexDirection: "column",
      position: "relative"
    }, _defineProperty(_secondaryNav, theme.breakpoints.up("xl"), {
      paddingLeft: theme.spacing(2.5),
      marginLeft: theme.spacing(2.5),
      marginTop: 0,
      paddingTop: 0,
      borderTop: "none",
      flexDirection: "row",
      alignItems: "center",
      height: "100%"
    }), _defineProperty(_secondaryNav, "&:before", {
      content: "close-quote",
      left: 0,
      position: "absolute",
      width: "1px"
    }), _defineProperty(_secondaryNav, "&.lines1", {
      "&:before": {
        height: "20px"
      }
    }), _defineProperty(_secondaryNav, "&.lines2", {
      "&:before": {
        height: "40px"
      }
    }), _defineProperty(_secondaryNav, "& $link", _defineProperty({
      marginTop: theme.spacing(2),
      "&:first-child": _defineProperty({
        marginTop: 0
      }, theme.breakpoints.up("xl"), {
        marginLeft: 0
      })
    }, theme.breakpoints.up("xl"), {
      marginTop: 0,
      marginLeft: theme.spacing(2.5)
    })), _defineProperty(_secondaryNav, "&.hideMobile", _defineProperty({}, theme.breakpoints.down("lg"), {
      display: "none"
    })), _secondaryNav),
    secondaryLink: {
      "& p": _defineProperty({}, theme.breakpoints.up("xl"), _objectSpread2(_objectSpread2({}, theme.typography.h6D), {}, {
        fontWeight: theme.typography.fontWeights.normal,
        textAlign: "center"
      })),
      "& .MuiTypography-root": {
        letterSpacing: "normal"
      }
    },
    icon: {
      "&.MuiSvgIcon-root, &>.MuiSvgIcon-root": _defineProperty({
        cursor: "pointer",
        height: theme.spacing(3),
        width: theme.spacing(3)
      }, theme.breakpoints.up("xl"), {
        height: theme.spacing(4),
        width: theme.spacing(4)
      })
    },
    searchModalTitle: {
      "&.MuiTypography-h2": {
        fontWeight: theme.typography.fontWeights.bolder
      }
    },
    searchModalCloseBtn: {
      width: "".concat(theme.spacing(4), "px !important"),
      height: "".concat(theme.spacing(4), "px !important"),
      minWidth: "".concat(theme.spacing(4), "px !important"),
      minHeight: "".concat(theme.spacing(4), "px !important"),
      maxWidth: "".concat(theme.spacing(4), "px !important"),
      padding: "0px !important",
      position: "fixed !important",
      zIndex: 1,
      display: "flex !important",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      borderRadius: "50% !important",
      backgroundColor: fwdColors.white,
      right: theme.spacing(2),
      top: theme.spacing(2),
      boxShadow: "0 2px 4px 0 rgba(0,0,0,0.2)",
      "&.MuiButtonBase-root": (_MuiButtonBaseRoot = {
        "&:hover": {
          backgroundColor: fwdColors.orange,
          "& path": {
            fill: fwdColors.white
          }
        }
      }, _defineProperty(_MuiButtonBaseRoot, theme.breakpoints.up("sm"), {
        right: theme.spacing(6),
        top: theme.spacing(6)
      }), _defineProperty(_MuiButtonBaseRoot, "& svg", {
        width: theme.spacing(2),
        height: theme.spacing(2),
        "& path": {
          fill: fwdColors.darkGreen
        },
        "&:focus": {
          outline: "none"
        }
      }), _MuiButtonBaseRoot)
    },
    searchModalContainer: _defineProperty({}, theme.breakpoints.down("md"), {
      height: "100vh"
    }),
    menuItem: {
      "& .MuiLink-root": {
        display: "flex",
        alignItems: "flex-start"
      },
      "& .startIcon": {
        marginRight: theme.spacing(2),
        marginTop: 0,
        height: theme.spacing(3),
        "& .MuiSvgIcon-root": {
          margin: 0,

          /* overriding material default */
          height: "".concat(theme.spacing(3), "px !important"),
          width: "".concat(theme.spacing(3), "px !important")
        }
      },
      "& .MuiTypography-root": {
        whiteSpace: "break-spaces",
        fontWeight: theme.typography.fontWeights.bold
      }
    },
    popperMenuItem: {
      maxWidth: theme.spacing(30),
      width: "100%",

      /* overriding material default */
      paddingTop: "".concat(theme.spacing(1.5), "px !important"),
      paddingBottom: "".concat(theme.spacing(1.5), "px !important"),
      "&:focus, &.MuiMenuItem-root.Mui-focusVisible": {
        backgroundColor: "transparent"
      },
      "& .MuiTypography-root": {
        width: "100%",
        whiteSpace: "normal"
      }
    },
    popper: {
      '&[x-placement*="bottom"]': {
        /* overridding dynamic inline csss */
        marginTop: "0!important"
      }
    },
    countrySelectorLeadingText: {},
    loginLinksText: {
      fontWeight: theme.typography.fontWeights.bold,
      "& span": {
        fontWeight: theme.typography.fontWeights.bold,
        "&:nth-child(2)": {
          marginLeft: theme.spacing(1)
        }
      }
    },
    searchModalContainerInner: _defineProperty({
      position: "absolute",
      top: theme.spacing(2),
      right: theme.spacing(2)
    }, theme.breakpoints.up("xl"), {
      top: theme.spacing(6),
      right: theme.spacing(6)
    }),
    mobileModal: {
      marginTop: theme.spacing(1)
    },
    mobileHeaderMenuDialog: {
      marginTop: theme.spacing(16),
      marginBottom: theme.spacing(7),
      paddingBottom: theme.spacing(7),
      paddingLeft: theme.spacing(7),
      paddingRight: theme.spacing(7),
      flexGrow: 1
    },
    mobileHeaderLanguageSwitch: {
      position: "relative",
      textAlign: "right",
      right: theme.spacing(-5),
      top: theme.spacing(-6),
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: "18px"
    },
    leftContentInner: _defineProperty({
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    }, theme.breakpoints.up("xl"), {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0)
    }),
    navBox: _defineProperty({
      display: "flex"
    }, theme.breakpoints.up("xl"), {
      height: "100%",
      display: "inline-flex",
      alignItems: "center"
    })
  }, theming);
});

var HEADER_NAME = 'Header-Container';
var HEADER_WRAPPER = 'Header-Wrapper';
var HEADER_LOGO = 'Header-Logo';
var HEADER_MOBILE_MENU_ICON = 'Header-Mobile-Menu-Icon';
var HEADER_MOBILE_MENU_CONTENT = 'Header-Mobile-Menu-Content';
var HEADER_MOBILE_MENU_FOOTER = 'Header-Mobile-Menu-Footer';
var HEADER_SEARCH_MODAL_CONTAINER = 'Header-Overlay-Container';
var HEADER_SEARCH_MODAL_TITLE = 'Header-Overlay-Title';
var HEADER_RIGHTCONTENT_ITEM = 'Header-RightContent-Item';
var HEADER_RIGHTCONTENT_BUTTON = 'Header-RightContent-Button';
var HEADER_RIGHTCONTENT_ICON = 'Header-RightContent-Icon';
var HEADER_POPPER = 'Header-Popper';
var HEADER_POPPER_MENU_ITEM = 'Header-Popper-Menu-Item';
var HEADER_POPPER_MENU_ITEM_TEXT = 'Header-Popper-Menu-Item-Text';
var HEADER_SEARCH = 'Header-Search';
var HEADER_SEARCH_MODAL = 'Header-Search-Modal';
var HEADER_SEARCH_MODAL_CLOSE_ICON = 'Header-Overlay-Close-Icon';
var HEADER_PRIMARYNAV = 'Header-PrimaryNav';
var HEADER_PRIMARYNAV_ITEM = 'Header-PrimaryNav-Item';
var HEADER_SECONDARYNAV = 'Header-SecondaryNav';
var HEADER_SECONDARYNAV_ITEM = 'Header-SecondaryNav-Item';
var HEADER_RIGHT_CONTENT = 'Header-Right-Content';

var styles$1e = function styles(theme) {
  var _static;

  return {
    root: {
      display: 'inline-flex'
    },
    logo: {
      cursor: 'pointer',
      width: '100%',
      height: 'auto',
      '& img': {
        height: 'auto'
      }
    },
    static: (_static = {
      width: theme.spacing(7),
      height: theme.typography.pxToRem(19.25),
      display: 'inline-flex',
      visibility: 'visible'
    }, _defineProperty(_static, theme.breakpoints.up('xl'), {
      width: theme.spacing(12),
      height: theme.typography.pxToRem(33)
    }), _defineProperty(_static, '& .svglogo', {
      width: '100%',
      height: '100%'
    }), _static)
  };
};

var styles$1d = function styles(theme) {
  var marginBottom = {};
  var marginTop = {};
  var marginEmpty = {};
  Object.keys(_toConsumableArray(Array(13))).forEach(function (v, i) {
    marginEmpty["mb".concat(i)] = {};
    marginEmpty["mt".concat(i)] = {};
    marginBottom["&$mb".concat(i)] = {
      marginBottom: theme.spacing(i)
    };
    marginTop["&$mt".concat(i)] = {
      marginTop: theme.spacing(i)
    };
  });
  return _objectSpread2({
    /* Styles applied to the root element. */
    root: _objectSpread2(_objectSpread2({
      margin: 0,
      '&$normal': {
        fontWeight: fontWeights.normal
      },
      '&$bolder': {
        fontWeight: fontWeights.bolder
      },
      '&$bold': {
        fontWeight: fontWeights.bold
      }
    }, marginBottom), marginTop),

    /* Styles applied to the root element if `variant="small"`. */
    small: theme.typography.small,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="body1A"`. */
    body1A: theme.typography.body1A,

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body3"`. */
    body3: theme.typography.body3,

    /* Styles applied to the root element if `variant="body4"`. */
    body4: theme.typography.body4,

    /* Styles applied to the root element if `variant="body4B"`. */
    body4B: theme.typography.body4B,

    /* Styles applied to the root element if `variant="body5"`. */
    body5: theme.typography.body5,

    /* Styles applied to the root element if `variant="bodymd1"`. */
    bodymd1: theme.typography.bodymd1,

    /* Styles applied to the root element if `variant="body6"`. */
    body6: theme.typography.body6,

    /* Styles applied to the root element if `variant="quote"`. */
    quote: theme.typography.quote,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="radioButton"`. */
    radioButton: theme.typography.radioButton,

    /* Styles applied to the root element if `variant="h0"`. */
    h0: theme.typography.h0,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h2A"`. */
    h2A: theme.typography.h2A,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h3A"`. */
    h3A: theme.typography.h3A,

    /* Styles applied to the root element if `variant="h3B"`. */
    h3B: theme.typography.h3B,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h4A"`. */
    h4A: theme.typography.h4A,

    /* Styles applied to the root element if `variant="h4B"`. */
    h4B: theme.typography.h4B,

    /* Styles applied to the root element if `variant="h4C"`. */
    h4C: theme.typography.h4C,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h5A"`. */
    h5A: theme.typography.h5A,

    /* Styles applied to the root element if `variant="h5B"`. */
    h5B: theme.typography.h5B,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="h6A"`. */
    h6A: theme.typography.h6A,

    /* Styles applied to the root element if `variant="h6B"`. */
    h6B: theme.typography.h6B,

    /* Styles applied to the root element if `variant="h6C"`. */
    h6C: theme.typography.h6C,

    /* Styles applied to the root element if `variant="h6D"`. */
    h6D: theme.typography.h6D,

    /* Styles applied to the root element if `variant="h7"`. */
    h7: theme.typography.h7,

    /* Styles applied to the root element if `variant="h8"`. */
    h8: theme.typography.h8,

    /* Styles applied to the root element if `variant="h9"`. */
    h9: theme.typography.h9,

    /* Styles applied to the root element if `variant="h10"`. */
    h10: theme.typography.h10,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,
    searchRemoveBtn: theme.typography.searchRemoveBtn,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    bodyxs1: theme.typography.bodyxs1,

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },
    // /* Styles applied to the root element if `color="primary"`. */
    // colorPrimary: {
    //   color: theme.palette.primary.main,
    // },
    // /* Styles applied to the root element if `color="secondary"`. */
    // colorSecondary: {
    //   color: theme.palette.secondary.main,
    // },
    // /* Styles applied to the root element if `color="textPrimary"`. */
    // colorTextPrimary: {
    //   color: theme.palette.text.primary,
    // },
    // /* Styles applied to the root element if `color="textSecondary"`. */
    // colorTextSecondary: {
    //   color: theme.palette.text.secondary,
    // },
    // /* Styles applied to the root element if `color="error"`. */
    // colorError: {
    //   color: theme.palette.error.main,
    // },

    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: 'inline'
    },

    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: 'block'
    },

    /* Styles applied to the root element if `display="block"`. */
    wordBreak: {
      wordBreak: 'break-word'
    },

    /* font weights. */
    uppercase: {
      textTransform: 'uppercase'
    },
    normal: {},
    bold: {},
    bolder: {}
  }, marginEmpty);
};

var _excluded$d = ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping", "wordBreak", "fontWeight", "uppercase", "mb", "mt", "type"];
var defaultVariantMapping = {
  h0: 'h1',
  h1: 'h1',
  h2: 'h2',
  h2A: 'h2',
  h3: 'h3',
  h3A: 'h3',
  h3B: 'h3',
  h4: 'h4',
  h4A: 'h4',
  h4B: 'h4',
  h5: 'h5',
  h5A: 'h5',
  h5B: 'h5',
  h6: 'h6',
  h6A: 'h6',
  h6B: 'h6',
  h6C: 'h6C',
  h6D: 'h6D',
  h7: 'h6',
  h8: 'h3',
  h9: 'h3',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body1A: 'p',
  body2: 'p',
  body3: 'p',
  body4: 'p',
  body5: 'p',
  bodymd1: 'p',
  body6: 'p',
  quote: 'p',
  radioButton: 'div',
  checkBox: 'div',
  small: 'div',
  selectBox: 'div',
  button: 'h6',
  bodyxs1: 'p',
  searchRemoveBtn: 'h6'
};
/**
 * Typography -Use to present the design and content as clearly and efficiently as possible.
 *
 * @param {string} align - Set the text-align on the component and default value is inherit.
 * @param {boolean} gutterBottom - If true, the text will have a bottom margin and default value is set to false.
 * @param {object} classes - Override or extend the styles applied to the component.
 * @param {string} className
 * @param {string} display - Controls the display type and the defaut value is initial.
 * @param {boolean} noWrap - If true the text will not wrap and the default value is false.
 * @param {boolean} paragraph - If true the text will have a bottom margin and the default value is false.
 * @param {boolean} wordBreak - If true text will apply word-break and the default value is false.
 * @param {string} variant - Applies the theme typography styles and the default value is body1.
 * @param {object} variantMapping - Mapping the variant prop to a range of different DOM element types.
 * @param {string} fontWeight - Default value is null , value can be one of the following ['normal', 'bold', 'bolder'].
 * @param {boolean} uppercase - Default value is false.
 * @param {number} mb - Margin bottom and default value is set to null.
 * @param {number} mt - Margin top and default value is set to null.
 */

var Typography = /*#__PURE__*/React__default.forwardRef(function Typography(props, ref) {
  var _clsx;

  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$variantMapping = props.variantMapping,
      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
      _props$wordBreak = props.wordBreak,
      wordBreak = _props$wordBreak === void 0 ? false : _props$wordBreak,
      _props$fontWeight = props.fontWeight,
      fontWeight = _props$fontWeight === void 0 ? null : _props$fontWeight,
      _props$uppercase = props.uppercase,
      uppercase = _props$uppercase === void 0 ? false : _props$uppercase,
      _props$mb = props.mb,
      mb = _props$mb === void 0 ? null : _props$mb,
      _props$mt = props.mt,
      mt = _props$mt === void 0 ? null : _props$mt,
      _props$type = props.type,
      type = _props$type === void 0 ? null : _props$type,
      other = _objectWithoutProperties(props, _excluded$d);

  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span'; //TODO: Yatin - For Single Page Application
  // if (Component === 'a') {
  //   return (
  //     <ReactRouterLink
  //       className={clsx(
  //         classes.root,
  //         {
  //           [classes[variant]]: variant !== 'inherit',
  //           [classes[`text-${color}`]]: color !== 'initial',
  //           [classes.noWrap]: noWrap,
  //           [classes.gutterBottom]: gutterBottom,
  //           [classes.paragraph]: paragraph,
  //           [classes[`align${capitalize(align)}`]]: align !== 'inherit',
  //           [classes[`display${capitalize(display)}`]]: display !== 'initial',
  //         },
  //         className
  //       )}
  //       ref={ref}
  //       {...other}
  //     />
  //   )
  // }

  return /*#__PURE__*/React__default.createElement(Component, _extends({
    className: clsx(classes.root, (_clsx = {}, _defineProperty(_clsx, classes[variant], variant !== 'inherit'), _defineProperty(_clsx, "text-color-".concat(color), color !== 'initial'), _defineProperty(_clsx, "label-color-".concat(color), type === 'label'), _defineProperty(_clsx, "caption-color-".concat(color), type === 'caption'), _defineProperty(_clsx, "richtext-link-common richtext-link-".concat(color), type === 'richtext'), _defineProperty(_clsx, classes.noWrap, noWrap), _defineProperty(_clsx, classes.gutterBottom, gutterBottom), _defineProperty(_clsx, classes.paragraph, paragraph), _defineProperty(_clsx, classes["align".concat(capitalize(align))], align !== 'inherit'), _defineProperty(_clsx, classes["display".concat(capitalize(display))], display !== 'initial'), _defineProperty(_clsx, classes.wordBreak, wordBreak), _defineProperty(_clsx, classes.uppercase, uppercase), _defineProperty(_clsx, classes[fontWeight], fontWeight), _defineProperty(_clsx, classes["mb".concat(mb)], mb !== null), _defineProperty(_clsx, classes["mt".concat(mt)], mt !== null), _clsx), className),
    ref: ref
  }, other));
});
var StyledMemoizedTypography = withStyles(styles$1d, {
  name: 'MuiTypography'
})( /*#__PURE__*/React__default.memo(Typography));
StyledMemoizedTypography.propTypes = {
  /**
   * Set the text-align on the component.
   */
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  // color: PropTypes.oneOf([
  //   'initial',
  //   'inherit',
  //   'primary',
  //   'secondary',
  //   'textPrimary',
  //   'textSecondary',
  //   'error',
  // ]),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: PropTypes.elementType,

  /**
   * Controls the display type
   */
  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: PropTypes.bool,

  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   */
  noWrap: PropTypes.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: PropTypes.bool,

  /**
   * if `true`, text will apply word-break: break-word
   */
  wordBreak: PropTypes.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.oneOf(['h0', 'h1', 'h2', 'h2A', 'h3', 'h3A', 'h3B', 'h4', 'h4A', 'h4B', 'h5', 'h5A', 'h5B', 'h6', 'h6A', 'h6B', 'h6C', 'h6D', 'h7', 'h8', 'h9', 'subtitle1', 'subtitle2', 'body1', 'body1A', 'body2', 'body3', 'body4', 'body5', 'quote', 'caption', 'button', 'radioButton', 'checkBox', 'small', 'selectBox', 'overline', 'srOnly', 'inherit', 'bodyxs1', 'bodymd1', 'body6', 'searchRemoveBtn']),

  /**
   * We are empirically mapping the variant prop to a range of different DOM element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   */
  variantMapping: PropTypes.object,

  /**
   * fontweight
   */
  // fontWeight: PropTypes.oneOf(['normal', 'bold', 'bolder']), // FIXME: console error
  fontWeight: PropTypes.oneOf(['300', 'normal', 'bold', 'bolder']),

  /**
   * is uppercase
   */
  uppercase: PropTypes.bool,

  /**
   * marginBottom
   */
  mb: PropTypes.number,

  /**
   * marginBottom
   */
  mt: PropTypes.number
};

var style$c = function style(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      cursor: 'pointer',
      position: 'relative',
      zIndex: 0,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none'
      },
      '&:active': {
        outline: 'none'
      },
      outline: 'none',
      '&$focusVisible': {
        outline: 'auto'
      }
    },
    PrimaryLinkWrapper: {
      display: 'inline-flex'
    },

    /* Styles applied to the root element if `component="div"`. */
    displayInlineBlock: {
      display: 'inline-block'
    },
    displayInlineFlex: {
      display: 'inline-flex'
    },
    primaryLinkText: {
      fontWeight: fontWeights.bolder,
      lineHeight: lineHeight.L9,
      padding: theme.spacing(0.25, 0)
    },
    noPointer: {
      cursor: 'initial',
      pointerEvents: 'none'
    },
    // Same reset as ButtonBase.root

    /* Styles applied to the root element if `component="button"`. */
    button: {
      position: 'relative',
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      backgroundColor: 'transparent',
      // Reset default value
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      border: 0,
      margin: 0,
      // Remove the margin in Safari
      borderRadius: 0,
      padding: 0,
      // Remove the padding in Firefox
      cursor: 'pointer',
      userSelect: 'none',
      verticalAlign: 'middle',
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.

      },
      '&$focusVisible': {
        outline: 'auto'
      }
    },

    /* Pseudo-class applied to the root element if the link is keyboard focused. */
    focusVisible: {},

    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: 'inline-flex',
      marginRight: 4,
      alignItems: 'center'
    },
    tertiary: {
      margin: 'auto'
    },

    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      verticalAlign: 'middle',
      marginRight: -4,
      marginLeft: 8
    },

    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      '& > *:first-child': {
        fontSize: 18,
        width: '16px',
        height: '16px'
      }
    },

    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      '& > *:first-child': {
        fontSize: 22,
        width: '24px',
        height: '24px'
      }
    },

    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      '& > *:first-child': {
        fontSize: 24
      }
    },

    /* Styles applied to the icon element if supplied and `size="none"`. */
    iconSizeNone: {
      marginTop: 0,
      marginRight: 0,
      display: 'inline-block'
    }
  };
};

var styles$1c = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: 16,
      height: 16,
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(16),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};

var FwdSvgIcon = function FwdSvgIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon$1, _extends({
    viewBox: props.viewBox || '0 0 48 48'
  }, props));
};

var SvgIcon = withStyles(styles$1c, {
  name: 'MuiSvgIcon'
})(FwdSvgIcon);

var _excluded$c = ["inlineTitle"];
function createSvgIcon(path, displayName, viewBox) {
  var Component = /*#__PURE__*/React__default.memo( /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _ref = viewBox ? _objectSpread2(_objectSpread2({}, props), {}, {
      viewBox: viewBox,
      "aria-labelledby": props && props.inlineTitle ? "".concat(displayName, "Title") : null
    }) : _objectSpread2(_objectSpread2({}, props), {}, {
      "aria-labelledby": props && props.inlineTitle ? "".concat(displayName, "Title") : null
    }),
        _ref$inlineTitle = _ref.inlineTitle,
        inlineTitle = _ref$inlineTitle === void 0 ? "" : _ref$inlineTitle,
        updateProps = _objectWithoutProperties(_ref, _excluded$c);

    return /*#__PURE__*/React__default.createElement(SvgIcon, _extends({
      "data-mui-test": "".concat(displayName, "Icon"),
      ref: ref
    }, updateProps, {
      htmlColor: props.fill
    }), inlineTitle && /*#__PURE__*/React__default.createElement("title", {
      id: "".concat(displayName, "Title")
    }, inlineTitle), path);
  }));

  if (process.env.NODE_ENV !== "production") {
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = SvgIcon.muiName;
  return Component;
}

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var PlusIcon = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Plus",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M26,22 L26,11 C26,9.343 24.657,8 23,8 L22,8 L22,22 L11,22 C9.343,22 8,23.343 8,25 L8,26 L22,26 L22,37 C22,38.657 23.343,40 25,40 L26,40 L26,26 L37,26 C38.657,26 40,24.657 40,23 L40,22 L26,22 Z",
  id: "Plus",
  fill: "currentColor"
}))), "Plus");

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ArrowRight = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M23.2939,8.8787 L22.5859,9.5857 L35.1709,22.1697 L5.9999,22.1697 L5.9999,26.1697 L35.1729,26.1697 L22.5869,38.7567 L23.2939,39.4627 C24.4649,40.6347 26.3649,40.6347 27.5359,39.4627 L42.8279,24.1707 L27.5359,8.8787 C26.3639,7.7077 24.4649,7.7077 23.2939,8.8787",
  fill: "currentColor"
}))), 'ArrowRight');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Close = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Close",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M38.8281,11.5855 L38.1211,10.8785 C36.9501,9.7075 35.0501,9.7075 33.8791,10.8785 L23.4141,21.3435 L12.9491,10.8785 C11.7781,9.7075 9.8781,9.7075 8.7071,10.8785 L8.0001,11.5855 L20.5861,24.1715 L8.0001,36.7575 L8.7071,37.4645 C9.8781,38.6355 11.7781,38.6355 12.9491,37.4645 L23.4141,26.9995 L33.8791,37.4645 C35.0501,38.6355 36.9501,38.6355 38.1211,37.4645 L38.8281,36.7575 L26.2421,24.1715 L38.8281,11.5855 Z",
  id: "Close",
  fill: "currentColor"
}))), 'Close');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Info = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Info",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M40,24 C40,15.177 32.822,8 24,8 C15.178,8 8,15.177 8,24 C8,32.822 15.178,40 24,40 C32.822,40 40,32.822 40,24 M44,24 C44,35.028 35.028,44 24,44 C12.972,44 4,35.028 4,24 C4,12.972 12.972,4 24,4 C35.028,4 44,12.972 44,24 M25,20 L23,20 C22.447,20 22,20.447 22,21 L22,35 C22,35.552 22.447,36 23,36 L25,36 C25.552,36 26,35.552 26,35 L26,21 C26,20.447 25.552,20 25,20 M26,13 L26,15 C26,15.552 25.553,16 25,16 L22,16 L22,13 C22,12.447 22.448,12 23,12 L25,12 C25.553,12 26,12.447 26,13",
  id: "Info",
  fill: "#333333"
}))), 'info');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Briefcase = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "M10.0782541,21.7599208 L16.1570769,21.7599208 L16.1570769,22.8428024 C16.1570769,24.5921657 17.6122391,26.0153356 19.4013392,26.0153356 L22.5990726,26.0153356 C24.3877609,26.0153356 25.8433349,24.5921657 25.8433349,22.8428024 L25.8433349,21.7599208 L31.9229811,21.7599208 C34.2066058,21.7599208 36.8875795,20.2421145 38.0265095,18.3046866 L38.6013274,17.3277172 L38.6013274,32.3148958 C38.6005039,33.0655434 37.9754512,33.675646 37.2075176,33.675646 L4.79124714,33.675646 C4.02372526,33.675646 3.39908432,33.0655434 3.39908432,32.3152985 L3.39908432,17.3273145 L3.97390222,18.3046866 C5.11283223,20.2421145 7.7942177,21.7599208 10.0782541,21.7599208 L10.0782541,21.7599208 Z M35.0795384,16.6475435 C34.5294262,17.5826313 33.0248527,18.4347613 31.9229811,18.4347613 L25.8429231,18.4347613 L25.8429231,18.1782364 C25.8429231,16.4284704 24.3873491,15.0053005 22.5986608,15.0053005 L19.4009274,15.0053005 C17.6118273,15.0053005 16.1566651,16.4284704 16.1566651,18.1782364 L16.1566651,18.4347613 L10.0782541,18.4347613 C8.97597082,18.4347613 7.47098558,17.5826313 6.92046156,16.6479462 L3.52055372,10.8618385 C3.73796335,10.3677159 4.23907609,10.0350791 4.79124714,10.0350791 L37.2079293,10.0350791 C37.7601004,10.0350791 38.2616249,10.3677159 38.4794463,10.8618385 L35.0795384,16.6475435 Z M19.5561612,22.6909815 L22.443427,22.6909815 L22.443427,18.33046 L19.5561612,18.33046 L19.5561612,22.6909815 Z M20.9997941,4.16359738 C25.7556298,4.16359738 26.6034451,5.28111191 26.7953255,6.71032238 L15.2038509,6.71032238 C15.3953197,5.28111191 16.2423113,4.16359738 20.9997941,4.16359738 L20.9997941,4.16359738 Z M41.9888825,11.2721979 C42.0111175,11.0527221 41.9868237,10.823984 41.9172361,10.6049109 C41.5211223,8.34652474 39.5454947,6.71072509 37.2075176,6.71072509 L31.0352251,6.71072509 C30.5122891,2.07394588 27.3993784,0 20.9997941,0 C14.599798,0 11.4868874,2.07314047 10.9635396,6.71072509 L4.79124714,6.71072509 C2.45368183,6.71072509 0.478465897,8.34692745 0.0827638945,10.6053136 C0.0131763414,10.8243867 -0.0115292987,11.0531248 0.0107057774,11.2721979 C0.00452936736,11.3124687 0,11.3535449 0,11.396232 L0,32.3148958 C0,34.8982673 2.14939069,37 4.79124714,37 L37.2079293,37 C39.8501975,37 42,34.8982673 42,32.3148958 L42,11.3922049 C42,11.3555585 41.9958824,11.3197175 41.9888825,11.2721979 L41.9888825,11.2721979 Z",
  stroke: "#333333",
  strokeWidth: "0.5",
  fill: "#333333",
  mask: "url(#mask-2)"
})), 'Briefcase');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Reset = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Reset",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M29.9891,20.0015 C29.9891,21.6575 31.3331,23.0015 32.9891,23.0015 L42.0001,23.0015 L42.0001,14.0035 C42.0001,12.3465 40.6571,11.0035 39.0001,11.0035 L38.0001,11.0035 L38.0001,16.7085 C37.3891,15.2485 36.6171,13.8745 35.6651,12.6675 L35.5741,12.5605 C32.3581,9.0265 27.7751,6.9995 23.0001,6.9995 C13.6261,6.9995 6.0001,14.6265 6.0001,23.9995 C6.0001,33.3745 13.6261,40.9995 23.0001,40.9995 C30.6231,40.9995 37.3621,35.8725 39.3881,28.5325 L35.5331,27.4685 C33.9831,33.0815 28.8301,36.9995 23.0001,36.9995 C15.8321,36.9995 10.0001,31.1675 10.0001,23.9995 C10.0001,16.8315 15.8321,10.9995 23.0001,10.9995 C26.6281,10.9995 30.1081,12.5325 32.5641,15.2015 C33.4341,16.3175 34.1341,17.6095 34.6241,19.0015 L29.9891,19.0015 L29.9891,20.0015 Z",
  id: "Reset",
  fill: "#333333"
}))), 'Reset');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var SearchIcon = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Search",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M41.4141,38.7036 L32.7801,30.0696 L32.0731,30.7766 C30.9021,31.9486 30.9021,33.8476 32.0731,35.0186 L38.5861,41.5316 L41.4141,38.7036 Z M20.0001,9.9996 C14.4861,9.9996 10.0001,14.4856 10.0001,19.9996 C10.0001,25.5146 14.4861,29.9996 20.0001,29.9996 C25.5141,29.9996 30.0001,25.5146 30.0001,19.9996 C30.0001,14.4856 25.5141,9.9996 20.0001,9.9996 L20.0001,9.9996 Z M20.0001,33.9996 C12.2801,33.9996 6.0001,27.7196 6.0001,19.9996 C6.0001,12.2806 12.2801,5.9996 20.0001,5.9996 C27.7201,5.9996 34.0001,12.2806 34.0001,19.9996 C34.0001,27.7196 27.7201,33.9996 20.0001,33.9996 L20.0001,33.9996 Z",
  id: "Search",
  fill: "currentColor"
}))), 'Search');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Tags = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "M26,32 C28.209139,32 30,33.790861 30,36 C30,38.209139 28.209139,40 26,40 L8,40 C5.790861,40 4,38.209139 4,36 C4,33.790861 5.790861,32 8,32 L26,32 Z M40,32 C42.209139,32 44,33.790861 44,36 C44,38.209139 42.209139,40 40,40 L36,40 C33.790861,40 32,38.209139 32,36 C32,33.790861 33.790861,32 36,32 L40,32 Z M12,20 C14.209139,20 16,21.790861 16,24 C16,26.209139 14.209139,28 12,28 L8,28 C5.790861,28 4,26.209139 4,24 C4,21.790861 5.790861,20 8,20 L12,20 Z M26,20 C28.209139,20 30,21.790861 30,24 C30,26.209139 28.209139,28 26,28 L22,28 C19.790861,28 18,26.209139 18,24 C18,21.790861 19.790861,20 22,20 L26,20 Z M40,20 C42.209139,20 44,21.790861 44,24 C44,26.209139 42.209139,28 40,28 L36,28 C33.790861,28 32,26.209139 32,24 C32,21.790861 33.790861,20 36,20 L40,20 Z M12,8 C14.209139,8 16,9.790861 16,12 C16,14.209139 14.209139,16 12,16 L8,16 C5.790861,16 4,14.209139 4,12 C4,9.790861 5.790861,8 8,8 L12,8 Z M40,8 C42.209139,8 44,9.790861 44,12 C44,14.209139 42.209139,16 40,16 L22,16 C19.790861,16 18,14.209139 18,12 C18,9.790861 19.790861,8 22,8 L40,8 Z",
  fill: "#333333"
})), 'Tags');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Quote = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Quote",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M19.0042,20.9844 L8.0042,20.9844 C8.0092,17.3154 10.5002,14.2164 13.8792,13.2864 C15.1602,12.9324 16.0002,11.6994 16.0002,10.3704 L16.0002,9.0004 C9.3892,9.0004 4.0102,14.3754 4.0042,20.9844 L4.0002,20.9844 L4.0002,35.9844 C4.0002,37.6414 5.3432,38.9844 7.0002,38.9844 L19.0042,38.9844 C20.6612,38.9844 22.0042,37.6414 22.0042,35.9844 L22.0042,23.9844 C22.0042,22.3274 20.6612,20.9844 19.0042,20.9844 M44.0042,23.9844 L44.0042,35.9844 C44.0042,37.6414 42.6612,38.9844 41.0042,38.9844 L29.0002,38.9844 C27.3432,38.9844 26.0002,37.6414 26.0002,35.9844 L26.0002,20.9844 L26.0042,20.9844 C26.0102,14.3754 31.3892,9.0004 38.0002,9.0004 L38.0002,10.3704 C38.0002,11.6994 37.1602,12.9324 35.8792,13.2864 C32.4992,14.2164 30.0092,17.3154 30.0042,20.9844 L41.0042,20.9844 C42.6612,20.9844 44.0042,22.3274 44.0042,23.9844",
  id: "Quote",
  fill: "#333333"
}))), 'quote');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var DocumentDownload = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "M14.320118,25.3811828 L28.6535578,25.3811828 L28.6535578,23.5747819 L14.320118,23.5747819 L14.320118,25.3811828 Z M14.320118,22.1082569 L28.6535578,22.1082569 L28.6535578,20.301856 L14.320118,20.301856 L14.320118,22.1082569 Z M32.4116846,39.6820163 C32.2713323,39.8240062 32.0875409,39.8950353 31.9037495,39.8950353 C31.7198908,39.8950353 31.5360994,39.8240062 31.3958145,39.6820163 L28.5222975,36.7735744 C28.2416603,36.4895945 28.2416603,36.0294735 28.5222975,35.7454255 C28.8028673,35.4613775 29.2574631,35.4613775 29.5381002,35.7454255 L31.1852861,37.4126314 L31.1852861,30.4426502 C31.1852861,30.040743 31.5065338,29.7155227 31.9036822,29.7155227 C32.3007632,29.7155227 32.6220783,30.040743 32.6220783,30.4426502 L32.6220783,37.4126314 L34.2692641,35.7454255 C34.5498339,35.4614456 35.0044297,35.4614456 35.2852016,35.7454255 C35.5657714,36.0294054 35.5657714,36.4895264 35.2852016,36.7735744 L32.4116846,39.6820163 Z M26.2409673,9.72357183 L31.1825922,14.7252576 L26.2409673,14.7252576 L26.2409673,9.72357183 Z M23.8074317,34.805279 C23.8074317,36.222997 24.1632287,37.5566663 24.789224,38.719784 L11.1551209,38.719784 L11.1551209,8.18138256 L24.0858464,8.18138256 L24.0858464,14.7253939 C24.0858464,15.9278434 25.0528895,16.9067083 26.2409673,16.9067083 L32.70633,16.9067083 L32.70633,26.6469587 C33.4596121,26.7194192 34.1827225,26.8963102 34.8614509,27.1632485 L34.8614509,15.8158466 C34.8614509,15.5262089 34.7477683,15.2492502 34.5457931,15.0447519 L25.9252421,6.31949439 C25.7231995,6.11499617 25.4496338,6 25.1634068,6 L11.1551209,6 C9.96704316,6 9,6.97879667 9,8.18131439 L9,38.7196477 C9,39.9221654 9.96704316,40.9010302 11.1551209,40.9010302 L26.4932511,40.9010302 C27.9271474,42.2057971 29.8237211,43 31.9037495,43 C36.375154,43 40,39.3310974 40,34.805279 C40,30.2794606 36.375154,26.610558 31.9037495,26.610558 C27.4322777,26.610558 23.8074317,30.2794606 23.8074317,34.805279 Z"
})), 'DocumentDownload');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Download = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M37.1205006,40.035 L11.2545006,40.035 C10.7025006,40.035 10.2545006,40.483 10.2545006,41.035 L10.2545006,43.035 C10.2545006,43.587 10.7025006,44.035 11.2545006,44.035 L37.1205006,44.035 C37.6725006,44.035 38.1205006,43.587 38.1205006,43.035 L38.1205006,41.035 C38.1205006,40.483 37.6725006,40.035 37.1205006,40.035 L37.1205006,40.035 Z M10.8805006,23.535 C9.70750064,22.364 9.70650064,20.465 10.8775006,19.292 L11.5845006,18.585 L22.1875006,29.176 L22.1875006,4 L26.1875006,4 L26.1875006,29.171 L36.7735006,18.586 L37.4805006,19.293 C38.6515006,20.464 38.6515006,22.364 37.4805006,23.535 L24.1885006,36.827 L10.8805006,23.535 Z",
  fill: "#333333"
}))), 'Download');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var EnterKey = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Enter",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M40.8311,9 C40.8311,8.448 40.3841,8 39.8311,8 L37.8311,8 C37.2781,8 36.8311,8.448 36.8311,9 L36.8311,26 L13.6671,26 L22.2561,17.429 L21.5491,16.721 C20.3791,15.548 18.4791,15.546 17.3071,16.717 L6.0001,28 L17.3071,39.284 C18.4791,40.454 20.3791,40.453 21.5491,39.28 L22.2561,38.572 L13.6661,30 L40.8311,30 L40.8311,9 Z",
  id: "Enter",
  fill: "#333333"
}))), 'enter-key');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var History = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "M25.425,7 C18.95,7 13.215,10.5 10.255,15.8421053 L6,11.6052632 L6,23.5789474 L18.025,23.5789474 L12.845,18.4210526 C15.25,13.8157895 19.875,10.6842105 25.425,10.6842105 C33.01,10.6842105 39.3,16.9473684 39.3,24.5 C39.3,32.0526316 33.01,38.3157895 25.425,38.3157895 C19.32,38.3157895 14.325,34.4473684 12.29,29.1052632 L8.405,29.1052632 C10.44,36.4736842 17.285,42 25.425,42 C35.23,42 43,34.0789474 43,24.5 C43,14.9210526 35.045,7 25.425,7 Z M22.65,16.2105263 L22.65,25.6052632 L31.345,30.7631579 L32.825,28.3684211 L25.425,23.9473684 L25.425,16.2105263 L22.65,16.2105263 L22.65,16.2105263 Z"
})), 'history');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Filter = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Filter",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M32.001,26 C30.898,26 30.001,25.103 30.001,24 C30.001,22.897 30.898,22 32.001,22 C33.104,22 34.001,22.897 34.001,24 C34.001,25.103 33.104,26 32.001,26 L32.001,26 Z M41,22 L37.651,22 C36.824,19.674 34.607,18 32.001,18 C29.395,18 27.178,19.674 26.351,22 L7,22 C6.447,22 6,22.448 6,23 L6,25 C6,25.553 6.447,26 7,26 L26.352,26 C27.178,28.327 29.395,30 32.001,30 C34.607,30 36.824,28.327 37.65,26 L41,26 C41.553,26 42,25.553 42,25 L42,23 C42,22.448 41.553,22 41,22 L41,22 Z M16.001,38 C14.898,38 14.001,37.103 14.001,36 C14.001,34.897 14.898,34 16.001,34 C17.104,34 18.001,34.897 18.001,36 C18.001,37.103 17.104,38 16.001,38 L16.001,38 Z M16.001,30 C13.395,30 11.178,31.674 10.351,34 L7,34 C6.447,34 6,34.448 6,35 L6,37 C6,37.553 6.447,38 7,38 L10.352,38 C11.178,40.327 13.395,42 16.001,42 C18.607,42 20.824,40.327 21.65,38 L39,38 C40.657,38 42,36.657 42,35 L42,34 L21.651,34 C20.824,31.674 18.607,30 16.001,30 L16.001,30 Z M16.001,14 C14.898,14 14.001,13.103 14.001,12 C14.001,10.897 14.898,10 16.001,10 C17.104,10 18.001,10.897 18.001,12 C18.001,13.103 17.104,14 16.001,14 L16.001,14 Z M21.651,10 C20.824,7.674 18.607,6 16.001,6 C13.395,6 11.178,7.674 10.351,10 L7,10 C6.447,10 6,10.448 6,11 L6,13 C6,13.553 6.447,14 7,14 L10.352,14 C11.178,16.327 13.395,18 16.001,18 C18.607,18 20.824,16.327 21.65,14 L41,14 C41.553,14 42,13.553 42,13 L42,10 L21.651,10 Z",
  id: "Filter",
  fill: "#333333"
}))), 'filter');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var QuestionMark = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "M24,2 C36.1308,2 46,11.8692 46,24 C46,36.1308 36.1308,46 24,46 C11.8692,46 2,36.1308 2,24 C2,11.8692 11.8692,2 24,2 Z M24,6.4 C14.2958,6.4 6.4,14.2958 6.4,24 C6.4,33.7053 14.2958,41.6 24,41.6 C33.7042,41.6 41.6,33.7053 41.6,24 C41.6,14.2958 33.7042,6.4 24,6.4 Z",
  fill: "#000000"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M41.6,24 C41.6,33.7053 33.7042,41.6 24,41.6 C14.2958,41.6 6.4,33.7053 6.4,24 C6.4,14.2958 14.2958,6.4 24,6.4 C33.7042,6.4 41.6,14.2958 41.6,24 L41.6,24 Z",
  fill: "#FFFFFF"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M26.1736,28.4704 L26.1736,28.4704 C26.3914,27.3517 27.0118,26.354 27.9193,25.6643 C28.2724,25.3959 28.6442,25.1176 28.9742,24.8778 C29.5847,24.4356 31.3733,23.1266 32.1972,20.9728 C32.5096,20.1555 32.6812,19.2535 32.6812,18.2514 C32.6812,14.4707 29.6485,10.8011 23.8438,10.8011 C23.2102,10.8011 19.7221,10.6735 17.2603,13.4884 C15.596,15.3925 15.3155,17.6288 15.3187714,18.9356 C15.321,19.5483 15.8072,20.0444 16.4199,20.0455 L18.8894,20.0466 C19.4867,20.0466 19.9949,19.5714 19.9894,18.9741 C19.9839,18.4703 20.0697,17.8532 20.3909,17.2306 C21.3941,15.2803 23.7162,15.1846 23.8438,15.1813 C24.2024,15.1736 25.7853,15.1351 26.8303,16.41 C28.0139,17.8543 27.4166,19.6539 27.3891,19.7309 C27.025,20.7693 26.2583,21.3248 25.9778,21.5096 L24.1826,22.8571 C23.6392,23.2333 21.5503,24.7722 21.3545,27.2307 C21.3193,27.6773 21.3501,28.0975 21.4216,28.4825 L26.1736,28.4704 Z",
  fill: "#000000"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M27.2747,33.9253 C27.2747,35.7337 25.8084,37.2 24,37.2 C22.1916,37.2 20.7253,35.7337 20.7253,33.9253 C20.7253,32.1169 22.1916,30.6517 24,30.6517 C25.8084,30.6517 27.2747,32.1169 27.2747,33.9253 L27.2747,33.9253 Z",
  fill: "#000000"
})), 'question-mark');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Original = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "M37.3829787,31.0460383 L37.0103404,30.6734 C36.3919574,30.0559106 35.3902128,30.0559106 34.7727234,30.6734 L29.5611489,35.8840809 L28.5701277,34.8930596 C27.9526383,34.2746766 26.95,34.2746766 26.3325106,34.8930596 L25.9598723,35.2656979 L28.8158723,38.1216979 C29.0214043,38.3272298 29.2912766,38.4308894 29.5611489,38.4308894 C29.8310213,38.4308894 30.1008936,38.3272298 30.3073191,38.1216979 L37.3829787,31.0460383 Z M41.8108511,35.8286766 C41.7045106,36.3121234 41.3953191,36.7267617 40.9619149,36.9689319 L40.4150213,37.2745489 C40.156766,37.4184213 40.0164681,37.7115277 40.0709787,38.004634 L40.1862553,38.6194426 C40.2747234,39.1073574 40.1522979,39.607783 39.8457872,39.9982936 C39.5410638,40.3879106 39.0826383,40.6256128 38.5866809,40.6559957 L37.9593617,40.6935277 C37.6617872,40.7105064 37.4071064,40.9142511 37.3302553,41.1984213 L37.1649362,41.8051872 C36.9620851,42.5558255 36.274,43.0776979 35.4983404,43.0776979 C35.2740426,43.0776979 35.0524255,43.0312298 34.8406383,42.9463362 L34.2597872,42.708634 C33.9881277,42.5987191 33.6655319,42.6746766 33.4742979,42.8954 L33.0641277,43.3708043 C32.7325957,43.7479106 32.2580851,43.964166 31.756766,43.964166 C31.2688511,43.964166 30.7979149,43.7523787 30.4708511,43.387783 L30.0499574,42.9213149 C29.8605106,42.704166 29.5334468,42.6326766 29.2653617,42.7470596 L28.6889787,42.9928043 C28.4727234,43.086634 28.2394894,43.1331021 28.0053617,43.1331021 C27.2377447,43.1331021 26.5550213,42.6192723 26.343234,41.8856128 L26.1689787,41.2833149 C26.0885532,40.9991447 25.8338723,40.7998681 25.5371915,40.7864638 L24.9089787,40.7614426 C24.4174894,40.7408894 23.9545957,40.5076553 23.6409362,40.1216128 C23.3308511,39.7355702 23.200383,39.2342511 23.2808085,38.7472298 L23.3862553,38.1279532 C23.4327234,37.8348468 23.2933191,37.5462085 23.0297021,37.4059106 L22.4783404,37.1092298 C22.0422553,36.8759957 21.7277021,36.4649319 21.6133191,35.9805915 C21.4989362,35.4971447 21.6008085,34.9886766 21.8849787,34.5847617 L22.2451064,34.0718255 C22.4193617,33.8305489 22.4148936,33.5034851 22.2415319,33.265783 L21.8724681,32.7608894 C21.5793617,32.3623362 21.4730213,31.8538681 21.5793617,31.3695277 C21.6857021,30.8860809 21.9948936,30.4705489 22.4282979,30.2283787 L22.9751915,29.9236553 C23.2343404,29.779783 23.3737447,29.4866766 23.3183404,29.1935702 L23.2039574,28.5787617 C23.1154894,28.0953149 23.2379149,27.5895277 23.5435319,27.1999106 C23.8491489,26.8094 24.3120426,26.5672298 24.8035319,26.5422085 L25.4272766,26.503783 C25.7239574,26.4868043 25.9786383,26.2830596 26.0545957,25.9988894 L26.2208085,25.393017 C26.4245532,24.6423787 27.1117447,24.1205064 27.8882979,24.1205064 C28.1125957,24.1205064 28.3333191,24.1669745 28.5451064,24.2518681 L29.1268511,24.4886766 C29.397617,24.5994851 29.7202128,24.522634 29.9114468,24.3019106 L30.3189362,23.8265064 C30.6495745,23.4494 31.1249787,23.2331447 31.6254043,23.2331447 C32.1133191,23.2331447 32.5833617,23.4449319 32.9104255,23.8104213 L33.3304255,24.2768894 C33.520766,24.4931447 33.8469362,24.5655277 34.1150213,24.4502511 L34.6914043,24.2045064 C34.9076596,24.1115702 35.1417872,24.0651021 35.3750213,24.0651021 C36.1426383,24.0651021 36.8253617,24.5780383 37.0380426,25.3116979 L37.2203404,25.9095277 C37.300766,26.1936979 37.5554468,26.3938681 37.8521277,26.4063787 L38.4803404,26.4314 C38.9718298,26.4528468 39.4347234,26.6860809 39.748383,27.073017 C40.0584681,27.458166 40.1898298,27.9585915 40.1094043,28.4474 L40.0030638,29.065783 C39.9565957,29.3588894 40.096,29.6475277 40.359617,29.7878255 L40.9109787,30.0845064 C41.3479574,30.3177404 41.6625106,30.7288043 41.7768936,31.2131447 C41.890383,31.6965915 41.7894043,32.2050596 41.505234,32.6089745 L41.1442128,33.1219106 C40.9708511,33.3640809 40.9753191,33.6893574 41.1486809,33.9279532 L41.5177447,34.4364213 C41.8108511,34.8358681 41.9171915,35.3443362 41.8108511,35.8286766 L41.8108511,35.8286766 Z M15.0425532,25.6594851 C14.5492766,25.6594851 14.1489362,25.2591447 14.1489362,24.7658681 L14.1489362,22.978634 C14.1489362,22.4853574 14.5492766,22.085017 15.0425532,22.085017 L21.5531915,22.085017 C22.0464681,22.085017 22.4468085,22.4853574 22.4468085,22.978634 L22.4468085,24.7658681 C22.4468085,25.2591447 22.0464681,25.6594851 21.5531915,25.6594851 L15.0425532,25.6594851 Z M27.5531915,18.5105489 L15.0425532,18.5105489 C14.5492766,18.5105489 14.1489362,18.1102085 14.1489362,17.6169319 L14.1489362,15.8296979 C14.1489362,15.3364213 14.5492766,14.9360809 15.0425532,14.9360809 L27.5531915,14.9360809 C28.0464681,14.9360809 28.4468085,15.3364213 28.4468085,15.8296979 L28.4468085,17.6169319 C28.4468085,18.1102085 28.0464681,18.5105489 27.5531915,18.5105489 L27.5531915,18.5105489 Z M18.6170213,41.7445915 L8.78723404,41.7445915 C7.80068085,41.7445915 7,40.9448043 7,39.9573574 L7,7.78714468 C7,6.80059149 7.80068085,5.99991064 8.78723404,5.99991064 L33.8085106,5.99991064 C34.7950638,5.99991064 35.5957447,6.80059149 35.5957447,7.78714468 L35.5957447,19.8722511 L32.0212766,19.8722511 L32.0212766,9.57437872 L10.5744681,9.57437872 L10.5744681,38.1701234 L18.6170213,38.1701234 L18.6170213,41.7445915 Z"
})), 'original');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Certified = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "M7.57455745,40.5674809 L7.57455745,6.57428936 L33.8397489,6.57428936 L33.8397489,4.78705532 C33.8397489,3.79960851 33.0390681,2.99982128 32.0525149,2.99982128 L5.7873234,2.99982128 C4.80077021,2.99982128 4.00008936,3.79960851 4.00008936,4.78705532 L4.00008936,38.7802468 C4.00008936,39.7668 4.80077021,40.5674809 5.7873234,40.5674809 L7.57455745,40.5674809 Z M31.702217,28.0210979 L31.702217,26.2338638 C31.702217,25.7405872 31.3018766,25.3402468 30.8086,25.3402468 L18.2979617,25.3402468 C17.8046851,25.3402468 17.4043447,25.7405872 17.4043447,26.2338638 L17.4043447,28.0210979 C17.4043447,28.5152681 17.8046851,28.9147149 18.2979617,28.9147149 L30.8086,28.9147149 C31.3018766,28.9147149 31.702217,28.5152681 31.702217,28.0210979 L31.702217,28.0210979 Z M31.702217,20.8721617 L31.702217,19.0849277 C31.702217,18.5916511 31.3018766,18.1913106 30.8086,18.1913106 L18.2979617,18.1913106 C17.8046851,18.1913106 17.4043447,18.5916511 17.4043447,19.0849277 L17.4043447,20.8721617 C17.4043447,21.3663319 17.8046851,21.7657787 18.2979617,21.7657787 L30.8086,21.7657787 C31.3018766,21.7657787 31.702217,21.3663319 31.702217,20.8721617 L31.702217,20.8721617 Z M31.1785574,39.1144596 L43.1655362,27.1283745 L42.5337489,26.4965872 C41.4873234,25.4501617 39.7894511,25.4501617 38.7421319,26.4965872 L29.914983,35.3237362 L28.2358766,33.6446298 C27.1894511,32.5982043 25.4915787,32.5982043 24.4442596,33.6446298 L23.813366,34.276417 L28.6514085,39.1144596 C29.0008128,39.4638638 29.4574511,39.6381191 29.914983,39.6381191 C30.3725149,39.6381191 30.8291532,39.4638638 31.1785574,39.1144596 L31.1785574,39.1144596 Z M37.0639191,44.9998213 L12.0426426,44.9998213 C11.0560894,44.9998213 10.2554085,44.1991404 10.2554085,43.2125872 L10.2554085,11.0423745 C10.2554085,10.0549277 11.0560894,9.25514043 12.0426426,9.25514043 L37.0639191,9.25514043 C38.0504723,9.25514043 38.8511532,10.0549277 38.8511532,11.0423745 L38.8511532,23.5530128 L35.2766851,23.5530128 L35.2766851,12.8296085 L13.8298766,12.8296085 L13.8298766,41.4253532 L35.2766851,41.4253532 L35.2766851,37.8508851 L38.8511532,37.8508851 L38.8511532,43.2125872 C38.8511532,44.1991404 38.0504723,44.9998213 37.0639191,44.9998213 L37.0639191,44.9998213 Z"
})), 'certified');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Email = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "M42,10.0005 C43.104,10.0005 44,10.8955 44,12.0005 L44,36.0005 C44,37.1045 43.104,38.0005 42,38.0005 L6,38.0005 C4.896,38.0005 4,37.1045 4,36.0005 L4,12.0005 C4,11.4695 4.211,10.9605 4.586,10.5855 C4.961,10.2105 5.47,10.0005 6,10.0005 L42,10.0005 Z M40,16.6925 L24,28.9273 L8,16.6925 L8,34.0005 L40,34.0005 L40,16.6925 Z M36.934,14.0005 L11.066,14.0005 L24,23.8923 L36.934,14.0005 Z"
})), 'email');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var MultipleMedia = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Multiple-Media",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M41.996,16.0001 C43.106,16.0001 43.996,16.9001 43.996,18.0001 L43.996,18.0001 L43.996,42.0001 C43.996,43.0991 43.106,44.0001 41.996,44.0001 L41.996,44.0001 L17.996,44.0001 C16.896,44.0001 15.996,43.0991 15.996,42.0001 L15.996,42.0001 L15.996,18.0001 C15.996,16.9001 16.896,16.0001 17.996,16.0001 L17.996,16.0001 Z M39.996,20.0001 L19.996,20.0001 L19.996,40.0001 L39.996,40.0001 L39.996,20.0001 Z M33.0001,10 C34.6571,10 36.0001,11.343 36.0001,13 L36.0001,13 L36.0001,14 L14.0001,14 L14.0001,34 L13.0001,34 C11.3431,34 10.0001,32.657 10.0001,31 L10.0001,31 L10.0001,12 C10.0001,10.896 10.8961,10 12.0001,10 L12.0001,10 Z M26.0264,4 C27.6834,4 29.0264,5.343 29.0264,7 L29.0264,7 L29.0264,8 L8.0004,8 L8.0004,29.026 L7.0004,29.026 C5.3434,29.026 4.0004,27.684 4.0004,26.026 L4.0004,26.026 L4.0004,6 C4.0004,4.896 4.8954,4 6.0004,4 L6.0004,4 Z",
  id: "Multiple-Media",
  fill: "#000000"
}))), 'multiple-media');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var NotificationIcon = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "M40.4299065,19.6281665 L38.7476636,19.6281665 L38.7476636,7.53002886 C38.7476636,6.91277694 38.411215,6.41897541 37.9626168,6.17207464 C37.5140187,5.92517387 36.953271,5.92517387 36.5046729,6.29552502 C31.682243,10.4928381 25.4018692,12.8383954 19.0093458,12.8383954 L14.1869159,12.8383954 C9.70093458,12.8383954 6,16.5419069 6,21.2330214 C6,25.4303345 9.02803738,28.8869452 12.953271,29.5041971 L16.7663551,39.3802278 C17.2149533,40.3678309 17.8878505,41.2319836 18.8971963,41.6023347 C19.3457944,41.8492355 19.9065421,41.9726859 20.4672897,41.9726859 C21.0280374,41.9726859 21.7009346,41.8492355 22.2616822,41.6023347 C24.3925234,40.6147317 25.4018692,37.8988232 24.6168224,35.6767163 L22.3738318,29.8745483 C27.5327103,30.4918002 32.4672897,32.5904567 36.5046729,35.9236171 C36.728972,36.1705179 37.0654206,36.2939682 37.4018692,36.2939682 C37.6261682,36.2939682 37.8504673,36.2939682 38.0747664,36.1705179 C38.5233645,35.9236171 38.8598131,35.4298156 38.8598131,34.8125636 L38.8598131,22.714426 L40.5420561,22.714426 C41.3271028,22.714426 42,21.9737237 42,21.1095711 C42,20.2454184 41.2149533,19.6281665 40.4299065,19.6281665 Z M22.0373832,36.9112202 C22.2616822,37.5284721 21.9252336,38.3926248 21.1401869,38.7629759 C20.8037383,39.0098767 20.3551402,39.0098767 20.0186916,38.7629759 C19.7943925,38.6395255 19.5700935,38.5160751 19.4579439,38.145724 L16.0934579,29.6276475 L19.2336449,29.6276475 C19.2336449,29.6276475 19.2336449,29.6276475 19.2336449,29.6276475 L22.0373832,36.9112202 Z M36.0560748,31.8497544 C31.4579439,28.6400445 25.9626168,26.9117391 20.3551402,26.6648383 C20.2429907,26.6648383 20.2429907,26.6648383 20.1308411,26.6648383 C19.7943925,26.6648383 19.5700935,26.6648383 19.2336449,26.6648383 L14.1869159,26.6648383 C11.1588785,26.6648383 8.80373832,24.319281 8.80373832,21.3564718 C8.80373832,18.3936626 11.271028,16.0481053 14.1869159,16.0481053 L19.0093458,16.0481053 C25.1775701,16.0481053 31.0093458,14.0728992 35.9439252,10.6162884 L35.9439252,31.8497544 L36.0560748,31.8497544 Z",
  fill: "currentColor",
  fillRule: "nonzero"
})), 'NotificationIcon');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Call = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "M10.5232,18.3972 C10.5472,18.4902 11.2982,21.2522 13.8022,24.3312 C15.0602,25.8942 19.5052,31.2222 24.1002,34.4972 C27.1852,36.7052 29.6592,37.4822 29.6842,37.4882 L29.8802,37.5602 C31.5142,38.2502 32.5532,37.9272 32.5972,37.9132 L32.7192,37.8722 C33.5822,37.6222 34.5062,36.9192 35.3052,36.2802 C36.2642,35.4922 37.0692,34.7382 37.7412,33.9982 C36.9552,33.1152 35.2532,31.5062 34.3992,30.8152 C34.2322,30.6812 34.0602,30.5382 33.8892,30.3962 C33.6082,30.1602 33.3382,29.9362 33.0792,29.7502 L33.0542,29.7752 C32.8622,29.9682 32.6312,30.2452 32.3792,30.5422 C31.2432,31.8842 30.4182,32.7862 29.3402,33.0942 C27.2532,33.7982 24.0042,31.1352 23.6412,30.8292 C21.5052,29.0652 18.4832,26.2622 17.0462,24.2012 C15.3162,21.7292 14.4262,20.0332 14.9172,18.5632 C15.2082,17.5882 16.1042,16.7622 17.4352,15.6202 C17.7362,15.3622 18.0162,15.1262 18.2092,14.9332 C18.2182,14.9232 18.2282,14.9142 18.2372,14.9052 C17.9592,14.5072 17.6072,14.0962 17.2652,13.6962 L17.1712,13.5862 C16.4842,12.7382 14.8922,11.0542 13.9762,10.2462 C13.2002,10.9282 12.4472,11.7362 11.7162,12.6672 C11.0792,13.4632 10.3932,14.3642 10.1292,15.2152 L10.1052,15.2992 C10.0242,15.5792 9.8082,16.6092 10.4312,18.1202 L10.5232,18.3972 Z M31.8562,41.9962 C30.9292,41.9962 29.7522,41.8322 28.4132,41.2812 C27.8202,41.0882 25.0812,40.1182 21.7752,37.7522 C16.7682,34.1832 12.0262,28.5032 10.6922,26.8482 C7.9032,23.4172 6.8962,20.2702 6.6852,19.5242 C5.7802,17.2552 5.9512,15.4542 6.1922,14.4502 L6.1922,14.4232 L6.2722,14.1492 C6.7282,12.5812 7.7042,11.2782 8.5822,10.1822 C9.6012,8.8842 10.6882,7.7562 11.8002,6.8432 C12.9802,5.8982 14.0832,5.9172 14.8032,6.0972 L15.1242,6.2072 C16.8502,6.9682 20.2482,11.0292 20.2802,11.0702 C20.7612,11.6302 21.2812,12.2362 21.7212,12.9202 C22.1392,13.4572 22.3892,14.0402 22.4662,14.6552 C22.7382,16.1872 21.6482,17.1942 21.1832,17.6242 L21.0362,17.7622 C20.7872,18.0112 20.4292,18.3222 20.0402,18.6562 C19.7352,18.9182 19.2412,19.3412 18.9202,19.6622 C19.0992,20.0362 19.4802,20.7022 20.2942,21.8652 C21.3052,23.3142 23.6662,25.6622 26.2022,27.7572 C26.7522,28.2192 27.7322,28.8222 28.3202,29.0862 C28.6372,28.7722 29.0662,28.2662 29.3272,27.9562 C29.6612,27.5642 29.9722,27.2012 30.2252,26.9482 L30.3572,26.8102 C30.8012,26.3392 31.8452,25.2362 33.4512,25.5382 L33.6322,25.5812 C34.1372,25.7262 34.5552,25.9652 34.8912,26.1562 C35.5262,26.5522 35.9972,26.9442 36.4532,27.3242 C36.6032,27.4502 36.7542,27.5752 36.9072,27.6982 C36.9552,27.7372 41.0212,31.1392 41.7792,32.8632 L41.8972,33.2182 C42.2602,34.7912 41.4302,35.8272 41.1572,36.1672 C40.2302,37.2582 39.1522,38.2962 37.8242,39.3872 C36.7172,40.2732 35.4312,41.2352 33.8892,41.6972 C33.5972,41.7962 32.8792,41.9962 31.8562,41.9962 L31.8562,41.9962 Z",
  fill: ""
})), 'call');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var MinusIcon = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Minus",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M37.0002,26.0001 L8.0002,26.0001 L8.0002,25.0001 C8.0002,23.3431 9.3432,22.0001 11.0002,22.0001 L40.0002,22.0001 L40.0002,23.0001 C40.0002,24.6571 38.6562,26.0001 37.0002,26.0001",
  id: "Minus",
  fill: "currentColor"
}))), "minus");

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Share = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Share",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M36.0005,40 C33.7945,40 32.0005,38.206 32.0005,36 C32.0005,33.794 33.7945,32 36.0005,32 C38.2065,32 40.0005,33.794 40.0005,36 C40.0005,38.206 38.2065,40 36.0005,40 M12.0005,28 C9.7945,28 8.0005,26.206 8.0005,24 C8.0005,21.794 9.7945,20 12.0005,20 C14.2055,20 16.0005,21.794 16.0005,24 C16.0005,26.206 14.2055,28 12.0005,28 M36.0005,8 C38.2055,8 40.0005,9.794 40.0005,12 C40.0005,14.206 38.2055,16 36.0005,16 C33.7945,16 32.0005,14.206 32.0005,12 C32.0005,9.794 33.7945,8 36.0005,8 M36.0005,28 C33.5975,28 31.4445,29.069 29.9775,30.752 L19.8205,25.674 C19.9365,25.134 20.0005,24.574 20.0005,24 C20.0005,23.426 19.9365,22.866 19.8205,22.326 L29.9765,17.248 C31.4445,18.931 33.5975,20 36.0005,20 C40.4115,20 44.0005,16.411 44.0005,12 C44.0005,7.589 40.4115,4 36.0005,4 C31.5885,4 28.0005,7.589 28.0005,12 C28.0005,12.574 28.0635,13.134 28.1795,13.674 L18.0235,18.752 C16.5555,17.069 14.4025,16 12.0005,16 C7.5885,16 4.0005,19.589 4.0005,24 C4.0005,28.411 7.5885,32 12.0005,32 C14.4025,32 16.5555,30.931 18.0235,29.248 L28.1795,34.326 C28.0645,34.866 28.0005,35.426 28.0005,36 C28.0005,40.411 31.5895,44 36.0005,44 C40.4115,44 44.0005,40.411 44.0005,36 C44.0005,31.589 40.4115,28 36.0005,28",
  id: "Share",
  fill: "#333333"
}))), 'Share');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Filtered = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M16,32.4995 C18.606,32.4995 20.823,34.1735 21.65,36.4995 L21.65,36.4995 L42,36.4995 L42,37.4995 C42,39.1565 40.657,40.4995 39,40.4995 L39,40.4995 L21.649,40.4995 C20.823,42.8265 18.606,44.4995 16,44.4995 C13.395,44.4995 11.178,42.8265 10.351,40.4995 L10.351,40.4995 L7,40.4995 C6.447,40.4995 6,40.0525 6,39.4995 L6,39.4995 L6,37.4995 C6,36.9475 6.447,36.4995 7,36.4995 L7,36.4995 L10.351,36.4995 C11.177,34.1735 13.395,32.4995 16,32.4995 Z M16,36.4995 C14.897,36.4995 14.001,37.3965 14.001,38.4995 C14.001,39.6025 14.897,40.4995 16,40.4995 C17.103,40.4995 18,39.6025 18,38.4995 C18,37.3965 17.103,36.4995 16,36.4995 Z M32,20.4995 C34.606,20.4995 36.823,22.1735 37.65,24.4995 L37.65,24.4995 L41,24.4995 C41.553,24.4995 42,24.9475 42,25.4995 L42,25.4995 L42,27.4995 C42,28.0525 41.553,28.4995 41,28.4995 L41,28.4995 L37.649,28.4995 C36.823,30.8265 34.606,32.4995 32,32.4995 C29.395,32.4995 27.178,30.8265 26.351,28.4995 L26.351,28.4995 L7,28.4995 C6.447,28.4995 6,28.0525 6,27.4995 L6,27.4995 L6,25.4995 C6,24.9475 6.447,24.4995 7,24.4995 L7,24.4995 L26.351,24.4995 C27.177,22.1735 29.395,20.4995 32,20.4995 Z M32,24.4995 C30.897,24.4995 30.001,25.3965 30.001,26.4995 C30.001,27.6025 30.897,28.4995 32,28.4995 C33.103,28.4995 34,27.6025 34,26.4995 C34,25.3965 33.103,24.4995 32,24.4995 Z M16,8.5 C18.606,8.5 20.823,10.173 21.65,12.5 L21.65,12.5 L26.716,12.5 C27.037,13.993 27.709,15.357 28.643,16.5 L28.643,16.5 L21.649,16.5 C20.823,18.826 18.606,20.5 16,20.5 C13.395,20.5 11.178,18.826 10.351,16.5 L10.351,16.5 L7,16.5 C6.447,16.5 6,16.052 6,15.5 L6,15.5 L6,13.5 C6,12.948 6.447,12.5 7,12.5 L7,12.5 L10.351,12.5 C11.177,10.173 13.395,8.5 16,8.5 Z M16,12.5 C14.897,12.5 14.001,13.397 14.001,14.5 C14.001,15.603 14.897,16.5 16,16.5 C17.103,16.5 18,15.603 18,14.5 C18,13.397 17.103,12.5 16,12.5 Z M36,4 C32.416,4 29.5,6.916 29.5,10.5 C29.5,11.198 29.613,11.869 29.818,12.5 C30.405,14.309 31.763,15.773 33.504,16.5 C34.273,16.821 35.116,17 36,17 C36.884,17 37.727,16.821 38.496,16.5 C40.075,15.84 41.341,14.576 42,12.996 C42.321,12.227 42.5,11.384 42.5,10.5 C42.5,6.916 39.584,4 36,4",
  fill: "#333333"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M36,4 C32.416,4 29.5,6.916 29.5,10.5 C29.5,11.198 29.613,11.869 29.818,12.5 C30.405,14.309 31.763,15.773 33.504,16.5 C34.273,16.821 35.116,17 36,17 C36.884,17 37.727,16.821 38.496,16.5 C40.075,15.84 41.341,14.576 42,12.996 C42.321,12.227 42.5,11.384 42.5,10.5 C42.5,6.916 39.584,4 36,4",
  fill: "#333333"
}), /*#__PURE__*/React__default.createElement("rect", {
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}))), 'filtered');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Edit = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Edit",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M36.1719,14.5851 L32.9999,11.4141 L19.0009,25.4141 L19.0009,28.5851 L22.1719,28.5851 L36.1719,14.5851 Z M39.7069,16.7071 L23.8289,32.5851 L15.0009,32.5851 L15.0009,23.7561 L30.8789,7.8781 C32.0509,6.7071 33.9489,6.7071 35.1209,7.8781 L39.7069,12.4641 C40.8779,13.6351 40.8789,15.5351 39.7069,16.7071 L39.7069,16.7071 Z M37.9999,26.5851 L38.9999,26.5851 L38.9999,37.5851 C38.9999,39.2421 37.6569,40.5851 35.9999,40.5851 L9.9999,40.5851 C8.3429,40.5851 6.9999,39.2421 6.9999,37.5851 L6.9999,11.5851 C6.9999,9.9291 8.3429,8.5851 9.9999,8.5851 L21.0009,8.5851 L21.0009,9.5851 C21.0009,11.2421 19.6579,12.5851 18.0009,12.5851 L10.9999,12.5851 L10.9999,36.5851 L34.9999,36.5851 L34.9999,29.5851 C34.9999,27.9291 36.3429,26.5851 37.9999,26.5851 L37.9999,26.5851 Z",
  id: "Edit",
  fill: "#333333"
}))), 'edit');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Career = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Career",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M24,7.9999 C27.309,7.9999 30,10.6909 30,13.9999 C30,17.3089 27.309,19.9999 24,19.9999 C20.691,19.9999 18,17.3089 18,13.9999 C18,10.6909 20.691,7.9999 24,7.9999 M31.541,20.5469 C33.068,18.7909 34,16.5039 34,13.9999 C34,8.4859 29.514,3.9999 24,3.9999 C18.486,3.9999 14,8.4859 14,13.9999 C14,16.5039 14.932,18.7909 16.459,20.5469 C10.444,22.1179 6,27.5709 6,34.0769 L6,36.9999 C6,38.6569 7.343,39.9999 9,39.9999 L10,39.9999 L10,34.0769 C10,28.5539 14.478,24.0769 20,24.0769 L21.436,24.0769 L17.923,38.0619 C17.838,38.4039 17.938,38.7649 18.186,39.0129 L23.293,44.1209 C23.684,44.5119 24.316,44.5119 24.707,44.1209 L29.854,38.9749 C30.123,38.7069 30.216,38.3079 30.095,37.9479 L28.855,34.2799 C28.325,32.7099 26.623,31.8669 25.054,32.3969 L24.106,32.7169 L25.709,37.4639 L24,39.1719 L22.217,37.3879 L25.56,24.0769 L28,24.0769 C33.522,24.0769 38,28.5539 38,34.0769 L38,39.9999 L39,39.9999 C40.657,39.9999 42,38.6569 42,36.9999 L42,34.0769 C42,27.5709 37.556,22.1179 31.541,20.5469",
  id: "Career",
  fill: "#333333"
}))), 'Career');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var CorporateGovernance = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Corporate-Governance",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M33.9999,29.9999 L31.1499,29.9999 C29.3299,29.9999 27.5209,30.4799 25.9999,31.4599 L25.9999,16.8299 C25.9999,15.5609 26.5209,14.3109 27.4199,13.4099 C28.3299,12.4999 29.5399,11.9999 30.8299,11.9999 L33.9999,11.9999 L33.9999,29.9999 Z M21.9999,31.4499 C20.4899,30.4799 18.6799,29.9999 16.8599,29.9999 L13.9999,29.9999 L13.9999,11.9999 L17.1699,11.9999 C18.4499,11.9999 19.6899,12.5209 20.5899,13.4099 C21.4899,14.3109 21.9999,15.5609 21.9999,16.8299 L21.9999,31.4499 Z M36.9999,7.9999 L31.1499,7.9999 C28.9099,7.9999 26.6899,8.7099 25.0099,10.1899 C24.6399,10.5209 24.3099,10.8799 23.9999,11.2499 C23.6999,10.8799 23.3699,10.5209 22.9999,10.1899 C21.3199,8.7099 19.0999,7.9999 16.8599,7.9999 L10.9999,7.9999 C10.4499,7.9999 9.9999,8.4499 9.9999,8.9999 L9.9999,32.9999 C9.9999,33.5499 10.4499,33.9999 10.9999,33.9999 L17.1699,33.9999 C18.4699,33.9999 19.6799,34.4999 20.5899,35.4099 C21.4899,36.3109 21.9999,37.5609 21.9999,38.8299 L21.9999,38.9999 C21.9999,39.5499 22.4499,39.9999 22.9999,39.9999 L24.9999,39.9999 C25.5599,39.9999 25.9999,39.5499 25.9999,38.9999 L25.9999,38.8299 C25.9999,37.5609 26.5209,36.3109 27.4199,35.4099 C28.3299,34.4999 29.5399,33.9999 30.8299,33.9999 L36.9999,33.9999 C37.5599,33.9999 37.9999,33.5499 37.9999,32.9999 L37.9999,8.9999 C37.9999,8.4499 37.5599,7.9999 36.9999,7.9999 L36.9999,7.9999 Z M39.9999,13.9999 L39.9999,35.9999 L31.0009,35.9999 C29.3449,35.9999 28.0019,37.3419 28.0009,38.9969 L27.9999,39.9999 L42.9999,39.9999 C43.5599,39.9999 43.9999,39.5499 43.9999,38.9999 L43.9999,16.9999 C43.9999,15.3429 42.6569,13.9999 40.9999,13.9999 L39.9999,13.9999 Z M16.9999,35.9999 L7.9999,35.9999 L7.9999,13.9999 L6.9999,13.9999 C5.3429,13.9999 3.9999,15.3429 3.9999,16.9999 L3.9999,38.9999 C3.9999,39.5499 4.4499,39.9999 4.9999,39.9999 L19.9999,39.9999 L19.9999,38.9999 C19.9999,37.3429 18.6569,35.9999 16.9999,35.9999 L16.9999,35.9999 Z",
  id: "Corporate-Governance",
  fill: "#333333"
}))), 'CorporateGovernance');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var InvestorInformation = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Investor-Information",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M15.7363,27.9922 L14.8683,27.4962 C13.4293,26.6742 12.9303,24.8422 13.7523,23.4032 L16.6703,18.2962 C16.9063,17.8822 17.4033,17.6922 17.8553,17.8432 L23.0763,19.5842 L26.2633,14.0082 L27.1313,14.5042 C28.5703,15.3262 29.0693,17.1582 28.2473,18.5962 L25.3293,23.7042 C25.0923,24.1182 24.5963,24.3072 24.1443,24.1572 L18.9233,22.4162 L15.7363,27.9922 Z M41.9993,39.0002 L41.9993,15.0002 C41.9993,13.3432 40.6563,12.0002 38.9993,12.0002 L37.9993,12.0002 L37.9993,38.0002 L12.0003,38.0002 L12.0003,39.0002 C12.0003,40.6572 13.3433,42.0002 15.0003,42.0002 L38.9993,42.0002 C40.6563,42.0002 41.9993,40.6572 41.9993,39.0002 L41.9993,39.0002 Z M10.0003,32.0012 L32.0003,32.0012 L32.0003,10.0002 L10.0003,10.0002 L10.0003,32.0012 Z M33.0003,6.0002 L9.0003,6.0002 C7.3433,6.0002 6.0003,7.3432 6.0003,9.0002 L6.0003,33.0012 C6.0003,34.6582 7.3433,36.0012 9.0003,36.0012 L33.0003,36.0012 C34.6573,36.0012 36.0003,34.6582 36.0003,33.0012 L36.0003,9.0002 C36.0003,7.3432 34.6573,6.0002 33.0003,6.0002 L33.0003,6.0002 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'InvestorInformation');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Press = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Press",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M14.004,20 L24.004,20 L24.004,18 L14.004,18 L14.004,20 Z M27.004,24 L11.004,24 C10.451,24 10.004,23.553 10.004,23 L10.004,15 C10.004,14.448 10.451,14 11.004,14 L27.004,14 C27.556,14 28.004,14.448 28.004,15 L28.004,23 C28.004,23.553 27.556,24 27.004,24 L27.004,24 Z M17.199,32 L11.199,32 C10.647,32 10.199,31.553 10.199,31 L10.199,29 C10.199,28.448 10.647,28 11.199,28 L17.199,28 C17.751,28 18.199,28.448 18.199,29 L18.199,31 C18.199,31.553 17.751,32 17.199,32 L17.199,32 Z M25.004,32 L21.004,32 C20.451,32 20.004,31.552 20.004,31 L20.004,29 C20.004,28.448 20.451,28 21.004,28 L28.004,28 L28.004,29 C28.004,30.657 26.66,32 25.004,32 L25.004,32 Z M40,35 C40,36.84 38.333,38.307 36.415,37.945 C34.986,37.674 34,36.342 34,34.887 L34,32 L40,32 L40,35 Z M11,38 C9.35,38 8,36.65 8,35 L8,10 L30,10 L30,35 C30,36.071 30.25,37.09 30.68,38 L11,38 Z M42,28 L34,28 L34,9 C34,7.343 32.657,6 31,6 L7,6 C5.343,6 4,7.343 4,9 L4,35 C4,38.866 7.134,42 11,42 L37.01,42 C40.87,42 44.01,38.87 44.0000238,35 L44.0000238,30 C44.0000238,28.9 43.11,28 42,28 L42,28 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'Press');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Chat = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Chat",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M24.1224,5.9997 C34.1194,5.9997 42.2244,14.1037 42.2244,24.1017 L42.2244,24.1017 L42.2244,24.1127 C42.2244,34.1167 34.1144,42.2257 24.1114,42.2257 L24.1114,42.2257 L9.0004,42.2257 C7.3434,42.2257 6.0004,40.8827 6.0004,39.2257 L6.0004,39.2257 L6.0004,24.1127 C6.0004,14.1097 14.1094,5.9997 24.1134,5.9997 L24.1134,5.9997 Z M24.1224,9.9997 C16.3314,9.9997 10.0004,16.3307 10.0004,24.1127 L10.0004,24.1127 L10.0004,38.2257 L24.1114,38.2257 C31.8934,38.2257 38.2244,31.8947 38.2244,24.1127 C38.2244,16.3257 31.8984,9.9997 24.1224,9.9997 L24.1224,9.9997 Z M24.0874,21.8447 C25.4224,21.8447 26.4684,22.8907 26.4684,24.2257 C26.4684,25.5607 25.4224,26.6067 24.0874,26.6067 C22.7524,26.6067 21.7064,25.5607 21.7064,24.2257 C21.7064,22.9137 22.7744,21.8447 24.0874,21.8447 Z M16.4684,21.8447 C17.8024,21.8447 18.8484,22.8907 18.8484,24.2257 C18.8484,25.5607 17.8024,26.6067 16.4684,26.6067 C15.1334,26.6067 14.0864,25.5607 14.0864,24.2257 C14.0864,22.9137 15.1554,21.8447 16.4684,21.8447 Z M31.7074,21.8447 C33.0414,21.8447 34.0884,22.8907 34.0884,24.2257 C34.0884,25.5607 33.0414,26.6067 31.7074,26.6067 C30.3944,26.6067 29.3254,25.5387 29.3254,24.2257 C29.3254,22.9137 30.3944,21.8447 31.7074,21.8447 Z",
  id: "Chat",
  fill: "#333333"
}))), 'Chat');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Claims = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Claims",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M28.0034,30.9431 L28.0034,31.9431 C28.0034,33.6001 26.6604,34.9431 25.0034,34.9431 L21.0034,34.9431 C20.4534,34.9431 20.0034,34.4931 20.0034,33.9431 L20.0034,31.9431 C20.0034,31.3831 20.4534,30.9431 21.0034,30.9431 L28.0034,30.9431 Z M28.0034,19.0001 L28.0034,20.0001 C28.0034,21.6571 26.6604,23.0001 25.0034,23.0001 L21.0034,23.0001 C20.4534,23.0001 20.0034,22.5491 20.0034,22.0001 L20.0034,20.0001 C20.0034,19.4401 20.4534,19.0001 21.0034,19.0001 L28.0034,19.0001 Z M28.0034,25.0001 L28.0034,26.0001 C28.0034,27.6571 26.6604,29.0001 25.0034,29.0001 L21.0034,29.0001 C20.4534,29.0001 20.0034,28.5491 20.0034,28.0001 L20.0034,26.0001 C20.0034,25.4401 20.4534,25.0001 21.0034,25.0001 L28.0034,25.0001 Z M28.0034,13.0001 L28.0034,14.0001 C28.0034,15.6571 26.6604,17.0001 25.0034,17.0001 L21.0034,17.0001 C20.4534,17.0001 20.0034,16.5491 20.0034,16.0001 L20.0034,14.0001 C20.0034,13.4401 20.4534,13.0001 21.0034,13.0001 L28.0034,13.0001 Z M18.0004,19.0001 L18.0004,20.0001 C18.0004,21.6571 16.6564,23.0001 15.0004,23.0001 L11.0004,23.0001 C10.4504,23.0001 10.0004,22.5491 10.0004,22.0001 L10.0004,20.0001 C10.0004,19.4401 10.4504,19.0001 11.0004,19.0001 L18.0004,19.0001 Z M18.0004,25.0001 L18.0004,26.0001 C18.0004,27.6571 16.6564,29.0001 15.0004,29.0001 L11.0004,29.0001 C10.4504,29.0001 10.0004,28.5491 10.0004,28.0001 L10.0004,26.0001 C10.0004,25.4401 10.4504,25.0001 11.0004,25.0001 L18.0004,25.0001 Z M18.0004,13.0001 L18.0004,14.0001 C18.0004,15.6571 16.6564,17.0001 15.0004,17.0001 L11.0004,17.0001 C10.4504,17.0001 10.0004,16.5491 10.0004,16.0001 L10.0004,14.0001 C10.0004,13.4401 10.4504,13.0001 11.0004,13.0001 L18.0004,13.0001 Z M40.0004,15.0001 L34.0004,15.0001 L34.0004,12.0001 C34.0004,10.3391 35.3504,9.0001 37.0004,9.0001 C38.6604,9.0001 40.0004,10.3391 40.0004,12.0001 L40.0004,15.0001 Z M30.0004,12.0001 L30.0004,39.0001 L8.0004,39.0001 L8.0004,12.0001 C8.0004,10.3391 9.3504,9.0001 11.0004,9.0001 L30.6804,9.0001 C30.2504,9.9101 30.0004,10.9201 30.0004,12.0001 L30.0004,12.0001 Z M37.0004,5.0001 L11.0004,5.0001 C7.1404,5.0001 4.0004,8.1391 4.0004,12.0001 L4.0004,43.0001 L34.0004,43.0001 L34.0004,19.0001 L42.0004,19.0001 C43.1094,19.0001 44.0004,18.1001 44.0004,17.0001 L44.0004,12.0001 C44.0004,8.1391 40.8594,5.0001 37.0004,5.0001 L37.0004,5.0001 Z",
  id: "Claims",
  fill: "#333333"
}))), 'Claims');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var CallEmail = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Call-Email",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M11.1667,10.7867 C12.2807,9.8967 13.3247,9.9157 14.0107,10.0837 L14.0107,10.0837 L14.3357,10.1957 C15.8058176,10.8422882 18.5639076,14.0745651 18.9074794,14.482609 L18.9427,14.5247 C19.3567,15.0057 19.8177,15.5417 20.2127,16.1547 C20.6017,16.6577 20.8367,17.2067 20.9087,17.7867 C21.1677,19.2487 20.1087,20.2287 19.7097,20.5977 L19.7097,20.5977 L19.5877,20.7117 C19.3377,20.9617 19.0307,21.2207 18.7167,21.4787 C18.6077,21.5687 18.4647,21.6857 18.3337,21.7997 C18.5087,22.1327 18.8327,22.6697 19.4307,23.5237 C20.3007,24.7717 22.3487,26.8077 24.5547,28.6287 C24.9677,28.9757 25.6857,29.4287 26.1827,29.6767 C26.2927,29.5477 26.4097,29.4037 26.5037,29.2877 C26.7627,28.9677 27.0217,28.6547 27.2757,28.4007 L27.2757,28.4007 L27.3857,28.2857 C27.8037,27.8427 28.7797,26.8127 30.3217,27.0987 L30.3217,27.0987 L30.5017,27.1417 C30.9767,27.2777 31.3727,27.5037 31.6617,27.6687 C32.2397,28.0287 32.6777,28.3937 33.0637,28.7157 C33.1937,28.8237 33.3237,28.9327 33.4567,29.0387 C33.5007,29.0747 37.1067,32.0927 37.7927,33.6537 L37.7927,33.6537 L37.9107,34.0087 C38.1397,34.9987 37.9067,35.9387 37.2167,36.8007 C36.3877,37.7767 35.4337,38.6957 34.2617,39.6577 C33.2707,40.4497 32.1207,41.3107 30.7287,41.7257 C30.4497,41.8197 29.7957,41.9957 28.8757,41.9957 C28.0377,41.9957 26.9787,41.8497 25.7797,41.3577 C25.2257,41.1757 22.8107,40.3117 19.9107,38.2367 C15.4987,35.0897 11.3337,30.0997 10.1617,28.6457 C7.7137,25.6357 6.8117,22.8587 6.6127,22.1607 C5.8097,20.1407 5.9527,18.5257 6.1687,17.6097 L6.1687,17.6097 L6.1687,17.5787 L6.2477,17.3067 C6.6597,15.8897 7.5307,14.7257 8.3147,13.7457 C9.2157,12.5997 10.1797,11.5987 11.1667,10.7867 Z M13.2287,14.2927 C12.6267,14.8417 12.0297,15.4917 11.4487,16.2317 C10.9057,16.9107 10.3217,17.6767 10.1027,18.3767 L10.1027,18.3767 L10.0817,18.4507 C10.0347,18.6117 9.8307,19.4767 10.3587,20.7557 L10.3587,20.7557 L10.4497,21.0297 C10.4717,21.1157 11.1217,23.4867 13.2717,26.1287 C14.3677,27.4897 18.2367,32.1297 22.2367,34.9827 C24.8987,36.8867 27.0317,37.5587 27.0527,37.5657 L27.0527,37.5657 L27.2477,37.6357 C28.5767,38.1977 29.4167,37.9477 29.4517,37.9357 L29.4517,37.9357 L29.5667,37.8987 C30.2757,37.6937 31.0617,37.0947 31.7427,36.5507 C32.4987,35.9287 33.1457,35.3307 33.6957,34.7437 C32.9807,33.9757 31.6337,32.7097 30.9487,32.1547 C30.8027,32.0377 30.6507,31.9117 30.5007,31.7857 C30.3207,31.6367 30.1467,31.4907 29.9787,31.3627 C29.8567,31.4977 29.7357,31.6517 29.6117,31.8047 C29.0297,32.5247 28.3047,33.4197 27.2117,33.7327 C25.3027,34.3697 22.5297,32.1527 21.9927,31.7007 C20.0207,30.0717 17.4467,27.6707 16.1777,25.8507 C14.6177,23.6237 13.8177,22.0817 14.2817,20.6947 C14.5777,19.7057 15.4257,19.0077 16.1727,18.3917 C16.3317,18.2607 16.4907,18.1327 16.6297,18.0067 C16.4147,17.7197 16.1607,17.4237 15.9137,17.1357 L15.9137,17.1357 L15.8327,17.0397 C15.2827,16.3607 14.0317,15.0287 13.2287,14.2927 Z M41.9961,17.9999 L41.9961,18.9999 C41.9961,20.6569 40.6531,21.9999 38.9961,21.9999 L38.9961,21.9999 L26.9961,21.9999 C26.4441,21.9999 25.9961,21.5529 25.9961,20.9999 L25.9961,20.9999 L25.9961,18.9999 C25.9961,18.4479 26.4441,17.9999 26.9961,17.9999 L26.9961,17.9999 L41.9961,17.9999 Z M41.9961,11.9999 L41.9961,12.9999 C41.9961,14.6569 40.6531,15.9999 38.9961,15.9999 L38.9961,15.9999 L26.9961,15.9999 C26.4441,15.9999 25.9961,15.5529 25.9961,14.9999 L25.9961,14.9999 L25.9961,12.9999 C25.9961,12.4479 26.4441,11.9999 26.9961,11.9999 L26.9961,11.9999 L41.9961,11.9999 Z M41.9966,5.9999 L41.9966,6.9999 C41.9966,8.6569 40.6526,9.9999 38.9966,9.9999 L38.9966,9.9999 L18.9966,9.9999 C18.4446,9.9999 17.9966,9.5529 17.9966,8.9999 L17.9966,8.9999 L17.9966,6.9999 C17.9966,6.4479 18.4446,5.9999 18.9966,5.9999 L18.9966,5.9999 L41.9966,5.9999 Z",
  id: "Call-Email",
  fill: "#333333"
}))), 'CallEmail');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Products = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Products",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M23.9974,3.9998 L24.2594,4.0108 C24.5924,3.9908 24.7534,4.0528 24.9414,4.1228 L24.9414,4.1228 L24.9264,4.1648 C26.7784,4.5938 31.1214,6.0348 42.6624,10.1138 L42.6624,10.1138 L43.7514,10.4988 L43.9624,11.6348 C43.9864,11.7668 44.3044,13.5468 44.2754,16.2568 C44.2544,18.3598 41.6974,19.3948 40.2114,17.9078 L40.2114,17.9078 L40.2034,17.9008 C40.3304,16.0118 40.2574,14.4488 40.1674,13.4758 C33.3174,11.0638 25.9704,8.5538 24.1244,8.0568 C22.2764,8.5548 14.9214,11.0668 8.0694,13.4798 C7.6354,17.7428 7.3704,32.8528 24.1244,39.7958 C25.7934,39.1038 27.3454,38.3048 28.7694,37.4108 C29.9744,36.6548 31.5324,36.7888 32.5384,37.7958 L32.5384,37.7958 L33.6164,38.8728 C33.6164,38.8798 33.6154,38.8818 33.6154,38.8878 C31.0794,40.8938 28.0824,42.5698 24.7154,43.8658 L24.7154,43.8658 L24.3684,43.9998 L23.8874,43.9998 L23.5324,43.8658 C0.2514,34.9048 4.2424,11.8658 4.2854,11.6348 L4.2854,11.6348 L4.4964,10.4988 L5.5854,10.1138 C17.1264,6.0348 21.4694,4.5938 23.3214,4.1648 L23.3214,4.1648 L23.3064,4.1228 C23.4944,4.0538 23.6554,3.9938 23.9884,4.0108 L23.9884,4.0108 L23.9974,3.9998 Z M37.4727,18.8184 L37.4727,24.8174 L43.4727,24.8174 L43.4727,25.8174 C43.4727,27.4744 42.1297,28.8174 40.4727,28.8174 L40.4727,28.8174 L37.4727,28.8174 L37.4727,31.8184 C37.4727,33.4754 36.1297,34.8184 34.4727,34.8184 L34.4727,34.8184 L33.4727,34.8184 L33.4727,28.8174 L27.4727,28.8174 L27.4727,27.8174 C27.4727,26.1614 28.8157,24.8174 30.4727,24.8174 L30.4727,24.8174 L33.4727,24.8174 L33.4727,21.8184 C33.4727,20.1614 34.8157,18.8184 36.4727,18.8184 L36.4727,18.8184 L37.4727,18.8184 Z M23.4724,21.9971 L23.4724,22.9971 C23.4724,24.6531 22.1294,25.9971 20.4724,25.9971 L20.4724,25.9971 L13.4194,25.9971 C12.8674,25.9971 12.4194,25.5501 12.4194,24.9971 L12.4194,24.9971 L12.4194,22.9971 C12.4194,22.4441 12.8674,21.9971 13.4194,21.9971 L13.4194,21.9971 L23.4724,21.9971 Z M29.4727,15.9971 L29.4727,16.9971 C29.4727,18.6531 28.1297,19.9971 26.4727,19.9971 L26.4727,19.9971 L13.1237,19.9971 C12.5717,19.9971 12.1237,19.5501 12.1237,18.9971 L12.1237,18.9971 L12.1237,16.9971 C12.1237,16.4441 12.5717,15.9971 13.1237,15.9971 L13.1237,15.9971 L29.4727,15.9971 Z",
  id: "Combined-Shape",
  fill: "#000000"
}))), 'products');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ProductsOutline = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "m15.9982667 2.66653333.1746666.00733334c.1776-.01066667.2818134.01365333.3805654.04770133l.0741013.02696533-.01.028c1.2122182.2808 4.0252641 1.21195637 11.4090674 3.81941035l.4149326.14658965.726.25666667.1406667.75733333c.016.088.228 1.27466667.2086666 3.08133337-.0135333 1.3552666-1.6069007 2.0452089-2.6079757 1.1942314l-.1013576-.0935648c.0793333-1.264.0306667-2.30599997-.0293333-2.95466663-4.5666667-1.608-9.4646667-3.28133334-10.6953334-3.61266667-1.232.332-6.1353333 2.00666667-10.7033333 3.61533333-.28933333 2.84199997-.466 12.91533337 10.7033333 17.54399997 1.1126667-.4613333 2.1473334-.994 3.0966667-1.59.753125-.4725 1.7130859-.4235156 2.3827515.1376148l.1299152.1190519.7186666.718c0 .0046667-.0006666.006-.0006666.01-1.5606154 1.2344615-3.3831006 2.2814675-5.4197397 3.1148002l-.5135937.2038665-.2313333.0893333h-.3206667l-.2366666-.0893333c-15.36546003-5.91426-12.91139523-21.02708523-12.83296215-21.47817636l.00162878-.00915701.14066667-.75733333.726-.25666667c7.5541091-2.66989091 10.4824621-3.64448529 11.7549887-3.94972439l.0690113-.01627561-.01-.028c.1002667-.0368.1890133-.06976.3341653-.07566933l.1205014.00100267zm8.9835333 9.87906667v3.9993333h4v.6666667c0 1.0544545-.8157893 1.9181736-1.8507256 1.9945148l-.1492744.0054852h-2v2.0006667c0 1.0544545-.8157893 1.9181735-1.8507256 1.9945148l-.1492744.0054852h-.6666667v-4.0006667h-4v-.6666667c0-1.0538181.8157893-1.9181157 1.8507256-1.9945109l.1492744-.0054891h2v-1.9993333c0-1.0544545.8157893-1.9181736 1.8507256-1.9945148l.1492744-.0054852zm-9.3335333 2.1191333v.6666667c0 1.104-.8953334 2-2 2h-4.70200003c-.368 0-.66666667-.298-.66666667-.6666667v-1.3333333c0-.3686667.29866667-.6666667.66666667-.6666667zm4.0002-4v.6666667c0 1.0538182-.8157893 1.9181157-1.8507256 1.9945109l-.1492744.0054891h-8.89933337c-.33454545 0-.61179063-.246281-.65943401-.5680441l-.00723265-.0986226v-1.3333333c0-.3351515.24683195-.6119008.56819434-.659449l.09847232-.0072177z",
  transform: "translate(8 8)"
}))), 'ProductsOutline');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ClaimsOutline = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "m18.6689333 20.6287333v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0-7.962v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0 4v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0-7.99999997v.66666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.37333333.3-.66666667.6666667-.66666667zm-6.6686666 3.99999997v.6666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.3733333.3-.6666667.66666667-.6666667zm0 4v.6666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.3733333.3-.6666667.66666667-.6666667zm0-7.99999997v.66666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.37333333.3-.66666667.66666667-.66666667zm14.6666666 1.33333337h-4v-2.00000003c0-1.10733334.9-2 2-2 1.1066667 0 2 .89266666 2 2zm-6.6666666-2.00000003v18.00000003h-14.6666667v-18.00000003c0-1.10733334.9-2 2-2h13.12c-.2866667.60666666-.4533333 1.28-.4533333 2zm4.6666666-4.66666667h-17.3333333c-2.57333333 0-4.66666667 2.09266667-4.66666667 4.66666667v20.66666663h19.99999997v-16h5.3333334c.7393333 0 1.3333333-.6 1.3333333-1.3333333v-3.33333333c0-2.574-2.094-4.66666667-4.6666667-4.66666667z",
  transform: "translate(8 8)"
}))), 'ClaimsOutline');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var SupportOutline = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "m10.6674667 10.5636667c0-.73600003.5973333-1.33333337 1.3333333-1.33333337.7366667 0 1.3333333.59733334 1.3333333 1.33333337 0 .736-.5966666 1.3333333-1.3333333 1.3333333-.736 0-1.3333333-.5973333-1.3333333-1.3333333zm7.882 0c0-.73600003.5966666-1.33333337 1.3333333-1.33333337.736 0 1.3333333.59733334 1.3333333 1.33333337 0 .736-.5973333 1.3333333-1.3333333 1.3333333-.7366667 0-1.3333333-.5973333-1.3333333-1.3333333zm-7.7333334 5.576c-.2606666-.26-.2606666-.682 0-.9426667l.9426667-.9426667c.26-.26.682-.26.9426667 0l.4713333.4713334c1.562 1.562 4.0946667 1.562 5.6566667 0l.4713333-.4713334c.2606667-.26.6826667-.26.9426667 0l.9426666.9426667c.2606667.2606667.2606667.6826667 0 .9426667l-.4713333.4713333c-1.2993333 1.3-3.006 1.95-4.714 1.95-1.7073333 0-3.414-.65-4.7133333-1.95zm15.8513334 5.0906666h-17.6086667c-.17666667 0-.34666667.07-.47133333.1953334l-3.252 3.2513333.00066666-18.01066667h21.33133337zm2-17.23066663h-25.33133337c-.368 0-.66666666.29933333-.66666666.66666666l-.00266667 21.62199997c0 1.782 2.154 2.6746667 3.414 1.414l3.806-3.8053333h18.7806667c.368 0 .6666666-.298.6666666-.6666667v-18.56399997c0-.36733333-.2986666-.66666666-.6666666-.66666666z",
  transform: "translate(8 8)"
}))), 'SupportOutline');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var RewardsOutline = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "m26.667 14.9495333h-9.3333333v-2.6666666h9.3333333zm-9.3333333 12h6.6666666v-9.3333333h-6.6666666zm-9.33333337 0h6.66666667v-9.3333333h-6.66666667zm-2.66666666-12h9.33333333v-2.6666666h-9.33333333zm4.10666666-9.1073333c.08333334-.12733333.35666667-.466.88866667-.466.1433333 0 .3053333.02466667.4873333.08466667 1.5093334.49733333 2.346 1.89 2.7833334 2.978-1.378-.00733334-3.1313334-.25733334-3.99133337-1.22666667-.56933333-.642-.27266666-1.21133333-.168-1.37zm11.61399997-.42266667c.182-.06.344-.08466666.4873334-.08466666.5313333 0 .8046666.33933333.888.46533333.1046666.16.402.728-.168 1.37066667-.86.96933333-2.6126667 1.21866666-3.9913334 1.22666666.4373334-1.08866666 1.274-2.48066666 2.784-2.978zm8.2793334 6.19666667c0-1.1046667-.8953334-2-2-2h-3.824c.266-.2.5193333-.41933333.7466666-.676 1.178-1.328 1.3393334-3.178.4013334-4.60466667-.9546667-1.45266666-2.6966667-2.02266666-4.4373334-1.44866666-2.3326666.768-3.6133333 2.658-4.2946666 4.20933333-.6866667-1.54333333-1.964-3.40666667-4.276-4.168-1.74000003-.57533333-3.48200003-.00333333-4.43800003 1.44933333-.93733334 1.42533334-.776 3.276.40133333 4.604.21066667.23733334.442.446.68533333.63466667h-3.63133333c-1.10466667 0-2 .8953333-2 2v6h2.66666667v10c0 1.1046667.89533333 2 2 2h17.33333333c1.104 0 2-.8953333 2-2v-10h2.6666667z",
  transform: "translate(8 8)"
}))), 'RewardsOutline');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ChatOutline = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "m24.0007301 0c13.2546433 0 23.9995899 10.4201375 23.9995899 23.2731249 0 12.8529875-10.7449466 23.2739203-23.9995899 23.2739203-13.2554635 0-24.0004101-10.4209328-24.0004101-23.2739203 0-12.8529874 10.7449466-23.2731249 24.0004101-23.2731249zm0 2.42424242c-11.8744552 0-21.5004101 9.33447968-21.5004101 20.84888248 0 11.5145802 9.6261378 20.8496778 21.5004101 20.8496778 11.8735657 0 21.4995899-9.3352078 21.4995899-20.8496778 0-11.5142926-9.6258413-20.84888248-21.4995899-20.84888248z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "m16.0816 3.87480625c6.6646667 0 12.068 5.23383333 12.068 11.69087505 0 6.4680208-5.4066667 11.7050833-12.0753333 11.7050833h-10.07400003c-1.10466667 0-2-.8673542-2-1.9375v-9.7604792c0-6.46027082 5.406-11.69797915 12.07533333-11.69797915zm0 2.58333333c-5.194 0-9.41466667 4.08877082-9.41466667 9.11464582v9.1146459h9.40733337c5.188 0 9.4086666-4.0887709 9.4086666-9.1146459 0-5.0291041-4.2173333-9.11464582-9.4013333-9.11464582zm-.0233333 7.64989582c.89 0 1.5873333.6755417 1.5873333 1.5377292s-.6973333 1.5377292-1.5873333 1.5377292-1.5873334-.6755417-1.5873334-1.5377292c0-.8473333.712-1.5377292 1.5873334-1.5377292zm-5.0793334 0c.8893334 0 1.5866667.6755417 1.5866667 1.5377292s-.6973333 1.5377292-1.5866667 1.5377292c-.89 0-1.58799997-.6755417-1.58799997-1.5377292 0-.8473333.71266667-1.5377292 1.58799997-1.5377292zm10.1593334 0c.8893333 0 1.5873333.6755417 1.5873333 1.5377292s-.698 1.5377292-1.5873333 1.5377292c-.8753334 0-1.588-.68975-1.588-1.5377292 0-.8473333.7126666-1.5377292 1.588-1.5377292z",
  transform: "translate(8 7.757576)"
}))), 'ChatOutline');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var CallOutline = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "m24.0007301 0c13.2546433 0 23.9995899 10.4201375 23.9995899 23.2731249 0 12.8529875-10.7449466 23.2739203-23.9995899 23.2739203-13.2554635 0-24.0004101-10.4209328-24.0004101-23.2739203 0-12.8529874 10.7449466-23.2731249 24.0004101-23.2731249zm0 2.42424242c-11.8744552 0-21.5004101 9.33447968-21.5004101 20.84888248 0 11.5145802 9.6261378 20.8496778 21.5004101 20.8496778 11.8735657 0 21.4995899-9.3352078 21.4995899-20.8496778 0-11.5142926-9.6258413-20.84888248-21.4995899-20.84888248z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "m7.01546667 11.881525c.016.0600625.51666666 1.8438542 2.186 3.832375.83866663 1.0094375 3.80200003 4.4504375 6.86533333 6.5655417 2.0566667 1.426 3.706 1.9278125 3.7226667 1.9316875l.1306666.0465c1.0893334.445625 1.782.2370208 1.8113334.2279791l.0813333-.0264791c.5753333-.1614584 1.1913333-.6154792 1.724-1.0281667.6393333-.5089167 1.176-.995875 1.624-1.4737917-.524-.5702708-1.6586667-1.6094166-2.228-2.0556875-.1113333-.0865416-.226-.1788958-.34-.2706041-.1873333-.1524167-.3673333-.2970834-.54-.4172084l-.0166667.0161459c-.128.1246458-.282.3035416-.45.4953541-.7573333.8667084-1.3073333 1.44925-2.026 1.6481667-1.3913333.4546667-3.5573333-1.2651875-3.7993333-1.4628125-1.424-1.13925-3.4386667-2.9495208-4.3966667-4.2805833-1.1533333-1.5965-1.74666663-2.6918334-1.4193333-3.6412084.194-.6296875.7913333-1.1631458 1.6786667-1.9006875.2006666-.16662497.3873333-.31904163.516-.44368747.006-.00645833.0126666-.01227083.0186666-.01808333-.1853333-.25704167-.42-.52247917-.648-.7808125l-.0626666-.07104167c-.458-.54766666-1.51933337-1.63525-2.13000003-2.15708333-.51733334.44045833-1.01933334.96229167-1.50666667 1.5635625-.42466667.51408333-.882 1.09597917-1.058 1.64558333l-.016.05425c-.054.18083337-.198.84604167.21733333 1.82189587zm14.22200003 15.2410208c-.618 0-1.4026667-.1059166-2.2953334-.4617708-.3953333-.1246458-2.2213333-.7511042-4.4253333-2.2791458-3.338-2.3049792-6.49933333-5.9733125-7.38866667-7.0421667-1.85933333-2.2158542-2.53066666-4.2482917-2.67133333-4.7300833-.60333333-1.4653959-.48933333-2.6285417-.32866667-3.27695837v-.0174375l.05333334-.17695833c.304-1.01266667.95466666-1.8541875 1.54-2.56202083.67933333-.83829167 1.404-1.56679167 2.14533333-2.1564375.78666667-.6103125 1.522-.59804167 2.002-.48179167l.214.07104167c1.1506667.49147916 3.416 3.11420833 3.4373333 3.1406875.3206667.36166666.6673334.75304166.9606667 1.19479166.2786667.3468125.4453333.72333334.4966667 1.12052084.1813333.98941663-.5453334 1.63977083-.8553334 1.91747913l-.098.089125c-.166.1608125-.4046666.3616667-.664.577375-.2033333.1692084-.5326666.4423959-.7466666.6497084.1193333.2415416.3733333.6716666.916 1.4227708.674.9358125 2.248 2.4522292 3.9386666 3.80525.3666667.298375 1.02.6878125 1.412.8583125.2113334-.2027917.4973334-.5295833.6713334-.7297917.2226666-.2531666.43-.4876041.5986666-.651l.088-.089125c.296-.3041875.992-1.0165416 2.0626667-.8215l.1206667.0277709c.3366666.0936458.6153333.248.8393333.3713541.4233333.25575.7373333.5089167 1.0413333.7543334.1.081375.2006667.1621041.3026667.2415416.032.0251875 2.7426667 2.2223125 3.248 3.3357292l.0786667.2292708c.242 1.0158959-.3113334 1.6849792-.4933334 1.9045625-.618.7046042-1.3366666 1.3749792-2.222 2.0795834-.738.5722083-1.5953333 1.1935-2.6233333 1.491875-.1946667.0639375-.6733333.1931041-1.3553333.1931041z",
  transform: "translate(8 7.757576)"
}))), 'CallOutline');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var CallDualTone = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  id: "icon-call-dual-tone"
}, /*#__PURE__*/React__default.createElement("circle", {
  cx: "24",
  cy: "24",
  fill: "#e87722",
  r: "24"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M10.5232,18.3972 C10.5472,18.4902 11.2982,21.2522 13.8022,24.3312 C15.0602,25.8942 19.5052,31.2222 24.1002,34.4972 C27.1852,36.7052 29.6592,37.4822 29.6842,37.4882 L29.8802,37.5602 C31.5142,38.2502 32.5532,37.9272 32.5972,37.9132 L32.7192,37.8722 C33.5822,37.6222 34.5062,36.9192 35.3052,36.2802 C36.2642,35.4922 37.0692,34.7382 37.7412,33.9982 C36.9552,33.1152 35.2532,31.5062 34.3992,30.8152 C34.2322,30.6812 34.0602,30.5382 33.8892,30.3962 C33.6082,30.1602 33.3382,29.9362 33.0792,29.7502 L33.0542,29.7752 C32.8622,29.9682 32.6312,30.2452 32.3792,30.5422 C31.2432,31.8842 30.4182,32.7862 29.3402,33.0942 C27.2532,33.7982 24.0042,31.1352 23.6412,30.8292 C21.5052,29.0652 18.4832,26.2622 17.0462,24.2012 C15.3162,21.7292 14.4262,20.0332 14.9172,18.5632 C15.2082,17.5882 16.1042,16.7622 17.4352,15.6202 C17.7362,15.3622 18.0162,15.1262 18.2092,14.9332 C18.2182,14.9232 18.2282,14.9142 18.2372,14.9052 C17.9592,14.5072 17.6072,14.0962 17.2652,13.6962 L17.1712,13.5862 C16.4842,12.7382 14.8922,11.0542 13.9762,10.2462 C13.2002,10.9282 12.4472,11.7362 11.7162,12.6672 C11.0792,13.4632 10.3932,14.3642 10.1292,15.2152 L10.1052,15.2992 C10.0242,15.5792 9.8082,16.6092 10.4312,18.1202 L10.5232,18.3972 Z M31.8562,41.9962 C30.9292,41.9962 29.7522,41.8322 28.4132,41.2812 C27.8202,41.0882 25.0812,40.1182 21.7752,37.7522 C16.7682,34.1832 12.0262,28.5032 10.6922,26.8482 C7.9032,23.4172 6.8962,20.2702 6.6852,19.5242 C5.7802,17.2552 5.9512,15.4542 6.1922,14.4502 L6.1922,14.4232 L6.2722,14.1492 C6.7282,12.5812 7.7042,11.2782 8.5822,10.1822 C9.6012,8.8842 10.6882,7.7562 11.8002,6.8432 C12.9802,5.8982 14.0832,5.9172 14.8032,6.0972 L15.1242,6.2072 C16.8502,6.9682 20.2482,11.0292 20.2802,11.0702 C20.7612,11.6302 21.2812,12.2362 21.7212,12.9202 C22.1392,13.4572 22.3892,14.0402 22.4662,14.6552 C22.7382,16.1872 21.6482,17.1942 21.1832,17.6242 L21.0362,17.7622 C20.7872,18.0112 20.4292,18.3222 20.0402,18.6562 C19.7352,18.9182 19.2412,19.3412 18.9202,19.6622 C19.0992,20.0362 19.4802,20.7022 20.2942,21.8652 C21.3052,23.3142 23.6662,25.6622 26.2022,27.7572 C26.7522,28.2192 27.7322,28.8222 28.3202,29.0862 C28.6372,28.7722 29.0662,28.2662 29.3272,27.9562 C29.6612,27.5642 29.9722,27.2012 30.2252,26.9482 L30.3572,26.8102 C30.8012,26.3392 31.8452,25.2362 33.4512,25.5382 L33.6322,25.5812 C34.1372,25.7262 34.5552,25.9652 34.8912,26.1562 C35.5262,26.5522 35.9972,26.9442 36.4532,27.3242 C36.6032,27.4502 36.7542,27.5752 36.9072,27.6982 C36.9552,27.7372 41.0212,31.1392 41.7792,32.8632 L41.8972,33.2182 C42.2602,34.7912 41.4302,35.8272 41.1572,36.1672 C40.2302,37.2582 39.1522,38.2962 37.8242,39.3872 C36.7172,40.2732 35.4312,41.2352 33.8892,41.6972 C33.5972,41.7962 32.8792,41.9962 31.8562,41.9962 L31.8562,41.9962 Z",
  fill: "#fff"
}))), "callDualTone");

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var LinkOutLine = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "m15.5292667 5.91913333-.472.47133334 8.39 8.38933333h-19.44733337v2.6666667h19.44866667l-8.3906667 8.3913333.4713334.4706667c.7806666.7813333 2.0473333.7813333 2.828 0l10.1946666-10.1946667-10.1946666-10.19466667c-.7813334-.78066666-2.0473334-.78066666-2.828 0",
  transform: "translate(8 8)"
}))), 'LinkOutLine');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ArrowUp = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Arrow-Up",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M38.463,21.293 L23.17,6 L7.879,21.293 C6.707,22.464 6.707,24.364 7.879,25.535 L8.586,26.242 L21.17,13.658 L21.17,41.829 C21.17,42.381 21.617,42.829 22.17,42.829 L24.17,42.829 C24.722,42.829 25.17,42.381 25.17,41.829 L25.17,13.657 L37.756,26.242 L38.463,25.535 C39.634,24.364 39.634,22.464 38.463,21.293",
  id: "Arrow-Up",
  fill: "currentColor"
}))), 'ArrowUp');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ArrowDown = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Arrow-Down",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M37.7555,22.5864 L25.1695,35.1714 L25.1695,6.0004 L21.1695,6.0004 L21.1695,35.1714 L8.5855,22.5864 L7.8785,23.2934 C6.7065,24.4644 6.7065,26.3644 7.8785,27.5354 L23.1695,42.8284 L38.4625,27.5354 C39.6335,26.3644 39.6335,24.4644 38.4625,23.2934 L37.7555,22.5864 Z",
  id: "Arrow-Down",
  fill: "#333333"
}))), 'ArrowDown');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ArrowLeft = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Arrow-Left",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M41.8281,22.1695 L12.6571,22.1695 L25.2421,9.5855 L24.5351,8.8785 C23.3641,7.7075 21.4641,7.7075 20.2931,8.8785 L5.0001,24.1705 L20.2931,39.4635 C21.4641,40.6345 23.3641,40.6345 24.5351,39.4635 L25.2421,38.7565 L12.6551,26.1695 L41.8281,26.1695 L41.8281,22.1695 Z",
  id: "Arrow-Left",
  fill: "#333333"
}))), 'ArrowLeft');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ChevronUp = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Chevron-Up",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M38.75725,34.243 L24.17125,19.658 L9.58525,34.243 L8.87825,33.536 C7.70725,32.365 7.70725,30.465 8.87825,29.294 L24.17125,14 L39.46425,29.294 C40.63525,30.465 40.63525,32.365 39.46425,33.536 L38.75725,34.243 Z",
  id: "Chevron-Up",
  fill: "#333333"
}))), 'chevron-up');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ChevronRight = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Chevron-Right",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M14.707,39.46425 L14,38.75725 L28.586,24.17125 L14,9.58525 L14.707,8.87825 C15.878,7.70725 17.778,7.70725 18.949,8.87825 L34.242,24.17125 L18.949,39.46425 C17.778,40.63525 15.878,40.63525 14.707,39.46425",
  id: "Chevron-Right",
  fill: "#333333"
}))), 'chevron-right');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ChevronDown = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Chevron-Down",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M23.1714,34.2425 L7.8784,18.9495 C6.7074,17.7775 6.7074,15.8785 7.8784,14.7065 L8.5854,13.9995 L23.1714,28.5855 L37.7574,13.9995 L38.4644,14.7065 C39.6354,15.8785 39.6354,17.7775 38.4644,18.9495 L23.1714,34.2425 Z",
  id: "Chevron-Down",
  fill: "#333333"
}))), 'chevron-down');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ChevronLeft = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Chevron-Left",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M29.293,39.46425 L14,24.17125 L29.293,8.87825 C30.464,7.70725 32.364,7.70725 33.535,8.87825 L34.242,9.58525 L19.656,24.17125 L34.242,38.75725 L33.535,39.46425 C32.364,40.63525 30.464,40.63525 29.293,39.46425",
  id: "Chevron-Left",
  fill: "#333333"
}))), 'chevron-left');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Tick = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Tick",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M15.3701,37.044 L6.0001,27.673 L6.7071,26.966 C7.8791,25.795 9.7781,25.795 10.9491,26.966 L15.3701,31.387 L35.8791,10.878 C37.0501,9.707 38.9501,9.707 40.1211,10.878 L40.8281,11.586 L15.3701,37.044 Z",
  id: "Tick"
}))), 'Tick');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var TickCircle = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Tick-Circle",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M35.4141,17.3721 L19.9561,32.8301 L12.5861,25.4601 L13.2931,24.7531 C14.4651,23.5811 16.3631,23.5811 17.5351,24.7531 L19.9561,27.1731 L30.4651,16.6651 C31.6361,15.4941 33.5351,15.4941 34.7071,16.6651 L35.4141,17.3721 Z M24.0001,40.0001 C15.1781,40.0001 8.0001,32.8221 8.0001,24.0001 C8.0001,15.1781 15.1781,8.0001 24.0001,8.0001 C32.8221,8.0001 40.0001,15.1781 40.0001,24.0001 C40.0001,32.8221 32.8221,40.0001 24.0001,40.0001 L24.0001,40.0001 Z M24.0001,4.0001 C12.9721,4.0001 4.0001,12.9721 4.0001,24.0001 C4.0001,35.0281 12.9721,44.0001 24.0001,44.0001 C35.0281,44.0001 44.0001,35.0281 44.0001,24.0001 C44.0001,12.9721 35.0281,4.0001 24.0001,4.0001 L24.0001,4.0001 Z",
  id: "Tick-Circle",
  fill: "#333333"
}))), 'TickCircle');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var CloseCircle = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Close-Circle",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M33.4433,17.3852 L26.8283,24.0002 L33.4433,30.6152 L32.7363,31.3222 C31.5653,32.4932 29.6653,32.4932 28.4943,31.3222 L24.0003,26.8282 L19.5063,31.3222 C18.3353,32.4932 16.4353,32.4932 15.2643,31.3222 L14.5573,30.6152 L21.1723,24.0002 L14.5573,17.3852 L15.2643,16.6782 C16.4353,15.5072 18.3353,15.5072 19.5063,16.6782 L24.0003,21.1722 L28.4943,16.6782 C29.6653,15.5072 31.5653,15.5072 32.7363,16.6782 L33.4433,17.3852 Z M4.0003,24.0002 C4.0003,35.0282 12.9723,44.0002 24.0003,44.0002 C35.0283,44.0002 44.0003,35.0282 44.0003,24.0002 C44.0003,12.9722 35.0283,4.0002 24.0003,4.0002 C12.9723,4.0002 4.0003,12.9722 4.0003,24.0002 Z",
  id: "Icon",
  fill: "#183028"
}), /*#__PURE__*/React__default.createElement("rect", {
  id: "Rectangle",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}))), 'CloseCircle');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Menu = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Menu",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M4.0001,35 L4.0001,37 C4.0001,37.552 4.4481,38 5.0001,38 L25.0001,38 C26.6571,38 28.0001,36.657 28.0001,35 L28.0001,34 L5.0001,34 C4.4481,34 4.0001,34.448 4.0001,35 M43.0001,22 L5.0001,22 C4.4481,22 4.0001,22.448 4.0001,23 L4.0001,25 C4.0001,25.552 4.4481,26 5.0001,26 L43.0001,26 C43.5521,26 44.0001,25.552 44.0001,25 L44.0001,23 C44.0001,22.448 43.5521,22 43.0001,22 M4.0001,13 L4.0001,11 C4.0001,10.448 4.4481,10 5.0001,10 L35.0001,10 C35.5521,10 36.0001,10.448 36.0001,11 L36.0001,13 C36.0001,13.552 35.5521,14 35.0001,14 L5.0001,14 C4.4481,14 4.0001,13.552 4.0001,13",
  id: "Menu",
  fill: "#333333"
}))), 'Menu');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Business = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Business",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M20,12 L16,12 L16,9 C16,7.343 17.343,6 19,6 L29,6 C30.657,6 32,7.343 32,9 L32,12 L28,12 L28,10 L20,10 L20,12 Z M22,29.951 L18.951,29.951 C18.398,29.951 17.951,29.503 17.951,28.951 L17.951,26.951 C17.951,26.398 18.398,25.951 18.951,25.951 L22,25.951 L22,22.901 C22,22.349 22.447,21.901 23,21.901 L25,21.901 C25.553,21.901 26,22.349 26,22.901 L26,25.951 L29.05,25.951 C29.603,25.951 30.05,26.398 30.05,26.951 L30.05,28.951 C30.05,29.503 29.603,29.951 29.05,29.951 L26,29.951 L26,33 C26,33.552 25.553,34 25,34 L23,34 C22.447,34 22,33.552 22,33 L22,29.951 Z M8,38 L40,38 L40,18 L8,18 L8,38 Z M41,14 L7,14 C5.343,14 4,15.344 4,17 L4,39 C4,40.657 5.343,42 7,42 L41,42 C42.657,42 44,40.657 44,39 L44,17 C44,15.344 42.657,14 41,14 L41,14 Z",
  id: "Business",
  fill: "#333333"
}))), 'Business');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Account = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Account",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M41.9995,40 L41.9995,41 C41.9995,42.657 40.6565,44 38.9995,44 L37.9995,44 L37.9995,40 C37.9995,34.478 33.5215,30 27.9995,30 L19.9995,30 C14.4775,30 9.9995,34.478 9.9995,40 L9.9995,44 L8.9995,44 C7.3435,44 5.9995,42.657 5.9995,41 L5.9995,40 C5.9995,32.268 12.2685,26 19.9995,26 L27.9995,26 C35.7315,26 41.9995,32.268 41.9995,40 M23.9995,8 C27.3085,8 29.9995,10.691 29.9995,14 C29.9995,17.309 27.3085,20 23.9995,20 C20.6905,20 17.9995,17.309 17.9995,14 C17.9995,10.691 20.6905,8 23.9995,8 M23.9995,24 C29.5135,24 33.9995,19.514 33.9995,14 C33.9995,8.486 29.5135,4 23.9995,4 C18.4855,4 13.9995,8.486 13.9995,14 C13.9995,19.514 18.4855,24 23.9995,24",
  id: "Account",
  fill: "#333333"
}))), 'Account');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Location = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Location",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M24,23.999 C21.794,23.999 20,22.205 20,19.999 C20,17.794 21.794,16 24,16 C26.205,16 27.999,17.794 27.999,19.999 C27.999,22.205 26.205,23.999 24,23.999 M24,12 C19.589,12 16,15.588 16,19.999 C16,24.41 19.589,27.999 24,27.999 C28.411,27.999 31.999,24.41 31.999,19.999 C31.999,15.588 28.411,12 24,12 M24,39.3076 C19.741,35.3136 12,26.6736 12,19.9986 C12,13.3826 17.383,7.9996 24,7.9996 C30.616,7.9996 35.999,13.3826 35.999,19.9986 C35.999,26.6736 28.259,35.3136 24,39.3076 M24,3.9996 C15.178,3.9996 8,11.1766 8,19.9986 C8,30.7946 22.098,43.0026 22.698,43.5176 L24,44.6326 L25.302,43.5176 C25.901,43.0026 39.999,30.7946 39.999,19.9986 C39.999,11.1766 32.822,3.9996 24,3.9996",
  id: "Fill-1",
  fill: "#333333"
}))), 'Location');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Time = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Time",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M4.1021,26.0481 C2.8401,13.4151 13.4151,2.8401 26.0481,4.1031 C35.3991,5.0371 42.9631,12.6011 43.8971,21.9521 C45.1601,34.5841 34.5841,45.1601 21.9521,43.8971 C12.6011,42.9631 5.0371,35.3991 4.1021,26.0481 Z M39.8671,26.0851 C41.1961,15.6341 32.3661,6.8051 21.9151,8.1331 C14.7911,9.0381 9.0381,14.7911 8.1331,21.9151 C6.8041,32.3651 15.6341,41.1951 26.0851,39.8671 C33.2091,38.9621 38.9621,33.2091 39.8671,26.0851 Z M21.002,12.0005016 L22.002,12.0015016 C23.659,12.0015016 25.002,13.3455016 25.002,15.0015016 L25,23.0635016 L32.413,30.4755016 L31.706,31.1825016 C30.534,32.3535016 28.635,32.3535016 27.463,31.1825016 L21,24.7195016 L21.002,12.0005016 Z",
  id: "Combined-Shape",
  fill: "#333333"
}))), 'Time');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Alert = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Alert",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M40,24 C40,15.178 32.822,8 24,8 C15.178,8 8,15.178 8,24 C8,32.822 15.178,40 24,40 C32.822,40 40,32.822 40,24 M44,24 C44,35.028 35.028,44 24,44 C12.972,44 4,35.028 4,24 C4,12.972 12.972,4 24,4 C35.028,4 44,12.972 44,24 M24.602,12 L23.399,12 C21.595,12 20.198,13.581 20.422,15.372 L22.001,28 L26,28 L27.579,15.372 C27.803,13.581 26.406,12 24.602,12 M26.001,32.918 L26.001,34.999 C26.001,35.551 25.554,35.999 25.001,35.999 L23.001,35.999 C22.448,35.999 22.001,35.551 22.001,34.999 L22.001,31.918 L25.001,31.918 C25.554,31.918 26.001,32.366 26.001,32.918",
  id: "Alert",
  fill: "#333333"
}))), 'Alert');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Direction = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Direction",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M15.123,22.75 L31.998,15.998 L25.249,32.875 C24.88,33.799 23.536,33.675 23.34,32.7 L22,25.999 L15.298,24.659 C14.323,24.464 14.199,23.119 15.123,22.75 M24,39.999 C15.178,39.999 8,32.822 8,24 C8,15.177 15.178,8 24,8 C32.822,8 40,15.177 40,24 C40,32.822 32.822,39.999 24,39.999 M24,4 C12.972,4 4,12.972 4,24 C4,35.027 12.972,43.999 24,43.999 C35.028,43.999 44,35.027 44,24 C44,12.972 35.028,4 24,4",
  id: "Direction",
  fill: "#333333"
}))), 'Direction');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var DropdownIcon = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Drop-Down",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M12.5855,21.2426 L23.1715,10.6576 L33.7575,21.2426 L34.4645,20.5356 C35.6365,19.3646 35.6365,17.4646 34.4645,16.2936 L23.1715,4.9996 L11.8785,16.2936 C10.7065,17.4646 10.7065,19.3646 11.8785,20.5356 L12.5855,21.2426 Z M34.4645,27.1216 C35.6365,28.2926 35.6365,30.1926 34.4645,31.3636 L23.1715,42.6576 L11.8785,31.3636 C10.7065,30.1926 10.7065,28.2926 11.8785,27.1216 L12.5855,26.4146 L23.1715,36.9996 L33.7575,26.4146 L34.4645,27.1216 Z",
  id: "Drop-Down",
  fill: "#333333"
}))), 'Dropdown');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Bookmark = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Bookmark",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M24,26.5791 L34,36.5791 L34,10.0001 L14,10.0001 L14,36.5791 L24,26.5791 Z M32.879,41.1151 L24,32.2361 L15.121,41.1151 C13.231,43.0051 10,41.6661 10,38.9941 L10,9.0001 C10,7.3431 11.343,6.0001 13,6.0001 L35,6.0001 C36.657,6.0001 38,7.3431 38,9.0001 L38,38.9941 C38,41.6661 34.769,43.0051 32.879,41.1151 L32.879,41.1151 Z",
  id: "Bookmark",
  fill: "#333333"
}))), 'Bookmark');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var PlayButton = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Play",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M0,24 C0,37.2336 10.7664,48 24,48 C37.2336,48 48,37.2336 48,24 C48,10.7664 37.2336,0 24,0 C10.7664,0 0,10.7664 0,24 Z",
  id: "Circle",
  fill: "#000000"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M18.7620269,32.86948 C17.9516895,33.2753638 17,32.6854306 17,31.7785912 L17.0048742,16.2197133 C17.0048742,15.3140927 17.9577822,14.7253784 18.7681196,15.1300433 L34.3265974,22.9100917 C35.2246705,23.358636 35.2246705,24.6421063 34.3253788,25.0906505 L18.7620269,32.86948 Z",
  id: "Play",
  fill: "#FFFFFF"
}))), 'PlayButton');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Document = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Document",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M12,40 L36,40 L36,8 L12,8 L12,40 Z M40,7 L40,41 C40,42.657 38.657,44 37,44 L11,44 C9.343,44 8,42.657 8,41 L8,7 C8,5.343 9.343,4 11,4 L37,4 C38.657,4 40,5.343 40,7 L40,7 Z M17,34 L23,34 C24.657,34 26,32.657 26,31 L26,30 L17,30 C16.448,30 16,30.448 16,31 L16,33 C16,33.552 16.448,34 17,34 L17,34 Z M17,18 L31,18 C31.552,18 32,17.552 32,17 L32,15 C32,14.448 31.552,14 31,14 L17,14 C16.448,14 16,14.448 16,15 L16,17 C16,17.552 16.448,18 17,18 L17,18 Z M16,25 L16,23 C16,22.448 16.448,22 17,22 L31,22 C31.552,22 32,22.448 32,23 L32,25 C32,25.552 31.552,26 31,26 L17,26 C16.448,26 16,25.552 16,25 L16,25 Z",
  id: "Document",
  fill: "#333333"
}))), 'Document');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var DocumentCertifiedCopy = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Document-Certified-Copy",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M25.9967,25.9998 L18.9967,25.9998 C18.4447,25.9998 17.9967,26.4478 17.9967,26.9998 L17.9967,28.9998 C17.9967,29.5528 18.4447,29.9998 18.9967,29.9998 L22.9967,29.9998 C24.6537,29.9998 25.9967,28.6568 25.9967,26.9998 L25.9967,25.9998 Z M18.9967,17.9998 C18.4447,17.9998 17.9967,18.4478 17.9967,18.9998 L17.9967,20.9998 C17.9967,21.5528 18.4447,21.9998 18.9967,21.9998 L28.9967,21.9998 C29.5487,21.9998 29.9967,21.5528 29.9967,20.9998 L29.9967,18.9998 C29.9967,18.4478 29.5487,17.9998 28.9967,17.9998 L18.9967,17.9998 Z M29.0087,6.9998 C29.0087,5.3438 27.6657,3.9998 26.0087,3.9998 L7.9997,3.9998 C6.3437,3.9998 4.9997,5.3438 4.9997,6.9998 L4.9997,33.0008 C4.9997,34.6568 6.3437,36.0008 7.9997,36.0008 L8.9997,36.0008 L8.9997,7.9998 L29.0087,7.9998 L29.0087,6.9998 Z M23.9967,40.0008 L14.9957,40.0008 L14.9957,13.9998 L33.0047,13.9998 L33.0047,25.0008 C33.0047,25.5528 33.4527,26.0008 34.0047,26.0008 L36.0047,26.0008 C36.5567,26.0008 37.0047,25.5528 37.0047,25.0008 L37.0047,12.9998 C37.0047,11.3428 35.6617,9.9998 34.0047,9.9998 L13.9957,9.9998 C12.3387,9.9998 10.9957,11.3428 10.9957,12.9998 L10.9957,41.0008 C10.9957,42.6568 12.3387,44.0008 13.9957,44.0008 L23.9967,44.0008 C24.5487,44.0008 24.9967,43.5528 24.9967,43.0008 L24.9967,41.0008 C24.9967,40.4478 24.5487,40.0008 23.9967,40.0008 L23.9967,40.0008 Z M43.0047,29.9448 L31.5907,41.3588 L26.1757,35.9438 L26.8827,35.2368 C28.0537,34.0658 29.9537,34.0658 31.1247,35.2368 L31.5907,35.7028 L38.0547,29.2378 C39.2267,28.0658 41.1257,28.0658 42.2977,29.2378 L43.0047,29.9448 Z",
  id: "Document-Certified-Copy",
  fill: "#333333"
}))), 'DocumentCertifiedCopy');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var DocumentCopy = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Document-Copy",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M18.129,40.001 L36.138,40.001 L36.138,14.001 L18.129,14.001 L18.129,40.001 Z M40.138,13.001 L40.138,41.001 C40.138,42.658 38.794,44.001 37.138,44.001 L17.129,44.001 C15.472,44.001 14.129,42.658 14.129,41.001 L14.129,13.001 C14.129,11.343 15.472,10.001 17.129,10.001 L37.138,10.001 C38.794,10.001 40.138,11.343 40.138,13.001 L40.138,13.001 Z M22.13,30 L30.13,30 C31.787,30 33.13,28.657 33.13,27 L33.13,26 L22.13,26 C21.578,26 21.13,26.448 21.13,27 L21.13,29 C21.13,29.552 21.578,30 22.13,30 L22.13,30 Z M22.13,22 L32.13,22 C32.682,22 33.13,21.552 33.13,21 L33.13,19 C33.13,18.448 32.682,18 32.13,18 L22.13,18 C21.578,18 21.13,18.448 21.13,19 L21.13,21 C21.13,21.552 21.578,22 22.13,22 L22.13,22 Z M32.009,8 L12,8 L12,36.001 L11,36.001 C9.343,36.001 8,34.657 8,33.001 L8,7 C8,5.342 9.343,4 11,4 L29.009,4 C30.666,4 32.009,5.342 32.009,7 L32.009,8 Z",
  id: "Document-Copy",
  fill: "#333333"
}))), 'DocumentCopy');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var AvailableOnline = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Available-Online",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M22.1196,20.9707 L22.9746,35.2147 C23.0186,35.9567 23.8286,36.3927 24.4726,36.0217 L28.2676,33.8297 L30.7676,38.1597 C31.0436,38.6387 31.6556,38.8027 32.1336,38.5267 L33.8656,37.5267 C34.3446,37.2497 34.5076,36.6387 34.2316,36.1597 L31.7316,31.8297 L35.5266,29.6397 C36.1706,29.2677 36.1976,28.3487 35.5776,27.9387 L23.6686,20.0757 C22.9806,19.6217 22.0706,20.1477 22.1196,20.9707 M40.9996,34.9997 L35.9996,34.9997 L35.9996,33.9997 C35.9996,32.3427 37.3426,30.9997 38.9996,30.9997 L39.9996,30.9997 L39.9996,12.9997 L7.9996,12.9997 L7.9996,30.9997 L16.9996,30.9997 C18.6566,30.9997 19.9996,32.3427 19.9996,33.9997 L19.9996,34.9997 L6.9996,34.9997 C5.3436,34.9997 3.9996,33.6577 3.9996,31.9997 L3.9996,11.9997 C3.9996,10.3427 5.3436,8.9997 6.9996,8.9997 L40.9996,8.9997 C42.6566,8.9997 43.9996,10.3427 43.9996,11.9997 L43.9996,31.9997 C43.9996,33.6577 42.6566,34.9997 40.9996,34.9997",
  id: "Available-Online",
  fill: "#333333"
}))), 'AvailableOnline');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var LiveChat = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Live-Chat",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M16.0012,15.8455 C16.0012,14.7415 16.8972,13.8455 18.0012,13.8455 C19.1062,13.8455 20.0012,14.7415 20.0012,15.8455 C20.0012,16.9495 19.1062,17.8455 18.0012,17.8455 C16.8972,17.8455 16.0012,16.9495 16.0012,15.8455 L16.0012,15.8455 Z M27.8242,15.8455 C27.8242,14.7415 28.7192,13.8455 29.8242,13.8455 C30.9282,13.8455 31.8242,14.7415 31.8242,15.8455 C31.8242,16.9495 30.9282,17.8455 29.8242,17.8455 C28.7192,17.8455 27.8242,16.9495 27.8242,15.8455 L27.8242,15.8455 Z M16.2242,24.2095 C15.8332,23.8195 15.8332,23.1865 16.2242,22.7955 L17.6382,21.3815 C18.0282,20.9915 18.6612,20.9915 19.0522,21.3815 L19.7592,22.0885 C22.1022,24.4315 25.9012,24.4315 28.2442,22.0885 L28.9512,21.3815 C29.3422,20.9915 29.9752,20.9915 30.3652,21.3815 L31.7792,22.7955 C32.1702,23.1865 32.1702,23.8195 31.7792,24.2095 L31.0722,24.9165 C29.1232,26.8665 26.5632,27.8415 24.0012,27.8415 C21.4402,27.8415 18.8802,26.8665 16.9312,24.9165 L16.2242,24.2095 Z M40.0012,31.8455 L13.5882,31.8455 C13.3232,31.8455 13.0682,31.9505 12.8812,32.1385 L8.0032,37.0155 L8.0042,9.9995 L40.0012,9.9995 L40.0012,31.8455 Z M43.0012,5.9995 L5.0042,5.9995 C4.4522,5.9995 4.0042,6.4485 4.0042,6.9995 L4.0002,39.4325 C4.0002,42.1055 7.2312,43.4445 9.1212,41.5535 L14.8302,35.8455 L43.0012,35.8455 C43.5532,35.8455 44.0012,35.3985 44.0012,34.8455 L44.0012,6.9995 C44.0012,6.4485 43.5532,5.9995 43.0012,5.9995 L43.0012,5.9995 Z",
  id: "Live-Chat",
  fill: "#333333"
}))), 'LiveChat');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Feedback = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Feedback",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M16.0016,10.1716 L16.0006,11.1716 C16.0006,12.8286 14.6586,14.1716 13.0006,14.1716 L13.0006,14.1716 L8.0036,14.1716 L8.0026,37.3366 L12.8806,32.4586 C13.0686,32.2706 13.3226,32.1666 13.5876,32.1666 L13.5876,32.1666 L23.1736,32.1666 L20.5876,29.5806 L21.2946,28.8736 C22.4666,27.7016 24.3656,27.7016 25.5376,28.8736 L25.5376,28.8736 L30.8296,34.1666 L25.5366,39.4586 C24.3646,40.6306 22.4656,40.6306 21.2936,39.4586 L21.2936,39.4586 L20.5866,38.7526 L23.1726,36.1666 L14.8296,36.1666 L9.1206,41.8746 C7.2306,43.7646 3.9996,42.4256 3.9996,39.7526 L3.9996,39.7526 L4.0036,11.1716 C4.0036,10.6186 4.4516,10.1716 5.0036,10.1716 L5.0036,10.1716 L16.0016,10.1716 Z M24.466,6.8784 C25.637,5.7064 27.537,5.7064 28.709,6.8784 L28.709,6.8784 L29.415,7.5854 L26.829,10.1714 L43.001,10.1714 C43.553,10.1714 44.001,10.6184 44.001,11.1714 L44.001,11.1714 L44.001,35.1664 C44.001,35.7184 43.553,36.1664 43.001,36.1664 L43.001,36.1664 L34.001,36.1664 L34.001,35.1654 C34.002,33.5094 35.345,32.1664 37.001,32.1664 L37.001,32.1664 L40.001,32.1664 L40.001,14.1714 L26.829,14.1714 L29.415,16.7574 L28.709,17.4644 C27.537,18.6354 25.637,18.6354 24.466,17.4644 L24.466,17.4644 L19.173,12.1714 Z",
  id: "Feedback",
  fill: "#333333"
}))), 'Feedback');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Investment = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Investment",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M10.6847,21.9999 L17.3167,21.9999 C18.9737,21.9999 20.3167,20.6569 20.3167,18.9999 L20.3167,17.9999 L10.6847,17.9999 C10.1327,17.9999 9.6847,18.4469 9.6847,18.9999 L9.6847,20.9999 C9.6847,21.5529 10.1327,21.9999 10.6847,21.9999 M10.6847,15.9999 L17.3167,15.9999 C18.9737,15.9999 20.3167,14.6569 20.3167,12.9999 L20.3167,11.9999 L10.6847,11.9999 C10.1327,11.9999 9.6847,12.4469 9.6847,12.9999 L9.6847,14.9999 C9.6847,15.5529 10.1327,15.9999 10.6847,15.9999 M22.9997,9.9999 L28.9997,9.9999 C30.6567,9.9999 31.9997,8.6569 31.9997,6.9999 L31.9997,5.9999 L22.9997,5.9999 C22.4477,5.9999 21.9997,6.4469 21.9997,6.9999 L21.9997,8.9999 C21.9997,9.5529 22.4477,9.9999 22.9997,9.9999 M22.9997,15.9999 L28.9997,15.9999 C30.6567,15.9999 31.9997,14.6569 31.9997,12.9999 L31.9997,11.9999 L22.9997,11.9999 C22.4477,11.9999 21.9997,12.4469 21.9997,12.9999 L21.9997,14.9999 C21.9997,15.5529 22.4477,15.9999 22.9997,15.9999 M22.9997,21.9999 L28.9997,21.9999 C30.6567,21.9999 31.9997,20.6569 31.9997,18.9999 L31.9997,17.9999 L22.9997,17.9999 C22.4477,17.9999 21.9997,18.4469 21.9997,18.9999 L21.9997,20.9999 C21.9997,21.5529 22.4477,21.9999 22.9997,21.9999 M6.9997,26.0029 L4.9997,26.0029 C4.4477,26.0029 3.9997,26.4509 3.9997,27.0029 L3.9997,38.9999 C3.9997,40.6569 5.3427,41.9999 6.9997,41.9999 L7.9997,41.9999 L7.9997,27.0029 C7.9997,26.4509 7.5527,26.0029 6.9997,26.0029 M42.8987,28.3969 L34.1767,41.1299 C33.8037,41.6749 33.1857,41.9999 32.5267,41.9999 L10.6847,41.9999 C10.1327,41.9999 9.6847,41.5529 9.6847,40.9999 L9.6847,37.9999 L31.4717,37.9999 L39.6517,26.0599 C39.6927,25.9999 39.7367,25.9419 39.7837,25.8879 C40.0877,25.5319 40.0677,24.9939 39.7367,24.6629 C39.4967,24.4229 39.2367,24.4059 39.0687,24.3989 C38.9307,24.4039 38.6737,24.4459 38.4567,24.6669 L30.9617,34.6709 C30.5837,35.1749 29.9917,35.4719 29.3617,35.4719 L24.0687,35.4719 L22.5057,35.4719 L17.2377,35.4719 L17.2377,34.4719 C17.2377,32.8139 18.5807,31.4719 20.2377,31.4719 L22.5057,31.4719 L24.0687,31.4719 C24.4737,31.4719 24.8027,31.1429 24.8027,30.7369 C24.8027,30.3319 24.4737,30.0029 24.0687,30.0029 L9.6847,30.0029 L9.6847,29.0029 C9.6847,27.3459 11.0277,26.0029 12.6847,26.0029 L24.0687,26.0029 C26.6787,26.0029 28.8027,28.1269 28.8027,30.7369 C28.8027,30.7939 28.7887,30.8479 28.7867,30.9039 L35.3137,22.1919 C35.3437,22.1519 35.3747,22.1129 35.4077,22.0759 C36.2967,21.0579 37.5817,20.4469 38.9337,20.4019 C40.2877,20.3599 41.6087,20.8779 42.5647,21.8349 C44.3357,23.6059 44.4727,26.4649 42.8987,28.3969",
  id: "Investment",
  fill: "#333333"
}))), 'Investment');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var NoResultIcon = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/No-Result",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M40.707,37.9961 L34.901,32.1901 C33.73,31.0181 31.83,31.0181 30.659,32.1901 L29.952,32.8971 L37.879,40.8241 C38.269,41.2151 38.902,41.2151 39.293,40.8241 L40.707,39.4101 C41.098,39.0191 41.098,38.3871 40.707,37.9961 M30,20.0001 C30,14.4861 25.514,10.0001 20,10.0001 C14.486,10.0001 10,14.4861 10,20.0001 C10,25.5141 14.486,30.0001 20,30.0001 C25.514,30.0001 30,25.5141 30,20.0001 M34,20.0001 C34,27.7201 27.72,34.0001 20,34.0001 C12.28,34.0001 6,27.7201 6,20.0001 C6,12.2801 12.28,6.0001 20,6.0001 C27.72,6.0001 34,12.2801 34,20.0001 M20.009,12.9531 C17.142,12.9531 15.642,14.9911 15.642,17.0061 C15.642,17.3661 15.684,17.8261 15.75,18.0591 L18.328,18.0591 C18.282,17.9231 18.245,17.5761 18.245,17.3391 C18.245,16.4311 18.707,15.3701 20.009,15.3701 C21.203,15.3701 21.737,16.1451 21.737,16.9141 C21.737,17.4551 21.486,17.9131 20.989,18.2771 L20.101,18.9441 C19.083,19.7121 18.588,20.6231 18.588,21.7301 C18.588,22.0281 18.68,22.6141 18.68,22.6141 L20.912,22.6141 L20.912,22.3791 C20.912,21.6841 21.213,21.1451 21.859,20.6831 L22.619,20.1451 C23.89,19.2421 24.507,18.1361 24.507,16.7651 C24.507,14.8701 22.962,12.9531 20.009,12.9531 M21.431,25.1761 C21.431,26.0521 20.71,26.7641 19.824,26.7641 C18.933,26.7641 18.234,26.0661 18.234,25.1761 C18.234,24.2901 18.948,23.5691 19.824,23.5691 C20.71,23.5691 21.431,24.2901 21.431,25.1761",
  id: "No-Result",
  fill: "currentColor"
}))), 'NoResult');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var CategoryTier = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Category-Tier",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M10,34 L38,34 L38,30 L10,30 L10,34 Z M41,26 L7,26 C6.45,26 6,26.44 6,27 L6,37 C6,37.55 6.45,38 7,38 L41,38 C41.56,38 42,37.55 42,37 L42,27 C42,26.44 41.56,26 41,26 L41,26 Z M15,10 C14.448,10 14,10.448 14,11 L14,13 C14,13.55 14.45,14 15,14 L31,14 C32.657,14 34,12.657 34,11 L34,10 L15,10 Z M11,18 C10.448,18 10,18.448 10,19 L10,21 C10,21.55 10.45,22 11,22 L35,22 C36.657,22 38,20.657 38,19 L38,18 L11,18 Z",
  id: "Category-Tier",
  fill: "#333333"
}))), 'CategoryTier');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Warning = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M44,24 C44,35.028 35.028,44 24,44 C12.972,44 4,35.028 4,24 C4,12.972 12.972,4 24,4 C35.028,4 44,12.972 44,24 M24.602,12 L23.399,12 C21.595,12 20.198,13.581 20.422,15.372 L22.001,28 L26,28 L27.579,15.372 C27.803,13.581 26.406,12 24.602,12 M26.001,32.918 L26.001,34.999 C26.001,35.551 25.554,35.999 25.001,35.999 L23.001,35.999 C22.448,35.999 22.001,35.551 22.001,34.999 L22.001,31.918 L25.001,31.918 C25.554,31.918 26.001,32.366 26.001,32.918",
  fill: "#B30909"
}))), 'Warning');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var InfoFilled = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M44,24 C44,35.028 35.028,44 24,44 C12.972,44 4,35.028 4,24 C4,12.972 12.972,4 24,4 C35.028,4 44,12.972 44,24 M25,20 L23,20 C22.447,20 22,20.447 22,21 L22,35 C22,35.552 22.447,36 23,36 L25,36 C25.552,36 26,35.552 26,35 L26,21 C26,20.447 25.552,20 25,20 M26,13 L26,15 C26,15.552 25.553,16 25,16 L22,16 L22,13 C22,12.447 22.448,12 23,12 L25,12 C25.553,12 26,12.447 26,13",
  fill: "#000000"
}))), 'InfoFilled');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var FWDLogo = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "m85.0647368 16.8813014c.2339474.2394642.3647369.553646.3647369.8886508 0 .332555-.1307895.6510239-.3647369.8898756l-6.2158772 6.1452248c-.2468421.2388517-.5728947.3680766-.9001754.3680766-.1633333 0-.3291228-.0275598-.4881579-.0967656-.472807-.1947559-.7810526-.6516363-.7810526-1.1593492v-12.2922871c0-.5107751.3082456-.9664306.7810526-1.1648613.4771053-.1929186 1.0229825-.0839043 1.3883333.2737608z",
  fill: "#e87722"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "m46.1005263.88926316c-.7386842.59467942-1.2642982 1.29898564-1.5903509 2.12026794-.3242105.81699522-.6821929 2.00390431-1.1009649 3.56991388l-.3278947 1.22855502-4.0403509 15.8530144-4.708421-20.27789478c-.4003509-1.93776077-1.4890351-3.13385646-4.1846492-3.13385646h-28.77491224c-1.32263158 0-1.36929825 1.39330143-1.37298246 1.4049378v32.86047844s.02210526.6987943.6981579.6987943h2.67350877c1.92008772 0 4.37438596-1.2346794 4.37438596-4.6398469v-10.0103349h10.07631577c3.8432456 0 4.7790351-2.7363828 4.7790351-4.2925933v-.5781436c0-.552421-.1872807-.8874258-.8553509-.8874258h-13.99999997v-8.29182776h19.79280697l5.9727193 22.93833496c.1829825.6865454 1.2280702 4.3164784 1.2280702 4.3164784.402193 1.2726508.3579825 1.4576077 1.4448246 1.4576077h2.4199123c2.9731579 0 3.9998245-1.8269091 4.5248245-3.1160957.2640351-.6987943.4513158-1.0062392.8756141-2.5820479l5.2659649-19.77385641 5.5699123 19.67525361c.1811403.6871579 1.1531578 4.331177 1.1531578 4.331177.400965 1.2683636.3604386 1.4631196 1.4478948 1.4631196h2.4174561c2.975 0 4.0035088-1.8287464 4.5291228-3.1258947.2572807-.6987943.5170176-1.3669665.943772-2.9391005l5.4753508-22.62537798h16.9547369c1.4577193 0 2.6311403.12677512 3.6878947.44585646 1.3668421.40972249 2.5826316 1.43188517 3.5970176 3.03157892.9824561 1.5684594 1.5442982 4.3146412 1.5700877 7.725933-.0018421 3.8448996-1.155 7.2580288-3.2967544 9.1026986-.4771053.429933-1.0371053.7631005-1.7008772 1.0062392-.6766667.2486508-1.330614.4054354-1.9507895.4679043-.6680701.0698182-1.5522807.2045551-2.7152631.2143541h-.016579l-3.6977193.0061244h-5.3120175l-.0264035-.0061244c-1.1488597 0-1.1850877.6651101-1.1850877.9517321v1.3755406c0 2.0014546 1.6566666 4.3023924 4.9835087 4.3023924h.1148246l6.4535088-.0036747c1.6425438-.0165358 3.116228-.1365741 4.4370175-.3613397 1.3281579-.2308899 2.5783333-.6106028 3.7419298-1.1624115 1.1635965-.5444593 2.2381579-1.2671387 3.2163158-2.1588516 1.236053-1.1562871 2.244912-2.4632345 3.031491-3.9245168.777369-1.4618947 1.350877-3.0903732 1.711316-4.8829856.340175-1.6927847.509035-2.8974546.509035-4.9050335v-.0422584c-.056491-6.5010526-1.982719-11.1225263-5.8210525-14.34886123-1.4718421-1.26713875-3.1303509-2.13435406-4.9540351-2.58817225-1.6947368-.42564593-3.6958772-.63448803-5.9825439-.63448803h-20.5419298c-1.1273684.0122488-2.8165789.59222966-3.4662281 3.23858373l-4.4566666 20.14744498-4.7366667-15.79850718v.01163636l-.3180702-1.1642488c-.4568421-1.68421053-.8252631-2.89316747-1.0991228-3.62380862-.2757017-.72880382-.7607894-1.40371292-1.4736842-2.02778947-.7024561-.61856459-1.6965789-.92784689-2.9731579-.92784689-1.2661403 0-2.258421.29519617-2.9909649.88926316",
  fill: "#183028"
})), 'FWDLogo');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Team = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/team",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M13.5071,13.0501 C14.6241,13.0501 15.5331,13.9591 15.5331,15.0771 C15.5331,16.1941 14.6241,17.1031 13.5071,17.1031 C12.3901,17.1031 11.4811,16.1941 11.4811,15.0771 C11.4811,13.9591 12.3901,13.0501 13.5071,13.0501 M13.5071,21.1541 C16.8581,21.1541 19.5841,18.4271 19.5841,15.0771 C19.5841,11.7261 16.8581,9.0001 13.5071,9.0001 C10.1561,9.0001 7.4311,11.7261 7.4311,15.0771 C7.4311,18.4271 10.1561,21.1541 13.5071,21.1541 M40.7981,39.3721 L40.7971,39.3721 C40.2841,39.3771 39.8431,38.9981 39.7891,38.4891 C39.3611,34.4911 36.0931,31.2791 32.1401,31.2791 L27.2791,31.2791 C23.3221,31.2791 20.0541,34.4961 19.6291,38.4971 C19.5761,39.0031 19.1391,39.3811 18.6301,39.3811 L18.6261,39.3811 C16.8121,39.3811 15.5221,37.6321 16.0321,35.8921 C16.6641,33.7411 17.8631,31.8331 19.4471,30.3581 C18.9571,28.5691 17.0881,27.2291 14.8501,27.2291 L12.1471,27.2291 C9.8621,27.2291 7.9501,28.6221 7.5101,30.4681 C7.3981,30.9371 7.0041,31.2791 6.5231,31.2791 L6.5151,31.2791 C4.6541,31.2791 3.4031,29.2881 4.2931,27.6541 C5.7371,25.0031 8.7151,23.1791 12.1471,23.1791 L14.8501,23.1791 C18.4741,23.1791 21.5911,25.2141 22.9321,28.1101 C24.2781,27.5481 25.7431,27.2291 27.2791,27.2291 L32.1401,27.2291 C37.4361,27.2291 41.9251,30.8931 43.3861,35.8561 C43.8991,37.6001 42.6151,39.3561 40.7981,39.3721 M29.7091,13.0521 C31.9431,13.0521 33.7601,14.8681 33.7601,17.1031 C33.7601,19.3361 31.9431,21.1541 29.7091,21.1541 C27.4761,21.1541 25.6591,19.3361 25.6591,17.1031 C25.6591,14.8681 27.4761,13.0521 29.7091,13.0521 M29.7091,25.2031 C34.1761,25.2031 37.8111,21.5701 37.8111,17.1031 C37.8111,12.6351 34.1761,9.0011 29.7091,9.0011 C25.2421,9.0011 21.6081,12.6351 21.6081,17.1031 C21.6081,21.5701 25.2421,25.2031 29.7091,25.2031",
  id: "Fill-1",
  fill: "#000000"
}))), 'Team');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var StepperPlus = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/StepperPlus",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("g", {
  id: "Molecule---CTA",
  transform: "translate(-928.000000, -2914.000000)"
}, /*#__PURE__*/React__default.createElement("g", {
  id: "Group-2-Copy",
  transform: "translate(928.000000, 2914.000000)"
}, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Bookmark",
  transform: "translate(4.000000, 4.000000)",
  fill: "#E87722"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M8.66666667,7.33333333 L8.66666667,3.66666667 C8.66666667,3.11433333 8.219,2.66666667 7.66666667,2.66666667 L7.33333333,2.66666667 L7.33333333,7.33333333 L3.66666667,7.33333333 C3.11433333,7.33333333 2.66666667,7.781 2.66666667,8.33333333 L2.66666667,8.66666667 L7.33333333,8.66666667 L7.33333333,12.3333333 C7.33333333,12.8856667 7.781,13.3333333 8.33333333,13.3333333 L8.66666667,13.3333333 L8.66666667,8.66666667 L12.3333333,8.66666667 C12.8856667,8.66666667 13.3333333,8.219 13.3333333,7.66666667 L13.3333333,7.33333333 L8.66666667,7.33333333 Z",
  id: "StepperPlus"
})), /*#__PURE__*/React__default.createElement("circle", {
  id: "Oval-Copy",
  stroke: "#E87722",
  cx: "12",
  cy: "12",
  r: "11.5"
}))))), 'stepperPlus');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var StepperMinus = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/StepperMinus",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("g", {
  id: "Molecule---CTA",
  transform: "translate(-856.000000, -2914.000000)"
}, /*#__PURE__*/React__default.createElement("g", {
  id: "Group-2-Copy-2",
  transform: "translate(856.000000, 2914.000000)"
}, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Bookmark",
  transform: "translate(4.000000, 4.000000)",
  fill: "#E87722"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M12.3334,8.6667 L2.66673333,8.6667 L2.66673333,8.33336667 C2.66673333,7.78103333 3.1144,7.33336667 3.66673333,7.33336667 L13.3334,7.33336667 L13.3334,7.6667 C13.3334,8.21903333 12.8854,8.6667 12.3334,8.6667",
  id: "StepperMinus"
})), /*#__PURE__*/React__default.createElement("circle", {
  id: "Oval-Copy",
  stroke: "#E87722",
  cx: "12",
  cy: "12",
  r: "11.5"
}))))), 'stepperMinus');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Magnifiying = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "m35.7574635 33.0557856.1440365.1350144 5.805 5.805c.3609231.3609231.3886864.9271953.0832899 1.3197105l-.0832899.0942895-1.413 1.414c-.3609231.3609231-.9288994.3886864-1.3208903.0832899l-.0941097-.0832899-7.926-7.927.706-.706c1.12512-1.12512 2.9202432-1.1701248 4.0989635-.1350144zm-14.7570635-26.0560856c7.72 0 14 6.28 14 14s-6.28 14-14 14-14-6.28-14-14 6.28-14 14-14zm0 4c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zm-1.0683 2.9722c1.657 0 3 1.343 3 3v2.186h5.186v1c0 1.657-1.343 3-3 3h-2.186v5.186h-1c-1.657 0-3-1.343-3-3v-2.186h-5.186v-1c0-1.657 1.343-3 3-3h2.186v-5.186z",
  fill: "currentColor",
  fillRule: "evenodd"
})), 'ZoomIn');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var SeeFull = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "m18.7065 32.1221c.391-.391.391-1.023 0-1.414l-1.414-1.414c-.391-.391-1.024-.391-1.414 0l-5.879 5.879v-7.173h-1c-1.656 0-3 1.343-3 3v11.001h11.005c1.657 0 3-1.343 3-3v-1h-7.176zm20.295-4.122h-1v7.173l-5.878-5.879c-.391-.391-1.024-.391-1.415 0l-1.414 1.414c-.39.391-.39 1.023 0 1.414l5.879 5.879h-7.176v1c0 1.657 1.343 3 3 3h11.004v-11.001c0-1.657-1.343-3-3-3zm-21.997-22h-11.005v11.001c0 1.657 1.344 3 3 3h1v-7.173l5.879 5.879c.39.391 1.023.391 1.414 0l1.414-1.414c.391-.391.391-1.024 0-1.414l-5.878-5.879h7.176v-1c0-1.657-1.343-3-3-3zm24.997 0v11.001c0 1.657-1.343 3-3 3h-1v-7.173l-5.878 5.879c-.391.391-1.024.391-1.415 0l-1.414-1.414c-.39-.391-.39-1.024 0-1.414l5.879-5.879h-7.176v-1c0-1.657 1.343-3 3-3z",
  fill: "currentColor",
  fillRule: "evenodd"
})), 'SeeFull');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var DoubleChevronUp = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Double-Chevron-Up",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M39.4644,26.5356 C40.6354,25.3646 40.6354,23.4646 39.4644,22.2936 L24.1714,6.9996 L8.8784,22.2936 C7.7074,23.4646 7.7074,25.3646 8.8784,26.5356 L9.5854,27.2426 L24.1714,12.6576 L38.7574,27.2426 L39.4644,26.5356 Z M38.7574,40.9496 L24.1714,26.3646 L9.5854,40.9496 L8.8784,40.2436 C7.7074,39.0716 7.7074,37.1716 8.8784,36.0006 L24.1714,20.7066 L39.4644,36.0006 C40.6354,37.1716 40.6354,39.0716 39.4644,40.2436 L38.7574,40.9496 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'DoubleChevronUp');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var DoubleChevronDown = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Double-Chevron-Down",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M38.7571,20.7072 L24.1711,35.2922 L9.5861,20.7072 L8.8791,21.4142 C7.7071,22.5852 7.7071,24.4852 8.8791,25.6562 L24.1711,40.9502 L39.4641,25.6562 C40.6361,24.4852 40.6361,22.5852 39.4641,21.4142 L38.7571,20.7072 Z M39.4641,7.7072 C40.6361,8.8782 40.6361,10.7782 39.4641,11.9492 L24.1711,27.2432 L8.8791,11.9492 C7.7071,10.7782 7.7071,8.8782 8.8791,7.7072 L9.5861,7.0002 L24.1711,21.5852 L38.7571,7.0002 L39.4641,7.7072 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'DoubleChevronDown');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var DoubleChevronLeft = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Double-Chevron-Left",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M27.2427,37.7574 L12.6577,23.1714 L27.2427,8.5854 L26.5357,7.8784 C25.3647,6.7074 23.4647,6.7074 22.2937,7.8784 L6.9997,23.1714 L22.2937,38.4644 C23.4647,39.6354 25.3647,39.6354 26.5357,38.4644 L27.2427,37.7574 Z M40.2427,38.4644 C39.0717,39.6354 37.1717,39.6354 36.0007,38.4644 L20.7067,23.1714 L36.0007,7.8784 C37.1717,6.7074 39.0717,6.7074 40.2427,7.8784 L40.9497,8.5854 L26.3647,23.1714 L40.9497,37.7574 L40.2427,38.4644 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'DoubleChevronLeft');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var DoubleChevronRight = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Double-Chevron-Right",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "m21.4143 38.4644c1.171 1.171 3.071 1.171 4.242 0l15.294-15.293-15.294-15.293c-1.171-1.171-3.071-1.171-4.242 0l-.707.707 14.585 14.586-14.585 14.586zm-14.414-.707 14.585-14.586-14.585-14.586.706-.707c1.172-1.171 3.072-1.171 4.243 0l15.294 15.293-15.294 15.293c-1.171 1.171-3.071 1.171-4.243 0z",
  id: "Fill-1",
  fill: "#333333"
}))), 'DoubleChevronRight');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var PlusCircle = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Plus-Circle",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M24.0001,6.0003 C33.9251,6.0003 42.0001,14.0753 42.0001,24.0003 C42.0001,33.9263 33.9251,42.0003 24.0001,42.0003 C14.0751,42.0003 6.0001,33.9263 6.0001,24.0003 C6.0001,14.0753 14.0751,6.0003 24.0001,6.0003 Z M24.0001,10.0003 C16.2801,10.0003 10.0001,16.2803 10.0001,24.0003 C10.0001,31.7203 16.2801,38.0003 24.0001,38.0003 C31.7201,38.0003 38.0001,31.7203 38.0001,24.0003 C38.0001,16.2803 31.7201,10.0003 24.0001,10.0003 Z M23.001,14.0003 C24.658,14.0003 26.001,15.3443 26.001,17.0003 L26.001,17.0003 L26.001,22.0003 L34,22.0003 L34,23.0003 C34,24.6573 32.657,26.0003 31,26.0003 L31,26.0003 L26.001,26.0003 L26.001,34.0003 L24.996,34.0003 C23.339,34.0003 22.001,32.6573 22.001,31.0003 L22.001,31.0003 L22.001,26.0003 L14,26.0003 L14,24.9953 C14,23.3393 15.343,22.0003 17,22.0003 L17,22.0003 L22.001,22.0003 L22.001,14.0003 Z",
  id: "Expand-Circle",
  fill: "#231F20"
}))), 'PlusCircle');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var MinusCircle = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Minus-Circle",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M23.9999,5.9999 C33.9299,5.9999 41.9999,14.0699 41.9999,23.9999 C41.9999,33.9299 33.9299,41.9999 23.9999,41.9999 C14.0799,41.9999 5.9999,33.9299 5.9999,23.9999 C5.9999,14.0699 14.0799,5.9999 23.9999,5.9999 Z M23.9999,9.9999 C16.2799,9.9999 9.9999,16.2799 9.9999,23.9999 C9.9999,31.7199 16.2799,37.9999 23.9999,37.9999 C31.7199,37.9999 37.9999,31.7199 37.9999,23.9999 C37.9999,16.2799 31.7199,9.9999 23.9999,9.9999 Z M33.9999,21.9999 L33.9999,22.9999 C33.9999,24.6569 32.6569,25.9999 30.9999,25.9999 L14.0199,25.9999 L14.0199,24.9999 C14.0199,23.3429 15.3629,21.9999 17.0199,21.9999 L33.9999,21.9999 Z",
  id: "Collapse-Circle",
  fill: "#231F20"
}))), 'MinusCircle');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var LinkOut = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Link-out",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M15.414,8.9999 C13.757,8.9999 12.414,10.3429 12.414,11.9999 L12.414,12.9999 L31.585,12.9999 L9,35.5849 L11.828,38.4129 L34.414,15.8279 L34.414,34.9909 L35.414,34.9909 C37.07,34.9909 38.414,33.6469 38.414,31.9909 L38.414,8.9999 L15.414,8.9999 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'LinkOut');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Announcements = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Announcements",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M32,30.5719 L24.385,27.5259 L15,27.5259 C11.141,27.5259 8,24.3849 8,20.5259 C8,16.6669 11.141,13.5259 15,13.5259 L24.385,13.5259 L32,10.4799 L32,30.5719 Z M31.886,6.2179 L23.615,9.5259 L15,9.5259 C8.584,9.5259 3.435,15.0469 4.05,21.5869 C4.586,27.2859 9.598,31.5259 15.322,31.5259 L23.615,31.5259 L31.886,34.8349 C33.856,35.6229 36,34.1719 36,32.0499 L36,9.0029 C36,6.8809 33.856,5.4289 31.886,6.2179 L31.886,6.2179 Z M39.1528,15.6373 C38.5508,15.5203 38.0008,16.0153 38.0008,16.6273 L38.0008,18.6753 C38.0008,19.0903 38.2378,19.4963 38.6318,19.6273 C39.4258,19.8933 39.9998,20.6443 39.9998,21.5263 C39.9998,22.4083 39.4258,23.1583 38.6318,23.4233 C38.2378,23.5553 38.0008,23.9613 38.0008,24.3763 L38.0008,26.4243 C38.0008,27.0363 38.5508,27.5323 39.1528,27.4143 C41.9118,26.8763 43.9998,24.4403 43.9998,21.5263 C43.9998,18.6123 41.9118,16.1753 39.1528,15.6373 M15.0005,33.526 L14.0005,33.526 L14.0005,40.526 C14.0005,41.079 14.4485,41.526 15.0005,41.526 L17.0005,41.526 C17.5525,41.526 18.0005,41.079 18.0005,40.526 L18.0005,36.526 C18.0005,34.869 16.6575,33.526 15.0005,33.526",
  id: "Fill-3",
  fill: "#333333"
}))), 'Announcements');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var BookmarkFilled = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Bookmark-Filled",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M34.9999,6 L12.9999,6 C11.3429,6 9.9999,7.343 9.9999,9 L9.9999,37.585 C9.9999,40.258 13.2309,41.597 15.1219,39.707 L23.9999,30.828 L32.8789,39.707 C34.7689,41.597 37.9999,40.259 37.9999,37.586 L37.9999,9 C37.9999,7.343 36.6569,6 34.9999,6",
  id: "Fill-1",
  fill: "#333333"
}))), 'BookmarkFilled');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Contact = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Contact",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M42.0001,30.0267 C42.0001,31.1217 41.1121,32.0087 40.0181,32.0087 L38.0351,32.0087 L38.0351,24.0347 L40.0191,24.0357 C41.1131,24.0357 42.0001,24.9227 42.0001,26.0177 L42.0001,30.0267 Z M10.0001,32.0087 L8.0181,32.0087 C6.9231,32.0087 6.0351,31.1217 6.0351,30.0267 L6.0351,26.0167 C6.0351,24.9227 6.9231,24.0347 8.0181,24.0347 L10.0001,24.0347 L10.0001,32.0087 Z M41.9491,20.3237 C41.0921,11.1807 33.3801,4.0007 24.0181,4.0007 C14.6551,4.0007 6.9431,11.1807 6.0861,20.3227 C3.7131,21.1307 2.0001,23.3747 2.0001,26.0167 L2.0001,30.0267 C2.0001,33.3497 4.6941,36.0447 8.0181,36.0447 L13.0351,36.0447 C13.5871,36.0447 14.0351,35.5957 14.0351,35.0447 L14.0351,20.9997 C14.0351,20.4467 13.5871,19.9997 13.0351,19.9997 L10.1981,19.9997 C11.1821,13.2447 16.9951,8.0357 24.0181,8.0357 C31.0401,8.0357 36.8541,13.2457 37.8371,19.9997 L35.0001,19.9997 C34.4471,19.9997 34.0001,20.4467 34.0001,20.9997 L34.0001,34.0267 C34.0001,37.3257 31.3251,40.0007 28.0261,40.0007 L28.0181,40.0007 L28.0181,39.0267 C28.0181,38.4737 27.5691,38.0267 27.0181,38.0267 L22.9961,38.0267 C21.3381,38.0267 19.9961,39.3697 19.9961,41.0267 L19.9961,43.0257 C19.9961,43.5787 20.4431,44.0257 20.9961,44.0257 L24.0061,44.0257 L24.0061,44.0357 L28.0261,44.0357 C32.8541,44.0357 36.8951,40.5987 37.8311,36.0447 L40.0181,36.0447 C43.3411,36.0447 46.0351,33.3497 46.0351,30.0267 L46.0351,26.0177 C46.0351,23.3757 44.3211,21.1307 41.9491,20.3237 L41.9491,20.3237 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'Contact');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var User = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/User",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M10,40 L38,40 C38,34.486 33.514,30 28,30 L20,30 C14.486,30 10,34.486 10,40 M39,44 L9,44 C7.343,44 6,42.657 6,41 L6,40 C6,32.268 12.268,26 20,26 L28,26 C35.732,26 42,32.268 42,40 L42,41 C42,42.657 40.657,44 39,44 M24,8 C20.691,8 18,10.691 18,14 C18,17.309 20.691,20 24,20 C27.309,20 30,17.309 30,14 C30,10.691 27.309,8 24,8 M24,24 C18.486,24 14,19.514 14,14 C14,8.486 18.486,4 24,4 C29.514,4 34,8.486 34,14 C34,19.514 29.514,24 24,24",
  id: "Fill-1",
  fill: "#333333"
}))), 'User');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var LockOpen = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Lock-Open",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M22,35 L26,35 L26,27 L22,27 L22,35 Z M37,39.0002 L11,39.0002 C10.448,39.0002 10,38.5522 10,38.0002 L10,23.0002 L14,23.0002 L32,23.0002 L38,23.0002 L38,38.0002 C38,38.5522 37.552,39.0002 37,39.0002 L37,39.0002 Z M18,19.0002 L18,9.0002 L30,9.0002 L30,12.0002 C30,13.6562 31.343,15.0002 33,15.0002 L34,15.0002 L34,5.0002 L14,5.0002 L14,19.0002 L6,19.0002 L6,40.0002 C6,41.6562 7.343,43.0002 9,43.0002 L39,43.0002 C40.657,43.0002 42,41.6562 42,40.0002 L42,19.0002 L18,19.0002 Z",
  id: "Fill-2",
  fill: "#333333"
}))), 'LockOpen');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Rewards = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Rewards",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M26,22.0037191 L40,22.0037191 L40,18.0007191 L26,18.0007191 L26,22.0037191 Z M26,40.0007191 L36,40.0007191 L36,26.0037191 L26,26.0037191 L26,40.0007191 Z M30.195,8.10571911 C30.412,8.03171911 30.604,8.00171911 30.773,8.00171911 C31.307,8.00171911 31.612,8.30971911 31.761,8.53071911 C32.058,8.96871911 32.164,9.68371911 31.57,10.3787191 C30.518,11.6077191 28.377,12.0167191 26.612,12.1037191 C27.207,10.5937191 28.297,8.75471911 30.195,8.10571911 L30.195,8.10571911 Z M8,22.0037191 L22,22.0037191 L22,18.0007191 L8,18.0007191 L8,22.0037191 Z M12,40.0007191 L22,40.0007191 L22,26.0037191 L12,26.0037191 L12,40.0007191 Z M16.239,8.53071911 C16.389,8.30971911 16.694,8.00171911 17.228,8.00171911 C17.396,8.00171911 17.588,8.03171911 17.804,8.10571911 C19.704,8.75471911 20.794,10.5937191 21.388,12.1037191 C19.624,12.0167191 17.483,11.6077191 16.431,10.3787191 C15.837,9.68371911 15.942,8.96871911 16.239,8.53071911 L16.239,8.53071911 Z M41,14.0007191 L33.51,14.0007191 C33.902,13.6987191 34.276,13.3677191 34.61,12.9787191 C36.279,11.0257191 36.464,8.33671911 35.071,6.28471911 C33.71,4.27671911 31.288,3.50471911 28.903,4.32071911 C26.591,5.10971911 25.041,6.74671911 24,8.43671911 C22.959,6.74671911 21.409,5.10971911 19.097,4.32071911 C16.712,3.50471911 14.291,4.27671911 12.929,6.28471911 C11.537,8.33671911 11.722,11.0267191 13.391,12.9787191 C13.724,13.3677191 14.098,13.6987191 14.49,14.0007191 L7,14.0007191 C5.343,14.0007191 4,15.3437191 4,17.0007191 L4,25.0037191 C4,25.5557191 4.448,26.0037191 5,26.0037191 L8,26.0037191 L8,41.0007191 C8,42.6567191 9.342,44.0007191 11,44.0007191 L37,44.0007191 C38.657,44.0007191 40,42.6567191 40,41.0007191 L40,26.0037191 L43,26.0037191 C43.552,26.0037191 44,25.5557191 44,25.0037191 L44,17.0007191 C44,15.3437191 42.657,14.0007191 41,14.0007191 L41,14.0007191 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'Rewards');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ZoomIn = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Zoom-in",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M27,20.0004 L27,22.0004 C27,22.5534 26.552,23.0004 26,23.0004 L23,23.0004 L23,25.9424 C23,26.4944 22.552,26.9424 22,26.9424 L20,26.9424 C19.448,26.9424 19,26.4944 19,25.9424 L19,23.0004 L16,23.0004 C15.448,23.0004 15,22.5534 15,22.0004 L15,20.0004 C15,19.4474 15.448,19.0004 16,19.0004 L19,19.0004 L19,16.0004 C19,15.4474 19.448,15.0004 20,15.0004 L22,15.0004 C22.552,15.0004 23,15.4474 23,16.0004 L23,19.0004 L26,19.0004 C26.552,19.0004 27,19.4474 27,20.0004 M41.707,40.2934 L40.293,41.7064 C39.902,42.0974 39.27,42.0974 38.879,41.7064 L33.707,36.5354 C32.536,35.3634 32.536,33.4644 33.707,32.2924 L34.414,31.5864 L41.707,38.8784 C42.098,39.2694 42.098,39.9024 41.707,40.2934 M21,31.0004 C15.486,31.0004 11,26.5144 11,21.0004 C11,15.4864 15.486,11.0004 21,11.0004 C26.514,11.0004 31,15.4864 31,21.0004 C31,26.5144 26.514,31.0004 21,31.0004 M21,7.0004 C13.28,7.0004 7,13.2804 7,21.0004 C7,28.7204 13.28,35.0004 21,35.0004 C28.72,35.0004 35,28.7204 35,21.0004 C35,13.2804 28.72,7.0004 21,7.0004",
  id: "Fill-1",
  fill: "#333333"
}))), 'ZoomIn');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ZoomOut = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Zoom-Out",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M20.9999,31.0004 C15.4859,31.0004 10.9999,26.5144 10.9999,21.0004 C10.9999,15.4864 15.4859,11.0004 20.9999,11.0004 C26.5139,11.0004 30.9999,15.4864 30.9999,21.0004 C30.9999,26.5144 26.5139,31.0004 20.9999,31.0004 M20.9999,7.0004 C13.2799,7.0004 6.9999,13.2804 6.9999,21.0004 C6.9999,28.7204 13.2799,35.0004 20.9999,35.0004 C28.7199,35.0004 34.9999,28.7204 34.9999,21.0004 C34.9999,13.2804 28.7199,7.0004 20.9999,7.0004 M41.707,38.8783 L34.414,31.5863 L33.707,32.2923 C32.536,33.4643 32.536,35.3633 33.707,36.5353 L38.879,41.7063 C39.269,42.0973 39.902,42.0973 40.293,41.7063 L41.707,40.2933 C42.098,39.9023 42.098,39.2693 41.707,38.8783 M25.9999,19.0004 L15.9999,19.0004 C15.4479,19.0004 14.9999,19.4474 14.9999,20.0004 L14.9999,22.0004 C14.9999,22.5534 15.4479,23.0004 15.9999,23.0004 L25.9999,23.0004 C26.5519,23.0004 26.9999,22.5534 26.9999,22.0004 L26.9999,20.0004 C26.9999,19.4474 26.5519,19.0004 25.9999,19.0004",
  id: "Fill-6",
  fill: "#333333"
}))), 'ZoomOut');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Fax = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Fax",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M39.9998,36.9998 C39.9998,37.5528 39.5518,37.9998 38.9998,37.9998 L8.9998,37.9998 C8.4478,37.9998 7.9998,37.5528 7.9998,36.9998 L7.9998,24.9998 C7.9998,24.4478 8.4478,23.9998 8.9998,23.9998 L11.9998,23.9998 L11.9998,26.9998 C11.9998,27.5528 12.4478,27.9998 12.9998,27.9998 L34.9998,27.9998 C35.5528,27.9998 35.9998,27.5528 35.9998,26.9998 L35.9998,23.9998 L38.9998,23.9998 C39.5518,23.9998 39.9998,24.4478 39.9998,24.9998 L39.9998,36.9998 Z M15.9998,19.9998 L15.9998,10.9998 C15.9998,10.4478 16.4478,9.9998 16.9998,9.9998 L31.9998,9.9998 L31.9998,19.9998 L31.9998,23.9998 L15.9998,23.9998 L15.9998,19.9998 Z M40.9998,19.9998 L35.9998,19.9998 L35.9998,6.9998 C35.9998,6.4478 35.5528,5.9998 34.9998,5.9998 L14.9998,5.9998 C13.3428,5.9998 11.9998,7.3438 11.9998,8.9998 L11.9998,19.9998 L6.9998,19.9998 C5.3428,19.9998 3.9998,21.3438 3.9998,22.9998 L3.9998,38.9998 C3.9998,40.6568 5.3428,41.9998 6.9998,41.9998 L40.9998,41.9998 C42.6558,41.9998 43.9998,40.6568 43.9998,38.9998 L43.9998,22.9998 C43.9998,21.3438 42.6558,19.9998 40.9998,19.9998 L40.9998,19.9998 Z M11.9998,31.9998 C10.8958,31.9998 9.9998,32.8958 9.9998,33.9998 C9.9998,35.1038 10.8958,35.9998 11.9998,35.9998 C13.1038,35.9998 13.9998,35.1038 13.9998,33.9998 C13.9998,32.8958 13.1038,31.9998 11.9998,31.9998 M17.9993,19.9998 L17.9993,21.9998 L23.5993,21.9998 C24.6433,21.9998 25.5223,21.1628 25.8533,19.9998 C25.9423,19.6858 25.9993,19.3528 25.9993,18.9998 L25.9993,17.9998 L17.9993,17.9998 L17.9993,19.9998 Z M17.9993,15.9998 L26.9993,15.9998 C28.6563,15.9998 29.9993,14.6568 29.9993,12.9998 L29.9993,11.9998 L17.9993,11.9998 L17.9993,15.9998 Z",
  id: "Fill-7",
  fill: "#333333"
}))), 'Fax');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Mobile = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Mobile",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M33.9999,29.9998 L13.9999,29.9998 L13.9999,8.9998 C13.9999,8.4478 14.4479,7.9998 14.9999,7.9998 L32.9999,7.9998 C33.5519,7.9998 33.9999,8.4478 33.9999,8.9998 L33.9999,29.9998 Z M25.9999,36.9998 C25.9999,38.1038 25.1039,38.9998 23.9999,38.9998 C22.8959,38.9998 21.9999,38.1038 21.9999,36.9998 C21.9999,35.8958 22.8959,34.9998 23.9999,34.9998 C25.1039,34.9998 25.9999,35.8958 25.9999,36.9998 M33.9999,38.9998 C33.9999,39.5528 33.5519,39.9998 32.9999,39.9998 L14.9999,39.9998 C14.4479,39.9998 13.9999,39.5528 13.9999,38.9998 L13.9999,33.9998 L33.9999,33.9998 L33.9999,38.9998 Z M34.9999,3.9998 L12.9999,3.9998 C11.3429,3.9998 9.9999,5.3438 9.9999,6.9998 L9.9999,40.9998 C9.9999,42.6568 11.3429,43.9998 12.9999,43.9998 L34.9999,43.9998 C36.6569,43.9998 37.9999,42.6568 37.9999,40.9998 L37.9999,6.9998 C37.9999,5.3438 36.6569,3.9998 34.9999,3.9998 L34.9999,3.9998 Z",
  id: "Fill-3",
  fill: "#333333"
}))), 'Mobile');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ShowMore = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Show-More",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M11.9999,24.00006 C11.9999,26.20906 10.2089,28.00006 7.9999,28.00006 C5.7909,28.00006 3.9999,26.20906 3.9999,24.00006 C3.9999,21.79106 5.7909,20.00006 7.9999,20.00006 C10.2089,20.00006 11.9999,21.79106 11.9999,24.00006 M27.9999,24.00006 C27.9999,26.20906 26.2089,28.00006 23.9999,28.00006 C21.7909,28.00006 19.9999,26.20906 19.9999,24.00006 C19.9999,21.79106 21.7909,20.00006 23.9999,20.00006 C26.2089,20.00006 27.9999,21.79106 27.9999,24.00006 M43.9999,24.00006 C43.9999,26.20906 42.2089,28.00006 39.9999,28.00006 C37.7909,28.00006 35.9999,26.20906 35.9999,24.00006 C35.9999,21.79106 37.7909,20.00006 39.9999,20.00006 C42.2089,20.00006 43.9999,21.79106 43.9999,24.00006",
  id: "Fill-8",
  fill: "#333333"
}))), 'ShowMore');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Hospital = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Hospital",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M22.0002,12.9511 C22.0002,12.3991 22.4482,11.9511 23.0002,11.9511 L25.0002,11.9511 C25.5522,11.9511 26.0002,12.3991 26.0002,12.9511 L26.0002,16.0001 L29.0502,16.0001 C29.6022,16.0001 30.0502,16.4481 30.0502,17.0001 L30.0502,19.0001 C30.0502,19.5531 29.6022,20.0001 29.0502,20.0001 L26.0002,20.0001 L26.0002,23.0501 C26.0002,23.6021 25.5522,24.0501 25.0002,24.0501 L23.0002,24.0501 C22.4482,24.0501 22.0002,23.6021 22.0002,23.0501 L22.0002,20.0001 L18.9512,20.0001 C18.3992,20.0001 17.9512,19.5531 17.9512,19.0001 L17.9512,17.0001 C17.9512,16.4481 18.3992,16.0001 18.9512,16.0001 L22.0002,16.0001 L22.0002,12.9511 Z M36.0002,40.0001 L30.0252,40.0001 L30.0252,34.0031 L30.0252,31.0001 C30.0252,30.4481 29.5782,30.0001 29.0252,30.0001 L18.9982,30.0001 C18.4462,30.0001 17.9992,30.4461 17.9982,30.9981 L17.9802,40.0001 L12.0002,40.0001 L12.0002,13.3181 L24.4102,8.0001 L36.0002,8.0001 L36.0002,40.0001 Z M21.9762,40.0001 L26.0252,40.0001 L26.0252,34.0031 L21.9762,34.0031 L21.9762,40.0001 Z M39.0002,4.0001 L23.5902,4.0001 L9.8182,9.9021 C8.7152,10.3751 8.0002,11.4601 8.0002,12.6601 L8.0002,44.0001 L40.0002,44.0001 L40.0002,5.0001 C40.0002,4.4481 39.5522,4.0001 39.0002,4.0001 L39.0002,4.0001 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'Hospital');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var LicensedSellers = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Licensed-Seller",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M30.7106,32 L29.8896,35.064 L26.8366,29.778 C28.3676,29.498 29.8016,28.948 31.0966,28.182 L33.7746,32.82 L30.7106,32 Z M24.4986,8 C29.4606,8 33.4986,12.037 33.4986,17 C33.4986,21.963 29.4606,26 24.4986,26 C19.5356,26 15.4986,21.963 15.4986,17 C15.4986,12.037 19.5356,8 24.4986,8 L24.4986,8 Z M40.8606,37.093 L34.2236,25.598 C36.2536,23.304 37.4986,20.298 37.4986,17 C37.4986,9.832 31.6666,4 24.4986,4 C17.3296,4 11.4986,9.832 11.4986,17 C11.4986,20.298 12.7426,23.304 14.7736,25.599 L8.1376,37.093 C7.6916,37.864 8.4016,38.789 9.2616,38.559 L15.4576,36.898 L17.1176,43.095 C17.3486,43.954 18.5036,44.106 18.9496,43.335 L22.7306,36.79 C23.5586,35.354 23.0666,33.52 21.6326,32.691 L20.7666,32.191 L19.1076,35.064 L18.2866,32 L15.2226,32.82 L17.9006,28.182 C19.2126,28.959 20.6686,29.512 22.2236,29.788 L30.0476,43.335 C30.4936,44.106 31.6486,43.954 31.8796,43.095 L33.5396,36.898 L39.7356,38.559 C40.5956,38.789 41.3056,37.864 40.8606,37.093 L40.8606,37.093 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'LicensedSellers');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Savings = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Savings",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M23.9995,34.0001 C21.7935,34.0001 19.9995,32.2061 19.9995,30.0001 C19.9995,27.7941 21.7935,26.0001 23.9995,26.0001 C26.2055,26.0001 27.9995,27.7941 27.9995,30.0001 C27.9995,32.2061 26.2055,34.0001 23.9995,34.0001 L23.9995,34.0001 Z M38.0005,10.0001 C38.0005,8.3431 36.6575,7.0001 35.0005,7.0001 L14.9995,7.0001 C13.3435,7.0001 11.9995,8.3431 11.9995,10.0001 L11.9995,11.0001 L38.0005,11.0001 L38.0005,10.0001 Z M39.9995,16.0001 C39.9995,14.3431 38.6565,13.0001 36.9995,13.0001 L10.9995,13.0001 C9.3435,13.0001 7.9995,14.3431 7.9995,16.0001 L7.9995,17.0001 L39.9995,17.0001 L39.9995,16.0001 Z M38.0005,34.0001 L38.0005,32.0001 C38.0005,31.4471 37.5535,31.0001 37.0005,31.0001 L32.9995,31.0001 C32.4465,31.0001 31.9995,31.4471 31.9995,32.0001 L31.9995,34.0001 C31.9995,34.5531 32.4465,35.0001 32.9995,35.0001 L37.0005,35.0001 C37.5535,35.0001 38.0005,34.5531 38.0005,34.0001 L38.0005,34.0001 Z M16.0005,28.0001 L16.0005,26.0001 C16.0005,25.4471 15.5525,25.0001 15.0005,25.0001 L10.9995,25.0001 C10.4475,25.0001 9.9995,25.4471 9.9995,26.0001 L9.9995,28.0001 C9.9995,28.5531 10.4475,29.0001 10.9995,29.0001 L15.0005,29.0001 C15.5525,29.0001 16.0005,28.5531 16.0005,28.0001 L16.0005,28.0001 Z M7.9995,37.0001 L39.9995,37.0001 L39.9995,22.9991 L7.9995,22.9991 L7.9995,37.0001 Z M40.9995,41.0001 L6.9995,41.0001 C5.3435,41.0001 3.9995,39.6571 3.9995,38.0001 L3.9995,21.9991 C3.9995,20.3421 5.3435,18.9991 6.9995,18.9991 L40.9995,18.9991 C42.6565,18.9991 43.9995,20.3421 43.9995,21.9991 L43.9995,38.0001 C43.9995,39.6571 42.6565,41.0001 40.9995,41.0001 L40.9995,41.0001 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'Savings');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Outpatient = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Outpatient",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M26.0131,24.9339 C26.0131,24.3809 26.4601,23.9339 27.0131,23.9339 L29.0131,23.9339 C29.5661,23.9339 30.0131,24.3809 30.0131,24.9339 L30.0131,27.9839 L33.0621,27.9839 C33.6151,27.9839 34.0621,28.4309 34.0621,28.9839 L34.0621,30.9839 C34.0621,31.5369 33.6151,31.9839 33.0621,31.9839 L30.0131,31.9839 L30.0131,35.0329 C30.0131,35.5849 29.5661,36.0329 29.0131,36.0329 L27.0131,36.0329 C26.4601,36.0329 26.0131,35.5849 26.0131,35.0329 L26.0131,31.9839 L22.9631,31.9839 C22.4111,31.9839 21.9631,31.5369 21.9631,30.9839 L21.9631,28.9839 C21.9631,28.4309 22.4111,27.9839 22.9631,27.9839 L26.0131,27.9839 L26.0131,24.9339 Z M36.0581,39.9969 L20.0581,40.0449 L20.0371,31.0449 C20.0321,29.3889 18.6851,28.0499 17.0281,28.0549 L12.0271,28.0709 L12.0031,20.0709 L19.0131,20.0489 C19.5601,20.0469 20.0021,19.6029 20.0001,19.0559 L19.9851,14.0459 L27.9851,14.0219 L27.9991,19.0319 C28.0011,19.5789 28.4461,20.0199 28.9921,20.0179 L36.0031,19.9969 L36.0581,39.9969 Z M12.0581,40.0699 L12.0401,32.0699 L16.0401,32.0579 L16.0581,40.0579 L12.0581,40.0699 Z M17.9721,10.0579 L17.9661,8.0579 L29.9661,8.0089 L29.9721,10.0089 L17.9721,10.0579 Z M11.0701,44.073914 L37.0701,43.9939 C38.7271,43.9889 40.0661,42.6409 40.061114,40.9849 L39.9991,18.9849 C39.9941,17.3279 38.6481,15.9889 36.9911,15.9939 L31.9911,16.0089 L31.9851,14.0089 L32.9911,13.9998933 C33.5401,13.9949 33.9831,13.5469 33.9821,12.9969 L33.9571,4.9969 C33.9551,4.4439 33.5061,3.9979 32.9541,3.9998933 L14.9531,4.0679 C14.4011,4.0699 13.9551,4.5179 13.9571,5.0709 L13.9821,13.0709 C13.9831,13.6249 14.4361,14.0729 14.9911,14.0669 L15.9851,14.0579 L15.9911,16.0579 L10.9911,16.0739 C9.3341,16.0789 7.9951,17.4249 8.00008604,19.0819 L8.0611,41.0819 C8.0661,42.7399 9.4131,44.0789 11.0701,44.073914 L11.0701,44.073914 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'Outpatient');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var LoanApplication = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Loan-Application",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M28.9995,35.8281 L34.9995,29.8281 L38.1705,33.0001 L32.1715,39.0001 L28.9995,39.0001 L28.9995,35.8281 Z M34.1215,42.7071 L43.1205,33.7071 C43.5105,33.3161 43.5105,32.6831 43.1205,32.2931 L35.7065,24.8791 C35.3155,24.4881 34.6835,24.4881 34.2925,24.8791 L25.2925,33.8791 C25.1045,34.0661 24.9995,34.3211 24.9995,34.5861 L24.9995,42.0001 C24.9995,42.5531 25.4475,43.0001 25.9995,43.0001 L33.4145,43.0001 C33.6795,43.0001 33.9345,42.8941 34.1215,42.7071 L34.1215,42.7071 Z M20.9995,30.0001 L20.9995,29.0001 L14.0005,29.0001 C13.4485,29.0001 13.0005,29.4471 13.0005,30.0001 L13.0005,32.0001 C13.0005,32.5531 13.4485,33.0001 14.0005,33.0001 L17.9995,33.0001 C19.6565,33.0001 20.9995,31.6571 20.9995,30.0001 L20.9995,30.0001 Z M28.9995,24.0001 L28.9995,22.0001 C28.9995,21.4471 28.5515,21.0001 27.9995,21.0001 L14.0005,21.0001 C13.4485,21.0001 13.0005,21.4471 13.0005,22.0001 L13.0005,24.0001 C13.0005,24.5531 13.4485,25.0001 14.0005,25.0001 L27.9995,25.0001 C28.5515,25.0001 28.9995,24.5531 28.9995,24.0001 L28.9995,24.0001 Z M28.9995,16.0001 L28.9995,14.0001 C28.9995,13.4471 28.5515,13.0001 27.9995,13.0001 L14.0005,13.0001 C13.4485,13.0001 13.0005,13.4471 13.0005,14.0001 L13.0005,16.0001 C13.0005,16.5531 13.4485,17.0001 14.0005,17.0001 L27.9995,17.0001 C28.5515,17.0001 28.9995,16.5531 28.9995,16.0001 L28.9995,16.0001 Z M17.9995,43.0001 L5.9995,43.0001 C5.4475,43.0001 4.9995,42.5531 4.9995,42.0001 L4.9995,6.0001 C4.9995,5.4471 5.4475,5.0001 5.9995,5.0001 L35.9995,5.0001 C36.5525,5.0001 36.9995,5.4471 36.9995,6.0001 L36.9995,21.0001 L35.9995,21.0001 C34.3435,21.0001 32.9995,19.6571 32.9995,18.0001 L32.9995,9.0001 L8.9995,9.0001 L8.9995,39.0001 L20.9995,39.0001 L20.9995,40.0001 C20.9995,41.6571 19.6565,43.0001 17.9995,43.0001 L17.9995,43.0001 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'LoanApplication');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Patient = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Patient",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M23.9995,9 C25.1745,9 26.2675,9.345 27.1935,9.93 L18.6935,12.207 C19.7005,10.303 21.6995,9 23.9995,9 L23.9995,9 Z M23.9995,20.999 C21.2045,20.999 18.8555,19.074 18.1925,16.481 L29.7715,13.38 C29.9165,13.896 29.9995,14.437 29.9995,14.999 C29.9995,18.308 27.3085,20.999 23.9995,20.999 L23.9995,20.999 Z M23.9995,24.999 C29.5135,24.999 33.9995,20.513 33.9995,14.999 C33.9995,9.485 29.5135,5 23.9995,5 C18.4855,5 13.9995,9.485 13.9995,14.999 C13.9995,20.513 18.4855,24.999 23.9995,24.999 L23.9995,24.999 Z M19.6775,38.992 L18.2915,31.157 C18.5945,31.104 18.9005,31.064 19.2115,31.04 L27.1685,38.997 L19.6775,38.992 Z M27.9995,27 L19.9995,27 C12.2685,27 5.9995,33.268 5.9995,41 L5.9995,42 C5.9995,42.553 6.4475,43 6.9995,43 L8.9995,43 C9.5525,43 9.9995,42.553 9.9995,42 L9.9995,41 C9.9995,37.52 11.7905,34.452 14.4955,32.66 L15.8835,40.515 C16.1375,41.946 17.3815,42.991 18.8365,42.992 L29.5825,42.998 C32.2555,43 33.5965,39.768 31.7055,37.877 L24.8285,31 L27.9995,31 C33.5225,31 37.9995,35.478 37.9995,41 L37.9995,42 C37.9995,42.553 38.4475,43 38.9995,43 L40.9995,43 C41.5525,43 41.9995,42.553 41.9995,42 L41.9995,41 C41.9995,33.268 35.7315,27 27.9995,27 L27.9995,27 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'Patient');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Death = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Death",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M24.647,22.7105 C26.314,15.0325 30.034,11.3125 37.71,9.6465 C36.043,17.3225 32.323,21.0435 24.647,22.7105 L24.647,22.7105 Z M35.225,33.1785 L32.825,39.1785 L13.533,39.1785 L11.133,33.1785 L35.225,33.1785 Z M10.687,13.6865 C15.833,14.9495 18.406,17.5235 19.67,22.6695 C14.524,21.4055 11.951,18.8315 10.687,13.6865 L10.687,13.6865 Z M41.216,5.0105 L39.896,5.1985 C30.291,6.5695 24.824,10.2085 22.019,17.5335 C19.594,12.7255 15.318,10.1775 8.461,9.1985 L7.142,9.0105 C6.481,8.9155 5.916,9.4815 6.01,10.1425 L6.199,11.4615 C7.508,20.6235 11.604,25.1895 20.179,26.8655 L20.179,29.1775 L9.656,29.1785 C7.533,29.1785 6.082,31.3215 6.87,33.2925 L10.07,41.2925 C10.526,42.4315 11.629,43.1785 12.856,43.1785 L33.501,43.1785 C34.729,43.1785 35.832,42.4315 36.287,41.2925 L39.487,33.2925 C40.275,31.3215 38.824,29.1785 36.702,29.1785 L24.179,29.1785 L24.179,26.8695 C35.369,24.8345 40.471,19.2715 42.159,7.4615 L42.347,6.1425 C42.441,5.4815 41.876,4.9155 41.216,5.0105 L41.216,5.0105 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'Death');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Disability = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Disability",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M38.0869,40 C36.9839,40 36.0869,39.103 36.0869,38 C36.0869,36.897 36.9839,36 38.0869,36 C39.1899,36 40.0869,36.897 40.0869,38 C40.0869,39.103 39.1899,40 38.0869,40 L38.0869,40 Z M30.8139,24 C30.1069,22.507 29.1569,21.15 27.9959,20 L36.0869,20 L36.0869,24 L30.8139,24 Z M18.0869,39.913 C12.6209,39.913 8.1739,35.466 8.1739,29.999 C8.1739,24.533 12.6209,20.086 18.0869,20.086 C23.5529,20.086 27.9999,24.533 27.9999,29.999 C27.9999,35.466 23.5529,39.913 18.0869,39.913 L18.0869,39.913 Z M40.0869,32.351 L40.0869,19 C40.0869,17.343 38.7439,16 37.0869,16 L19.6229,16 C19.1179,15.944 18.6069,15.912 18.0869,15.912 C17.8919,15.912 17.7019,15.934 17.5089,15.941 L14.2119,6.052 C13.8039,4.826 12.6569,4 11.3659,4 L9.0869,4 C7.4299,4 6.0869,5.343 6.0869,7 L6.0869,8 L10.6459,8 L13.5389,16.68 C7.9989,18.577 3.9999,23.824 3.9999,29.999 C3.9999,37.768 10.3189,44.087 18.0869,44.087 C25.8549,44.087 32.1739,37.768 32.1739,29.999 C32.1739,29.318 32.1089,28.655 32.0149,28 L36.0869,28 L36.0869,32.351 C33.7599,33.177 32.0869,35.394 32.0869,38 C32.0869,41.309 34.7779,44 38.0869,44 C41.3959,44 44.0869,41.309 44.0869,38 C44.0869,35.394 42.4139,33.177 40.0869,32.351 L40.0869,32.351 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'Disability');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var CriticalIllness = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Critical-Illness",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M44.6743,24.2185 C44.6743,25.8755 43.3313,27.2185 41.6743,27.2185 L35.2193,27.2185 C34.9543,27.2185 34.7003,27.1135 34.5123,26.9255 L29.6343,22.0465 L24.3413,27.3395 C23.9513,27.7305 23.3183,27.7305 22.9273,27.3395 L17.6343,22.0465 L12.3313,27.3505 C14.8213,30.1615 18.1483,33.2195 22.0733,36.8225 L23.6303,38.2325 L25.0133,36.9815 C27.8563,34.3715 30.1533,32.3175 32.1753,30.2925 C33.2993,29.1675 35.1143,29.1415 36.2923,30.2085 L36.6573,30.5385 C37.0703,30.9135 37.1033,31.5575 36.7213,31.9635 C34.2703,34.5735 31.5493,36.9905 28.0073,40.2425 L24.3003,43.5895 C23.9193,43.9335 23.3403,43.9335 22.9603,43.5895 L19.0793,40.0835 C9.3963,31.1955 3.0003,25.3225 3.0003,17.4045 C3.0003,10.4485 8.4213,4.9995 15.3423,4.9995 C18.3063,4.9995 21.2733,6.1325 23.6343,8.1055 C25.9943,6.1325 28.9583,4.9995 31.9173,4.9995 C38.8393,4.9995 44.2603,10.4485 44.2603,17.4045 C44.2603,17.6355 44.2543,17.8665 44.2423,18.0975 C44.1413,20.1005 42.1943,21.4785 40.2913,20.8445 L40.2203,20.8215 C39.7383,20.6605 39.4403,20.1605 39.5603,19.6675 C39.7433,18.9135 39.8333,18.1655 39.8333,17.4045 C39.8333,12.8565 36.4303,9.4275 31.9173,9.4275 C29.4863,9.4275 27.0233,10.6295 25.3283,12.6435 L24.4003,13.7475 C24.0003,14.2225 23.2693,14.2225 22.8693,13.7475 L21.9413,12.6435 C20.2463,10.6295 17.7793,9.4275 15.3423,9.4275 C10.8293,9.4275 7.4263,12.8565 7.4263,17.4045 C7.4263,19.6935 8.2883,21.8905 9.8403,24.1855 L16.9273,17.0975 C17.3183,16.7065 17.9513,16.7065 18.3413,17.0975 L23.6343,22.3905 L28.9273,17.0975 C29.3183,16.7065 29.9513,16.7065 30.3413,17.0975 L36.4633,23.2185 L43.6743,23.2185 C44.2263,23.2185 44.6743,23.6665 44.6743,24.2185",
  id: "Fill-1",
  fill: "#333333"
}))), 'CriticalIllness');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Accident = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Accident",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M23.9663,28.2086 L18.7943,23.0366 C18.4043,22.6466 18.4043,22.0136 18.7943,21.6226 L20.2083,20.2086 C21.3803,19.0376 23.2793,19.0376 24.4503,20.2086 L29.6223,25.3806 C30.0133,25.7706 30.0133,26.4036 29.6223,26.7946 L28.2083,28.2086 C27.0373,29.3796 25.1373,29.3796 23.9663,28.2086 L23.9663,28.2086 Z M31.9863,39.1126 L14.8963,22.0216 L9.3043,16.4306 L16.4303,9.3046 L22.3843,15.2586 L32.7213,25.5956 L39.1123,31.9856 L31.9863,39.1126 Z M16.4303,39.1126 L9.3043,31.9856 L14.3093,26.9816 L21.4353,34.1076 L16.4303,39.1126 Z M39.1123,16.4306 L34.1083,21.4356 L26.9823,14.3096 L31.9863,9.3046 L39.1123,16.4306 Z M42.5383,14.3096 L34.1083,5.8786 C32.9363,4.7076 31.0363,4.7076 29.8653,5.8786 L24.2083,11.5356 L18.5513,5.8786 C17.3803,4.7066 15.4803,4.7076 14.3093,5.8786 L5.8793,14.3096 C4.7073,15.4796 4.7073,17.3806 5.8793,18.5516 L11.5353,24.2086 L5.8793,29.8646 C4.7073,31.0356 4.7073,32.9366 5.8783,34.1066 L14.3093,42.5386 C15.4803,43.7096 17.3803,43.7096 18.5513,42.5386 L24.2083,36.8816 L29.8643,42.5386 C31.0363,43.7096 32.9363,43.7096 34.1083,42.5386 L42.5383,34.1066 C43.7103,32.9366 43.7103,31.0356 42.5383,29.8646 L36.8813,24.2086 L42.5383,18.5516 C43.7103,17.3806 43.7103,15.4796 42.5383,14.3096 L42.5383,14.3096 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'Accident');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Inpatient = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Inpatient",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M15,29 L31,29 L31,23 L15,23 L15,29 Z M31,9 L31,19 L15,19 L15,16 L18,16 C19.657,16 21,14.657 21,13 L21,12 L15,12 L15,9 L31,9 Z M33,36 C33,38.206 31.206,40 29,40 C26.794,40 25,38.206 25,36 L27,36 C27.552,36 28,35.552 28,35 L28,33 L32,33 C33.657,33 35,31.657 35,30 L35,8 C35,6.343 33.657,5 32,5 L14,5 C12.343,5 11,6.343 11,8 L11,30 C11,31.657 12.343,33 14,33 L18,33 L18,35 C18,35.552 18.448,36 19,36 L21,36 C21,40.411 24.588,44 29,44 C33.411,44 37,40.411 37,36 L33,36 Z",
  id: "Fill-1",
  fill: "#333333"
}))), 'Inpatient');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Bank = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Bank",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M37,34.8815 C37.552,34.8815 38,34.4345 38,33.8815 L38,23.8815 C38,23.3295 37.552,22.8815 37,22.8815 L35,22.8815 C34.447,22.8815 34,23.3295 34,23.8815 L34,33.8815 C34,34.4345 34.447,34.8815 35,34.8815 L37,34.8815 Z M25,34.8815 C25.552,34.8815 26,34.4345 26,33.8815 L26,23.8815 C26,23.3295 25.552,22.8815 25,22.8815 L23,22.8815 C22.448,22.8815 22,23.3295 22,23.8815 L22,33.8815 C22,34.4345 22.448,34.8815 23,34.8815 L25,34.8815 Z M13,34.8815 C13.552,34.8815 14,34.4345 14,33.8815 L14,23.8815 C14,23.3295 13.552,22.8815 13,22.8815 L11,22.8815 C10.448,22.8815 10,23.3295 10,23.8815 L10,33.8815 C10,34.4345 10.448,34.8815 11,34.8815 L13,34.8815 Z M35.527,14.8815 L24,9.1175 L12.471,14.8815 L35.527,14.8815 Z M42,14.2635 L42,17.8815 C42,18.4345 41.552,18.8815 41,18.8815 L7,18.8815 C6.448,18.8815 6,18.4345 6,17.8815 L6,14.2625 C6,13.8835 6.214,13.5375 6.553,13.3675 L22.659,5.3165 C23.503,4.8945 24.497,4.8945 25.342,5.3165 L41.447,13.3685 C41.786,13.5385 42,13.8845 42,14.2635 L42,14.2635 Z M42,39.8815 L42,41.8815 C42,42.4345 41.552,42.8815 41,42.8815 L7,42.8815 C6.448,42.8815 6,42.4345 6,41.8815 L6,39.8815 C6,39.3295 6.448,38.8815 7,38.8815 L41,38.8815 C41.552,38.8815 42,39.3295 42,39.8815 L42,39.8815 Z",
  id: "Fill-1",
  fill: "#183028"
}), /*#__PURE__*/React__default.createElement("rect", {
  id: "Rectangle",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}))), 'Bank');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Oops = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "m23.9994 3.8538c1.906 0 3.62 1.06 4.473 2.765l15.146 30.291c.78 1.562.698 3.381-.22 4.865-.917 1.484-2.507 2.371-4.253 2.371h-30.292c-1.745 0-3.335-.887-4.253-2.371-.917-1.485-.999-3.304-.219-4.865l15.146-30.291c.853-1.705 2.566-2.765 4.472-2.765zm.8532321 31.0642h-3v3.081c0 .552.447 1 1 1h2c.553 0 1-.448 1-1v-2.081c0-.552-.447-1-1-1zm-.399-19.918h-1.203c-1.804 0-3.201 1.581-2.977 3.372l1.579 12.628h3.999l1.579-12.628c.224-1.791-1.173-3.372-2.977-3.372z",
  fill: "currentColor"
}))), 'Oops');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Cancer = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/cancer",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M33.4451,33.6437 L33.4451,35.6387 L27.0911,28.3077 L29.5251,25.4997 L36.5611,34.1617 L33.4451,33.6437 Z M12.3291,34.1617 L21.9261,22.3477 L21.9261,22.3477 L33.5981,7.9817 L36.7141,11.0977 L28.0621,21.0797 L22.9331,26.9977 L15.4451,35.6377 L15.4451,33.6437 L12.3291,34.1617 Z M12.1761,11.0977 L15.2921,7.9817 L21.8691,16.0767 L19.2671,19.2787 L12.1761,11.0977 Z M24.4451,12.9057 L19.6461,6.9997 L29.2441,6.9997 L24.4451,12.9057 Z M32.1841,22.4307 L40.3461,13.0137 C41.3781,11.8247 41.3141,10.0397 40.2011,8.9277 L35.1521,3.8787 C34.5901,3.3157 33.8261,2.9997 33.0311,2.9997 L15.8591,2.9997 C15.0641,2.9997 14.3001,3.3157 13.7381,3.8787 L8.6891,8.9277 C7.5761,10.0397 7.5121,11.8247 8.5441,13.0137 L16.7061,22.4307 L4.2271,37.7887 C3.6461,38.5027 4.2581,39.5567 5.1671,39.4057 L11.4451,38.3627 L11.4441,43.6807 C11.4431,44.6067 12.5931,45.0357 13.1991,44.3357 L24.4451,31.3617 L35.6891,44.3347 C36.2961,45.0357 37.4451,44.6067 37.4451,43.6807 L37.4451,38.3627 L43.7231,39.4057 C44.6321,39.5567 45.2441,38.5027 44.6631,37.7887 L32.1841,22.4307 Z",
  id: "Fill-1",
  fill: "#000000"
}))), 'Cancer');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var CareCard = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/care-card",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M14.976,41.788 L4.541,26.862 C3.592,25.503 3.924,23.633 5.282,22.684 L28.374,6.541 C29.733,5.592 31.603,5.924 32.552,7.282 L42.987,22.208 C43.936,23.566 43.605,25.437 42.247,26.386 L19.154,42.529 C17.796,43.478 15.925,43.147 14.976,41.788 L14.976,41.788 Z M8.393,25.389 L17.681,38.677 L39.135,23.681 L29.847,10.393 L8.393,25.389 Z M27.7816,21.0467 C27.7086,20.6307 27.5526,20.2247 27.2946,19.8577 C26.3506,18.5177 24.4936,18.1957 23.1546,19.1397 C22.3186,19.7287 21.8786,20.6737 21.8966,21.6277 C21.0046,21.2897 19.9666,21.3857 19.1296,21.9747 C17.7906,22.9187 17.4686,24.7747 18.4116,26.1147 C18.6706,26.4817 19.0016,26.7637 19.3686,26.9737 L19.8536,27.1977 C20.0626,27.2717 25.9356,28.5557 25.9356,28.5557 L26.8936,28.7217 L27.0596,27.7637 C27.0596,27.7637 27.8286,21.8007 27.8296,21.5787 L27.7816,21.0467 Z",
  id: "Path-2",
  fill: "#333333"
}))), 'CareCard');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Swap = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Swap",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M16.2976119,11.3764105 L16.2966428,12.3263772 C16.2966428,13.9004721 14.9961583,15.1762775 13.3894494,15.1762775 L13.3894494,15.1762775 L8.54703418,15.1762775 L8.54606511,32.2709292 L23.2477423,32.2709292 L20.7417416,29.8143151 L21.4268702,29.1426886 C22.5626138,28.0293276 24.4028672,28.0293276 25.5386108,29.1426886 L25.5386108,29.1426886 L30.6669,34.1708627 L25.5376417,39.1980867 C24.4018981,40.3114477 22.5616447,40.3114477 21.4259011,39.1980867 L21.4259011,39.1980867 L20.7407725,38.5274102 L23.2467733,36.0707962 L5.63984074,36.0707962 C5.07766847,36.0707962 4.6669,35.8453233 4.6669,35.0546531 L4.6669,35.0546531 L4.67077626,12.3263772 C4.67077626,11.8010456 5.10491714,11.3764105 5.63984074,11.3764105 L5.63984074,11.3764105 L16.2976119,11.3764105 Z M23.7833814,8.24797996 C24.9153292,7.13461893 26.7519652,7.13461893 27.8848797,8.24797996 L27.8848797,8.24797996 L28.567335,8.91960645 L26.0675767,11.3762205 L41.7002494,11.3762205 C42.2338406,11.3762205 42.6669,11.8008556 42.6669,12.3261872 L42.6669,12.3261872 L42.6669,35.1206394 C42.6669,35.6450211 42.2338406,36.0706062 41.7002494,36.0706062 L41.7002494,36.0706062 L33.0003944,36.0706062 L33.0003944,35.1196895 C33.0013611,33.5465445 34.2995728,32.2707392 35.9003461,32.2707392 L35.9003461,32.2707392 L38.8002978,32.2707392 L38.8002978,15.1760875 L26.0675767,15.1760875 L28.567335,17.6327015 L27.8848797,18.304328 C26.7519652,19.4167391 24.9153292,19.4167391 23.7833814,18.304328 L23.7833814,18.304328 L18.6669,13.276154 Z",
  fill: "#333333"
}))), 'SWAP');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ClearIcon = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Reset",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M33.9888,24 L42.9998,24 L42.9998,15.002 C42.9998,13.345 41.6568,12.002 39.9998,12.002 L38.9998,12.002 L38.9998,17.313 C37.1498,12.756 32.1608,7 22.9998,7 C12.8598,7 4.7638,15.925 6.1558,26.332 C7.0748,33.198 12.2348,38.912 18.9718,40.521 C27.7678,42.623 36.2868,37.588 39.0648,29.572 C39.2578,29.019 38.9578,28.414 38.3918,28.258 L36.4608,27.725 C35.9648,27.588 35.4328,27.845 35.2618,28.33 C33.1138,34.42 26.6238,38.234 19.9198,36.635 C14.8048,35.414 10.8668,31.087 10.1328,25.88 C9.0048,17.881 15.2138,11 22.9998,11 C31.3228,11 34.9258,17.118 35.6888,20 L30.9888,20 L30.9888,21 C30.9888,22.657 32.3318,24 33.9888,24",
  id: "Fill-1",
  fill: "#333333"
}))), 'Clear');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var PremiumPayment = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/premium-payment",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M10.1724,28.002 C10.1724,26.508 11.3834,25.296 12.8774,25.296 C13.7574,25.296 14.5304,25.723 15.0254,26.373 C15.5194,25.723 16.2934,25.296 17.1724,25.296 C18.6674,25.296 19.8784,26.508 19.8784,28.002 C19.8784,29.496 18.6674,30.707 17.1724,30.707 C16.2934,30.707 15.5194,30.281 15.0254,29.631 C14.5304,30.281 13.7574,30.707 12.8774,30.707 C11.3834,30.707 10.1724,29.496 10.1724,28.002 L10.1724,28.002 Z M20.4664,12.971 L36.6174,12.971 L36.6174,14.951 C36.6174,15.503 36.1694,15.951 35.6174,15.951 L20.4664,15.951 C19.9144,15.951 19.4664,15.503 19.4664,14.951 L19.4664,13.971 C19.4664,13.418 19.9144,12.971 20.4664,12.971 L20.4664,12.971 Z M44.2344,9.001 L44.2344,25.002 C44.2344,26.659 42.8914,28.002 41.2344,28.002 L40.2344,28.002 L40.2344,10.001 L16.0514,10.002 L16.0514,16.002 L15.0514,16.002 C13.3944,16.002 12.0514,14.659 12.0514,13.002 L12.0514,6 L17.2944,6.002 L41.2344,6.001 C42.8914,6.001 44.2344,7.344 44.2344,9.001 L44.2344,9.001 Z M32.1834,32.512 L8.0004,32.512 L8.0004,21.734 L32.1834,21.733 L32.1834,32.512 Z M8.0004,38.002 L32.1834,38.002 L32.1834,35.491 L8.0004,35.491 L8.0004,38.002 Z M33.1834,17.733 L9.2434,17.734 L4.0004,17.732 L4.0004,39.002 C4.0004,40.659 5.3434,42.002 7.0004,42.002 L33.1834,42.002 C34.8394,42.002 36.1834,40.659 36.1834,39.002 L36.1834,20.733 C36.1834,19.076 34.8394,17.733 33.1834,17.733 L33.1834,17.733 Z",
  id: "Fill-1",
  fill: "#000000"
}))), 'PremiumPayment');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var BestSeller = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Best-seller",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M13.5986,6.4659 C14.4386,4.4369 16.7786,3.4569 18.8186,4.3069 L18.8186,4.3069 L23.8586,6.3969 L28.9096,4.3069 C30.9496,3.4659 33.2886,4.4369 34.1286,6.4659 L34.1286,6.4659 L36.2186,11.5059 L41.2586,13.5959 C43.2986,14.4369 44.2686,16.7869 43.4286,18.8269 L43.4286,18.8269 L41.3386,23.8669 L43.4186,28.9069 C44.2686,30.9469 43.2986,33.2869 41.2586,34.1259 L41.2586,34.1259 L36.2186,36.2159 L34.1286,41.2559 C33.7186,42.2469 32.9496,43.0159 31.9686,43.4259 C30.9786,43.8359 29.8886,43.8359 28.9096,43.4259 L28.9096,43.4259 L23.8686,41.3359 L18.8186,43.4259 C18.3286,43.6259 17.8086,43.7269 17.2886,43.7269 C16.7786,43.7269 16.2586,43.6259 15.7586,43.4259 C14.7786,43.0159 14.0086,42.2469 13.5986,41.2559 L13.5986,41.2559 L11.5086,36.2159 L6.4686,34.1259 C5.4786,33.7269 4.7086,32.9569 4.2986,31.9659 C3.8986,30.9769 3.8986,29.8969 4.3086,28.9069 L4.3086,28.9069 L6.3886,23.8669 L4.3086,18.8269 C3.8986,17.8359 3.8986,16.7469 4.2986,15.7659 C4.7086,14.7769 5.4786,14.0059 6.4686,13.5959 L6.4686,13.5959 L11.5086,11.5059 Z M30.4386,7.9969 L25.3986,10.0859 C24.4086,10.4969 23.3186,10.4969 22.3286,10.0859 L22.3286,10.0859 L17.2886,7.9969 L15.2086,13.0369 C14.7986,14.0269 14.0286,14.7959 13.0386,15.2069 L13.0386,15.2069 L7.9986,17.2959 L10.0886,22.3359 C10.4986,23.3169 10.4986,24.4069 10.0886,25.3969 L10.0886,25.3969 L7.9986,30.4369 L13.0386,32.5269 C14.0286,32.9369 14.7986,33.6969 15.2086,34.6869 L15.2086,34.6869 L17.2886,39.7269 L22.3286,37.6369 C23.3186,37.2269 24.4086,37.2269 25.3986,37.6369 L25.3986,37.6369 L30.4386,39.7269 L32.5186,34.6869 C32.9286,33.6969 33.6996,32.9369 34.6886,32.5269 L34.6886,32.5269 L39.7286,30.4369 L37.6386,25.3969 C37.2286,24.4069 37.2286,23.3169 37.6386,22.3359 L37.6386,22.3359 L39.7286,17.2959 L34.6886,15.2069 C33.6996,14.7959 32.9286,14.0269 32.5186,13.0369 L32.5186,13.0369 L30.4386,7.9969 Z M21.9889,15.432 C22.7269,13.959 24.8279,13.959 25.5649,15.432 L25.5649,15.432 L27.4069,19.106 L31.4609,19.686 C33.1109,19.922 33.7659,21.955 32.5629,23.109 L32.5629,23.109 L29.6499,25.905 L30.3449,29.891 C30.6289,31.52 28.9239,32.77 27.4549,32.01 L27.4549,32.01 L23.7769,30.106 L20.0999,32.01 C18.6309,32.77 16.9269,31.52 17.2109,29.891 L17.2109,29.891 L17.9049,25.905 L14.9919,23.109 C13.7899,21.955 14.4439,19.922 16.0939,19.686 L16.0939,19.686 L20.1479,19.106 Z",
  id: "Combined-Shape",
  fill: "#183028"
}), /*#__PURE__*/React__default.createElement("rect", {
  id: "Rectangle",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}))), 'BestSeller');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Promotion = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Promotion",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M21.7675,5.0463 C23.2705,4.8433 24.7795,5.3133 25.9125,6.3383 L25.9125,6.3383 L42.1545,21.0293 C43.1595,21.9403 43.7605,23.1793 43.8475,24.5203 C43.9355,25.8833 43.4835,27.1873 42.5745,28.1903 L42.5745,28.1903 L29.4695,42.6793 C28.4885,43.7633 27.1315,44.3123 25.7605,44.3123 C24.5315,44.3123 23.2915,43.8703 22.3025,42.9763 L22.3025,42.9763 L5.7035,27.9613 C4.5505,26.9183 3.9315,25.4393 4.0055,23.9023 L4.0055,23.9023 L4.6065,11.4913 C4.7215,9.0993 6.5285,7.1263 8.9035,6.8023 L8.9035,6.8023 Z M22.4555,8.9993 C22.4065,8.9993 22.3575,9.0023 22.3085,9.0093 L22.3085,9.0093 L9.4445,10.7653 C8.9715,10.8293 8.6245,11.2073 8.6015,11.6843 L8.6015,11.6843 L8.0015,24.0953 C7.9855,24.4253 8.1285,24.7623 8.3865,24.9943 L8.3865,24.9943 L24.9865,40.0093 C25.4415,40.4223 26.1225,40.4163 26.5035,39.9953 L26.5035,39.9953 L39.6085,25.5063 C39.8475,25.2423 39.8655,24.9363 39.8555,24.7773 C39.8365,24.4813 39.6995,24.2033 39.4705,23.9963 L39.4705,23.9963 L23.2295,9.3053 C23.0105,9.1073 22.7345,8.9993 22.4555,8.9993 Z M16.3992,12.1809 C17.9022,12.0989 19.3312,12.6179 20.4422,13.6229 C21.5532,14.6279 22.2062,16.0059 22.2812,17.5019 C22.3552,18.9969 21.8432,20.4319 20.8392,21.5429 C19.8342,22.6539 18.4562,23.3069 16.9612,23.3809 C16.8652,23.3859 16.7692,23.3889 16.6742,23.3889 C15.2822,23.3889 13.9582,22.8809 12.9182,21.9399 C11.8082,20.9349 11.1542,19.5569 11.0802,18.0609 C11.0052,16.5659 11.5172,15.1309 12.5212,14.0199 C13.5262,12.9089 14.9042,12.2559 16.3992,12.1809 Z M16.6822,16.1729 L16.6002,16.1749 C16.1712,16.1969 15.7762,16.3839 15.4882,16.7029 C15.2002,17.0209 15.0532,17.4329 15.0752,17.8619 C15.0962,18.2909 15.2832,18.6849 15.6022,18.9729 C15.9202,19.2609 16.3382,19.4029 16.7612,19.3869 C17.1892,19.3659 17.5842,19.1779 17.8722,18.8599 C18.1602,18.5419 18.3072,18.1299 18.2862,17.7009 C18.2642,17.2719 18.0772,16.8779 17.7582,16.5889 C17.4602,16.3199 17.0802,16.1729 16.6822,16.1729 L16.6822,16.1729 Z",
  id: "Combined-Shape",
  fill: "#183028"
}), /*#__PURE__*/React__default.createElement("rect", {
  id: "Rectangle",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}))), 'Promotion');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var LanguageGlobe = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Search",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M29.0615,39.166 C30.8265,36.745 32.0495,34.345 32.8385,32 L37.8345,32 C35.8945,35.344 32.7845,37.92 29.0615,39.166 L29.0615,39.166 Z M10.1655,32 L15.2075,32 C15.9895,34.347 17.2065,36.751 18.9655,39.176 C15.2305,37.934 12.1105,35.352 10.1655,32 L10.1655,32 Z M19.3585,8.692 C18.0785,10.603 16.6705,13.102 15.6185,16.02 L10.1535,16.02 C12.1665,12.54 15.4415,9.882 19.3585,8.692 L19.3585,8.692 Z M19.8125,16.02 C21.1255,12.89 22.8685,10.43 24.0655,8.95 C25.2765,10.446 27.0085,12.903 28.3105,16.02 L19.8125,16.02 Z M7.9995,24 C7.9995,22.624 8.1935,21.295 8.5215,20.02 L14.4975,20.02 C14.0025,22.503 13.8515,25.188 14.2535,28 L8.5265,28 C8.1945,26.719 7.9995,25.384 7.9995,24 L7.9995,24 Z M28.5565,32 C27.5935,34.314 26.1325,36.69 24.0025,39.085 C21.8875,36.692 20.4435,34.315 19.4945,32 L28.5565,32 Z M18.3195,28 C17.8055,25.158 17.9735,22.466 18.5275,20.02 L29.5855,20.02 C30.1305,22.466 30.2865,25.158 29.7565,28 L18.3195,28 Z M39.9995,24 C39.9995,25.384 39.8055,26.719 39.4735,28 L33.8035,28 C34.2145,25.188 34.0705,22.505 33.5825,20.02 L39.4785,20.02 C39.8065,21.295 39.9995,22.624 39.9995,24 L39.9995,24 Z M37.8465,16.02 L32.4735,16.02 C31.4385,13.129 30.0535,10.643 28.7835,8.731 C32.6385,9.942 35.8575,12.582 37.8465,16.02 L37.8465,16.02 Z M23.9995,4 C12.9725,4 3.9995,12.972 3.9995,24 C3.9995,35.028 12.9725,44 23.9995,44 C35.0275,44 43.9995,35.028 43.9995,24 C43.9995,12.972 35.0275,4 23.9995,4 L23.9995,4 Z",
  id: "LanguageGlobe",
  fill: "#183028"
}), /*#__PURE__*/React__default.createElement("rect", {
  id: "Rectangle",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}))), 'LanguageGlobe');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var EDocument = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/E-documents",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M33.7408,26.544 C34.5938,25.123 36.4368,24.662 37.8578,25.515 L37.8578,25.515 L38.7148,26.029 L34.5318,33 L40.7658,33 C41.5428,33 42.0228,33.848 41.6228,34.515 L41.6228,34.515 L36.2588,43.456 C35.4058,44.877 33.5628,45.338 32.1418,44.485 L32.1418,44.485 L31.2848,43.971 L35.4678,37 L29.2338,37 C28.4558,37 27.9758,36.152 28.3758,35.485 L28.3758,35.485 Z M38.0002,5 C38.5522,5 39.0002,5.448 39.0002,6 L39.0002,6 L39.0002,21 L38.0002,21 C36.3432,21 35.0002,19.657 35.0002,18 L35.0002,18 L35.0002,9 L11.0002,9 L11.0002,39 L23.0002,39 L23.0002,40 C23.0002,41.657 21.6572,43 20.0002,43 L20.0002,43 L8.0002,43 C7.4482,43 7.0002,42.553 7.0002,42 L7.0002,42 L7.0002,6 C7.0002,5.448 7.4482,5 8.0002,5 L8.0002,5 Z M23.0007,29 L23.0007,30 C23.0007,31.657 21.6567,33 20.0007,33 L20.0007,33 L16.0007,33 C15.4487,33 15.0007,32.553 15.0007,32 L15.0007,32 L15.0007,30 C15.0007,29.448 15.4487,29 16.0007,29 L16.0007,29 L23.0007,29 Z M29.9997,21 C30.5517,21 30.9997,21.448 30.9997,22 L30.9997,22 L30.9997,24 C30.9997,24.553 30.5517,25 29.9997,25 L29.9997,25 L16.0007,25 C15.4487,25 15.0007,24.553 15.0007,24 L15.0007,24 L15.0007,22 C15.0007,21.448 15.4487,21 16.0007,21 L16.0007,21 Z M29.9997,13 C30.5517,13 30.9997,13.448 30.9997,14 L30.9997,14 L30.9997,16 C30.9997,16.553 30.5517,17 29.9997,17 L29.9997,17 L16.0007,17 C15.4487,17 15.0007,16.553 15.0007,16 L15.0007,16 L15.0007,14 C15.0007,13.448 15.4487,13 16.0007,13 L16.0007,13 Z",
  id: "Combined-Shape",
  fill: "#000000"
}))), 'EDocument');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Success = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Success",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M35.4136,17.4141 L34.7066,16.7071 C33.5356,15.5361 31.6356,15.5361 30.4646,16.7071 L19.9996,27.1711 L17.5356,24.7071 C16.3646,23.5361 14.4646,23.5361 13.2936,24.7071 L12.5866,25.4141 L19.9996,32.8291 L35.4136,17.4141 Z M23.9996,44.0001 C12.9716,44.0001 3.9996,35.0281 3.9996,24.0001 C3.9996,12.9721 12.9716,4.0001 23.9996,4.0001 C35.0276,4.0001 44.0006,12.9721 44.0006,24.0001 C44.0006,35.0281 35.0276,44.0001 23.9996,44.0001 L23.9996,44.0001 Z",
  id: "Icon",
  fill: "#183028"
}), /*#__PURE__*/React__default.createElement("rect", {
  id: "Rectangle",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}))), 'Success');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Logout = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Logout",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M20,6 L20,7 C20,8.657 18.657,10 17,10 L17,10 L10,10 L10,38 L17,38 C18.657,38 20,39.343 20,41 L20,41 L20,42 L6,42 L6,6 L20,6 Z M27.4141,8.5859 L42.8291,23.9989 L27.4141,39.4139 L26.7071,38.7069 C25.5361,37.5359 25.5361,35.6359 26.7071,34.4649 L26.7071,34.4649 L35.1711,25.9999 L15.0001,25.9999 L15.0001,21.9999 L35.1721,21.9999 L26.7071,13.5349 C25.5361,12.3639 25.5361,10.4639 26.7071,9.2929 L26.7071,9.2929 L27.4141,8.5859 Z",
  id: "Combined-Shape",
  fill: "#000000"
}))), 'Logout');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var SeePassword = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/See-Password",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M23.9996,10 C34.5826,10 41.886312,20.1767619 43.4192474,22.5069875 L43.7086,22.961 C44.0667538,23.5508462 44.0943041,24.2778757 43.7912509,24.8880405 L43.6461589,25.1392206 C42.8331332,26.4401429 35.27885,38 23.9996,38 C13.4166,38 6.11370658,27.8232381 4.58092707,25.4930125 L4.2916,25.039 C3.93252308,24.4491538 3.90490178,23.7221243 4.20794957,23.1119595 L4.35314077,22.8607794 C5.16699668,21.5598571 12.72035,10 23.9996,10 Z M23.9996,14 C16.3166,14 10.3876,21.249 8.4146,24 L8.74567869,24.4527132 C10.9931858,27.4676426 16.7063119,34 23.9996,34 C31.6826,34 37.6126,26.751 39.5856,24 L39.2543764,23.5472868 C37.0060142,20.5323574 31.2928881,14 23.9996,14 Z M24.0001,16 C28.4111,16 32.0001,19.589 32.0001,24 C32.0001,28.411 28.4111,32 24.0001,32 C19.5891,32 16.0001,28.411 16.0001,24 C16.0001,19.589 19.5891,16 24.0001,16 Z M24.0001,20 C21.7941,20 20.0001,21.794 20.0001,24 C20.0001,26.206 21.7941,28 24.0001,28 C26.2061,28 28.0001,26.206 28.0001,24 C28.0001,21.794 26.2061,20 24.0001,20 Z",
  id: "Icon",
  fill: "#183028"
}), /*#__PURE__*/React__default.createElement("rect", {
  id: "Rectangle",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}))), 'SeePassword');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Branch = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/branch",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M16,26.999 C16,25.342 17.343,23.999 19,23.999 L20,23.999 L20,30.012 L16,30.012 L16,26.999 Z M32,30.012 L28,30.012 L28,26.999 C28,25.342 29.343,23.999 31,23.999 L32,23.999 L32,30.012 Z M32,20.012 L28,20.012 L28,16.999 C28,15.342 29.343,13.999 31,13.999 L32,13.999 L32,20.012 Z M22,26.999 C22,25.342 23.343,23.999 25,23.999 L26,23.999 L26,30.012 L22,30.012 L22,26.999 Z M16,16.999 C16,15.342 17.343,13.999 19,13.999 L20,13.999 L20,20.012 L16,20.012 L16,16.999 Z M22,16.999 C22,15.342 23.343,13.999 25,13.999 L26,13.999 L26,20.012 L22,20.012 L22,16.999 Z M36,39.999 L29.994,39.999 L29.994,38.006 L29.994,36.006 L29.994,35.006 C29.994,34.453 29.546,34.006 28.994,34.006 L18.994,34.006 C18.441,34.006 17.994,34.453 17.994,35.006 L17.994,36.006 L17.994,38.006 L17.994,39.999 L12,39.999 L12,13.318 L24.411,8 L36,8 L36,39.999 Z M21.994,39.999 L25.994,39.999 L25.994,38.006 L21.994,38.006 L21.994,39.999 Z M23.401,4.081 L8.606,10.42 C8.238,10.577 8,10.939 8,11.339 L8,43.999 L17.994,43.999 L17.994,44.055 L21.994,44.055 L21.994,43.999 L25.994,43.999 L25.994,44.055 L29.994,44.055 L29.994,43.999 L40,43.999 L40,5 C40,4.447 39.552,4 39,4 L23.794,4 C23.659,4 23.525,4.027 23.401,4.081 L23.401,4.081 Z",
  id: "Fill-1",
  fill: "#000000"
}))), 'Branch');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Calender = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Calendar",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M21.084,22.883 C22.739,22.883 24.084,24.229 24.084,25.883 L24.084,25.883 L24.084,32.053 C24.084,33.707 22.739,35.053 21.084,35.053 L21.084,35.053 L15.624,35.053 C13.969,35.053 12.624,33.707 12.624,32.053 L12.624,32.053 L12.624,25.883 C12.624,24.229 13.969,22.883 15.624,22.883 L15.624,22.883 Z M20.084,26.883 L16.623,26.883 L16.623,31.053 L20.084,31.053 L20.084,26.883 Z M37,39.477 L11,39.477 C10.449,39.477 10,39.029 10,38.477 L10,20.3 L38,20.3 L38,38.477 C38,39.029 37.551,39.477 37,39.477 L37,39.477 Z M11,13 L14.686,13 L18.686,13 L30.686,13 L34.686,13 L37,13 C37.551,13 38,13.449 38,14 L38,16.3 L10,16.3 L10,14 C10,13.449 10.449,13 11,13 L11,13 Z M37,9 L33.316,9 L33.316,6 C33.316,5.449 32.869,5 32.316,5 L30.316,5 C29.764,5 29.316,5.449 29.316,6 L29.316,9 L18.686,9 L18.686,6 C18.686,5.449 18.238,5 17.686,5 L15.686,5 C15.133,5 14.686,5.449 14.686,6 L14.686,9 L11,9 C8.243,9 6,11.244 6,14 L6,38.477 C6,41.234 8.243,43.477 11,43.477 L37,43.477 C39.757,43.477 42,41.234 42,38.477 L42,14 C42,11.244 39.757,9 37,9 L37,9 Z",
  id: "Fill-1",
  fill: "#183028"
}), /*#__PURE__*/React__default.createElement("rect", {
  id: "Rectangle",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("rect", {
  id: "Rectangle",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}))), 'Calender');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var LocatorFill = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Section",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("g", {
  id: "Section---Locator",
  transform: "translate(-1095.000000, -7806.000000)"
}, /*#__PURE__*/React__default.createElement("g", {
  id: "Group-8",
  transform: "translate(992.000000, 7719.000000)"
}, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Location---Fill-(Map)",
  transform: "translate(96.000000, 84.000000)"
}, /*#__PURE__*/React__default.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: "23.5",
  cy: "19.5833333",
  r: "5.875"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M29.3745104,19.5828438 C29.3745104,22.8268229 26.7434896,25.4578438 23.5004896,25.4578438 C20.2555312,25.4578438 17.6254896,22.8268229 17.6254896,19.5828438 C17.6254896,16.3388646 20.2555312,13.7088229 23.5004896,13.7088229 C26.7434896,13.7088229 29.3745104,16.3388646 29.3745104,19.5828438 M7.83382292,19.5828438 C7.83382292,30.1539271 21.6390937,42.1066146 22.2256146,42.6108854 L23.5004896,43.7036354 L24.7753646,42.6108854 C25.3618854,42.1066146 39.1661771,30.1539271 39.1661771,19.5828438 C39.1661771,10.9446354 32.1386979,3.91617708 23.5004896,3.91617708 C14.8622812,3.91617708 7.83382292,10.9446354 7.83382292,19.5828438 Z",
  id: "Location",
  stroke: "#FFFFFF",
  strokeWidth: "1",
  fill: "#E87722"
})))))), 'LocatorFill');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var LocatorMarker = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Section",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("g", {
  id: "Section---Locator",
  transform: "translate(-464.000000, -8043.000000)"
}, /*#__PURE__*/React__default.createElement("g", {
  id: "Misc/Map/*My-Location",
  transform: "translate(464.000000, 8043.000000)"
}, /*#__PURE__*/React__default.createElement("ellipse", {
  id: "Oval",
  fill: "#E87722",
  opacity: "0.2",
  cx: "31.5",
  cy: "32",
  rx: "31.5",
  ry: "32"
}), /*#__PURE__*/React__default.createElement("ellipse", {
  id: "Oval",
  fill: "#E87722",
  opacity: "0.2",
  cx: "31.5",
  cy: "32",
  rx: "19.6875",
  ry: "20"
}), /*#__PURE__*/React__default.createElement("ellipse", {
  id: "Oval",
  fill: "#E87722",
  cx: "31.5",
  cy: "32",
  rx: "12.796875",
  ry: "13"
}), /*#__PURE__*/React__default.createElement("ellipse", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: "31.5",
  cy: "32",
  rx: "7.875",
  ry: "8"
}))))), 'LocatorMarker');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var YenSvg = function YenSvg() {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    style: {
      transform: 'scale(0.85)',
      transformOrigin: 'center'
    }
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "\u30EC\u30A4\u30E4\u30FC_1-2",
    "data-name": "\u30EC\u30A4\u30E4\u30FC 1"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M47.28,52.53h-42A5.25,5.25,0,0,1,0,47.28v-42A5.25,5.25,0,0,1,5.25,0h42a5.25,5.25,0,0,1,5.25,5.25v42a5.25,5.25,0,0,1-5.25,5.25M7,45.53H45.52V7H7Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M57.78,63h-42a5.25,5.25,0,0,1-5.25-5.25V56H56V10.51h1.75A5.25,5.25,0,0,1,63,15.76v42A5.25,5.25,0,0,1,57.78,63"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M29.47,33.71a.56.56,0,0,0-.56.57v5.59a.57.57,0,0,1-.57.56H25.27a.56.56,0,0,1-.57-.56V34.28a.57.57,0,0,0-.57-.57h-6.2a.57.57,0,0,1-.56-.57v-2a.56.56,0,0,1,.56-.56h6.2A.58.58,0,0,0,24.7,30V27.68a.58.58,0,0,0-.57-.57h-6.2a.56.56,0,0,1-.56-.56V24.6a.57.57,0,0,1,.56-.57h3.95c.31,0,.43-.21.26-.48L15.33,12.8c-.17-.27-.05-.48.26-.48H19.4a1.13,1.13,0,0,1,.86.48l6.23,10.36a.3.3,0,0,0,.57,0L33,12.81a1.06,1.06,0,0,1,.84-.49h3.73c.31,0,.43.22.27.48L31.33,23.55c-.16.27,0,.48.27.48h4a.58.58,0,0,1,.57.57v1.95a.57.57,0,0,1-.57.56H29.47a.57.57,0,0,0-.56.57V30a.57.57,0,0,0,.56.57h6.16a.57.57,0,0,1,.57.56v2a.58.58,0,0,1-.57.57Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M29.47,33.71a.56.56,0,0,0-.56.57v5.59a.57.57,0,0,1-.57.56H25.27a.56.56,0,0,1-.57-.56V34.28a.57.57,0,0,0-.57-.57h-6.2a.57.57,0,0,1-.56-.57v-2a.56.56,0,0,1,.56-.56h6.2A.58.58,0,0,0,24.7,30V27.68a.58.58,0,0,0-.57-.57h-6.2a.56.56,0,0,1-.56-.56V24.6a.57.57,0,0,1,.56-.57h3.95c.31,0,.43-.21.26-.48L15.33,12.8c-.17-.27-.05-.48.26-.48H19.4a1.13,1.13,0,0,1,.86.48l6.23,10.36a.3.3,0,0,0,.57,0L33,12.81a1.06,1.06,0,0,1,.84-.49h3.73c.31,0,.43.22.27.48L31.33,23.55c-.16.27,0,.48.27.48h4a.58.58,0,0,1,.57.57v1.95a.57.57,0,0,1-.57.56H29.47a.57.57,0,0,0-.56.57V30a.57.57,0,0,0,.56.57h6.16a.57.57,0,0,1,.57.56v2a.58.58,0,0,1-.57.57Z"
  }))));
};

var Yen = createSvgIcon( /*#__PURE__*/React__default.createElement(YenSvg, null), 'yen', '0 0 63.03 63.03');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Facebook = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  fill: "#1877F2",
  d: "M48,24C48,10.7,37.3,0,24,0S0,10.7,0,24c0,12,8.8,21.9,20.2,23.7V30.9h-6.1V24h6.1v-5.3c0-6,3.6-9.3,9.1-9.3\r c2.6,0,5.4,0.5,5.4,0.5v5.9h-3c-3,0-3.9,1.9-3.9,3.7V24h6.7l-1.1,6.9h-5.6v16.8C39.2,45.9,48,36,48,24z"
}), /*#__PURE__*/React__default.createElement("path", {
  fill: "#FFFFFF",
  d: "M33.3,30.9l1.1-6.9h-6.7v-4.5c0-1.9,0.9-3.7,3.9-3.7h3v-6c0,0-2.7-0.5-5.4-0.5c-5.5,0-9.1,3.3-9.1,9.3V24H14\r v6.9h6.1v16.8c1.2,0.2,2.5,0.3,3.8,0.3s2.5-0.1,3.8-0.3V30.9H33.3z"
}))), 'Facebook');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Twitter = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/SocialMedia/Twitter-Brand",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("circle", {
  id: "Oval",
  fill: "#1DA1F2",
  fillRule: "nonzero",
  cx: "24",
  cy: "24",
  r: "24"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M19.608,36.66 C30.252,36.66 36.072,27.84 36.072,20.196 C36.072,19.944 36.072,19.692 36.06,19.452 C37.188,18.636 38.172,17.616 38.952,16.452 C37.92,16.908 36.804,17.22 35.628,17.364 C36.828,16.644 37.74,15.516 38.172,14.16 C37.056,14.82 35.82,15.3 34.5,15.564 C33.444,14.436 31.944,13.74 30.276,13.74 C27.084,13.74 24.492,16.332 24.492,19.524 C24.492,19.98 24.54,20.424 24.648,20.844 C19.836,20.604 15.576,18.3 12.72,14.796 C12.228,15.648 11.94,16.644 11.94,17.7 C11.94,19.704 12.96,21.48 14.52,22.512 C13.572,22.488 12.684,22.224 11.904,21.792 C11.904,21.816 11.904,21.84 11.904,21.864 C11.904,24.672 13.896,27 16.548,27.54 C16.068,27.672 15.552,27.744 15.024,27.744 C14.652,27.744 14.292,27.708 13.932,27.636 C14.664,29.94 16.8,31.608 19.332,31.656 C17.352,33.204 14.856,34.128 12.144,34.128 C11.676,34.128 11.22,34.104 10.764,34.044 C13.296,35.7 16.344,36.66 19.608,36.66",
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))), 'Twitter');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Line = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("circle", {
  fill: "#00B900",
  cx: "24",
  cy: "24",
  r: "24"
}), /*#__PURE__*/React__default.createElement("g", {
  id: "TYPE_A_19_"
}, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  fill: "#FFFFFF",
  d: "M40,22.6c0-7.1-7.2-13-16-13s-16,5.8-16,13c0,6.4,5.7,11.8,13.4,12.8c0.5,0.1,1.2,0.3,1.4,0.8\r c0.2,0.4,0.1,1,0.1,1.4c0,0-0.2,1.1-0.2,1.4c-0.1,0.4-0.3,1.6,1.4,0.9c1.7-0.7,9.2-5.4,12.5-9.3l0,0C38.9,28,40,25.4,40,22.6"
}), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  fill: "#00B900",
  d: "M20.8,19.1h-1.1c-0.2,0-0.3,0.1-0.3,0.3v7c0,0.2,0.1,0.3,0.3,0.3h1.1c0.2,0,0.3-0.1,0.3-0.3v-7\r C21.1,19.2,20.9,19.1,20.8,19.1"
}), /*#__PURE__*/React__default.createElement("path", {
  fill: "#00B900",
  d: "M28.5,19.1h-1.1c-0.2,0-0.3,0.1-0.3,0.3v4.1l-3.2-4.3l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0\r l0,0l0,0l0,0l0,0l0,0l0,0l0,0h-1.1c-0.2,0-0.3,0.1-0.3,0.3v7c0,0.2,0.1,0.3,0.3,0.3h1.1c0.2,0,0.3-0.1,0.3-0.3v-4.1l3.2,4.3\r c0,0,0,0.1,0.1,0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0.1h1.1c0.2,0,0.3-0.1,0.3-0.3v-7C28.8,19.2,28.6,19.1,28.5,19.1"
}), /*#__PURE__*/React__default.createElement("path", {
  fill: "#00B900",
  d: "M18.1,24.9h-3v-5.5c0-0.2-0.1-0.3-0.3-0.3h-1.1c-0.2,0-0.3,0.1-0.3,0.3v7l0,0c0,0.1,0,0.2,0.1,0.2l0,0l0,0\r c0.1,0.1,0.1,0.1,0.2,0.1l0,0h4.5c0.2,0,0.3-0.1,0.3-0.3v-1.1C18.4,25.1,18.2,24.9,18.1,24.9"
}), /*#__PURE__*/React__default.createElement("path", {
  fill: "#00B900",
  d: "M34.6,20.8c0.2,0,0.3-0.1,0.3-0.3v-1.1c0-0.2-0.1-0.3-0.3-0.3h-4.5l0,0c-0.1,0-0.2,0-0.2,0.1l0,0l0,0\r c-0.1,0.1-0.1,0.1-0.1,0.2l0,0v7l0,0c0,0.1,0,0.2,0.1,0.2l0,0l0,0c0.1,0.1,0.1,0.1,0.2,0.1l0,0h4.5c0.2,0,0.3-0.1,0.3-0.3v-1.1\r c0-0.2-0.1-0.3-0.3-0.3h-3v-1.2h3c0.2,0,0.3-0.1,0.3-0.3v-1.1c0-0.2-0.1-0.3-0.3-0.3h-3v-1.2h3V20.8z"
})))))), 'Line');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Youtube = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  fill: "#FF0000",
  d: "M43.1,14.3c-0.5-1.7-1.8-3.1-3.5-3.6C36.5,9.9,24,9.9,24,9.9s-12.5,0-15.6,0.8\r c-1.7,0.5-3.1,1.8-3.5,3.6C4,17.5,4,24,4,24s0,6.6,0.8,9.7c0.5,1.7,1.8,3.1,3.5,3.6c3.1,0.8,15.6,0.8,15.6,0.8s12.5,0,15.6-0.8\r c1.7-0.5,3.1-1.8,3.5-3.6c1-3.1,1-9.7,1-9.7S44,17.5,43.1,14.3z"
}), /*#__PURE__*/React__default.createElement("polygon", {
  fill: "#FFFFFF",
  points: "19.9,30 30.3,24 19.9,18.1"
}))), 'Youtube');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Wechat = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/SocialMedia/Wechat-Brand",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M47.99952,23.99952 C47.99952,37.25472 37.25472,47.99952 23.99952,47.99952 C10.74552,47.99952 -0.00048,37.25472 -0.00048,23.99952 C-0.00048,10.74552 10.74552,-0.00048 23.99952,-0.00048 C37.25472,-0.00048 47.99952,10.74552 47.99952,23.99952",
  id: "Fill-1",
  fill: "#00B900"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M31.09896,19.60404 C37.04016,19.60404 41.85576,23.61684 41.85576,28.56804 C41.85576,31.26804 40.40736,33.69924 38.13936,35.34324 C37.95696,35.47164 37.83816,35.68644 37.83816,35.92644 C37.83816,36.00684 37.85496,36.07884 37.87536,36.15564 C38.05776,36.83004 38.34696,37.91364 38.36136,37.96404 C38.38296,38.04804 38.41776,38.13684 38.41776,38.22564 C38.41776,38.42244 38.25816,38.58444 38.06016,38.58444 C37.98096,38.58444 37.91736,38.55564 37.85256,38.51844 L37.85256,38.51844 L35.49816,37.15764 C35.32056,37.05564 35.13336,36.99204 34.92576,36.99204 C34.81536,36.99204 34.71096,37.01004 34.61136,37.04004 C33.51216,37.35564 32.32536,37.53084 31.09896,37.53084 C25.15896,37.53084 20.34216,33.51804 20.34216,28.56804 C20.34216,23.61684 25.15896,19.60404 31.09896,19.60404 Z M19.0506,9.7062 C25.4898,9.7062 30.8274,13.6362 31.7994,18.7758 C31.5678,18.765 31.3338,18.7566 31.0986,18.7566 C24.597,18.7566 19.3266,23.1498 19.3266,28.5678 C19.3266,29.481 19.479,30.3642 19.7598,31.2042 C19.5258,31.215 19.2882,31.221 19.0506,31.221 C17.577,31.221 16.1562,31.0098 14.8374,30.6306 C14.7174,30.5934 14.5902,30.5754 14.4582,30.5754 C14.2098,30.5754 13.9854,30.6498 13.773,30.7722 L13.773,30.7722 L10.947,32.4042 C10.8678,32.4498 10.791,32.4834 10.6986,32.4834 C10.461,32.4834 10.2678,32.2914 10.2678,32.0538 C10.2678,31.947 10.3098,31.8414 10.3362,31.7394 C10.353,31.6794 10.701,30.381 10.9194,29.5698 C10.9434,29.4786 10.965,29.391 10.965,29.295 C10.965,29.0058 10.8222,28.7502 10.6026,28.5942 C7.881,26.6226 6.1422,23.7054 6.1422,20.4642 C6.1422,14.523 11.9226,9.7062 19.0506,9.7062 Z M27.51336,24.26484 C26.72016,24.26484 26.07816,24.90684 26.07816,25.69884 C26.07816,26.49084 26.72016,27.13284 27.51336,27.13284 C28.30536,27.13284 28.94736,26.49084 28.94736,25.69884 C28.94736,24.90684 28.30536,24.26484 27.51336,24.26484 Z M34.68456,24.26484 C33.89256,24.26484 33.25056,24.90684 33.25056,25.69884 C33.25056,26.49084 33.89256,27.13284 34.68456,27.13284 C35.47656,27.13284 36.11856,26.49084 36.11856,25.69884 C36.11856,24.90684 35.47656,24.26484 34.68456,24.26484 Z M14.7486,15.3006 C13.797,15.3006 13.0266,16.071 13.0266,17.0214 C13.0266,17.9718 13.797,18.7422 14.7486,18.7422 C15.699,18.7422 16.4694,17.9718 16.4694,17.0214 C16.4694,16.071 15.699,15.3006 14.7486,15.3006 Z M23.3538,15.3006 C22.4034,15.3006 21.6318,16.071 21.6318,17.0214 C21.6318,17.9718 22.4034,18.7422 23.3538,18.7422 C24.3042,18.7422 25.0758,17.9718 25.0758,17.0214 C25.0758,16.071 24.3042,15.3006 23.3538,15.3006 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
}))), 'Wechat');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var LinkedIn = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  fill: "#0A66C1",
  d: "M41.9,36.1c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2C40,37,40.8,36.1,41.9,36.1 M41.9,35.9\r c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2C44.1,36.9,43.1,35.9,41.9,35.9L41.9,35.9z"
}), /*#__PURE__*/React__default.createElement("path", {
  id: "Path_2525_1_",
  fill: "#0A66C1",
  d: "M42.2,38.2c0.3,0,0.6-0.3,0.6-0.6l0,0c0-0.4-0.3-0.7-0.8-0.7h-0.9v2.4h0.3v-1h0.4l0,0\r l0.6,1h0.4L42.2,38.2L42.2,38.2z M41.9,38h-0.4v-0.8H42c0.3,0,0.5,0,0.5,0.4C42.5,38,42.2,38,41.9,38"
}), /*#__PURE__*/React__default.createElement("path", {
  id: "Path_2520_1_",
  fill: "#0A66C1",
  d: "M33.4,35.3h-4.8v-7.5c0-1.8,0-4.1-2.5-4.1s-2.9,2-2.9,4v7.6h-4.8V19.8H23V22h0.1\r c0.9-1.6,2.7-2.6,4.5-2.5c4.9,0,5.8,3.2,5.8,7.4V35.3z M13.1,17.7c-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8c1.5,0,2.8,1.2,2.8,2.8\r C15.8,16.5,14.6,17.7,13.1,17.7L13.1,17.7 M15.4,35.3h-4.8V19.8h4.8V35.3z M35.8,7.7H8.2c-1.3,0-2.4,1-2.4,2.3v27.7\r C5.8,39,6.9,40,8.2,40h27.6c1.3,0,2.4-1,2.4-2.3V10C38.2,8.7,37.1,7.7,35.8,7.7"
}))), 'LinkedIn');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Instagram = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("image", {
  width: "70px",
  height: "70px",
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAYAAABxLuKEAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ\r bWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdp\r bj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6\r eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2\r NDQ2MCwgMjAyMC8wNS8xMi0xNjowNDoxNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJo\r dHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlw\r dGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEu\r MC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVz\r b3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1N\r Ok9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo2M2U0MDEzMS01OGEzLTRjODktYmZiMi02MjUx\r MzY4ZDlhNWIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QTQzNDU0Q0JGMUMwMTFFQUJCQjBF\r QTk4NzgwQzk1QUIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QTQzNDU0Q0FGMUMwMTFFQUJC\r QjBFQTk4NzgwQzk1QUIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUg\r KE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlp\r ZDpmMDQyMTc0MC0zOTNhLTRjMjEtYjA1MS0yODI2ZWVjZGI0YWIiIHN0UmVmOmRvY3VtZW50SUQ9\r ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo5M2U5YjhhMC0xYWRmLTFiNGQtYjcxNC0zNDA1MmQ5YjI4\r OTQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tl\r dCBlbmQ9InIiPz48nc9bAAAa1klEQVR42uxcedBlR1Xv0933vvVbZk1iWEKpYbFCFqJsslWRQAUr\r AoZUMEoCSFgkKIUEi6UKRKGQUgStIogmChECwULFkEqRCMGQghRIYtQqCogsWWYyycx8831vuUv3\r 8ZzT3ffeN8nA96ziv5lMz73vvvvuvf3r3/mdpfsGEFEd//PwP/o4BMeBOQ7McWB+hn/sIx08suXV\r f39vpjR0j7YiDZ1jmL5iEacvAEDT71ZBwwhADaj16WiPtjmdZegUw5eQUxVCvB4ApmujXBbi5SHc\r hA86+pdbRQ6joANz5XHmESfo8YiX75DvL88H6Umx+7zdboBy9KPHPXGsVnZk2wPmfwiUl//e91Qv\r B3lQiFcLWwwgoJd9o2E17+mn5z3zrCyHM42FUwiZXQTOiB6oR80yAPKw9DtNP9W0NbGF/XBMx++N\r b8/TXsk+pGO05euAVxUBUxIcE3T+IVf7H5alu3Ne1v9O7Tbv/SFNsIbGj5rg4l5o6dVs6tU7P3GW\r Ovuc3dsDhn82oDv3oAsMhmHFMIB5Dr80XMkv6w/sS2wGj9ZhpMN5GPabrcKm4+YRgBEwOqDp7n60\r dw3xGESAQWVaU1NqpLXeq61+IvTsC8Hnb6srf/+kKP/5yLz4WFHXd3AvQK4SewMo4Nja08Di9k2J\r +2+do9ayJFDcK3qY9ZW1/D2jcX6ZMWQmnoa0DIAlVgQzaD8LEKoFowuOPopFLTiBHWkfInMWWCTn\r qOZ7iMf6Ck5a7eWvOyHLXr1RlFcdnM3eVWN9gKy8BUdFxi+jMdwZU1eEZjB+7iASAHmuz9q5c/BJ\r Mp0nqZpQq7AFQrX7cmsMzDP48JaOHw2GacBYBEeuFY9BBwj5jC0gjbpgUDGjINvbz1+7lpnn79/a\r esWsrm7TYIJwoRZwQABaAhjrKqIaCDBITOnn5jm713ufp8vuULOq0ZzQAgg6ihvfLI22QV/Rlpp3\r BIKjfU8agrTFo4DBaFKwAAxdXvMxJisyYZWlbUbaYdmqtIIGkOgKAi5RU/jZhxp+/rEr4xv3bx25\r cFJWN5B7iIru5LmXAMYrW9UsrGI+uYUzTlgZ/pOp/Xowkdi4YxDMpqrr787L6mtVVX3bu/pucO5B\r us4EvJ/RtoQIjgCjAjANiwKDAlB0+64o8/gKOEFm6JEYEOgRIH0NekRtt9XmcbnJzujZ/Jm0fQKb\r jGfnAJFBXvze+OTx+HP7NjfOmVX1bemcJYEhxrApsW/Vau3EtZVre11QRPwCQ6ZFcePmdPrhoqy+\r rLybM6hG2BO2ci7vRwCsbH3YLgATWRfAaYRX2BjNpHHD0SWztjt2u7Rf0HYCOs9t/uyV3vjyQd4/\r n22m8ae0b0EPTxqOr71/8/DZDusHfByA5TSmquSBd6+O3ruC6vFYVA1Tgslg8dDWkcs3Z7OP87Es\r gqG7wDDAzL60H7UlbXUUv7TfABEdgG4cbGoRHFQqKUqMgqK2+NJX9U0b1eymKh/+1vpo/aNambEX\r HdFiZNboR+/p9//0wenmpdgJRbYFDJuPcaUa5vYJO415rRFQfAcUP9+3efiCSTG/nkKdAIh03sfR\r 99J5KyCEYwKGahmiVQtMEurkmqELUAcUddR+AxWqLmzS3bLYvGbD1/fsGu/8ggEzDvFfkIbVXu8V\r s2Lyl1tYfGtJU2JvUKv1fPC7PYU5eyQR1BA/qP1bG2+azScBFAwsYQACGHGbAImmYzrAJEBaMI5i\r yyOA0/qcLihMXI6vTGa0PYnka8N5vyFumTWkmnxla6J+Z8d457U+mpP8jv6u9Xpvmm9OLlkKGFIr\r lYFfWc3sBeCddJzHgTVnUs5unsyPfDwxRQAB1gxH5sT7HR2R30SGNExpgTCNR1MdtmBjSkebUBee\r YDpI3nJ48bi/9nYC5hSv8NCsnP7d1nzr3cSMmhGoyq3PVEXvon4+enEyKQZzbLPzN0BRyIsPLgEM\r qqHRT+8bdSIovn5Qb+7kVnH4A1aXoikMSk6A2ABkyxLAjlkFAIJYd8Hp6Ag+MlvC9x1QeKixTU56\r 2eBFO0c7rglMECc97PdW30EDYzfnR/4QMIT+RbHxgVHe+3Vy8RDcNMU4Wq8PjXkuOYvPLaUx41w9\r N9MECroGlKou767ryS19steMzskSY1RrPgtCq47Wk3Cdh7GjA4RwAmFRbBNTFkRXqdV8+BYegFCF\r jCJM+yv54A1lceTPHLoDElXV89up/Vdm+6exJwpAKjWwBIzC7QPDuI4yPCMjtijlG02YVrOvkiiX\r PcAFULKj9KUVWd+YTHDfyQ376MZRGGGAYhIFAwgDP6eIdMas5/wmhfGwkNcLZDoDeJSRpDsNaLgA\r /WKFGL0XKA1Q8hTOu2r25b7JT5N0DwLIfW1O18ukBCSwpg/qFE03haQvdLyuZ/+RE1i5aoHhbdaJ\r TWwDZLf5DiCsQ2a1l/Wf17f95+cmP8NoczIFbuOYY00oDryvdtWdVTW/uaqKf/PeHYIo1wApLqEL\r ufl3tMl+ESXTb6WZmaKxutdGyByzxM2/pXGlBZD+5lo9hvo6oCOzbQFDI7iSgdrFo5FiF2YAuOLu\r HgHTS8BgiF+aWEUtBnemiWlQAMlA7xn11944zFcuyUz2WN0km9jVlj1g7Slge89QvfHrva/uLYrJ\r NfNi8yPOVfcB2kZjquLgHw8IXPJKfYyFF/5mNj/0J+DLw5bzoshK+vwDkQVhS2AehdA7qK/r2weG\r Unnq+ChR3iSzwfJBjjN7kRkBnBaUxBSL7b64c/pulI0vXh3sfH+ms0czSORLO1FHqzHBnFodMaBP\r 7g3W3jbKh5dMZ4feVZRbf6MwXN3X029MJveeM+jteLs2+ROIOQ9Mi62PldX0agtNaiumQ+HHQbIA\r DJmFMI4He0h3Yhrdv11TGlCncjYl0+iHIw9UT4i/YkrJPbcxSgCpjVdi0Ke8Xh3s/otxb/1yyb6x\r ivrS9UDYxiqoHqYmXLyzWp+4Ntr98bnNnjadPvQGCthKUa96cuu0np6nwDJr5qzDBqwK6QBKPMNi\r q1U90cpx9psnjtLzmWhK2xRf0iWjXJY8jYT76KqMpJ2epNGXBEqGcR/9QjDHN14f7P3kqLf2csVh\r RVM76wRwAE0xK4xv8kUYg7dUOg1J4bC3+mpiw57JdP+FJNKFpJcoscm8hbtufSEG96xRF9SHklx+\r 7uPdfXiWwTLi2wtmooK4BmDqDKuSb5o1rtmF8L/LlKQzNMrClHxMoJTd+lkTm3hXfLesJzc6N/8m\r AXcfd1+DPcma/lMyOzrXmP4T20ItNAD1s9H50N/5senswKWUi7chIyYwtNhlilmYu6QvJcfC0Ai1\r Ds6A61rbBobolrxNBkEz6MI1mU8FMYZhUBIgtmNOIaOu1TBbuWilt/pGMZ0Y+QaGaE7CfzCfH3h3\r VW19lsxkpjoM4sembPmTJZheno1f0u/veQ8BdCoDgh2XPOitXoJuehvFK39NZsTFiQ44JhaiAqBh\r D2rqQ8WFKjZlDwFOImG27ekT6ohpQny2b9l3LlOVI9Yojm+ycEzlwiAnxywBYrBUFOfsWuvv+BB7\r NYMRQAGTOl0evn669f2n1uXBvzeqnnGUnMWW9kP2XReuPHTtdPP7T6uLg9fpKOSGi0sY2rC/k6Jw\r fTLpBx2nBtw4II2fmzCBtdJ5+r1P4UfK8eAY5DgWY0zWiUvYdIjqmGHttTClE+WKOSW2eHngcW/X\r m3JtT2TmNGVOzluqQzfMp/e8lB6WbV3OXRTaJjXsZM71oXJ6z0V87Sxff5noTsyTyB2v93trb53P\r Dvx+MCmUQjewm/YYJjOkAsmmRaAoac2doimZJRijdMOUNOoUJtE+BqYQO1QVmpwTGMSMofhnZZiN\r X2OIWeLVoiArN/tROb33t+lzyaNhU+FKLW67Xk7H0iNtfTm971VYT7+T9ItNmoHvZ+NXEGt2h3MD\r WzQ9l9Ycs9ThGYRlHpkxqUQCUX3gGBjoY02fZBGYIK5iDhRaMSChZY2J0WfgFoAa2Ox5uTEnBTq7\r SGOvqvkD7wBfPRTSAt+26M00pu3ibIJpajbVVjXffwXEeEkH3WPN2pGZ/gs11m1dSO7JxXz+PoCo\r pdYXyqeg0r1xYSJxO+4aQuAGTahPlEbSGDSqbEsN4DrCi/Kgw172gswW7HKasqR35d3KHbou16Ge\r nII41cmsF2c5OxUYbI0Mq81/JdbcZczgtCCsoSpHyeEL6urQNRCDAWwMsuZKumKeUCxDBuUgmTaD\r 44NZwjKlTQhsIcnmznPZQVfQ03MRVykxgD8qgw6j1e+rM202DwDEskE1O3x9potCJjTSAPmQRWOs\r 5yJ2p1ZTtoxNzTac4z3Wm/+iOUv2KD6Mu2V19mQj+WntAVIu38S9BA4NL+sMsV5MMBpK0BtcAhip\r qVCySGhbTVtgWyxUn5hgREdiIAedJDEUsvp5z/+cMUUz0cYdcvPN2zNbB5tO06U6bhkcD+1+M5WK\r ndQAm2PEmNsZdA1tbENpA5kurHr0hxvKy8/D3JGK4q+BgJEqpBdBTuXaJQI8r3p2rnLLEzhOmgBj\r KrFdm0QyFZ8gJo6gh1lejdi2JTmMwBg93wemlkJTnKYPUxoRDJne74AkXmRhrrldQkA6tZ9Ft4l8\r wt8hT9VSRw+HWeHonSI4HmJplp9LgIKm6H/UlP9PYQwxJc8KDn+FMZZFDAtV20oYE0qWvqnMmajw\r nHjYrACtTWeGkq5ha/SubjVDGBNB4efUumUOT4Z5GlHWBZ/i5LZqJxBK/AFNXSUZj4+mw/3lMibG\r ip8GaGYdeebO+/Z3CpdmTKEyAiYTYNgESpUbDuAqCcR0BCeVLKWBmhpbTowxu9pyAn2TuxNcnRjT\r mhCzBnVIEhUDkZgjo6wFMIlHPDS1WgOwVzcrQ6KhoUzqTSCxKok+zwxAnJWE5KKdFL+CyXrVit62\r KnheGJPTt9a4EE3yigtmjK+D6UAEpgFFTGdOZnO/yfPHqCi+8hAD+GUo6k+paEph0URkTTQpZLvX\r EJjCnYjJoQDEQPkwukZnZ0MaaQg5EeVi+0h8jkD0MUl4Nf9eltToKLQekmAzi3z0UMswBrOMGQMS\r C7ApEWMwI8ZoZhC0YIStb4pRoGZ3mByeSjFZuCknI2N9npq4K6iHFaR8RxZPtCYlZhNBEdPyXtws\r RGAkx6J/reUZRhdXVIQCOSWhd/EyoMUgNpY5GTfwadEBBIP0cl8Ix3GZmi9mluIVS8AYF0yJElNv\r YiQJLRgJnGbqtp5+SdvstUr7trZi4VQ1ti/2k/l1gQkBHIyMQYx6oZO2eAFDavrACR/KyGd2fK7N\r 7ZmeWMtsSmVKX0++JJoGQV+SuGFnitcDxTCA2E79u3h9hUuZkiWzsZExEkEiZeyGLo6tKTUmpDrg\r 1LObtOo9AJnZqxCbyn+2q/e+uprdqFx9JLjZZEJHbwMokuPQvpf1DFwiMH07WvkgRUVK1ZwLxWKU\r L49gPfkiQLuODGMlEDqry4IzCIyBzqqMY7lrfQxgvM3KAE5sxlZEYwesOd1m0taGRnnKhppPrtY5\r sYtjl4zyFv79SP1CvndwlTZOC9AmNMMsZFGXbXucfyvfy7kUS62tfNQOzGlgw/VAcz5EPKo2P0Xg\r 7NedgE43iwnaJXK6WfYQwwiIJhXWzG03iSRgAhix1dyAQNAJDJM6puO+Do3BUZPJh8i9P6QzBoco\r y52kjph18xvZicNPQ+bXJMETAMgkDY2c8QvACCBafj/Kd6xcnY37l4IpBRS+rslYZ+Zbrjz4gVSP\r 051lcaqzeAka28Vkx931PW4JxmC9AEomwBhrapNASYA0AEkLnSSz249Htq7QeRz51Agcu8NcmD9q\r dJtdNS+l35H3DYKegE1ZMZDZ2qF9Ub53/dZspXcp2AgKs5DZRcA49+A7CZwfJDOCJmteXCIXP4cV\r oxhdNDYLLd0yKUFlOMq1hgAIESPR2ZKvtpKpQqBi0heAxdVVsvpnOrtKbalf1ev9V6ratxEve64R\r PEkPhv+IM3eHn9RfVHP3TV+p+0NsYU5QJj9L5f3zlOmdTXkfeeKKNUbFGp54qHpy+DpfHf6wttSF\r 2lEuZGLyiE0oqGKwF+eieAVWprqMCvFQucykfhHYgmLHRlICZ5X1PZmZTKAk4YUuNVVDY3Vw8jqV\r 4y5Yyc5XLpm0atIAAugMGOZncOe1gxDkeR22NZO8Vt0sWv4lV+62Nm92s41Xal4kyBdlLtDvHXZj\r 5NZgYqbK6xAyTOocweGZhWXc9ZxMo9aW19l4AYdumxEwfVn9oIPngrjMVC2wJuUgcrhUD2xdqFT/\r SljPL23A8Z3gzseKGoTYRbk4s23C5G5wHyb6XYplNjc/6yabr9JaT5RMvrkWOgLHS3KITQ1QtdDS\r oHLlFGPumVaaLgEMDdtMm6o0hqdzXACGgyHrh1CzjkQQoNMWSpQdF+gpyXpw+kpV1d+AXb33qp7e\r rWoUyYMGHM3zqGm2LZYnsbPkQUb9sN/Y+iN/ZP4hLiOACaXJtIyMCwqa458YqYCCJj0Ia2JgGFan\r d83LO0onpsvUYyYkiBNt9VACOTYlQzfJ1W5ewkpMWgQF2sUAqltTwQ6VJ+WVWNRfhLX8zWolvxgy\r 2AMMjmOQQiTK5iBD75pVz8yigzidX+sPl3/uC/99ihnI7FBO8hjyIJ1iIuMCIB6ihkgCEAdR7wyx\r Lnbqyn5GJ28twxjKO+qD5Jv3iMkYBoM6MFCnqIIunAXma724BE50A9oFhAkbiF6SWPIjPFK+WW3V\r 71d9ey61c4iTT6ZzTyL2DCW8cDSCtdqHc7wLJ/5mnLgbscD7KLqkZzACosc4LWd8LIhB0zT66JU7\r vBGG2Md234AIrz+4Q8SYQ0sAg2Tp9Q8hyx8vIstsIWBgxZyFMwIkAxXWmEYRNa1MtOBAXJsVQnKM\r i5bZW1Lw/ABW7hryRtcoKd3AGk9vM4Owxikl8Bu0RdEb1gzL+oMqVfgh8kALS2KyGpmDGMBivWmN\r iQbW5Gc2Sz3ThJ+v7qGbzJaq4FHofofO1LkQSiTi7GA1exZuESycHzAoJoDC9p5AkRATuvWTUL6U\r DN8ncILGSL2JV5dXuCFgyDQNyCCka4n2xNXbkvMgxKQ6mI+OOVdgjg6MibkWYnIMQMHp4HnpTZSm\r uurmd+JSy1n5xnV9C2nJFQyAiC0zpGdPxbXsmaqsvwLMmgiMABTZE1/NSUtQOvFLbC4se2dt4XVJ\r yEJMWwKHIorQOB3iz52ViWHsMWXwAQgpT3KZ00g9N7JFSzFKpmJdYkv/LG16p4fgTjfQODe9BZZZ\r OMSip537GlH2gM71Hukvd57B2Dt8K8UnX+HFJRIyJVB0zJaj1qQSNqYlZGngpfDE8+683iZuGRxm\r DkUZyCEY6Riy+ZbxJYGO44XOImzwsUoHsYwgy0u8UJxf4xFnQNssX/8Dfo3KxzdnpBCG1aarZ18+\r xiTBMYAR8/AbWNafh9X+ZeJ5GAgaGQrIziO+Xozz8h+AX4oxMSbRLWsa8U0DHoGR8kcEh5nDbFEJ\r nCqCY+WFAhVfUVGq8O3yuuThZAoGIjN0yxSPgdno07yNstnK+SZbuYjPCVl7gNlVk+s9JZ9LveEm\r 06e8Wn9e/pUyw1eT+BkBxsorDgpO3HmlOnzkXlVXxBwTGROYhgDq6FEIeoChvtsBJrjqoDMUIwko\r wpQIDOpYySvaTNmrlOp0TAsjW3QwKeC4iCf87PhXbH/P1eF37TIT3i/LQx9Wxyw6/CSN6UkEeReU\r 7ipY6b9GGGFDRArWjOGk/hdwc/MyVc0+zUzyTF+pii16JcQOaxpTCk2K9hQwIrOk0g1bxNNoDKYZ\r Xj8J88bdt0vSMrXIEuVToBnWS9j++MUmP+Fvyb/udA5bs+ZJ3HLjM87Nvo4AaimNEboRMLKuqije\r rmB8ju7lpyRwSOLp4fUYBoNPqap4KRaTj2hffa0pqLbBzIIpycP78BqfF8+EYp4BDDal9LZWDAcg\r BfdhyapMyiG23o09G/h2xTenL3nvaXq0fjmYHb/pSy6guLhuNIDiyHyK+YG3/LTX8I/BGLpJnyLM\r AbVMPwiT6cthPLxJZXYk7/qYmMswS/qDC2B1xwXK13equriFtt8m8fhfetqHqE2pzamV1OpQmeb4\r hPwJKaGPUS+Lr6roAMdKlvy1mFJgDcX5JB88wSi+2ZCU8JrDXFvo0dOPsDI7AXmhY/9MhOGzlRo9\r xde58mV8/S2UL8XcKFYu57P7L3ZY3avA/IRXLH4CMLpv2D1TGiBLKL6O082Xwa4912GWjYKm6IWG\r enC6grXTG/EN8UFBOFTAwLBT9rwo14dJY36Zi2gj6QCDIwDR6NcU1jNzuFRRkr8tCRRqWHhNzZA7\r tzBXmS8oW54TQHNKWuZkyqWNDWNB3TcFX8lPHZbz6b6L63pycyqaIyzJGKEygxKBEe+j3A0w23ih\r 6u35hMoHj0vZboj+dPRInRwhmBKvle41YpPW0rH4eh9NywfWOCcAcW0FuTpXORFkeTGzaYFJSvIz\r n9KMEA9VsQCl2xxO9onZWFX3zab7Lq3r2ZfC6quQQx39svS2gFEEijRmTBbBAXermj30DGV2vU8N\r 1i5hO1Mp4gXdeCRo/Wtbjk7vZmMLStiyLLk4K+CiKsXSgyzADnNQkEoUXLgSICG4e87b+BXFmmcL\r sH1BgU2dPpPQfno22XxbXeOPOcmLLzpH5fr/mFJOpkRNZUbAEY8U4pZ9qjr8KgXFlaq/4/VoV34N\r TL6bbRa6pfkmuWjfqu0CI6/6RGDktzqAoyJAGN8pCFsX69it2TXalIdsnIHSNYkrA1a6Q/V884Zy\r c/7Rcu5u9Rw1Un6TSOvb94KXA0Y8ga5Dk0CLATHBY/BI8MyFmt6uytnt4PO9Khs9W9nxc5Tpk8bk\r j6EYfAedPAyLrzuuDjtJ3EK8E8sVJsQnGF10iGMYsNhUaNI1L6ZXU2A4c3N/yG35H7sN95/VRv3V\r auJuqQu4v3aZEiEmvXJkqg6tTMf4uJSo4pde3SO/RQuPmEQVGwoP3BVilhjVLrhh3a40WFz1IyM+\r oB6u00kr9GEgDYD/NwY8ZDaW5WKxL053YVPFVyq8HqKaffbrQawd/VdTRyrazslM5qQrUzKnTdpu\r SFbuYvaOOrZUxGr3FbRlck+grD3lVJXtWdsmMMf/HP+/gRwH5jgwx4H5mf75PwEGAHpGByzrcXaA\r AAAAAElFTkSuQmCC",
  transform: "matrix(0.6857 0 0 0.6857 0 0)"
}))), 'Instagram');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var Whatsapp = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("circle", {
  id: "Oval",
  fill: "#25D366",
  cx: "24",
  cy: "24",
  r: "24"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M34.6,13.4C31.8,10.6,28,9,24.1,9C15.9,9,9.2,15.6,9.2,23.9c0,2.6,0.6,5.1,2,7.4L9.1,39l7.9-2c2.1,1.2,4.6,1.8,7.1,1.8l0,0l0,0c8.1,0,14.9-6.6,14.9-14.9C38.8,19.9,37.3,16.2,34.6,13.4z M24.1,36.2L24.1,36.2c-2.2,0-4.4-0.6-6.3-1.7l-0.4-0.2l-4.7,1.2l1.3-4.6l-0.3-0.4c-1.3-1.9-1.9-4.3-1.9-6.5c0-6.9,5.6-12.3,12.3-12.3c3.3,0,6.4,1.3,8.8,3.6s3.6,5.5,3.6,8.8C36.4,30.6,30.8,36.2,24.1,36.2z M30.8,27c-0.3-0.2-2.2-1.1-2.6-1.2c-0.3-0.1-0.5-0.2-0.9,0.2c-0.3,0.4-1,1.2-1.2,1.5c-0.2,0.2-0.4,0.3-0.9,0.1c-0.3-0.2-1.6-0.5-3-1.8c-1.1-1-1.8-2.2-2-2.6c-0.2-0.3,0-0.5,0.2-0.8c0.2-0.2,0.3-0.4,0.5-0.6c0.2-0.2,0.2-0.3,0.3-0.6c0.1-0.2,0.1-0.4,0-0.6s-0.9-2-1.2-2.8c-0.3-0.8-0.6-0.6-0.9-0.6c-0.2,0-0.4,0-0.8,0c-0.2,0-0.6,0.1-1,0.4c-0.3,0.3-1.3,1.3-1.3,3.1c0,1.8,1.3,3.6,1.5,3.9c0.2,0.2,2.6,4,6.3,5.6c0.9,0.4,1.6,0.6,2.1,0.8c0.9,0.3,1.7,0.2,2.4,0.1c0.8-0.1,2.2-0.9,2.5-1.7c0.3-0.9,0.3-1.6,0.2-1.7C31.4,27.2,31.1,27.2,30.8,27z",
  id: "Path",
  fill: "#FFFFFF"
}))), 'Whatsapp');

/*eslint-disable */

var BuyOnline = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M16.913 8.49411L12.9037 2.4829C12.4763 1.83903 11.5294 1.83903 11.102 2.4829L7.09265 8.49411H2.26091C1.51964 8.49411 1.00022 9.21921 1.23288 9.91719L4.35484 19.2884C4.57668 19.9539 5.1935 20.3976 5.89689 20.3976H18.1034C18.8014 20.3976 19.4236 19.9485 19.6455 19.2884L22.7674 9.91719C23.0001 9.21921 22.4807 8.49411 21.7394 8.49411H16.913ZM12.0056 5.03132L14.3105 8.48869H9.69519L12.0056 5.03132ZM17.7193 18.2333H6.29188L3.76508 10.6584H20.2406L17.7193 18.2333Z",
  fill: "#E87722"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M12.0067 16.1665C12.957 16.1665 13.7273 15.3962 13.7273 14.4459C13.7273 13.4956 12.957 12.7253 12.0067 12.7253C11.0565 12.7253 10.2861 13.4956 10.2861 14.4459C10.2861 15.3962 11.0565 16.1665 12.0067 16.1665Z",
  fill: "#E87722"
}))), "BuyOnline");

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var MinusBig = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("svg", {
  width: "60",
  height: "60",
  viewBox: "0 0 16 5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.5 2H0V1.5C0 0.6715 0.6715 0 1.5 0H16V0.5C16 1.3285 15.3285 2 14.5 2Z",
  fill: "#E87722"
}))), "minusBig");

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var PlusBig = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("svg", {
  width: "60",
  height: "60",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9 7V1.5C9 0.6715 8.3285 0 7.5 0H7V7H1.5C0.6715 7 0 7.6715 0 8.5V9H7V14.5C7 15.3285 7.6715 16 8.5 16H9V9H14.5C15.3285 9 16 8.3285 16 7.5V7H9Z",
  fill: "#E87722"
}))), "plusBig");

var NamedIcon$1 = function NamedIcon(props) {
  var icon = props.icon;

  switch (icon) {
    case "minusBig":
      return /*#__PURE__*/React__default.createElement(MinusBig, icon);

    case "plusBig":
      return /*#__PURE__*/React__default.createElement(PlusBig, icon);

    case "arrow-up":
      return /*#__PURE__*/React__default.createElement(ArrowUp, props);

    case "arrow-right":
      return /*#__PURE__*/React__default.createElement(ArrowRight, props);

    case "arrow-down":
      return /*#__PURE__*/React__default.createElement(ArrowDown, props);

    case "arrow-left":
      return /*#__PURE__*/React__default.createElement(ArrowLeft, props);

    case "chevron-up":
      return /*#__PURE__*/React__default.createElement(ChevronUp, props);

    case "chevron-right":
      return /*#__PURE__*/React__default.createElement(ChevronRight, props);

    case "chevron-down":
      return /*#__PURE__*/React__default.createElement(ChevronDown, props);

    case "chevron-left":
      return /*#__PURE__*/React__default.createElement(ChevronLeft, props);

    case "tick":
      return /*#__PURE__*/React__default.createElement(Tick, props);

    case "tick-circle":
      return /*#__PURE__*/React__default.createElement(TickCircle, props);

    case "close":
      return /*#__PURE__*/React__default.createElement(Close, props);

    case "close-circle":
      return /*#__PURE__*/React__default.createElement(CloseCircle, props);

    case "menu":
      return /*#__PURE__*/React__default.createElement(Menu, props);

    case "search":
      return /*#__PURE__*/React__default.createElement(SearchIcon, props);

    case "share":
      return /*#__PURE__*/React__default.createElement(Share, props);

    case "filter":
      return /*#__PURE__*/React__default.createElement(Filter, props);

    case "edit":
      return /*#__PURE__*/React__default.createElement(Edit, props);

    case "chat":
      return /*#__PURE__*/React__default.createElement(Chat, props);

    case "business":
      return /*#__PURE__*/React__default.createElement(Business, props);

    case "account":
      return /*#__PURE__*/React__default.createElement(Account, props);

    case "location":
      return /*#__PURE__*/React__default.createElement(Location, props);

    case "info":
      return /*#__PURE__*/React__default.createElement(Info, props);

    case "stepper-plus":
      return /*#__PURE__*/React__default.createElement(StepperPlus, props);

    case "stepper-minus":
      return /*#__PURE__*/React__default.createElement(StepperMinus, props);

    case "time":
      return /*#__PURE__*/React__default.createElement(Time, props);

    case "alert":
      return /*#__PURE__*/React__default.createElement(Alert, props);

    case "direction":
      return /*#__PURE__*/React__default.createElement(Direction, props);

    case "download":
      return /*#__PURE__*/React__default.createElement(Download, props);

    case "dropdown":
      return /*#__PURE__*/React__default.createElement(DropdownIcon, props);

    case "double-chevron-up":
      return /*#__PURE__*/React__default.createElement(DoubleChevronUp, props);

    case "double-chevron-down":
      return /*#__PURE__*/React__default.createElement(DoubleChevronDown, props);

    case "double-chevron-left":
      return /*#__PURE__*/React__default.createElement(DoubleChevronLeft, props);

    case "double-chevron-right":
      return /*#__PURE__*/React__default.createElement(DoubleChevronRight, props);

    case "enter-key":
      return /*#__PURE__*/React__default.createElement(EnterKey, props);

    case "bookmark":
      return /*#__PURE__*/React__default.createElement(Bookmark, props);

    case "play-button":
      return /*#__PURE__*/React__default.createElement(PlayButton, props);

    case "document":
      return /*#__PURE__*/React__default.createElement(Document, props);

    case "document-certified-copy":
      return /*#__PURE__*/React__default.createElement(DocumentCertifiedCopy, props);

    case "document-copy":
      return /*#__PURE__*/React__default.createElement(DocumentCopy, props);

    case "plus":
      return /*#__PURE__*/React__default.createElement(PlusIcon, props);

    case "minus":
      return /*#__PURE__*/React__default.createElement(MinusIcon, props);

    case "plus-circle":
      return /*#__PURE__*/React__default.createElement(PlusCircle, props);

    case "minus-circle":
      return /*#__PURE__*/React__default.createElement(MinusCircle, props);

    case "quote":
      return /*#__PURE__*/React__default.createElement(Quote, props);

    case "available-online":
      return /*#__PURE__*/React__default.createElement(AvailableOnline, props);

    case "career":
      return /*#__PURE__*/React__default.createElement(Career, props);

    case "press":
      return /*#__PURE__*/React__default.createElement(Press, props);

    case "corporate-governance":
      return /*#__PURE__*/React__default.createElement(CorporateGovernance, props);

    case "call-email":
      return /*#__PURE__*/React__default.createElement(CallEmail, props);

    case "language-globe":
      return /*#__PURE__*/React__default.createElement(LanguageGlobe, props);

    case "live-chat":
      return /*#__PURE__*/React__default.createElement(LiveChat, props);

    case "feedback":
      return /*#__PURE__*/React__default.createElement(Feedback, props);

    case "claims":
      return /*#__PURE__*/React__default.createElement(Claims, props);

    case "investor-information":
      return /*#__PURE__*/React__default.createElement(InvestorInformation, props);

    case "investment":
      return /*#__PURE__*/React__default.createElement(Investment, props);

    case "reset":
      return /*#__PURE__*/React__default.createElement(Reset, props);

    case "no-result":
      return /*#__PURE__*/React__default.createElement(NoResultIcon, props);

    case "multiple-media":
      return /*#__PURE__*/React__default.createElement(MultipleMedia, props);

    case "category-tier":
      return /*#__PURE__*/React__default.createElement(CategoryTier, props);

    case "filtered":
      return /*#__PURE__*/React__default.createElement(Filtered, props);

    case "briefcase":
      return /*#__PURE__*/React__default.createElement(Briefcase, props);

    case "tags":
      return /*#__PURE__*/React__default.createElement(Tags, props);

    case "document-download":
      return /*#__PURE__*/React__default.createElement(DocumentDownload, props);

    case "question-mark":
      return /*#__PURE__*/React__default.createElement(QuestionMark, props);

    case "history":
      return /*#__PURE__*/React__default.createElement(History, props);

    case "original":
      return /*#__PURE__*/React__default.createElement(Original, props);

    case "certified":
      return /*#__PURE__*/React__default.createElement(Certified, props);

    case "email":
      return /*#__PURE__*/React__default.createElement(Email, props);

    case "notification-icon":
      return /*#__PURE__*/React__default.createElement(NotificationIcon, props);

    case "call":
      return /*#__PURE__*/React__default.createElement(Call, props);

    case "products":
      return /*#__PURE__*/React__default.createElement(Products, props);

    case "products-outline":
      return /*#__PURE__*/React__default.createElement(ProductsOutline, props);

    case "claims-outline":
      return /*#__PURE__*/React__default.createElement(ClaimsOutline, props);

    case "support-outline":
      return /*#__PURE__*/React__default.createElement(SupportOutline, props);

    case "rewards-outline":
      return /*#__PURE__*/React__default.createElement(RewardsOutline, props);

    case "chat-outline":
      return /*#__PURE__*/React__default.createElement(ChatOutline, props);

    case "call-outline":
      return /*#__PURE__*/React__default.createElement(CallOutline, props);

    case "call-dual-tone":
      return /*#__PURE__*/React__default.createElement(CallDualTone, props);

    case "link-outline":
      return /*#__PURE__*/React__default.createElement(LinkOutLine, props);

    case "link-out":
      return /*#__PURE__*/React__default.createElement(LinkOut, props);

    case "warning":
      return /*#__PURE__*/React__default.createElement(Warning, props);

    case "info-filled":
      return /*#__PURE__*/React__default.createElement(InfoFilled, props);

    case "team":
      return /*#__PURE__*/React__default.createElement(Team, props);

    case "announcements":
      return /*#__PURE__*/React__default.createElement(Announcements, props);

    case "bookmark-filled":
      return /*#__PURE__*/React__default.createElement(BookmarkFilled, props);

    case "contact":
      return /*#__PURE__*/React__default.createElement(Contact, props);

    case "user":
      return /*#__PURE__*/React__default.createElement(User, props);

    case "lock-open":
      return /*#__PURE__*/React__default.createElement(LockOpen, props);

    case "rewards":
      return /*#__PURE__*/React__default.createElement(Rewards, props);

    case "zoom-in":
      return /*#__PURE__*/React__default.createElement(ZoomIn, props);

    case "zoom-out":
      return /*#__PURE__*/React__default.createElement(ZoomOut, props);

    case "fax":
      return /*#__PURE__*/React__default.createElement(Fax, props);

    case "mobile":
      return /*#__PURE__*/React__default.createElement(Mobile, props);

    case "show-more":
      return /*#__PURE__*/React__default.createElement(ShowMore, props);

    case "hospital":
      return /*#__PURE__*/React__default.createElement(Hospital, props);

    case "outpatient":
      return /*#__PURE__*/React__default.createElement(Outpatient, props);

    case "savings":
      return /*#__PURE__*/React__default.createElement(Savings, props);

    case "licensed-sellers":
      return /*#__PURE__*/React__default.createElement(LicensedSellers, props);

    case "loan-application":
      return /*#__PURE__*/React__default.createElement(LoanApplication, props);

    case "patient":
      return /*#__PURE__*/React__default.createElement(Patient, props);

    case "death":
      return /*#__PURE__*/React__default.createElement(Death, props);

    case "disability":
      return /*#__PURE__*/React__default.createElement(Disability, props);

    case "accident":
      return /*#__PURE__*/React__default.createElement(Accident, props);

    case "critical-illness":
      return /*#__PURE__*/React__default.createElement(CriticalIllness, props);

    case "inpatient":
      return /*#__PURE__*/React__default.createElement(Inpatient, props);

    case "bank":
      return /*#__PURE__*/React__default.createElement(Bank, props);

    case "cancer":
      return /*#__PURE__*/React__default.createElement(Cancer, props);

    case "care-card":
      return /*#__PURE__*/React__default.createElement(CareCard, props);

    case "fwd-logo":
      return /*#__PURE__*/React__default.createElement(FWDLogo, _extends({
        viewBox: "0 0 105 36"
      }, props));

    case "magnifiying":
      return /*#__PURE__*/React__default.createElement(Magnifiying, props);

    case "SeeFull":
      return /*#__PURE__*/React__default.createElement(SeeFull, props);

    case "Oops":
      return /*#__PURE__*/React__default.createElement(Oops, props);

    case "swap":
      return /*#__PURE__*/React__default.createElement(Swap, props);

    case "clear-filter":
      return /*#__PURE__*/React__default.createElement(ClearIcon, props);

    case "premium-payment":
      return /*#__PURE__*/React__default.createElement(PremiumPayment, props);

    case "best-seller":
      return /*#__PURE__*/React__default.createElement(BestSeller, props);

    case "promotion":
      return /*#__PURE__*/React__default.createElement(Promotion, props);

    case "e-document":
      return /*#__PURE__*/React__default.createElement(EDocument, props);

    case "success":
      return /*#__PURE__*/React__default.createElement(Success, props);

    case "logout":
      return /*#__PURE__*/React__default.createElement(Logout, props);

    case "see-password":
      return /*#__PURE__*/React__default.createElement(SeePassword, props);

    case "see-full":
      return /*#__PURE__*/React__default.createElement(SeeFull, props);

    case "branch":
      return /*#__PURE__*/React__default.createElement(Branch, props);

    case "calendar":
      return /*#__PURE__*/React__default.createElement(Calender, props);

    case "locator-fill":
      return /*#__PURE__*/React__default.createElement(LocatorFill, props);

    case "locator-marker":
      return /*#__PURE__*/React__default.createElement(LocatorMarker, props);

    case "yen":
      return /*#__PURE__*/React__default.createElement(Yen, props);

    case "facebook":
      return /*#__PURE__*/React__default.createElement(Facebook, props);

    case "twitter":
      return /*#__PURE__*/React__default.createElement(Twitter, props);

    case "line":
      return /*#__PURE__*/React__default.createElement(Line, props);

    case "youtube":
      return /*#__PURE__*/React__default.createElement(Youtube, props);

    case "wechat":
      return /*#__PURE__*/React__default.createElement(Wechat, props);

    case "linkedin":
      return /*#__PURE__*/React__default.createElement(LinkedIn, props);

    case "instagram":
      return /*#__PURE__*/React__default.createElement(Instagram, props);

    case "whatsapp":
      return /*#__PURE__*/React__default.createElement(Whatsapp, props);

    case "buy-online":
      return /*#__PURE__*/React__default.createElement(BuyOnline, props);

    default:
      return /*#__PURE__*/React__default.createElement(PlusIcon, props);
  }
};

NamedIcon$1.propTypes = {
  icon: PropTypes.string,
  fill: PropTypes.string
};
var icons = ["arrow-up", "arrow-right", "arrow-down", "arrow-left", "chevron-up", "chevron-right", "chevron-down", "chevron-left", "tick", "tick-circle", "close", "close-circle", "menu", "search", "share", "filter", "edit", "chat", "business", "account", "location", "info", "stepper-plus", "stepper-minus", "time", "alert", "direction", "download", "dropdown", "double-chevron-up", "double-chevron-down", "double-chevron-left", "double-chevron-right", "enter-key", "bookmark", "play-button", "document", "document-certified-copy", "document-copy", "plus", "minus", "plus-circle", "minus-circle", "quote", "available-online", "career", "press", "corporate-governance", "call-email", "language-globe", "live-chat", "feedback", "claims", "investor-information", "investment", "reset", "no-result", "multiple-media", "category-tier", "filtered", "briefcase", "tags", "document-download", "question-mark", "history", "original", "certified", "email", "notification-icon", "call", "products", "products-outline", "claims-outline", "support-outline", "rewards-outline", "chat-outline", "call-outline", "call-dual-tone", "link-outline", "link-out", "warning", "info-filled", "team", "announcements", "bookmark-filled", "contact", "user", "lock-open", "rewards", "zoom-in", "zoom-out", "fax", "mobile", "show-more", "hospital", "outpatient", "savings", "licensed-sellers", "loan-application", "patient", "death", "disability", "accident", "critical-illness", "inpatient", "bank", "cancer", "care-card", "fwd-logo", "magnifiying", "SeeFull", "Oops", "swap", "clear-filter", "premium-payment", "best-seller", "promotion", "e-document", "success", "logout", "see-password", "see-full", "branch", "calendar", "locator-fill", "locator-marker", "yen", "facebook", "twitter", "line", "youtube", "wechat", "linkedin", "instagram", "whatsapp", "buy-online"];

/*9fbef606107a605d69c0edbcd8029e5d*/
var paymentModes = {
  YEARLY: 'yearly',
  SINGLE: 'single',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  HALFYEARLY: 'halfyearly',
  'SEMI-ANNUALLY': 'semi-annually',
  ANNUALLY: 'annually'
};
var planListSliderTypes = {
  FORYOU: 'foryou',
  ALLPLANS: 'allplans'
};
var productPlanList = {
  COMPONENT_ANCHOR_ID: 'productPlanList'
};
var calculatorInitializers = {
  CALCULATOR: 'calculator',
  RECOMMENDER: 'recommender',
  ENQUIRY: 'enquiry',
  BOOKANAGENT: 'bookAnAgent'
};
var calculateTypes = {
  PREMIUM: 'premium',
  SUMASSURED: 'sumassured'
};
var apiNames = {
  SELECTEDPAYMENTMODE: 'selectedPaymentMode',
  COUNTRYCODE: 'countryCode'
};
var calculatorPages = {
  AGECAPTUREPAGE: 'AgeCapturePage',
  AVAILABILITYDAYPAGE: 'availabilityDayPage',
  AVAILABILITYPAGE: 'availabilityPage',
  AVAILABILITYTIMEPAGE: 'availabilityTimePage',
  CONDITIONALPAGE: 'conditionalPage',
  DAYPAGE: 'dayPage',
  DAYSPAGE: 'daysPage',
  DOBPAGE: 'dobPage',
  EMAILPAGE: 'emailPage',
  EMAILSUBMITPAGE: 'emailSubmitPage',
  GENDERCAPTUREPAGE: 'GenderCapturePage',
  PHONEENQUIRYTHANKYOUPAGE: 'phoneEnquiryThankYouPage',
  PHONEPAGE: 'phonePage',
  PHONESUBMITPAGE: 'phoneSubmitPage',
  PLANCHOICEPAGE: 'PlanChoicePage',
  PREFERREDCONTACTPAGE: 'preferredContactPage',
  PREMIUMPAGE: 'premiumPage',
  RECOMMEDOROUTPUTPAGE: 'recommedorOutputPage',
  SPLASHSCREENPAGE: 'splashScreenPage',
  SUBMITPAGE: 'submitPage',
  SUMASSUREDFIRSTPAGE: 'sumAssuredFirstPage',
  SUMASSUREDSECONDPAGE: 'sumAssuredSecondPage',
  SUMMARYPAGE: 'summaryPage',
  TIMEPAGE: 'timePage',
  TIMEPAGE2: 'timePage2',
  CALCULATORSUMASSUREDPAGE: 'sumAssured',
  CALCULATORPREMIUMPAGE: 'premium',
  PHONEBOOKANAGENTTHANKYOUPAGE: 'phoneBookAnAgentThankYouPage'
};
var enquiryInitializer = {
  SUPPORT: 'SUPPORT',
  PRODUCT_CARD: 'PRODUCT_CARD',
  PLAN_CARD: 'PLAN_CARD',
  FOOTER_HEADER: 'FOOTER_HEADER',
  CONTENT_BLOCK: 'CONTENT_BLOCK'
};
var productTypes = {
  PACKAGE: 'Package Page',
  RIDER: 'Rider Page'
};
var buttonModes = {
  SIMPLELINK: 'SimpleLink',
  SIMPLEPRIMARYLINK: 'SimplePrimaryLink',
  PRIMARY: 'Primary',
  SECONDARY: 'Secondary',
  HOTCHIP: 'HotChip'
};
var pageTypes = {
  INDIVIDUAL: 'individual',
  BUSINESS: 'business',
  HOMEPAGE: 'homePage'
};
var linkListTypes = {
  GENERICLINK: 'generic_link',
  CHAT: 'chat',
  CALL: 'call',
  MODAL: 'modal',
  SEARCH: 'search'
};
var GroupEnquiryPages = {
  PRIVACYPOLICY_SECTION: 'privacy-policy'
};
var CallBackPages = {
  PRIVACYPOLICY_SECTION: 'privacy-policy'
};
var GTMdataLayerProperties = {
  TITLE: 'title',
  YEAR_OF_BIRTH: 'year_of_birth',
  EMAIL: 'email',
  PHONE_NUMBER: 'phone_number',
  LIVING_IN: 'living_in',
  GENDER: 'gender',
  BASED_ON: 'based_on',
  ASSURANCE_SUM: 'assurance_sum',
  PREMIUM_BUDGET: 'premium_budget',
  CURRENCY: 'currency',
  PAYMENT_TERM: 'payment_term',
  SUM_ASSURED: 'sumAssured',
  PREMIUM: 'premium',
  COVERAGE: 'coverage',
  ENQUIRY: 'enquiry',
  CALCULATOR: 'calculator',
  RECOMMENDER: 'recommender',
  BOOK_AN_AGENT: 'bookAnAgent',
  ENQUIRY_GENERAL: 'enquiryGeneral',
  ENQUIRY_PRODUCT: 'enquiryProduct',
  ENQUIRY_BUSINESS: 'enquiryBusiness',
  ENQUIRY_GROUP: 'enquiryGroup',
  USER_DETAILS: 'user_details',
  USER_PREFERENCES: 'user_preferences',
  CONTACT_FORM: 'contact_form',
  CONTACT_TOPIC: 'contact_topic',
  BUSINESS_DETAILS: 'business_details',
  BUSINESS_TYPE: 'business_type',
  NUMBER_OF_INSURED: 'number_of_insured',
  PRODUCT: 'product',
  ORGANISATION: 'organisation',
  NAME: 'name',
  CONTACT_ON: 'contactOn',
  CONTACT_TIMING: 'contactTiming',
  CONTACT_VIA: 'contact_via',
  EXISTING_GROUP_PLAN: 'existingGroupPlan',
  INTERESTED_COVERAGE: 'interested_coverage'
};
var API = {
  SAVE_LEAD: 'saveLead',
  SEND_EMAIL: 'sendEmail',
  CUSTOM_ACTION: 'customAction'
};
var formFieldApiNames = {
  SELECTED_PAYMENT_MODE: 'selectedPaymentMode',
  GENDER: 'gender',
  FIRST_NAME: 'firstName',
  MIDDLE_NAME: 'middleName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  CELLPHONE: 'cellPhone',
  HOME_PROVINCE: 'homeProvince',
  PREFERRED_TIME: 'preferredTime',
  PREFERRED_DAY: 'preferredDay',
  EXPECTED_INSURANCE_TYPE: 'expectedInsuranceType',
  QUERY_REASON: 'queryReason',
  PREFERRED_CONTACT_METHOD: 'preferredContactMethod',
  COMMENT: 'comment',
  CONSENT_CHECKBOX: 'consentCheckBox',
  SUM_ASSURED: 'sumAssured'
};
var disclosurePopups = {
  EVERY_TIME_IN_SESSION: 'every-time-in-session',
  ONCE_IN_BROWSING_SESSION: 'once-in-browsing-session',
  ACCEPTED_DISCLOSURES: 'acceptedDisclosures',
  SESSION_TIMEOUT: '1440'
};
var listTypes = {
  GENERAL_PRODUCT_LIST: 'general-product-list',
  PRODUCT_PAGES_LIST: 'product-pages-list',
  SEARCH_RESULTS: 'search-results'
};
var templateIds = {
  PRODUCT_TEMPLATE_ID: '0ba5819e-97b4-4ed8-8f4c-2363603b4faf',
  PACKAGE_TEMPLATE_ID: '8c431675-a9b1-4774-b7e9-8a30e7522fe3',
  RIDER_TEMPLATE_ID: 'ab750b30-eb3c-4f78-acd7-7124675e31b9'
};
var articleListingDesign = {
  LIVE: 'articleCards',
  CSR: 'csrCards'
};
var locations = {
  PH: 'fwd-ph',
  TH: 'fwd-th',
  HK: 'fwd-hk',
  KH: 'fwd-kh'
};
var infoCardVariation = {
  ESG: 'ESG'
};

var styles$1b = function styles(theme) {
  return style$c(theme);
};
var Link = /*#__PURE__*/React__default.forwardRef(function Link(props, ref) {
  var _clsx, _clsx2;

  var children = props.children,
      classes = props.classes,
      _props$size = props.size,
      size = _props$size === void 0 ? "medium" : _props$size,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? false : _props$icon,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      role = props.role,
      className = props.className,
      component = props.component,
      href = props.href,
      variant = props.variant,
      onClick = props.onClick,
      _props$onKeyPress = props.onKeyPress,
      onKeyPress = _props$onKeyPress === void 0 ? null : _props$onKeyPress,
      link = props.link,
      _props$disablePointer = props.disablePointer,
      disablePointer = _props$disablePointer === void 0 ? false : _props$disablePointer,
      _props$linktype = props.linktype,
      linktype = _props$linktype === void 0 ? "" : _props$linktype,
      _props$target = props.target,
      target = _props$target === void 0 ? "_self" : _props$target,
      _props$color = props.color,
      color = _props$color === void 0 ? "initial" : _props$color,
      _props$iconAltText = props.iconAltText,
      iconAltText = _props$iconAltText === void 0 ? "" : _props$iconAltText,
      _props$linkMode = props.linkMode,
      linkMode = _props$linkMode === void 0 ? buttonModes.SIMPLELINK : _props$linkMode,
      _props$hasMotion = props.hasMotion,
      hasMotion = _props$hasMotion === void 0 ? true : _props$hasMotion,
      _props$disableTabInde = props.disableTabIndex,
      disableTabIndex = _props$disableTabInde === void 0 ? false : _props$disableTabInde,
      onMouseEnter = props.onMouseEnter;
  var type = get$1(props, "type", "action"); // const pageEditing = get(props, 'sitecoreContext.pageEditing', false);

  linkMode === buttonModes.SIMPLEPRIMARYLINK && (type = "caption");
  var startIcon = icon && /*#__PURE__*/React__default.createElement("span", {
    className: clsx("startIcon", classes.startIcon, (_clsx = {}, _defineProperty(_clsx, classes["iconSize".concat(capitalize(size))], size != null), _defineProperty(_clsx, classes["tertiary"], children === undefined), _clsx))
  }, /*#__PURE__*/React__default.createElement(NamedIcon$1, {
    icon: icon,
    alt: iconAltText
  }));
  return /*#__PURE__*/React__default.createElement(MatLink, {
    ref: ref,
    rel: "noopener noreferrer",
    tabIndex: disableTabIndex ? null : parseInt("".concat(tabIndex)),
    role: role,
    "data-locator": props["data-locator"],
    className: clsx((_clsx2 = {}, _defineProperty(_clsx2, "hyperlink-".concat(color), color !== "initial" && color !== null && type === "hyperlink"), _defineProperty(_clsx2, "link-action-".concat(color), color !== "initial" && color !== null && type !== "caption" && type !== "hyperlink"), _defineProperty(_clsx2, "link-caption-".concat(color), color !== "initial" && type === "caption"), _defineProperty(_clsx2, classes.displayInlineFlex, linktype !== "modelpopup" && component === "div"), _defineProperty(_clsx2, classes.noPointer, disablePointer === true), _defineProperty(_clsx2, classes.PrimaryLinkWrapper, linkMode === buttonModes.SIMPLEPRIMARYLINK), _defineProperty(_clsx2, "motionColorTransition", hasMotion), _clsx2), className),
    component: component,
    href: href,
    onClick: onClick,
    onKeyPress: onKeyPress,
    variant: variant
    /*Most of the anchor tags do not have underlines,any such underlines must be overriden at higher components wherever required*/
    ,
    underline: "none",
    target: component === "a" ? target : undefined,
    "data-type": props["data-type"],
    color: "inherit",
    "aria-label": props.ariaLabel,
    onMouseEnter: onMouseEnter
  }, startIcon, linkMode === buttonModes.SIMPLEPRIMARYLINK ? /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    color: color,
    component: "span",
    className: classes.primaryLinkText
  }, props.children) : props.children, link && link.value && link.value.text);
});
var StyledMemoizedLink = withStyles(styles$1b, {
  name: "MuiLink"
})( /*#__PURE__*/React__default.memo(Link));
StyledMemoizedLink.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  size: PropTypes.oneOf(["small", "medium", "large", "none"]),
  icon: PropTypes.oneOf(icons),
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  role: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  href: PropTypes.string,
  variant: PropTypes.string,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  link: PropTypes.shape({
    value: PropTypes.shape({
      text: PropTypes.string
    })
  }),
  disablePointer: PropTypes.bool,
  linktype: PropTypes.string,
  target: PropTypes.string,
  color: PropTypes.string,
  iconAltText: PropTypes.string,
  linkMode: PropTypes.oneOf(Object.values(buttonModes)),
  hasMotion: PropTypes.bool,
  disableTabIndex: PropTypes.bool
};

var AddMouseListener = function AddMouseListener() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      useKeyBoard = _useState2[0],
      setKeyBoardUse = _useState2[1];

  useEffect(function () {
    document.body.addEventListener('mousedown', function () {
      setKeyBoardUse(false);
    });
    document.body.addEventListener('keydown', function (event) {
      if (event.keyCode === 9) {
        setKeyBoardUse(true);
      }

      return function () {
        document.body.removeEventListener('mousedown');
        document.body.removeEventListener('keydown');
      };
    });
  }, [useKeyBoard]);
  return {
    useKeyBoard: useKeyBoard
  };
};

/**
 *
 * Secure Hash Algorithm (SHA256)
 */
var SHA256 = function SHA256(s) {
  var chrsz = 8;

  function safe_add(x, y) {
    var lsw = (x & 0xffff) + (y & 0xffff);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xffff;
  }

  function S(X, n) {
    return X >>> n | X << 32 - n;
  }

  function R(X, n) {
    return X >>> n;
  }

  function Ch(x, y, z) {
    return x & y ^ ~x & z;
  }

  function Maj(x, y, z) {
    return x & y ^ x & z ^ y & z;
  }

  function Sigma0256(x) {
    return S(x, 2) ^ S(x, 13) ^ S(x, 22);
  }

  function Sigma1256(x) {
    return S(x, 6) ^ S(x, 11) ^ S(x, 25);
  }

  function Gamma0256(x) {
    return S(x, 7) ^ S(x, 18) ^ R(x, 3);
  }

  function Gamma1256(x) {
    return S(x, 17) ^ S(x, 19) ^ R(x, 10);
  }

  function core_sha256(m, l) {
    var K = new Array( // eslint-disable-line no-array-constructor
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786, 0xfc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x6ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2);
    var HASH = new Array( // eslint-disable-line no-array-constructor
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19);
    var W = new Array(64);
    var a, b, c, d, e, f, g, h;
    var T1, T2;
    m[l >> 5] |= 0x80 << 24 - l % 32;
    m[(l + 64 >> 9 << 4) + 15] = l;

    for (var i = 0; i < m.length; i += 16) {
      a = HASH[0];
      b = HASH[1];
      c = HASH[2];
      d = HASH[3];
      e = HASH[4];
      f = HASH[5];
      g = HASH[6];
      h = HASH[7];

      for (var j = 0; j < 64; j++) {
        if (j < 16) W[j] = m[j + i];else W[j] = safe_add(safe_add(safe_add(Gamma1256(W[j - 2]), W[j - 7]), Gamma0256(W[j - 15])), W[j - 16]);
        T1 = safe_add(safe_add(safe_add(safe_add(h, Sigma1256(e)), Ch(e, f, g)), K[j]), W[j]);
        T2 = safe_add(Sigma0256(a), Maj(a, b, c));
        h = g;
        g = f;
        f = e;
        e = safe_add(d, T1);
        d = c;
        c = b;
        b = a;
        a = safe_add(T1, T2);
      }

      HASH[0] = safe_add(a, HASH[0]);
      HASH[1] = safe_add(b, HASH[1]);
      HASH[2] = safe_add(c, HASH[2]);
      HASH[3] = safe_add(d, HASH[3]);
      HASH[4] = safe_add(e, HASH[4]);
      HASH[5] = safe_add(f, HASH[5]);
      HASH[6] = safe_add(g, HASH[6]);
      HASH[7] = safe_add(h, HASH[7]);
    }

    return HASH;
  }

  function str2binb(str) {
    var bin = Array(); // eslint-disable-line no-array-constructor

    var mask = (1 << chrsz) - 1;

    for (var i = 0; i < str.length * chrsz; i += chrsz) {
      bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << 24 - i % 32;
    }

    return bin;
  }

  function Utf8Encode(string) {
    string = string.replace(/\r\n/g, '\n');
    var utftext = '';

    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode(c >> 6 | 192);
        utftext += String.fromCharCode(c & 63 | 128);
      } else {
        utftext += String.fromCharCode(c >> 12 | 224);
        utftext += String.fromCharCode(c >> 6 & 63 | 128);
        utftext += String.fromCharCode(c & 63 | 128);
      }
    }

    return utftext;
  }

  function binb2hex(binarray) {
    var hex_tab = '0123456789abcdef';
    var str = '';

    for (var i = 0; i < binarray.length * 4; i++) {
      str += hex_tab.charAt(binarray[i >> 2] >> (3 - i % 4) * 8 + 4 & 0xf) + hex_tab.charAt(binarray[i >> 2] >> (3 - i % 4) * 8 & 0xf);
    }

    return str;
  }

  s = Utf8Encode(s);
  return binb2hex(core_sha256(str2binb(s), s.length * chrsz));
};

var moveArr = function moveArr(arr, old_index, new_index) {
  while (old_index < 0) {
    old_index += arr.length;
  }

  while (new_index < 0) {
    new_index += arr.length;
  }

  if (new_index >= arr.length) {
    var k = new_index - arr.length;

    while (k-- + 1) {
      arr.push(undefined);
    }
  }

  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
};
/**
 * @param {Array} array of numbers to be accumulated
 */

var sumOfArray = function sumOfArray(arr) {
  return arr.reduce(function (a, b) {
    return a + b;
  }, 0);
}; // conditional wrapper for child elements

var ConditionalWrap = function ConditionalWrap(_ref) {
  var condition = _ref.condition,
      wrap = _ref.wrap,
      children = _ref.children;
  return condition ? wrap(children) : children;
};
var getGTMSharedKeyVal = function getGTMSharedKeyVal(url, dataLocator) {
  var domainReg = /^http[s]?:\/\/([0-9A-Za-z-\\.:]+)\//i;
  var langReg = /\/([a-z]{2})(?:-[A-Z]{2})?\//g;

  if (!url) {
    return dataLocator;
  } else {
    url = url.replace(/#.*$/, "");
    url = url.split("?")[0];
    url = url.slice("-1") !== "/" ? "".concat(url, "/") : url;
    var domain = url.match(domainReg);
    url = domain ? "/".concat(url.substr(domain[0].length)) : url;
    var lang = url.match(langReg);
    url = lang ? url.substr(lang[0].length) : url;
    var routeArr = url.split("/");
    var route = routeArr && routeArr[routeArr.length - 2] ? routeArr[routeArr.length - 2] : "";
    return route || dataLocator;
  }
};
var hasParents = function hasParents(elm, selector) {
  var parentElement = get$1(elm, "parentElement", null);

  if (parentElement) {
    if (parentElement.classList.contains(selector)) {
      return parentElement;
    } else {
      return hasParents(parentElement, selector);
    }
  } else {
    return false;
  }
}; // to generate classnames without a random number at the end

var setFormDataForGTM = function setFormDataForGTM(formData) {
  return {
    formDetails: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, formData), get$1(formData, formFieldApiNames.FIRST_NAME, "") && _defineProperty({}, formFieldApiNames.FIRST_NAME, SHA256(formData.firstName))), get$1(formData, formFieldApiNames.MIDDLE_NAME, "") && _defineProperty({}, formFieldApiNames.MIDDLE_NAME, SHA256(formData.middleName))), get$1(formData, formFieldApiNames.LAST_NAME, "") && _defineProperty({}, formFieldApiNames.LAST_NAME, SHA256(formData.lastName))), get$1(formData, formFieldApiNames.EMAIL, "") && _defineProperty({}, formFieldApiNames.EMAIL, SHA256(formData.email))), get$1(formData, formFieldApiNames.CELLPHONE, "") && _defineProperty({}, formFieldApiNames.CELLPHONE, SHA256(formData.cellPhone)))
  };
}; // Get URL query params

var getUrlQueryParams = function getUrlQueryParams() {
  if (typeof window !== "undefined") {
    var queryParams = window.location.search.substr(1).split("&").reduce(function (qs, query) {
      var chunks = query.split("=");
      var key = chunks[0];
      var value = decodeURIComponent(chunks[1] || "");
      var valueLower = value.trim().toLowerCase();

      if (valueLower === "true" || value === "false") {
        value = Boolean(value);
      } else if (!isNaN(Number(value))) {
        value = Number(value);
      }

      qs[key] = value;
      return qs;
    }, {});
    return queryParams;
  } else return;
};
var count = 0;
var getRandomValues = function getRandomValues() {
  if (typeof window !== "undefined") {
    var typedArray = new Uint16Array(1);
    return window.crypto ? window.crypto.getRandomValues(typedArray)[0] : window.msCrypto.getRandomValues(typedArray)[0];
  } else {
    return count++;
  }
}; // count the steps in conversational form

var getStepCount = function getStepCount(stepCountList, name) {
  var length = stepCountList.length;
  var id = length + 1;
  var found = stepCountList.some(function (el) {
    return el.pageName === name;
  });
  if (!found) stepCountList.push({
    id: id,
    pageName: name
  });
  var stepCountIndex = stepCountList.findIndex(function (el) {
    return el.pageName === name;
  });
  return {
    stepCountIndex: stepCountIndex + 1,
    stepCountList: stepCountList
  };
};
var getMaxHeight = function getMaxHeight(elms) {
  return Math.max.apply(Math, _toConsumableArray(_toConsumableArray(elms).map(function (elm) {
    return elm.getBoundingClientRect().height;
  })));
};
/**
 * @param {Array} array of html nodes
 * @param {Array} array of classnames to be added to the parent
 * @returns
 */

var wrapNodes = function wrapNodes() {
  var _wrapper$classList;

  var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var parentClasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  /* istanbul ignore else */
  if (children[0] && children[0].parentNode.classList.contains("wrapped")) return;
  var wrapper = document.createElement("div");

  (_wrapper$classList = wrapper.classList).add.apply(_wrapper$classList, ["wrapped"].concat(_toConsumableArray(parentClasses)));

  children.forEach(function (child) {
    child.parentNode.insertBefore(wrapper, child);
    wrapper.appendChild(child);
  });
}; // get GTM data for the conversational form

var getDataForGTM = function getDataForGTM() {
  var pageFieldObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var siteLanguage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var _pageFieldObj$optionF = pageFieldObj.optionForGTA,
      optionForGTA = _pageFieldObj$optionF === void 0 ? {} : _pageFieldObj$optionF,
      _pageFieldObj$apiName = pageFieldObj.apiName,
      apiName = _pageFieldObj$apiName === void 0 ? "" : _pageFieldObj$apiName,
      _pageFieldObj$value = pageFieldObj.value,
      value = _pageFieldObj$value === void 0 ? "" : _pageFieldObj$value;

  if (!isEmpty(optionForGTA) && apiName === "homeProvince") {
    return {
      user_details: _defineProperty({}, apiName, optionForGTA[value]),
      user_preferences: {}
    };
  } else if (siteLanguage === "th" && !isEmpty(optionForGTA) && (apiName === "preferredTime" || apiName === "preferredDay" || apiName === "expectedInsuranceType")) {
    return {
      user_details: {},
      user_preferences: _defineProperty({}, apiName, optionForGTA[value])
    };
  } else if ((apiName === "email" || apiName === "cellPhone") && value !== "") {
    return {
      user_details: _defineProperty({}, apiName, SHA256(value.replace(" ", ""))),
      user_preferences: {}
    };
  } else if (apiName === "queryReason" || apiName === "preferredContactMethod" || apiName === "expectedInsuranceType" || apiName === "preferredDay" || apiName === "preferredTime" || apiName === "comment" || apiName === "consentCheckBox" || apiName === "sumAssured") {
    return _objectSpread2({
      user_details: {},
      user_preferences: _defineProperty({}, apiName, value)
    }, isEmpty(optionForGTA) ? {
      user_preferences: _defineProperty({}, apiName, value)
    } : {
      user_preferences: _defineProperty({}, apiName, optionForGTA[value])
    });
  } else if (apiName === "selectedPaymentMode" && value !== "") {
    return {
      user_details: {},
      user_preferences: _defineProperty({}, apiName, value.split("|")[0])
    };
  } else if (apiName !== "" && value !== "") {
    return {
      user_details: _defineProperty({}, apiName, value),
      user_preferences: {}
    };
  } else {
    return {
      user_details: {},
      user_preferences: {}
    };
  }
}; // Get English Date from Buddhist Date

var getEnglishCalendarDate = function getEnglishCalendarDate(buddhistDate) {
  return buddhistDate.split("-").map(function (dateItem) {
    if (dateItem.length === 4) {
      return (parseInt(dateItem) - 543).toString();
    } else {
      return dateItem;
    }
  }).join("-");
};
var setDisclosureAcceptanceInLocalStorage = function setDisclosureAcceptanceInLocalStorage(localStorageKey, isAccepted, activeDisclosureItem) {
  /* istanbul ignore else */
  if (typeof window !== "undefined" && window.localStorage) {
    var acceptedDisclosureList = JSON.parse(localStorage.getItem(localStorageKey)) || [];
    var activeDisclosureIndex = acceptedDisclosureList.findIndex(function (disclosureItem) {
      return disclosureItem.id === activeDisclosureItem.id;
    });

    if (isAccepted) {
      if (activeDisclosureIndex === -1) {
        acceptedDisclosureList.push(activeDisclosureItem);
      } else {
        acceptedDisclosureList.splice(activeDisclosureIndex, 1, activeDisclosureItem);
      }
    } else {
      if (activeDisclosureIndex !== -1) {
        acceptedDisclosureList.splice(activeDisclosureIndex, 1);
      }
    }

    localStorage.setItem(localStorageKey, JSON.stringify(acceptedDisclosureList));
  }
};
var checkDisclosureExpiryInLocalStorage = function checkDisclosureExpiryInLocalStorage(localStorageKey, acceptedDisclosureList) {
  // filter expired disclosure key
  var disclosureListNotExpiredYet = acceptedDisclosureList.filter( // item.disclosureSessionTimeout is in minutes
  function (item) {
    return item.disclosureAcceptedTime >= Date.now() - item.disclosureSessionTimeout * 60 * 1000;
  }); // update filtered data in local storage

  if (typeof window !== "undefined" && window.localStorage) {
    localStorage.setItem(localStorageKey, JSON.stringify(disclosureListNotExpiredYet));
  }

  return disclosureListNotExpiredYet;
};
var checkDisclosureAlreadyAddedInLocalStorage = function checkDisclosureAlreadyAddedInLocalStorage(localStorageKey, disclosureId) {
  /* istanbul ignore else */
  if (typeof window !== "undefined" && window.localStorage) {
    var allAcceptedDisclosureKeyList = JSON.parse(localStorage.getItem(localStorageKey)) || []; // filter expired disclosure key

    var disclosureListNotExpiredYet = checkDisclosureExpiryInLocalStorage(localStorageKey, allAcceptedDisclosureKeyList);
    /* istanbul ignore else */

    var disclosureData = disclosureListNotExpiredYet.find(function (disclosureItem) {
      return disclosureItem.id === disclosureId;
    });

    if (!isEmpty(disclosureData)) {
      return true;
    }
  }

  return false;
};
var setDisclosureButtonWidth = function setDisclosureButtonWidth(buttonClass, buttonContainerId) {
  var buttonList = document.querySelectorAll(".".concat(buttonClass));
  var buttonWrap = document.getElementById(buttonContainerId);
  var viewportWidth = window.innerWidth;

  if (buttonList && buttonWrap) {
    var maxWidth = 0;
    var wrapperWidth = 0;
    var elementWidth = 0;
    var className = "sideBySide";
    var classNameWrapper = "sideBySideLayout";

    for (var i = 0; i < buttonList.length; i++) {
      // need to check the maximum value of all
      if (maxWidth < buttonList[i].offsetWidth) maxWidth = buttonList[i].offsetWidth;
    }

    wrapperWidth = buttonList.length === 2 ? buttonWrap.offsetWidth / 2 : buttonWrap.offsetWidth;
    elementWidth = maxWidth;

    if (maxWidth >= wrapperWidth - 20) {
      className = "stacked";
      classNameWrapper = "stackedLayout";

      if (viewportWidth > 600) {
        elementWidth = maxWidth >= buttonWrap.offsetWidth ? buttonWrap.offsetWidth + "px" : maxWidth + 20 + "px";
      } else {
        elementWidth = "100%";
      }
    } else {
      elementWidth = elementWidth === 200 ? "".concat(elementWidth, "px") : "".concat(elementWidth + 2, "px");
    }

    for (var _i = 0; _i < buttonList.length; _i++) {
      // set the width to the max plus the padding 24 left and 24 right
      buttonList[_i].style.width = elementWidth;

      buttonList[_i].classList.add(className);
    }

    buttonWrap.classList.add(classNameWrapper);
  }
};
var getAcceptedRiskDisclosureKeyList = function getAcceptedRiskDisclosureKeyList(localStorageKey) {
  var acceptedRiskDisclosureKeyList = [];
  /* istanbul ignore else */

  if (typeof window !== 'undefined' && window.localStorage) {
    var allAcceptedDisclosureKeyList = JSON.parse(window.localStorage.getItem(localStorageKey)) || [];
    var disclosureListNotExpiredYet = checkDisclosureExpiryInLocalStorage(localStorageKey, allAcceptedDisclosureKeyList);
    disclosureListNotExpiredYet.forEach(function (disclosureItem) {
      if (disclosureItem.isRiskDisclosure) {
        acceptedRiskDisclosureKeyList.push(disclosureItem.id);
      }
    });
  }

  return acceptedRiskDisclosureKeyList;
};
var isIE11$1 = function isIE11() {
  return typeof window !== "undefined" && /Trident\/|MSIE/.test(window.navigator.userAgent);
};
var isIEorEdge = typeof window !== "undefined" && typeof document !== "undefined" && (document.documentMode || window.navigator && /Edge/.test(window.navigator.userAgent));
var getIsTouchDevice = function getIsTouchDevice() {
  return typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches;
};
var isEdge = /edge/.test(typeof window !== "undefined" && window.navigator && window.navigator.userAgent.toLowerCase());
var isChrome = /chrome/.test(typeof window !== "undefined" && window.navigator && window.navigator.userAgent.toLowerCase()) && !isEdge;
var isSafari = /safari/.test(typeof window !== "undefined" && window.navigator && window.navigator.userAgent.toLowerCase()) && !isEdge;
var isWebkit = /webkit/.test(typeof window !== "undefined" && window.navigator && window.navigator.userAgent.toLowerCase());
var isWindows = /windows/.test(typeof window !== "undefined" && window.navigator && window.navigator.userAgent.toLowerCase());
var formatCurrency = function formatCurrency(num) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ",";
  var roundingOff = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var decimalDigit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (!isNaN(num) && num !== "") {
    var roundOffNum = num;

    if (!roundingOff) {
      var decimalPlaceNum = Math.pow(10, decimalDigit);
      roundOffNum = Math.floor(parseFloat(num) * decimalPlaceNum) / decimalPlaceNum;
    } // Pass only 'id' or 'en' locale based upon separator, it'll return formated number


    var locale = separator === "." ? "id" : "en";
    var numToFormat = roundOffNum;
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: decimalDigit,
      maximumFractionDigits: decimalDigit
    }).format(numToFormat);
  } else {
    // It is expected that there no further operation performed on the returned value
    return "NaN";
  }
};
var customScrollbarDesign = function customScrollbarDesign() {
  return isChrome && isWebkit || isSafari && isWebkit || getIsTouchDevice() && !isIEorEdge;
};
var isRichText = function isRichText(text) {
  return /<\/?[a-z][\s\S]*>/i.test(text);
};

var useStyles$1a = makeStyles(styles$1e);
/**
 * Logo Component
 * @param {object} props Component props
 * @param {number} props.transitionDuration value of transitionDuration, default Value - 400
 * @param {function} props.onClick click event of logo
 * @param {string} props.href link url
 * @param {string} props.value display value
 * @param {object} props.icon icon
 */

var Logo = function Logo(props) {
  var transitionDuration = get$1(props, 'transitionDuration', 400);

  var _onClick = get$1(props, 'onClick', null);

  var href = get$1(props, 'href', null);
  var value = get$1(props, 'value', null);
  var icon = get$1(props, 'icon', null);
  var classes = useStyles$1a({
    transitionDuration: transitionDuration
  }); // refs

  var logoRef = useRef();

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root)
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: logoRef
  }, /*#__PURE__*/React__default.createElement(ConditionalWrap, {
    wrap: function wrap(children) {
      return /*#__PURE__*/React__default.createElement("h1", {
        style: {
          fontSize: '1em',
          lineHeight: '1em',
          margin: 0
        }
      }, children);
    }
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    href: href,
    className: clsx(classes.logo, classes.static, 'fwd-logo', _defineProperty({}, 'hideFocusonClick', !useKeyBoard)),
    onClick: function onClick(e) {
      e.preventDefault();

      _onClick();
    },
    ariaLabel: "FWD Logo"
  }, value && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "srOnly"
  }, value), get$1(icon, 'value.src', null) ? /*#__PURE__*/React__default.createElement("img", {
    src: get$1(icon, 'value.src', '/'),
    alt: get$1(icon, 'value.alt', null),
    className: 'svglogo'
  }) : /*#__PURE__*/React__default.createElement(FWDLogo, {
    viewBox: '0 0 105 36',
    className: 'svglogo',
    inlineTitle: value
  })))));
};

Logo.propTypes = {
  transitionDuration: PropTypes.number,
  onClick: PropTypes.func,
  href: PropTypes.string,
  value: PropTypes.string,
  icon: PropTypes.shape({
    value: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    })
  })
};
var Logo$1 = /*#__PURE__*/React__default.memo(Logo);

var styleFunction = styleFunctionSx(compose(borders$1, display, flexbox, positions, palette, shadows, sizing, spacing, typography));
/**
 * @ignore - do not document.
 */

var Box = styled("div")(styleFunction, {
  name: "MuiBox"
});

var styles$1a = function styles(theme) {
  var _root, _inner;

  return {
    root: (_root = {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '56px',
      height: '56px'
    }, _defineProperty(_root, theme.breakpoints.up('xl'), {
      width: '71px',
      height: '71px'
    }), _defineProperty(_root, '&$menuOpen', {
      background: 'rgba(0, 0, 0, 0)'
    }), _root),
    showBackDrop: _defineProperty({}, theme.breakpoints.down('lg'), {
      background: 'linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 100%)'
    }),
    menuOpen: {},
    inner: (_inner = {
      transform: 'scale(0.6)',
      display: 'inline-block'
    }, _defineProperty(_inner, theme.breakpoints.up('xl'), {
      display: 'none'
    }), _defineProperty(_inner, "cursor", 'pointer'), _defineProperty(_inner, '&$active', {
      '& $line1': {
        width: '34px',
        transform: 'translateX(8px) rotate(45deg)',
        borderBottomRightRadius: '3px',
        borderTopLeftRadius: '3px'
      },
      '& $line2': {
        opacity: 0
      },
      '& $line3': {
        width: '34px',
        transform: 'translateX(8px) rotate(-45deg)',
        borderBottomLeftRadius: '3px',
        borderTopRightRadius: '3px',
        borderBottomRightRadius: 0
      }
    }), _inner),
    active: {},
    line: {
      transition: motionTypes.moveUpAndFade.in,
      borderBottomLeftRadius: '1px',
      borderBottomRightRadius: '1px',
      borderTopLeftRadius: '1px',
      borderTopRightRadius: '1px',
      opacity: 1,
      transformOrigin: 'left center'
    },
    orange: {
      backgroundColor: theme.palette.colors.orange.main
    },
    white: {
      backgroundColor: theme.palette.colors.white.main,
      '&$active': {
        backgroundColor: theme.palette.colors.orange.main
      }
    },
    line1: {
      width: theme.spacing(4),
      height: theme.spacing(0.5)
    },
    line2: {
      marginTop: theme.spacing(1),
      width: theme.spacing(5),
      height: theme.spacing(0.5)
    },
    line3: {
      marginTop: theme.spacing(1),
      width: theme.spacing(3),
      height: theme.spacing(0.5),
      borderBottomRightRadius: '3px'
    }
  };
};

var useStyles$19 = makeStyles(styles$1a);
/**
 * Hamburger Icon Component
 * @param {object} props Component props
 * @param {bool} props.open Shows Menu State open or closed
 * @param {function} props.onClick click event of hamburger component
 * @param {bool} props.showBackDrop Whether to display backdrop or not
 * @param {string} props.color Color of Hamburger Icon
 */

var HamburgerIcon = function HamburgerIcon(props) {
  var _clsx;

  var onClick = props.onClick,
      open = props.open,
      _props$color = props.color,
      color = _props$color === void 0 ? 'white' : _props$color,
      showBackDrop = props.showBackDrop;
  var classes = useStyles$19({
    color: color
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, (_clsx = {}, _defineProperty(_clsx, classes.menuOpen, open), _defineProperty(_clsx, classes.showBackDrop, showBackDrop), _clsx)),
    onClick: onClick,
    role: "presentation"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.inner, _defineProperty({}, classes.active, open))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx('line', classes.line, classes.line1, classes[color], _defineProperty({}, classes.active, open))
  }), /*#__PURE__*/React__default.createElement("div", {
    className: clsx('line', classes.line, classes.line2, classes[color], _defineProperty({}, classes.active, open))
  }), /*#__PURE__*/React__default.createElement("div", {
    className: clsx('line', classes.line, classes.line3, classes[color], _defineProperty({}, classes.active, open))
  })));
};

HamburgerIcon.propTypes = {
  color: PropTypes.oneOf(['white', 'orange']),
  open: PropTypes.bool,
  showBackDrop: PropTypes.bool,
  onClick: PropTypes.func
};
var HamburgerIcon$1 = /*#__PURE__*/React__default.memo(HamburgerIcon);

var styles$19 = function styles() {
  //Apply theme here if Necessary
  return {
    root: {}
  };
};

var useStyles$18 = makeStyles(styles$19);
/**
 * Paper Component Material UI
 * @param {object} props Component props
 */

var FwdPaper = function FwdPaper(props) {
  var classes = useStyles$18();
  return /*#__PURE__*/React__default.createElement(Paper, _extends({
    className: classes.root
  }, props));
};

FwdPaper.propTypes = {
  elevation: PropTypes.number,
  variant: PropTypes.oneOf(['outlined']),
  square: PropTypes.bool
};

var style$b = function style(theme) {
  var _objectSpread2$1;

  return {
    /* Styles applied to the root element. */
    rootBtn: _objectSpread2(_objectSpread2({}, theme.typography.button), {}, (_objectSpread2$1 = {
      display: 'inline-block',
      boxSizing: 'border-box',
      textTransform: 'none',
      minHeight: 32,
      padding: '8px 24px',
      minWidth: '120px',
      width: 'auto',
      height: 'auto',
      fontWeight: theme.typography.fontWeights.bolder,
      '&.rippleEffect': {
        overflow: 'hidden',
        '&:before': {
          content: '""',
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          left: '-100%'
        }
      }
    }, _defineProperty(_objectSpread2$1, theme.breakpoints.up('lg'), {
      minWidth: '200px'
    }), _defineProperty(_objectSpread2$1, '&:hover', {
      textDecoration: 'none'
    }), _defineProperty(_objectSpread2$1, '& .buttonText', {
      fontWeight: theme.typography.fontWeights.bold
    }), _defineProperty(_objectSpread2$1, '&.variant-HotChip', {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }), _defineProperty(_objectSpread2$1, '& .MuiButton-startIcon', {
      alignSelf: 'flex-start',
      zIndex: '1'
    }), _objectSpread2$1)),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // assure the correct width for iOS Safari
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit',
      '& p': {
        marginBottom: '0px'
      }
    },

    /* Styles applied to the root element if `variant="extended"`. */
    buttonText: {
      textAlign: 'initial',
      fontWeight: theme.typography.fontWeights.bolder,
      padding: theme.spacing(0.25, 0),
      zIndex: '1',
      '&.MuiTypography-h6': {
        marginBottom: 0
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },
    fullWidth: {
      width: '100%',
      minWidth: '100%'
    },
    maxWidthApplied: {
      maxWidth: theme.spacing(45),
      height: 'auto'
    },

    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: 'inherit',
      margin: "".concat(theme.spacing(0, 0.5), " !important")
    },

    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: 'inherit',
      marginRight: -4,
      marginLeft: 8
    },

    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      '& > *:first-child': {
        fontSize: 18,
        margin: 'auto'
      }
    },

    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      '& > *:first-child': {
        fontSize: 22,
        width: '24px',
        height: '24px'
      }
    },

    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      '& > *:first-child': {
        fontSize: 24
      }
    },
    iconButton: {
      minWidth: 'auto',
      height: 'auto',
      padding: theme.spacing(0.5),
      width: 'auto',
      '& .MuiButton-startIcon': {
        margin: 0
      }
    },
    alignCenter: {
      textAlign: 'center'
    }
  };
};

var PushEvent = function PushEvent(eventObject) {
  var customEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  if (customEvent && typeof customEvent === "function") {
    customEvent(eventObject);
  } else if (typeof window !== 'undefined' && window.dataLayer !== undefined) {
    window.dataLayer.push(eventObject);
  }
};

var _excluded$b = ["children", "classes", "className", "outlined", "component", "color", "disabled", "disableFocusRipple", "size", "variant", "icon", "prefixIcon", "hasBorderRadius", "iconButton", "gaCategoryName", "type", "fullWidth", "maxWidthApplied", "disableTabIndex", "GTMSharedKey", "disablePushEvent", "hasMotionElevate", "extraGAData"];
var styles$18 = function styles(theme) {
  return style$b(theme);
};
/**
 * Button component allow users to take actions, and make choices, with a single click or tap.
 */

var Button$1 = /*#__PURE__*/React__default.forwardRef(function Button(props, ref) {
  var _clsx, _clsx2;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$outlined = props.outlined,
      outlined = _props$outlined === void 0 ? false : _props$outlined,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      color = props.color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'primary' : _props$variant,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? false : _props$icon,
      _props$prefixIcon = props.prefixIcon,
      prefixIcon = _props$prefixIcon === void 0 ? true : _props$prefixIcon,
      _props$hasBorderRadiu = props.hasBorderRadius,
      hasBorderRadius = _props$hasBorderRadiu === void 0 ? true : _props$hasBorderRadiu,
      _props$iconButton = props.iconButton,
      iconButton = _props$iconButton === void 0 ? false : _props$iconButton,
      gaCategoryName = props.gaCategoryName,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$maxWidthApplie = props.maxWidthApplied,
      maxWidthApplied = _props$maxWidthApplie === void 0 ? false : _props$maxWidthApplie,
      _props$disableTabInde = props.disableTabIndex,
      disableTabIndex = _props$disableTabInde === void 0 ? false : _props$disableTabInde,
      _props$GTMSharedKey = props.GTMSharedKey,
      GTMSharedKey = _props$GTMSharedKey === void 0 ? null : _props$GTMSharedKey,
      _props$disablePushEve = props.disablePushEvent,
      disablePushEvent = _props$disablePushEve === void 0 ? false : _props$disablePushEve,
      _props$hasMotionEleva = props.hasMotionElevate,
      hasMotionElevate = _props$hasMotionEleva === void 0 ? true : _props$hasMotionEleva,
      _props$extraGAData = props.extraGAData,
      extraGAData = _props$extraGAData === void 0 ? {} : _props$extraGAData,
      other = _objectWithoutProperties(props, _excluded$b); // override if iconButton is true

  /* istanbul ignore else */


  if (iconButton) {
    disableFocusRipple = true;
  }

  var startIcon = icon && /*#__PURE__*/React__default.createElement("span", {
    className: clsx(classes.startIcon, (_clsx = {}, _defineProperty(_clsx, classes["iconSize".concat(capitalize(size))], size != null), _defineProperty(_clsx, classes['tertiary'], children === undefined), _clsx))
  }, /*#__PURE__*/React__default.createElement(NamedIcon$1, {
    icon: icon
  }));

  var unHovered = function unHovered(e) {
    return e.currentTarget.classList.add('unHovered');
  };

  var hovered = function hovered(e) {
    return e.currentTarget.classList.remove('unHovered');
  };

  return /*#__PURE__*/React__default.createElement(ButtonBase, _extends({
    onMouseEnter: hovered,
    onMouseLeave: unHovered,
    className: clsx(hasMotionElevate ? 'motionElevate' : '', hasBorderRadius ? getBorderRadius('small') : '', disableFocusRipple ? '' : 'rippleEffect', classes.rootBtn, (_clsx2 = {}, _defineProperty(_clsx2, classes.extended, variant === 'extended'), _defineProperty(_clsx2, classes.outlined, outlined === true), _defineProperty(_clsx2, classes["size".concat(capitalize(size))], size !== 'large'), _defineProperty(_clsx2, classes.disabled, disabled), _defineProperty(_clsx2, "btn-color-".concat(color, "-default"), color && outlined === false), _defineProperty(_clsx2, 'btn-color-common-default', color && outlined === false), _defineProperty(_clsx2, 'btn-color-common-outlined', color && outlined === true), _defineProperty(_clsx2, "btn-color-".concat(color, "-outlined"), color && outlined === true), _defineProperty(_clsx2, classes.iconButton, iconButton), _defineProperty(_clsx2, classes.fullWidth, fullWidth), _defineProperty(_clsx2, classes.maxWidthApplied, maxWidthApplied), _defineProperty(_clsx2, "iconButton", iconButton), _clsx2), className),
    component: component,
    disabled: disabled,
    disableRipple: true,
    type: type,
    ref: ref,
    onClick: function onClick() {
      if (props['data-locator'] && !disablePushEvent) {
        PushEvent(_objectSpread2({
          event: 'buttonClick',
          buttonTitle: GTMSharedKey || getGTMSharedKeyVal(props.link, props['data-locator']),
          componentName: gaCategoryName ? gaCategoryName : props['data-locator'],
          destinationUrl: props.link ? props.link : undefined
        }, extraGAData), props.gtmPushEvent);
      }

      props.onClick && props.onClick();
    }
  }, other, disableTabIndex ? {
    tabIndex: -1
  } : {}), /*#__PURE__*/React__default.createElement("span", {
    className: classes.label
  }, prefixIcon && startIcon, children && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    component: "span",
    variant: "button",
    className: clsx(classes.buttonText, _defineProperty({}, classes.alignCenter, !icon))
  }, children), !prefixIcon && startIcon));
});
var StyledMemoizedButton = withStyles$1(styles$18, {
  name: 'MuiButton'
})( /*#__PURE__*/React__default.memo(Button$1));
StyledMemoizedButton.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * @ignore
   */
  type: PropTypes.string,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['round', 'extended'])
};

var styles$17 = function styles(theme) {
  var _root;

  return {
    /* Styles applied to the root element. */
    root: (_root = {
      width: '100%',
      marginLeft: 'auto',
      boxSizing: 'border-box',
      marginRight: 'auto',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }, _defineProperty(_root, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }), _defineProperty(_root, theme.breakpoints.up('md'), {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4)
    }), _root),

    /* Styles applied to the root element if `fixed={true}`. */
    fixed: Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
      var value = theme.breakpoints.values[breakpoint];

      if (value !== 0) {
        acc[theme.breakpoints.up(breakpoint)] = {
          maxWidth: value
        };
      }

      return acc;
    }, {}),

    /* Styles applied to the root element if `maxWidth="xs"`. */
    maxWidthXs: _defineProperty({}, theme.breakpoints.up('xs'), {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }),

    /* Styles applied to the root element if `maxWidth="sm"`. */
    maxWidthSm: _defineProperty({}, theme.breakpoints.up('sm'), {
      maxWidth: theme.breakpoints.values.sm
    }),

    /* Styles applied to the root element if `maxWidth="md"`. */
    maxWidthMd: _defineProperty({}, theme.breakpoints.up('md'), {
      maxWidth: theme.breakpoints.values.md
    }),

    /* Styles applied to the root element if `maxWidth="lg"`. */
    maxWidthLg: _defineProperty({}, theme.breakpoints.up('lg'), {
      maxWidth: theme.breakpoints.values.lg
    }),

    /* Styles applied to the root element if `maxWidth="xl"`. */
    maxWidthXl: _defineProperty({}, theme.breakpoints.up('xl'), {
      maxWidth: theme.breakpoints.values.xl
    }),
    overflowHidden: {
      overflow: 'hidden'
    },
    mobileFluid: {
      paddingLeft: 0,
      paddingRight: 0
    }
  };
};

var _excluded$a = ["classes", "className", "component", "fixed", "maxWidth", "useContainer", "background", "overflowHidden", "section", "mobileFluid", "id", "sectionId", "mergedClass", "footerMargin"];
/**
 * The container centers your content horizontally. It's the most basic layout element.
 *
 * @param {object} classes - To override or extend the styles applied to the component.
 * @param {string} classname - Name of class
 * @param {string} component - The component used for the root node. Default vlaue is 'div'
 * @param {boolean} fixed - to design for a fixed set of sizes instead of trying to accommodate a fully fluid viewport
 * The max-width matches the min-width of the current breakpoint. Set false by default
 * @param {string} maxWidth Determine the max-width of the container.
 * The container width grows with the size of the screen. Set to false to disable. Default value is 'xl'.
 * @param {boolean} useContainer - If container should contained within a container node
 * @param {string} background - Set to null by default
 * @param {boolean} overflowHidden - If true set overflow to 'hidden'. Set to false by default.
 * @param {boolean} section - If container should contained within a section node
 * @param {boolean} mobileFluid - Apply mobileFluid style properies for mobile viewport
 * @param {string} id - Id for container
 * @param {string} sectionId - Id for the section
 * @param {string} mergedClass
 */

var Container = /*#__PURE__*/React__default.forwardRef(function Container(props, ref) {
  var _clsx, _clsx2;

  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$fixed = props.fixed,
      fixed = _props$fixed === void 0 ? false : _props$fixed,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'xl' : _props$maxWidth,
      _props$useContainer = props.useContainer,
      useContainer = _props$useContainer === void 0 ? true : _props$useContainer,
      _props$background = props.background,
      background = _props$background === void 0 ? null : _props$background,
      _props$overflowHidden = props.overflowHidden,
      overflowHidden = _props$overflowHidden === void 0 ? false : _props$overflowHidden,
      _props$section = props.section,
      section = _props$section === void 0 ? true : _props$section,
      _props$mobileFluid = props.mobileFluid,
      mobileFluid = _props$mobileFluid === void 0 ? false : _props$mobileFluid,
      _props$id = props.id,
      id = _props$id === void 0 ? null : _props$id,
      _props$sectionId = props.sectionId,
      sectionId = _props$sectionId === void 0 ? null : _props$sectionId,
      _props$mergedClass = props.mergedClass,
      mergedClass = _props$mergedClass === void 0 ? null : _props$mergedClass,
      _props$footerMargin = props.footerMargin,
      footerMargin = _props$footerMargin === void 0 ? null : _props$footerMargin,
      other = _objectWithoutProperties(props, _excluded$a);

  var container = /*#__PURE__*/React__default.createElement(Component, _extends({
    className: clsx(classes.root, (_clsx = {}, _defineProperty(_clsx, classes.fixed, fixed), _defineProperty(_clsx, classes["maxWidth".concat(capitalize(String(maxWidth)))], maxWidth !== false), _defineProperty(_clsx, classes.mobileFluid, mobileFluid), _clsx), className),
    ref: ref,
    id: id
  }, other));

  if (!useContainer) {
    return props.children;
  }

  if (!section) {
    return container;
  }

  return /*#__PURE__*/React__default.createElement("section", _extends({
    className: clsx(classes.sectionRoot, mergedClass, get$1(props, 'data-sectionProps.className', ''), (_clsx2 = {}, _defineProperty(_clsx2, "bg-color-".concat(background), background !== null), _defineProperty(_clsx2, classes.overflowHidden, overflowHidden), _clsx2)),
    id: sectionId
  }, footerMargin && {
    style: {
      marginTop: "".concat(footerMargin, "px")
    }
  }), container);
});
Container.propTypes = {
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   */
  fixed: PropTypes.bool,

  /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),

  /**
   * if container should contained within a container node
   */
  useContainer: PropTypes.bool,

  /**
   * if container should contained within a section node
   */
  section: PropTypes.bool,

  /**
   * id for the container
   */
  id: PropTypes.string,

  /**
   * id for the section
   */
  sectionId: PropTypes.string
};
var Container$1 = withStyles$1(styles$17, {
  name: 'MuiContainer'
})(Container);

var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  var gridStyles = {};
  GRID_SIZES.forEach(function (size) {
    var key = "grid-".concat(breakpoint, "-").concat(size);

    if (size === true) {
      // For the auto layouting
      gridStyles[key] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
      return;
    }

    if (size === 'auto') {
      gridStyles[key] = {
        flexBasis: 'auto',
        flexGrow: 0,
        maxWidth: 'none'
      };
      return;
    } // Keep 7 significant numbers.


    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41

    gridStyles[key] = {
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    };
  }); // No need for a media query for the first size.

  if (breakpoint === 'xs') {
    Object.assign(globalStyles, gridStyles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = gridStyles;
  }
}

function getOffset(val) {
  var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var parse = parseFloat(val);
  return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
}

function generateGutter(theme, breakpoint) {
  var gutterStyles = {};
  SPACINGS.forEach(function (spacing) {
    var themeSpacing = theme.spacing(spacing);

    if (themeSpacing === 0) {
      return;
    }

    gutterStyles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: "-".concat(getOffset(themeSpacing, 2)),
      width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
      '& > $item': {
        padding: getOffset(themeSpacing, 2)
      }
    };
  });
  return gutterStyles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',


var styles$16 = function styles(theme) {
  return _objectSpread2(_objectSpread2({
    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },

    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: 'border-box',
      margin: '0' // For instance, it's useful when used with a `figure` element.

    },

    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },

    /* Styles applied to the root element if `direction="column"`. */
    'direction-xs-column': {
      flexDirection: 'column'
    },

    /* Styles applied to the root element if `direction="column-reverse"`. */
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },

    /* Styles applied to the root element if `direction="rwo-reverse"`. */
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `wrap="nowrap"`. */
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },

    /* Styles applied to the root element if `wrap="reverse"`. */
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },

    /* Styles applied to the root element if `alignItems="center"`. */
    'align-items-xs-center': {
      alignItems: 'center'
    },

    /* Styles applied to the root element if `alignItems="flex-start"`. */
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },

    /* Styles applied to the root element if `alignItems="flex-end"`. */
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },

    /* Styles applied to the root element if `alignItems="baseline"`. */
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },

    /* Styles applied to the root element if `alignContent="center"`. */
    'align-content-xs-center': {
      alignContent: 'center'
    },

    /* Styles applied to the root element if `alignContent="flex-start"`. */
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },

    /* Styles applied to the root element if `alignContent="flex-end"`. */
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },

    /* Styles applied to the root element if `alignContent="space-between"`. */
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },

    /* Styles applied to the root element if `alignContent="space-around"`. */
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="center"`. */
    'justify-content-xs-center': {
      justifyContent: 'center'
    },

    /* Styles applied to the root element if `justify="flex-end"`. */
    'justify-content-xs-flex-end': {
      justifyContent: 'flex-end'
    },

    /* Styles applied to the root element if `justify="space-between"`. */
    'justify-content-xs-space-between': {
      justifyContent: 'space-between'
    },

    /* Styles applied to the root element if `justify="space-around"`. */
    'justify-content-xs-space-around': {
      justifyContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="space-evenly"`. */
    'justify-content-xs-space-evenly': {
      justifyContent: 'space-evenly'
    }
  }, generateGutter(theme, 'xs')), theme.breakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};

var StyledGrid = withStyles(styles$16)(Grid);

var COMPONENT_DIALOG_CONTAINER = 'Dialog-Container';
var COMPONENT_DIALOG_CLOSE_BUTTON$1 = 'Dialog-Close-Button';

var styles$15 = function styles(theme) {
  var _closeButtonWrap, _closeButton, _slickPrev, _slickNext, _sectionInner, _MuiContainerRoot2, _scrollDialogContentW;

  return {
    /* Styles applied to the root element. */
    root: {
      '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
      },
      '& .MuiBackdrop-root': {
        backgroundColor: 'rgba(24,48,40,0.9)'
      },
      '& h2': {
        fontWeight: fontWeights.bolder
      }
    },

    /* Styles applied to the container element if `scroll="paper"`. */
    scrollPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& form .hasCalculateData': {
        borderBottomWidth: '1px'
      }
    },

    /* Styles applied to the container element if `scroll="body"`. */
    scrollBody: {
      overflowY: 'auto',
      overflowX: 'hidden',
      textAlign: 'center',
      '&:after': {
        content: '""',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0'
      }
    },

    /* Styles applied to the container element. */
    container: {
      height: '100%',
      '@media print': {
        height: 'auto'
      },
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      margin: 32,
      position: 'relative',
      overflowY: 'auto',
      // Fix IE 11 issue, to remove at some point.
      '@media print': {
        overflowY: 'visible',
        boxShadow: 'none'
      }
    },

    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'calc(100% - 64px)',
      '-webkit-overflow-scrolling': 'touch',
      '& .MuiGrid-grid-lg-6': _defineProperty({
        maxWidth: theme.spacing(75)
      }, theme.breakpoints.down('md'), {
        maxWidth: '100%'
      })
    },

    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'left' // 'initial' doesn't work on IE 11

    },

    /* Styles applied to the `Paper` component if `maxWidth=false`. */
    paperWidthFalse: {
      maxWidth: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444),
      '&$paperScrollBody': _defineProperty({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm,
      '&$paperScrollBody': _defineProperty({}, theme.breakpoints.down(theme.breakpoints.values.sm + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md,
      '&$paperScrollBody': _defineProperty({}, theme.breakpoints.down(theme.breakpoints.values.md + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: theme.breakpoints.values.lg,
      '&$paperScrollBody': _defineProperty({}, theme.breakpoints.down(theme.breakpoints.values.lg + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
    paperWidthXl: {
      maxWidth: theme.breakpoints.values.xl,
      '&$paperScrollBody': _defineProperty({}, theme.breakpoints.down(theme.breakpoints.values.xl + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      borderRadius: 0,
      '&$paperScrollBody': {
        margin: 0,
        maxWidth: '100%'
      }
    },
    transparent: {
      background: 'transparent'
    },
    closeButtonWrap: (_closeButtonWrap = {
      height: theme.spacing(12)
    }, _defineProperty(_closeButtonWrap, theme.breakpoints.down('md'), {
      height: theme.spacing(8)
    }), _defineProperty(_closeButtonWrap, '& svg', {
      fill: fwdColors.darkGreen,
      transition: motionTypes.colorTransition,
      transitionProperty: 'background-color'
    }), _closeButtonWrap),

    /* Styles applied to the close button. */
    closeButton: (_closeButton = {
      cursor: 'pointer',
      zIndex: 9,
      width: theme.spacing(4),
      height: theme.spacing(4),
      minWidth: theme.spacing(4),
      minHeight: theme.spacing(4),
      maxWidth: theme.spacing(4),
      borderRadius: '50%',
      padding: 0,
      border: 0,
      lineHeight: 0,
      top: theme.spacing(2),
      right: theme.spacing(2),
      position: 'fixed',
      '&.MuiDialog-closeButton': {
        '&.MuiButtonBase-root': {
          boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
          '& svg': {
            width: theme.spacing(2),
            height: theme.spacing(2),
            '&:hover': {
              backgroundColor: 'transparent'
            },
            '& path': {
              fill: fwdColors.darkGreen
            }
          },
          '&:not(.disabled):hover': {
            boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
            '& svg path': {
              fill: fwdColors.white
            }
          },
          '&:hover': {
            boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
            '& svg': {
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'transparent'
              },
              '& path': {
                fill: fwdColors.white
              }
            }
          }
        }
      },
      '& path': {
        fill: fwdColors.darkGreen
      }
    }, _defineProperty(_closeButton, theme.breakpoints.up('sm'), {
      top: theme.spacing(6),
      right: theme.spacing(6)
    }), _defineProperty(_closeButton, '&.margin50', {
      marginTop: theme.spacing(6.25)
    }), _closeButton),
    dialogContainer: {},
    '-splash': {
      '& .MuiContainer-root': _defineProperty({}, theme.breakpoints.down('md'), {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3)
      })
    },
    '-gallery': {
      maxWidth: '100vw',
      '& $dialogContainer': {
        height: '100%',
        marginTop: '0',
        marginBottom: '0'
      },
      '& .sliderWrap': {
        '& .slick-list': {
          transition: motionTypes.expand.up
        },
        '& .slick-prev': (_slickPrev = {}, _defineProperty(_slickPrev, theme.breakpoints.up('sm'), {
          left: -theme.spacing(6),
          color: theme.palette.colors.orange.main
        }), _defineProperty(_slickPrev, theme.breakpoints.up('md'), {
          left: -theme.spacing(7)
        }), _slickPrev),
        '& .slick-next': (_slickNext = {}, _defineProperty(_slickNext, theme.breakpoints.up('sm'), {
          right: -theme.spacing(6),
          color: theme.palette.colors.orange.main
        }), _defineProperty(_slickNext, theme.breakpoints.up('md'), {
          right: -theme.spacing(7)
        }), _slickNext),
        '& .slick-prev, .slick-next': {
          transition: motionTypes.colorTransition,
          transitionProperty: 'background-color',
          '&:hover': _defineProperty({
            background: alpha(fwdColors.orange, 0.2),
            borderRadius: theme.spacing(0.5)
          }, theme.breakpoints.up('sm'), {
            color: theme.palette.colors.white.contrastTextAction
          })
        }
      },
      '& .galleryCaption': {
        color: 'white',
        fontSize: theme.typography.T11,
        lineHeight: theme.typography.lineHeight.L14,
        fontWeight: theme.typography.fontWeights.normal
      },
      '& .sectionInner': (_sectionInner = {}, _defineProperty(_sectionInner, theme.breakpoints.only('xs'), {
        paddingLeft: 0,
        paddingRight: 0
      }), _defineProperty(_sectionInner, theme.breakpoints.between('sm', 'md'), {
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6)
      }), _sectionInner)
    },
    'paper-gallery': _defineProperty({
      background: 'transparent',
      justifyContent: 'center'
    }, "@media screen and (orientation:landscape) and (max-device-width: ".concat(theme.breakpoints.values.md, "px)"), {
      justifyContent: 'flex-start',
      '& .sectionInner': {
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6)
      }
    }),
    '-disclosure': {
      '& .MuiDialog-paper': {
        overflowY: 'initial',
        '& .MuiContainer-root': (_MuiContainerRoot2 = {
          padding: theme.spacing(15.5, 0)
        }, _defineProperty(_MuiContainerRoot2, theme.breakpoints.down('xs'), {
          padding: theme.spacing(8, 3, 6)
        }), _defineProperty(_MuiContainerRoot2, "".concat(theme.breakpoints.down('lg'), " and (orientation: landscape)"), {
          padding: theme.spacing(8, 3, 6),
          '& .MuiDialog-closeButton': {
            top: theme.spacing(3),
            right: theme.spacing(3)
          }
        }), _defineProperty(_MuiContainerRoot2, '& .MuiGrid-root.MuiGrid-item', _defineProperty({}, theme.breakpoints.down('xs'), {
          height: '100%'
        })), _MuiContainerRoot2)
      }
    },
    darkMode: {
      '& $closeButton': {
        '& path': {
          fill: theme.palette.colors.white.main
        }
      }
    },
    'verticallyAlign--top': {},
    'verticallyAlign--center': {
      '& $closeButtonWrap': {
        height: 'auto'
      },
      '& > .MuiContainer-root': {
        minHeight: '100%',
        alignItems: 'center',
        display: 'flex',
        '& > .MuiGrid-root': {
          alignItems: 'center',
          height: '100%',
          marginTop: 0,
          marginBottom: 0
        }
      },
      '& $closeButton': {
        '& path': {
          fill: theme.palette.colors.white.main
        }
      }
    },
    'verticallyAlign--bottom': {},
    '-mobileHeaderMenu': {
      // overrides material inline default
      zIndex: '999 !important'
    },
    scrollDialogContainer: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    },
    scrollDialogContentWrapper: (_scrollDialogContentW = {
      margin: 'auto',
      padding: theme.spacing(3, 4, 3, 3),
      height: 'calc(100vh - 64px - 48px)',
      marginTop: theme.spacing(8)
    }, _defineProperty(_scrollDialogContentW, theme.breakpoints.up('md'), {
      height: 'calc(100vh - 128px - 124px)',
      maxWidth: '59vw',
      padding: theme.spacing(6, 5, 6, 5),
      marginTop: theme.spacing(16)
    }), _defineProperty(_scrollDialogContentW, theme.breakpoints.up('lg'), {
      padding: theme.spacing(6, 10, 6, 10)
    }), _defineProperty(_scrollDialogContentW, '& .MuiGrid-item', {
      padding: 0
    }), _scrollDialogContentW),
    scrollDialogContent: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '100%',
      width: '100%',
      '& .scrollAreaScrollDialog': _defineProperty({
        overflow: 'auto',
        marginRight: theme.spacing(-4),
        paddingRight: theme.spacing(4)
      }, theme.breakpoints.up('md'), {
        marginRight: theme.spacing(-10),
        paddingRight: theme.spacing(10)
      })
    },
    scrollDialogCloseButton: _defineProperty({
      position: 'fixed',
      top: theme.spacing(2),
      right: theme.spacing(2)
    }, theme.breakpoints.up('md'), {
      top: theme.spacing(6),
      right: theme.spacing(6)
    })
  };
};

var _excluded$9 = ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "disableCloseButton", "fullScreen", "fullWidth", "gtmPushEvent", "isFixed", "transparent", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "showButton", "justify", "variant", "disableLocators", "darkMode", "verticallyAlign", "mobileFluid", "fixedHeight", "border", "color", "gridSpacing", "dialogTransitionClassName"];
var defaultTransitionDuration = {
  enter: duration.enteringScreen,
  exit: duration.leavingScreen
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */

var Dialog = /*#__PURE__*/React__default.forwardRef(function Dialog(props, ref) {
  var _clsx3, _clsx4;

  var BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$disableCloseBu = props.disableCloseButton,
      disableCloseButton = _props$disableCloseBu === void 0 ? false : _props$disableCloseBu,
      _props$fullScreen = props.fullScreen,
      fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      gtmPushEvent = props.gtmPushEvent,
      _props$isFixed = props.isFixed,
      isFixed = _props$isFixed === void 0 ? false : _props$isFixed,
      _props$transparent = props.transparent,
      transparent = _props$transparent === void 0 ? false : _props$transparent,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEnter = props.onEnter,
      _onEntered = props.onEntered,
      onEntering = props.onEntering,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onExit = props.onExit,
      _onExited = props.onExited,
      _onExiting = props.onExiting,
      open = props.open,
      _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? FwdPaper : _props$PaperComponent,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$scroll = props.scroll,
      scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Fade : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      _props$showButton = props.showButton,
      showButton = _props$showButton === void 0 ? true : _props$showButton,
      _props$justify = props.justify,
      justify = _props$justify === void 0 ? 'center' : _props$justify,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? null : _props$variant,
      _props$disableLocator = props.disableLocators,
      disableLocators = _props$disableLocator === void 0 ? false : _props$disableLocator,
      _props$darkMode = props.darkMode,
      darkMode = _props$darkMode === void 0 ? false : _props$darkMode,
      _props$verticallyAlig = props.verticallyAlign,
      verticallyAlign = _props$verticallyAlig === void 0 ? null : _props$verticallyAlig,
      _props$mobileFluid = props.mobileFluid,
      mobileFluid = _props$mobileFluid === void 0 ? null : _props$mobileFluid,
      _props$fixedHeight = props.fixedHeight,
      fixedHeight = _props$fixedHeight === void 0 ? false : _props$fixedHeight,
      border = props.border,
      _props$color = props.color,
      color = _props$color === void 0 ? 'white' : _props$color,
      _props$gridSpacing = props.gridSpacing,
      gridSpacing = _props$gridSpacing === void 0 ? 0 : _props$gridSpacing,
      _props$dialogTransiti = props.dialogTransitionClassName,
      dialogTransitionClassName = _props$dialogTransiti === void 0 ? '' : _props$dialogTransiti,
      other = _objectWithoutProperties(props, _excluded$9);

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;

  var history;

  if (typeof window !== 'undefined') {
    history = createHistory && createHistory(window);
  }

  useEffect(function () {
    return history && history.listen(function () {
      if (typeof window !== 'undefined') {
        if (window.event && window.event.type === 'popstate' && open && variant !== 'disclosure') {
          onClose && onClose();
        }
      }
    });
  }, []); // eslint-disable-line

  var mouseDownTarget = React__default.useRef();

  var handleMouseDown = function handleMouseDown(event) {
    mouseDownTarget.current = event.target;
  };

  var isMobileWidth = useMediaQuery("(max-width:".concat(breakpoints.values.sm, "px)"));

  var handleBackdropClick = function handleBackdropClick(event) {
    // Ignore the events not coming from the "backdrop"
    // We don't want to close the dialog when clicking the dialog content.
    event.stopPropagation();

    if (event.target !== event.currentTarget) {
      return;
    } // Make sure the event starts and ends on the same DOM element.


    if (event.target !== mouseDownTarget.current) {
      return;
    }

    mouseDownTarget.current = null;

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  var longContentFix = function longContentFix() {
    if (typeof window === 'undefined') return;

    if (variant === 'gallery') {
      var sectionInner = document.querySelector('#gallery--modal .sectionInner');
      var slickList = document.querySelector('#gallery--modal .slick-list');
      var offset = isMobileWidth ? 16 : 48;

      if (get$1(slickList, 'style', false)) {
        slickList.style.marginTop = sectionInner && sectionInner.clientHeight > window.outerHeight - offset && window.innerWidth > window.outerHeight ? "".concat(offset, "px") : '';
      }
    }
  };

  if (typeof window !== 'undefined' && 'onorientationchange' in window && variant === 'gallery') {
    window.addEventListener('orientationchange', debounce(longContentFix, 250, {
      trailing: true
    }), false);
  }

  var getVariant = function getVariant() {
    if (variant === 'gallery') {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showButton && /*#__PURE__*/React__default.createElement(StyledMemoizedButton, _extends({
        hasBorderRadius: false,
        className: clsx(classes.closeButton, _defineProperty({}, 'showFocusOnButton', useKeyBoard), // eslint-disable-line no-useless-computed-key
        'motionColorTransition'),
        title: "Close",
        "aria-label": "Close",
        onClick: onClose,
        icon: "close",
        alt: 'close',
        color: 'orange',
        disableFocusRipple: true,
        hasMotionElevate: false,
        gtmPushEvent: gtmPushEvent
      }, disableLocators ? {} : {
        'data-locator': COMPONENT_DIALOG_CLOSE_BUTTON$1
      })), /*#__PURE__*/React__default.createElement(Container$1, {
        fixed: isFixed,
        className: 'sectionInner',
        mobileFluid: mobileFluid
      }, /*#__PURE__*/React__default.createElement(StyledGrid, {
        container: true,
        className: classes.dialogContainer,
        alignItems: 'center',
        justifyContent: 'center'
      }, /*#__PURE__*/React__default.createElement(StyledGrid, {
        item: true,
        xs: 12,
        md: props.md || 10,
        lg: props.lg || 8
      }, children))));
    } else if (['mobileHeaderMenu', 'searchOverlay', 'splash', 'empty', 'wechat'].includes(variant)) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
    } else if (variant === 'scrollDialog') {
      return /*#__PURE__*/React__default.createElement(Container$1, {
        fixed: isFixed,
        section: false,
        mobileFluid: mobileFluid,
        className: classes.scrollDialogContainer
      }, showButton ? /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
        className: clsx(classes.scrollDialogCloseButton, classes.closeButton, 'motionColorTransition'),
        onClick: onClose,
        icon: "close",
        alt: 'close',
        title: "Close",
        "aria-label": "Close",
        "data-locator": COMPONENT_DIALOG_CLOSE_BUTTON$1,
        "data-testid": COMPONENT_DIALOG_CLOSE_BUTTON$1,
        hasBorderRadius: false,
        color: 'orange',
        disableFocusRipple: true,
        hasMotionElevate: false,
        gtmPushEvent: gtmPushEvent
      }) : null, /*#__PURE__*/React__default.createElement(StyledGrid, {
        container: true,
        justifyContent: justify,
        style: fixedHeight ? {
          /* ie11 minheight fix */
          height: window.innerHeight
        } : null,
        xs: 12,
        md: 8,
        spacing: 5,
        className: clsx(classes.scrollDialogContentWrapper, getBorderRadius('medium'), 'bg-color-white')
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classes.scrollDialogContent
      }, children)));
    } else {
      return /*#__PURE__*/React__default.createElement(Container$1, {
        fixed: isFixed,
        section: false,
        mobileFluid: mobileFluid
      }, showButton ? /*#__PURE__*/React__default.createElement(Box, {
        display: "flex",
        justifyContent: 'flex-end',
        className: classes.closeButtonWrap
      }, /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
        className: clsx(classes.closeButton, _defineProperty({}, 'showFocusOnButton', useKeyBoard), // eslint-disable-line no-useless-computed-key
        'motionColorTransition'),
        hasBorderRadius: false,
        disabled: disableCloseButton,
        onClick: onClose,
        icon: "close",
        alt: 'close',
        title: "Close",
        "aria-label": "Close",
        "data-locator": COMPONENT_DIALOG_CLOSE_BUTTON$1,
        "data-testid": COMPONENT_DIALOG_CLOSE_BUTTON$1,
        color: 'orange',
        disableFocusRipple: true,
        hasMotionElevate: false,
        gtmPushEvent: gtmPushEvent
      })) : null, /*#__PURE__*/React__default.createElement(StyledGrid, {
        container: true,
        justifyContent: justify,
        style: fixedHeight ? {
          /* ie11 minheight fix */
          height: window.innerHeight
        } : null,
        spacing: gridSpacing
      }, /*#__PURE__*/React__default.createElement(StyledGrid, {
        item: true,
        xs: 12,
        md: props.md || 10,
        lg: props.lg || 6
      }, children)));
    }
  };

  var rootElement = typeof document !== 'undefined' ? document.getElementsByTagName('body')[0] : null;
  useEffect(function () {
    if (open) {
      rootElement && rootElement.classList.add('modal--open');
    } else {
      clearAllBodyScrollLocks();
    }

    return function () {
      if (typeof document !== 'undefined') {
        document.body.style.paddingRight = 0;
      }

      rootElement && rootElement.classList.remove('modal--open'); // clearAllBodyScrollLocks here when dialog such as forms, does not have transition and component just unmount abruptly
      // usually the case when component is using the openState as the condition to render the Dialog.
      // Eg.formModalState && <Dialog />

      clearAllBodyScrollLocks();
      Object.assign(rootElement.style, {
        overflow: 'unset'
      });
    };
  }, [open]); // eslint-disable-line

  if (typeof window === 'undefined') return;
  return /*#__PURE__*/React__default.createElement(Modal, _extends({
    role: "alert",
    className: clsx(classes.root, className, (_clsx3 = {}, _defineProperty(_clsx3, classes.darkMode, darkMode), _defineProperty(_clsx3, classes["-".concat(variant)], variant), _clsx3), "richtext-styling-".concat(color), 'richtext-styling-common'),
    BackdropComponent: Backdrop,
    BackdropProps: _objectSpread2({
      transitionDuration: transitionDuration
    }, BackdropProps),
    closeAfterTransition: true,
    disableEscapeKeyDown: disableEscapeKeyDown,
    onEscapeKeyDown: onEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref
  }, other), /*#__PURE__*/React__default.createElement(TransitionComponent, _extends({
    appear: true,
    in: open,
    timeout: transitionDuration,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: function onEntered() {
      _onEntered && _onEntered();
      longContentFix();
      clearAllBodyScrollLocks();
      disableBodyScroll(document.querySelector(variant === 'disclosure' ? '#scrollingContent' : '.MuiDialog-paperScrollPaper'));
    },
    className: clsx('MuiDialog-container', 'MuiDialog-scrollPaper', dialogTransitionClassName),
    onExit: onExit,
    onExiting: function onExiting() {
      _onExiting && _onExiting();
      clearAllBodyScrollLocks();
    },
    onExited: function onExited() {
      _onExited && _onExited();
      clearAllBodyScrollLocks();
    },
    role: "none presentation"
  }, TransitionProps), /*#__PURE__*/React__default.createElement("div", _extends({
    className: clsx(classes.container, classes["scroll".concat(capitalize(scroll))]),
    onClick: handleBackdropClick,
    onMouseDown: handleMouseDown,
    "data-mui-test": "FakeBackdrop"
  }, disableLocators ? {} : {
    'data-locator': COMPONENT_DIALOG_CONTAINER
  }), /*#__PURE__*/React__default.createElement(PaperComponent, _extends({
    role: "dialog"
  }, PaperProps, {
    className: clsx(classes.paper, border ? getBorderRadius(border) : '', classes["paperScroll".concat(capitalize(scroll))], classes["paperWidth".concat(capitalize(String(maxWidth)))], "icon-close-".concat(color), 'icon-close-common', (_clsx4 = {}, _defineProperty(_clsx4, classes.paperFullScreen, fullScreen), _defineProperty(_clsx4, classes.paperFullWidth, fullWidth), _defineProperty(_clsx4, classes.transparent, transparent), _defineProperty(_clsx4, classes["verticallyAlign--".concat(verticallyAlign)], verticallyAlign !== null), _clsx4), variant && classes["paper-".concat(variant)], PaperProps.className),
    id: PaperProps.id ? PaperProps.id : 'dialogPaperElm'
  }), getVariant()))));
});
Dialog.propTypes = {
  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   */
  disableBackdropClick: PropTypes.bool,

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: PropTypes.bool,

  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: PropTypes.bool,

  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   */
  fullWidth: PropTypes.bool,

  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the dialog enters.
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   */
  onEscapeKeyDown: PropTypes.func,

  /**
   * Callback fired before the dialog exits.
   */
  onExit: PropTypes.func,

  /**
   * Callback fired when the dialog has exited.
   */
  onExited: PropTypes.func,

  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: PropTypes.func,

  /**
   * If `true`, the Dialog is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * The component used to render the body of the dialog.
   */
  PaperComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes.object,

  /**
   * Determine the container for scrolling the dialog.
   */
  scroll: PropTypes.oneOf(['body', 'paper']),

  /**
   * The component used for the transition.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the `Transition` element.
   */
  TransitionProps: PropTypes.object,

  /**
   * Determine the variant for style and features.
   */
  variant: PropTypes.oneOf(['gallery', 'splash', 'mobileHeaderMenu', 'searchOverlay', 'empty', 'wechat', 'disclosure']),

  /**
   * is dark mode
   */
  darkMode: PropTypes.bool,

  /**
   * verticallyAlign
   */
  verticallyAlign: PropTypes.oneOf(['top', 'center', 'bottom']),

  /**
   * remove the left right padding of container when in mobile viewport
   */
  mobileFluid: PropTypes.bool,

  /**
   * set fixed height in pixel, primary for ie fixe
   */
  fixedHeight: PropTypes.bool,

  /**
   * set optional material-ui container grid spacing
   */
  gridSpacing: PropTypes.number,

  /**
   * set optional disable close button
   */
  disableCloseButton: PropTypes.bool
};
var Dialog$1 = withStyles(styles$15, {
  name: 'MuiDialog'
})(Dialog);

var styles$14 = function styles(theme) {
  return {
    marginTop: _defineProperty({
      marginTop: theme.spacing(4)
    }, theme.breakpoints.down("md"), {
      marginTop: theme.spacing(5)
    }),
    dropdownWrapper: {
      display: "inline-block",
      verticalAlign: "middle",
      "& $dropdown": {
        width: "auto",
        fontWeight: theme.typography.fontWeights.bold,
        "&:after, &:before, &:hover:before": {
          border: "none"
        }
      }
    },
    dropdown: _defineProperty({
      color: theme.palette.colors.orange.main,
      "& .MuiSelect-root.MuiSelect-select": {
        padding: theme.spacing(0, 2, 0, 0.5),
        fontWeight: theme.typography.fontWeights.bolder
      },
      "&.country-selector svg": {
        width: theme.spacing(2),
        height: theme.spacing(2),
        top: "50%",
        transform: "translateY(-50%)",
        fill: theme.palette.colors.orange.main
      },
      "&$variant--small": _objectSpread2(_objectSpread2({}, theme.typography.body3), {}, {
        height: "auto",
        "& .MuiSelect-root": {
          paddingTop: 0,
          paddingBottom: 0
        }
      })
    }, theme.breakpoints.between("md", "lg"), {
      maxWidth: theme.spacing(23)
    }),
    "variant--small": {},
    "placement--header": {
      "& $leadingText": {
        color: theme.palette.colors.white.contrastTextCaption,
        lineHeight: theme.typography.pxToRem(21)
      },
      "& $dropdown": {
        color: theme.palette.colors.white.contrastText,
        "& svg": {
          color: theme.palette.colors.white.line.textFieldDefault,
          fill: theme.palette.colors.white.line.textFieldDefault
        }
      }
    },
    leadingText: {
      display: "inline-block",
      verticalAlign: "middle",
      lineHeight: theme.typography.pxToRem(20)
    },
    overFlowWrapper: {
      textOverflow: "ellipsis",
      maxWidth: "80px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      marginTop: "1px",
      marginRight: "1px"
    },
    selected: {
      textOverflow: "ellipsis",
      "& .showTickIcon": {
        display: "none",
        textOverflow: "ellipsis"
      },
      "&.MuiMenuItem-root.Mui-selected": {
        "& .showTickIcon": {
          display: "inline-flex",
          paddingLeft: theme.spacing(2),
          textOverflow: "ellipsis"
        }
      }
    }
  };
};

var COUNTRYSELECTOR_CONTAINER = 'CountrySelector-Container';
var COUNTRYSELECTOR_LEADINGTEXT = 'CountrySelector-LeadingText';
var COUNTRYSELECTOR_DROPDOWN = 'CountrySelector-Dropdown';

var styles$13 = function styles(theme) {
  var _MuiMenuItemRoot;

  return {
    root: {
      width: '288px',
      maxWidth: '100%',
      height: '42px',
      fontWeight: theme.typography.fontWeights.bolder,
      '& .MuiSelect-root': {
        fontWeight: theme.typography.fontWeights.bolder
      },
      '& svg': {
        width: theme.spacing(3),
        height: theme.spacing(3)
      },
      '& .MuiSelect-select:focus': {
        backgroundColor: 'inherit'
      },
      '& .MuiListItem-root': {
        justifyContent: 'space-between'
      },
      '& [aria-haspopup="listbox"]': {
        '& .showTickIcon': {
          display: 'none'
        }
      },
      '& .MuiSelect-iconOpen': {
        transform: 'none'
      }
    },
    dropdownShadow: {
      boxShadow: '0 0 8px 0 rgba(0,0,0,0.24)',
      '& .MuiMenu-list': {
        '& .Mui-selected': {
          backgroundColor: 'rgba(0, 0, 0, 0)'
        }
      },
      '&.hasBottomLine': {
        borderRadius: theme.spacing(0, 0, 0.5, 0.5)
      }
    },
    menuItems: {
      '& .MuiMenuItem-root': (_MuiMenuItemRoot = {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingRight: theme.spacing(5)
      }, _defineProperty(_MuiMenuItemRoot, theme.breakpoints.down('sm'), {
        whiteSpace: 'initial'
      }), _defineProperty(_MuiMenuItemRoot, '&.Mui-selected', {
        background: 'none'
      }), _defineProperty(_MuiMenuItemRoot, '&:hover, &.Mui-selected:hover', {
        backgroundColor: theme.palette.colors.orange.main,
        color: theme.palette.colors.orange.contrastText
      }), _defineProperty(_MuiMenuItemRoot, '& .showTickIcon', {
        display: 'none'
      }), _defineProperty(_MuiMenuItemRoot, '&.MuiMenuItem-root.Mui-selected', {
        paddingRight: theme.spacing(5),
        // as per FWD-8349 point #8, we need 16px spacing from text to icon.
        position: 'relative',
        '& .showTickIcon': {
          display: 'inline-block',
          textAlign: 'right',
          width: '100%',
          position: 'absolute',
          right: theme.spacing(1),
          '& svg': {
            verticalAlign: 'middle'
          }
        }
      }), _MuiMenuItemRoot),
      '&.country-selector li': {
        paddingRight: theme.spacing(5)
      }
    },
    langSwitcherHeader: _defineProperty({
      marginLeft: theme.spacing(1)
    }, theme.breakpoints.down('sm'), {
      marginLeft: 0
    })
  };
};

var _excluded$8 = ["languageSwitcher", "color"];
var useStyles$17 = makeStyles(styles$13);
/**
 * Dropdown for collecting user provided information from a list of options.
 * @param {string} className
 * @param {string} color
 *
 */

var Dropdown$1 = function Dropdown(props) {
  var _clsx, _clsx2;

  var classes = useStyles$17();

  var _props$origin = props.origin,
      origin = _props$origin === void 0 ? {} : _props$origin,
      _props$onOpen = props.onOpen,
      _onOpen = _props$onOpen === void 0 ? undefined : _props$onOpen,
      _props$onClose = props.onClose,
      _onClose = _props$onClose === void 0 ? undefined : _props$onClose,
      _props$hasBottomLine = props.hasBottomLine,
      hasBottomLine = _props$hasBottomLine === void 0 ? false : _props$hasBottomLine,
      _props$type = props.type,
      type = _props$type === void 0 ? 'primary' : _props$type,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal;

  var hasCountrySelector = get$1(props, 'className', '').split(' ').includes('country-selector');

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;

  props.languageSwitcher;
      var color = props.color,
      selectProps = _objectWithoutProperties(props, _excluded$8);

  return /*#__PURE__*/React__default.createElement(Select //{...props}  // FIXME: console error
  , _extends({}, selectProps, {
    color: color === 'secondary' ? 'secondary' : 'primary',
    onOpen: function onOpen() {
      if (disablePortal === false && typeof document !== 'undefined' && document.querySelector('.MuiDialog-root') !== null) {
        disableBodyScroll(document.querySelector('.MuiPopover-root .MuiMenu-paper'));
      }

      _onOpen && _onOpen();
    },
    onClose: function onClose() {
      if (disablePortal === false && typeof document !== 'undefined' && document.querySelector('.MuiDialog-root') !== null) {
        enableBodyScroll(document.querySelector('.MuiPopover-root .MuiMenu-paper'));
      }

      _onClose && _onClose();
    },
    className: clsx(classes.root, props.className, (_clsx = {}, _defineProperty(_clsx, 'hideFocusonClick', !useKeyBoard), _defineProperty(_clsx, 'showFocusonTab', useKeyBoard), _defineProperty(_clsx, "dropdown-".concat(props.color), type !== 'secondary'), _defineProperty(_clsx, "dropdown-secondary-".concat(props.color), type === 'secondary'), _clsx)),
    IconComponent: DropdownIcon,
    MenuProps: _objectSpread2({
      transitionDuration: 300,
      //to match the motionMoveDownAndFade timings
      classes: {
        paper: clsx(classes.menuItems, classes.dropdownShadow, 'motionMoveDownAndFade', (_clsx2 = {
          'country-selector': hasCountrySelector
        }, _defineProperty(_clsx2, classes.langSwitcherHeader, props.languageSwitcher === 'small_header'), _defineProperty(_clsx2, "hasBottomLine", hasBottomLine), _clsx2))
      },
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      disableScrollLock: false,
      disablePortal: disablePortal
    }, origin)
  }));
};

var useStyles$16 = makeStyles(styles$14);
/**
 * Provides a dropdown menu to select country
 * @param {string} color - Provide color palette for style
 * @param {string} dict - To provide dictionary reference
 * @param {Object[]} countryList - List of objects for countries. They provide details such as country name, website url
 * @param {boolean} marginTop - Top margin value for styling
 * @param {string} variant - Variant for applying theme to the typography component. Default value provided is `normal`
 * @param {string} placement - For applying style depending on position of component. Default value provided is null
 * @param {string} gaCategoryName - Provides GA category name
 */

var CountrySelector = function CountrySelector(props) {
  var _clsx;

  var classes = useStyles$16();
  var color = props.color,
      dict = props.dict,
      _props$countryList = props.countryList,
      countryList = _props$countryList === void 0 ? [] : _props$countryList,
      _props$marginTop = props.marginTop,
      marginTop = _props$marginTop === void 0 ? true : _props$marginTop,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? "normal" : _props$variant,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? null : _props$placement,
      _props$gaCategoryName = props.gaCategoryName,
      gaCategoryName = _props$gaCategoryName === void 0 ? "" : _props$gaCategoryName;
  var defaultRegion = countryList.find(function (item) {
    return get$1(item, "fields.isDefault.value", null);
  });

  var _useState = useState(get$1(defaultRegion, "fields.title.value", null)),
      _useState2 = _slicedToArray(_useState, 2),
      region = _useState2[0],
      setRegion = _useState2[1];

  var handleOnCountryChange = function handleOnCountryChange(event) {
    setRegion(event.target.value);
    var linkDetails;
    var GTMSharedKey;
    countryList.forEach(function (country) {
      if (country.fields.title.value === event.target.value) {
        linkDetails = get$1(country, "fields.link.value", null);
        GTMSharedKey = get$1(country, "fields.gaLabelName.value", "");
      }
    });
    var href = linkDetails.href ? linkDetails.href : undefined;
    PushEvent({
      event: "dropdownChange",
      buttonTitle: GTMSharedKey || getGTMSharedKeyVal(href, COUNTRYSELECTOR_DROPDOWN),
      componentName: gaCategoryName ? gaCategoryName : COUNTRYSELECTOR_DROPDOWN,
      destinationUrl: href
    }, props.gtmPushEvent);

    if (typeof window !== "undefined") {
      if (linkDetails.linktype === "external" && linkDetails.target === "_blank" && !props.isDisableClick) {
        window.open(linkDetails.href, "_blank");
      } else {
        window.open(linkDetails.href, "_self");
      }
    }
  };

  return countryList.length && region && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, (_clsx = {}, _defineProperty(_clsx, classes.marginTop, marginTop), _defineProperty(_clsx, classes["placement--".concat(placement)], placement !== null), _clsx)),
    "data-locator": COUNTRYSELECTOR_CONTAINER
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: variant === "normal" ? "body1" : "body6",
    component: "span",
    "data-locator": COUNTRYSELECTOR_LEADINGTEXT,
    color: color,
    className: classes.leadingText
  }, "".concat(dict("visitFWD"), " ")), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: variant === "normal" ? "body1" : "body6",
    component: "div",
    className: clsx(classes.dropdownWrapper),
    color: color,
    type: "label"
  }, /*#__PURE__*/React__default.createElement(Dropdown$1, {
    value: region,
    onChange: handleOnCountryChange,
    className: clsx(classes.dropdown, "country-selector", _defineProperty({}, classes["variant--".concat(variant)], variant !== "normal")),
    "data-locator": COUNTRYSELECTOR_DROPDOWN,
    origin: {
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      }
    }
  }, countryList.map(function (country) {
    var title = get$1(country, "fields.title.value", "");
    return /*#__PURE__*/React__default.createElement(MenuItem, {
      key: country.id,
      value: title,
      className: clsx("icon-action-dropDown-white", "showTickIcon", classes.selected)
    }, /*#__PURE__*/React__default.createElement("div", {
      className: clsx(classes.overFlowWrapper)
    }, title, /*#__PURE__*/React__default.createElement("span", {
      className: clsx("icon-action-dropDown-white", "showTickIcon")
    }, /*#__PURE__*/React__default.createElement(Tick, null))));
  }))));
};

var CountrySelector$1 = /*#__PURE__*/React__default.memo(CountrySelector);

var languageSwitcherStyles = makeStyles(function (theme) {
  var _closeButton;

  return {
    dropdown: {
      /* overrides material default */
      '&:focus': {
        outline: 'auto'
      },
      '&:before': {
        borderBottom: 'none'
      },
      '&:hover': {
        '&:before': {
          borderBottom: 'none'
        }
      },
      '&$variant--small': _objectSpread2(_objectSpread2({}, theme.typography.body3), {}, {
        height: 'auto',
        '& .MuiSelect-root': {
          paddingTop: 0,
          paddingBottom: 0,
          paddingRight: theme.spacing(2.5)
        },
        '& svg': {
          top: '50%',
          width: theme.spacing(2),
          height: theme.spacing(2),
          transform: 'translateY(-50%)',
          '& path': {
            fill: fwdColors.orange
          }
        }
      })
    },
    link: {
      position: 'static'
    },
    languageIcon: {
      marginRight: theme.spacing(1)
    },
    languageWrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      position: 'relative',
      '& [data-locator="LanguageSwitcher-Dropdown"] .MuiSelect-root': {
        opacity: 0
      }
    },
    languageDropdown: {
      textAlign: 'right'
    },
    displayLanguage: {
      position: 'absolute',
      right: theme.spacing(2.5),
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        __expression__: 'all and (-ms-high-contrast: none), (-ms-high-contrast: active)',
        top: 0
      }
    },
    closeButton: (_closeButton = {
      width: theme.spacing(30),
      padding: theme.spacing(0),
      '&>span': {
        height: '100%'
      }
    }, _defineProperty(_closeButton, theme.breakpoints.down('lg'), {
      width: theme.spacing(20),
      marginRight: theme.spacing(0.5)
    }), _defineProperty(_closeButton, theme.breakpoints.down('sm'), {
      width: theme.spacing(16),
      marginRight: 0,
      maxWidth: 'calc((100% - 5px) / 2)'
    }), _closeButton),
    actionsButton: _defineProperty({
      marginRight: theme.spacing(2)
    }, theme.breakpoints.down('md'), {
      marginRight: theme.spacing(0.5)
    }),
    modal: {
      animation: animations.fadeIn,
      '& .MuiPaper-root': _defineProperty({
        animation: animations.scaleUpAndFadeIn.desktop
      }, theme.breakpoints.up('sm'), {
        animation: animations.scaleUpAndFadeIn.mobile
      }),
      '&.dialogClosing': {
        animation: animations.fadeOut,
        '& .MuiPaper-root': _defineProperty({
          animation: animations.scaleDownAndFadeOut.desktop
        }, theme.breakpoints.up('sm'), {
          animation: animations.scaleDownAndFadeOut.mobile
        })
      }
    },
    modalPopupWrap: _defineProperty({
      padding: theme.spacing(3)
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing(6)
    }),
    modalTitleMobile: _defineProperty({
      fontSize: theme.typography.pxToRem(20),
      lineHeight: theme.typography.pxToRem(25),
      fontWeight: theme.typography.fontWeights.bolder
    }, theme.breakpoints.up('sm'), {
      display: 'none'
    }),
    modalTitleDesktop: _defineProperty({
      fontSize: theme.typography.pxToRem(25),
      lineHeight: theme.typography.pxToRem(38),
      fontWeight: theme.typography.fontWeights.bold
    }, theme.breakpoints.down('sm'), {
      display: 'none'
    }),
    modalDescription: {
      fontWeight: theme.typography.fontWeights.normal,
      fontFamily: theme.typography.fontFamily,
      lineHeight: theme.typography.lineHeight.L7,
      fontSize: theme.spacing(2),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(3)
    },
    selected: {
      '& .showTickIcon': {
        display: 'none'
      },
      '&.MuiMenuItem-root.Mui-selected': {
        '& .showTickIcon': {
          display: 'inline-flex',
          paddingLeft: theme.spacing(1)
        },
        color: theme.palette.colors.orange.main
      }
    },
    'variant--small': {},
    'placement--header': {
      '& .MuiTypography-root': {
        color: theme.palette.colors.white.contrastText
      },
      '& path': {
        fill: theme.palette.colors.white.line.textFieldDefault
      }
    }
  };
});

var COMPONENT_DROPDOWN = 'LanguageSwitcher-Dropdown';
var COMPONENT_DIALOG_CLOSE_BUTTON = 'LanguageSwitcher-Dialog-CloseButton';
var COMPONENT_DIALOG_ACTION_BUTTON = 'LanguageSwitcher-Dialog-ActionButton';
var COMPONENT_DIALOG_TITLE$1 = 'LanguageSelector-Dialog-Title';
var COMPONENT_DIALOG_DESCRIPTION$1 = 'LanguageSelector-Dialog-Description';

/**
 * TODO - test case for this function pending
 */

var getLanguagePageURL = function getLanguagePageURL() {
  var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (url !== '') {
    return "/".concat(language.toLowerCase(), "/").concat(url, "/");
  } else {
    return "/".concat(language.toLowerCase(), "/");
  }
};

var LanguageSwitcher = function LanguageSwitcher(props) {
  var _clsx;

  var classes = languageSwitcherStyles();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showLanguageModal = _useState2[0],
      setlanguageModal = _useState2[1];

  var backgroundColor = get$1(props.params, 'backgroundColor', 'white-white');

  var _getColors = getColors(backgroundColor),
      bgColor = _getColors.bgColor;

  var langSwitchRef = useRef(null);

  var _useState3 = useState('40px'),
      _useState4 = _slicedToArray(_useState3, 2),
      langWidth = _useState4[0],
      setLangWidth = _useState4[1];

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;

  useEffect(function () {
    langSwitchRef.current && setLangWidth(langSwitchRef.current.offsetWidth + 20);
  }, [langSwitchRef]);
  var title = props.title,
      description = props.description,
      secondaryLink = props.secondaryLink,
      languageModalLink = props.languageModalLink,
      _props$languageList = props.languageList,
      languageList = _props$languageList === void 0 ? [] : _props$languageList,
      itemLanguage = props.itemLanguage,
      _props$languageCode = props.languageCode,
      languageCode = _props$languageCode === void 0 ? null : _props$languageCode,
      onOpen = props.onOpen,
      onClose = props.onClose,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'normal' : _props$variant,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? null : _props$placement,
      _props$gaCategoryName = props.gaCategoryName,
      gaCategoryName = _props$gaCategoryName === void 0 ? '' : _props$gaCategoryName,
      availableLanguages = props.availableLanguages,
      color = props.color,
      _props$showIcon = props.showIcon,
      showIcon = _props$showIcon === void 0 ? true : _props$showIcon,
      _props$typo = props.typo,
      typo = _props$typo === void 0 ? 'body1' : _props$typo,
      _props$languageIcon = props.languageIcon,
      languageIcon = _props$languageIcon === void 0 ? 'language-globe' : _props$languageIcon,
      onLanguageChange = props.onLanguageChange;

  function getKeyByValue(object, value) {
    return Object.keys(object).find(function (key) {
      return object[key] === value;
    });
  }

  var text = '';
  var href = '';
  var sitecoreRoute = '';

  if (languageModalLink) {
    text = languageModalLink.text;
    href = languageModalLink.href;
  }

  var languageListArray;
  var languageListCodeArray = {};

  if (languageList) {
    languageListArray = languageList.map(function (item) {
      return get$1(item, 'fields.languageName.value', '');
    });
    languageList.forEach(function (item) {
      languageListCodeArray[get$1(item, 'fields.languageName.value', '')] = get$1(item, 'fields.languageCode.value', '');
    });
  }

  var displayLang = ''; // update languageCode to DefaultLanguage

  languageList.forEach(function (item) {
    get$1(item, 'fields.languageCode.value', '') === languageCode && (displayLang = getKeyByValue(languageListCodeArray, get$1(item, 'fields.defaultLanguage.value', 'en').toLowerCase()));
  });
  var clickHref = ''; // Get the default language;

  var defaultLang = languageCode ? getKeyByValue(languageListCodeArray, languageCode.toLowerCase()) : itemLanguage ? itemLanguage.toUpperCase() : 'EN'; // : config.defaultLanguage;

  var onCloseHref = function onCloseHref(hrefVal) {
    clickHref = hrefVal;

    if (modalRef && modalRef.current) {
      modalRef.current.classList.add('dialogClosing');
    }
  };

  var onAnimationEnd = function onAnimationEnd() {
    if (modalRef && modalRef.current && modalRef.current.classList.contains('dialogClosing')) {
      setlanguageModal(false);

      if (clickHref) {
        navigate(clickHref);
      }
    }
  };

  var getSitecoreRoute = function getSitecoreRoute() {
    var route = get$1(props, 'sitecoreRoute', '') || '';

    if (route) {
      route = "".concat(route, "/");
      var reg = /^([a-z]{2})(?:-[A-Z]{2})?\//g;
      var lang = route.match(reg);
      return lang ? route.substr(lang[0].length) : route;
    }

    return route;
  };

  sitecoreRoute = getSitecoreRoute();
  sitecoreRoute = sitecoreRoute.slice(0, sitecoreRoute.length - 1);
  /**
   *
   * Handle Language change from dropdown menu
   */

  var handleLanguageChange = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var selectedLang, pageExists;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selectedLang = languageListCodeArray[e.target.value];

              if (!(!selectedLang || selectedLang === defaultLang)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              //Push to GTM
              PushEvent({
                event: 'dropdownChange',
                buttonTitle: e.target.value,
                componentName: gaCategoryName ? gaCategoryName : COMPONENT_DROPDOWN,
                destinationUrl: href ? href : undefined
              }, props.gtmPushEvent); // Check if the page exists in selected language

              pageExists = availableLanguages.indexOf(selectedLang.toLowerCase()) !== -1;

              if (!pageExists) {
                setlanguageModal(true);
              } else {
                // Check if running on client Browser
                if (typeof window !== 'undefined' && e.target.value) {
                  // // retains search string in url
                  // const searchPart = !isEmpty(window.location.search) ? `/${window.location.search}` : '';
                  // // add selected language to url and reload the page
                  // window.location = '/' + selectedLang.toLowerCase() + '/' + sitecoreRoute + searchPart;
                  onLanguageChange && onLanguageChange(selectedLang.toLowerCase());
                }
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleLanguageChange(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var options = function options() {
    return languageListArray && languageListArray.map(function (item, index) {
      return /*#__PURE__*/React__default.createElement(MenuItem$1, {
        key: index,
        value: item,
        className: clsx('icon-action-dropDown-white', 'showTickIcon', classes.selected)
      }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, _extends({
        tabIndex: -1,
        className: classes.link,
        underline: "none",
        onClick: function onClick(e) {
          e.preventDefault();

          if ((e.ctrlKey || e.metaKey) && typeof window !== 'undefined') {
            e.stopPropagation();
            window.open(getLanguagePageURL(languageListCodeArray[item], sitecoreRoute), '_blank');
          }
        }
      }, availableLanguages.map(function (v) {
        return v.toLowerCase();
      }).includes(languageListCodeArray[item].toLowerCase()) ? {
        href: getLanguagePageURL(languageListCodeArray[item], sitecoreRoute)
      } : {}), variant ? /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        variant: typo,
        component: "span"
      }, item, /*#__PURE__*/React__default.createElement("span", {
        className: clsx('showTickIcon')
      }, /*#__PURE__*/React__default.createElement(Tick, null))) : item));
    });
  };

  var getSSRLanguageLinks = function getSSRLanguageLinks() {
    if (typeof window === 'undefined' && languageListArray && languageListArray.length > 0) {
      return /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        variant: "srOnly"
      }, languageListArray.map(function (item) {
        return /*#__PURE__*/React__default.createElement("a", {
          key: item,
          href: getLanguagePageURL(languageListCodeArray[item], sitecoreRoute)
        }, item);
      }));
    } else return null;
  };

  var modalRef = useRef();
  return !isEmpty(languageListArray) && languageListArray.length > 1 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.languageWrapper, 'languageContainer', "border-color-".concat(color))
  }, showIcon && /*#__PURE__*/React__default.createElement(NamedIcon$1, {
    icon: languageIcon,
    className: classes.languageIcon
  }), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: typo,
    component: "span",
    color: color,
    ref: langSwitchRef,
    className: clsx(classes.displayLanguage, 'displayLang')
  }, displayLang), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: langWidth,
      textAlign: 'right'
    }
  }, /*#__PURE__*/React__default.createElement(Dropdown$1, {
    className: clsx(classes.dropdown, (_clsx = {}, _defineProperty(_clsx, classes["variant--".concat(variant)], variant !== 'normal'), _defineProperty(_clsx, classes["placement--".concat(placement)], placement !== null), _defineProperty(_clsx, 'hideFocusonClick', !useKeyBoard), _defineProperty(_clsx, 'showFocusOnDiv', useKeyBoard), _clsx)),
    value: defaultLang,
    onChange: handleLanguageChange,
    "data-locator": COMPONENT_DROPDOWN,
    onOpen: onOpen,
    onClose: onClose,
    disableUnderline: true,
    color: color,
    "aria-label": COMPONENT_DROPDOWN,
    languageSwitcher: "".concat(variant, "_").concat(placement),
    type: 'secondary',
    origin: {
      transformOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      }
    }
  }, options()))), getSSRLanguageLinks(), /*#__PURE__*/React__default.createElement(Dialog$1, {
    lg: 12,
    open: showLanguageModal,
    maxWidth: "sm",
    showButton: false,
    border: 'medium',
    variant: 'empty',
    onAnimationEnd: onAnimationEnd,
    ref: modalRef,
    className: classes.modal,
    gtmPushEvent: props.gtmPushEvent
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.modalPopupWrap
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: 'h3A',
    className: classes.modalTitleMobile,
    color: bgColor,
    "data-locator": COMPONENT_DIALOG_TITLE$1
  }, title), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: 'h7',
    className: classes.modalTitleDesktop,
    color: bgColor,
    "data-locator": COMPONENT_DIALOG_TITLE$1
  }, title), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    className: classes.modalDescription,
    color: bgColor,
    "data-locator": COMPONENT_DIALOG_DESCRIPTION$1
  }, description), text ? /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
    className: [classes.closeButton, classes.actionsButton],
    onClick: function onClick() {
      return onCloseHref(href);
    },
    href: href,
    size: "large",
    "data-locator": COMPONENT_DIALOG_ACTION_BUTTON,
    color: bgColor,
    gtmPushEvent: props.gtmPushEvent
  }, text) : '', secondaryLink ? /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
    className: classes.closeButton,
    outlined: true,
    onClick: function onClick() {
      return onCloseHref('');
    },
    size: "large",
    "data-locator": COMPONENT_DIALOG_CLOSE_BUTTON,
    color: bgColor,
    gtmPushEvent: props.gtmPushEvent
  }, secondaryLink) : ''))) : /*#__PURE__*/React__default.createElement("div", {
    className: clsx(_defineProperty({}, classes["placement--".concat(placement)], placement !== null))
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: 'body6',
    component: 'span'
  }, languageListArray));
};

var dynamicLinkStyles = makeStyles(function (theme) {
  var _descriptionBottom;

  return {
    modal: {
      animation: animations.fadeIn,
      '& .MuiDialog-container, & .MuiDialog-paper, & .MuiBackdrop-root': {
        transition: 'none !important'
      },
      '&.dynamicLinkModalClosing': {
        animation: animations.fadeOut
      }
    },
    descriptionBottom: (_descriptionBottom = {
      marginBottom: theme.spacing(12)
    }, _defineProperty(_descriptionBottom, theme.breakpoints.down('sm'), {
      marginBottom: theme.spacing(8)
    }), _defineProperty(_descriptionBottom, '&.modalDescription', {
      '& a:hover': {
        backgroundColor: alpha(theme.palette.colors.orange.main, 0.2)
      },
      '& ul': {
        listStyleType: 'disc'
      },
      '& ol': {
        paddingInlineStart: "".concat(theme.spacing(6.5), "px")
      }
    }), _descriptionBottom),
    simplelink: {
      display: 'flex',
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      '&$noPadding': {
        paddingLeft: 0,
        paddingRight: 0
      }
    },
    noPadding: {},
    modalText: {
      '& h2': {
        fontWeight: theme.typography.fontWeights.bolder,
        marginBottom: theme.spacing(3)
      },
      '& h3': {
        fontWeight: theme.typography.fontWeights.bold,
        marginTop: '0px',
        marginBottom: theme.spacing(3)
      },
      '& div': {
        marginTop: '0px'
      }
    }
  };
});

var COMPONENT_MODALTITLE = 'Dialog-Title';
var COMPONENT_MODALSUBTITLE = 'Dialog-Subtitle';
var COMPONENT_MODALDESCRIPTION = 'Dialog-Description';

/**
 * This fn adds <br> tags replacing '$$'
 * @param {string} text - text to which line breaks need to be added
 */
function lineBreaker(text) {
  var sanitizedHtml = text && sanitizer(text);
  return sanitizedHtml ? sanitizedHtml.split('$$').join('<br>') : '';
}
/**
 * This fn removes <,>,&lt;,&gt; from string to prevent XSS attacks
 * @param {string} text - text to sanitize
 */

function sanitizer(text) {
  if (text.indexOf('<') > -1 || text.indexOf('>') > -1) {
    text = text.replace(/</g, '').replace(/>/g, '');
  }

  if (text.indexOf('&lt;') > -1 || text.indexOf('&gt;') > -1) {
    text = text.replace(/&lt;/g, '').replace(/&gt;/g, '');
  }

  return text;
}

/**
 * Dynamic link components can bs used for different behavior depending on props passed.
 * With Dynamic Links, your users get the best available experience for the platform they open your link on.
 * @param {string} linkType - Default value is null. Type of link.
 * @param {string} target - Contains the link target. Default is `_self`.
 * @param {string} buttonMode - Enum value for applying varied style. Default is provided as enum buttonTypes.SIMPLELINK
 * @param {string} buttonValue - Default value is ''.
 * @param {string} title - Default value is ''.
 * @param {object} icon - Contains icon details for the link. Default is null.
 * @param {string} color - Color palette for styling.
 * @param {string} dialogBgColor - For applying style for modal popup. Default value is null
 * @param {string} gaCategoryName - GA category. CMS driven field used for analytics
 * @param {function} onClick - Event handler for onClick event. Default value is null
 * @param {function} onKeyPress - Event handler for onKeyPress event. Default value is null
 * @param {string} iconLocation - Icon location for button. Default is 'PrefixIcon'.
 * @param {object} typographyProps - Props for Typography element
 * @param {boolean} noPadding - If true, sets the padding to 0.Default value is false
 * @param {string} htmlComponent - Prop passed in Link component for conditional styling . Default set to 'a'
 * @param {string} destinationUrl - Default is undefined.
 * @param {boolean} disableFocusRipple - disableFocusRipple props for Button
 * @param {boolean} useLineBreaker - Default is undefined.
 */

var DynamicLink = function DynamicLink(props) {
  var _ref = props || {},
      _ref$buttonMode = _ref.buttonMode,
      buttonMode = _ref$buttonMode === void 0 ? buttonModes.SIMPLELINK : _ref$buttonMode,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? null : _ref$icon,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? null : _ref$color,
      _ref$maxWidthApplied = _ref.maxWidthApplied,
      maxWidthApplied = _ref$maxWidthApplied === void 0 ? false : _ref$maxWidthApplied,
      _ref$dialogBgColor = _ref.dialogBgColor,
      dialogBgColor = _ref$dialogBgColor === void 0 ? null : _ref$dialogBgColor,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? null : _ref$onClick,
      _ref$postLinkHandler = _ref.postLinkHandler,
      postLinkHandler = _ref$postLinkHandler === void 0 ? null : _ref$postLinkHandler,
      _ref$onKeyPress = _ref.onKeyPress,
      _onKeyPress = _ref$onKeyPress === void 0 ? null : _ref$onKeyPress,
      _ref$onMouseEnter = _ref.onMouseEnter,
      onMouseEnter = _ref$onMouseEnter === void 0 ? null : _ref$onMouseEnter,
      _ref$iconLocation = _ref.iconLocation,
      iconLocation = _ref$iconLocation === void 0 ? "PrefixIcon" : _ref$iconLocation,
      _ref$gaCategoryName = _ref.gaCategoryName,
      gaCategoryName = _ref$gaCategoryName === void 0 ? null : _ref$gaCategoryName,
      _ref$typographyProps = _ref.typographyProps,
      typographyProps = _ref$typographyProps === void 0 ? null : _ref$typographyProps,
      _ref$noPadding = _ref.noPadding,
      noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
      _ref$htmlComponent = _ref.htmlComponent,
      htmlComponent = _ref$htmlComponent === void 0 ? "a" : _ref$htmlComponent,
      _ref$forcedHtmlCompon = _ref.forcedHtmlComponent,
      forcedHtmlComponent = _ref$forcedHtmlCompon === void 0 ? false : _ref$forcedHtmlCompon,
      _ref$formHandler = _ref.formHandler,
      formHandler = _ref$formHandler === void 0 ? null : _ref$formHandler,
      _ref$GTMSharedKey = _ref.GTMSharedKey,
      GTMSharedKey = _ref$GTMSharedKey === void 0 ? "" : _ref$GTMSharedKey,
      _ref$disableFocusRipp = _ref.disableFocusRipple,
      disableFocusRipple = _ref$disableFocusRipp === void 0 ? false : _ref$disableFocusRipp,
      _ref$useLineBreaker = _ref.useLineBreaker,
      useLineBreaker = _ref$useLineBreaker === void 0 ? false : _ref$useLineBreaker,
      _ref$disableTabIndex = _ref.disableTabIndex,
      disableTabIndex = _ref$disableTabIndex === void 0 ? false : _ref$disableTabIndex,
      _ref$disablePushEvent = _ref.disablePushEvent,
      disablePushEvent = _ref$disablePushEvent === void 0 ? false : _ref$disablePushEvent,
      _ref$stopPropagation = _ref.stopPropagation,
      stopPropagation = _ref$stopPropagation === void 0 ? null : _ref$stopPropagation,
      _ref$extraGAData = _ref.extraGAData,
      extraGAData = _ref$extraGAData === void 0 ? {} : _ref$extraGAData;

  var classes = dynamicLinkStyles({
    color: color
  });
  var linkType = get$1(props, "value.linktype", null);
  var target = get$1(props, "value.target", "_self");
  var buttonValue = get$1(props, "value.text", get$1(props, "buttonValue", ""));
  var isModal = linkType === "modelpopup";
  var isForm = linkType === "form";
  var destinationUrl = !isModal && !isForm && linkType !== "custom" ? get$1(props, "value.href", undefined) : undefined; // states

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalState = _useState2[0],
      setModalState = _useState2[1];

  var _useState3 = useState(get$1(props, "modalContent", null)),
      _useState4 = _slicedToArray(_useState3, 2),
      modalContent = _useState4[0],
      setModalContent = _useState4[1];

  var navigate = get$1(props, "navigate", function (href) {
    if (typeof window !== "undefined") {
      window.open(href);
    }
  }); // methods

  var linkHandler = function linkHandler(e) {
    e.preventDefault();

    if (!props.skipGA && !disablePushEvent) {
      var gaData = _objectSpread2({
        event: "buttonClick",
        buttonTitle: GTMSharedKey || getGTMSharedKeyVal(destinationUrl, props["data-locator"]),
        componentName: gaCategoryName ? gaCategoryName : props["data-locator"],
        destinationUrl: destinationUrl
      }, extraGAData);

      if (props.gaExtraParams) {
        gaData = _objectSpread2(_objectSpread2({}, gaData), props.gaExtraParams);
      }

      PushEvent(gaData, props.gtmPushEvent);
    }
    /* istanbul ignore else */


    if ((e.ctrlKey || e.metaKey) && typeof window !== "undefined") {
      window.open(destinationUrl, "_blank");
    } else if (linkType === "internal") {
      navigate(destinationUrl);
    } else if (linkType === "external") {
      if (typeof window !== "undefined") {
        window.open(destinationUrl, "_blank");
      }
    }

    postLinkHandler && postLinkHandler(e);
    stopPropagation && e.stopPropagation();
  };

  var openModalHandler = function openModalHandler(e) {
    PushEvent(_objectSpread2({
      event: "buttonClick",
      buttonTitle: GTMSharedKey || getGTMSharedKeyVal(destinationUrl, props["data-locator"]),
      componentName: gaCategoryName ? gaCategoryName : props["data-locator"],
      destinationUrl: destinationUrl
    }, extraGAData), props.gtmPushEvent);
    e.preventDefault();
    setModalState(true);
    setModalContent(get$1(props, "modalContent", null));
    stopPropagation && e.stopPropagation();
  };

  var closeModalHandler = function closeModalHandler() {
    if (modalRef && modalRef.current) {
      modalRef.current.classList.add("dynamicLinkModalClosing");
    }
  };

  var onAnimationEnd = function onAnimationEnd() {
    if (modalRef && modalRef.current && modalRef.current.classList.contains("dynamicLinkModalClosing")) {
      setModalState(false);
      setModalContent(null);
    }
  };

  var children = function children() {
    var titleButtonValue = title || buttonValue;

    var Content = function Content() {
      var lineBreakContent = useLineBreaker ? /*#__PURE__*/React__default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: lineBreaker(titleButtonValue)
        }
      }) : titleButtonValue.replace(/\$\$/gi, " ");
      return typographyProps ? /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, typographyProps, lineBreakContent) : /*#__PURE__*/React__default.createElement("span", null, lineBreakContent);
    };

    switch (buttonMode) {
      case buttonModes.HOTCHIP:
      case buttonModes.PRIMARY:
        return /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
          color: color,
          "aria-label": titleButtonValue.replace(/\$\$/, ""),
          icon: icon,
          prefixIcon: iconLocation === "PrefixIcon",
          className: "variant-".concat(buttonMode),
          maxWidthApplied: maxWidthApplied,
          GTMSharedKey: GTMSharedKey,
          disableFocusRipple: disableFocusRipple,
          disableTabIndex: disableTabIndex,
          disablePushEvent: disablePushEvent,
          gtmPushEvent: props.gtmPushEvent
        }, /*#__PURE__*/React__default.createElement(Content, null));

      case buttonModes.SECONDARY:
        return /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
          color: color,
          outline: true,
          icon: icon,
          outlined: true,
          "aria-label": titleButtonValue.replace(/\$\$/, ""),
          prefixIcon: iconLocation === "PrefixIcon",
          maxWidthApplied: maxWidthApplied,
          GTMSharedKey: GTMSharedKey,
          disableFocusRipple: disableFocusRipple,
          disableTabIndex: disableTabIndex,
          disablePushEvent: disablePushEvent,
          gtmPushEvent: props.gtmPushEvent
        }, /*#__PURE__*/React__default.createElement(Content, null));

      case buttonModes.SIMPLELINK:
      case buttonModes.SIMPLEPRIMARYLINK:
      default:
        return /*#__PURE__*/React__default.createElement(Content, null);
    }
  };

  var modalRef = useRef();
  return linkType || _onClick ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, _extends({
    type: get$1(props, "type"),
    component: forcedHtmlComponent ? htmlComponent : isModal || buttonMode === buttonModes.PRIMARY ? "div" : htmlComponent ? htmlComponent : "a",
    variant: get$1(props, "variant", "body1"),
    color: ![buttonModes.PRIMARY, buttonModes.SECONDARY, buttonModes.HOTCHIP].includes(buttonMode) ? color : undefined,
    underline: get$1(props, "underline", "none"),
    size: get$1(props, "size", "small"),
    className: clsx(classes[buttonMode.toLowerCase()], get$1(props, "className", null), _defineProperty({}, classes.noPadding, noPadding)),
    title: get$1(props, "value.title", ""),
    href: destinationUrl,
    onClick: function onClick(e) {
      if (!props.isDisableClick) {
        if (!props.skipGA && !disablePushEvent) {
          var gaData = _objectSpread2({
            event: "buttonClick",
            buttonTitle: GTMSharedKey || getGTMSharedKeyVal(destinationUrl, props["data-locator"]),
            componentName: gaCategoryName ? gaCategoryName : props["data-locator"],
            destinationUrl: destinationUrl
          }, extraGAData);

          if (props.gaExtraParams) {
            gaData = _objectSpread2(_objectSpread2({}, gaData), props.gaExtraParams);
          }

          PushEvent(gaData, props.gtmPushEvent);
        }

        if (isForm && formHandler) {
          formHandler(get$1(props, "value.href", undefined), get$1(props, "value.querystring", null));
          return;
        }

        _onClick && _onClick(e);
      }
    },
    linkMode: buttonMode,
    onKeyPress: function onKeyPress(e) {
      _onKeyPress && _onKeyPress(e);

      if (e.key === "Enter") {
        isModal && openModalHandler(e);
      }
    },
    onMouseEnter: onMouseEnter
  }, (buttonMode === buttonModes.SIMPLELINK || buttonMode === buttonModes.SIMPLEPRIMARYLINK) && {
    icon: icon
  }, !isModal && linkType !== "custom" && {
    target: linkType === "external" ? "_blank" : target
  }, isModal && {
    onClick: openModalHandler,
    role: "button"
  }, get$1(props, "data-locator", null) && {
    "data-locator": props["data-locator"]
  }, !isModal && !isForm && !_onClick && ["internal", "external"].includes(linkType) && destinationUrl && {
    onClick: linkHandler
  }, {
    disableTabIndex: disableTabIndex
  }), children()), isModal && /*#__PURE__*/React__default.createElement(Dialog$1, {
    fullScreen: true,
    className: classes.modal,
    open: modalState,
    onClose: closeModalHandler,
    isFixed: true,
    ref: modalRef,
    onAnimationEnd: onAnimationEnd
  }, modalContent || /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box$1, {
    className: classes.modalText
  }, get$1(props, "value.modelpopupcontent.title", null) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h2",
    component: "h2",
    className: "modalTitle",
    color: dialogBgColor || color,
    "data-locator": COMPONENT_MODALTITLE
  }, props.value.modelpopupcontent.title), get$1(props, "value.modelpopupcontent.subTitle", null) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h4",
    component: "h4",
    color: dialogBgColor || color,
    className: "modalSubTitle",
    "data-locator": COMPONENT_MODALSUBTITLE
  }, props.value.modelpopupcontent.subTitle), get$1(props, "value.modelpopupcontent.description", null) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body4",
    component: "div",
    color: dialogBgColor || color,
    className: clsx("modalDescription", classes.descriptionBottom),
    "data-locator": COMPONENT_MODALDESCRIPTION,
    type: "richtext"
  }, props.value.modelpopupcontent.description))))) : null;
};

var DynamicLink$1 = /*#__PURE__*/React__default.memo(DynamicLink);

var ACCORDION_ITEM = 'Header-PrimaryNav-Accordion-Item';
var ACCORDION_SUB_ITEM = 'Header-PrimaryNav-Accordion-Sub-Item';

var styles$12 = function styles(theme) {
  return {
    accordion: {
      listStyle: "none",
      padding: 0,
      marginTop: "-30px",
      marginBottom: "-15px"
    },
    buttonWrapper: {
      display: "flex",
      alignItems: "center"
    },
    img: {
      marginRight: "15px"
    },
    button: {
      fontSize: "16px",
      backgroundColor: "transparent",
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px 0px",
      border: "none"
    },
    buttonTitle: {
      color: fwdColors.darkGreen,
      textAlign: "left",
      fontWeight: "700",
      fontSize: "20px"
    },
    control: {
      marginTop: "-5px",
      fontSize: "1.5rem",
      color: theme.palette.colors.orange.main
    },
    minusIcon: {
      marginTop: "-10px"
    },
    answer: {
      padding: "8px 15px",
      color: fwdColors.darkGreen,
      fontWeight: "300",
      fontSize: "16px",
      lineHeight: "24px"
    },
    answer_wrapper: {
      height: 0,
      overflow: "hidden",
      transition: "height ease 0.2s"
    },
    "answer_wrapper.open": {
      height: "auto"
    }
  };
};

var AccordionItem = function AccordionItem(_ref) {
  var data = _ref.data,
      active = _ref.active,
      onToggle = _ref.onToggle,
      handlelinkClick = _ref.handlelinkClick;
  var title = data.title,
      iconUrl = data.iconUrl,
      subGroup = data.subGroup;
  var contentEl = useRef();
  var useStyles = makeStyles(styles$12);
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement("div", {
    "data-locator": ACCORDION_ITEM
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.button
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.buttonWrapper,
    onClick: function onClick() {
      return handlelinkClick(data.url, title, ACCORDION_ITEM);
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: iconUrl,
    alt: "contentIcon",
    className: classes.img
  }), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    className: classes.buttonTitle
  }, title)), subGroup !== null && subGroup !== void 0 && subGroup.length ? /*#__PURE__*/React__default.createElement("span", {
    className: classes.control,
    onClick: onToggle
  }, active ? /*#__PURE__*/React__default.createElement(NamedIcon$1, {
    icon: "minusBig"
  }) : /*#__PURE__*/React__default.createElement(NamedIcon$1, {
    icon: "plusBig"
  })) : null), subGroup !== null && subGroup !== void 0 && subGroup.length ? subGroup.map(function (item) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: item === null || item === void 0 ? void 0 : item.title,
      ref: contentEl,
      onClick: function onClick() {
        return handlelinkClick(item.url, item.title, ACCORDION_SUB_ITEM);
      },
      className: classes.answer_wrapper,
      style: active ? {
        height: contentEl.current.scrollHeight
      } : {
        height: "0px"
      },
      "data-locator": ACCORDION_SUB_ITEM
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      className: classes.answer
    }, item.title));
  }) : null);
};

var Accordion = function Accordion(_ref) {
  var collapseData = _ref.collapseData,
      navigate = _ref.navigate,
      gtmPushEvent = _ref.gtmPushEvent;

  var _useState = useState("0"),
      _useState2 = _slicedToArray(_useState, 2),
      clicked = _useState2[0],
      setClicked = _useState2[1];

  var useStyles = makeStyles(styles$12);
  var classes = useStyles();

  var handleToggle = function handleToggle(index) {
    if (clicked === index) {
      return setClicked("0");
    }

    setClicked(index);
  };

  return /*#__PURE__*/React__default.createElement("ul", {
    className: classes.accordion
  }, collapseData.map(function (data, index) {
    return /*#__PURE__*/React__default.createElement(AccordionItem, {
      onToggle: function onToggle() {
        var _data$subGroup;

        return data !== null && data !== void 0 && (_data$subGroup = data.subGroup) !== null && _data$subGroup !== void 0 && _data$subGroup.length ? handleToggle(index) : navigate(data.url, true);
      },
      active: clicked === index,
      key: data.title,
      data: data,
      handlelinkClick: function handlelinkClick(url, title, dataLocator) {
        PushEvent({
          event: "buttonClick",
          buttonTitle: title,
          componentName: dataLocator,
          destinationUrl: url
        }, gtmPushEvent);
        navigate(url, true);
      }
    });
  }));
};

var HeaderNavigationLinks = function HeaderNavigationLinks(props) {
  var _clsx, _clsx3;

  var classes = get$1(props, "classes", []);
  var hideMob = get$1(props, "hideMobile", null);
  var onClick = get$1(props, "onClick", null);
  var navigate = get$1(props, "navigate", function (href) {
    if (typeof window !== "undefined") {
      window.open(href);
    }
  });
  var isMobileWidth = useMediaQuery("(max-width:".concat(breakpoints.values.xl, "px)")); // const { pathname } = useLocation();

  var pathname = useMemo(function () {
    if (typeof window !== "undefined") {
      var _window, _window$location, _window2, _window2$location;

      return props.isFullUrl ? (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href : (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.pathname;
    }

    return "";
  }, [props.isFullUrl]); // exact URL match

  var activeURL = [].concat(_toConsumableArray(props.primaryNav), _toConsumableArray(props.secondaryNav)).map(function (item) {
    return get$1(item, "fields.link.value.href", "/");
  }).find(function (path) {
    return pathname.indexOf(path) === 0 && pathname.length === path.length;
  }) || "/"; // subpages match

  [].concat(_toConsumableArray(props.primaryNav), _toConsumableArray(props.secondaryNav)).map(function (item) {
    return get$1(item, "fields.link.value.href", "/");
  }).forEach(function (path) {
    /* istanbul ignore else */
    if (pathname.indexOf(path) === 0 && pathname.length > activeURL.length) {
      activeURL = path;
    }
  });

  var linkHandler = function linkHandler(e, link) {
    e.preventDefault();
    onClick && onClick();
    /* istanbul ignore else */

    if ((e.ctrlKey || e.metaKey) && typeof window !== "undefined") {
      window.open(link.href, "_blank");
    } else if (link.linktype === "internal") {
      navigate(link.href);
    } else if (link.linktype === "external") {
      if (typeof window !== "undefined") {
        if (link.target === "_blank") {
          window.open(link.href, "_blank");
        } else {
          navigate(link.href);
        }
      }
    }
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isEmpty(props.primaryNav) && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.primaryNav, (_clsx = {}, _defineProperty(_clsx, classes.mobileNav, isMobileWidth), _defineProperty(_clsx, "hideMobile", hideMob), _clsx)),
    "data-locator": HEADER_PRIMARYNAV
  }, props.primaryNav.map(function (item) {
    var _item$fields;

    var isCollapsibleMenu = item === null || item === void 0 ? void 0 : (_item$fields = item.fields) === null || _item$fields === void 0 ? void 0 : _item$fields.collapsibleLinkListProps;

    if (isCollapsibleMenu && isMobileWidth) {
      var _item$fields2;

      return /*#__PURE__*/React__default.createElement("div", {
        key: item.id
      }, /*#__PURE__*/React__default.createElement(Accordion, {
        collapseData: item === null || item === void 0 ? void 0 : (_item$fields2 = item.fields) === null || _item$fields2 === void 0 ? void 0 : _item$fields2.collapsibleLinkListProps,
        navigate: navigate,
        gtmPushEvent: props.gtmPushEvent
      }));
    }

    return /*#__PURE__*/React__default.createElement("div", {
      key: item.id,
      className: clsx(classes.link, classes.navBox, _defineProperty({}, classes.active, get$1(item, "fields.link.value.href", "/") === activeURL)),
      role: "button",
      "aria-label": get$1(item, "fields.title.value", "").replace(/\$\$/gi, " ")
    }, /*#__PURE__*/React__default.createElement(DynamicLink$1, {
      noPadding: true,
      className: clsx(classes.primaryLink),
      value: _objectSpread2({}, get$1(item, "fields.link.value", {})),
      useLineBreaker: !isMobileWidth,
      title: get$1(item, "fields.title.value", ""),
      icon: isMobileWidth ? get$1(item, "fields.buttonIcon.fields.value.value", null) : null,
      size: "none",
      "data-locator": HEADER_PRIMARYNAV_ITEM,
      buttonMode: buttonModes.SIMPLEPRIMARYLINK,
      onClick: get$1(item, "fields.link.value.href", null) ? function (e) {
        return linkHandler(e, item.fields.link.value);
      } : undefined,
      GTMSharedKey: get$1(item, "fields.gaLabelName.value", ""),
      navigate: navigate,
      onMouseEnter: get$1(item, "fields.onMouseEnter", null),
      gtmPushEvent: props.gtmPushEvent,
      isDisableClick: props.isDisableClick
    }));
  })), !isEmpty(props.secondaryNav) && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.secondaryNav, "lines".concat([].concat(_toConsumableArray(props.secondaryNav), _toConsumableArray(props.primaryNav)).some(function (item) {
      return get$1(item, "fields.title.value", "").indexOf("$$") !== -1;
    }) ? 2 : 1), (_clsx3 = {}, _defineProperty(_clsx3, classes.mobileNav, isMobileWidth), _defineProperty(_clsx3, "hideMobile", hideMob), _clsx3)),
    "data-locator": HEADER_SECONDARYNAV
  }, props.secondaryNav.map(function (item) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: item.id,
      className: clsx(classes.link, classes.navBox, _defineProperty({}, classes.active, get$1(item, "fields.link.value.href", "/") === activeURL)),
      role: "button",
      "aria-label": get$1(item, "fields.title.value", "")
    }, /*#__PURE__*/React__default.createElement(DynamicLink$1, {
      noPadding: true,
      className: clsx(classes.secondaryLink),
      value: _objectSpread2({}, get$1(item, "fields.link.value", {})),
      useLineBreaker: !isMobileWidth,
      title: get$1(item, "fields.title.value", ""),
      "data-locator": HEADER_SECONDARYNAV_ITEM,
      buttonMode: buttonModes.SIMPLELINK,
      typographyProps: {
        fontWeight: fontWeights.normal
      },
      onClick: get$1(item, "fields.link.value.href", null) ? function (e) {
        return linkHandler(e, item.fields.link.value);
      } : undefined,
      GTMSharedKey: get$1(item, "fields.gaLabelName.value", ""),
      navigate: navigate,
      gtmPushEvent: props.gtmPushEvent,
      isDisableClick: props.isDisableClick
    }));
  })));
};

var styles$11 = function styles(theme) {
  return {
    root: {
      zIndex: 1500,
      borderRadius: '4px',
      boxSizing: 'border-box',
      boxShadow: '0 0 8px 0 rgba(0,0,0,0.24)',
      overflow: 'visible',
      background: fwdColors.white,
      '&.hasAnimation': _defineProperty({
        animation: animations.moveDownAndFadeInTop.mobile
      }, theme.breakpoints.up('xl'), {
        animation: animations.moveDownAndFadeInTop.desktop
      }),
      '&.popperClosing': _defineProperty({
        animation: animations.fadeOutMobileDesktop.mobile
      }, theme.breakpoints.up('xl'), {
        animation: animations.fadeOutMobileDesktop.desktop
      }),
      '& li': {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
      },
      '& .MuiMenuItem-root': {
        minHeight: theme.spacing(0)
      },
      '& .menuTextStyle': {
        color: fwdColors.darkgreen,
        fontSize: theme.spacing(2),
        fontWeight: theme.typography.fontWeights.normal,
        lineHeight: '24px'
      },
      '& .menuIconStyle': {
        marginRight: theme.spacing(2),
        alignItems: 'center',
        display: 'flex',
        '& svg, & img': {
          height: theme.spacing(4),
          width: theme.spacing(4)
        }
      }
    }
  };
};

function arrowGenerator$1(color, theme) {
  return {
    '&[x-placement*="bottom"],&[x-placement*="top"]': {
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5)
    },
    '&[x-placement*="left"],&[x-placement*="right"]': {
      marginLeft: theme.spacing(1.5),
      marginRight: theme.spacing(1.5)
    },
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: theme.spacing(-0.5),
      '&::before': {
        boxShadow: '-4px -4px 4px 0 rgba(0,0,0,0.12)'
      }
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: theme.spacing(-0.5),
      '&::before': {
        boxShadow: '4px 4px 4px 0 rgba(0,0,0,0.12)'
      }
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: theme.spacing(-0.5),
      '&::before': {
        boxShadow: '-4px 4px 4px 0 rgba(0,0,0,0.12)'
      }
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: theme.spacing(-0.5),
      '&::before': {
        boxShadow: '4px -4px 4px 0 rgba(0,0,0,0.12)'
      }
    }
  };
}

var useStylesArrow$1 = makeStyles(function (theme) {
  return {
    arrow: {
      position: 'absolute',
      '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: theme.spacing(1),
        height: theme.spacing(1),
        background: theme.palette.common.white,
        transform: 'rotate(45deg)'
      }
    },
    popper: arrowGenerator$1(theme.palette.common.white, theme)
  };
});
var useStyles$15 = makeStyles(function (theme) {
  return styles$11(theme);
});

var Popper = function Popper(props) {
  var classes = useStyles$15();

  var _useStylesArrow = useStylesArrow$1(),
      arrow = _useStylesArrow.arrow,
      popper = _useStylesArrow.popper;

  var children = props.children,
      anchorEl = props.anchorEl,
      open = props.open,
      _props$className = props.className,
      className = _props$className === void 0 ? {} : _props$className,
      _props$hasClickAwayLi = props.hasClickAwayListener,
      hasClickAwayListener = _props$hasClickAwayLi === void 0 ? true : _props$hasClickAwayLi,
      _props$hasAnimation = props.hasAnimation,
      hasAnimation = _props$hasAnimation === void 0 ? false : _props$hasAnimation;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      arrowRef = _useState2[0],
      setArrowRef = _useState2[1];

  var handleArrowRef = function handleArrowRef(node) {
    setArrowRef(node);
  };

  return open && /*#__PURE__*/React__default.createElement(PopperProxy, {
    placement: props.popperPlacement,
    className: clsx(popper, classes.root, className, 'popper', {
      hasAnimation: hasAnimation
    }),
    anchorEl: anchorEl,
    keepMounted: true,
    modifiers: {
      flip: {
        enabled: true
      },
      arrow: {
        enabled: true,
        element: arrowRef
      },
      preventOverflow: {
        enabled: 'true',
        boundariesElement: 'scrollParent'
      }
    },
    open: open,
    "data-locator": props.dataLocator,
    disablePortal: get$1(props, 'disablePortal', true)
  }, /*#__PURE__*/React__default.createElement("span", {
    className: arrow,
    ref: handleArrowRef
  }), hasClickAwayListener ? /*#__PURE__*/React__default.createElement(ClickAwayListener, {
    onClickAway: function onClickAway(e) {
      props.handleClose && props.handleClose(e);
    }
  }, children) : children);
};

var COMPONENT_MODAL_TITLE$1 = 'Modal-Title';
var COMPONENT_MODAL_SUBTITLE$1 = 'Modal-Subtitle';
var COMPONENT_MODAL_LINK = 'Modal-Link';
var COMPONENT_MODAL_DESCRIPTION$1 = 'Modal-Description';

var NavigationLink = function NavigationLink(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'grey' : _props$color,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$type = props.type,
      type = _props$type === void 0 ? null : _props$type,
      _props$underline = props.underline,
      underline = _props$underline === void 0 ? 'none' : _props$underline,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? null : _props$icon,
      _props$size = props.size,
      size = _props$size === void 0 ? 'small' : _props$size,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      _props$hasTitle = props.hasTitle,
      hasTitle = _props$hasTitle === void 0 ? true : _props$hasTitle,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$dataLocator = props.dataLocator,
      dataLocator = _props$dataLocator === void 0 ? null : _props$dataLocator,
      formHandler = props.formHandler,
      onClick = props.onClick,
      liveChatMethods = props.liveChatMethods,
      _props$fontWeight = props.fontWeight,
      fontWeight = _props$fontWeight === void 0 ? null : _props$fontWeight,
      _props$gaCategoryName = props.gaCategoryName,
      gaCategoryName = _props$gaCategoryName === void 0 ? '' : _props$gaCategoryName,
      GTMSharedKey = props.GTMSharedKey,
      useLineBreaker = props.useLineBreaker,
      liveChatTitle = props.liveChatTitle,
      offlineChatGreeting = props.offlineChatGreeting,
      onlineChatGreeting = props.onlineChatGreeting;
  var listType = get$1(props, 'listType.fields.key.value', 'generic_link');
  var link = get$1(props, 'link.value', null);
  var linkType = get$1(link, 'linktype', null);
  var target = get$1(link, 'target', null);
  var href = get$1(link, 'href', null);
  var url = get$1(link, 'url', null);
  var modelpopupcontent = get$1(link, 'modelpopupcontent', null);
  var disclosurepopupcontent = get$1(link, 'disclosurepopupcontent', null);
  var formType = get$1(link, 'querystring', null);
  var linkText = get$1(link, 'text', null);
  var navigate = get$1(props, 'navigate', function (href) {
    if (typeof window !== 'undefined') {
      window.open(href);
    }
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalState = _useState2[0],
      setModalState = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      modalContent = _useState4[0],
      setModalContent = _useState4[1];

  var closeModalHandler = function closeModalHandler() {
    setModalState(false);
    setModalContent(null);
  }; // const { t } = useTranslation();
  // const { setDisclosurePopupList } = useDisclosure();


  var setDisclosurePopupList = props.setDisclosurePopupList;
  var chatLanguage = {
    // liveChatTitle: t('liveChatTitle'),
    // offlineChatGreeting: t('offlineChatGreeting'),
    // onlineChatGreeting: t('onlineChatGreeting'),
    liveChatTitle: liveChatTitle,
    offlineChatGreeting: offlineChatGreeting,
    onlineChatGreeting: onlineChatGreeting
  };

  var linkHandler = function linkHandler(e) {
    /* istanbul ignore else */
    if (listType !== 'call') {
      e.preventDefault();
      e.stopPropagation();

      if (listType === 'chat') {
        e.nativeEvent.stopImmediatePropagation();

        if (typeof window !== 'undefined') {
          // window.showChat = true;
          window.LiveChat(fwdColors.orange, true, liveChatMethods, chatLanguage, false, e);
        }
      } else if (listType === 'generic_link') {
        /* istanbul ignore else */
        if ((e.ctrlKey || e.metaKey) && !['form', 'modelpopup'].includes(linkType) && typeof window !== 'undefined') {
          window.open(href, '_blank');
        } else if (linkType === 'internal') {
          navigate(href);
        } else if (/(external)|(media)/i.test(linkType)) {
          if (typeof window !== 'undefined') {
            window.open(href, target || '_blank');
          } else {
            navigate(href);
          }
        } else if (linkType === 'form') {
          formHandler(href, formType);
        } else if (linkType === 'modelpopup') {
          /* istanbul ignore else */
          if (!isEmpty(modelpopupcontent)) {
            setModalState(true);
            setModalContent(modelpopupcontent);
          } else if (!isEmpty(disclosurepopupcontent) && disclosurepopupcontent.disclosure.value) {
            setDisclosurePopupList({
              isRoutedDirectly: false,
              activePopupKey: disclosurepopupcontent.disclosure.value,
              eligiblePopupList: [disclosurepopupcontent.disclosure.value]
            });
          }
        }
      }
    }

    onClick && onClick(listType);
  };

  var handleKeyPress = function handleKeyPress(e) {
    if (e.keyCode === 13) {
      linkHandler(e);
    }
  };

  return listType === 'chat' || linkType ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    iconAltText: linkText,
    icon: icon,
    size: size,
    underline: underline,
    href: listType === 'generic_link' ? ['internal', 'external'].includes(linkType) ? href : null : listType === 'call' ? url : null,
    target: listType === 'generic_link' ? linkType === 'internal' ? '_self' : linkType === 'external' ? target ? target : '_self' : null : listType === 'call' ? '_self' : null,
    component: listType === 'generic_link' && ['internal', 'external'].includes(linkType) && !href ? 'div' : 'a',
    tabIndex: "0",
    className: className,
    "data-locator": dataLocator,
    onClick: function onClick(e) {
      PushEvent({
        event: 'buttonClick',
        buttonTitle: GTMSharedKey || getGTMSharedKeyVal(href, dataLocator),
        componentName: gaCategoryName ? gaCategoryName : dataLocator,
        destinationUrl: href ? href : undefined
      }, props.gtmPushEvent);
      linkHandler(e);
    },
    onKeyPress: function onKeyPress(e) {
      return handleKeyPress(e);
    }
  }, !hasTitle && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "srOnly"
  }, linkText || title), hasTitle && (title || linkText) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: variant,
    component: "span",
    color: color,
    fontWeight: fontWeight,
    type: type
  }, useLineBreaker ? /*#__PURE__*/React__default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: lineBreaker(title || linkText)
    }
  }) : title || linkText)), modalState && /*#__PURE__*/React__default.createElement(Dialog$1, {
    fullScreen: true,
    open: modalState,
    onClose: closeModalHandler,
    gtmPushEvent: props.gtmPushEvent
  }, get$1(modalContent, 'title.value', null) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    component: "h2",
    variant: "h2",
    color: color,
    "data-locator": COMPONENT_MODAL_TITLE$1
  }, modalContent.title), get$1(modalContent, 'subTitle.value', null) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h4",
    component: "h4",
    color: color,
    "data-locator": COMPONENT_MODAL_SUBTITLE$1
  }, modalContent.subTitle), get$1(modalContent, 'link.value.text', null) && /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    component: "div",
    variant: "body1",
    underline: "hover",
    size: "small",
    icon: "arrow-right",
    href: modalContent.link.value.href,
    target: modalContent.link.value.linktype === 'external' ? '_blank' : '_self',
    "data-locator": COMPONENT_MODAL_LINK
  }, get$1(modalContent, 'title.value', null) || get$1(modalContent, 'link.value.text', null)), get$1(modalContent, 'description.value', null) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body4",
    component: "div",
    color: color,
    "data-locator": COMPONENT_MODAL_DESCRIPTION$1,
    type: 'richtext'
  }, modalContent.description))) : null;
};

var NavigationLink$1 = /*#__PURE__*/React__default.memo(NavigationLink);

var searchStyles = makeStyles(function (theme) {
  var _cookieDataWrapper;

  var colors = theme.palette.colors || {};
  var bgColors = {};
  var paperThemes = {};
  Object.keys(colors).forEach(function (color) {
    /** For Default */
    bgColors["bg-".concat(color)] = {
      borderBottom: "1px solid",
      borderBottomColor: colors[color].contrastText,
      backgroundColor: colors[color].main,
      "& svg": {
        color: colors[color].contrastText
      },
      "& input": {
        color: colors[color].contrastText,
        "&::placeholder": {
          color: colors[color].contrastText
        }
      }
    };
    bgColors["history-bg-".concat(color)] = {
      backgroundColor: colors[color].contrastTextCaption,
      "& svg": {
        color: colors[colors[color].searchInput.background].contrastTextAction
      },
      "& h6": {
        color: colors[colors[color].searchInput.background].contrastText,
        "& span": {
          color: colors[colors[color].searchInput.background].contrastTextCaption
        }
      },
      "&.active": {
        backgroundColor: colors[color].main,
        "& svg": {
          color: colors[color].contrastText
        },
        "& h6, & h6 span": {
          color: colors[color].contrastText
        },
        "& #button": {
          display: "flex"
        }
      }
    };
    paperThemes["paper--".concat(color)] = {
      backgroundColor: theme.palette.colors[color].main,
      color: theme.palette.colors[color].contrastText,
      "& .MuiInputBase-root, & .MuiInputBase-input": {
        color: theme.palette.colors[color].contrastText
      },
      "& .MuiSvgIcon-root": {
        color: theme.palette.colors[color].contrastTextAction
      },
      "& $closeInputIcon": {
        backgroundColor: theme.palette.colors[color].contrastText,
        color: theme.palette.colors[color].main
      },
      "&$searchBox": {
        borderColor: theme.palette.colors[color].line.textFieldDefault
      }
    };
  });
  return _objectSpread2(_objectSpread2(_objectSpread2({}, bgColors), paperThemes), {}, {
    searchBox: _defineProperty({
      borderBottom: "1px solid",
      display: "flex",
      height: "40px"
    }, theme.breakpoints.up("sm"), {
      height: "42px"
    }),
    searchInput: {
      flex: "auto",
      height: "41px",
      "& .MuiInputBase-input": _defineProperty({
        fontSize: theme.typography.pxToRem(25),
        fontWeight: theme.typography.fontWeights.bolder,
        lineHeight: theme.typography.pxToRem(42),
        padding: 0,
        height: "auto"
      }, theme.breakpoints.down("sm"), {
        fontSize: theme.typography.pxToRem(20),
        lineHeight: theme.typography.pxToRem(40)
      }),
      "& ::-ms-clear": {
        display: "none"
      }
    },
    relativeDiv: {
      position: "relative"
    },
    searchInputIconWrapper: {
      "&.MuiIconButton-root": {
        padding: "9px 0px",
        paddingLeft: "4px"
      },
      "&.MuiIconButton-root:hover": {
        backgroundColor: "transparent"
      }
    },
    searchInputIcon: {
      "&.MuiSvgIcon-root": {
        height: theme.spacing(3),
        width: theme.spacing(3),
        cursor: "pointer"
      }
    },
    closeInputIconWrapper: {
      padding: "13px",
      paddingRight: "9px",

      /* override material default */
      backgroundColor: "transparent !important"
    },
    closeInputIcon: {
      "&.MuiSvgIcon-root": {
        height: theme.typography.pxToRem(13),
        width: theme.typography.pxToRem(13),
        cursor: "pointer",
        borderRadius: "50%",
        padding: "2px"
      }
    },
    showItems: {
      display: "block"
    },
    hideItems: {
      display: "none"
    },
    historyIcon: {
      "& svg": {
        height: "24px",
        width: "24px"
      }
    },
    removeButton: {
      background: "none",
      border: "none",
      padding: 0,
      minWidth: 0,
      minHeight: 0,
      height: "auto",
      "& h6": {
        marginBottom: 0,
        width: "100%"
      },
      "&:hover": {
        background: "none",
        border: "none"
      },
      "&:focus": {
        background: "none",
        border: "none"
      }
    },
    cookieOverlay: {
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0,
      float: "right",
      width: "100%",
      position: "absolute",
      zIndex: "10000",
      boxShadow: "0 0 ".concat(theme.spacing(1), "px 0 rgba(0,0,0,0.24)")
    },
    searchHistoryWrapper: {
      cursor: "pointer",
      padding: "".concat(theme.spacing(1), "px ").concat(theme.spacing(2), "px"),
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      width: "100%",
      minHeight: theme.spacing(5),
      "&:first-child": {
        marginTop: theme.spacing(1)
      },
      "&:last-child": {
        marginBottom: theme.spacing(1)
      }
    },
    wordWrap: _defineProperty({
      width: "85%",
      overflowWrap: "break-word"
    }, theme.breakpoints.up("sm"), {
      width: "95%"
    }),
    cookieDataWrapper: (_cookieDataWrapper = {
      display: "flex",
      width: "80%",
      height: "100%"
    }, _defineProperty(_cookieDataWrapper, theme.breakpoints.up("sm"), {
      width: "90%"
    }), _defineProperty(_cookieDataWrapper, "& h6", {
      paddingLeft: theme.spacing(1)
    }), _cookieDataWrapper)
  });
});

var save = function save(text, pastSearchRecordsCount) {
  // To avoid saving null values in localStorage
  if (!text) return true;
  var searchHistory = JSON.parse(localStorage.getItem('searchHistoryFWD')) || []; // To filter data on the basis of pastSearchRecordsCount received from sitecore

  if (searchHistory.length >= pastSearchRecordsCount) {
    searchHistory = searchHistory.slice(0, pastSearchRecordsCount - 1);
  }

  if (pastSearchRecordsCount !== 0) {
    // To avoid case sensitive data
    searchHistory = searchHistory.filter(function (item) {
      return item.searchContent.toString().toLowerCase() !== text.toString().toLowerCase();
    }); // To filter expired data

    searchHistory = searchHistory.filter(function (item) {
      return item.timeStamp >= Date.now() - 86400 * 30 * 1000;
    });
    searchHistory.unshift({
      timeStamp: Date.now(),
      searchContent: text.toString()
    });
  }

  localStorage.setItem('searchHistoryFWD', JSON.stringify(searchHistory));
};
var get = function get() {
  if (typeof window !== 'undefined') {
    return JSON.parse(window.localStorage.getItem('searchHistoryFWD'));
  } else return [];
};
var remove = function remove(text) {
  var searchHistory = JSON.parse(localStorage.getItem('searchHistoryFWD'));
  searchHistory = searchHistory.filter(function (item) {
    return item.searchContent !== text;
  });
  localStorage.setItem('searchHistoryFWD', JSON.stringify(searchHistory));
};

var SEARCH_BAR_CONTAINER = 'SerachInput-Search-Bar-Container';
var SEARCH_ICON = 'SerachInput-Search-Icon';
var CLOSE_ICON = 'SerachInput-Close-Icon';
var SERACH_HISTORY_CONTAINER = 'SerachInput-Search-History-Container';
var SERACH_HISTORY_ICON = 'SerachInput-Search-History-Icon';
var SERACH_HISTORY_CONTENT = 'SerachInput-Search-History-Content';
var SERACH_REMOVE_BUTTON = 'SerachInput-Search-Remove-Button';

/**
 *
 * @param {string} placeholderText
 * @param {string} pastSearchRecordsCount - number of search results that needs to be store.
 * @param {string} color - default color is set to orange
 * @param {string} bgColor - default color is set to value of color field
 * @param {boolean} enableAutoFocus - default value is false
 * @param {string} searchHistoryIcon - used to display the icon and default value is history
 */

var SearchInput = function SearchInput(props) {
  var _clsx, _clsx2, _clsx4;

  /**
   * Getting Dictionary Service from props
   * Will be used for 'remove' text
   */
  // const { t } = useTranslation();
  var placeholderText = props.placeholderText,
      pastSearchRecordsCount = props.pastSearchRecordsCount,
      onSubmit = props.onSubmit,
      _props$color = props.color,
      color = _props$color === void 0 ? 'orange' : _props$color,
      _props$bgColor = props.bgColor,
      bgColor = _props$bgColor === void 0 ? color : _props$bgColor,
      _props$enableAutoFocu = props.enableAutoFocus,
      enableAutoFocus = _props$enableAutoFocu === void 0 ? false : _props$enableAutoFocu,
      _props$searchHistoryI = props.searchHistoryIcon,
      searchHistoryIcon = _props$searchHistoryI === void 0 ? 'history' : _props$searchHistoryI,
      _props$removeBtnLabel = props.removeBtnLabel,
      removeBtnLabel = _props$removeBtnLabel === void 0 ? 'remove' : _props$removeBtnLabel;
  var classes = searchStyles();
  var inputEl = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focusEl = _useState2[0],
      setfocusEl = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      closeEl = _useState4[0],
      setCloseEl = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      recentSearch = _useState6[0],
      setRecentSearch = _useState6[1];

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;
  /**
   * To focus input field on default load
   */


  useEffect(function () {
    setTimeout(function () {
      var inputVal = get$1(inputEl, 'current.value', null); // check with avoids for empty case

      if (inputVal !== null && enableAutoFocus) {
        inputEl.current.focus();
      }
    }, 350);
  }, [inputEl, enableAutoFocus]);
  /**
   * To remove the focus from the input field
   */

  var hidefocusdata = function hidefocusdata() {
    setfocusEl(false);
  };

  var alignSearchContainer = function alignSearchContainer() {
    // FWD-6198: to align searchInput in viewport if the user is in middle of /search page and go to Search header to do another Global search
    if (typeof document !== 'undefined') {
      var searchHeaderWrapper = document.getElementById('searchHeaderWrapper');
      searchHeaderWrapper && searchHeaderWrapper.scrollIntoView();
    }
  };
  /**
   * use to add the input text in history list and to trigger the callback function of parent (onSubmit)
   */


  var handleSubmit = function handleSubmit(searchInput) {
    if (typeof searchInput === 'string') {
      searchInput = searchInput.trim();
    }

    PushEvent({
      event: 'buttonClick',
      buttonTitle: SEARCH_ICON,
      componentName: SEARCH_BAR_CONTAINER,
      destinationUrl: undefined
    });
    onSubmit(searchInput);
    save(searchInput, JSON.parse(pastSearchRecordsCount));
    alignSearchContainer();
  };
  /**
   * use to call handlesubmit for adding valid searched value to local storage and update the recent search list with updated local storage data
   *
   * @param {string} inputVal - consist of value that is to be searched
   */


  var submitEv = function submitEv(e) {
    e.preventDefault();
    var inputVal = get$1(inputEl, 'current.value', null);

    if (inputVal && inputVal.trim()) {
      handleSubmit(inputVal);
      setList();
    }
  };
  /**
   * To remove searched key from local
   */


  var removeHistoryItem = function removeHistoryItem(text) {
    if (typeof text === 'string') {
      text = text.trim();
    }

    PushEvent({
      event: 'buttonClick',
      buttonTitle: SERACH_REMOVE_BUTTON,
      componentName: SERACH_REMOVE_BUTTON,
      destinationUrl: undefined
    });
    remove(text);

    var recentSearchHistory = _toConsumableArray(recentSearch);

    recentSearchHistory = recentSearchHistory.filter(function (item) {
      return item.searchContent !== text;
    });

    if (recentSearchHistory.length) {
      recentSearchHistory[0]['active'] = true;
    } else {
      recentSearchHistory = [];
    }

    setRecentSearch(recentSearchHistory);
    inputEl.current.focus();
    inputEl.current.value ? setCloseEl(true) : setCloseEl(false);
    setfocusEl(true);
  };
  /**
   * To highlight the current search text in the recent search list and to update recent search list with updated local storage data
   */


  var setList = function setList() {
    var historyArr = get();

    if (!historyArr || !historyArr.length) {
      return false;
    }

    var recentSearchHistory = _toConsumableArray(historyArr);

    if (recentSearchHistory.length) {
      var inputVal = get$1(inputEl, 'current.value', null);

      if (inputVal && inputVal.trim()) {
        recentSearchHistory.forEach(function (elem) {
          if (elem.searchContent === inputVal) {
            elem['active'] = true;
          } else {
            elem['active'] = false;
          }
        });
      } else {
        recentSearchHistory[0]['active'] = true;
      }

      setRecentSearch(recentSearchHistory);
    }
  };
  /**
   * to clear the input field value
   */


  var clearFieldData = function clearFieldData() {
    PushEvent({
      event: 'buttonClick',
      buttonTitle: CLOSE_ICON,
      componentName: CLOSE_ICON,
      destinationUrl: undefined
    });
    inputEl.current.value = '';
    inputEl.current.focus();
    setCloseEl(false);
  };
  /**
   * To show/hide cross button depending upon input text value
   * setList will pull the updated result from the local storage to highlight the searched text if applicable
   * setfocusEl will show the recent search results in list view
   */


  var handleChange = function handleChange() {
    inputEl.current.value ? setCloseEl(true) : setCloseEl(false);
    setList();
    setfocusEl(true);
  };
  /**
   * To add active class on hovered list item
   */


  var handleHoveState = function handleHoveState(identifier) {
    var recentSearchHistory = _toConsumableArray(recentSearch);

    recentSearchHistory.forEach(function (elem) {
      elem['active'] = false;
    });
    recentSearchHistory.forEach(function (elem) {
      if (elem.searchContent === identifier) {
        elem['active'] = true;
      }
    });
    setRecentSearch(recentSearchHistory);
  };
  /**
   * Highlight the next text field value in the list on pressing down arrow key
   */


  var moveActiveDown = function moveActiveDown(e) {
    e.preventDefault();

    var recentSearchHistory = _toConsumableArray(recentSearch);

    var currIndex = 0;
    if (recentSearchHistory.length < 1) return true;
    recentSearchHistory.forEach(function (elem, index) {
      if (elem['active']) {
        currIndex = index;
      }
    });

    if (recentSearchHistory[currIndex + 1]) {
      recentSearchHistory[currIndex]['active'] = false;
      recentSearchHistory[currIndex + 1]['active'] = true;
    } else {
      recentSearchHistory[currIndex]['active'] = false;
      recentSearchHistory[0]['active'] = true;
    }

    setRecentSearch(recentSearchHistory);
  };
  /**
   * Highlight the previous text feild value in the list on pressing up arrow key
   */


  var moveActiveUp = function moveActiveUp(e) {
    e.preventDefault();

    var recentSearchHistory = _toConsumableArray(recentSearch);

    var currIndex = 0;
    if (recentSearchHistory.length < 1) return true;
    recentSearchHistory.forEach(function (elem, index) {
      if (elem['active']) {
        currIndex = index;
      }
    });

    if (recentSearchHistory[currIndex - 1]) {
      recentSearchHistory[currIndex]['active'] = false;
      recentSearchHistory[currIndex - 1]['active'] = true;
    } else {
      recentSearchHistory[currIndex]['active'] = false;
      recentSearchHistory[recentSearchHistory.length - 1]['active'] = true;
    }

    setRecentSearch(recentSearchHistory);
  };
  /**
   * To move up and down in the recent search list using arrow keys
   */


  var changeActiveTab = function changeActiveTab(e) {
    var pressedKey = e.keyCode || e.which;

    if (pressedKey === 38) {
      moveActiveUp(e);
    } else if (pressedKey === 40) {
      moveActiveDown(e);
    }

    if (pressedKey === 13) {
      var currEl = {};

      if (!recentSearch.length) {
        return;
      }

      recentSearch.forEach(function (elem) {
        if (elem['active']) {
          currEl = elem;
        }
      });
      handleSubmit(currEl.searchContent);
    }
  };

  return /*#__PURE__*/React__default.createElement(ClickAwayListener, {
    onClickAway: hidefocusdata
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.relativeDiv
  }, /*#__PURE__*/React__default.createElement(Paper, {
    elevation: 0,
    square: true,
    onSubmit: submitEv,
    component: "form",
    className: clsx(classes.searchBox, (_clsx = {}, _defineProperty(_clsx, classes["paper--".concat(bgColor)], bgColor !== null), _defineProperty(_clsx, classes["bg-".concat(bgColor)], bgColor !== 'initial'), _defineProperty(_clsx, 'formBorder', focusEl), _clsx)),
    "aria-label": placeholderText,
    "data-locator": SEARCH_BAR_CONTAINER,
    "data-locator-count": pastSearchRecordsCount
  }, /*#__PURE__*/React__default.createElement(InputBase, {
    inputRef: inputEl,
    className: classes.searchInput,
    placeholder: placeholderText,
    name: placeholderText,
    defaultValue: props.searchText,
    onKeyDown: changeActiveTab,
    onChange: handleChange,
    onFocus: !enableAutoFocus ? handleChange : function () {},
    autoComplete: "off",
    inputProps: {
      'aria-label': placeholderText
    }
  }), /*#__PURE__*/React__default.createElement(IconButton, {
    tabIndex: 0,
    disableRipple: true,
    className: clsx(classes.closeInputIconWrapper, (_clsx2 = {}, _defineProperty(_clsx2, classes['showItems'], closeEl), _defineProperty(_clsx2, classes['hideItems'], !closeEl), _defineProperty(_clsx2, 'showFocusOnButton', useKeyBoard), _clsx2)),
    "aria-label": "Clear",
    onClick: clearFieldData,
    onKeyPress: function onKeyPress(e) {
      if (e.key === 'Enter') {
        clearFieldData();
      }
    }
  }, /*#__PURE__*/React__default.createElement(Close, {
    className: clsx('clearInput', classes.closeInputIcon),
    "data-locator": CLOSE_ICON
  })), /*#__PURE__*/React__default.createElement(IconButton, {
    color: "primary",
    disableRipple: true,
    className: clsx(classes.searchInputIconWrapper, _defineProperty({}, 'showFocusOnButton', useKeyBoard)) // eslint-disable-line no-useless-computed-key
    ,
    "aria-label": "Search",
    type: "submit"
  }, /*#__PURE__*/React__default.createElement(SearchIcon, {
    className: classes.searchInputIcon,
    "data-locator": SEARCH_ICON
  }))), /*#__PURE__*/React__default.createElement(Paper, {
    className: clsx(classes.cookieOverlay, (_clsx4 = {}, _defineProperty(_clsx4, classes['showItems'], focusEl), _defineProperty(_clsx4, classes['hideItems'], !focusEl), _clsx4)),
    "data-locator": SERACH_HISTORY_CONTAINER
  }, recentSearch && recentSearch.map(function (item) {
    var _clsx5;

    return /*#__PURE__*/React__default.createElement("div", {
      tabIndex: 0,
      key: item.searchContent,
      onFocus: handleHoveState.bind(null, item.searchContent),
      className: clsx(classes.searchHistoryWrapper, (_clsx5 = {}, _defineProperty(_clsx5, 'active', item.active), _defineProperty(_clsx5, classes['history-bg-orange'], color !== 'initial'), _defineProperty(_clsx5, 'hideFocusonClick', !useKeyBoard), _clsx5)),
      onMouseOver: handleHoveState.bind(null, item.searchContent),
      onMouseLeave: handleHoveState.bind(null, recentSearch[0].searchContent),
      onKeyPress: function onKeyPress(e) {
        if (e.key === 'Enter') {
          handleSubmit(e.currentTarget.innerText.substring(0, e.currentTarget.innerText.length - 6));
        }
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: classes.cookieDataWrapper,
      onClick: function onClick(e) {
        return handleSubmit(e.currentTarget.innerText.trim());
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: classes.historyIcon,
      "data-locator": SERACH_HISTORY_ICON
    }, /*#__PURE__*/React__default.createElement(NamedIcon$1, {
      icon: searchHistoryIcon
    })), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: 'body1',
      component: 'h6',
      "data-locator": SERACH_HISTORY_CONTENT,
      className: classes.wordWrap
    }, item.searchContent)), /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
      onClick: removeHistoryItem.bind(null, item.searchContent),
      onKeyPress: function onKeyPress(e) {
        if (e.key === 'Enter') {
          removeHistoryItem(item.searchContent);
          e.stopPropagation();
        }
      },
      className: clsx(classes.removeButton, _defineProperty({}, 'showFocusOnButton', useKeyBoard)),
      id: "button",
      alt: removeBtnLabel // alt={t('remove')}
      ,
      "aria-label": removeBtnLabel // aria-label={t('remove')}
      ,
      "data-locator": SERACH_REMOVE_BUTTON,
      GTMSharedKey: "remove"
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: 'searchRemoveBtn',
      component: 'span',
      color: 'orange'
    }, removeBtnLabel)));
  }))));
};

var SearchInput$1 = /*#__PURE__*/React__default.memo(SearchInput);

var SearchModal = function SearchModal(props) {
  var item = get$1(props, "item", {});
  var classes = get$1(props, "classes", {});
  var searchModalVisible = get$1(props, "searchModalVisible", false);
  var onHideSearchModal = get$1(props, "onHideSearchModal", null);
  var searchHistoryIcon = get$1(props, "searchHistoryIcon", "history");
  var bgColor = get$1(props, "bgColor", "white"); // states

  var _useState = useState(searchModalVisible),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1]; // methods


  var onCollapseOverlay = function onCollapseOverlay() {
    setVisible(false);
  };

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;

  var handleSearchSubmit = useCallback(function (searchText) {
    if (typeof props.handleSearch === "function" && typeof searchText === "string") {
      setTimeout(onCollapseOverlay, 350);
      props.handleSearch(searchText);
    } else {
      searchText = searchText.trim();
      /* istanbul ignore else */

      if (searchText) {
        // close search modal
        setTimeout(onCollapseOverlay, 350); // navigate(`${get(item, 'fields.link.value.href', '/')}?q=${searchText}`);

        window.location.href = "".concat(get$1(item, "fields.link.value.href", "/"), "?q=").concat(searchText);
      }
    }
  }, []);

  var handleKeyPress = function handleKeyPress(event) {
    if (event.keyCode === 27 || event.keyCode === 13) {
      setVisible(false);
    }
  }; // effects


  useEffect(function () {
    setOpen(searchModalVisible);
  }, [searchModalVisible]);
  return /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: open,
    transparent: true,
    PaperProps: {
      onClick: function onClick(e) {
        /* istanbul ignore else */
        if (e.target.classList.contains("MuiPaper-root")) {
          onCollapseOverlay();
        }
      }
    },
    fullScreen: true,
    "data-locator": HEADER_SEARCH_MODAL,
    darkMode: true,
    variant: "searchOverlay",
    onEntered: function onEntered() {
      setVisible(true);
    } // transition can't be simulated
    ,
    onExited:
    /* istanbul ignore next */
    function onExited() {
      onHideSearchModal && onHideSearchModal();
    },
    gtmPushEvent: props.gtmPushEvent
  }, /*#__PURE__*/React__default.createElement(Collapse, {
    in: visible,
    onExiting:
    /* istanbul ignore next */
    function onExiting() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React__default.createElement(Container$1, {
    background: bgColor,
    "data-locator": HEADER_SEARCH_MODAL_CONTAINER,
    className: clsx(classes.searchModalContainer, getPaddingString({
      paddingTop: "large",
      paddingBottom: "large"
    }))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.searchModalContainerInner
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
    className: clsx(classes.searchModalCloseBtn, "motionColorTransition", _defineProperty({}, "showFocusOnButton", useKeyBoard)),
    onClick: onCollapseOverlay,
    onKeyPress: handleKeyPress,
    icon: "close",
    alt: "close",
    "aria-label": "close",
    "data-locator": HEADER_SEARCH_MODAL_CLOSE_ICON,
    hasMotionElevate: false,
    disableFocusRipple: true,
    gtmPushEvent: props.gtmPushEvent
  })), /*#__PURE__*/React__default.createElement(Container$1, {
    className: classes.searchForm,
    onKeyUp: handleKeyPress
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 12,
    lg: 6
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    mb: 3,
    className: classes.searchModalTitle,
    tag: "p",
    variant: "h2",
    component: "h2",
    "data-locator": HEADER_SEARCH_MODAL_TITLE,
    color: bgColor
  }, item.searchTitle.value), /*#__PURE__*/React__default.createElement(SearchInput$1, {
    placeholderText: item.searchPlaceholderText,
    pastSearchRecordsCount: item.searchPastRecordsCount,
    onSubmit: handleSearchSubmit,
    color: bgColor,
    enableAutoFocus: true,
    searchHistoryIcon: searchHistoryIcon,
    removeBtnLabel: item.searchHistoryRemoveText
  })))))));
}; // const mapDispatchToProps = dispatch => {
//   return {
//     setSearchParams: params => dispatch(searchActions.setSearchParams(params)),
//     setSearchTriggerPoint: params => dispatch(searchActions.setSearchTriggerPoint(params)),
//   };
// };


var SearchModal$1 = /*#__PURE__*/React__default.memo(SearchModal); // export default connect(null, mapDispatchToProps)(React.memo(SearchModal));

var _this$2 = undefined;

var HeaderRightContentItem = function HeaderRightContentItem(props) {
  var _clsx2;

  var classes = props.classes,
      isTablet = props.isTablet,
      item = props.item,
      gaCategoryName = props.gaCategoryName,
      bgColor = props.bgColor,
      surfaceColor = props.surfaceColor,
      index = props.index,
      headerActiveEl = props.headerActiveEl,
      setHeaderActiveEl = props.setHeaderActiveEl,
      _props$scrolledDown = props.scrolledDown,
      scrolledDown = _props$scrolledDown === void 0 ? false : _props$scrolledDown,
      liveChatTitle = props.liveChatTitle,
      offlineChatGreeting = props.offlineChatGreeting,
      onlineChatGreeting = props.onlineChatGreeting,
      isMobileHeaderLanguageSwitch = props.isMobileHeaderLanguageSwitch;
  var popperClosingTimeout = null;
  var navigate = get$1(props, "navigate", function (href) {
    if (typeof window !== "undefined") {
      window.open(href);
    }
  }); // states

  var isMobileWidth = useMediaQuery$1("(max-width:".concat(breakpoints.values.xl, "px)"));
  var children = get$1(item, "Children", []);
  var title = get$1(item, "fields.title.value", "") || get$1(item, "fields.link.value.text", "");
  var enableDropdown = get$1(item, "fields.enableDropdown.value", true);
  var buttonIcon = get$1(item, "fields.buttonIcon.fields.value.value", null);
  var listType = get$1(item, "fields.listType.fields.key.value", "");
  var isSearch = listType === linkListTypes.SEARCH;
  var hasMouseEnter = !isMobileWidth && !isTablet && enableDropdown && !isSearch && !isEmpty(children);
  var linkHref = listType === "call" ? get$1(item, "fields.link.value.url", "") : get$1(item, "fields.link.value.href", "");
  var linkTarget = get$1(item, "fields.link.value.target", "");
  var linkType = get$1(item, "fields.link.value.linktype", "");
  var GTMSharedKey = get$1(item, "fields.linkGALabelName.value", ""); // const { t } = useTranslation();

  var chatLanguage = {
    // liveChatTitle: t('liveChatTitle'),
    // offlineChatGreeting: t('offlineChatGreeting'),
    // onlineChatGreeting: t('onlineChatGreeting'),
    liveChatTitle: liveChatTitle || "Live chat",
    offlineChatGreeting: offlineChatGreeting || "Leave a message",
    onlineChatGreeting: onlineChatGreeting || "Leave a message"
  };
  var liveChatMethods = {
    // close modal after livechat is initialized and connected

    /* 3rd party library can't be simulated */
    setOnConnected: function setOnConnected() {
      setAnchorEl(null);
    }
  };
  var handleOnClick = listType === "click" ? get$1(item, "fields.listType.fields.onClick") : function () {};
  var buttonModesValue = get$1(item, "fields.listType.buttonModes", buttonModes.PRIMARY); // states

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      hoverClickData = _useState2[0],
      setHoverClickData = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      anchorEl = _useState4[0],
      setAnchorEl = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      popperClosing = _useState6[0],
      setPopperClosing = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      searchModalVisible = _useState8[0],
      setSearchModalVisible = _useState8[1];

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;

  useEffect(function () {
    if (typeof window !== "undefined") {
      window.onpopstate = function () {
        setSearchModalVisible && setSearchModalVisible(false);
      };
    }
  }, []); // refs

  var rootRef = useRef();

  var onActivateItem = function onActivateItem(el, e) {
    var _e$target, _e$target$classList;

    // ignore if it tabbing within the menulist
    if ((e === null || e === void 0 ? void 0 : e.type) === "focus" && !(e !== null && e !== void 0 && (_e$target = e.target) !== null && _e$target !== void 0 && (_e$target$classList = _e$target.classList) !== null && _e$target$classList !== void 0 && _e$target$classList.contains("headerRightContentItem"))) {
      return;
    }
    /* istanbul ignore else */


    if (popperClosingTimeout) {
      popperClosingTimeoutFunc(popperClosing, anchorEl);
    } // we need an state and effect to trigger a render, as popperClosingTimeoutFunc is setting to null


    setHoverClickData({
      item: _objectSpread2({}, el),
      e: _objectSpread2({}, e)
    });
  };

  var onDeactivateItem = function onDeactivateItem(e) {
    var _e$target2, _e$target2$parentNode, _e$target2$parentNode2, _e$target3;

    var lastMenuItem = e === null || e === void 0 ? void 0 : (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : (_e$target2$parentNode = _e$target2.parentNode) === null || _e$target2$parentNode === void 0 ? void 0 : (_e$target2$parentNode2 = _e$target2$parentNode.parentNode) === null || _e$target2$parentNode2 === void 0 ? void 0 : _e$target2$parentNode2.querySelector(".MuiListItem-root:last-child");
    /* istanbul ignore else */

    if ((popperClosing === null || popperClosing === void 0 ? void 0 : popperClosing.target) !== null && (e === null || e === void 0 ? void 0 : e.type) !== "blur" || // if tabbing out the last item
    (e === null || e === void 0 ? void 0 : e.type) === "blur" && lastMenuItem === (e === null || e === void 0 ? void 0 : (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.parentNode)) {
      setPopperClosing({
        target: e === null || e === void 0 ? void 0 : e.target,
        type: e === null || e === void 0 ? void 0 : e.type
      });
    }
  }; // setAnchorEl(null) after fadeout animation is completed


  var popperClosingTimeoutFunc = function popperClosingTimeoutFunc(_popperClosing, _anchorEl) {
    /* istanbul ignore else */
    if (!(_popperClosing && _popperClosing.target && ["click", "touchend"].includes(_popperClosing.type) && hasParents(_popperClosing.target, "headerRightContentItem"))) {
      _anchorEl && setAnchorEl(null);
    }

    setPopperClosing(null);
    clearTimeout(popperClosingTimeout);
    popperClosingTimeout = null;
  };

  var onHideSearchModal = function onHideSearchModal() {
    searchModalVisible && PushEvent({
      event: "buttonClick",
      buttonTitle: HEADER_SEARCH_MODAL_CLOSE_ICON,
      componentName: get$1(item, "fields.gaCategoryName.value", null) || gaCategoryName || HEADER_SEARCH_MODAL_CLOSE_ICON,
      destinationUrl: undefined
    }, props.gtmPushEvent);
    setSearchModalVisible(false);
  };

  var linkHandler = function linkHandler(e) {
    if (listType !== "call") {
      if (e.preventDefault) {
        e.preventDefault();
      }

      if (e.stopPropagation) {
        e.stopPropagation();
      }

      if (listType === "click") {
        return handleOnClick();
      }

      if (listType === "chat") {
        e.nativeEvent.stopImmediatePropagation();

        if (typeof window !== "undefined") {
          window.LiveChat(fwdColors.orange, true, liveChatMethods, chatLanguage, false, e);
        }
      } else if (listType === "generic_link") {
        if ((e.ctrlKey || e.metaKey) && typeof window !== "undefined") {
          window.open(linkHref, "_blank");
        } else if (linkType === "internal") {
          navigate(linkHref);
        } else if (linkType === "external") {
          if (linkTarget === "_blank" && typeof window !== "undefined") {
            window.open(linkHref, "_blank");
          } else {
            navigate(linkHref);
          }
        }
      }
    }
  };

  var menuListMemo = useMemo(function () {
    return /*#__PURE__*/React__default.createElement(MenuList, {
      autoFocusItem: true,
      variant: "menu"
    }, children.map(function (child) {
      return /*#__PURE__*/React__default.createElement(MenuItem, {
        key: child.id,
        "data-locator": HEADER_POPPER_MENU_ITEM,
        className: clsx(classes.menuItem, classes.popperMenuItem, _defineProperty({}, classes["menuItem-".concat(bgColor)], bgColor))
      }, /*#__PURE__*/React__default.createElement(NavigationLink$1, {
        listType: get$1(child, "fields.listType", null),
        link: get$1(child, "fields.link", null),
        size: "small",
        hasTitle: true,
        icon: get$1(child, "fields.buttonIcon.fields.value.value", null),
        title: get$1(child, "fields.title.value", "") || get$1(child, "fields.link.value.text", ""),
        dataLocator: HEADER_POPPER_MENU_ITEM_TEXT,
        fontWeight: "bold",
        color: bgColor,
        onClick: onDeactivateItem,
        GTMSharedKey: get$1(child, "fields.gaLabelName.value", ""),
        tabIndex: index,
        liveChatMethods: liveChatMethods,
        setDisclosurePopupList: props.setDisclosurePopupList,
        navigate: navigate,
        gtmPushEvent: props.gtmPushEvent
      }));
    }));
  }, [] // eslint-disable-line react-hooks/exhaustive-deps
  ); // effects

  useEffect(function () {
    /* istanbul ignore else */
    if (scrolledDown && anchorEl) {
      onDeactivateItem();
    }
  }, [scrolledDown]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    /* istanbul ignore else */
    if (isMobileWidth && headerActiveEl !== anchorEl) {
      onDeactivateItem();
    }
  }, [headerActiveEl, isMobileWidth]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    /* istanbul ignore else */
    if (popperClosing) {
      popperClosingTimeout = setTimeout(function () {
        // eslint-disable-line react-hooks/exhaustive-deps
        popperClosingTimeoutFunc(popperClosing, anchorEl);
      }, [isMobileWidth ? 400 : 600]);
    }
  }, [popperClosing, isMobileWidth]);
  useEffect(function () {
    var detectAndOffsetNotification = function detectAndOffsetNotification(callback) {
      var notificationElm = document.querySelector(".notifications");
      /* istanbul ignore if */

      if (notificationElm && notificationElm.getBoundingClientRect().bottom > 0) {
        setTimeout(function () {
          callback();
          animateScroll.scrollTo(notificationElm.getBoundingClientRect().height, {
            duration: 150,
            smooth: "easeInOutQuint"
          });
        }, 150);
      } else {
        callback();
      }
    };
    /* istanbul ignore else */


    if (hoverClickData) {
      if (isSearch) {
        detectAndOffsetNotification(function () {
          return setSearchModalVisible(true);
        });
        PushEvent({
          event: "buttonClick",
          buttonTitle: HEADER_SEARCH,
          componentName: get$1(hoverClickData.item, "fields.gaCategoryName.value", null) || gaCategoryName || HEADER_SEARCH,
          destinationUrl: undefined
        }, props.gtmPushEvent);
        setHeaderActiveEl && setHeaderActiveEl(hoverClickData.e.currentTarget);
      } else if (hoverClickData.e.type === "focus") {
        setAnchorEl(hoverClickData.e.currentTarget);
        setHeaderActiveEl && setHeaderActiveEl(hoverClickData.e.currentTarget);
      } else if (enableDropdown) {
        if (anchorEl) {
          setAnchorEl(null);
        } else {
          setAnchorEl(hoverClickData.e.currentTarget);
          setHeaderActiveEl && setHeaderActiveEl(hoverClickData.e.currentTarget);

          if (hoverClickData.e.type === "click") {
            if (get$1(hoverClickData.item, "fields.link.value.href", null)) {
              linkHandler(hoverClickData.e);
              setAnchorEl(null);
              return;
            }

            PushEvent({
              event: "buttonClick",
              buttonTitle: get$1(hoverClickData.item, "fields.gaLabelName.value", "") || getGTMSharedKeyVal(undefined, HEADER_RIGHTCONTENT_ITEM),
              componentName: get$1(hoverClickData.item, "fields.gaCategoryName.value", null) || gaCategoryName || HEADER_RIGHTCONTENT_ITEM,
              destinationUrl: undefined
            }, props.gtmPushEvent);
          }
        }
      }
    }
  }, [hoverClickData]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    ref: rootRef,
    className: clsx(classes.link, "headerRightContentItem", (_clsx2 = {}, _defineProperty(_clsx2, "hideFocusonClick", !useKeyBoard), _defineProperty(_clsx2, classes.item, !isMobileHeaderLanguageSwitch), _defineProperty(_clsx2, classes.mobileHeaderLanguageSwitchItem, isMobileHeaderLanguageSwitch), _clsx2)),
    role: "button",
    onClick: isMobileWidth || isTablet || !hasMouseEnter ? onActivateItem.bind(_this$2, item) : null,
    onMouseEnter: !useKeyBoard && hasMouseEnter ? onActivateItem.bind(_this$2, item) : null,
    onMouseLeave: !useKeyBoard && hasMouseEnter ? onDeactivateItem : null,
    onFocus: useKeyBoard && hasMouseEnter ? onActivateItem.bind(_this$2, item) : null,
    onBlur: useKeyBoard && hasMouseEnter ? onDeactivateItem : null,
    "data-locator": HEADER_RIGHTCONTENT_ITEM,
    "aria-label": get$1(item, "displayName", HEADER_RIGHTCONTENT_ITEM.replace(/-/gi, " ")),
    tabIndex: 0,
    onKeyPress: function onKeyPress(e) {
      if (e.key === "Enter") {
        isSearch && onActivateItem.call(_this$2, item, e);
      }
    },
    onKeyUp: function onKeyUp(e) {
      var _e$target4, _e$target4$parentNode, _e$target4$parentNode2, _e$target5;

      var lastMenuItem = e === null || e === void 0 ? void 0 : (_e$target4 = e.target) === null || _e$target4 === void 0 ? void 0 : (_e$target4$parentNode = _e$target4.parentNode) === null || _e$target4$parentNode === void 0 ? void 0 : (_e$target4$parentNode2 = _e$target4$parentNode.parentNode) === null || _e$target4$parentNode2 === void 0 ? void 0 : _e$target4$parentNode2.querySelector(".MuiListItem-root:last-child");

      if (lastMenuItem === (e === null || e === void 0 ? void 0 : (_e$target5 = e.target) === null || _e$target5 === void 0 ? void 0 : _e$target5.parentNode)) {
        var elms = _toConsumableArray(document.querySelectorAll(".headerRightContentItem"));

        elms[Math.min(elms.indexOf(rootRef.current) + 1, elms.length - 1)].focus();
      }
    }
  }, title ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DynamicLink$1, {
    value: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, get$1(item, "fields.link.value", {})), get$1(item, "fields.link.value.linktype", "") ? {} : {
      linktype: "external"
    }), listType === "call" ? {
      linktype: "",
      target: "_self"
    } : {}), {}, {
      href: linkHref,
      text: title
    }),
    onClick: !isEmpty(children) || listType === "call" ? function () {} : linkHandler,
    className: clsx(classes.rightContentButton, classes.mobileView),
    "data-locator": HEADER_RIGHTCONTENT_BUTTON,
    buttonStyle: buttonModesValue,
    color: "white",
    gaCategoryName: get$1(item, "fields.gaCategoryName.value", null) || gaCategoryName,
    buttonMode: buttonModesValue,
    htmlComponent: !isEmpty(children) || listType === "chat" ? "div" : "a",
    GTMSharedKey: GTMSharedKey,
    disableFocusRipple: isMobileWidth || isTablet,
    disableTabIndex: true,
    forcedHtmlComponent: true,
    navigate: navigate,
    gtmPushEvent: props.gtmPushEvent
  }), /*#__PURE__*/React__default.createElement(DynamicLink$1, {
    value: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, get$1(item, "fields.link.value", {})), get$1(item, "fields.link.value.linktype", "") ? {} : {
      linktype: "external"
    }), listType === "call" ? {
      linktype: "",
      target: "_self"
    } : {}), {}, {
      href: linkHref,
      text: title
    }),
    onClick: listType === "call" ? function () {} : linkHandler,
    className: clsx(classes.rightContentButton, classes.desktopView),
    "data-locator": HEADER_RIGHTCONTENT_BUTTON,
    buttonStyle: buttonModesValue,
    color: "white",
    gaCategoryName: get$1(item, "fields.gaCategoryName.value", null) || gaCategoryName,
    buttonMode: buttonModesValue,
    htmlComponent: !isEmpty(children) || listType === "chat" ? "div" : "a",
    GTMSharedKey: GTMSharedKey,
    disableFocusRipple: isMobileWidth || isTablet,
    disableTabIndex: true,
    forcedHtmlComponent: true,
    navigate: navigate,
    gtmPushEvent: props.gtmPushEvent
  })) : buttonIcon ? !isEmpty(children) && enableDropdown || isSearch ? /*#__PURE__*/React__default.createElement("div", {
    className: classes.icon,
    "data-locator": HEADER_RIGHTCONTENT_ICON,
    style: {
      display: "inline-flex"
    }
  }, /*#__PURE__*/React__default.createElement(NamedIcon$1, {
    icon: buttonIcon,
    "aria-hidden": true
  })) : /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    underline: "none",
    className: classes.icon,
    "data-locator": HEADER_RIGHTCONTENT_ICON,
    style: {
      display: "inline-flex"
    },
    href: linkHref,
    onClick: linkHandler
  }, /*#__PURE__*/React__default.createElement(NamedIcon$1, {
    icon: buttonIcon,
    "aria-hidden": true
  })) : null, !isEmpty(children) && enableDropdown && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "none"
    }
  }, menuListMemo), /*#__PURE__*/React__default.createElement(Popper, {
    anchorEl: anchorEl,
    open: !!anchorEl,
    handleClose: onDeactivateItem,
    hasClickAwayListener: isMobileWidth || isTablet || enableDropdown,
    className: clsx(classes.popper, {
      popperClosing: popperClosing !== null
    }),
    dataLocator: HEADER_POPPER,
    disablePortal: false,
    hasAnimation: popperClosing === null
  }, menuListMemo))), isSearch && /*#__PURE__*/React__default.createElement(SearchModal$1, {
    item: item,
    classes: classes,
    searchModalVisible: searchModalVisible,
    onHideSearchModal: onHideSearchModal,
    bgColor: surfaceColor,
    handleSearch: props.handleSearch,
    gtmPushEvent: props.gtmPushEvent
  }));
};

var HeaderRightContentItem$1 = /*#__PURE__*/React__default.memo(HeaderRightContentItem);

var _excluded$7 = ["icon", "type", "shape", "size", "color", "className", "parentHover", "parentRef", "hasHoverEffect", "hasShadowEffect"];

var BrandingIcon = function BrandingIcon(_ref) {
  var _clsx;

  var _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? 'call-email' : _ref$icon,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'primary' : _ref$type,
      _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? 'circle' : _ref$shape,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'white' : _ref$color,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$parentHover = _ref.parentHover,
      parentHover = _ref$parentHover === void 0 ? false : _ref$parentHover,
      _ref$parentRef = _ref.parentRef,
      parentRef = _ref$parentRef === void 0 ? null : _ref$parentRef,
      _ref$hasHoverEffect = _ref.hasHoverEffect,
      hasHoverEffect = _ref$hasHoverEffect === void 0 ? true : _ref$hasHoverEffect,
      _ref$hasShadowEffect = _ref.hasShadowEffect,
      hasShadowEffect = _ref$hasShadowEffect === void 0 ? true : _ref$hasShadowEffect,
      props = _objectWithoutProperties(_ref, _excluded$7);

  var ref = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hovered = _useState2[0],
      setHovered = _useState2[1];

  var button = '';
  var hoverRef;

  var handleMouseOver = function handleMouseOver() {
    return setHovered(true);
  };

  var handleMouseOut = function handleMouseOut() {
    return setHovered(false);
  };

  useEffect(function () {
    if (hasHoverEffect) {
      if (parentRef && parentRef.current) {
        hoverRef = parentRef.current; // eslint-disable-line react-hooks/exhaustive-deps

        /* istanbul ignore else */
      } else if (ref && ref.current && ref.current.parentNode) {
        if (parentHover) {
          hoverRef = ref.current.parentNode;
        } else {
          hoverRef = ref.current;
        }
      }
    }

    if (hoverRef && hasHoverEffect) {
      hoverRef.addEventListener('mouseover', handleMouseOver);
      hoverRef.addEventListener('mouseout', handleMouseOut);
    }
  }, [parentRef, ref]);
  button = /*#__PURE__*/React__default.createElement("div", {
    ref: ref,
    "data-locator": props['data-locator'],
    className: clsx('motionColorTransition', 'branding-icon', (_clsx = {}, _defineProperty(_clsx, "branding-icon-".concat(size), shape === 'circle' || shape === 'square'), _defineProperty(_clsx, "branding-icon-".concat(size, "-default"), shape === 'default'), _defineProperty(_clsx, 'branding-icon-default', shape === 'default'), _defineProperty(_clsx, 'branding-icon-circle', !hovered && shape === 'circle'), _defineProperty(_clsx, 'branding-icon-square', !hovered && shape === 'square'), _defineProperty(_clsx, 'branding-icon-hovered-circle', hovered && shape === 'circle' && hasShadowEffect), _defineProperty(_clsx, 'branding-icon-hovered-square', hovered && shape === 'square' && hasShadowEffect), _defineProperty(_clsx, "branding-icon-".concat(type, "-").concat(color), shape !== 'default'), _defineProperty(_clsx, "branding-icon-".concat(type, "-").concat(color, "-default"), shape === 'default'), _defineProperty(_clsx, "branding-icon-".concat(type, "-").concat(color, "-hovered"), hovered && shape !== 'default'), _defineProperty(_clsx, "branding-icon-".concat(type, "-").concat(color, "-hovered-default"), hovered && shape === 'default'), _defineProperty(_clsx, getBorderRadius('circle'), shape === 'circle'), _defineProperty(_clsx, getBorderRadius('small'), shape === 'square' || shape === 'default'), _clsx), className)
  }, /*#__PURE__*/React__default.createElement(NamedIcon$1, {
    icon: icon
  }));
  return button;
};

var HEADER_CALL_SUPPORT = 'Header-Call-Support';

var styles$10 = {
  wrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    right: "10px",
    bottom: "15px"
  },
  typoWrapper: {
    marginLeft: "5px",
    marginBottom: "-15px"
  }
};

var PhoneSelector = function PhoneSelector(props) {
  var telePhoneSelector = props.telePhoneSelector;
  return /*#__PURE__*/React__default.createElement("div", {
    style: styles$10.wrapper,
    onClick: function onClick() {
      PushEvent({
        event: "buttonClick",
        buttonTitle: HEADER_CALL_SUPPORT,
        componentName: HEADER_CALL_SUPPORT,
        destinationUrl: "tel:".concat(telePhoneSelector[0].number)
      }, props.gtmPushEvent);
      window.open("tel:".concat(telePhoneSelector[0].number), "_self");
    }
  }, /*#__PURE__*/React__default.createElement(BrandingIcon, {
    icon: "call-dual-tone",
    type: "primary",
    size: "sm",
    shape: "circle",
    parentHover: true
  }), /*#__PURE__*/React__default.createElement("div", {
    style: styles$10.typoWrapper
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h5"
  }, telePhoneSelector[0].number)));
};

var PhoneSelector$1 = /*#__PURE__*/React__default.memo(PhoneSelector);

var transitionDuration = 700;
var lastScrollTop = typeof window === "undefined" ? 0 : window.pageYOffset; // Transition props

var TransitionComponent = /*#__PURE__*/React__default.forwardRef(function TransitionComponent(props, ref) {
  return /*#__PURE__*/React__default.createElement(Slide, _extends({
    direction: "right",
    ref: ref
  }, props));
});

var Header$1 = function Header(props) {
  var _window, _window$DeviceDetecti, _window2, _window2$location, _ref;

  var _getColors = getColors("white-orange"),
      bgColor = _getColors.bgColor,
      surfaceColor = _getColors.surfaceColor;

  var classes = headerStyles({
    bgColor: bgColor,
    surfaceColor: surfaceColor,
    transitionDuration: transitionDuration
  });
  var enableMargin = !!parseInt(get$1(props, "params.enableMargin", "0"));
  var searchPastRecordsCount = get$1(props, "fields.pastSearchRecordsCount.value", "");
  var searchTitle = get$1(props, "fields.title", {});
  var searchPlaceholderText = get$1(props, "fields.placeholderText.value", "");
  var searchHistoryRemoveText = get$1(props, "fields.searchHistoryRemoveText.value", "");
  var languageList = get$1(props, "fields.languageList", []);
  var languageModalTitle = get$1(props, "fields.languageModalTitle.value", "Do you want to Continue ?");
  var enablelanguageList = get$1(props, "fields.enableLanguageToggle.value", true);
  var languageModalDescription = get$1(props, "fields.languageModalDescription.value", "");
  var languageModalSecondaryLink = get$1(props, "fields.languageModalSecondaryLink.value", "");
  var languageModalLink = get$1(props, "fields.languageModalLink.value", "");
  var image = get$1(props, "fields.logo", null);
  var desktopImage = get$1(props, "fields.desktopLogo", null);
  var mobileImage = get$1(props, "fields.mobileLogo", null);
  var logoIcon = get$1(props, "fields.headerLogo", null);
  var iconNavigationLinks = (get$1(props, "fields.iconNavigationLinks", []) || []).reduce(function (acc, item) {
    // method to determine how much slow the _item needs
    // button takes 2 slots, icon takes 1
    var getSlotCount = function getSlotCount(_item) {
      return (get$1(_item, "fields.title.value", "") || get$1(_item, "fields.link.value.text", "")) !== "" ? 2 : 1;
    }; // count the number of slots taken already


    var filledSlots = sumOfArray(acc.map(function (_item) {
      return getSlotCount(_item);
    })); // check if current slots + new item can still fit within 4 slots
    // TODO adam changed it to 6  slots

    var canBeSloted = filledSlots + getSlotCount(item) <= 6;
    var hasIconOrTitle = get$1(item, "fields.buttonIcon.fields.value.value", null) !== null || (get$1(item, "fields.title.value", "") || get$1(item, "fields.link.value.text", "")) !== ""; // has valid link + either icon or title

    var hasValidLink = (get$1(item, "fields.link.value.href", "") !== "" || get$1(item, "fields.listType.fields.key.value", "") === "chat") && hasIconOrTitle; // has children and enableDropdown is true

    var hasValidChildren = !isEmpty(get$1(item, "Children", [])) && get$1(item, "fields.enableDropdown.value", false) && hasIconOrTitle;
    var hasValidOnClick = get$1(item, "fields.listType.fields.onClick", null);

    if (canBeSloted && (hasValidLink || hasValidChildren || hasValidOnClick)) {
      acc.push(item);
    }

    return acc;
  }, []);
  var navigate = get$1(props, "navigate", function (href) {
    if (typeof window !== "undefined") {
      window.open(href);
    }
  });
  var isHomepage = get$1(props, "sitecoreContext.route.fields.pageType.fields.key.value", null) === pageTypes.HOMEPAGE; // This is a hack to handle default landing hamburger issue specific to search page

  var jssMain = get$1(props, "sitecoreContext.route.placeholders.jss-main", []);
  jssMain.some(function (item) {
    return (item === null || item === void 0 ? void 0 : item.componentName) === "GlobalSearch";
  }); // eslint-disable-line no-unused-vars

  var pageType = isHomepage ? pageTypes.INDIVIDUAL : get$1(props, "sitecoreContext.route.fields.pageType.fields.key.value", pageTypes.INDIVIDUAL);
  var primaryNavRaw = (get$1(props, "fields.headerNavigationLinks", []) || []).find(function (item) {
    return get$1(item, "fields.pageType.fields.key.value", null) === pageType && !isEmpty(get$1(item, "Children", []));
  });
  var primaryNav = get$1(primaryNavRaw, "Children", []).filter(function (item) {
    return !isEmpty(get$1(item, "fields.link.value", {})) && (get$1(item, "fields.title.value", null) || get$1(item, "fields.link.value.text", null));
  });
  var secondaryNav = (get$1(props, "fields.headerNavigationLinks", []) || []).filter(function (item) {
    return !(get$1(item, "fields.pageType.fields.key.value", null) === pageType && !isEmpty(get$1(item, "Children", [])));
  }).filter(function (item) {
    return !isEmpty(get$1(item, "fields.link.value", {})) && (get$1(item, "fields.title.value", null) || get$1(item, "fields.link.value.text", null));
  });
  var itemLanguage = get$1(props, "sitecoreContext.route.itemLanguage", "en");
  var languageCode = get$1(props, "sitecoreContext.languageCode", null);
  var countrySelector = get$1(props, "fields.countrySelector", []);
  var telePhoneSelector = get$1(props, "fields.telephoneSelector", []);
  var headerState = get$1(props, "headerState", {});
  get$1(props, "notificationExist", false); // eslint-disable-line no-unused-vars
  // const { t } = useTranslation();

  var t = function t(key) {
    var map = {
      visitFWD: "Visit FWD"
    };
    return map[key];
  };

  var gaCategoryName = get$1(props, "fields.gaCategoryName.value", "");
  var sitecoreRoute = get$1(props, "sitecoreContext.route.sitecoreRoute", "");
  var logoLink = get$1(props, "fields.logoLink.value.href", "/");
  var logoValue = get$1(props, "fields.logoLink.value.title", "");
  var availableLanguages = get$1(props, "sitecoreContext.availableLanguages", []);
  var languageIcon = get$1(props, "sitecoreContext.siteSettings.languageIcon.value", "language-globe") || "language-globe"; // refs

  var headerRef = useRef(null); // states

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuOpen = _useState2[0],
      setMenuOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      scrolledDown = _useState4[0],
      setScrolledDown = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      haveScrollBar = _useState6[0];
      _useState6[1]; // eslint-disable-line no-unused-vars


  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isFluidHeader = _useState8[0],
      setIsFluidHeader = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isFixed = _useState10[0],
      setIsFixed = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      lanuageSwitcherOpen = _useState12[0],
      setLanuageSwitcherOpen = _useState12[1];

  var isMobileWidth = useMediaQuery("(max-width:".concat(breakpoints.values.xl, "px)"));
  var isTablet = typeof window !== "undefined" && ((_window = window) === null || _window === void 0 ? void 0 : (_window$DeviceDetecti = _window.DeviceDetection) === null || _window$DeviceDetecti === void 0 ? void 0 : _window$DeviceDetecti.isTablet);

  var _useState13 = useState(),
      _useState14 = _slicedToArray(_useState13, 2),
      headerActiveEl = _useState14[0],
      setHeaderActiveEl = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      orangeHamburger = _useState16[0];
      _useState16[1]; // eslint-disable-line no-unused-vars


  var _useState17 = useState(true),
      _useState18 = _slicedToArray(_useState17, 2),
      showHamburgerBackdrop = _useState18[0];
      _useState18[1]; // eslint-disable-line no-unused-vars
  // const { pathname } = useLocation();


  var pathname = typeof window !== "undefined" ? (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.pathname : "";

  var onClickedHamburger = function onClickedHamburger(e) {
    e.stopPropagation();
    var notificationElm = document.querySelector(".notifications"); // getBoundingClientRect() can't be simulated

    /* istanbul ignore if */

    if (notificationElm && notificationElm.getBoundingClientRect().bottom > 0) {
      setTimeout(function () {
        setMenuOpen(!menuOpen);
        animateScroll.scrollTo(notificationElm.getBoundingClientRect().height, {
          duration: 150,
          smooth: "easeInOutQuint"
        });
      }, 150);
    } else {
      setMenuOpen(!menuOpen);
    }
    /* istanbul ignore else */


    if (menuOpen) {
      setScrolledDown(false);
    }
  };

  var onClickLogo = function onClickLogo(e) {
    e && e.preventDefault();
    PushEvent({
      event: "buttonClick",
      buttonTitle: HEADER_LOGO,
      componentName: gaCategoryName ? gaCategoryName : HEADER_LOGO,
      destinationUrl: logoLink
    }, props.gtmPushEvent);
    navigate(logoLink);
  }; // memos


  var leftContentMemo = useMemo(function () {
    return /*#__PURE__*/React__default.createElement("div", {
      className: classes.leftContent
    }, /*#__PURE__*/React__default.createElement("div", {
      className: clsx(classes.item, classes.leftContentInner)
    }, /*#__PURE__*/React__default.createElement(Logo$1, {
      media: {
        image: image,
        mobileImage: mobileImage,
        desktopImage: desktopImage
      },
      onClick: onClickLogo,
      href: logoLink,
      dataLocator: HEADER_LOGO,
      transitionDuration: transitionDuration,
      value: logoValue,
      icon: logoIcon
    }), !isMobileWidth && /*#__PURE__*/React__default.createElement(HeaderNavigationLinks, {
      classes: classes,
      hideMobile: true,
      primaryNav: primaryNav,
      secondaryNav: secondaryNav,
      navigate: navigate,
      isFullUrl: props.isFullUrl,
      gtmPushEvent: props.gtmPushEvent
    })));
  }, [isHomepage, isMobileWidth, pathname, primaryNav, secondaryNav] // eslint-disable-line react-hooks/exhaustive-deps
  );
  useEffect(function () {
    /* istanbul ignore if */
    if (isMobileWidth && menuOpen) {
      setMenuOpen(false);
    }
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps
  // effects

  useEffect(function () {
    setTimeout(function () {
      return props.setHeaderTransitionStatus(true);
    }, transitionDuration / 4);
    var eventListener = debounce$1(function () {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      var deltaY = scrollY > lastScrollTop ? 1 : scrollY === lastScrollTop ? 0 : -1;
      lastScrollTop = scrollY <= 0 ? 0 : scrollY;
      /* istanbul ignore else */

      if (lanuageSwitcherOpen || menuOpen || deltaY === 0) return;
      var notificationElm = document.querySelector(".notifications");

      if (notificationElm) {
        // getBoundingClientRect() can't be simulated

        /* istanbul ignore if */
        if (notificationElm.getBoundingClientRect().bottom > 0) {
          setIsFixed(false);
          setScrolledDown(false);
          setIsFluidHeader(false);
        } else {
          setScrolledDown(deltaY > 0);
          /* istanbul ignore if */

          if (deltaY < 0) {
            setIsFixed(true);
            setIsFluidHeader(true);
          }
        }
      } else {
        setIsFixed(true);
        setScrolledDown(deltaY > 0);
        deltaY < 0 && setIsFluidHeader(scrollY !== 0);
      }
    }, 100 / 6);
    /* istanbul ignore else */

    if (typeof window !== "undefined") {
      window.addEventListener("scroll", eventListener);
    }

    eventListener();
    return function () {
      /* istanbul ignore else */
      if (typeof window !== "undefined") {
        window.removeEventListener("scroll", eventListener);
      }
    };
  }, [lanuageSwitcherOpen, menuOpen, headerRef]); // eslint-disable-line react-hooks/exhaustive-deps
  // close the mobile menu if responsive scales from mobile to desktop

  useEffect(function () {
    /* istanbul ignore if */
    if (!isMobileWidth) {
      setMenuOpen(false);
    }
  }, [isMobileWidth, menuOpen]);
  useEffect(function () {
    props.setHeaderVisible && props.setHeaderVisible(!scrolledDown);
  }, [scrolledDown]); // eslint-disable-line react-hooks/exhaustive-deps

  var _renderLangSwitchMobile = function _renderLangSwitchMobile() {
    var extraItemList = iconNavigationLinks.filter(function (link) {
      return link.fields.isShowInMobileHeaderLanguageSwitch;
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: classes.mobileHeaderLanguageSwitch
    }, extraItemList.map(function (item, itemIndex) {
      var isSearch = get$1(item, "fields.listType.fields.key.value", null) === linkListTypes.SEARCH;
      return /*#__PURE__*/React__default.createElement(HeaderRightContentItem$1, {
        isMobileHeaderLanguageSwitch: true,
        index: itemIndex,
        key: item.id,
        item: _objectSpread2(_objectSpread2({}, item), isSearch ? {
          searchPastRecordsCount: searchPastRecordsCount,
          searchTitle: searchTitle,
          searchPlaceholderText: searchPlaceholderText,
          searchHistoryRemoveText: searchHistoryRemoveText
        } : {}),
        classes: classes,
        isTablet: isTablet,
        gaCategoryName: gaCategoryName,
        bgColor: bgColor,
        surfaceColor: surfaceColor,
        scrolledDown: scrolledDown,
        setHeaderActiveEl: setHeaderActiveEl,
        headerActiveEl: headerActiveEl,
        setDisclosurePopupList: props.setDisclosurePopupList,
        navigate: navigate,
        handleSearch: props.handleSearch,
        gtmPushEvent: props.gtmPushEvent
      });
    }), /*#__PURE__*/React__default.createElement(LanguageSwitcher, {
      title: languageModalTitle,
      description: languageModalDescription,
      secondaryLink: languageModalSecondaryLink,
      languageModalLink: languageModalLink,
      languageList: languageList,
      itemLanguage: itemLanguage,
      languageCode: languageCode,
      onOpen: function onOpen() {
        return setLanuageSwitcherOpen(true);
      },
      onClose: function onClose() {
        return setLanuageSwitcherOpen(false);
      },
      variant: "small",
      placement: "header",
      gaCategoryName: gaCategoryName,
      sitecoreRoute: sitecoreRoute,
      availableLanguages: availableLanguages,
      color: bgColor,
      showIcon: true,
      languageIcon: languageIcon,
      typo: "body1",
      onLanguageChange: props.onLanguageChange,
      gtmPushEvent: props.gtmPushEvent
    }));
  };

  return /*#__PURE__*/React__default.createElement("section", {
    id: "header",
    ref: headerRef,
    className: clsx.apply(void 0, [classes.header].concat(_toConsumableArray(Object.keys(headerState).filter(function (k) {
      return headerState[k].sticky;
    }).map(function (k) {
      return classes["state--".concat(k)];
    })), [(_ref = {}, _defineProperty(_ref, classes.scrolled, !menuOpen && scrolledDown), _defineProperty(_ref, "scrolled", !menuOpen && scrolledDown), _defineProperty(_ref, classes.fluidHeader, isFluidHeader), _defineProperty(_ref, classes.menuOpen, menuOpen), _defineProperty(_ref, classes.fixed, isFixed), _defineProperty(_ref, classes.enableMargin, enableMargin), _defineProperty(_ref, classes["header-".concat(bgColor)], bgColor), _ref)])),
    "data-locator": HEADER_NAME
  }, /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: menuOpen,
    TransitionComponent: TransitionComponent,
    BackdropProps: {
      invisible: true
    },
    variant: "mobileHeaderMenu",
    fullScreen: true,
    className: clsx(_defineProperty({}, classes["header-".concat(bgColor)], bgColor)),
    gtmPushEvent: props.gtmPushEvent
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.mobileHeaderMenuDialog,
    "data-locator": HEADER_MOBILE_MENU_CONTENT
  }, !isEmpty(languageList) && languageList.length > 1 && enablelanguageList && _renderLangSwitchMobile(), isMobileWidth && /*#__PURE__*/React__default.createElement(HeaderNavigationLinks, {
    classes: classes,
    primaryNav: primaryNav,
    secondaryNav: secondaryNav,
    onClick: function onClick() {
      return setMenuOpen(false);
    },
    navigate: navigate,
    isFullUrl: props.isFullUrl,
    gtmPushEvent: props.gtmPushEvent,
    isDisableClick: props.isDisableClick
  })), /*#__PURE__*/React__default.createElement(Box, {
    p: 2,
    justifyContent: "space-between",
    display: "flex",
    borderTop: 1,
    className: clsx(classes.borderColor),
    "data-locator": HEADER_MOBILE_MENU_FOOTER,
    bgcolor: bgColor,
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0
  }, !isEmpty(countrySelector) && /*#__PURE__*/React__default.createElement(Box, {
    className: classes.countrySelectorWrapper,
    display: "inline-flex",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(CountrySelector$1, {
    dict: t,
    color: "white",
    countryList: countrySelector,
    marginTop: false,
    variant: "small",
    placement: "header",
    gtmPushEvent: props.gtmPushEvent,
    isDisableClick: props.isDisableClick
  })), !isEmpty(telePhoneSelector) && /*#__PURE__*/React__default.createElement(PhoneSelector$1, {
    telePhoneSelector: telePhoneSelector,
    gtmPushEvent: props.gtmPushEvent
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.headerWrapper),
    "data-locator": HEADER_WRAPPER
  }, /*#__PURE__*/React__default.createElement(HamburgerIcon$1, {
    open: menuOpen,
    onClick: onClickedHamburger,
    dataLocator: HEADER_MOBILE_MENU_ICON,
    color: isFluidHeader || orangeHamburger ? "orange" : "white",
    showBackDrop: showHamburgerBackdrop
  }), leftContentMemo, (!isEmpty(iconNavigationLinks) || !isEmpty(Object.values(languageList)) && Object.values(languageList).length > 1 && enablelanguageList) && /*#__PURE__*/React__default.createElement("div", {
    "data-locator": HEADER_RIGHT_CONTENT,
    className: clsx(classes.rightContent, {
      portalOffset: lanuageSwitcherOpen && !isMobileWidth && haveScrollBar
    })
  }, iconNavigationLinks.map(function (item, itemIndex) {
    var isSearch = get$1(item, "fields.listType.fields.key.value", null) === linkListTypes.SEARCH;
    if (isMobileWidth && item.fields.isDesktopOnly) return null;
    return /*#__PURE__*/React__default.createElement(HeaderRightContentItem$1, {
      index: itemIndex,
      key: item.id,
      item: _objectSpread2(_objectSpread2({}, item), isSearch ? {
        searchPastRecordsCount: searchPastRecordsCount,
        searchTitle: searchTitle,
        searchPlaceholderText: searchPlaceholderText,
        searchHistoryRemoveText: searchHistoryRemoveText
      } : {}),
      classes: classes,
      isTablet: isTablet,
      gaCategoryName: gaCategoryName,
      bgColor: bgColor,
      surfaceColor: surfaceColor,
      scrolledDown: scrolledDown,
      setHeaderActiveEl: setHeaderActiveEl,
      headerActiveEl: headerActiveEl,
      setDisclosurePopupList: props.setDisclosurePopupList,
      navigate: navigate,
      handleSearch: props.handleSearch,
      gtmPushEvent: props.gtmPushEvent
    });
  }), !isEmpty(Object.values(languageList)) && Object.values(languageList).length > 1 && enablelanguageList && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.item, classes.link, classes.mobileCheck, {
      hasBorderLeft: !isEmpty(iconNavigationLinks)
    })
  }, /*#__PURE__*/React__default.createElement(LanguageSwitcher, {
    title: languageModalTitle,
    description: languageModalDescription,
    secondaryLink: languageModalSecondaryLink,
    languageModalLink: languageModalLink,
    languageList: languageList,
    itemLanguage: itemLanguage,
    languageCode: languageCode,
    onOpen: function onOpen() {
      return setLanuageSwitcherOpen(true);
    },
    onClose: function onClose() {
      return setLanuageSwitcherOpen(false);
    },
    variant: "small",
    placement: "header",
    gaCategoryName: gaCategoryName,
    sitecoreRoute: sitecoreRoute,
    availableLanguages: availableLanguages,
    color: bgColor,
    showIcon: false,
    languageIcon: languageIcon,
    typo: "body6",
    onLanguageChange: props.onLanguageChange,
    gtmPushEvent: props.gtmPushEvent
  })))));
}; // const mapStateToProps = createStructuredSelector({
 // export default withSitecoreContext()(connect(mapStateToProps, mapDispatchToProps)(Header));

var styles$$ = function styles(theme) {
  var _wrapper, _wrapperSmall, _stickyContent, _wrapperContent;

  var theming = {};
  return _objectSpread2({
    modal: _defineProperty({
      animation: animations.fadeIn,
      '& $wrapper': {
        animation: animations.scaleUpAndFadeIn.desktop
      },
      '& .MuiDialog-container, & .MuiDialog-paper, & .MuiBackdrop-root': {
        transition: 'none !important'
      },
      '& .MuiGrid-root': {
        height: '100%'
      },
      '&.modalClosing': {
        animation: animations.fadeOut,
        '& $wrapper': {
          animation: animations.scaleDownAndFadeOut.desktop
        }
      }
    }, theme.breakpoints.down('sm'), {
      '& $wrapper': {
        animation: animations.scaleUpAndFadeIn.mobile
      },
      '&.modalClosing': {
        '& $wrapper': {
          animation: animations.scaleDownAndFadeOut.mobile
        }
      }
    }),
    wrapper: (_wrapper = {
      position: 'relative',
      maxWidth: '100%',
      margin: '0 auto',
      overflow: 'hidden',
      maxHeight: function maxHeight(_ref) {
        var viewportHeight = _ref.viewportHeight;
        return "calc((".concat(viewportHeight, " * 100) - ").concat(theme.spacing(31), "px)");
      },
      padding: theme.spacing(6, 10),
      backgroundColor: '#fff',
      borderRadius: theme.spacing(2),
      '& strong': {
        lineHeight: theme.typography.lineHeight.L9
      },
      '& ol': {
        letterSpacing: 'initial'
      },
      '& ul': {
        paddingLeft: theme.spacing(4),
        '& li': {
          paddingLeft: theme.spacing(1)
        }
      }
    }, _defineProperty(_wrapper, theme.breakpoints.down('sm'), {
      padding: theme.spacing(3),
      minHeight: 'initial'
    }), _defineProperty(_wrapper, theme.breakpoints.down('xs'), {
      height: '100%',
      maxHeight: function maxHeight(_ref2) {
        var viewportHeight = _ref2.viewportHeight;
        return "calc((".concat(viewportHeight, " * 100) - ").concat(theme.spacing(12), "px)");
      },
      '&$wrapperSmall': {
        height: 'auto',
        maxHeight: 'auto'
      }
    }), _defineProperty(_wrapper, "".concat(theme.breakpoints.down('lg'), " and (orientation: landscape)"), {
      minHeight: theme.spacing(35),
      maxHeight: 'initial',
      padding: theme.spacing(3),
      '&$wrapperSmall': {
        minHeight: theme.spacing(30)
      }
    }), _wrapper),
    wrapperSmall: (_wrapperSmall = {
      padding: theme.spacing(6)
    }, _defineProperty(_wrapperSmall, theme.breakpoints.down('sm'), {
      padding: theme.spacing(3)
    }), _defineProperty(_wrapperSmall, "".concat(theme.breakpoints.down('lg'), " and (orientation: landscape)"), {
      padding: theme.spacing(3)
    }), _wrapperSmall),
    stickyContent: (_stickyContent = {
      height: 'auto',
      maxHeight: function maxHeight(_ref3) {
        var buttonSpace = _ref3.buttonSpace,
            viewportHeight = _ref3.viewportHeight;
        return "calc((".concat(viewportHeight, " * 100) - ").concat(buttonSpace, "px)");
      },
      overflowY: 'scroll',
      width: "calc(100% + ".concat(theme.spacing(9), "px)"),
      paddingRight: theme.spacing(9),
      '-webkit-overflow-scrolling': 'touch',
      '&::-webkit-scrollbar': {
        appearance: 'none',
        '-webkit-appearance': 'none'
      },
      '&::-webkit-scrollbar:vertical': {
        width: theme.spacing(0.5)
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: theme.spacing(0.25),
        backgroundColor: 'rgba(0,0,0,0.24)'
      }
    }, _defineProperty(_stickyContent, theme.breakpoints.down('sm'), {
      width: "calc(100% + ".concat(theme.spacing(2), "px)"),
      paddingRight: theme.spacing(2)
    }), _defineProperty(_stickyContent, "".concat(theme.breakpoints.down('lg'), " and (orientation: landscape)"), {
      width: "calc(100% + ".concat(theme.spacing(3), "px)"),
      paddingRight: theme.spacing(3)
    }), _defineProperty(_stickyContent, "".concat(theme.breakpoints.down('sm'), " and (orientation: landscape)"), {
      maxHeight: function maxHeight(_ref4) {
        var buttonSpace = _ref4.buttonSpace,
            viewportHeight = _ref4.viewportHeight;
        return "calc((".concat(viewportHeight, " * 100) - ").concat(buttonSpace - 48, "px)");
      }
    }), _defineProperty(_stickyContent, "".concat(theme.breakpoints.up('lg'), " and (orientation: landscape)"), {
      maxHeight: function maxHeight(_ref5) {
        var buttonSpace = _ref5.buttonSpace,
            viewportHeight = _ref5.viewportHeight;
        return "calc((".concat(viewportHeight, " * 100) - ").concat(buttonSpace + 160, "px)");
      }
    }), _defineProperty(_stickyContent, theme.breakpoints.between('sm', 'md'), {
      maxHeight: function maxHeight(_ref6) {
        var buttonSpace = _ref6.buttonSpace,
            viewportHeight = _ref6.viewportHeight;
        return "calc((".concat(viewportHeight, " * 100) - ").concat(buttonSpace + 160, "px)");
      }
    }), _defineProperty(_stickyContent, "".concat(theme.breakpoints.up('xl'), " and (orientation: landscape)"), {
      maxHeight: function maxHeight(_ref7) {
        var buttonSpace = _ref7.buttonSpace,
            viewportHeight = _ref7.viewportHeight;
        return "calc((".concat(viewportHeight, " * 100) - ").concat(buttonSpace, "px)");
      }
    }), _stickyContent),
    wrapperContent: (_wrapperContent = {
      height: 'auto',
      maxHeight: function maxHeight(_ref8) {
        var viewportHeight = _ref8.viewportHeight;
        return "calc((".concat(viewportHeight, " * 100) - ").concat(theme.spacing(43), "px)");
      },
      minHeight: theme.spacing(35),
      width: "calc(100% + ".concat(theme.spacing(9), "px)"),
      paddingRight: theme.spacing(9),
      overflowY: 'scroll',
      '$wrapperSmall &': {
        minHeight: 'initial',
        overflowY: 'hidden'
      },
      '-webkit-overflow-scrolling': 'touch',
      '&::-webkit-scrollbar': {
        appearance: 'none',
        '-webkit-appearance': 'none'
      },
      '&::-webkit-scrollbar:vertical': {
        width: theme.spacing(0.5)
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: theme.spacing(0.25),
        backgroundColor: 'rgba(0,0,0,0.24)'
      }
    }, _defineProperty(_wrapperContent, theme.breakpoints.down('sm'), {
      width: "calc(100% + ".concat(theme.spacing(3), "px)"),
      paddingRight: theme.spacing(3)
    }), _defineProperty(_wrapperContent, theme.breakpoints.down('xs'), {
      maxHeight: function maxHeight(_ref9) {
        var viewportHeight = _ref9.viewportHeight;
        return "calc((".concat(viewportHeight, " * 100) - ").concat(theme.spacing(18), "px)");
      },
      minHeight: 'initial'
    }), _defineProperty(_wrapperContent, "".concat(theme.breakpoints.down('lg'), " and (orientation: landscape)"), {
      width: "calc(100% + ".concat(theme.spacing(3), "px)"),
      paddingRight: theme.spacing(3),
      minHeight: theme.spacing(35),
      maxHeight: function maxHeight(_ref10) {
        var viewportHeight = _ref10.viewportHeight;
        return "calc((".concat(viewportHeight, " * 100) - ").concat(theme.spacing(35), "px)");
      },
      '$wrapperSmall &': {
        maxHeight: 'initial'
      }
    }), _wrapperContent),
    wrapWord: {
      overflowWrap: 'break-word',
      wordWrap: 'break-word',
      hyphens: 'auto',
      letterSpacing: 'initial',
      '& .MuiButton-buttonText': {
        letterSpacing: 'initial'
      }
    },
    modalTitle: {
      marginBottom: theme.spacing(3),
      '$wrapperSmall &': {
        marginBottom: theme.spacing(1)
      }
    },
    modalFooter: {
      textAlign: 'center',
      marginTop: theme.spacing(3)
    },
    disclosureAgreement: {
      paddingTop: theme.spacing(3)
    },
    stickyCTA: {
      border: '1px solid transparent',
      marginTop: '0'
    },
    ctaWrapper: {
      marginTop: theme.spacing(3),
      marginBottom: -theme.spacing(2),
      '&.sideBySideLayout': {
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        justifyContent: 'center',
        '& button:first-child': {
          marginLeft: theme.spacing(1)
        },
        '& button:last-child': {
          marginRight: theme.spacing(1)
        }
      }
    },
    cta: {
      marginBottom: theme.spacing(2),
      display: 'inline-flex'
    }
  }, theming);
};

var DISCLOSURE_POPUP_CONTAINER = 'DisclosurePopupContainer';
var DISCLOSURE_POPUP_CONTENT = 'DisclosurePopupContent';
var DISCLOSURE_POPUP_TITLE = 'DisclosurePopupTitle';
var DISCLOSURE_POPUP_FOOTER_LABEL = 'DisclosurePopupTitle';
var DISCLOSURE_POPUP_PRIMARY_BUTTON = 'DisclosurePopupPrimaryButton';
var DISCLOSURE_POPUP_SECONDARY_BUTTON = 'DisclosurePopupSecondaryButton';

var useStyles$14 = makeStyles(function (theme) {
  return styles$$(theme);
});

var DisclosurePopup$1 = function DisclosurePopup(props) {
  var bgColor = get$1(props, 'color', 'white');
  var _props$disclosurePopu = props.disclosurePopupList,
      disclosurePopupList = _props$disclosurePopu === void 0 ? [] : _props$disclosurePopu,
      _props$routeLevelDisc = props.routeLevelDisclosures,
      routeLevelDisclosures = _props$routeLevelDisc === void 0 ? {} : _props$routeLevelDisc;

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard; // const { setAvailableDisclosurePopupList, setDisclosurePopupList } = useDisclosure();


  var setAvailableDisclosurePopupList = props.setAvailableDisclosurePopupList,
      setDisclosurePopupList = props.setDisclosurePopupList;
  var isMobileWidth = useMediaQuery("(max-width:".concat(breakpoints.values.sm, "px)"));
  var initialSpace = isMobileWidth ? 340 : 450; // states

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      popupContent = _useState2[0],
      setPopupContent = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      buttonDisabled = _useState6[0],
      setButtonDisabled = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      ctaDisable = _useState8[0],
      setCtaDisable = _useState8[1];

  var _useState9 = useState(initialSpace),
      _useState10 = _slicedToArray(_useState9, 2),
      buttonSpace = _useState10[0],
      setButtonSpace = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isStickyCTA = _useState12[0],
      setIsStickyCTA = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isActiveAtEndOfScroll = _useState14[0],
      setIsActiveAtEndOfScroll = _useState14[1];

  var _useState15 = useState('1vh'),
      _useState16 = _slicedToArray(_useState15, 2),
      viewportHeight = _useState16[0],
      setViewportHeight = _useState16[1];

  var isMobileLandscape = useMediaQuery("(max-width:".concat(breakpoints.values.xl, "px)  and (orientation: landscape) "));
  var classes = useStyles$14({
    buttonSpace: buttonSpace,
    viewportHeight: viewportHeight
  }); // methods

  var getAvailableDisclosureList = function getAvailableDisclosureList() {
    return disclosurePopupList.map(function (popup) {
      return {
        id: popup.id,
        isRiskDisclosure: get$1(popup, 'isRiskDisclosure.value', false),
        disclosureSessionTimeout: get$1(popup, 'sessionTimeout.value', disclosurePopups.SESSION_TIMEOUT) || disclosurePopups.SESSION_TIMEOUT,
        frequency: get$1(popup, 'frequency.fields.key.value', 'once-in-browsing-session'),
        defaultPageLink: get$1(popup, 'defaultPageLink.value.href', null),
        primaryLink: get$1(popup, 'link.value.href', null),
        primaryLinkType: get$1(popup, 'link.value.linktype', null),
        isCloseCTA: get$1(popup, 'isCloseCTA.value', false),
        secondaryLink: get$1(popup, 'secondaryLink.value.href', null),
        secondaryLinkType: get$1(popup, 'secondaryLink.value.linktype', null),
        isSecondaryCloseCTA: get$1(popup, 'isSecondaryCloseCTA.value', false)
      };
    });
  };

  var getActivePopupContent = function getActivePopupContent(activeDisclosureId) {
    return disclosurePopupList.find(function (disclosureContent) {
      return disclosureContent.id === activeDisclosureId;
    });
  };

  var handleModalScroll = function handleModalScroll(e) {
    var element = e.target;

    if (element.scrollHeight - element.scrollTop - 1 <= element.clientHeight) {
      // end of scroll
      setButtonDisabled(false);
    }
  };

  var handleStickyCTA = function handleStickyCTA() {
    var scrollingEle = document.getElementById('scrollingContent');

    if (scrollingEle && scrollingEle.scrollHeight <= scrollingEle.clientHeight) {
      setButtonDisabled(false);
    }
  };

  var handleCTA = function handleCTA() {
    var scrollingCTA = document.getElementById('scrollingContentCTA');

    if (scrollingCTA) {
      /**
       * Mobile space - 144 = MarginTopBottom - 96, PaddingTopBottom- 48
       * Desktop space - 344 = MarginTopBottom - 248, PaddingTopBottom- 96
       */
      var spacer = isMobileWidth || isMobileLandscape ? scrollingCTA.offsetHeight + 160 : scrollingCTA.offsetHeight + 360;
      setButtonSpace(spacer);
    }
  };

  var resetDisclosureStates = function resetDisclosureStates() {
    var eligibleDisclosurePopupList = props.eligibleDisclosurePopupList;

    if (eligibleDisclosurePopupList && eligibleDisclosurePopupList.length) {
      setIsOpen(false);
      setIsStickyCTA(false);
      setIsActiveAtEndOfScroll(false);
      setButtonDisabled(true);
      setButtonSpace(150);
      setPopupContent(null);
      setDisclosurePopupList({
        activePopupKey: null,
        eligiblePopupList: []
      });
    }
  };

  var handleOnAccept = function handleOnAccept(e, activeItem) {
    e.preventDefault();
    var _props$eligibleDisclo = props.eligibleDisclosurePopupList,
        eligibleDisclosurePopupList = _props$eligibleDisclo === void 0 ? [] : _props$eligibleDisclo,
        activeDisclosurePopupKey = props.activeDisclosurePopupKey;
    setCtaDisable(true);

    if (!isEmpty(activeItem)) {
      setDisclosureAcceptanceInLocalStorage(disclosurePopups.ACCEPTED_DISCLOSURES, true, activeItem);
    }
    /**
     * Now check which popup is currently active from eligible popup list.
     * If active popup is not the last popup then change the active popup key in redux store.
     * Else navigate to the destination URL
     */


    var activePopupIndex = eligibleDisclosurePopupList.indexOf(activeDisclosurePopupKey);

    if (activeDisclosurePopupKey !== eligibleDisclosurePopupList[eligibleDisclosurePopupList.length - 1]) {
      setDisclosurePopupList({
        activePopupKey: eligibleDisclosurePopupList[activePopupIndex + 1]
      });
    } else {
      setDisclosurePopupList({
        activePopupKey: null,
        eligiblePopupList: []
      });
      /* istanbul ignore else */

      if (typeof window !== 'undefined') {
        /* istanbul ignore else */
        if (!activeItem.isFormPost) {
          var pathname = window.location.pathname;
          pathname = pathname.charAt(pathname.length - 1) === '/' ? pathname : pathname + '/';

          if (activeItem.destinationUrl && pathname !== activeItem.destinationUrl) {
            if (activeItem.isDestinationUrlExternal) {
              window.open(activeItem.destinationUrl, '_blank');
            } else {
              props.isDirectRoute ? navigate(activeItem.destinationUrl, {
                replace: true
              }) : navigate(activeItem.destinationUrl);
            }
          }
        } else {
          var disclosureForm = document.getElementById('disclosureForm');
          disclosureForm && disclosureForm.submit();
        }
      }
    }

    setIsOpen(false);
    setIsStickyCTA(false);
    setIsActiveAtEndOfScroll(false);
    setButtonDisabled(true);
    setButtonSpace(150);
    setPopupContent(null);
  };

  var handleOnReject = function handleOnReject(e, activeItem) {
    e.preventDefault();
    setCtaDisable(true);
    setDisclosureAcceptanceInLocalStorage(disclosurePopups.ACCEPTED_DISCLOSURES, false, activeItem);
    /* istanbul ignore else */

    if (activeItem.secondaryLink && typeof window !== 'undefined') {
      var pathname = window.location.pathname;
      pathname = pathname.charAt(pathname.length - 1) === '/' ? pathname : pathname + '/';

      if (pathname !== activeItem.secondaryLink) {
        if (activeItem.isSecondaryLinkExternal) {
          resetDisclosureStates();
          window.open(activeItem.secondaryLink, '_blank');
        } else {
          props.isDirectRoute ? navigate(activeItem.secondaryLink, {
            replace: true
          }) : navigate(activeItem.secondaryLink);
        }
      } else {
        resetDisclosureStates();
      }
    } else if (activeItem.isRiskDisclosure && props.isDirectRoute) {
      if (!props.isRequestFromExternalSource) {
        navigate(-1);
      } else if (activeItem.defaultPageLink) {
        navigate(activeItem.defaultPageLink, {
          replace: true
        });
      } else {
        resetDisclosureStates();
      }
    } else {
      resetDisclosureStates();
    }
  }; // effects


  useEffect(function () {
    var popupList = getAvailableDisclosureList();
    setAvailableDisclosurePopupList(popupList);
    setCtaDisable(false);
  }, []);
  useEffect(function () {
    resetDisclosureStates();
    /* istanbul ignore else */

    if (routeLevelDisclosures.riskDisclosure || routeLevelDisclosures.nonRiskDisclosure) {
      var eligibleDisclosures = [];

      if (routeLevelDisclosures.riskDisclosure) {
        eligibleDisclosures.push(routeLevelDisclosures.riskDisclosure);
      }

      if (routeLevelDisclosures.nonRiskDisclosure) {
        eligibleDisclosures.push(routeLevelDisclosures.nonRiskDisclosure);
      }

      setDisclosurePopupList({
        isRoutedDirectly: true,
        activePopupKey: routeLevelDisclosures.riskDisclosure || routeLevelDisclosures.nonRiskDisclosure,
        eligiblePopupList: eligibleDisclosures
      });
    }
  }, [props.pageRouteItemId]);
  useEffect(function () {
    var _props$availableDiscl = props.availableDisclosurePopupList,
        availableDisclosurePopupList = _props$availableDiscl === void 0 ? [] : _props$availableDiscl,
        _props$eligibleDisclo2 = props.eligibleDisclosurePopupList,
        eligibleDisclosurePopupList = _props$eligibleDisclo2 === void 0 ? [] : _props$eligibleDisclo2,
        activeDisclosurePopupKey = props.activeDisclosurePopupKey;
    /* istanbul ignore else */

    if (typeof window !== 'undefined') {
      // Here we are calculating only the inner height of viewport
      var vh = window.innerHeight * 0.01;
      setViewportHeight("".concat(vh, "px"));
    }

    if (activeDisclosurePopupKey) {
      var isAlreadyAccepted = checkDisclosureAlreadyAddedInLocalStorage(disclosurePopups.ACCEPTED_DISCLOSURES, activeDisclosurePopupKey);
      var activeDisclosureItem = getActivePopupContent(activeDisclosurePopupKey);

      if (!isAlreadyAccepted || activeDisclosureItem.frequency.fields.key.value === disclosurePopups.EVERY_TIME_IN_SESSION) {
        setPopupContent(activeDisclosureItem);
        setIsStickyCTA(get$1(activeDisclosureItem, 'sticky.value', false));
        setIsActiveAtEndOfScroll(get$1(activeDisclosureItem, 'activeAtEndOfScroll.value', false));
        setCtaDisable(false);
        setIsOpen(true);
      } else {
        var activePopupIndex = eligibleDisclosurePopupList.indexOf(activeDisclosurePopupKey);

        if (activeDisclosurePopupKey !== eligibleDisclosurePopupList[eligibleDisclosurePopupList.length - 1]) {
          setDisclosurePopupList({
            activePopupKey: eligibleDisclosurePopupList[activePopupIndex + 1]
          });
        } else {
          var activeDisclosure = availableDisclosurePopupList.find(function (disclosureContent) {
            return disclosureContent.id === activeDisclosurePopupKey;
          });
          setIsOpen(false);
          setPopupContent(null);
          setDisclosurePopupList({
            activePopupKey: null,
            eligiblePopupList: []
          });
          /* istanbul ignore else */

          if (get$1(activeDisclosure, 'primaryLink', null) && typeof window !== 'undefined') {
            var pathname = window.location.pathname;
            pathname = pathname.charAt(pathname.length - 1) === '/' ? pathname : pathname + '/';

            if (pathname !== activeDisclosure.primaryLink) {
              if (get$1(activeDisclosure, 'primaryLinkType', null) !== 'external') {
                props.isDirectRoute ? navigate(activeDisclosure.primaryLink, {
                  replace: true
                }) : navigate(activeDisclosure.primaryLink);
              } else {
                window.open(activeDisclosure.primaryLink, '_blank');
              }
            }
          }
        }
      }
    }
  }, [props.activeDisclosurePopupKey]);
  useEffect(function () {
    if (typeof window !== 'undefined') {
      setTimeout(function () {
        setDisclosureButtonWidth('disclosureModalButton', 'disclosureModalButtonWrapper');
      }, 50);

      if (isStickyCTA) {
        setTimeout(function () {
          handleCTA();
        }, 100);
      }

      if (isActiveAtEndOfScroll) {
        setTimeout(function () {
          handleStickyCTA();
        }, 350);
      }
    }
  }, [props.activeDisclosurePopupKey, isStickyCTA, isActiveAtEndOfScroll]);

  var renderModalContent = function renderModalContent() {
    var isFormPost = get$1(popupContent, 'IsFormPost.value', false);
    var formParameters = get$1(popupContent, 'FormParameters.value', {});
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, popupContent.title.value && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      className: clsx(classes.modalTitle, classes.wrapWord),
      "data-locator": DISCLOSURE_POPUP_TITLE,
      variant: "h4",
      component: "h3",
      color: bgColor
    }, popupContent.title.value), popupContent.text.value && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, _extends({
      variant: "body1",
      component: "div",
      color: bgColor,
      type: 'richtext',
      className: classes.wrapWord,
      "data-locator": DISCLOSURE_POPUP_CONTENT
    }, useKeyBoard && {
      tabIndex: '0'
    }), /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: popupContent.text.value
      }
    })), isFormPost && /*#__PURE__*/React__default.createElement("form", {
      id: "disclosureForm",
      action: get$1(popupContent, 'link.value.href', ''),
      method: "post",
      role: "form",
      target: get$1(popupContent, 'link.value.linktype', '') === 'internal' ? '_self' : '_blank'
    }, !isEmpty(formParameters) && Object.keys(formParameters).map(function (item) {
      return /*#__PURE__*/React__default.createElement("input", {
        type: "hidden",
        key: item,
        name: item,
        value: formParameters[item]
      });
    })));
  };

  var renderModalCTA = function renderModalCTA() {
    var buttonStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return /*#__PURE__*/React__default.createElement("div", {
      className: clsx(classes.modalFooter, _defineProperty({}, classes.stickyCTA, isStickyCTA))
    }, get$1(popupContent, 'footerText.value', '') && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "h10",
      component: "p",
      color: bgColor,
      align: 'center',
      className: clsx(classes.disclosureAgreement, classes.wrapWord),
      "data-locator": DISCLOSURE_POPUP_FOOTER_LABEL
    }, popupContent.footerText.value), /*#__PURE__*/React__default.createElement("div", {
      id: "disclosureModalButtonWrapper",
      className: classes.ctaWrapper
    }, get$1(popupContent, 'isCloseCTA.value', 'false') && get$1(popupContent, 'closeCTALabel.value', null) ? /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
      disabled: buttonStatus || ctaDisable,
      color: bgColor,
      className: clsx(classes.cta, classes.wrapWord, 'disclosureModalButton', _defineProperty({}, 'showFocusOnButton', useKeyBoard)),
      "data-locator": DISCLOSURE_POPUP_PRIMARY_BUTTON,
      onClick: function onClick(e) {
        PushEvent({
          event: 'buttonClick',
          buttonTitle: get$1(popupContent, 'linkGALabelName.value', '') ? popupContent.linkGALabelName.value : DISCLOSURE_POPUP_PRIMARY_BUTTON,
          componentName: DISCLOSURE_POPUP_PRIMARY_BUTTON,
          destinationUrl: undefined
        });
        handleOnAccept(e, {
          id: popupContent.id,
          isRiskDisclosure: get$1(popupContent, 'isRiskDisclosure.value', false),
          disclosureSessionTimeout: get$1(popupContent, 'sessionTimeout.value', disclosurePopups.SESSION_TIMEOUT) || disclosurePopups.SESSION_TIMEOUT,
          disclosureAcceptedTime: Date.now(),
          destinationUrl: null,
          isDestinationUrlExternal: null,
          defaultPageLink: get$1(popupContent, 'defaultPageLink.value.href', null),
          isFormPost: get$1(popupContent, 'IsFormPost.value', false)
        });
      }
    }, popupContent.closeCTALabel.value) : get$1(popupContent, 'link.value.text', '') ? /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
      disabled: buttonStatus || ctaDisable,
      color: bgColor,
      className: clsx(classes.cta, classes.wrapWord, 'disclosureModalButton', _defineProperty({}, 'showFocusOnButton', useKeyBoard)),
      "data-locator": DISCLOSURE_POPUP_PRIMARY_BUTTON,
      onClick: function onClick(e) {
        PushEvent({
          event: 'buttonClick',
          buttonTitle: get$1(popupContent, 'linkGALabelName.value', '') ? popupContent.linkGALabelName.value : get$1(popupContent, 'link.value.href', '') ? getGTMSharedKeyVal(popupContent.link.value.href, DISCLOSURE_POPUP_PRIMARY_BUTTON) : DISCLOSURE_POPUP_PRIMARY_BUTTON,
          componentName: DISCLOSURE_POPUP_PRIMARY_BUTTON,
          destinationUrl: get$1(popupContent, 'link.value.href', '') ? popupContent.link.value.href : undefined
        });
        handleOnAccept(e, {
          id: popupContent.id,
          isRiskDisclosure: get$1(popupContent, 'isRiskDisclosure.value', false),
          disclosureSessionTimeout: get$1(popupContent, 'sessionTimeout.value', disclosurePopups.SESSION_TIMEOUT) || disclosurePopups.SESSION_TIMEOUT,
          disclosureAcceptedTime: Date.now(),
          destinationUrl: get$1(popupContent, 'link.value.href', null),
          isDestinationUrlExternal: get$1(popupContent, 'link.value.linktype', null) === 'external' ? true : false,
          defaultPageLink: get$1(popupContent, 'defaultPageLink.value.href', null),
          isFormPost: get$1(popupContent, 'IsFormPost.value', false)
        });
      }
    }, popupContent.link.value.text) : null, get$1(popupContent, 'isSecondaryCloseCTA.value', 'false') && get$1(popupContent, 'secondaryCloseCTALabel.value', null) ? /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
      color: bgColor,
      disabled: ctaDisable,
      className: clsx(classes.cta, classes.wrapWord, 'disclosureModalButton', _defineProperty({}, 'showFocusOnButton', useKeyBoard)),
      "data-locator": DISCLOSURE_POPUP_SECONDARY_BUTTON,
      outlined: true,
      onClick: function onClick(e) {
        PushEvent({
          event: 'buttonClick',
          buttonTitle: get$1(popupContent, 'secondaryLinkGALabelName.value', '') ? popupContent.secondaryLinkGALabelName.value : DISCLOSURE_POPUP_SECONDARY_BUTTON,
          componentName: DISCLOSURE_POPUP_SECONDARY_BUTTON,
          destinationUrl: props.isDirectRoute && get$1(popupContent, 'isRiskDisclosure.value', false) && get$1(popupContent, 'defaultPageLink.value.href', null) ? popupContent.defaultPageLink.value.href : undefined
        });
        handleOnReject(e, {
          id: popupContent.id,
          isRiskDisclosure: get$1(popupContent, 'isRiskDisclosure.value', false),
          disclosureSessionTimeout: get$1(popupContent, 'sessionTimeout.value', disclosurePopups.SESSION_TIMEOUT) || disclosurePopups.SESSION_TIMEOUT,
          disclosureAcceptedTime: Date.now(),
          destinationUrl: get$1(popupContent, 'link.value.href', null),
          secondaryLink: null,
          isSecondaryLinkExternal: null,
          defaultPageLink: get$1(popupContent, 'defaultPageLink.value.href', null)
        });
      }
    }, popupContent.secondaryCloseCTALabel.value) : get$1(popupContent, 'secondaryLink.value.text', '') ? /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
      color: bgColor,
      disabled: ctaDisable,
      className: clsx(classes.cta, classes.wrapWord, 'disclosureModalButton', _defineProperty({}, 'showFocusOnButton', useKeyBoard)),
      "data-locator": DISCLOSURE_POPUP_SECONDARY_BUTTON,
      outlined: true,
      onClick: function onClick(e) {
        PushEvent({
          event: 'buttonClick',
          buttonTitle: get$1(popupContent, 'secondaryLinkGALabelName.value', '') ? popupContent.secondaryLinkGALabelName.value : get$1(popupContent, 'secondaryLink.value.href', '') ? getGTMSharedKeyVal(popupContent.secondaryLink.value.href, DISCLOSURE_POPUP_SECONDARY_BUTTON) : DISCLOSURE_POPUP_SECONDARY_BUTTON,
          componentName: DISCLOSURE_POPUP_SECONDARY_BUTTON,
          destinationUrl: get$1(popupContent, 'secondaryLink.value.href', '') ? popupContent.secondaryLink.value.href : undefined
        });
        handleOnReject(e, {
          id: popupContent.id,
          isRiskDisclosure: get$1(popupContent, 'isRiskDisclosure.value', false),
          disclosureSessionTimeout: get$1(popupContent, 'sessionTimeout.value', disclosurePopups.SESSION_TIMEOUT) || disclosurePopups.SESSION_TIMEOUT,
          disclosureAcceptedTime: Date.now(),
          destinationUrl: get$1(popupContent, 'link.value.href', null),
          secondaryLink: get$1(popupContent, 'secondaryLink.value.href', null),
          isSecondaryLinkExternal: get$1(popupContent, 'secondaryLink.value.linktype', null) === 'external' ? true : false,
          defaultPageLink: get$1(popupContent, 'defaultPageLink.value.href', null)
        });
      }
    }, popupContent.secondaryLink.value.text) : null));
  };

  return !isEmpty(popupContent) && /*#__PURE__*/React__default.createElement(Dialog$1, {
    fullScreen: true,
    transparent: true,
    classes: classes,
    className: clsx(classes.modal, _defineProperty({}, classes.modalWithStickyCTA, isStickyCTA)),
    open: isOpen,
    showButton: props.isDirectRoute && props.isRequestFromExternalSource ? false : true,
    onClose: function onClose() {
      setCtaDisable(true);
      PushEvent({
        event: 'buttonClick',
        buttonTitle: COMPONENT_DIALOG_CLOSE_BUTTON$1,
        componentName: COMPONENT_DIALOG_CLOSE_BUTTON$1,
        destinationUrl: undefined
      });

      if (props.isDirectRoute && !props.isRequestFromExternalSource) {
        navigate(-1);
      } else {
        resetDisclosureStates();
      }
    },
    disableCloseButton: ctaDisable,
    isFixed: true,
    md: get$1(popupContent, 'enableSmallView.value', false) === true ? 8 : 10,
    lg: get$1(popupContent, 'enableSmallView.value', false) === true ? 6 : 8,
    verticallyAlign: 'center',
    color: 'darkGreen',
    disableEscapeKeyDown: true,
    disableBackdropClick: true,
    variant: 'disclosure',
    mobileFluid: true,
    "data-locator": DISCLOSURE_POPUP_CONTAINER
  }, /*#__PURE__*/React__default.createElement(Box, {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.wrapper, _defineProperty({}, classes.wrapperSmall, get$1(popupContent, 'enableSmallView.value', false) === true))
  }, isStickyCTA && !isActiveAtEndOfScroll ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    id: "scrollingContent",
    className: classes.stickyContent
  }, renderModalContent()), /*#__PURE__*/React__default.createElement("div", {
    id: "scrollingContentCTA"
  }, renderModalCTA())) : isStickyCTA && isActiveAtEndOfScroll ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    id: "scrollingContent",
    className: classes.stickyContent,
    onScroll: handleModalScroll
  }, renderModalContent()), /*#__PURE__*/React__default.createElement("div", {
    id: "scrollingContentCTA"
  }, renderModalCTA(buttonDisabled))) : /*#__PURE__*/React__default.createElement("div", {
    id: "scrollingContent",
    className: classes.wrapperContent
  }, renderModalContent(), renderModalCTA()))));
};

var styles$_ = function styles(theme) {
  var _rootContainer, _logoSection, _bottomAlignSection, _ul, _bottomLinksContainer, _copyrightSection, _hideMobile;

  return {
    rootContainer: (_rootContainer = {
      '&.footer': {
        paddingBottom: theme.spacing(2)
      },
      '& .MuiSelect-root.MuiSelect-select': {
        fontWeight: theme.typography.fontWeights.bolder,
        lineHeight: theme.typography.pxToRem(20)
      }
    }, _defineProperty(_rootContainer, theme.breakpoints.down('xs'), {
      position: 'relative'
    }), _defineProperty(_rootContainer, '&:before', {
      content: '""',
      width: '100vw',
      position: 'absolute',
      top: 0,
      left: 0,
      border: "1px solid ".concat(theme.palette.colors.orange.main)
    }), _defineProperty(_rootContainer, '& .MuiAccordionSummary-content', {
      '& a': {
        paddingLeft: theme.spacing(2.5),
        position: 'relative',
        wordBreak: 'break-all',
        '& .startIcon': {
          position: 'absolute',
          top: '50%',
          left: 0,
          transform: 'translateY(-50%)'
        }
      }
    }), _rootContainer),
    siteMapWrapper: {
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        __expression__: 'all and (-ms-high-contrast: none), (-ms-high-contrast: active)',
        // maxWidth: '70%',
        maxWidth: '832px'
      }
    },
    logoAndSupportWrapper: _defineProperty({
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      '& $logoSection a:hover': {
        backgroundColor: 'transparent'
      }
    }, theme.breakpoints.down('md'), {
      paddingBottom: theme.spacing(2),
      flexDirection: 'row'
    }),
    callingHrsToolTipWrapper: _defineProperty({}, theme.breakpoints.up('md'), {
      maxWidth: '280px'
    }),
    callingHrsWrapper: function callingHrsWrapper(_ref) {
      var bgColor = _ref.bgColor;
      return {
        marginTop: theme.spacing(2),
        display: 'inline-block',
        color: get$1(theme.palette.colors[bgColor], 'contrastTextCaption', '#666666'),
        '& a': {
          color: get$1(theme.palette.colors[bgColor], 'contrastTextCaption', '#666666'),
          '&:hover': {
            color: get$1(theme.palette.colors[bgColor], 'contrastTextLabel', '#666666')
          }
        }
      };
    },
    callingHrsText: {
      position: 'relative',
      display: 'inline-block',
      marginTop: 0,
      '& div,p': {
        margin: 0,
        padding: 0
      },
      '& p:last-of-type': {
        display: 'inline-block'
      },
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        __expression__: 'all and (-ms-high-contrast: none), (-ms-high-contrast: active)' // maxWidth: '30%',

      }
    },
    callingHrsToolTip: {
      display: 'inline-block',
      marginLeft: 5,
      verticalAlign: 'middle'
    },
    callingHrsAfterToolTip: {
      marginTop: 0
    },
    languageCountryWrapper: _defineProperty({
      display: 'flex',
      '& .languageContainer': {
        marginTop: theme.spacing(5),
        marginRight: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        height: theme.spacing(2.5),
        borderWidth: '0 1px 0 0',
        borderStyle: 'solid'
      }
    }, theme.breakpoints.up('lg'), {
      marginBottom: theme.spacing(6.8)
    }),
    footerLanguageSwitch: {
      '& .displayLang': {
        lineHeight: theme.typography.pxToRem(20),
        right: theme.spacing(4)
      }
    },
    mobileFooterLanguageSwitch: {
      maxWidth: theme.spacing(23),
      left: '50%',
      position: 'relative',
      transform: 'translateX(-50%)',
      '& .displayLang': {
        lineHeight: theme.typography.pxToRem(20)
      },
      '& .languageContainer': {},
      paddingBottom: theme.spacing(1.25),
      borderWidth: '0 0 1px 0',
      borderStyle: 'solid',
      justifyContent: 'center',
      width: '100%'
    },
    logoSection: (_logoSection = {}, _defineProperty(_logoSection, theme.breakpoints.down('md'), {
      display: 'inline-block',
      width: '40%'
    }), _defineProperty(_logoSection, '& $logo', {
      '& path:nth-child(odd)': {
        fill: theme.palette.colors.orange.main
      },
      '& path:nth-child(even)': {
        fill: theme.palette.colors.darkGreen.main
      }
    }), _logoSection),
    logo: function logo(_ref2) {
      var isDesktop = _ref2.isDesktop;
      return {
        width: theme.typography.pxToRem(isDesktop ? 105 : 96),
        height: theme.typography.pxToRem(isDesktop ? 36 : 33),
        maxWidth: theme.typography.pxToRem(isDesktop ? 105 : 96),
        maxHeight: theme.typography.pxToRem(isDesktop ? 36 : 33)
      };
    },
    bottomAlignSection: (_bottomAlignSection = {
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        __expression__: 'all and (-ms-high-contrast: none), (-ms-high-contrast: active)',
        display: 'table'
      }
    }, _defineProperty(_bottomAlignSection, theme.breakpoints.up('lg'), {
      //position: 'absolute',
      // bottom: theme.spacing(1.5),
      // left: theme.spacing(1.5),
      // right: theme.spacing(1.5),
      // display: 'table',
      width: 'fit-content'
    }), _defineProperty(_bottomAlignSection, theme.breakpoints.down('md'), {
      display: 'inline-block',
      width: '80%',
      textAlign: 'right',
      position: 'static'
    }), _defineProperty(_bottomAlignSection, '& hr', {
      margin: theme.spacing(3, 0, 3)
    }), _bottomAlignSection),
    dividerLine: {
      borderWidth: '1px 0 0 0',
      borderStyle: 'solid',
      '&.dividerLinePadding': {
        paddingTop: theme.spacing(3),
        marginTop: theme.spacing(3)
      }
    },
    supportOption: _defineProperty({
      display: 'flex',
      marginBottom: 0,
      alignItems: 'center',
      '&.MuiLink-root:hover': {
        backgroundColor: 'transparent'
      },
      '& .branding-icon': {
        marginRight: theme.spacing(1)
      },
      '& span': {
        margin: 0,
        '&.startIcon': {
          verticalAlign: 'middle',
          marginTop: theme.spacing(-1)
        }
      }
    }, theme.breakpoints.down('md'), {
      //marginBottom: theme.spacing(2),
      justifyContent: 'flex-end',
      '& .large-font': {
        fontSize: theme.typography.pxToRem(31),
        lineHeight: theme.typography.pxToRem(39)
      },
      '& .small-font': {
        fontSize: theme.typography.pxToRem(16),
        lineHeight: theme.typography.pxToRem(20)
      }
    }),
    siteMapSection: {
      marginTop: theme.spacing(4)
    },
    socialMediaSection: _defineProperty({
      //width: 'fit-content',
      '& ul': (_ul = {
        listStyle: 'none',
        padding: 0,
        marginTop: 0,
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 'calc(288px + 12px)',
        marginBottom: theme.spacing(-2.5)
      }, _defineProperty(_ul, theme.breakpoints.up('lg'), {
        marginLeft: theme.spacing(-1.25),
        marginRight: theme.spacing(-1.25)
      }), _defineProperty(_ul, '& li', {
        display: 'inline-block',
        marginLeft: theme.spacing(1.25),
        marginRight: theme.spacing(1.25),
        marginBottom: theme.spacing(2.5),
        height: theme.spacing(5),
        '& a': {
          display: 'inline',
          '&:hover': {
            backgroundColor: 'transparent'
          },
          '& span': {
            marginRight: 0
          }
        },
        '& svg.MuiSvgIcon-root, & img': {
          /* overriding link > *:first-child */
          width: "".concat(theme.spacing(5), "px !important"),
          height: "".concat(theme.spacing(5), "px !important")
        }
      }), _ul)
    }, theme.breakpoints.down('md'), {
      width: 'auto'
    }),
    mobileLinkSection: {
      textAlign: 'center',
      '& $socialMediaSection, .countrySelectorWrapper': {
        marginTop: theme.spacing(4.5)
      }
    },
    bottomLinksContainer: (_bottomLinksContainer = {
      marginTop: theme.spacing(8)
    }, _defineProperty(_bottomLinksContainer, theme.breakpoints.down('md'), {
      marginTop: theme.spacing(2),
      border: 'none'
    }), _defineProperty(_bottomLinksContainer, '&.belowfooter', {
      marginTop: 0
    }), _defineProperty(_bottomLinksContainer, '& $bottomLinksSection', {
      marginTop: 0
    }), _bottomLinksContainer),
    bottomLinksDividerContainer: _defineProperty({
      display: 'none'
    }, theme.breakpoints.up('sm'), {
      display: 'block'
    }),
    dividerWrapper: _defineProperty({
      position: 'relative',
      display: 'block'
    }, theme.breakpoints.down('md'), {
      display: 'none'
    }),
    quickLinksDivider: _defineProperty({}, theme.breakpoints.down('md'), {
      position: 'absolute',
      width: '100vw',
      left: '50%',
      top: theme.typography.pxToRem(22),
      transform: 'translateX(-50%)'
    }),
    bottomLinksSection: _defineProperty({
      display: 'flex',
      justifyContent: 'space-between'
    }, theme.breakpoints.down('md'), {
      display: 'block',
      marginTop: theme.spacing(8)
    }),
    footerColumn: _defineProperty({}, theme.breakpoints.up('lg'), {
      maxWidth: '208px',
      paddingRight: theme.spacing(3),
      flexGrow: '1',
      '&:last-child': {
        maxWidth: '184px',
        paddingRight: '0'
      }
    }),
    footerQuickLinksSection: function footerQuickLinksSection(_ref3) {
      var bgColor = _ref3.bgColor,
          surfaceColor = _ref3.surfaceColor;
      return _defineProperty({
        marginTop: theme.spacing(2),
        maxWidth: '600px',
        flexBasis: '50%',
        '&.belowfooter': _defineProperty({}, theme.breakpoints.down('md'), {
          marginLeft: "-".concat(theme.spacing(3), "px"),
          marginRight: "-".concat(theme.spacing(3), "px"),
          borderWidth: '1px 0 0 0',
          borderStyle: 'solid',
          borderColor: get$1(theme.palette.colors[bgColor], 'line.divider', '#666666')
        }),
        '& ul': {
          listStyle: 'none',
          padding: 0,
          margin: 0,
          '& li': {
            display: 'inline-block',
            '&:after': {
              content: '"|"',
              color: get$1(theme.palette.colors[surfaceColor], 'contrastTextCaption', '#666666'),
              margin: theme.spacing(0, 1)
            },
            '&:last-child': {
              '& a': {
                marginRight: 0
              },
              '&:after': {
                content: '""',
                margin: 0
              }
            }
          }
        }
      }, theme.breakpoints.down('md'), {
        textAlign: 'center',
        marginTop: 0,
        maxWidth: 'none',
        flexBasis: '100%',
        paddingTop: theme.spacing(3)
      });
    },
    quickLink: {
      display: 'inline-block',
      '&:hover': {
        color: theme.palette.colors.orange.main,
        '& .MuiTypography-root': {
          color: theme.palette.colors.orange.main
        }
      }
    },
    copyrightSection: (_copyrightSection = {
      marginTop: theme.spacing(2),
      textAlign: 'right',
      maxWidth: '600px',
      flexBasis: '50%',
      flexShrink: '0',
      paddingTop: theme.spacing(2),
      '& p': {
        margin: '0',
        display: 'inline-block',
        '&:nth-child(2)': _defineProperty({}, theme.breakpoints.down('md'), {
          display: 'block'
        })
      },
      '& div': {
        margin: '0',
        display: 'inline-block'
      }
    }, _defineProperty(_copyrightSection, theme.breakpoints.down('md'), {
      textAlign: 'center',
      marginTop: theme.spacing(3),
      marginLeft: theme.spacing(-3),
      marginRight: theme.spacing(-3),
      width: 'auto',
      maxWidth: 'none',
      flexBasis: '100%'
    }), _defineProperty(_copyrightSection, theme.breakpoints.up('lg'), {
      border: 'none',
      paddingTop: 0,
      marginLeft: 0,
      marginRight: 0
    }), _copyrightSection),
    copyrightContent: _defineProperty({}, theme.breakpoints.down('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),
    hideMobile: (_hideMobile = {}, _defineProperty(_hideMobile, theme.breakpoints.down('md'), {
      display: 'none'
    }), _defineProperty(_hideMobile, '&>div', {
      marginTop: theme.spacing(3.5)
    }), _hideMobile),
    hideDesktop: _defineProperty({}, theme.breakpoints.up('lg'), {
      display: 'none'
    })
  };
};

var FOOTER_CONTAINER = 'Footer-Container';
var FOOTER_LOGO = 'Footer-Logo';
var FOOTER_CALL_SUPPORT = 'Footer-Call-Support';
var FOOTER_SITE_NAVIGATION_SECTION = 'Footer-Site-Navigation-Section';
var FOOTER_SOCIAL_MEDIA_SECTION = 'Footer-Social-Media-Section';
var FOOTER_SOCIAL_MEDIA_ITEM = 'Footer-Social-Media-Item';
var FOOTER_QUICK_LINKS_SECTION = 'Footer-Quick-Links-Section';
var FOOTER_QUICK_LINKS_ITEM = 'Footer-Quick-Links-Item';
var FOOTER_COPYRIGHT_INFO = 'Footer-Copyright-Info';
var FOOTER_COMPLIANCE_WRAPPER = 'Footer-Compliance-Wrapper';
var FOOTER_COMPLIANCE_CONTAINER = 'Footer-Compliance-Container';
var FOOTER_COMPLIANCE_LINK = 'Footer-Compliance-Link';
var FOOTER_COMPLIANCE_IMAGE = 'Footer-Compliance-Image';
var FOOTER_COMPLIANCE_DESCRIPTION = 'Footer-Compliance-Description';
var FOOTER_CALLING_HOUR_BEFORE_TEXT = 'Footer-Calling-Hour-before-Text';
var FOOTER_CALLING_HOUR_AFTER_TEXT = 'Footer-Calling-Hour-after-Text';
var FOOTER_CALLING_HOUR_TOOLTIP = 'Footer-Calling-Hour-Tooltip';

var styles$Z = function styles(theme) {
  var _svg, _$svgItemContainer, _$mainListItemConta, _$subList2, _expansionPanelDetail;

  return {
    root: {
      '& ul': {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        '&$mainList': {
          '& $mainListItemContainer': (_$mainListItemConta = {}, _defineProperty(_$mainListItemConta, theme.breakpoints.down('md'), {
            display: 'flex',
            justifyContent: 'space-between',
            borderBottom: '1px solid',
            borderBottomColor: theme.palette.colors.grey.line.divider
          }), _defineProperty(_$mainListItemConta, '& svg', (_svg = {}, _defineProperty(_svg, theme.breakpoints.up('lg'), {
            display: 'none'
          }), _defineProperty(_svg, "top", '50%'), _svg)), _defineProperty(_$mainListItemConta, '& .startIcon', {
            top: '50%',
            left: '0',
            position: 'absolute',
            transform: 'translateY(-50%)'
          }), _defineProperty(_$mainListItemConta, '& $svgItemContainer', (_$svgItemContainer = {}, _defineProperty(_$svgItemContainer, theme.breakpoints.up('lg'), {
            display: 'none'
          }), _defineProperty(_$svgItemContainer, "alignSelf", 'center'), _defineProperty(_$svgItemContainer, '& svg', {
            width: '24px',
            height: '24px',
            '& path': {
              fill: theme.palette.colors.orange.main
            }
          }), _$svgItemContainer)), _defineProperty(_$mainListItemConta, '& $mainListItem', _defineProperty({
            wordBreak: 'break-word'
          }, theme.breakpoints.down('md'), {
            margin: '16px 0',
            position: 'relative',
            paddingLeft: '20px'
          })), _defineProperty(_$mainListItemConta, '& $subList', _defineProperty({}, theme.breakpoints.down('md'), {
            display: 'none'
          })), _$mainListItemConta),
          '& $mainListItem': {
            marginBottom: theme.spacing(1.5),
            display: 'inline-block',
            padding: theme.spacing(0.5, 0.5),
            marginLeft: theme.spacing(-0.5),
            '&:hover': {
              backgroundColor: alpha(theme.palette.colors.orange.main, 0.2),
              borderRadius: theme.spacing(0.5) //padding: theme.spacing(0, 0.5),

            }
          },
          '& $sitemapMainListItem': {
            marginBottom: theme.spacing(1.5)
          },
          '& $sitemapSubList': _defineProperty({}, theme.breakpoints.down('md'), {
            marginBottom: theme.spacing(2.5)
          }),
          '& $siteMapNoSubItems': _defineProperty({}, theme.breakpoints.down('md'), {
            paddingBottom: 0,
            marginBottom: 0
          }),
          '& $subList': (_$subList2 = {
            marginBottom: theme.spacing(3.25)
          }, _defineProperty(_$subList2, theme.breakpoints.down('md'), {
            marginBottom: theme.spacing(2.25)
          }), _defineProperty(_$subList2, '& li', {
            '& $subListItem': {
              marginBottom: theme.spacing(1.5),
              display: 'inline-block',
              wordBreak: 'break-word',
              '&:hover': {
                color: theme.palette.colors.orange.main,
                '& .MuiTypography-root': {
                  color: theme.palette.colors.orange.main
                }
              }
            },
            '& $sitemapSubListItem': _defineProperty({
              marginBottom: theme.spacing(1)
            }, theme.breakpoints.down('sm'), {
              marginBottom: theme.spacing(2)
            }),
            '&:last-child': {
              '& $subListItem': {
                marginBottom: 0
              }
            }
          }), _$subList2),
          '&:last-child $subList': {
            marginBottom: 0
          }
        }
      },
      '&$rootWithSitemap': _defineProperty({}, theme.breakpoints.down('md'), {
        marginBottom: theme.spacing(2.25),
        width: '100%',
        '&:last-child': {
          marginBottom: 0
        }
      })
    },
    rootWithSitemap: {},
    mainList: {},
    mainListItemContainer: {},
    svgItemContainer: {},
    mainListItem: {
      '& .MuiTypography-root': {
        lineHeight: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeights.bolder
      },
      '& svg path': {
        fill: theme.palette.colors.orange.main
      }
    },
    sitemapMainListItem: {},
    sitemapSubList: {},
    siteMapNoSubItems: {},
    subList: {},
    subListItem: {
      '& span': {
        lineHeight: theme.typography.pxToRem(20)
      }
    },
    sitemapSubListItem: {},
    expansionPanel: {
      backgroundColor: 'inherit',
      '&.MuiAccordion-root': {
        borderRadius: 0,
        boxShadow: 'none',
        borderBottomColor: theme.palette.colors.orangeLighter.line.divider,
        backgroundColor: 'transparent',
        '&:before': {
          backgroundColor: 'inherit'
        }
      },
      '&.Mui-expanded': {
        borderRadius: 0,
        borderBottomColor: theme.palette.colors.orangeLighter.line.divider,
        margin: 0
      }
    },
    expansionPanelSummary: {
      padding: 0,
      '&.MuiAccordionSummary-root': {
        '&.Mui-focused': {
          backgroundColor: 'transparent'
        },
        '&.Mui-expanded': {
          minHeight: theme.spacing(6)
        }
      },
      '& .MuiAccordionSummary-content, .MuiAccordionSummary-content.Mui-expanded': {
        margin: theme.spacing(2, 0)
      },
      '& .MuiTouchRipple-root': {
        opacity: 0
      },
      '& $expandIcon, & $collapseIcon': {
        width: theme.spacing(3),
        height: theme.spacing(3),
        '& path': {
          fill: theme.palette.colors.orange.main
        }
      }
    },
    expansionPanelDetails: (_expansionPanelDetail = {
      padding: theme.spacing(0, 0, 2, 2.5)
    }, _defineProperty(_expansionPanelDetail, theme.breakpoints.down('md'), {
      width: '288px'
    }), _defineProperty(_expansionPanelDetail, '& li', {
      paddingBottom: theme.spacing(1),
      '& a': {
        wordBreak: 'break-all'
      },
      '&:last-child': {
        paddingBottom: 0
      }
    }), _expansionPanelDetail),
    expandIcon: {},
    collapseIcon: {}
  };
};

var NAVIGATIONLIST_MAIN_LINK = 'NavigationList-Main-Link';
var NAVIGATIONLIST_SUB_LINK = 'NavigationList-Sub-Link';
var NAVIGATIONLIST_ACCORDION_EXPAND_ICON = 'NavigationList-Accordion-Expand-Icon';
var NAVIGATIONLIST_ACCORDION_COLLAPSE_ICON = 'NavigationList-Accordion-Collapse-Icon';

var styles$Y = function styles() {
  return {
    root: {
      "&:before": {
        content: "unset"
      }
    }
  };
};

var useStyles$13 = makeStyles(styles$Y);
/**
 * This material ui component contains creation flows and allow lightweight editing of an element.
 * It is a lightweight container that may either stand alone or be connected to a larger surface, such as a card.
 * @param {string} color - Used to generate classname. Default value provided 'grey'
 * @param {string} className
 */

var FwdExpansionPanel = function FwdExpansionPanel(props) {
  var classes = useStyles$13();
  var _props$color = props.color,
      color = _props$color === void 0 ? "grey" : _props$color,
      _props$className = props.className,
      className = _props$className === void 0 ? "" : _props$className;
  return /*#__PURE__*/React__default.createElement(Accordion$1, _extends({}, props, {
    color: color,
    className: clsx(className, classes.root, _defineProperty({}, "expansion-panel-".concat(color), color !== "initial"))
  }));
};

var ExpansionPanel = /*#__PURE__*/React__default.memo(FwdExpansionPanel);

var styles$X = function styles() {
  return {
    root: {
      transitionProperty: 'background-color, color, border-color, top, margin ! important',
      '& .MuiAccordionSummary-expandIcon .MuiTouchRipple-root': {
        display: 'none'
      }
    }
  };
};

var _excluded$6 = ["className"];
var useStyles$12 = makeStyles(styles$X);
/**
 * ExpansionPanelSummary Component Material UI
 * @param {object} props Component props
 */

var FwdExpansionPanelSummary = function FwdExpansionPanelSummary(props) {
  var _clsx;

  var classes = useStyles$12();

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;

  var className = props.className,
      props1 = _objectWithoutProperties(props, _excluded$6);

  return /*#__PURE__*/React__default.createElement(AccordionSummary, _extends({
    className: clsx(className, classes.root, (_clsx = {}, _defineProperty(_clsx, "hideFocusonClick", !useKeyBoard), _defineProperty(_clsx, "showFocusonTab", useKeyBoard), _clsx))
  }, props1));
};

/**
 * For use with ExpansionPanel to provide the content
 */

var FwdExpansionPanelDetails = function FwdExpansionPanelDetails(props) {
  return /*#__PURE__*/React__default.createElement(AccordionDetails, props);
};

var useStyles$11 = makeStyles(styles$Z);

var NavigationList = function NavigationList(props) {
  var _clsx;

  var classes = useStyles$11();
  var isDesktop = props.isDesktop || false;
  var hideDesktop = props.hideDesktop || false;
  var hideMobile = props.hideMobile || false;
  var mainNavLinkList = get$1(props, 'mainNavLinkList', []);
  var color = get$1(props, 'color', 'grey');
  var expanded = props.expanded,
      handleChange = props.handleChange,
      _props$hasMobileAccor = props.hasMobileAccordion,
      hasMobileAccordion = _props$hasMobileAccor === void 0 ? true : _props$hasMobileAccor,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$isSitemap = props.isSitemap,
      isSitemap = _props$isSitemap === void 0 ? false : _props$isSitemap,
      _props$gaCategoryName = props.gaCategoryName,
      gaCategoryName = _props$gaCategoryName === void 0 ? '' : _props$gaCategoryName,
      _props$footerNavigati = props.footerNavigation,
      footerNavigation = _props$footerNavigati === void 0 ? false : _props$footerNavigati,
      _props$useLineBreaker = props.useLineBreaker,
      useLineBreaker = _props$useLineBreaker === void 0 ? false : _props$useLineBreaker;

  var handleKeyDown = function handleKeyDown(e, panel, isExpanded) {
    if (e.keyCode === 13) {
      handleChange(panel, isExpanded);
    }
  };

  var formHandler = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(apiLink, formType) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // if (formType === 'enquiry') {
              //   props.updateFormLinks({
              //     URL: generatelayoutServicePath(
              //       apiLink,
              //       props.sitecoreContext.languageCode || props.sitecoreContext.language
              //     ),
              //     formType: 'enquiry',
              //   });
              //   props.updateFormInitializer({
              //     initializer: enums.calculatorInitializers.ENQUIRY,
              //     enquiryInitializer: 'SUPPORT',
              //   });
              //   props.appInSession(true);
              // } else if (formType === 'bookAnAgent') {
              //   props.updateFormLinks({
              //     URL: generatelayoutServicePath(
              //       apiLink,
              //       props.sitecoreContext.languageCode || props.sitecoreContext.language
              //     ),
              //     formType: 'bookAnAgent',
              //   });
              //   props.updateFormInitializer({
              //     initializer: enums.calculatorInitializers.BOOKANAGENT,
              //     enquiryInitializer: 'SUPPORT',
              //   });
              // }
              props.updateFormModalState({
                formModalState: true
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function formHandler(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(); // To trigger different forms eg: enquiry-form from Medallia form links


  if (props.checkQueryParamsForEnqForm === 0) {
    var queryParams = getUrlQueryParams(); // To check the query params for opening a form

    if (get$1(queryParams, 'formType', '') && get$1(queryParams, 'formUrl', '')) {
      formHandler(queryParams.formUrl, queryParams.formType);
    }
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, (_clsx = {}, _defineProperty(_clsx, classes.rootWithSitemap, isSitemap), _defineProperty(_clsx, classes.hideMobile, hideMobile), _defineProperty(_clsx, classes.hideDesktop, hideDesktop), _clsx))
  }, mainNavLinkList && mainNavLinkList.length && mainNavLinkList.map(function (item) {
    var _clsx3;

    return isDesktop || !hasMobileAccordion ? /*#__PURE__*/React__default.createElement("ul", {
      key: item.id,
      className: classes.mainList
    }, /*#__PURE__*/React__default.createElement("li", {
      className: clsx(_defineProperty({}, classes.mainListItemContainer, footerNavigation))
    }, /*#__PURE__*/React__default.createElement(NavigationLink$1, {
      useLineBreaker: useLineBreaker,
      listType: item.fields.listType,
      link: item.fields.link,
      title: item.fields.title.value,
      color: color,
      variant: variant,
      type: "label",
      underline: "none",
      icon: footerNavigation ? 'arrow-right' : null,
      formHandler: formHandler,
      className: clsx(classes.mainListItem, (_clsx3 = {}, _defineProperty(_clsx3, classes.sitemapMainListItem, isSitemap), _defineProperty(_clsx3, classes.siteMapNoSubItems, !item.Children), _clsx3)),
      dataLocator: NAVIGATIONLIST_MAIN_LINK,
      gaCategoryName: gaCategoryName,
      GTMSharedKey: get$1(item, 'fields.gaLabelName.value', ''),
      gtmPushEvent: props.gtmPushEvent,
      navigate: props.navigate
    }), item.Children && item.Children.length && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, footerNavigation && /*#__PURE__*/React__default.createElement("span", {
      className: classes.svgItemContainer
    }, /*#__PURE__*/React__default.createElement(PlusIcon, null)), /*#__PURE__*/React__default.createElement("ul", {
      className: clsx(classes.subList, _defineProperty({}, classes.sitemapSubList, isSitemap))
    }, item.Children.map(function (subItem) {
      return get$1(subItem, 'fields.listType.fields.key.value', 'generic_link') === 'chat' || get$1(subItem, 'fields.link.value.linktype', null) ? /*#__PURE__*/React__default.createElement("li", {
        key: subItem.id
      }, /*#__PURE__*/React__default.createElement(NavigationLink$1, {
        useLineBreaker: useLineBreaker,
        listType: subItem.fields.listType,
        link: subItem.fields.link,
        title: subItem.fields.title.value,
        color: color,
        variant: variant,
        underline: "none",
        icon: null,
        formHandler: formHandler,
        className: clsx(classes.subListItem, _defineProperty({}, classes.sitemapSubListItem, isSitemap)),
        dataLocator: NAVIGATIONLIST_SUB_LINK,
        gaCategoryName: gaCategoryName,
        GTMSharedKey: get$1(subItem, 'fields.gaLabelName.value', ''),
        gtmPushEvent: props.gtmPushEvent,
        navigate: props.navigate
      })) : null;
    }))))) : /*#__PURE__*/React__default.createElement(ExpansionPanel, {
      key: item.id,
      className: classes.expansionPanel,
      expanded: expanded === item.id,
      color: color,
      onChange: item.Children && item.Children.length ? function () {
        return handleChange(item.id, expanded === item.id, get$1(item, 'fields.gaLableName.value', ''));
      } : undefined
    }, /*#__PURE__*/React__default.createElement(FwdExpansionPanelSummary, {
      expandIcon: item.Children && item.Children.length ? expanded === item.id ? /*#__PURE__*/React__default.createElement(MinusIcon, {
        className: classes.collapseIcon,
        tabIndex: '0',
        onKeyDown: function onKeyDown(e) {
          return handleKeyDown(e, item.id, expanded === item.id);
        },
        "data-locator": NAVIGATIONLIST_ACCORDION_COLLAPSE_ICON
      }) : /*#__PURE__*/React__default.createElement(PlusIcon, {
        className: classes.expandIcon,
        tabIndex: '0',
        onKeyDown: function onKeyDown(e) {
          return handleKeyDown(e, item.id);
        },
        "data-locator": NAVIGATIONLIST_ACCORDION_EXPAND_ICON
      }) : null,
      className: classes.expansionPanelSummary,
      tabIndex: null
    }, /*#__PURE__*/React__default.createElement(NavigationLink$1, {
      listType: item.fields.listType,
      link: item.fields.link,
      title: get$1(item, 'fields.title.value', '').replace(/\$\$/gi, ' '),
      color: color,
      variant: variant,
      type: "label",
      underline: "none",
      icon: "arrow-right",
      formHandler: formHandler,
      className: classes.mainListItem,
      dataLocator: NAVIGATIONLIST_MAIN_LINK,
      gaCategoryName: gaCategoryName,
      GTMSharedKey: get$1(item, 'fields.gaLabelName.value', ''),
      gtmPushEvent: props.gtmPushEvent,
      navigate: props.navigate
    })), item.Children && item.Children.length && /*#__PURE__*/React__default.createElement(FwdExpansionPanelDetails, {
      className: classes.expansionPanelDetails
    }, /*#__PURE__*/React__default.createElement("ul", null, item.Children && item.Children.length && item.Children.map(function (subItem) {
      return get$1(subItem, 'fields.listType.fields.key.value', 'generic_link') === 'chat' || get$1(subItem, 'fields.link.value.linktype', null) ? /*#__PURE__*/React__default.createElement("li", {
        key: subItem.id
      }, /*#__PURE__*/React__default.createElement(NavigationLink$1, {
        listType: subItem.fields.listType,
        link: subItem.fields.link,
        title: get$1(subItem, 'fields.title.value', '').replace(/\$\$/gi, ' '),
        color: color,
        variant: variant,
        underline: "none",
        icon: null,
        formHandler: formHandler,
        className: classes.subListItem,
        dataLocator: NAVIGATIONLIST_SUB_LINK,
        gaCategoryName: gaCategoryName,
        GTMSharedKey: get$1(subItem, 'fields.gaLabelName.value', ''),
        gtmPushEvent: props.gtmPushEvent,
        navigate: props.navigate
      })) : null;
    }))));
  }));
}; // const mapDispatchToProps = dispatch => {
//   return {
//     updateFormInitializer: params => dispatch(actions.updateFormInitializer(params)),
//     updateFormLinks: params => dispatch(actions.updateFormLinks(params)),
//     updateFormModalState: params => dispatch(actions.updateFormModalState(params)),
//     appInSession: params => dispatch(appActions.appInSession(params)),
//   };
// };
// export default withSitecoreContext()(connect(null, mapDispatchToProps)(React.memo(NavigationList)));


var NavigationList$1 = /*#__PURE__*/React__default.memo(NavigationList);

var styles$W = function styles(theme) {
  var _complianceImageConta;

  return {
    complianceContainer: function complianceContainer(_ref) {
      var bgColor = _ref.bgColor;
      return {
        '&.paddingSmall': {
          paddingTop: theme.spacing(4),
          paddingBottom: theme.spacing(4)
        },
        '&.belowFooter': _defineProperty({
          borderTop: '1px solid',
          borderColor: get$1(theme.palette.colors[bgColor], 'line.divider', '#666666'),
          marginTop: theme.spacing(8),
          paddingTop: theme.spacing(4),
          paddingBottom: theme.spacing(4)
        }, theme.breakpoints.down('md'), {
          marginTop: '38px',
          marginLeft: "-".concat(theme.spacing(3), "px"),
          marginRight: "-".concat(theme.spacing(3), "px"),
          paddingLeft: theme.spacing(3),
          paddingRight: theme.spacing(3)
        })
      };
    },
    complianceDescription: {
      fontSize: theme.typography.T11,
      lineHeight: theme.typography.lineHeight.L15,
      marginBottom: theme.spacing(2),
      '&.onlyDescription': {
        marginBottom: 0
      },
      '& p': {
        margin: 0
      }
    },
    complianceImageContainer: (_complianceImageConta = {
      '& div.complianceImage:nth-child(n + 7)': {
        marginTop: '-8px'
      }
    }, _defineProperty(_complianceImageConta, theme.breakpoints.down('md'), {
      '& div.complianceImage:nth-child(n + 5)': {
        marginTop: '-8px'
      }
    }), _defineProperty(_complianceImageConta, theme.breakpoints.down('sm'), {
      '& div.complianceImage:nth-child(n + 4)': {
        marginTop: '-8px'
      }
    }), _defineProperty(_complianceImageConta, theme.breakpoints.down('xs'), {
      '& div.complianceImage:nth-child(n + 3)': {
        marginTop: '-8px'
      }
    }), _complianceImageConta)
  };
};

var styles$V = function styles(theme) {
  var customStyle = _objectSpread2(_objectSpread2({
    root: {
      position: 'relative',
      display: 'block',
      '&.fallbackPic': {
        '&.fwd-logo': {
          paddingTop: '56.25%',
          backgroundSize: '100%'
        }
      },
      '&.aspectRatioImg': {
        '& img': {
          position: 'absolute',
          top: '0'
        }
      }
    }
  }, [{
    size: 'm',
    bp: 'sm',
    dir: 'down'
  }, {
    size: 't',
    bp: 'sm',
    dir: 'up'
  }, {
    size: 'd',
    bp: 'lg',
    dir: 'up'
  }].reduce(function (r, viewport) {
    return _objectSpread2(_objectSpread2({}, r), [{
      ratio: '1-1',
      paddingTop: '100%'
    }, {
      ratio: '2-1',
      paddingTop: '50%'
    }, {
      ratio: '2-3',
      paddingTop: '150%'
    }, {
      ratio: '3-1',
      paddingTop: '33.333%'
    }, {
      ratio: '16-9',
      paddingTop: '56.25%'
    }, {
      ratio: 'full-flex-end',
      paddingTop: '75.5%'
    }].reduce(function (rr, ratio) {
      return _objectSpread2(_objectSpread2({}, rr), _defineProperty({}, "aspectRatio--".concat(viewport.size, "__").concat(ratio.ratio), _defineProperty({}, theme.breakpoints[viewport.dir](viewport.bp), {
        paddingTop: ratio.paddingTop
      })));
    }, {}));
  }, {})), {}, {
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center'
    },
    fallback: {
      display: 'none !important'
    },
    div: {
      '&[data-locator="Header-Logo"]': {
        paddingTop: '56.25%',
        backgroundSize: '100%'
      }
    }
  });

  return customStyle;
};

var useStyles$10 = makeStyles(styles$V);
var isIE11 = typeof window !== 'undefined' && !!window.msCrypto;
var Picture = /*#__PURE__*/React__default.forwardRef(function Picture(props, ref) {
  var classes = useStyles$10();
  var _props$media = props.media,
      image = _props$media.image,
      mobileImage = _props$media.mobileImage,
      _props$media$minWidth = _props$media.minWidth,
      minWidth = _props$media$minWidth === void 0 ? '960' : _props$media$minWidth,
      aspectRatio = _props$media.aspectRatio;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isImageLoaded = _useState4[0],
      setImageLoaded = _useState4[1];

  var _onError = get$1(props, 'onError', null);

  var onLoad = get$1(props, 'onLoad', null);
  var objectFit = get$1(props, 'objectFit', null);
  var onClick = get$1(props, 'onClick', null);
  /**
   * hideFallbackImage - this should be passed as true if we need to show some transparent image,
   * such as icons, transparent png image, svg image.
   * the background image usually visible for critical images, once javascript excutes, it removes the background
   * so, this value should be passed as true only for selective images where we dont want background to be visible
   * along with images before javascript kicks in.
   */

  var hideFallbackImage = get$1(props, 'hideFallbackImage', false);
  var aspectRatioMobile = get$1(aspectRatio, 'mobile', null);
  var aspectRatioDesktop = get$1(aspectRatio, 'desktop', aspectRatioMobile);
  var aspectRatioTablet = get$1(aspectRatio, 'tablet', aspectRatioDesktop);
  var _props$hasBorderRadiu = props.hasBorderRadius,
      hasBorderRadius = _props$hasBorderRadiu === void 0 ? true : _props$hasBorderRadiu;
  var _props$borderRadiusOp = props.borderRadiusOption,
      borderRadiusOption = _props$borderRadiusOp === void 0 ? 'medium' : _props$borderRadiusOp;
  /* istanbul ignore else */

  if (typeof window !== 'undefined') {
    require('lazysizes');

    require('picturefill');

    require('picturefill/dist/plugins/mutation/pf.mutation');

  }


  var shouldIncludeSrcSet = function shouldIncludeSrcSet(imageType) {
    return !error && (typeof window !== 'undefined' || typeof window === 'undefined' && props.critical) && get$1(imageType, 'value.x1', null);
  };

  var onImageLoaded = function onImageLoaded() {
    setImageLoaded(true);

    if (isIE11) {
      var resizeEvent = window.document.createEvent('UIEvents');
      resizeEvent.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(resizeEvent);
    }

    if (onLoad !== null) {
      onLoad();
    }
  };

  return /*#__PURE__*/React__default.createElement("picture", {
    className: clsx(classes.root, aspectRatioMobile && classes["aspectRatio--m__".concat(aspectRatioMobile)], aspectRatioTablet && classes["aspectRatio--t__".concat(aspectRatioTablet)], aspectRatioDesktop && classes["aspectRatio--d__".concat(aspectRatioDesktop)], (aspectRatioMobile || aspectRatioTablet || aspectRatioDesktop) && 'aspectRatioImg', get$1(aspectRatio, 'tablet', null) && classes["aspectRatio--t__".concat(aspectRatio.tablet)], props.className, {
      fallbackPic: !hideFallbackImage && (!isImageLoaded || error)
    }),
    "data-locator": get$1(props, 'data-locator', ''),
    ref: ref,
    onClick: onClick
  }, shouldIncludeSrcSet(mobileImage) && /*#__PURE__*/React__default.createElement("source", {
    srcSet: "".concat(mobileImage.value.x1, " 1x, ").concat(mobileImage.value.x2, " 2x"),
    media: "(max-width: ".concat(minWidth - 0.01, "px)")
  }), shouldIncludeSrcSet(image) && /*#__PURE__*/React__default.createElement("source", {
    srcSet: "".concat(image.value.x1, " 1x, ").concat(image.value.x2, " 2x"),
    media: "(min-width: ".concat(minWidth, "px)")
  }), /*#__PURE__*/React__default.createElement("img", _extends({
    className: clsx(classes.img, hasBorderRadius ? getBorderRadius(borderRadiusOption) : '', !props.critical || isIE11 ? 'lazyload' : '', error && classes.fallback),
    alt: get$1(image, 'value.alt', 'image'),
    "data-src": get$1(image, 'value.src', null),
    onError: function onError() {
      setError(true);
      _onError && _onError();
    },
    onLoad: onImageLoaded,
    "data-locator": props.dataLocator,
    decoding: "async",
    loading: !props.critical ? 'lazy' : 'auto',
    src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAABCAQAAABeK7cBAAAADUlEQVR42mP8L8nAAAAEUQEaJRQ1vgAAAABJRU5ErkJggg=='
  }, objectFit ? {
    'data-object-fit': objectFit
  } : {})));
});

var useStyles$$ = makeStyles(styles$W);

var ComplianceAccreditation = function ComplianceAccreditation(props) {
  var _props$Images;

  var isDesktop = props.isDesktop,
      bgColor = props.bgColor,
      surfaceColor = props.surfaceColor;
  var classes = useStyles$$({
    isDesktop: isDesktop,
    bgColor: bgColor,
    surfaceColor: surfaceColor
  });
  var complianceImages = ((_props$Images = props.Images) === null || _props$Images === void 0 ? void 0 : _props$Images.filter(function (item) {
    var _item$fields, _item$fields$image;

    return !isEmpty((_item$fields = item.fields) === null || _item$fields === void 0 ? void 0 : (_item$fields$image = _item$fields.image) === null || _item$fields$image === void 0 ? void 0 : _item$fields$image.value);
  })) || [];

  var onClickLogo = function onClickLogo(e, item) {
    e.preventDefault();
    e.stopPropagation();

    if ((e.ctrlKey || e.metaKey) && typeof window !== 'undefined') {
      window.open(get$1(item, 'fields.link.value.href', '/'), '_blank');
    } else {
      navigate(get$1(item, 'fields.link.value.href', '/'));
    }
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.complianceContainer, {
      belowFooter: props.accrediationPosition === 'belowfooter'
    }),
    "data-locator": FOOTER_COMPLIANCE_WRAPPER
  }, /*#__PURE__*/React__default.createElement(Container$1, {
    useContainer: props.accrediationPosition === 'abovefooter',
    className: clsx(classes.complianceContainer, 'paddingSmall'),
    background: props.bgColor,
    fixed: true,
    overflowHidden: true,
    "data-locator": FOOTER_COMPLIANCE_CONTAINER
  }, props.Description && props.Description.value && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    className: clsx(classes.complianceDescription, {
      onlyDescription: !props.Images || !complianceImages.length
    }),
    variant: "body1",
    component: "div",
    color: props.bgColor,
    "data-locator": FOOTER_COMPLIANCE_DESCRIPTION,
    type: "caption"
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: props.Description.value
    }
  })), props.Images && complianceImages.length > 0 && /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    spacing: 3,
    className: classes.complianceImageContainer
  }, complianceImages.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      item: true,
      xs: 6,
      sm: 4,
      md: 3,
      lg: 2,
      key: index,
      className: 'complianceImage'
    }, get$1(item, 'fields.link.value.href', null) ? /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
      href: get$1(item, 'fields.link.value.href', ''),
      onClick: function onClick(e) {
        return onClickLogo(e, item);
      },
      target: get$1(item, 'fields.link.value.linktype') === 'external' ? '_blank' : '_self',
      "data-locator": FOOTER_COMPLIANCE_LINK
    }, /*#__PURE__*/React__default.createElement(Picture, {
      media: {
        image: item.fields.image,
        mobileImage: item.fields.mobileImage,
        aspectRatio: {
          mobile: '2-1',
          desktop: '2-1',
          tablet: '2-1'
        }
      },
      hasBorderRadius: false,
      dataLocator: FOOTER_COMPLIANCE_IMAGE
    })) : /*#__PURE__*/React__default.createElement(Picture, {
      media: {
        image: item.fields.image,
        mobileImage: item.fields.mobileImage,
        aspectRatio: {
          mobile: '2-1',
          desktop: '2-1',
          tablet: '2-1'
        }
      },
      hasBorderRadius: false,
      dataLocator: FOOTER_COMPLIANCE_IMAGE
    }));
  }))));
};

var styles$U = function styles(theme) {
  return {
    tooltip: {
      position: 'relative',
      backgroundColor: theme.palette.toolTip.background,
      color: theme.palette.toolTip.contrastText,
      padding: theme.spacing(2),
      maxWidth: theme.typography.pxToRem(240),
      fontWeight: theme.typography.fontWeights.normal,
      fontSize: theme.typography.T11,
      lineHeight: theme.typography.lineHeight.L14,
      transition: "opacity ".concat(timings.small, " ").concat(transitionFunction.easeOut, " !important"),
      '&.MuiTooltip-tooltipPlacementTop': {
        marginBottom: '10px',
        boxShadow: '0 6px 8px 0 rgba(0,0,0,0.24)'
      },
      '&.MuiTooltip-tooltipPlacementBottom': {
        marginTop: '10px',
        boxShadow: '0 -6px 8px 0 rgba(0,0,0,0.24)'
      }
    },
    tooltopIcon: {
      display: 'inline-flex',
      '&:focus': {
        outline: 0
      }
    },
    popper: arrowGenerator(theme.palette.toolTip.background)
  };
};

function arrowGenerator(color) {
  return {
    '& .MuiTooltip-tooltip': {},
    '&[x-placement*="bottom"] .MuiTooltip-arrow': {
      top: 0,
      left: '50%',
      marginTop: '-0.95em',
      width: '2em',
      height: '1em',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: "transparent transparent ".concat(color, " transparent")
      }
    },
    '&[x-placement*="top"] .MuiTooltip-arrow': {
      bottom: 0,
      left: '47%',
      marginBottom: '-0.95em',
      width: '2em',
      height: '1em',
      '&::before': {
        borderWidth: '1em 1em 0 1em',
        borderColor: "".concat(color, " transparent transparent transparent")
      }
    },
    '&[x-placement*="right"] .MuiTooltip-arrow': {
      left: 0,
      marginLeft: '-0.9em',
      height: '2em',
      width: '1em',
      '&::before': {
        borderWidth: '1em 1em 1em 0',
        borderColor: "transparent ".concat(color, " transparent transparent")
      }
    },
    '&[x-placement*="left"] .MuiTooltip-arrow': {
      right: 0,
      marginRight: '-0.95em',
      height: '2em',
      width: '1em',
      '&::before': {
        borderWidth: '1em 0 1em 1em',
        borderColor: "transparent transparent transparent ".concat(color)
      }
    }
  };
}

var _excluded$5 = ["isRichText", "color"];
var useStylesArrow = makeStyles(styles$U);
/**
 *
 * @param {boolean} isRichText - default value is false and if true it will render RichText content
 * @param {string} color - default value is white
 * @param {object} classes
 * @param {boolean} disableFocusListener - Do not respond to focus events and default value is false
 * @param {boolean} disableTouchListener - Do not respond to long press touch events and default value is false
 * @param {string} placement - Tooltip placement and default value is top (refer-`https://material-ui.com/api/tooltip/` for different possible values of placement)
 * @param {object} PopperProps -Props applied to the Popper element.
 */

function ArrowTooltip(props) {
  var _useStylesArrow = useStylesArrow(),
      classes = _extends({}, _useStylesArrow);

  var _props$isRichText = props.isRichText,
      isRichText = _props$isRichText === void 0 ? false : _props$isRichText,
      _props$color = props.color,
      color = _props$color === void 0 ? 'white' : _props$color,
      otherProps = _objectWithoutProperties(props, _excluded$5);

  var propClassName = props.className || '';
  return /*#__PURE__*/React__default.createElement(Tooltip, _extends({
    classes: classes,
    onClose: props.handleTooltipClose,
    open: props.open,
    "data-locator": 'Tooltip-text-icon',
    disableFocusListener: false,
    disableTouchListener: true,
    placement: "top",
    tabIndex: 0,
    arrow: true
  }, otherProps, {
    className: clsx("toolTipIcon-color-".concat(color), propClassName, classes.tooltopIcon),
    title: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: 'span'
    }, isRichText ? /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: props.title
      }
    }) : props.title))
  }));
}

var FwdTooltip = function FwdTooltip(props) {
  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var isMobileWidth = useMediaQuery("(max-width:".concat(breakpoints.values.md, "px)"));

  var handleTooltipClose = function handleTooltipClose() {
    isMobileWidth && typeof document !== 'undefined' && document.removeEventListener('touchstart', handleTooltipClose);
    setOpen(false);
  };

  var handleTooltipOpen = function handleTooltipOpen() {
    setOpen(true);
  };

  useEffect(function () {
    if (open && isMobileWidth && typeof document !== 'undefined') {
      document.addEventListener('touchstart', handleTooltipClose);
      return function () {
        document.removeEventListener('touchstart', handleTooltipClose);
      };
    }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/React__default.createElement(ArrowTooltip, _extends({}, props, {
    open: open,
    handleTooltipClose: handleTooltipClose
  }), /*#__PURE__*/React__default.createElement("div", {
    onMouseOver: handleTooltipOpen
  }, props.children));
};

var useStyles$_ = makeStyles(styles$_);

var Footer$1 = function Footer(props) {
  var _clsx2;

  var isDesktop = useMediaQuery("(min-width:".concat(breakpoints.values.lg, "px)"));
  var isMobile = useMediaQuery("(max-width:".concat(breakpoints.values.lg, "px)"));
  var flexiCol = get$1(props, 'flexiCol', null);
  var params = get$1(props, 'params', {});
  var color = get$1(props, 'params.backgroundColor', 'orangeLighter-orangeLighter');

  var _getColors = getColors(color),
      bgColor = _getColors.bgColor,
      surfaceColor = _getColors.surfaceColor;

  var classes = useStyles$_({
    isDesktop: isDesktop,
    bgColor: bgColor,
    surfaceColor: surfaceColor
  }); // const { t } = useTranslation();
  // const dict = t;

  var translation = get$1(props, 'translation', {
    visitFWD: 'Visit your local FWD site'
  });

  var dict = function dict(key) {
    return translation[key] ? translation[key] : key;
  };

  var fields = get$1(props, 'fields', {});
  var logoLink = get$1(fields, 'logoLink', null);
  var logoIcon = get$1(fields, 'logo', null);
  var countrySelector = get$1(fields, 'countrySelector', []);
  var supportOption = get$1(fields, 'call', null); // Calling hours

  var callingHoursBeforeText = get$1(fields, 'callingHoursTextBeforeTooltip', null);
  var callingHoursAfterText = get$1(fields, 'callingHoursTextAfterTooltip', null);
  var callingHoursTooltip = get$1(fields, 'callingHoursTooltip', null);
  var enableCallingHoursText = get$1(fields, 'enableCallingHoursText.value', false) && (callingHoursBeforeText && callingHoursBeforeText.value || callingHoursAfterText && callingHoursAfterText.value);
  var socialMediaLinks = get$1(fields, 'socialMediaLinks', []);
  var siteNavigationLinks = get$1(fields, 'siteNavigationLinks', []);
  var footerQuickLinks = get$1(fields, 'footerQuickLinks', []);
  var copyrightLabel = get$1(fields, 'copyrightLabel.value', '');
  var gaCategoryName = get$1(props, 'fields.gaCategoryName.value', null);
  var icon = get$1(props, 'fields.icon.fields.value.value', 'call-dual-tone') || 'call-dual-tone'; //added for lang-switcher

  var languageList = get$1(props, 'fields.languageList', []);
  var enablelanguageList = get$1(props, 'fields.enableLanguageToggle.value', true);
  var sitecoreRoute = get$1(props, 'sitecoreContext.route.sitecoreRoute', '');
  var availableLanguages = get$1(props, 'sitecoreContext.availableLanguages', []);
  var itemLanguage = get$1(props, 'sitecoreContext.route.itemLanguage', 'en');
  var languageCode = get$1(props, 'sitecoreContext.languageCode', null);
  var languageIcon = get$1(props, 'sitecoreContext.siteSettings.languageIcon.value', 'language-globe') || 'language-globe';
  var languageModalTitle = get$1(props, 'fields.languageModalTitle.value', 'Do you want to Continue ?');
  var languageModalDescription = get$1(props, 'fields.languageModalDescription.value', '');
  var languageModalSecondaryLink = get$1(props, 'fields.languageModalSecondaryLink.value', '');
  var languageModalLink = get$1(props, 'fields.languageModalLink.value', '');

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var handleChange = function handleChange(id, isExpanded, summary) {
    PushEvent({
      event: 'accordionChange',
      buttonTitle: summary || getGTMSharedKeyVal(undefined, FOOTER_SITE_NAVIGATION_SECTION),
      destinationUrl: undefined,
      componentName: gaCategoryName ? gaCategoryName : FOOTER_SITE_NAVIGATION_SECTION
    }, props.gtmPushEvent);
    setExpanded(isExpanded ? false : id);
  };

  var onClickLogo = function onClickLogo(e) {
    PushEvent({
      event: 'buttonClick',
      buttonTitle: 'FWDLogo',
      componentName: gaCategoryName ? gaCategoryName : FOOTER_LOGO,
      destinationUrl: get$1(logoLink, 'value.href', '/')
    }, props.gtmPushEvent);
    e.preventDefault();
    e.stopPropagation();

    if ((e.ctrlKey || e.metaKey) && typeof window !== 'undefined') {
      window.open(get$1(logoLink, 'value.href', '/'), '_blank');
    } else {
      navigate(get$1(logoLink, 'value.href', '/'));
    }
  };

  var copyrightLabels = copyrightLabel.split('\n');
  var copyrightText = '';

  if (copyrightLabels.length === 1) {
    copyrightText = "".concat('&copy; ' + copyrightLabel);
  } else {
    copyrightText = "".concat('&copy; ' + copyrightLabels[0], " ").concat(copyrightLabels[1]);
  } // Error page footer fix
  // TODO: Need to look for better approach


  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      footerMargin = _useState4[0],
      setFooterMargin = _useState4[1];

  var errorComponent = get$1(props, 'sitecoreContext.route.placeholders["jss-main"][0].componentName', '');
  var isErrorComponent = errorComponent === 'Error';
  var updateFooterMargin = debounce(function () {
    var viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 0;
    var bodyHeight = typeof document !== 'undefined' ? document.documentElement.offsetHeight - footerMargin : 0;

    if (bodyHeight < viewportHeight) {
      setFooterMargin(viewportHeight - bodyHeight);
    } else if (bodyHeight > viewportHeight) {
      setFooterMargin(null);
    }
  }, 300, {
    trailing: true
  });
  useEffect(function () {
    if (isErrorComponent) updateFooterMargin();
  }); // Compliance Accreditation
  //** Page Compliance Data */

  var routeAccreditationValue = get$1(props, 'sitecoreContext.route.fields.accrediationValue.fields', {}) || {};
  var routeAccreditationDescription = get$1(props, 'sitecoreContext.route.fields.accreditationDescription.value', null);
  var routeAccreditationMode = get$1(props, 'sitecoreContext.route.fields.accreditationMode', null);
  /**
   * Check if Page Level Compliance Description is present
   * IF present merge it with Route Accreditation Description and Mode
   */

  if (routeAccreditationValue && routeAccreditationDescription) {
    routeAccreditationValue = _objectSpread2(_objectSpread2({}, routeAccreditationValue), {}, {
      Description: {
        value: routeAccreditationDescription
      }
    });
  }

  if (routeAccreditationValue && routeAccreditationMode) {
    routeAccreditationValue = _objectSpread2(_objectSpread2({}, routeAccreditationValue), {}, {
      accreditationMode: routeAccreditationMode
    });
  }
  /**
   * Get default accrediation from Footer
   */


  var defaultAccrediation = get$1(props, 'fields.defaultComplianceAccreditation.fields', null);
  /**
   * Check if Comppliance is enabled
   * Compliance is disabled
   *      IF Page level Compliance is diabled
   *      IF Page level data is empty and default is disabled or empty
   */

  var isAccreditationEmpty = !routeAccreditationValue || routeAccreditationValue && !Object.keys(routeAccreditationValue).length;
  var disableCompliance = Boolean(get$1(props, 'fields.disableComplianceAccreditation.value', false) || Boolean(get$1(props, 'sitecoreContext.route.fields.disableCompliance.value', false)) || !routeAccreditationDescription && isAccreditationEmpty && !defaultAccrediation);
  var pageAccrediation = !disableCompliance && !isAccreditationEmpty ? routeAccreditationValue : null;

  if (!pageAccrediation && !disableCompliance) {
    pageAccrediation = defaultAccrediation;
  }
  /**
   * Get the position from the final Accreditation data
   */


  var accrediationPosition = get$1(pageAccrediation, 'accreditationMode.fields.searchName.value', 'belowfooter');
  /**
   * If both description and images are empty , then hide the whole component
   */

  if (pageAccrediation && !get$1(pageAccrediation, 'Description.value', null) && !get$1(pageAccrediation, 'Images', []).length) {
    pageAccrediation = null;
  }
  /**
   * Add addition data for child compliance component
   */


  var complianceProps = Object.assign({
    isDesktop: isDesktop,
    bgColor: bgColor,
    surfaceColor: surfaceColor,
    accrediationPosition: accrediationPosition
  }, pageAccrediation);
  /** Calling Hours */

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;

  useEffect(function () {
    if (typeof window !== 'undefined') {
      var callingHourElm = document.getElementById('callingHrsTextRT');
      var callingHrsToolTipElm = document.getElementById('callingHrsToolTip');

      if (callingHourElm && callingHrsToolTipElm) {
        if (callingHourElm.childElementCount) {
          callingHourElm.lastElementChild.appendChild(callingHrsToolTipElm);
        } else {
          callingHourElm.appendChild(callingHrsToolTipElm);
        }
      }
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, pageAccrediation && accrediationPosition === 'abovefooter' && /*#__PURE__*/React__default.createElement(ComplianceAccreditation, complianceProps), /*#__PURE__*/React__default.createElement(Container$1, {
    useContainer: !flexiCol,
    background: bgColor,
    className: clsx(classes.rootContainer, 'footer', getPaddingString(params)),
    fixed: true,
    overflowHidden: true,
    "data-locator": FOOTER_CONTAINER,
    footerMargin: footerMargin
  }, isErrorComponent && /*#__PURE__*/React__default.createElement(ReactResizeDetector, {
    handleWidth: true,
    onResize: function onResize() {
      return updateFooterMargin();
    }
  }), /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    justifyContent: 'flex-start',
    spacing: isDesktop ? 3 : 0
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 12,
    lg: 4,
    className: clsx(classes.logoAndSupportWrapper)
  }, /*#__PURE__*/React__default.createElement("div", null, logoLink && /*#__PURE__*/React__default.createElement("div", {
    className: classes.logoSection
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    href: get$1(logoLink, 'value.href', '/'),
    "data-locator": FOOTER_LOGO,
    onClick: onClickLogo,
    ariaLabel: "FWD Logo"
  }, get$1(logoLink, 'value.title', false) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "srOnly"
  }, get$1(logoLink, 'value.title')), get$1(logoIcon, 'value.src', null) ? /*#__PURE__*/React__default.createElement("img", {
    src: get$1(logoIcon, 'value.src', '/'),
    alt: get$1(logoIcon, 'value.alt', null),
    className: classes.logo
  }) : /*#__PURE__*/React__default.createElement(FWDLogo, {
    viewBox: '0 0 105 36',
    className: classes.logo
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: classes.languageCountryWrapper
  }, !isEmpty(languageList) && languageList.length > 1 && enablelanguageList && !isMobile && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.footerLanguageSwitch, classes.hideMobile)
  }, /*#__PURE__*/React__default.createElement(LanguageSwitcher, {
    title: languageModalTitle,
    description: languageModalDescription,
    secondaryLink: languageModalSecondaryLink,
    languageModalLink: languageModalLink,
    languageList: languageList,
    itemLanguage: itemLanguage,
    languageCode: languageCode,
    variant: 'small',
    placement: 'footer',
    gaCategoryName: gaCategoryName,
    sitecoreRoute: sitecoreRoute,
    availableLanguages: availableLanguages,
    color: bgColor,
    typo: 'body1A',
    languageIcon: languageIcon,
    onLanguageChange: props.onLanguageChange,
    gtmPushEvent: props.gtmPushEvent
  })), countrySelector.length && !isMobile && /*#__PURE__*/React__default.createElement("div", {
    className: classes.hideMobile
  }, /*#__PURE__*/React__default.createElement(CountrySelector$1, {
    dict: dict,
    color: bgColor,
    countryList: countrySelector,
    gaCategoryName: gaCategoryName,
    gtmPushEvent: props.gtmPushEvent
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: classes.bottomAlignSection
  }, supportOption && supportOption.value && /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    variant: "h3",
    href: "tel:".concat(supportOption.value),
    underline: "none",
    size: "small",
    "data-locator": FOOTER_CALL_SUPPORT,
    type: "text",
    className: classes.supportOption,
    onClick: function onClick() {
      return PushEvent({
        event: 'buttonClick',
        buttonTitle: get$1(fields, 'gaLabelName.value', '') || getGTMSharedKeyVal(undefined, FOOTER_CALL_SUPPORT),
        componentName: gaCategoryName ? gaCategoryName : FOOTER_CALL_SUPPORT,
        destinationUrl: "tel:".concat(supportOption.value)
      }, props.gtmPushEvent);
    }
  }, /*#__PURE__*/React__default.createElement(BrandingIcon, {
    icon: icon,
    type: 'primary',
    size: 'lg',
    shape: 'circle',
    parentHover: true
  }), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: supportOption.value.length <= 6 ? 'h3' : 'h4',
    component: "span",
    color: bgColor,
    type: "text",
    fontWeight: "bolder",
    className: supportOption.value.length <= 6 ? 'large-font' : 'small-font'
  }, supportOption.value)), enableCallingHoursText && /*#__PURE__*/React__default.createElement("div", {
    className: classes.callingHrsWrapper
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body3",
    component: "div",
    type: "caption",
    color: bgColor,
    "data-locator": FOOTER_CALLING_HOUR_BEFORE_TEXT,
    className: classes.callingHrsToolTipWrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    id: "callingHrsTextRT",
    className: clsx(classes.callingHrsText, 'richtext-link-common'),
    dangerouslySetInnerHTML: {
      __html: callingHoursBeforeText.value
    }
  }), callingHoursTooltip && callingHoursTooltip.value && callingHoursBeforeText && callingHoursBeforeText.value && /*#__PURE__*/React__default.createElement("span", {
    id: "callingHrsToolTip",
    className: classes.callingHrsToolTip
  }, /*#__PURE__*/React__default.createElement(FwdTooltip, {
    title: callingHoursTooltip.value,
    isRichText: true
  }, /*#__PURE__*/React__default.createElement("span", {
    "data-locator": FOOTER_CALLING_HOUR_TOOLTIP,
    className: clsx(classes.tooltip, _defineProperty({}, 'hideFocusonClick', !useKeyBoard)),
    tabIndex: 0
  }, /*#__PURE__*/React__default.createElement(NamedIcon$1, {
    icon: "question-mark"
  }))))), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body3",
    component: "div",
    type: "caption",
    color: bgColor,
    "data-locator": FOOTER_CALLING_HOUR_AFTER_TEXT,
    className: classes.callingHrsToolTipWrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.callingHrsText, classes.callingHrsAfterToolTip, 'richtext-link-common'),
    dangerouslySetInnerHTML: {
      __html: callingHoursAfterText.value
    }
  }))), !isEmpty(socialMediaLinks) && !isMobile && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.socialMediaSection, classes.hideMobile, 'dividerLinePadding', (_clsx2 = {}, _defineProperty(_clsx2, classes.dividerLine, (supportOption === null || supportOption === void 0 ? void 0 : supportOption.value) || enableCallingHoursText), _defineProperty(_clsx2, "border-color-".concat(bgColor), (supportOption === null || supportOption === void 0 ? void 0 : supportOption.value) || enableCallingHoursText), _clsx2)),
    "data-locator": FOOTER_SOCIAL_MEDIA_SECTION
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: 'icon-social-media'
  }, socialMediaLinks.map(function (option) {
    var iconVal = get$1(option, 'fields.title.value', '').toLowerCase();
    return get$1(option, 'fields.link.value.href', null) && iconVal && iconVal !== '$name' ? /*#__PURE__*/React__default.createElement("li", {
      key: option.id
    }, /*#__PURE__*/React__default.createElement(NavigationLink$1, {
      listType: option.fields.listType,
      link: option.fields.link,
      size: "small",
      underline: "none",
      hasTitle: false,
      icon: iconVal,
      dataLocator: FOOTER_SOCIAL_MEDIA_ITEM,
      GTMSharedKey: get$1(option, 'fields.gaLabelName.value', ''),
      gtmPushEvent: props.gtmPushEvent
    })) : null;
  })))))), /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 12,
    lg: 8,
    className: classes.siteMapWrapper
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    justifyContent: "flex-start",
    className: classes.siteMapSection,
    "data-locator": FOOTER_SITE_NAVIGATION_SECTION
  }, siteNavigationLinks.map(function (mainNavLinkList, id) {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      key: mainNavLinkList.id,
      item: true,
      xs: 12,
      lg: 3,
      className: classes.footerColumn
    }, /*#__PURE__*/React__default.createElement(NavigationList$1, {
      mainNavLinkList: mainNavLinkList.Children,
      color: bgColor,
      expanded: expanded,
      handleChange: handleChange,
      gaCategoryName: gaCategoryName,
      isDesktop: !isMobile,
      checkQueryParamsForEnqForm: id,
      footerNavigation: true,
      useLineBreaker: !isMobile,
      updateFormModalState: props.updateFormModalState,
      gtmPushEvent: props.gtmPushEvent,
      navigate: props.navigate
    }));
  })))), !isDesktop && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.mobileLinkSection, classes.hideDesktop)
  }, socialMediaLinks && socialMediaLinks.length && /*#__PURE__*/React__default.createElement("div", {
    className: classes.socialMediaSection,
    "data-locator": FOOTER_SOCIAL_MEDIA_SECTION
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: 'icon-social-media'
  }, socialMediaLinks.map(function (option) {
    var iconVal = get$1(option, 'fields.title.value', '').toLowerCase();
    return get$1(option, 'fields.link.value.href', null) && iconVal && iconVal !== '$name' ? /*#__PURE__*/React__default.createElement("li", {
      key: option.id
    }, /*#__PURE__*/React__default.createElement(NavigationLink$1, {
      listType: option.fields.listType,
      link: option.fields.link,
      size: "small",
      underline: "none",
      hasTitle: false,
      icon: get$1(option, 'fields.title.value', '').toLowerCase(),
      dataLocator: FOOTER_SOCIAL_MEDIA_ITEM,
      GTMSharedKey: get$1(option, 'fields.gaLabelName.value', ''),
      gtmPushEvent: props.gtmPushEvent
    })) : null;
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: 'countrySelectorWrapper'
  }, !isEmpty(languageList) && languageList.length > 1 && enablelanguageList && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.mobileFooterLanguageSwitch, "border-color-".concat(bgColor))
  }, /*#__PURE__*/React__default.createElement(LanguageSwitcher, {
    title: languageModalTitle,
    description: languageModalDescription,
    secondaryLink: languageModalSecondaryLink,
    languageModalLink: languageModalLink,
    languageList: languageList,
    itemLanguage: itemLanguage,
    languageCode: languageCode,
    variant: 'small',
    placement: 'footer',
    gaCategoryName: gaCategoryName,
    sitecoreRoute: sitecoreRoute,
    availableLanguages: availableLanguages,
    color: bgColor,
    typo: 'body1A',
    languageIcon: languageIcon,
    onLanguageChange: props.onLanguageChange,
    gtmPushEvent: props.gtmPushEvent
  })), countrySelector.length && /*#__PURE__*/React__default.createElement(CountrySelector$1, {
    dict: dict,
    color: bgColor,
    countryList: countrySelector,
    gaCategoryName: gaCategoryName,
    marginTop: false,
    gtmPushEvent: props.gtmPushEvent
  }))), pageAccrediation && accrediationPosition === 'belowfooter' && /*#__PURE__*/React__default.createElement(ComplianceAccreditation, complianceProps), /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.bottomLinksContainer, classes.dividerLine, "border-color-".concat(bgColor), {
      belowfooter: pageAccrediation && accrediationPosition === 'belowfooter'
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.bottomLinksSection
  }, footerQuickLinks && footerQuickLinks.length && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.footerQuickLinksSection, {
      belowfooter: pageAccrediation && accrediationPosition === 'belowfooter'
    }),
    "data-locator": FOOTER_QUICK_LINKS_SECTION
  }, /*#__PURE__*/React__default.createElement("ul", null, footerQuickLinks.map(function (quickLink) {
    var _quickLink$fields, _quickLink$fields2, _quickLink$fields3, _quickLink$fields3$ti;

    return get$1(quickLink, 'fields.listType.fields.key.value', null) === 'chat' || get$1(quickLink, 'fields.link.value.linktype', null) ? /*#__PURE__*/React__default.createElement("li", {
      key: quickLink.id
    }, /*#__PURE__*/React__default.createElement(NavigationLink$1, {
      listType: quickLink === null || quickLink === void 0 ? void 0 : (_quickLink$fields = quickLink.fields) === null || _quickLink$fields === void 0 ? void 0 : _quickLink$fields.listType,
      link: quickLink === null || quickLink === void 0 ? void 0 : (_quickLink$fields2 = quickLink.fields) === null || _quickLink$fields2 === void 0 ? void 0 : _quickLink$fields2.link,
      title: quickLink === null || quickLink === void 0 ? void 0 : (_quickLink$fields3 = quickLink.fields) === null || _quickLink$fields3 === void 0 ? void 0 : (_quickLink$fields3$ti = _quickLink$fields3.title) === null || _quickLink$fields3$ti === void 0 ? void 0 : _quickLink$fields3$ti.value,
      color: bgColor,
      variant: !isMobile ? 'body1' : 'body6',
      type: "caption",
      underline: "none",
      className: classes.quickLink,
      dataLocator: FOOTER_QUICK_LINKS_ITEM,
      GTMSharedKey: get$1(quickLink, 'fields.gaLabelName.value', ''),
      gtmPushEvent: props.gtmPushEvent
    })) : null;
  }))), copyrightLabel && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.copyrightSection, classes.dividerLine, "border-color-".concat(bgColor))
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: !isMobile ? 'body1' : 'body6',
    type: "caption",
    component: "div",
    color: bgColor,
    "data-locator": FOOTER_COPYRIGHT_INFO,
    className: classes.copyrightContent
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: copyrightText
    }
  })))))));
}; // export default withSitecoreContext()(Footer);

var PageType = 'page';
var SectionType = 'section';
var TextType = 'text';
var SingleLineTextType = 'single-line-text';
var SubmitType = 'submit-button';
var RadioListType = 'radio-button-list';
var TelephoneType = 'telephone';
var EmailType = 'email';
var DropDown = 'dropdown-list';
var CheckBox$1 = 'checkbox-list';
var ToolTip = 'tooltip';
var DateType = 'dob';
var SaveButton = 'save-data';
var SendEmail = 'send-email';
var CustomAction = 'custom-action';
var MultiLineTextType = 'multiple-line-text';

var styles$T = function styles(theme) {
  var primaryColor = get$1(theme, 'palette.primary.color', 'orange') || 'orange';
  return {
    root: {
      width: '100%',
      '& .MuiInputBase-input': {
        height: theme.typography.pxToRem(36),
        caretColor: primaryColor
      },
      '&$rootRegular': {
        marginTop: theme.typography.pxToRem(20),
        marginBottom: 0,
        '& .MuiInputLabel-outlined': {
          transform: 'translate(0px, 16px) scale(1)',
          top: theme.spacing(-0.25),
          '&.Mui-focused': {
            top: theme.typography.pxToRem(-4),
            transform: 'translate(0px, -16px) scale(1)',
            fontSize: theme.typography.pxToRem(14),
            lineHeight: theme.typography.pxToRem(18)
          },
          '&.MuiFormLabel-filled': {
            top: theme.typography.pxToRem(-4),
            transform: 'translate(0px, -16px) scale(1)',
            fontSize: theme.typography.pxToRem(14),
            lineHeight: theme.typography.pxToRem(18)
          }
        },
        '&$nonEmptyField .MuiOutlinedInput-notchedOutline': {
          border: 0
        },
        '&$nonEmptyField .MuiInputBase-root': {
          border: "1px solid ".concat(theme.palette.colors.grey.line.textFieldDefault),
          borderRadius: '4px'
        },
        '& .MuiOutlinedInput-root.Mui-focused': {
          border: "1px solid ".concat(primaryColor),
          borderRadius: '4px'
        },
        '& .MuiOutlinedInput-root': {
          borderRadius: 0,
          border: 0,
          borderBottom: "1px solid ".concat(theme.palette.colors.grey.line.textFieldDefault),
          '& .Mui-focused': {
            border: "1px solid ".concat(primaryColor),
            borderRadius: '4px'
          }
        },
        '& .MuiOutlinedInput-adornedStart': {
          padding: theme.spacing(1.25, 1),
          '& .MuiOutlinedInput-input': {
            padding: '0'
          }
        },
        '& .MuiOutlinedInput-input': {
          padding: theme.spacing(1.25, 3, 1.25, 1),
          height: theme.spacing(2.5),
          color: theme.palette.colors.white.contrastText
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius: 0,
          border: 0,
          '& legend': {
            width: 'inherit !important'
          }
        },
        '&$errorField': {
          '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.error.main
          }
        }
      },
      '&$rootConversational': {
        '&$errorField': {
          '& .MuiInput-underline::before': {
            borderColor: theme.palette.error.main
          },
          '& .MuiInput-underline::after': {
            borderColor: theme.palette.error.main
          }
        },
        '&$nonEmptyField': {
          '& .MuiInput-underline::before': {
            borderColor: theme.palette.colors.darkGreen.main
          },
          '& .MuiInput-underline::after': {
            borderColor: theme.palette.colors.darkGreen.main
          }
        },
        '& .MuiInputBase-input': {
          height: theme.spacing(5),
          padding: 0,
          '&::-ms-clear': {
            display: 'none'
          }
        },
        '&.multiline': {
          margin: 0
        }
      }
    },
    rootConversational: {},
    rootRegular: {},
    errorField: {},
    nonEmptyField: {}
  };
};

var styles$S = function styles(theme) {
  return {
    fieldMessage: {
      color: theme.palette.error.main,
      '& a': {
        marginLeft: '20px',
        fontWeight: theme.typography.fontWeights.bolder,
        '&:hover': {
          color: theme.palette.error.main
        }
      }
    },
    fieldMessageConversational: {
      color: theme.palette.error.main,
      display: 'flex',
      '& svg': {
        marginTop: theme.spacing(0.25)
      },
      '& svg path': {
        fill: theme.palette.error.main
      }
    },
    Apitimeout: {
      color: '#333',
      backgroundColor: '#E5E5E5',
      padding: theme.spacing(1),
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(3)
    },
    errorContainerBg: {
      color: '#333',
      backgroundColor: '#FEF3F3',
      borderRadius: theme.spacing(2),
      padding: theme.spacing(2),
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(3)
    },
    textwrapper: {
      display: 'flex',
      '& span': {
        marginTop: '-2px'
      }
    },
    link: {
      textDecoration: 'underline',
      color: theme.palette.error.main
    },
    hintConversational: {
      fontWeight: theme.typography.fontWeights.normal,
      lineHeight: theme.typography.pxToRem(21),
      paddingTop: theme.spacing(2),
      display: 'inline-block',
      position: 'relative',
      '& span': {
        color: theme.palette.colors.white.contrastTextCaption
      },
      '& svg path': {
        fill: theme.palette.colors.white.line.textFieldDefault
      }
    }
  };
};

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ErrorOutline = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
})), 'ErrorOutline');

var useStyles$Z = makeStyles(styles$S);

var FieldMessage = function FieldMessage(props) {
  var _clsx, _clsx2;

  var classes = useStyles$Z();
  var _props$errorInContain = props.errorInContainer,
      errorInContainer = _props$errorInContain === void 0 ? false : _props$errorInContain;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.errors && props.errors["".concat(props.name)] && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    component: "div",
    variant: "body3",
    "data-locator": 'Form-Section-Label-Error',
    className: clsx(classes.fieldMessage, (_clsx = {}, _defineProperty(_clsx, classes.fieldMessageConversational, props.formtype === 'conversational'), _defineProperty(_clsx, classes.Apitimeout, props.name === 'Apitimeout'), _defineProperty(_clsx, "multiline", props.multiline), _clsx))
  }, props.name === 'Apitimeout' ? /*#__PURE__*/React__default.createElement(ErrorOutline, {
    style: {
      verticalAlign: 'middle'
    },
    viewBox: "0 0 24 24"
  }) : /*#__PURE__*/React__default.createElement(Warning, {
    style: {
      verticalAlign: 'middle'
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: '4px',
      verticalAlign: 'middle'
    }
  }, props.errors["".concat(props.name)].message)), props.hint && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    component: "div",
    variant: props.name === 'apiError' ? 'body6' : 'h10',
    "data-locator": 'Form-Section-Label-Hint',
    className: classes.hintConversational
  }, props.name === 'apiError' ? /*#__PURE__*/React__default.createElement(Warning, {
    style: {
      verticalAlign: 'middle'
    }
  }) : /*#__PURE__*/React__default.createElement(InfoFilled, {
    style: {
      verticalAlign: 'middle'
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: '4px',
      verticalAlign: 'middle'
    },
    dangerouslySetInnerHTML: {
      __html: props.hint
    }
  })), errorInContainer && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    component: "div",
    variant: "body3",
    "data-locator": 'Background-Label-Error',
    className: clsx(classes.fieldMessage, classes.errorContainerBg, (_clsx2 = {}, _defineProperty(_clsx2, classes.fieldMessageConversational, props.formtype === 'conversational'), _defineProperty(_clsx2, "multiline", props.multiline), _clsx2))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.textwrapper
  }, /*#__PURE__*/React__default.createElement(Warning, {
    style: {
      verticalAlign: 'middle'
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: '4px',
      verticalAlign: 'middle'
    }
  }, props.message)), props.retryLink && /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    component: "a",
    onClick: props.onRetryClick,
    className: classes.link
  }, /*#__PURE__*/React__default.createElement("span", null, props.retryLink))));
};

var _excluded$4 = ["hasDummyText", "dummyTextSource"];
var useStyles$Y = makeStyles(styles$T);

var InputField = function InputField(_ref) {
  var _clsx;

  var _ref$hasDummyText = _ref.hasDummyText,
      hasDummyText = _ref$hasDummyText === void 0 ? false : _ref$hasDummyText,
      _ref$dummyTextSource = _ref.dummyTextSource,
      dummyTextSource = _ref$dummyTextSource === void 0 ? '' : _ref$dummyTextSource,
      props = _objectWithoutProperties(_ref, _excluded$4);

  var classes = useStyles$Y();
  var maxLength = props.maxLength || 0;
  /* refs */

  var rootRef = useRef();
  /* states */

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isFieldEmpty = _useState2[0],
      setIsFieldEmpty = _useState2[1];
  /* methods */


  var handleBlur = function handleBlur(event) {
    setIsFieldEmpty(!event.target.value);
  };

  var handleChange = function handleChange(event) {
    /* istanbul ignore else */
    if (maxLength > 0 && event.target.value.length > maxLength) {
      event.target.value = event.target.value.slice(0, maxLength);
    }

    props.onChange();
  };
  /* effects */


  useEffect(function () {
    /* istanbul ignore else */
    if (hasDummyText && rootRef.current.querySelector('.dummyInputText') && rootRef.current.querySelector('input')) {
      Object.assign(rootRef.current.querySelector('input').style, {
        width: "".concat(rootRef.current.querySelector('.dummyInputText').offsetWidth, "px")
      });
    }
  }, [props === null || props === void 0 ? void 0 : props.defaultValue]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    ref: rootRef
  }, hasDummyText && /*#__PURE__*/React__default.createElement("div", {
    className: "dummyInputText dummyInputText-".concat(dummyTextSource),
    style: {
      position: 'absolute',
      pointerEvents: 'none',
      visibility: 'hidden'
    }
  }, props.defaultValue || ''), /*#__PURE__*/React__default.createElement(TextField, _extends({
    variant: props.formtype === 'conversational' ? 'standard' : 'outlined',
    className: clsx(classes.root, (_clsx = {}, _defineProperty(_clsx, classes.rootRegular, props.formtype === 'regular'), _defineProperty(_clsx, classes.rootConversational, props.formtype === 'conversational'), _defineProperty(_clsx, classes.nonEmptyField, !isFieldEmpty || props.defaultValue), _defineProperty(_clsx, classes.errorField, props.errors && props.errors["".concat(props.name)]), _defineProperty(_clsx, "multiline", props.multiline), _clsx)),
    InputLabelProps: {
      shrink: false
    },
    "data-testid": "inputField",
    onBlur: function onBlur(event) {
      return handleBlur(event);
    },
    id: props.label
  }, props, {
    onChange: function onChange(e) {
      return handleChange(e);
    }
  }))), /*#__PURE__*/React__default.createElement(FieldMessage, {
    name: props.name,
    errors: props.errors,
    formtype: props.formtype,
    multiline: props.multiline
  }));
};

var styles$R = function styles(theme) {
  var primaryColor = get$1(theme, 'palette.primary.color', 'orange') || 'orange';
  return {
    root: {
      width: '100%',
      '& .MuiInputBase-input': {
        height: theme.spacing(5),
        caretColor: primaryColor,
        padding: 0,
        '&::-ms-clear': {
          display: 'none'
        }
      },
      '&$rootRegular': {
        marginTop: theme.typography.pxToRem(20),
        marginBottom: 0,
        '& .MuiInputLabel-outlined': {
          transform: 'translate(0px, 16px) scale(1)',
          '&.Mui-focused': {
            top: theme.typography.pxToRem(-4),
            transform: 'translate(0px, -16px) scale(1)',
            fontSize: theme.typography.pxToRem(14),
            lineHeight: theme.typography.pxToRem(18)
          },
          '&.MuiFormLabel-filled': {
            top: theme.typography.pxToRem(-4),
            transform: 'translate(0px, -16px) scale(1)',
            fontSize: theme.typography.pxToRem(14),
            lineHeight: theme.typography.pxToRem(18)
          }
        },
        '&$nonEmptyField .MuiOutlinedInput-notchedOutline': {
          border: 0
        },
        '&$nonEmptyField .MuiInputBase-root': {
          border: "1px solid ".concat(theme.palette.colors.grey.line.textFieldDefault),
          borderRadius: '4px'
        },
        '& .MuiOutlinedInput-root.Mui-focused': {
          border: "1px solid ".concat(primaryColor),
          borderRadius: '4px'
        },
        '& .MuiOutlinedInput-root': {
          borderRadius: 0,
          border: 0,
          borderBottom: "1px solid ".concat(theme.palette.colors.grey.line.textFieldDefault),
          '& .Mui-focused': {
            border: "1px solid ".concat(primaryColor),
            borderRadius: '4px'
          }
        },
        '& .MuiOutlinedInput-adornedStart': {
          padding: theme.spacing(1.25, 1),
          '& .MuiOutlinedInput-input': {
            padding: '0'
          }
        },
        '& .MuiOutlinedInput-input': {
          padding: theme.spacing(1.25, 1),
          height: theme.spacing(2.5),
          color: theme.palette.colors.white.contrastText
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius: 0,
          border: 0,
          '& legend': {
            width: 'inherit !important'
          }
        },
        '&$errorField': {
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.error.main
          }
        }
      },
      '&$rootConversational': {
        '&$errorField': {
          '& .MuiInput-underline::before': {
            borderColor: theme.palette.error.main
          },
          '& .MuiInput-underline::after': {
            borderColor: theme.palette.error.main
          }
        },
        '&$nonEmptyField': {
          '& .MuiInput-underline::before': {
            borderColor: theme.palette.colors.darkGreen.main
          },
          '& .MuiInput-underline::after': {
            borderColor: theme.palette.colors.darkGreen.main
          }
        }
      }
    },
    rootConversational: {},
    rootRegular: {},
    errorField: {},
    nonEmptyField: {}
  };
};

var useStyles$X = makeStyles(styles$R);
var defaultWhiteSpaceIndex = 2;

var MaskInputField = function MaskInputField(props) {
  var _clsx;

  var classes = useStyles$X();

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isFieldEmpty = _useState2[0],
      setIsFieldEmpty = _useState2[1];

  var whiteSpaceIndex = props.dialInCodeLength ? parseInt(props.dialInCodeLength) : defaultWhiteSpaceIndex;

  var handleBlur = function handleBlur(event) {
    setIsFieldEmpty(!event.target.value);
  };

  var whiteSpace = whiteSpaceIndex ? ' ' : '';

  var telPhoneMask = function telPhoneMask(event) {
    var phoneMaskValue = event.target.value.replace(/\D/g, '');
    var cursorStartPoint = event.target.selectionStart;

    if (phoneMaskValue.length > whiteSpaceIndex) {
      phoneMaskValue = phoneMaskValue.substr(0, whiteSpaceIndex) + whiteSpace + phoneMaskValue.substr(whiteSpaceIndex);
    }

    event.target.value = phoneMaskValue.substr(0, parseInt(props.maxLength));
    cursorStartPoint = whiteSpaceIndex && cursorStartPoint === whiteSpaceIndex + 1 && event.target.value.length === whiteSpaceIndex + 2 ? cursorStartPoint + 1 : cursorStartPoint;
    event.target.selectionEnd = event.target.selectionStart = cursorStartPoint;

    if (event.target.value.length >= props.minLength && props.triggerValidation) {
      props.triggerValidation(props.name);
    }

    props.onChange();
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div"
  }, /*#__PURE__*/React__default.createElement(TextField, _extends({
    variant: props.formtype === 'conversational' ? 'standard' : 'outlined',
    className: clsx(classes.root, (_clsx = {}, _defineProperty(_clsx, classes.rootRegular, props.formtype === 'regular'), _defineProperty(_clsx, classes.rootConversational, props.formtype === 'conversational'), _defineProperty(_clsx, classes.nonEmptyField, !isFieldEmpty || props.defaultValue), _defineProperty(_clsx, classes.errorField, props.errors && props.errors["".concat(props.name)]), _clsx)),
    InputLabelProps: {
      shrink: false
    },
    "data-testid": "inputField",
    onBlur: function onBlur(event) {
      return handleBlur(event);
    }
  }, props, {
    onChange: function onChange(event) {
      return telPhoneMask(event);
    }
  }))), /*#__PURE__*/React__default.createElement(FieldMessage, {
    name: props.name,
    errors: props.errors,
    formtype: props.formtype
  }));
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var useStyles$W = makeStyles({
  root: {
    flexDirection: 'row'
  }
});

var RadioButtonGroup = function RadioButtonGroup(props) {
  var classes = useStyles$W();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(RadioGroup, {
    className: clsx(classes.root, props.className),
    defaultValue: props.defaultValue,
    "aria-label": props.label,
    name: props.name,
    onChange: props.onChange,
    inputRef: props.register || null
  }, props.children), /*#__PURE__*/React__default.createElement(FieldMessage, {
    name: props.name,
    errors: props.errors,
    formtype: props.formtype
  }));
};

var styles$Q = function styles(theme) {
  var _root;

  return {
    root: (_root = {
      color: theme.palette.colors.white.contrastText,
      position: 'relative',
      width: theme.spacing(16),
      height: theme.spacing(10),
      margin: theme.spacing(0.5),
      padding: theme.spacing(2, 1.5)
    }, _defineProperty(_root, theme.breakpoints.only('xs'), {
      width: theme.spacing(16.5)
    }), _defineProperty(_root, '&$strechedOutButton', _defineProperty({
      width: theme.spacing(33)
    }, theme.breakpoints.only('xs'), {
      width: theme.spacing(16.5)
    })), _defineProperty(_root, '& .MuiIconButton-label', {
      width: '100%',
      height: '100%'
    }), _defineProperty(_root, '& .MuiFormControlLabel-label', {
      display: 'inline-block',
      width: '100%',
      zIndex: 100,
      textAlign: 'center',
      fontSize: 'inherit',
      fontWeight: 'inherit',
      fontFamily: 'inherit',
      lineHeight: theme.typography.lineHeight.L7,
      textTransform: 'lowercase'
    }), _root),
    strechedOutButton: {},
    radioRootConversational: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      padding: 0,
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    radioRootRegular: {
      padding: theme.spacing(1),
      background: 'transparent !important',
      '&.MuiButtonBase-root': {
        padding: theme.spacing(1)
      }
    },
    rootRegular: {
      color: theme.palette.colors.white.contrastText,
      opacity: 1
    },
    radioInput: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      opacity: 0,
      width: '100%',
      height: '100%',
      zIndex: 1,
      position: 'absolute'
    }
  };
};

var useStyles$V = makeStyles(styles$Q);

function StyledRadio(props) {
  var _clsx;

  var classes = useStyles$V();
  var _props$color = props.color,
      color = _props$color === void 0 ? 'white' : _props$color,
      _props$hasBorderRadiu = props.hasBorderRadius,
      hasBorderRadius = _props$hasBorderRadiu === void 0 ? true : _props$hasBorderRadiu;
  var isChecked = props.checked;
  return /*#__PURE__*/React__default.createElement("span", {
    className: clsx('MuiButtonBase-root MuiIconButton-root MuiRadio-root', hasBorderRadius ? getBorderRadius('small') : '', (_clsx = {
      'Mui-checked': props.checked
    }, _defineProperty(_clsx, classes.radioRootRegular, props.formtype === 'regular'), _defineProperty(_clsx, "radioBtn-common-conversation radioBtn-".concat(color, "-conversation"), props.formtype === 'conversational'), _defineProperty(_clsx, "radioBtn-common-regular radioBtn-".concat(color, "-regular"), color && props.formtype === 'regular'), _defineProperty(_clsx, classes.radioRootConversational, props.formtype === 'conversational'), _clsx)),
    "aria-disabled": "false"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "MuiIconButton-label"
  }, /*#__PURE__*/React__default.createElement("input", {
    className: classes.radioInput,
    ref: props.inputRef,
    name: props.name,
    value: props.value,
    type: "radio",
    defaultChecked: props.checked,
    checked: isChecked,
    onClick: function onClick(evt) {
      props.onChange(evt, evt.target.value);
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    className: clsx(classes.icon, 'icon', props.checked ? clsx(classes.checkedIcon, 'checkedIcon') : '')
  })));
}

var RadioButton = function RadioButton(props) {
  var _clsx2;

  var classes = useStyles$V();
  return /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    component: "div",
    variant: "radioButton",
    className: "motionColorTransition",
    "data-value": props.value
  }, /*#__PURE__*/React__default.createElement(FormControlLabel, {
    className: clsx((_clsx2 = {}, _defineProperty(_clsx2, classes.root, props.formtype === 'conversational'), _defineProperty(_clsx2, classes.rootRegular, props.formtype === 'regular'), _defineProperty(_clsx2, classes.strechedOutButton, props.variant === 'large'), _clsx2)),
    value: props.value,
    control: /*#__PURE__*/React__default.createElement(StyledRadio, _extends({}, props, {
      inputRef: props.register,
      formtype: props.formtype
    })),
    label: props.label
  }));
};

var styles$P = function styles(theme) {
  return {
    root: {
      paddingRight: theme.typography.pxToRem(8),
      '&:hover': {
        backgroundColor: 'transparent'
      },
      '& .MuiFormControlLabel-label': {
        lineHeight: theme.typography.lineHeight.L7
      }
    },
    checkboxFieldRegular: {
      padding: theme.spacing(1)
    },
    icon: {
      width: theme.typography.pxToRem(20),
      height: theme.typography.pxToRem(20)
    },
    checkedIcon: {
      overflow: 'hidden'
    }
  };
};

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var CheckBoxIcon = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "M16.255,35.914 L8,27.659 C9.561,26.098 12.091,26.098 13.651,27.658 L16.962,30.969 L35.052,12.879 C36.224,11.707 38.124,11.707 39.295,12.879 L40,13.583 L17.669,35.914 C17.279,36.305 16.646,36.305 16.255,35.914"
})), 'CheckBox');

var useStyles$U = makeStyles(styles$P);

function StyledCheckedBox(props) {
  var classes = useStyles$U();
  var _props$color = props.color,
      color = _props$color === void 0 ? 'white' : _props$color,
      _props$hasBorderRadiu = props.hasBorderRadius,
      hasBorderRadius = _props$hasBorderRadiu === void 0 ? true : _props$hasBorderRadiu;
  var extProps = {};

  if (props.checked !== undefined) {
    extProps.checked = props.checked;
  }

  return props.formtype === 'regular' ? /*#__PURE__*/React__default.createElement(Checkbox, _extends({
    color: 'primary',
    disableRipple: true,
    className: clsx(classes.root, 'checkbox-common', "checkbox-".concat(color), _defineProperty({}, classes.checkboxFieldRegular, props.formtype === 'regular')),
    inputRef: props.register,
    checkedIcon: /*#__PURE__*/React__default.createElement("span", {
      className: clsx(classes.checkedIcon, 'checkedIcon')
    }, /*#__PURE__*/React__default.createElement(CheckBoxIcon, {
      className: clsx(classes.icon, 'icon')
    })),
    value: props.value,
    icon: /*#__PURE__*/React__default.createElement("span", {
      className: clsx(classes.icon, 'icon')
    }),
    name: props.name,
    onChange: props.onChange,
    defaultChecked: props.defaultChecked,
    inputProps: props.dataLocator ? _defineProperty({}, 'data-locator', props.dataLocator) : {} // eslint-disable-line no-useless-computed-key

  }, extProps)) : /*#__PURE__*/React__default.createElement(Checkbox, _extends({}, extProps, {
    color: 'primary',
    disableRipple: true,
    className: clsx(classes.root, 'checkbox-common', "checkbox-".concat(color)),
    inputRef: props.register,
    checkedIcon: /*#__PURE__*/React__default.createElement("span", {
      className: clsx(classes.checkedIcon, 'checkedIcon', hasBorderRadius ? getBorderRadius('small') : '')
    }, /*#__PURE__*/React__default.createElement(CheckBoxIcon, {
      className: clsx(classes.icon, 'icon', hasBorderRadius ? getBorderRadius('small') : '')
    })),
    icon: /*#__PURE__*/React__default.createElement("span", {
      className: clsx(classes.icon, 'icon', hasBorderRadius ? getBorderRadius('small') : '')
    }),
    name: props.name,
    onChange: props.onChange,
    defaultChecked: props.defaultChecked,
    inputProps: props.dataLocator ? _defineProperty({}, 'data-locator', props.dataLocator) : {} // eslint-disable-line no-useless-computed-key

  }));
}

var CheckBox = function CheckBox(props) {
  var classes = useStyles$U();
  var _props$color2 = props.color,
      color = _props$color2 === void 0 ? 'white' : _props$color2;
  var labelValue = /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, _extends({
    color: color
  }, props.dataLocatorLabel && {
    'data-locator': props.dataLocatorLabel
  }), /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: props.label.value
    }
  }));
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    component: "div",
    variant: "checkBox"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel, {
    className: clsx(classes.root, _defineProperty({}, props.className, props.className)),
    control: /*#__PURE__*/React__default.createElement(StyledCheckedBox, _extends({}, props, {
      name: props.name,
      value: props.value,
      register: props.register,
      formtype: props.formtype,
      onChange: props.onChange,
      defaultChecked: props.defaultChecked,
      dataLocator: props.dataLocator
    })),
    label: labelValue,
    labelPlacementBottom: true
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "spacerBox",
    "data-value": props.value
  })), props.formtype !== 'regular' && /*#__PURE__*/React__default.createElement(FieldMessage, {
    name: props.name,
    errors: props.errors,
    formtype: props.formtype
  }));
};

var styles$O = function styles(theme) {
  return {
    formControl: {
      display: 'flex',
      '& .MuiFormLabel-filled ~ .MuiInput-underline:before': {
        borderWidth: '1px'
      },
      '& .MuiInput-underline:before, .MuiInput-underline:hover:before': {
        borderWidth: '1px'
      },
      '& .MuiInput-underline:after': {
        borderWidth: '1px'
      }
    },

    /* Styles applied to the root element. */
    root: {
      maxWidth: '100%',
      height: theme.typography.pxToRem(42),
      fontWeight: theme.typography.fontWeights.bolder,
      letterSpacing: 0,
      '& .MuiSelect-select.MuiSelect-select': {
        paddingRight: theme.spacing(3.5)
      },
      '& svg': {
        width: theme.spacing(3),
        height: theme.spacing(3)
      },
      '& .MuiSelect-select:focus': {
        backgroundColor: 'transparent'
      },
      '& [aria-haspopup="listbox"]': {
        '& .showTickIcon': {
          display: 'none'
        }
      }
    },
    nonEmptyField: {
      opacity: 1
    },
    fieldMessage: {
      color: 'red'
    },
    menuItems: {
      padding: theme.spacing(1, 4, 1, 2),
      '&.MuiListItem-root.Mui-selected': {
        background: 'none'
      },
      '&:hover, &.MuiListItem-root.Mui-selected:hover': {
        backgroundColor: theme.palette.colors.orange.main,
        color: theme.palette.colors.orange.contrastText
      }
    },
    regularFormInput: {
      width: '100%',
      marginTop: theme.typography.pxToRem(20),
      display: 'inline-flex',
      marginBottom: 0,
      '& svg': {
        width: theme.spacing(2),
        height: theme.spacing(2),
        top: 'calc(50% - 4px)'
      },
      '& .MuiInputLabel-root': {
        transform: 'translate(0px, 16px) scale(1)',
        top: theme.typography.pxToRem(-2),
        color: fwdColors.greyDarkest,
        letterSpacing: 0,
        '&.MuiFormLabel-filled': {
          top: theme.typography.pxToRem(-4),
          transform: 'translate(0px, -16px) scale(1)',
          fontSize: theme.typography.pxToRem(14),
          lineHeight: theme.typography.pxToRem(18)
        }
      },
      '& .MuiSelect-select': {
        paddingLeft: theme.spacing(1),
        color: theme.palette.colors.white.contrastText
      },
      '& .MuiInput-underline': {
        transition: 'none'
      },
      '& .MuiInput-underline:before': {
        borderWidth: '1px !important'
      },
      '& .MuiInput-underline:after': {
        display: 'none'
      },
      '& .dropdown-form-common-regular': {
        marginTop: theme.spacing(0.5)
      }
    },
    conversationalLabel: _objectSpread2(_objectSpread2({}, theme.typography.conversionFormInput), {}, {
      color: theme.palette.colors.white.contrastTextCaption,
      top: theme.spacing(-3),
      '&.Mui-focused': {
        color: 'inherit'
      }
    }),
    fieldMessageConversational: {
      backgroundColor: '#eaeaea',
      padding: theme.spacing(1),
      borderRadius: '0 5px 5px 5px',
      marginTop: '5px',
      display: 'inline-block',
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: '100%',
        left: 0,
        marginLeft: 0,
        borderWidth: '3px',
        borderStyle: 'solid',
        borderColor: 'transparent transparent #eaeaea #eaeaea'
      }
    },
    dropdownShadow: {
      borderRadius: theme.spacing(0, 0, 0.5, 0.5),
      boxShadow: '0 0 8px 0 rgba(0,0,0,0.24)',
      maxHeight: theme.typography.pxToRem(256),
      marginTop: theme.typography.pxToRem(-6),
      width: 'auto !important',
      selected: {
        '& .showTickIcon': {
          display: 'none'
        },
        '&.MuiMenuItem-root.Mui-selected': {
          '& .showTickIcon': {
            display: 'inline-flex',
            paddingLeft: theme.spacing(1)
          }
        }
      },
      '& .MuiMenu-list': {
        '& .MuiMenuItem-root': {
          minHeight: 'auto'
        }
      }
    },
    selected: {
      '& .showTickIcon': {
        display: 'none'
      },
      '&.MuiMenuItem-root.Mui-selected': {
        '& .showTickIcon': {
          display: 'inline-block',
          textAlign: 'right',
          width: '100%',
          position: 'absolute',
          right: theme.spacing(1),
          '& svg': {
            verticalAlign: 'middle'
          }
        }
      }
    },
    disabledField: {
      opacity: '0.75'
    },
    dropdownShadowRegular: {
      marginTop: theme.spacing(0.125),
      borderRadius: theme.spacing(0, 0, 0.5, 0.5),
      '&.itemType-fund': {
        '& ul li': {
          whiteSpace: 'normal'
        }
      }
    }
  };
};

var useStyles$T = makeStyles(styles$O);

var DropDownList = function DropDownList(props) {
  var _clsx, _clsx2, _clsx3;

  var classes = useStyles$T();

  var _useState = useState(props.defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(props.errors),
      _useState4 = _slicedToArray(_useState3, 2),
      message = _useState4[0],
      setMessage = _useState4[1];

  var _props$color = props.color,
      color = _props$color === void 0 ? 'white' : _props$color,
      _props$hasBorderRadiu = props.hasBorderRadius,
      hasBorderRadius = _props$hasBorderRadiu === void 0 ? true : _props$hasBorderRadiu,
      _props$fixedMenuWidth = props.fixedMenuWidth,
      fixedMenuWidth = _props$fixedMenuWidth === void 0 ? false : _props$fixedMenuWidth,
      _props$onOpen = props.onOpen,
      _onOpen = _props$onOpen === void 0 ? undefined : _props$onOpen,
      _props$onClose = props.onClose,
      _onClose = _props$onClose === void 0 ? undefined : _props$onClose,
      _props$isDisabled = props.isDisabled,
      isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled;

  useEffect(function () {
    if (props.defaultValue && props.itemType === 'fund') {
      setValue(props.defaultValue);
    }
  }, [props.items]); // eslint-disable-line react-hooks/exhaustive-deps

  var handleChange = function handleChange(event) {
    setValue(event.target.value);
    setMessage(value !== undefined ? {} : props.errors);
    setTimeout(function () {
      if (props.itemType === 'DOB') {
        props.onChange(props.name, event.target.value);
      } else if (props.itemType === 'fund') {
        props.onChange(event);
      } else {
        props.onChange();
      }
    }, 0);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FormControl, {
    className: clsx(classes.margin, classes.formControl, 'dropdownList', (_clsx = {}, _defineProperty(_clsx, classes.regularFormInput, props.formtype === 'regular'), _defineProperty(_clsx, classes.disabledField, isDisabled), _defineProperty(_clsx, "forms-".concat(color, "-conversation"), props.formtype === 'conversational'), _clsx))
  }, props.formtype === 'regular' ? /*#__PURE__*/React__default.createElement(InputLabel, {
    "data-testid": "select",
    id: props.label,
    className: clsx(classes.label)
  }, props.label) : /*#__PURE__*/React__default.createElement(InputLabel, {
    "data-testid": "select",
    id: props.label,
    shrink: false,
    className: clsx(classes.label, props.formtype === 'conversational' && classes.conversationalLabel)
  }, value && value.length > 0 ? '' : props.label), /*#__PURE__*/React__default.createElement(Select$1, {
    disabled: isDisabled,
    defaultValue: props.dValue,
    inputProps: props.id ? {
      id: props.id
    } : null,
    "data-locator": props['data-locator'],
    onChange: function onChange(event) {
      return handleChange(event);
    },
    labelId: props.label,
    className: clsx(classes.root, props.className, hasBorderRadius ? getBorderRadius('small') : '', (_clsx2 = {}, _defineProperty(_clsx2, clsx(classes.nonEmptyField, 'nonEmptyField'), value && value.length > 0 && props.formtype === 'regular'), _defineProperty(_clsx2, classes.rootConversational, props.formtype !== 'conversational'), _defineProperty(_clsx2, "dropdown-form-common-conversation dropdown-form-".concat(color, "-conversation"), props.formtype === 'conversational'), _defineProperty(_clsx2, "dropdown-form-common-regular dropdown-form-".concat(color, "-regular"), color && props.formtype === 'regular'), _clsx2)),
    IconComponent: DropdownIcon,
    MenuProps: {
      classes: {
        paper: clsx(classes.dropdownShadow, 'dropdownShadow', "dropdownUl-form-".concat(color), (_clsx3 = {}, _defineProperty(_clsx3, classes.dropdownShadowRegular, props.formtype === 'regular'), _defineProperty(_clsx3, "itemType-".concat(props.itemType), props.itemType), _clsx3))
      },
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      onEnter: fixedMenuWidth ? function () {
        /* ie11 fix, ignoring ie only fixes */

        /* istanbul ignore if */
        if (document.querySelector('.itemType-DOB')) {
          document.querySelector('.itemType-DOB').style.width = document.querySelector('.itemType-DOB').style.minWidth;
        }
      } : null
    },
    value: props.name === 'day' ? props.dayValue : value,
    placeholder: props.placeholder,
    onOpen: function onOpen() {
      setTimeout(function () {
        return disableBodyScroll(document.querySelector('.MuiPopover-root .MuiMenu-paper'));
      }, 200);
      _onOpen && _onOpen();
    },
    onClose: function onClose() {
      enableBodyScroll(document.querySelector('.MuiPopover-root .MuiMenu-paper'));
      _onClose && _onClose();
    }
  }, props.fieldName === apiNames.SELECTEDPAYMENTMODE ? props.items && props.items.map(function (field) {
    return /*#__PURE__*/React__default.createElement(MenuItem$2, {
      className: clsx('icon-action-dropDown-white', 'showTickIcon', classes.selected, classes.menuItems),
      key: field.value,
      value: field.value
    }, field.displayValue, /*#__PURE__*/React__default.createElement("span", {
      className: clsx('icon-action-dropDown-white', 'showTickIcon')
    }, /*#__PURE__*/React__default.createElement(Tick, null)));
  }) : props.items && props.items.map(function (field) {
    return /*#__PURE__*/React__default.createElement(MenuItem$2, {
      className: clsx('icon-action-dropDown-white', 'showTickIcon', classes.selected, classes.menuItems),
      key: props.itemType === 'fund' ? field.key : field.name || field,
      value: props.itemType === 'fund' ? field.key : get$1(field, 'fields.value.value', field) || ''
    }, props.itemType === 'fund' ? field.value : get$1(field, 'fields.value.value', field) || '', /*#__PURE__*/React__default.createElement("span", {
      className: clsx('icon-action-dropDown-white', 'showTickIcon')
    }, /*#__PURE__*/React__default.createElement(Tick, null)));
  })), /*#__PURE__*/React__default.createElement("input", {
    type: 'hidden',
    name: props.name,
    ref: props.register,
    value: props.name === 'day' ? props.dayValue : value
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FieldMessage, {
    name: props.name,
    errors: value !== undefined && value.length > 0 ? message : props.errors,
    formtype: props.formtype
  })), props.hint && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FieldMessage, {
    hint: props.hint,
    formtype: props.formtype
  }))));
};

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var CloseIcon = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Close-Fill",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M23.9998,3.9996 C12.9718,3.9996 3.9998,12.9726 3.9998,23.9996 C3.9998,35.0276 12.9718,43.9996 23.9998,43.9996 C35.0278,43.9996 43.9998,35.0276 43.9998,23.9996 C43.9998,12.9726 35.0278,3.9996 23.9998,3.9996",
  id: "Close-Fill",
  fill: "#000000"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M33.4431,17.3853 L26.8281,23.9993 L33.4431,30.6143 L32.7361,31.3223 C31.5651,32.4933 29.6651,32.4933 28.4931,31.3223 L24.0001,26.8273 L19.5061,31.3223 C18.3351,32.4933 16.4351,32.4933 15.2631,31.3223 L14.5571,30.6143 L21.1721,23.9993 L14.5571,17.3853 L15.2631,16.6783 C16.4351,15.5063 18.3351,15.5063 19.5061,16.6783 L24.0001,21.1713 L28.4931,16.6783 C29.6651,15.5063 31.5651,15.5063 32.7361,16.6783 L33.4431,17.3853 Z",
  id: "Fill-4",
  fill: "#FFFFFF"
}))), 'CloseFilled');

// Give up on IE 11 support for this feature

function stripDiacritics(string) {
  return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}

function defaultStringify(value) {
  if (value == null) {
    return '';
  }

  if (typeof value === 'string') {
    return value;
  }

  if (_typeof(value) === 'object') {
    return Object.keys(value).map(function (key) {
      return value[key];
    }).join(' ');
  }

  return JSON.stringify(value);
}

function createFilterOptions() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$ignoreAccents = config.ignoreAccents,
      ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents,
      _config$ignoreCase = config.ignoreCase,
      ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase,
      _config$matchFrom = config.matchFrom,
      matchFrom = _config$matchFrom === void 0 ? 'any' : _config$matchFrom,
      _config$stringify = config.stringify,
      stringify = _config$stringify === void 0 ? defaultStringify : _config$stringify,
      _config$trim = config.trim,
      trim = _config$trim === void 0 ? false : _config$trim;
  return function (options, _ref) {
    var inputValue = _ref.inputValue;
    var input = trim ? inputValue.trim() : inputValue;

    if (ignoreCase) {
      input = input.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
    }

    return options.filter(function (option) {
      var candidate = stringify(option);

      if (ignoreCase) {
        candidate = candidate.toLowerCase();
      }

      if (ignoreAccents) {
        candidate = stripDiacritics(candidate);
      }

      return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
    });
  };
}
var defaultFilterOptions = createFilterOptions(); // Number of options to jump in list box when pageup and pagedown keys are used.

var pageSize = 5;
function useAutocomplete(props) {
  var _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
      _props$autoHighlight = props.autoHighlight,
      autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
      _props$autoSelect = props.autoSelect,
      autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
      _props$blurOnSelect = props.blurOnSelect,
      blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect,
      _props$clearOnEscape = props.clearOnEscape,
      clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
      _props$debug = props.debug,
      debug = _props$debug === void 0 ? false : _props$debug,
      defaultValue = props.defaultValue,
      _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
      _props$disableCloseOn = props.disableCloseOnSelect,
      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      _props$disableOpenOnF = props.disableOpenOnFocus,
      disableOpenOnFocus = _props$disableOpenOnF === void 0 ? false : _props$disableOpenOnF,
      _props$filterOptions = props.filterOptions,
      filterOptions = _props$filterOptions === void 0 ? defaultFilterOptions : _props$filterOptions,
      _props$filterSelected = props.filterSelectedOptions,
      filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
      _props$freeSolo = props.freeSolo,
      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
      getOptionDisabled = props.getOptionDisabled,
      _props$getOptionLabel = props.getOptionLabel,
      getOptionLabel = _props$getOptionLabel === void 0 ? function (x) {
    return x;
  } : _props$getOptionLabel,
      _props$getOptionSelec = props.getOptionSelected,
      getOptionSelected = _props$getOptionSelec === void 0 ? function (selectedOption, selectedValue) {
    return selectedOption === selectedValue;
  } : _props$getOptionSelec,
      groupBy = props.groupBy,
      idProp = props.id,
      _props$includeInputIn = props.includeInputInList,
      includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
      inputValueProp = props.inputValue,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      onChange = props.onChange,
      onClose = props.onClose,
      onOpen = props.onOpen,
      onInputChange = props.onInputChange,
      openProp = props.open,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      valueProp = props.value,
      inputTitle = props.inputTitle,
      ariaLabel = props.ariaLabel;

  var _React$useState = React__default.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      defaultId = _React$useState2[0],
      setDefaultId = _React$useState2[1];

  var id = idProp || defaultId;
  React__default.useEffect(function () {
    // Fallback to this default id when possible.
    // Use the random value for client-side rendering only.
    // We can't use it server-side.
    setDefaultId("mui-autocomplete-".concat(getRandomValues()));
  }, []);
  var ignoreFocus = React__default.useRef(false);
  var firstFocus = React__default.useRef(true);
  var inputRef = React__default.useRef(null);
  var listboxRef = React__default.useRef(null);

  var _React$useState3 = React__default.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      anchorEl = _React$useState4[0],
      setAnchorEl = _React$useState4[1];

  var _React$useState5 = React__default.useState(-1),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      focusedTag = _React$useState6[0],
      setFocusedTag = _React$useState6[1];

  var defaultHighlighted = autoHighlight ? 0 : -1;
  var highlightedIndexRef = React__default.useRef(defaultHighlighted);
  var selectedIndexRef = React__default.useRef(-1);

  function setHighlightedIndex(index) {
    var mouse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    highlightedIndexRef.current = index; // does the index exist?

    if (index === -1) {
      inputRef.current && inputRef.current.removeAttribute('aria-activedescendant');
    } else {
      inputRef.current && inputRef.current.setAttribute('aria-activedescendant', "".concat(id, "-option-").concat(index));
    }

    if (!listboxRef.current) {
      return;
    }

    var prev = listboxRef.current.querySelector('[data-focus]');

    if (prev) {
      prev.removeAttribute('data-focus');
    }

    var listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"

    if (!listboxNode) {
      return;
    }

    if (index === -1) {
      listboxNode.scrollTop = 0;
      return;
    }

    var option = listboxRef.current.querySelector("[data-option-index=\"".concat(index, "\"]"));

    if (!option) {
      return;
    }

    option.setAttribute('data-focus', 'true'); // Scroll active descendant into view.
    // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
    //
    // Consider this API instead once it has a better browser support:
    // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });

    if (listboxNode.scrollHeight > listboxNode.clientHeight && !mouse) {
      var element = option;
      var scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
      var elementBottom = element.offsetTop + element.offsetHeight;

      if (elementBottom > scrollBottom) {
        listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
      } else if (element.offsetTop < listboxNode.scrollTop) {
        listboxNode.scrollTop = element.offsetTop;
      }
    }
  }

  var _React$useRef = React__default.useRef(valueProp !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState7 = React__default.useState(function () {
    return !isControlled ? defaultValue || (multiple ? [] : null) : null;
  }),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      valueState = _React$useState8[0],
      setValue = _React$useState8[1];

  var value = isControlled ? valueProp : valueState;

  var _React$useRef2 = React__default.useRef(inputValueProp != null),
      isInputValueControlled = _React$useRef2.current;

  var _React$useState9 = React__default.useState(''),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      inputValueState = _React$useState10[0],
      setInputValue = _React$useState10[1];

  var inputValue = isInputValueControlled ? inputValueProp : inputValueState;

  var _React$useState11 = React__default.useState(false),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      focused = _React$useState12[0],
      setFocused = _React$useState12[1];

  var resetInputValue = useEventCallback(function (event, newValue) {
    var newInputValue;

    if (multiple) {
      newInputValue = '';
    } else if (newValue == null) {
      newInputValue = '';
    } else {
      var optionLabel = getOptionLabel(newValue);

      if (process.env.NODE_ENV !== 'production') {
        if (typeof optionLabel !== 'string') {
          console.error(['Material-UI: the `getOptionLabel` method of useAutocomplete do not handle the options correctly.', "The component expect a string but received ".concat(_typeof(optionLabel), "."), "For the input option: ".concat(JSON.stringify(newValue), ", `getOptionLabel` returns: ").concat(newInputValue, ".")].join('\n'));
        }
      }

      newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
    }

    if (inputValue === newInputValue) {
      return;
    }

    setInputValue(newInputValue);

    if (onInputChange) {
      onInputChange(event, newInputValue, 'reset');
    }
  });
  React__default.useEffect(function () {
    resetInputValue(null, value);
  }, [value, resetInputValue]);

  var _React$useRef3 = React__default.useRef(openProp != null),
      isOpenControlled = _React$useRef3.current;

  var _React$useState13 = React__default.useState(false),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      openState = _React$useState14[0],
      setOpenState = _React$useState14[1];

  var open = isOpenControlled ? openProp : openState;
  var inputValueFilter = !multiple && value && inputValue === getOptionLabel(value) ? '' : inputValue;
  var popupOpen = open;
  var filteredOptions = popupOpen ? filterOptions(options.filter(function (option) {
    if (filterSelectedOptions && (multiple ? value : [value]).some(function (value2) {
      return value2 !== null && getOptionSelected(option, value2);
    })) {
      return false;
    }

    return true;
  }), {
    inputValue: inputValueFilter
  }) : [];
  popupOpen = freeSolo && filteredOptions.length === 0 ? false : popupOpen;
  var focusTag = useEventCallback(function (tagToFocus) {
    if (tagToFocus === -1) {
      inputRef.current.focus();
    } else {
      anchorEl.querySelector("[data-tag-index=\"".concat(tagToFocus, "\"]")).focus();
    }
  }); // Ensure the focusedTag is never inconsistent

  React__default.useEffect(function () {
    if (multiple && focusedTag > value.length - 1) {
      setFocusedTag(-1);
      focusTag(-1);
    }
  }, [value, multiple, focusedTag, focusTag]);

  function validOptionIndex(index, direction) {
    if (!listboxRef.current || index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === filteredOptions.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }

      var option = listboxRef.current.querySelector("[data-option-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      if (option && (!option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true')) {
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var changeHighlightedIndex = function changeHighlightedIndex(diff, direction) {
    if (!popupOpen) {
      return;
    }

    var getNextIndex = function getNextIndex() {
      var maxIndex = filteredOptions.length - 1;

      if (diff === 'reset') {
        return defaultHighlighted;
      }

      if (diff === 'start') {
        return 0;
      }

      if (diff === 'end') {
        return maxIndex;
      }

      var newIndex = highlightedIndexRef.current + diff;

      if (newIndex < 0) {
        if (newIndex === -1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) {
          return 0;
        }

        return maxIndex;
      }

      if (newIndex > maxIndex) {
        if (newIndex === maxIndex + 1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap || Math.abs(diff) > 1) {
          return maxIndex;
        }

        return 0;
      }

      return newIndex;
    };

    var nextIndex = validOptionIndex(getNextIndex(), direction);
    setHighlightedIndex(nextIndex);
    selectedIndexRef.current = nextIndex;

    if (autoComplete && diff !== 'reset') {
      if (nextIndex === -1) {
        inputRef.current.value = inputValue;
      } else {
        var option = getOptionLabel(filteredOptions[nextIndex]);
        inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
        // a completion string, appears inline after the input cursor in the textbox.

        var index = option.toLowerCase().indexOf(inputValue.toLowerCase());

        if (index === 0 && inputValue.length > 0) {
          inputRef.current.setSelectionRange(inputValue.length, option.length);
        }
      }
    }
  };

  React__default.useEffect(function () {
    changeHighlightedIndex('reset', 'next');
  }, [inputValue]); // eslint-disable-line react-hooks/exhaustive-deps

  var handleOpen = function handleOpen(event) {
    if (open) {
      return;
    }

    if (onOpen) {
      onOpen(event);
    }

    if (!isOpenControlled) {
      setOpenState(true);
    }
  };

  var handleClose = function handleClose(event) {
    if (!open) {
      return;
    }

    if (onClose) {
      onClose(event);
    }

    if (!isOpenControlled) {
      setOpenState(false);
    }
  };

  var handleValue = function handleValue(event, newValue) {
    if (value === newValue) {
      return;
    }

    if (onChange) {
      onChange(event, newValue);
    }

    if (!isControlled) {
      setValue(newValue);
    }
  };

  var selectNewValue = function selectNewValue(event, newValue) {
    if (multiple) {
      var item = newValue;
      newValue = Array.isArray(value) ? _toConsumableArray(value) : [];
      var itemIndex = -1; // To replace with .findIndex() once we stop IE 11 support.

      for (var i = 0; i < newValue.length; i += 1) {
        if (getOptionSelected(item, newValue[i])) {
          itemIndex = i;
        }
      }

      if (itemIndex === -1) {
        newValue.push(item);
      } else {
        newValue.splice(itemIndex, 1);
      }
    }

    resetInputValue(event, newValue);
    handleValue(event, newValue);

    if (!disableCloseOnSelect) {
      handleClose(event);
    }

    selectedIndexRef.current = -1;
  };

  function validTagIndex(index, direction) {
    if (index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }

      var option = anchorEl.querySelector("[data-tag-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      if (option && (!option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true')) {
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var handleFocusTag = function handleFocusTag(event, direction) {
    if (!multiple) {
      return;
    }

    handleClose(event);
    var nextTag = focusedTag;

    if (focusedTag === -1) {
      if (inputValue === '' && direction === 'previous') {
        nextTag = value.length - 1;
      }
    } else {
      nextTag += direction === 'next' ? 1 : -1;

      if (nextTag < 0) {
        nextTag = 0;
      }

      if (nextTag === value.length) {
        nextTag = -1;
      }
    }

    nextTag = validTagIndex(nextTag, direction);
    setFocusedTag(nextTag);
    focusTag(nextTag);
  };

  var handleClear = function handleClear(event) {
    ignoreFocus.current = true;
    setInputValue('');

    if (onInputChange) {
      onInputChange(event, '', 'clear');
    }

    handleValue(event, multiple ? [] : null);
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (focusedTag !== -1 && ['ArrowLeft', 'ArrowRight'].indexOf(event.key) === -1) {
      setFocusedTag(-1);
      focusTag(-1);
    }

    switch (event.key) {
      case 'Home':
        if (popupOpen) {
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex('start', 'next');
        }

        break;

      case 'End':
        if (popupOpen) {
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex('end', 'previous');
        }

        break;

      case 'PageUp':
        // Prevent scroll of the page
        event.preventDefault();
        changeHighlightedIndex(-pageSize, 'previous');
        handleOpen(event);
        break;

      case 'PageDown':
        // Prevent scroll of the page
        event.preventDefault();
        changeHighlightedIndex(pageSize, 'next');
        handleOpen(event);
        break;

      case 'ArrowDown':
        // Prevent cursor move
        event.preventDefault();
        changeHighlightedIndex(1, 'next');
        handleOpen(event);
        break;

      case 'ArrowUp':
        // Prevent cursor move
        event.preventDefault();
        changeHighlightedIndex(-1, 'previous');
        handleOpen(event);
        break;

      case 'ArrowLeft':
        handleFocusTag(event, 'previous');
        break;

      case 'ArrowRight':
        handleFocusTag(event, 'next');
        break;

      case 'Enter':
        if (highlightedIndexRef.current !== -1 && popupOpen) {
          // We don't want to validate the form.
          event.preventDefault();
          selectNewValue(event, filteredOptions[highlightedIndexRef.current]); // Move the selection to the end.

          if (autoComplete) {
            inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
          }
        } else if (freeSolo && inputValueFilter !== '') {
          selectNewValue(event, inputValue);
        }

        break;

      case 'Escape':
        if (popupOpen) {
          // Avoid Opera to exit fullscreen mode.
          event.preventDefault(); // Avoid the Modal to handle the event.

          event.stopPropagation();
          handleClose(event);
        } else if (clearOnEscape && inputValue !== '') {
          // Avoid Opera to exit fullscreen mode.
          event.preventDefault(); // Avoid the Modal to handle the event.

          event.stopPropagation();
          handleClear(event);
        }

        break;

      case 'Backspace':
        if (multiple && inputValue === '' && value.length > 0) {
          var index = focusedTag === -1 ? value.length - 1 : focusedTag;

          var newValue = _toConsumableArray(value);

          newValue.splice(index, 1);
          handleValue(event, newValue);
        }

        break;
    }
  };

  var handleFocus = function handleFocus(event) {
    setFocused(true);

    if (!disableOpenOnFocus && !ignoreFocus.current) {
      handleOpen(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    setFocused(false);
    firstFocus.current = true;
    ignoreFocus.current = false;

    if (debug && inputValue !== '') {
      return;
    }

    if (autoSelect && selectedIndexRef.current !== -1) {
      handleValue(event, filteredOptions[selectedIndexRef.current]);
    } else if (!freeSolo) {
      resetInputValue(event, value);
    }

    handleClose(event);
  };

  var handleInputChange = function handleInputChange(event) {
    var newValue = event.target.value;

    if (inputValue !== newValue) {
      setInputValue(newValue);

      if (onInputChange) {
        onInputChange(event, newValue, 'input');
      }
    }

    if (newValue === '') {
      if (disableOpenOnFocus) {
        handleClose(event);
      }

      if (!disableClearable && !multiple) {
        handleValue(event, null);
      }
    } else {
      handleOpen(event);
    }
  };

  var handleOptionMouseOver = function handleOptionMouseOver(event) {
    var index = Number(event.currentTarget.getAttribute('data-option-index'));
    setHighlightedIndex(index, 'mouse');
  };

  var isTouch = React__default.useRef(false);

  var handleOptionTouchStart = function handleOptionTouchStart() {
    isTouch.current = true;
  };

  var handleOptionClick = function handleOptionClick(event) {
    var index = Number(event.currentTarget.getAttribute('data-option-index'));
    selectNewValue(event, filteredOptions[index]);

    if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) {
      inputRef.current.blur();
    }

    isTouch.current = false;
  };

  var handleTagDelete = function handleTagDelete(index) {
    return function (event) {
      var newValue = _toConsumableArray(value);

      newValue.splice(index, 1);
      handleValue(event, newValue);
    };
  };

  var handleListboxRef = useEventCallback(function (node) {
    setRef(listboxRef, node);

    if (!node) {
      return;
    } // Restore the focus to the correct option.


    setHighlightedIndex(highlightedIndexRef.current);
  });

  var handlePopupIndicator = function handlePopupIndicator(event) {
    if (open) {
      handleClose(event);
    } else {
      handleOpen(event);
    }
  }; // Prevent input blur when interacting with the combobox


  var handleMouseDown = function handleMouseDown(event) {
    if (event.target.nodeName !== 'INPUT') {
      event.preventDefault();
    }
  }; // Focus the input when first interacting with the combobox


  var handleClick = function handleClick() {
    if (firstFocus.current && inputRef.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
      inputRef.current.focus();
      inputRef.current.select();
    }

    firstFocus.current = false;
  };

  var handleInputMouseDown = function handleInputMouseDown(event) {
    if (inputValue === '' && (!disableOpenOnFocus || inputRef.current === document.activeElement)) {
      handlePopupIndicator(event);
    }
  };

  var dirty = freeSolo && inputValue.length > 0;
  dirty = dirty || (multiple ? value.length > 0 : value !== null);
  var groupedOptions = filteredOptions;

  if (groupBy) {
    groupedOptions = filteredOptions.reduce(function (acc, option, index) {
      var key = groupBy(option);

      if (acc.length > 0 && acc[acc.length - 1].key === key) {
        acc[acc.length - 1].options.push(option);
      } else {
        acc.push({
          key: key,
          index: index,
          options: [option]
        });
      }

      return acc;
    }, []);
  }

  return {
    getRootProps: function getRootProps() {
      return {
        'aria-owns': popupOpen ? "".concat(id, "-popup") : null,
        role: 'combobox',
        'aria-expanded': popupOpen,
        onKeyDown: handleKeyDown,
        onMouseDown: handleMouseDown,
        onClick: handleClick
      };
    },
    getInputLabelProps: function getInputLabelProps() {
      return {
        id: "".concat(id, "-label"),
        htmlFor: id
      };
    },
    getInputProps: function getInputProps() {
      return {
        title: inputTitle,
        id: id,
        value: inputValue,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onChange: handleInputChange,
        onMouseDown: handleInputMouseDown,
        'aria-label': ariaLabel,
        // if open then this is handled imperativeley so don't let react override
        // only have an opinion about this when closed
        'aria-activedescendant': popupOpen ? '' : null,
        'aria-autocomplete': autoComplete ? 'both' : 'list',
        'aria-controls': popupOpen ? "".concat(id, "-popup") : null,
        // Disable browser's suggestion that might overlap with the popup.
        // Handle autocomplete but not autofill.
        autoComplete: 'off',
        ref: inputRef,
        autoCapitalize: 'none',
        spellCheck: 'false'
      };
    },
    getClearProps: function getClearProps() {
      return {
        tabIndex: -1,
        onClick: handleClear
      };
    },
    getPopupIndicatorProps: function getPopupIndicatorProps() {
      return {
        tabIndex: -1,
        onClick: handlePopupIndicator
      };
    },
    getTagProps: function getTagProps(_ref2) {
      var index = _ref2.index;
      return {
        key: index,
        'data-tag-index': index,
        tabIndex: -1,
        onDelete: handleTagDelete(index)
      };
    },
    getListboxProps: function getListboxProps() {
      return {
        role: 'listbox',
        id: "".concat(id, "-popup"),
        'aria-labelledby': "".concat(id, "-label"),
        ref: handleListboxRef,
        onMouseDown: function onMouseDown(event) {
          // Prevent blur
          event.preventDefault();
        }
      };
    },
    getOptionProps: function getOptionProps(_ref3) {
      var index = _ref3.index,
          option = _ref3.option;
      var selected = (multiple ? value : [value]).some(function (value2) {
        return value2 != null && getOptionSelected(option, value2);
      });
      var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
      return {
        key: index,
        tabIndex: -1,
        role: 'option',
        id: "".concat(id, "-option-").concat(index),
        onMouseOver: handleOptionMouseOver,
        onClick: handleOptionClick,
        onTouchStart: handleOptionTouchStart,
        'data-option-index': index,
        'aria-disabled': disabled,
        'aria-selected': selected
      };
    },
    id: id,
    inputValue: inputValue,
    value: value,
    dirty: dirty,
    popupOpen: popupOpen,
    focused: focused || focusedTag !== -1,
    anchorEl: anchorEl,
    setAnchorEl: setAnchorEl,
    focusedTag: focusedTag,
    groupedOptions: groupedOptions
  };
}
useAutocomplete.propTypes = {
  /**
   * If `true`, the portion of the selected suggestion that has not been typed by the user,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   */
  autoComplete: PropTypes.bool,

  /**
   * If `true`, the first option is automatically highlighted.
   */
  autoHighlight: PropTypes.bool,

  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   */
  autoSelect: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   */
  clearOnEscape: PropTypes.bool,

  /**
   * If `true`, the popup will ignore the blur event if the input if filled.
   * You can inspect the popup markup with your browser tools.
   * Consider this option when you need to customize the component.
   */
  debug: PropTypes.bool,

  /**
   * The default input value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the input can't be cleared.
   */
  disableClearable: PropTypes.bool,

  /**
   * If `true`, the popup won't close when a value is selected.
   */
  disableCloseOnSelect: PropTypes.bool,

  /**
   * If `true`, the list box in the popup will not wrap focus.
   */
  disableListWrap: PropTypes.bool,

  /**
   * If `true`, the popup won't open on input focus.
   */
  disableOpenOnFocus: PropTypes.bool,

  /**
   * A filter function that determins the options that are eligible.
   *
   * @param {any} options The options to render.
   * @param {object} state The state of the component.
   * @returns {boolean}
   */
  filterOptions: PropTypes.func,

  /**
   * If `true`, hide the selected options from the list box.
   */
  filterSelectedOptions: PropTypes.bool,

  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   */
  freeSolo: PropTypes.bool,

  /**
   * Used to determine the disabled state for a given option.
   */
  getOptionDisabled: PropTypes.func,

  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   */
  getOptionLabel: PropTypes.func,

  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {any} options The option to group.
   * @returns {string}
   */
  groupBy: PropTypes.func,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,

  /**
   * If `true`, the highlight can move to the input.
   */
  includeInputInList: PropTypes.bool,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the text input value changes.
   *
   * @param {object} event The event source of the callback
   * @param {string} value The new value of the text input
   * @param {string} reason One of "input" (user input) or "reset" (programmatic change)
   */
  onInputChange: PropTypes.func,

  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control the popup` open state.
   */
  open: PropTypes.bool,

  /**
   * Array of options.
   */
  options: PropTypes.array,

  /**
   * The input value.
   */
  value: PropTypes.any
};

var _excluded$3 = ["ChipProps", "classes", "className", "clearText", "closeIcon", "closeText", "defaultValue", "disableClearable", "disabled", "disablePortal", "filterOptions", "forcePopupIcon", "freeSolo", "getOptionDisabled", "getOptionLabel", "getOptionSelected", "groupBy", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onInputChange", "onOpen", "open", "openText", "PaperComponent", "PopperComponent", "popupIcon", "renderGroup", "renderInput", "renderOption", "renderTags", "size"];
var styles$N = function styles(theme) {
  var _option;

  return {
    /* Styles applied to the root element. */

    /* Styles applied to the tag elements, e.g. the chips. */
    tag: {
      margin: 3,
      maxWidth: 'calc(100% - 6px)'
    },

    /* Styles applied to the tag elements, e.g. the chips if `size="small"`. */
    tagSizeSmall: {
      margin: 2,
      maxWidth: 'calc(100% - 4px)'
    },

    /* Styles applied to the Input element. */
    inputRoot: {
      flexWrap: 'wrap',
      paddingRight: 62,
      '& $input': {
        width: 0,
        minWidth: 30
      },
      '&[class*="MuiInput-root"]': {
        paddingBottom: 1,
        '& $input': {
          padding: 4
        },
        '& $input:first-child': {
          padding: '6px 0'
        }
      },
      '&[class*="MuiInput-root"][class*="MuiInput-marginDense"]': {
        '& $input': {
          padding: '4px 4px 5px'
        },
        '& $input:first-child': {
          padding: '3px 0 6px'
        }
      },
      '&[class*="MuiOutlinedInput-root"]': {
        padding: 9,
        paddingRight: 62,
        '& $input': {
          padding: '9.5px 4px'
        },
        '& $input:first-child': {
          paddingLeft: 6
        },
        '& $endAdornment': {
          right: 7
        }
      },
      '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
        padding: 6,
        paddingRight: 62,
        '& $input': {
          padding: '4.5px 4px'
        }
      },
      '&[class*="MuiFilledInput-root"]': {
        paddingTop: 19,
        paddingLeft: 8,
        '& $input': {
          padding: '9px 4px'
        },
        '& $endAdornment': {
          right: 7
        }
      },
      '&[class*="MuiFilledInput-root"][class*="MuiFilledInput-marginDense"]': {
        paddingBottom: 1,
        '& $input': {
          padding: '4.5px 4px'
        }
      },
      '&.MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottomWidth: '1px'
      },
      '&.MuiInput-underline:after': {
        borderBottomWidth: '1px'
      }
    },

    /* Styles applied to the input element. */
    input: {
      flexGrow: 1,
      textOverflow: 'ellipsis',
      opacity: 0
    },

    /* Styles applied to the input element if tag focused. */
    inputFocused: {
      opacity: 1
    },

    /* Styles applied to the endAdornment element. */
    endAdornment: {
      // We use a position absolute to support wrapping tags.
      position: 'absolute',
      right: 0,
      top: 0 // Center vertically

    },

    /* Styles applied to the clear indictator. */
    clearIndicator: {
      marginRight: -2,
      padding: 4,
      color: theme.palette.action.active,
      visibility: 'hidden',
      '& span svg': {
        height: '16px',
        width: '16px'
      },
      '&.MuiIconButton-root:hover': {
        backgroundColor: 'transparent'
      }
    },

    /* Styles applied to the clear indictator if the input is dirty. */
    clearIndicatorDirty: {
      visibility: 'visible'
    },

    /* Styles applied to the popup indictator. */
    popupIndicator: {
      padding: 2,
      marginRight: -2,
      color: theme.palette.action.active,
      '& svg': {
        height: '24px',
        width: '24px'
      }
    },

    /* Styles applied to the popper element. */
    popper: {
      zIndex: theme.zIndex.modal
    },

    /* Styles applied to the popper element if `disablePortal={true}`. */
    popperDisablePortal: {
      position: 'absolute'
    },

    /* Styles applied to the `Paper` component. */
    paper: _objectSpread2(_objectSpread2({}, theme.typography.body1), {}, {
      overflow: 'hidden',
      margin: 0,
      '& > ul': {
        maxHeight: theme.spacing(32),
        overflow: 'auto'
      }
    }),

    /* Styles applied to the `listbox` component. */
    listbox: {
      listStyle: 'none',
      margin: 0,
      padding: '8px 0px',
      position: 'relative'
    },

    /* Styles applied to the loading wrapper. */
    loading: {
      color: theme.palette.text.secondary,
      padding: '14px 16px'
    },

    /* Styles applied to the no option wrapper. */
    noOptions: {
      color: theme.palette.text.secondary,
      padding: '14px 16px'
    },

    /* Styles applied to the option elements. */
    option: (_option = {
      minHeight: 48,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      cursor: 'pointer',
      paddingTop: 8,
      outline: '0',
      WebkitTapHighlightColor: 'transparent',
      paddingBottom: 8,
      paddingLeft: 16,
      paddingRight: 8
    }, _defineProperty(_option, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    }), _defineProperty(_option, '&[aria-selected="true"]', {
      backgroundColor: theme.palette.action.selected
    }), _defineProperty(_option, '&[data-focus="true"]', {
      backgroundColor: theme.palette.colors.orange.main,
      color: theme.palette.colors.white.main
    }), _defineProperty(_option, '&[aria-disabled="true"]', {
      opacity: 0.5,
      pointerEvents: 'none'
    }), _defineProperty(_option, '&:active', {
      backgroundColor: theme.palette.action.selected
    }), _option),

    /* Styles applied to the group's label elements. */
    groupLabel: {
      backgroundColor: theme.palette.background.paper,
      top: -8
    },

    /* Styles applied to the group's ul elements. */
    groupUl: {
      padding: 0
    },
    closeIcon: {
      '& g path': {
        '&:first-child': {
          fill: fwdColors.greyDarker
        },
        '&:nth-child(2)': {
          fill: fwdColors.white
        }
      }
    }
  };
};

function DisablePortal(props) {
  // eslint-disable-next-line react/prop-types
  var other = _extends({}, props);

  return /*#__PURE__*/React__default.createElement("div", other);
}

var Autocomplete = /*#__PURE__*/React__default.forwardRef(function Autocomplete(props, ref) {
  var enableCrossIcon = props.enableCrossIcon || false; // const { t } = useTranslation();

  /* eslint-disable no-unused-vars */

  var ChipProps = props.ChipProps,
      classes = props.classes,
      className = props.className,
      _props$clearText = props.clearText,
      clearText = _props$clearText === void 0 ? 'Clear' : _props$clearText,
      _props$closeIcon = props.closeIcon,
      closeIcon = _props$closeIcon === void 0 ? /*#__PURE__*/React__default.createElement(CloseIcon, {
    fontSize: "small",
    className: classes.closeIcon
  }) : _props$closeIcon,
      _props$closeText = props.closeText,
      closeText = _props$closeText === void 0 ? 'Close' : _props$closeText;
      props.defaultValue;
      var _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal;
      props.filterOptions;
      var _props$forcePopupIcon = props.forcePopupIcon,
      forcePopupIcon = _props$forcePopupIcon === void 0 ? 'auto' : _props$forcePopupIcon,
      _props$freeSolo = props.freeSolo,
      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo;
      props.getOptionDisabled;
      var _props$getOptionLabel = props.getOptionLabel,
      getOptionLabel = _props$getOptionLabel === void 0 ? function (x) {
    return x;
  } : _props$getOptionLabel;
      props.getOptionSelected;
      var groupBy = props.groupBy,
      _props$ListboxCompone = props.ListboxComponent,
      ListboxComponent = _props$ListboxCompone === void 0 ? 'ul' : _props$ListboxCompone,
      ListboxProps = props.ListboxProps,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$loadingText = props.loadingText,
      loadingText = _props$loadingText === void 0 ? 'Loading…' : _props$loadingText,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$noOptionsText = props.noOptionsText,
      noOptionsText = _props$noOptionsText === void 0 ? 'No options' : _props$noOptionsText;
      props.onChange;
      props.onClose;
      props.onInputChange;
      props.onOpen;
      props.open;
      var _props$openText = props.openText,
      openText = _props$openText === void 0 ? 'Open' : _props$openText,
      _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? Paper : _props$PaperComponent,
      _props$PopperComponen = props.PopperComponent,
      PopperComponentProp = _props$PopperComponen === void 0 ? PopperProxy : _props$PopperComponen,
      _props$popupIcon = props.popupIcon,
      popupIcon = _props$popupIcon === void 0 ? /*#__PURE__*/React__default.createElement(DropdownIcon, null) : _props$popupIcon,
      renderGroupProp = props.renderGroup,
      renderInput = props.renderInput,
      renderOptionProp = props.renderOption,
      renderTags = props.renderTags,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = _objectWithoutProperties(props, _excluded$3);
  /* eslint-enable no-unused-vars */


  var PopperComponent = disablePortal ? DisablePortal : PopperComponentProp;

  var _useAutocomplete = useAutocomplete(props),
      getRootProps = _useAutocomplete.getRootProps,
      getInputProps = _useAutocomplete.getInputProps,
      getInputLabelProps = _useAutocomplete.getInputLabelProps,
      getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps,
      getClearProps = _useAutocomplete.getClearProps,
      getTagProps = _useAutocomplete.getTagProps,
      getListboxProps = _useAutocomplete.getListboxProps,
      getOptionProps = _useAutocomplete.getOptionProps,
      value = _useAutocomplete.value,
      dirty = _useAutocomplete.dirty,
      id = _useAutocomplete.id,
      popupOpen = _useAutocomplete.popupOpen,
      focused = _useAutocomplete.focused,
      focusedTag = _useAutocomplete.focusedTag,
      anchorEl = _useAutocomplete.anchorEl,
      setAnchorEl = _useAutocomplete.setAnchorEl,
      inputValue = _useAutocomplete.inputValue,
      groupedOptions = _useAutocomplete.groupedOptions;

  var startAdornment;

  if (multiple && value.length > 0) {
    var getCustomizedTagProps = function getCustomizedTagProps(params) {
      return _objectSpread2({
        className: clsx(classes.tag, _defineProperty({}, classes.tagSizeSmall, size === 'small'))
      }, getTagProps(params));
    };

    if (renderTags) {
      startAdornment = renderTags(value, getCustomizedTagProps);
    } else {
      startAdornment = value.map(function (option, index) {
        return /*#__PURE__*/React__default.createElement(Chip$1, _extends({
          key: index,
          label: getOptionLabel(option),
          size: size
        }, getCustomizedTagProps({
          index: index
        }), ChipProps));
      });
    }
  }

  var defaultRenderGroup = function defaultRenderGroup(params) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: params.key
    }, /*#__PURE__*/React__default.createElement(ListSubheader, {
      className: classes.groupLabel,
      component: "div"
    }, params.key), /*#__PURE__*/React__default.createElement("ul", {
      className: classes.groupUl
    }, params.children));
  };

  var renderGroup = renderGroupProp || defaultRenderGroup;
  var renderOption = renderOptionProp || getOptionLabel;

  var renderListOption = function renderListOption(option, index) {
    var optionProps = getOptionProps({
      option: option,
      index: index
    });
    return /*#__PURE__*/React__default.createElement("li", _extends({}, optionProps, {
      className: classes.option
    }), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      varient: "body1",
      component: "p"
    }, renderOption(option, {
      selected: optionProps['aria-selected'],
      inputValue: inputValue
    })), optionProps['aria-selected'] && /*#__PURE__*/React__default.createElement(Tick, null));
  };

  useEffect(function () {
    if (document.querySelector('.MuiDialog-root') === null) return;

    if (popupOpen) {
      setTimeout(function () {
        return disableBodyScroll(document.querySelector('.MuiAutocomplete-paper .autoDropdown'));
      }, 200);
    } else {
      enableBodyScroll(document.querySelector('.MuiAutocomplete-paper .autoDropdown'));
    }
  }, [popupOpen]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", _extends({
    ref: ref,
    className: clsx(classes.root, _defineProperty({}, classes.focused, focused), className)
  }, getRootProps(), other), renderInput({
    id: id,
    disabled: disabled,
    size: size === 'small' ? 'small' : undefined,
    InputLabelProps: getInputLabelProps(),
    InputProps: {
      ref: setAnchorEl,
      className: classes.inputRoot,
      startAdornment: startAdornment,
      endAdornment: /*#__PURE__*/React__default.createElement("div", {
        className: classes.endAdornment
      }, disableClearable || disabled ? null : /*#__PURE__*/React__default.createElement(IconButton, _extends({}, getClearProps(), {
        "aria-label": clearText,
        title: clearText,
        className: clsx(classes.clearIndicator, _defineProperty({}, classes.clearIndicatorDirty, dirty))
      }), enableCrossIcon && closeIcon), (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false ? /*#__PURE__*/React__default.createElement(IconButton, _extends({}, getPopupIndicatorProps(), {
        disabled: disabled,
        "aria-label": popupOpen ? closeText : openText,
        title: popupOpen ? closeText : openText,
        className: clsx(classes.popupIndicator, _defineProperty({}, classes.popupIndicatorOpen, popupOpen))
      }), popupIcon) : null)
    },
    inputProps: _objectSpread2({
      className: clsx(classes.input, _defineProperty({}, classes.inputFocused, focusedTag === -1)),
      disabled: disabled
    }, getInputProps())
  })), popupOpen && anchorEl ? /*#__PURE__*/React__default.createElement(PopperComponent, {
    className: clsx(classes.popper, _defineProperty({}, classes.popperDisablePortal, disablePortal)),
    style: {
      width: anchorEl ? anchorEl.clientWidth : null
    },
    role: "presentation",
    anchorEl: anchorEl,
    open: true
  }, /*#__PURE__*/React__default.createElement(PaperComponent, {
    className: classes.paper
  }, loading && groupedOptions.length === 0 ? /*#__PURE__*/React__default.createElement("div", {
    className: classes.loading
  }, loadingText) : null, groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/React__default.createElement("div", {
    className: classes.noOptions
  }, noOptionsText) : null, groupedOptions.length > 0 ? /*#__PURE__*/React__default.createElement(ListboxComponent, _extends({
    className: classes.listbox
  }, getListboxProps(), ListboxProps), groupedOptions.map(function (option, index) {
    if (groupBy) {
      return renderGroup({
        key: option.key,
        children: option.options.map(function (option2, index2) {
          return renderListOption(option2, option.index + index2);
        })
      });
    }

    return renderListOption(option, index);
  })) : null)) : null);
});
Autocomplete.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the portion of the selected suggestion that has not been typed by the user,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   */
  autoComplete: PropTypes.bool,

  /**
   * If `true`, the first option is automatically highlighted.
   */
  autoHighlight: PropTypes.bool,

  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   */
  autoSelect: PropTypes.bool,

  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   */
  blurOnSelect: PropTypes.oneOfType([PropTypes.oneOf(['mouse', 'touch']), PropTypes.bool]),

  /**
   * Props applied to the [`Chip`](/api/chip/) element.
   */
  ChipProps: PropTypes.object,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   */
  clearOnEscape: PropTypes.bool,

  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  clearText: PropTypes.string,

  /**
   * The icon to display in place of the default close icon.
   */
  closeIcon: PropTypes.node,

  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  closeText: PropTypes.string,

  /**
   * If `true`, the popup will ignore the blur event if the input if filled.
   * You can inspect the popup markup with your browser tools.
   * Consider this option when you need to customize the component.
   */
  debug: PropTypes.bool,

  /**
   * The default input value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the input can't be cleared.
   */
  disableClearable: PropTypes.bool,

  /**
   * If `true`, the popup won't close when a value is selected.
   */
  disableCloseOnSelect: PropTypes.bool,

  /**
   * If `true`, the input will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the list box in the popup will not wrap focus.
   */
  disableListWrap: PropTypes.bool,

  /**
   * If `true`, the popup won't open on input focus.
   */
  disableOpenOnFocus: PropTypes.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * A filter function that determines the options that are eligible.
   *
   * @param {any[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {any[]}
   */
  filterOptions: PropTypes.func,

  /**
   * If `true`, hide the selected options from the list box.
   */
  filterSelectedOptions: PropTypes.bool,

  /**
   * Force the visibility display of the popup icon.
   */
  forcePopupIcon: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.bool]),

  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   */
  freeSolo: PropTypes.bool,

  /**
   * Used to determine the disabled state for a given option.
   */
  getOptionDisabled: PropTypes.func,

  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   */
  getOptionLabel: PropTypes.func,

  /**
   * Used to determine if an option is selected.
   * Uses strict equality by default.
   */
  getOptionSelected: PropTypes.func,

  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {any} options The option to group.
   * @returns {string}
   */
  groupBy: PropTypes.func,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,

  /**
   * If `true`, the highlight can move to the input.
   */
  includeInputInList: PropTypes.bool,

  /**
   * The input value.
   */
  inputValue: PropTypes.string,

  /**
   * The component used to render the listbox.
   */
  ListboxComponent: PropTypes.elementType,

  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: PropTypes.object,

  /**
   * If `true`, the component is in a loading state.
   */
  loading: PropTypes.bool,

  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  loadingText: PropTypes.node,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  noOptionsText: PropTypes.node,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the input value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {string} value The new value of the text input
   * @param {string} reason Can be: "input" (user input), "reset" (programmatic change), `"clear"`.
   */
  onInputChange: PropTypes.func,

  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control the popup` open state.
   */
  open: PropTypes.bool,

  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  openText: PropTypes.string,

  /**
   * Array of options.
   */
  options: PropTypes.array,

  /**
   * The component used to render the body of the popup.
   */
  PaperComponent: PropTypes.elementType,

  /**
   * The component used to position the popup.
   */
  PopperComponent: PropTypes.elementType,

  /**
   * The icon to display in place of the default popup icon.
   */
  popupIcon: PropTypes.node,

  /**
   * Render the group.
   *
   * @param {any} option The group to render.
   * @returns {ReactNode}
   */
  renderGroup: PropTypes.func,

  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: PropTypes.func.isRequired,

  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {any} option The option to render.
   * @param {object} state The state of the component.
   * @returns {ReactNode}
   */
  renderOption: PropTypes.func,

  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @returns {ReactNode}
   */
  renderTags: PropTypes.func,

  /**
   * The size of the autocomplete.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `getOptionSelected` prop.
   */
  value: PropTypes.any
};
var Autocomplete$1 = withStyles$1(styles$N, {
  name: 'MuiAutocomplete'
})(Autocomplete);

var styles$M = function styles(theme) {
  var _MuiAutocompleteI;

  return {
    formControl: {
      display: 'flex',
      '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottom: "2px solid ".concat(theme.palette.colors.orange.main)
      }
    },
    root: {
      width: '100%',
      maxWidth: '100%',
      height: '40px',
      '.day &': {
        width: '152px'
      },
      '.month &': {
        width: '151px'
      },
      '.year &': {
        width: '200px'
      },
      '& svg': {
        width: theme.spacing(3),
        height: theme.spacing(3),
        '& path': {
          fill: theme.palette.colors.orange.main
        }
      },
      '& .MuiFormControl-root': {
        width: '100%',
        '& .MuiAutocomplete-endAdornment': _defineProperty({
          top: '-2px'
        }, theme.breakpoints.down('md'), {
          top: 0
        })
      },
      '& .MuiAutocomplete-inputRoot': (_MuiAutocompleteI = {
        color: 'orange',
        padding: '5px 24px 5px 0px'
      }, _defineProperty(_MuiAutocompleteI, theme.breakpoints.down('md'), {
        paddingBottom: theme.typography.pxToRem(5)
      }), _defineProperty(_MuiAutocompleteI, '& .MuiInput-input.MuiAutocomplete-input', _defineProperty({
        padding: 0
      }, theme.breakpoints.down('md'), {
        lineHeight: 'normal',
        paddingBottom: theme.typography.pxToRem(2)
      })), _MuiAutocompleteI)
    },
    nonEmptyField: {
      border: '1px solid #000',
      borderRadius: '5px'
    },
    fieldMessage: {
      color: 'red'
    },
    fieldMessageConversational: {
      backgroundColor: '#eaeaea',
      padding: theme.spacing(1),
      borderRadius: '0 5px 5px 5px',
      marginTop: '5px',
      display: 'inline-block',
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: '100%',
        left: 0,
        marginLeft: 0,
        borderWidth: '3px',
        borderStyle: 'solid',
        borderColor: 'transparent transparent #eaeaea #eaeaea'
      }
    },
    'datalist-filled': {
      '& .MuiFormControl-root': {
        '& .MuiInput-underline::before': {
          borderColor: theme.palette.colors.darkGreen.main
        }
      }
    }
  };
};

var useStyles$S = makeStyles(styles$M);

var DataList = function DataList(props) {
  var _clsx;

  var classes = useStyles$S();
  var color = props.color,
      _props$hasBorderRadiu = props.hasBorderRadius,
      hasBorderRadius = _props$hasBorderRadiu === void 0 ? true : _props$hasBorderRadiu;
  var items = props.items || [];
  var defaultKey = items.forEach(function (item) {
    if (props.defaultValue === item.title) {
      return item.key;
    }
  });

  var _useState = useState({
    title: props.defaultValue,
    key: defaultKey
  }),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(props.errors),
      _useState4 = _slicedToArray(_useState3, 2),
      message = _useState4[0],
      setMessage = _useState4[1];

  var _useState5 = useState(defaultKey),
      _useState6 = _slicedToArray(_useState5, 2),
      dataKey = _useState6[0],
      setDataKey = _useState6[1];

  var handleChange = function handleChange(event, newValue) {
    newValue && setValue(newValue);

    if (newValue === null) {
      setValue({
        key: '',
        title: ''
      });
    }

    setMessage(value !== undefined ? {} : props.errors);
    newValue && setDataKey(newValue.key);
    setTimeout(function () {
      props.onChange();
    }, 0);
  };

  return /*#__PURE__*/React__default.createElement(FormControl, {
    className: clsx(classes.margin, classes.formControl)
  }, /*#__PURE__*/React__default.createElement(Autocomplete$1, {
    id: props.id || 'testId',
    className: clsx(classes.root, hasBorderRadius ? getBorderRadius('small') : '', (_clsx = {}, _defineProperty(_clsx, classes['datalist-filled'], value.title), _defineProperty(_clsx, "datalist-common-conversation datalist-".concat(color, "-conversation"), props.formtype === 'conversational'), _defineProperty(_clsx, "datalist-common-regular datalist-".concat(color, "-regular"), color && props.formtype === 'regular'), _clsx)),
    options: items,
    ListboxProps: {
      className: 'autoDropdown'
    },
    "data-locator": props['data-locator'],
    value: value,
    "data-key": dataKey,
    getOptionLabel: function getOptionLabel(option) {
      return option.title;
    },
    errors: props.errors,
    enableCrossIcon: value && value.title && value.title.length > 0,
    onChange: function onChange(event, newValue) {
      return handleChange(event, newValue);
    },
    classes: {
      option: clsx(classes.dropdownShadow, classes["datalistUl-".concat(color)])
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField, _extends({}, params, {
        margin: "normal",
        formtype: props.formtype,
        placeholder: props.formtype === 'conversational' ? props.label : ''
      }));
    }
  }), /*#__PURE__*/React__default.createElement("input", {
    type: 'hidden',
    name: props.name,
    ref: props.register,
    value: value.title
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FieldMessage, {
    name: props.name,
    errors: value && value.length > 0 ? message : props.errors,
    formtype: props.formtype
  })));
};

var styles$L = function styles(theme) {
  var _day, _month, _year;

  return {
    root: {
      display: 'inline-block',
      maxWidth: '100%',
      height: '42px',
      '& .MuiSelect-select.MuiSelect-select': _defineProperty({
        paddingRight: theme.spacing(3.5)
      }, theme.breakpoints.down('md'), {
        paddingRight: theme.spacing(2.5)
      }),
      '& .day': (_day = {
        width: theme.typography.pxToRem(88)
      }, _defineProperty(_day, theme.breakpoints.down('sm'), {
        minWidth: theme.typography.pxToRem(57),
        width: 'auto',
        flex: '1 0 auto'
      }), _defineProperty(_day, '&.chineseDateFormat', _defineProperty({
        width: theme.typography.pxToRem(112)
      }, theme.breakpoints.down('sm'), {
        minWidth: theme.typography.pxToRem(73),
        width: theme.typography.pxToRem(73)
      })), _day),
      '& .month': (_month = {
        width: theme.typography.pxToRem(168)
      }, _defineProperty(_month, theme.breakpoints.down('sm'), {
        minWidth: theme.typography.pxToRem(128),
        width: 'auto',
        flex: '1 0 auto'
      }), _defineProperty(_month, '&.chineseDateFormat', _defineProperty({
        width: theme.typography.pxToRem(128)
      }, theme.breakpoints.down('sm'), {
        minWidth: theme.typography.pxToRem(96),
        width: theme.typography.pxToRem(96)
      })), _month),
      '& .year': (_year = {
        width: theme.typography.pxToRem(112)
      }, _defineProperty(_year, theme.breakpoints.down('sm'), {
        minWidth: theme.typography.pxToRem(71),
        width: 'auto',
        flex: '1 0 auto'
      }), _defineProperty(_year, '&.chineseDateFormat', _defineProperty({
        width: theme.typography.pxToRem(128)
      }, theme.breakpoints.down('sm'), {
        minWidth: theme.typography.pxToRem(96),
        width: theme.typography.pxToRem(96)
      })), _year),
      '& .MuiFormControl-root': {
        width: '100%'
      },
      '& .MuiAutocomplete-inputRoot': {
        padding: '6px 24px 7px 0px',
        '& .MuiInput-input.MuiAutocomplete-input': {
          padding: 0
        }
      },
      '& $dobErrorSection': {
        '& [data-locator=Form-Section-Label-Error]': {
          top: 0,
          marginTop: theme.spacing(1)
        }
      }
    },
    dobHelpText: function dobHelpText(_ref) {
      var bgColor = _ref.bgColor;
      return {
        position: 'absolute',
        width: '100%',
        left: 0,
        color: theme.palette.colors[bgColor].contrastTextCaption
      };
    },
    dobErrorSection: _defineProperty({
      position: 'absolute',
      left: 0,
      width: '100%'
    }, theme.breakpoints.down('sm'), {
      position: 'relative'
    })
  };
};

var useStyles$R = makeStyles(styles$L);

var DateField = function DateField(props) {
  var _props$monthFormat = props.monthFormat,
      monthFormat = _props$monthFormat === void 0 ? '' : _props$monthFormat,
      _props$isHistoricalPr = props.isHistoricalPrice,
      isHistoricalPrice = _props$isHistoricalPr === void 0 ? false : _props$isHistoricalPr,
      _props$isDisabled = props.isDisabled,
      isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
      _props$enablePushEven = props.enablePushEvent,
      enablePushEvent = _props$enablePushEven === void 0 ? false : _props$enablePushEven,
      _props$startYear = props.startYear,
      startYear = _props$startYear === void 0 ? '' : _props$startYear,
      _props$identifier = props.identifier,
      identifier = _props$identifier === void 0 ? '' : _props$identifier,
      _props$fieldLabel = props.fieldLabel,
      fieldLabel = _props$fieldLabel === void 0 ? {} : _props$fieldLabel,
      _props$dictionary = props.dictionary,
      dictionary = _props$dictionary === void 0 ? {
    day: 'Day',
    month: 'Month',
    year: 'Year',
    genericRequiredErrorMessage: 'Please fill in this blank!'
  } : _props$dictionary;
  var bgColor = get$1(props, 'color', 'white');
  var classes = useStyles$R({
    bgColor: bgColor
  }); // const { t } = useTranslation();

  var t = function t(key) {
    return dictionary[key];
  };

  var siteName = props.siteName ? props.siteName : 'fwd-th';
  var siteLanguage = props.siteLanguage ? props.siteLanguage : 'en';
  var dayDefaultValue = '';
  var monthDefaultValue = '';
  var yearDefaultValue = '';
  var dobDefaultValue = '';

  var daysList = _toConsumableArray(Array(31).keys()).map(function (day) {
    return (day + 1).toString();
  });

  if (siteName.toLowerCase() === 'fwd-hk' && siteLanguage === 'zh-HK') {
    daysList = daysList.map(function (day) {
      return "".concat(day).concat(t('day'));
    });
  }

  if (props.defaultValue) {
    dayDefaultValue = props.defaultValue.day;
    monthDefaultValue = props.defaultValue.month;
    yearDefaultValue = props.defaultValue.year;
    dobDefaultValue = props.defaultValue.dob;
  }

  var _useState = useState(dayDefaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      dayValue = _useState2[0],
      setDayValue = _useState2[1];

  var _useState3 = useState(monthDefaultValue),
      _useState4 = _slicedToArray(_useState3, 2),
      monthValue = _useState4[0],
      setMonthValue = _useState4[1];

  var _useState5 = useState(yearDefaultValue),
      _useState6 = _slicedToArray(_useState5, 2),
      yearValue = _useState6[0],
      setYearValue = _useState6[1];

  var _useState7 = useState(dobDefaultValue),
      _useState8 = _slicedToArray(_useState7, 2),
      dobValue = _useState8[0],
      setDobValue = _useState8[1];

  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      ageEligibleFlag = _useState10[0],
      setAgeEligibleFlag = _useState10[1];

  var _useState11 = useState(true),
      _useState12 = _slicedToArray(_useState11, 2),
      ageValidFlag = _useState12[0],
      setAgeValidFlag = _useState12[1];

  var _useState13 = useState(daysList),
      _useState14 = _slicedToArray(_useState13, 2),
      days = _useState14[0],
      setDays = _useState14[1];

  var dataLocators = props.dataLocator ? props.dataLocator : {};
  moment.locale(siteLanguage);
  var months = siteName.toLowerCase() === 'fwd-hk' && siteLanguage === 'zh-HK' || monthFormat === 'numberType' ? _toConsumableArray(Array(12 - 1 + 1)).map(function (_, i) {
    return (1 + i).toString();
  }) : moment.months();

  var yearRange = function yearRange(start, end) {
    /* istanbul ignore else */
    if (siteName.toLowerCase() === 'fwd-th' && siteLanguage === 'th') {
      return _toConsumableArray(Array(end + 543 - (start + 543) + 1)).map(function (_, i) {
        return (start + 543 + i).toString();
      }).reverse();
    } else {
      return _toConsumableArray(Array(end - start + 1)).map(function (_, i) {
        return (start + i).toString();
      }).reverse();
    }
  }; // const years = yearRange(
  //   props.minimumYear ? parseInt(props.minimumYear) : 1970,
  //   new Date().getFullYear()
  // );


  var startRange = startYear ? Number(startYear) : new Date().getFullYear() - 100;
  var years = yearRange(startRange, new Date().getFullYear());

  if (siteName.toLowerCase() === 'fwd-hk' && siteLanguage === 'zh-HK') {
    months = months.map(function (month) {
      return "".concat(month).concat(t('month'));
    });
    years = years.map(function (year) {
      return "".concat(year).concat(t('year'));
    });
  }

  var checkIsLeapYear = function checkIsLeapYear(yearVal) {
    var isLeapYear = null;
    var selectedYear = yearVal ? parseInt(siteLanguage === 'zh-HK' ? yearVal.replace(t('year'), '') : yearVal) : null;

    if (selectedYear) {
      if (siteName.toLowerCase() === 'fwd-th' && siteLanguage === 'th') {
        isLeapYear = selectedYear % 4 === 3 ? true : false;
      } else {
        isLeapYear = selectedYear % 4 === 0 ? true : false;
      }
    }

    return isLeapYear;
  };

  var checkIfMonthIsFebruary = function checkIfMonthIsFebruary(monthVal) {
    var selectedMonth = monthVal ? months.indexOf(monthVal) + 1 : null;
    return selectedMonth === 2 ? true : false;
  };

  var checkIfMonthHas30Days = function checkIfMonthHas30Days(monthVal) {
    var selectedMonth = monthVal ? months.indexOf(monthVal) + 1 : null;
    return selectedMonth === 4 || selectedMonth === 6 || selectedMonth === 9 || selectedMonth === 11 ? true : false;
  };

  var setInitialDayList = function setInitialDayList(dayVal, monthVal, yearVal) {
    var initialDayList = _toConsumableArray(daysList);

    if (dayVal && monthVal && yearVal) {
      if (checkIfMonthIsFebruary(monthVal)) {
        initialDayList = checkIsLeapYear(yearVal) ? daysList.slice(0, -2) : daysList.slice(0, -3);
      } else if (checkIfMonthHas30Days(monthVal)) {
        initialDayList = daysList.slice(0, -1);
      }
    }

    setDays(initialDayList);
  };

  var checkInvalidDate = function checkInvalidDate(dayVal, monthVal, yearVal) {
    var validDayValue = dayVal;
    var dayValueWithoutSymbol = dayVal && siteLanguage === 'zh-HK' ? dayVal.replace(t('day'), '') : dayVal;
    var isMonthFebruary = checkIfMonthIsFebruary(monthVal);
    var isMonthHas30Days = checkIfMonthHas30Days(monthVal);
    var isLeapYear = checkIsLeapYear(yearVal);

    if (dayVal) {
      if (monthVal && yearVal) {
        if (isMonthFebruary) {
          if (isLeapYear) {
            validDayValue = dayValueWithoutSymbol === '30' || dayValueWithoutSymbol === '31' ? daysList[0] : validDayValue;
            setDays(daysList.slice(0, -2));
            setDayValue(validDayValue);
          } else {
            validDayValue = dayValueWithoutSymbol === '29' || dayValueWithoutSymbol === '30' || dayValueWithoutSymbol === '31' ? daysList[0] : validDayValue;
            setDays(daysList.slice(0, -3));
            setDayValue(validDayValue);
          }
        } else if (isMonthHas30Days) {
          validDayValue = dayValueWithoutSymbol === '31' ? daysList[0] : validDayValue;
          setDays(daysList.slice(0, -1));
          setDayValue(validDayValue);
        } else {
          setDays(daysList);
        }
      } else if (monthVal) {
        if (isMonthFebruary) {
          validDayValue = dayValueWithoutSymbol === '30' || dayValueWithoutSymbol === '31' ? daysList[0] : validDayValue;
          setDays(daysList.slice(0, -2));
          setDayValue(validDayValue);
        } else if (isMonthHas30Days) {
          validDayValue = dayValueWithoutSymbol === '31' ? daysList[0] : validDayValue;
          setDays(daysList.slice(0, -1));
          setDayValue(validDayValue);
        } else {
          setDays(daysList);
        }
      }
    } else if (monthVal && yearVal) {
      if (isMonthFebruary) {
        setDays(isLeapYear ? daysList.slice(0, -2) : daysList.slice(0, -3));
      } else if (isMonthHas30Days) {
        setDays(daysList.slice(0, -1));
      } else {
        setDays(daysList);
      }
    } else if (monthVal) {
      if (isMonthFebruary) {
        setDays(daysList.slice(0, -2));
      } else if (isMonthHas30Days) {
        setDays(daysList.slice(0, -1));
      } else {
        setDays(daysList);
      }
    } else {
      setDays(daysList);
    }

    dayValueWithoutSymbol = validDayValue && siteLanguage === 'zh-HK' ? validDayValue.replace(t('day'), '') : dayValueWithoutSymbol;
    return dayValueWithoutSymbol;
  };

  var onChangeHandler = function onChangeHandler(dobFieldType, value) {
    var userBirthDateArray = [];
    var userBirthDateString = '';
    var validAge = true;
    var dayValueNumeric = '';
    var monthValueNumeric = '';
    var validDayValueWithoutSymbol = '';
    var currentValueWithoutSymbol = value && siteLanguage === 'zh-HK' ? value.replace(t(dobFieldType), '') : value;
    var yearValueWithoutSymbol = yearValue && siteLanguage === 'zh-HK' ? yearValue.replace(t('year'), '') : yearValue; // enable push event to push the google analytics

    if (enablePushEvent) {
      var _PushEvent;

      PushEvent((_PushEvent = {
        event: 'dropdownChange',
        buttonTitle: dobFieldType
      }, _defineProperty(_PushEvent, dobFieldType, value), _defineProperty(_PushEvent, "componentName", dataLocators.dropdown), _defineProperty(_PushEvent, "destinationUrl", undefined), _PushEvent));
    }

    switch (dobFieldType) {
      case 'day':
        setDayValue(value);
        dayValueNumeric = value ? daysList.indexOf(value) + 1 : dayValueNumeric;
        /* istanbul ignore else */

        if (dayValueNumeric.toString().length === 1) {
          dayValueNumeric = '0' + dayValueNumeric;
        }

        monthValueNumeric = monthValue ? months.indexOf(monthValue) + 1 : monthValueNumeric;
        /* istanbul ignore else */

        if (monthValueNumeric.toString().length === 1) {
          monthValueNumeric = '0' + monthValueNumeric;
        }

        userBirthDateString = "".concat(yearValueWithoutSymbol, "-").concat(monthValueNumeric, "-").concat(dayValueNumeric);
        userBirthDateArray.push(currentValueWithoutSymbol, monthValue, yearValueWithoutSymbol);
        value && monthValue && yearValue ? setDobValue(userBirthDateString) : setDobValue('');
        break;

      case 'month':
        setMonthValue(value);
        validDayValueWithoutSymbol = checkInvalidDate(dayValue, value, yearValue);
        dayValueNumeric = validDayValueWithoutSymbol.length === 1 ? '0' + validDayValueWithoutSymbol : validDayValueWithoutSymbol;
        monthValueNumeric = value ? months.indexOf(value) + 1 : monthValueNumeric;
        /* istanbul ignore else */

        if (monthValueNumeric.toString().length === 1) {
          monthValueNumeric = '0' + monthValueNumeric;
        }

        userBirthDateString = "".concat(yearValueWithoutSymbol, "-").concat(monthValueNumeric, "-").concat(dayValueNumeric);
        userBirthDateArray.push(validDayValueWithoutSymbol, value, yearValueWithoutSymbol);
        validDayValueWithoutSymbol && value && yearValue ? setDobValue(userBirthDateString) : setDobValue('');
        break;

      case 'year':
        setYearValue(value);
        validDayValueWithoutSymbol = checkInvalidDate(dayValue, monthValue, value);
        dayValueNumeric = validDayValueWithoutSymbol.length === 1 ? '0' + validDayValueWithoutSymbol : validDayValueWithoutSymbol;
        monthValueNumeric = monthValue ? months.indexOf(monthValue) + 1 : monthValueNumeric;

        if (monthValueNumeric.toString().length === 1) {
          monthValueNumeric = '0' + monthValueNumeric;
        }

        userBirthDateString = "".concat(currentValueWithoutSymbol, "-").concat(monthValueNumeric, "-").concat(dayValueNumeric);
        userBirthDateArray.push(validDayValueWithoutSymbol, monthValue, currentValueWithoutSymbol);
        validDayValueWithoutSymbol && monthValue && value ? setDobValue(userBirthDateString) : setDobValue('');
        break;

      default:
        return null;
    }

    var selectedDay = parseInt(userBirthDateArray[0]);
    var selectedMonth = months.indexOf(userBirthDateArray[1]) + 1;
    var selectedYear = parseInt(userBirthDateArray[2]);
    var userBirthDateFormattedValue = "".concat(selectedDay, "/").concat(selectedMonth, "/").concat(selectedYear);
    var userBirthDateISOFormat = "".concat(selectedYear, "-").concat(selectedMonth, "-").concat(selectedDay);

    var checkFutureDateValidation = function checkFutureDateValidation() {
      var today = new Date();
      var currDate = today.getDate();
      var currMonth = today.getMonth() + 1;
      var currYear = siteName.toLowerCase() === 'fwd-th' && siteLanguage === 'th' ? today.getFullYear() + 543 : today.getFullYear();
      var currentDateISOFormat = "".concat(currYear, "-").concat(currMonth, "-").concat(currDate);

      if (new Date(currentDateISOFormat) < new Date(userBirthDateISOFormat)) {
        validAge = false;
        setAgeValidFlag(validAge);
      }

      setAgeValidFlag(validAge);
    };

    if (userBirthDateArray[0] && userBirthDateArray[1] && userBirthDateArray[2]) {
      checkFutureDateValidation();
    }

    var age = '';

    if (validAge) {
      age = calculateAge(userBirthDateFormattedValue);

      if (props.productAgeRange && (age < parseInt(props.productAgeRange.productMinAge) || age > parseInt(props.productAgeRange.productMaxAge))) {
        setAgeEligibleFlag(false);
      } else {
        setAgeEligibleFlag(true);
        props.clearError([props.name]);
      }
    }

    props.onChangeHandler();
  };

  var calculateAge = function calculateAge(birth) {
    var today = new Date();
    var currDate = today.getDate();
    var currMonth = today.getMonth() + 1;
    var currYear = siteName.toLowerCase() === 'fwd-th' && siteLanguage === 'th' ? today.getFullYear() + 543 : today.getFullYear();
    var birthDateArray = birth.split('/');
    var birthDate = birthDateArray[0];
    var birthMonth = birthDateArray[1];
    var birthYear = birthDateArray[2];
    /* istanbul ignore else */

    if (currMonth === parseInt(birthMonth) && currDate >= parseInt(birthDate)) return parseInt(currYear - birthYear);
    /* istanbul ignore else */

    if (currMonth === parseInt(birthMonth) && currDate < parseInt(birthDate)) return parseInt(currYear - birthYear - 1);
    /* istanbul ignore else */

    if (currMonth > parseInt(birthMonth)) return parseInt(currYear - birthYear);
    /* istanbul ignore else */

    if (currMonth < parseInt(birthMonth)) return parseInt(currYear - birthYear - 1);
  };

  useEffect(function () {
    setInitialDayList(dayDefaultValue, monthDefaultValue, yearDefaultValue);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var dayFieldTemplate = /*#__PURE__*/React__default.createElement(FormGroup, {
    className: clsx('inline', 'day', _defineProperty({}, 'chineseDateFormat', siteLanguage === 'zh-HK')),
    "data-locator": dataLocators.dropdown
  }, /*#__PURE__*/React__default.createElement(DropDownList, {
    fixedMenuWidth: true,
    id: isHistoricalPrice ? "days-".concat(identifier) : 'days',
    formtype: props.formtype,
    register: props.register,
    label: get$1(fieldLabel, 'day', '') || t('day'),
    name: 'day',
    items: days,
    itemType: 'DOB',
    isDisabled: isDisabled,
    displayEmpty: true,
    defaultValue: dayDefaultValue,
    dValue: dayDefaultValue,
    color: props.color,
    placeholder: get$1(fieldLabel, 'day', '') || t('day'),
    isHistoricalPrice: isHistoricalPrice,
    onChange: function onChange(dobFieldType, value) {
      onChangeHandler(dobFieldType, value);
    },
    dayValue: dayValue
  }));
  var monthFieldTemplate = /*#__PURE__*/React__default.createElement(FormGroup, {
    className: clsx('inline', 'month', _defineProperty({}, 'chineseDateFormat', siteLanguage === 'zh-HK')),
    "data-locator": dataLocators.dropdown
  }, /*#__PURE__*/React__default.createElement(DropDownList, {
    fixedMenuWidth: true,
    id: isHistoricalPrice ? "months-".concat(identifier) : 'months',
    formtype: props.formtype,
    register: props.register,
    label: get$1(fieldLabel, 'month', '') || t('month'),
    name: 'month',
    items: months,
    itemType: 'DOB',
    isDisabled: isDisabled,
    color: props.color,
    displayEmpty: true,
    defaultValue: monthDefaultValue,
    dValue: monthDefaultValue,
    placeholder: get$1(fieldLabel, 'month', '') || t('month'),
    isHistoricalPrice: isHistoricalPrice,
    onChange: function onChange(dobFieldType, value) {
      onChangeHandler(dobFieldType, value);
    }
  }));
  var yearFieldTemplate = /*#__PURE__*/React__default.createElement(FormGroup, {
    className: clsx('inline', 'year', _defineProperty({}, 'chineseDateFormat', siteLanguage === 'zh-HK')),
    "data-locator": dataLocators.dropdown
  }, /*#__PURE__*/React__default.createElement(DropDownList, {
    fixedMenuWidth: true,
    id: isHistoricalPrice ? "years-".concat(identifier) : 'years',
    formtype: props.formtype,
    register: props.register,
    label: get$1(fieldLabel, 'year', '') || t('year'),
    name: 'year',
    items: years,
    itemType: 'DOB',
    isDisabled: isDisabled,
    color: props.color,
    displayEmpty: true,
    defaultValue: yearDefaultValue,
    dValue: yearDefaultValue,
    placeholder: get$1(fieldLabel, 'year', '') || t('year'),
    isHistoricalPrice: isHistoricalPrice,
    onChange: function onChange(dobFieldType, value) {
      onChangeHandler(dobFieldType, value);
    }
  }));
  return /*#__PURE__*/React__default.createElement(FormControl, {
    className: clsx(classes.root, 'dateField'),
    "data-locator": dataLocators.dob
  }, siteLanguage !== 'zh-HK' ? dayFieldTemplate : yearFieldTemplate, monthFieldTemplate, siteLanguage !== 'zh-HK' ? yearFieldTemplate : dayFieldTemplate, props.dobHelpText && !props.errors[props.name] && /*#__PURE__*/React__default.createElement("div", {
    className: classes.dobHelpText
  }, /*#__PURE__*/React__default.createElement(FieldMessage, {
    hint: props.dobHelpText,
    formtype: props.formtype
  })), /*#__PURE__*/React__default.createElement("input", {
    type: 'hidden',
    name: props.name,
    ref: props.register && props.register({
      required: {
        value: true,
        message: t('genericRequiredErrorMessage')
      },
      validate: {
        invalidAge: function invalidAge() {
          return ageValidFlag || props.errorMessages.generalError;
        },
        ageNotEligible: function ageNotEligible() {
          return ageEligibleFlag || props.errorMessages.specificError;
        }
      }
    }),
    value: dobValue
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classes.dobErrorSection
  }, /*#__PURE__*/React__default.createElement(FieldMessage, {
    name: props.name,
    errors: props.errors,
    formtype: props.formtype
  })));
};

var CALLBACKFORM_PAGE_WRAPPER$1 = 'Form-Page-Wrapper';
var CALLBACKFORM_FORMVALUE_LIST$1 = 'Form-FormValue-List';
var CALLBACKFORM_PAGE_UPWORD_ARROW = 'Form-Page-Upword-Arrow';
var FORM_SECTION_LABEL$1 = 'Form-Section-Label';
var FORM_SECTION_INPUTBOX$1 = 'Form-Section-InputBox';
var FORM_SECTION_RADIOBOX$1 = 'Form-Section-RadioBox';
var FORM_SECTION_BUTTON$1 = 'Form-Section-Button';
var FORM_SECTION_CHECKBOX$1 = 'Form-Section-Checkbox';
var FORM_SECTION_DROPDOWN$1 = 'Form-Section-Dropdown';
var FORM_DOB_WRAPPER$1 = 'Form-Dob-Wrapper';
var PRODUCT_MIN_AGE$1 = 'Form-Dob-HelpText-Product-Min-Age';
var PRODUCT_MAX_AGE$1 = 'Form-Dob-HelpText-Product-Max-Age';
var FORM_SECTION_FORM_TYPE = 'Form-Section-Form-Type';
var FORM_SECTION_TOOLTIP$1 = 'Form-Section-Tooltip';
var FORM_SECTION_DATALIST$1 = 'Form-Section-DataList';

var config = {
  "sitecoreApiKey": "{D7333054-1DCE-4B0C-A9A5-AC7372A796AB}",
  "sitecoreApiHost": "http://localhost:7000",
  "jssAppName": "fwd-hk",
  "siteCode": "hk",
  "defaultLanguage": "en"
};
var getDomain = function getDomain() {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  } else return '';
};
var removeTag = function removeTag(str) {
  if (typeof str === 'string') {
    if (!isEmpty(str)) return str.replace(/(<([^>]+)>)/gi, '');
  }
};
var generatelayoutServicePath = function generatelayoutServicePath(item, lang, customConfig) {
  var sitecoreApiHost = config.sitecoreApiHost,
      sitecoreApiKey = config.sitecoreApiKey;

  if (customConfig.sitecoreApiHost) {
    sitecoreApiHost = customConfig.sitecoreApiHost;
  }

  if (customConfig.sitecoreApiKey) {
    sitecoreApiKey = customConfig.sitecoreApiKey;
  }

  if (typeof window !== 'undefined' && window.isGatsby) {
    return item;
  } else {
    var regex = new RegExp("/".concat(lang, "/"));
    item = item.replace(regex, '/');
    return "".concat(sitecoreApiHost, "/sitecore/api/layout/render/jss?item=").concat(item, "&sc_lang=").concat(lang, "&sc_apikey=").concat(sitecoreApiKey);
  }
};
var getFieldType = function getFieldType(fieldUrl) {
  return fieldUrl && fieldUrl.substring(fieldUrl.lastIndexOf('/') + 1);
};
var getPayloadData = function getPayloadData(data) {
  if (!isEmpty(data)) {
    return {
      user: {
        profile: {
          contact: {
            email: _objectSpread2({}, data.email)
          }
        },
        lead: _objectSpread2({}, data.lead)
      }
    };
  }

  return null;
}; // Ex: To get plan card index from query params of URL

var getQueryParams = function getQueryParams(queryParam, url) {
  //this expression is to get the query strings
  var reg = new RegExp('[?&]' + queryParam + '=([^&#]*)', 'i');
  var queryString = reg.exec(url);
  return queryString ? parseInt(queryString[1]) : undefined;
};

var FieldRenderer$1 = function FieldRenderer(props) {
  // const { t } = useTranslation();
  var fieldItem = props.fieldItem,
      isShowNext = props.isShowNext,
      data = props.data;

  var dictionary = _objectSpread2({
    genericRequiredErrorMessage: 'Please fill in this blank!',
    minLengthErrorMessage: '{this} should have minimum {minValue} characters',
    maxLengthErrorMessage: '{this} should have minimum {maxValue} characters'
  }, get$1(props, "dictionary", {}));

  var t = function t(key) {
    return dictionary[key];
  };

  var isSubmitDisable = props.data ? data.isSubmitDisable : false;
  var backgroundColor = props.data ? data.backgroundColor : 'white';
  var formAPIValues = props.data ? data.formAPIPayload.data : {};
  var enterKeyInfo = props.enterKeyInfo ? props.enterKeyInfo : 'or, press enter to continue';
  var fieldTypeURL = getFieldType(get$1(fieldItem, 'fields[Field Type].url', ''));
  var regEx = get$1(fieldItem, 'fields.Validations[0].fields.Parameters.value', '');
  var validationErrorMsg = get$1(fieldItem, 'fields.Validations[0].fields.Message.value', 'error');
  var requiredValidationRule = {
    required: get$1(fieldItem, 'fields["Required"].value', null) === true ? t('genericRequiredErrorMessage') : null
  };
  var minLengthValidationRule = {
    minLength: {
      value: get$1(fieldItem, 'fields["Min Length"].value', null),
      message: t('minLengthErrorMessage').replace('{this}', "".concat(get$1(fieldItem, 'displayName', ''))).replace('{minValue}', "".concat(get$1(fieldItem, 'fields["Min Length"].value', '')))
    }
  };
  var maxLengthValidationRule = {
    maxLength: {
      value: get$1(fieldItem, 'fields["Max Length"].value', null),
      message: t('maxLengthErrorMessage').replace('{this}', "".concat(get$1(fieldItem, 'displayName', ''))).replace('{maxValue}', "".concat(get$1(fieldItem, 'fields["Max Length"].value', '')))
    }
  };
  var patternValidationRule = {
    pattern: {
      value: new RegExp(regEx.substring(1, regEx.length - 1)),
      message: validationErrorMsg
    }
  };
  var fieldClassName = get$1(fieldItem, 'fields["Css Class"].value', '');

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      radioChecked = _useState2[0],
      setRadioChecked = _useState2[1];

  if ([SingleLineTextType, MultiLineTextType].includes(fieldTypeURL)) {
    var defaultValue = props.pageValue ? props.pageValue[fieldItem.fields['Field Key'].value].value : undefined;

    var validationRules = _objectSpread2({}, requiredValidationRule);
    /* istanbul ignore else */


    if (fieldItem.fields['Min Length'].value > 0) {
      validationRules = _objectSpread2(_objectSpread2({}, validationRules), minLengthValidationRule);
    }
    /* istanbul ignore else */


    if (fieldItem.fields['Max Length'].value > 0) {
      validationRules = _objectSpread2(_objectSpread2({}, validationRules), maxLengthValidationRule);
    }

    return fieldClassName.indexOf('hide') === -1 && /*#__PURE__*/React__default.createElement(FormGroup, {
      key: fieldItem.id,
      className: clsx(fieldClassName, {
        multilineFieldWithValue: MultiLineTextType === fieldTypeURL && isShowNext
      })
    }, /*#__PURE__*/React__default.createElement(InputField, {
      multiline: MultiLineTextType === fieldTypeURL,
      "data-locator": FORM_SECTION_INPUTBOX$1,
      label: props.formtype === 'regular' ? fieldItem.fields.Title.value : null,
      placeholder: props.formtype === 'conversational' ? fieldItem.fields['Placeholder Text'].value : '',
      margin: "normal",
      color: backgroundColor,
      name: fieldItem.fields['Field Key'].value,
      inputProps: {
        type: 'text'
      },
      inputRef: props.register(_objectSpread2({}, validationRules)),
      formtype: props.formtype,
      errors: props.errors,
      defaultValue: fieldClassName.indexOf('disabled') !== -1 ? fieldItem.fields['Default Value'].value : defaultValue // eslint-disable-next-line react/jsx-no-duplicate-props
      ,
      InputProps: fieldClassName.indexOf('disabled') !== -1 ? {
        readOnly: true
      } : {},
      onChange: function onChange() {
        props.handleOnFormValueChange();
      },
      hasDummyText: fieldClassName.includes('countryCodeInput'),
      dummyTextSource: 'callback'
    }));
  } else if (fieldTypeURL === TextType) {
    var descriptionValue = fieldItem.fields.Text.value;

    for (var ApiName in formAPIValues) {
      descriptionValue = descriptionValue.replace("{".concat(ApiName, "}"), formAPIValues[ApiName]);
    }

    var textlable = {
      value: descriptionValue
    };
    return /*#__PURE__*/React__default.createElement(FormGroup, {
      key: fieldItem.id,
      className: fieldClassName
    }, /*#__PURE__*/React__default.createElement("label", {
      className: 'fieldlabel',
      "data-locator": FORM_SECTION_LABEL$1
    }, /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: textlable.value
      }
    })), /*#__PURE__*/React__default.createElement(FieldMessage, {
      name: props.name,
      hint: props.fieldItem.fields.HelpText.value,
      errors: props.errors,
      formtype: props.formtype,
      color: backgroundColor
    }));
  } else if (fieldTypeURL === RadioListType) {
    var _validationRules = _objectSpread2({}, requiredValidationRule);

    var _defaultValue = props.pageValue ? props.pageValue[fieldItem.fields['Field Key'].value].value : undefined;
    /* istanbul ignore else */


    if (_defaultValue !== '') {
      _validationRules[fieldItem.fields['Field Key'].value] = _defaultValue;

      if (_defaultValue !== radioChecked && radioChecked === '') {
        setRadioChecked(_defaultValue);
      }
    }

    return /*#__PURE__*/React__default.createElement("span", {
      "data-locator": FORM_SECTION_RADIOBOX$1
    }, /*#__PURE__*/React__default.createElement(RadioButtonGroup, {
      label: fieldItem.displayName,
      name: fieldItem.fields['Field Key'].value,
      errors: props.errors,
      formtype: props.formtype,
      className: fieldClassName,
      defaultValue: _defaultValue,
      color: backgroundColor
    }, fieldItem.items.map(function (radioField) {
      return /*#__PURE__*/React__default.createElement(RadioButton, {
        key: radioField.displayName,
        value: radioField.fields.value.value,
        label: radioField.displayName,
        color: backgroundColor,
        formtype: props.formtype,
        defaultValue: _defaultValue,
        name: fieldItem.fields['Field Key'].value,
        register: props.register(_objectSpread2({}, _validationRules)),
        checked: radioChecked === radioField.fields.value.value,
        onChange: function onChange(evt, val) {
          props.handleOnFormValueChange(evt.target.name, val);
          setRadioChecked(val);
        }
      });
    })));
  } else if (fieldTypeURL === CheckBox$1) {
    var _validationRules2 = _objectSpread2({}, requiredValidationRule);

    var _defaultValue2 = props.pageValue ? get$1(props, 'pageValue[fieldItem.fields["Field Key"].value].value', false) : false;

    var registerFunction = get$1(fieldItem, 'fields["Required"].value', false) === true && get$1(fieldItem, 'fields.isHidden.value', true) === false ? props.register(_objectSpread2({}, _validationRules2)) : null;
    return /*#__PURE__*/React__default.createElement(FormGroup, {
      key: fieldItem.id,
      className: clsx(fieldClassName, 'CheckboxWrapper', {
        activeCheckbox: isShowNext
      }),
      "data-locator": FORM_SECTION_CHECKBOX$1
    }, fieldItem.items.map(function (field) {
      return /*#__PURE__*/React__default.createElement(CheckBox, {
        key: field.displayName,
        value: field.fields.value.value,
        defaultChecked: _defaultValue2,
        label: field.fields.value,
        name: fieldItem.fields['Field Key'].value,
        formtype: props.formtype,
        register: registerFunction,
        errors: props.errors,
        color: backgroundColor,
        onChange: function onChange() {
          props.handleOnFormValueChange();
        }
      });
    }));
  } else if (fieldTypeURL === DropDown) {
    var _defaultValue3 = props.pageValue ? props.pageValue[fieldItem.fields['Field Key'].value].value : '';

    var _validationRules3 = _objectSpread2({}, requiredValidationRule);

    var autoSuggest = get$1(fieldItem, 'fields[isAutoSuggest].value', false) || false;
    var dropDownlist = fieldItem.items;
    var defaultSelection = '';
    var defaultSelectionID = get$1(fieldItem, 'fields["Default Selection"].value', '');
    /* istanbul ignore else */

    if (defaultSelectionID && !autoSuggest) {
      var defaultSelectionItem = dropDownlist.find(function (item) {
        return item.id.toLowerCase() === defaultSelectionID.replace(/{|}/g, '').toLowerCase();
      });
      defaultSelection = get$1(defaultSelectionItem, 'fields.value.value', '');
    }

    var cityList = [];
    /* istanbul ignore else */

    if (autoSuggest) {
      dropDownlist.map(function (item) {
        return cityList.push({
          key: get$1(item, 'fields.key.value', ''),
          title: get$1(item, 'fields.value.value', null)
        });
      });
    }

    var fieldBox = autoSuggest ? /*#__PURE__*/React__default.createElement(DataList, {
      id: fieldItem.id,
      errors: props.errors,
      formtype: props.formtype,
      color: backgroundColor,
      register: props.register(_objectSpread2({}, _validationRules3)),
      label: fieldItem.fields['Title'].value,
      name: fieldItem.fields['Field Key'].value,
      items: cityList,
      displayEmpty: true,
      defaultValue: _defaultValue3,
      placeholder: fieldItem.fields['Title'].value,
      "data-locator": FORM_SECTION_DATALIST$1,
      onChange: function onChange() {
        props.handleOnFormValueChange('DataList');
      }
    }) : /*#__PURE__*/React__default.createElement(DropDownList, {
      errors: props.errors,
      formtype: props.formtype,
      color: backgroundColor,
      register: props.register(_objectSpread2({}, _validationRules3)),
      label: fieldItem.fields['Title'].value,
      name: fieldItem.fields['Field Key'].value,
      items: dropDownlist,
      displayEmpty: true,
      defaultValue: _defaultValue3 || defaultSelection,
      placeholder: fieldItem.fields['Title'].value,
      "data-locator": FORM_SECTION_DROPDOWN$1,
      onChange: function onChange() {
        props.handleOnFormValueChange();
      }
    });
    return /*#__PURE__*/React__default.createElement(FormGroup, {
      className: fieldClassName
    }, fieldBox);
  } else if (fieldTypeURL === DateType) {
    var _defaultValue4 = props.pageValue['day'] ? {
      day: props.pageValue['day'].value,
      month: props.pageValue['month'].value,
      year: props.pageValue['year'].value,
      dob: props.pageValue['dob'].value
    } : '';

    var errorMessages = {};
    var productAgeRangeArray = [];
    var defaultProductAgeRange = {
      productMinAge: 0,
      productMaxAge: 200
    };
    var productAgeRange = get$1(props, 'rangeItem.productAgeRange', defaultProductAgeRange) || defaultProductAgeRange;
    var productMinAge = get$1(props, 'rangeItem.productAgeRange.productMinAge', 0) || 0;
    var productMaxAge = get$1(props, 'rangeItem.productAgeRange.productMaxAge', 200) || 200;
    var dobHelpText = fieldItem.fields['HelpText'].value ? fieldItem.fields['HelpText'].value : null;
    /* istanbul ignore else */

    if (dobHelpText) {
      dobHelpText = dobHelpText.replace('{minAge}', "<span data-locator=".concat(PRODUCT_MIN_AGE$1, ">").concat(props.rangeItem.productAgeRange.productMinAge, "</span>"));
      dobHelpText = dobHelpText.replace('{maxAge}', "<span data-locator=".concat(PRODUCT_MAX_AGE$1, ">").concat(props.rangeItem.productAgeRange.productMaxAge, "</span>"));
    }

    errorMessages = {
      specificError: fieldItem.fields['SpecificError'].value,
      generalError: fieldItem.fields['GeneralError'].value
    };
    productAgeRangeArray.push(parseInt(productMinAge), parseInt(productMaxAge));
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DateField, {
      register: props.register,
      errors: props.errors,
      setError: props.setError,
      clearError: props.clearError,
      color: backgroundColor,
      errorMessages: errorMessages,
      minimumYear: fieldItem.fields['minimumYear'].value,
      fieldItem: fieldItem,
      defaultValue: _defaultValue4,
      name: 'dob',
      formtype: props.formtype,
      dataLocator: {
        dropdown: FORM_SECTION_DROPDOWN$1,
        dob: FORM_DOB_WRAPPER$1
      },
      onChangeHandler: function onChangeHandler() {
        props.handleOnFormValueChange();
      },
      siteName: props.siteName,
      siteLanguage: props.siteLanguage,
      productAgeRange: productAgeRange,
      dobHelpText: dobHelpText,
      productAgeRangeArray: productAgeRangeArray
    }));
  } else if (fieldTypeURL === TelephoneType) {
    var _validationRules4 = _objectSpread2(_objectSpread2({}, requiredValidationRule), patternValidationRule);
    /* istanbul ignore else */


    if (fieldItem.fields['Min Length'].value > 0) {
      _validationRules4 = _objectSpread2(_objectSpread2({}, _validationRules4), {}, {
        minLength: {
          value: fieldItem.fields['Min Length'].value,
          message: validationErrorMsg
        }
      });
    }
    /* istanbul ignore else */


    if (fieldItem.fields['Max Length'].value > 0) {
      _validationRules4 = _objectSpread2(_objectSpread2({}, _validationRules4), {}, {
        maxLength: {
          value: fieldItem.fields['Max Length'].value + 1,
          message: validationErrorMsg
        }
      });
    }

    var _defaultValue5 = props.pageValue ? props.pageValue[fieldItem.fields['Field Key'].value].value : undefined;

    var dialInCodeLength = get$1(fieldItem, 'fields["dialInCodeLength"].fields.value.value', '');
    return /*#__PURE__*/React__default.createElement(FormGroup, {
      className: fieldClassName
    }, /*#__PURE__*/React__default.createElement(MaskInputField, _extends({
      id: fieldItem.id,
      label: fieldItem.fields.Title.value,
      name: fieldItem.fields['Field Key'].value,
      margin: "normal",
      inputProps: {
        type: 'tel'
      },
      formtype: props.formtype,
      color: backgroundColor,
      inputRef: props.register(_objectSpread2({}, _validationRules4)),
      errors: props.errors,
      placeholder: props.formtype === 'conversational' ? fieldItem.fields['Placeholder Text'].value : '',
      "data-locator": FORM_SECTION_INPUTBOX$1,
      defaultValue: _defaultValue5,
      onChange: function onChange() {
        props.handleOnFormValueChange();
      },
      triggerValidation: props.triggerValidation
    }, fieldItem.fields['Min Length'].value > 0 && {
      minLength: fieldItem.fields['Min Length'].value
    }, fieldItem.fields['Max Length'].value > 0 && {
      maxLength: fieldItem.fields['Max Length'].value
    }, {
      dialInCodeLength: dialInCodeLength
    })));
  } else if (fieldTypeURL === EmailType) {
    var _validationRules5 = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, requiredValidationRule), patternValidationRule), minLengthValidationRule), maxLengthValidationRule);

    var _defaultValue6 = props.pageValue ? props.pageValue[fieldItem.fields['Field Key'].value].value : undefined;

    return /*#__PURE__*/React__default.createElement(FormGroup, {
      className: fieldClassName
    }, /*#__PURE__*/React__default.createElement(InputField, {
      id: fieldItem.id,
      label: fieldItem.fields.Title.value,
      name: fieldItem.fields['Field Key'].value,
      margin: "normal",
      inputProps: {
        type: 'text'
      },
      color: backgroundColor,
      formtype: props.formtype,
      inputRef: props.register(_objectSpread2({}, _validationRules5)),
      errors: props.errors,
      placeholder: props.formtype === 'conversational' ? fieldItem.fields['Placeholder Text'].value : '',
      "data-locator": FORM_SECTION_INPUTBOX$1,
      defaultValue: _defaultValue6,
      onChange: function onChange() {
        props.handleOnFormValueChange();
      }
    }));
  } else if (fieldTypeURL === SubmitType) {
    var items = fieldItem.items;
    var PageID = null;
    var buttonType = '';
    var parameter = null;
    var btnTypeURLs = [];
    var emailTemplate = '';
    var apiToQuery = '';
    /* istanbul ignore else */

    if (items && items.length > 0) {
      items.forEach(function (param) {
        var btnTypeURL = getFieldType(get$1(param, 'fields["Submit Action"].url', null));

        try {
          parameter = JSON.parse(get$1(param, 'fields.Parameters.value', null));
          PageID = parameter.referenceId.replace('{', '').replace('}', '').toLowerCase();
        } catch (err) {
          parameter = null;
        }

        btnTypeURLs.push(btnTypeURL);
      });
    }

    if (btnTypeURLs.some(function (btnType) {
      return btnType === CustomAction;
    })) {
      buttonType = 'submit';
      emailTemplate = get$1(fieldItem, 'fields.emailTemplateLink.value', '');
      apiToQuery = API.CUSTOM_ACTION;
    } else if (btnTypeURLs.some(function (btnType) {
      return btnType === SendEmail;
    })) {
      buttonType = 'submit';
      emailTemplate = get$1(fieldItem, 'fields.emailTemplateLink.value', '');
      apiToQuery = API.SEND_EMAIL;
    } else if (btnTypeURLs.some(function (btnType) {
      return btnType === SaveButton;
    }) || fieldClassName.indexOf('submitButton') !== -1) {
      buttonType = 'submit';
      emailTemplate = get$1(fieldItem, 'fields.emailTemplateLink.value', '');
      apiToQuery = API.SAVE_LEAD;
    } else if (fieldClassName.indexOf('back-to-home') !== -1 || fieldClassName.indexOf('back_to_home') !== -1) {
      buttonType = 'backHome';
    } else {
      buttonType = 'next';
    }

    return /*#__PURE__*/React__default.createElement(FormGroup, {
      key: fieldItem.id,
      className: clsx([fieldClassName, 'formNextButton'], isShowNext || !isSubmitDisable ? 'activeButton' : '')
    }, /*#__PURE__*/React__default.createElement(Box, {
      display: "flex",
      mt: 12,
      className: "formButtonBox"
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
      color: backgroundColor,
      outlined: buttonType === 'submit' || props.mode === 'dark' ? false : true,
      variant: 'secondary',
      alt: fieldItem.fields.Title.value,
      onClick: function onClick() {
        return props.onNextClick(buttonType, PageID, emailTemplate, apiToQuery);
      },
      "data-locator": FORM_SECTION_BUTTON$1,
      disabled: isSubmitDisable && buttonType === 'submit' ? true : false,
      type: buttonType === 'submit' ? buttonType : 'button'
    }, fieldItem.fields.Title.value), fieldClassName.indexOf('next-button') !== -1 && /*#__PURE__*/React__default.createElement("div", {
      className: 'enterKeyIconBox'
    }, enterKeyInfo)));
  } else if (fieldTypeURL === ToolTip) {
    return props.fieldItem.fields.toolTipText.value && /*#__PURE__*/React__default.createElement("div", {
      className: 'toolTipWrapper',
      "data-locator": FORM_SECTION_TOOLTIP$1
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "body3",
      component: "span"
    }, props.fieldItem.fields.label.value), /*#__PURE__*/React__default.createElement(FwdTooltip, {
      className: fieldClassName,
      color: backgroundColor,
      title: props.fieldItem.fields.toolTipText.value
    }, /*#__PURE__*/React__default.createElement("span", {
      style: {
        marginLeft: '4px',
        verticalAlign: 'middle'
      }
    }, /*#__PURE__*/React__default.createElement(QuestionMark, null))));
  } else {
    return null;
  }
};

var SectionRenderer$1 = function SectionRenderer(props) {
  var watchers = props.watchers,
      actionItems = props.actionItems,
      evalCondition = props.evalCondition,
      bgColor = props.bgColor,
      cssClass = props.cssClass;
  return /*#__PURE__*/React__default.createElement(Box, {
    className: clsx('sectionWrapper', "bgText-color-".concat(bgColor), {
      consentSection: cssClass === 'consentSection',
      consentSectionActive: cssClass === 'consentSection' && props.isShowNext
    })
  }, props.items && props.items.map(function (item, index) {
    var isHidden = get$1(item, 'fields.isHidden.value', false) || false;
    var fieldKey = get$1(item, 'fields[Field Key].value', '');

    if (!isHidden) {
      if (actionItems && actionItems[fieldKey]) {
        if (watchers[actionItems[fieldKey].depends] === actionItems[fieldKey].value) {
          return /*#__PURE__*/React__default.createElement(FieldRenderer$1, {
            key: index,
            fieldItem: item,
            register: props.register,
            onNextClick: props.onNextClick,
            errors: props.errors,
            formtype: props.formtype,
            enterKeyInfo: props.enterKeyInfo,
            pageValue: props.pageValue ? props.pageValue : undefined,
            isShowNext: props.isShowNext,
            setIsShowNext: props.setIsShowNext,
            mode: props.mode,
            data: props.data,
            clearError: props.clearError,
            handleOnFormValueChange: props.handleOnFormValueChange,
            evalCondition: evalCondition,
            siteName: props.siteName,
            siteLanguage: props.siteLanguage,
            triggerValidation: props.triggerValidation,
            dictionary: props.dictionary
          });
        } else {
          return null;
        }
      } else {
        return /*#__PURE__*/React__default.createElement(FieldRenderer$1, {
          key: index,
          fieldItem: item,
          register: props.register,
          onNextClick: props.onNextClick,
          errors: props.errors,
          formtype: props.formtype,
          enterKeyInfo: props.enterKeyInfo,
          pageValue: props.pageValue ? props.pageValue : undefined,
          isShowNext: props.isShowNext,
          setIsShowNext: props.setIsShowNext,
          mode: props.mode,
          data: props.data,
          clearError: props.clearError,
          handleOnFormValueChange: props.handleOnFormValueChange,
          evalCondition: evalCondition,
          siteName: props.siteName,
          siteLanguage: props.siteLanguage,
          triggerValidation: props.triggerValidation,
          dictionary: props.dictionary
        });
      }
    } else return null;
  }));
};

var PageRenderer$1 = function PageRenderer(props) {
  var actionItems = props.actionItems,
      evalCondition = props.evalCondition;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'formPageRender'
  }, props.items && props.items.map(function (item, index) {
    var backgroundColor = get$1(item, 'fields.backgroundColor.fields.value.value', null) || null;
    var bgColor = backgroundColor ? getColors(backgroundColor).bgColor : null;
    var isHidden = get$1(item, 'fields.isHidden.value', false) || false;
    var fieldKey = get$1(item, 'fields[Field Key].value', '') || '';
    var fieldType = get$1(item, 'fields[Field Type].url', '') || '';
    fieldType = getFieldType(fieldType);

    if (!isHidden) {
      if (fieldType === SectionType) {
        if (actionItems[fieldKey]) {
          if (evalCondition(actionItems, fieldKey)) {
            return /*#__PURE__*/React__default.createElement(SectionRenderer$1, {
              items: item.items,
              bgColor: bgColor,
              cssClass: get$1(item, 'fields["Css Class"].value', ''),
              displayName: item.displayName,
              register: props.register,
              key: item.id,
              watchers: props.watchers,
              actionItems: props.actionItems,
              activePage: props.activePage,
              onNextClick: props.onNextClick,
              errors: props.errors,
              formtype: props.formtype,
              clearError: props.clearError,
              enterKeyInfo: props.enterKeyInfo,
              pageValue: props.pageValue ? props.pageValue : undefined,
              isShowNext: props.isShowNext,
              setIsShowNext: props.setIsShowNext,
              mode: props.mode,
              data: props.data,
              handleOnFormValueChange: props.handleOnFormValueChange,
              evalCondition: evalCondition,
              siteName: props.siteName,
              siteLanguage: props.siteLanguage,
              triggerValidation: props.triggerValidation,
              dictionary: props.dictionary
            });
          } else {
            return null;
          }
        } else {
          return /*#__PURE__*/React__default.createElement(SectionRenderer$1, {
            items: item.items,
            bgColor: bgColor,
            cssClass: get$1(item, 'fields["Css Class"].value', ''),
            displayName: item.displayName,
            register: props.register,
            key: item.id,
            watchers: props.watchers,
            actionItems: props.actionItems,
            activePage: props.activePage,
            onNextClick: props.onNextClick,
            clearError: props.clearError,
            errors: props.errors,
            formtype: props.formtype,
            enterKeyInfo: props.enterKeyInfo,
            pageValue: props.pageValue ? props.pageValue : undefined,
            isShowNext: props.isShowNext,
            setIsShowNext: props.setIsShowNext,
            mode: props.mode,
            data: props.data,
            handleOnFormValueChange: props.handleOnFormValueChange,
            evalCondition: evalCondition,
            siteName: props.siteName,
            siteLanguage: props.siteLanguage,
            triggerValidation: props.triggerValidation,
            dictionary: props.dictionary
          });
        }
      }

      if (actionItems[fieldKey]) {
        if (evalCondition(actionItems, fieldKey)) {
          return /*#__PURE__*/React__default.createElement(FieldRenderer$1, {
            key: index,
            fieldItem: item,
            register: props.register,
            onNextClick: props.onNextClick,
            errors: props.errors,
            formtype: props.formtype,
            clearError: props.clearError,
            enterKeyInfo: props.enterKeyInfo,
            pageValue: props.pageValue ? props.pageValue : undefined,
            isShowNext: props.isShowNext,
            setIsShowNext: props.setIsShowNext,
            mode: props.mode,
            data: props.data,
            handleOnFormValueChange: props.handleOnFormValueChange,
            evalCondition: evalCondition,
            siteName: props.siteName,
            siteLanguage: props.siteLanguage,
            triggerValidation: props.triggerValidation,
            dictionary: props.dictionary
          });
        } else {
          return null;
        }
      } else {
        return /*#__PURE__*/React__default.createElement(FieldRenderer$1, {
          key: index,
          fieldItem: item,
          register: props.register,
          onNextClick: props.onNextClick,
          errors: props.errors,
          formtype: props.formtype,
          enterKeyInfo: props.enterKeyInfo,
          clearError: props.clearError,
          pageValue: props.pageValue ? props.pageValue : undefined,
          isShowNext: props.isShowNext,
          setIsShowNext: props.setIsShowNext,
          mode: props.mode,
          data: props.data,
          handleOnFormValueChange: props.handleOnFormValueChange,
          evalCondition: evalCondition,
          siteName: props.siteName,
          siteLanguage: props.siteLanguage,
          triggerValidation: props.triggerValidation,
          dictionary: props.dictionary
        });
      }
    } else return null;
  }));
};

var style$a = function style(theme) {
  var _form, _formContainerList, _namePageFormPage, _namePageFormPage2, _dobPageFormPageR3, _consentSection, _activeInputList;

  var primaryColor = get$1(theme, 'palette.primary.color', 'black') || 'black';
  var colors = theme.palette.colors || {};
  var backgrounds = {};
  Object.keys(colors).forEach(function (color) {
    backgrounds["bgcolor-".concat(color)] = {
      backgroundColor: colors[color].main
    };
  });
  return _objectSpread2(_objectSpread2({}, backgrounds), {}, {
    dialog: {
      '& .MuiDialog-closeButtonWrap': {
        height: '0'
      }
    },
    form: (_form = {
      height: '100vh'
    }, _defineProperty(_form, theme.breakpoints.down('sm'), {
      height: '85vh'
    }), _defineProperty(_form, '& > .MuiGrid-container', {
      height: '100%'
    }), _defineProperty(_form, '& .nonSplashScreen', {
      width: '100%',
      maxWidth: '600px',
      display: 'block',
      alignItems: 'initial'
    }), _defineProperty(_form, '& .nonSplashScreen .formTypeBright', _defineProperty({
      paddingTop: theme.typography.pxToRem(126),
      color: theme.palette.colors.white.contrastTextCaption
    }, theme.breakpoints.down('md'), {
      paddingLeft: 0,
      paddingTop: theme.typography.pxToRem(85)
    })), _defineProperty(_form, '& .nonSplashScreen #ulElm', {
      position: 'absolute'
    }), _form),
    root: _defineProperty({
      paddingTop: theme.spacing(12),
      paddingBottom: theme.spacing(12)
    }, theme.breakpoints.down('md'), {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8)
    }),
    callBackFormDialog: {
      '& .MuiDialog-paper': {
        transition: 'all 0.5s'
      },
      '& .MuiContainer-root': _defineProperty({}, theme.breakpoints.down('md'), {
        maxWidth: '100%'
      }),
      '& ::placeholder': {
        color: theme.palette.colors.white.contrastTextCaption,
        opacity: 1
      },
      '& .MuiDialog-closeButton': {
        zIndex: '110',
        color: theme.palette.colors.white.line.textFieldDefault
      },
      '& .MuiDialog-paper .MuiGrid-grid-lg-6': _defineProperty({
        maxWidth: theme.typography.pxToRem(612),
        flexBasis: theme.typography.pxToRem(612)
      }, theme.breakpoints.down('md'), {
        maxWidth: theme.typography.pxToRem(375),
        flexBasis: theme.typography.pxToRem(375)
      })
    },
    formInnerWrapper: {
      width: '100%',
      maxWidth: theme.typography.pxToRem(600),
      position: 'relative',
      opacity: 0
    },
    formType: _objectSpread2({
      fontWeight: theme.typography.fontWeights.bolder,
      paddingTop: theme.spacing(12),
      paddingLeft: theme.typography.pxToRem(6),
      lineHeight: theme.typography.pxToRem(20)
    }, theme.typography.body5),
    upwordArrowBox: _defineProperty({
      paddingTop: theme.typography.pxToRem(28),
      paddingBottom: theme.typography.pxToRem(44),
      textAlign: 'center',
      position: 'fixed',
      top: 0,
      width: '100%',
      left: 0,
      cursor: 'pointer',
      height: theme.spacing(9),
      zIndex: 101,
      background: theme.palette.colors.white.main
    }, theme.breakpoints.down('md'), {
      height: theme.spacing(5),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(2)
    }),
    upwordArrowIcon: {
      display: 'inline-block',
      height: theme.spacing(2),
      color: primaryColor,
      '& svg': {
        '& path': {
          fill: primaryColor
        }
      }
    },
    formContainerList: (_formContainerList = {
      height: '100%',
      listStyle: 'none',
      marginTop: 0,
      padding: theme.spacing(0, 4),
      marginLeft: theme.typography.pxToRem(6),
      marginRight: theme.typography.pxToRem(6),
      marginBottom: 0
    }, _defineProperty(_formContainerList, theme.breakpoints.down('md'), {
      margin: 0,
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(2)
    }), _defineProperty(_formContainerList, "position", 'absolute'), _defineProperty(_formContainerList, "margin", 0), _defineProperty(_formContainerList, "width", '100%'), _formContainerList),
    upwordArrowGradient: _defineProperty({
      height: theme.spacing(9),
      width: '100%',
      background: 'linear-gradient(180deg, #FFFFFF 0%, rgba(255,255,255,0) 100%)',
      position: 'fixed',
      top: theme.spacing(9),
      left: 0,
      zIndex: 101
    }, theme.breakpoints.down('md'), {
      height: theme.spacing(5),
      top: theme.spacing(5)
    }),
    saveLeadForm: {
      opacity: 1
    },
    unFilledList: {
      position: 'relative',
      width: 0,
      height: theme.spacing(3),
      '&>div': {
        display: 'inline-block'
      },
      '&.splashScreenPage': {
        display: 'none'
      },
      '&:before': {
        content: '" "',
        height: theme.spacing(1),
        width: theme.spacing(1),
        position: 'absolute',
        background: 'transparent',
        left: theme.typography.pxToRem(-28),
        top: theme.typography.pxToRem(8),
        borderRadius: '50%',
        border: "1px solid ".concat(fwdColors.greyDarker)
      },
      '&.conditionalPage': {
        display: 'none'
      }
    },
    haveChild: {
      opacity: 1
    },
    filledList: {
      position: 'relative',
      cursor: 'pointer',
      marginTop: theme.spacing(1),
      '&:before': {
        content: '" "',
        height: theme.spacing(1),
        width: theme.spacing(1),
        position: 'absolute',
        background: primaryColor,
        left: theme.typography.pxToRem(-28),
        top: theme.typography.pxToRem(8),
        borderRadius: '50%'
      },
      '&$haveChild:before': {
        background: 'transparent',
        borderRadius: '50%',
        border: "1px solid ".concat(fwdColors.greyDarker)
      },
      '&.conditionalPage:before': {
        background: 'transparent'
      }
    },
    formTypeLabel: {
      position: 'absolute'
    },
    enquiryTag: {
      transition: 'transform 0.8s'
    },
    modalBackgroundColor: {
      '& .MuiDialog-closeButton:hover:before': {
        opacity: '0.2',
        backgroundColor: theme.palette.colors.white.main
      },
      '& .formTypeBright': {
        maxWidth: theme.typography.pxToRem(328)
      },
      '& .phoneBookAnAgentThankYouPage.formTypeBright ': {
        display: 'none'
      },
      '& .SplashScreen,& .nonSplashScreen': {
        display: 'flex',
        alignItems: 'center'
      },
      '& .SplashScreen .formTypeBright': _defineProperty({
        paddingLeft: theme.typography.pxToRem(6),
        paddingTop: 0
      }, theme.breakpoints.down('md'), {
        paddingLeft: 0
      }),
      '& .SplashScreen #ulElm,& .nonSplashScreen #ulElm': {
        top: 'auto !important',
        position: 'relative !important',
        padding: 0
      },
      '& #li0': _defineProperty({
        paddingTop: theme.spacing(6),
        paddingBottom: 0
      }, theme.breakpoints.down('md'), {
        paddingTop: theme.spacing(3)
      }),
      '& li:before': {
        display: 'none'
      },
      '& li:not(.activeList),& .SplashScreen#formElmItem li:not(.activeList)': {
        display: 'none'
      },
      '& $formContainerList li:before': {
        display: 'none'
      },
      '& $formContainerList li:not(.activeList).filledList': {
        display: 'none'
      },
      '& .unwordArrowWrapper': {
        display: 'none'
      },
      '& ul[data-locator="Form-Page-Wrapper"]': {
        marginTop: '0',
        marginBottom: '0',
        padding: 0
      },
      '& .splashScreenDisclaimer': _defineProperty({
        paddingTop: theme.spacing(3)
      }, theme.breakpoints.down('md'), {
        paddingTop: 0
      }),
      '& [data-locator="Form-FormValue-List"].activeList .listIcon': {
        display: 'none'
      },
      '& .formPageRender .fieldlabel': {
        color: theme.palette.colors.white.main + ' !important'
      },
      '& .activeList .formPageRender  .formButtonBox': _defineProperty({
        marginTop: theme.spacing(8)
      }, theme.breakpoints.down('md'), {
        marginTop: theme.spacing(6)
      }),
      '& .activeList.splashScreenPage .formPageRender  .formButtonBox': _defineProperty({
        marginTop: theme.spacing(8)
      }, theme.breakpoints.down('md'), {
        marginTop: theme.spacing(6)
      }),
      '& .activeList .formPageRender .MuiFormGroup-root:nth-child(1) .fieldlabel': {
        fontSize: theme.typography.T3,
        lineHeight: theme.typography.lineHeight.L3,
        fontWeight: theme.typography.fontWeights.bolder
      },
      '& .activeList .formPageRender .MuiFormGroup-root:nth-child(2) .fieldlabel': _defineProperty({
        fontSize: theme.typography.body1.fontSize,
        lineHeight: theme.typography.body1.lineHeight
      }, theme.breakpoints.down('md'), _objectSpread2({
        paddingTop: theme.spacing(3)
      }, theme.typography.body3)),
      '& .activeList.phoneSubmitPage .formPageRender .sectionWrapper .fieldlabel': _defineProperty({
        fontWeight: theme.typography.fontWeights.normal,
        fontSize: theme.typography.body1.fontSize,
        lineHeight: theme.typography.body1.lineHeight
      }, theme.breakpoints.down('md'), _objectSpread2({}, theme.typography.body3)),
      '& .MuiDialog-closeButton svg path': {
        fill: theme.palette.colors.white.main
      }
    },
    formLabel: {
      color: theme.palette.colors.white.line.textFieldDefault
    },
    formLabelNull: {
      width: 0
    },
    formFilledValue: {
      fontWeight: theme.typography.fontWeights.bolder
    },
    activeInputList: (_activeInputList = {
      position: 'relative',
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(8)
    }, _defineProperty(_activeInputList, theme.breakpoints.down('md'), {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(6)
    }), _defineProperty(_activeInputList, '& [data-locator=Form-Section-RadioBox] .allBorderRadiusSmall', {
      borderRadius: theme.spacing(0.5)
    }), _defineProperty(_activeInputList, '& [data-locator=Form-Section-Label-Error]', _defineProperty({
      position: 'absolute',
      marginTop: theme.spacing(1),
      top: theme.typography.pxToRem(46)
    }, theme.breakpoints.down('md'), {
      position: 'relative',
      top: 0
    })), _defineProperty(_activeInputList, '& [data-locator="Form-Section-Checkbox"] [data-locator=Form-Section-Label-Error]', {
      position: 'relative',
      top: 0
    }), _defineProperty(_activeInputList, '&.splashScreenPage', _defineProperty({}, theme.breakpoints.down('md'), {
      paddingTop: theme.spacing(1)
    })), _defineProperty(_activeInputList, '&.commentsPage, &.namePage, &.emailPage, &.phonePage, &.taskPage, &.preferredContactModePage', {
      '& [data-locator=Form-Section-Label-Error]': {
        marginTop: theme.spacing(1),
        position: 'relative',
        top: 0
      }
    }), _defineProperty(_activeInputList, '&.interestedPage .formPageRender [role="radiogroup"],&.preferredContactModePage .formPageRender [role="radiogroup"]', _defineProperty({
      width: 'calc(100% + 8px)',
      margin: theme.spacing(2.5, -0.5, 0, -0.5)
    }, theme.breakpoints.down('md'), {
      marginTop: theme.spacing(1.5)
    })), _defineProperty(_activeInputList, '&.interestedPage .formPageRender [role="radiogroup"] .MuiTypography-radioButton, &.preferredContactModePage .formPageRender [role="radiogroup"] .MuiTypography-radioButton', {
      width: '50%',
      '& .MuiFormControlLabel-root': {
        width: "calc(100% - ".concat(theme.spacing(1), "px)")
      }
    }), _defineProperty(_activeInputList, '& .formPageRender .formButtonBox', _defineProperty({
      marginTop: theme.spacing(8),
      textAlign: 'center',
      animation: animations.fadeIn
    }, theme.breakpoints.down('md'), {
      marginTop: theme.spacing(6)
    })), _defineProperty(_activeInputList, '&.interestedPage .formPageRender .formButtonBox', _defineProperty({
      marginTop: theme.spacing(7.5),
      textAlign: 'center'
    }, theme.breakpoints.down('md'), {
      marginTop: theme.spacing(5.5)
    })), _defineProperty(_activeInputList, '& .formPageRender .formButtonBox .enterKeyIconBox', _objectSpread2(_objectSpread2({}, theme.typography.body3), {}, _defineProperty({
      color: theme.palette.colors.white.contrastTextCaption,
      lineHeight: theme.typography.pxToRem(16),
      paddingTop: theme.spacing(1)
    }, theme.breakpoints.down('md'), {
      display: 'none'
    }))), _defineProperty(_activeInputList, '& .formPageRender [class*="submit:"] .formButtonBox', _defineProperty({
      marginTop: theme.spacing(8)
    }, theme.breakpoints.down('md'), {
      marginTop: theme.spacing(3)
    })), _defineProperty(_activeInputList, '& .formPageRender .MuiFormGroup-root', {
      position: 'relative'
    }), _defineProperty(_activeInputList, '& .formPageRender .MuiFormGroup-root[role="radiogroup"]', {
      display: 'flex',
      '& .MuiTypography-radioButton .MuiFormControlLabel-root': {
        height: 'calc(100% - 8px)',
        minHeight: theme.spacing(10)
      }
    }), _defineProperty(_activeInputList, '&.taskPage .formPageRender [role="radiogroup"]', {
      width: 'calc(100% + 8px)'
    }), _defineProperty(_activeInputList, '&.subTaskPage .formPageRender [role="radiogroup"]', _defineProperty({
      width: 'calc(100% + 8px)',
      margin: theme.spacing(2.5, -0.5, 0, -0.5)
    }, theme.breakpoints.down('md'), {
      marginTop: theme.spacing(1.5)
    })), _defineProperty(_activeInputList, '&.subTaskPage .formPageRender [role="radiogroup"] .MuiTypography-radioButton .MuiFormControlLabel-root', _defineProperty({
      width: '173px'
    }, theme.breakpoints.down('md'), {
      width: theme.typography.pxToRem(132)
    })), _defineProperty(_activeInputList, '&.subTaskPage .formPageRender [class*=makeStyles-fieldMessageConversational-]', {
      top: '0px',
      position: 'relative'
    }), _defineProperty(_activeInputList, '&.subTaskPage .formPageRender .formButtonBox', _defineProperty({
      marginTop: theme.spacing(7.5),
      textAlign: 'center'
    }, theme.breakpoints.down('md'), {
      marginTop: theme.spacing(5.5)
    })), _defineProperty(_activeInputList, '&.namePage .formPageRender .MuiTextField-root', {
      width: theme.spacing(30)
    }), _defineProperty(_activeInputList, '&.namePage .formPageRender .MuiFormGroup-root:nth-child(2)', (_namePageFormPage = {
      paddingRight: theme.spacing(2)
    }, _defineProperty(_namePageFormPage, theme.breakpoints.up('md'), {
      maxWidth: theme.spacing(32)
    }), _defineProperty(_namePageFormPage, theme.breakpoints.down('md'), {
      paddingRight: theme.spacing(0),
      width: theme.typography.pxToRem(237)
    }), _namePageFormPage)), _defineProperty(_activeInputList, '&.namePage .formPageRender .MuiFormGroup-root:nth-child(3)', (_namePageFormPage2 = {
      paddingRight: 0
    }, _defineProperty(_namePageFormPage2, theme.breakpoints.up('md'), {
      maxWidth: theme.spacing(29.5)
    }), _defineProperty(_namePageFormPage2, theme.breakpoints.down('md'), {
      width: theme.typography.pxToRem(272)
    }), _namePageFormPage2)), _defineProperty(_activeInputList, '&.namePage .formPageRender .MuiFormGroup-root:nth-child(3) .MuiFormControl-root', _defineProperty({}, theme.breakpoints.down('md'), {
      width: theme.typography.pxToRem(272)
    })), _defineProperty(_activeInputList, '&.dobPage .formPageRender [data-locator="Form-Dob-Wrapper"]', _defineProperty({
      width: '100%'
    }, theme.breakpoints.down('md'), {
      position: 'relative'
    })), _defineProperty(_activeInputList, '&.dobPage .formPageRender [data-locator="Form-Dob-Wrapper"]>div:not(.MuiFormGroup-root)', _defineProperty({
      position: 'absolute',
      width: '100%',
      left: 0,
      marginTop: theme.spacing(0.5)
    }, theme.breakpoints.down('md'), {
      position: 'relative',
      marginTop: 0
    })), _defineProperty(_activeInputList, '&.dobPage .formPageRender [data-locator="Form-Dob-Wrapper"] .day', (_dobPageFormPageR3 = {
      marginRight: theme.spacing(2),
      paddingRight: 0
    }, _defineProperty(_dobPageFormPageR3, theme.breakpoints.down('md'), {
      marginRight: theme.spacing(0.5)
    }), _defineProperty(_dobPageFormPageR3, '&.chineseDateFormat', {
      marginRight: 0
    }), _dobPageFormPageR3)), _defineProperty(_activeInputList, '&.dobPage .formPageRender [data-locator="Form-Dob-Wrapper"] .month', _defineProperty({
      marginRight: theme.spacing(2),
      paddingRight: 0
    }, theme.breakpoints.down('md'), {
      marginRight: theme.spacing(0.5)
    })), _defineProperty(_activeInputList, '&.dobPage .formPageRender [data-locator="Form-Dob-Wrapper"] .year', {
      marginRight: 0,
      paddingRight: 0,
      '&.chineseDateFormat': _defineProperty({
        marginRight: theme.spacing(2)
      }, theme.breakpoints.down('md'), {
        marginRight: theme.spacing(0.5)
      })
    }), _defineProperty(_activeInputList, '&.dobPage .formPageRender [data-locator="Form-Dob-Wrapper"] label + .MuiInput-formControl', {
      marginTop: 0
    }), _defineProperty(_activeInputList, '&.dobPage .formPageRender [data-locator="Form-Dob-Wrapper"] label', {
      top: theme.spacing(-3)
    }), _defineProperty(_activeInputList, '&.dobPage .formPageRender [data-locator="Form-Section-Tooltip"],&.provincePage .formPageRender [data-locator="Form-Section-Tooltip"]', _defineProperty({}, theme.breakpoints.down('md'), {
      paddingTop: theme.spacing(6)
    })), _defineProperty(_activeInputList, '&.dobPage .formPageRender>.inline', _defineProperty({}, theme.breakpoints.down('md'), {
      display: 'block'
    })), _defineProperty(_activeInputList, '&.provincePage .formPageRender .MuiFormGroup-root:nth-child(2)', _defineProperty({
      width: theme.typography.pxToRem(368)
    }, theme.breakpoints.down('md'), {
      width: theme.typography.pxToRem(272)
    })), _defineProperty(_activeInputList, '&.provincePage .formPageRender .MuiFormGroup-root:nth-child(2) .MuiFormControl-root', _defineProperty({
      width: theme.typography.pxToRem(368)
    }, theme.breakpoints.down('md'), {
      width: theme.typography.pxToRem(272)
    })), _defineProperty(_activeInputList, '&.emailPage .formPageRender .MuiInputBase-root, &.emailPage .formPageRender .MuiInputBase-root', _defineProperty({
      width: theme.typography.pxToRem(399)
    }, theme.breakpoints.down('md'), {
      width: theme.typography.pxToRem(272)
    })), _defineProperty(_activeInputList, '&.emailPage .formPageRender .MuiFormGroup-root:nth-child(2)', {
      paddingRight: 0
    }), _defineProperty(_activeInputList, '&.phonePage .formPageRender .MuiFormGroup-root:nth-child(1)', _defineProperty({}, theme.breakpoints.down('md'), {
      display: 'block'
    })), _defineProperty(_activeInputList, '&.phonePage .formPageRender .wrapped .countryCodeInput.inline', {
      display: 'inline-block'
    }), _defineProperty(_activeInputList, '&.phonePage .formPageRender .countryCodeInput', {
      marginRight: theme.spacing(2),
      padding: '0'
    }), _defineProperty(_activeInputList, '&.phonePage .formPageRender .countryCodeDropDown', {
      marginRight: theme.spacing(1),
      '& .MuiInputBase-root': {
        height: theme.typography.pxToRem(40),
        '&:before': {
          borderWidth: '1px'
        }
      }
    }), _defineProperty(_activeInputList, '&.phonePage .formPageRender .telephoneInput', _defineProperty({
      paddingRight: 0,
      width: theme.typography.pxToRem(235)
    }, theme.breakpoints.down('md'), {
      width: theme.typography.pxToRem(212)
    })), _defineProperty(_activeInputList, '&.phonePage .formPageRender .telephoneInput .MuiInputBase-root', _defineProperty({
      width: theme.typography.pxToRem(235)
    }, theme.breakpoints.down('md'), {
      width: theme.typography.pxToRem(212)
    })), _defineProperty(_activeInputList, '&.preferredContactPage .formPageRender [role="radiogroup"]', _defineProperty({
      width: 'calc(100% + 8px)',
      margin: theme.spacing(2.5, -0.5, 0, -0.5)
    }, theme.breakpoints.down('md'), {
      marginTop: theme.spacing(1.5)
    })), _defineProperty(_activeInputList, '&.preferredContactPage .formPageRender [role="radiogroup"] .MuiTypography-radioButton .MuiFormControlLabel-root', _defineProperty({
      width: theme.typography.pxToRem(264)
    }, theme.breakpoints.down('md'), {
      width: theme.typography.pxToRem(132)
    })), _defineProperty(_activeInputList, '&.preferredContactPage .formPageRender .formButtonBox', _defineProperty({
      marginTop: theme.spacing(5.5),
      textAlign: 'center'
    }, theme.breakpoints.down('md'), {
      marginTop: theme.spacing(5.5)
    })), _defineProperty(_activeInputList, '&.preferredContactPage .formPageRender [class*="submit:"] .formButtonBox', _defineProperty({
      marginTop: theme.spacing(8)
    }, theme.breakpoints.down('md'), {
      marginTop: theme.spacing(3)
    })), _defineProperty(_activeInputList, '&.availabilityDayPage .formPageRender .MuiFormGroup-root:nth-child(2), &.availabilityTimePage .formPageRender .MuiFormGroup-root:nth-child(2), &.dayPage .formPageRender .MuiFormGroup-root:nth-child(2), &.timePage .formPageRender .MuiFormGroup-root:nth-child(2)', _defineProperty({
      width: theme.typography.pxToRem(332),
      margin: 0,
      marginLeft: theme.typography.pxToRem(-1)
    }, theme.breakpoints.down('md'), {
      margin: 0,
      width: theme.typography.pxToRem(272)
    })), _defineProperty(_activeInputList, '& .formPageRender .sectionWrapper .MuiFormGroup-root:nth-child(2).formNextButton', {
      width: '100%'
    }), _defineProperty(_activeInputList, '&.availabilityDayPage .formPageRender .MuiFormGroup-root:nth-child(2) .MuiInputBase-root, &.availabilityTimePage .formPageRender .MuiFormGroup-root:nth-child(2) .MuiInputBase-root', _defineProperty({
      width: theme.typography.pxToRem(332)
    }, theme.breakpoints.down('md'), {
      width: theme.typography.pxToRem(272)
    })), _defineProperty(_activeInputList, '&.dayPage .formPageRender .MuiFormGroup-root:nth-child(2) .MuiInputBase-root, &.timePage .formPageRender .MuiFormGroup-root:nth-child(2) .MuiInputBase-root', _defineProperty({
      width: theme.typography.pxToRem(332)
    }, theme.breakpoints.down('md'), {
      width: theme.typography.pxToRem(272)
    })), _defineProperty(_activeInputList, '&.availabilityDayPage label + .MuiInput-formControl, &.availabilityTimePage label + .MuiInput-formControl', {
      marginTop: 0
    }), _defineProperty(_activeInputList, '&.availabilityDayPage .MuiFormLabel-root, &.availabilityTimePage .MuiFormLabel-root, &.dayPage .MuiFormLabel-root, &.availabilityTimePage .MuiFormLabel-root', {
      top: theme.spacing(-3)
    }), _defineProperty(_activeInputList, '&.availabilityTimePage .formPageRender .MuiFormGroup-root:nth-child(2),&.timePage .formPageRender .MuiFormGroup-root:nth-child(2)', _defineProperty({
      width: theme.typography.pxToRem(276),
      margin: 0,
      marginLeft: theme.typography.pxToRem(-1)
    }, theme.breakpoints.down('md'), {
      margin: 0,
      width: theme.typography.pxToRem(272)
    })), _defineProperty(_activeInputList, '&.availabilityTimePage .formPageRender .MuiFormGroup-root:nth-child(2) .MuiInputBase-root, &.timePage .formPageRender .MuiFormGroup-root:nth-child(2) .MuiInputBase-root', _defineProperty({
      width: theme.typography.pxToRem(276)
    }, theme.breakpoints.down('md'), {
      width: theme.typography.pxToRem(272)
    })), _defineProperty(_activeInputList, '&.timePage .formPageRender .formButtonBox', _defineProperty({
      marginTop: theme.spacing(8)
    }, theme.breakpoints.down('md'), {
      marginTop: theme.spacing(6)
    })), _defineProperty(_activeInputList, '&.phoneSubmitPage .formPageRender .MuiFormGroup-root:nth-child(1) .fieldlabel,&.emailSubmitPage .formPageRender .MuiFormGroup-root:nth-child(1) .fieldlabel', {
      paddingBottom: theme.spacing(3),
      display: 'block'
    }), _defineProperty(_activeInputList, '&.phoneSubmitPage .formPageRender .MuiFormGroup-root:nth-child(2) .fieldlabel,&.emailSubmitPage .formPageRender .MuiFormGroup-root:nth-child(2) .fieldlabel', _defineProperty({
      fontSize: theme.typography.body1.fontSize,
      lineHeight: theme.typography.body1.lineHeight,
      paddingTop: 0,
      display: 'block'
    }, theme.breakpoints.down('md'), {
      fontSize: theme.typography.body1.fontSize,
      lineHeight: theme.typography.body1.lineHeight,
      paddingTop: 0
    })), _defineProperty(_activeInputList, '& .formPageRender [data-locator="Form-Section-Checkbox"] .MuiTypography-body1, & .formPageRender [data-locator="Form-Section-Checkbox"] .MuiTypography-body1 a', _objectSpread2(_objectSpread2({}, theme.typography.body3), {}, {
      color: theme.palette.colors.white.contrastText,
      lineHeight: theme.typography.lineHeight.L14
    })), _defineProperty(_activeInputList, '& .formPageRender .formNextButton>div', {
      display: 'block'
    }), _defineProperty(_activeInputList, '& .formPageRender [data-locator="Form-Section-Tooltip"]', _defineProperty({
      paddingTop: theme.spacing(8),
      textAlign: 'center'
    }, theme.breakpoints.down('md'), {
      paddingTop: theme.spacing(6)
    })), _defineProperty(_activeInputList, '& .formPageRender .inline', {
      display: 'inline-block',
      paddingRight: theme.spacing(1),
      verticalAlign: 'top',
      '& .MuiFormControl-root': {
        margin: 0
      },
      '& .fieldlabel>div': _defineProperty({}, theme.breakpoints.down('md'), {
        paddingTop: theme.typography.pxToRem(5)
      })
    }), _defineProperty(_activeInputList, '& .formPageRender .multiline', {
      '& .MuiFormControl-root': {
        margin: 0
      }
    }), _defineProperty(_activeInputList, '& .consentSection', (_consentSection = {
      padding: theme.spacing(2),
      borderRadius: theme.spacing(2),
      margin: theme.spacing(8, -2, 0, -3.5),
      opacity: 0,
      visibility: 'hidden'
    }, _defineProperty(_consentSection, theme.breakpoints.down('md'), {
      margin: theme.spacing(6, -1.5, 0, -3.5),
      padding: theme.spacing(2)
    }), _defineProperty(_consentSection, '&.consentSectionActive', {
      opacity: 1,
      visibility: 'visible'
    }), _defineProperty(_consentSection, '& .MuiIconButton-label', {
      marginLeft: theme.typography.pxToRem(2)
    }), _defineProperty(_consentSection, '& .privacyPolicy.fieldHeading .fieldlabel', _objectSpread2(_objectSpread2({}, theme.typography.body3), {}, {
      marginBottom: 0,
      '& a': {
        color: fwdColors.darkGreen,
        '&:hover': {
          color: fwdColors.orange
        }
      }
    })), _consentSection)), _defineProperty(_activeInputList, '& .formNextButton, .privacyPolicyCheckbox', {
      position: 'relative',
      transition: 'all .5s',
      opacity: 0,
      visibility: 'hidden',
      '& .MuiFormControlLabel-root': {
        padding: 0,
        marginRight: 0
      },
      '& .MuiCheckbox-root': {
        paddingTop: 0,
        paddingBottom: 0,
        alignSelf: 'flex-start'
      }
    }), _defineProperty(_activeInputList, '& .formNextButton.activeButton, .privacyPolicyCheckbox.activeCheckbox', {
      position: 'relative',
      top: 0,
      opacity: 1,
      visibility: 'visible',
      '& .MuiCheckbox-root': {
        paddingTop: 0,
        paddingBottom: 0,
        alignSelf: 'flex-start'
      }
    }), _defineProperty(_activeInputList, '&.editModeList .formNextButton', {
      maxHeight: theme.spacing(4)
    }), _defineProperty(_activeInputList, '&.editModeList .formNextButton.activeButton', {
      maxHeight: '100%'
    }), _defineProperty(_activeInputList, '& .formNextButton button', {
      position: 'relative',
      zIndex: 1
    }), _defineProperty(_activeInputList, '& .formPageRender .block', {
      display: 'block'
    }), _defineProperty(_activeInputList, '& .formPageRender .fieldlabel', _objectSpread2(_objectSpread2({}, theme.typography.conversionFormLabel), {}, {
      color: theme.palette.colors.white.contrastText
    })), _defineProperty(_activeInputList, '& .formPageRender .MuiInputBase-root, & .formPageRender .dummyInputText-callback', _objectSpread2(_objectSpread2({}, theme.typography.conversionFormInput), {}, {
      color: theme.palette.colors.white.contrastText,
      marginTop: 0,
      '&.MuiInputBase-multiline': _objectSpread2(_objectSpread2({}, theme.typography.conversionFormTextarea), {}, {
        overflow: 'hidden',
        alignItems: 'flex-end',
        lineHeight: theme.typography.lineHeight.L6,
        padding: theme.spacing(1, 0, 0),
        '& .MuiInput-inputMultiline': _defineProperty({
          paddingBottom: theme.spacing(1),
          maxHeight: theme.spacing(18.75)
        }, theme.breakpoints.up('lg'), {
          maxHeight: theme.spacing(15.75)
        })
      })
    })), _defineProperty(_activeInputList, '& .formPageRender', {
      '& .MuiInput-inputMultiline': {
        //TODO: Take this piece of code in utility so that can be reused

        /* overriding dynamic inline default */
        overflow: 'auto !important'
      }
    }), _defineProperty(_activeInputList, '&.provincePage .formPageRender .MuiInputBase-root', _defineProperty({}, theme.breakpoints.down('md'), {
      lineHeight: 'normal'
    })), _defineProperty(_activeInputList, '& .MuiInputBase-root:not([data-locator="Form-Section-Dropdown"]) .MuiFormControl-root', {
      verticalAlign: 'baseline !important'
    }), _defineProperty(_activeInputList, '&.activeList', {
      '& .listIcon': _defineProperty({
        position: 'absolute',
        display: 'block',
        left: theme.spacing(-30 / 8),
        top: theme.typography.pxToRem(43),
        borderRadius: '50%',
        width: theme.spacing(1.5),
        height: theme.spacing(1.5),
        border: '4px solid transparent',
        backgroundColor: fwdColors.white,
        borderColor: fwdColors.orange
      }, theme.breakpoints.down('md'), {
        top: theme.typography.pxToRem(23)
      }),
      '&:before': _defineProperty({
        content: '""',
        width: theme.spacing(2),
        height: theme.spacing(2),
        position: 'absolute',
        borderRadius: '50%',
        left: theme.spacing(-4),
        top: theme.typography.pxToRem(41),
        animation: animations.pulse,
        background: fwdColors.orange
      }, theme.breakpoints.down('md'), {
        top: theme.typography.pxToRem(21)
      })
    }), _defineProperty(_activeInputList, '&.conditionalPage', {
      '&.activeList': {
        '&:before': {
          display: 'none'
        }
      },
      '& .listIcon': {
        opacity: 0
      }
    }), _activeInputList)
  });
};

var operations = {
  show: '{AAE07A52-46A4-49EF-98B0-C2595BAC2382}',
  hide: '{7F58C8DD-D7C0-4FB7-BB44-8EC6B5E1C3D9}',
  enable: '{5744A87E-E32C-42CC-862F-96842A0202BB}',
  disable: '{C698C993-549E-486A-A09C-BB8D830DA958}',
  eq: '{1D38B217-A2EE-4E7B-B6ED-13E751462FEB}',
  neq: '{49F47E77-E8C5-46F9-BF39-78D6B0D40B48}'
};

var styles$K = function styles(theme) {
  var colors = theme.palette.colors || {};
  var backgrounds = {};
  Object.keys(colors).forEach(function (color) {
    var _backgrounds$bg$conc;

    /** For Default */
    backgrounds["bg-".concat(color)] = (_backgrounds$bg$conc = {
      backgroundColor: colors[color].main,
      '& .MuiDialog-paperFullScreen': {
        backgroundColor: colors[color].main
      },
      '& .MuiLinearProgress-colorPrimary': {
        border: "1px solid ".concat(colors[color].contrastTextAction),
        color: colors[color].contrastTextAction
      },
      '& .MuiLinearProgress-barColorPrimary': {
        backgroundColor: colors[color].contrastTextAction
      },
      '& .MuiDialog-closeButton': {
        color: colors[color].contrastTextAction
      },
      '& div': {
        color: colors[color].contrastText,
        fontFamily: theme.typography.fontFamily
      }
    }, _defineProperty(_backgrounds$bg$conc, "&.customTextColor-".concat(color), {
      '& div': {
        color: colors[color].contrastText,
        fontFamily: theme.typography.fontFamily
      }
    }), _defineProperty(_backgrounds$bg$conc, "color", colors[color].contrastText), _defineProperty(_backgrounds$bg$conc, '& .loadingText', {
      '& div': {
        color: colors[color].contrastText,
        fontFamily: theme.typography.fontFamily
      }
    }), _backgrounds$bg$conc);
  });
  return _objectSpread2({
    root: {
      flexGrow: 1
    },
    margin: {
      margin: theme.spacing(1)
    },
    backGroundPaper: {
      '& .MuiDialog-paperFullScreen': {
        backgroundColor: theme.palette.primary.main
      },
      '& .MuiLinearProgress-colorPrimary': {
        border: "1px solid ".concat(theme.palette.primary.light),
        color: theme.palette.primary.light
      },
      '& .MuiLinearProgress-barColorPrimary': {
        backgroundColor: theme.palette.primary.light
      },
      '& .MuiDialog-closeButton': {
        color: theme.palette.primary.light
      },
      '& div': {
        color: theme.palette.primary.light
      },
      color: theme.palette.primary.light
    },
    apiWrapper: {
      position: 'fixed',
      left: 0,
      top: 0,
      height: '100%',
      width: '100%',
      zIndex: '199'
    },
    showInArea: {
      position: 'relative',
      backgroundColor: 'transparent !important'
    },
    progressWrapper: {
      height: 'calc(100vh - 192px)',
      textAlign: 'center',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    containedProgressWrapper: {
      height: 'auto',
      position: 'relative'
    }
  }, backgrounds);
};

var inlineStyles = function inlineStyles() {
  return {
    colorPrimary: {
      backgroundColor: 'transparent',
      borderRadius: '2px',
      width: '120px',
      height: '8px',
      margin: '0 auto',
      marginBottom: '8px'
    },
    barColorPrimary: {
      height: '4px',
      top: '1px',
      width: '64px'
    },
    bar1Determinate: {
      height: '4px',
      top: '0',
      width: 'calc(100% - 2px)',
      margin: '1px'
    },
    bar2Indeterminate: {
      display: 'none'
    }
  };
};

var ColorLinearProgress = withStyles$1(inlineStyles, {
  name: 'MuiLinearProgress'
})(LinearProgress$1);
var useStyles$Q = makeStyles(styles$K);

var LinearProgressBars = function LinearProgressBars(props) {
  var _props$showInModal = props.showInModal,
      showInModal = _props$showInModal === void 0 ? true : _props$showInModal,
      _props$title = props.title,
      title = _props$title === void 0 ? null : _props$title,
      _props$pageCentered = props.pageCentered,
      pageCentered = _props$pageCentered === void 0 ? false : _props$pageCentered,
      _props$value = props.value,
      value = _props$value === void 0 ? undefined : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? undefined : _props$variant,
      _props$background = props.background,
      background = _props$background === void 0 ? null : _props$background,
      _props$showInFullPage = props.showInFullPage,
      showInFullPage = _props$showInFullPage === void 0 ? true : _props$showInFullPage,
      _props$isColorChange = props.isColorChange,
      isColorChange = _props$isColorChange === void 0 ? false : _props$isColorChange,
      textColor = props.textColor;
  var classes = useStyles$Q(); // states

  var _React$useState = React__default.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  if (!showInModal) {
    var _clsx, _clsx3;

    var renderEle = pageCentered ? /*#__PURE__*/React__default.createElement("div", {
      className: clsx(classes.root, classes.backGroundPaper, classes.apiWrapper, (_clsx = {}, _defineProperty(_clsx, classes["bg-".concat(background)], background), _defineProperty(_clsx, classes.showInArea, !showInFullPage), _defineProperty(_clsx, "customTextColor-".concat(textColor), textColor), _clsx))
    }, /*#__PURE__*/React__default.createElement(Box, {
      display: "flex",
      flexDirection: "column",
      className: clsx(classes.progressWrapper, _defineProperty({}, classes.containedProgressWrapper, !showInFullPage)),
      alignItems: "center",
      justifyContent: "center"
    }, /*#__PURE__*/React__default.createElement(ColorLinearProgress, {
      className: classes.linearProgress,
      value: value,
      variant: variant
    }), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "body3",
      component: "div",
      color: background,
      className: isColorChange && 'loadingText'
    }, title && /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: title
      }
    })))) : /*#__PURE__*/React__default.createElement("div", {
      className: clsx((_clsx3 = {}, _defineProperty(_clsx3, classes["bg-".concat(background)], background), _defineProperty(_clsx3, "customTextColor-".concat(textColor), textColor), _clsx3))
    }, /*#__PURE__*/React__default.createElement(ColorLinearProgress, {
      className: classes.linearProgress,
      value: value,
      variant: variant
    }), title && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "body3",
      component: "div",
      color: background
    }, /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: title
      }
    })));
    return renderEle;
  }

  return /*#__PURE__*/React__default.createElement(Dialog$1, {
    fullScreen: true,
    open: open,
    showButton: false,
    onClose: function onClose() {
      return setOpen(false);
    },
    className: clsx(classes.root, classes.backGroundPaper)
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    className: classes.progressWrapper,
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(ColorLinearProgress, {
    className: classes.linearProgress,
    value: value,
    variant: variant
  }), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body3",
    component: "div"
  }, title && /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: title
    }
  }))));
};

var LinearProgress = withStyles$1(styles$K)(LinearProgressBars);

/**
 * Required Properties
 * Type : type of progress [linear, circular]
 * Background : color for modal background
 *
 */

var Progress = function Progress(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'linear' : _props$type;

  if (type.toLowerCase() === 'linear') {
    return /*#__PURE__*/React__default.createElement(LinearProgress, props);
  }
};

var styles$J = function styles(theme) {
  var _apiErrorWrapper;

  return {
    apiErrorWrapper: (_apiErrorWrapper = {
      position: 'fixed',
      bottom: 0,
      padding: theme.spacing(0, 2, 2),
      background: theme.palette.error.background,
      width: '100%',
      left: 0,
      zIndex: 9,
      textAlign: 'center'
    }, _defineProperty(_apiErrorWrapper, theme.breakpoints.down('md'), {
      textAlign: 'left'
    }), _defineProperty(_apiErrorWrapper, '& svg path', {
      fill: theme.palette.error.main
    }), _defineProperty(_apiErrorWrapper, '& span', {
      color: theme.palette.error.main,
      '& a': {
        color: theme.palette.error.main,
        fontWeight: theme.typography.fontWeights.bold
      }
    }), _apiErrorWrapper)
  };
};

var useStyles$P = makeStyles(styles$J);
/**
 * To display the API related errors using FieldMessage atom. Uses are such as displaying errors on form submit actions
 * @param {string} title - The error message to be displayed
 * @param {string} error - Api error status
 * @param {string} type - Provides formtype for FieldMessage
 */

var ApiErrorForms = function ApiErrorForms(props) {
  var classes = useStyles$P();
  var _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      _props$error = props.error,
      error = _props$error === void 0 ? '' : _props$error,
      _props$type = props.type,
      type = _props$type === void 0 ? '' : _props$type;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.apiErrorWrapper
  }, /*#__PURE__*/React__default.createElement(FieldMessage, {
    name: 'apiError',
    hint: title,
    errors: error,
    formtype: type
  }));
};

// check child values for parent-child relation
var childValidate = function childValidate(pageId, requirePages, formValues, requireCheck) {
  var pageArray = Object.keys(requirePages);
  var pageIndex = pageArray.indexOf(pageId);

  while (true) {
    pageIndex += 1;
    var pID = pageArray[pageIndex];

    if (pID) {
      if (requirePages[pID].parent) {
        return true;
      } else {
        if (formValues[pID]) {
          for (var _i = 0, _Object$keys = Object.keys(formValues[pID]); _i < _Object$keys.length; _i++) {
            var itemId = _Object$keys[_i];

            if (formValues[pID][itemId]['apiName'] && !formValues[pID][itemId]['value'] && (requireCheck ? formValues[pID][itemId]['required'] : true)) {
              // 'consentCheckbox' have in multiple page which may blank for some attribute,
              // so ignore this attribute for global validation
              if (formValues[pID][itemId]['apiName'] !== 'consentCheckBox') {
                return false;
              }
            }
          }
        }
      }
    } else {
      return true;
    }
  }
}; // check global validation when we trigger submit action

var globalValidate = function globalValidate(requirePages, formValues) {
  for (var _i2 = 0, _Object$keys2 = Object.keys(requirePages); _i2 < _Object$keys2.length; _i2++) {
    var pid = _Object$keys2[_i2];

    /* istanbul ignore else */
    if (formValues[pid]) {
      for (var _i3 = 0, _Object$keys3 = Object.keys(formValues[pid]); _i3 < _Object$keys3.length; _i3++) {
        var iid = _Object$keys3[_i3];

        if (formValues[pid][iid]['apiName'] && !formValues[pid][iid]['value'] && formValues[pid][iid]['required']) {
          // 'consentCheckbox' have in multiple page which may blank for some attribute,
          // so ignore this attribute for global validation
          if (formValues[pid][iid]['apiName'] !== 'consentCheckBox') {
            return {
              status: false,
              gotoPage: pid
            };
          }
        }
      }
    }
  }

  return {
    status: true,
    gotoPage: ''
  };
}; // add/remove new require page IDs

var addRemoveRequirePage = function addRemoveRequirePage(obj, currentPage, newPage, conditionalPages, formValues) {
  var temp = {};
  var removePages = [];
  var conditional = conditionalPages.indexOf(newPage) !== -1 ? true : false;

  for (var _i4 = 0, _Object$keys4 = Object.keys(obj); _i4 < _Object$keys4.length; _i4++) {
    var page = _Object$keys4[_i4];

    if (page === currentPage) {
      // if page have mutiple conditional buttons, it will create array of nextPageIDs
      for (var _i5 = 0, _Object$keys5 = Object.keys(formValues[currentPage]); _i5 < _Object$keys5.length; _i5++) {
        var itemKey = _Object$keys5[_i5];

        if (formValues[currentPage][itemKey].hasOwnProperty('nextPageID')) {
          newPage !== formValues[currentPage][itemKey]['nextPageID'] && removePages.push(formValues[currentPage][itemKey]['nextPageID']);
        }
      }
    }

    removePages.indexOf(page) === -1 && (temp[page] = obj[page]);

    if (page === currentPage && newPage) {
      temp[newPage] = {
        parent: !conditional
      };
    }
  } // If no currentPage, add to the end


  if (!currentPage && newPage) {
    temp[newPage] = {
      parent: !conditional
    };
  }

  return temp;
}; // add/remove new require page IDs

var addRequirePage = function addRequirePage(obj, currentPage, newPage, conditionalPages) {
  var temp = {};
  var conditional = conditionalPages.indexOf(newPage) !== -1 ? true : false;

  for (var _i6 = 0, _Object$keys6 = Object.keys(obj); _i6 < _Object$keys6.length; _i6++) {
    var page = _Object$keys6[_i6];
    temp[page] = obj[page];

    if (page === currentPage && newPage) {
      temp[newPage] = {
        parent: !conditional
      };
    }
  } // If no currentPage, add to the end


  if (!currentPage && newPage) {
    temp[newPage] = {
      parent: !conditional
    };
  }

  return temp;
};
var findNextPageIDfromArray = function findNextPageIDfromArray(object, key) {
  for (var _i7 = 0, _Object$keys7 = Object.keys(object); _i7 < _Object$keys7.length; _i7++) {
    var page = _Object$keys7[_i7];

    if (object[page].hasOwnProperty(key)) {
      if (object[page][key].hasOwnProperty('nextPageID')) {
        return {
          pageid: page,
          nextPageId: object[page][key].nextPageID
        };
      }
    }
  }

  return null;
};

var useStyles$O = makeStyles(function (theme) {
  return style$a(theme);
});
var formValues$1 = {};
var formSubmittedValues$1 = '{}';
var previousFormValues = '';
var formFields$1 = {};
var pagesClassname$1 = {};
var conditionTriggerPages = [];
var pageGaLabelNames = {};
var pagesBackgroundColor = {};
var actionItems$1 = {};
var pageArray$1 = [];
var pageNames$1 = {};
var requirePages = {};
var apiNameMapper$1 = {};
var conditionalPages$1 = [];
var modalElement = ''; //persist emailPayload after submit and send it to thankyou page

var persistEmailPayload = {
  data: {},
  email: {}
};
var scrollToCenterInterval = ''; // let formHeight = 0;
// let marginTop = 0;
// let viewportHeight = 768;
// if (typeof window !== 'undefined') {
//   viewportHeight = window.innerHeight;
// }
// formHeight = viewportHeight;

var hiddenApiNames$1 = {};
var consentVer$1 = '';

var CallbackForm = function CallbackForm(props) {
  var _props$sitecoreContex, _props$sitecoreContex2, _props$sitecoreContex3, _props$sitecoreContex4, _props$sitecoreContex5;

  var siteName = (_props$sitecoreContex = props === null || props === void 0 ? void 0 : (_props$sitecoreContex2 = props.sitecoreContext) === null || _props$sitecoreContex2 === void 0 ? void 0 : (_props$sitecoreContex3 = _props$sitecoreContex2.site) === null || _props$sitecoreContex3 === void 0 ? void 0 : _props$sitecoreContex3.name) !== null && _props$sitecoreContex !== void 0 ? _props$sitecoreContex : 'fwd-th';
  var siteLanguage = (_props$sitecoreContex4 = props === null || props === void 0 ? void 0 : (_props$sitecoreContex5 = props.sitecoreContext) === null || _props$sitecoreContex5 === void 0 ? void 0 : _props$sitecoreContex5.language) !== null && _props$sitecoreContex4 !== void 0 ? _props$sitecoreContex4 : 'en';
  var dateFormat = get$1(props, 'sitecoreContext.siteSettings.dateFormat', 'D MMMM YYYY') || 'D MMMM YYYY';
  moment.locale(siteLanguage);
  var payload = {
    data: {},
    email: {}
  };
  var emailPayload = {
    data: {},
    email: {}
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      fields = _useState2[0],
      setFields = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      params = _useState4[0],
      setParams = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      globalError = _useState6[0],
      setGlobalError = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      successPageID = _useState8[0],
      setSuccessPageID = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      sitecoreData = _useState10[0],
      setSitecoreData = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      stepCounter = _useState12[0],
      setStepCounter = _useState12[1];

  var _props$apiStatus = props.apiStatus,
      errorCode = _props$apiStatus.errorCode,
      loading = _props$apiStatus.loading,
      apiStatus = _props$apiStatus.apiStatus; //default BgColor

  var backgroundColor = 'white';

  var fetchURL = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var form;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // let form = '';
              // let url = '';
              // if (get(props, 'getFormLinks.callbackFormLink', null)) {
              //   url = props.getFormLinks.callbackFormLink;
              // }
              // let response = await fetchService({
              //   url,
              //   method: 'GET',
              // });
              // form = response.data;
              // if (response.status === 200 && form) {
              //   setFields(get(form, 'sitecore.route.placeholders["jss-main"][0].fields', null));
              //   setParams(get(form, 'sitecore.route.placeholders["jss-main"][0].params', null));
              //   setSitecoreData(form);
              //   setIsRecurssionDone(true);
              // } else {
              //   //TODO: Navdeep - Error handling
              // }
              form = get$1(props, 'form');
              setFields(get$1(form, 'sitecore.route.placeholders["jss-main"][0].fields', null));
              setParams(get$1(form, 'sitecore.route.placeholders["jss-main"][0].params', null));
              setSitecoreData(form);
              setIsRecurssionDone(true);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchURL() {
      return _ref.apply(this, arguments);
    };
  }();

  var disableFormSubmittedValues = get$1(props, 'disableFormSubmittedValues', false); // const { t } = useTranslation();

  var dictionary = get$1(props, 'dictionary', {
    'global-error-validation-msg': 'Sorry, we missed your input on some questions.',
    'enquiry': 'Enquiry\n',
    'apiErrorMessageForm': 'Sorry, we\'ve encountered an error. Please try again.',
    'sending': 'We\'re working on it...  <br>A moment please.',
    'enterKeyInfo': 'or hit enter to continue'
  });

  var t = function t(key) {
    return dictionary[key];
  };

  var globalValidationError = t('global-error-validation-msg') || 'Global validation error';
  var globalErrorTimeout = parseInt(t('global-error-timeout')) || 2000; // const siteName = get(sitecoreData, 'sitecore.context.site.name', '');

  var mobileMatch = useMediaQuery('(max-width:991px)');

  var renderBulletIcon = function renderBulletIcon() {
    if (activePageList.current) {
      mobileMatch ? setActiveListHeight(activePageList.current.offsetHeight - 45) : setActiveListHeight(activePageList.current.offsetHeight - 64);
    }
  };

  var getKeyByValue = function getKeyByValue(object, value) {
    return Object.keys(object).find(function (key) {
      return object[key].indexOf(value) !== -1;
    });
  };

  var classes = useStyles$O();
  useEffect(function () {
    fetchURL();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var _useForm = useForm({
    mode: 'onBlur'
  }),
      register = _useForm.register,
      watch = _useForm.watch,
      errors = _useForm.errors,
      getValues = _useForm.getValues,
      setValue = _useForm.setValue,
      triggerValidation = _useForm.triggerValidation,
      clearError = _useForm.clearError;

  var listRef = useRef();
  var activePageList = useRef();
  var formRef = useRef();
  var formTypeRef = useRef();
  var gaCategoryName = get$1(props, 'field.gaCategoryName', '');

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      modalState = _useState14[0],
      setModalState = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      isFormSubmitted = _useState16[0],
      setFormSubmitted = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      modalDarkMode = _useState18[0],
      setModalDarkMode = _useState18[1];

  var _useState19 = useState(0),
      _useState20 = _slicedToArray(_useState19, 2),
      activeListHeight = _useState20[0],
      setActiveListHeight = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      isShowNext = _useState22[0],
      setIsShowNext = _useState22[1];

  var _useState23 = useState(true),
      _useState24 = _slicedToArray(_useState23, 2),
      isSubmitDisable = _useState24[0],
      setIsSubmitDisable = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      showUpwordButton = _useState26[0],
      setShowUpwordButton = _useState26[1];

  var openModelHandler = function openModelHandler() {
    setModalState(true);
  };

  var closeModalHandler = function closeModalHandler() {
    props.updateFormModalState(false);

    if (isFormSubmitted) {
      if (!disableFormSubmittedValues) {
        formSubmittedValues$1 = JSON.stringify(formValues$1);
      }

      setFormSubmitted(false);
    } else {
      if (!disableFormSubmittedValues) {
        formValues$1 = JSON.parse(formSubmittedValues$1);
      }
    }

    props.resetAPIStatus();
    modalElement = document.querySelector('.callBackFormModal .MuiDialog-paper');

    if (modalElement && typeof modalElement !== 'undefined') {
      modalElement.removeEventListener('scroll', handleUpwordButton);
    }

    setIsRecurssionDone(false);
  };

  var handleUpwordButton = function handleUpwordButton() {
    if (modalState === true) {
      modalElement.scrollTop > 16 ? setShowUpwordButton(true) : setShowUpwordButton(false);
    }
  };

  var _useState27 = useState(null),
      _useState28 = _slicedToArray(_useState27, 2),
      activePage = _useState28[0],
      setActivePage = _useState28[1];

  var _useState29 = useState([]),
      _useState30 = _slicedToArray(_useState29, 2),
      pages = _useState30[0],
      setPages = _useState30[1];

  var _useState31 = useState(false),
      _useState32 = _slicedToArray(_useState31, 2),
      isRecurssionDone = _useState32[0],
      setIsRecurssionDone = _useState32[1];

  var watchers = watch();
  var conditionalItemID;

  function getHiddenData(i) {
    var apiName = get$1(i, 'fields.apiName.fields.value.value', '');
    var apiKey = get$1(i, 'fields.apiName.fields.key.value', '');
    var isHidden = get$1(i, 'fields.isHidden.value', '');
    var hiddenOptions = transform(get$1(i, 'items', []), function (r, o) {
      if (get$1(o, 'displayName', null)) {
        r[get$1(o, 'displayName').toLowerCase()] = get$1(o, 'fields.key.value', '') ? o.fields.key.value : get$1(o, 'fields.value.value', '');
      }
    }, {}); //for hidden api text fields

    var hiddenText = transform(i, function (result, value, key) {
      var _value$Text, _value$apiName, _value$apiName$fields, _value$apiName$fields2;

      var text = (_value$Text = value.Text) === null || _value$Text === void 0 ? void 0 : _value$Text.value;
      var apiKeyHiddenText = (_value$apiName = value.apiName) === null || _value$apiName === void 0 ? void 0 : (_value$apiName$fields = _value$apiName.fields) === null || _value$apiName$fields === void 0 ? void 0 : (_value$apiName$fields2 = _value$apiName$fields.key) === null || _value$apiName$fields2 === void 0 ? void 0 : _value$apiName$fields2.value;
      if (key === 'fields' && text && apiKeyHiddenText) result[apiKeyHiddenText] = text;
    }, {});
    apiName && isHidden && Object.assign(hiddenApiNames$1, _defineProperty({}, apiKey, _objectSpread2({
      apiName: apiName,
      hiddenOptions: hiddenOptions
    }, !isEmpty(hiddenText) && {
      hiddenText: hiddenText[apiKey]
    })));
  }

  function setCondition(item) {
    var parentId = '';

    if (item && item.fields && item.fields['Conditions']) {
      var fieldType = item.fields['Field Type'] ? item.fields['Field Type'] : '';
      var fieldTypeUrl = getFieldType(fieldType.url);
      var tempFieldObj = {};

      if (fieldTypeUrl === PageType) {
        parentId = item.id;
        formValues$1 = Object.assign(formValues$1, _defineProperty({}, parentId, {}));
      }

      if (fieldTypeUrl) {
        item.items && item.items.forEach(function (i) {
          if (parentId === item.id) {
            if (i.fields['Field Key']) {
              getHiddenData(i); // option For GTA

              var optionForGTA = transform(get$1(i, 'items', []), function (r, o) {
                if (get$1(o, 'fields.value.value', null)) {
                  r[get$1(o, 'fields.value.value')] = get$1(o, 'name', '');
                }
              }, {});
              apiNameMapper$1[[i.fields['Field Key'].value]] = i.fields['Field Key'].value;
              /**
               * get last saved data in form !(for first flow of form)
               */

              if (formSubmittedValues$1.length > 2) {
                formValues$1 = JSON.parse(formSubmittedValues$1);
              } else {
                /**
                 * create new formFields (for first flow of form)
                 */
                Object.assign(tempFieldObj, _defineProperty({}, i.fields['Field Key'].value, i.displayName));

                if (fieldTypeUrl === SectionType) {
                  if (i.items.length > 0) {
                    i.items.forEach(function (sectionItem) {
                      getHiddenData(sectionItem);
                      var sectionOptions = {};

                      if (sectionItem.items.length > 0) {
                        sectionItem.items.forEach(function (o) {
                          if (o.name === CallBackPages.PRIVACYPOLICY_SECTION) {
                            consentVer$1 = get$1(o, 'fields.key.value', '');
                          }

                          if (get$1(o, 'fields.value.value', null)) {
                            var key = get$1(o, 'fields.key.value', '') || '';
                            sectionOptions[get$1(o, 'fields.value.value')] = key;
                          }
                        });
                      }

                      formValues$1 = Object.assign(formValues$1, _defineProperty({}, parentId, _objectSpread2(_objectSpread2({}, formValues$1[parentId]), {}, _defineProperty({}, sectionItem.fields['Field Key'].value, {
                        label: get$1(sectionItem, 'fields.Text.value', ''),
                        apiName: get$1(sectionItem, 'fields.apiName.fields.value.value', ''),
                        value: '',
                        display: sectionItem.displayName,
                        options: sectionOptions,
                        required: get$1(i, 'fields.Required.value', false),
                        optionForGTA: optionForGTA
                      }))));
                    });
                  }
                } else {
                  var options = {};

                  if (i.items.length > 0) {
                    i.items.forEach(function (o) {
                      if (get$1(o, 'fields.value.value', null)) {
                        var key = get$1(o, 'fields.key.value', '') || '';
                        options[get$1(o, 'fields.value.value')] = key; // Object.assign(options, {[key] :O .fields.value.value})
                      }
                    });
                  } // langOptions are used for radio buttons


                  var langOptions = {};

                  if (get$1(i, 'fields.apiName.fields.key.value', '') !== apiNames.COUNTRYCODE) {
                    langOptions = transform(get$1(i, 'items', []), function (r, o) {
                      /* istanbul ignore else */
                      if (get$1(o, 'fields.value.value', null)) {
                        r[get$1(o, 'fields.value.value')] = get$1(o, 'displayName', '');
                      }
                    }, {});
                  }

                  var fieldTypeUrlOne = getFieldType(i.fields['Field Type'].url);

                  if (fieldTypeUrlOne === DateType) {
                    formValues$1 = Object.assign(formValues$1, _defineProperty({}, parentId, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, formValues$1[parentId]), siteLanguage !== 'zh-HK' ? {
                      day: {
                        label: get$1(i, 'fields.Text.value', ''),
                        apiName: '',
                        value: '',
                        display: i.displayName,
                        options: options
                      }
                    } : {
                      year: {
                        label: get$1(i, 'fields.Text.value', ''),
                        apiName: '',
                        value: '',
                        display: i.displayName,
                        options: options
                      }
                    }), {}, {
                      month: {
                        label: get$1(i, 'fields.Text.value', ''),
                        apiName: '',
                        value: '',
                        display: i.displayName,
                        options: options
                      }
                    }, siteLanguage !== 'zh-HK' ? {
                      year: {
                        label: get$1(i, 'fields.Text.value', ''),
                        apiName: '',
                        value: '',
                        display: i.displayName,
                        options: options
                      }
                    } : {
                      day: {
                        label: get$1(i, 'fields.Text.value', ''),
                        apiName: '',
                        value: '',
                        display: i.displayName,
                        options: options
                      }
                    }), {}, {
                      dob: {
                        label: get$1(i, 'fields.Text.value', ''),
                        apiName: get$1(i, 'fields.apiName.fields.value.value', ''),
                        value: '',
                        display: i.displayName,
                        options: options,
                        required: 'true',
                        //dob field have not required attribute
                        optionForGTA: optionForGTA
                      }
                    })));
                  } else if (fieldTypeUrlOne === SubmitType) {
                    var items = i.items;
                    var nextPageID = null;
                    var parameter = null;
                    /* istanbul ignore else */

                    if (items && items.length > 0) {
                      items.forEach(function (param) {
                        try {
                          parameter = JSON.parse(get$1(param, 'fields.Parameters.value', null));
                          nextPageID = parameter.referenceId.replace(/}|{/g, '').toLowerCase();
                        } catch (err) {
                          parameter = null;
                        }
                      });
                    }

                    formValues$1 = Object.assign(formValues$1, _defineProperty({}, parentId, _objectSpread2(_objectSpread2({}, formValues$1[parentId]), {}, _defineProperty({}, i.fields['Field Key'].value, {
                      label: get$1(i, 'fields.Text.value', ''),
                      apiName: get$1(i, 'fields.apiName.fields.value.value', ''),
                      value: '',
                      display: i.displayName,
                      options: options,
                      langOptions: langOptions,
                      nextPageID: nextPageID,
                      required: get$1(i, 'fields.Required.value', false),
                      optionForGTA: optionForGTA
                    }))));
                  } else {
                    formValues$1 = Object.assign(formValues$1, _defineProperty({}, parentId, _objectSpread2(_objectSpread2({}, formValues$1[parentId]), {}, _defineProperty({}, i.fields['Field Key'].value, {
                      label: get$1(i, 'fields.Text.value', ''),
                      apiName: get$1(i, 'fields.apiName.fields.value.value', ''),
                      value: '',
                      display: i.displayName,
                      options: options,
                      langOptions: langOptions,
                      required: get$1(i, 'fields.Required.value', false),
                      optionForGTA: optionForGTA
                    }))));
                  }
                }
              }
            }
          }
        });
      }

      if (fieldTypeUrl === PageType) {
        var pageStyleName = item.fields['Css Class'].value;

        if (pageStyleName.indexOf('conditionPage') !== -1) {
          conditionalPages$1.push(item.id);
        }

        conditionalItemID = item.id;
        pageArray$1.push(item.id);
        pagesClassname$1 = Object.assign(pagesClassname$1, _defineProperty({}, item.id, item.fields['Css Class'].value));
        pagesBackgroundColor = Object.assign(pagesBackgroundColor, _defineProperty({}, item.id, get$1(item, 'fields.backgroundColor.fields.value.value', 'white')));
        pageNames$1 = Object.assign(pageNames$1, _defineProperty({}, item.id, item.name));
        pageGaLabelNames = Object.assign(pageGaLabelNames, _defineProperty({}, item.id, item.fields.gaLabel ? item.fields.gaLabel.value : ''));
        /* istanbul ignore else */

        if (conditionalPages$1.indexOf(item.id) === -1) {
          requirePages = Object.assign(requirePages, _defineProperty({}, item.id, {
            parent: true
          }));
        }

        formFields$1 = item.items && item.items[0].fields.Text ? Object.assign(formFields$1, _defineProperty({}, item.id, _objectSpread2({
          label: item.items[0].fields.Text.value
        }, tempFieldObj))) : formFields$1;
      }

      var conditions = item.fields['Conditions'].value ? JSON.parse(item.fields['Conditions'].value) : '';

      if (conditions.fieldConditions && conditions.fieldConditions.length > 0) {
        conditionTriggerPages.push(conditionalItemID);

        var _iterator = _createForOfIteratorHelper(conditions.fieldConditions),
            _step;

        try {
          var _loop = function _loop() {
            var obj = _step.value;
            obj.actions.forEach(function (action) {
              actionItems$1[action.fieldId] = {
                depends: obj.conditions[0].fieldId,
                value: obj.conditions[0].value,
                operator: obj.conditions[0].operatorId === operations.eq ? '==' : '!=',
                show: action.actionTypeId === operations.show || action.actionTypeId === operations.enable
              };
            });
            obj.conditions.forEach(function (condition) {
              // eslint-disable-line no-loop-func
              var defaultValue = formValues$1[activePage];
              watchers[condition.fieldId] = defaultValue ? watch(condition.fieldId, defaultValue[condition.fieldId]) : watch(condition.fieldId, '');
            });
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }

    item && item.items && item.items.forEach(function (next) {
      return setCondition(next);
    });
  }

  var pagesID = Object.keys(pageNames$1);
  var isSaveLead = false;
  useEffect(function () {
    setCondition(fields);
  }, [fields]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    if (isRecurssionDone) {
      setActivePage(pageArray$1[0]);
      setPages(pageArray$1);
      openModelHandler();
      setModalState(true);
    } else {
      scrollToCenterInterval = setInterval(function () {
        return scrollToCenter;
      }, 100);
    }
  }, [isRecurssionDone, params]); // eslint-disable-line react-hooks/exhaustive-deps

  /**
   * On Active Page Change
   */

  var colorData;
  useEffect(function () {
    renderBulletIcon();

    if (pagesClassname$1[activePage]) {
      var showNextButton = function showNextButton() {
        setModalDarkMode(true);
        setIsShowNext(true);
      };

      pagesClassname$1[activePage].indexOf('darkMode') !== -1 ? showNextButton() : setModalDarkMode(false);
    }

    setIsSubmitDisable(true);

    if (getUserFilledValue(formValues$1[activePage], pageNames$1[activePage])) {
      setIsShowNext(true);
    }

    setTimeout(function () {
      return scrollToCenter();
    }, 100);
    setTimeout(function () {
      return renderBulletIcon();
    }, 100);
  }, [activePage]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    renderBulletIcon();
  }, [isShowNext, errors]); // eslint-disable-line react-hooks/exhaustive-deps

  var handleOnFormValueChange = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(key, val) {
      var currentValue, _values, phoneValue;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currentValue = getValues();

              if (key && val && key !== 'DataList') {
                setValue(key, val);
                currentValue[key] = val;
              }

              if (key === 'DataList') {
                setValue(key, val);
              }

              _values = Object.values(currentValue);
              phoneValue = true;

              if ('17D41C11355B4567AF0A9A0E1C21E415' in currentValue) {
                currentValue['17D41C11355B4567AF0A9A0E1C21E415'].length < 1 && (phoneValue = false);
              }

              _values.every(function (value) {
                return value !== '' && value !== false;
              }) ? setIsSubmitDisable(false) : setIsSubmitDisable(true);
              _values.some(function (value) {
                return value !== '' && value !== false && phoneValue;
              }) ? setIsShowNext(true) : setIsShowNext(false);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleOnFormValueChange(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var _useState33 = useState(false),
      _useState34 = _slicedToArray(_useState33, 2),
      showLoader = _useState34[0],
      setShowLoader = _useState34[1];

  useEffect(function () {
    setShowLoader(loading);
  }, [loading]);
  /**
   * removes conditional page data if SA/Premium radio button value is changed and results in hiding those values in the form
   */

  var removeConditionalLI = function removeConditionalLI(activePageId) {
    var allPageIds = Object.keys(pageNames$1);
    var filteredPageIds = allPageIds.slice(allPageIds.indexOf(activePageId) + 1);
    var parsedPreviousValues = JSON.parse(previousFormValues);
    var taskPagePageId = getKeyByValue(pageNames$1, 'taskPage');
    var taskPagePrevValue = parsedPreviousValues[taskPagePageId] ? getUserFilledValue(parsedPreviousValues[taskPagePageId], pageNames$1[taskPagePageId]) : null;

    if (taskPagePrevValue) {
      conditionalPages$1.forEach(function (pageId) {
        var activePageObj = formValues$1[pageId];

        if (filteredPageIds.includes(pageId)) {
          for (var fieldKey in activePageObj) {
            activePageObj[fieldKey].value = '';
          }
        }

        formValues$1[pageId] = activePageObj;
      });
    }
  }; //reset all child pages which are after the condition-trigger-page


  var resetConditionalRequirePage = function resetConditionalRequirePage(currentPage) {
    var temp = {};
    var removeConditionalPage = false;
    var obj = requirePages;

    for (var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++) {
      var page = _Object$keys[_i];
      var pagetype = obj[page].parent;

      if (!removeConditionalPage) {
        temp[page] = obj[page];
      } else {
        pagetype && (temp[page] = obj[page]);
      }

      page === currentPage && (removeConditionalPage = true);
    }

    requirePages = temp;

    for (var _i2 = 0, _Object$keys2 = Object.keys(watchers); _i2 < _Object$keys2.length; _i2++) {
      var watcherFieldItem = _Object$keys2[_i2];

      if (watcherFieldItem) {
        for (var _i3 = 0, _Object$keys3 = Object.keys(actionItems$1); _i3 < _Object$keys3.length; _i3++) {
          var actionFieldItem = _Object$keys3[_i3];

          if (actionItems$1[actionFieldItem].depends === watcherFieldItem) {
            if (evalCondition(actionItems$1, actionFieldItem)) {
              var pageValues = findNextPageIDfromArray(formValues$1, actionFieldItem);
              pageValues && (requirePages = addRequirePage(requirePages, pageValues.pageid, pageValues.nextPageId, conditionalPages$1));
            }
          }
        }
      }
    }
  };

  var handleOnNextClick = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type, pageId, emailTemplate, apiToQuery) {
      var checkPageName, currentValue, gtmUserDetails, _getStepCount, stepCountIndex, stepCountList, sitecore, form_type, checkGlobalCondition, isValidated, _objectSpread6, _Object$assign20, _siteName$split$, getAvailabilityPageId, _sitecore, templateUrl, templateApiKey, templateApiHost, edmTemplateUrl, MailURL, MailURLKey, SaveLeadURL, SaveLeadKey, apiListArr, gtmValues, hiddenApiTextData, url, dataLayer, userDetails, userPreference, newPaylaod, leadData, entity, pageArr, index, page, currentValueOne;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              checkPageName = pageNames$1[activePage];
              checkPageName !== calculatorPages.SPLASHSCREENPAGE ? animateScroll.scrollTo(pagesID.indexOf(activePage) * 24 + 24, {
                duration: 500,
                smooth: 'easeInOutQuint',
                containerId: 'callBackFormModalElement'
              }) : animateScroll.scrollTo(0, {
                duration: 500,
                smooth: 'easeInOutQuint',
                containerId: 'callBackFormModalElement'
              });
              /* istanbul ignore else */

              if (!(type === 'backHome')) {
                _context3.next = 6;
                break;
              }

              PushEvent({
                event: 'buttonClick',
                buttonTitle: 'Back to Home',
                componentName: gaCategoryName ? gaCategoryName : FORM_SECTION_BUTTON$1,
                destinationUrl: undefined
              });
              closeModalHandler();
              return _context3.abrupt("return");

            case 6:
              /* istanbul ignore else */
              if (pageNames$1[activePage] === 'taskPage' || pageNames$1[activePage] === 'preferredContactModePage') {
                removeConditionalLI(activePage);
              }

              currentValue = getValues();
              gtmUserDetails = {
                user_details: {},
                user_preferences: {}
              };
              /* istanbul ignore else */

              _context3.next = 11;
              return triggerValidation();

            case 11:
              if (!_context3.sent) {
                _context3.next = 19;
                break;
              }

              Object.keys(currentValue).forEach(function (fieldKey) {
                var activePageObj = formValues$1[activePage];
                var pageFieldObj = activePageObj[fieldKey];

                if (pageFieldObj) {
                  pageFieldObj.value = currentValue[fieldKey];
                  activePageObj = _objectSpread2(_objectSpread2({}, activePageObj), {}, _defineProperty({}, fieldKey, pageFieldObj));

                  var _getDataForGTM = getDataForGTM(pageFieldObj, siteLanguage),
                      user_details = _getDataForGTM.user_details,
                      user_preferences = _getDataForGTM.user_preferences;
                  /* istanbul ignore else */


                  if (!isEmpty(user_details)) {
                    Object.assign(gtmUserDetails.user_details, user_details);
                  }
                  /* istanbul ignore else */


                  if (!isEmpty(user_preferences)) {
                    Object.assign(gtmUserDetails.user_preferences, user_preferences);
                  }

                  if (type === 'submit') {
                    Object.assign(gtmUserDetails.user_preferences, {
                      consentCheckBox: true
                    });
                  }

                  formValues$1[activePage] = activePageObj;
                }
              });
              previousFormValues = JSON.stringify(formValues$1);
              _getStepCount = getStepCount(stepCounter, pageNames$1[activePage]), stepCountIndex = _getStepCount.stepCountIndex, stepCountList = _getStepCount.stepCountList;
              setStepCounter(stepCountList);
              sitecore = get$1(sitecoreData, 'sitecore', '') || '';
              form_type = get$1(sitecore, 'route.displayName', null);
              PushEvent(_objectSpread2(_objectSpread2({
                event: 'form_step',
                form_type: form_type ? form_type : get$1(props, 'getProductDetails.initializer', ''),
                step: "Step ".concat(stepCountIndex),
                'step-name': !isEmpty(pageGaLabelNames[activePage]) ? pageGaLabelNames[activePage] : pageNames$1[activePage]
              }, !isEmpty(gtmUserDetails.user_details) ? {
                user_details: gtmUserDetails.user_details
              } : null), !isEmpty(gtmUserDetails.user_preferences) ? {
                user_preferences: gtmUserDetails.user_preferences
              } : null));

            case 19:
              if (!(type === 'submit')) {
                _context3.next = 90;
                break;
              }

              checkGlobalCondition = globalValidate(requirePages, formValues$1);

              if (!checkGlobalCondition.status) {
                _context3.next = 86;
                break;
              }

              setGlobalError(false);
              _context3.prev = 23;
              _context3.next = 26;
              return triggerValidation();

            case 26:
              isValidated = _context3.sent;
              setFormSubmitted(true);

              if (!isValidated) {
                _context3.next = 78;
                break;
              }

              if (pagesClassname$1[pageId]) {
                if (pagesClassname$1[pageId].indexOf('emailSubmitPage') !== -1) {
                  getAvailabilityPageId = getKeyByValue(pagesClassname$1, 'availabilityPage');

                  if (formValues$1[getAvailabilityPageId]) {
                    delete formValues$1[getAvailabilityPageId];
                  }
                }
              } //Trigger SendMail or SaveLead


              _sitecore = get$1(sitecoreData, 'sitecore', '') || '';
              templateUrl = get$1(_sitecore, 'route.fields.formEmailTemplate.value.href', '') || '';
              templateApiKey = get$1(_sitecore, 'route.fields.formEmailTemplate.value.apiKey', null);
              templateApiHost = get$1(_sitecore, 'route.fields.formEmailTemplate.value.apiHost', null);

              if (emailTemplate) {
                templateUrl = emailTemplate;
              }

              edmTemplateUrl = generatelayoutServicePath(templateUrl, _sitecore.context.languageCode || _sitecore.context.language, {
                "sitecoreApiKey": templateApiKey,
                "sitecoreApiHost": templateApiHost
              });

              if (edmTemplateUrl.indexOf('http') === -1) {
                edmTemplateUrl = getDomain() + edmTemplateUrl;
              }

              MailURL = '';
              MailURLKey = '';
              SaveLeadURL = '';
              SaveLeadKey = '';
              apiListArr = get$1(_sitecore, 'route.fields.apiList', []) || [];
              gtmValues = {};
              apiListArr.length > 0 && apiListArr.forEach(function (apiList) {
                var apiName = get$1(apiList, 'fields.apiName.value', '') || '';

                if (apiName === 'SaveLead') {
                  SaveLeadURL = get$1(apiList, 'fields.value.value', '') || '';
                  SaveLeadKey = get$1(apiList, 'fields.key.value', '') || '';
                } else if (apiName === 'Email') {
                  MailURL = get$1(apiList, 'fields.value.value', '') || '';
                  MailURLKey = get$1(apiList, 'fields.key.value', '') || '';
                }
              });
              values(formValues$1).forEach(function (page) {
                values(page).forEach(function (field) {
                  //added condition: !emailPayload.data[field.apiName] to handle conditional pages having fields with same apiName, ex: cellPhone
                  if (field.apiName !== '' && !emailPayload.data[field.apiName]) {
                    var fieldValue = field.value;
                    isEmpty(field.langOptions) ? Object.assign(emailPayload.data, _defineProperty({}, field.apiName, removeTag(field.value))) : Object.assign(emailPayload.data, _defineProperty({}, field.apiName, removeTag(field.langOptions[field.value])));
                    !isEmpty(field.optionForGTA) ? Object.assign(gtmValues, _defineProperty({}, field.apiName, removeTag(field.optionForGTA[fieldValue]))) : Object.assign(gtmValues, _defineProperty({}, field.apiName, removeTag(fieldValue)));
                    isEmpty(field.options) ? Object.assign(payload.data, _defineProperty({}, field.apiName, removeTag(field.value))) : Object.assign(payload.data, _defineProperty({}, field.apiName, removeTag(field.options[field.value])));
                  }
                });
              }); //hiddenFields which are pre-field by the author

              hiddenApiTextData = transform(hiddenApiNames$1, function (result, value) {
                if (value.hiddenText) result[value.apiName] = value.hiddenText;
              }, {});

              if (typeof window !== 'undefined' && get$1(hiddenApiNames$1, 'mediaSource.apiName', '')) {
                url = new URLSearchParams(window.location.search);

                if (url.has('mediaSource') || url.has('MediaSource')) {
                  payload.data[hiddenApiNames$1.mediaSource.apiName] = url.get('mediaSource') || url.get('MediaSource');
                }
              }

              if (consentVer$1 && get$1(hiddenApiNames$1, 'ConsentVersionCd.apiName', '')) {
                payload.data[hiddenApiNames$1.ConsentVersionCd.apiName] = consentVer$1;
              }
              /* istanbul ignore else */


              if (emailPayload.data.dob) {
                emailPayload.data.dob = moment(emailPayload.data.dob).format(dateFormat);
              }

              if (payload.data.hasOwnProperty('countryCode') && payload.data.hasOwnProperty('cellPhone')) {
                if (siteName.toLowerCase() === 'fwd-th') {
                  emailPayload.data.cellPhone = payload.data.cellPhone;
                } else {
                  emailPayload.data.cellPhone = payload.data.countryCode + ' ' + payload.data.cellPhone;
                  payload.data.cellPhone = payload.data.countryCode + ' ' + payload.data.cellPhone;
                  if (emailPayload.data.countryCode) delete emailPayload.data.countryCode;
                }
              }

              if (payload.data.hasOwnProperty('consentCheckBox')) {
                emailPayload.data.consentCheckBox = 'true';
                payload.data.consentCheckBox = 'Y';
              }

              if (payload.data.hasOwnProperty('expectedInsuranceType')) {
                payload.data.expectedProductName = emailPayload.data.expectedInsuranceType;
              }
              /**
               * Google Analytics Start
               */


              dataLayer = {
                event: GTMdataLayerProperties.ENQUIRY
              };
              userDetails = _objectSpread2(_objectSpread2({}, get$1(payload, 'data.dob', '') && _defineProperty({}, GTMdataLayerProperties.YEAR_OF_BIRTH, moment(payload.data.dob, 'YYYY-MM-DD').year().toString())), {}, (_objectSpread6 = {}, _defineProperty(_objectSpread6, GTMdataLayerProperties.EMAIL, SHA256(get$1(payload, 'data.email', ''))), _defineProperty(_objectSpread6, GTMdataLayerProperties.PHONE_NUMBER, SHA256(get$1(payload, 'data.cellPhone', ''))), _objectSpread6), gtmValues.homeProvince && _defineProperty({}, GTMdataLayerProperties.LIVING_IN, gtmValues.homeProvince));
              userPreference = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, gtmValues.expectedInsuranceType && _defineProperty({}, GTMdataLayerProperties.CONTACT_TOPIC, gtmValues.expectedInsuranceType)), gtmValues.queryReason && _defineProperty({}, GTMdataLayerProperties.CONTACT_FORM, gtmValues.queryReason)), gtmValues.preferredDay && _defineProperty({}, GTMdataLayerProperties.CONTACT_ON, gtmValues.preferredDay)), gtmValues.preferredTime && _defineProperty({}, GTMdataLayerProperties.CONTACT_TIMING, gtmValues.preferredTime)), gtmValues.preferredContactMethod && _defineProperty({}, GTMdataLayerProperties.CONTACT_VIA, gtmValues.preferredContactMethod));
              Object.assign(dataLayer, (_Object$assign20 = {}, _defineProperty(_Object$assign20, GTMdataLayerProperties.USER_DETAILS, _objectSpread2({}, userDetails)), _defineProperty(_Object$assign20, GTMdataLayerProperties.USER_PREFERENCES, _objectSpread2({}, userPreference)), _Object$assign20));
              PushEvent(_objectSpread2({}, dataLayer));
              /**
               * Google Analytics End
               */

              payload.email.templateUrl = edmTemplateUrl;
              payload.email.parameters = emailPayload.data; //Putting this at last to give priority to author filled hiddenApiField texts

              Object.assign(payload.data, hiddenApiTextData); // payload is defined globally so created a local payload

              newPaylaod = {};
              Object.assign(newPaylaod, payload);
              leadData = _objectSpread2(_objectSpread2({}, newPaylaod.data), {}, {
                cellPhone: newPaylaod.data.cellPhone && newPaylaod.data.cellPhone.replace(' ', ''),
                dob: newPaylaod.data.dob && siteName.toLowerCase() === 'fwd-th' && siteLanguage === 'th' ? getEnglishCalendarDate(newPaylaod.data.dob) : newPaylaod.data.dob
              });
              newPaylaod.lead = leadData;
              delete newPaylaod.data; //persisting emailPayload in global variable 'persistEmailPayload' which will be used in thankyou page

              persistEmailPayload = JSON.parse(JSON.stringify(emailPayload));
              entity = siteName === null || siteName === void 0 ? void 0 : (_siteName$split$ = siteName.split('-')[1]) === null || _siteName$split$ === void 0 ? void 0 : _siteName$split$.toUpperCase();
              _context3.t0 = apiToQuery;
              _context3.next = _context3.t0 === API.SAVE_LEAD ? 70 : _context3.t0 === API.SEND_EMAIL ? 72 : _context3.t0 === API.CUSTOM_ACTION ? 74 : 76;
              break;

            case 70:
              props.saveLeadAPI({
                apiUrl: SaveLeadURL,
                authorizationKey: SaveLeadKey,
                entity: entity,
                data: _objectSpread2({}, getPayloadData(newPaylaod))
              });
              return _context3.abrupt("break", 77);

            case 72:
              props.saveLeadAPI({
                apiUrl: MailURL,
                authorizationKey: MailURLKey,
                data: {
                  user: {
                    profile: {
                      contact: {
                        email: {
                          templateUrl: edmTemplateUrl,
                          parameters: emailPayload.data
                        }
                      }
                    }
                  }
                },
                entity: entity,
                factorType: 'EMAIL'
              });
              return _context3.abrupt("break", 77);

            case 74:
              props.submitAction({
                apiUrl: MailURL,
                authorizationKey: MailURLKey,
                data: {
                  user: {
                    profile: {
                      contact: {
                        email: {
                          templateUrl: edmTemplateUrl,
                          parameters: emailPayload.data
                        }
                      }
                    }
                  }
                },
                entity: entity,
                factorType: 'EMAIL'
              });
              return _context3.abrupt("break", 77);

            case 76:
              return _context3.abrupt("break", 77);

            case 77:
              setSuccessPageID(pageId);

            case 78:
              _context3.next = 84;
              break;

            case 80:
              _context3.prev = 80;
              _context3.t1 = _context3["catch"](23);
              console.log('error', _context3.t1);
              return _context3.abrupt("return");

            case 84:
              _context3.next = 88;
              break;

            case 86:
              setGlobalError(true);
              setTimeout(function () {
                handleOnPageClick(checkGlobalCondition.gotoPage);
                setGlobalError(false);
              }, globalErrorTimeout);

            case 88:
              _context3.next = 117;
              break;

            case 90:
              _context3.t2 = pageId;

              if (!_context3.t2) {
                _context3.next = 95;
                break;
              }

              _context3.next = 94;
              return triggerValidation();

            case 94:
              _context3.t2 = _context3.sent;

            case 95:
              if (!_context3.t2) {
                _context3.next = 103;
                break;
              }

              setIsShowNext(false); // mobileMatch
              //   ? scroll.scrollTo(pagesID.indexOf(pageId) * 16, {
              //       duration: 500,
              //       smooth: 'easeInOutQuint',
              //       containerId: 'callBackFormModalElement',
              //     })
              //   : scroll.scrollTo(pagesID.indexOf(pageId) * 32 + 32, {
              //       duration: 500,
              //       smooth: 'easeInOutQuint',
              //       containerId: 'callBackFormModalElement',
              //     });

              if (conditionTriggerPages.indexOf(activePage) !== -1) {
                resetConditionalRequirePage(activePage);
              }

              if (!requirePages.hasOwnProperty(pageId)) {
                requirePages = addRemoveRequirePage(requirePages, activePage, pageId, conditionalPages$1, formValues$1);
              }

              setActivePage(pageId);

              if (pages.indexOf(pageId) !== -1) {
                pageArr = pages.filter(function (item) {
                  return item !== pageId;
                });
                setPages(pageArr);
              }

              _context3.next = 117;
              break;

            case 103:
              index = pages.indexOf(activePage);
              page = pages[index + 1];
              _context3.t3 = page;

              if (!_context3.t3) {
                _context3.next = 110;
                break;
              }

              _context3.next = 109;
              return triggerValidation();

            case 109:
              _context3.t3 = _context3.sent;

            case 110:
              if (!_context3.t3) {
                _context3.next = 117;
                break;
              }

              setIsShowNext(false);
              currentValueOne = getValues();
              formValues$1 = Object.assign(formValues$1, _defineProperty({}, activePage, currentValueOne));

              if (conditionTriggerPages.indexOf(activePage) !== -1) {
                resetConditionalRequirePage(activePage);
              }

              if (!requirePages.hasOwnProperty(pageId)) {
                requirePages = addRemoveRequirePage(requirePages, activePage, pageId, conditionalPages$1, formValues$1);
              }

              setActivePage(page);

            case 117:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[23, 80]]);
    }));

    return function handleOnNextClick(_x3, _x4, _x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleOnPrevClick = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              animateScroll.scrollMore(-32, {
                duration: 500,
                smooth: 'easeInOutQuint',
                containerId: 'callBackFormModalElement'
              });

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleOnPrevClick() {
      return _ref11.apply(this, arguments);
    };
  }();

  var handleOnPageClick = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(pageid) {
      var existingFilledCount, newFilledCount, existingFullList, i, page;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              existingFilledCount = 0;
              newFilledCount = 0;
              existingFullList = document.querySelectorAll('[data-locator="Form-FormValue-List"]');
              i = 0;

            case 4:
              if (!(i < existingFullList.length)) {
                _context5.next = 14;
                break;
              }

              page = existingFullList[i];

              if (!page.classList.contains('activeList')) {
                _context5.next = 10;
                break;
              }

              return _context5.abrupt("break", 14);

            case 10:
              if (page.classList.contains('filledList')) {
                existingFilledCount++;
              }

            case 11:
              i++;
              _context5.next = 4;
              break;

            case 14:
              if (pageid) {
                pagesClassname$1[pageid].indexOf('submitPage') !== -1 ? setIsShowNext(true) : setIsShowNext(false);
                setActivePage(pageid);
              }

              setTimeout(function () {
                var newFullList = document.querySelectorAll('[data-locator="Form-FormValue-List"]');

                for (var _i4 = 0; _i4 < newFullList.length; _i4++) {
                  var _page = newFullList[_i4];

                  if (_page.classList.contains('activeList')) {
                    break;
                  } else if (_page.classList.contains('filledList')) {
                    newFilledCount++;
                  }
                }

                animateScroll.scrollMore(-((existingFilledCount - newFilledCount) * 32), {
                  duration: 500,
                  smooth: 'easeInOutQuint',
                  containerId: 'callBackFormModalElement'
                });
              }, 100);

            case 16:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleOnPageClick(_x7) {
      return _ref12.apply(this, arguments);
    };
  }();

  var onModalEntered = function onModalEntered() {
    renderBulletIcon();
    modalElement = document.querySelector('.callBackFormModal .MuiDialog-paper');

    if (modalElement && typeof modalElement !== 'undefined') {
      modalElement.addEventListener('scroll', handleUpwordButton);
      modalElement.scrollTop = 0;
    }
  };

  document.onkeydown = function (evt) {
    evt = evt || typeof window !== 'undefined' && window.event;

    if (evt.keyCode === 13 && isShowNext && get$1(evt, 'target.type', null) !== 'textarea') {
      evt.preventDefault();
      var nextButtonElement = document.querySelector('.MuiButtonBase-root[data-locator=Form-Section-Button]');

      if (nextButtonElement) {
        nextButtonElement.click();
      }
    }
  };

  var findValuefromArray = function findValuefromArray(array, key) {
    for (var i = 0, len = array.length; i < len; i++) {
      if (Object.keys(array[i])[1] === key) {
        return array[i][key].value;
      }
    }

    return null;
  };
  /**
   * Conditionally render PageRenderer & SectionRenderer & FieldRenderer
   *  based no eval condition and show hide
   * {
      "4238ED94AA024B399222A8CD8D0CA23D": {
      "depends": "3C4023E8B86445F9BC50AEB6652C54B4",
      "value": "meetAnAgent",
      "operator": "!=",
      "show": false
    }
  },
   */


  var evalCondition = function evalCondition(_actionItems, fieldKey) {
    var watcherValue = '';
    var formFeildValue = Object.values(formValues$1);

    if (_actionItems[fieldKey]) {
      if (watchers[_actionItems[fieldKey].depends]) {
        watcherValue = watchers[_actionItems[fieldKey].depends];
      } else {
        watcherValue = findValuefromArray(formFeildValue, _actionItems[fieldKey].depends);
      }
    } //A simple parser to evaluate [==] && [!=]


    var condition = '';

    if (_actionItems[fieldKey].operator === '==' && watcherValue === _actionItems[fieldKey].value || _actionItems[fieldKey].operator === '!=' && watcherValue !== _actionItems[fieldKey].value) {
      condition = true;
    } else if (_actionItems[fieldKey].operator === '==' && watcherValue !== _actionItems[fieldKey].value || _actionItems[fieldKey].operator === '!=' && watcherValue === _actionItems[fieldKey].value) {
      condition = false;
    }

    if (condition === _actionItems[fieldKey].show) {
      return true;
    }

    return false;
  };
  /**
   * Get User Entered Value for Displaying in Prefilled List
   */


  var getUserFilledValue = function getUserFilledValue(items, pageName) {
    var displayText = '';

    try {
      if (pageName !== 'dobPage') {
        for (var key in items) {
          if (items.hasOwnProperty(key)) {
            if (Object.keys(items[key].langOptions).length > 0) {
              displayText += items[key].langOptions[items[key].value] ? items[key].langOptions[items[key].value] : '';
            } else {
              var itemValue = items[key].value;
              typeof itemValue !== 'boolean' && itemValue && (displayText += items[key].value + ' ');
            }
          }
        }
      }

      if (pageName === 'dobPage') {
        var dob = [];
        var day = get$1(items, 'day.value', '');
        var month = get$1(items, 'month.value', '');
        var year = get$1(items, 'year.value', '');
        /* istanbul ignore else */

        if (!isEmpty(day) && !isEmpty(month) && !isEmpty(year)) {
          if (siteLanguage !== 'zh-HK') {
            dob.push(day);
            dob.push(month);
            dob.push(year);
          } else {
            dob.push(year);
            dob.push(month);
            dob.push(day);
          }
        }

        !isEmpty(dob) && (displayText = dob.join(' '));
      }

      return displayText;
    } catch (err) {
      return displayText;
    }
  };

  var subTaskPagePageId = getKeyByValue(pageNames$1, 'subTaskPage');
  isSaveLead = getUserFilledValue(formValues$1[subTaskPagePageId], pageNames$1[subTaskPagePageId]).length > 0;
  var editModeList = false;
  useEffect(function () {
    // wraper countryCodeInput telephoneInput to a same parent div

    /* istanbul ignore else */
    if (document.querySelector('.countryCodeInput') && document.querySelector('.telephoneInput')) {
      wrapNodes([document.querySelector('.countryCodeInput'), document.querySelector('.telephoneInput')], ['MuiFormGroup-root', 'inline']);
    }
  }, [activePage]);
  /*
   * End
   */

  /**
   * Scroll to Center for Desktop ( fixed from top 300px)
   * Scroll to fixed position from top (150px) on Mobile
   */

  var scrollToCenter = function scrollToCenter() {
    // The id of the dialog
    var dialog = document.getElementById('callBackForm');
    var formElm = document.getElementById('formElm');
    var ulElm = document.getElementById('ulElm');
    var activeElm = document.querySelector('.activeList');
    var formElmItem = document.getElementById('formElmItem');
    var formInnerWrapper = document.getElementById('formInnerWrapper');

    if (formElm && ulElm && activeElm) {
      clearInterval(scrollToCenterInterval);
      var labelElm = document.getElementById('enquiryTag');
      var activeElmId = activeElm.getAttribute('id');
      var positionOnDesktop = activeElmId === 'li0' ? formElm.offsetHeight / 2 - 70 : formElm.offsetHeight / 3;
      var positionFromTop = mobileMatch ? 150 : positionOnDesktop; // Calculate the shift in px that is required for ul tag.

      var styleTop = positionFromTop - activeElm.offsetTop;

      if (activeElmId === 'li0') {
        formElmItem.classList.remove('nonSplashScreen');
        formElmItem.classList.add('SplashScreen');
        labelElm.style.position = 'relative';
        ulElm.style.top = 'auto';
        ulElm.style.position = 'relative';
      } else {
        formElmItem.classList.remove('SplashScreen');
        formElmItem.classList.add('nonSplashScreen');
        ulElm.style.top = styleTop + 'px';
        ulElm.style.position = 'absolute';
      }

      var translate = "translate3d(0,-".concat(activeElm.offsetTop, "px,0)");
      labelElm.style.transition = 'transform 0.5s';
      labelElm.style.transform = activeElmId === 'li0' ? '' : translate;
      formElm.style.marginTop = activeElmId === 'li0' ? '0' : activeElm.offsetTop + 'px';
      dialog.scrollTop = activeElm.offsetTop;
      formInnerWrapper.style.opacity = 1;
    }
  };

  if (pagesBackgroundColor[activePage]) {
    colorData = getColors(pagesBackgroundColor[activePage]);
    backgroundColor = colorData.bgColor;
  }

  if (errorCode && errorCode === 200 && successPageID && activePage !== successPageID) {
    setIsShowNext(true);
    setActivePage(successPageID);
    setModalDarkMode(true);
  }

  var loaderBgcolor = get$1(params, 'loaderBackgroundColor', 'orange') || 'orange';
  if (!isRecurssionDone) return null;
  return fields && params && /*#__PURE__*/React__default.createElement("div", {
    id: "parentOfAll"
  }, /*#__PURE__*/React__default.createElement(Dialog$1, {
    fullScreen: true,
    className: clsx(classes.callBackFormDialog, 'callBackFormModal'),
    open: modalState,
    onEntered: onModalEntered,
    onClose: closeModalHandler,
    color: colorData && colorData.bgColor ? colorData.bgColor : 'white',
    PaperProps: {
      className: clsx(classes.dialog, modalDarkMode && classes.modalBackgroundColor, modalDarkMode && 'modalDarkMode', colorData && classes["bgcolor-".concat(colorData.bgColor)]),
      id: 'callBackFormModalElement'
    }
  }, /*#__PURE__*/React__default.createElement("form", {
    id: "callBackForm",
    autoComplete: "off",
    noValidate: true,
    ref: formRef,
    className: classes.form,
    onSubmit: function onSubmit(e) {
      return e.preventDefault();
    }
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    id: "formElm",
    container: true
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 12,
    id: "formElmItem"
  }, showUpwordButton && /*#__PURE__*/React__default.createElement("div", {
    className: "unwordArrowWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    onClick: handleOnPrevClick,
    className: classes.upwordArrowBox,
    "data-locator": CALLBACKFORM_PAGE_UPWORD_ARROW
  }, /*#__PURE__*/React__default.createElement("span", {
    className: clsx(classes.upwordArrowIcon, 'icon-action-white')
  }, /*#__PURE__*/React__default.createElement(NamedIcon$1, {
    icon: 'double-chevron-up'
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: classes.upwordArrowGradient
  }, "\xA0")), /*#__PURE__*/React__default.createElement("div", {
    id: "formInnerWrapper",
    className: clsx('motionFade', classes.formInnerWrapper, pageNames$1[activePage])
  }, /*#__PURE__*/React__default.createElement("div", {
    id: "enquiryTag",
    className: clsx('weightBlack', classes.formTypeLabel, _defineProperty({}, classes.formtypeLabelHide, pageNames$1[activePage] === 'summaryPage'))
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    className: clsx(classes.formType, pageNames$1[activePage], 'formTypeBright'),
    variant: "body5",
    component: "p",
    "data-locator": FORM_SECTION_FORM_TYPE,
    ref: formTypeRef,
    color: modalDarkMode ? 'orange' : 'white'
  }, t('enquiry'))), errorCode && errorCode !== 200 && /*#__PURE__*/React__default.createElement(ApiErrorForms, {
    title: t('apiErrorMessageForm'),
    errors: apiStatus,
    formtype: params.formType
  }), globalError && /*#__PURE__*/React__default.createElement(ApiErrorForms, {
    title: globalValidationError,
    errors: globalValidationError,
    formtype: params.formType
  }), showLoader && /*#__PURE__*/React__default.createElement("div", {
    className: classes.apiProgressWrapper
  }, /*#__PURE__*/React__default.createElement(Progress, {
    background: loaderBgcolor,
    title: t('sending'),
    pageCentered: true,
    showInModal: false
  })), /*#__PURE__*/React__default.createElement("ul", {
    id: "ulElm",
    className: clsx(classes.formContainerList, _defineProperty({}, classes.saveLeadForm, isSaveLead)),
    "data-locator": CALLBACKFORM_PAGE_WRAPPER$1,
    ref: listRef
  }, fields && fields.items && fields.items.map(function (item, index) {
    var fieldType = item.fields['Field Type'];
    var fieldTypeUrl = getFieldType(fieldType.url);
    var fieldKey = item.fields['Field Key'] ? item.fields['Field Key'].value : '';
    var pageClassnameById = pagesClassname$1[item.id] ? pagesClassname$1[item.id] : '';

    if (activePage !== item.id) {
      var _clsx3;

      var displayValue = getUserFilledValue(formValues$1[item.id], pageNames$1[item.id]);
      {
        // eslint-disable-line no-lone-blocks
        displayValue && pagesID.indexOf(activePage) < index && (editModeList = false);
      }
      var parent = true;
      var requirePageIds = Object.keys(requirePages);

      if (requirePageIds.indexOf(item.id) !== -1) {
        if (requirePages[item.id].parent) {
          parent = childValidate(item.id, requirePages, formValues$1, true);
        }
      }

      return /*#__PURE__*/React__default.createElement("li", {
        key: index,
        id: "li".concat(index),
        "data-locator": CALLBACKFORM_FORMVALUE_LIST$1,
        className: clsx("page-i".concat(index), pagesClassname$1[item.id], pageNames$1[item.id], (_clsx3 = {}, _defineProperty(_clsx3, classes.filledList, displayValue), _defineProperty(_clsx3, "filledList", displayValue), _defineProperty(_clsx3, classes.unFilledList, !displayValue), _defineProperty(_clsx3, classes.haveChild, !parent), _defineProperty(_clsx3, "conditionalPage", conditionalPages$1.includes(item.id)), _clsx3)),
        onClick: function onClick() {
          return displayValue ? handleOnPageClick(item.id) : null;
        },
        style: !displayValue ? {
          top: !editModeList ? '-' + activeListHeight + 'px' : '0'
        } : {}
      }, displayValue && pagesID.indexOf(activePage) < index && (editModeList = true), displayValue ? /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        className: classes.formLabel,
        variant: "body1",
        component: "p"
      }, formValues$1[item.id] && Object.values(formValues$1[item.id])[0] ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Object.values(formValues$1[item.id])[0]['label'], ' ', /*#__PURE__*/React__default.createElement("span", {
        className: clsx('weightBold', classes.formFilledValue)
      }, item.name === 'dobPage' ? displayValue : displayValue.toLowerCase())) : '') : /*#__PURE__*/React__default.createElement("div", null, "\xA0"));
    } else {
      if (fieldTypeUrl === PageType) {
        if (actionItems$1[fieldKey]) {
          if (evalCondition(actionItems$1, fieldKey)) {
            return activePage === item.id && [/*#__PURE__*/React__default.createElement("li", {
              key: index,
              id: "li".concat(index),
              ref: activePageList,
              "data-locator": CALLBACKFORM_FORMVALUE_LIST$1,
              className: clsx(classes.activeInputList, "page-i".concat(index), 'activeList', item.name, pagesClassname$1[item.id], editModeList && 'editModeList', {
                conditionalPage: conditionalPages$1.indexOf(item.id) !== -1 || pageClassnameById.indexOf('darkMode') !== -1
              })
            }, /*#__PURE__*/React__default.createElement("span", {
              className: 'listIcon'
            }), /*#__PURE__*/React__default.createElement(PageRenderer$1, {
              items: item.items,
              displayName: item.displayName,
              register: register,
              key: item.id,
              watchers: watchers,
              actionItems: actionItems$1,
              errors: errors,
              formtype: params.formType,
              enterKeyInfo: t('enterKeyInfo'),
              mode: modalDarkMode ? 'dark' : 'light',
              clearError: clearError,
              pageValue: formValues$1[activePage] ? formValues$1[activePage] : undefined,
              isShowNext: isShowNext,
              setIsShowNext: setIsShowNext,
              data: {
                isSubmitDisable: isSubmitDisable,
                backgroundColor: backgroundColor
              },
              handleOnFormValueChange: handleOnFormValueChange,
              evalCondition: evalCondition,
              siteName: siteName,
              siteLanguage: siteLanguage,
              triggerValidation: triggerValidation,
              dictionary: dictionary
            }))];
          } else {
            return null;
          }
        } else {
          var PageRenderContent = activePage === item.id && [/*#__PURE__*/React__default.createElement("li", {
            key: index,
            id: "li".concat(index),
            "data-locator": CALLBACKFORM_FORMVALUE_LIST$1,
            ref: activePageList,
            className: clsx(classes.activeInputList, "page-i".concat(index), 'activeList', item.name, pagesClassname$1[item.id], editModeList && 'editModeList', {
              conditionalPage: conditionalPages$1.indexOf(item.id) !== -1 || pagesClassname$1[item.id].indexOf('darkMode') !== -1
            })
          }, /*#__PURE__*/React__default.createElement("span", {
            className: 'listIcon'
          }), /*#__PURE__*/React__default.createElement(PageRenderer$1, {
            items: item.items,
            displayName: item.displayName,
            register: register,
            key: item.id,
            watchers: watchers,
            actionItems: actionItems$1,
            activePage: activePage,
            onNextClick: handleOnNextClick,
            errors: errors,
            formtype: get$1(params, 'formType', null),
            clearError: clearError,
            enterKeyInfo: t('enterKeyInfo'),
            mode: modalDarkMode ? 'dark' : 'light',
            pageValue: formValues$1[activePage] ? formValues$1[activePage] : undefined,
            isShowNext: isShowNext,
            setIsShowNext: setIsShowNext,
            data: {
              isSubmitDisable: isSubmitDisable,
              backgroundColor: backgroundColor,
              formAPIPayload: persistEmailPayload
            },
            handleOnFormValueChange: handleOnFormValueChange,
            evalCondition: evalCondition,
            siteName: siteName,
            siteLanguage: siteLanguage,
            triggerValidation: triggerValidation,
            dictionary: dictionary
          }))];
          return PageRenderContent;
        }
      } else {
        return activePage === item.id && [/*#__PURE__*/React__default.createElement("li", {
          key: index,
          id: "li".concat(index),
          "data-locator": CALLBACKFORM_FORMVALUE_LIST$1,
          className: clsx(classes.activeInputList, "page-i".concat(index), 'activeList', item.name, {
            conditionalPage: conditionalPages$1.indexOf(item.id) !== -1
          })
        }, /*#__PURE__*/React__default.createElement("span", {
          className: 'listIcon'
        }), /*#__PURE__*/React__default.createElement(PageRenderer$1, {
          items: item.items,
          displayName: item.displayName,
          register: register,
          key: item.id,
          watchers: watchers,
          actionItems: actionItems$1,
          activePage: activePage,
          clearError: clearError,
          onNextClick: handleOnNextClick,
          errors: errors,
          formtype: params.formType,
          enterKeyInfo: t('enterKeyInfo'),
          mode: modalDarkMode ? 'dark' : 'light',
          pageValue: formValues$1[activePage] ? formValues$1[activePage] : undefined,
          isShowNext: isShowNext,
          setIsShowNext: setIsShowNext,
          data: {
            isSubmitDisable: isSubmitDisable,
            backgroundColor: backgroundColor
          },
          handleOnFormValueChange: handleOnFormValueChange,
          evalCondition: evalCondition,
          siteName: siteName,
          siteLanguage: siteLanguage,
          triggerValidation: triggerValidation,
          dictionary: dictionary
        }))];
      }
    }
  }))))))));
}; // const mapStateToProps = createStructuredSelector({

//   loader: () => import('../CalculateForm'),
//   loading() {
//     return <></>;
//   },
// });
// const LoadableEnquiryForm = Loadable({
//   loader: () => import('../EnquiryForm'),
//   loading() {
//     return <></>;
//   },
// });
// const LoadableCallbackForm = Loadable({
//   loader: () => import('../CallbackForm'),
//   loading() {
//     return <></>;
//   },
// });

var FormsHOC$1 = function FormsHOC(props) {
  var sitecoreContext = get$1(props, 'sitecoreContext', {});
  var productDetails = get$1(props, 'productDetails', {});
  var formLinks = get$1(props, 'formLinks', {});
  var apiStatus = get$1(props, 'apiStatus', {});
  var finalizer = get$1(props, 'finalizer', '');
  var form = get$1(props, 'form', {});
  var formModalState = get$1(props, 'formModalState', false);
  var formName = get$1(productDetails, 'initializer', null) || null;
  var submitAction = get$1(props, 'submitAction', null);
  var dictionary = get$1(props, 'dictionary', undefined);
  var disableFormSubmittedValues = get$1(props, 'disableFormSubmittedValues', false);
  var formElement = '';

  if (formModalState) {
    if (formName === calculatorInitializers.CALCULATOR || formName === calculatorInitializers.RECOMMENDER) ; else if (formName === calculatorInitializers.ENQUIRY) ; else if (formName === calculatorInitializers.BOOKANAGENT) {
      formElement = /*#__PURE__*/React__default.createElement(CallbackForm, {
        sitecoreContext: sitecoreContext,
        getProductDetails: productDetails,
        getFormLinks: formLinks,
        getFinalizer: finalizer,
        apiStatus: apiStatus,
        form: form,
        updateFormModalState: props.updateFormModalState,
        resetAPIStatus: props.resetAPIStatus,
        submitAction: submitAction,
        dictionary: dictionary,
        disableFormSubmittedValues: disableFormSubmittedValues
      });
    }
  }

  return formElement;
}; // export const mapStateToProps = createStructuredSelector({
//   productDetails: getProductDetails,
//   formModalState: getFormModalState,
//   finalizer: getFinalizer,
//   apiStatus: getAPIStatus,
// });
// export default withTheme(withSitecoreContext()(connect(mapStateToProps, '')(FormsHOC)));


var NextGenFormsHOC = withTheme$1(FormsHOC$1);

var styles$I = function styles(theme) {
  return {
    cookieHeader: function cookieHeader(_ref) {
      var surfaceColor = _ref.surfaceColor;
      return _defineProperty({
        background: theme.palette.colors[surfaceColor].main,
        boxShadow: '0 -2px 4px 0 rgba(0,0,0,0.2)',
        position: 'fixed',
        bottom: '0',
        width: '100%',
        zIndex: '999',
        padding: "".concat(theme.spacing(2), "px ").concat(theme.spacing(2), "px ").concat(theme.typography.pxToRem(13))
      }, theme.breakpoints.up('sm'), {
        padding: "".concat(theme.spacing(2), "px ").concat(theme.spacing(6), "px")
      });
    },
    cookieMessageWrapper: function cookieMessageWrapper(_ref3) {
      var surfaceColor = _ref3.surfaceColor;
      return {
        '& p': {
          margin: 0
        },
        '& .MuiTypography-root a': {
          color: theme.palette.colors[surfaceColor].contrastText,
          fontWeight: theme.typography.fontWeights.normal
        }
      };
    },
    cookieBtn: {
      borderColor: theme.palette.colors.white.main,
      color: theme.palette.colors.white.main
    },
    cookieBtnWrapper: _defineProperty({
      marginLeft: theme.spacing(2)
    }, theme.breakpoints.up('sm'), {
      marginLeft: theme.spacing(6)
    })
  };
};

var COMPONENT_WRAPPER$1 = 'Cookie-Banner-Wrapper';
var COMPONENT_MESSAGE = 'Cookie-Banner-Message';
var COMPONENT_MESSAGE_WRAPPER = 'Cookie-Banner-Message-Wrapper';
var COMPONENT_BUTTON_WRAPPER$2 = 'Cookie-Banner-Button-Wrapper';
var COMPONENT_BUTTON$6 = 'Cookie-Banner-Button';

var useStyles$N = makeStyles(function (theme) {
  return styles$I(theme);
});

var CookieBanner$1 = function CookieBanner(props) {
  var _props$backgroundColo = props.backgroundColor,
      backgroundColor = _props$backgroundColo === void 0 ? 'white-orange' : _props$backgroundColo;

  var _getColors = getColors(backgroundColor),
      surfaceColor = _getColors.surfaceColor;

  var classes = useStyles$N({
    surfaceColor: surfaceColor
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showCookieBanner = _useState2[0],
      setShowCookieBanner = _useState2[1];

  var setCookieBannerExist = get$1(props, 'setCookieBannerExist', null);

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;
  /**
   * Getting Dictionary Service from props
   * Its will be used to get different global messages
   */
  // const { t: dictionaryService } = useTranslation();
  // const btnText = dictionaryService('ok');


  var btnText = get$1(props, 'btnText', 'OK');
  /**
   * Getting Sitecore Context from props
   * Its will be used to get different values from context
   */

  var siteSettings = get$1(props, 'sitecoreContext.siteSettings', {});
  var cookieMessage = {
    value: siteSettings && siteSettings.cookieMessage
  };
  var cookieExpiryDays = siteSettings && siteSettings.cookieTimeStamp || null;
  var cookieMessageElement = document.createElement('object');
  cookieMessageElement.innerHTML = cookieMessage.value;
  /**
   * Cookie accept handler which will store in local storage that we have read the cookie
   */

  var acceptCookieHandler = function acceptCookieHandler() {
    PushEvent({
      event: 'buttonClick',
      buttonTitle: 'ok',
      componentName: COMPONENT_BUTTON$6,
      destinationUrl: undefined
    });
    setShowCookieBanner(false);
    localStorage.setItem('cookieBannerRead', true);
    localStorage.setItem('cookieBannerReadDate', moment().format());
    setCookieBannerExist(false);

    if (typeof window !== 'undefined') {
      if (window.$zopim === undefined || window.$zopim.livechat === undefined) {
        return;
      }

      window.$zopim(function () {
        window.$zopim.livechat.button.setOffsetVertical(20);
        window.$zopim.livechat.button.setOffsetVerticalMobile(24);
      });
    }
  };
  /**
   * Use effect is used to check if we have already read the cookie
   */


  useEffect(function () {
    var cookieBannerRead = localStorage.getItem('cookieBannerRead');
    var cookieBannerReadDate = localStorage.getItem('cookieBannerReadDate');
    var cookieBannerReadExpiringDate = cookieExpiryDays ? moment(cookieBannerReadDate).add(cookieExpiryDays, 'days') : moment(cookieBannerReadDate);
    var cookieBannerReadExpired = cookieExpiryDays ? cookieBannerReadExpiringDate < moment() : false;

    if (!cookieBannerRead || cookieBannerReadExpired) {
      setShowCookieBanner(true);
      setCookieBannerExist(true);
    } else {
      setCookieBannerExist(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showCookieBanner && cookieMessage && cookieMessage.value && /*#__PURE__*/React__default.createElement("section", {
    className: classes.cookieHeader
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    "data-locator": COMPONENT_WRAPPER$1
  }, /*#__PURE__*/React__default.createElement(Box, {
    alignSelf: "center",
    className: classes.cookieMessageWrapper,
    "data-locator": COMPONENT_MESSAGE_WRAPPER
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "bodyxs1",
    component: "div",
    color: surfaceColor,
    "data-locator": COMPONENT_MESSAGE,
    type: 'richtext'
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: cookieMessage.value
    }
  }))), /*#__PURE__*/React__default.createElement(Box, {
    alignSelf: "center",
    className: classes.cookieBtnWrapper,
    "data-locator": COMPONENT_BUTTON_WRAPPER$2
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
    color: surfaceColor,
    onClick: acceptCookieHandler,
    className: clsx(classes.cookieBtn, _defineProperty({}, 'showFocusOnButton', useKeyBoard)),
    "data-locator": COMPONENT_BUTTON$6,
    alt: btnText,
    tabIndex: 0
  }, btnText)))));
}; // const mapDispatchToProps = dispatch => {
//   return {
//     setCookieBannerExist: params => dispatch(actions.setCookieBannerExist(params)),
//   };
// };
// export default withSitecoreContext()(connect(null, mapDispatchToProps)(React.memo(CookieBanner)));


var NextGenCookieBanner = /*#__PURE__*/React__default.memo(CookieBanner$1);

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$H = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 32,
      whiteSpace: 'nowrap',
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: 'default',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      textDecoration: 'none',
      padding: 0,
      // Remove `button` padding
      verticalAlign: 'middle',
      textTransform: 'lowercase',
      boxSizing: 'border-box',
      borderRadius: theme.spacing(0.5),
      fontWeight: theme.typography.fontWeights.normal,
      '&.MuiChip-clickable': {
        cursor: 'pointer'
      },

      /* Styles applied to the root element if `size="small"`. */
      '&.MuiChip-sizeSmall': {
        height: 'auto',
        lineHeight: theme.typography.lineHeight.L15,
        fontSize: theme.typography.T11,
        '& span': {
          paddingTop: '2px',
          paddingBottom: '2px'
        }
      },
      '& .MuiChip-label': {
        overflow: 'visible'
      }
    }
  };
};

var _excluded$2 = ["classes", "color"];
var useStyles$M = makeStyles(styles$H);
/**
 * Material UI Chip - allow users to enter information, make selections, filter content, or trigger actions.
 * @param {object} classes - For overriding or extend the styles applied. Default value is 'inheritClasses'
 * @param {string} color - default value is 'white'
 */

var FwdChip = function FwdChip(_ref) {
  var inheritClasses = _ref.classes,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'white' : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded$2);

  var classes = useStyles$M();
  return /*#__PURE__*/React__default.createElement(Chip$1, _extends({
    className: clsx("chipColor-".concat(color), classes.root, inheritClasses)
  }, props));
};

var styles$G = function styles(theme) {
  var _shareHorizontalView, _close;

  var colors = theme.palette.colors || {};
  var theming = {};
  Object.keys(colors).forEach(function (color) {
    theming["wechat-".concat(color)] = {
      '& $close': {
        backgroundColor: theme.palette.colors[color].main,
        '& path': {
          fill: theme.palette.colors[color].secondaryIcon
        },
        '&:hover': {
          '& path': {
            fill: theme.palette.colors[color].main
          },
          backgroundColor: theme.palette.colors[color].contrastTextAction
        }
      }
    };
  });
  return _objectSpread2({
    shareHorizontalViewElement: {
      outline: 'none'
    },
    shareHorizontalView: (_shareHorizontalView = {
      display: 'flex',
      flexWrap: 'wrap',
      marginBottom: theme.spacing(-2.5)
    }, _defineProperty(_shareHorizontalView, theme.breakpoints.up('sm'), {
      marginBottom: theme.spacing(-3)
    }), _defineProperty(_shareHorizontalView, '& > span, > div', _defineProperty({
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: theme.spacing(2.5),
      marginBottom: theme.spacing(2.5)
    }, theme.breakpoints.up('sm'), {
      marginRight: theme.spacing(3),
      marginBottom: theme.spacing(3)
    })), _defineProperty(_shareHorizontalView, '& svg, & img, & div', _defineProperty({
      height: theme.spacing(5),
      width: theme.spacing(5)
    }, theme.breakpoints.up('sm'), {
      height: theme.spacing(6),
      width: theme.spacing(6)
    })), _shareHorizontalView),
    menuItem: {
      color: fwdColors.darkGreen,
      '&:hover': {
        backgroundColor: fwdColors.orange,
        color: fwdColors.white,
        '& .menuTextStyle': {
          color: fwdColors.white
        },
        '& .zalo-share-button': {
          '& img': {
            filter: 'brightness(0) invert(1)'
          }
        }
      },
      '&.keyboardFocused': {
        '&:focus': {
          backgroundColor: fwdColors.orange,
          color: fwdColors.white,
          '& .menuTextStyle': {
            color: fwdColors.white
          }
        }
      },
      '& .zalo-share-button': {
        display: 'flex',
        alignItems: 'center'
      }
    },
    transparent: {},
    shareButtonStyle: {
      display: 'flex',
      cursor: 'pointer',
      outline: 'none',
      width: theme.spacing(5),
      height: theme.spacing(5),
      padding: theme.spacing(1),
      '&$transparent': {
        background: 'transparent'
      },
      '& svg, & img': {
        width: '100%',
        height: '100%',
        '&:focus': {
          outline: '1px solid transparent'
        }
      }
    },
    qrCodeModalRoot: {
      zIndex: '1500 !important'
    },
    qrCodeModalPaper: {
      width: '100%'
    },
    wrapper: {
      position: 'relative',
      maxWidth: '100%',
      margin: '0 auto',
      width: theme.spacing(43),
      padding: theme.spacing(3),
      borderRadius: theme.spacing(2),
      backgroundColor: 'white'
    },
    close: (_close = {
      position: 'absolute',
      width: theme.spacing(5),
      height: theme.spacing(5),
      borderRadius: '50%',
      right: theme.spacing(-2.5),
      top: theme.spacing(-2.5),
      zIndex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer'
    }, _defineProperty(_close, theme.breakpoints.down('sm'), {
      width: theme.spacing(4),
      height: theme.spacing(4),
      right: theme.spacing(-2),
      top: theme.spacing(-2)
    }), _defineProperty(_close, "boxShadow", '0 2px 4px 0 rgba(0,0,0,0.2)'), _close),
    closeIcon: {
      height: theme.spacing(3),
      width: theme.spacing(3)
    },
    title: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(2)
    },
    description: {
      marginBottom: theme.spacing(3)
    },
    qrCodeWrapper: {
      textAlign: 'center',
      marginBottom: theme.spacing(2.5)
    },
    emailMenuH: {
      '& .emailIconH': {
        width: theme.spacing(6),
        height: theme.spacing(6),
        '& svg.MuiSvgIcon-root': {
          width: theme.spacing(4),
          height: theme.spacing(4)
        }
      }
    },
    emailMenu: {
      '&:hover': {
        '& .branding-icon': {
          backgroundColor: fwdColors.white
        },
        '& path': {
          fill: fwdColors.orange
        }
      }
    },
    emailIcon: {
      '& svg.MuiSvgIcon-root': {
        width: theme.typography.pxToRem(21),
        height: theme.typography.pxToRem(21)
      }
    }
  }, theming);
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var MENU_VIEW_CONTAINER = 'SocialShare-VerticleContainer';
var HORIZONTAL_VIEW_CONTAINER = 'SocialShare-HorizontalContainer';
var SOCIAL_SHARE_COMPONENT = 'SocialShare-';
var SOCIAL_SHARE_LIST = 'SocialShare-list';
var SOCIAL_SHARE_WECHAT_MODAL_CLOSE_BUTTON = 'SocialShare-WeChat-Modal-Close-Button';
var SOCIAL_SHARE_WECHAT_MODAL_TITLE = 'SocialShare-WeChat-Modal-Title';
var SOCIAL_SHARE_WECHAT_MODAL_DESCRIPTION = 'SocialShare-WeChat-Modal-Description';
var SOCIAL_SHARE_WECHAT_MODAL_QRCODE = 'SocialShare-WeChat-Modal-QrCode';
var SOCIAL_SHARE = 'Share';

var useStyles$L = makeStyles(function (theme) {
  return styles$G(theme);
});
var whatsappMobileHref = "whatsapp://send?text=";
var viberMobileHref = "viber://forward?text=";
/**
 * @param {string} bgColor - default color is white
 * @param {boolean} transparent - default value is set to false
 */

var SocialShare$1 = function SocialShare(props) {
  var _props$sitecoreContex, _props$sitecoreContex2, _props$sitecoreContex3, _props$sitecoreContex4, _props$sitecoreContex5, _zaloGTM$value$value, _zaloGTM$value, _filteredShareOptions, _clsx3, _ref;

  // const { t } = useTranslation();
  var dictionary = get$1(props, "dictionary", {
    wechatmodaltitle: "wechatmodaltitle",
    wechatmodaldescription: "wechatmodaldescription"
  });

  var t = function t(key) {
    return dictionary[key];
  };

  var _props$bgColor = props.bgColor,
      bgColor = _props$bgColor === void 0 ? "white" : _props$bgColor,
      _props$transparent = props.transparent,
      transparent = _props$transparent === void 0 ? false : _props$transparent,
      _props$sharedUrl = props.sharedUrl,
      sharedUrl = _props$sharedUrl === void 0 ? "" : _props$sharedUrl,
      _props$shareOptions = props.shareOptions,
      shareOptions = _props$shareOptions === void 0 ? [] : _props$shareOptions,
      _props$useExternalBut = props.useExternalButton,
      useExternalButton = _props$useExternalBut === void 0 ? false : _props$useExternalBut,
      _props$allowQueryPara = props.allowQueryParams,
      allowQueryParams = _props$allowQueryPara === void 0 ? false : _props$allowQueryPara,
      _props$extraGAData = props.extraGAData,
      extraGAData = _props$extraGAData === void 0 ? {} : _props$extraGAData;
  var classes = useStyles$L({
    bgColor: bgColor
  });

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;

  var _useState = useState(shareOptions),
      _useState2 = _slicedToArray(_useState, 2),
      filteredShareOptions = _useState2[0],
      setFilteredShareOptions = _useState2[1];

  var routeFields = (_props$sitecoreContex = props.sitecoreContext) === null || _props$sitecoreContex === void 0 ? void 0 : (_props$sitecoreContex2 = _props$sitecoreContex.route) === null || _props$sitecoreContex2 === void 0 ? void 0 : _props$sitecoreContex2.fields;
  var zaloGTM = (_props$sitecoreContex3 = props.sitecoreContext) === null || _props$sitecoreContex3 === void 0 ? void 0 : (_props$sitecoreContex4 = _props$sitecoreContex3.siteSettings) === null || _props$sitecoreContex4 === void 0 ? void 0 : (_props$sitecoreContex5 = _props$sitecoreContex4.gtmParamters) === null || _props$sitecoreContex5 === void 0 ? void 0 : _props$sitecoreContex5.find(function (el) {
    return el.key.value.indexOf("zalo") !== -1;
  });
  var zaloOAID = (_zaloGTM$value$value = zaloGTM === null || zaloGTM === void 0 ? void 0 : (_zaloGTM$value = zaloGTM.value) === null || _zaloGTM$value === void 0 ? void 0 : _zaloGTM$value.value) !== null && _zaloGTM$value$value !== void 0 ? _zaloGTM$value$value : "4031694726435746938"; // making sure the keys are lowercase

  shareOptions = shareOptions.reduce(function (acc, v) {
    acc.push(_defineProperty({}, Object.keys(v)[0].toLowerCase(), Object.values(v)[0]));
    return acc;
  }, []);
  useEffect(function () {
    /* istanbul ignore else */
    if (typeof window !== "undefined") {
      var tempFilteredShareOptions = (window.DeviceDetection.isMobile || window.DeviceDetection.isTablet) && !navigator.share ? shareOptions.filter(function (option) {
        return !option["wechat"];
      }).filter(function (option) {
        return get$1(Object.values(option), "[0].url.value.href", "") || option["email"];
      }) : shareOptions.filter(function (option) {
        return option["wechat"] || option["email"] || !option["wechat"] && get$1(Object.values(option), "[0].url.value.href", "");
      });
      tempFilteredShareOptions.length && tempFilteredShareOptions.forEach(function (option, index) {
        option["icon"] = renderIcon(Object.keys(tempFilteredShareOptions[index])[0]);
        option["identifier"] = Object.keys(tempFilteredShareOptions[index])[0];
        return option;
      });
      setFilteredShareOptions(tempFilteredShareOptions);
    }
  }, []); // states

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      anchorEl = _useState4[0],
      setAnchorEl = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      qrCodeModalState = _useState6[0],
      setQrCodeModalState = _useState6[1];

  var _useState7 = useState(""),
      _useState8 = _slicedToArray(_useState7, 2),
      qrCodeEmbeddedUrl = _useState8[0],
      setQrCodeEmbeddedUrl = _useState8[1];

  var _useState9 = useState(""),
      _useState10 = _slicedToArray(_useState9, 2),
      zaloSharingUrl = _useState10[0],
      setZaloSharingUrl = _useState10[1]; // methods

  /**
   * Callback function used to set the selected card index
   */


  var handleClick = function handleClick(event) {
    event.preventDefault();
    props.handleSelectedCardIndex && props.handleSelectedCardIndex();
    setAnchorEl(event.currentTarget);
    props.setPopperState && props.setPopperState(true);
    var gaCategoryName = props.gaCategoryName;
    var componentName = gaCategoryName || props.dataLocator;
    PushEvent(_objectSpread2({
      event: "buttonClick",
      buttonTitle: SOCIAL_SHARE,
      componentName: componentName,
      destinationUrl: ""
    }, extraGAData));
  };

  var getSharingURL = function getSharingURL() {
    /* istanbul ignore else */
    if (typeof window !== "undefined") {
      var sharedItemName = props.sharedItemName;
      var shareHost = window.location.toString();
      shareHost = shareHost.replace("&", "%26");
      var selectedCardIndex = props.selectedCardIndex;
      /* istanbul ignore else */

      if (!allowQueryParams) {
        shareHost = shareHost.indexOf("?") !== -1 ? shareHost.substring(0, shareHost.indexOf("?")) : shareHost;
      }

      if (allowQueryParams && sharedItemName === "Plan comparison") {
        return shareHost;
      }

      selectedCardIndex = props.selectedCardIndex !== undefined && props.selectedCardIndex !== "" ? "?plancard=" + selectedCardIndex : "";

      if (sharedUrl) {
        if (sharedUrl.search(/http(s)?:/) !== 0) {
          shareHost = shareHost.substring(0, shareHost.indexOf(window.location.pathname)) + sharedUrl;
        } else {
          shareHost = sharedUrl;
        }
      } else {
        var openGraphURL = document.querySelector('meta[property="og:url"]') ? document.querySelector('meta[property="og:url"]').getAttribute("content") : "";
        shareHost = openGraphURL || shareHost;
      }
      /* istanbul ignore else */


      if (shareHost.search(/http(s)?:/) !== 0) {
        shareHost = window.location.origin + shareHost;
      }

      return shareHost + selectedCardIndex;
    }

    return "";
  };

  useLayoutEffect(function () {
    setZaloSharingUrl(getSharingURL());
  });
  /**
   * Open new browser window to share on the basis of choice
   */

  var handleShareOption = function handleShareOption(e, social_media, option) {
    /* istanbul ignore else */
    if (e !== null || social_media !== "zalo") {
      e.preventDefault();
      e.stopPropagation();
    }

    var gaCategoryName = props.gaCategoryName;
    var componentName = gaCategoryName || props.dataLocator;
    var url = option.url;
    /* 7737 changes, sitecontext -- socialApps */

    PushEvent({
      event: "social_share",
      buttonTitle: get$1(url, "value.text") || getGTMSharedKeyVal(get$1(url, "value.href", ""), props.dataLocator),
      sharedItemName: props.sharedItemName,
      social_network: social_media,
      componentName: componentName
    });
    /* istanbul ignore else */

    if (social_media === "zalo") {
      return;
    }
    /* istanbul ignore else */


    if (typeof window !== "undefined") {
      var sharingUrl = getSharingURL();
      var finalSharedUrl;

      if (social_media === "whatsapp" && window.DeviceDetection.isMobile) {
        finalSharedUrl = "".concat(whatsappMobileHref).concat(sharingUrl);
      } else if (social_media === "viber") {
        finalSharedUrl = viberMobileHref + get$1(url, "value.text", "") + " " + sharingUrl;
        /* istanbul ignore else */

        if (window.DeviceDetection.isMobile) {
          finalSharedUrl = get$1(url, "value.href", "") + finalSharedUrl;
        }
      } else {
        finalSharedUrl = get$1(url, "value.href", "") + "" + sharingUrl;
      }

      if (social_media === "wechat") {
        if (window.DeviceDetection.isDesktop) {
          setQrCodeEmbeddedUrl(finalSharedUrl);
          setQrCodeModalState(true);
          setAnchorEl(false);
        } else {
          navigator.share({
            title: t("wechatmodaltitle"),
            url: finalSharedUrl
          });
        }
      } else if (social_media === "email") {
        var _routeFields$openGrap, _routeFields$metadata, _option$body, _routeFields$openGrap2, _routeFields$metadata2, _option$subject;

        var title = (routeFields === null || routeFields === void 0 ? void 0 : (_routeFields$openGrap = routeFields.openGraphTitle) === null || _routeFields$openGrap === void 0 ? void 0 : _routeFields$openGrap.value) || (routeFields === null || routeFields === void 0 ? void 0 : (_routeFields$metadata = routeFields.metadataTitle) === null || _routeFields$metadata === void 0 ? void 0 : _routeFields$metadata.value);
        var emailBody = option === null || option === void 0 ? void 0 : (_option$body = option.body) === null || _option$body === void 0 ? void 0 : _option$body.value.replace(/\\n/g, "\n").replace("{title}", title).replace("{description}", (routeFields === null || routeFields === void 0 ? void 0 : (_routeFields$openGrap2 = routeFields.openGraphDescription) === null || _routeFields$openGrap2 === void 0 ? void 0 : _routeFields$openGrap2.value) || (routeFields === null || routeFields === void 0 ? void 0 : (_routeFields$metadata2 = routeFields.metadataDescription) === null || _routeFields$metadata2 === void 0 ? void 0 : _routeFields$metadata2.value));
        emailBody = encodeURIComponent(emailBody).replace("%7Burl%7D", finalSharedUrl);
        window.location.assign("mailto:?subject=".concat(option === null || option === void 0 ? void 0 : (_option$subject = option.subject) === null || _option$subject === void 0 ? void 0 : _option$subject.value.replace("{title}", title), "&body=").concat(emailBody));
      } else {
        window.open(finalSharedUrl, "popup", "width=600,height=600");
      }

      console.log("Share URL", finalSharedUrl);
    }
  };
  /**
   * To close the SocialShare popper
   */


  var handleClose = function handleClose(e) {
    e.preventDefault();
    e.stopPropagation();
    setAnchorEl(null);
    props.setPopperState && props.setPopperState(false);
  };

  var handleQrCodeModalState = function handleQrCodeModalState(e) {
    e.preventDefault();
    e.stopPropagation();
    setQrCodeModalState(false);
  };
  /**
   * Renders the icon corresponding to the keys
   */


  var renderIcon = function renderIcon(shareText) {
    //if the shareText does NOT corrospond to the required icon name add an if stmt

    /* istanbul ignore else */
    if (shareText.toLowerCase() === "email") {
      return /*#__PURE__*/React__default.createElement(BrandingIcon, {
        icon: "email",
        type: "primary",
        size: "md",
        shape: "circle",
        hasHoverEffect: false,
        className: props.varient === "horizontal" ? "emailIconH" : classes.emailIcon
      });
    }

    return /*#__PURE__*/React__default.createElement(NamedIcon$1, {
      icon: "".concat(shareText.toLowerCase())
    });
  };

  var intiZaloSdk = function intiZaloSdk() {
    /* istanbul ignore else */
    if (typeof window !== "undefined") {
      if (window.ZaloSocialSDK) {
        setTimeout(function () {
          window.ZaloSocialSDK.reload();
        }, 300);
      } else {
        setTimeout(function () {
          intiZaloSdk();
        }, 1000);
      }
    }
  };

  useLayoutEffect(function () {
    intiZaloSdk();
  });
  return (_filteredShareOptions = filteredShareOptions[0]) !== null && _filteredShareOptions !== void 0 && _filteredShareOptions.identifier ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.varient === "horizontal" ? /*#__PURE__*/React__default.createElement("div", {
    "data-locator": HORIZONTAL_VIEW_CONTAINER,
    className: clsx(classes.shareHorizontalView, _defineProperty({}, classes.hideFocusonClick, !useKeyBoard))
  }, filteredShareOptions.map(function (option, index) {
    var _clsx2;

    return /*#__PURE__*/React__default.createElement("span", {
      key: index,
      tabIndex: "0",
      className: clsx(classes.shareHorizontalViewElement, (_clsx2 = {}, _defineProperty(_clsx2, "showFocusOnButton", useKeyBoard), _defineProperty(_clsx2, classes.emailMenuH, option.identifier.toLowerCase() === "email"), _clsx2)),
      onClick: function onClick(e) {
        return handleShareOption(e, option.identifier.toLowerCase(), option[option.identifier]);
      },
      onKeyPress: function onKeyPress(e) {
        if (e.key === "Enter") {
          handleShareOption(e, option.identifier.toLowerCase(), option[option.identifier]);
        }
      },
      "data-locator": "".concat(SOCIAL_SHARE_COMPONENT).concat(option.identifier.toLowerCase(), "Element-H")
    }, option.identifier.toLowerCase() === "zalo" ? /*#__PURE__*/React__default.createElement("div", {
      className: "zalo-share-button",
      "data-href": zaloSharingUrl,
      "data-oaid": zaloOAID,
      "data-layout": "4",
      "data-color": "blue",
      "data-customize": "true"
    }, option.icon) : option.icon);
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: clsx(get$1(props, "className", ""), (_clsx3 = {}, _defineProperty(_clsx3, "icon-action-common", !useExternalButton && bgColor !== null), _defineProperty(_clsx3, "icon-action-".concat(bgColor), !useExternalButton && bgColor !== null), _defineProperty(_clsx3, classes.shareButtonStyle, !useExternalButton && bgColor !== null), _defineProperty(_clsx3, "showFocusOnButton", useKeyBoard), _clsx3)),
    tabIndex: 0,
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter") {
        handleClick(event);
      }
    },
    onClick: handleClick
  }, useExternalButton ? /*#__PURE__*/React__default.createElement("div", {
    onClick: handleClick,
    "data-locator": props.dataLocator,
    tabIndex: "0",
    focusable: true,
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter") {
        handleClick(event);
      }
    }
  }, props.children) : /*#__PURE__*/React__default.createElement(Share, {
    id: 'Share',
    className: clsx("motionColorTransition", [(_ref = {}, _defineProperty(_ref, classes.transparent, transparent), _defineProperty(_ref, "bg-color-".concat(bgColor), bgColor !== null), _defineProperty(_ref, "text-color-".concat(bgColor), bgColor !== "initial"), _defineProperty(_ref, classes.hideFocusonClick, !useKeyBoard), _ref)]),
    "data-locator": props.dataLocator,
    focusable: false
  })), /*#__PURE__*/React__default.createElement(Popper, {
    anchorEl: anchorEl,
    open: !!anchorEl,
    handleClose: handleClose,
    tabIndex: "0",
    dataLocator: "".concat(MENU_VIEW_CONTAINER, "-").concat(get$1(props, "dataLocatorIdentifier", "")),
    popperPlacement: props.popperPlacement ? props.popperPlacement : "bottom-end",
    disablePortal: get$1(props, "disablePortal", true)
  }, /*#__PURE__*/React__default.createElement(MenuList, {
    autoFocusItem: !!anchorEl,
    "data-locator": SOCIAL_SHARE_LIST,
    onKeyUp: function onKeyUp(e) {
      if (e.key === "Escape") {
        handleClose(e);
      }
    }
  }, filteredShareOptions.map(function (option, index) {
    var _clsx4;

    return /*#__PURE__*/React__default.createElement(MenuItem, {
      key: index,
      className: clsx(classes.menuItem, (_clsx4 = {}, _defineProperty(_clsx4, "keyboardFocused", useKeyBoard), _defineProperty(_clsx4, classes.emailMenu, option.identifier.toLowerCase() === "email"), _clsx4)),
      onClick: function onClick(e) {
        return handleShareOption(e, option.identifier.toLowerCase(), option[option.identifier]);
      },
      "data-locator": "SocialShare-".concat(option.identifier.toLowerCase(), "Element")
    }, option.identifier.toLowerCase() === "zalo" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "zalo-share-button",
      "data-href": zaloSharingUrl,
      "data-oaid": zaloOAID,
      "data-layout": "4",
      "data-color": "blue",
      "data-customize": "true"
    }, /*#__PURE__*/React__default.createElement("span", {
      "data-locator": "".concat(option.identifier.toLowerCase(), "-Icon"),
      className: "menuIconStyle"
    }, option.icon), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "body1",
      component: "h3",
      className: "menuTextStyle",
      "data-locator": "".concat(option.identifier.toLowerCase(), "-Text")
    }, /*#__PURE__*/React__default.createElement("span", null, option[option.identifier].header.value)))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
      "data-locator": "".concat(option.identifier.toLowerCase(), "-Icon"),
      className: "menuIconStyle"
    }, option.icon), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "body1",
      component: "h3",
      className: "menuTextStyle",
      "data-locator": "".concat(option.identifier.toLowerCase(), "-Text")
    }, /*#__PURE__*/React__default.createElement("span", null, option[option.identifier].header.value))));
  })))), qrCodeModalState && /*#__PURE__*/React__default.createElement(Dialog$1, {
    fullScreen: true,
    transparent: true,
    variant: "wechat",
    open: qrCodeModalState,
    onClose: handleQrCodeModalState,
    isFixed: true,
    disableEscapeKeyDown: true,
    disableBackdropClick: true,
    classes: {
      root: classes.qrCodeModalRoot,
      paper: classes.qrCodeModalPaper
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    position: "relative",
    display: "flex",
    alignItems: "center",
    height: "100vh"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.wrapper, _defineProperty({}, classes["wechat-".concat(bgColor)], bgColor))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.close,
    onClick: handleQrCodeModalState,
    "data-locator": SOCIAL_SHARE_WECHAT_MODAL_CLOSE_BUTTON
  }, /*#__PURE__*/React__default.createElement(Close, {
    className: classes.closeIcon
  })), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    component: "h3",
    variant: "h4",
    color: bgColor,
    className: classes.title,
    "data-locator": SOCIAL_SHARE_WECHAT_MODAL_TITLE
  }, t("wechatmodaltitle")), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    component: "p",
    variant: "body1",
    color: bgColor,
    className: classes.description,
    "data-locator": SOCIAL_SHARE_WECHAT_MODAL_DESCRIPTION
  }, t("wechatmodaldescription")), /*#__PURE__*/React__default.createElement("div", {
    className: classes.qrCodeWrapper
  }, /*#__PURE__*/React__default.createElement(QRCode, {
    value: qrCodeEmbeddedUrl,
    renderAs: "canvas",
    size: 160,
    fgColor: fwdColors.darkGreen,
    "data-color": fwdColors.darkGreen,
    "data-locator": SOCIAL_SHARE_WECHAT_MODAL_QRCODE
  })))))) : null;
}; // export default withSitecoreContext()(SocialShare);

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$F = function styles(theme) {
  var _rootContainerFeature, _rootContainerMarketi, _contentBlockFirst, _contentBlockMiddle, _contentBlockLast, _paddingBottomContent, _twoCtasPrimarySimp, _twoCTAs, _linkWrapper2, _theme$breakpoints$do, _alignCenter, _img, _media, _bottomLinkWrapper, _widthWithImageLeft, _downloadIcons, _featuredMediaCont2, _featured, _purchaseMethodWrappe;

  var colors = theme.palette.colors || {};
  var seperator = {};
  Object.keys(colors).forEach(function (color) {
    var _seperator$divider$c;

    seperator["divider-".concat(color)] = (_seperator$divider$c = {}, _defineProperty(_seperator$divider$c, theme.breakpoints.up('sm'), {
      borderLeft: "1px solid ".concat(colors[color].line.divider),
      marginBottom: '1px;'
    }), _defineProperty(_seperator$divider$c, "".concat(theme.breakpoints.down('xs'), " and (orientation: portrait)"), {
      borderTop: "1px solid ".concat(colors[color].line.divider)
    }), _seperator$divider$c);
  });
  return _objectSpread2(_objectSpread2({}, seperator), {}, {
    boxCss: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      height: '100%'
    },
    rootContainer: {
      '& h2': {
        fontWeight: theme.typography.fontWeights.bolder
      }
    },
    rootContainerMerged: {
      marginBottom: '-1px',
      '& h2': {
        fontWeight: theme.typography.fontWeights.bolder
      }
    },
    rootContainerFeatured: (_rootContainerFeature = {}, _defineProperty(_rootContainerFeature, theme.breakpoints.down('md'), {
      maxWidth: '490px'
    }), _defineProperty(_rootContainerFeature, theme.breakpoints.down('xs'), {
      maxWidth: 'unset'
    }), _rootContainerFeature),
    rootContainerMarketing: (_rootContainerMarketi = {}, _defineProperty(_rootContainerMarketi, theme.breakpoints.down('lg'), {
      maxWidth: '490px'
    }), _defineProperty(_rootContainerMarketi, theme.breakpoints.down('xs'), {
      maxWidth: 'unset'
    }), _rootContainerMarketi),
    flexiColBlocks: {
      '& .linkWrapper': _defineProperty({
        marginTop: theme.spacing(6)
      }, theme.breakpoints.up('sm'), {
        position: 'absolute',
        bottom: 0
      })
    },
    // Deprecated. Below styling is only supported up to 2 columns layout
    // contentBlock0: {
    //   position: 'relative',
    //   marginRight: theme.spacing(-1.5),
    //   [theme.breakpoints.only('sm')]: {
    //     paddingRight: theme.spacing(8),
    //   },
    //   /* IPad padding */
    //   [theme.breakpoints.up('sm')]: {
    //     paddingRight: theme.spacing(3),
    //     '& .twoCTAs button': {
    //       marginRight: theme.spacing(3),
    //     },
    //   },
    //   [theme.breakpoints.up('lg')]: {
    //     paddingRight: theme.spacing(8),
    //     '& .twoCTAs button': {
    //       marginRight: theme.spacing(8),
    //     },
    //   },
    //   [`${theme.breakpoints.down('sm')} and (orientation:portrait)`]: {
    //     paddingBottom: theme.spacing(0),
    //     marginRight: theme.spacing(0),
    //   },
    //   [`${theme.breakpoints.down('sm')} and (orientation:landscape)`]: {
    //     paddingRight: theme.spacing(3),
    //     '& button': {
    //       marginRight: theme.spacing(2),
    //     },
    //   },
    //   '& .linkWrapper a, & .linkWrapper button': {
    //     [theme.breakpoints.up('sm')]: {
    //       maxWidth: theme.spacing(41),
    //     },
    //   },
    // },
    // contentBlock1: {
    //   position: 'relative',
    //   paddingLeft: 0,
    //   [theme.breakpoints.only('sm')]: {
    //     paddingLeft: theme.spacing(8),
    //   },
    //   /* IPad padding */
    //   [theme.breakpoints.up('sm')]: {
    //     marginLeft: theme.spacing(-1.5),
    //     paddingLeft: theme.spacing(3),
    //   },
    //   [theme.breakpoints.up('lg')]: {
    //     paddingLeft: theme.spacing(8),
    //   },
    //   [`${theme.breakpoints.down('sm')} and (orientation:portrait) `]: {
    //     paddingBottom: theme.spacing(0),
    //   },
    //   [`${theme.breakpoints.down('sm')} and (orientation:landscape) `]: {
    //     paddingTop: theme.spacing(1.5),
    //     paddingLeft: theme.spacing(3),
    //   },
    //   '& .linkWrapper a, & .linkWrapper button': {
    //     [theme.breakpoints.up('sm')]: {
    //       maxWidth: theme.spacing(41),
    //     },
    //   },
    // },
    // FWDS-2934 Investify flexi container with 3 columns
    // Adding >= 3 columns layout (first, middle, last)
    contentBlockFirst: (_contentBlockFirst = {
      position: 'relative',
      marginRight: theme.spacing(-1.5)
    }, _defineProperty(_contentBlockFirst, theme.breakpoints.only('sm'), {
      paddingRight: theme.spacing(8)
    }), _defineProperty(_contentBlockFirst, theme.breakpoints.up('sm'), {
      paddingRight: theme.spacing(3),
      '& .twoCTAs button': {
        marginRight: theme.spacing(3)
      }
    }), _defineProperty(_contentBlockFirst, theme.breakpoints.up('lg'), {
      paddingRight: theme.spacing(8),
      '& .twoCTAs button': {
        marginRight: theme.spacing(8)
      }
    }), _defineProperty(_contentBlockFirst, "".concat(theme.breakpoints.down('sm'), " and (orientation:portrait)"), {
      paddingBottom: theme.spacing(0),
      marginRight: theme.spacing(0)
    }), _defineProperty(_contentBlockFirst, "".concat(theme.breakpoints.down('sm'), " and (orientation:landscape)"), {
      paddingRight: theme.spacing(3),
      '& button': {
        marginRight: theme.spacing(2)
      }
    }), _defineProperty(_contentBlockFirst, '& .linkWrapper a, & .linkWrapper button', _defineProperty({}, theme.breakpoints.up('sm'), {
      maxWidth: theme.spacing(41)
    })), _contentBlockFirst),
    contentBlockMiddle: (_contentBlockMiddle = {
      position: 'relative'
    }, _defineProperty(_contentBlockMiddle, theme.breakpoints.only('sm'), {
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(8)
    }), _defineProperty(_contentBlockMiddle, theme.breakpoints.up('sm'), {
      marginLeft: theme.spacing(-1.5),
      marginRight: theme.spacing(-1.5),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }), _defineProperty(_contentBlockMiddle, theme.breakpoints.up('lg'), {
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(8)
    }), _defineProperty(_contentBlockMiddle, "".concat(theme.breakpoints.down('sm'), " and (orientation:portrait)"), {
      paddingBottom: theme.spacing(0)
    }), _defineProperty(_contentBlockMiddle, "".concat(theme.breakpoints.down('sm'), " and (orientation:landscape)"), {
      paddingRight: theme.spacing(3),
      paddingTop: theme.spacing(1.5),
      paddingLeft: theme.spacing(3)
    }), _defineProperty(_contentBlockMiddle, '& .linkWrapper a, & .linkWrapper button', _defineProperty({}, theme.breakpoints.up('sm'), {
      maxWidth: theme.spacing(41)
    })), _contentBlockMiddle),
    contentBlockLast: (_contentBlockLast = {
      position: 'relative',
      paddingLeft: 0
    }, _defineProperty(_contentBlockLast, theme.breakpoints.only('sm'), {
      paddingLeft: theme.spacing(8)
    }), _defineProperty(_contentBlockLast, theme.breakpoints.up('sm'), {
      marginLeft: theme.spacing(-1.5),
      paddingLeft: theme.spacing(3)
    }), _defineProperty(_contentBlockLast, theme.breakpoints.up('lg'), {
      paddingLeft: theme.spacing(8)
    }), _defineProperty(_contentBlockLast, "".concat(theme.breakpoints.down('sm'), " and (orientation:portrait) "), {
      paddingBottom: theme.spacing(0)
    }), _defineProperty(_contentBlockLast, "".concat(theme.breakpoints.down('sm'), " and (orientation:landscape) "), {
      paddingTop: theme.spacing(1.5),
      paddingLeft: theme.spacing(3)
    }), _defineProperty(_contentBlockLast, '& .linkWrapper a, & .linkWrapper button', _defineProperty({}, theme.breakpoints.up('sm'), {
      maxWidth: theme.spacing(41)
    })), _contentBlockLast),
    paddingBottomContentBlock: (_paddingBottomContent = {}, _defineProperty(_paddingBottomContent, theme.breakpoints.up('sm'), {
      paddingBottom: theme.spacing(11)
    }), _defineProperty(_paddingBottomContent, "".concat(theme.breakpoints.down('sm'), " and (orientation:portrait)"), {
      paddingBottom: theme.spacing(0)
    }), _paddingBottomContent),
    paddingBottomInFlexitwoCTA: _defineProperty({}, theme.breakpoints.up('sm'), {
      paddingBottom: theme.spacing(11)
    }),
    innerGridContainer: {
      maxWidth: '100%'
    },
    paddingBottomMarketingTabletMobile: _defineProperty({}, theme.breakpoints.down('lg'), {
      paddingBottom: '0px !important'
    }),
    rightContent: {
      width: '100%'
    },
    title: {
      marginBottom: theme.spacing(3),
      fontWeight: theme.typography.fontWeights.bolder,
      '& h1': {
        margin: 'auto'
      }
    },
    description: {
      '& p:last-child': {
        marginBottom: 0,
        marginTop: 0
      },
      '&:last-child': {
        marginBottom: 0
      }
    },
    linkWrapper: (_linkWrapper2 = {
      display: 'flex',
      justifyContent: 'flex-start',
      marginTop: theme.spacing(6),
      '&.twoCtasPrimarySimpleLink': (_twoCtasPrimarySimp = {}, _defineProperty(_twoCtasPrimarySimp, theme.breakpoints.down('md'), {
        '& .MuiLink-displayInlineFlex': {
          display: 'block'
        }
      }), _defineProperty(_twoCtasPrimarySimp, '& .simpleLink', {
        marginTop: theme.spacing(1.5)
      }), _defineProperty(_twoCtasPrimarySimp, '& $linkAlign', {
        display: 'inline-flex',
        textAlign: 'initial',
        alignItems: 'flex-start',
        '& > span': {
          height: theme.spacing(3)
        }
      }), _twoCtasPrimarySimp),
      '&.twoCTAs': (_twoCTAs = {
        flexDirection: 'column'
      }, _defineProperty(_twoCTAs, theme.breakpoints.up('sm'), {
        '&:not(.maxWidth)': {
          flexWrap: 'nowrap',
          flexDirection: 'row-reverse',
          justifyContent: 'flex-end',
          '&.bothPrimary': {
            flexDirection: 'row',
            justifyContent: 'flex-start',
            '& > div + div': _defineProperty({
              marginLeft: 0,
              marginBottom: theme.spacing(2)
            }, theme.breakpoints.up('sm'), {
              marginLeft: theme.spacing(2),
              marginBottom: 0
            })
          },
          '& > div + div': {
            marginRight: theme.spacing(2)
          }
        }
      }), _defineProperty(_twoCTAs, '&:not(.flexiCol)', {
        '&:not(.maxWidth)': {
          '&.bothPrimary': {
            '& > div + div': _defineProperty({}, theme.breakpoints.up('sm'), {
              marginRight: 0
            })
          }
        }
      }), _defineProperty(_twoCTAs, '&:not(.simpleLink) > div > a, &:not(.simpleLink) > div > div, &:not(.simpleLink) button', _defineProperty({
        display: 'inline-block',
        width: '100%'
      }, theme.breakpoints.up('sm'), {
        maxWidth: theme.spacing(41)
      })), _defineProperty(_twoCTAs, '& .simpleLink', {
        marginTop: '-4px'
      }), _defineProperty(_twoCTAs, '& > div > a > button ', {
        width: '100%'
      }), _defineProperty(_twoCTAs, '& > div + div', _defineProperty({
        marginRight: 0,
        marginTop: theme.spacing(2)
      }, theme.breakpoints.up('sm'), {
        marginTop: 0
      })), _defineProperty(_twoCTAs, '&.maxWidth > div + div', _defineProperty({}, theme.breakpoints.up('sm'), {
        marginTop: theme.spacing(2),
        marginRight: 0
      })), _defineProperty(_twoCTAs, '& button', {
        marginRight: 0
      }), _twoCTAs),
      '& a:nth-child(2)': {
        marginLeft: theme.spacing(2)
      }
    }, _defineProperty(_linkWrapper2, "".concat(theme.breakpoints.down('sm'), " and (orientation:portrait)"), {
      justifyContent: 'center',
      width: '100%',
      textAlign: 'center'
    }), _defineProperty(_linkWrapper2, '&.linkWrapper a, &.linkWrapper button', _defineProperty({}, theme.breakpoints.up('sm'), {
      maxWidth: theme.spacing(41)
    })), _linkWrapper2),
    buttonMergedContainer: {
      marginBottom: '1px'
    },
    button: {
      height: 'auto'
    },
    alignCenter: (_alignCenter = {}, _defineProperty(_alignCenter, theme.breakpoints.down('lg'), (_theme$breakpoints$do = {
      justifyContent: 'center',
      '& a:nth-child(2)': {
        marginLeft: theme.spacing(2)
      }
    }, _defineProperty(_theme$breakpoints$do, theme.breakpoints.up('sm'), {
      justifyContent: 'flex-start'
    }), _defineProperty(_theme$breakpoints$do, theme.breakpoints.down('sm'), {
      width: '100%',
      textAlign: 'center'
    }), _theme$breakpoints$do)), _defineProperty(_alignCenter, "buttonMergedContainer", {
      marginBottom: '1px'
    }), _alignCenter),
    marketingOnly: _defineProperty({
      display: 'block'
    }, theme.breakpoints.down('sm'), {
      display: 'flex'
    }),
    marketingDesktopMedia: {
      paddingLeft: "".concat(theme.spacing(8), "px !important")
    },
    showOnDesktopOnly: _defineProperty({
      display: 'none'
    }, theme.breakpoints.up('sm'), {
      display: 'block'
    }),
    showOnTabletMobile: _defineProperty({
      display: 'flex'
    }, theme.breakpoints.up('xl'), {
      display: 'none'
    }),
    showOnMobileOnly: _defineProperty({
      display: 'flex'
    }, theme.breakpoints.up('sm'), {
      display: 'none'
    }),
    mediaOnTop: {
      '& picture': _defineProperty({}, theme.breakpoints.down('sm'), {
        width: '100%',
        marginBottom: theme.spacing(3)
      }),
      '& $infographicCtaWrapper': _defineProperty({
        marginBottom: theme.spacing(3),
        marginTop: 0
      }, theme.breakpoints.up('sm'), {
        marginBottom: 0
      })
    },
    flexStart: {
      justifyContent: 'flex-start'
    },
    flexEnd: {
      justifyContent: 'flex-end'
    },
    media: (_media = {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column'
    }, _defineProperty(_media, theme.breakpoints.down('sm'), {
      justifyContent: 'center',
      width: '100%',
      '& .MuiCard-videoWrapper': {
        width: '100%'
      }
    }), _defineProperty(_media, '& img', (_img = {
      display: 'block',
      width: '100%'
    }, _defineProperty(_img, theme.breakpoints.down('sm'), {
      margin: '0 auto'
    }), _defineProperty(_img, theme.breakpoints.up('lg'), {
      paddingBottom: 0
    }), _img)), _defineProperty(_media, '& .fallbackPic', {
      borderRadius: theme.spacing(2)
    }), _media),
    contentBlockImg: {
      paddingTop: 0,
      '&& img': {
        position: 'relative'
      }
    },
    chip: _defineProperty({
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
      borderRadius: theme.spacing(0.5),
      cursor: 'pointer'
    }, theme.breakpoints.down('sm'), {
      marginBottom: theme.spacing(3)
    }),
    bottomLinkWrapper: (_bottomLinkWrapper = {
      '&:not(.firstsimplelink)': {
        paddingTop: theme.spacing(0.5)
      },
      '& .MuiLink-root a': {
        textDecoration: 'none',
        fontWeight: theme.typography.fontWeights.bold,
        marginLeft: theme.spacing(0)
      },
      justifyContent: 'left'
    }, _defineProperty(_bottomLinkWrapper, theme.breakpoints.down('xs'), {
      paddingTop: theme.spacing(1.5)
    }), _defineProperty(_bottomLinkWrapper, '& $linkAlign', {
      display: 'inline-flex',
      textAlign: 'initial',
      alignItems: 'flex-start',
      '& > span': {
        height: theme.spacing(3)
      }
    }), _defineProperty(_bottomLinkWrapper, "".concat(theme.breakpoints.down('sm'), " and (orientation:portrait)"), {
      textAlign: 'center'
    }), _bottomLinkWrapper),
    linkButtonWrapper: {
      display: 'inline-flex'
    },

    /*Introduced because width defined by number of grids occupied do not match required width in pixels */
    widthWithoutImage: _defineProperty({}, theme.breakpoints.up('lg'), {
      maxWidth: '100%'
    }),
    widthWithImageRight: _defineProperty({}, theme.breakpoints.up('lg'), {
      maxWidth: '100%'
    }),
    widthWithImageLeft: (_widthWithImageLeft = {}, _defineProperty(_widthWithImageLeft, theme.breakpoints.up('lg'), {
      maxWidth: '100%'
    }), _defineProperty(_widthWithImageLeft, '& .featuredMediaContainer', _defineProperty({}, theme.breakpoints.down('xs'), {
      display: 'none'
    })), _widthWithImageLeft),
    widthWithoutImageMS: _defineProperty({}, theme.breakpoints.up('lg'), {
      maxWidth: '100%'
    }),
    downloadIcons: (_downloadIcons = {}, _defineProperty(_downloadIcons, theme.breakpoints.up('xl'), {
      marginTop: theme.spacing(6)
    }), _defineProperty(_downloadIcons, theme.breakpoints.down('lg'), {
      marginTop: theme.spacing(1, 5),
      maxWidth: '310px'
    }), _defineProperty(_downloadIcons, theme.breakpoints.down('sm'), {
      maxWidth: 'unset'
    }), _defineProperty(_downloadIcons, '& svg', {
      height: '40px',
      overflow: 'visible',
      cursor: 'pointer',
      maxWidth: 'initial',
      maxHeight: 'initial'
    }), _defineProperty(_downloadIcons, '& .app-store', {
      display: 'inline-flex',
      outline: 'none',
      '& svg': {
        width: '100%',
        height: '100%',
        maxWidth: '100%',
        maxHeight: '100%',
        backfaceVisibility: 'hidden'
      }
    }), _defineProperty(_downloadIcons, '& .google-play', {
      display: 'inline-flex',
      outline: 'none',
      '& svg': {
        width: '100%',
        height: '100%',
        maxWidth: '100%',
        maxHeight: '100%',
        backfaceVisibility: 'hidden'
      }
    }), _downloadIcons),
    marketingSectionContainer: {
      display: 'flex',
      padding: theme.spacing(3),
      borderRadius: theme.spacing(2),
      background: 'white'
    },
    marketingContent: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(2),
      '& $downloadIconsContainer': {
        display: 'flex',
        marginBottom: theme.spacing(-1),
        '&>a:first-child': {
          paddingRight: theme.spacing(1)
        },
        '&>a:last-child': {
          paddingLeft: theme.spacing(1)
        }
      }
    },
    downloadIconsContainer: {
      '&.marketingContentMobile': {
        display: 'flex',
        width: '100%'
      },
      '&>a:first-child': {
        paddingRight: theme.spacing(1)
      },
      '&>a:last-child': {
        paddingLeft: theme.spacing(1)
      }
    },
    chipWrapper: {
      marginRight: theme.spacing(1),
      '& a': {
        cursor: 'pointer',
        margin: 0
      }
    },
    chipsWrapper: {
      marginTop: theme.spacing(3),
      flexWrap: 'wrap',
      display: 'flex',
      flexDirection: 'row'
    },
    modalPopupWrap: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6),
      '& h2': _defineProperty({
        marginBottom: theme.spacing(0),
        fontWeight: theme.typography.fontWeights.bolder,
        lineHeight: theme.typography.pxToRem(39),
        fontSize: theme.typography.pxToRem(31)
      }, theme.breakpoints.up('sm'), {
        lineHeight: theme.typography.pxToRem(49),
        fontSize: theme.typography.pxToRem(39)
      }),
      '& p': _defineProperty({
        marginTop: theme.spacing(3),
        fontWeight: theme.typography.fontWeights.normal,
        lineHeight: theme.typography.pxToRem(24),
        fontSize: theme.typography.pxToRem(16)
      }, theme.breakpoints.up('sm'), {
        marginTop: theme.spacing(6),
        lineHeight: theme.typography.pxToRem(30),
        fontSize: theme.typography.pxToRem(20)
      }),
      '& div': _defineProperty({
        marginTop: theme.spacing(2),
        fontWeight: theme.typography.fontWeights.normal,
        lineHeight: theme.typography.pxToRem(24),
        fontSize: theme.typography.pxToRem(16)
      }, theme.breakpoints.up('sm'), {
        marginTop: theme.spacing(3),
        lineHeight: theme.typography.pxToRem(30),
        fontSize: theme.typography.pxToRem(20)
      })
    },
    infographicCtaWrapper: _defineProperty({
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.spacing(3)
    }, theme.breakpoints.up('sm'), {
      bottom: theme.spacing(-8),
      position: 'absolute',
      width: '100%'
    }),
    isArticleBody: _defineProperty({
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6)
    }, theme.breakpoints.up('sm'), {
      marginTop: theme.spacing(8),
      marginBottom: theme.spacing(16)
    }),
    featuredLinkWrapper: _defineProperty({}, theme.breakpoints.down('md'), {
      justifyContent: 'center',
      width: '100%',
      textAlign: 'center'
    }),
    marketing: {
      '& .marketingContentWrapper': {
        alignItems: 'flex-end'
      }
    },
    featured: (_featured = {
      marginTop: 'calc(56.25% / 2)',
      wordBreak: 'break-word',
      paddingBottom: theme.spacing(6)
    }, _defineProperty(_featured, theme.breakpoints.up('lg'), {
      marginRight: theme.spacing(8),
      padding: theme.spacing(6),
      marginTop: theme.spacing(8)
    }), _defineProperty(_featured, '&.leftImageFeatured', _defineProperty({}, theme.breakpoints.up('lg'), {
      marginRight: 0,
      marginLeft: theme.spacing(8),
      '& .featuredContentWrapper': {
        flexDirection: 'row-reverse'
      },
      '& .featuredMediaContainer': {
        left: '-112px'
      }
    })), _defineProperty(_featured, '& .featuredContentWrapper', _defineProperty({
      position: 'relative',
      padding: "0 ".concat(theme.spacing(2), "px")
    }, theme.breakpoints.up('lg'), {
      flexWrap: 'nowrap',
      padding: 0
    })), _defineProperty(_featured, '& .featuredTextContainer', _defineProperty({
      marginTop: "calc(56.25% / 2 + ".concat(theme.spacing(6), "px)")
    }, theme.breakpoints.up('lg'), {
      marginTop: '0',
      maxWidth: '46.62%',
      flexBasis: '46.62%',
      minWidth: '46.62%'
    })), _defineProperty(_featured, '& .featuredMediaContainer', (_featuredMediaCont2 = {
      width: 'calc(100% - 32px)',
      maxWidth: 'none',
      flexBasis: 'none',
      position: 'absolute'
    }, _defineProperty(_featuredMediaCont2, theme.breakpoints.down('md'), {
      transform: 'translateY(-50%)'
    }), _defineProperty(_featuredMediaCont2, theme.breakpoints.up('lg'), {
      width: '56.4%',
      top: '-112px',
      right: '-112px'
    }), _defineProperty(_featuredMediaCont2, '& picture', {
      marginBottom: 0
    }), _featuredMediaCont2)), _defineProperty(_featured, '& .featuredMedia', {
      overflow: 'hidden'
    }), _featured),
    purchaseMethodWrapper: (_purchaseMethodWrappe = {
      marginTop: theme.spacing(3)
    }, _defineProperty(_purchaseMethodWrappe, theme.breakpoints.down('sm'), {
      marginBottom: theme.spacing(3)
    }), _defineProperty(_purchaseMethodWrappe, '& $purchaseMethodHeader', {
      margin: 0
    }), _defineProperty(_purchaseMethodWrappe, '& $purchaseMethodList', {
      padding: 0,
      margin: 0,
      listStyle: 'none'
    }), _defineProperty(_purchaseMethodWrappe, '& $purchaseMethodListItem', {
      marginTop: theme.spacing(0.5),
      '&:first-child': {
        marginTop: theme.spacing(0.75)
      }
    }), _purchaseMethodWrappe),
    // Please do not remove these empty classes or else it'll break the UI.
    purchaseMethodHeader: {},
    purchaseMethodList: {},
    purchaseMethodListItem: {},
    linkAlign: {}
  });
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var COMPONENT_WRAPPER = 'ContentBlock-Wrapper';
var FEATURED_COMPONENT_WRAPPER = 'Featured-ContentBlock-Wrapper';
var COMPONENT_LINK$4 = 'ContentBlock-Link';
var COMPONENT_BUTTON$5 = 'ContentBlock-Button';
var COMPONENT_IMAGE$2 = 'ContentBlock-Image';
var COMPONENT_INFOGRAPHIC_BUTTON = 'ContentBlock-Infographic-Button';
var COMPONENT_TITLE$8 = 'ContentBlock-Header';
var COMPONENT_DESCRIPTION$4 = 'ContentBlock-Description';
var COMPONENT_DIALOG = 'ContentBlock-Dialog';
var COMPONENT_TAG$1 = 'ContentBlock-Tag';
var COMPONENT_TAG_ITEM = 'ContentBlock-TagItem';
var COMPONENT_PURCHASE_METHOD_HEADER = 'ContentBlock-PurchaseMethod-Header';
var COMPONENT_PURCHASE_METHOD_LIST = 'ContentBlock-PurchaseMethod-List';
var COMPONENT_PURCHASE_METHOD_LIST_ITEM = 'ContentBlock-PurchaseMethod-ListItem';
var COMPONENT_MARKETING_SECTION_CONTAINER = 'ContentBlock-MarketingSectionContainer';
var COMPONENT_MARKETING_SECTION = 'ContentBlock-MarketingSection';
var COMPONENT_MARKETING_LABEL = 'ContentBlock-MarketingLabel';
var COMPONENT_DOWNLOAD_ICON_CONTAINER = 'ContentBlock-DownloadIconContainer';
var COMPONENT_APP_STORE_ICON = 'ContentBlock-AppStoreIcon';
var COMPONENT_GOOGLE_PLAY_ICON = 'ContentBlock-GooglePlayIcon';
var COMPONENT_MODALPOPUP_CONTAINER = 'ContentBlock-Modal-Container';
var COMPONENT_MODAL_TITLE = 'ContentBlock-Modal-Title';
var COMPONENT_MODAL_SUBTITLE = 'ContentBlock-Modal-SubTitle';
var COMPONENT_MODAL_DESCRIPTION = 'ContentBlock-Modal-Description';

var styles$E = function styles(theme) {
  var _dataLocatorDial, _iframeVideoModal;

  var colors = theme.palette.colors || {};
  var icon = theme.palette;
  var iconColors = {};
  Object.keys(colors).forEach(function (color) {
    /** For Default */
    var videoIcon = icon[colors[color].icon].icon.videoIcon;
    iconColors["videoIcon-".concat(color)] = {
      '& path': {
        transition: motionTypes.colorTransition,
        transitionProperty: 'fill'
      },
      '& path:nth-child(1)': {
        fill: videoIcon.background.default
      },
      '& path:nth-child(2)': {
        fill: videoIcon.contrastText.default
      },
      '&:hover': {
        '& path:nth-child(1)': {
          fill: videoIcon.background.hover
        },
        '& path:nth-child(2)': {
          fill: videoIcon.contrastText.hover
        }
      },
      '&:active': {
        '& path:nth-child(1)': {
          fill: videoIcon.background.active
        },
        '& path:nth-child(2)': {
          fill: videoIcon.contrastText.active
        }
      }
    };
  });
  return _objectSpread2(_objectSpread2(_objectSpread2({}, iconColors), [{
    size: 'm',
    bp: 'md',
    dir: 'down'
  }, {
    size: 't',
    bp: 'md',
    dir: 'up'
  }, {
    size: 'd',
    bp: 'lg',
    dir: 'up'
  }].reduce(function (r, viewport) {
    return _objectSpread2(_objectSpread2({}, r), [{
      ratio: '1-1',
      paddingTop: '100%'
    }, {
      ratio: '2-1',
      paddingTop: '50%'
    }, {
      ratio: '3-1',
      paddingTop: '33.333%'
    }, {
      ratio: '16-9',
      paddingTop: '56.25%'
    }].reduce(function (rr, ratio) {
      return _objectSpread2(_objectSpread2({}, rr), _defineProperty({}, "aspectRatio--".concat(viewport.size, "__").concat(ratio.ratio), _defineProperty({}, theme.breakpoints[viewport.dir](viewport.bp), {
        paddingTop: ratio.paddingTop,
        overflow: 'hidden',
        position: 'relative',
        '& video, & iframe': {
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          backgroundColor: 'black'
        }
      })));
    }, {}));
  }, {})), {}, {
    backgroundVideo: {
      position: 'absolute',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      width: '100%',
      height: '100%'
    },
    videoWrapper: {
      position: 'relative',
      height: '100%',
      '& svg': {
        borderRadius: '50%',
        boxShadow: theme.shadows[5]
      }
    },
    playIcon: _defineProperty({
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translateX(-50%) translateY(-50%)',
      cursor: 'pointer',
      height: '48px',
      width: '48px'
    }, theme.breakpoints.up('lg'), {
      height: '80px',
      width: '80px'
    }),
    nativeVideoWrapper: _defineProperty({
      display: 'none',
      '& video': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center'
      }
    }, theme.breakpoints.up('lg'), {
      display: 'block'
    }),
    nativeVideoImage: _defineProperty({
      display: 'block'
    }, theme.breakpoints.up('lg'), {
      display: 'none'
    }),
    hasMobileVideo: _defineProperty({}, theme.breakpoints.down('md'), {
      '& $nativeVideoWrapper': {
        display: 'block'
      },
      '& $nativeVideoImage': {
        display: 'none'
      }
    }),
    videoError: {
      '& $nativeVideoWrapper': {
        display: 'none'
      },
      '& $nativeVideoImage': {
        display: 'block'
      }
    },
    hideBrightcovePlayIcon: {
      '& .vjs-big-play-button': {
        display: 'none'
      }
    },
    mediaContainer: {
      backgroundColor: fwdColors.greyDark
    },
    modalDialog: {
      animation: animations.fadeIn,
      '& .MuiDialog-container, & .MuiDialog-paper, & .MuiBackdrop-root': {
        transition: 'none !important'
      },
      '&.modalDialogClosing': {
        animation: animations.fadeOut
      },
      '& [data-locator=DialogArticleMedia-modal-brightcove]': (_dataLocatorDial = {}, _defineProperty(_dataLocatorDial, theme.breakpoints.up('sm'), {
        borderRadius: theme.spacing(2)
      }), _defineProperty(_dataLocatorDial, '& .fallbackPic', {
        position: 'absolute',
        top: 0,
        left: 0
      }), _dataLocatorDial)
    },
    iframeVideoModal: (_iframeVideoModal = {
      animation: animations.scaleUpAndFadeIn.desktop,
      borderRadius: theme.spacing(2)
    }, _defineProperty(_iframeVideoModal, theme.breakpoints.down('md'), {
      animation: animations.scaleUpAndFadeIn.mobile
    }), _defineProperty(_iframeVideoModal, theme.breakpoints.down('sm'), {
      borderRadius: 0
    }), _defineProperty(_iframeVideoModal, '&.iframeVideoModalClosing', _defineProperty({
      animation: animations.scaleDownAndFadeOut.desktop
    }, theme.breakpoints.down('md'), {
      animation: animations.scaleDownAndFadeOut.mobile
    })), _iframeVideoModal),
    backgroundBrightcove: {
      width: '100%',
      height: '100%',
      '& .vjs-control-bar': {
        display: 'none'
      },
      '& video': {
        objectFit: 'cover'
      },
      '& video-js': {
        height: '100%',
        width: '100%',
        overflow: 'initial',
        pointerEvents: 'none'
      }
    },
    modalBrightcove: {
      '& video': {
        objectFit: 'cover'
      },
      '& video-js': {
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        position: 'initial'
      }
    },
    brightcoveFallbackImageModal: {
      top: 0,
      width: '100%',
      height: '100%',
      position: 'absolute',
      paddingTop: 0
    }
  });
};

/**
 * @param {object} image - consist of image attribute
 * @param {boolean} playVideoInBackground - default value is false
 * @param {boolean} isYoutube - value depends on videoYouTubeID
 * @param {string} videoYouTubeID
 * @param {string} componentName
 * @param {string} variant - The type of content that will be rendered.
 * @param {object} classes - Override or extend the styles applied to the component.
 * @param {boolean} autoPlay - default value is true
 * @param {string} objectFit - default value is null
 * @param {boolean} hasBorderRadius - default value is true
 * @param {string} gaCategoryName - stores the name of component.
 * @param {string} title -stores the link of video and default value is null
 * @param {string} color - default value is white
 */

var Video = /*#__PURE__*/React__default.forwardRef(function Video(props, ref) {
  var _clsx5;

  var image = props.image,
      playVideoInBackground = props.playVideoInBackground,
      isYoutube = props.isYoutube,
      videoYouTubeID = props.videoYouTubeID,
      componentName = props.componentName,
      variant = props.variant,
      classes = props.classes,
      autoPlay = props.autoPlay,
      id = props.id,
      _props$objectFit = props.objectFit,
      objectFit = _props$objectFit === void 0 ? null : _props$objectFit,
      _props$hasBorderRadiu = props.hasBorderRadius,
      hasBorderRadius = _props$hasBorderRadiu === void 0 ? true : _props$hasBorderRadiu,
      gaCategoryName = props.gaCategoryName,
      _props$color = props.color,
      color = _props$color === void 0 ? 'white' : _props$color,
      _props$gaLabelName = props.gaLabelName,
      gaLabelName = _props$gaLabelName === void 0 ? '' : _props$gaLabelName,
      _props$brightcoveVide = props.brightcoveVideoInfo,
      brightcoveVideoInfo = _props$brightcoveVide === void 0 ? {} : _props$brightcoveVide,
      _props$isArticleDetai = props.isArticleDetail,
      isArticleDetail = _props$isArticleDetai === void 0 ? false : _props$isArticleDetai,
      _props$isBrightcoveAu = props.isBrightcoveAutoplay,
      isBrightcoveAutoplay = _props$isBrightcoveAu === void 0 ? false : _props$isBrightcoveAu,
      _props$onCanPlay = props.onCanPlay,
      onCanPlay = _props$onCanPlay === void 0 ? null : _props$onCanPlay; // states

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalState = _useState2[0],
      setModalState = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      videoError = _useState4[0],
      setVideoError = _useState4[1];

  var isMobileWidth = useMediaQuery("(max-width:".concat(breakpoints.values.lg, "px)"), {
    noSsr: true
  });
  var hasMobileVideo = isMobileWidth && !isEmpty(get$1(props, 'mobileVideoSource', '')); // This is to be used in case of SSR Rendering logic

  var isMobileVideoDataPresent = !isEmpty(get$1(props, 'mobileVideoSource', ''));

  var getNativeVideo = function getNativeVideo(_isMobile) {
    if (typeof window !== 'undefined') {
      return _isMobile ? get$1(props, 'mobileVideoSource', null) : get$1(props, 'videoSource', null);
    } else {
      return null;
    }
  };

  var videoId = get$1(brightcoveVideoInfo, 'fields.videoID.value', null);
  var playerId = get$1(brightcoveVideoInfo, 'fields.playerID.value', 'default');
  var accountId = get$1(props, 'brightCoveAccId', '');
  var isBrightcove = !isEmpty(brightcoveVideoInfo);
  var videoSource = isBrightcove ? "https://players.brightcove.net/".concat(accountId, "/").concat(playerId, "_default/index.html?videoId=").concat(videoId) : isYoutube ? "https://www.youtube.com/embed/".concat(videoYouTubeID, "?enablejsapi=1&version=3&playsinline=1") : getNativeVideo(hasMobileVideo);
  var aspectRatioMobile = get$1(image, 'aspectRatio.mobile', '16-9');
  var aspectRatioDesktop = get$1(image, 'aspectRatio.desktop', aspectRatioMobile);
  var aspectRatioTablet = get$1(image, 'aspectRatio.tablet', aspectRatioDesktop);

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard; // Youtube iframe_api

  /* istanbul ignore else */


  if (isYoutube && typeof document !== 'undefined' && !document.getElementById('youtubeiframeapi')) {
    var tag = document.createElement('script');
    tag.setAttribute('id', 'youtubeiframeapi');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    /* istanbul ignore if  */

    if (firstScriptTag) {
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }
  /* istanbul ignore else */


  if (typeof window !== 'undefined') {
    /* istanbul ignore if  */

    window.onYouTubeIframeAPIReady = function () {
      window.youTubeIframeAPIReady = true;
    };
  }

  var modalRef = useRef();
  var iframeRef = useRef(); // components

  /**
   * to display a video within a web page.
   *
   * @param {string} width - specifies the width of <iframe> and default value is 100%
   * @param {string} height -specifies the height of <iframe> and default value is 100%
   * @param {string} src - file name that should be loaded in the frame
   * @param {string} title - title of iframe
   * @param {string} frameBorder - specifies whether or not the borders of that frame are shown and this can take values either 1 or 0.
   * @param {string} allow - specifies a feature policy
   * @param {boolean} allowFullScreen - is used to enable a "fullscreen" button within the iframe and default value is true.
   * @param {string} data-locator
   *
   */

  var BrightCove = function BrightCove(videoProps) {
    if (!accountId || !videoId || !playerId) {
      return /*#__PURE__*/React__default.createElement(Picture, {
        id: "posterImage",
        media: _objectSpread2(_objectSpread2({}, image), {}, {
          aspectRatio: videoProps.inModal ? {
            mobile: '16-9',
            desktop: '16-9',
            tablet: '16-9'
          } : image.aspectRatio
        }),
        className: clsx(props.className, _defineProperty({}, classes.brightcoveFallbackImageModal, videoProps.inModal)),
        hasBorderRadius: videoProps.inModal ? !isMobileWidth : hasBorderRadius
      });
    }

    return playVideoInBackground ? /*#__PURE__*/React__default.createElement("div", {
      "data-locator": "".concat(componentName, "-brightcove"),
      className: clsx(playVideoInBackground && classes.hideBrightcovePlayIcon, playVideoInBackground && classes.backgroundVideo, classes.mediaContainer)
    }, /*#__PURE__*/React__default.createElement(ReactPlayerLoader, {
      accountId: accountId,
      videoId: videoId,
      playerId: playerId,
      options: {
        muted: videoProps.muted ? videoProps.muted : false,
        loop: videoProps.loop ? videoProps.loop : false,
        autoplay: videoProps.autoPlay ? videoProps.autoPlay : false,
        playsinline: true
      },
      embedOptions: {
        responsive: !isMobileWidth
      },
      attrs: {
        className: playVideoInBackground ? classes.backgroundBrightcove : classes.modalBrightcove
      },
      className: clsx(classes.iframeVideoModal)
    })) : /*#__PURE__*/React__default.createElement("iframe", {
      width: "100%",
      height: "100%",
      src: "".concat(videoSource).concat(videoProps.autoPlay ? '&autoplay' : '').concat(videoProps.muted ? '&muted' : '').concat(videoProps.loop ? '&loop' : ''),
      title: videoSource,
      id: id,
      frameBorder: "0",
      allow: "autoplay; fullscreen",
      allowFullScreen: true,
      "data-locator": "".concat(componentName, "-brightcove"),
      className: classes.iframeVideoModal,
      ref: iframeRef
    });
  };

  var Youtube = function Youtube(videoProps) {
    return /*#__PURE__*/React__default.createElement("iframe", {
      width: "100%",
      height: "100%",
      src: "".concat(videoSource).concat(videoProps.autoPlay ? '&autoplay=1' : ''),
      title: videoSource,
      id: id,
      frameBorder: "0",
      allow: "autoplay; fullscreen",
      allowFullScreen: true,
      "data-locator": "".concat(componentName, "-youtube"),
      className: classes.iframeVideoModal,
      ref: iframeRef
    });
  };
  /**
   * render video or picture on the basis of videoSource value
   *
   * @param {string} width - specifies the width of video and default value is 100%
   * @param {boolean} autoPlay - video will automatically start playing as soon as it can do so without stopping and default value is true
   * @param {boolean} playsInline - will play the video right where it is instead of the default, which is to open it up fullscreen while it plays.
   * @param {string} data-object-fit - used to specify how <video> should be resized to fit its container and default value is cover.
   * @param {boolean} controls - specifies that video controls should be displayed like 'play', 'pause' etc and default value is false
   * @param {boolean} muted - specifies that the audio output of the video should be muted and default value is false.
   * @param {boolean} onError - set setVideoError to true whenever error occurs while media data of a video is being downloaded.
   * @param {boolean} loop -  specifies that the video will start over again, every time it is finished and default value is false.
   */


  var NativeVideo = function NativeVideo(videoProps) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: clsx(classes.mediaContainer, hasBorderRadius ? getBorderRadius('medium') : '')
    }, videoSource ? /*#__PURE__*/React__default.createElement("video", {
      width: '100%',
      autoPlay: get$1(videoProps, 'autoPlay', true),
      playsInline: true,
      id: id,
      "data-locator": get$1(videoProps, 'dataLocator', "".concat(componentName, "-video")),
      "data-object-fit": "cover",
      controls: get$1(videoProps, 'controls', false),
      muted: get$1(videoProps, 'muted', false),
      loop: get$1(videoProps, 'loop', false),
      onError: function onError() {
        return setVideoError(true);
      },
      className: hasBorderRadius ? getBorderRadius('medium') : '',
      onCanPlay: onCanPlay
    }, /*#__PURE__*/React__default.createElement("source", {
      src: videoSource,
      type: "video/mp4"
    })) : /*#__PURE__*/React__default.createElement(Picture, {
      id: "posterImage",
      media: image,
      hasBorderRadius: hasBorderRadius,
      hideFallbackImage: true
    }));
  };

  var renderModalVideo = function renderModalVideo() {
    if (isBrightcove) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: clsx(classes['aspectRatio--m__16-9'], classes['aspectRatio--d__16-9']),
        "data-locator": "".concat(componentName, "-modal-brightcove")
      }, /*#__PURE__*/React__default.createElement(BrightCove, {
        autoPlay: true,
        loop: false,
        inModal: true
      }));
    } else if (isYoutube) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: clsx(classes['aspectRatio--m__16-9'], classes['aspectRatio--d__16-9']),
        "data-locator": "".concat(componentName, "-modal-youtube")
      }, /*#__PURE__*/React__default.createElement(Youtube, {
        autoPlay: true
      }));
    } else {
      return /*#__PURE__*/React__default.createElement(NativeVideo, {
        controls: true
      });
    }
  };
  /**
   * On the basis of variant different type of content will be rendered.
   */


  var getVariant = function getVariant() {
    switch (variant) {
      case 'gallery':
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Picture, {
          id: "posterImage",
          media: image,
          className: props.className,
          hasBorderRadius: hasBorderRadius
        }), videoSource && /*#__PURE__*/React__default.createElement(PlayButton, {
          tabindex: "0",
          onClick: function onClick() {
            PushEvent({
              event: 'buttonClick',
              buttonTitle: gaLabelName || getGTMSharedKeyVal(undefined, "".concat(componentName, "-playButton")),
              componentName: gaCategoryName ? gaCategoryName : "".concat(componentName),
              destinationUrl: videoSource
            });
          },
          onKeyPress: function onKeyPress(e) {
            if (e.key === 'Enter') {
              PushEvent({
                event: 'buttonClick',
                buttonTitle: gaLabelName || getGTMSharedKeyVal(undefined, "".concat(componentName, "-playButton")),
                componentName: gaCategoryName ? gaCategoryName : "".concat(componentName),
                destinationUrl: videoSource
              });
            }
          },
          className: clsx(classes.playIcon, classes["videoIcon-".concat(color)], _defineProperty({}, 'hideFocusonClick', !useKeyBoard)),
          "data-locator": "".concat(componentName, "-playButton")
        }));

      case 'gallery-modal':
        /* some how using of <Youtube /> approach is not working when component unmount, thus this approach */
        return isBrightcove ? /*#__PURE__*/React__default.createElement("div", {
          className: clsx(classes['aspectRatio--m__16-9'], classes['aspectRatio--d__16-9'])
        }, /*#__PURE__*/React__default.createElement(BrightCove, {
          autoPlay: false,
          loop: false,
          inModal: true
        })) : isYoutube ? /*#__PURE__*/React__default.createElement("div", {
          className: clsx(classes['aspectRatio--m__16-9'], classes['aspectRatio--d__16-9'])
        }, /*#__PURE__*/React__default.createElement("div", {
          className: 'youtube-iframe',
          width: "100%",
          height: "100%",
          src: videoSource,
          title: videoSource,
          id: id,
          frameBorder: "0",
          allow: "autoplay; fullscreen",
          allowFullScreen: true,
          "data-locator": "".concat(componentName, "-youtube")
        })) : /*#__PURE__*/React__default.createElement(NativeVideo, {
          controls: true,
          autoPlay: autoPlay
        });

      default:
        if (playVideoInBackground && !isArticleDetail) {
          if (isBrightcove) {
            return /*#__PURE__*/React__default.createElement("div", {
              className: clsx(aspectRatioMobile && classes["aspectRatio--m__".concat(aspectRatioMobile)], aspectRatioTablet && classes["aspectRatio--t__".concat(aspectRatioTablet)], aspectRatioDesktop && classes["aspectRatio--d__".concat(aspectRatioDesktop)])
            }, /*#__PURE__*/React__default.createElement(BrightCove, {
              autoPlay: isBrightcoveAutoplay,
              muted: true,
              loop: true
            }));
          } else if (isYoutube) {
            return /*#__PURE__*/React__default.createElement("div", {
              className: clsx(aspectRatioMobile && classes["aspectRatio--m__".concat(aspectRatioMobile)], aspectRatioTablet && classes["aspectRatio--t__".concat(aspectRatioTablet)], aspectRatioDesktop && classes["aspectRatio--d__".concat(aspectRatioDesktop)])
            }, /*#__PURE__*/React__default.createElement(Youtube, null));
          } else {
            var _clsx3;

            return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Picture, {
              id: "posterImage",
              media: image,
              className: clsx(classes.nativeVideoImage, props.className),
              hasBorderRadius: hasBorderRadius
            }), /*#__PURE__*/React__default.createElement("div", {
              className: clsx(classes.nativeVideoWrapper, props.className, (_clsx3 = {}, _defineProperty(_clsx3, classes["aspectRatio--m__".concat(aspectRatioMobile)], aspectRatioMobile !== null), _defineProperty(_clsx3, classes["aspectRatio--t__".concat(aspectRatioTablet)], aspectRatioTablet !== null), _defineProperty(_clsx3, classes["aspectRatio--d__".concat(aspectRatioDesktop)], aspectRatioDesktop !== null), _clsx3))
            }, /*#__PURE__*/React__default.createElement(NativeVideo, {
              dataLocator: "".concat(componentName, "-video-background"),
              loop: true,
              muted: true
            })));
          }
        } else {
          var onAnimationEnd = function onAnimationEnd() {
            if (modalRef && modalRef.current && modalRef.current.classList.contains('modalDialogClosing')) {
              setModalState(false);
            }

            if (iframeRef && iframeRef.current && iframeRef.current.classList.contains('iframeVideoModalClosing')) {
              setModalState(false);
            }
          };

          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Picture, {
            media: _objectSpread2(_objectSpread2({}, image), {}, {
              image: image.image && defaultsDeep({
                value: _objectSpread2(_objectSpread2({}, image.image.value), image.image.value.Large)
              }),
              mobileImage: image.mobileImage && defaultsDeep({
                value: _objectSpread2(_objectSpread2({}, image.mobileImage.value), image.mobileImage.value.Large)
              })
            }),
            className: props.className,
            onClick: function onClick() {
              videoSource && setModalState(true);
            },
            objectFit: objectFit,
            hasBorderRadius: hasBorderRadius
          }), videoSource && /*#__PURE__*/React__default.createElement(PlayButton, {
            tabindex: "0",
            onKeyPress: function onKeyPress(e) {
              if (e.key === 'Enter') {
                PushEvent({
                  event: 'buttonClick',
                  buttonTitle: gaLabelName || getGTMSharedKeyVal(undefined, "".concat(componentName, "-playButton")),
                  componentName: gaCategoryName ? gaCategoryName : "".concat(componentName),
                  destinationUrl: videoSource
                });
                setModalState(true);
              }
            },
            onClick: function onClick() {
              PushEvent({
                event: 'buttonClick',
                buttonTitle: gaLabelName || getGTMSharedKeyVal(undefined, "".concat(componentName, "-playButton")),
                componentName: gaCategoryName ? gaCategoryName : "".concat(componentName),
                destinationUrl: videoSource
              });
              videoSource && setModalState(true);
            },
            className: clsx(classes.playIcon, classes["videoIcon-".concat(color)], _defineProperty({}, 'hideFocusonClick', !useKeyBoard)),
            "data-locator": "".concat(componentName, "-playButton")
          }), /*#__PURE__*/React__default.createElement(Dialog$1, {
            open: modalState,
            fullScreen: true,
            onClose: function onClose() {
              if (modalRef && modalRef.current) {
                modalRef.current.classList.add('modalDialogClosing');
              }

              if (iframeRef && iframeRef.current) {
                iframeRef.current.classList.add('iframeVideoModalClosing');
              }
            },
            onAnimationEnd: onAnimationEnd,
            darkMode: true,
            transparent: true,
            verticallyAlign: 'center',
            md: 10,
            lg: 8,
            isFixed: true,
            mobileFluid: true,
            color: "darkGreen",
            ref: modalRef,
            className: classes.modalDialog
          }, renderModalVideo()));
        }

    }
  };


  return /*#__PURE__*/React__default.createElement("div", {
    "data-locator": "".concat(componentName, "-video-container"),
    ref: ref,
    className: clsx(classes.videoWrapper, props.className, props.videoWrapperClassName, (_clsx5 = {}, _defineProperty(_clsx5, classes.hasMobileVideo, isMobileVideoDataPresent), _defineProperty(_clsx5, classes.videoError, videoError), _clsx5))
  }, getVariant());
});
var Video$1 = withStyles$1(styles$E, {
  name: 'MuiCard'
})(Video);

/*9fbef606107a605d69c0edbcd8029e5d*/

var generateGoogleMapUrl = function generateGoogleMapUrl(currLat, currLong, lat, long) {
  return "https://www.google.com/maps/dir/?api=1&origin=".concat(currLat, ",").concat(currLong, "&destination=").concat(lat, ",").concat(long);
};
var generateGoogleMapScript = function generateGoogleMapScript(mapApiKey, pageLanguage) {
  return "https://maps.googleapis.com/maps/api/js?key=".concat(mapApiKey, "&libraries=places&language=").concat(pageLanguage);
};
var FWD_LOGO_FALLBACK = 'url(data:image/png;base64,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)';

var styles$D = function styles(theme) {
  return {
    container: {
      position: 'relative',
      '& img': {
        objectFit: 'cover'
      },
      '& .react-transform-component': {
        borderRadius: theme.spacing(2),
        width: '100%',
        height: '100%'
      },
      '& .react-transform-element': {
        display: 'inline-flex'
      }
    },
    mobileImageWrapper: {
      paddingTop: theme.spacing(7),
      paddingBottom: theme.spacing(7),
      '& img': {
        width: '100%'
      }
    },
    contentWrapper: {
      position: 'relative'
    },
    toolbar: _defineProperty({
      position: 'absolute',
      right: theme.spacing(-5),
      display: 'flex',
      flexDirection: 'column',
      width: theme.spacing(4)
    }, theme.breakpoints.down('md'), {
      display: 'none'
    }),
    hidden: {
      display: 'none'
    },
    iconButton: {
      marginTop: theme.spacing(0.25),
      '&:first-child': {
        marginTop: theme.spacing(0)
      },
      '& svg': {
        width: theme.spacing(2),
        height: theme.spacing(2)
      },
      '&.disabled': {
        opacity: 0.5,
        pointerEvents: 'none'
      }
    },
    centralisedWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.palette.colors.grey.main,
      textAlign: 'center',
      flexDirection: 'column',
      color: theme.palette.colors.grey.contrastText
    },
    fallback: _defineProperty({
      objectFit: 'scale-down',
      backgroundColor: '#F2F2F2',
      backgroundImage: FWD_LOGO_FALLBACK,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      height: '100%',
      width: '100%',
      minWidth: "calc(100vw - ".concat(theme.spacing(4), "px)"),
      minHeight: "calc(100vw - ".concat(theme.spacing(4), "px)")
    }, theme.breakpoints.up('sm'), {
      minWidth: theme.spacing(101),
      minHeight: theme.spacing(101)
    }),
    imageErrorWrapper: {
      '& svg': {
        width: theme.spacing(8),
        height: theme.spacing(8),
        color: theme.palette.colors.grey.line.divider
      }
    },
    imageErrorText: {
      width: '100%',
      maxWidth: '648px',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    zoomPanPinchModal: {
      animation: animations.fadeIn,
      '& .MuiDialog-container, & .MuiDialog-paper, & .MuiBackdrop-root': {
        transition: 'none !important'
      },
      '&.infographicModalClosing': {
        animation: animations.fadeOut
      },
      '& .MuiDialog-verticallyAlign--center': {
        '& > .MuiContainer-root': {
          display: 'flex'
        }
      }
    }
  };
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var ZOOMPANPINCH_IMAGE = 'ZoomPanPinch-Image';
var ZOOMPANPINCH_MOBILE_IMAGE = 'ZoomPanPinch-Mobile-Image';
var ZOOMPANPINCH_ZOOMIN = 'ZoomPanPinch-Zoom-In';
var ZOOMPANPINCH_ZOOMOUT = 'ZoomPanPinch-Zoom-Out';
var ZOOMPANPINCH_RESET = 'ZoomPanPinch-Reset';
var ZOOMPANPINCH_BUTTON = 'ZoomPanPinch-Button';
var ZOOMPANPINCH_CONTENT_WRAPPER = 'ZoomPanPinch-ContentWrapper';
var ZOOMPANPINCH_IMAGE_ERROR_WRAPPER = 'ZoomPanPinch-imageErrorWrapper';
var ZOOMPANPINCH_BUTTON_CLOSE_BUTTON = 'ZoomPanPinch-closeButton';
var ZOOMPANPINCH_COMPONENT = 'ZoomPanPinch';

var useStyles$K = makeStyles(styles$D);
var zoomInHandler = null;
var zoomOutHandler = null;
var setTransformHandler = null;
var scrollLock = null;

var gtmEventHandler = function gtmEventHandler(buttonTitle, componentName, destinationUrl) {
  PushEvent({
    event: 'buttonClick',
    buttonTitle: buttonTitle,
    componentName: componentName,
    destinationUrl: destinationUrl
  });
};

var ImageErrorContainer = function ImageErrorContainer(props) {
  var classes = useStyles$K(); // const { t } = useTranslation();

  var dictionary = get$1(props, 'dictionary', {
    'imageErrorMessage': 'Oops! Unable to load image',
    'imageErrorDescription': 'Please give it a moment and try refreshing the page.'
  });

  var t = function t(key) {
    return dictionary[key];
  };

  var height = get$1(props, 'height', 0);
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.imageErrorWrapper, classes.centralisedWrapper, getBorderRadius('medium')),
    "data-locator": ZOOMPANPINCH_IMAGE_ERROR_WRAPPER // ie11 minHeight fix
    // top + bottom padding
    ,
    style: {
      height: height
    }
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    className: classes.imageErrorText,
    mb: 0,
    variant: 'h3A',
    color: 'grey'
  }, t('imageErrorMessage')), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    className: classes.imageErrorText,
    mt: 1,
    mb: 0,
    variant: 'body1',
    color: 'grey'
  }, t('imageErrorDescription')));
};

var ZoomPanPinch = function ZoomPanPinch(props) {
  var _props$hasButton = props.hasButton,
      hasButton = _props$hasButton === void 0 ? true : _props$hasButton,
      _props$open = props.open,
      open = _props$open === void 0 ? false : _props$open,
      onClose = props.onClose,
      _props$buttonProps = props.buttonProps,
      buttonProps = _props$buttonProps === void 0 ? {} : _props$buttonProps,
      infographicImage = props.infographicImage,
      gaLabelName = props.gaLabelName,
      gaCategoryName = props.gaCategoryName;
  var classes = useStyles$K(); // const { t } = useTranslation();

  var dictionary = get$1(props, 'dictionary', {
    'loading': 'Loading... A moment please.',
    'zoomin': 'Zoom In',
    'zoomout': 'Zoom Out',
    'bestfit': 'Best Fit'
  });

  var t = function t(key) {
    return dictionary[key];
  }; // settings


  var animationTime = 200;
  var animationType = 'easeOutQuint';
  var initialTransformWrapperProps = {
    options: {
      limitToBounds: true,
      limitToWrapper: true,
      centerContent: true,
      minScale: 1,
      maxScale: 1,
      pan: {
        animationTime: animationTime,
        animationType: animationType
      },
      zoomIn: {
        animationTime: animationTime,
        animationType: animationType
      },
      zoomOut: {
        animationTime: animationTime,
        animationType: animationType
      },
      doubleClick: {
        animationTime: animationTime,
        animationType: animationType
      },
      reset: {
        animationTime: animationTime,
        animationType: animationType
      }
    }
  }; // refs

  var imageRef = /*#__PURE__*/createRef();
  var containerRef = /*#__PURE__*/createRef(); // states

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      preloaderPercentage = _useState2[0],
      setPreloaderPercentage = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      imageBlob = _useState4[0],
      setImageBlob = _useState4[1];

  var _useState5 = useState(open),
      _useState6 = _slicedToArray(_useState5, 2),
      isOpen = _useState6[0],
      setIsOpen = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isEntered = _useState8[0],
      setIsEntered = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isImageLoaded = _useState10[0],
      setIsImageLoaded = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      imageError = _useState12[0],
      setImageError = _useState12[1];

  var _useState13 = useState(true),
      _useState14 = _slicedToArray(_useState13, 2),
      isBestFit = _useState14[0],
      setIsBestFit = _useState14[1]; // iosFix


  var _useState15 = useState('center'),
      _useState16 = _slicedToArray(_useState15, 2),
      verticallyAlign = _useState16[0],
      setVerticallyAlign = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      isMaxZoom = _useState18[0],
      setIsMaxZoom = _useState18[1];

  var _useState19 = useState({
    container: {
      width: 0,
      height: 0
    },
    image: {
      width: 0,
      height: 0
    },
    viewport: {
      height: typeof window === 'undefined' ? 0 : window.innerHeight
    }
  }),
      _useState20 = _slicedToArray(_useState19, 2),
      dimensions = _useState20[0],
      setDimensions = _useState20[1];

  var isMobileWidth = useMediaQuery("(max-width:".concat(breakpoints.values.lg, "px)"));

  var _useState21 = useState(initialTransformWrapperProps),
      _useState22 = _slicedToArray(_useState21, 2),
      transformWrapperProps = _useState22[0],
      setTransformWrapperProps = _useState22[1]; // methods

  /* prevents double call when keypress also triggers click event simultaneously */


  var onClickedInfographic = debounce(function (e) {
    /* istanbul ignore else */
    if (e.type === 'keypress' && e.key === 'Enter' || e.type === 'click') {
      setIsOpen(true);
      gtmEventHandler(gaLabelName || getGTMSharedKeyVal(undefined, buttonProps['data-locator']), gaCategoryName || buttonProps['data-locator']);
    }
  }, 250, {
    leading: true,
    trailing: false
  }); // set initial scale and position when image loads
  // getBoundingClientRect can't be simulated

  /* istanbul ignore next */

  var onImageLoad = function onImageLoad() {
    if (imageRef.current === null || containerRef.current === null || !isEntered) return;
    var containerWidth = containerRef.current.getBoundingClientRect().width;
    var containerHeight = containerRef.current.getBoundingClientRect().height;
    var imageWidth = imageRef.current.naturalWidth;
    var imageHeight = imageRef.current.naturalHeight; // Math.min/max 1 to fix images that are smaller than container.

    var maxScale = Math.max(1, Math.max(imageWidth / containerWidth, imageHeight / containerHeight));
    var minScale = Math.min(1, Math.min(containerWidth / imageWidth, containerHeight / imageHeight)); // fixed IEEE-754 js issue (parseFloat + toFixed)

    var positionX = containerWidth * 0.5 - parseFloat((minScale * imageWidth * 0.5).toFixed(2));
    var positionY = containerHeight * 0.5 - parseFloat((minScale * imageHeight * 0.5).toFixed(2));
    Object.assign(containerRef.current.querySelector('.react-transform-component').style, {
      width: "".concat(containerWidth, "px"),
      height: "".concat(containerHeight, "px")
    });
    setTransformWrapperProps(_objectSpread2(_objectSpread2({}, initialTransformWrapperProps), {}, {
      scale: 1,
      positionX: positionX,
      positionY: positionY,
      defaultScale: 1,
      defaultPositionX: positionX,
      defaultPositionY: positionY,
      options: _objectSpread2(_objectSpread2({}, initialTransformWrapperProps.options), {}, {
        maxScale: maxScale
      }),
      onZoomChange: onZoomChange
    }));
    setDimensions({
      container: {
        width: containerWidth,
        height: containerHeight
      },
      image: {
        width: imageWidth,
        height: imageHeight
      },
      viewport: {
        height: typeof window === 'undefined' ? 0 : window.innerHeight
      }
    });
    setIsMaxZoom(false);
    setIsBestFit(true);
  };

  var onCloseDialog = function onCloseDialog() {
    setModalClosing(true);
    gtmEventHandler(ZOOMPANPINCH_BUTTON_CLOSE_BUTTON, gaCategoryName || ZOOMPANPINCH_COMPONENT);
  };
  /* istanbul ignore next */


  var onAnimationEnd = function onAnimationEnd() {
    if (modalRef && modalRef.current && modalRef.current.classList.contains('infographicModalClosing')) {
      setIsOpen(false);
      setIsEntered(false);
      setIsImageLoaded(false);
      onClose && onClose();
      setModalClosing(false);
    }
  };

  var onZoomChange = function onZoomChange(e) {
    setIsMaxZoom(Math.ceil(e.scale) === Math.ceil(e.options.maxScale));
    setIsBestFit(e.scale === 1);
  };

  var onResize = function onResize() {
    /* istanbul ignore else */
    if (imageBlob) {
      onImageLoad();
    }
  }; // memo


  var transformWrapperMemo = useMemo(function () {
    return /*#__PURE__*/React__default.createElement(TransformWrapper, transformWrapperProps, function (_ref) {
      var zoomIn = _ref.zoomIn,
          zoomOut = _ref.zoomOut,
          setTransform = _ref.setTransform;
      zoomInHandler = zoomIn;
      zoomOutHandler = zoomOut;
      setTransformHandler = setTransform;
      return /*#__PURE__*/React__default.createElement("div", {
        className: classes.container,
        ref: containerRef // ie11 minHeight fix
        // top + bottom padding
        ,
        style: {
          height: dimensions.viewport.height - (isMobileWidth ? 192 : 96)
        },
        title: get$1(infographicImage, 'value.alt', '')
      }, /*#__PURE__*/React__default.createElement(TransformComponent, null, /*#__PURE__*/React__default.createElement("img", {
        title: get$1(infographicImage, 'value.alt', ''),
        "data-locator": ZOOMPANPINCH_IMAGE,
        ref: imageRef,
        src: imageBlob,
        alt: get$1(infographicImage, 'value.alt', ''),
        onLoad: function onLoad() {
          return setIsImageLoaded(true);
        },
        style: {
          maxWidth: dimensions.container.width,
          maxHeight: dimensions.container.height
        }
      })));
    });
  }, [transformWrapperProps, dimensions, zoomInHandler, zoomOutHandler, setTransformHandler, imageBlob]); // effects

  useEffect(function () {
    var xmlHTTP = new XMLHttpRequest();

    if (isOpen && !imageBlob) {
      var url = get$1(infographicImage, 'value.src', '');

      xmlHTTP.onerror = function () {
        setImageError(true);
      };

      xmlHTTP.onload = function () {
        if (get$1(this, 'response.type', '').toString().includes('image')) {
          var objectURL = window.URL.createObjectURL(this.response);
          setTimeout(function () {
            return setImageBlob(objectURL);
          }, 500);
        } else {
          setImageError(true);
        }
      };

      xmlHTTP.onprogress = function (e) {
        var perc = parseInt(e.loaded / e.total * 100, 10);
        setPreloaderPercentage(isNaN(perc) ? 0 : perc);
      };

      xmlHTTP.onloadstart = function () {
        xmlHTTP.responseType = 'blob';
        setPreloaderPercentage(0);
      };

      xmlHTTP.open('GET', url, true);
      xmlHTTP.send();
    }

    return function () {
      xmlHTTP.abort();
    };
  }, [isOpen, imageBlob]);
  useEffect(function () {
    if (isOpen && isMobileWidth && imageBlob && get$1(imageRef, 'current', null)) {
      // if image height is longer that viewport height (after top and bottom padding)
      setVerticallyAlign(imageRef.current.getBoundingClientRect().height > (typeof window === 'undefined' ? 0 : window.innerHeight - (isMobileWidth ? 112 : 192)) ? 'top' : 'center');
    }
  }, [isOpen, imageBlob, isMobileWidth, imageRef]);
  useEffect(function () {
    if (!isOpen && scrollLock) {
      scrollLock = null;
      clearAllBodyScrollLocks();
    }
  }, [isOpen, imageError]);
  useEffect(function () {
    /* istanbul ignore else */
    if (isImageLoaded && isEntered) {
      onImageLoad();
    }

    if (isEntered && !scrollLock && getIsTouchDevice()) {
      disableBodyScroll(document.querySelector('.MuiDialog-paperScrollPaper'));
      scrollLock = true;
    }
  }, [isImageLoaded, isEntered]);

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      modalClosing = _useState24[0],
      setModalClosing = _useState24[1];

  var modalRef = useRef();
  return infographicImage ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, hasButton && /*#__PURE__*/React__default.createElement(StyledMemoizedButton, _extends({
    onKeyPress: onClickedInfographic,
    onClick: onClickedInfographic,
    alt: buttonProps.text,
    "data-locator": ZOOMPANPINCH_BUTTON,
    GTMSharedKey: gaLabelName
  }, buttonProps), buttonProps.text), /*#__PURE__*/React__default.createElement(Dialog$1, {
    fullScreen: true,
    open: isOpen,
    onClose: onCloseDialog,
    darkMode: true,
    color: 'darkGreen',
    transparent: true,
    verticallyAlign: verticallyAlign,
    fixedHeight: !isMobileWidth,
    className: clsx(classes.zoomPanPinchModal, _defineProperty({}, 'infographicModalClosing', modalClosing)),
    gridSpacing: 3,
    md: 10,
    lg: 8,
    ref: modalRef,
    onAnimationEnd: onAnimationEnd,
    onEntered: function onEntered() {
      setTimeout(function () {
        setIsEntered(true);
      }, 350);
    }
  }, imageError ?
  /*#__PURE__*/
  // show image error container
  React__default.createElement(ImageErrorContainer, {
    height: dimensions.viewport.height - (isMobileWidth ? 192 : 96)
  }) : !imageBlob ?
  /*#__PURE__*/
  // show loading state
  React__default.createElement("div", {
    className: clsx(classes.centralisedWrapper, getBorderRadius('medium')) // ie11 minHeight fix
    // top + bottom padding
    ,
    style: {
      height: dimensions.viewport.height - (isMobileWidth ? 192 : 96)
    }
  }, /*#__PURE__*/React__default.createElement(Progress, {
    background: 'grey',
    textColor: 'grey',
    title: t('loading'),
    showInModal: false,
    value: preloaderPercentage,
    variant: "determinate"
  })) : isEntered ? isMobileWidth ?
  /*#__PURE__*/
  // on success show mobile
  React__default.createElement("div", {
    className: classes.mobileImageWrapper
  }, /*#__PURE__*/React__default.createElement("img", {
    title: get$1(infographicImage, 'value.alt', ''),
    className: clsx(getBorderRadius('medium')),
    "data-locator": ZOOMPANPINCH_MOBILE_IMAGE,
    ref: imageRef,
    src: imageBlob,
    alt: get$1(infographicImage, 'value.alt', ''),
    onLoad: onImageLoad
  })) :
  /*#__PURE__*/
  // on success show desktop
  React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ReactResizeDetector, {
    skipOnMount: true,
    handleWidth: true,
    handleHeight: true,
    onResize: onResize
  }), /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.contentWrapper, {
      isBestFit: isBestFit,
      isMaxZoom: isMaxZoom
    }),
    "data-locator": ZOOMPANPINCH_CONTENT_WRAPPER
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: classes.toolbar
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
    title: t('zoomin'),
    iconButton: true
    /* fixed theming for ZoomPanPinch in Dialog */
    ,
    color: 'white',
    className: clsx('motionColorTransition', classes.iconButton, 'allBorderRadiusSmall', {
      disabled: isMaxZoom
    }),
    onClick: function onClick(e) {
      zoomInHandler && zoomInHandler(e);
      gtmEventHandler('zoomin', gaCategoryName || ZOOMPANPINCH_ZOOMIN);
    },
    "data-locator": ZOOMPANPINCH_ZOOMIN,
    icon: 'Plus'
  }), /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
    title: t('zoomout'),
    iconButton: true
    /* fixed theming for ZoomPanPinch in Dialog */
    ,
    color: 'white',
    className: clsx('motionColorTransition', classes.iconButton, 'allBorderRadiusSmall', {
      disabled: isBestFit
    }),
    onClick: function onClick(e) {
      zoomOutHandler && zoomOutHandler(e);
      gtmEventHandler('zoomout', gaCategoryName || ZOOMPANPINCH_ZOOMOUT);
    },
    "data-locator": ZOOMPANPINCH_ZOOMOUT,
    icon: 'minus'
  }), /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
    title: t('bestfit'),
    iconButton: true
    /* fixed theming for ZoomPanPinch in Dialog */
    ,
    color: 'white',
    className: clsx('motionColorTransition', classes.iconButton, 'allBorderRadiusSmall', {
      disabled: isBestFit
    }),
    onClick: function onClick() {
      setTransformHandler(transformWrapperProps.defaultPositionX, transformWrapperProps.defaultPositionY, transformWrapperProps.defaultScale, animationTime, animationType);
      gtmEventHandler('bestfit', gaCategoryName || ZOOMPANPINCH_RESET);
    },
    "data-locator": ZOOMPANPINCH_RESET,
    icon: 'SeeFull'
  })), transformWrapperMemo))) : '')) : '';
};

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var AppStore = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M110.13477,-0.00013 L9.53468,-0.00013 C9.16798,-0.00013 8.80568,-0.00013 8.43995,0.002 C8.1338,0.004 7.83009,0.00981 7.521,0.0147 C6.84951368,0.0226018036 6.17960647,0.0816762599 5.5171,0.19141 C4.85552408,0.303532628 4.21467252,0.51491574 3.61622,0.81841 C3.01849941,1.12447171 2.47234502,1.52216753 1.99757,1.99707 C1.5203025,2.47063699 1.12246318,3.01801638 0.81935,3.61816 C0.515400242,4.21710912 0.304640498,4.8589383 0.19435,5.52148 C0.0830109412,6.18318491 0.0230983806,6.85252054 0.01515,7.52348 C0.00587,7.83008 0.00489,8.1377 0,8.44434 L0,31.5586 C0.00489,31.8691 0.00587,32.1699 0.01515,32.4805 C0.023100818,33.1514262 0.0830133796,33.8207284 0.19435,34.4824 C0.304335953,35.145329 0.515108158,35.7875266 0.81935,36.3867 C1.12232555,36.9849029 1.52022081,37.5300662 1.99757,38.001 C2.47054482,38.478014 3.01705224,38.8759804 3.61622,39.1797 C4.21466797,39.4840065 4.85545044,39.6966478 5.5171,39.8105 C6.1797191,39.9193547 6.84955741,39.9784532 7.521,39.9873 C7.83009,39.9941 8.1338,39.998 8.43995,39.998 C8.80567,40 9.168,40 9.53468,40 L110.13477,40 C110.49417,40 110.85937,40 111.21877,39.998 C111.52347,39.998 111.83597,39.9941 112.14067,39.9873 C112.810843,39.9789237 113.47942,39.9198215 114.14067,39.8105 C114.804454,39.6958464 115.447534,39.4832614 116.04887,39.1797 C116.647497,38.8758046 117.1935,38.4778491 117.66607,38.001 C118.142188,37.5282218 118.540932,36.9834573 118.84767,36.3867 C119.149629,35.7870908 119.358395,35.1449445 119.46677,34.4824 C119.578285,33.8206376 119.640323,33.1514843 119.65237,32.4805 C119.65627,32.1699 119.65627,31.8691 119.65627,31.5586 C119.66407,31.1953 119.66407,30.834 119.66407,30.4648 L119.66407,9.53613 C119.66407,9.16992 119.66407,8.80664 119.65627,8.44434 C119.65627,8.1377 119.65627,7.83008 119.65237,7.52344 C119.640326,6.85242244 119.578287,6.18323567 119.46677,5.52144 C119.358093,4.8592816 119.149339,4.21750328 118.84767,3.61812 C118.230394,2.41519608 117.251573,1.4360254 116.04887,0.81832 C115.447532,0.51556738 114.804383,0.30424041 114.14067,0.19132 C113.479535,0.0811027831 112.810888,0.0220077649 112.14067,0.01456 C111.83597,0.00968 111.52347,0.00382 111.21877,0.00187 C110.85937,-0.00013 110.49417,-0.00013 110.13477,-0.00013 L110.13477,-0.00013 Z",
  fill: "#A6A6A6"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M8.44483,39.125 C8.14015,39.125 7.84283,39.1211 7.54054,39.1143 C6.91432177,39.1061407 6.28956717,39.051625 5.6714,38.9512 C5.0949903,38.8519282 4.53660424,38.6672645 4.01466,38.4033 C3.4975017,38.1415227 3.02581177,37.7982729 2.61766,37.3867 C2.20360033,36.9799753 1.85887673,36.508244 1.59715,35.9902 C1.33253926,35.4687891 1.14941288,34.9098996 1.05415,34.333 C0.951274358,33.7131149 0.895614374,33.0863132 0.88765,32.458 C0.88131,32.2471 0.87301,31.5449 0.87301,31.5449 L0.87301,8.44434 C0.87301,8.44434 0.88185,7.75293 0.8877,7.5498 C0.895325827,6.92248205 0.950662148,6.2966531 1.05323,5.67773 C1.14866872,5.09925008 1.33193687,4.53874887 1.59669,4.01563 C1.85745482,3.49794385 2.20026458,3.02586029 2.61183,2.61768 C3.02293283,2.20562142 3.49613161,1.86060412 4.01417,1.59521 C4.53491467,1.3320936 5.09224545,1.14873255 5.66749,1.05127 C6.28768733,0.949836139 6.91461084,0.894996084 7.543,0.88721 L8.44532,0.875 L111.21387,0.875 L112.12697,0.8877 C112.749643,0.895099198 113.370872,0.949450006 113.98537,1.05029 C114.566438,1.14897507 115.129577,1.33361553 115.65627,1.59814 C116.694088,2.13298605 117.538542,2.97916295 118.07127,4.01807 C118.331797,4.53757756 118.512239,5.09350676 118.60647,5.66699 C118.710259,6.29099138 118.768347,6.92173834 118.78027,7.5542 C118.78317,7.8374 118.78317,8.1416 118.78317,8.44434 C118.79107,8.81934 118.79107,9.17627 118.79107,9.53613 L118.79107,30.4648 C118.79107,30.8281 118.79107,31.1826 118.78317,31.54 C118.78317,31.8652 118.78317,32.1631 118.77927,32.4697 C118.767605,33.0908757 118.710486,33.7103642 118.60837,34.3232 C118.51506,34.9042612 118.33293,35.4675131 118.06837,35.9932 C117.804793,36.5056211 117.462049,36.9732662 117.05277,37.3789 C116.644251,37.7926846 116.171729,38.1379427 115.65337,38.4014 C115.128136,38.6673937 114.565826,38.8527403 113.98537,38.9512 C113.36725,39.052161 112.742435,39.1066802 112.11617,39.1143 C111.82327,39.1211 111.51657,39.125 111.21877,39.125 L110.13477,39.127 L8.44483,39.125 Z",
  fill: "#000000"
})), /*#__PURE__*/React__default.createElement("g", {
  transform: "translate(9.000000, 8.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M15.76888,12.30068 C15.790737,10.6042091 16.6801229,9.03718611 18.12544,8.14862 C17.2095126,6.84051277 15.730392,6.04087835 14.13428,5.99094 C12.45504,5.81468 10.82709,6.99577 9.97138,6.99577 C9.09911,6.99577 7.78161,6.00844 6.36288,6.03763 C4.49620126,6.09793842 2.79813717,7.13352548 1.88996,8.7655 C-0.04404,12.11392 1.39855,17.03497 3.25116,19.74158 C4.17806,21.06693 5.26134,22.54738 6.67879,22.49488 C8.06585,22.43735 8.58389,21.6104 10.25819,21.6104 C11.91695,21.6104 12.40298,22.49488 13.84919,22.4615 C15.33757,22.43734 16.27532,21.13026 17.1697,19.79236 C17.8356761,18.8479997 18.3481437,17.8042759 18.68812,16.69985 C16.9203766,15.9521813 15.7709432,14.2200343 15.76888,12.30068 L15.76888,12.30068 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M13.03725,4.21089 C13.8487766,3.23668191 14.248585,1.98450245 14.15177,0.72027 C12.9119378,0.850490487 11.7666802,1.44304968 10.94419,2.37988 C10.1320187,3.30418903 9.72057463,4.51343268 9.80048,5.74127 C11.0569368,5.75420677 12.2499161,5.19015322 13.03725,4.21089 L13.03725,4.21089 Z"
}))), /*#__PURE__*/React__default.createElement("g", {
  transform: "translate(25.000000, 9.000000)"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M8.30227,10.13965 L3.56887,10.13965 L2.43215,13.4961 L0.42727,13.4961 L4.91067,1.0781 L6.99367,1.0781 L11.47707,13.4961 L9.438,13.4961 L8.30227,10.13965 Z M4.0591,8.59082 L7.8111,8.59082 L5.96149,3.14355 L5.90973,3.14355 L4.0591,8.59082 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M21.15969,8.96973 C21.15969,11.78321 19.65383,13.59082 17.38137,13.59082 C16.2067553,13.6522646 15.1003324,13.0370307 14.53274,12.00682 L14.48974,12.00682 L14.48974,16.4912 L12.63134,16.4912 L12.63134,4.44238 L14.4302,4.44238 L14.4302,5.94824 L14.46438,5.94824 C15.0571883,4.92448792 16.1648043,4.30951884 17.34719,4.34765 C19.645,4.34766 21.15969,6.16406 21.15969,8.96973 Z M19.24953,8.96973 C19.24953,7.13673 18.30226,5.93164 16.85695,5.93164 C15.43703,5.93164 14.48195,7.16211 14.48195,8.96973 C14.48195,10.79395 15.43703,12.01563 16.85695,12.01563 C18.30227,12.01563 19.24953,10.81934 19.24953,8.96973 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M31.12453,8.96973 C31.12453,11.78321 29.61867,13.59082 27.34621,13.59082 C26.1715953,13.6522646 25.0651724,13.0370307 24.49758,12.00682 L24.45458,12.00682 L24.45458,16.4912 L22.59618,16.4912 L22.59618,4.44238 L24.395,4.44238 L24.395,5.94824 L24.42918,5.94824 C25.0219926,4.92448854 26.1296128,4.30952307 27.312,4.34766 C29.60988,4.34766 31.12453,6.16406 31.12453,8.96973 Z M29.21438,8.96973 C29.21438,7.13673 28.2671,5.93164 26.82179,5.93164 C25.40187,5.93164 24.44679,7.16211 24.44679,8.96973 C24.44679,10.79395 25.40187,12.01563 26.82179,12.01563 C28.26711,12.01563 29.21438,10.81934 29.21438,8.96973 L29.21438,8.96973 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M37.71047,10.03613 C37.84817,11.26758 39.04447,12.07613 40.67922,12.07613 C42.24563,12.07613 43.37258,11.26754 43.37258,10.15718 C43.37258,9.19331 42.69289,8.61618 41.08352,8.22066 L39.47415,7.83296 C37.19388,7.28218 36.13528,6.21577 36.13528,4.4853 C36.13528,2.34272 38.00247,0.87104 40.65383,0.87104 C43.27783,0.87104 45.07668,2.34272 45.13723,4.4853 L43.26123,4.4853 C43.14893,3.24604 42.12451,2.498 40.62744,2.498 C39.13037,2.498 38.10596,3.25484 38.10596,4.3564 C38.10596,5.23433 38.76026,5.75093 40.36084,6.1464 L41.729,6.48234 C44.27685,7.08488 45.33545,8.10834 45.33545,9.92472 C45.33545,12.24796 43.48486,13.70304 40.5415,13.70304 C37.78759,13.70304 35.92822,12.28214 35.8081,10.03604 L37.71047,10.03613 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M49.34621,2.2998 L49.34621,4.44238 L51.06789,4.44238 L51.06789,5.91406 L49.34621,5.91406 L49.34621,10.90527 C49.34621,11.68066 49.69094,12.04199 50.44777,12.04199 C50.6521614,12.0384259 50.8562221,12.0240726 51.0591,11.99899 L51.0591,13.46188 C50.7188283,13.5254596 50.3729708,13.5542545 50.02687,13.54782 C48.19387,13.54782 47.47902,12.85934 47.47902,11.10348 L47.47902,5.91406 L46.16262,5.91406 L46.16262,4.44238 L47.479,4.44238 L47.479,2.2998 L49.34621,2.2998 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M52.065,8.96973 C52.065,6.1211 53.74273,4.33106 56.35895,4.33106 C58.98395,4.33106 60.65387,6.12106 60.65387,8.96973 C60.65387,11.82618 58.99274,13.6084 56.35895,13.6084 C53.72609,13.6084 52.065,11.82617 52.065,8.96973 Z M58.76031,8.96973 C58.76031,7.01563 57.8648,5.86231 56.35894,5.86231 C54.85308,5.86231 53.95855,7.02442 53.95855,8.96973 C53.95855,10.93164 54.85308,12.07618 56.35894,12.07618 C57.8648,12.07618 58.76031,10.93164 58.76031,8.96973 L58.76031,8.96973 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M62.18605,4.44238 L63.95852,4.44238 L63.95852,5.98338 L64.00152,5.98338 C64.248696,4.99136841 65.1576526,4.30863156 66.17925,4.34764 C66.393414,4.34689223 66.6069872,4.37015075 66.81597,4.41698 L66.81597,6.15526 C66.545601,6.07264332 66.2635596,6.03471129 65.98097,6.04296 C65.4346182,6.02079544 64.9058709,6.23853473 64.5335615,6.63900597 C64.161252,7.03947722 63.9825766,7.58267074 64.04445,8.12596 L64.04445,13.49608 L62.18605,13.49608 L62.18605,4.44238 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M75.3843,10.83691 C75.1343,12.48046 73.53371,13.60839 71.48586,13.60839 C68.85207,13.60839 67.21731,11.84374 67.21731,9.01269 C67.21731,6.17285 68.86086,4.33105 71.40774,4.33105 C73.91262,4.33105 75.48782,6.05175 75.48782,8.79687 L75.48782,9.43359 L69.09329,9.43359 L69.09329,9.54589 C69.0335874,10.2199216 69.2663316,10.8871194 69.7323199,11.3777699 C70.1983083,11.8684204 70.8526275,12.1352333 71.52884,12.11034 C72.4306823,12.1948396 73.2809431,11.6769777 73.61966,10.8369 L75.3843,10.83691 Z M69.1020624,8.13477 L73.62844,8.13477 C73.6621655,7.52909749 73.4416965,6.93682308 73.0201501,6.50063155 C72.5986036,6.06444001 72.0142008,5.82388041 71.40774,5.83691 C70.7964818,5.83326223 70.2090907,6.07393463 69.7761255,6.50543324 C69.3431603,6.93693186 69.1004963,7.52350292 69.1020624,8.13477 L69.1020624,8.13477 Z"
})))), /*#__PURE__*/React__default.createElement("g", {
  transform: "translate(35.000000, 8.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M2.82619,0.731 C3.61513656,0.674384181 4.38789226,0.974547428 4.93176129,1.54887182 C5.47563032,2.12319621 5.73328587,2.91114479 5.63381,3.69584 C5.63381,5.60209 4.60354,6.69784 2.82619,6.69784 L0.67092,6.69784 L0.67092,0.731 L2.82619,0.731 Z M1.59767,5.854 L2.72267,5.854 C3.28649194,5.88770201 3.83548652,5.66555901 4.21721851,5.24925179 C4.5989505,4.83294457 4.77277961,4.26679442 4.69044,3.708 C4.76678901,3.15152453 4.59045658,2.59004622 4.20967108,2.17713398 C3.82888557,1.76422175 3.28349567,1.5430863 2.72267,1.57421 L1.59767,1.57421 L1.59767,5.854 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M6.68068,4.44434 C6.60346713,3.63722505 6.99048366,2.85611193 7.67941593,2.42859737 C8.36834819,2.0010828 9.24008181,2.0010828 9.92901407,2.42859737 C10.6179463,2.85611193 11.0049629,3.63722505 10.92775,4.44434 C11.0064319,5.25232226 10.6197687,6.03495038 9.93022554,6.4633853 C9.24068243,6.89182022 8.36774757,6.89182022 7.67820446,6.4633853 C6.98866134,6.03495038 6.60199806,5.25232226 6.68068,4.44434 Z M10.01369,4.44434 C10.01369,3.46827 9.5752,2.89747 8.80568,2.89747 C8.03322,2.89747 7.59868,3.46827 7.59868,4.44435 C7.59868,5.42824 8.03325,5.99464 8.80568,5.99464 C9.57522,5.99464 10.01369,5.42432 10.01369,4.44434 L10.01369,4.44434 Z"
}), /*#__PURE__*/React__default.createElement("polygon", {
  points: "16.57326 6.69775 15.65139 6.69775 14.72073 3.38134 14.65042 3.38134 13.72366 6.69775 12.81057 6.69775 11.56936 2.19482 12.47073 2.19482 13.27737 5.63082 13.34378 5.63082 14.26956 2.19482 15.1221 2.19482 16.04788 5.63082 16.11819 5.63082 16.92092 2.19482 17.80959 2.19482"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M18.85353,2.19482 L19.709,2.19482 L19.709,2.91015 L19.77541,2.91015 C20.0063449,2.38347794 20.5459729,2.06130747 21.11916,2.1079 C21.5629768,2.07453177 21.9978859,2.2447899 22.3010908,2.57060207 C22.6042957,2.89641424 22.7428931,3.34242376 22.67775,3.7827 L22.67775,6.6977 L21.78908,6.6977 L21.78908,4.00586 C21.78908,3.28223 21.47463,2.92236 20.8174,2.92236 C20.5163658,2.90833912 20.2242202,3.02648257 20.0175546,3.24581678 C19.810889,3.465151 19.710315,3.76380101 19.7422,4.06347 L19.7422,6.69775 L18.85353,6.69775 L18.85353,2.19482 Z"
}), /*#__PURE__*/React__default.createElement("polygon", {
  points: "24.09377 0.437 24.98244 0.437 24.98244 6.69774 24.09377 6.69774"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M26.21779,4.44434 C26.1406364,3.63717225 26.527714,2.85603936 27.2166974,2.4285182 C27.9056808,2.00099704 28.7774592,2.00099704 29.4664426,2.4285182 C30.155426,2.85603936 30.5425036,3.63717225 30.46535,4.44434 C30.543932,5.25235119 30.1571979,6.03495719 29.4676205,6.46337324 C28.7780432,6.89178929 27.9050968,6.89178929 27.2155195,6.46337324 C26.5259421,6.03495719 26.139208,5.25235119 26.21779,4.44434 L26.21779,4.44434 Z M29.5508,4.44434 C29.5508,3.46827 29.11231,2.89747 28.34279,2.89747 C27.57033,2.89747 27.13579,3.46827 27.13579,4.44435 C27.13579,5.42824 27.57036,5.99464 28.34279,5.99464 C29.11232,5.99464 29.5508,5.42432 29.5508,4.44434 L29.5508,4.44434 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M31.4009,5.42432 C31.4009,4.61377 32.00442,4.14649 33.0757,4.08008 L34.29543,4.00977 L34.29543,3.6211 C34.29543,3.14551 33.98098,2.87696 33.37356,2.87696 C32.87747,2.87696 32.53372,3.05909 32.43508,3.37745 L31.57473,3.37745 C31.66555,2.60401 32.39309,2.10792 33.41457,2.10792 C34.54348,2.10792 35.1802,2.66992 35.1802,3.6211 L35.1802,6.69776 L34.32473,6.69776 L34.32473,6.06495 L34.25442,6.06495 C33.9638686,6.52707633 33.4471736,6.79716323 32.90188,6.77195 C32.5196161,6.81171181 32.1383711,6.68791066 31.8523958,6.43115244 C31.5664205,6.17439423 31.4024061,5.80864331 31.4009,5.42432 L31.4009,5.42432 Z M34.29543,5.03955 L34.29543,4.66309 L33.19582,4.7334 C32.5757,4.7749 32.29445,4.98584 32.29445,5.38281 C32.29445,5.78808 32.64601,6.02392 33.12945,6.02392 C33.4156361,6.05288986 33.7013264,5.96447505 33.9211204,5.77891559 C34.1409144,5.59335613 34.2759916,5.32654106 34.29543,5.03955 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M36.34816,4.44434 C36.34816,3.02149 37.07961,2.12012 38.2173,2.12012 C38.7917768,2.09365013 39.3298275,2.40147287 39.59816,2.91012 L39.66457,2.91012 L39.66457,0.437 L40.55324,0.437 L40.55324,6.69774 L39.70168,6.69774 L39.70168,5.98631 L39.63137,5.98631 C39.3427542,6.49073698 38.7980745,6.79335648 38.21731,6.77195 C37.0718,6.772 36.34816,5.87061 36.34816,4.44434 Z M37.26616,4.44434 C37.26616,5.39942 37.71636,5.97413 38.46929,5.97413 C39.21829,5.97413 39.6812,5.39113 39.6812,4.44825 C39.6812,3.50977 39.21343,2.91846 38.46929,2.91846 C37.72121,2.91846 37.26613,3.49707 37.26613,4.44434 L37.26616,4.44434 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M44.23,4.44434 C44.1527871,3.63722505 44.5398037,2.85611193 45.2287359,2.42859737 C45.9176682,2.0010828 46.7894018,2.0010828 47.4783341,2.42859737 C48.1672663,2.85611193 48.5542829,3.63722505 48.47707,4.44434 C48.5557519,5.25232226 48.1690887,6.03495038 47.4795455,6.4633853 C46.7900024,6.89182022 45.9170676,6.89182022 45.2275245,6.4633853 C44.5379813,6.03495038 44.1513181,5.25232226 44.23,4.44434 L44.23,4.44434 Z M47.563,4.44434 C47.563,3.46827 47.12452,2.89747 46.355,2.89747 C45.58254,2.89747 45.148,3.46827 45.148,4.44435 C45.148,5.42824 45.58257,5.99464 46.355,5.99464 C47.12453,5.99464 47.563,5.42432 47.563,4.44434 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M49.66945,2.19482 L50.52492,2.19482 L50.52492,2.91015 L50.59133,2.91015 C50.8222649,2.38347794 51.3618929,2.06130747 51.93508,2.1079 C52.3788968,2.07453177 52.8138059,2.2447899 53.1170108,2.57060207 C53.4202157,2.89641424 53.5588131,3.34242376 53.49367,3.7827 L53.49367,6.6977 L52.605,6.6977 L52.605,4.00586 C52.605,3.28223 52.29055,2.92236 51.63332,2.92236 C51.3322858,2.90833912 51.0401402,3.02648257 50.8334746,3.24581678 C50.626809,3.465151 50.526235,3.76380101 50.55812,4.06347 L50.55812,6.69775 L49.66945,6.69775 L49.66945,2.19482 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M58.51516,1.07373 L58.51516,2.21533 L59.49075,2.21533 L59.49075,2.96387 L58.51516,2.96387 L58.51516,5.2793 C58.51516,5.75098 58.7095,5.95752 59.15188,5.95752 C59.2651356,5.95715754 59.3782775,5.95030966 59.49075,5.93701 L59.49075,6.67724 C59.3311595,6.70579072 59.1694656,6.72098004 59.00735,6.72265 C58.01907,6.72265 57.62551,6.37499 57.62551,5.50683 L57.62551,2.96383 L56.91067,2.96383 L56.91067,2.21529 L57.62551,2.21529 L57.62551,1.07373 L58.51516,1.07373 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M60.70461,0.437 L61.58547,0.437 L61.58547,2.91845 L61.65578,2.91845 C61.8978078,2.38716856 62.4468801,2.06458754 63.02878,2.11181 C63.4700766,2.08779728 63.8990983,2.26180371 64.1989893,2.58643385 C64.4988802,2.91106399 64.6384049,3.35250564 64.57956,3.79052 L64.57956,6.69775 L63.69,6.69775 L63.69,4.00975 C63.69,3.29051 63.355,2.92625 62.72711,2.92625 C62.417939,2.90089367 62.1133391,3.01329096 61.8947423,3.2333935 C61.6761456,3.45349605 61.5658419,3.75886031 61.59332,4.06785 L61.59332,6.69775 L60.70465,6.69775 L60.70461,0.437 Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M69.76125,5.48193 C69.512057,6.33130948 68.6900989,6.88010304 67.81008,6.78466 C67.2096439,6.8005102 66.6325914,6.5516307 66.2320282,6.10405516 C65.8314651,5.65647963 65.6478864,5.05545594 65.73,4.46045 C65.6500674,3.86379048 65.8329582,3.26180373 66.2312908,2.81044696 C66.6296234,2.35909018 67.204202,2.10277675 67.80617,2.10791 C69.0591,2.10791 69.81496,2.96391 69.81496,4.37791 L69.81496,4.688 L66.63527,4.688 L66.63527,4.7378 C66.607132,5.07194014 66.7212507,5.40244775 66.9495608,5.6480407 C67.1778709,5.89363365 67.4991879,6.03152392 67.83449,6.0278 C68.2692619,6.07999468 68.6924825,5.86433304 68.90578,5.4819 L69.76125,5.48193 Z M66.63525,4.03076 L68.90966,4.03076 C68.9323129,3.72516044 68.8248585,3.42420507 68.6137769,3.20205909 C68.4026954,2.97991311 68.1076175,2.85723623 67.80126,2.86426 C67.490752,2.86035891 67.191828,2.98202124 66.9722963,3.20164888 C66.7527647,3.42127653 66.6312331,3.72025374 66.63527,4.03076 L66.63525,4.03076 Z"
})))))), 'app-store', '0 0 120 40');

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var GooglePlay = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
  x1: "61.0453132%",
  y1: "4.94615078%",
  x2: "26.512955%",
  y2: "71.8787395%",
  id: "linearGradient-1"
}, /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#00A0FF",
  offset: "0%"
}), /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#00A1FF",
  offset: "1%"
}), /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#00BEFF",
  offset: "26%"
}), /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#00D2FF",
  offset: "51%"
}), /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#00DFFF",
  offset: "76%"
}), /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#00E3FF",
  offset: "100%"
})), /*#__PURE__*/React__default.createElement("linearGradient", {
  x1: "107.684729%",
  y1: "50%",
  x2: "-130.640394%",
  y2: "50%",
  id: "linearGradient-2"
}, /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#FFE000",
  offset: "0%"
}), /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#FFBD00",
  offset: "41%"
}), /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#FFA500",
  offset: "78%"
}), /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#FF9C00",
  offset: "100%"
})), /*#__PURE__*/React__default.createElement("linearGradient", {
  x1: "86.2709832%",
  y1: "30.8725537%",
  x2: "-50.1798561%",
  y2: "136.108936%",
  id: "linearGradient-3"
}, /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#FF3A44",
  offset: "0%"
}), /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#C31162",
  offset: "100%"
})), /*#__PURE__*/React__default.createElement("linearGradient", {
  x1: "-18.82494%",
  y1: "-11.9103989%",
  x2: "42.0863309%",
  y2: "35.0790955%",
  id: "linearGradient-4"
}, /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#32A071",
  offset: "0%"
}), /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#2DA771",
  offset: "7%"
}), /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#15CF74",
  offset: "48%"
}), /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#06E775",
  offset: "80%"
}), /*#__PURE__*/React__default.createElement("stop", {
  stopColor: "#00F076",
  offset: "100%"
}))), /*#__PURE__*/React__default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React__default.createElement("rect", {
  fill: "#000000",
  x: "0",
  y: "0",
  width: "135",
  height: "40",
  rx: "5"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M130,0.8 C132.319596,0.8 134.2,2.68040405 134.2,5 L134.2,35 C134.2,37.3195959 132.319596,39.2 130,39.2 L5,39.2 C2.68040405,39.2 0.8,37.3195959 0.8,35 L0.8,5 C0.8,2.68040405 2.68040405,0.8 5,0.8 L130,0.8 M130,0 L5,0 C2.23857625,0 0,2.23857625 0,5 L0,35 C0,37.7614237 2.23857625,40 5,40 L130,40 C132.761424,40 135,37.7614237 135,35 L135,5 C135,2.23857625 132.761424,0 130,0 Z",
  fill: "#A6A6A6"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M47.42,10.24 C47.4531747,10.9810449 47.182257,11.703492 46.67,12.24 C46.0954216,12.8332072 45.2951824,13.1533029 44.47,13.12 C43.6405789,13.1384846 42.840533,12.812674 42.26,12.22 C41.0480699,10.9803246 41.0480699,8.99967541 42.26,7.76 C43.1709107,6.86991481 44.5271184,6.61365464 45.7,7.11 C46.0606018,7.25823045 46.3822404,7.48748348 46.64,7.78 L46.11,8.31 C45.7073541,7.82495058 45.0995877,7.55812631 44.47,7.59 C43.3916641,7.59745842 42.4507006,8.32321534 42.1695842,9.36429056 C41.8884679,10.4053658 42.3362296,11.5061132 43.2642473,12.0553373 C44.192265,12.6045614 45.3726551,12.4673948 46.15,11.72 C46.4554502,11.3851023 46.6325669,10.9529375 46.65,10.5 L44.47,10.5 L44.47,9.78 L47.38,9.78 C47.4027696,9.93236612 47.4161282,10.0859906 47.42,10.24 L47.42,10.24 Z",
  stroke: "#FFFFFF",
  strokeWidth: "0.2",
  fill: "#FFFFFF"
}), /*#__PURE__*/React__default.createElement("polygon", {
  stroke: "#FFFFFF",
  strokeWidth: "0.2",
  fill: "#FFFFFF",
  points: "52 7.74 49.3 7.74 49.3 9.64 51.76 9.64 51.76 10.36 49.3 10.36 49.3 12.26 52 12.26 52 13 48.52 13 48.52 7 52 7"
}), /*#__PURE__*/React__default.createElement("polygon", {
  stroke: "#FFFFFF",
  strokeWidth: "0.2",
  fill: "#FFFFFF",
  points: "55.28 13 54.51 13 54.51 7.74 52.83 7.74 52.83 7 57 7 57 7.74 55.28 7.74"
}), /*#__PURE__*/React__default.createElement("polygon", {
  stroke: "#FFFFFF",
  strokeWidth: "0.2",
  fill: "#FFFFFF",
  points: "59.94 13 59.94 7 60.71 7 60.71 13"
}), /*#__PURE__*/React__default.createElement("polygon", {
  stroke: "#FFFFFF",
  strokeWidth: "0.2",
  fill: "#FFFFFF",
  points: "64.13 13 63.36 13 63.36 7.74 61.68 7.74 61.68 7 65.8 7 65.8 7.74 64.13 7.74"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M73.61,12.22 C73.026689,12.8037876 72.2352634,13.1317962 71.41,13.1317962 C70.5847366,13.1317962 69.793311,12.8037876 69.21,12.22 C68.0365537,10.9725973 68.0365537,9.02740265 69.21,7.78 C69.7814921,7.17897422 70.5809257,6.84829942 71.41,6.87 C72.2374575,6.85691055 73.0335694,7.18621139 73.61,7.78 C74.190918,8.37091188 74.5082932,9.17156292 74.49,10 C74.5165237,10.8298939 74.1979114,11.6336659 73.61,12.22 L73.61,12.22 Z M69.78,11.72 C70.2103002,12.1560579 70.7973788,12.4015225 71.41,12.4015225 C72.0226212,12.4015225 72.6096998,12.1560579 73.04,11.72 C73.9346528,10.7478399 73.9346528,9.25216008 73.04,8.28 C72.6096998,7.84394215 72.0226212,7.59847754 71.41,7.59847754 C70.7973788,7.59847754 70.2103002,7.84394215 69.78,8.28 C68.8853472,9.25216008 68.8853472,10.7478399 69.78,11.72 L69.78,11.72 Z",
  stroke: "#FFFFFF",
  strokeWidth: "0.2",
  fill: "#FFFFFF"
}), /*#__PURE__*/React__default.createElement("polygon", {
  stroke: "#FFFFFF",
  strokeWidth: "0.2",
  fill: "#FFFFFF",
  points: "75.58 13 75.58 7 76.51 7 79.43 11.67 79.43 11.67 79.43 10.51 79.43 7 80.2 7 80.2 13 79.4 13 76.35 8.11 76.35 8.11 76.35 9.26 76.35 13"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M68.14,21.75 C65.7872765,21.7555293 63.8844985,23.6672686 63.8900115,26.0199921 C63.8955484,28.3727156 65.8072843,30.2754972 68.1600078,30.2699885 C70.5127313,30.2644558 72.4155163,28.3527235 72.41,26 C72.426473,24.8643738 71.9812316,23.7707097 71.1762551,22.9695037 C70.3712787,22.1682976 69.2755364,21.7281956 68.14,21.75 L68.14,21.75 Z M68.14,28.58 C67.0832273,28.6539053 66.088673,28.0743135 65.6320213,27.1184371 C65.1753697,26.1625607 65.3494358,25.0246828 66.0709659,24.249038 C66.7924959,23.4733932 67.9148379,23.2176324 68.9011878,23.6040831 C69.8875378,23.9905338 70.5374189,24.9406494 70.54,26 C70.5725428,26.6626719 70.3360327,27.3103928 69.8841403,27.7961771 C69.432248,28.2819613 68.8032921,28.5646164 68.14,28.58 L68.14,28.58 Z M58.82,21.75 C56.4672765,21.7555293 54.5644985,23.6672686 54.5700115,26.0199921 C54.5755484,28.3727156 56.4872843,30.2754972 58.8400078,30.2699885 C61.1927313,30.2644558 63.0955163,28.3527235 63.09,26 C63.106473,24.8643738 62.6612316,23.7707097 61.8562551,22.9695037 C61.0512787,22.1682976 59.9555364,21.7281956 58.82,21.75 L58.82,21.75 Z M58.82,28.58 C57.7632273,28.6539053 56.768673,28.0743135 56.3120213,27.1184371 C55.8553697,26.1625607 56.0294358,25.0246828 56.7509659,24.249038 C57.4724959,23.4733932 58.5948379,23.2176324 59.5811878,23.6040831 C60.5675378,23.9905338 61.2174189,24.9406494 61.22,26 C61.2525428,26.6626719 61.0160327,27.3103928 60.5641403,27.7961771 C60.112248,28.2819613 59.4832921,28.5646164 58.82,28.58 L58.82,28.58 Z M47.74,23.06 L47.74,24.86 L52.06,24.86 C51.9922634,25.7078038 51.6398446,26.5077945 51.06,27.13 C50.1836518,28.0228625 48.9699725,28.5025202 47.72,28.45 C45.0690332,28.45 42.92,26.3009668 42.92,23.65 C42.92,20.9990332 45.0690332,18.85 47.72,18.85 C48.9404476,18.8318498 50.1188954,19.2953247 51,20.14 L52.27,18.87 C51.0659807,17.6791542 49.4332385,17.0231739 47.74,17.05 C45.3189608,16.955779 43.0403936,18.1936718 41.801854,20.2760571 C40.5633145,22.3584423 40.5633145,24.9515577 41.801854,27.0339429 C43.0403936,29.1163282 45.3189608,30.354221 47.74,30.26 C49.4701987,30.3291046 51.1475475,29.655982 52.35,28.41 C53.4001185,27.2564101 53.9596631,25.7391832 53.91,24.18 C53.9135793,23.8047255 53.8834584,23.4298875 53.82,23.06 L47.74,23.06 Z M93.05,24.46 C92.5160796,22.8892101 91.0679278,21.811053 89.41,21.7499923 C88.3043635,21.7478383 87.2471451,22.2034076 86.4893794,23.0085336 C85.7316138,23.8136596 85.3408955,24.8965231 85.41,26 C85.3924407,27.8748194 86.611123,29.5374987 88.4042599,30.0851449 C90.1973968,30.632791 92.1370825,29.9347165 93.17,28.37 L91.72,27.37 C91.280167,28.103094 90.4848748,28.5483054 89.63,28.54 C88.742835,28.5766297 87.9244125,28.0641224 87.57,27.2499923 L93.26,24.9 L93.05,24.46 Z M87.25,25.88 C87.2090571,25.2525116 87.4223869,24.634951 87.8419025,24.1665232 C88.2614182,23.6980954 88.8518111,23.4182257 89.48,23.39 C90.1387659,23.3497893 90.7574492,23.7083892 91.05,24.3 L87.25,25.88 Z M82.63,30 L84.5,30 L84.5,17.5 L82.63,17.5 L82.63,30 Z M79.57,22.7 L79.5,22.7 C78.9347066,22.0562073 78.116706,21.6910285 77.26,21.7 C74.9901469,21.8100717 73.2063371,23.6824796 73.2063371,25.955 C73.2063371,28.2275204 74.9901469,30.0999283 77.26,30.21 C78.1183976,30.2272187 78.9397171,29.8605582 79.5,29.21 L79.57,29.21 L79.57,29.82 C79.57,31.45 78.7,32.32 77.3,32.32 C76.3435146,32.2989876 75.4943492,31.702597 75.15,30.81 L73.53,31.48 C74.1431493,33.0199895 75.6425851,34.0222649 77.3,34 C79.49,34 81.3,32.71 81.3,29.57 L81.3,22 L79.57,22 L79.57,22.7 Z M77.42,28.58 C76.0600866,28.4952122 75.0005459,27.367554 75.0005459,26.005 C75.0005459,24.642446 76.0600866,23.5147878 77.42,23.43 C78.0670204,23.4579218 78.6750106,23.747221 79.1047995,24.231676 C79.5345883,24.7161309 79.7493771,25.3542625 79.7,26 C79.7551348,26.6480494 79.5426575,27.2904311 79.1119703,27.7777877 C78.6812831,28.2651443 78.0699104,28.5550138 77.42,28.58 L77.42,28.58 Z M101.81,17.5 L97.33,17.5 L97.33,30 L99.2,30 L99.2,25.26 L101.81,25.26 C103.262684,25.3643638 104.651974,24.648509 105.41013,23.404973 C106.168286,22.161437 106.168286,20.598563 105.41013,19.355027 C104.651974,18.111491 103.262684,17.3956362 101.81,17.5 L101.81,17.5 Z M101.81,23.5 L99.2,23.5 L99.2,19.24 L101.85,19.24 C102.614548,19.24 103.32102,19.6478817 103.703294,20.31 C104.085569,20.9721183 104.085569,21.7878817 103.703294,22.45 C103.32102,23.1121183 102.614548,23.52 101.85,23.52 L101.81,23.5 Z M113.35,21.71 C111.958089,21.6241747 110.648702,22.3752042 110.02,23.62 L111.67,24.31 C112.010603,23.695923 112.680401,23.3394806 113.38,23.4 C113.859528,23.3439946 114.341454,23.4829701 114.717528,23.7857102 C115.093603,24.0884503 115.332299,24.5295749 115.38,25.01 L115.38,25.13 C114.778663,24.8139168 114.109348,24.6491623 113.43,24.65 C111.65,24.65 109.83,25.65 109.83,27.47 C109.865569,28.2515813 110.216509,28.9853449 110.802624,29.5036142 C111.38874,30.0218835 112.159942,30.280368 112.94,30.22 C113.895412,30.2728479 114.805111,29.8065317 115.32,29 L115.38,29 L115.38,30 L117.18,30 L117.18,25.19 C117.18,23 115.52,21.73 113.39,21.73 L113.35,21.71 Z M113.12,28.56 C112.51,28.56 111.66,28.25 111.66,27.5 C111.66,26.5 112.72,26.16 113.66,26.16 C114.254042,26.1453419 114.841131,26.2903874 115.36,26.58 C115.230157,27.7031043 114.29036,28.5574651 113.16,28.58 L113.12,28.56 Z M123.74,22 L121.6,27.42 L121.54,27.42 L119.32,22 L117.32,22 L120.65,29.58 L118.75,33.79 L120.7,33.79 L125.82,22 L123.74,22 Z M106.94,30 L108.8,30 L108.8,17.5 L106.94,17.5 L106.94,30 Z",
  fill: "#FFFFFF"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M10.44,7.54 C10.1104694,7.92961949 9.94232908,8.43046284 9.97,8.94 L9.97,31.06 C9.93597397,31.5703792 10.1048935,32.0735438 10.44,32.46 L10.51,32.54 L22.9,20.15 L22.9,19.85 L10.51,7.47 L10.44,7.54 Z",
  fill: "url(#linearGradient-1)"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M27,24.28 L22.9,20.15 L22.9,19.85 L27,15.72 L27.09,15.78 L32,18.56 C33.4,19.35 33.4,20.65 32,21.45 L27.11,24.23 L27,24.28 Z",
  fill: "url(#linearGradient-2)"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M27.12,24.22 L22.9,20 L10.44,32.46 C11.0230326,32.9789708 11.89324,33.0083981 12.51,32.53 L27.12,24.22",
  fill: "url(#linearGradient-3)"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M27.12,15.78 L12.51,7.48 C11.8969646,6.9947215 11.0238977,7.02002779 10.44,7.54 L22.9,20 L27.12,15.78 Z",
  fill: "url(#linearGradient-4)"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M27,24.13 L12.51,32.38 C11.9181542,32.8266792 11.1018458,32.8266792 10.51,32.38 L10.51,32.38 L10.44,32.45 L10.44,32.45 L10.51,32.53 L10.51,32.53 C11.1018458,32.9766792 11.9181542,32.9766792 12.51,32.53 L27.12,24.22 L27,24.13 Z",
  fill: "#000000",
  opacity: "0.2"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M10.44,32.32 C10.1187941,31.9233599 9.96138192,31.4189256 10,30.91 L10,31.06 C9.96597397,31.5703792 10.1348935,32.0735438 10.47,32.46 L10.54,32.39 L10.44,32.32 Z",
  fill: "#000000",
  opacity: "0.12"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M32,21.3 L27,24.13 L27.09,24.22 L32,21.44 C32.5903954,21.1903582 32.9970603,20.6379078 33.06,20 L33.06,20 C32.9332082,20.5771002 32.5397617,21.059629 32,21.3 Z",
  fill: "#000000",
  opacity: "0.12"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M12.51,7.62 L32,18.7 C32.5397617,18.940371 32.9332082,19.4228998 33.06,20 L33.06,20 C32.9970603,19.3620922 32.5903954,18.8096418 32,18.56 L12.51,7.48 C11.12,6.68 9.97,7.34 9.97,8.94 L9.97,9.09 C10,7.49 11.12,6.83 12.51,7.62 Z",
  fill: "#FFFFFF",
  opacity: "0.25"
})))), 'google-play', '0 0 135 40');

var StoreIcons = function StoreIcons(_ref) {
  var _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? "" : _ref$icon;

  switch (icon) {
    case "app-store":
      return /*#__PURE__*/React__default.createElement(AppStore, null);

    case "google-play":
      return /*#__PURE__*/React__default.createElement(GooglePlay, null);

    default:
      return null;
  }
};

var useStyles$J = makeStyles(styles$F);
var ContentLinks = function ContentLinks(props) {
  var _clsx2;

  var classes = useStyles$J();
  var surfaceColor = props.surfaceColor,
      flexiCol = props.flexiCol,
      isMobileWidth = props.isMobileWidth,
      isTabletWidth = props.isTabletWidth; // const { setDisclosurePopupList } = useDisclosure();

  var setDisclosurePopupList = props.setDisclosurePopupList;
  var link = get$1(props.fields, "link.value.text") ? props.fields.link : null;
  var secondaryLink = get$1(props.fields, "secondaryLink.value.text") ? props.fields.secondaryLink : null;
  var buttonIcon = get$1(props.fields, "buttonIcon.fields.value.value") || null;
  var iconLocation = get$1(props.fields, "iconLocation.value.text") || "PrefixIcon";
  var secondaryLinkButtonIcon = get$1(props.fields, "secondaryLinkButtonIcon.fields.value.value") || null;
  var secondaryLinkIconLocation = get$1(props.fields, "secondaryLinkIconLocation.value.text") || "PrefixIcon";
  var linkType = get$1(link, "value.linktype", null) || null;
  var linkHref = get$1(link, "value.href", null) || null;
  var linkUrl = get$1(link, "value.url", null) || null;
  var linkModelPopupContent = get$1(link, "value.modelpopupcontent", null) || null;
  var linkDisclosurePopupContent = get$1(link, "value.disclosurepopupcontent", null) || null;
  var secondaryLinkType = get$1(secondaryLink, "value.linktype", null) || null;
  var secondarylinkHref = get$1(secondaryLink, "value.href", null) || null;
  var secondarylinkUrl = get$1(secondaryLink, "value.url", null) || null;
  var secondarylinkModelPopupContent = get$1(secondaryLink, "value.modelpopupcontent", null) || null;
  var secondarylinkDisclosurePopupContent = get$1(secondaryLink, "value.disclosurepopupcontent", null) || null;
  var secondaryformType = get$1(secondaryLink, "value.querystring", null) || null;
  var buttonMode = get$1(props.fields, "buttonMode.fields.value.value", null) || null;
  var secondaryLinkButtonMode = get$1(props.fields, "secondaryLinkButtonMode.fields.value.value", null);
  var isBothPrimary = buttonMode === secondaryLinkButtonMode === "Primary";
  var linkGALabelName = get$1(props, "fields.linkGALabelName.value", "");
  var secondaryLinkGALabelName = get$1(props, "fields.secondaryLinkGALabelName.value", "");
  var gaCategoryName = props.gaCategoryName;
  var setModalState = props.setModalState,
      modalState = props.modalState,
      closeModalHandler = props.closeModalHandler;
  var pageEditing = get$1(props, "pageEditing", false);
  var routeTemplateId = get$1(props, "routeData.templateId", "");
  var productGALabelName = get$1(props, "routeData.fields.gaLabelName.value", "");
  var productName = get$1(props, "routeData.fields.productTitle.value", "");
  var qRCodeImageValue = get$1(props, "fields.qRCodeImage.value", "");
  var isMarketing = get$1(props, "isMarketing", false) && true;
  var navigate = get$1(props, 'navigate', function (href) {
    if (typeof window !== 'undefined') {
      window.open(href);
    }
  });

  var openModalHandler = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, linkVariant) {
      var href, urlLink, typeLink, iconButton, formType;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              e.stopPropagation();
              href = linkVariant === "primary" ? linkHref : secondarylinkHref;
              urlLink = linkVariant === "primary" ? linkUrl : secondarylinkUrl;
              typeLink = linkVariant === "primary" ? get$1(link, "value.linktype", null) || null : secondaryLinkType;
              iconButton = linkVariant === "primary" ? get$1(props.fields, "buttonIcon.fields.value.value") || null : secondaryLinkButtonIcon;
              formType = linkVariant === "primary" ? get$1(link, "value.querystring", null) || null : secondaryformType;
              PushEvent(_objectSpread2(_objectSpread2({
                event: "buttonClick",
                buttonTitle: (linkVariant === "primary" ? linkGALabelName : secondaryLinkGALabelName) || getGTMSharedKeyVal(href, COMPONENT_LINK$4),
                componentName: gaCategoryName ? gaCategoryName : COMPONENT_LINK$4,
                destinationUrl: href
              }, typeLink === "media" ? {
                brochure: {
                  name: getGTMSharedKeyVal(linkHref, COMPONENT_LINK$4),
                  url: linkHref
                }
              } : null), [templateIds.PRODUCT_TEMPLATE_ID, templateIds.PACKAGE_TEMPLATE_ID, templateIds.RIDER_TEMPLATE_ID].includes(routeTemplateId.toLowerCase()) ? {
                productName: productGALabelName || getGTMSharedKeyVal(href, COMPONENT_LINK$4)
              } : null), props.gtmPushEvent);

              if (iconButton === "call") {
                /* istanbul ignore else */
                if (urlLink && typeof window !== "undefined") {
                  window.open(urlLink, "_self");
                }
              } else {
                if (typeLink === "modelpopup") {
                  if (linkVariant === "primary" && !isEmpty(linkModelPopupContent) || linkVariant === "secondary" && !isEmpty(secondarylinkModelPopupContent)) {
                    setModalState(true);
                  } else {
                    /* istanbul ignore else */
                    if (linkVariant === "primary" && !isEmpty(linkDisclosurePopupContent) && get$1(linkDisclosurePopupContent, "disclosure.value", null)) {
                      setDisclosurePopupList({
                        isRoutedDirectly: false,
                        activePopupKey: linkDisclosurePopupContent.disclosure.value,
                        eligiblePopupList: [linkDisclosurePopupContent.disclosure.value]
                      });
                    } else if (linkVariant === "secondary" && !isEmpty(secondarylinkDisclosurePopupContent) && get$1(secondarylinkDisclosurePopupContent, "disclosure.value", null)) {
                      setDisclosurePopupList({
                        isRoutedDirectly: false,
                        activePopupKey: secondarylinkDisclosurePopupContent.disclosure.value,
                        eligiblePopupList: [secondarylinkDisclosurePopupContent.disclosure.value]
                      });
                    }
                  }
                } else if ((e.ctrlKey || e.metaKey) && typeof window !== "undefined") {
                  window.open(href, "_blank");
                } else if (typeLink === "internal") {
                  navigate(href);
                  props.updateGroupEnquiryData({
                    productName: productName,
                    groupEnquiryInitializer: enquiryInitializer.CONTENT_BLOCK
                  });
                } else if (["external", "media"].includes(typeLink)) {
                  if (typeof window !== "undefined") {
                    window.open(href, "_blank");
                  }
                } else if (typeLink === "mailto") {
                  if (typeof window !== "undefined") {
                    window.open(href, "_self");
                  }
                } else if (typeLink === "form") {
                  if (formType === "enquiry") {
                    props.updateFormLinks({
                      URL: generatelayoutServicePath(href, props.language),
                      formType: "enquiry"
                    });
                    props.updateFormInitializer({
                      initializer: calculatorInitializers.ENQUIRY,
                      enquiryInitializer: "SUPPORT"
                    });
                    props.appInSession(true);
                  } else if (formType === "bookAnAgent") {
                    props.updateFormLinks({
                      URL: generatelayoutServicePath(href, props.language),
                      formType: "bookAnAgent"
                    });
                    props.updateFormInitializer({
                      initializer: calculatorInitializers.BOOKANAGENT,
                      enquiryInitializer: "SUPPORT"
                    });
                  } else if (formType === "calculator") {
                    props.updateFormLinks({
                      URL: generatelayoutServicePath(href, props.language),
                      formType: "calculator"
                    });
                    props.updateFormInitializer({
                      initializer: calculatorInitializers.CALCULATOR
                    });
                    props.appInSession(true);
                    props.hasSessionPopups(true);
                  } else {
                    props.updateFormLinks({
                      URL: generatelayoutServicePath(href, props.language),
                      formType: "recommender"
                    });
                    props.updateFormInitializer({
                      initializer: calculatorInitializers.RECOMMENDER
                    });
                    props.appInSession(true);
                    props.hasSessionPopups(true);
                  }

                  props.updateFormModalState({
                    formModalState: true
                  });
                }
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function openModalHandler(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var wrapperRef = React__default.useRef();

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      wrapCTAs = _React$useState2[0],
      setWrapCTAs = _React$useState2[1];

  React__default.useEffect(function () {
    checkWidthCTAs();
  }, [wrapperRef]);

  var checkWidthCTAs = function checkWidthCTAs() {
    setWrapCTAs(false);
    /* istanbul ignore else */

    if (wrapperRef.current) {
      if (!flexiCol && wrapperRef.current.offsetHeight > 40) {
        setWrapCTAs(true);
      } else if (secondaryLinkButtonMode === "SimpleLink" || wrapperRef.current.offsetWidth > wrapperRef.current.parentNode.offsetWidth || wrapperRef.current.offsetHeight > 40) {
        setWrapCTAs(true);
      }
    }
  };

  React__default.useEffect(function () {
    /* istanbul ignore else */
    if (wrapperRef.current) {
      var flexiContainerElm = hasParents(wrapperRef.current, "flexiContainer");
      /* istanbul ignore else */

      if (flexiContainerElm) {
        _toConsumableArray(flexiContainerElm.querySelectorAll(".contentBlock")).forEach(function (elm) {
          return Object.assign(elm.style, {
            paddingBottom: flexiCol && !isMobileWidth && wrapperRef.current.offsetHeight > 96 ? "".concat(wrapperRef.current.offsetHeight + 48, "px") : ""
          });
        });
      }
    }
  }, [wrapCTAs, isMobileWidth]);
  /* istanbul ignore else */

  if (!link && !secondaryLink) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  }

  var storeIconHandler = function storeIconHandler(hrefValue) {
    /* istanbul ignore else */
    if (typeof window !== "undefined") {
      window.open(hrefValue, "_blank");
    }
  };

  var renderStoreIcon = function renderStoreIcon(href, _ref3) {
    var locator = _ref3.locator,
        icon = _ref3.icon;
    return /*#__PURE__*/React__default.createElement("a", {
      onClick: function onClick() {
        PushEvent({
          event: "buttonClick",
          buttonTitle: icon,
          componentName: gaCategoryName ? gaCategoryName : locator,
          destinationUrl: href
        }, props.gtmPushEvent);
        storeIconHandler(href);
      },
      tabIndex: 0,
      onKeyPress: function onKeyPress(e) {
        if (e.key === "Enter") {
          PushEvent({
            event: "buttonClick",
            buttonTitle: icon,
            componentName: gaCategoryName ? gaCategoryName : locator,
            destinationUrl: href
          }, props.gtmPushEvent);
          storeIconHandler(href);
        }
      },
      "data-locator": locator,
      className: icon,
      name: locator
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "srOnly"
    }, icon), /*#__PURE__*/React__default.createElement(StoreIcons, {
      icon: icon
    }));
  };

  var iosAndroidRegex = /(android)|(ios)/i;
  var isStoreIconExist = iosAndroidRegex.test(buttonMode) || iosAndroidRegex.test(secondaryLinkButtonMode);
  /* istanbul ignore else */

  if (isStoreIconExist) {
    var params = {
      ios: {
        locator: COMPONENT_APP_STORE_ICON,
        icon: "app-store"
      },
      android: {
        locator: COMPONENT_GOOGLE_PLAY_ICON,
        icon: "google-play"
      }
    };

    if (qRCodeImageValue && !isMobileWidth && !isTabletWidth) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: classes.marketingSectionContainer,
        "data-locator": COMPONENT_MARKETING_SECTION_CONTAINER
      }, /*#__PURE__*/React__default.createElement("img", {
        src: qRCodeImageValue.src,
        alt: qRCodeImageValue.alt,
        height: 110,
        width: 110
      }), /*#__PURE__*/React__default.createElement("div", {
        className: classes.marketingContent,
        "data-locator": COMPONENT_MARKETING_SECTION
      }, get$1(props, "fields.marketingLabel.value", "") && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        "data-locator": COMPONENT_MARKETING_LABEL,
        variant: "h6"
      }, get$1(props, "fields.marketingLabel.value", "")), /*#__PURE__*/React__default.createElement("div", {
        className: clsx("linkWrapper", classes.downloadIconsContainer),
        "data-locator": COMPONENT_DOWNLOAD_ICON_CONTAINER
      }, link && renderStoreIcon(linkHref, params[buttonMode.search(/ios/i) !== -1 ? "ios" : "android"]), secondaryLink && renderStoreIcon(secondarylinkHref, params[secondaryLinkButtonMode.search(/ios/i) !== -1 ? "ios" : "android"]))));
    } else {
      return /*#__PURE__*/React__default.createElement("div", {
        className: clsx("linkWrapper", classes.downloadIconsContainer, _defineProperty({}, "marketingContentMobile", isMarketing)),
        "data-locator": COMPONENT_DOWNLOAD_ICON_CONTAINER
      }, link && renderStoreIcon(linkHref, params[buttonMode.search(/ios/i) !== -1 ? "ios" : "android"]), secondaryLink && renderStoreIcon(secondarylinkHref, params[secondaryLinkButtonMode.search(/ios/i) !== -1 ? "ios" : "android"]));
    }
  }

  var renderDialog = function renderDialog(modelLink) {
    var modalContent = get$1(modelLink, "value.modelpopupcontent", {});

    if ((linkType === "modelpopup" || secondaryLinkType === "modelpopup") && !isEmpty(modalContent)) {
      return /*#__PURE__*/React__default.createElement(Dialog$1, {
        fullScreen: true,
        open: modalState,
        onClose: closeModalHandler,
        "data-locator": COMPONENT_DIALOG
      }, /*#__PURE__*/React__default.createElement("div", {
        "data-locator": COMPONENT_MODALPOPUP_CONTAINER,
        className: classes.modalPopupWrap
      }, get$1(modalContent, "title.value", null) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        component: "h2",
        variant: "h2",
        color: "white",
        "data-locator": COMPONENT_MODAL_TITLE
      }, modalContent.title.value), get$1(modalContent, "subTitle.value", null) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        variant: "body1",
        component: "h3",
        color: "white",
        "data-locator": COMPONENT_MODAL_SUBTITLE
      }, modalContent.subTitle.value), get$1(modalContent, "description.value", null) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        variant: "body4",
        component: "div",
        color: "white",
        "data-locator": COMPONENT_MODAL_DESCRIPTION,
        type: "richtext"
      }, /*#__PURE__*/React__default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: modalContent.description.value
        }
      }))));
    } else {
      return null;
    }
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ReactResizeDetector, {
    handleWidth: true,
    onResize: checkWidthCTAs
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: wrapperRef,
    className: clsx("linkWrapper", classes.linkWrapper, secondaryLinkButtonMode === "SimpleLink" && "twoCtasPrimarySimpleLink", secondaryLinkButtonMode === "SimpleLink" ? "simpleLink" : "secondary", secondaryLinkButtonMode === "Primary" && buttonMode === "Primary" ? "bothPrimary" : "diffCtas", (_clsx2 = {}, _defineProperty(_clsx2, classes.featuredLinkWrapper, props.isFeatured), _defineProperty(_clsx2, "twoCTAs", link && secondaryLink), _defineProperty(_clsx2, "maxWidth", wrapCTAs), _defineProperty(_clsx2, "flexiCol", flexiCol), _clsx2))
  }, link && /*#__PURE__*/React__default.createElement("div", {
    className: clsx("primaryLink")
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    component: linkType === "modelpopup" ? "div" : "a",
    onClick: function onClick(e) {
      openModalHandler(e, "primary");
    },
    onKeyPress: function onKeyPress(e) {
      if (e.key === "Enter") {
        openModalHandler(e, "primary");
      }
    },
    href: get$1(link, "value.linktype", "") !== "modelpopup" ? buttonIcon === "call" ? linkUrl : linkHref : undefined,
    underline: "none",
    "data-locator": COMPONENT_LINK$4,
    className: classes.linkButtonWrapper
  }, buttonMode === "SimpleLink" && linkType !== "form" ? /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.bottomLinkWrapper, "firstsimplelink")
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    component: "div",
    variant: "body1",
    underline: "none",
    size: "small",
    type: "caption",
    icon: buttonIcon,
    color: surfaceColor,
    className: clsx(_defineProperty({}, classes.linkAlign, buttonIcon))
  }, link && link.value && link.value.text)) : /*#__PURE__*/React__default.createElement(StyledMemoizedButton, _extends({
    disablePushEvent: true,
    color: surfaceColor,
    "data-locator": COMPONENT_BUTTON$5,
    icon: buttonIcon,
    alt: get$1(link, "value.text", null),
    GTMSharedKey: get$1(linkGALabelName, "value", ""),
    link: buttonIcon === "call" ? linkUrl : linkHref,
    "aria-label": get$1(link, "value.text", null),
    prefixIcon: iconLocation === "PrefixIcon",
    "button-type": buttonMode === "Secondary" ? "Secondary" : "Primary",
    className: clsx(classes.button, props.IsMerge === "1" ? classes.buttonMergedContainer : ""),
    gtmPushEvent: props.gtmPushEvent
  }, buttonMode === "Secondary" && {
    outlined: true
  }), get$1(link, "value.text", null)), renderDialog(link))), secondaryLink && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(isBothPrimary ? "primaryLink" : secondaryLinkButtonMode !== "SimpleLink" ? "secondaryLink" : "simpleLink")
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    component: secondaryLinkType === "modelpopup" ? "div" : "a",
    href: secondaryLinkType !== "modelpopup" ? secondarylinkHref : undefined,
    target: secondaryLinkType === "external" ? "_blank" : "_self",
    "data-locator": COMPONENT_LINK$4,
    underline: "none",
    onClick: function onClick(e) {
      openModalHandler(e, "secondary");
    },
    onKeyPress: function onKeyPress(e) {
      if (e.key === "Enter") {
        openModalHandler(e, "secondary");
      }
    }
  }, secondaryLinkButtonMode === "SimpleLink" && secondaryLinkType !== "form" ? /*#__PURE__*/React__default.createElement("div", {
    className: classes.bottomLinkWrapper
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    component: "div",
    variant: "body1",
    underline: "none",
    size: "small",
    type: "caption",
    icon: secondaryLinkButtonIcon,
    color: surfaceColor,
    className: clsx(_defineProperty({}, classes.linkAlign, secondaryLinkButtonIcon))
  }, pageEditing ? get$1(secondaryLink, "value.text", null) : // <SitecoreLink field={secondaryLink} />
  secondaryLink && secondaryLink.value && secondaryLink.value.text)) : /*#__PURE__*/React__default.createElement(StyledMemoizedButton, _extends({
    color: surfaceColor,
    "data-locator": COMPONENT_BUTTON$5,
    icon: secondaryLinkButtonIcon,
    prefixIcon: secondaryLinkIconLocation === "PrefixIcon",
    className: props.IsMerge === "1" ? classes.buttonMergedContainer : "",
    "aria-label": get$1(secondaryLink, "value.text", null),
    alt: get$1(secondaryLink, "value.text", null),
    GTMSharedKey: get$1(secondaryLinkGALabelName, "value", ""),
    "button-type": secondaryLinkButtonMode,
    variant: secondaryLinkButtonMode,
    gtmPushEvent: props.gtmPushEvent
  }, secondaryLinkButtonMode === "Secondary" && {
    outlined: true
  }), get$1(secondaryLink, "value.text", null)), renderDialog(secondaryLink)))));
};

var ContentBlock$1 = function ContentBlock(props) {
  var _clsx5, _clsx6, _clsx7, _clsx8, _clsx10, _clsx12, _clsx14, _clsx15, _clsx16, _clsx17;

  var addSeperator = props.addSeperator;
  var classes = useStyles$J(); // const { t } = useTranslation();

  var dictionary = get$1(props, "dictionary", {
    "available-to-buy": "Available to buy"
  });

  var t = function t(key) {
    return dictionary[key];
  };

  var anchorText = get$1(props, "params.anchorText", "Content-Block-" + getRandomValues()).replace(/\s+/g, "-") || "Content-Block";

  var _ref4 = props.fields || {},
      title = _ref4.title,
      description = _ref4.description,
      image = _ref4.image,
      mobileImage = _ref4.mobileImage,
      qRCodeImage = _ref4.qRCodeImage,
      infographicImage = _ref4.infographicImage,
      videoLink = _ref4.videoLink,
      videoYouTubeID = _ref4.videoYouTubeID,
      enableHeading = _ref4.enableHeading,
      link = _ref4.link,
      secondaryLink = _ref4.secondaryLink,
      _ref4$brightcoveVideo = _ref4.brightcoveVideo,
      brightcoveVideo = _ref4$brightcoveVideo === void 0 ? {} : _ref4$brightcoveVideo;

  var showMediaOnMobile = !!parseInt(get$1(props, "params.showMediaOnMobile", "0"), 10);
  var mediaType = get$1(props, "fields.mediaType.fields.key.value", null);
  var hasMedia = (get$1(image, "value.src") || get$1(videoLink, "value.src")) && mediaType !== null;
  var imageAlignment = get$1(props, "params.imageAlignment", "Right") || "Right";
  var contentBlockVariant = get$1(props, "params.contentBlockVariant", "default");
  var titleHtml = lineBreaker(title === null || title === void 0 ? void 0 : title.value);
  var gaCategoryName = get$1(props, "fields.gaCategoryName.value", null);
  var playVideoInBackground = get$1(props, "params.PlayVideoInBackground", false);
  var flexiCol = props.flexiCol || null;
  var colIndex = props.colIndex;
  var isFirst = props.isFirst;
  var isMiddle = props.isMiddle;
  var isLast = props.isLast;
  var color = get$1(props, "params.backgroundColor", "white-white");

  var _getColors = getColors(color),
      bgColor = _getColors.bgColor,
      surfaceColor = _getColors.surfaceColor;

  var isMobileWidth = useMediaQuery("(max-width:".concat(breakpoints.values.sm, "px)"));
  var isTabletSmallWidth = useMediaQuery("(max-width:".concat(breakpoints.values.lg, "px)"));
  var isTabletWidth = useMediaQuery("(max-width:".concat(breakpoints.values.xl, "px)"));
  var params = props.params ? props.params : {
    paddingTop: "large",
    paddingBottom: "large"
  };
  var hasDividerLine = !!parseInt(get$1(props, "params.divider", "0"), 10);
  var featuredTags = get$1(props, "fields.featuredTags", null);
  var purchaseMethod = get$1(props, "fields.purchaseMethod", []);
  var isYoutube = videoYouTubeID && videoYouTubeID.value || false;
  var contentBlockType = get$1(props, "params.contentBlockType", "ls") || "ls";
  var IsMerge = get$1(props, "params.IsMerge", 0) || 0;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalState = _useState2[0],
      setModalState = _useState2[1];

  var buttonMode = get$1(props.fields, "buttonMode.fields.value.value", null) || null;
  var secondaryLinkButtonMode = get$1(props.fields, "secondaryLinkButtonMode.fields.value.value", null);
  var brightcoveAccId = get$1(props, "sitecoreContext.siteSettings.brightcoveAccountID", "");
  var pageEditing = get$1(props, "sitecoreContext.pageEditing", "");
  var qRCodeImageValue = get$1(qRCodeImage, "value.src", "");
  var navigate = get$1(props, 'navigate', function (href) {
    if (typeof window !== 'undefined') {
      window.open(href);
    }
  });
  var navigateChip = get$1(props, 'navigateChip', function (href) {
    if (typeof window !== 'undefined') {
      window.open(href);
    }
  });
  var iosAndroidRegex = /(android)|(ios)/i;
  var isStoreIconExist = iosAndroidRegex.test(buttonMode) || iosAndroidRegex.test(secondaryLinkButtonMode); // infographic fields
  // overridding mandate fields for infographic

  var isInfographic = !!parseInt(get$1(props, "params.isInfographic", "0"), 10);
  var isArticleBody = !!parseInt(get$1(props, "params.isArticleBody", "0"), 10);
  var infographicButtonIcon = get$1(props, "fields.infographicButtonIcon.fields.value.value");
  var infographicButtonText = get$1(props, "fields.infographicButtonText.value");
  var infographicButtonGaLabel = get$1(props, "fields.infographicGaLabelName");
  /* istanbul ignore else */

  if (isInfographic) {
    mediaType = "Image";
    showMediaOnMobile = true;
    hasMedia = true;
  }
  /* istanbul ignore else */


  if (isArticleBody) {
    imageAlignment = "Right";
  }

  var direction = imageAlignment === "Right" || contentBlockType === "ls" && !hasMedia ? "row" : "row-reverse";
  var justifyContent = direction === "row-reverse" ? "flex-start" : "flex-end";

  var closeModalHandler = function closeModalHandler() {
    if (get$1(props, "fields.link.value.linktype", "") === "form") {
      props.updateFormModalState({
        formModalState: false
      });
    } else {
      setModalState(false);
    }
  }; // elements


  var infographicCtaWrapper = useMemo(function () {
    return isInfographic && /*#__PURE__*/React__default.createElement("div", {
      className: classes.infographicCtaWrapper
    }, /*#__PURE__*/React__default.createElement(ZoomPanPinch, {
      buttonProps: {
        "data-locator": COMPONENT_INFOGRAPHIC_BUTTON,
        color: bgColor,
        text: infographicButtonText,
        icon: infographicButtonIcon,
        "aria-label": "zoom and pinch button"
      },
      infographicImage: infographicImage,
      gaLabelName: infographicButtonGaLabel,
      gaCategoryName: gaCategoryName
    }));
  }, [infographicImage]);
  var isContainer = !flexiCol;
  var isFeatured = contentBlockVariant === "featured" && hasMedia && !flexiCol;
  var isMarketing = contentBlockVariant === "marketing" && qRCodeImageValue;
  surfaceColor = isFeatured ? surfaceColor : bgColor;
  return pageEditing || title && title.value || description && description.value || image && image.value && image.value.src ? /*#__PURE__*/React__default.createElement(Container$1, {
    id: anchorText,
    useContainer: !isArticleBody && isContainer,
    background: bgColor,
    "data-locator": isFeatured ? FEATURED_COMPONENT_WRAPPER : COMPONENT_WRAPPER,
    "data-scriptidentifier": "ContentBlock",
    mergedClass: IsMerge === "1" ? "mergedContainer" : "",
    className: clsx(getPaddingString(!isMarketing ? params : _objectSpread2(_objectSpread2({}, params), {}, {
      paddingBottom: "None"
    })), hasDividerLine ? "component-divider-".concat(bgColor) : "", (_clsx5 = {}, _defineProperty(_clsx5, classes.rootContainer, IsMerge === 0), _defineProperty(_clsx5, classes.rootContainerMerged, IsMerge === "1"), _defineProperty(_clsx5, classes.rootContainerFeatured, isFeatured), _defineProperty(_clsx5, classes.rootContainerMarketing, isMarketing), _clsx5))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx("contentBlock", "bg-color-".concat(surfaceColor), classes.boxCss, (_clsx6 = {}, _defineProperty(_clsx6, getBorderRadius("xlarge", "xlarge", "none", "xlarge"), isFeatured && !isTabletSmallWidth), _defineProperty(_clsx6, getBorderRadius("medium", "medium", "none", "medium"), isFeatured && isTabletSmallWidth), _defineProperty(_clsx6, classes["contentBlockFirst"], flexiCol && isFirst), _defineProperty(_clsx6, "contentBlockFirst", flexiCol && isFirst), _defineProperty(_clsx6, classes["contentBlockMiddle"], flexiCol && isMiddle), _defineProperty(_clsx6, "contentBlockMiddle", flexiCol && isMiddle), _defineProperty(_clsx6, classes["contentBlockLast"], flexiCol && isLast), _defineProperty(_clsx6, "contentBlockLast", flexiCol && isLast), _defineProperty(_clsx6, classes.featured, isFeatured), _defineProperty(_clsx6, classes.marketing, isMarketing), _defineProperty(_clsx6, "leftImageFeatured", isFeatured && imageAlignment === "Left"), _defineProperty(_clsx6, classes["divider-".concat(surfaceColor)], addSeperator === true), _defineProperty(_clsx6, classes.flexiColBlocks, !isContainer), _defineProperty(_clsx6, classes.isArticleBody, isArticleBody), _defineProperty(_clsx6, classes.paddingBottomContentBlock, (link && link.value && Object.keys(link.value).length > 0 || secondaryLink && link.value && Object.keys(secondaryLink.value).length > 0) && colIndex >= 0), _defineProperty(_clsx6, "isInfographic", isInfographic), _defineProperty(_clsx6, classes.paddingBottomInFlexitwoCTA, !isContainer && link && !isEmpty(link.value) && secondaryLink && !isEmpty(secondaryLink.value)), _clsx6))
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    display: "flex",
    direction: direction,
    justifyContent: "space-between",
    alignItems: isFeatured ? "flex-start" : "center",
    spacing: !isMarketing || !isFeatured ? 3 : 0,
    className: clsx((_clsx7 = {}, _defineProperty(_clsx7, "featuredContentWrapper", isFeatured), _defineProperty(_clsx7, "marketingContentWrapper", isMarketing), _clsx7))
  }, !isArticleBody && /*#__PURE__*/React__default.createElement(StyledGrid, _extends({
    item: true,
    className: isFeatured ? "featuredTextContainer" : ""
  }, isFeatured || isMarketing ? {
    lg: 12,
    xl: hasMedia ? 5 : contentBlockType === "ls" ? 8 : 12
  } : {
    xs: 12,
    sm: hasMedia ? 5 : contentBlockType === "ls" ? 8 : 12
  }), /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    item: true,
    sm: 12,
    lg: 12,
    spacing: 0,
    className: clsx(isMarketing ? getPaddingString({
      paddingBottom: params.paddingBottom,
      paddingTop: "None"
    }) : "", (_clsx8 = {}, _defineProperty(_clsx8, classes.innerGridContainer, contentBlockType === "ms"), _defineProperty(_clsx8, classes.paddingBottomMarketingTabletMobile, isMarketing && isTabletWidth), _clsx8))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(_defineProperty({}, classes.rightContent, imageAlignment === "Left" && contentBlockType !== "ms" && hasMedia))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx((_clsx10 = {}, _defineProperty(_clsx10, classes.widthWithImageRight, hasMedia && contentBlockType === "ls" && imageAlignment === "Right"), _defineProperty(_clsx10, classes.widthWithImageLeft, hasMedia && contentBlockType === "ls" && imageAlignment === "Left"), _defineProperty(_clsx10, classes.widthWithoutImage, !hasMedia && contentBlockType === "ls"), _defineProperty(_clsx10, classes.widthWithoutImageMS, contentBlockType === "ms"), _clsx10))
  }, !isArticleBody && title && title.value && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h2",
    component: enableHeading && enableHeading.value ? "h1" : "h2",
    color: surfaceColor,
    gutter: "false",
    className: classes.title,
    "data-locator": COMPONENT_TITLE$8
  }, /*#__PURE__*/React__default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: titleHtml
    }
  })), hasMedia && imageAlignment === "Left" && showMediaOnMobile && /*#__PURE__*/React__default.createElement(StyledGrid, _extends({
    item: true,
    className: clsx(classes.showOnMobileOnly, _defineProperty({}, "featuredMediaContainer", isFeatured))
  }, isFeatured ? {
    lg: 12,
    xl: isArticleBody ? 12 : 6
  } : {
    xs: 12,
    sm: isArticleBody ? 12 : 6
  }), /*#__PURE__*/React__default.createElement("div", {
    display: "flex",
    flexDirection: "column",
    "data-locator": "Content-Block-Media-Alignment-".concat(imageAlignment),
    className: clsx(classes.media, classes.mediaOnTop, (_clsx12 = {}, _defineProperty(_clsx12, "featuredMedia", isFeatured), _defineProperty(_clsx12, getBorderRadius("xlarge", "xlarge", "none", "xlarge"), isFeatured && !isMobileWidth), _defineProperty(_clsx12, getBorderRadius("medium", "medium", "none", "medium"), isFeatured && isMobileWidth), _defineProperty(_clsx12, classes.flexStart, justifyContent === "flex-start"), _defineProperty(_clsx12, classes.flexEnd, justifyContent === "flex-end"), _clsx12))
  }, mediaType === "Image" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Picture, {
    media: {
      image: image,
      mobileImage: mobileImage,
      aspectRatio: {
        mobile: "16-9",
        tablet: "16-9",
        desktop: "16-9"
      }
    },
    hasBorderRadius: isFeatured ? false : true,
    "data-locator": COMPONENT_IMAGE$2
  }), infographicCtaWrapper), mediaType === "Video" && /*#__PURE__*/React__default.createElement(Video$1, {
    image: {
      image: image,
      mobileImage: mobileImage,
      aspectRatio: {
        mobile: "16-9",
        tablet: "16-9",
        desktop: "16-9"
      }
    },
    hasBorderRadius: isFeatured ? false : true,
    title: title.value,
    gaCategoryName: gaCategoryName,
    isYoutube: isYoutube,
    videoSource: get$1(videoLink, "value.src"),
    videoYouTubeID: videoYouTubeID.value,
    componentName: "ContentBlock",
    playVideoInBackground: playVideoInBackground,
    gaLabelName: get$1(props, "fields.gaLabelName.value", ""),
    brightcoveVideoInfo: brightcoveVideo,
    brightCoveAccId: brightcoveAccId
  }))), !isArticleBody && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    color: surfaceColor,
    className: classes.description,
    "data-locator": COMPONENT_DESCRIPTION$4,
    type: "richtext"
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description.value
    }
  })), featuredTags && /*#__PURE__*/React__default.createElement("div", {
    "data-locator": COMPONENT_TAG$1,
    className: classes.chipsWrapper
  }, featuredTags.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      mr: 1,
      className: classes.chipWrapper
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "body3",
      component: "span"
    }, /*#__PURE__*/React__default.createElement(FwdChip, {
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        PushEvent({
          event: "buttonClick",
          buttonTitle: get$1(item, "fields.searchName.value", "") || getGTMSharedKeyVal(get$1(item, "fields.link.value.href", ""), COMPONENT_TAG$1),
          componentName: gaCategoryName ? gaCategoryName : COMPONENT_TAG$1,
          destinationUrl: "".concat(get$1(item, "fields.link.value.href", "")).concat(get$1(item, "fields.link.value.querystring", ""))
        }, props.gtmPushEvent);
        /* istanbul ignore else */

        if (get$1(item, "fields.link.value.linktype", null) === "internal") {
          navigateChip(get$1(item, "fields.link.value.href", "") + get$1(item, "fields.link.value.querystring", ""));
        } else if (get$1(item, "fields.link.value.linktype", null) === "external") {
          if (typeof window !== "undefined") {
            window.open(get$1(item, "fields.link.value.href", "") + get$1(item, "fields.link.value.querystring", ""), "_blank");
          }
        }
      },
      tabIndex: 0,
      onKeyPress: function onKeyPress(e) {
        if (e.key === "Enter") {
          e.preventDefault();
          e.stopPropagation();
          PushEvent({
            event: "buttonClick",
            buttonTitle: get$1(item, "fields.searchName.value", "") || getGTMSharedKeyVal(get$1(item, "fields.link.value.href", ""), COMPONENT_TAG$1),
            componentName: gaCategoryName ? gaCategoryName : COMPONENT_TAG$1,
            destinationUrl: "".concat(get$1(item, "fields.link.value.href", "")).concat(get$1(item, "fields.link.value.querystring", ""))
          }, props.gtmPushEvent);
          /* istanbul ignore else */

          if (get$1(item, "fields.link.value.linktype", null) === "internal") {
            navigateChip(get$1(item, "fields.link.value.href", "") + get$1(item, "fields.link.value.querystring", ""));
          } else if (get$1(item, "fields.link.value.linktype", null) === "external") {
            if (typeof window !== "undefined") {
              window.open(get$1(item, "fields.link.value.href", "") + get$1(item, "fields.link.value.querystring", ""), "_blank");
            }
          }
        }
      },
      size: "small",
      label: item.fields.name.value,
      classes: classes.chip,
      "data-locator": COMPONENT_TAG_ITEM,
      component: "a",
      href: get$1(item, "fields.link.value.href", "") + get$1(item, "fields.link.value.querystring", ""),
      target: item.fields.link.linktype === "external" ? "_blank" : "_self"
    })));
  })), purchaseMethod && purchaseMethod.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: classes.purchaseMethodWrapper
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h6",
    component: "h3",
    color: surfaceColor,
    className: classes.purchaseMethodHeader,
    "data-locator": COMPONENT_PURCHASE_METHOD_HEADER
  }, t("available-to-buy")), /*#__PURE__*/React__default.createElement("ul", {
    className: classes.purchaseMethodList,
    "data-locator": COMPONENT_PURCHASE_METHOD_LIST
  }, purchaseMethod.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      key: index,
      variant: "body1",
      component: "li",
      type: "caption",
      color: surfaceColor,
      className: classes.purchaseMethodListItem,
      "data-locator": COMPONENT_PURCHASE_METHOD_LIST_ITEM
    }, get$1(item, "fields.name.value", ""));
  }))), (!isMarketing && isTabletWidth || !isTabletWidth) && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.showOnDesktopOnly, _defineProperty({}, classes.downloadIcons, isStoreIconExist))
  }, !isInfographic && /*#__PURE__*/React__default.createElement(ContentLinks, {
    isMobileWidth: isMobileWidth,
    isTabletWidth: isTabletWidth,
    flexiCol: flexiCol,
    updateFormInitializer: props.updateFormInitializer,
    bgColor: bgColor,
    surfaceColor: surfaceColor,
    gaCategoryName: gaCategoryName,
    fields: props.fields,
    setModalState: setModalState,
    modalState: modalState,
    updateFormModalState: props.updateFormModalState,
    closeModalHandler: closeModalHandler,
    language: props.sitecoreContext.languageCode || props.sitecoreContext.language,
    updateFormLinks: props.updateFormLinks,
    IsMerge: IsMerge,
    isFeatured: isFeatured,
    isMarketing: isMarketing,
    appInSession: props.appInSession,
    hasSessionPopups: props.hasSessionPopups,
    pageEditing: pageEditing,
    routeData: get$1(props, "sitecoreContext.route", {}),
    updateGroupEnquiryData: props.updateGroupEnquiryData,
    navigate: navigate,
    gtmPushEvent: props.gtmPushEvent
  })))))), isTabletWidth && isMarketing && /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    item: true,
    sm: 12,
    lg: 12,
    spacing: 0
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.showOnTabletMobile, (_clsx14 = {}, _defineProperty(_clsx14, classes.alignCenter, !isStoreIconExist && !flexiCol && buttonMode !== "SimpleLink"), _defineProperty(_clsx14, classes.downloadIcons, isStoreIconExist), _clsx14))
  }, !isInfographic && /*#__PURE__*/React__default.createElement(ContentLinks, {
    isMobileWidth: isMobileWidth,
    isTabletWidth: isTabletWidth,
    flexiCol: flexiCol,
    updateFormInitializer: props.updateFormInitializer,
    bgColor: bgColor,
    surfaceColor: surfaceColor,
    gaCategoryName: gaCategoryName,
    fields: props.fields,
    setModalState: setModalState,
    modalState: modalState,
    updateFormModalState: props.updateFormModalState,
    closeModalHandler: closeModalHandler,
    language: props.sitecoreContext.languageCode || props.sitecoreContext.language,
    updateFormLinks: props.updateFormLinks,
    IsMerge: IsMerge,
    appInSession: props.appInSession,
    hasSessionPopups: props.hasSessionPopups,
    isFeatured: isFeatured,
    isMarketing: isMarketing,
    pageEditing: pageEditing,
    routeData: get$1(props, "sitecoreContext.route", {}),
    updateGroupEnquiryData: props.updateGroupEnquiryData,
    navigate: navigate
  }))), hasMedia && /*#__PURE__*/React__default.createElement(StyledGrid, _extends({
    item: true,
    className: clsx((_clsx15 = {}, _defineProperty(_clsx15, "featuredMediaContainer", isFeatured), _defineProperty(_clsx15, classes.showOnDesktopOnly, isFeatured ? false : showMediaOnMobile === false || imageAlignment === "Left"), _defineProperty(_clsx15, classes.marketingOnly, isMarketing), _defineProperty(_clsx15, classes.marketingDesktopMedia, isMarketing && !isTabletWidth), _clsx15))
  }, isFeatured || isMarketing ? {
    xs: 12,
    sm: 12,
    lg: 12,
    xl: isArticleBody ? 12 : 7
  } : {
    xs: 12,
    sm: isArticleBody ? 12 : 6
  }), /*#__PURE__*/React__default.createElement("div", {
    justifyContent: justifyContent,
    "data-locator": "Content-Block-Media-Alignment-".concat(imageAlignment),
    className: clsx(classes.media, (_clsx16 = {}, _defineProperty(_clsx16, "featuredMedia", isFeatured), _defineProperty(_clsx16, getBorderRadius("xlarge", "xlarge", "none", "xlarge"), isFeatured && !isTabletSmallWidth), _defineProperty(_clsx16, getBorderRadius("medium", "medium", "none", "medium"), isFeatured && isTabletSmallWidth), _defineProperty(_clsx16, classes.flexStart, justifyContent === "flex-start"), _defineProperty(_clsx16, classes.flexEnd, justifyContent === "flex-end"), _clsx16))
  }, mediaType === "Image" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Picture, {
    media: {
      image: image,
      mobileImage: mobileImage,
      aspectRatio: {
        mobile: !isMarketing ? "16-9" : "full-flex-end",
        tablet: !isMarketing ? "16-9" : "full-flex-end",
        desktop: !isMarketing ? "16-9" : "full-flex-end"
      }
    },
    hasBorderRadius: isFeatured || isMarketing ? false : true,
    className: isFeatured ? "featuredPicture" : "",
    "data-locator": COMPONENT_IMAGE$2
  }), infographicCtaWrapper), mediaType === "Video" && /*#__PURE__*/React__default.createElement(Video$1, {
    image: {
      image: image,
      mobileImage: mobileImage,
      minWidth: 720,
      aspectRatio: {
        mobile: "16-9",
        desktop: "16-9",
        tablet: "16-9"
      }
    },
    hasBorderRadius: isFeatured ? false : true,
    className: isFeatured ? "featuredVideo" : "",
    title: title.value,
    gaCategoryName: gaCategoryName,
    isYoutube: isYoutube,
    videoSource: get$1(videoLink, "value.src"),
    videoYouTubeID: videoYouTubeID.value,
    componentName: "ContentBlock",
    playVideoInBackground: playVideoInBackground,
    brightcoveVideoInfo: brightcoveVideo,
    brightCoveAccId: brightcoveAccId
  })))), isMobileWidth && !isMarketing && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.showOnTabletMobile, (_clsx17 = {}, _defineProperty(_clsx17, classes.alignCenter, !isStoreIconExist && !flexiCol && buttonMode !== "SimpleLink"), _defineProperty(_clsx17, classes.downloadIcons, isStoreIconExist), _clsx17))
  }, !isInfographic && /*#__PURE__*/React__default.createElement(ContentLinks, {
    isMobileWidth: isMobileWidth,
    isTabletWidth: isTabletWidth,
    flexiCol: flexiCol,
    updateFormInitializer: props.updateFormInitializer,
    bgColor: bgColor,
    surfaceColor: surfaceColor,
    gaCategoryName: gaCategoryName,
    fields: props.fields,
    setModalState: setModalState,
    modalState: modalState,
    updateFormModalState: props.updateFormModalState,
    closeModalHandler: closeModalHandler,
    language: props.sitecoreContext.languageCode || props.sitecoreContext.language,
    updateFormLinks: props.updateFormLinks,
    IsMerge: IsMerge,
    appInSession: props.appInSession,
    hasSessionPopups: props.hasSessionPopups,
    isFeatured: isFeatured,
    isMarketing: isMarketing,
    pageEditing: pageEditing,
    routeData: get$1(props, "sitecoreContext.route", {}),
    updateGroupEnquiryData: props.updateGroupEnquiryData,
    navigate: navigate,
    gtmPushEvent: props.gtmPushEvent
  })))) : null;
}; // const mapDispatchToProps = dispatch => {

var styles$C = function styles(theme) {
  var _li;

  var colors = theme.palette.colors || {};
  var theming = {};
  Object.keys(colors).forEach(function (color) {
    theming["carousel-".concat(color)] = {
      '& .slick-dots li button': {
        '&:hover': {
          '&:before': {
            color: theme.palette.colors[color].slick.dotsActive
          }
        },
        '&:before': {
          color: theme.palette.colors[color].slick.dotsDefault
        }
      },
      '& .slick-dots li.slick-active button:before': {
        color: theme.palette.colors[color].slick.dotsActive
      },
      '& .slick-prev, .slick-next': {
        color: theme.palette.colors[color].slick.dotsActive,
        '&:hover': {
          color: theme.palette.colors[color].slick.dotsActive
        }
      }
    };
  });
  return _objectSpread2({
    root: {
      '& .slick-dots': {
        height: theme.spacing(1),
        '& li': (_li = {
          top: theme.spacing(-1.5),
          width: theme.spacing(1),
          height: theme.spacing(1),
          margin: "0 ".concat(theme.spacing(0.25), "px")
        }, _defineProperty(_li, theme.breakpoints.up('lg'), {
          margin: "0 ".concat(theme.spacing(0.5), "px")
        }), _defineProperty(_li, '&.slick-active', {
          '& button': {
            '&:before': {
              opacity: 1
            }
          }
        }), _defineProperty(_li, '& button', {
          width: theme.spacing(1),
          height: theme.spacing(1),
          padding: 0,
          '&:before': {
            opacity: 1,
            lineHeight: "".concat(theme.spacing(0.5), "px"),
            left: '-1px',
            width: theme.spacing(1),
            height: theme.spacing(1)
          }
        }), _li)
      }
    },
    carouselAnimation: {
      '& .slick-track > div:first-child': {
        animation: animations.moveUpAndFadeIn.desktop,
        animationDelay: '0.00s',
        animationFillMode: 'backwards'
      },
      '& .slick-track > div:nth-child(2)': {
        animation: animations.moveUpAndFadeIn.desktop,
        animationDelay: '0.05s',
        animationFillMode: 'backwards'
      },
      '& .slick-track > div:nth-child(3)': {
        animation: animations.moveUpAndFadeIn.desktop,
        animationDelay: '0.1s',
        animationFillMode: 'backwards'
      }
    }
  }, theming);
};

/**
 * Slick slider- base css style
 * import css file to prevent transforms the class name
 * @param {object} settings - Provides slider configuration
 * @param {HtmlElement} children - Children nodes of slider
 * @parma {string} className - Name of class
 * @param {string} dataLocator - Data locator name
 * @param {string} color - Provides color palette for styling. Default value set to null
 */

/**
 * Slider Animations
 * @param {bool} settings.animate - To add animation classes
 * @param {bool} settings.overrideSpeedAndEase - if true then css and ease effects will be used from component params
 */

var Carousel$1 = /*#__PURE__*/React__default.forwardRef(function Carousel(props, ref) {
  var _clsx;

  var useStyles = makeStyles(styles$C);
  var _props$settings = props.settings,
      settings = _props$settings === void 0 ? {} : _props$settings,
      children = props.children,
      _props$className = props.className,
      className = _props$className === void 0 ? [] : _props$className,
      dataLocator = props.dataLocator,
      _props$color = props.color,
      color = _props$color === void 0 ? null : _props$color;
  var _settings$animate = settings.animate,
      animate = _settings$animate === void 0 ? false : _settings$animate,
      _settings$overrideSpe = settings.overrideSpeedAndEase,
      overrideSpeedAndEase = _settings$overrideSpe === void 0 ? false : _settings$overrideSpe;

  if (!overrideSpeedAndEase) {
    settings.speed = '600';
    if (settings.responsive) settings.responsive[0].settings.speed = '400'; //for mobile sliding speed

    settings.cssEase = transitionFunction.easeInOut;
  }

  var classes = useStyles();
  var isMobile = useMediaQuery("(max-width:".concat(breakpoints.values.sm, "px)"));
  return /*#__PURE__*/React__default.createElement(Fragment, null, children && children.length ? /*#__PURE__*/React__default.createElement(Slider, _extends({}, settings, {
    className: clsx(className, (_clsx = {}, _defineProperty(_clsx, classes.root, color), _defineProperty(_clsx, classes["carousel-".concat(color)], color), _defineProperty(_clsx, classes.carouselAnimation, animate && !isMobile), _clsx)),
    "data-locator": dataLocator ? dataLocator : '',
    ref: ref
  }), children) : null);
});
Carousel$1.propTypes = {
  /**
   * Slider configurations settings
   */
  settings: PropTypes.object,

  /**
   * Children nodes of slider
   */
  children: PropTypes.node.isRequired,

  /**
   *  Class name
   */
  className: PropTypes.string,

  /**
   *  Data Locator name
   */
  dataLocator: PropTypes.string
};

var styles$B = function styles(theme) {
  var colors = theme.palette.colors || {};
  var theming = {};
  Object.keys(colors).forEach(function (color) {
    var _colors$color$tabsBac, _colors$color;

    theming["tabs-vertical-".concat(color)] = {
      '& .MuiTabs-flexContainerVertical': {
        backgroundColor: (_colors$color$tabsBac = (_colors$color = colors[color]) === null || _colors$color === void 0 ? void 0 : _colors$color.tabsBackground) !== null && _colors$color$tabsBac !== void 0 ? _colors$color$tabsBac : colors.orangeLighter.main
      }
    };
    theming["divider-primary-".concat(color)] = {
      borderBottom: "1px solid ".concat(colors[color].contrastTextAction)
    };
    theming["divider-secondary-".concat(color)] = {
      borderBottom: "1px solid ".concat(colors[color].line.divider)
    };
    theming["indicator-".concat(color)] = {
      '& .MuiTabs-indicator': {
        backgroundColor: colors[color].contrastTextAction
      }
    };
  });
  return _objectSpread2({
    vertical: {
      '& .MuiTabs-flexContainerVertical': {
        borderRadius: theme.spacing(2),
        alignItems: 'flex-start',
        padding: theme.spacing(1.5, 0)
      },
      '& .MuiTabs-indicator': {
        right: 'auto',
        width: theme.spacing(0.5),
        left: 0
      },
      '& [class*=PrivateTabIndicator-root-]': {
        transition: motionTypes.moveSmall.in,
        transitionProperty: 'top, height'
      }
    },
    horizontal: {
      '& .MuiTabs-indicator': {
        height: theme.spacing(0.5)
      },
      '& [class*=PrivateTabIndicator-root-]': {
        transition: motionTypes.moveSmall.in,
        transitionProperty: 'left, width'
      },
      '& .MuiTabs-scroller': {
        display: 'flex',
        justifyContent: 'center'
      }
    },
    singleTab: {
      '& button': {
        pointerEvents: 'none'
      }
    },
    hideIndicator: {
      '& .MuiTabs-indicator': {
        display: 'none'
      }
    }
  }, theming);
};

var useStyles$I = makeStyles(styles$B);
/**
 * @param {string} orientation - 'horizontal' | 'vertical'; default: 'horizontal'
 * @param {bool} divider - 'true' | 'false'; default: 'false' - show/hide divider line
 * @param {string} dividerType - 'primary' | 'secondary'; default: 'primary' - sets divider line colour; refer colour foundation -> Divider
 * @param {string} color - background color
 * @param {function} onChange - called when tabs are switched
 * @param {string} value - the value of currently selected tab
 * @param {bool} singleTab - if there's only one tab
 * @param {bool} hideIndicator - hides indicator when single tab and no label
 */

var FwdTabs = function FwdTabs(props) {
  var _clsx;

  var classes = useStyles$I();
  var color = props.color,
      orientation = props.orientation,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      _props$dividerType = props.dividerType,
      dividerType = _props$dividerType === void 0 ? 'primary' : _props$dividerType,
      _props$singleTab = props.singleTab,
      singleTab = _props$singleTab === void 0 ? false : _props$singleTab,
      _props$hideIndicator = props.hideIndicator,
      hideIndicator = _props$hideIndicator === void 0 ? false : _props$hideIndicator;
  return /*#__PURE__*/React__default.createElement(Tabs, _extends({
    indicatorColor: "primary",
    scrollButtons: "off",
    className: clsx(classes.root, classes["indicator-".concat(color)], (_clsx = {}, _defineProperty(_clsx, classes["tabs-vertical-".concat(color)], orientation === 'vertical'), _defineProperty(_clsx, classes.vertical, orientation === 'vertical'), _defineProperty(_clsx, classes.horizontal, orientation === 'horizontal'), _defineProperty(_clsx, classes["divider-primary-".concat(color)], orientation === 'horizontal' && divider && dividerType === 'primary'), _defineProperty(_clsx, classes["divider-secondary-".concat(color)], orientation === 'horizontal' && divider && dividerType === 'secondary'), _defineProperty(_clsx, classes.singleTab, singleTab), _defineProperty(_clsx, classes.hideIndicator, hideIndicator), _clsx))
  }, props));
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$A = function styles(theme) {
  var colors = theme.palette.colors || {};
  var theming = {};
  Object.keys(colors).forEach(function (color) {
    var _colors$color, _colors$color2, _colors$color3;

    theming["tab-horizontal-".concat(color)] = {
      '& .MuiTab-wrapper': {
        color: (_colors$color = colors[color]) === null || _colors$color === void 0 ? void 0 : _colors$color.contrastText
      },
      '&.Mui-selected .MuiTab-wrapper': {
        color: (_colors$color2 = colors[color]) === null || _colors$color2 === void 0 ? void 0 : _colors$color2.contrastTextAction
      },
      '&:hover .MuiTab-wrapper': {
        color: (_colors$color3 = colors[color]) === null || _colors$color3 === void 0 ? void 0 : _colors$color3.contrastTextAction,
        background: color === 'orange' ? '#FFFFFF33' : '#e8772233',
        //colors with 30% opacity
        borderRadius: theme.spacing(0.5)
      }
    };
  });
  return _objectSpread2({
    vertical: _objectSpread2(_objectSpread2({}, theme.typography.h6D), {}, {
      textAlign: 'left',
      minHeight: '0',
      maxWidth: 'none',
      width: '100%',
      padding: theme.spacing(1, 0),
      margin: theme.spacing(0.5, 0),
      color: colors.darkGreen.main,
      '& .MuiTab-wrapper': _defineProperty({
        width: '85%',
        maxWidth: theme.spacing(30.5),
        letterSpacing: 'initial',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'flex-start'
      }, theme.breakpoints.down('md'), {
        width: '80%'
      }),
      '&:hover ': {
        background: colors.orange.main,
        color: colors.white.main
      },
      '&:hover .bullet': {
        color: colors.white.main
      },
      '&.MuiTab-textColorInherit': {
        opacity: '1'
      },
      '&.Mui-selected': {
        color: colors.orange.main,
        '&:hover': {
          color: colors.white.main
        }
      },
      '& .MuiTouchRipple-root': {
        display: 'none'
      },
      '& .bullet': {
        color: colors.orange.main
      }
    }),
    horizontal: {
      padding: theme.spacing(0, 1.5),
      '&.MuiTab-root': {
        margin: 0,
        minWidth: 'unset',
        maxWidth: 'unset'
      },
      '& .MuiTab-wrapper': _objectSpread2(_objectSpread2({}, theme.typography.h5), {}, _defineProperty({
        transition: 'inherit',
        padding: theme.spacing(0.5),
        marginBottom: theme.spacing(1),
        alignSelf: 'flex-end',
        textAlign: 'start',
        wordBreak: 'break-word',
        maxWidth: theme.spacing(37)
      }, theme.breakpoints.down('sm'), {
        maxWidth: theme.spacing(30)
      })),
      '&.MuiTab-textColorInherit': {
        opacity: '1'
      },
      '& .MuiTouchRipple-root': {
        display: 'none'
      }
    }
  }, theming);
};

var useStyles$H = makeStyles(styles$A);
/**
 * @param {string} label - label to show on tab
 * @param {bool} ordering - when true shows index as bullets
 * @param {string} index - text for bullets
 */

var FwdTab = function FwdTab(props) {
  var _clsx;

  var classes = useStyles$H();
  var index = props.index,
      ordering = props.ordering,
      label = props.label,
      orientation = props.orientation;
  var color = orientation === 'horizontal' ? props === null || props === void 0 ? void 0 : props.color : undefined;

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;

  return /*#__PURE__*/React__default.createElement(Tab, _extends({}, props, {
    label: ordering ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
      className: 'bullet'
    }, "".concat(index + 1, "."), "\xA0"), /*#__PURE__*/React__default.createElement("span", null, "".concat(label))) : label,
    className: clsx(classes["tab-".concat(color)], 'motionColorTransition', (_clsx = {}, _defineProperty(_clsx, classes["tab-horizontal-".concat(color)], orientation === 'horizontal'), _defineProperty(_clsx, classes.vertical, orientation === 'vertical'), _defineProperty(_clsx, classes.horizontal, orientation === 'horizontal'), _defineProperty(_clsx, 'hideFocusonClick', !useKeyBoard), _defineProperty(_clsx, 'showFocusonTab', useKeyBoard), _clsx))
  }));
};

var styles$z = function styles(theme) {
  var _itemRoot;

  var colors = theme.palette.colors || {};
  var shareIcons = {};
  var backgrounds = {};
  var tags = {};
  Object.keys(colors).forEach(function (color) {
    shareIcons["shareIcon-".concat(color)] = {
      '& path': {
        fill: colors[color].contrastTextLabel
      }
    };
  });
  Object.keys(colors).forEach(function (color) {
    backgrounds["bgColor-".concat(color)] = {
      backgroundColor: colors[color].main
    };
  });
  Object.keys(colors).forEach(function (color) {
    tags["tagColor-".concat(color)] = {
      backgroundColor: colors[color].contrastTextAction,
      '& span': {
        fontWeight: '500',
        color: colors[color].main
      }
    };
  });
  return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, backgrounds), tags), {}, {
    itemRoot: (_itemRoot = {
      borderColor: 'transparent',
      borderRadius: theme.spacing(2.5),
      margin: '0px 2px'
    }, _defineProperty(_itemRoot, theme.breakpoints.up('xs'), {
      maxWidth: theme.typography.pxToRem(415),
      margin: '0 auto'
    }), _defineProperty(_itemRoot, theme.breakpoints.up('lg'), {
      maxWidth: 'auto',
      margin: '0px 12px'
    }), _defineProperty(_itemRoot, '&:hover', _defineProperty({}, theme.breakpoints.up('sm'), {
      cursor: 'pointer',
      boxShadow: theme.shadows[4]
    })), _itemRoot),
    selected: function selected(_ref) {
      var color = _ref.color;
      return _defineProperty({}, theme.breakpoints.up('lg'), {
        border: "3px solid ".concat(theme.palette.colors[color] ? theme.palette.colors[color].contrastTextAction : fwdColors.grey),
        padding: '3px',
        marginTop: '-6px',
        marginRight: '6px',
        marginLeft: '6px',
        backgroundColor: 'unset'
      });
    },
    itemInner: {
      margin: 0,
      border: '3px solid transparent ',
      position: 'relative',
      opacity: '1'
    },
    productPlanLabel: {
      fontSize: theme.typography.T11,
      lineHeight: theme.typography.lineHeight.L15
    },
    title: _defineProperty({
      marginBottom: '0',
      letterSpacing: 'unset',
      fontSize: theme.typography.T5,
      lineHeight: theme.typography.lineHeight.L8,
      fontWeight: theme.typography.fontWeights.bolder
    }, theme.breakpoints.up('lg'), {
      fontSize: theme.typography.T4,
      lineHeight: theme.typography.lineHeight.L6
    }),
    header: function header(_ref3) {
      var color = _ref3.color;
      return {
        paddingTop: theme.spacing(2.75),
        paddingBottom: theme.spacing(3),
        '& + .productPlanCard__body': {
          borderTop: "1px solid ".concat(theme.palette.colors[color] ? theme.palette.colors[color].line.divider : fwdColors.grey)
        }
      };
    },
    body: {
      paddingTop: theme.spacing(1),
      '&:last-child': {
        paddingBottom: theme.spacing(1)
      }
    },
    cardFooter: {
      paddingTop: theme.spacing(1)
    },
    tooltip: {
      marginLeft: theme.spacing(0.5),
      width: theme.spacing(2),
      height: theme.spacing(2),
      display: 'inline-flex',
      cursor: 'pointer'
    },
    valuesContainer: function valuesContainer(_ref4) {
      var color = _ref4.color;
      return {
        border: "1px solid ".concat(theme.palette.colors[color] ? theme.palette.colors[color].line.divider : fwdColors.grey),
        borderRadius: theme.spacing(0.5)
      };
    },
    valueItem: function valueItem(_ref5) {
      var color = _ref5.color;
      return {
        paddingTop: theme.typography.pxToRem(1),
        paddingBottom: theme.typography.pxToRem(1),
        marginLeft: theme.typography.pxToRem(-1),
        borderBottom: "1px solid ".concat(theme.palette.colors[color] ? theme.palette.colors[color].line.divider : fwdColors.grey),
        display: 'flex',
        '&:last-child': {
          borderBottom: 'none'
        }
      };
    },
    currencyValueLabel: {
      fontSize: theme.typography.T11,
      lineHeight: theme.typography.lineHeight.L14
    },
    tag: {
      '& span': {
        fontSize: theme.typography.T11,
        fontWeight: theme.typography.fontWeights.bold,
        lineHeight: theme.typography.lineHeight.L14
      },
      padding: theme.spacing(0.75, 1),
      paddingTop: theme.typography.pxToRem(5),
      borderRadius: theme.typography.pxToRem(4),
      marginLeft: theme.spacing(2),
      transform: 'translate(-3px, calc(-100% + 14px))',
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        __expression__: 'all and (-ms-high-contrast: none), (-ms-high-contrast: active)',
        transform: 'translate(-3px, -65%)'
      }
    },
    share: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      padding: theme.spacing(0)
    },
    secLink: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: theme.typography.T11,
      lineHeight: theme.typography.lineHeight.L15,
      '&.noPadding': {
        fontWeight: theme.typography.fontWeights.bolder,
        padding: 0,
        margin: theme.spacing(-0.5, 0)
      }
    },
    buttonEnquire: {
      padding: 0,
      width: '100%',
      '& button': {
        width: '100%'
      }
    }
  }, shareIcons), {}, {
    compareBoxWrapper: function compareBoxWrapper(_ref6) {
      var color = _ref6.color;
      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '21px',
        // explict requirement for 21px.
        '& .MuiCheckbox-root': {
          padding: theme.spacing(0, 1)
        },
        '& .MuiFormControlLabel-root': {
          fontSize: theme.typography.T11,
          lineHeight: theme.typography.lineHeight.L15,
          margin: 0
        },
        '& .MuiFormControlLabel-label .MuiTypography-root': {
          color: theme.palette.colors[color] ? theme.palette.colors[color].contrastTextAction : fwdColors.grey,
          fontWeight: theme.typography.fontWeights.bolder,
          fontSize: theme.typography.T11,
          lineHeight: theme.typography.lineHeight.L15,
          '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
            __expression__: 'all and (-ms-high-contrast: none), (-ms-high-contrast: active)',
            position: 'relative',
            top: theme.spacing(0.25)
          }
        }
      };
    },
    secLinkContainer: function secLinkContainer(_ref7) {
      var color = _ref7.color;
      return {
        marginBottom: '21px',
        // explict requirement for 21px.
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        '&.withCompare': {
          borderLeft: "1px solid ".concat(theme.palette.colors[color] ? theme.palette.colors[color].line.divider : fwdColors.grey)
        }
      };
    }
  });
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var PRODUCTPLANLIST_CONTAINER = 'ProductPlanList-Container';
var PRODUCTPLANLIST_HEADING = 'ProductPlanList-Heading';
var PRODUCTPLANLIST_SUBHEADING = 'ProductPlanList-SubHeading';
var PRODUCTPLANLIST_CAROUSEL = 'ProductPlanList-Carousel';
var PRODUCTPLANLIST_CAROUSEL_NEXT_BUTTON = 'ProductPlanList-Carousel-Next-Button';
var PRODUCTPLANLIST_CAROUSEL_PREV_BUTTON = 'ProductPlanList-Carousel-Prev-Button';
var PRODUCTPLANLIST_PRIMARY_CTA = 'ProductPlanList-Primary-Cta';
var PRODUCTPLANLIST_SECONDARY_CTA = 'ProductPlanList-Secondary-Cta';
var PRODUCTPLANLIST_CALCULATE_BUTTON = 'ProductPlanList-CalculateButton';
var PRODUCTPLANLIST_SLIDER_FORYOU = 'ProductPlanList-Slider-foryou';
var PRODUCTPLANLIST_SLIDER_ALLPLANS = 'ProductPlanList-Slider-allplans';
var PRODUCTPLANLIST_EDIT = 'ProductPlanList-Edit';
var PRODUCTPLANLIST_RESET = 'ProductPlanList-Reset';
var PRODUCTPLANLIST_NO_RESULTS_ICON = 'ProductPlanList-No-Results-Icon';
var PRODUCTPLANLIST_NO_RESULTS_TITLE = 'ProductPlanList-No-Results-Title';
var PRODUCTPLANLIST_NO_RESULTS_DESCRIPTION = 'ProductPlanList-No-Results-Description';
var PRODUCTPLANLIST_NO_RESULTS_CTA = 'ProductPlanList-No-Results-Cta';
var PRODUCTPLANLIST_USER_DETAILS_WRAPPER = 'ProductPlanList-User-Details-Wrapper';
var PRODUCTPLANLIST_USER_DETAILS_LABEL = 'ProductPlanList-User-Detail-Label';
var PRODUCTPLANLIST_SEE_COMPARISON_CTA = 'ProductPlanList-See-Comparison-button';
var PRODUCTPLANLIST_COMPARISON_BAR_WRAPPER = 'ProductPlanList-Comparison-Bar-Wrapper';
var PRODUCTPLANLIST_BAR_TEXT = 'ProductPlanList-Comparison-Bar-Text';
var PRODUCTPLANCARD = 'ProductPlanCard';
var PRODUCTPLANCARD_TOOLTIPICON = 'ProductPlanCard-TooltipIcon';
var PRODUCTPLANCARD_LABEL = 'ProductPlanCard-Label';
var PRODUCTPLANCARD_SHAREICON = 'ProductPlanCard-ShareIcon';
var PRODUCTPLANCARD_PRODUCTNAME = 'ProductPlanCard-ProductName';
var PRODUCTPLANCARD_PRODUCTVALUE = 'ProductPlanCard-ProductValue';
var PRODUCTPLANCARD_ENQUIREBUTTON = 'ProductPlanCard-EnquireButton';
var PRODUCTPLANCARD_VALUES_CONTAINER = 'ProductPlanCard-Values-Container';
var PRODUCTPLANCARD_VALUE_LABEL = 'ProductPlanCard-Value-Labels';
var PRODUCTPLANCARD_TAG = 'ProductPlanCard-Tag';
var PRODUCTPLANCARD_COMPARE_CHECKBOX = 'ProductPlanCard-Compare-Checkbox';
var PRODUCTPLANCARD_COMPARE_CHECKBOX_LABEL = 'ProductPlanCard-Compare-Checkbox-Label';

var locators$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PRODUCTPLANLIST_CONTAINER: PRODUCTPLANLIST_CONTAINER,
  PRODUCTPLANLIST_HEADING: PRODUCTPLANLIST_HEADING,
  PRODUCTPLANLIST_SUBHEADING: PRODUCTPLANLIST_SUBHEADING,
  PRODUCTPLANLIST_CAROUSEL: PRODUCTPLANLIST_CAROUSEL,
  PRODUCTPLANLIST_CAROUSEL_NEXT_BUTTON: PRODUCTPLANLIST_CAROUSEL_NEXT_BUTTON,
  PRODUCTPLANLIST_CAROUSEL_PREV_BUTTON: PRODUCTPLANLIST_CAROUSEL_PREV_BUTTON,
  PRODUCTPLANLIST_PRIMARY_CTA: PRODUCTPLANLIST_PRIMARY_CTA,
  PRODUCTPLANLIST_SECONDARY_CTA: PRODUCTPLANLIST_SECONDARY_CTA,
  PRODUCTPLANLIST_CALCULATE_BUTTON: PRODUCTPLANLIST_CALCULATE_BUTTON,
  PRODUCTPLANLIST_SLIDER_FORYOU: PRODUCTPLANLIST_SLIDER_FORYOU,
  PRODUCTPLANLIST_SLIDER_ALLPLANS: PRODUCTPLANLIST_SLIDER_ALLPLANS,
  PRODUCTPLANLIST_EDIT: PRODUCTPLANLIST_EDIT,
  PRODUCTPLANLIST_RESET: PRODUCTPLANLIST_RESET,
  PRODUCTPLANLIST_NO_RESULTS_ICON: PRODUCTPLANLIST_NO_RESULTS_ICON,
  PRODUCTPLANLIST_NO_RESULTS_TITLE: PRODUCTPLANLIST_NO_RESULTS_TITLE,
  PRODUCTPLANLIST_NO_RESULTS_DESCRIPTION: PRODUCTPLANLIST_NO_RESULTS_DESCRIPTION,
  PRODUCTPLANLIST_NO_RESULTS_CTA: PRODUCTPLANLIST_NO_RESULTS_CTA,
  PRODUCTPLANLIST_USER_DETAILS_WRAPPER: PRODUCTPLANLIST_USER_DETAILS_WRAPPER,
  PRODUCTPLANLIST_USER_DETAILS_LABEL: PRODUCTPLANLIST_USER_DETAILS_LABEL,
  PRODUCTPLANLIST_SEE_COMPARISON_CTA: PRODUCTPLANLIST_SEE_COMPARISON_CTA,
  PRODUCTPLANLIST_COMPARISON_BAR_WRAPPER: PRODUCTPLANLIST_COMPARISON_BAR_WRAPPER,
  PRODUCTPLANLIST_BAR_TEXT: PRODUCTPLANLIST_BAR_TEXT,
  PRODUCTPLANCARD: PRODUCTPLANCARD,
  PRODUCTPLANCARD_TOOLTIPICON: PRODUCTPLANCARD_TOOLTIPICON,
  PRODUCTPLANCARD_LABEL: PRODUCTPLANCARD_LABEL,
  PRODUCTPLANCARD_SHAREICON: PRODUCTPLANCARD_SHAREICON,
  PRODUCTPLANCARD_PRODUCTNAME: PRODUCTPLANCARD_PRODUCTNAME,
  PRODUCTPLANCARD_PRODUCTVALUE: PRODUCTPLANCARD_PRODUCTVALUE,
  PRODUCTPLANCARD_ENQUIREBUTTON: PRODUCTPLANCARD_ENQUIREBUTTON,
  PRODUCTPLANCARD_VALUES_CONTAINER: PRODUCTPLANCARD_VALUES_CONTAINER,
  PRODUCTPLANCARD_VALUE_LABEL: PRODUCTPLANCARD_VALUE_LABEL,
  PRODUCTPLANCARD_TAG: PRODUCTPLANCARD_TAG,
  PRODUCTPLANCARD_COMPARE_CHECKBOX: PRODUCTPLANCARD_COMPARE_CHECKBOX,
  PRODUCTPLANCARD_COMPARE_CHECKBOX_LABEL: PRODUCTPLANCARD_COMPARE_CHECKBOX_LABEL
});

/*9fbef606107a605d69c0edbcd8029e5d*/
var LABELVALUELIST_TITLE = 'LabelValueList-Title';
var LABELVALUELIST = 'LabelValueList';
var LABELVALUELIST_PARENT_X = 'ParentValueList-{X}';
var LABELVALUELIST_X = 'LabelValueList-{X}';
var LABELVALUELIST_X_TITLE = 'LabelValueList-{X}-Title';
var LABELVALUELIST_X_ATTRIBUTEKEY_Y = 'LabelValueList-{X}-AttributeKey-{Y}';
var LABELVALUELIST_X_ATTRIBUTEVALUE_Y = 'LabelValueList-{X}-AttributeValue-{Y}';
var LABELVALUELIST_EXPANDICON = 'LabelValueList-ExpandIcon';

var styles$y = function styles(theme) {
  var colors = theme.palette.colors || {};
  var icon = theme.palette;
  var expandingIconColors = {};
  var cardDividers = {};
  Object.keys(colors).forEach(function (color) {
    var carouselIcon = icon[colors[color].icon].icon.carousel;
    expandingIconColors["expandingIcon-".concat(color)] = {
      borderRadius: '50%',
      backgroundColor: carouselIcon.background.default,
      '& path': {
        fill: carouselIcon.contrastText.default
      },
      '&:hover': {
        boxShadow: theme.shadows[5],
        backgroundColor: carouselIcon.background.hover,
        '& path': {
          fill: carouselIcon.contrastText.hover
        }
      },
      '&.expanded': {
        backgroundColor: carouselIcon.background.hover,
        '& path': {
          fill: carouselIcon.contrastText.hover
        }
      }
    };
  });
  Object.keys(colors).forEach(function (color) {
    cardDividers["divider-".concat(color)] = {
      '&::before': {
        backgroundColor: colors[color].line.divider
      }
    };
  });
  return _objectSpread2(_objectSpread2({}, cardDividers), {}, {
    root: {
      overflow: 'hidden'
    },
    title: {
      marginBottom: theme.spacing(2),
      fontSize: theme.typography.T11,
      lineHeight: theme.typography.lineHeight.L14
    },
    nextListAttibute: {
      paddingTop: theme.spacing(1)
    },
    itemTitle: {
      marginBottom: theme.spacing(1)
    },
    easingInOut: {
      transitionTimingFunction: "".concat(transitionFunction.easeInOut)
    },
    easingOut: {
      transitionTimingFunction: "".concat(transitionFunction.easeOut)
    },
    listItem: {
      marginBottom: theme.spacing(3),
      '&:last-child': {
        marginBottom: '0'
      }
    },
    expandingBar: {
      minHeight: theme.spacing(27 / 8),
      marginTop: theme.spacing(3),
      '&::before': {
        content: '""',
        height: '1px',
        width: '100%',
        position: 'absolute',
        top: '12px',
        left: '0'
      }
    },
    expandingBarCircle: {
      zIndex: '1',
      cursor: 'pointer',
      '&:hover': {
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)'
      }
    },
    expandingBarIcon: {
      width: '16px',
      height: '16px',
      transform: 'rotate(-90deg)',
      transition: 'all 300ms cubic-bezier(0.230, 1.000, 0.320, 1.000)',
      '&.expanded': {
        transform: 'rotate(90deg)'
      }
    }
  }, expandingIconColors);
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$x = function styles(theme) {
  return {
    key: {
      fontWeight: theme.typography.fontWeights.normal
    },
    labelValues: {
      '& .key, & .value': {
        fontSize: theme.typography.T11,
        lineHeight: theme.typography.lineHeight.L15,
        fontWeight: theme.typography.fontWeights.normal
      },
      '& .value': {
        fontWeight: theme.typography.fontWeights.bold,
        letterSpacing: 'unset'
      }
    }
  };
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var useStyles$G = makeStyles(styles$x);

var LabelValueItem = function LabelValueItem(props) {
  var classes = useStyles$G();
  var key = get$1(props, "fields.key", null);
  var value = get$1(props, "fields.value", null);
  var color = get$1(props, "color", "white");

  var render = function render() {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      container: true,
      spacing: 2,
      className: clsx(classes.labelValues)
    }, /*#__PURE__*/React__default.createElement(StyledGrid, {
      item: true,
      xs: true
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "h10",
      component: "span",
      className: "key",
      "data-locator": get$1(props, "data-locator-key", null),
      color: color,
      type: "caption"
    }, key)), /*#__PURE__*/React__default.createElement(StyledGrid, {
      item: true,
      xs: true
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "h10",
      component: "span",
      className: "value",
      "data-locator": get$1(props, "data-locator-value", null),
      color: color
    }, value)));
  };

  return render();
};

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var ArrowForward = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
  d: "m14.707 39.46425-.707-.707 14.586-14.586-14.586-14.586.707-.707c1.171-1.171 3.071-1.171 4.242 0l15.293 15.293-15.293 15.293c-1.171 1.171-3.071 1.171-4.242 0"
})), 'ArrowForward');

var useStyles$F = makeStyles(styles$y);

var LabelValueList = function LabelValueList(props) {
  var classes = useStyles$F();
  var _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'base' : _props$variant,
      _props$title = props.title,
      title = _props$title === void 0 ? null : _props$title,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      _props$onToggleExpand = props.onToggleExpand,
      onToggleExpand = _props$onToggleExpand === void 0 ? null : _props$onToggleExpand,
      _props$expandable = props.expandable,
      expandable = _props$expandable === void 0 ? false : _props$expandable,
      _props$expanded = props.expanded,
      expanded = _props$expanded === void 0 ? false : _props$expanded,
      _props$onExited = props.onExited,
      onExited = _props$onExited === void 0 ? undefined : _props$onExited;
  var color = get$1(props, 'color', 'white') || 'white'; // refs

  var listItemRef = useRef(); // states

  var _useState = useState(expanded),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard; // methods


  var onResize = debounce(function () {
    /* istanbul ignore else */
    if (listItemRef.current) {
      onExited && onExited();
    }
  }, 200, {
    trailing: true
  }); // effects

  useLayoutEffect(function () {
    onResize();
  }, [listItemRef, isExpanded]);
  useEffect(function () {
    setIsExpanded(expanded);
  }, [expanded]);
  return /*#__PURE__*/React__default.createElement(Box$1, {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    className: clsx('labelValueList', isExpanded && 'expanded', classes.root, classes[variant]),
    "data-locator": LABELVALUELIST
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    px: 2,
    flexGrow: 1
  }, title && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body2",
    component: "div",
    align: "center",
    className: classes.title,
    "data-locator": LABELVALUELIST_TITLE,
    color: color,
    type: "caption"
  }, title), items.map(function (item, packageIndex) {
    var key = "".concat(get$1(item, 'id', ''), "__").concat(packageIndex);
    var attributes = get$1(item, 'fields.cardAttributes.value', {});
    var itemArray = Object.keys(attributes);
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isEmpty(get$1(item, 'fields.title.value', '')) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "h6",
      component: "div",
      className: clsx(classes.itemTitle),
      color: color,
      "data-locator": LABELVALUELIST_X_TITLE.replace('{X}', packageIndex)
    }, item.fields.title.value), /*#__PURE__*/React__default.createElement(Box$1, {
      className: clsx('motionExpand', classes.planAttributeWrapper, classes.listItem),
      "data-locator": LABELVALUELIST_PARENT_X.replace('{X}', packageIndex)
    }, Object.keys(attributes).slice(0, 3).map(function (attributeKey, attributeIndex) {
      return /*#__PURE__*/React__default.createElement(LabelValueItem, {
        color: color,
        key: "".concat(attributeKey, "__").concat(kebabCase(attributeKey)),
        fields: {
          key: attributeKey,
          value: attributes[attributeKey]
        },
        "data-locator-key": LABELVALUELIST_X_ATTRIBUTEKEY_Y.replace('{X}', packageIndex).replace('{Y}', attributeIndex),
        "data-locator-value": LABELVALUELIST_X_ATTRIBUTEVALUE_Y.replace('{X}', packageIndex).replace('{Y}', attributeIndex)
      });
    }), /*#__PURE__*/React__default.createElement(Collapse, {
      key: key,
      in: isExpanded,
      collapsedHeight: 0,
      className: clsx(classes.listItem, isExpanded ? classes.easingInOut : classes.easingOut),
      onExited: onExited,
      timeout: {
        enter: 300,
        exit: 200
      }
    }, /*#__PURE__*/React__default.createElement(Box$1, {
      ref: listItemRef,
      "data-locator": LABELVALUELIST_X.replace('{X}', packageIndex),
      className: classes.nextListAttibute
    }, itemArray.length > 3 && Object.keys(attributes).slice(3).map(function (attributeKey, attributeIndex) {
      return /*#__PURE__*/React__default.createElement(LabelValueItem, {
        color: color,
        key: "".concat(attributeKey, "__").concat(kebabCase(attributeKey)),
        fields: {
          key: attributeKey,
          value: attributes[attributeKey]
        },
        "data-locator-key": LABELVALUELIST_X_ATTRIBUTEKEY_Y.replace('{X}', packageIndex).replace('{Y}', attributeIndex),
        "data-locator-value": LABELVALUELIST_X_ATTRIBUTEVALUE_Y.replace('{X}', packageIndex).replace('{Y}', attributeIndex)
      });
    })))));
  })), expandable && /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    justifyContent: 'center',
    className: clsx(classes.expandingBar, classes["divider-".concat(color)]),
    mt: 2,
    position: 'relative'
  }, items.some(function (item) {
    return Object.keys(get$1(item, 'fields.cardAttributes.value', {})).length > 3;
  }) && /*#__PURE__*/React__default.createElement(Box$1, {
    className: clsx(classes.expandingBarCircle, classes["expandingIcon-".concat(color)], isExpanded && 'expanded', _defineProperty({}, 'hideFocusonClick', !useKeyBoard)),
    role: 'button',
    onClick: function onClick() {
      var bool = !isExpanded;
      setIsExpanded(bool);
      onToggleExpand && onToggleExpand(bool);
      PushEvent({
        event: 'buttonClick',
        buttonTitle: LABELVALUELIST_EXPANDICON,
        componentName: LABELVALUELIST,
        destinationUrl: undefined
      });
    },
    onKeyPress: function onKeyPress(e) {
      if (e.key === 'Enter') {
        var bool = !isExpanded;
        setIsExpanded(bool);
        onToggleExpand && onToggleExpand(bool);
      }
    },
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: "50%",
    height: 24,
    width: 24,
    "data-locator": LABELVALUELIST_EXPANDICON,
    "aria-label": LABELVALUELIST_EXPANDICON,
    tabIndex: 0
  }, /*#__PURE__*/React__default.createElement(ArrowForward, {
    className: clsx(classes.expandingBarIcon, isExpanded && 'expanded')
  }))));
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var VALUE_CONTAINER = 'Value-Container';
var VALUE_VALUE = 'Value-Value';
var VALUE_CURRENCY = 'Value-Currency';
var VALUE_SUFFIX = 'Value-Suffix';

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$w = function styles(theme) {
  return {
    root: {
      overflow: 'hidden'
    },
    value: {
      fontWeight: theme.typography.fontWeights.bold
    },
    currencyInitial: {
      flexDirection: 'column',
      alignItems: 'flex-end'
    },
    currency: {
      lineHeight: theme.typography.lineHeight.L13,
      marginTop: theme.spacing(0.4),
      marginRight: theme.spacing(0.5)
    },
    currency2: _defineProperty({
      marginTop: theme.spacing(0.5875)
    }, theme.breakpoints.up('md'), {
      marginTop: theme.spacing(0.8375)
    }),
    noMarginRight: {
      marginRight: 0
    },
    suffix: {
      lineHeight: theme.typography.lineHeight.L13
    }
  };
};

var useStyles$E = makeStyles(styles$w);

var Value = function Value(props) {
  var classes = useStyles$E();
  var variant = get$1(props, "variant", "base");
  var value = get$1(props, "value", null);
  var currency = get$1(props, "currency", null);
  var suffix = get$1(props, "suffix", null);
  var currencyPlacement = get$1(props, "sitecoreContext.siteSettings.currencyPlacement", "BeforeNumericals");
  var currencyWhitesapce = get$1(props, "sitecoreContext.siteSettings.currencyWhitespace", true);
  var color = get$1(props, "color", "white");

  var render = function render() {
    if (variant === "base") {
      return /*#__PURE__*/React__default.createElement(Box$1, {
        display: "flex",
        flexGrow: 1,
        justifyContent: "flex-end",
        my: 0.7,
        className: clsx(classes.root, classes[variant], _defineProperty({}, classes.currencyInitial, currencyPlacement === "BeforeNumericals")),
        "data-locator": VALUE_CONTAINER
      }, /*#__PURE__*/React__default.createElement(Box$1, {
        display: "flex"
      }, currencyPlacement === "BeforeNumericals" && currency && /*#__PURE__*/React__default.createElement(Box$1, {
        display: "flex",
        flexDirection: "column",
        ml: 0.5
      }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        variant: "small",
        component: "div",
        className: clsx(classes.currency, classes.currency2, _defineProperty({}, classes.noMarginRight, !currencyWhitesapce)),
        color: color,
        type: "label",
        "data-locator": VALUE_CURRENCY
      }, currency)), /*#__PURE__*/React__default.createElement(Box$1, {
        display: "flex",
        alignItems: "center"
      }, value && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        variant: "body4",
        component: "div",
        className: clsx(classes.value),
        color: color,
        "data-locator": VALUE_VALUE,
        type: "label",
        wordBreak: true
      }, value))), /*#__PURE__*/React__default.createElement(Box$1, {
        display: "flex",
        flexDirection: "column",
        ml: currencyWhitesapce ? 0.5 : 0
      }, currencyPlacement === "AfterNumericals" && currency && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        variant: "small",
        component: "div",
        className: clsx(classes.currency),
        color: color,
        "data-locator": VALUE_CURRENCY,
        type: "label"
      }, value), suffix && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        variant: "small",
        component: "div",
        className: clsx(classes.suffix),
        color: color,
        "data-locator": VALUE_SUFFIX,
        type: "label"
      }, suffix.toLowerCase())));
    }
  };

  return render();
}; // export default withSitecoreContext()(Value);

var useStyles$D = makeStyles(styles$z);
/**
 * ProductPlanCard
 */

var ProductPlanCard = function ProductPlanCard(props) {
  var index = props.index,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? "base" : _props$variant,
      selectedCardIndex = props.selectedCardIndex,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? null : _props$onClick,
      onResize = props.onResize,
      userdata = props.userdata,
      _props$hasTag = props.hasTag,
      hasTag = _props$hasTag === void 0 ? true : _props$hasTag,
      _props$hasShareIcon = props.hasShareIcon,
      hasShareIcon = _props$hasShareIcon === void 0 ? true : _props$hasShareIcon,
      _props$hasEnquiryLink = props.hasEnquiryLink,
      hasEnquiryLink = _props$hasEnquiryLink === void 0 ? true : _props$hasEnquiryLink,
      isPackage = props.isPackage,
      gaCategoryName = props.gaCategoryName,
      _props$isRecommenderR = props.isRecommenderResult,
      isRecommenderResult = _props$isRecommenderR === void 0 ? false : _props$isRecommenderR,
      setSliderArrowPosition = props.setSliderArrowPosition,
      prevArrowRef = props.prevArrowRef,
      nextArrowRef = props.nextArrowRef;
  var color = get$1(props, "color", "white");
  var classes = useStyles$D({
    color: color
  }); // if packageList is empty, check for cardAttributes

  var packageList = get$1(props, "fields.packageList", []);
  var label = !isEmpty(get$1(props, "fields.cardLabel.value", null)) ? get$1(props, "fields.cardLabel", null) : null;
  var tooltip = !isEmpty(get$1(props, "fields.value.value", null)) ? get$1(props, "fields.value", null) : null;
  var title = !isEmpty(get$1(props, "fields.title.value", null)) ? get$1(props, "fields.title", null) : null;
  var planCode = get$1(props, "fields.planCode.value", null);
  var primaryLink = !isEmpty(get$1(props, "fields.link.value", null)) ? get$1(props, "fields.link", null) : null; //Added check for call link

  var primaryLinkHref = get$1(props, "fields.link.value.href", null);
  var primaryLinkUrl = get$1(props, "fields.link.value.url", null);
  var linkTypeTel = primaryLinkHref && primaryLinkHref.indexOf("tel:") !== -1;
  /* istanbul ignore else */

  if (linkTypeTel && primaryLink) {
    primaryLink.value.href = primaryLinkUrl ? primaryLinkUrl : primaryLinkHref.indexOf("://") !== -1 ? primaryLinkHref.split("://")[1] : primaryLinkHref;
    primaryLink.value.target = "_self";
    primaryLink.value.linktype = "internal";
  }

  var primaryLinkGTM = get$1(props, "fields.linkGALabelName.value", "");
  var secLink = !isEmpty(get$1(props, "fields.secondaryLink.value", null)) ? get$1(props, "fields.secondaryLink", null) : null;
  var secLinkGTM = get$1(props, "fields.secondaryLinkGALabelName.value", "");
  var isComparable = get$1(props, "fields.isComparable.value", false);
  var selectedPlans = get$1(props, "selectedPlans", []);

  var _useState = useState(selectedPlans.includes(get$1(props, "fields.uniqueId"))),
      _useState2 = _slicedToArray(_useState, 2),
      checkedValue = _useState2[0],
      setCheckedValue = _useState2[1];

  useEffect(function () {
    setCheckedValue(selectedPlans.includes(get$1(props, "fields.uniqueId")));
  }, [selectedPlans]);
  var isDesktop = get$1(breakpoints, "values[".concat(get$1(props, "width", "lg"), "]"), 0) >= breakpoints.values.lg;
  var isShareOptionAvailable = get$1(props, "fields.share.value", false);
  var currencyPlacement = get$1(props, "sitecoreContext.siteSettings.currencyPlacement", "BeforeNumericals"); // const { t } = useTranslation();

  var dictionary = get$1(props, "dictionary", {
    currency: get$1(props, "currency", "THB"),
    coverageSummary: "Coverage summary",
    recommended: "Recommended",
    compare: "Compare"
  });

  var t = function t(key) {
    return dictionary[key];
  };

  var currencySeparator = get$1(props, "sitecoreContext.siteSettings.currencySeparator.value[".concat(t("currency"), "]"), ",");
  var listTitle = t("coverageSummary");
  var calculateType = get$1(userdata, "calculateType", null);

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;

  var isRecommended;
  var tagValue = "";
  var valueList;
  var sumAssured; // data formatting

  if (calculateType) {
    var plan = find(get$1(props, "userdata.resultedPlanList", []), function (item) {
      return get$1(item, "product.plan.code", null) && isPackage ? get$1(item, "product.plan.code", null) === get$1(props, "fields.title.value", null) : get$1(item, "product.plan.productOption", "") ? get$1(item, "product.plan.code", "") + "_" + get$1(item, "product.plan.productOption", "") === get$1(props, "fields.planCode.value", "") + "_" + get$1(props, "fields.productPlanOptionCd.value", "") : get$1(item, "product.plan.code", null) === get$1(props, "fields.planCode.value", null);
    });
    isRecommended = get$1(plan, "isRecommended", false);
    tagValue = t("recommended");
    /* istanbul ignore else */

    if (plan) {
      // when we'll get 'defaultSumAssuredPaymentMode' value from CMS then following piece of code will get removed.
      var paymentModes$1 = get$1(props, "sitecoreContext.route.fields.sumAssuredPaymentMode", []);
      var isAnnual;

      if (paymentModes$1 && paymentModes$1.length) {
        isAnnual = paymentModes$1.find(function (mode) {
          var paymentFrequency = get$1(mode, "fields.key.value", "") ? get$1(mode, "fields.key.value", "").split("|")[0] : "";

          if (paymentFrequency === paymentModes.ANNUALLY) {
            return true;
          }

          return false;
        });
      }

      var selectedPaymentMode = !isEmpty(get$1(props, "userdata.selectedPaymentMode", "")) ? get$1(props, "userdata.selectedPaymentMode", "").replace(" ", "").toUpperCase() : isAnnual ? paymentModes.ANNUALLY.toUpperCase() : paymentModes.YEARLY.toUpperCase();
      var premium = find(get$1(plan, "premiums", []), function (item) {
        return get$1(item, "premiumType", null) === selectedPaymentMode;
      });
      sumAssured = get$1(plan, "product.amount.baseSumAssured", null);
      valueList = [].concat(_toConsumableArray(calculateType.toLowerCase() === calculateTypes.PREMIUM ? [{
        sumAssured: sumAssured,
        label: t(calculateTypes.PREMIUM),
        value: {
          value: formatCurrency(get$1(premium, "amount.modalPremium", 0), currencySeparator),
          currency: t("currency"),
          suffix: selectedPaymentMode === paymentModes.SINGLE.toUpperCase() ? "".concat(t(paymentModes[selectedPaymentMode.toUpperCase()])) : "/".concat(t(paymentModes[selectedPaymentMode.toUpperCase()]))
        }
      }] : []), _toConsumableArray(calculateType.toLowerCase() === calculateTypes.SUMASSURED ? [{
        sumAssured: sumAssured,
        label: t(calculateTypes.SUMASSURED),
        value: {
          value: formatCurrency(sumAssured, currencySeparator),
          currency: t("currency")
        }
      }] : []));
    }
  } // states


  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isHovered = _useState4[0],
      setIsHovered = _useState4[1];

  var shareOptions = get$1(props, "sitecoreContext.share.socialApps", []); // methods

  var triggerCommerceClick = function triggerCommerceClick() {
    /* istanbul ignore else */
    PushEvent({
      event: "productClick",
      ecommerce: {
        click: {
          products: [{
            name: get$1(props, "productGaLabelName", ""),
            id: get$1(props, "productGaLabelName", ""),
            category: get$1(props, "fields.cardLabel.value", ""),
            position: index + 1
          }]
        }
      }
    });
  };

  var gaButtonClick = function gaButtonClick(apiLink) {
    PushEvent({
      event: "buttonClick",
      buttonTitle: primaryLinkGTM || getGTMSharedKeyVal(undefined, PRODUCTPLANCARD_ENQUIREBUTTON),
      productName: props.productGaLabelName,
      planName: get$1(props, "fields.gaLabelName.value") || get$1(props, "fields.cardTitle.value", ""),
      componentName: gaCategoryName ? gaCategoryName : PRODUCTPLANCARD_ENQUIREBUTTON,
      destinationUrl: apiLink
    });
  }; // effects


  useEffect(function () {
    /* istanbul ignore else */
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      // This is to block th Carousel icon movement on hover state
      // ignoring jest due to .offsetTop

      /* istanbul ignore next */
      if (nextArrowRef && nextArrowRef.current) {
        setSliderArrowPosition(nextArrowRef.current.offsetTop);
      } else if (prevArrowRef && prevArrowRef.current) {
        setSliderArrowPosition(prevArrowRef.current.offsetTop);
      }
    }
  }, [isHovered]);

  var openFormModal = function openFormModal(apiLink, formType, selectedPlanCard, gaLabel) {
    PushEvent({
      event: "buttonClick",
      buttonTitle: gaLabel || primaryLinkGTM || getGTMSharedKeyVal(undefined, PRODUCTPLANCARD_ENQUIREBUTTON),
      productName: props.productGaLabelName,
      //get(props, 'fields.gaLabelName.value', ''),
      planName: get$1(props, "fields.gaLabelName.value") || get$1(props, "fields.cardTitle.value", ""),
      componentName: gaCategoryName ? gaCategoryName : PRODUCTPLANCARD_ENQUIREBUTTON,
      destinationUrl: apiLink
    });
    PushEvent({
      enquire: {
        plan: {
          title: get$1(props, "fields.gaLabelName.value") || get$1(props, "fields.cardTitle.value", ""),
          product: get$1(props, "productGaLabelName", ""),
          position: index + 1
        }
      }
    });
    triggerCommerceClick();
    props.setSelectedPlanCard({
      selectedPlanCard: selectedPlanCard
    });
    /* istanbul ignore else */

    if (formType === "enquiry") {
      var fields = get$1(props, "fields", {});
      isPackage && Object.assign(fields, {
        cardTitle: {
          value: get$1(props, "fields.title.value", "")
        } //as Package Page doesn't come with cardTitle property

      });
      props.setEnquiryPlanData({
        planDetail: {
          fields: fields,
          brochure: get$1(props, "brochure", {})
        }
      });
      props.updateFormLinks({
        URL: generatelayoutServicePath(apiLink, props.sitecoreContext.languageCode || props.sitecoreContext.language),
        formType: "enquiry"
      });
    }

    props.updateFormInitializer({
      initializer: calculatorInitializers.ENQUIRY,
      enquiryInitializer: "PRODUCT_PLAN_CARD"
    });
    props.updateFormModalState({
      formModalState: true
    });
    props.appInSession(true);
  };

  return /*#__PURE__*/React__default.createElement(Box$1, _extends({
    className: clsx("productPlanCard", "motionElevate", classes["bgColor-".concat(color)], index === selectedCardIndex && "productPlanCard--selected", classes.itemRoot, classes[variant], _defineProperty({}, classes.selected, index === selectedCardIndex))
  }, onClick && {
    onClick: onClick
  }, isDesktop && {
    onMouseEnter: function onMouseEnter() {
      setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      setIsHovered(false);
    }
  }, {
    role: "description",
    "data-locator": PRODUCTPLANCARD
  }), /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    flexDirection: "column",
    className: clsx("productPlanCardInner", classes.itemInner, getBorderRadius("medium"), classes["bgColor-".concat(color)])
  }, isRecommended && hasTag && /*#__PURE__*/React__default.createElement(Box$1, {
    px: 2,
    position: "absolute",
    component: "span",
    className: clsx(classes.tag, classes["tagColor-".concat(color)])
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h7",
    component: "span",
    "data-locator": PRODUCTPLANCARD_TAG
  }, tagValue)), /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    pt: 3,
    px: 2,
    pb: 2,
    className: clsx("productPlanCard__header", classes.header)
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    flexGrow: 1
  }, (title || tooltip) && /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    alignItems: "center",
    mb: 1
  }, label && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h7",
    component: "span",
    "data-locator": PRODUCTPLANCARD_LABEL,
    color: color,
    type: "label",
    className: classes.productPlanLabel
  }, label.value), tooltip && /*#__PURE__*/React__default.createElement(FwdTooltip, {
    title: tooltip.value,
    isRichText: true
  }, /*#__PURE__*/React__default.createElement("span", {
    "data-locator": PRODUCTPLANCARD_TOOLTIPICON,
    className: clsx(classes.tooltip, _defineProperty({}, "hideFocusonClick", !useKeyBoard)),
    tabIndex: 0
  }, /*#__PURE__*/React__default.createElement(NamedIcon$1, {
    icon: "question-mark"
  })))), title && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h7",
    component: "div",
    color: color,
    className: clsx(classes.title),
    "data-locator": PRODUCTPLANCARD_PRODUCTNAME
  }, title.value)), hasShareIcon && isShareOptionAvailable && shareOptions.length && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SocialShare$1, {
    gaCategoryName: gaCategoryName,
    sharedItemName: get$1(title, "value", ""),
    className: clsx(classes.share, classes["shareIcon-".concat(color)]),
    selectedCardIndex: props.selectedCardIndex,
    handleSelectedCardIndex: props.onClick,
    shareOptions: shareOptions,
    dataLocator: PRODUCTPLANCARD_SHAREICON,
    dataLocatorIdentifier: "".concat(PRODUCTPLANCARD, "-").concat(props.index),
    bgColor: color,
    transparent: true,
    extraGAData: {
      productName: get$1(props, "productGaLabelName", ""),
      planName: get$1(props, "fields.gaLabelName.value") || get$1(props, "fields.cardTitle.value", "")
    }
  }))), !isEmpty(valueList) && /*#__PURE__*/React__default.createElement(Box$1, {
    mx: 2,
    px: 2,
    mb: 2,
    className: classes.valuesContainer,
    "data-locator": PRODUCTPLANCARD_VALUES_CONTAINER
  }, valueList.map(function (item) {
    return /*#__PURE__*/React__default.createElement(Box$1, {
      className: classes.valueItem,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      py: 1,
      key: kebabCase("".concat(item.label, "--").concat(PRODUCTPLANCARD_VALUE_LABEL))
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "body3",
      component: "div",
      className: clsx(_defineProperty({}, classes.currencyValueLabel, currencyPlacement === "BeforeNumericals")),
      "data-locator": PRODUCTPLANCARD_VALUE_LABEL,
      mb: 0,
      type: "caption",
      color: color
    }, item.label), /*#__PURE__*/React__default.createElement(Value, _extends({}, item.value, {
      color: color
    })));
  })), !isEmpty(packageList) && /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    className: clsx("productPlanCard__body", classes.body)
  }, !isEmpty(packageList) && /*#__PURE__*/React__default.createElement(LabelValueList, {
    key: "".concat(get$1(props, "id", kebabCase(listTitle)), "__packageList"),
    items: packageList,
    title: listTitle,
    expandable: true,
    onEntered: onResize,
    onExited: onResize,
    color: color,
    isRecommenderResult: isRecommenderResult
  })), hasEnquiryLink && (isComparable || primaryLink) && /*#__PURE__*/React__default.createElement(Collapse, {
    in: true,
    className: clsx("card-footer", classes.cardFooter)
  }, primaryLink && /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    px: 2,
    pt: 2,
    pb: 3,
    className: clsx(classes.footer)
  }, /*#__PURE__*/React__default.createElement(DynamicLink$1, _extends({}, primaryLink, get$1(primaryLink, "value.linktype", null) === "form" ? {
    onClick: function onClick(e) {
      openFormModal(primaryLink.value.href, primaryLink.value.querystring, planCode);
      e.preventDefault();
      e.stopPropagation();
    }
  } : {
    postLinkHandler: function postLinkHandler() {
      props.updateGroupEnquiryData({
        planName: title === null || title === void 0 ? void 0 : title.value,
        groupEnquiryInitializer: enquiryInitializer.PLAN_CARD
      });
      gaButtonClick(get$1(primaryLink, "value.href", undefined));
      triggerCommerceClick();
    }
  }, get$1(primaryLink, "value.linktype", null) === "form" && {
    onKeyPress: function onKeyPress(e) {
      /* istanbul ignore else */
      if (e.key === "Enter") {
        openFormModal(primaryLink.value.href, primaryLink.value.querystring, planCode);
      }
    }
  }, {
    stopPropagation: true,
    icon: get$1(props, "fields.buttonIcon.fields.value.value", null),
    color: color,
    disablePushEvent: true,
    gaCategoryName: gaCategoryName,
    "data-locator": PRODUCTPLANCARD_ENQUIREBUTTON,
    className: clsx(classes.buttonEnquire),
    buttonMode: get$1(props, "fields.buttonMode.fields.value.value", buttonModes.PRIMARY),
    forcedHtmlComponent: linkTypeTel,
    GTMSharedKey: primaryLinkGTM,
    gaExtraParams: (isComparable && get$1(props, "sitecoreContext.site.name", "").toLowerCase().indexOf("hk") !== -1 ? {
      compared_plans: {
        title: get$1(props, "fields.title.value"),
        product: get$1(props, "fields.cardLabel.value"),
        currency: t("currency"),
        premium: valueList && valueList[0] && valueList[0].value.value.premium || "",
        sum_assured: valueList && valueList[0] && valueList[0].sum_assured || "",
        coverage: Object.values(get$1(props, "fields.cardAttributes.value", {}))
      }
    } : null) || null
  }))), /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true
  }, isComparable && props.isCompareCheckboxRender && /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: secLink ? 6 : 12,
    className: classes.compareBoxWrapper
  }, /*#__PURE__*/React__default.createElement(CheckBox, {
    dataLocator: PRODUCTPLANCARD_COMPARE_CHECKBOX,
    dataLocatorLabel: PRODUCTPLANCARD_COMPARE_CHECKBOX_LABEL,
    value: true,
    checked: checkedValue,
    color: color,
    label: {
      value: props.compareCTALabel || t("compare")
    },
    name: props.compareCTALabel || t("compare"),
    fontWeight: "bold",
    onChange: function onChange() {
      props.selectPlansForCompare({
        uid: get$1(props, "fields.uniqueId"),
        gaData: valueList && valueList[0] || {}
      });
    }
  })), secLink && /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: isComparable && props.isCompareCheckboxRender ? 6 : 12,
    className: clsx(classes.secLinkContainer, isComparable && props.isCompareCheckboxRender && "withCompare")
  }, /*#__PURE__*/React__default.createElement(DynamicLink$1, _extends({}, secLink, get$1(secLink, "value.linktype", null) === "form" ? {
    onClick: function onClick(e) {
      openFormModal(secLink.value.href, secLink.value.querystring, planCode, secLinkGTM);
      e.preventDefault();
      e.stopPropagation();
    }
  } : {
    postLinkHandler: function postLinkHandler() {
      gaButtonClick(get$1(secLink, "value.href", undefined));
      triggerCommerceClick();
    }
  }, get$1(secLink, "value.linktype", null) === "form" && {
    onKeyPress: function onKeyPress(e) {
      /* istanbul ignore else */
      if (e.key === "Enter") {
        openFormModal(secLink.value.href, secLink.value.querystring, planCode, secLinkGTM);
      }
    }
  }, {
    icon: get$1(props, "fields.secondaryLinkButtonIcon.fields.value.value", null),
    color: color,
    disablePushEvent: true,
    gaCategoryName: gaCategoryName,
    "data-locator": PRODUCTPLANCARD_ENQUIREBUTTON,
    className: clsx(classes.secLink, "noPadding"),
    buttonMode: get$1(props, "fields.secondaryLinkButtonMode.fields.value.value", buttonModes.SIMPLELINK),
    GTMSharedKey: secLinkGTM
  })))))));
}; // const mapDispatchToProps = dispatch => {

var styles$v = function styles(theme) {
  var colors = theme.palette.colors;
  return {
    infoBar: function infoBar(_ref) {
      var _form, _hasCalculateData, _ref2;

      var color = _ref.color;
      return _ref2 = {
        marginTop: theme.spacing(1)
      }, _defineProperty(_ref2, theme.breakpoints.down('md'), {
        marginTop: theme.spacing(3)
      }), _defineProperty(_ref2, '& .MuiGrid-container', {
        alignItems: 'flex-end'
      }), _defineProperty(_ref2, 'form &', (_form = {}, _defineProperty(_form, theme.breakpoints.down('md'), {
        marginTop: theme.spacing(7)
      }), _defineProperty(_form, "marginTop", theme.spacing(13)), _form)), _defineProperty(_ref2, '&.hasCalculateData', (_hasCalculateData = {
        borderBottom: "0 solid ".concat(theme.palette.colors[color] ? colors[color].line.divider : fwdColors.grey)
      }, _defineProperty(_hasCalculateData, theme.breakpoints.down('md'), {
        borderBottom: 'none'
      }), _defineProperty(_hasCalculateData, theme.breakpoints.up('lg'), {
        paddingBottom: theme.spacing(2)
      }), _hasCalculateData)), _ref2;
    },
    divider: function divider(_ref3) {
      var color = _ref3.color;
      return {
        width: '1px',
        height: theme.spacing(3),
        backgroundColor: "".concat(theme.palette.colors[color] ? colors[color].line.divider : fwdColors.grey),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
      };
    },
    infoBarLeft: {
      display: 'flex',
      alignItems: 'flex-end'
    },
    infoBarActions: function infoBarActions(_ref4) {
      var color = _ref4.color;
      return _defineProperty({
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginLeft: theme.spacing(-0.75)
      }, theme.breakpoints.down('md'), {
        paddingTop: theme.spacing(1),
        marginTop: theme.spacing(2),
        borderTop: "1px solid ".concat(theme.palette.colors[color] ? colors[color].line.divider : fwdColors.grey)
      });
    },
    planCoverage: _defineProperty({
      paddingRight: theme.spacing(2.25),
      marginRight: theme.spacing(0.75)
    }, theme.breakpoints.down('md'), {
      paddingRight: theme.spacing(1.5),
      marginRight: theme.spacing(1.5)
    }),
    planAmountText: _defineProperty({}, theme.breakpoints.down('md'), {
      marginRight: theme.spacing(-1.5)
    }),
    action: _defineProperty({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end'
    }, theme.breakpoints.down('md'), {
      paddingTop: theme.spacing(1)
    }),
    subTitle: _defineProperty({}, theme.breakpoints.down('md'), {
      paddingRight: theme.spacing(3)
    }),
    userDetailsLabel: function userDetailsLabel(_ref6) {
      var _ref7;

      var color = _ref6.color;
      return _ref7 = {
        fontSize: theme.typography.T11,
        lineHeight: theme.typography.lineHeight.L14,
        maxWidth: theme.typography.pxToRem(288)
      }, _defineProperty(_ref7, theme.breakpoints.down('md'), {
        maxWidth: theme.typography.pxToRem(152),
        fontSize: theme.typography.T8,
        lineHeight: theme.typography.lineHeight.L13
      }), _defineProperty(_ref7, '&.MuiTypography-body1', {
        color: "".concat(theme.palette.colors[color] ? colors[color].contrastTextCaption : fwdColors.grey)
      }), _ref7;
    },
    userDetailsValue: _defineProperty({
      maxWidth: theme.typography.pxToRem(288)
    }, theme.breakpoints.down('md'), {
      maxWidth: theme.typography.pxToRem(152)
    }),
    link: {
      lineHeight: theme.typography.lineHeight.L9
    }
  };
};

var useStyles$C = makeStyles(styles$v);

var ProductInfoBar = function ProductInfoBar(props) {
  var _clsx;

  var color = get$1(props, "color", "darkGreen");
  var classes = useStyles$C({
    color: color
  });
  var productName = props.productName,
      subTitle = props.subTitle,
      calculateLink = props.calculateLink,
      resetAllData = props.resetAllData,
      userdata = props.userdata,
      _props$hasReset = props.hasReset,
      hasReset = _props$hasReset === void 0 ? true : _props$hasReset,
      gaCategoryName = props.gaCategoryName,
      productDetails = props.productDetails,
      gaLabelName = props.gaLabelName,
      setActiveTabIndex = props.setActiveTabIndex,
      calculateLinkGALabelName = props.calculateLinkGALabelName; // const { t } = useTranslation();

  var dictionary = get$1(props, "dictionary", {
    currency: get$1(props, "currency", "THB"),
    CoverageFor: "Coverage for",
    "0-1-year-old": "0-1 year old",
    "1-year-old": "1 year old",
    agesentence: "{x} years old",
    Edit: "Edit",
    Reset: "Reset",
    sumassuredsentence: "Sum Assured",
    premiumsentence: "Annual budget"
  });

  var t = function t(key) {
    return dictionary[key];
  };

  var lastFormAPI = get$1(productDetails, "lastCalculatedItemId", "");
  var genderType = get$1(userdata, "gender", null);

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;

  var genderValue = get$1(props, "sitecoreContext.language", "en") === "en" ? get$1(productDetails, "apiNameMapper[".concat(lastFormAPI, "][0].apiNames[0].value"), "") : get$1(productDetails, "apiNameMapper[".concat(lastFormAPI, "][0].apiNames[0].options[").concat(genderType, "]"), "");
  var hasCalculateData = !isEmpty(get$1(userdata, "calculateType", null));
  var currencyPlacement = get$1(props, "sitecoreContext.siteSettings.currencyPlacement", "BeforeNumericals");
  var currencyWhitespace = get$1(props, "sitecoreContext.siteSettings.currencyWhitespace", true) ? " " : "";
  var currencySeparator = get$1(props, "sitecoreContext.siteSettings.currencySeparator.value[".concat(t("currency"), "]"), ",");
  var enquiryFormData = get$1(props, "apiNameMapper.enquiryFormData", []); //calculate-form modalHandler

  var openModalHandler = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var href;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              href = get$1(calculateLink, "value.href", null);
              PushEvent({
                event: "buttonClick",
                buttonTitle: calculateLinkGALabelName || getGTMSharedKeyVal(href, PRODUCTPLANLIST_CALCULATE_BUTTON),
                componentName: gaCategoryName ? gaCategoryName : PRODUCTPLANLIST_CALCULATE_BUTTON,
                destinationUrl: href ? href : undefined,
                productName: productName
              });
              /* istanbul ignore else */

              if (href) {
                props.updateFormInitializer({
                  initializer: calculatorInitializers.CALCULATOR
                });
                props.appInSession(true);
                props.hasSessionPopups(true);
                props.updateFormModalState({
                  formModalState: true
                });
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function openModalHandler() {
      return _ref.apply(this, arguments);
    };
  }();

  var onEditClickHandler = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              props.updateEditMode(true);
              props.updateFormInitializer({
                initializer: props.getFinalizer
              });
              props.updateFormModalState({
                formModalState: true
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onEditClickHandler() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default.createElement(Box, {
    justifyContent: "space-between",
    display: "flex",
    className: clsx(classes.infoBar, hasCalculateData && "hasCalculateData"),
    mt: 3
  }, hasCalculateData ? /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    "data-locator": PRODUCTPLANLIST_USER_DETAILS_WRAPPER
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 6,
    lg: 3,
    className: classes.planCoverage
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    component: "div",
    className: classes.userDetailsLabel,
    color: color,
    type: "caption",
    "data-locator": PRODUCTPLANLIST_USER_DETAILS_LABEL
  }, t("CoverageFor")), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body4",
    component: "div",
    color: color,
    "data-locator": PRODUCTPLANLIST_USER_DETAILS_LABEL,
    className: classes.userDetailsValue
  }, transform(pick(userdata, ["gender", "dob"]), function (r, v, k) {
    switch (k) {
      case "dob":
        var mmdob = moment(v, "YYYY-MM-DD");
        var age = moment().diff(mmdob, "years");

        switch (age) {
          case 0:
            r.push(t("0-1-year-old"));
            break;

          case 1:
            r.push(t("1-year-old"));
            break;

          default:
            r.push(t("agesentence").replace(/{x}/gi, age));
            break;
        }

        break;

      case "gender":
      default:
        r.push(startCase(lowerCase(genderValue)));
        break;
    }
  }, []).join(", "))), /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 6,
    lg: 6,
    className: classes.planAmountText
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    className: classes.userDetailsLabel,
    component: "div",
    color: color,
    "data-locator": PRODUCTPLANLIST_USER_DETAILS_LABEL,
    type: "caption"
  }, t(userdata.calculateType.toLowerCase() === calculateTypes.PREMIUM ? "sumassuredsentence" : "premiumsentence")), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body4",
    component: "div",
    color: color,
    "data-locator": PRODUCTPLANLIST_USER_DETAILS_LABEL,
    className: classes.userDetailsValue
  }, currencyPlacement === "BeforeNumericals" ? "".concat(t("currency")).concat(currencyWhitespace).concat(formatCurrency(get$1(userdata, "amount", ""), currencySeparator)) : "".concat(formatCurrency(get$1(userdata, "amount", ""), currencySeparator)).concat(currencyWhitespace).concat(t("currency")))), /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 12,
    lg: 3,
    className: clsx(classes.infoBarActions)
  }, /*#__PURE__*/React__default.createElement(DynamicLink$1, {
    value: _objectSpread2(_objectSpread2({}, get$1(calculateLink, "value", null)), {}, {
      linktype: "custom",
      text: t("Edit")
    }),
    gaCategoryName: gaCategoryName,
    className: clsx(classes.link),
    color: color,
    icon: "edit",
    "data-locator": PRODUCTPLANLIST_EDIT,
    onClick: function onClick() {
      return props.onEditClickHandler ? props.onEditClickHandler() : onEditClickHandler();
    },
    type: "caption",
    GTMSharedKey: "Edit"
  }), hasReset && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: classes.divider
  }), /*#__PURE__*/React__default.createElement(DynamicLink$1, {
    value: _objectSpread2(_objectSpread2({}, get$1(calculateLink, "value", null)), {}, {
      linktype: "custom",
      text: t("Reset")
    }),
    className: clsx(classes.link),
    gaCategoryName: gaCategoryName,
    color: color,
    icon: "reset",
    "data-locator": PRODUCTPLANLIST_RESET,
    onClick: function onClick() {
      resetAllData();
      setActiveTabIndex(0);
      props.hasSessionPopups(false);
      props.appInSession(false);

      if (enquiryFormData.length) {
        props.hasUserData(true);
      } else {
        props.hasUserData(false);
      }
    },
    type: "caption",
    GTMSharedKey: "Reset",
    extraGAData: {
      productName: productName
    }
  })))) : /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    spacing: 3
  }, subTitle && /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 8,
    className: clsx(classes.infoBarLeft)
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "p",
    className: classes.subTitle,
    "data-locator": PRODUCTPLANLIST_SUBHEADING,
    color: color
  }, subTitle.value)), calculateLink && /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 4,
    className: classes.action
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
    color: color,
    size: "small",
    gaCategoryName: gaCategoryName,
    "data-locator": PRODUCTPLANLIST_CALCULATE_BUTTON,
    onClick: openModalHandler,
    alt: get$1(calculateLink, "value.text", ""),
    className: clsx(classes.calculateButton, (_clsx = {}, _defineProperty(_clsx, "hideFocusonClick", !useKeyBoard), _defineProperty(_clsx, "showFocusonTab", useKeyBoard), _clsx)),
    GTMSharedKey: gaLabelName,
    extraGAData: {
      productName: productName
    }
  }, get$1(calculateLink, "value.text", "")))));
}; // export const mapStateToProps = createStructuredSelector({

var styles$u = function styles(theme) {
  var _slickSlide, _productPlanCardIn, _slickSlideAria, _slickPrev, _slickArrow, _footer, _buttonWrapper, _textWrapper;

  var colors = theme.palette.colors || {};
  var icon = theme.palette;
  var iconColors = {};
  var noResultIcons = {};
  var compareBoxWrapperColor = {};
  Object.keys(colors).forEach(function (color) {
    noResultIcons["noResultIcon-".concat(color)] = {
      color: colors[color].main
    };
    compareBoxWrapperColor["barColor-".concat(color)] = {
      color: colors[color].contrastTextLabel,
      backgroundColor: colors[color].main,
      borderTop: "1px solid ".concat(colors[color].contrastTextAction)
    };
  });
  Object.keys(colors).forEach(function (color) {
    var carouselIcon = icon[colors[color].icon].icon.carousel;
    iconColors["sliderIcon-".concat(color)] = {
      '& .slick-arrow': {
        top: '215px !important',
        // FWD-7864 to have fixed postion of arrows
        backgroundColor: carouselIcon.background.default,
        boxShadow: carouselIcon.shadow.hover,
        '& svg': {
          fill: carouselIcon.contrastText.default
        },
        '&:hover': {
          backgroundColor: carouselIcon.background.hover,
          '& svg': {
            fill: carouselIcon.contrastText.hover
          }
        },
        '&:active': {
          backgroundColor: carouselIcon.background.active,
          fill: carouselIcon.contrastText.active,
          boxShadow: carouselIcon.shadow.active
        }
      }
    };
  });
  return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, noResultIcons), {}, {
    animateSlider: function animateSlider(_ref) {
      var _ref2;

      var iSlide = _ref.iSlide;
      return _ref2 = {}, _defineProperty(_ref2, "& .slick-track > div:nth-child(".concat(iSlide, ")"), {
        animation: "slideMoveUpAndFadeIn ".concat(timings.larger, " ").concat(transitionFunction.easeIn),
        animationDelay: '0.00s',
        animationFillMode: 'backwards'
      }), _defineProperty(_ref2, "& .slick-track > div:nth-child(".concat(iSlide + 1, ")"), {
        animation: "slideMoveUpAndFadeIn ".concat(timings.larger, " ").concat(transitionFunction.easeIn),
        animationDelay: '0.05s',
        animationFillMode: 'backwards'
      }), _defineProperty(_ref2, "& .slick-track > div:nth-child(".concat(iSlide + 2, ")"), {
        animation: "slideMoveUpAndFadeIn ".concat(timings.larger, " ").concat(transitionFunction.easeIn),
        animationDelay: '0.1s',
        animationFillMode: 'backwards'
      }), _defineProperty(_ref2, "& .slick-track > div:nth-child(".concat(iSlide + 3, ")"), {
        animation: "slideMoveUpAndFadeIn ".concat(timings.larger, " ").concat(transitionFunction.easeIn),
        animationDelay: '0.15s',
        animationFillMode: 'backwards'
      }), _defineProperty(_ref2, "& .slick-track > div:nth-child(".concat(iSlide + 4, ")"), {
        animation: "slideMoveUpAndFadeIn ".concat(timings.larger, " ").concat(transitionFunction.easeIn),
        animationDelay: '0.2s',
        animationFillMode: 'backwards'
      }), _ref2;
    },
    title: {
      fontWeight: theme.typography.fontWeights.bolder,
      width: '100%',
      maxWidth: theme.spacing(102)
    },
    sliderWrap: {
      overflow: 'visible'
    },
    slider: {
      marginTop: theme.spacing(6),
      marginLeft: '-10px',
      marginRight: '-10px',
      '& .slick-list': {
        overflow: 'visible'
      },
      '& .slick-slide': (_slickSlide = {
        '&>div': _defineProperty({}, theme.breakpoints.down('md'), {
          marginLeft: theme.spacing(0.25),
          marginRight: theme.spacing(0.25)
        })
      }, _defineProperty(_slickSlide, theme.breakpoints.down('sm'), {
        padding: '0 16px',
        boxSizing: 'border-box'
      }), _defineProperty(_slickSlide, theme.breakpoints.down('xs'), {
        padding: '0 9px',
        boxSizing: 'border-box'
      }), _slickSlide),
      '& .slick-slide[aria-hidden="true"]': (_slickSlideAria = {
        opacity: '0.5',
        pointerEvents: 'none'
      }, _defineProperty(_slickSlideAria, theme.breakpoints.down('md'), {// transform: 'scale(0.93)',
      }), _defineProperty(_slickSlideAria, '& .productPlanCardInner', (_productPlanCardIn = {}, _defineProperty(_productPlanCardIn, theme.breakpoints.down('md'), {
        margin: '0 -5%'
      }), _defineProperty(_productPlanCardIn, '& .productPlanCard__header, .productPlanCard__body', _defineProperty({}, theme.breakpoints.down('md'), {// transform: 'scale(0.9)',
      })), _productPlanCardIn)), _slickSlideAria),
      '& .slick-next': _defineProperty({
        right: -theme.spacing(4)
      }, theme.breakpoints.up('xl'), {
        right: -theme.spacing(6)
      }),
      '& .slick-prev': (_slickPrev = {
        left: -theme.spacing(4)
      }, _defineProperty(_slickPrev, theme.breakpoints.up('xl'), {
        left: -theme.spacing(6)
      }), _defineProperty(_slickPrev, '& svg', {
        transform: 'rotate(180deg)'
      }), _slickPrev),
      '& .slick-arrow': (_slickArrow = {
        cursor: 'pointer',
        zIndex: 1,
        width: theme.spacing(5),
        height: theme.spacing(5),
        opacity: 1,
        transition: 'all .3s cubic-bezier(0.230, 1.000, 0.320, 1.000)',
        display: 'flex !important',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        '& svg': {
          width: theme.spacing(3),
          height: theme.spacing(3)
        }
      }, _defineProperty(_slickArrow, theme.breakpoints.down('md'), {
        display: 'none !important'
      }), _defineProperty(_slickArrow, '&:before', {
        display: 'none'
      }), _defineProperty(_slickArrow, '&.slick-disabled', {
        opacity: '0',
        pointerEvents: 'none'
      }), _slickArrow)
    },
    link: function link(_ref3) {
      var bgColor = _ref3.bgColor;
      return {
        fontWeight: theme.typography.fontWeights.bold,
        '& svg': {
          color: theme.palette.colors[bgColor] ? theme.palette.colors[bgColor].contrastTextAction : fwdColors.grey,
          fill: theme.palette.colors[bgColor] ? theme.palette.colors[bgColor].contrastTextAction : fwdColors.grey
        }
      };
    },
    footer: (_footer = {}, _defineProperty(_footer, theme.breakpoints.up('lg'), {
      marginTop: theme.spacing(1.75)
    }), _defineProperty(_footer, '& $link', _defineProperty({
      marginBottom: theme.spacing(1),
      '&:last-child': {
        marginBottom: 0
      }
    }, theme.breakpoints.up('lg'), {
      marginBottom: 0,
      marginRight: theme.spacing(8),
      '&:last-child': {
        marginRight: 0
      }
    })), _footer),
    sliderSelector: _defineProperty({
      marginTop: theme.spacing(4.5)
    }, theme.breakpoints.up('lg'), {
      marginTop: theme.spacing(4)
    }),
    noResultContainer: function noResultContainer(_ref4) {
      var _ref5;

      var bgColor = _ref4.bgColor;
      return _ref5 = {
        marginTop: theme.spacing(6)
      }, _defineProperty(_ref5, theme.breakpoints.up('lg'), {
        marginTop: theme.spacing(8)
      }), _defineProperty(_ref5, '& svg path', {
        fill: theme.palette.colors[bgColor] ? colors[bgColor].contrastTextAction : fwdColors.grey
      }), _ref5;
    },
    noResultPictogram: {
      width: theme.spacing(8),
      height: theme.spacing(8)
    },
    noResultIcon: _defineProperty({
      height: '64px',
      width: '64px'
    }, theme.breakpoints.up('lg'), {
      height: '64px',
      width: '64px'
    }),
    noResultTitle: _defineProperty({
      marginTop: theme.spacing(1),
      marginBottom: 0,
      textAlign: 'center',
      maxWidth: theme.spacing(75)
    }, theme.breakpoints.down('md'), {
      fontSize: theme.typography.T4,
      lineHeight: theme.typography.lineHeight.L6
    }),
    noResultDescription: {
      marginTop: theme.spacing(1),
      textAlign: 'center',
      maxWidth: theme.spacing(75)
    },
    noResultCta: _defineProperty({
      marginTop: theme.spacing(6)
    }, theme.breakpoints.up('lg'), {
      marginTop: theme.spacing(8)
    })
  }, iconColors), compareBoxWrapperColor), {}, {
    compareBar: _defineProperty({
      position: 'fixed',
      bottom: 0,
      right: 0,
      left: 0,
      zIndex: 998,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(2),
      boxShadow: '0 -2px 4px 0 rgba(0,0,0,0.2)'
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing(3),
      '&.compareEnable': {
        padding: theme.spacing(2)
      }
    }),
    buttonWrapper: (_buttonWrapper = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      width: '100%'
    }, _defineProperty(_buttonWrapper, theme.breakpoints.up('sm'), {
      flexDirection: 'row'
    }), _defineProperty(_buttonWrapper, '& .MuiButton-rootBtn', _defineProperty({
      padding: '7px',
      height: 'auto',
      marginTop: theme.spacing(2),
      '& .MuiButton-buttonText': _defineProperty({
        fontSize: theme.typography.T11,
        lineHeight: theme.typography.lineHeight.L15,
        fontWeight: theme.typography.fontWeights.bolder,
        padding: 0
      }, theme.breakpoints.up('sm'), {
        padding: theme.spacing(0.25),
        fontSize: theme.typography.T6,
        lineHeight: theme.typography.lineHeight.L9
      })
    }, theme.breakpoints.up('sm'), {
      marginTop: 0,
      padding: theme.spacing(1, 3)
    })), _defineProperty(_buttonWrapper, '& .bold', {
      fontWeight: theme.typography.fontWeights.bolder
    }), _buttonWrapper),
    countText: _defineProperty({
      fontSize: theme.typography.T11,
      lineHeight: theme.typography.lineHeight.L15,
      fontWeight: theme.typography.fontWeights.normal,
      letterSpacing: 0,
      paddingRight: theme.spacing(3),
      width: '100%'
    }, theme.breakpoints.up('sm'), {
      width: 'auto',
      paddingRight: theme.spacing(6),
      fontSize: theme.typography.T6,
      lineHeight: theme.typography.lineHeight.L7
    }),
    textWrapper: (_textWrapper = {
      width: '100%'
    }, _defineProperty(_textWrapper, theme.breakpoints.up('sm'), {
      width: 'auto'
    }), _defineProperty(_textWrapper, '& span', _defineProperty({
      fontSize: theme.typography.T11,
      lineHeight: theme.typography.lineHeight.L15,
      fontWeight: theme.typography.fontWeights.normal,
      letterSpacing: 0
    }, theme.breakpoints.up('sm'), {
      fontSize: theme.typography.T6,
      lineHeight: theme.typography.lineHeight.L7
    })), _defineProperty(_textWrapper, '& .bold', {
      fontWeight: theme.typography.fontWeights.bolder
    }), _textWrapper),
    '@global': {
      '@keyframes slideMoveUpAndFadeIn': {
        '0%': {
          opacity: 0,
          transform: 'translateY(50px)'
        },
        '100%': {
          opacity: 0.5,
          transform: 'translateY(0)'
        }
      }
    }
  });
};

var styles$t = function styles(theme) {
  var _MuiContainerRoot, _sticky, _cardTitle, _premiumDetails;

  var contrastColor = {};
  var colors = theme.palette.colors;
  /* istanbul ignore else */

  if (colors) {
    Object.keys(colors).forEach(function (color) {
      contrastColor["contrastColor-".concat(color)] = {
        color: colors[color].contrastTextAction
      };
    });
  }

  return _objectSpread2(_objectSpread2({}, contrastColor), {}, {
    productSummryCard: {
      background: fwdColors.white,
      borderRadius: theme.spacing(2),
      border: '1px solid #E5E5E5',
      marginRight: theme.spacing(1),
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'normal',
      '&.MuiContainer-root': (_MuiContainerRoot = {
        padding: theme.spacing(3, 1)
      }, _defineProperty(_MuiContainerRoot, theme.breakpoints.up('sm'), {
        padding: theme.spacing(3, 2)
      }), _defineProperty(_MuiContainerRoot, "paddingBottom", theme.spacing(2.25)), _MuiContainerRoot),
      '&.MuiContainer-root.withPadding': {
        paddingBottom: theme.spacing(3)
      },
      '&.MuiContainer-root.withCalculation': {
        paddingTop: theme.spacing(1.5)
      },
      '&.MuiContainer-root.withPremium': {
        justifyContent: 'space-between',
        paddingTop: theme.spacing(3)
      },
      '&.withHover': {
        margin: '-2px',
        border: '2px solid rgba(0,0,0,0)',
        '&:hover': _defineProperty({}, theme.breakpoints.up('sm'), {
          cursor: 'pointer',
          boxShadow: 'rgba(0,0,0,0.2) 0 6px 8px 0'
        })
      }
    },
    cardLabel: {
      fontSize: theme.typography.T11,
      lineHeight: theme.typography.lineHeight.L15,
      fontWeight: theme.typography.fontWeights.bold,
      letterSpacing: 0,
      paddingTop: theme.spacing(0),
      '&.inCard': _defineProperty({
        paddingTop: theme.spacing(2)
      }, theme.breakpoints.up('sm'), {
        paddingTop: 0,
        paddingRight: theme.spacing(5.5)
      }),
      '&.sticky': {
        display: 'none'
      }
    },
    cardTitle: (_cardTitle = {
      paddingTop: theme.spacing(1),
      fontSize: theme.typography.T6,
      lineHeight: theme.typography.lineHeight.L9,
      fontWeight: theme.typography.fontWeights.bolder,
      color: fwdColors.darkGreen,
      letterSpacing: 0
    }, _defineProperty(_cardTitle, theme.breakpoints.up('sm'), {
      paddingTop: theme.spacing(2)
    }), _defineProperty(_cardTitle, '&.sticky', (_sticky = {
      textAlign: 'center',
      fontSize: theme.typography.T11,
      lineHeight: theme.typography.lineHeight.L15
    }, _defineProperty(_sticky, theme.breakpoints.up('sm'), {
      paddingTop: theme.spacing(2),
      fontSize: theme.typography.T6,
      lineHeight: theme.typography.lineHeight.L9
    }), _defineProperty(_sticky, '&.card-0', {
      paddingRight: theme.spacing(1.5)
    }), _defineProperty(_sticky, '&.card-1', {
      paddingLeft: theme.spacing(1.5)
    }), _sticky)), _defineProperty(_cardTitle, theme.breakpoints.up('sm'), {
      fontSize: theme.typography.T4,
      lineHeight: theme.typography.lineHeight.L6
    }), _cardTitle),
    premiumDetails: (_premiumDetails = {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      paddingTop: theme.spacing(3)
    }, _defineProperty(_premiumDetails, theme.breakpoints.up('sm'), {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }), _defineProperty(_premiumDetails, '&.noTopPadding', {
      paddingTop: theme.spacing(0)
    }), _defineProperty(_premiumDetails, '&.topPaddingSpacing', {
      paddingTop: theme.spacing(2)
    }), _defineProperty(_premiumDetails, '&.sticky', {
      display: 'none'
    }), _premiumDetails),
    premiumLabel: _defineProperty({
      fontSize: theme.typography.T8,
      lineHeight: theme.typography.lineHeight.L13,
      fontWeight: theme.typography.fontWeights.normal,
      color: fwdColors.greyDarkest
    }, theme.breakpoints.up('sm'), {
      fontSize: theme.typography.T11,
      lineHeight: theme.typography.lineHeight.L14,
      paddingRight: theme.spacing(3)
    }),
    premiumValues: {
      display: 'flex',
      alignItems: 'flex-end',
      flexDirection: 'column',
      '&.afterCurrency': _defineProperty({}, theme.breakpoints.up('sm'), {
        alignItems: 'center',
        flexDirection: 'row'
      })
    },
    amountDiv: {
      display: 'flex',
      alignItems: 'flex-start',
      '& .currency': {
        paddingTop: theme.spacing(0.75),
        paddingRight: theme.spacing(0.5)
      }
    },
    premiumAmt: _defineProperty({
      fontSize: theme.typography.T5,
      lineHeight: theme.typography.lineHeight.L5,
      fontWeight: theme.typography.fontWeights.bold
    }, theme.breakpoints.up('sm'), {
      display: 'inline-block'
    }),
    premiumFrequencyContainer: _defineProperty({
      paddingLeft: 0,
      display: 'flex'
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(0.5),
      flexDirection: 'column'
    }),
    premiumFrequency: _defineProperty({
      fontSize: theme.typography.T8,
      lineHeight: theme.typography.lineHeight.L13,
      fontWeight: theme.typography.fontWeights.normal
    }, theme.breakpoints.up('sm'), {
      lineHeight: theme.typography.lineHeight.L16,
      display: 'inline-block'
    }),
    calculateCTA: {
      display: 'flex',
      alignItems: 'center',
      '&.MuiLink-root': _defineProperty({
        marginRight: theme.spacing(-0.75),
        marginTop: theme.spacing(-0.25)
      }, theme.breakpoints.up('sm'), {
        marginTop: 0
      }),
      '& .MuiSvgIcon-root': {
        width: theme.spacing(2),
        height: theme.spacing(2)
      },
      '& .MuiTypography-root': {
        fontSize: theme.typography.T11,
        lineHeight: theme.typography.lineHeight.L15,
        fontWeight: theme.typography.fontWeights.bolder
      }
    },
    selected: function selected(_ref) {
      var color = _ref.color;
      return {
        '&.withHover': {
          border: "2px solid ".concat(theme.palette.colors[color].contrastTextAction)
        }
      };
    },
    selectionBox: {
      position: 'absolute',
      right: 0,
      top: 0
    },
    checkboxContainer: function checkboxContainer(_ref2) {
      var _ref3;

      var color = _ref2.color;
      return _ref3 = {
        position: 'absolute',
        right: theme.spacing(1.5),
        top: theme.spacing(1.5)
      }, _defineProperty(_ref3, theme.breakpoints.up('sm'), {
        right: theme.spacing(2),
        top: theme.spacing(2)
      }), _defineProperty(_ref3, '& .MuiCheckbox-root', {
        padding: 0
      }), _defineProperty(_ref3, '& .MuiFormControlLabel-root', {
        padding: 0,
        margin: 0
      }), _defineProperty(_ref3, '& .MuiFormControlLabel-label', {
        color: theme.palette.colors[color].contrastTextAction,
        fontSize: theme.typography.pxToRem(13),
        fontWeight: theme.typography.fontWeights.bold,
        lineHeight: theme.typography.lineHeight.L9
      }), _ref3;
    }
  });
};
var ButtonStyle = function ButtonStyle(theme) {
  var _buttonContainer;

  return {
    link: _defineProperty({
      width: '100%'
    }, theme.breakpoints.up('sm'), {
      width: 'auto'
    }),
    buttonContainer: (_buttonContainer = {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: theme.spacing(2)
    }, _defineProperty(_buttonContainer, theme.breakpoints.up('sm'), {
      paddingTop: theme.spacing(0)
    }), _defineProperty(_buttonContainer, '& button, & a', _defineProperty({
      width: '100%'
    }, theme.breakpoints.up('sm'), {
      width: 'auto',
      maxWidth: theme.spacing(200 / 8)
    })), _defineProperty(_buttonContainer, '&.sticky', _defineProperty({
      '& $link': {
        width: 'auto'
      },
      '& button, & a': _defineProperty({
        height: 'auto',
        minWidth: 'unset',
        minHeight: 'unset',
        width: 'auto',
        lineHeight: theme.typography.lineHeight.L15
      }, theme.breakpoints.up('sm'), {
        marginBottom: theme.spacing(0)
      }),
      '& a': _defineProperty({
        padding: 0,
        marginTop: 0
      }, theme.breakpoints.up('sm'), {
        padding: theme.spacing(0.5),
        margin: theme.spacing(0, 0.5)
      }),
      '& button': {
        marginBottom: theme.spacing(0),
        padding: theme.spacing(1),
        '& span': {
          padding: 0
        }
      },
      '& .MuiTypography-button, & .MuiButton-label, & a': {
        fontSize: theme.typography.T11,
        lineHeight: theme.typography.lineHeight.L15
      },
      '&.card-0': {
        paddingRight: theme.spacing(1.5)
      },
      '&.card-1': {
        paddingLeft: theme.spacing(1.5)
      },
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    }, theme.breakpoints.up('sm'), {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBottom: theme.spacing(2)
    })), _buttonContainer),
    secLink: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: theme.spacing(0.5),
      fontSize: theme.typography.T11,
      lineHeight: theme.typography.lineHeight.L15,
      fontWeight: theme.typography.fontWeights.bold,
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(-0.5),
      '&.noMarginTop': _defineProperty({
        marginTop: theme.spacing(-0.5)
      }, theme.breakpoints.up('sm'), {
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(0)
      })
    }
  };
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var PC_LABEL = 'PlanComparison';
var PC_CHANGE_PLAN_MODAL = 'PC_CHANGE_PLAN_MODAL';
var PC_CHANGE_PLAN_MODAL_LABEL = 'PC_CHANGE_PLAN_MODAL_LABEL';
var PC_CHANGE_PLAN_MODAL_CTA = 'PC_CHANGE_PLAN_MODAL_CTA';
var PC_CHANGE_PLAN_MODAL_CARDS_CONTAINER = 'PC_CHANGE_PLAN_MODAL_CARDS_CONTAINER';
var PC_CHANGE_PLAN_MODAL_CLOSE = 'PC_CHANGE_PLAN_MODAL_CLOSE';
var PC_SUMMRY_CARD_CONTAINER = 'PC_SUMMRY_CARD_CONTAINER';
var PC_SUMMRY_CARD_TYPE_LABEL = 'PC_SUMMRY_CARD_TYPE_LABEL';
var PC_SUMMRY_PLAN_LABEL = 'PC_SUMMRY_PLAN_LABEL';
var PC_SUMMRY_CALCULATE_TYPE = 'PC_SUMMRY_CALCULATE_TYPE';
var PC_SUMMRY_CALCULATE_CTA = 'PC_SUMMRY_CALCULATE_CTA';
var PC_SUMMRY_PREMIUM_AMT = 'PC_SUMMRY_PREMIUM_AMT';
var PC_SUMMRY_FREQUENCY = 'PC_SUMMRY_FREQUENCY';
var PC_SUMMRY_CURRENCY = 'PC_SUMMRY_CURRENCY';
var PC_SUMMRY_CHECKBOX = 'PC_SUMMRY_CHECKBOX';

var useStyle$1 = makeStyles(styles$t);

var PlanSummryCard = function PlanSummryCard(props) {
  var classes = useStyle$1({
    color: "white"
  });
  var t = props.t,
      _props$isSelectionEna = props.isSelectionEnabled,
      isSelectionEnabled = _props$isSelectionEna === void 0 ? false : _props$isSelectionEna,
      _props$checked = props.checked,
      checked = _props$checked === void 0 ? false : _props$checked,
      _props$ctaCalculateIc = props.ctaCalculateIcon,
      ctaCalculateIcon = _props$ctaCalculateIc === void 0 ? "arrow-right" : _props$ctaCalculateIc,
      _props$ctaCalculateTi = props.ctaCalculateTitle,
      ctaCalculateTitle = _props$ctaCalculateTi === void 0 ? t && t("calculatepagelinklabel") : _props$ctaCalculateTi,
      _props$plan = props.plan,
      plan = _props$plan === void 0 ? {} : _props$plan,
      _props$resultedPlanLi = props.resultedPlanList,
      resultedPlanList = _props$resultedPlanLi === void 0 ? [] : _props$resultedPlanLi,
      _props$selectedPaymen = props.selectedPaymentMode,
      selectedPaymentMode = _props$selectedPaymen === void 0 ? "" : _props$selectedPaymen;
  var currency = t && t("currency");
  var cardTitle = get$1(props, "plan.fields.title.value", "");
  var cardLabel = get$1(props, "plan.fields.cardLabel.value", "");
  var premiumLabel = props.calculatedTypeLabel && t(props.calculatedTypeLabel.toLowerCase()) || props.comparisonTypeLabel;

  var _React$useState = React__default.useState(checked),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      compareChecked = _React$useState2[0],
      setCompareChecked = _React$useState2[1];

  React__default.useEffect(function () {
    setCompareChecked(checked);
  }, [checked]);
  var currencySeparator = get$1(props, "sitecoreContext.siteSettings.currencySeparator.value[".concat(currency, "]"), ",");
  var premiumFrequency = "",
      premiumAmt = "",
      sumAssured = "";

  if (resultedPlanList.length > 0) {
    var resultPlan = resultedPlanList.find(function (item) {
      return get$1(item, "product.plan.code", null) === (get$1(plan, "fields.planCode.value", null) || get$1(plan, "fields.title.value", null));
    });

    if (resultPlan) {
      var premium = get$1(resultPlan, "premiums", []).find(function (item) {
        return get$1(item, "premiumType", null) === selectedPaymentMode.toUpperCase();
      });
      sumAssured = get$1(resultPlan, "product.amount.baseSumAssured", null);

      if (props.calculatedTypeLabel.toLowerCase() === calculateTypes.PREMIUM) {
        premiumAmt = formatCurrency(get$1(premium, "amount.modalPremium", 0), currencySeparator);
      } else {
        premiumAmt = formatCurrency(sumAssured, currencySeparator);
      }

      premiumFrequency = t && t(paymentModes[selectedPaymentMode.toUpperCase()]);
      premiumFrequency = premiumFrequency ? "/" + premiumFrequency : "";
    }
  }

  if (resultedPlanList.length === 0 && props.enableCalculation === false) {
    premiumAmt = get$1(props, "plan.fields[".concat(props.comparisonType, "].value"), 0);
    premiumFrequency = get$1(props, "plan.fields.frequency.fields.value.value", "");
    premiumFrequency = premiumFrequency ? "/" + premiumFrequency : "";
  }

  if (props.setGAData) {
    props.setGAData({
      title: cardTitle,
      product: cardLabel,
      currency: t("currency"),
      premium: premiumAmt,
      sum_assured: sumAssured,
      coverage: Object.values(get$1(props, "plan.fields.cardAttributes.value", {}))
    }, get$1(props, "plan.fields.uniqueId", ""));
  }

  var currencyPlacementBefore = get$1(props, "sitecoreContext.siteSettings.currencyPlacement", "BeforeNumericals") === "BeforeNumericals";
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Container$1, {
    useContainer: !props.isStickyState,
    "data-locator": PC_SUMMRY_CARD_CONTAINER,
    className: clsx(classes.productSummryCard, isSelectionEnabled && "withHover", compareChecked && classes.selected, props.enableCalculation === true && resultedPlanList.length > 0 && "withCalculation", (isSelectionEnabled || resultedPlanList.length > 0 || props.enableCalculation === false) && "withPadding", (!isSelectionEnabled || resultedPlanList.length > 0 || props.enableCalculation === false) && "withPremium")
  }, isSelectionEnabled && /*#__PURE__*/React__default.createElement(Box$1, {
    color: "white",
    className: classes.selectionBox
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.checkboxContainer
  }, /*#__PURE__*/React__default.createElement(CheckBox, {
    value: true,
    color: props.color,
    fontWeight: "bold",
    label: "",
    checked: compareChecked,
    name: "compare",
    disabled: true,
    onChange: function onChange(evt) {
      var gaPlanData = {
        title: cardTitle,
        product: cardLabel,
        currency: t("currency"),
        premium: premiumAmt,
        sum_assured: sumAssured,
        coverage: Object.values(get$1(props, "plan.fields.cardAttributes.value", {}))
      };
      setCompareChecked(evt.target.checked);
      props.onChangeHander(gaPlanData);
    },
    dataLocator: PC_SUMMRY_CHECKBOX
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.titles)
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    className: clsx(classes.cardLabel, isSelectionEnabled && "inCard", props.isStickyState && "sticky", classes["contrastColor-".concat(props.color)]),
    varient: "h6",
    "data-locator": PC_SUMMRY_CARD_TYPE_LABEL,
    component: "h6"
  }, cardLabel), /*#__PURE__*/React__default.createElement(Typography$1, {
    className: clsx(classes.cardTitle, props.isStickyState && "sticky", "card-".concat(props.cardIndex)),
    varient: "h4",
    component: "h4",
    "data-locator": PC_SUMMRY_PLAN_LABEL
  }, cardTitle)), /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.premiumDetails, props.isStickyState && "sticky", isSelectionEnabled && !premiumAmt && "noTopPadding", !isSelectionEnabled && !premiumAmt && props.enableCalculation === false && "topPaddingSpacing")
  }, (!isSelectionEnabled || resultedPlanList.length > 0 || props.enableCalculation === false) && (premiumAmt || props.enableCalculation === true) ? /*#__PURE__*/React__default.createElement(Typography$1, {
    component: "div",
    className: classes.premiumLabel,
    "data-locator": PC_SUMMRY_CALCULATE_TYPE
  }, premiumLabel) : null, resultedPlanList.length > 0 || props.enableCalculation === false ? premiumAmt ? /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.premiumValues, !currencyPlacementBefore && "afterCurrency")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.amountDiv
  }, currencyPlacementBefore && currency && /*#__PURE__*/React__default.createElement(Typography$1, {
    "data-locator": PC_SUMMRY_CURRENCY,
    component: "span",
    className: clsx(classes.premiumFrequency, "currency", classes["contrastColor-".concat(props.color)])
  }, currency), /*#__PURE__*/React__default.createElement(Typography$1, {
    "data-locator": PC_SUMMRY_PREMIUM_AMT,
    className: clsx(classes.premiumAmt, classes["contrastColor-".concat(props.color)])
  }, premiumAmt)), /*#__PURE__*/React__default.createElement("div", {
    className: classes.premiumFrequencyContainer
  }, !currencyPlacementBefore && currency && /*#__PURE__*/React__default.createElement(Typography$1, {
    "data-locator": PC_SUMMRY_CURRENCY,
    component: "span",
    className: clsx(classes.premiumFrequency, classes["contrastColor-".concat(props.color)])
  }, currency), /*#__PURE__*/React__default.createElement(Typography$1, {
    "data-locator": PC_SUMMRY_FREQUENCY,
    component: "span",
    className: clsx(classes.premiumFrequency, classes["contrastColor-".concat(props.color)])
  }, premiumFrequency))) : null : !isSelectionEnabled && /*#__PURE__*/React__default.createElement("div", {
    className: classes.calculateContainer
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    "data-locator": PC_SUMMRY_CALCULATE_CTA,
    className: clsx(classes.calculateCTA),
    color: props.color,
    href: get$1(props, "plan.fields.calculatePageLink.value.href", ""),
    onClick: function onClick(e) {
      e.preventDefault();
      PushEvent({
        event: "buttonClick",
        buttonTitle: "calculatepagelinklabel",
        destinationUrl: get$1(props, "plan.fields.calculatePageLink.value.href", ""),
        componentName: props.gaCategoryName ? props.gaCategoryName : PC_LABEL
      });
      navigate(get$1(props, "plan.fields.calculatePageLink.value.href", ""));
    },
    icon: ctaCalculateIcon,
    size: "small"
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    component: "span"
  }, ctaCalculateTitle))))));
};

makeStyles(ButtonStyle);

var styles$s = function styles(theme) {
  var _close;

  return {
    planListModal: {
      animation: animations.fadeIn,
      '&.closeAnimation': {
        animation: animations.fadeOut
      },
      '& .MuiDialog-container, & .MuiDialog-paper, & .MuiBackdrop-root': {
        transition: 'none !important'
      }
    },
    rootDiv: function rootDiv(_ref) {
      var bgColor = _ref.bgColor;
      return {
        backgroundColor: fwdColors[bgColor],
        height: '100%'
      };
    },
    container: {
      paddingBottom: theme.spacing(3),
      '& .MuiContainer-sectionRoot': {
        height: '100%'
      }
    },
    modalTitle: _defineProperty({
      paddingBottom: theme.spacing(24 / 8),
      paddingTop: theme.spacing(64 / 8),
      margin: 0,
      '& h2': _defineProperty({
        fontWeight: theme.typography.fontWeights.bolder,
        letterSpacing: 0,
        fontSize: theme.typography.T3,
        lineHeight: theme.typography.lineHeight.L3
      }, theme.breakpoints.up('sm'), {
        fontSize: theme.typography.T2,
        lineHeight: theme.typography.lineHeight.L2
      })
    }, theme.breakpoints.up('sm'), {
      paddingTop: theme.spacing(96 / 8),
      paddingBottom: theme.spacing(48 / 8),
      paddingLeft: theme.spacing(1.5),
      margin: theme.spacing(0, -1.5)
    }),
    summryCardGrid: {
      '& > section': {
        height: '100%'
      }
    },
    buttonContainer: _defineProperty({
      paddingTop: theme.spacing(4),
      textAlign: 'center',
      '& span': {
        display: 'inline-flex'
      }
    }, theme.breakpoints.up('sm'), {
      paddingTop: theme.spacing(6)
    }),
    close: (_close = {
      position: 'fixed',
      zIndex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      width: theme.spacing(4),
      height: theme.spacing(4),
      minWidth: theme.spacing(4),
      minHeight: theme.spacing(4),
      maxWidth: theme.spacing(4),
      borderRadius: '50%',
      backgroundColor: fwdColors.white,
      right: theme.spacing(2),
      top: theme.spacing(2),
      boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
      '& svg': {
        width: theme.spacing(2),
        height: theme.spacing(2),
        '& path': {
          fill: fwdColors.darkGreen
        }
      },
      '&:hover': {
        backgroundColor: fwdColors.orange,
        '& path': {
          fill: fwdColors.white
        }
      }
    }, _defineProperty(_close, theme.breakpoints.up('sm'), {
      right: theme.spacing(6),
      top: theme.spacing(6)
    }), _defineProperty(_close, '& .closeBg', {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1,
      opacity: 0.2
    }), _close),
    closeIcon: {
      height: theme.spacing(3),
      width: theme.spacing(3),
      zIndex: 2,
      pointerEvents: 'none'
    }
  };
};

var useStyles$B = makeStyles$1(styles$s);

function PlanListModal(props) {
  // const resultedPlanList = useSelector(store =>
  //   get(store, 'productDetailPage.apiData.resultedPlanList', [])
  // );
  var resultedPlanList = get$1(props, 'productDetailPage.apiData.resultedPlanList', []);
  var _props$surfaceColor = props.surfaceColor,
      surfaceColor = _props$surfaceColor === void 0 ? 'white' : _props$surfaceColor,
      modalState = props.modalState,
      updateComparePlans = props.updateComparePlans,
      t = props.t;
  var bgColor = 'grey';
  var classes = useStyles$B({
    bgColor: bgColor,
    color: surfaceColor
  });
  var closeOnUpdate = get$1(props, 'closeOnUpdate', true);
  var plans = props.plans || [];
  var modalTitle = props.comparePlansModalTitle || t && t('compareotherplans');

  var _React$useState = React__default.useState(props.selectedPlans || []),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedPlans = _React$useState2[0],
      setSelectedPlans = _React$useState2[1];

  React__default.useEffect(function () {
    setSelectedPlans(props.selectedPlans || []);
  }, [props.selectedPlans]);

  var closeModalHandler = function closeModalHandler() {
    ref.current.classList.add('closeAnimation');
  };

  var ref = /*#__PURE__*/React__default.createRef();

  var onAnimationEnd = function onAnimationEnd() {
    /* istanbul ignore else */
    if (ref.current.classList.contains('closeAnimation')) {
      props.closeModalHandler();
      ref.current.classList.remove('closeAnimation');
    }
  };

  var planCheckBoxHandler = function planCheckBoxHandler(plan, gaData) {
    var uid = get$1(plan, 'fields.uniqueId', '');
    var planArr = [];
    /* istanbul ignore else */

    if (selectedPlans.includes(uid)) {
      planArr = selectedPlans.filter(function (item) {
        return item !== uid;
      });
      planArr.gaData = selectedPlans.gaData || {};
      planArr.gaData[uid] = gaData;
      setSelectedPlans(planArr); // only for planCompare page.

      PushEvent({
        event: 'buttonClick',
        buttonTitle: 'Compare',
        destinationUrl: '',
        componentName: props.gaCategoryName ? props.gaCategoryName : PC_LABEL,
        compared_plans: planArr.map(function (_uid) {
          return planArr.gaData[_uid];
        })
      });
      return;
    }

    if (selectedPlans.length < 2) {
      planArr = [].concat(_toConsumableArray(selectedPlans), [uid]);
    } else {
      planArr = [selectedPlans[1], uid];
    }

    planArr.gaData = selectedPlans.gaData || {};
    planArr.gaData[uid] = gaData; // only for planCompare page.

    PushEvent({
      event: 'buttonClick',
      buttonTitle: 'Compare',
      destinationUrl: '',
      componentName: props.gaCategoryName ? props.gaCategoryName : PC_LABEL,
      compared_plans: planArr.map(function (_uid) {
        return planArr.gaData[_uid];
      })
    });
    setSelectedPlans(planArr);
  };

  var setGAData = function setGAData(gaData, uid) {
    /* istanbul ignore else */
    if (selectedPlans) {
      selectedPlans.gaData = selectedPlans.gaData || [];
      selectedPlans.gaData[uid] = gaData;
      setSelectedPlans(selectedPlans);
    }
  };

  var isMobile = useMediaQuery$1("(max-width:".concat(breakpoints.values.sm, "px)"));
  return /*#__PURE__*/React__default.createElement(Dialog$1, {
    ref: ref,
    fullScreen: true,
    open: modalState,
    onClose: closeModalHandler,
    variant: 'empty',
    "data-locator": PC_CHANGE_PLAN_MODAL,
    className: classes.planListModal,
    onAnimationEnd: onAnimationEnd
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.rootDiv
  }, /*#__PURE__*/React__default.createElement(Container$1, {
    background: bgColor,
    className: clsx(classes.container, classes["compare-modal-".concat(bgColor)])
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.close, 'close', 'motionColorTransition', 'allBorderRadiusSmall'),
    "data-locator": PC_CHANGE_PLAN_MODAL_CLOSE,
    onClick: function onClick() {
      PushEvent({
        event: 'buttonClick',
        buttonTitle: 'close',
        destinationUrl: '',
        componentName: props.gaCategoryName ? props.gaCategoryName : PC_LABEL
      });
      closeModalHandler();
    }
  }, /*#__PURE__*/React__default.createElement(Close, {
    className: clsx(classes.closeIcon)
  })), /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    item: true,
    xs: 12,
    sm: 8,
    spacing: 3,
    className: classes.modalTitle
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    varient: "h2",
    component: "h2",
    "data-locator": PC_CHANGE_PLAN_MODAL_LABEL
  }, modalTitle)), /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    className: classes.plansContainer,
    spacing: isMobile ? 1 : 3,
    "data-locator": PC_CHANGE_PLAN_MODAL_CARDS_CONTAINER
  }, plans && plans.map(function (plan) {
    var resultPlan = resultedPlanList.find(function (item) {
      return get$1(item, 'product.plan.code', null) === (get$1(plan, 'fields.planCode.value', null) || get$1(plan, 'fields.title.value', null));
    });
    /* istanbul ignore else */

    if (get$1(plan, 'fields.isComparable.value', false) && (resultedPlanList.length === 0 || resultedPlanList.length > 0 && resultPlan)) {
      return /*#__PURE__*/React__default.createElement(StyledGrid, {
        item: true,
        key: "modal-".concat(plan.id),
        sm: 4,
        xs: 6,
        className: classes.summryCardGrid
      }, /*#__PURE__*/React__default.createElement(PlanSummryCard, {
        plan: plan,
        isSelectionEnabled: true,
        t: t,
        classes: classes,
        checked: selectedPlans.includes(get$1(plan, 'fields.uniqueId', '')),
        color: surfaceColor,
        onChangeHander: function onChangeHander(gaData) {
          planCheckBoxHandler(plan, gaData);
        },
        enableCalculation: props.enableCalculation,
        comparisonType: props.comparisonType,
        comparePlanLabel: props.comparePlanLabel,
        comparisonTypeLabel: props.comparisonTypeLabel,
        sitecoreContext: props.sitecoreContext,
        setGAData: setGAData
      }));
    } else {
      return null;
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
    color: bgColor,
    "data-locator": PC_CHANGE_PLAN_MODAL_CTA,
    disabled: selectedPlans.length !== 2,
    onClick: function onClick() {
      var plansData = _toConsumableArray(selectedPlans);

      plansData.gaData = _objectSpread2({}, selectedPlans.gaData);
      updateComparePlans(plansData);
      /* istanbul ignore else */

      if (closeOnUpdate) {
        closeModalHandler();
        PushEvent({
          event: 'buttonClick',
          buttonTitle: 'comparenow',
          destinationUrl: '',
          componentName: props.gaCategoryName ? props.gaCategoryName : PC_LABEL,
          compared_plans: plansData.map(function (name) {
            return selectedPlans.gaData[name];
          })
        });
      }
    }
  }, props.compareCTALabel || t && t('comparenow')))))));
}

var useStyles$A = makeStyles(styles$u);
var productPlanListAnchorId = productPlanList.COMPONENT_ANCHOR_ID;
var currentSlide = 0;
var nextArrowRef = /*#__PURE__*/React__default.createRef();
var prevArrowRef = /*#__PURE__*/React__default.createRef();
/**
 *
 * ProductPlanList
 *
 */

var ProductPlanList$1 = function ProductPlanList(props) {
  var flexiCol = get$1(props, "flexiCol", null);
  var color = get$1(props, "params.backgroundColor", "orangeLight-white") || "orangeLight-white";
  var params = props.params ? props.params : {};
  var dividerLine = params.divider ? params.divider : "0";

  var _getColors = getColors(color),
      bgColor = _getColors.bgColor,
      surfaceColor = _getColors.surfaceColor;

  var title = get$1(props, "fields.title.value", null) ? get$1(props, "fields.title", null) : null;
  var subTitle = get$1(props, "fields.subTitle", null) ? get$1(props, "fields.subTitle", null) : null;
  var calculateLink = !isEmpty(get$1(props, "fields.calculateLink.value", "")) ? get$1(props, "fields.calculateLink", null) : null;
  var calculateLinkGALabelName = get$1(props, "fields.calculateLinkGALabelName.value", "");
  var gaLabelName = get$1(props, "fields.gaLabelName.value", "");
  var brochure = get$1(props, "fields.brochure", null) || null;
  var primaryCta = get$1(props, "fields.link.value", null) ? get$1(props, "fields.link", null) : null;
  var primaryCtaGTM = get$1(props, "fields.linkGALabelName.value", "");
  var secondaryCta = get$1(props, "fields.secondaryLink.value", null) ? get$1(props, "fields.secondaryLink", null) : null;
  var secondaryCtaGTM = get$1(props, "fields.secondaryLinkGALabelName.value", ""); // const { t } = useTranslation();

  var dictionary = get$1(props, "dictionary", {
    currency: get$1(props, "currency", "THB"),
    swipetocompare: "You selected {plan1}. Select another plan to compare.",
    planselected: "You selected {plan1} and {plan2}.",
    seeComparison: "See Comparison",
    compare: "Compare",
    noplansfound: "No plans found",
    noplansfoundmessage: "Sorry, an error occured. Please go back and try again.",
    seeallplans: "See all plans",
    comparenow: "Compare now"
  });

  var t = function t(key) {
    return dictionary[key];
  };

  var initialSlide = findIndex(get$1(props, "fields.planCards", []), function (item) {
    return get$1(item, "fields.isFeatured.value", null) === true;
  });
  var iSlide = Math.ceil((initialSlide + 1) / 3); //first visible slide

  var classes = useStyles$A({
    bgColor: bgColor,
    iSlide: iSlide
  });
  var isDesktop = useMediaQuery$1("(min-width:".concat(breakpoints.values.lg, "px)"));
  var userdata = get$1(props, "userdata", {});
  var productDetails = get$1(props, "productDetails", {});
  var apiNameMapper = get$1(props, "apiNameMapper", {});
  var cookieBanner = get$1(props, "cookieBanner", {});
  var planListSliderTypes$1 = values(planListSliderTypes);
  var fields = get$1(props, "fields", {});
  var routeData = get$1(props, "sitecoreContext.route", null);
  var formModalState = get$1(props, "formModalState", false);
  var sitecoreItemId = get$1(props, "sitecoreContext.itemId", "");
  var productType = get$1(routeData, "templateName", "");
  var productGaLabelName = get$1(routeData, "fields.gaLabelName.value") || get$1(routeData, "fields.productTitle.value", "");
  var isPackage = productType === productTypes.PACKAGE ? true : false;
  var gaCategoryName = get$1(props, "fields.gaCategoryName.value", null);
  var locationType = get$1(props, "sitecoreContext.site.name", "fwd-th");
  var pageEditing = get$1(props, "sitecoreContext.pageEditing", false);
  var noResultPictogram = get$1(props, "sitecoreContext.siteSettings.productErrorPictogramUrl", ""); // data formatting
  // standardise property since packages returns with packageList and base and riders return with cardAttributes

  var allCards = get$1(props, "fields.planCards", []).map(function (item) {
    if (isEmpty(get$1(item, "fields.packageList", []))) {
      return get$1(item, "fields.cardAttributes.value", null) ? defaultsDeep({
        fields: {
          packageList: [{
            fields: {
              cardAttributes: get$1(item, "fields.cardAttributes", {})
            }
          }]
        }
      }, item) : defaultsDeep({
        fields: {
          packageList: []
        }
      }, item);
    } else {
      if (has(item, "fields.packageList.value")) {
        set(item, "fields.packageList", item.fields.packageList.value);
      }

      return item;
    }
  });
  var protectionValueArr = [];
  var protectionValue = {};

  if (isPackage) {
    allCards.forEach(function (card, index) {
      Object.assign(protectionValue, _defineProperty({}, "option".concat(index + 1), get$1(card, "fields.protectionValue.value", "")));
      protectionValueArr.push(Number(get$1(card, "fields.protectionValue.value", "")));
    });
  }

  var minProtectionValue = !isEmpty(protectionValueArr) ? Math.min.apply(Math, protectionValueArr) : "";
  var maxProtectionValue = !isEmpty(protectionValueArr) ? Math.max.apply(Math, protectionValueArr) : ""; // refs

  var sliderWrap = React__default.useRef();
  var slider = React__default.useRef(); // states

  var _useState = useState(allCards),
      _useState2 = _slicedToArray(_useState, 2),
      items = _useState2[0],
      setItems = _useState2[1];

  useEffect(function () {
    setItems(allCards);
  }, [props && props.fields && props.fields.planCards]);
  var selectedIndexFromQueryString = typeof window !== "undefined" ? getQueryParams("plancard", window.location.href) : null;
  var selectedIndexFromCMS = initialSlide === -1 ? Math.min(items.length - 1, 1) : initialSlide;

  if ((selectedIndexFromQueryString || selectedIndexFromQueryString === 0) && selectedIndexFromQueryString < items.length) {
    selectedIndexFromCMS = selectedIndexFromQueryString;
  }

  var _useState3 = useState(_defineProperty({}, planListSliderTypes.ALLPLANS, selectedIndexFromCMS)),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedCardIndex = _useState4[0],
      setSelectedCardIndex = _useState4[1];

  var _useState6 = useState(get$1(userdata, "calculateType", null) ? planListSliderTypes.FORYOU : planListSliderTypes.ALLPLANS),
      _useState7 = _slicedToArray(_useState6, 2),
      selectedSlider = _useState7[0],
      setSelectedSlider = _useState7[1];

  var _useState8 = useState(false),
      _useState9 = _slicedToArray(_useState8, 2),
      initialSlideReady = _useState9[0],
      setInitialSlideReady = _useState9[1];

  var _useState10 = useState(0),
      _useState11 = _slicedToArray(_useState10, 2),
      compareBarBottom = _useState11[0];
      _useState11[1]; //#region Tab Functionality


  var _useState12 = useState(0),
      _useState13 = _slicedToArray(_useState12, 2),
      activeTabIndex = _useState13[0],
      setActiveTabIndex = _useState13[1];

  var handleTabChange = function handleTabChange(event, newValue) {
    setActiveTabIndex(newValue);
    setSelectedSlider(planListSliderTypes$1[newValue]);
  }; //#endregion


  var _onResize = debounce(function () {
    // if (typeof document !== "undefined" && cookieBanner) {
    //   setCompareBarBottom(
    //     document.querySelector('[data-locator="Cookie-Banner-Wrapper"]')
    //       .parentNode.offsetHeight
    //   );
    // }

    /* istanbul ignore else */
    if (!sliderWrap.current) return;
    var maxPackages = Math.max.apply(Math, _toConsumableArray(items.map(function (item) {
      return get$1(item, "fields.packageList.length", 0);
    }))); // same height for card's header, body, and labelvaluelist item within

    var selectors = [".productPlanCard__header"].concat(_toConsumableArray(times(maxPackages, function (packageIndex) {
      return "[data-locator=ParentValueList-".concat(packageIndex, "]");
    })), _toConsumableArray(times(maxPackages, function (packageIndex) {
      return "[data-locator=LabelValueList-".concat(packageIndex, "]");
    })), [".productPlanCard__body"]);
    (sliderWrap.current.querySelector(".labelValueList.expanded") ? selectors.slice(0, -1) : selectors).forEach(function (selector) {
      // reset, get max height, apply
      if (selector.indexOf("[data-locator=ParentValueList-") !== -1) {
        var childSelector = selector.replace("Parent", "Label");
        var elms = sliderWrap.current.querySelectorAll(childSelector);
        var mh = getMaxHeight(elms);
        var elmsParent = sliderWrap.current.querySelectorAll(selector);
        var mhParent = getMaxHeight(elmsParent);

        _toConsumableArray(elmsParent).forEach(function (elm) {
          elm.style.maxHeight = "".concat(mhParent + mh, "px");

          if (!elm.style.minHeight) {
            elm.style.minHeight = "".concat(mhParent, "px");
          }
        });
      } else {
        var _elms = sliderWrap.current.querySelectorAll(selector);

        _toConsumableArray(_elms).forEach(function (elm) {
          return elm.style.minHeight = "";
        });

        var _mh = getMaxHeight(_elms);

        _toConsumableArray(_elms).forEach(function (elm) {
          return elm.style.minHeight = "".concat(_mh - 8, "px");
        });
      }
    });
  }, 300, {
    trailing: true
  }); // const onResize = () => {}


  var resetSessionPopupState = function resetSessionPopupState() {
    props.hasSessionPopups(false);
  }; // elements


  var NextArrow = function NextArrow(_ref) {
    var arrowProps = _extends({}, _ref);

    return /*#__PURE__*/React__default.createElement("div", _extends({
      role: "button",
      ref: nextArrowRef
    }, arrowProps, {
      "data-locator": PRODUCTPLANLIST_CAROUSEL_NEXT_BUTTON,
      "aria-label": PRODUCTPLANLIST_CAROUSEL_NEXT_BUTTON
    }), /*#__PURE__*/React__default.createElement(ArrowForward, null));
  };

  var PrevArrow = function PrevArrow(_ref2) {
    var arrowProps = _extends({}, _ref2);

    return /*#__PURE__*/React__default.createElement("div", _extends({
      ref: prevArrowRef,
      role: "button"
    }, arrowProps, {
      "data-locator": PRODUCTPLANLIST_CAROUSEL_PREV_BUTTON,
      "aria-label": PRODUCTPLANLIST_CAROUSEL_PREV_BUTTON
    }), /*#__PURE__*/React__default.createElement(ArrowForward, null));
  }; // options


  var settings = {
    dots: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerPadding: "0px",
    swipeToSlide: true,
    nextArrow: /*#__PURE__*/React__default.createElement(NextArrow, null),
    prevArrow: /*#__PURE__*/React__default.createElement(PrevArrow, null),
    afterChange: function afterChange(next) {
      if (!isDesktop) {
        setSelectedCardIndex(_objectSpread2(_objectSpread2({}, selectedCardIndex), {}, _defineProperty({}, selectedSlider, next)));
      }

      isVisible && impressions(next);
    },
    beforeChange: function beforeChange(current, next) {
      /* istanbul ignore else */
      if (isDesktop && !sliderWrap.current.querySelector(".slick-slide[data-index=\"".concat(current, "\"] .labelValueList.expanded"))) {
        var mh = getMaxHeight(sliderWrap.current.querySelectorAll(".slick-slide"));
        sliderWrap.current.querySelector(".slick-slider").style.minHeight = "".concat(mh, "px");
      }
      /* istanbul ignore else */


      if (next !== currentSlide && initialSlideReady) {
        next < currentSlide ? PushEvent({
          event: "buttonClick",
          buttonTitle: PRODUCTPLANLIST_CAROUSEL_PREV_BUTTON,
          destinationUrl: undefined,
          componentName: gaCategoryName ? gaCategoryName : PRODUCTPLANLIST_CONTAINER
        }) : PushEvent({
          event: "buttonClick",
          buttonTitle: PRODUCTPLANLIST_CAROUSEL_NEXT_BUTTON,
          destinationUrl: undefined,
          componentName: gaCategoryName ? gaCategoryName : PRODUCTPLANLIST_CONTAINER
        });
        currentSlide = next;
      }

      !initialSlideReady && setInitialSlideReady(true);
    },
    responsive: [{
      breakpoint: 960,
      settings: {
        adaptiveHeight: false,
        slidesToShow: 1,
        centerPadding: "108px",
        centerMode: true
      }
    }, {
      breakpoint: 639,
      settings: {
        adaptiveHeight: false,
        slidesToShow: 1,
        centerPadding: "24px",
        centerMode: true
      }
    }]
  }; // effects
  // update store on page load with product and plan details
  // const category = get(routeData, 'templateName', '');

  useEffect(function () {
    if (!routeData) return;
    var calculationOptions = routeData.fields.calculationOptions.map(function (option) {
      return option.fields;
    });
    var plans = get$1(fields, "planCards", []).map(function (planCard) {
      return {
        planCode: get$1(planCard, "fields.planCode.value"),
        planMinAge: get$1(planCard, "fields.minAge.value"),
        planMaxAge: get$1(planCard, "fields.maxAge.value", ""),
        planMinimumPremiumYearly: get$1(planCard, "fields.minimumPremiumYearly.value", ""),
        planMaximumPremiumYearly: get$1(planCard, "fields.maximumPremiumYearly.value", ""),
        planMinimumSumAssured: get$1(planCard, "fields.minimumSumAssured.value", ""),
        planMaximumSumAssured: get$1(planCard, "fields.maximumSumAssured.value", ""),
        minimumSumAssuredRule: get$1(planCard, "fields.minimumSumAssuredRule", ""),
        packageList: get$1(planCard, "fields.packageList", []),
        planTitle: get$1(planCard, "fields.title.value", ""),
        protectionValue: get$1(planCard, "fields.protectionValue.value", ""),
        productPlanOptionCd: get$1(planCard, "fields.productPlanOptionCd.value", "")
      };
    });
    props.updateProductDetails({
      productName: get$1(routeData, "fields.productTitle.value", ""),
      productGALabelName: get$1(routeData, "fields.gaLabelName.value", undefined) || get$1(routeData, "fields.productTitle.value", ""),
      minAge: get$1(routeData, "fields.minAge.value", ""),
      maxAge: get$1(routeData, "fields.maxAge.value", ""),
      minSumAssured: isPackage ? minProtectionValue : get$1(routeData, "fields.minimumSumAssured.value", ""),
      maxSumAssured: isPackage ? maxProtectionValue : get$1(routeData, "fields.maximumSumAssured.value", ""),
      calculationOptions: calculationOptions,
      sumAssuredSelectionType: get$1(routeData, "fields.sumAssuredSelectionType.fields", {}),
      premiumSelectionType: get$1(routeData, "fields.premiumSelectionType.fields", {}),
      maxPremiumYearly: get$1(routeData, "fields.maximumPremiumYearly.value", ""),
      minPremiumYearly: get$1(routeData, "fields.minimumPremiumYearly.value", ""),
      sumAssuredRange: !isEmpty(protectionValue) ? protectionValue : get$1(routeData, "fields.sumAssuredRange.value", ""),
      premiumRange: get$1(routeData, "fields.premiumRange.value", ""),
      sumAssuredPaymentMode: get$1(routeData, "fields.sumAssuredPaymentMode", []).map(function (mode) {
        return {
          value: mode.fields.key.value,
          displayValue: mode.fields.value.value
        };
      }),
      purchaseMethod: get$1(routeData, "fields.purchaseMethod", []).map(function (method) {
        return method.fields.name.value;
      }),
      sumAssuredStepperInterval: get$1(fields, "sumAssuredStepperInterval", ""),
      premiumStepperInterval: get$1(fields, "premiumStepperInterval", ""),
      plans: plans,
      ridersAvailable: get$1(routeData, "fields.exploreRiders.value", null),
      associatedItems: get$1(fields, "associatedItems", []),
      enableEnquiryForRiders: get$1(routeData, "fields.enableEnquiryForRiders.value", null),
      allPlanCards: allCards,
      productType: get$1(routeData, "templateName", ""),
      talkToAgentLink: get$1(routeData, "fields.talkToAgentLink", null),
      talkToAgentTitle: get$1(routeData, "fields.talkToAgentTitle", ""),
      expectedInsuranceType: get$1(routeData, "fields.expectedInsuranceType.fields.key.value", ""),
      parameters: get$1(routeData, "fields.parameters.value", {}) || {}
    });
    props.updateFormLinks({
      formType: "calculator",
      URL: generatelayoutServicePath(get$1(props, "fields.calculateLink.value.href", ""), props.sitecoreContext.languageCode || props.sitecoreContext.language)
    });
    props.updateGroupEnquiryData({
      productName: get$1(routeData, "fields.productTitle.value", "")
    });

    if (props.lastCalculatedItemId !== sitecoreItemId) {
      props.resetApiData && props.resetApiData();
      props.hasSessionPopups(false);
    } else {
      if (!isEmpty(apiNameMapper[sitecoreItemId])) {
        props.hasSessionPopups(true);
      }
    } // Scroll to PlanCardList component if selected card index comes in query params


    if ((selectedIndexFromQueryString || selectedIndexFromQueryString === 0) && selectedIndexFromQueryString < items.length) {
      setTimeout(function () {
        scroller.scrollTo(productPlanListAnchorId, {
          delay: 100,
          smooth: "easeInOutQuint"
        });
      }, 1000);
    }

    return resetSessionPopupState;
  }, []);
  useEffect(function () {
    props.setPDPItemId(get$1(props, "sitecoreContext.itemId", ""));

    if (get$1(userdata, "calculateType", null)) {
      setSelectedPlans([]);
      setSelectedSlider(planListSliderTypes.FORYOU);
      var resultedPlanList = get$1(userdata, "resultedPlanList", []);

      if (get$1(userdata, "finalizer", null) === calculatorInitializers.RECOMMENDER) {
        setSelectedCardIndex(_objectSpread2(_objectSpread2({}, selectedCardIndex), {}, _defineProperty({}, planListSliderTypes.FORYOU, resultedPlanList.length > 1 ? 1 : 0)));
      } else {
        setSelectedCardIndex(_objectSpread2(_objectSpread2({}, selectedCardIndex), {}, _defineProperty({}, planListSliderTypes.FORYOU, findIndex(resultedPlanList, function (item) {
          return get$1(item, "isRecommended", false);
        }))));
      }
    } else {
      setSelectedSlider(planListSliderTypes.ALLPLANS);
    }
  }, [userdata]);
  useEffect(function () {
    if (selectedSlider === planListSliderTypes.FORYOU) {
      var filteredPlanCodes = get$1(userdata, "resultedPlanList", []).map(function (item) {
        return get$1(item, "product.plan.code", null);
      });
      var filteredPlanCodeWithOptionCd = get$1(userdata, "resultedPlanList", []).map(function (item) {
        return get$1(item, "product.plan.code", "") + "_" + get$1(item, "product.plan.productOption", "");
      });

      if (get$1(userdata, "finalizer", null) === calculatorInitializers.RECOMMENDER && filteredPlanCodes.length > 1) {
        // get the recommended plan
        var recommendedPlan = get$1(userdata, "resultedPlanList", []).find(function (item) {
          return get$1(item, "isRecommended", false);
        }); // get the filtered cards base on filteredPlanCodes

        var filteredCards = allCards.filter(function (item) {
          if (isPackage) {
            return filteredPlanCodes.includes(get$1(item, "fields.title.value", null));
          } else {
            return get$1(userdata, "calculateType", null) === "sumassured" ? filteredPlanCodes.includes(get$1(item, "fields.planCode.value", null)) : filteredPlanCodeWithOptionCd.includes(get$1(item, "fields.planCode.value", null) + "_" + get$1(item, "fields.productPlanOptionCd.value", null));
          }
        }); // find existing index, and force it to always 1

        setItems(moveArr(filteredCards, filteredCards.findIndex(function (item) {
          return isPackage ? get$1(item, "fields.title.value", false) === get$1(recommendedPlan, "product.plan.code", null) : get$1(item, "fields.planCode.value", false) === get$1(recommendedPlan, "product.plan.code", null);
        }), 1));
      } else {
        // map against raw plan card data initially provided by layout service
        setItems(allCards.filter(function (item) {
          if (isPackage) return filteredPlanCodes.includes(get$1(item, "fields.title.value", null));else return get$1(userdata, "calculateType", null) === "sumassured" ? filteredPlanCodes.includes(get$1(item, "fields.planCode.value", null)) : filteredPlanCodeWithOptionCd.includes(get$1(item, "fields.planCode.value", null) + "_" + get$1(item, "fields.productPlanOptionCd.value", null));
        }));
      }
    } else if (selectedSlider === planListSliderTypes.ALLPLANS) {
      setItems(allCards);
    }
  }, [userdata, selectedSlider]);

  var setSliderArrowPosition = function setSliderArrowPosition(arrowposition) {
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      if (nextArrowRef.current && prevArrowRef.current) {
        if (arrowposition) {
          nextArrowRef.current.style.top = arrowposition + "px";
          prevArrowRef.current.style.top = arrowposition + "px";
        } else {
          nextArrowRef.current.style.top = "50%";
          prevArrowRef.current.style.top = "50%";
        }
      } else if (nextArrowRef.current) {
        if (arrowposition) {
          nextArrowRef.current.style.top = arrowposition + "px";
        } else nextArrowRef.current.style.top = "50%";
      } else if (prevArrowRef.current) {
        if (arrowposition) {
          prevArrowRef.current.style.top = arrowposition + "px";
        } else prevArrowRef.current.style.top = "50%";
      }
    }
  };
  /**
   * Google Analytics Start
   */


  var rootNode = useRef(null);

  var _useVisibilitySensor = useVisibilitySensor(rootNode, {
    scrollCheck: true,
    partialVisibility: false,
    shouldCheckOnMount: false,
    scrollThrottle: 1500
  }),
      isVisible = _useVisibilitySensor.isVisible;

  var plansGAData = {};

  var getGAProductData = function getGAProductData(uid) {
    var plan = get$1(props, "fields.planCards", []).find(function (el) {
      return get$1(el, "fields.uniqueId", "") === uid;
    });
    return {
      title: get$1(plan, "fields.title.value", ""),
      product: get$1(plan, "fields.cardLabel.value", ""),
      currency: t("currency"),
      premium: plansGAData[uid].premium,
      sum_assured: plansGAData[uid].sum_assured,
      coverage: Object.values(get$1(plan, "fields.cardAttributes.value", {}))
    };
  };

  var comparisonHandler = function comparisonHandler() {
    var url = "".concat(get$1(props, "fields.comparisonPageLink.value.href", ""), "?plan1=").concat(selectedPlans[0], "&plan2=").concat(selectedPlans[1]);
    PushEvent({
      event: "buttonClick",
      buttonTitle: "seeComparison",
      destinationUrl: url,
      componentName: gaCategoryName ? gaCategoryName : PRODUCTPLANLIST_CONTAINER,
      compared_plans: selectedPlans.map(function (uid) {
        return selectedPlans.gaData[uid];
      })
    });
    navigate(url);
    return;
  };

  useEffect(function () {
    if (slider && slider.current) {
      var gotoIndex = isDesktop ? Math.min(Math.max(0, selectedCardIndex[selectedSlider] - 1), items.length > 3 ? items.length - 3 : items.length - 1) : selectedCardIndex[selectedSlider];

      if (isDesktop) {
        if (gotoIndex < 3) {
          setInitialSlideReady(true);
        }
      } else {
        if (gotoIndex === 1) {
          setInitialSlideReady(true);
        }
      }

      slider.current.slickGoTo(gotoIndex, true);

      _onResize();

      isVisible && impressions(gotoIndex);
    }
  }, [isVisible, items, isDesktop]);

  var impressions = function impressions(n) {
    var dataLayer = {
      ecommerce: {
        impressions: []
      }
    };

    for (var i = 0; i < (isDesktop ? settings.slidesToShow : settings.responsive[0].settings.slidesToShow); i++) {
      var pos = n + i;
      var planGaLabelName = get$1(items, "[".concat(pos, "].fields.gaLabelName.value")) || get$1(items, "[".concat(pos, "].fields.cardTitle.value"));
      var label = get$1(items, "[".concat(pos, "].fields.cardLabel.value"), "");
      planGaLabelName && dataLayer.ecommerce.impressions.push({
        name: productGaLabelName,
        id: productGaLabelName,
        category: label,
        list: listTypes.PRODUCT_PAGES_LIST,
        position: pos + 1
      });
    }

    PushEvent(_objectSpread2({}, dataLayer));
  };
  /**
   * Compare checkbox will be render, if at-least two plans have isComparable = true
   */


  var isComparablePlansCount = get$1(props, "fields.comparisonPageLink.value.href", null) && items.filter(function (planVal) {
    return get$1(planVal, "fields.isComparable.value", null);
  }).length;
  var isCompareCheckboxRender;
  var otherComparablePlans = get$1(props, "fields.otherComparablePlans", []);

  if ((otherComparablePlans.length > 0 && isComparablePlansCount > 0 || isComparablePlansCount > 1) && (locationType !== "fwd-th" || locationType === "fwd-th" && (!get$1(userdata, "calculateType", null) || selectedSlider === planListSliderTypes.FORYOU))) {
    isCompareCheckboxRender = true;
  } else {
    isCompareCheckboxRender = false;
  }

  var _useState14 = useState([]),
      _useState15 = _slicedToArray(_useState14, 2),
      selectedPlans = _useState15[0],
      setSelectedPlans = _useState15[1];

  var _useState16 = useState(false),
      _useState17 = _slicedToArray(_useState16, 2),
      showComparePopup = _useState17[0],
      setShowComparePopup = _useState17[1];

  var selectPlansForCompare = function selectPlansForCompare(_ref3) {
    var uid = _ref3.uid,
        gaData = _ref3.gaData;

    if (gaData) {
      plansGAData[uid] = {
        sum_assured: get$1(gaData, "sumAssured", ""),
        premium: get$1(gaData, "value.value", "")
      };
    }

    var plansArr = [];

    if (otherComparablePlans.length > 0) {
      plansArr = [uid];
      plansArr.gaData = selectedPlans.gaData || {};
      plansArr.gaData[uid] = getGAProductData(uid);
      setSelectedPlans(plansArr);
      setShowComparePopup(true);
      PushEvent({
        event: "buttonClick",
        buttonTitle: "Compare",
        destinationUrl: get$1(props, "fields.comparisonPageLink.value.href", ""),
        componentName: gaCategoryName ? gaCategoryName : PRODUCTPLANCARD_ENQUIREBUTTON,
        compared_plans: plansArr.map(function (_ui) {
          return plansArr.gaData[_ui];
        })
      });
      return;
    }

    if (uid) {
      if (selectedPlans.includes(uid)) {
        plansArr = selectedPlans.filter(function (id) {
          return id !== uid;
        });
      } else {
        if (selectedPlans.length === 2) {
          plansArr = [selectedPlans[1], uid];
        } else {
          plansArr = [].concat(_toConsumableArray(selectedPlans), [uid]);
        }
      }

      plansArr.gaData = selectedPlans.gaData || {};
      plansArr.gaData[uid] = getGAProductData(uid);
      PushEvent({
        event: "buttonClick",
        buttonTitle: "Compare",
        destinationUrl: get$1(props, "fields.comparisonPageLink.value.href", ""),
        componentName: gaCategoryName ? gaCategoryName : PRODUCTPLANCARD_ENQUIREBUTTON,
        compared_plans: plansArr.map(function (_uid) {
          return plansArr.gaData[_uid];
        })
      });
      setSelectedPlans(plansArr);
    }
  };

  useEffect(function () {
    if (otherComparablePlans.length > 0 && selectedPlans.length === 2) {
      comparisonHandler();
    }
  }, [selectedPlans]);

  var getPlanName = function getPlanName(uid) {
    var pl = get$1(props, "fields.planCards", []).find(function (item) {
      return uid === get$1(item, "fields.uniqueId", "");
    });
    return get$1(pl, "fields.title.value", "");
  };

  var showBar = function showBar() {
    if (selectedPlans.length === 1) {
      var labelSingle = t("swipetocompare").replace("{plan1}", "<span class='bold'>".concat(getPlanName(selectedPlans[0]), "</span>"));
      return /*#__PURE__*/React__default.createElement("div", {
        className: classes.textWrapper
      }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        variant: "h7",
        component: "span",
        color: surfaceColor,
        "data-locator": PRODUCTPLANLIST_BAR_TEXT,
        dangerouslySetInnerHTML: {
          __html: labelSingle
        }
      }));
    }

    if (selectedPlans.length === 2) {
      var labelCompareMsg = t("planselected").replace("{plan1}", "<span class='bold'>".concat(getPlanName(selectedPlans[0]), "</span>")).replace("{plan2}", "<span class='bold'>".concat(getPlanName(selectedPlans[1]), "</span>"));
      return /*#__PURE__*/React__default.createElement("div", {
        className: classes.buttonWrapper
      }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        variant: "h7",
        component: "span",
        color: surfaceColor,
        className: classes.countText,
        "data-locator": PRODUCTPLANLIST_BAR_TEXT,
        dangerouslySetInnerHTML: {
          __html: labelCompareMsg
        }
      }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(DynamicLink$1, {
        value: {
          linktype: "custom",
          text: t("seeComparison")
        },
        gaCategoryName: gaCategoryName,
        color: surfaceColor,
        "data-locator": PRODUCTPLANLIST_SEE_COMPARISON_CTA,
        buttonMode: buttonModes.PRIMARY,
        onClick: comparisonHandler,
        GTMSharedKey: t("seeComparison"),
        skipGA: true
      })));
    }
  };
  /**
   * This function is to push dataLayer event when component is rendered for the first time.
   * Only runs when enableOptimize360 is enabled from the CMS.
   * FWDS-1513 & FWDS-1846
   */


  useEffect(function () {
    var enableOptimize360 = get$1(props, "sitecoreContext.siteSettings.optimize360", false);
    enableOptimize360 && PushEvent({
      event: "productPlanCardList_loaded",
      content: {}
    });
  }, []);
  /**
   * Google Analytics End
   */

  return pageEditing || title && title.value || subTitle && subTitle.value || items.length > 0 ? /*#__PURE__*/React__default.createElement(NoSsr, null, /*#__PURE__*/React__default.createElement(Container$1, {
    id: productPlanListAnchorId,
    useContainer: !flexiCol,
    background: bgColor,
    className: clsx(classes.container, getPaddingString(params), dividerLine === "1" ? "component-divider-".concat(bgColor) : ""),
    fixed: true,
    overflowHidden: true
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root),
    "data-locator": PRODUCTPLANLIST_CONTAINER
  }, title && /*#__PURE__*/React__default.createElement("div", {
    className: classes.planListTitle
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h2",
    component: "h2",
    color: bgColor,
    className: classes.title,
    "data-locator": PRODUCTPLANLIST_HEADING,
    mb: 0
  }, title.value)), /*#__PURE__*/React__default.createElement(ProductInfoBar, {
    gaCategoryName: gaCategoryName,
    subTitle: subTitle,
    productName: productGaLabelName,
    calculateLink: calculateLink,
    calculateLinkGALabelName: calculateLinkGALabelName,
    brochure: brochure,
    color: bgColor,
    gaLabelName: gaLabelName,
    setActiveTabIndex: setActiveTabIndex
  }), get$1(userdata, "calculateType", null) && /*#__PURE__*/React__default.createElement("div", {
    className: classes.sliderSelector
  }, /*#__PURE__*/React__default.createElement(FwdTabs, {
    orientation: "horizontal",
    value: activeTabIndex,
    onChange: handleTabChange,
    color: bgColor,
    centered: "true",
    divider: true,
    dividerType: "primary"
  }, planListSliderTypes$1.map(function (sliderItem) {
    return /*#__PURE__*/React__default.createElement(FwdTab, {
      orientation: "horizontal",
      color: bgColor,
      key: sliderItem,
      label: t(sliderItem),
      "data-locator": locators$2["PRODUCTPLANLIST_SLIDER_".concat(sliderItem.toUpperCase())]
    });
  }))), !isEmpty(items) ? /*#__PURE__*/React__default.createElement("div", {
    ref: rootNode
  }, /*#__PURE__*/React__default.createElement(Box, {
    ref: sliderWrap,
    className: clsx(classes.sliderWrap),
    position: "relative",
    "data-locator": PRODUCTPLANLIST_CAROUSEL
  }, /*#__PURE__*/React__default.createElement(ReactResizeDetector, {
    handleWidth: true,
    onResize: function onResize() {
      return _onResize();
    }
  }), /*#__PURE__*/React__default.createElement(Carousel$1, {
    settings: settings,
    className: clsx(isDesktop && classes.animateSlider, classes.slider, classes["sliderIcon-".concat("white")]),
    ref: slider
  }, items.map(function (item, i) {
    var hasShareIcon = function hasShareIcon() {
      if (get$1(item, "fields.share.value", false)) {
        if (selectedSlider === planListSliderTypes.FORYOU) {
          if (get$1(props, "sitecoreContext.site.name", "").slice(-2) === "th") {
            return false;
          }
        }

        return true;
      }

      return false;
    };

    return /*#__PURE__*/React__default.createElement(ProductPlanCard, _extends({}, item, {
      sitecoreContext: props.sitecoreContext,
      gaCategoryName: gaCategoryName,
      key: item.id,
      userdata: selectedSlider === planListSliderTypes.FORYOU && userdata,
      productDetails: selectedSlider === planListSliderTypes.FORYOU && productDetails,
      color: surfaceColor,
      index: i,
      selectedCardIndex: selectedCardIndex[selectedSlider],
      onClick: function onClick() {
        PushEvent({
          event: "buttonClick",
          buttonTitle: get$1(item, "fields.gaLabelName.value", "") || getGTMSharedKeyVal(undefined, PRODUCTPLANLIST_CAROUSEL),
          componentName: gaCategoryName ? gaCategoryName : PRODUCTPLANLIST_CAROUSEL,
          destinationUrl: undefined,
          productName: productGaLabelName
        });
        setSliderArrowPosition();
        setSelectedCardIndex(_objectSpread2(_objectSpread2({}, selectedCardIndex), {}, _defineProperty({}, selectedSlider, i)));
      },
      onResize: _onResize,
      hasShareIcon: hasShareIcon(),
      brochure: brochure,
      hasTag: get$1(userdata, "finalizer", null) === calculatorInitializers.RECOMMENDER,
      openCta: !isDesktop,
      isPackage: isPackage,
      productGaLabelName: productGaLabelName,
      selectPlansForCompare: selectPlansForCompare,
      selectedPlans: selectedPlans,
      isCompareCheckboxRender: isCompareCheckboxRender,
      setSliderArrowPosition: setSliderArrowPosition,
      prevArrowRef: prevArrowRef,
      nextArrowRef: nextArrowRef,
      compareCTALabel: get$1(routeData, "fields.compareLabel.value", t("compare"))
    }));
  })))) : /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    className: classes.noResultContainer
  }, noResultPictogram ?
  /*#__PURE__*/
  // <Image
  //   media={{ value: { src: noResultPictogram } }}
  //   className={classes.noResultPictogram}
  // />
  React__default.createElement("img", {
    src: noResultPictogram,
    className: classes.noResultPictogram
  }) : /*#__PURE__*/React__default.createElement(NoResultIcon, {
    className: clsx(classes.noResultIcon, classes["noResultIcon-".concat(bgColor)])
  }), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h4",
    component: "h3",
    color: bgColor,
    "data-locator": PRODUCTPLANLIST_NO_RESULTS_TITLE,
    className: clsx(classes.noResultTitle)
  }, t("noplansfound")), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    color: bgColor,
    "data-locator": PRODUCTPLANLIST_NO_RESULTS_DESCRIPTION,
    className: clsx(classes.noResultDescription)
  }, t("noplansfoundmessage")), /*#__PURE__*/React__default.createElement(DynamicLink$1, {
    value: {
      linktype: "custom",
      text: t("seeallplans")
    },
    color: bgColor,
    gaCategoryName: gaCategoryName,
    "data-locator": PRODUCTPLANLIST_NO_RESULTS_CTA,
    className: clsx(classes.noResultCta),
    buttonMode: buttonModes.PRIMARY,
    onClick: function onClick() {
      return setSelectedSlider(planListSliderTypes.ALLPLANS);
    },
    GTMSharedKey: "seeallplans"
  })), (primaryCta || secondaryCta) && /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: {
      xs: "column",
      lg: "row"
    },
    mt: 3,
    className: clsx(classes.footer)
  }, primaryCta && /*#__PURE__*/React__default.createElement(DynamicLink$1, _extends({}, primaryCta, {
    gaCategoryName: gaCategoryName,
    className: clsx(classes.link),
    icon: get$1(props, "fields.buttonIcon.fields.value.value", null),
    "data-locator": PRODUCTPLANLIST_PRIMARY_CTA,
    color: bgColor,
    dialogBgColor: surfaceColor,
    type: "caption",
    GTMSharedKey: primaryCtaGTM
  })), secondaryCta && /*#__PURE__*/React__default.createElement(DynamicLink$1, _extends({}, secondaryCta, {
    gaCategoryName: gaCategoryName,
    className: clsx(classes.link) // FWDS-5076 Secondary link icon are not showing correctly
    ,
    icon: get$1(props, "fields.secondaryLinkButtonIcon.fields.value.value", null),
    "data-locator": PRODUCTPLANLIST_SECONDARY_CTA,
    color: bgColor,
    dialogBgColor: surfaceColor,
    type: "caption",
    GTMSharedKey: secondaryCtaGTM
  }))), !(otherComparablePlans && otherComparablePlans.length > 0) && selectedPlans && selectedPlans.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    "data-locator": PRODUCTPLANLIST_COMPARISON_BAR_WRAPPER,
    className: clsx(classes.compareBar, classes["barColor-".concat(surfaceColor)], selectedPlans.length === 2 && "compareEnable"),
    style: {
      bottom: cookieBanner ? compareBarBottom : 0
    }
  }, showBar())), formModalState && /*#__PURE__*/React__default.createElement(Dialog$1, {
    fullScreen: true,
    open: true,
    disableLocators: true
  }), showComparePopup && /*#__PURE__*/React__default.createElement(PlanListModal, {
    t: t,
    closeOnUpdate: false,
    modalState: showComparePopup,
    updateComparePlans: function updateComparePlans(plans) {
      setSelectedPlans(plans);
    },
    closeModalHandler: function closeModalHandler() {
      setSelectedPlans([]);
      setShowComparePopup(false);
    },
    plans: [].concat(_toConsumableArray(get$1(props, "fields.planCards", [])), _toConsumableArray(otherComparablePlans.map(function (el) {
      return {
        fields: _objectSpread2({}, el)
      };
    }))),
    selectedPlans: selectedPlans,
    surfaceColor: surfaceColor,
    sitecoreContext: props.sitecoreContext,
    enableCalculation: get$1(props, "fields.planComparisonDetails.enableCalculation.value", false),
    comparisonType: get$1(props, "fields.planComparisonDetails.comparisonType.fields.key.value", ""),
    comparePlansModalTitle: get$1(props, "fields.planComparisonDetails.comparePlansModalTitle.value", ""),
    comparePlanLabel: get$1(props, "fields.planComparisonDetails.title.value", ""),
    comparisonTypeLabel: get$1(props, "fields.planComparisonDetails.comparisonTypeLabel.value"),
    compareCTALabel: t("comparenow")
  }))) : null;
}; // export const mapStateToProps = createStructuredSelector({

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$r = function styles(theme) {
  var _btnLinkWrapper, _cardWithLinkCTA, _buttonWithLinkCTA, _imageContainer;

  return {
    primaryButtonWrapper: {
      marginRight: theme.spacing(2)
    },
    btnLinkWrapper: (_btnLinkWrapper = {
      marginRight: theme.spacing(3)
    }, _defineProperty(_btnLinkWrapper, theme.breakpoints.up('sm'), {
      maxWidth: theme.spacing(41)
    }), _defineProperty(_btnLinkWrapper, '& .linkWrapper', {
      marginTop: 0
    }), _btnLinkWrapper),
    card: _defineProperty({
      borderRadius: theme.spacing(2),
      padding: theme.spacing(3, 2)
    }, theme.breakpoints.up('sm'), {
      borderRadius: theme.spacing(3),
      padding: theme.spacing(6)
    }),
    cardWithLinkCTA: (_cardWithLinkCTA = {
      padding: theme.spacing(3, 2, 3)
    }, _defineProperty(_cardWithLinkCTA, theme.breakpoints.up('md'), {
      padding: theme.spacing(6)
    }), _defineProperty(_cardWithLinkCTA, '& .linkWrapper', {
      marginTop: 0
    }), _defineProperty(_cardWithLinkCTA, '& .firstsimplelink', _defineProperty({}, theme.breakpoints.down('xs'), {
      paddingTop: theme.spacing(0)
    })), _cardWithLinkCTA),
    articleBody: _defineProperty({
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: '0'
    }, theme.breakpoints.up('sm'), {
      marginTop: theme.spacing(8),
      marginBottom: theme.spacing(8)
    }),
    snippetTitle: _defineProperty({
      marginBottom: theme.spacing(1),
      fontWeight: theme.typography.fontWeights.bold
    }, theme.breakpoints.down('sm'), {
      lineHeight: theme.typography.pxToRem(25),
      fontSize: theme.typography.pxToRem(20)
    }),
    simpleLink: {
      alignItems: 'start',
      marginLeft: '-4px',
      '& .startIcon': {
        paddingTop: '2px'
      },
      '&:hover': {
        textDecoration: 'none'
      },
      '& a': {
        textDecoration: 'none'
      }
    },
    buttonSection: {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        height: '40px',
        overflow: 'visible',
        cursor: 'pointer',
        maxWidth: 'initial',
        maxHeight: 'initial'
      },
      '& .app-store': {
        display: 'inline-flex',
        '& svg': {
          width: '120px'
        }
      },
      '& .google-play': {
        display: 'inline-flex',
        '& svg': {
          width: '135px'
        }
      }
    },
    buttonWithStoreCTA: {
      marginTop: theme.spacing(3),
      '& >div': {
        display: 'inline-flex'
      }
    },
    buttonWithLinkCTA: (_buttonWithLinkCTA = {
      marginTop: theme.spacing(3)
    }, _defineProperty(_buttonWithLinkCTA, theme.breakpoints.down('sm'), {
      flexDirection: 'column',
      '& $btnLinkWrapper:last-child': {
        paddingTop: theme.spacing(2)
      }
    }), _defineProperty(_buttonWithLinkCTA, '& a.MuiButton-rootBtn, button.MuiButton-rootBtn', {
      minWidth: theme.spacing(15)
    }), _defineProperty(_buttonWithLinkCTA, '&.left .linkWrapper', _defineProperty({}, theme.breakpoints.down('md'), {
      justifyContent: 'flex-start'
    })), _buttonWithLinkCTA),
    imageContainer: (_imageContainer = {}, _defineProperty(_imageContainer, theme.breakpoints.down('lg'), {
      justifyContent: 'center'
    }), _defineProperty(_imageContainer, '& .fallbackPic, .image', {
      borderRadius: theme.spacing(1)
    }), _imageContainer),
    imageGrid: _defineProperty({}, theme.breakpoints.up('sm'), {
      paddingRight: theme.spacing(2)
    }),
    image: _defineProperty({
      marginBottom: theme.spacing(3),
      '& img': {
        borderRadius: theme.spacing(1)
      }
    }, theme.breakpoints.up('sm'), {
      marginBottom: '0'
    }),
    snippetWithImage: _defineProperty({}, theme.breakpoints.up('sm'), {
      marginLeft: theme.spacing(1)
    })
  };
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var COMPONENT_CONTAINER$4 = 'ContentSnippet-Container';
var COMPONENT_SECTION = 'ContentSnippet-Section';
var CONTENT_SNIPPET_IMAGE = 'ContentSnippet-image';
var CONTENT_SNIPPET_TITLE = 'ContentSnippet-title';
var CONTENT_SNIPPET_DESCRIPTION = 'ContentSnippet-Description';

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$q = {
  /* Styles applied to the root element. */
  root: {
    overflow: 'hidden'
  },
  cardHover: {
    '&:hover': {
      boxShadow: '0 6px 8px 0 rgba(0,0,0,0.2)'
    }
  }
};

var _excluded$1 = ["hasBorderRadius", "hasElevateMotion", "hasBoxShadowHover", "color", "classes"];
var useStyles$z = makeStyles(styles$q);
/**
 * Contains content and actions about a single subject.
 * These should be easy to scan for relevant and actionable information.
 * Elements, like text and images, should be placed on them in a way that clearly indicates hierarchy.
 *
 * It recieves a ref and forwards it to child
 *
 * It uses following props -
 * @param {boolean} hasBorderRadius - If true, get the class to be applied for border radius
 *        Default value is true
 * @param {boolean} hasElevateMotion - If true, add the motion elevate class. Default value is true
 * @param {boolean} hasBoxShadowHover - If true, add shadow on hover Default value is true
 * @param {string} color - Color pallete applying style. Default value is 'white'
 * @param {object} classes - To override or extend the styles applied to the component.
 *        Default value is inheritClasses
 * @param {string} className -  Name of the class
 * @param {boolean} square - If true, rounded corners are disabled, default value is false
 * @param {number} elevation - Shadow depth, corresponds to dp in the spec.
 *        It accepts values between 0 and 24 inclusive, default value is 1
 *
 */

var FwdCard = /*#__PURE__*/React__default.forwardRef(function FwdCard(_ref, ref) {
  var _ref$hasBorderRadius = _ref.hasBorderRadius,
      hasBorderRadius = _ref$hasBorderRadius === void 0 ? true : _ref$hasBorderRadius,
      _ref$hasElevateMotion = _ref.hasElevateMotion,
      hasElevateMotion = _ref$hasElevateMotion === void 0 ? true : _ref$hasElevateMotion,
      _ref$hasBoxShadowHove = _ref.hasBoxShadowHover,
      hasBoxShadowHover = _ref$hasBoxShadowHove === void 0 ? true : _ref$hasBoxShadowHove,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'white' : _ref$color,
      inheritClasses = _ref.classes,
      props = _objectWithoutProperties(_ref, _excluded$1);

  var classes = useStyles$z();
  return /*#__PURE__*/React__default.createElement(Card, _extends({
    ref: ref,
    className: clsx("bg-color-".concat(color), hasBorderRadius ? getBorderRadius('medium') : '', hasElevateMotion ? 'motionElevate' : '', hasBoxShadowHover ? classes.cardHover : '', classes.root, inheritClasses),
    square: false,
    elevation: 0
  }, props));
});

// import {
//   getFormModalState,
//   getProductDetails,
// } from '../../pages/ProductDetailPage/redux/selectors';

var useStyles$y = makeStyles(styles$r);

var ContentSnippetComponent = function ContentSnippetComponent(props) {
  var classes = useStyles$y();
  var params = props.params || {};
  var anchorText = get$1(props, "params.anchorText", "Content-Snippet").replace(/\s+/g, "-");
  var backgroundColor = get$1(props, "params.backgroundColor", "white-orange") || "white-orange";
  var isArticleBody = !!get$1(props, "params.isArticleBody", false);
  var title = get$1(props, "fields.title.value", "");
  var description = get$1(props, "fields.description.value", "");
  var image = get$1(props, "fields.image", "");
  var mobileImage = get$1(props, "fields.mobileImage", "");
  var hasDividerLine = !!parseInt(get$1(props, "params.divider", "0"), 10);
  var isImage = !isEmpty(image.value) || !isEmpty(mobileImage.value);

  var _getColors = getColors(backgroundColor),
      bgColor = _getColors.bgColor,
      surfaceColor = _getColors.surfaceColor;

  var isStoreIcons = function isStoreIcons(mode) {
    /* istanbul ignore else */
    if (mode.toLowerCase() === "ios" || mode.toLowerCase() === "android") {
      return true;
    }

    return false;
  };

  var pageEditing = get$1(props, "pageEditing", false);
  var gaCategoryName = get$1(props, "fields.gaLabelName.value") || null;
  var primaryButtonMode = get$1(props, "fields.buttonMode.fields.value.value", "");
  var primaryButtonLink = get$1(props, "fields.link.value.text", "");
  var isPrimaryStoreMode = isStoreIcons(primaryButtonMode); // secondary Button

  var secondaryButtonMode = get$1(props, "fields.secondaryLinkButtonMode.fields.value.value", "");
  var secondaryButtonLink = get$1(props, "fields.secondaryLink.value.text", "");
  var isSecondaryStoreMode = isStoreIcons(secondaryButtonMode);
  var isMobileWidth = useMediaQuery("(max-width:".concat(breakpoints.values.sm, "px)"));

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalState = _useState2[0],
      setModalState = _useState2[1];

  var closeModalHandler = function closeModalHandler() {
    if (get$1(props, "fields.link.value.linktype", "") === "form") {
      props.updateFormModalState({
        formModalState: false
      });
    } else {
      setModalState(false);
    }
  };

  return /*#__PURE__*/React__default.createElement(Container$1, {
    id: anchorText,
    background: bgColor,
    "data-locator": COMPONENT_CONTAINER$4,
    className: clsx(hasDividerLine ? "component-divider-".concat(bgColor) : "", !isArticleBody ? getPaddingString(params) : classes.articleBody)
  }, /*#__PURE__*/React__default.createElement(FwdCard, {
    elevation: 0,
    "data-locator": COMPONENT_SECTION,
    color: surfaceColor,
    classes: clsx(classes.card, _defineProperty({}, classes.cardWithLinkCTA, !isPrimaryStoreMode && !isSecondaryStoreMode && (!isEmpty(primaryButtonLink) || !isEmpty(secondaryButtonLink)))),
    hasBoxShadowHover: false,
    hasElevateMotion: false
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    className: isImage ? classes.imageContainer : ""
  }, isImage && /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 12,
    sm: 5,
    md: 4,
    className: classes.imageGrid
  }, /*#__PURE__*/React__default.createElement(Picture, {
    "data-locator": CONTENT_SNIPPET_IMAGE,
    media: {
      image: image,
      mobileImage: mobileImage,
      aspectRatio: {
        mobile: "3-1",
        tablet: "16-9",
        desktop: "3-1"
      }
    },
    critical: true,
    hasBorderRadius: false,
    className: classes.image
  })), /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 12,
    sm: isImage ? 7 : 12,
    md: isImage ? 8 : 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: isImage ? classes.snippetWithImage : ""
  }, !isEmpty(title) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h5",
    component: "h3",
    color: surfaceColor,
    className: classes.snippetTitle,
    fontWeight: "bolder",
    "data-locator": CONTENT_SNIPPET_TITLE
  }, title), !isEmpty(description) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    color: surfaceColor,
    "data-locator": CONTENT_SNIPPET_DESCRIPTION,
    type: "richtext"
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description
    }
  })), (!isEmpty(primaryButtonLink) || !isEmpty(secondaryButtonLink)) && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.buttonSection, (isEmpty(primaryButtonLink) || !primaryButtonMode || primaryButtonMode === "SimpleLink") && (isEmpty(secondaryButtonLink) || !secondaryButtonMode || secondaryButtonMode === "SimpleLink") ? "left" : "center", isPrimaryStoreMode || isSecondaryStoreMode ? classes.buttonWithStoreCTA : classes.buttonWithLinkCTA)
  }, /*#__PURE__*/React__default.createElement(ContentLinks, {
    isMobileWidth: isMobileWidth,
    updateFormInitializer: props.updateFormInitializer,
    bgColor: bgColor,
    surfaceColor: surfaceColor,
    gaCategoryName: gaCategoryName,
    fields: props.fields,
    setModalState: setModalState,
    modalState: modalState,
    updateFormModalState: props.updateFormModalState,
    closeModalHandler: closeModalHandler,
    language: props.sitecoreContext.languageCode || props.sitecoreContext.language,
    updateFormLinks: props.updateFormLinks,
    IsMerge: 0,
    appInSession: props.appInSession,
    hasSessionPopups: props.hasSessionPopups,
    isFeatured: false,
    pageEditing: pageEditing,
    routeData: get$1(props, "sitecoreContext.route", {}),
    updateGroupEnquiryData: props.updateGroupEnquiryData
  })))))));
};

var ContentSnippet$1 = ContentSnippetComponent; // const mapDispatchToProps = dispatch => {

var styles$p = function styles(theme) {
  var _contentTitle, _ul, _descriptionBox, _imageListContainer, _tabsContentWrapperMo;

  var colors = theme.palette.colors || {};
  var bgColors = {};
  Object.keys(colors).forEach(function (color) {
    /** For Default */
    bgColors["active-tab-bg-".concat(color)] = {
      backgroundColor: "".concat(colors[color].contrastTextAction, " !important"),
      color: colors[color].main,
      '&.tabHeadingWrapper.Mui-expanded': {
        minHeight: 'unset',
        border: 'none'
      },
      '& .MuiIconButton-root.Mui-expanded': {
        backgroundColor: colors[color].main,
        '& path': {
          fill: colors[color].contrastTextAction
        }
      },
      '& .Mui-expanded': {
        '& .tabHeading, .ordering': {
          color: colors[color].main
        }
      }
    };
    bgColors["tab-border-".concat(color)] = {
      border: "1px solid ".concat(colors[color].line.divider),
      borderBottom: 'none',
      '&:last-child': {
        '& .tabHeadingWrapper': {
          borderBottom: "1px solid ".concat(colors[color].line.divider)
        }
      },
      '& .tabHeading': {
        color: colors[color].contrastText
      },
      '& .ordering': {
        color: colors[color].contrastTextLabel
      }
    };
    bgColors["expansion-panel-root-".concat(color)] = {
      boxShadow: 'none',
      '&.Mui-expanded': {
        margin: 0,
        '& .tabHeadingWrapper': {
          borderBottom: 'none'
        }
      },
      '& .MuiCollapse-container': {
        backgroundColor: colors[color].tabsBackground,
        borderRight: "1px solid ".concat(colors[color].line.divider),
        borderLeft: "1px solid ".concat(colors[color].line.divider)
      },
      '&:last-child': {
        '& .tabHeadingWrapper': {
          borderBottom: "1px solid ".concat(colors[color].line.divider)
        },
        '& .tabHeadingWrapper.Mui-expanded.MuiButtonBase-root.MuiExpansionPanelSummary-root': {
          borderRadius: 0
        },
        '& .MuiCollapse-container': {
          borderBottom: "1px solid ".concat(colors[color].line.divider)
        }
      },
      '& .MuiIconButton-root': {
        backgroundColor: colors[color].contrastTextAction,
        '& path': {
          fill: colors[color].main
        }
      }
    };
    bgColors["tabsContentWrapperMobile-".concat(color)] = {
      '& .MuiExpansionPanel-root:before': {
        backgroundColor: get$1(theme.palette.colors[color], 'main', '#FFFFFF')
      },
      '& .tabHeadingWrapper': {
        '&.MuiExpansionPanelSummary-root': {
          backgroundColor: get$1(theme.palette.colors[color], 'main', '#FFFFFF'),
          '&.Mui-expanded': {
            backgroundColor: get$1(theme.palette.colors[color], 'contrastTextAction', '#E87722')
          }
        }
      }
    };
  });
  return _objectSpread2(_objectSpread2({}, bgColors), {}, {
    container: {
      '& .MuiCollapse-container': {
        transition: "height ".concat(timings.smaller, " ").concat(transitionFunction.easeOut, " !important")
      },
      '& .MuiCollapse-container.MuiCollapse-entered': {
        opacity: 1,
        transition: "opacity ".concat(timings.small, " ").concat(transitionFunction.easeInOut, " !important")
      }
    },
    filterTitle: _defineProperty({
      fontWeight: theme.typography.fontWeights.bolder,
      marginBottom: theme.spacing(6)
    }, theme.breakpoints.up('sm'), {
      marginBottom: theme.spacing(8)
    }),
    headerTitle: {
      fontWeight: theme.typography.fontWeights.bolder,
      marginBottom: theme.spacing(3)
    },
    description: _defineProperty({
      marginBottom: theme.spacing(6)
    }, theme.breakpoints.up('sm'), {
      marginBottom: theme.spacing(8)
    }),
    title: {
      fontWeight: theme.typography.fontWeights.bolder
    },
    spacer: {
      width: theme.spacing(1)
    },
    dropdown: {
      fontWeight: theme.typography.fontWeights.bold,
      width: 'auto',
      maxWidth: '100%',
      '& .MuiSelect-selectMenu.MuiSelect-selectMenu': {
        padding: theme.spacing(0, 3.5, 0, 0)
      },
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        __expression__: 'all and (-ms-high-contrast: none), (-ms-high-contrast: active)',
        display: 'inline-table'
      }
    },
    dropdownLarge: _defineProperty({
      fontSize: theme.typography.pxToRem(31),
      lineHeight: theme.typography.pxToRem(49),
      height: theme.typography.pxToRem(49)
    }, theme.breakpoints.up('sm'), {
      maxWidth: theme.spacing(75),
      fontSize: theme.typography.pxToRem(39),
      lineHeight: theme.typography.pxToRem(56),
      height: theme.typography.pxToRem(56)
    }),
    dropdownSmall: _defineProperty({
      fontSize: theme.typography.pxToRem(20),
      lineHeight: theme.typography.pxToRem(40),
      height: theme.typography.pxToRem(40)
    }, theme.breakpoints.up('sm'), {
      maxWidth: theme.spacing(75),
      fontSize: theme.typography.pxToRem(25),
      lineHeight: theme.typography.pxToRem(42),
      height: theme.typography.pxToRem(42)
    }),
    titleWrapper: _defineProperty({
      marginBottom: theme.spacing(6),
      '& h2': {
        fontWeight: theme.typography.fontWeights.bolder
      }
    }, theme.breakpoints.up('sm'), {
      marginBottom: theme.spacing(8)
    }),
    blankGrid: _defineProperty({
      display: 'none'
    }, theme.breakpoints.up('sm'), {
      display: 'block'
    }),
    contentContainer: {
      animation: animations.fadeIn
    },
    tabContentTitle: {
      lineHeight: theme.typography.pxToRem(24),
      letterSpacing: 0
    },
    tabContentLink: {
      position: 'static',
      display: 'inline-flex',
      lineHeight: 'normal',
      '& .startIcon': {
        marginRight: 0
      }
    },
    tabContentDivider: {
      margin: theme.spacing(3, 0, 0, 0)
    },
    contentInner: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    contentTitle: (_contentTitle = {
      marginTop: theme.spacing(3)
    }, _defineProperty(_contentTitle, theme.breakpoints.up('sm'), {
      marginTop: theme.spacing(6)
    }), _defineProperty(_contentTitle, '&:first-child', {
      marginTop: 0
    }), _defineProperty(_contentTitle, '&+$descriptionBox', _defineProperty({
      marginTop: 0
    }, theme.breakpoints.up('sm'), {
      marginTop: theme.spacing(1)
    })), _contentTitle),
    contentLink: {
      '&:first-child': {
        marginTop: 0
      },
      '& $contentInner': {
        alignItems: 'center',
        margin: theme.spacing(-0.5, 0)
      },
      '&+$descriptionBox': _defineProperty({
        marginTop: theme.spacing(1)
      }, theme.breakpoints.up('sm'), {
        marginTop: theme.spacing(1)
      }),
      '&+$contentLink': {
        marginTop: theme.spacing(3)
      }
    },
    descriptionBox: (_descriptionBox = {
      '&:first-child': {
        marginTop: '0'
      },
      marginTop: theme.spacing(3)
    }, _defineProperty(_descriptionBox, theme.breakpoints.up('sm'), {
      marginTop: theme.spacing(6)
    }), _defineProperty(_descriptionBox, '& strong', {
      display: 'inline-block',
      marginBottom: theme.spacing(1),
      lineHeight: theme.typography.pxToRem(20)
    }), _defineProperty(_descriptionBox, '&.MuiTypography-root', {
      '& p': {
        margin: 0,
        fontFamily: 'inherit'
      }
    }), _defineProperty(_descriptionBox, '& ul', (_ul = {
      margin: 0,
      marginBottom: theme.spacing(6),
      paddingLeft: theme.spacing(3)
    }, _defineProperty(_ul, theme.breakpoints.down('sm'), {
      marginBottom: theme.spacing(3)
    }), _defineProperty(_ul, '& li', {
      paddingLeft: theme.spacing(0.5)
    }), _defineProperty(_ul, '& ul', {
      margin: 0
    }), _ul)), _defineProperty(_descriptionBox, '& ol', {
      margin: 0,
      marginTop: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      '& li': {
        paddingLeft: theme.spacing(2)
      }
    }), _defineProperty(_descriptionBox, '&+$imageListContainer', _defineProperty({}, theme.breakpoints.up('sm'), {
      marginTop: theme.spacing(3.5)
    })), _descriptionBox),
    imageListContainer: (_imageListContainer = {
      '&:first-child': {
        marginTop: '0'
      },
      marginTop: theme.spacing(2)
    }, _defineProperty(_imageListContainer, theme.breakpoints.up('sm'), {
      marginTop: theme.spacing(4.5)
    }), _defineProperty(_imageListContainer, '& .MuiGrid-root', _defineProperty({}, theme.breakpoints.down('sm'), {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    })), _imageListContainer),
    imageBoxWrapper: {
      display: 'flex',
      '& .imageWrapper': {
        minWidth: theme.spacing(8),
        minHeight: theme.spacing(8),
        '& .fallbackPic': {
          backgroundSize: '80%'
        }
      },
      '& .imageContentWrapper': {
        marginLeft: theme.spacing(2),
        '& .title': {
          marginBottom: theme.spacing(0.25)
        },
        '& .description': {
          '& p': {
            margin: 0,
            fontFamily: 'inherit'
          }
        }
      }
    },
    tabsContentWrapperDesktop: _defineProperty({
      display: 'none'
    }, theme.breakpoints.up('sm'), {
      display: 'block'
    }),
    tabsContentWrapperMobile: (_tabsContentWrapperMo = {
      display: 'block'
    }, _defineProperty(_tabsContentWrapperMo, theme.breakpoints.up('sm'), {
      display: 'none'
    }), _defineProperty(_tabsContentWrapperMo, '& .MuiExpansionPanel-root', {
      border: 'none'
    }), _defineProperty(_tabsContentWrapperMo, '& .MuiExpansionPanelDetails-root', {
      padding: theme.spacing(3, 1.875, 6),
      flexDirection: 'column'
    }), _defineProperty(_tabsContentWrapperMo, '& .tabHeadingWrapper', {
      padding: theme.spacing(0, 2),
      borderBottom: 0,
      position: 'sticky',
      top: 0,
      minHeight: 'inherit',
      '& .MuiExpansionPanelSummary-content': {
        margin: theme.spacing(2, 2, 2, 0)
      },
      '& .MuiExpansionPanelSummary-expandIcon': {
        '& svg': {
          width: theme.spacing(2),
          height: theme.spacing(2)
        },
        transition: "background-color ".concat(timings.large, " ").concat(transitionFunction.easeOut, " !important")
      },
      '&::before': {
        content: '""',
        height: '1px',
        width: 'calc(100% - 32px)',
        position: 'absolute',
        bottom: '0'
      },
      '&.Mui-expanded::before': {
        content: 'none'
      },
      '&$headerVisible': _defineProperty({
        top: theme.spacing(7)
      }, theme.breakpoints.up('lg'), {
        top: theme.spacing(9)
      })
    }), _defineProperty(_tabsContentWrapperMo, '& .MuiIconButton-edgeEnd', {
      margin: 0,
      width: theme.spacing(3),
      height: theme.spacing(3)
    }), _defineProperty(_tabsContentWrapperMo, '& .tabHeading', {
      display: 'flex',
      marginBottom: 0
    }), _defineProperty(_tabsContentWrapperMo, '& .expansion-panel-root', {
      '&:first-child': {
        '& .tabHeadingWrapper': {
          borderRadius: theme.spacing(2, 2, 0, 0),
          '&.isStickyHead': {
            borderRadius: '0'
          }
        }
      },
      '&:last-child': {
        '& .tabHeadingWrapper, &.Mui-expanded .MuiCollapse-container': {
          borderRadius: theme.spacing(0, 0, 2, 2)
        }
      }
    }), _defineProperty(_tabsContentWrapperMo, '& .isStickyHead.Mui-expanded', {
      margin: theme.spacing(0, -2),
      padding: theme.spacing(0, 4),
      borderRadius: '0',
      boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
      transition: "all ".concat(timings.large, " ").concat(transitionFunction.easeIn)
    }), _tabsContentWrapperMo),
    listSpacer: _defineProperty({
      marginBottom: theme.spacing(3)
    }, theme.breakpoints.up('sm'), {
      marginBottom: theme.spacing(6)
    }),
    ordering: {},
    headerVisible: {}
  });
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var COMPONENT_TABS_WRAPPER = 'TabContent-Tabs-Wrapper';
var COMPONENT_TITLE$7 = 'TabContent-Title';
var COMPONENT_TABS_WRAPPER_DESKTOP = 'TabContent-Tabs-Wrapper-Desktop';
var COMPONENT_TAB_WRAPPER = 'TabContent-Tab-Wrapper';
var COMPONENT_TAB_BUTTON = 'TabContent-Tab-BUTTON';
var COMPONENT_TAB_TITLE = 'TabContent-Tab-Title';
var COMPONENT_TAB_PLUS_ICON = 'TabContent-Tab-Plus-Icon';
var COMPONENT_TAB_MINUS_ICON = 'TabContent-Tab-Minus-Icon';
var COMPONENT_TAB_CONTENT_WRAPPER = 'TabContent-Tab-Content-Wrapper';
var COMPONENT_TAB_CONTENT_TITLE = 'TabContent-Tab-Content-Title';
var COMPONENT_TAB_CONTENT_LINK = 'TabContent-Tab-Content-Link';
var COMPONENT_TAB_CONTENT_DIVIDER = 'TabContent-Tab-Content-Divider';
var COMPONENT_TAB_CONTENT_DESC = 'TabContent-Tab-Content-Description';
var COMPONENT_TAB_CONTENT_IMAGE = 'TabContent-Tab-Content-Image';
var COMPONENT_TAB_CONTENT_IMAGE_TITLE = 'TabContent-Tab-Content-Image-Title';
var COMPONENT_TAB_CONTENT_IMAGE_DESCRIPTION = 'TabContent-Tab-Content-Image-Description';
var COMPONENT_TAB_CONTENT_HEADER_TITLE = 'ClaimCardList-Header-title';
var COMPONENT_TAB_CONTENT_HEADER_SUB_TITLE = 'ClaimCardList-Header-Sub-title';
var COMPONENT_TAB_CONTENT_HEADER_DESCRIPTION = 'ClaimCardList-Header-description';
var COMPONENT_TAB_CONTENT_FILTER = 'ClaimCardList-Filter';

var useStyles$x = makeStyles(styles$p);

var Tabcontent = function Tabcontent(props) {
  var _props$params = props.params,
      params = _props$params === void 0 ? {} : _props$params,
      _props$filterContent = props.filterContent,
      filterContent = _props$filterContent === void 0 ? [] : _props$filterContent,
      _props$fields = props.fields,
      fields = _props$fields === void 0 ? {} : _props$fields,
      _props$tabTitle = props.tabTitle,
      tabTitle = _props$tabTitle === void 0 ? {} : _props$tabTitle,
      _props$tabSubTitle = props.tabSubTitle,
      tabSubTitle = _props$tabSubTitle === void 0 ? {} : _props$tabSubTitle,
      _props$tabDescription = props.tabDescription,
      tabDescription = _props$tabDescription === void 0 ? {} : _props$tabDescription,
      _props$handleFilterIn = props.handleFilterIndex,
      handleFilterIndex = _props$handleFilterIn === void 0 ? function () {} : _props$handleFilterIn;
  var backgroundColor = get$1(props, "params.backgroundColor", "white");

  var _getColors = getColors(backgroundColor),
      color = _getColors.bgColor;

  var classes = useStyles$x({
    color: color
  });
  var isTabFilter = (params === null || params === void 0 ? void 0 : params.isTabFilter) === "1" ? true : false;
  var identifier = (params === null || params === void 0 ? void 0 : params.isTabFilter) === "1" ? get$1(props, "uid", "") : get$1(props, "rendering.uid", "Vertical-Tab-Content");
  var isHeaderTitle = tabTitle && tabTitle.value || tabDescription && tabDescription.value;
  var dividerLine = params.divider ? params.divider : "0";
  var ordering = (params === null || params === void 0 ? void 0 : params.tabVariant) === "numbered" ? true : false;
  var flexiCol = props.flexiCol && parseInt(props.flexiCol) || null;
  var title = get$1(props, "fields.title", "");
  var isMobile = useMediaQuery("(max-width:".concat(breakpoints.values.sm, "px)"));
  var sectionContent = fields && fields.Children;
  sectionContent = sectionContent && sectionContent.filter(function (content) {
    return get$1(content, "fields.title.value", null);
  });
  var gaCategoryName = get$1(props, "fields.gaCategoryName.value", null);
  var headerVisible = get$1(props, "headerVisible", null);
  /* states */

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeTabIndex = _useState2[0],
      setActiveTabIndex = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      expandedTabIndex = _useState4[0],
      setExpandedTabIndex = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      elementAtTopIndex = _useState6[0],
      setElementAtTopIndex = _useState6[1];

  var _useState7 = useState(filterContent.length > 0 && filterContent[0].displayName),
      _useState8 = _slicedToArray(_useState7, 2),
      currentClaimType = _useState8[0],
      setClaimType = _useState8[1];

  var isFilterRow = tabSubTitle && tabSubTitle.value || currentClaimType && filterContent.length > 1;

  var handleClaimType = function handleClaimType(value) {
    var index = filterContent.findIndex(function (element) {
      return element.displayName === value;
    });
    var sectionIndex = index > -1 ? index : 0;
    setClaimType(value);
    handleFilterIndex(sectionIndex);
    setActiveTabIndex(0);
  };

  var handleScroll = function handleScroll() {
    var panels = document.querySelectorAll("div[data-locator=\"".concat(COMPONENT_TAB_WRAPPER, "\"]"));
    var topIndex = null;
    panels.forEach(function (element) {
      if (element.getBoundingClientRect().top < 0 && element.id) {
        topIndex = element.getAttribute("data-index");
      }
    });
    setElementAtTopIndex(topIndex);
  };

  useEffect(function () {
    if (typeof window !== "undefined" && isMobile) {
      window.removeEventListener("scroll", handleScroll);
      window.addEventListener("scroll", handleScroll);
    }

    return function () {
      if (typeof window !== "undefined") {
        window.removeEventListener("scroll", handleScroll);
      }
    };
  }, [isMobile]);

  var renderTabContent = function renderTabContent(_sectionContent) {
    var _sectionContentItem = get$1(_sectionContent, "fields.Children", []);

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, _sectionContentItem.map(function (item, index) {
      var _clsx;

      var isNotLast = _sectionContentItem.length > 1 && index !== _sectionContentItem.length - 1;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (get$1(item, "fields.title.value", null) || get$1(item, "fields.link.value.href", null)) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: clsx((_clsx = {}, _defineProperty(_clsx, classes.contentTitle, !!get$1(item, "fields.title.value", null) && !get$1(item, "fields.link.value.href", null)), _defineProperty(_clsx, classes.contentLink, !!get$1(item, "fields.link.value.href", null)), _clsx))
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classes.contentInner
      }, get$1(item, "fields.title.value", null) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        variant: "button",
        component: "div",
        className: classes.tabContentTitle,
        "data-locator": COMPONENT_TAB_CONTENT_TITLE,
        color: color
      }, /*#__PURE__*/React__default.createElement("span", null, item.fields.title.value)), get$1(item, "fields.link.value.href", null) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        variant: "body1",
        component: "div",
        color: color
      }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
        component: "a",
        icon: get$1(item, "fields.buttonIcon.fields.value.value", null),
        href: get$1(item, "fields.link.value.href", "null"),
        target: get$1(item, "fields.link.value.linktype", "") === "internal" ? "_self" : get$1(item, "fields.link.value.target", "") || "_blank",
        underline: "none",
        color: color,
        className: classes.tabContentLink,
        "data-locator": COMPONENT_TAB_CONTENT_LINK,
        onClick: function onClick() {
          return PushEvent({
            event: "buttonClick",
            buttonTitle: get$1(item, "fields.linkGALabelName.value", "") || getGTMSharedKeyVal(get$1(item, "fields.link.value.href", "null"), COMPONENT_TAB_CONTENT_LINK),
            componentName: gaCategoryName ? gaCategoryName : COMPONENT_TAB_CONTENT_LINK,
            destinationUrl: get$1(item, "fields.link.value.href", "null")
          });
        },
        ariaLabel: "download link"
      }, get$1(item, "fields.link.value.text", null)))), get$1(item, "fields.link.value.href", null) && /*#__PURE__*/React__default.createElement(Divider, {
        className: classes.tabContentDivider,
        "data-locator": COMPONENT_TAB_CONTENT_DIVIDER
      }))), get$1(item, "fields.description.value", "null") && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        variant: "body1",
        component: "div",
        className: clsx(classes.descriptionBox, _defineProperty({}, classes.listSpacer, isNotLast)),
        "data-locator": COMPONENT_TAB_CONTENT_DESC,
        color: color,
        type: "richtext"
      }, /*#__PURE__*/React__default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: item.fields.description.value
        }
      })), item.fields.Children && renderImageComponent(item.fields.Children, isNotLast));
    }));
  };

  var renderImageComponent = function renderImageComponent(images, isNotLast) {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      container: true,
      spacing: 3,
      className: clsx(classes.imageListContainer, _defineProperty({}, classes.listSpacer, isNotLast))
    }, images && images.map(function (image, index) {
      return /*#__PURE__*/React__default.createElement(StyledGrid, {
        key: "image-".concat(index),
        item: true,
        xs: 12,
        sm: 6
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classes.imageBoxWrapper,
        "data-locator": COMPONENT_TAB_CONTENT_DESC
      }, /*#__PURE__*/React__default.createElement("div", {
        className: clsx("imageWrapper")
      }, /*#__PURE__*/React__default.createElement(Picture, {
        media: {
          image: image.fields.image,
          mobileImage: image.fields.mobileImage,
          aspectRatio: {
            mobile: "1-1",
            desktop: "1-1",
            tablet: "1-1"
          }
        },
        "data-locator": COMPONENT_TAB_CONTENT_IMAGE,
        hasBorderRadius: true,
        borderRadiusOption: "small"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "imageContentWrapper"
      }, get$1(image, "fields.title", null) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        "data-locator": COMPONENT_TAB_CONTENT_IMAGE_TITLE,
        variant: "h5A",
        component: "div",
        className: "title",
        color: color
      }, image.fields.title.value), get$1(image, "fields.description", null) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        "data-locator": COMPONENT_TAB_CONTENT_IMAGE_DESCRIPTION,
        variant: "body1",
        component: "div",
        className: "description",
        color: color,
        type: "richtext"
      }, /*#__PURE__*/React__default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: image.fields.description.value
        }
      })))));
    }));
  };

  var changeTabHandler = function changeTabHandler(event, newValue) {
    var _sectionContent$newVa, _sectionContent$newVa2, _sectionContent$newVa3;

    PushEvent({
      event: "buttonClick",
      buttonTitle: ((_sectionContent$newVa = sectionContent[newValue]) === null || _sectionContent$newVa === void 0 ? void 0 : (_sectionContent$newVa2 = _sectionContent$newVa.fields) === null || _sectionContent$newVa2 === void 0 ? void 0 : (_sectionContent$newVa3 = _sectionContent$newVa2.gaLabelName) === null || _sectionContent$newVa3 === void 0 ? void 0 : _sectionContent$newVa3.value) || getGTMSharedKeyVal(undefined, COMPONENT_TAB_TITLE),
      componentName: gaCategoryName ? gaCategoryName : COMPONENT_TAB_TITLE,
      destinationUrl: undefined
    });
    setActiveTabIndex(newValue);
  };

  var changeHandler = function changeHandler(number, item) {
    PushEvent({
      event: "buttonClick",
      buttonTitle: item || getGTMSharedKeyVal(undefined, COMPONENT_TAB_TITLE),
      componentName: gaCategoryName ? gaCategoryName : COMPONENT_TAB_TITLE,
      destinationUrl: undefined
    });

    var expandedTabIndexUpdated = _toConsumableArray(expandedTabIndex);

    if (expandedTabIndexUpdated.indexOf(number) !== -1) {
      expandedTabIndexUpdated.splice(expandedTabIndexUpdated.indexOf(number), 1);
    } else {
      expandedTabIndexUpdated.push(number);
    }

    setExpandedTabIndex(expandedTabIndexUpdated);
  };

  return /*#__PURE__*/React__default.createElement(Container$1, {
    useContainer: !flexiCol,
    background: color,
    className: clsx(getPaddingString(params), dividerLine === "1" ? "component-divider-".concat(color) : "", classes.container)
  }, isTabFilter ? /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 12,
    sm: 8
  }, tabTitle && tabTitle.value && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h2",
    component: "h2",
    "data-locator": COMPONENT_TAB_CONTENT_HEADER_TITLE,
    color: color,
    className: classes.headerTitle
  }, tabTitle.value), tabDescription && tabDescription.value && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    "data-locator": COMPONENT_TAB_CONTENT_HEADER_DESCRIPTION,
    variant: "body1",
    component: "p",
    className: classes.description,
    color: color,
    type: "richtext"
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: tabDescription.value
    }
  }))), isFilterRow && /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: isHeaderTitle ? "h4" : "h2",
    component: isHeaderTitle ? "h3" : "h2",
    "data-locator": COMPONENT_TAB_CONTENT_HEADER_SUB_TITLE,
    color: color,
    className: classes.filterTitle
  }, tabSubTitle && tabSubTitle.value && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, tabSubTitle.value, /*#__PURE__*/React__default.createElement("span", {
    className: classes.spacer,
    "aria-hidden": "true"
  }, "\xA0")), currentClaimType && filterContent.length > 1 && /*#__PURE__*/React__default.createElement(Dropdown$1, {
    color: color,
    value: currentClaimType,
    onChange: function onChange(e) {
      PushEvent({
        event: "dropdownChange",
        buttonTitle: e.target.value || getGTMSharedKeyVal(undefined, COMPONENT_TAB_CONTENT_FILTER),
        componentName: gaCategoryName ? gaCategoryName : COMPONENT_TAB_CONTENT_FILTER,
        destinationUrl: undefined
      });
      handleClaimType(e.target.value);
    },
    className: clsx(isHeaderTitle ? classes.dropdownSmall : classes.dropdownLarge, classes.dropdown),
    "data-locator": COMPONENT_TAB_CONTENT_FILTER,
    hasBottomLine: true
  }, filterContent.length && filterContent.map(function (item, index) {
    var value = get$1(item, "displayName", null);
    var displayValue = get$1(item, "fields.title.value", null);
    return /*#__PURE__*/React__default.createElement(MenuItem, {
      key: index,
      value: value,
      className: clsx("icon-action-dropDown-white", "showTickIcon", classes.selected)
    }, displayValue, /*#__PURE__*/React__default.createElement("span", {
      className: clsx("icon-action-dropDown-white", "showTickIcon")
    }, /*#__PURE__*/React__default.createElement(Tick, null)));
  }))))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, title && title.value && /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 12,
    sm: 8
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.titleWrapper
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h2",
    component: "h2",
    "data-locator": COMPONENT_TITLE$7,
    color: color
  }, title.value))))), /*#__PURE__*/React__default.createElement("div", {
    className: classes.tabsContentWrapperDesktop,
    "data-locator": COMPONENT_TABS_WRAPPER_DESKTOP
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: false,
    sm: 3
  }, sectionContent && /*#__PURE__*/React__default.createElement(FwdTabs, {
    orientation: "vertical",
    color: color,
    onChange: changeTabHandler,
    value: activeTabIndex,
    componentName: "TabComponent"
  }, sectionContent.map(function (tabItem, index) {
    var _tabItem$id, _tabItem$fields, _tabItem$fields$title;

    return /*#__PURE__*/React__default.createElement(FwdTab, {
      orientation: "vertical",
      key: (_tabItem$id = tabItem === null || tabItem === void 0 ? void 0 : tabItem.id) !== null && _tabItem$id !== void 0 ? _tabItem$id : index,
      label: tabItem === null || tabItem === void 0 ? void 0 : (_tabItem$fields = tabItem.fields) === null || _tabItem$fields === void 0 ? void 0 : (_tabItem$fields$title = _tabItem$fields.title) === null || _tabItem$fields$title === void 0 ? void 0 : _tabItem$fields$title.value,
      ordering: ordering,
      index: index,
      "data-locator": COMPONENT_TAB_BUTTON
    });
  }))), /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: false,
    sm: 1,
    className: classes.blankGrid
  }), /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 12,
    sm: 8,
    className: classes.contentContainer
  }, sectionContent && renderTabContent(sectionContent[activeTabIndex])))), /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.tabsContentWrapperMobile, _defineProperty({}, classes["tabsContentWrapperMobile-".concat(color)], color)),
    "data-locator": COMPONENT_TABS_WRAPPER
  }, sectionContent && sectionContent.map(function (item, index) {
    var _clsx6;

    return /*#__PURE__*/React__default.createElement(ExpansionPanel, {
      key: "expansionPanel-".concat(index),
      expanded: expandedTabIndex.indexOf(index) !== -1,
      onChange: function onChange() {
        return changeHandler(index, get$1(item, "fields.gaLabelName.value", ""));
      },
      "data-locator": COMPONENT_TAB_WRAPPER,
      className: clsx("expansion-panel-root", _defineProperty({}, classes["expansion-panel-root-".concat(color)], color != null)),
      color: color,
      "data-index": "".concat(index).concat(identifier),
      id: "tab-content-".concat(index, "-").concat(identifier, "-header")
    }, /*#__PURE__*/React__default.createElement(FwdExpansionPanelSummary, {
      expandIcon: expandedTabIndex.indexOf(index) !== -1 ? /*#__PURE__*/React__default.createElement(MinusIcon, {
        "data-locator": COMPONENT_TAB_MINUS_ICON
      }) : /*#__PURE__*/React__default.createElement(PlusIcon, {
        "data-locator": COMPONENT_TAB_PLUS_ICON
      }),
      className: clsx("tabHeadingWrapper", (_clsx6 = {}, _defineProperty(_clsx6, classes.headerVisible, "".concat(index).concat(identifier) === elementAtTopIndex && headerVisible), _defineProperty(_clsx6, classes["tab-border-".concat(color)], color != null), _defineProperty(_clsx6, classes["active-tab-bg-".concat(color)], expandedTabIndex.indexOf(index) !== -1), _defineProperty(_clsx6, "isStickyHead", "".concat(index).concat(identifier) === elementAtTopIndex), _clsx6)),
      "data-locator": COMPONENT_TAB_TITLE
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      className: clsx("tabHeading", " motionColorTransition"),
      component: "span",
      variant: "h5A"
    }, ordering && /*#__PURE__*/React__default.createElement("span", {
      className: "ordering"
    }, "".concat(index + 1, "."), "\xA0"), item.fields.title.value)), /*#__PURE__*/React__default.createElement(FwdExpansionPanelDetails, {
      "data-locator": COMPONENT_TAB_CONTENT_WRAPPER
    }, sectionContent && renderTabContent(item)));
  })));
}; // const mapStateToProps = createStructuredSelector({

var TabContentFilter$1 = function TabContentFilter(props) {
  var params = props.params ? props.params : {};
  var tabContentList = get$1(props, 'fields.Children', []);
  var tabTitle = get$1(props, 'fields.header', {});
  var tabSubTitle = get$1(props, 'fields.subheader', {});
  var tabDescription = get$1(props, 'fields.description', {});
  /* states */

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeSectionIndex = _useState2[0],
      setActiveSectionIndex = _useState2[1];

  var fields = get$1(tabContentList, "[".concat(activeSectionIndex, "].fields"), {});
  var uid = get$1(props, 'rendering.uid', 'Vertical-Tab-Content-Filter');
  var sectionProps = {
    params: _objectSpread2(_objectSpread2({}, params), {}, {
      isTabFilter: '1'
    }),
    fields: _objectSpread2({}, fields),
    filterContent: _toConsumableArray(tabContentList),
    tabTitle: tabTitle,
    tabSubTitle: tabSubTitle,
    tabDescription: tabDescription,
    uid: uid
  };

  var handleFilterIndex = function handleFilterIndex(value) {
    setActiveSectionIndex(value);
  };

  return /*#__PURE__*/React__default.createElement(Tabcontent, _extends({}, sectionProps, {
    handleFilterIndex: handleFilterIndex
  }));
};

var styles$o = function styles(theme) {
  var _col, _col2;

  var colors = theme.palette.colors || {};
  var panelColored = {};
  Object.keys(colors).forEach(function (color) {
    panelColored["panelColored-".concat(color)] = {
      '&.Mui-expanded': {
        borderBottomColor: colors[color].contrastTextAction,
        margin: '0',
        minHeight: 'unset'
      },
      '&.MuiExpansionPanel-root:before': {
        display: 'none'
      }
    };
  });
  return _objectSpread2(_objectSpread2({}, panelColored), {}, {
    root: {
      height: '100%',
      display: 'flex',
      position: 'relative',
      flexDirection: 'column',
      '& .MuiPaper-elevation1': {
        boxShadow: 'none'
      },
      '& .MuiCollapse-container': {
        transition: "height ".concat(timings.smaller, " ").concat(transitionFunction.easeOut, " !important")
      },
      '& .MuiCollapse-container.MuiCollapse-entered': {
        opacity: 1,
        transition: "opacity ".concat(timings.small, " ").concat(transitionFunction.easeInOut, " !important")
      },
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        __expression__: 'all and (-ms-high-contrast: none), (-ms-high-contrast: active)',
        display: 'block !important'
      }
    },
    flex1: {
      flex: 1
    },
    col0: (_col = {}, _defineProperty(_col, theme.breakpoints.up('sm'), {
      paddingRight: theme.spacing(2.5),
      '&.flexi': {
        paddingRight: 0
      }
    }), _defineProperty(_col, theme.breakpoints.up('lg'), {
      paddingRight: theme.spacing(6.5),
      '&.flexi': {
        paddingRight: 0
      }
    }), _col),
    col1: (_col2 = {}, _defineProperty(_col2, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(2.5),
      '&.flexi': {
        paddingLeft: 0
      }
    }), _defineProperty(_col2, theme.breakpoints.up('lg'), {
      paddingLeft: theme.spacing(6.5),
      '&.flexi': {
        paddingLeft: 0
      }
    }), _col2),
    faqButtonWrapper: _defineProperty({
      marginTop: theme.spacing(8)
    }, theme.breakpoints.down('sm'), {
      textAlign: 'center',
      marginTop: theme.spacing(6)
    }),
    faqButtonWrapperGrid: _defineProperty({
      marginTop: theme.spacing(8),
      textAlign: 'center'
    }, theme.breakpoints.down('md'), {
      textAlign: 'center',
      marginTop: theme.spacing(6)
    }),
    fluidRoot: {
      '& .MuiPaper-elevation1': {
        boxShadow: 'none'
      }
    },
    question: {
      lineHeight: '24px !important',
      marginTop: '4px !important',
      marginBottom: '4px !important',
      fontWeight: "".concat(theme.typography.fontWeights.bold, " !important")
    },
    answer: {
      fontWeight: theme.typography.fontWeights.normal,
      lineHeight: theme.typography.lineHeight.L7,
      width: '100%',
      paddingBottom: theme.spacing(2),
      paddingRight: theme.spacing(6),
      '& a': {
        lineHeight: '20px'
      }
    },
    summary: {
      padding: '0 0 0 0 !important',
      alignItems: 'flex-start !important',
      '& .MuiExpansionPanelSummary-expandIcon.Mui-expanded': {
        marginTop: '5px'
      },
      '& .MuiExpansionPanelSummary-expandIcon': {
        marginTop: '5px'
      },
      '& .MuiExpansionPanelSummary-content.Mui-expanded': {
        margin: theme.spacing(1.5, 0, 0.5)
      },
      '&.MuiExpansionPanelSummary-root.Mui-expanded': {
        minHeight: 'unset'
      },
      '& .MuiExpansionPanelSummary-content': {
        paddingRight: theme.spacing(1.5)
      }
    },
    details: {
      padding: '0 0 0 0 !important'
    },
    title: _defineProperty({
      maxWidth: "".concat(theme.spacing(101), "px !important"),
      marginBottom: "".concat(theme.spacing(4), "px !important"),
      fontWeight: "".concat(theme.typography.fontWeights.bolder, " !important")
    }, theme.breakpoints.down('md'), {
      marginBottom: "".concat(theme.spacing(1), "px !important")
    }),
    icon: _defineProperty({
      height: '24px',
      width: '24px'
    }, theme.breakpoints.down('md'), {
      textAlign: 'top'
    }),
    iconWrap: {
      '& svg': {
        transition: "background-color ".concat(timings.large, " ").concat(transitionFunction.easeOut, " !important")
      },
      height: '24px',
      width: '24px'
    },
    description: _defineProperty({
      marginTop: -theme.spacing(1),
      marginBottom: theme.spacing(6)
    }, theme.breakpoints.down('md'), {
      marginBottom: theme.spacing(4)
    }),
    displayFlex: {
      display: 'inline-flex'
    }
  });
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var COMPONENT_CONTAINER$3 = 'FAQsAccordion-Container';
var COMPONENT_FLEXI_CONTAINER = 'FAQsAccordion-Flexi-Container';
var COMPONENT_TITLE$6 = 'FAQsAccordion-Title';
var COMPONENT_DESCRIPTION$3 = 'FAQsAccordion-Description';
var COMPONENT_EXPANSION_PANEL = 'FAQsAccordion-Expansion-Panel';
var COMPONENT_EXPANSION_SUMMARY = 'FAQsAccordion-Expansion-Summary';
var COMPONENT_EXPAND_ICON = 'FAQsAccordion-Expand-Icon';
var COMPONENT_COLLAPSE_ICON = 'FAQsAccordion-Collapse-Icon';
var COMPONENT_EXPANSION_PANEL_DETAILS = 'FAQsAccordion-Expansion-Panel-Details';
var COMPONENT_BUTTON$4 = 'FAQsAccordion-Button';

var SimpleDiv = /*#__PURE__*/React__default.forwardRef(function SimpleDiv(props, ref) {
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: clsx("bg-color-".concat(props.color), props.classes)
  }, props, {
    ref: ref
  }), props.children);
});

var _this$1 = undefined;
var useStyles$w = makeStyles(styles$o);

var FAQsAccordion$1 = function FAQsAccordion(props) {
  var _clsx;

  var anchorText = get$1(props, "params.anchorText", "FAQsAccordion").replace(/\s+/g, "-");
  var gaCategoryName = get$1(props, "fields.gaCategoryName.value") || undefined;
  var buttonMode = get$1(props, "fields.buttonMode.fields.value.value", null); //For this component, if there is simple link, it should be Primary text link

  buttonMode === buttonModes.SIMPLELINK && (buttonMode = buttonModes.SIMPLEPRIMARYLINK);
  var buttonIcon = get$1(props, "fields.buttonIcon.fields.value.value", null); // Get the grid column from FlexiContainer component

  var flexiCol = parseInt(props.flexiCol) || null; // Bacground color of the component

  var backgroundColor = props.params && props.params.backgroundColor || "white";

  var _getColors = getColors(backgroundColor),
      color = _getColors.bgColor;

  var classes = useStyles$w();

  var _React$useState = React__default.useState(props.open || false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      expanded = _React$useState2[0],
      setExpanded = _React$useState2[1];

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;

  var isMobileWidth = useMediaQuery("(max-width:".concat(breakpoints.values.lg, "px)")); // const items = (props.fields && props.fields.faqItems) || [];

  var navigate = get$1(props, 'navigate', function (href) {
    if (typeof window !== 'undefined') {
      window.open(href);
    }
  });
  /**
   * handleChange is responsible to keep at most
   * one panel expanded at a time.
   */

  var handleChange = function handleChange(panel, isExpanded, GTMSharedKey) {
    PushEvent({
      event: "accordionChange",
      buttonTitle: GTMSharedKey || getGTMSharedKeyVal(undefined, COMPONENT_EXPANSION_PANEL),
      destinationUrl: undefined,
      componentName: gaCategoryName ? gaCategoryName : COMPONENT_EXPANSION_PANEL
    }, props.gtmPushEvent);
    setExpanded(isExpanded ? false : panel);
  };
  /**
   * key for every expansion panel.
   */


  var title = get$1(props, "fields.title", null);
  var description = get$1(props, "fields.description", null);
  var link = get$1(props, "fields.link", null);
  var linkGALabelName = get$1(props, "fields.linkGALabelName.value", "");
  var faqItems = get$1(props, "fields.faqItems", []);
  var showMoreLinkType = get$1(link, "value.linktype", null);
  var showMoreLinkHref = get$1(link, "value.href", null);
  var pageEditing = get$1(props, "sitecoreContext.pageEditing", false);

  var linkHandler = function linkHandler(e) {
    e.preventDefault();

    if (showMoreLinkType === "internal") {
      navigate(showMoreLinkHref);
    } else if (showMoreLinkType === "external") {
      if (typeof window !== "undefined") {
        window.open(showMoreLinkHref, "_blank");
      }
    }
  };

  var params = props.params ? props.params : {};
  var dividerLine = params.divider ? params.divider : "0";
  return pageEditing || title && title.value || faqItems.length > 0 ? /*#__PURE__*/React__default.createElement(Container$1, {
    id: anchorText,
    useContainer: !flexiCol,
    background: color,
    fixed: true
  }, /*#__PURE__*/React__default.createElement(SimpleDiv, {
    id: "FQAAccordainContainer",
    color: color,
    "data-locator": flexiCol ? COMPONENT_FLEXI_CONTAINER : COMPONENT_CONTAINER$3,
    "data-count": faqItems.length,
    classes: clsx(classes.root, getPaddingString(params), dividerLine === "1" ? "component-divider-".concat(color) : "", classes.fluidRoot, (_clsx = {}, _defineProperty(_clsx, classes["col".concat(props.colIndex)], !isNaN(props.colIndex)), _defineProperty(_clsx, "flexiBlock".concat(props.colIndex), flexiCol), _clsx))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.flex1
  }, title && title.value && title.value !== "" && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    color: color,
    variant: "h2",
    component: "h2",
    className: classes.title,
    "data-locator": COMPONENT_TITLE$6
  }, title.value), description && description.value !== "" && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    color: color,
    className: classes.description,
    "data-locator": COMPONENT_DESCRIPTION$3,
    type: "richtext"
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description.value
    }
  })), !isMobileWidth ? faqItems.map(function (item, i) {
    var _clsx2;

    var question = get$1(item, "fields.question", {
      value: ""
    }) || {
      value: ""
    };
    var GTMSharedKey = get$1(item, "fields.gaLabelName.value", "");
    var key = "".concat(kebabCase(question), "_").concat(i);
    return key && /*#__PURE__*/React__default.createElement(ExpansionPanel, {
      color: color,
      expanded: expanded === key,
      onChange: handleChange.bind(_this$1, key, expanded === key, GTMSharedKey),
      onKeyPress: function onKeyPress(e) {
        if (e.key === "Enter") {
          handleChange.bind(_this$1, key, expanded === key, GTMSharedKey);
        }
      },
      key: key,
      "data-locator": COMPONENT_EXPANSION_PANEL,
      square: true,
      className: classes["panelColored-".concat(color)]
    }, /*#__PURE__*/React__default.createElement(FwdExpansionPanelSummary, {
      expandIcon: /*#__PURE__*/React__default.createElement("span", {
        className: clsx("icon-action-common", "icon-action-".concat(color), classes.iconWrap)
      }, /*#__PURE__*/React__default.createElement(ChevronDown, {
        className: classes.icon,
        "data-locator": expanded === key ? COMPONENT_COLLAPSE_ICON : COMPONENT_EXPAND_ICON
      })),
      tabIndex: 0,
      "aria-controls": "panel".concat(key, "a-content"),
      id: "panel".concat(key, "a-header"),
      className: clsx(classes.summary, (_clsx2 = {}, _defineProperty(_clsx2, "hideFocusonClick", !useKeyBoard), _defineProperty(_clsx2, "showFocusonTab", useKeyBoard), _clsx2)),
      "data-locator": COMPONENT_EXPANSION_SUMMARY
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "h6",
      component: "div",
      color: color,
      className: classes.question,
      type: "richtext"
    }, /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: question.value
      }
    }))), /*#__PURE__*/React__default.createElement(FwdExpansionPanelDetails, {
      className: classes.details,
      "data-locator": COMPONENT_EXPANSION_PANEL_DETAILS
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "body1",
      component: "div",
      color: color,
      className: classes.answer,
      type: "richtext"
    }, /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: item.fields.answer.value
      }
    }))));
  }) : faqItems.map(function (item, i) {
    var _clsx3;

    var question = get$1(item, "fields.question", {
      value: ""
    }) || {
      value: ""
    };
    var GTMSharedKey = get$1(item, "fields.gaLabelName", {
      value: ""
    }) || {
      value: ""
    };
    var key = "".concat(kebabCase(question), "_").concat(i);
    return key && /*#__PURE__*/React__default.createElement(ExpansionPanel, {
      color: color,
      expanded: expanded === key,
      onChange: handleChange.bind(_this$1, key, expanded === key, GTMSharedKey),
      onKeyPress: function onKeyPress(e) {
        if (e.key === "Enter") {
          handleChange.bind(_this$1, key, expanded === key, GTMSharedKey);
        }
      },
      key: key,
      "data-locator": COMPONENT_EXPANSION_PANEL,
      square: true,
      className: classes["panelColored-".concat(color)]
    }, /*#__PURE__*/React__default.createElement(FwdExpansionPanelSummary, {
      expandIcon: /*#__PURE__*/React__default.createElement("span", {
        className: clsx("icon-action-common", "icon-action-".concat(color), classes.iconWrap)
      }, /*#__PURE__*/React__default.createElement(ChevronDown, {
        className: classes.icon,
        "data-locator": COMPONENT_EXPAND_ICON
      })),
      tabIndex: 0,
      "aria-controls": "panel".concat(key, "a-content"),
      id: "panel".concat(key, "a-header"),
      className: clsx(classes.summary, (_clsx3 = {}, _defineProperty(_clsx3, "hideFocusonClick", !useKeyBoard), _defineProperty(_clsx3, "showFocusonTab", useKeyBoard), _clsx3)),
      "data-locator": COMPONENT_EXPANSION_SUMMARY
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "h6",
      component: "div",
      color: color,
      className: classes.question,
      type: "richtext"
    }, /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: question.value
      }
    }))), /*#__PURE__*/React__default.createElement(FwdExpansionPanelDetails, {
      className: classes.details,
      "data-locator": COMPONENT_EXPANSION_PANEL_DETAILS
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "body1",
      component: "div",
      color: color,
      className: classes.answer,
      type: "richtext"
    }, /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: item.fields.answer.value
      }
    }))));
  })), showMoreLinkHref && /*#__PURE__*/React__default.createElement(Box, {
    className: !flexiCol ? classes.faqButtonWrapperGrid : classes.faqButtonWrapper
  }, /*#__PURE__*/React__default.createElement(DynamicLink$1, {
    value: link.value,
    color: color,
    icon: buttonIcon,
    className: classes.displayFlex,
    buttonMode: buttonMode ? buttonMode : undefined,
    "data-locator": COMPONENT_BUTTON$4,
    onClick: linkHandler,
    maxWidthApplied: true,
    GTMSharedKey: linkGALabelName,
    gtmPushEvent: props.gtmPushEvent,
    navigate: navigate
  })))) : null;
}; // export default withSitecoreContext()(FAQsAccordion);

/*9fbef606107a605d69c0edbcd8029e5d*/
var style$9 = function style(theme) {
  var _title, _threeColumn, _supportItemBox, _col, _col2;

  var spacingZero = '0';
  var colors = theme.palette.colors || {};
  var borderColor = {};
  Object.keys(colors).forEach(function (color) {
    var _borderColor$borderC;

    borderColor["border-color-".concat(color)] = (_borderColor$borderC = {
      borderBottom: "1px solid ".concat(colors[color].line.divider),
      borderRight: 'none'
    }, _defineProperty(_borderColor$borderC, theme.breakpoints.up('sm'), {
      borderBottom: 'none',
      borderRight: "1px solid ".concat(colors[color].line.divider)
    }), _defineProperty(_borderColor$borderC, '&.flexiCol', {
      borderBottom: "1px solid ".concat(colors[color].line.divider)
    }), _borderColor$borderC);
  });
  return _objectSpread2(_objectSpread2({}, borderColor), {}, {
    root: {
      height: '100%',
      display: 'flex',
      position: 'relative',
      flexDirection: 'column'
    },
    title: (_title = {
      fontWeight: theme.typography.fontWeights.bolder,
      marginBottom: '0'
    }, _defineProperty(_title, theme.breakpoints.up('sm'), {
      width: '66.05%'
    }), _defineProperty(_title, '&.flexiTitle', {
      width: '100%'
    }), _title),
    description: _defineProperty({
      marginTop: theme.spacing(3),
      fontWeight: theme.typography.fontWeights.normal
    }, theme.breakpoints.up('sm'), {
      width: '66.05%'
    }),
    supportItems: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'column',
      marginTop: theme.spacing(6),
      '&.threeColumn': (_threeColumn = {}, _defineProperty(_threeColumn, theme.breakpoints.up('sm'), {
        flexDirection: 'row',
        marginLeft: theme.spacing(-2),
        marginRight: theme.spacing(-2)
      }), _defineProperty(_threeColumn, '&.detailList', {
        marginLeft: 0,
        marginRight: 0
      }), _threeColumn),
      '&.twoColumn': _defineProperty({}, theme.breakpoints.up('sm'), {
        flexDirection: 'row'
      })
    },
    supportItemBox: (_supportItemBox = {
      width: '100%',
      paddingBottom: '23px',
      paddingTop: theme.spacing(3),
      '&:nth-child(1)': {
        paddingTop: 0
      },
      '&.detailList': {
        paddingBottom: '47px'
      },
      '&:last-child': {
        paddingBottom: 0,
        borderBottom: 0
      }
    }, _defineProperty(_supportItemBox, theme.breakpoints.up('sm'), {
      marginTop: theme.spacing(4),
      '&.detailList': {
        marginTop: theme.spacing(8)
      },
      '&.flexiCol': {
        marginTop: 0,
        borderRight: 0,
        marginLeft: theme.spacing(-2),
        marginRight: theme.spacing(-2),
        '&:not(.detailList)': {
          paddingTop: theme.spacing(1),
          paddingBottom: theme.spacing(1)
        },
        '&.detailList': {
          marginTop: 0,
          marginLeft: 0,
          marginRight: 0
        }
      }
    }), _defineProperty(_supportItemBox, '&.threeColumn', _defineProperty({}, theme.breakpoints.up('sm'), {
      width: 'calc((100% - 164px)/3 + 65px)',
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingBottom: 0,
      paddingTop: 0,
      borderBottom: 'none',
      '&:nth-child(1)': {
        marginTop: 0
      },
      '&:nth-child(2)': {
        marginTop: 0
      },
      '&:nth-child(3)': {
        marginTop: 0
      },
      '&:nth-child(3n+1)': {
        width: 'calc((100% - 164px)/3 + 49px)',
        paddingLeft: '0'
      },
      '&:nth-child(3n)': {
        width: 'calc((100% - 164px)/3 + 48px)',
        borderRight: 'none',
        paddingRight: '0'
      },
      '&.detailList': {
        width: 'calc((100% - 198px)/3 + 97px)',
        paddingRight: theme.spacing(6),
        paddingLeft: theme.spacing(6),
        '&:nth-child(3n+1)': {
          width: 'calc((100% - 198px)/3 + 49px)',
          paddingLeft: '0'
        },
        '&:nth-child(3n)': {
          width: 'calc((100% - 198px)/3 + 48px)',
          borderRight: 'none',
          paddingRight: '0'
        }
      }
    })), _defineProperty(_supportItemBox, '&.twoColumn', _defineProperty({
      paddingRight: '0'
    }, theme.breakpoints.up('sm'), {
      width: '50%',
      paddingRight: '99px',
      paddingLeft: '88px',
      paddingBottom: 0,
      paddingTop: 0,
      borderBottom: 'none',
      '&:nth-child(1)': {
        marginTop: 0
      },
      '&:nth-child(2)': {
        marginTop: 0
      },
      '&:nth-child(2n)': {
        borderRight: 'none',
        paddingLeft: '100px',
        paddingRight: '88px'
      },
      '&.detailList': {
        width: '50%',
        paddingRight: '63px',
        paddingLeft: '0',
        '&:nth-child(2n)': {
          paddingLeft: '64px',
          paddingRight: '0'
        }
      }
    })), _supportItemBox),
    col0: (_col = {}, _defineProperty(_col, theme.breakpoints.up('sm'), {
      paddingRight: theme.spacing(2.5),
      '&.flexi': {
        paddingRight: spacingZero
      }
    }), _defineProperty(_col, theme.breakpoints.up('lg'), {
      paddingRight: theme.spacing(6.5),
      '&.flexi': {
        paddingRight: spacingZero
      }
    }), _col),
    col1: (_col2 = {}, _defineProperty(_col2, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(2.5),
      '&.flexi': {
        paddingLeft: spacingZero
      }
    }), _defineProperty(_col2, theme.breakpoints.up('lg'), {
      paddingLeft: theme.spacing(6.5),
      '&.flexi': {
        paddingLeft: spacingZero
      }
    }), _col2),
    supportButton: {
      marginTop: theme.spacing(6)
    },
    alignToBottom: {
      justifyContent: 'space-between'
    },
    supportButtonCenter: {
      justifyContent: 'center'
    },
    supportButtonRight: {
      justifyContent: 'flex-end'
    }
  });
};
/* eslint-enable max-len */

/*9fbef606107a605d69c0edbcd8029e5d*/
var SUPPORT_CONTAINER = 'Support-Container';
var SUPPORT_TITLE = 'Support-Title';
var SUPPORT_DESCRIPTION = 'Support-Description';
var SUPPORT_ITEM_WRAPPER = 'Support-Item-Wrapper';
var SUPPORT_ITEM = 'Support-Item';
var SUPPORT_ITEM_IMAGE = 'Support-Image';
var SUPPORT_ITEM_TITLE = 'Support-Item-Title';
var SUPPORT_ITEM_DESCRIPTION = 'Support-Item-Description';
var SUPPORT_ITEM_LINK_ICON = 'Support-Link-Icon';
var SUPPORT_FOOTER_ITEM_LINK = 'Support-footer-item-link';
var SUPPORT_ITEM_BUTTON = 'Support-Item-Button';

var style$8 = function style(theme) {
  var colors = theme.palette.colors || {};
  var bgColors = {};
  Object.keys(colors).forEach(function (color) {
    var supportHover = theme.palette[colors[color].supportHover];
    bgColors["bgColor-".concat(color)] = _defineProperty({
      '& [data-locator="Support-Link-Icon"]': {
        '& path': {
          fill: colors[color].contrastTextAction
        }
      }
    }, theme.breakpoints.up('sm'), {
      '&:hover': {
        backgroundColor: colors[color].contrastTextAction,
        '& .MuiTypography-root': {
          color: supportHover.supportTextHover
        },
        '& [data-locator="Support-Link-Icon"]': {
          '& path': {
            fill: supportHover.contrastText
          }
        }
      }
    });
  });
  return _objectSpread2(_objectSpread2({}, bgColors), {}, {
    itemRoot: _defineProperty({
      display: 'flex',
      alignItems: 'center',
      transition: "background-color ".concat(timings.large, " ").concat(transitionFunction.easeOut, ", box-shadow ").concat(timings.smaller, " ").concat(transitionFunction.easeOut),
      '&:hover': _defineProperty({}, theme.breakpoints.up('sm'), {
        transition: "background-color ".concat(timings.large, " ").concat(transitionFunction.easeOut, ", box-shadow ").concat(timings.small, " ").concat(transitionFunction.easeOut),
        boxShadow: theme.shadows[4]
      })
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing(2)
    }),
    listIconImage: {
      alignItems: 'center'
    },
    linkItemWrapper: {
      display: 'flex',
      flexGrow: '1'
    },
    supportItemWrapper: {
      display: 'flex',
      flexGrow: '1',
      flexDirection: 'column',
      overflow: 'hidden',
      lineHeight: '20px',
      flexBasis: 'calc(100% - 76px)',
      margin: '0',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    listIcon: {
      width: theme.spacing(3),
      height: theme.spacing(3)
    },
    itemTitle: {
      marginBottom: "".concat(theme.spacing(0.25), "px !important")
    }
  });
};
/* eslint-enable max-len */

/*9fbef606107a605d69c0edbcd8029e5d*/
var handleMedalliaFormTrigger = function handleMedalliaFormTrigger(medalliaFormId) {
  if (typeof window !== 'undefined') {
    if (window.KAMPYLE_ONSITE_SDK) {
      // To generate a container for form Loading view
      onsiteLoaded(window.KAMPYLE_ONSITE_SDK, medalliaFormId);
    }
  } else return;
};

function onsiteLoaded(KAMPYLE_ONSITE_SDK, medalliaFormId) {
  // To check if the form has been loaded or not
  var neb_status = KAMPYLE_ONSITE_SDK.loadForm(medalliaFormId);

  if (neb_status === true) {
    // To show the form with valid formId
    return KAMPYLE_ONSITE_SDK.showForm(medalliaFormId);
  }
}

var useStyles$v = makeStyles(function (theme) {
  return style$8(theme);
});

var ListItem$1 = function ListItem(props) {
  var classes = useStyles$v();
  var color = props.color;
  var _props$fields = props.fields,
      icon = _props$fields.icon,
      supportIcon = _props$fields.supportIcon,
      title = _props$fields.title,
      subTitle = _props$fields.subTitle,
      listType = _props$fields.listType,
      link = _props$fields.link,
      contactNumber = _props$fields.contactNumber,
      linkGALabelName = _props$fields.linkGALabelName;
  var fieldType = get$1(listType, "fields.key.value", "");
  var medalliaFormId = get$1(props, "fields.medalliaForm.value", "");

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var url = "#";
  var subTitleField = subTitle;
  var target = "_self";

  switch (fieldType) {
    case "call":
      url = get$1(contactNumber, "value", "") ? "tel:".concat(contactNumber.value) : get$1(link, "value.href", "");
      subTitleField = get$1(subTitleField, "value", "") ? subTitleField : contactNumber;
      break;

    case "chat":
      url = null;
      break;

    case "generic_link":
    default:
      if (!medalliaFormId) {
        url = get$1(link, "value.href", "");
        target = get$1(link, "value.linktype", null) === "internal" ? "_self" : "_blank";
      } else url = null;

      break;
  }

  var navigate = get$1(props, "navigate", function (href) {
    if (typeof window !== "undefined") {
      window.open(href);
    }
  });
  var itemRootRef = useRef();
  var fieldTypeUrl = fieldType === "generic_link" ? url : undefined;
  return /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    component: fieldType === "chat" ? "span" : "a",
    className: classes.linkItem,
    href: url,
    underline: "none",
    "data-locator": SUPPORT_ITEM,
    "data-type": fieldType,
    target: target,
    tabIndex: 0,
    onKeyPress: function onKeyPress(e) {
      if (e.key === "Enter" && fieldType === "chat") {
        props.toggleChatBox(e);
      }
    },
    onClick: function onClick(e) {
      PushEvent({
        event: "buttonClick",
        buttonTitle: get$1(linkGALabelName, "value", "") || getGTMSharedKeyVal(fieldTypeUrl, SUPPORT_ITEM_BUTTON),
        componentName: props.gaCategoryName ? props.gaCategoryName : SUPPORT_ITEM_BUTTON,
        destinationUrl: fieldTypeUrl,
        productName: props.gaLabelName
      }, props.gtmPushEvent);
      props.updateGroupEnquiryData({
        productName: props.productName,
        groupEnquiryInitializer: enquiryInitializer.SUPPORT
      });

      if (fieldType === "generic_link") {
        e.preventDefault();

        if (medalliaFormId) {
          handleMedalliaFormTrigger(medalliaFormId);
        } else if ((e.ctrlKey || e.metaKey) && typeof window !== "undefined" && link.value.linktype !== "form" //forms meant to be opened in modal
        ) {
          window.open(url, "_blank");
        } else if (link.value.linktype === "internal") {
          navigate(url);
        } else if (link.value.linktype === "external") {
          window.open(url, "_blank");
        } else if (link.value.linktype === "form") {
          props.openModalHandler(get$1(link, "value.href", ""), get$1(link, "value.querystring", "") ? link.value.querystring : "");
        } else if (link.value.linktype === "mailto") {
          if (typeof window !== "undefined") {
            window.open(get$1(link, "value.href", ""), "_self");
          }
        }
      } else if (fieldType === "chat") {
        props.toggleChatBox(e);
      }
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.itemRoot, classes["bgColor-".concat(color)], getBorderRadius("small"), _defineProperty({}, classes["support-option-background-".concat(color)], color !== "initial")),
    "data-type": fieldType,
    ref: itemRootRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.linkItemWrapper
  }, get$1(supportIcon, "fields.value.value") ? /*#__PURE__*/React__default.createElement(BrandingIcon, {
    icon: supportIcon.fields.value.value,
    parentHover: true,
    size: "xl",
    parentRef: itemRootRef,
    "data-locator": SUPPORT_ITEM_IMAGE,
    className: classes.supportIcon,
    color: color,
    hasShadowEffect: false
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: classes.listIconImage
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(_defineProperty({}, classes.fallbackPic, error))
  }, /*#__PURE__*/React__default.createElement("img", {
    src: icon,
    alt: SUPPORT_ITEM_IMAGE,
    onError: function onError() {
      return setError(true);
    },
    "data-locator": SUPPORT_ITEM_IMAGE
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: classes.supportItemWrapper
  }, title && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h6",
    component: "p",
    className: clsx(classes.itemTitle, "motionColorTransition"),
    "data-locator": SUPPORT_ITEM_TITLE,
    color: color
  }, title.value), subTitleField && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "p",
    className: clsx(classes.itemDescription, "motionColorTransition"),
    "data-locator": SUPPORT_ITEM_DESCRIPTION,
    color: color
  }, subTitleField.value))), /*#__PURE__*/React__default.createElement(ArrowForward, {
    viewBox: "0, 0, 48, 48",
    className: classes.listIcon,
    "data-locator": SUPPORT_ITEM_LINK_ICON
  })));
};

var style$7 = function style(theme) {
  return {
    itemDetailRoot: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      height: '100%'
    },
    detailContentWrapper: {
      width: '100%'
    },
    supportDetailItemWrapper: {
      paddingTop: theme.spacing(3)
    },
    itemDetailTitle: _defineProperty({
      lineHeight: theme.typography.pxToRem(25),
      fontWeight: theme.typography.fontWeights.bolder,
      fontSize: theme.typography.pxToRem(20)
    }, theme.breakpoints.up('md'), {
      lineHeight: theme.typography.pxToRem(31),
      fontSize: theme.typography.pxToRem(25)
    }),
    itemDetailDescription: {
      marginTop: theme.spacing(1),
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeights.normal,
      fontSize: theme.typography.pxToRem(16)
    },
    itemDetailLink: {
      marginTop: theme.spacing(2.25),
      marginLeft: '-6px',
      lineHeight: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeights.bold,
      fontSize: theme.typography.pxToRem(16),
      cursor: 'pointer',
      '& > span': {
        display: 'flex'
      },
      '& a': {
        display: 'flex'
      },
      '& svg': {
        height: '20px'
      }
    }
  };
};
/* eslint-enable max-len */

var useStyles$u = makeStyles(function (theme) {
  return style$7(theme);
});

var DetailListItem = function DetailListItem(props) {
  // const { t } = useTranslation();
  var dictionary = get$1(props, "dictionary", {
    "medallia-chat": "Submit Feedback",
    supportOptionChat: "Start a chat"
  });

  var t = function t(key) {
    return dictionary[key];
  };

  var classes = useStyles$u();
  var toggleChatBox = props.toggleChatBox,
      color = props.color;

  var _get = get$1(props, "fields"),
      icon = _get.icon,
      title = _get.title,
      subTitle = _get.subTitle,
      listType = _get.listType,
      link = _get.link,
      contactNumber = _get.contactNumber,
      productName = _get.productName,
      supportIcon = _get.supportIcon,
      linkGALabelName = _get.linkGALabelName;

  var fieldType = get$1(listType, "fields.key.value", "");
  var medalliaFormId = get$1(props, "fields.medalliaForm.value", "");
  var buttonIcon = get$1(props, "fields.buttonIcon.fields.value.value", null);
  var buttonText = get$1(props, "fields.link.value.text", null) || null;
  var titleValue = get$1(title, "value", null) || null;
  var GTMSharedKey = get$1(linkGALabelName, "value", "");
  var contactNumberValue = get$1(contactNumber, "value", null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var url = "#";
  var subTitleField = subTitle;
  var target = "_self";

  switch (fieldType) {
    case "call":
      url = contactNumberValue ? "tel:".concat(contactNumberValue) : get$1(link, "value.href", "");
      subTitleField = get$1(subTitleField, "value", "") ? subTitleField : contactNumber;
      break;

    case "generic_link":
      if (!medalliaFormId) {
        url = get$1(link, "value.href", "");
        target = get$1(link, "value.linktype", null) === "internal" ? "_self" : "_blank";
      } else url = null;

      break;

    default:
      url = null;
      break;
  }

  var navigate = get$1(props, 'navigate', function (href) {
    if (typeof window !== 'undefined') {
      window.open(href);
    }
  });
  var itemRootRef = useRef();
  return /*#__PURE__*/React__default.createElement(Box, {
    className: clsx(classes.itemDetailRoot, _defineProperty({}, classes["support-detail-list-background-".concat(color)], color !== "initial")),
    alignItems: "center",
    "data-locator": SUPPORT_ITEM,
    "data-type": fieldType,
    ref: itemRootRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.detailContentWrapper
  }, get$1(supportIcon, "fields.value.value") ? /*#__PURE__*/React__default.createElement(BrandingIcon, {
    icon: supportIcon.fields.value.value,
    parentHover: true,
    size: "xxl",
    parentRef: itemRootRef,
    "data-locator": SUPPORT_ITEM_IMAGE,
    hasHoverEffect: false,
    color: color,
    hasShadowEffect: false
  }) : /*#__PURE__*/React__default.createElement(Box, {
    alignItems: "center",
    className: clsx(classes.detailListIconImage, error && classes.fallbackPic)
  }, /*#__PURE__*/React__default.createElement("img", {
    src: icon,
    "data-locator": SUPPORT_ITEM_IMAGE,
    alt: SUPPORT_ITEM_IMAGE,
    onError: function onError() {
      setError(true);
    }
  })), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 2,
    className: classes.supportDetailItemWrapper
  }, title && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "h3",
    color: color,
    className: classes.itemDetailTitle,
    "data-locator": SUPPORT_ITEM_TITLE
  }, title.value), subTitleField && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    color: color,
    className: classes.itemDetailDescription,
    "data-locator": SUPPORT_ITEM_DESCRIPTION
  }, subTitleField.value))), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    className: classes.itemDetailLink
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    component: fieldType === "chat" ? "span" : "a",
    href: url,
    underline: "none",
    "data-locator": SUPPORT_ITEM_BUTTON,
    "data-type": fieldType,
    alt: titleValue,
    target: target,
    color: color,
    size: "small",
    type: "caption",
    icon: buttonIcon,
    onClick: function onClick(e) {
      PushEvent({
        event: "buttonClick",
        buttonTitle: GTMSharedKey || getGTMSharedKeyVal(url, SUPPORT_ITEM_BUTTON),
        componentName: props.gaCategoryName ? props.gaCategoryName : SUPPORT_ITEM_BUTTON,
        destinationUrl: url ? url : undefined,
        productName: props.gaLabelName
      }, props.gtmPushEvent);
      props.updateGroupEnquiryData({
        productName: productName,
        groupEnquiryInitializer: enquiryInitializer.SUPPORT
      });

      if (fieldType === "generic_link") {
        e.preventDefault();

        if (medalliaFormId) {
          handleMedalliaFormTrigger(medalliaFormId);
        } else if ((e.ctrlKey || e.metaKey) && typeof window !== "undefined" && link.value.linktype !== "form" //forms meant to be opened in modal
        ) {
          window.open(url, "_blank");
        } else if (link.value.linktype === "internal") {
          navigate(url);
        } else if (link.value.linktype === "external" || link.value.linktype === "mailto") {
          window.open(url, "_blank");
        } else if (target === "_self") {
          navigate(url);
        } else if (link.value.linktype === "form") {
          props.openModalHandler(get$1(link, "value.href", ""), get$1(link, "value.querystring", "") ? link.value.querystring : "");
        }
      } else if (fieldType === "chat") {
        toggleChatBox(e);
      }
    }
  }, /*#__PURE__*/React__default.createElement("span", null, medalliaFormId ? t("medallia-chat") : buttonText || t("supportOptionChat")))));
};

var useStyles$t = makeStyles(function (theme) {
  return style$9(theme);
});

var CustomerSupport$1 = function CustomerSupport(props) {
  var _clsx, _clsx3, _clsx5;

  var anchorText = get$1(props, "params.anchorText", "Customer-Support").replace(/\s+/g, "-");
  var buttonAlignment = props.params && props.params.buttonAlignment || "left"; // Get the grid column from FlexiContainer component

  var flexiCol = props.flexiCol || null; // Background color of the component

  var background = get$1(props, "params.backgroundColor", null);
  var backgroundForComponent = background ? background : flexiCol && props.color ? props.color : "white";

  var _getColors = getColors(backgroundForComponent),
      color = _getColors.bgColor,
      surfaceColor = _getColors.surfaceColor;

  var classes = useStyles$t({
    color: color
  });

  var _ref = props.fields || {},
      title = _ref.title,
      description = _ref.description,
      link = _ref.link,
      linkGALabelName = _ref.linkGALabelName;

  var supportOptions = get$1(props, "fields.supportOptions", []);
  var supportLinkVariant = get$1(props, "params.variant", null) || null;
  var noOfColumns = get$1(props, "params.numberOfColumns", "three") || null;
  var linkValue = get$1(link, "value.text") || null;
  var gaCategoryName = get$1(props.fields, "gaCategoryName.value") || null;
  var gaLabelName = get$1(props, "sitecoreContext.route.fields.gaLabelName.value", undefined) || undefined;
  var buttonMode = get$1(props, "fields.buttonMode.fields.value.value", null);
  var buttonIcon = get$1(props, "fields.buttonIcon.fields.value.value", null);
  var pageEditing = get$1(props, "sitecoreContext.pageEditing", false);
  var productName = get$1(props.sitecoreContext, "route.fields.productTitle.value", "");
  var navigate = get$1(props, "navigate", function (href) {
    if (typeof window !== "undefined") {
      window.open(href);
    }
  });
  /**
   * Toggle Chat bot if Link Item type is chat
   */
  // const { t } = useTranslation();

  var dictionary = _objectSpread2({
    liveChatTitle: "Live chat",
    offlineChatGreeting: "Leave a message",
    onlineChatGreeting: "Leave a message"
  }, get$1(props, "dictionary", {}));

  var t = function t(key) {
    return dictionary[key];
  };

  var chatLanguage = {
    liveChatTitle: t("liveChatTitle"),
    offlineChatGreeting: t("offlineChatGreeting"),
    onlineChatGreeting: t("onlineChatGreeting")
  };

  var handleChatBotToggle = function handleChatBotToggle(e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation(); // if (typeof window !== "undefined" && window.LiveChat) {
    //   // window.showChat = true;
    //   window.LiveChat(fwdColors.orange, true, null, chatLanguage, false, e);
    // }

    props.handleChatBotToggle({
      event: e,
      chatLanguage: chatLanguage
    });
  };

  var openModalHandler = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(apiLink, formType) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // formType &&
              //   props.updateFormLinks({
              //     URL: generatelayoutServicePath(
              //       apiLink,
              //       props.sitecoreContext.languageCode || props.sitecoreContext.language
              //     ),
              //     formType: formType,
              //   });
              // if (formType === "enquiry") {
              //   props.updateFormInitializer({
              //     initializer: enums.calculatorInitializers.ENQUIRY,
              //     enquiryInitializer: "SUPPORT",
              //   });
              //   props.appInSession(true);
              // } else if (formType === "bookAnAgent") {
              //   props.updateFormInitializer({
              //     initializer: enums.calculatorInitializers.BOOKANAGENT,
              //     enquiryInitializer: "SUPPORT",
              //   });
              // } else if (formType === "recommender") {
              //   props.updateFormInitializer({
              //     initializer: enums.calculatorInitializers.RECOMMENDER,
              //   });
              // } else {
              //   props.updateFormInitializer({
              //     initializer: enums.calculatorInitializers.CALCULATOR,
              //   });
              // }
              props.updateFormModalState({
                formModalState: true
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function openModalHandler(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var linkType = link && link.value.linktype || null;
  var linkHref = link && link.value.href || null;

  var linkHandler = function linkHandler(e, btnText) {
    PushEvent({
      event: "buttonClick",
      buttonTitle: btnText || getGTMSharedKeyVal(linkHref, SUPPORT_ITEM_BUTTON),
      componentName: gaCategoryName ? gaCategoryName : SUPPORT_ITEM_BUTTON,
      destinationUrl: linkHref
    }, props.gtmPushEvent);

    if (linkType === "internal") {
      e.preventDefault();
      navigate(linkHref);
    } else if (linkType === "external") {
      if (typeof window !== "undefined") {
        window.open(linkHref, "_blank");
      }
    }
  };

  var params = props.params ? props.params : {};
  var dividerLine = params.divider ? params.divider : "0";
  var toggleData = {};

  (function toggle() {
    supportOptions.forEach(function (item, index) {
      var type = get$1(item, "fields.listType.fields.key.value", "link");
      toggleData[index] = type ? type === "chat" ? function (e) {
        return handleChatBotToggle(e);
      } : null : null;
    });
  })();

  return pageEditing || title && title.value || description && description.value || supportOptions.length > 0 ? /*#__PURE__*/React__default.createElement(Container$1, {
    id: anchorText,
    useContainer: !flexiCol,
    background: color
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, getPaddingString(params), (_clsx = {}, _defineProperty(_clsx, classes["col".concat(props.colIndex)], !isNaN(props.colIndex)), _defineProperty(_clsx, "flexiBlock".concat(props.colIndex), flexiCol), _defineProperty(_clsx, classes["alignToBottom"], supportLinkVariant === "base" && flexiCol), _clsx), dividerLine === "1" ? "component-divider-".concat(color) : ""),
    "data-locator": supportLinkVariant ? "".concat(SUPPORT_CONTAINER, "_").concat(supportLinkVariant) : SUPPORT_CONTAINER
  }, /*#__PURE__*/React__default.createElement("div", null, title && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h2",
    component: "h2",
    color: color,
    className: clsx(classes.title, _defineProperty({}, "flexiTitle", flexiCol)),
    "data-locator": SUPPORT_TITLE
  }, title.value), description && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    color: color,
    type: "richtext",
    className: classes.description,
    "data-locator": SUPPORT_DESCRIPTION
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description.value
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.supportItems, (_clsx3 = {}, _defineProperty(_clsx3, "twoColumn", noOfColumns === "two" && !flexiCol), _defineProperty(_clsx3, "threeColumn", noOfColumns !== "two" && !flexiCol), _defineProperty(_clsx3, "flexiCol", flexiCol !== null), _defineProperty(_clsx3, "detailList", supportLinkVariant === "detailList"), _clsx3)),
    "data-locator": SUPPORT_ITEM_WRAPPER
  }, supportOptions.map(function (item, index) {
    var _clsx4;

    var type = get$1(item, "fields.listType.fields.key.value", "link");
    return /*#__PURE__*/React__default.createElement("div", {
      className: clsx(classes.supportItemBox, (_clsx4 = {}, _defineProperty(_clsx4, classes["border-color-".concat(color)], index + 1 !== supportOptions.length), _defineProperty(_clsx4, "twoColumn", noOfColumns === "two" && !flexiCol), _defineProperty(_clsx4, "threeColumn", noOfColumns !== "two" && !flexiCol), _defineProperty(_clsx4, "flexiCol", flexiCol !== null), _defineProperty(_clsx4, "detailList", supportLinkVariant === "detailList"), _clsx4)),
      key: item.id
    }, supportLinkVariant === "detailList" ? /*#__PURE__*/React__default.createElement(DetailListItem, {
      fields: item.fields,
      type: type,
      history: props.history,
      toggleChatBox: toggleData[index],
      color: color,
      gaCategoryName: gaCategoryName,
      gaLabelName: gaLabelName,
      productName: productName,
      openModalHandler: openModalHandler,
      updateGroupEnquiryData: props.updateGroupEnquiryData,
      gtmPushEvent: props.gtmPushEvent,
      navigate: navigate
    }) : /*#__PURE__*/React__default.createElement(ListItem$1, {
      gaCategoryName: gaCategoryName,
      gaLabelName: gaLabelName,
      fields: item.fields,
      surfaceColor: surfaceColor,
      color: color,
      type: type,
      history: props.history,
      productName: productName,
      toggleChatBox: toggleData[index],
      openModalHandler: openModalHandler,
      updateGroupEnquiryData: props.updateGroupEnquiryData,
      gtmPushEvent: props.gtmPushEvent,
      navigate: navigate
    }));
  }))), linkValue && /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    className: clsx(classes.supportButton, (_clsx5 = {}, _defineProperty(_clsx5, classes.supportButtonCenter, buttonAlignment === "center"), _defineProperty(_clsx5, classes.supportButtonRight, buttonAlignment === "right"), _clsx5))
  }, /*#__PURE__*/React__default.createElement(DynamicLink$1, {
    value: link.value,
    className: classes.displayFlex,
    color: color,
    icon: buttonIcon,
    buttonMode: buttonMode ? buttonMode : undefined,
    "data-locator": SUPPORT_FOOTER_ITEM_LINK,
    onClick: function onClick(e) {
      return linkHandler(e, linkGALabelName.value);
    },
    maxWidthApplied: true,
    GTMSharedKey: get$1(linkGALabelName, "value", ""),
    gtmPushEvent: props.gtmPushEvent,
    navigate: navigate
  })))) : null;
}; // const mapDispatchToProps = dispatch => {

/*9fbef606107a605d69c0edbcd8029e5d*/
var CALLBACKFORM_PAGE_WRAPPER = 'Form-Page-Wrapper';
var CALLBACKFORM_FORMVALUE_LIST = 'Form-FormValue-List';
var FORM_SECTION_LABEL = 'Form-Section-Label';
var FORM_SECTION_INPUTBOX = 'Form-Section-InputBox';
var FORM_SECTION_RADIOBOX = 'Form-Section-RadioBox';
var FORM_SECTION_BUTTON = 'Form-Section-Button';
var FORM_SECTION_CHECKBOX = 'Form-Section-Checkbox';
var FORM_SECTION_DROPDOWN = 'Form-Section-Dropdown';
var FORM_DOB_WRAPPER = 'Form-Dob-Wrapper';
var PRODUCT_MIN_AGE = 'Form-Dob-HelpText-Product-Min-Age';
var PRODUCT_MAX_AGE = 'Form-Dob-HelpText-Product-Max-Age';
var FORM_SECTION_TOOLTIP = 'Form-Section-Tooltip';
var FORM_SECTION_DATALIST = 'Form-Section-DataList';

//   updateDynamicDropdownData,
//   setStrikeIronApiStatus,
// } from "../ProductDetailPage/redux/actions";
// import { getDynamicDropdownData } from "../ProductDetailPage/redux/selectors";
// import fetchService from '../../../../services/FetchService';

var FieldRenderer = function FieldRenderer(props) {
  // const { t } = useTranslation();
  var dictionary = get$1(props, "dictionary", {
    genericRequiredErrorMessage: "Please fill in this blank!",
    minLengthErrorMessage: "{this} should have minimum {minValue} characters",
    maxLengthErrorMessage: "{this} should have minimum {maxValue} characters"
  });

  var t = function t(key) {
    return dictionary[key];
  };

  var fieldItem = props.fieldItem,
      isShowNext = props.isShowNext,
      data = props.data,
      isConditional = props.isConditional;
  var isSubmitDisable = props.data ? data.isSubmitDisable : false;
  var enterKeyInfo = props.enterKeyInfo ? props.enterKeyInfo : "or, press enter to continue";
  var fieldTypeURL = getFieldType(get$1(fieldItem, "fields[Field Type].url", ""));
  var regEx = get$1(fieldItem, "fields.Validations[0].fields.Parameters.value", "");
  var validationErrorMsg = get$1(fieldItem, "fields.Validations[0].fields.Message.value", "error");
  var requiredValidationRule = {
    required: get$1(fieldItem, 'fields["Required"].value', null) === true ? t("genericRequiredErrorMessage") : null
  };
  var minLengthValidationRule = {
    minLength: {
      value: get$1(fieldItem, 'fields["Min Length"].value', null),
      message: t("minLengthErrorMessage").replace("{this}", "".concat(get$1(fieldItem, "displayName", ""))).replace("{minValue}", "".concat(get$1(fieldItem, 'fields["Min Length"].value', "")))
    }
  };
  var maxLengthValidationRule = {
    maxLength: {
      value: get$1(fieldItem, 'fields["Max Length"].value', null),
      message: t("maxLengthErrorMessage").replace("{this}", "".concat(get$1(fieldItem, "displayName", ""))).replace("{maxValue}", "".concat(get$1(fieldItem, 'fields["Max Length"].value', "")))
    }
  };
  var patternValidationRule = {
    pattern: {
      value: new RegExp(regEx.substring(1, regEx.length - 1)),
      message: validationErrorMsg
    }
  };
  var fieldClassName = get$1(fieldItem, 'fields["Css Class"].value', "");
  fieldClassName += isConditional ? " conditional" : "";

  var _useState = useState({
    loader: false,
    tick: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      emailValidationObj = _useState2[0],
      setEmailValidationObj = _useState2[1];

  var _useState3 = useState({
    loader: false,
    tick: false
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      phoneValidationObj = _useState4[0],
      setPhoneValidationObj = _useState4[1];

  var isFormHeading = fieldClassName.split(" ").some(function (cssClassName) {
    return cssClassName === "formHeading";
  });

  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      radioChecked = _useState6[0],
      setRadioChecked = _useState6[1];

  if ([SingleLineTextType, MultiLineTextType].find(function (el) {
    return fieldTypeURL.includes(el);
  })) {
    var defaultValue = props.pageValue ? props.pageValue[fieldItem.fields["Field Key"].value].value : undefined;

    var validationRules = _objectSpread2({}, requiredValidationRule);
    /* istanbul ignore else */


    if (fieldItem.fields["Min Length"].value > 0) {
      validationRules = _objectSpread2(_objectSpread2({}, validationRules), minLengthValidationRule);
    }
    /* istanbul ignore else */


    if (fieldItem.fields["Max Length"].value > 0) {
      validationRules = _objectSpread2(_objectSpread2({}, validationRules), maxLengthValidationRule);
    }

    var isMultipleLine = MultiLineTextType === fieldTypeURL;
    return fieldClassName.indexOf("hide") === -1 && /*#__PURE__*/React__default.createElement(FormGroup, {
      key: fieldItem.id,
      className: clsx(fieldClassName, {
        multilineFieldWithValue: isMultipleLine && isShowNext
      })
    }, /*#__PURE__*/React__default.createElement(InputField, _extends({
      multiline: isMultipleLine,
      "data-locator": FORM_SECTION_INPUTBOX,
      label: props.formtype === "regular" ? fieldItem.fields.Title.value : null,
      placeholder: props.formtype === "conversational" ? fieldItem.fields["Placeholder Text"].value : "",
      margin: "normal",
      maxLength: fieldItem.fields["Max Length"].value,
      name: fieldItem.fields["Field Key"].value,
      inputProps: {
        type: "text"
      },
      inputRef: props.register(_objectSpread2({}, validationRules)),
      formtype: props.formtype,
      errors: props.errors,
      defaultValue: fieldClassName.indexOf("disabled") !== -1 ? fieldItem.fields["Default Value"].value : defaultValue,
      rows: 1
    }, isMultipleLine && {
      rowsMax: get$1(fieldItem, "fields.Rows.value", "3")
    }, {
      InputProps: fieldClassName.indexOf("disabled") !== -1 ? {
        readOnly: true
      } : {},
      onChange: function onChange() {
        props.handleOnFormValueChange();
      }
    })));
  } else if (fieldTypeURL === TextType) {
    return /*#__PURE__*/React__default.createElement(FormGroup, {
      key: fieldItem.id,
      className: fieldClassName
    }, isFormHeading ? /*#__PURE__*/React__default.createElement("div", {
      className: "fieldlabel",
      "data-locator": FORM_SECTION_LABEL
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "h3",
      component: "h1",
      fontWeight: "bolder"
    }, get$1(fieldItem, "fields.Text.value", ""))) : /*#__PURE__*/React__default.createElement("label", {
      className: "fieldlabel",
      "data-locator": FORM_SECTION_LABEL
    }, /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: fieldItem.fields.Text.value
      }
    })), /*#__PURE__*/React__default.createElement(FieldMessage, {
      name: props.name,
      hint: props.fieldItem.fields.HelpText.value,
      errors: props.errors,
      formtype: props.formtype
    }));
  } else if (fieldTypeURL === RadioListType) {
    var _validationRules = _objectSpread2({}, requiredValidationRule);

    var _defaultValue = props.pageValue ? props.pageValue[fieldItem.fields["Field Key"].value].value : undefined;
    /* istanbul ignore else */


    if (_defaultValue !== "") {
      _validationRules[fieldItem.fields["Field Key"].value] = _defaultValue;
      /* istanbul ignore else */

      if (_defaultValue !== radioChecked && radioChecked === "") {
        setRadioChecked(_defaultValue);
      }
    }

    return /*#__PURE__*/React__default.createElement("span", {
      "data-locator": FORM_SECTION_RADIOBOX,
      "data-key": fieldItem.id
    }, /*#__PURE__*/React__default.createElement(RadioButtonGroup, {
      label: fieldItem.displayName,
      name: fieldItem.fields["Field Key"].value,
      errors: props.errors,
      formtype: props.formtype,
      className: fieldClassName
    }, get$1(fieldItem, "fields.Title.value", "") ? /*#__PURE__*/React__default.createElement("div", {
      className: "MuiFormGroup-root block fieldHeading innerField"
    }, /*#__PURE__*/React__default.createElement("label", {
      className: "fieldlabel",
      "data-locator": FORM_SECTION_LABEL
    }, /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: fieldItem.fields.Title.value
      }
    }))) : null, fieldItem.items.map(function (radioField) {
      return /*#__PURE__*/React__default.createElement(RadioButton, {
        key: radioField.displayName,
        value: radioField.fields.value.value,
        label: radioField.displayName,
        formtype: props.formtype,
        defaultValue: _defaultValue,
        name: fieldItem.fields["Field Key"].value,
        register: props.register(_objectSpread2({}, _validationRules)),
        checked: radioChecked === radioField.fields.value.value,
        onChange: function onChange(evt, val) {
          props.handleOnFormValueChange(evt.target.name, val);
          setRadioChecked(val);
        }
      });
    })));
  } else if (fieldTypeURL === CheckBox$1) {
    var _validationRules2 = _objectSpread2({}, requiredValidationRule);

    var _defaultValue2 = props.pageValue ? props.pageValue[fieldItem.fields["Field Key"].value].value : false;

    var conditions = fieldItem.fields && fieldItem.fields["Conditions"] && fieldItem.fields["Conditions"].value ? JSON.parse(fieldItem.fields["Conditions"].value) : {};
    var isConditionalField = conditions.fieldConditions && conditions.fieldConditions.length > 0;
    return /*#__PURE__*/React__default.createElement(FormGroup, {
      "data-key": fieldItem.id,
      key: fieldItem.id,
      className: clsx(fieldClassName, "CheckboxWrapper", {
        activeCheckbox: isShowNext,
        hasConditional: isConditionalField
      }),
      "data-locator": FORM_SECTION_CHECKBOX
    }, get$1(fieldItem, "fields.Title.value", "") ? /*#__PURE__*/React__default.createElement("div", {
      className: "MuiFormGroup-root block fieldHeading innerField"
    }, /*#__PURE__*/React__default.createElement("label", {
      className: "fieldlabel",
      "data-locator": FORM_SECTION_LABEL
    }, /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: fieldItem.fields.Title.value
      }
    }))) : null, fieldItem.items.map(function (field) {
      return /*#__PURE__*/React__default.createElement(CheckBox, {
        key: field.displayName,
        value: field.fields.value.value,
        defaultChecked: _defaultValue2,
        label: field.fields.value,
        name: fieldItem.fields["Field Key"].value,
        formtype: props.formtype,
        register: props.register(_objectSpread2({}, _validationRules2)),
        errors: props.errors,
        onChange: function onChange() {
          props.handleOnFormValueChange();
        }
      });
    }), props.formtype === "regular" && /*#__PURE__*/React__default.createElement(FieldMessage, {
      name: fieldItem.fields["Field Key"].value,
      errors: props.errors,
      formtype: props.formtype
    }));
  } else if (fieldTypeURL === DropDown) {
    var _defaultValue3 = props.pageValue ? props.pageValue[fieldItem.fields["Field Key"].value].value : "";

    var _validationRules3 = _objectSpread2({}, requiredValidationRule);

    var autoSuggest = get$1(fieldItem, "fields[isAutoSuggest].value", false) || false;
    var dropDownlist = fieldItem.items;
    var defaultSelection = "";
    var defaultSelectionID = get$1(fieldItem, 'fields["Default Selection"].value', "");
    /* istanbul ignore else */

    if (defaultSelectionID && !autoSuggest) {
      var defaultSelectionItem = dropDownlist.find(function (item) {
        return item.id.toLowerCase() === defaultSelectionID.replace(/{|}/g, "").toLowerCase();
      });
      defaultSelection = get$1(defaultSelectionItem, "fields.value.value", "");
    } // console.log(props);

    /* istanbul ignore else */


    if (autoSuggest) {
      dropDownlist = dropDownlist.map(function (item) {
        return item.fields.value.value;
      });
    }

    var fieldBox = autoSuggest ? /*#__PURE__*/React__default.createElement(DataList, {
      id: fieldItem.id,
      fieldClassName: fieldClassName,
      errors: props.errors,
      formtype: props.formtype,
      register: props.register(_objectSpread2({}, _validationRules3)),
      label: fieldItem.fields["Title"].value,
      name: fieldItem.fields["Field Key"].value,
      items: dropDownlist,
      displayEmpty: true,
      defaultValue: _defaultValue3,
      placeholder: fieldItem.fields["Title"].value,
      "data-locator": FORM_SECTION_DATALIST,
      onChange: function onChange() {
        props.handleOnFormValueChange();
      }
    }) : /*#__PURE__*/React__default.createElement(DropDownList, {
      fieldClassName: fieldClassName,
      errors: props.errors,
      formtype: props.formtype,
      register: props.register(_objectSpread2({}, _validationRules3)),
      label: fieldItem.fields["Title"].value,
      name: fieldItem.fields["Field Key"].value,
      items: dropDownlist,
      hint: fieldItem.fields["HelpText"].value,
      displayEmpty: true,
      defaultValue: _defaultValue3 || defaultSelection,
      placeholder: fieldItem.fields["Title"].value,
      "data-locator": FORM_SECTION_DROPDOWN,
      fieldItem: fieldItem // updateDynamicDropdownData={props.updateDynamicDropdownData}
      // dynamicDropdownData={props.dynamicDropdownData}
      ,
      onChange: function onChange() {
        props.handleOnFormValueChange();
      }
    });
    return fieldBox;
  } else if (fieldTypeURL === DateType) {
    var _defaultValue4 = props.pageValue["day"] ? {
      day: props.pageValue["day"].value,
      month: props.pageValue["month"].value,
      year: props.pageValue["year"].value,
      dob: props.pageValue["dob"].value
    } : "";

    var errorMessages = {};
    var productAgeRangeArray = [];
    var defaultProductAgeRange = {
      productMinAge: 0,
      productMaxAge: 200
    };
    var productAgeRange = get$1(props, "rangeItem.productAgeRange", defaultProductAgeRange) || defaultProductAgeRange;
    var productMinAge = get$1(props, "rangeItem.productAgeRange.productMinAge", 0) || 0;
    var productMaxAge = get$1(props, "rangeItem.productAgeRange.productMaxAge", 200) || 200;
    var dobHelpText = fieldItem.fields["HelpText"].value ? fieldItem.fields["HelpText"].value : null;

    if (dobHelpText) {
      dobHelpText = dobHelpText.replace("{minAge}", "<span data-locator=".concat(PRODUCT_MIN_AGE, ">").concat(props.rangeItem.productAgeRange.productMinAge, "</span>"));
      dobHelpText = dobHelpText.replace("{maxAge}", "<span data-locator=".concat(PRODUCT_MAX_AGE, ">").concat(props.rangeItem.productAgeRange.productMaxAge, "</span>"));
    }

    errorMessages = {
      specificError: fieldItem.fields["SpecificError"].value,
      generalError: fieldItem.fields["GeneralError"].value
    };
    productAgeRangeArray.push(parseInt(productMinAge), parseInt(productMaxAge));
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DateField, {
      register: props.register,
      errors: props.errors,
      setError: props.setError,
      clearError: props.clearError,
      errorMessages: errorMessages,
      minimumYear: fieldItem.fields["minimumYear"].value,
      fieldItem: fieldItem,
      defaultValue: _defaultValue4,
      name: "dob",
      formtype: props.formtype,
      dataLocator: {
        dropdown: FORM_SECTION_DROPDOWN,
        dob: FORM_DOB_WRAPPER
      },
      onChangeHandler: function onChangeHandler() {
        props.handleOnFormValueChange();
      },
      siteName: props.siteName,
      productAgeRange: productAgeRange,
      dobHelpText: dobHelpText,
      productAgeRangeArray: productAgeRangeArray
    }));
  } else if (fieldTypeURL === TelephoneType) {
    var _props$fieldItem, _props$fieldItem$fiel, _props$fieldItem$fiel2, _props$fieldItem2, _props$fieldItem2$fie, _props$fieldItem2$fie2;

    document.querySelector("[name=\"".concat(props === null || props === void 0 ? void 0 : (_props$fieldItem = props.fieldItem) === null || _props$fieldItem === void 0 ? void 0 : (_props$fieldItem$fiel = _props$fieldItem.fields) === null || _props$fieldItem$fiel === void 0 ? void 0 : (_props$fieldItem$fiel2 = _props$fieldItem$fiel["Field Key"]) === null || _props$fieldItem$fiel2 === void 0 ? void 0 : _props$fieldItem$fiel2.value, "\"]")); // const serverValidationRule = async fieldData => {
    //   if (document.activeElement !== phoneField) {
    //     setPhoneValidationObj({ loader: true, tick: false });
    //     return fetchService({
    //       url: props?.fieldItem?.fields?.serverValidationAPI?.fields?.value?.value,
    //       method: 'POST',
    //       data: {
    //         [props.fieldItem?.fields?.apiName?.fields?.value?.value]:
    //           props.defaultCountryCode + fieldData,
    //       },
    //       headers: {
    //         entity: props.siteName?.split('-')[1]?.toUpperCase(),
    //         Authorization: props?.fieldItem?.fields?.serverValidationAPI?.fields?.key?.value,
    //       },
    //     }).then(result => {
    //       if (result.status === 200) {
    //         setPhoneValidationObj({ loader: false, tick: true });
    //         props.setStrikeIronApiStatus({ errorCode: '' });
    //         return true;
    //       } else {
    //         setPhoneValidationObj({ loader: false, tick: false });
    //         if (result.status === 400) {
    //           props.setStrikeIronApiStatus({ errorCode: '' });
    //           return false;
    //         } else {
    //           props.setStrikeIronApiStatus({ errorCode: result.status });
    //           return true;
    //         }
    //       }
    //     });
    //   } else {
    //     return true;
    //   }
    // };

    var serverValidationRule = function serverValidationRule(fieldData) {
      return true;
    };

    var _validationRules4 = _objectSpread2(_objectSpread2(_objectSpread2({}, requiredValidationRule), patternValidationRule), ((_props$fieldItem2 = props.fieldItem) === null || _props$fieldItem2 === void 0 ? void 0 : (_props$fieldItem2$fie = _props$fieldItem2.fields) === null || _props$fieldItem2$fie === void 0 ? void 0 : (_props$fieldItem2$fie2 = _props$fieldItem2$fie.enableServerValidation) === null || _props$fieldItem2$fie2 === void 0 ? void 0 : _props$fieldItem2$fie2.value) && {
      validate: function () {
        var _validate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
          var _props$fieldItem3, _props$fieldItem3$fie, _props$fieldItem3$fie2;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return serverValidationRule(value);

                case 2:
                  _context.t0 = _context.sent;

                  if (_context.t0) {
                    _context.next = 5;
                    break;
                  }

                  _context.t0 = (_props$fieldItem3 = props.fieldItem) === null || _props$fieldItem3 === void 0 ? void 0 : (_props$fieldItem3$fie = _props$fieldItem3.fields) === null || _props$fieldItem3$fie === void 0 ? void 0 : (_props$fieldItem3$fie2 = _props$fieldItem3$fie.serverValidationErrorText) === null || _props$fieldItem3$fie2 === void 0 ? void 0 : _props$fieldItem3$fie2.value;

                case 5:
                  return _context.abrupt("return", _context.t0);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function validate(_x) {
          return _validate.apply(this, arguments);
        }

        return validate;
      }()
    });
    /* istanbul ignore else */


    if (fieldItem.fields["Min Length"].value > 0) {
      _validationRules4 = _objectSpread2(_objectSpread2({}, _validationRules4), {}, {
        minLength: {
          value: fieldItem.fields["Min Length"].value,
          message: validationErrorMsg
        }
      });
    }
    /* istanbul ignore else */


    if (fieldItem.fields["Max Length"].value > 0) {
      _validationRules4 = _objectSpread2(_objectSpread2({}, _validationRules4), {}, {
        maxLength: {
          value: fieldItem.fields["Max Length"].value + 1,
          message: validationErrorMsg
        }
      });
    }

    var _defaultValue5 = props.pageValue ? props.pageValue[fieldItem.fields["Field Key"].value].value : undefined;

    var dialInCodeLength = get$1(fieldItem, 'fields["dialInCodeLength"].fields.value.value', "");
    return /*#__PURE__*/React__default.createElement(FormGroup, {
      className: fieldClassName
    }, /*#__PURE__*/React__default.createElement(MaskInputField, _extends({
      id: fieldItem.id,
      label: fieldItem.fields.Title.value,
      name: fieldItem.fields["Field Key"].value,
      margin: "normal",
      inputProps: {
        type: "tel"
      },
      formtype: props.formtype,
      inputRef: props.register(_objectSpread2({}, _validationRules4)),
      errors: props.errors,
      placeholder: props.formtype === "conversational" ? fieldItem.fields["Placeholder Text"].value : "",
      "data-locator": FORM_SECTION_INPUTBOX,
      defaultValue: _defaultValue5,
      onChange: function onChange() {
        props.handleOnFormValueChange();
      },
      triggerValidation: props.triggerValidation
    }, fieldItem.fields["Min Length"].value > 0 && {
      minLength: fieldItem.fields["Min Length"].value
    }, fieldItem.fields["Max Length"].value > 0 && {
      maxLength: fieldItem.fields["Max Length"].value
    }, {
      dialInCodeLength: dialInCodeLength,
      fieldItem: props.fieldItem,
      phoneValidationObj: phoneValidationObj,
      setPhoneValidationObj: setPhoneValidationObj
    })));
  } else if (fieldTypeURL === EmailType) {
    var _props$fieldItem4, _props$fieldItem4$fie, _props$fieldItem4$fie2, _props$fieldItem5, _props$fieldItem5$fie, _props$fieldItem5$fie2;

    document.querySelector("[name=\"".concat(props === null || props === void 0 ? void 0 : (_props$fieldItem4 = props.fieldItem) === null || _props$fieldItem4 === void 0 ? void 0 : (_props$fieldItem4$fie = _props$fieldItem4.fields) === null || _props$fieldItem4$fie === void 0 ? void 0 : (_props$fieldItem4$fie2 = _props$fieldItem4$fie["Field Key"]) === null || _props$fieldItem4$fie2 === void 0 ? void 0 : _props$fieldItem4$fie2.value, "\"]")); // const serverValidationRule = async (fieldData) => {
    //   if (document.activeElement !== emailField) {
    //     setEmailValidationObj({ loader: true, tick: false });
    //     return fetchService({
    //       url:
    //         props?.fieldItem?.fields?.serverValidationAPI?.fields?.value?.value,
    //       method: "POST",
    //       data: {
    //         [props.fieldItem?.fields?.apiName?.fields?.value?.value]: fieldData,
    //       },
    //       headers: {
    //         entity: props.siteName?.split("-")[1]?.toUpperCase(),
    //         Authorization:
    //           props?.fieldItem?.fields?.serverValidationAPI?.fields?.key?.value,
    //       },
    //     }).then((result) => {
    //       if (result.status === 200) {
    //         setEmailValidationObj({ loader: false, tick: true });
    //         props.setStrikeIronApiStatus({ errorCode: "" });
    //         return true;
    //       } else {
    //         setEmailValidationObj({ loader: false, tick: false });
    //         if (result.status === 400) {
    //           props.setStrikeIronApiStatus({ errorCode: "" });
    //           return false;
    //         } else {
    //           props.setStrikeIronApiStatus({ errorCode: result.status });
    //           return true;
    //         }
    //       }
    //     });
    //   } else {
    //     return true;
    //   }
    // };

    var _serverValidationRule = function _serverValidationRule(fieldData) {
      return true;
    };

    var _validationRules5 = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, requiredValidationRule), patternValidationRule), minLengthValidationRule), maxLengthValidationRule), ((_props$fieldItem5 = props.fieldItem) === null || _props$fieldItem5 === void 0 ? void 0 : (_props$fieldItem5$fie = _props$fieldItem5.fields) === null || _props$fieldItem5$fie === void 0 ? void 0 : (_props$fieldItem5$fie2 = _props$fieldItem5$fie.enableServerValidation) === null || _props$fieldItem5$fie2 === void 0 ? void 0 : _props$fieldItem5$fie2.value) && {
      validate: function () {
        var _validate2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(value) {
          var _props$fieldItem6, _props$fieldItem6$fie, _props$fieldItem6$fie2;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _serverValidationRule(value);

                case 2:
                  _context2.t0 = _context2.sent;

                  if (_context2.t0) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.t0 = (_props$fieldItem6 = props.fieldItem) === null || _props$fieldItem6 === void 0 ? void 0 : (_props$fieldItem6$fie = _props$fieldItem6.fields) === null || _props$fieldItem6$fie === void 0 ? void 0 : (_props$fieldItem6$fie2 = _props$fieldItem6$fie.serverValidationErrorText) === null || _props$fieldItem6$fie2 === void 0 ? void 0 : _props$fieldItem6$fie2.value;

                case 5:
                  return _context2.abrupt("return", _context2.t0);

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function validate(_x2) {
          return _validate2.apply(this, arguments);
        }

        return validate;
      }()
    });

    var _defaultValue6 = props.pageValue ? props.pageValue[fieldItem.fields["Field Key"].value].value : undefined;

    return /*#__PURE__*/React__default.createElement(FormGroup, {
      className: fieldClassName
    }, /*#__PURE__*/React__default.createElement(InputField, {
      id: fieldItem.id,
      label: fieldItem.fields.Title.value,
      name: fieldItem.fields["Field Key"].value,
      margin: "normal",
      inputProps: {
        type: "text"
      },
      formtype: props.formtype,
      inputRef: props.register(_objectSpread2({}, _validationRules5)),
      errors: props.errors,
      placeholder: props.formtype === "conversational" ? fieldItem.fields["Placeholder Text"].value : "",
      "data-locator": FORM_SECTION_INPUTBOX,
      defaultValue: _defaultValue6,
      onChange: function onChange() {
        props.handleOnFormValueChange();
      },
      setError: props.setError,
      fieldItem: props.fieldItem,
      emailValidationObj: emailValidationObj,
      setEmailValidationObj: setEmailValidationObj
    }));
  } else if (fieldTypeURL === SubmitType) {
    var items = fieldItem.items;
    var PageID = null;
    var buttonType = "";
    var parameter = null;
    var btnTypeURLs = [];
    var emailTemplate = "";
    var apiToQuery = "";
    /* istanbul ignore else */

    if (items && items.length > 0) {
      items.forEach(function (item) {
        var btnTypeURL = getFieldType(get$1(item, 'fields["Submit Action"].url', null));

        try {
          parameter = JSON.parse(get$1(item, "fields.Parameters.value", null));
          PageID = parameter.referenceId.replace("{", "").replace("}", "").toLowerCase();
        } catch (err) {
          parameter = null;
        }

        btnTypeURLs.push(btnTypeURL);
      });
    }

    if (btnTypeURLs.some(function (btnType) {
      return btnType === SendEmail;
    })) {
      buttonType = "submit";
      emailTemplate = get$1(fieldItem, "fields.emailTemplateLink.value", "") || "";
      apiToQuery = API.SEND_EMAIL;
    } else if (btnTypeURLs.some(function (btnType) {
      return btnType === SaveButton;
    }) || fieldClassName.indexOf("submitButton") !== -1) {
      buttonType = "submit";
      emailTemplate = get$1(fieldItem, "fields.emailTemplateLink.value", "") || "";
      apiToQuery = API.SAVE_LEAD;
    } else if (fieldClassName.indexOf("back-to-home") !== -1 || fieldClassName.indexOf("back_to_home") !== -1) {
      buttonType = "backHome";
    } else {
      buttonType = "next";
    }

    return /*#__PURE__*/React__default.createElement(FormGroup, {
      key: fieldItem.id,
      className: clsx([fieldClassName, "formNextButton"], isShowNext || !isSubmitDisable ? "activeButton" : "")
    }, /*#__PURE__*/React__default.createElement(Box, {
      display: "flex",
      mt: 12,
      className: "formButtonBox"
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
      color: props.mode === "light" ? "white" : "black",
      outlined: buttonType === "submit" || props.mode === "dark" ? false : true,
      variant: "secondary",
      alt: fieldItem.fields.Title.value,
      onClick: function onClick() {
        return props.onNextClick(buttonType, PageID, emailTemplate, apiToQuery);
      },
      "data-locator": FORM_SECTION_BUTTON,
      disabled: isSubmitDisable && buttonType === "submit" ? true : false,
      type: buttonType === "submit" ? buttonType : "button"
    }, fieldItem.fields.Title.value), fieldClassName.indexOf("next-button") !== -1 && /*#__PURE__*/React__default.createElement("div", {
      className: "enterKeyIconBox"
    }, enterKeyInfo)));
  } else if (fieldTypeURL === ToolTip) {
    return props.fieldItem.fields.toolTipText.value && /*#__PURE__*/React__default.createElement("div", {
      className: "toolTipWrapper",
      "data-locator": FORM_SECTION_TOOLTIP
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "body3",
      component: "span"
    }, props.fieldItem.fields.label.value), /*#__PURE__*/React__default.createElement(FwdTooltip, {
      className: fieldClassName,
      title: props.fieldItem.fields.toolTipText.value
    }, /*#__PURE__*/React__default.createElement("span", {
      style: {
        marginLeft: "4px",
        verticalAlign: "middle"
      }
    }, /*#__PURE__*/React__default.createElement(QuestionMark, null))));
  } else {
    return null;
  }
}; // const mapStateToProps = createStructuredSelector({

/*9fbef606107a605d69c0edbcd8029e5d*/

var SectionRenderer = function SectionRenderer(props) {
  var watchers = props.watchers,
      actionItems = props.actionItems,
      evalCondition = props.evalCondition,
      bgColor = props.bgColor,
      _props$cssClass = props.cssClass,
      cssClass = _props$cssClass === void 0 ? '' : _props$cssClass;
  return /*#__PURE__*/React__default.createElement(Box, {
    className: clsx('sectionWrapper', "bgText-color-".concat(bgColor), {
      consentSection: cssClass.indexOf('consentSection') !== -1
    })
  }, props.items && props.items.map(function (item, index) {
    var isHidden = get$1(item, 'fields.isHidden.value', false) || false;
    var fieldKey = get$1(item, 'fields[Field Key].value', '') || '';

    if (!isHidden) {
      if (actionItems && actionItems[fieldKey]) {
        if (watchers[actionItems[fieldKey].depends] === actionItems[fieldKey].value) {
          return /*#__PURE__*/React__default.createElement(FieldRenderer, {
            key: index,
            fieldItem: item,
            register: props.register,
            onNextClick: props.onNextClick,
            errors: props.errors,
            formtype: props.formtype,
            enterKeyInfo: props.enterKeyInfo,
            pageValue: props.pageValue ? props.pageValue : undefined,
            isShowNext: props.isShowNext,
            setIsShowNext: props.setIsShowNext,
            mode: props.mode,
            data: props.data,
            clearError: props.clearError,
            handleOnFormValueChange: props.handleOnFormValueChange,
            evalCondition: evalCondition,
            triggerValidation: props.triggerValidation,
            defaultCountryCode: props.defaultCountryCode,
            siteName: props.siteName
          });
        } else {
          return null;
        }
      } else {
        return /*#__PURE__*/React__default.createElement(FieldRenderer, {
          key: index,
          fieldItem: item,
          register: props.register,
          onNextClick: props.onNextClick,
          errors: props.errors,
          formtype: props.formtype,
          enterKeyInfo: props.enterKeyInfo,
          pageValue: props.pageValue ? props.pageValue : undefined,
          isShowNext: props.isShowNext,
          setIsShowNext: props.setIsShowNext,
          mode: props.mode,
          data: props.data,
          clearError: props.clearError,
          handleOnFormValueChange: props.handleOnFormValueChange,
          evalCondition: evalCondition,
          siteName: props.siteName,
          triggerValidation: props.triggerValidation,
          defaultCountryCode: props.defaultCountryCode
        });
      }
    } else return null;
  }));
};

/*9fbef606107a605d69c0edbcd8029e5d*/

var PageRenderer = function PageRenderer(props) {
  var actionItems = props.actionItems,
      evalCondition = props.evalCondition;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'formPageRender'
  }, props.items && props.items.map(function (item, index) {
    var isHidden = get$1(item, 'fields.isHidden.value', false) || false;
    var fieldKey = get$1(item, 'fields[Field Key].value', '') || '';
    var fieldType = get$1(item, 'fields[Field Type].url', '') || '';
    var backgroundColor = get$1(item, 'fields.backgroundColor.fields.value.value', 'grey') || 'grey';

    var _getColors = getColors(backgroundColor),
        bgColor = _getColors.bgColor;

    fieldType = getFieldType(fieldType);

    if (!isHidden) {
      if (fieldType === SectionType) {
        if (actionItems[fieldKey]) {
          if (evalCondition(actionItems, fieldKey)) {
            return /*#__PURE__*/React__default.createElement(SectionRenderer, {
              items: item.items,
              bgColor: bgColor,
              cssClass: get$1(item, 'fields["Css Class"].value', ''),
              displayName: item.displayName,
              register: props.register,
              key: item.id,
              watchers: props.watchers,
              actionItems: props.actionItems,
              activePage: props.activePage,
              onNextClick: props.onNextClick,
              errors: props.errors,
              formtype: props.formtype,
              setError: props.setError,
              clearError: props.clearError,
              enterKeyInfo: props.enterKeyInfo,
              pageValue: props.pageValue ? props.pageValue : undefined,
              isShowNext: props.isShowNext,
              setIsShowNext: props.setIsShowNext,
              mode: props.mode,
              data: props.data,
              handleOnFormValueChange: props.handleOnFormValueChange,
              evalCondition: evalCondition,
              triggerValidation: props.triggerValidation,
              defaultCountryCode: props.defaultCountryCode,
              siteName: props.siteName
            });
          } else {
            return null;
          }
        } else {
          return /*#__PURE__*/React__default.createElement(SectionRenderer, {
            items: item.items,
            bgColor: bgColor,
            cssClass: get$1(item, 'fields["Css Class"].value', ''),
            displayName: item.displayName,
            register: props.register,
            key: item.id,
            watchers: props.watchers,
            actionItems: props.actionItems,
            activePage: props.activePage,
            onNextClick: props.onNextClick,
            clearError: props.clearError,
            setError: props.setError,
            siteName: props.siteName,
            errors: props.errors,
            formtype: props.formtype,
            enterKeyInfo: props.enterKeyInfo,
            pageValue: props.pageValue ? props.pageValue : undefined,
            isShowNext: props.isShowNext,
            setIsShowNext: props.setIsShowNext,
            mode: props.mode,
            data: props.data,
            handleOnFormValueChange: props.handleOnFormValueChange,
            evalCondition: evalCondition,
            triggerValidation: props.triggerValidation,
            defaultCountryCode: props.defaultCountryCode
          });
        }
      }
    } else return null;

    if (!isHidden) {
      if (actionItems[fieldKey]) {
        if (evalCondition(actionItems, fieldKey)) {
          var conditionalEl = /*#__PURE__*/React__default.createElement(FieldRenderer, {
            key: index,
            isConditional: true,
            fieldItem: item,
            register: props.register,
            onNextClick: props.onNextClick,
            errors: props.errors,
            formtype: props.formtype,
            clearError: props.clearError,
            enterKeyInfo: props.enterKeyInfo,
            pageValue: props.pageValue ? props.pageValue : undefined,
            isShowNext: props.isShowNext,
            setIsShowNext: props.setIsShowNext,
            mode: props.mode,
            data: props.data,
            handleOnFormValueChange: props.handleOnFormValueChange,
            evalCondition: evalCondition,
            setError: props.setError,
            defaultCountryCode: props.defaultCountryCode,
            siteName: props.siteName,
            triggerValidation: props.triggerValidation
          });
          var prevEl = props.items.find(function (el) {
            return get$1(el, 'fields[Field Key].value', '') === actionItems[fieldKey].depends;
          });
          var prevType = getFieldType(get$1(prevEl, 'fields[Field Type].url', ''));
          var portalContainer = prevEl && document.querySelector("[data-key=\"".concat(prevEl.id, "\"] div[data-value=\"").concat(actionItems[fieldKey].value, "\""));

          if (portalContainer && (prevType === RadioListType || prevType === CheckBox$1)) {
            return /*#__PURE__*/React__default.createElement(Portal, {
              container: portalContainer
            }, conditionalEl);
          } else {
            return conditionalEl;
          }
        } else {
          return null;
        }
      } else {
        return /*#__PURE__*/React__default.createElement(FieldRenderer, {
          key: index,
          fieldItem: item,
          register: props.register,
          onNextClick: props.onNextClick,
          errors: props.errors,
          formtype: props.formtype,
          enterKeyInfo: props.enterKeyInfo,
          clearError: props.clearError,
          pageValue: props.pageValue ? props.pageValue : undefined,
          isShowNext: props.isShowNext,
          setIsShowNext: props.setIsShowNext,
          mode: props.mode,
          data: props.data,
          handleOnFormValueChange: props.handleOnFormValueChange,
          evalCondition: evalCondition,
          triggerValidation: props.triggerValidation,
          setError: props.setError,
          defaultCountryCode: props.defaultCountryCode,
          siteName: props.siteName
        });
      }
    } else return null;
  }));
};

var style$6 = function style(theme) {
  var _consentSection, _sectionWrapper, _groupEnquiryCate, _CheckboxWrapperM2, _listIcon, _activeInputList;

  return {
    root: _defineProperty({
      paddingTop: theme.spacing(12),
      paddingBottom: theme.spacing(12)
    }, theme.breakpoints.down('md'), {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8)
    }),
    regularFormWrapper: _defineProperty({
      maxWidth: theme.typography.pxToRem(504),
      margin: '0 auto',
      marginTop: theme.spacing(9)
    }, theme.breakpoints.down('md'), {
      maxWidth: theme.typography.pxToRem(328),
      marginTop: theme.spacing(7)
    }),
    formListCon: {
      padding: 0,
      listStyle: 'none'
    },
    modalBackgroundColor: {
      '& .formTypeBright': _defineProperty({
        paddingTop: theme.typography.pxToRem(126)
      }, theme.breakpoints.down('md'), {
        paddingLeft: 0,
        paddingTop: theme.typography.pxToRem(85)
      }),
      '& ul[data-locator="Form-Page-Wrapper"]': _defineProperty({
        marginTop: theme.typography.pxToRem(36),
        padding: 0
      }, theme.breakpoints.down('md'), {
        marginTop: theme.typography.pxToRem(32)
      }),
      '& .activeList .formPageRender  .formButtonBox': _defineProperty({
        marginTop: theme.typography.pxToRem(185)
      }, theme.breakpoints.down('md'), {
        marginTop: theme.typography.pxToRem(164)
      }),
      '& .activeList.splashScreenPage .formPageRender  .formButtonBox': _defineProperty({
        marginTop: theme.typography.pxToRem(153)
      }, theme.breakpoints.down('md'), {
        marginTop: theme.typography.pxToRem(98)
      }),
      '& .activeList .formPageRender .MuiFormGroup-root:nth-child(1) .fieldlabel': _objectSpread2(_objectSpread2({}, theme.typography.h3), {}, {
        fontWeight: theme.typography.fontWeights.bolder,
        fontSize: theme.typography.T3,
        lineHeight: theme.typography.lineHeight.L3
      }),
      '& .activeList .formPageRender .MuiFormGroup-root:nth-child(2) .fieldlabel': _objectSpread2(_objectSpread2({}, theme.typography.body1), {}, _defineProperty({}, theme.breakpoints.down('md'), _objectSpread2({
        paddingTop: theme.spacing(3)
      }, theme.typography.body3)))
    },
    sectionActiveInputList: {
      '& .sectionWrapper': (_sectionWrapper = {
        borderRadius: theme.spacing(2),
        padding: theme.spacing(2, 3)
      }, _defineProperty(_sectionWrapper, theme.breakpoints.down('md'), {
        padding: theme.spacing(2.5, 2, 1.5, 2)
      }), _defineProperty(_sectionWrapper, '&.consentSection', (_consentSection = {
        padding: theme.spacing(3),
        marginTop: theme.spacing(6)
      }, _defineProperty(_consentSection, theme.breakpoints.down('md'), {
        padding: theme.spacing(3, 2)
      }), _defineProperty(_consentSection, '& .MuiTypography-body1', {
        lineHeight: theme.typography.lineHeight.L14
      }), _defineProperty(_consentSection, '& .privacyPolicy.fieldHeading', _objectSpread2(_objectSpread2({}, theme.typography.body3), {}, {
        marginBottom: 0,
        '& a': {
          color: fwdColors.darkGreen,
          '&:hover': {
            color: fwdColors.orange
          }
        }
      })), _defineProperty(_consentSection, '& .privacyPolicy.CheckboxWrapper', {
        paddingLeft: 0,
        minHeight: 'auto',
        marginTop: 0,
        marginBottom: 0,
        '& >.MuiTypography-root': {
          width: '100%'
        }
      }), _defineProperty(_consentSection, '& .MuiFormControlLabel-root', {
        padding: 0,
        marginRight: 0,
        marginLeft: theme.spacing(-1)
      }), _defineProperty(_consentSection, '& .MuiCheckbox-root', {
        padding: theme.spacing(0, 1),
        alignSelf: 'flex-start'
      }), _consentSection)), _sectionWrapper)
    },
    activeInputList: (_activeInputList = {
      position: 'relative',
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(7)
    }, _defineProperty(_activeInputList, theme.breakpoints.down('md'), {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(3)
    }), _defineProperty(_activeInputList, '& label.MuiFormLabel-root', {
      color: theme.palette.colors.white.contrastTextCaption,
      lineHeight: theme.typography.pxToRem(20)
    }), _defineProperty(_activeInputList, '& .disabled input.MuiOutlinedInput-input', {
      background: theme.palette.colors.grey.main,
      color: theme.palette.colors.white.line.textFieldDefault,
      borderRadius: theme.typography.pxToRem(4)
    }), _defineProperty(_activeInputList, '& .disabled [data-locator=Form-Section-InputBox] fieldset.MuiOutlinedInput-notchedOutline ', {
      border: 'none'
    }), _defineProperty(_activeInputList, '&.thankYouPage', _defineProperty({
      paddingTop: theme.typography.pxToRem(233)
    }, theme.breakpoints.down('md'), {
      paddingTop: theme.typography.pxToRem(180)
    })), _defineProperty(_activeInputList, '& [data-locator=Form-Section-Label-Hint]', {
      paddingTop: theme.spacing(1)
    }), _defineProperty(_activeInputList, '& [data-locator=Form-Section-Label-Error]', {
      position: 'relative',
      display: 'flex',
      top: 0,
      marginTop: theme.spacing(1),
      '& svg': {
        marginTop: theme.spacing(0.25)
      }
    }), _defineProperty(_activeInputList, '& .formPageRender [data-locator="Form-Section-Checkbox"].MuiFormGroup-root.CheckboxWrapper [data-locator=Form-Section-Label-Error]', {
      position: 'relative',
      top: 0,
      marginTop: 0
    }), _defineProperty(_activeInputList, '& .formPageRender .consentSection [data-locator="Form-Section-Checkbox"].MuiFormGroup-root.CheckboxWrapper [data-locator=Form-Section-Label-Error]', {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(3.5)
    }), _defineProperty(_activeInputList, '& .formPageRender .formButtonBox', _defineProperty({
      marginTop: theme.spacing(8),
      textAlign: 'center',
      animation: animations.fadeIn
    }, theme.breakpoints.down('md'), {
      marginTop: theme.spacing(6)
    })), _defineProperty(_activeInputList, '&.groupEnquiryFormPage .formPageRender .formButtonBox', _defineProperty({
      marginTop: theme.spacing(6),
      textAlign: 'center'
    }, theme.breakpoints.down('md'), {
      marginTop: theme.spacing(3)
    })), _defineProperty(_activeInputList, '& .formPageRender [data-locator=Form-Section-RadioBox]', {
      marginTop: -theme.spacing(1),
      marginBottom: theme.spacing(2),
      display: 'block',
      '& .MuiFormControlLabel-root': {
        paddingLeft: theme.typography.pxToRem(3)
      },
      '& label span': _defineProperty({}, theme.breakpoints.down('md'), {
        lineHeight: theme.typography.lineHeight.L9
      }),
      '& .MuiTypography-radioButton': {
        width: '100%'
      },
      '& [data-locator=Form-Section-Label-Error]': {
        marginTop: '0'
      },
      '& .MuiTypography-radioButton>.conditional': _defineProperty({
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1)
      }, theme.breakpoints.up('sm'), {
        marginTop: theme.spacing(0.5)
      }),
      '& .MuiTypography-radioButton:last-child .conditional': {
        marginBottom: '0'
      }
    }), _defineProperty(_activeInputList, '& .formPageRender>.MuiFormGroup-root', {
      marginBottom: theme.spacing(3),
      '&:nth-last-child(2)': {
        marginBottom: '0'
      }
    }), _defineProperty(_activeInputList, '& .formPageRender>.MuiFormGroup-root .MuiFormControl-root.MuiFormControl-marginNormal', {
      marginTop: theme.spacing(2.75)
    }), _defineProperty(_activeInputList, '& .formPageRender>.MuiFormGroup-root .MuiFormControl-root .MuiInputBase-multiline', {
      padding: theme.spacing(1.125, 0.5, 1.125, 1)
    }), _defineProperty(_activeInputList, '& .formPageRender>.MuiFormGroup-root .MuiFormControl-root .MuiInputBase-multiline .MuiInputBase-inputMultiline', {
      padding: '0',
      paddingRight: theme.spacing(3.5)
    }), _defineProperty(_activeInputList, '& .formPageRender>.MuiFormGroup-root .MuiFormControl-root .MuiFormLabel-filled, & .formPageRender>.MuiFormGroup-root > .MuiTypography-root .MuiFormLabel-root.Mui-focused', _defineProperty({
      top: -theme.spacing(0.5)
    }, theme.breakpoints.up('sm'), {
      top: -theme.spacing(0.75)
    })), _defineProperty(_activeInputList, '& .formPageRender .dateField', {
      minHeight: theme.spacing(7.75),
      width: '100%',
      marginBottom: theme.spacing(3),
      height: 'initial'
    }), _defineProperty(_activeInputList, '& .formPageRender .MuiFormGroup-root', {
      position: 'relative',
      minHeight: theme.spacing(7.75),
      '& .MuiInputBase-input, & .MuiOutlinedInput-input': {
        height: theme.spacing(2.25)
      },
      '& .dropdown-form-common-regular': {
        height: theme.spacing(5)
      },
      '&.group-enquiry-category-label': (_groupEnquiryCate = {
        minHeight: 0,
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(8),
        fontWeight: theme.typography.fontWeights.bolder,
        lineHeight: theme.typography.lineHeight.L9,
        color: theme.palette.colors.darkGreen.main
      }, _defineProperty(_groupEnquiryCate, theme.breakpoints.down('md'), {
        marginTop: theme.spacing(6)
      }), _defineProperty(_groupEnquiryCate, '&.first-label', _defineProperty({
        marginTop: theme.spacing(5)
      }, theme.breakpoints.down('md'), {
        marginTop: theme.spacing(3)
      })), _groupEnquiryCate),
      '&.firstName, &.lastName': {},
      '&.inline.firstName': _defineProperty({
        width: theme.typography.pxToRem(240),
        marginRight: theme.spacing(3)
      }, theme.breakpoints.down('md'), {
        width: theme.typography.pxToRem(152)
      }),
      '&.inline.lastName': _defineProperty({
        width: theme.typography.pxToRem(240)
      }, theme.breakpoints.down('md'), {
        width: theme.typography.pxToRem(152)
      }),
      //As per designs day & month has width=29.3% & month has width=41.4%
      '&.day': _defineProperty({
        width: '29.3%',
        paddingRight: theme.spacing(1.5)
      }, theme.breakpoints.down('md'), {
        paddingRight: theme.spacing(1)
      }),
      '&.month': _defineProperty({
        width: '41.4%',
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5)
      }, theme.breakpoints.down('md'), {
        minWidth: 'initial',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
      }),
      '&.year': _defineProperty({
        width: '29.3%',
        paddingLeft: theme.spacing(1.5)
      }, theme.breakpoints.down('md'), {
        paddingLeft: theme.spacing(1)
      }),
      '&.countryCodeInput, &.countryCodeDropDown': {
        width: theme.typography.pxToRem(87),
        marginRight: theme.spacing(3),
        '& label': {
          width: theme.typography.pxToRem(88)
        }
      },
      '&.telephoneInput': _defineProperty({
        width: theme.typography.pxToRem(393)
      }, theme.breakpoints.down('md'), {
        width: theme.typography.pxToRem(217)
      }),
      '&.fieldHeading': _objectSpread2(_objectSpread2({
        color: theme.palette.colors.white.contrastText
      }, theme.typography.body1), {}, {
        fontWeight: theme.typography.fontWeights.bolder,
        lineHeight: theme.typography.pxToRem(20),
        marginBottom: theme.spacing(2),
        minHeight: 'auto'
      }),
      '&.fieldHeading.innerField': {
        marginBottom: theme.spacing(1)
      },
      '&.formHeading': {
        marginBottom: 0,
        minHeight: 'auto',
        '& h1': _defineProperty({
          color: theme.palette.colors.white.contrastText,
          marginBottom: 0,
          paddingBottom: theme.spacing(3)
        }, theme.breakpoints.down('md'), {
          fontSize: theme.typography.T3,
          lineHeight: theme.typography.lineHeight.L3
        })
      },
      '&.CheckboxWrapper>.MuiTypography-root .MuiFormControlLabel-root': _defineProperty({}, theme.breakpoints.down('md'), {
        alignItems: 'flex-start'
      }),
      '&.CheckboxWrapper>.MuiTypography-root': (_CheckboxWrapperM2 = {
        '& .conditional': {
          marginBottom: theme.spacing(1),
          marginTop: theme.spacing(0)
        },
        '&:last-child .conditional': {
          marginBottom: '0'
        }
      }, _defineProperty(_CheckboxWrapperM2, theme.breakpoints.up('md'), {
        width: '50%',
        display: 'inline-block',
        verticalAlign: 'top',
        '& .spacerBox:empty': {
          display: 'none'
        }
      }), _defineProperty(_CheckboxWrapperM2, '&[data-locator=Form-Section-Label-Error]', {
        display: 'block'
      }), _CheckboxWrapperM2),
      '&.CheckboxWrapper': {
        marginBottom: theme.spacing(2),
        // marginTop: -theme.spacing(1), commenting for future
        '& [data-locator=Form-Section-Label-Error]': {
          top: theme.spacing(-1)
        }
      },
      '&.hasConditional.CheckboxWrapper>.MuiTypography-root': _defineProperty({}, theme.breakpoints.up('md'), {
        width: '100%'
      }),
      '&.CheckboxWrapper>.MuiTypography-root .MuiButtonBase-root': _defineProperty({}, theme.breakpoints.down('md'), {
        paddingTop: 0
      })
    }), _defineProperty(_activeInputList, '& .formPageRender > .MuiFormGroup-root.multilineFieldWithValue', {
      marginBottom: theme.spacing(3)
    }), _defineProperty(_activeInputList, '& .formPageRender [data-locator="Form-Section-Checkbox"] .MuiTypography-body1', {
      fontSize: theme.typography.body1.fontSize,
      fontWeight: theme.typography.body1.fontWeight
    }), _defineProperty(_activeInputList, '& .formPageRender [data-locator="Form-Section-Checkbox"]', {
      '& label.MuiFormControlLabel-root': {
        paddingLeft: theme.typography.pxToRem(3)
      }
    }), _defineProperty(_activeInputList, '& .formPageRender .formNextButton>div', {
      display: 'block'
    }), _defineProperty(_activeInputList, '& .formPageRender [data-locator="Form-Section-Tooltip"]', _defineProperty({
      paddingTop: theme.spacing(8),
      textAlign: 'center'
    }, theme.breakpoints.down('md'), {
      paddingTop: theme.spacing(6)
    })), _defineProperty(_activeInputList, '& .formPageRender .inline', {
      display: 'inline-block',
      verticalAlign: 'top'
    }), _defineProperty(_activeInputList, '& .formNextButton, .privacyPolicyCheckbox', {
      position: 'relative',
      top: '30px',
      transition: 'all .5s',
      opacity: 0,
      visibility: 'hidden'
    }), _defineProperty(_activeInputList, '& .formNextButton.activeButton, .privacyPolicyCheckbox.activeCheckbox', {
      position: 'relative',
      top: theme.spacing(1),
      bottom: 0,
      opacity: 1,
      visibility: 'visible',
      '& .MuiCheckbox-root': {
        paddingTop: 0,
        paddingBottom: 0,
        alignSelf: 'flex-start'
      }
    }), _defineProperty(_activeInputList, '& .formNextButton.activeButton', {
      top: theme.spacing(0)
    }), _defineProperty(_activeInputList, '&.editModeList .formNextButton', {
      maxHeight: theme.spacing(4)
    }), _defineProperty(_activeInputList, '&.editModeList .formNextButton.activeButton', {
      maxHeight: '100%'
    }), _defineProperty(_activeInputList, '& .formNextButton button', {
      position: 'relative',
      zIndex: 1
    }), _defineProperty(_activeInputList, '& .formPageRender .block', {
      display: 'block'
    }), _defineProperty(_activeInputList, '& .formPageRender .MuiInputBase-root', {
      lineHeight: theme.typography.pxToRem(20),
      marginTop: 0
    }), _defineProperty(_activeInputList, '& .formPageRender .MuiInputBase-root[data-locator=Form-Section-Dropdown]', {
      lineHeight: theme.typography.pxToRem(27)
    }), _defineProperty(_activeInputList, '& .MuiInputBase-root:not([data-locator="Form-Section-Dropdown"]) .MuiFormControl-root', {
      verticalAlign: 'baseline !important'
    }), _defineProperty(_activeInputList, '& .listIcon', (_listIcon = {
      height: theme.spacing(2),
      width: theme.spacing(2),
      position: 'absolute',
      display: 'block',
      left: theme.spacing(-4),
      top: theme.typography.pxToRem(46),
      borderRadius: '50%'
    }, _defineProperty(_listIcon, theme.breakpoints.down('md'), {
      top: theme.typography.pxToRem(30)
    }), _defineProperty(_listIcon, '&:before', {
      content: '" "',
      height: theme.typography.pxToRem(14),
      width: theme.typography.pxToRem(14),
      position: 'absolute',
      border: '3px solid #fff',
      left: 1,
      top: 1,
      borderRadius: '50%'
    }), _listIcon)), _defineProperty(_activeInputList, '&.conditionalPage .listIcon', {
      opacity: 0
    }), _defineProperty(_activeInputList, '& .conditional', {
      padding: theme.spacing(3),
      background: fwdColors.orangeLighter,
      marginTop: -theme.spacing(1.5),
      '&:before': {
        content: '" "',
        width: '0',
        height: '0',
        left: theme.spacing(2.75),
        top: -theme.spacing(1),
        position: 'absolute',
        borderLeft: "".concat(theme.spacing(1), "px solid transparent"),
        borderRight: "".concat(theme.spacing(1), "px solid transparent"),
        borderBottom: "".concat(theme.spacing(1), "px solid ").concat(fwdColors.orangeLighter)
      }
    }), _defineProperty(_activeInputList, '& .formPageRender .multilineFieldWithValue', {
      '& .MuiOutlinedInput-multiline': {
        padding: 0,
        paddingRight: theme.spacing(0.5)
      }
    }), _activeInputList)
  };
};

var useStyles$s = makeStyles(function (theme) {
  return style$6(theme);
});
var formValues = {};
var formSubmittedValues = "{}";
var formFields = {};
var pagesClassname = {};
var actionItems = {};
var pageArray = [];
var pageNames = {};
var apiNameMapper = {};
var conditionalPages = [];
var hiddenApiNames = {};
var consentVer = "";
var dobFieldKey = "";
var defaultCountryCode = "";
var GroupEnquiryForm$1 = function GroupEnquiryForm(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      fields = _useState2[0],
      setFields = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      params = _useState4[0],
      setParams = _useState4[1];

  var _props$apiStatus = props.apiStatus,
      errorCode = _props$apiStatus.errorCode,
      loading = _props$apiStatus.loading,
      apiStatus = _props$apiStatus.apiStatus;
  useEffect(function () {
    setFields(props.fields);
    setParams(props.params);
  }, []); // const { t } = useTranslation();

  var dictionary = get$1(props, "dictionary", {
    apiErrorMessageForm: "Sorry, we’ve encountered an error. Please try again.",
    sending: "We're working on it...  <br>A moment please.",
    enterKeyInfo: "or hit enter to continue"
  });

  var t = function t(key) {
    return dictionary[key];
  };

  var getKeyByValue = function getKeyByValue(object, value) {
    return Object.keys(object).find(function (key) {
      return object[key].indexOf(value) !== -1;
    });
  };

  var _props$sectionBackgro = props.sectionBackgroundColor,
      sectionBackgroundColor = _props$sectionBackgro === void 0 ? "grey" : _props$sectionBackgro;

  var _getColors = getColors(sectionBackgroundColor),
      surfaceColor = _getColors.surfaceColor;

  var classes = useStyles$s({
    surfaceColor: surfaceColor
  });
  var locationType = get$1(props, "sitecoreContext.site.name", locations.TH) || locations.TH;

  var _useForm = useForm({
    mode: "onBlur"
  }),
      register = _useForm.register,
      watch = _useForm.watch,
      errors = _useForm.errors,
      getValues = _useForm.getValues,
      setValue = _useForm.setValue,
      triggerValidation = _useForm.triggerValidation,
      clearError = _useForm.clearError,
      setError = _useForm.setError;

  var activePageList = useRef();
  var gaCategoryName = get$1(props, "fields.gaCategoryName.value", "");
  var conditionalItemID;

  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      userEmail = _useState6[0],
      setUserEmail = _useState6[1];

  var _useState7 = useState(""),
      _useState8 = _slicedToArray(_useState7, 2),
      userPrefferedTime = _useState8[0],
      setUserPrefferedTime = _useState8[1];

  var _useState9 = useState(""),
      _useState10 = _slicedToArray(_useState9, 2),
      userPrefferedDay = _useState10[0],
      setUserPrefferedDay = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      modalDarkMode = _useState12[0],
      setModalDarkMode = _useState12[1];

  var _useState13 = useState(true),
      _useState14 = _slicedToArray(_useState13, 2),
      isShowNext = _useState14[0],
      setIsShowNext = _useState14[1];

  var _useState15 = useState(true),
      _useState16 = _slicedToArray(_useState15, 2),
      isSubmitDisable = _useState16[0],
      setIsSubmitDisable = _useState16[1];

  var _useState17 = useState(null),
      _useState18 = _slicedToArray(_useState17, 2),
      activePage = _useState18[0],
      setActivePage = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      isRecurssionDone = _useState20[0],
      setIsRecurssionDone = _useState20[1];

  var _useState21 = useState(getValues()),
      _useState22 = _slicedToArray(_useState21, 2),
      formStateValue = _useState22[0],
      setFormStateValue = _useState22[1];

  var watchers = watch();

  function getHiddenData(i) {
    var apiName = get$1(i, "fields.apiName.fields.value.value", "");
    var apiKey = get$1(i, "fields.apiName.fields.key.value", "");
    var isHidden = get$1(i, "fields.isHidden.value", "");
    var hiddenOptions = transform(get$1(i, "items", []), function (r, o) {
      /* istanbul ignore else */
      if (get$1(o, "displayName", null)) {
        r[get$1(o, "displayName").toLowerCase()] = get$1(o, "fields.key.value", "") ? o.fields.key.value : get$1(o, "fields.value.value", "");
      }
    }, {}); //for hidden api text fields

    var hiddenText = transform(i, function (result, value, key) {
      var _value$Text, _value$apiName, _value$apiName$fields, _value$apiName$fields2;

      var text = (_value$Text = value.Text) === null || _value$Text === void 0 ? void 0 : _value$Text.value;
      var apiKeyHiddenText = (_value$apiName = value.apiName) === null || _value$apiName === void 0 ? void 0 : (_value$apiName$fields = _value$apiName.fields) === null || _value$apiName$fields === void 0 ? void 0 : (_value$apiName$fields2 = _value$apiName$fields.key) === null || _value$apiName$fields2 === void 0 ? void 0 : _value$apiName$fields2.value;
      /* istanbul ignore else */

      if (key === "fields" && text && apiKeyHiddenText) result[apiKeyHiddenText] = text;
    }, {});
    apiName && isHidden && Object.assign(hiddenApiNames, _defineProperty({}, apiKey, _objectSpread2({
      apiName: apiName,
      hiddenOptions: hiddenOptions
    }, !isEmpty(hiddenText) && {
      hiddenText: hiddenText[apiKey]
    })));
  }

  function setCondition(item) {
    var parentId = "";
    /* istanbul ignore else */

    if (item && item.fields && item.fields["Conditions"]) {
      var fieldType = item.fields["Field Type"] ? item.fields["Field Type"] : "";
      var fieldTypeUrl = getFieldType(fieldType.url);
      var tempFieldObj = {};
      var pageStyleName = item.fields["Css Class"].value;
      /* istanbul ignore else */

      if (pageStyleName.indexOf("conditionPage") !== -1) {
        conditionalPages.push(item.id);
      }

      conditionalItemID = item.id;
      /* istanbul ignore else */

      if (fieldTypeUrl === PageType) {
        parentId = item.id;
        formValues = Object.assign(formValues, _defineProperty({}, parentId, {}));
      }
      /* istanbul ignore else */


      if (fieldTypeUrl) {
        item.items && item.items.forEach(function (i) {
          /* istanbul ignore else */
          if (parentId === item.id) {
            /* istanbul ignore else */
            if (i.fields["Field Key"]) {
              getHiddenData(i);
              apiNameMapper[[i.fields["Field Key"].value]] = i.fields["Field Key"].value;
              /**
               * get last saved data in form !(for first flow of form)
               */

              /* istanbul ignore else */

              if (formSubmittedValues.length > 2) {
                formValues = JSON.parse(formSubmittedValues);
              } else {
                var _i$fields$apiName, _i$fields$apiName$fie, _i$fields$apiName$fie2, _i$fields$apiName2, _i$fields$apiName2$fi, _i$fields$apiName2$fi2;

                /**
                 * create new formFields (for first flow of form)
                 */
                Object.assign(tempFieldObj, _defineProperty({}, i.fields["Field Key"].value, i.displayName));

                if (((_i$fields$apiName = i.fields.apiName) === null || _i$fields$apiName === void 0 ? void 0 : (_i$fields$apiName$fie = _i$fields$apiName.fields) === null || _i$fields$apiName$fie === void 0 ? void 0 : (_i$fields$apiName$fie2 = _i$fields$apiName$fie.value) === null || _i$fields$apiName$fie2 === void 0 ? void 0 : _i$fields$apiName$fie2.value) === "dob") {
                  dobFieldKey = i.fields["Field Key"].value;
                }

                if (((_i$fields$apiName2 = i.fields.apiName) === null || _i$fields$apiName2 === void 0 ? void 0 : (_i$fields$apiName2$fi = _i$fields$apiName2.fields) === null || _i$fields$apiName2$fi === void 0 ? void 0 : (_i$fields$apiName2$fi2 = _i$fields$apiName2$fi.value) === null || _i$fields$apiName2$fi2 === void 0 ? void 0 : _i$fields$apiName2$fi2.value) === "countryCode") {
                  defaultCountryCode = i.fields["Default Value"].value;
                }

                var sectionType = i.fields["Field Type"] ? i.fields["Field Type"] : "";
                var sectionTypeUrl = getFieldType(sectionType.url);
                /* istanbul ignore else */

                if (sectionTypeUrl === "section") {
                  if (i.items.length > 0) {
                    i.items.forEach(function (sectionItem) {
                      var sectionOptions = {};
                      /* istanbul ignore else */

                      if (sectionItem.items.length > 0) {
                        getHiddenData(sectionItem);
                        sectionItem.items.forEach(function (o) {
                          /* istanbul ignore else */
                          if (o.name === GroupEnquiryPages.PRIVACYPOLICY_SECTION) {
                            consentVer = get$1(o, "fields.key.value", "");
                          }
                          /* istanbul ignore else */


                          if (get$1(o, "fields.value.value", null)) {
                            var key = get$1(o, "fields.key.value", "") || "";
                            sectionOptions[get$1(o, "fields.value.value")] = key;
                          }
                        });
                      }

                      formValues = Object.assign(formValues, _defineProperty({}, parentId, _objectSpread2(_objectSpread2({}, formValues[parentId]), {}, _defineProperty({}, sectionItem.fields["Field Key"].value, {
                        label: get$1(sectionItem, "fields.Text.value", ""),
                        apiName: get$1(sectionItem, "fields.apiName.fields.value.value", ""),
                        value: "",
                        display: sectionItem.displayName,
                        options: sectionOptions,
                        isRequired: get$1(sectionItem, "fields.Required.value", false),
                        isHidden: get$1(sectionItem, "fields.isHidden.value", false)
                      }))));
                    });
                  }
                } else if (sectionTypeUrl === "dob") {
                  formValues = Object.assign(formValues, _defineProperty({}, parentId, _objectSpread2(_objectSpread2({}, formValues[parentId]), {}, _defineProperty({}, i.fields["Field Key"].value, {
                    label: get$1(i, "fields.Text.value", ""),
                    apiName: get$1(i, "fields.apiName.fields.value.value", ""),
                    value: "",
                    display: i.displayName,
                    isRequired: true,
                    isHidden: get$1(i, "fields.isHidden.value", false)
                  }))));
                } else {
                  var options = {};

                  if (i.items.length > 0) {
                    i.items.forEach(function (o) {
                      if (get$1(o, "fields.value.value", null)) {
                        var key = get$1(o, "fields.key.value", "") || "";
                        options[get$1(o, "fields.value.value")] = key;
                      }
                    });
                  }

                  formValues = Object.assign(formValues, _defineProperty({}, parentId, _objectSpread2(_objectSpread2({}, formValues[parentId]), {}, _defineProperty({}, i.fields["Field Key"].value, {
                    label: get$1(i, "fields.Text.value", ""),
                    apiName: get$1(i, "fields.apiName.fields.value.value", ""),
                    value: "",
                    display: i.displayName,
                    options: options,
                    isRequired: get$1(i, "fields.Required.value", false),
                    isHidden: get$1(i, "fields.isHidden.value", false)
                  }))));
                }
              }
            }
          }
        });
      }
      /* istanbul ignore else */


      if (fieldTypeUrl === PageType) {
        var _pageStyleName = item.fields["Css Class"].value;
        /* istanbul ignore else */

        if (item.name === "thankYouPage" || _pageStyleName.indexOf("conditionPage") !== -1) {
          conditionalPages.push(item.id);
        }

        pageArray.push(item.id);
        pagesClassname = Object.assign(pagesClassname, _defineProperty({}, item.id, item.fields["Css Class"].value));
        pageNames = Object.assign(pageNames, _defineProperty({}, item.id, item.name));
        formFields = item.items && item.items[0].fields.Text ? Object.assign(formFields, _defineProperty({}, item.id, _objectSpread2({
          label: item.items[0].fields.Text.value
        }, tempFieldObj))) : formFields;
      }

      var conditions = item.fields["Conditions"].value ? JSON.parse(item.fields["Conditions"].value) : "";
      /* istanbul ignore else */

      if (conditions.fieldConditions && conditions.fieldConditions.length > 0) {
        conditionalPages.push(conditionalItemID);

        var _iterator = _createForOfIteratorHelper(conditions.fieldConditions),
            _step;

        try {
          var _loop = function _loop() {
            var obj = _step.value;
            obj.actions.forEach(function (action) {
              actionItems[action.fieldId] = {
                depends: obj.conditions[0].fieldId,
                value: obj.conditions[0].value,
                operator: obj.conditions[0].operatorId === operations.eq ? "==" : "!=",
                show: action.actionTypeId === operations.show || action.actionTypeId === operations.enable
              };
            });
            obj.conditions.forEach(function (condition) {
              var defaultValue = formValues[activePage];
              watchers[condition.fieldId] = defaultValue ? watch(condition.fieldId, defaultValue[condition.fieldId]) : watch(condition.fieldId, "");
            });
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }

    item && item.items && item.items.forEach(function (next) {
      return setCondition(next);
    });
  }
  /**
   * handle submit button visibility
   */


  var handleSubmitVisibility = function handleSubmitVisibility() {
    var currentValue = getValues();
    var activePageObj = formValues[activePage];
    var count = 0;

    for (var _i = 0, _Object$entries = Object.entries(currentValue); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          fieldKey = _Object$entries$_i[0],
          fieldValue = _Object$entries$_i[1];

      if (["day", "month", "year", "dob"].includes(fieldKey) && dobFieldKey) {
        fieldKey = dobFieldKey;
      }
      /* istanbul ignore else */


      if (!isEmpty(activePageObj[fieldKey])) {
        var _activePageObj$fieldK = activePageObj[fieldKey],
            _activePageObj$fieldK2 = _activePageObj$fieldK.isHidden,
            isHidden = _activePageObj$fieldK2 === void 0 ? false : _activePageObj$fieldK2,
            _activePageObj$fieldK3 = _activePageObj$fieldK.isRequired,
            isRequired = _activePageObj$fieldK3 === void 0 ? false : _activePageObj$fieldK3;
        /* istanbul ignore else */

        if (isRequired === true && isHidden === false && isEmpty(fieldValue)) count += 1;
      }
    }

    if (count) {
      setIsSubmitDisable(true);
    } else {
      setIsSubmitDisable(false);
    }
  };

  useEffect(function () {
    setCondition(fields);
    setIsRecurssionDone(true);
  }, [fields]);
  useEffect(function () {
    if (isRecurssionDone) {
      setActivePage(pageArray[0]);
    }
  }, [isRecurssionDone, params]);
  /**
   * On Active Page Change
   */

  useEffect(function () {
    handleSubmitVisibility();
  }, [activePage, formStateValue]);

  var handleOnFormValueChange = function handleOnFormValueChange(key, val) {
    var currentValue = getValues();
    /* istanbul ignore else */

    if (key && val) {
      currentValue[key] = val;
      setValue("object", currentValue);
    }

    setFormStateValue(currentValue);
  };
  /**
   * On Next Button Click
   */


  var sitecore = get$1(props, "sitecoreContext", "") || "";
  var redirectURL = get$1(sitecore, "route.fields.redirectUrl.value.href", "") || "";

  var handleOnNextClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(type, pageId, emailTemplate, apiToQuery) {
      var currentValue, isValidated, _locationType$split$, groupEnquiryData, useActualProductName, expectedProductName, productName, expectedPlanName, dynamicFormParams, utmParams, edmTemplateUrl, MailURL, MailURLKey, SaveLeadURL, SaveLeadKey, apiListArr, payload, emailPayload, hiddenApiTextData, url, dataLayer, filteredGtmValues, property, entity;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(type === "backHome")) {
                _context.next = 3;
                break;
              }

              PushEvent({
                event: "buttonClick",
                buttonTitle: "Back to Home",
                componentName: gaCategoryName ? gaCategoryName : FORM_SECTION_BUTTON,
                destinationUrl: undefined
              });
              return _context.abrupt("return");

            case 3:
              currentValue = getValues();
              _context.t0 = errorCode === null || errorCode === "" || errorCode === "200";

              if (!_context.t0) {
                _context.next = 9;
                break;
              }

              _context.next = 8;
              return triggerValidation();

            case 8:
              _context.t0 = _context.sent;

            case 9:
              isValidated = _context.t0;

              /* istanbul ignore else */
              if (isValidated) {
                Object.keys(currentValue).forEach(function (fieldKey) {
                  var activePageObj = formValues[activePage];
                  var pageFieldObj = activePageObj[fieldKey === "dob" ? dobFieldKey : fieldKey];

                  if (pageFieldObj) {
                    pageFieldObj.value = currentValue[fieldKey];
                    activePageObj = _objectSpread2(_objectSpread2({}, activePageObj), {}, _defineProperty({}, fieldKey, pageFieldObj));
                    formValues[activePage] = activePageObj;
                  }
                });
              }
              /* istanbul ignore else */


              if (!(type === "submit" && isValidated)) {
                _context.next = 73;
                break;
              }

              _context.prev = 12;
              groupEnquiryData = props.groupEnquiryData;
              useActualProductName = get$1(sitecore, "route.fields.useActualProductName.value", false) || false;
              expectedProductName = get$1(sitecore, "route.fields.expectedProductName.value", "") || (groupEnquiryData === null || groupEnquiryData === void 0 ? void 0 : groupEnquiryData.productName); // FWDS-1719 Get actual product name for Business Enquiry Form / Group Enquiry Form if required

              productName = useActualProductName ? groupEnquiryData.productName : expectedProductName;
              expectedPlanName = (groupEnquiryData === null || groupEnquiryData === void 0 ? void 0 : groupEnquiryData.groupEnquiryInitializer) === enquiryInitializer.PLAN_CARD && groupEnquiryData !== null && groupEnquiryData !== void 0 && groupEnquiryData.planName ? groupEnquiryData.planName : "";
              dynamicFormParams = get$1(sitecore, "route.fields.dynamicFormParams.value", {}) || {};
              utmParams = {};
              /* istanbul ignore else */

              if (typeof window !== "undefined" && sessionStorage.getItem("utm_params")) {
                Object.assign(utmParams, _objectSpread2({}, JSON.parse(sessionStorage.getItem("utm_params"))));
              }

              edmTemplateUrl = generatelayoutServicePath(get$1(sitecore, "route.fields.formEmailTemplate.value.href", "") || "", sitecore.languageCode || sitecore.language);

              if (edmTemplateUrl.indexOf("http") === -1) {
                edmTemplateUrl = getDomain() + edmTemplateUrl;
              }

              MailURL = "";
              MailURLKey = "";
              SaveLeadURL = "";
              SaveLeadKey = "";
              apiListArr = get$1(sitecore, "route.fields.apiList", []) || [];
              apiListArr.length > 0 && apiListArr.forEach(function (apiList) {
                var apiName = get$1(apiList, "fields.apiName.value", "") || "";

                if (apiName === "SaveLead") {
                  SaveLeadURL = get$1(apiList, "fields.value.value", "") || "";
                  SaveLeadKey = get$1(apiList, "fields.key.value", "") || "";
                } else if (apiName === "Email") {
                  MailURL = get$1(apiList, "fields.value.value", "") || "";
                  MailURLKey = get$1(apiList, "fields.key.value", "") || "";
                }
              });
              payload = {
                data: {},
                email: {}
              };
              emailPayload = {
                data: {},
                email: {}
              };
              values(formValues).forEach(function (page) {
                values(page).forEach(function (field) {
                  if (field.apiName !== "") {
                    Object.assign(emailPayload.data, _defineProperty({}, field.apiName, Array.isArray(field.value) ? field.value.join(", ") : removeTag(field.value))); // currently only for TH saveLead we need key of the fields in the API

                    isEmpty(field.options) || locationType === locations.PH ? Object.assign(payload.data, _defineProperty({}, field.apiName, field.value)) : Object.assign(payload.data, _defineProperty({}, field.apiName, Array.isArray(field.value) ? field.value.map(function (input) {
                      return field.options[input];
                    }).join(",") : removeTag(field.options[field.value])));
                  }
                });
              }); //hiddenFields which are pre-field by the author

              hiddenApiTextData = transform(hiddenApiNames, function (result, value) {
                if (value.hiddenText) result[value.apiName] = value.hiddenText;
              }, {});

              if (typeof window !== "undefined" && get$1(hiddenApiNames, "mediaSource.apiName", "")) {
                url = new URLSearchParams(window.location.search);

                if (url.has("mediaSource") || url.has("MediaSource")) {
                  payload.data[hiddenApiNames.mediaSource.apiName] = url.get("mediaSource") || url.get("MediaSource");
                }
              } // FWDS-1943 Add consent version cd in email payload


              if (consentVer && get$1(hiddenApiNames, "ConsentVersionCd.apiName", "")) {
                payload.data[hiddenApiNames.ConsentVersionCd.apiName] = consentVer;
              }

              if (payload.data.hasOwnProperty("countryCode") && payload.data.hasOwnProperty("cellPhone")) {
                if (locationType === locations.TH) {
                  emailPayload.data.cellPhone = payload.data.cellPhone;
                } else {
                  emailPayload.data.cellPhone = payload.data.countryCode + " " + payload.data.cellPhone;
                  payload.data.cellPhone = payload.data.countryCode + " " + payload.data.cellPhone;
                  if (emailPayload.data.countryCode) delete emailPayload.data.countryCode;
                }
              }
              /* istanbul ignore else */


              if (productName) {
                payload.data.expectedProductName = emailPayload.data.expectedProductName = productName; //for HK the emailPayload data key should be 'productName' (sendEmail API)

                /* istanbul ignore next */

                if (locationType === "fwd-hk") {
                  emailPayload.data.productName = productName;
                  delete emailPayload.data.expectedProductName;
                }
              }
              /* istanbul ignore else */


              if (expectedPlanName) {
                payload.data.expectedPlanName = emailPayload.data.expectedPlanName = expectedPlanName;
              }
              /* istanbul ignore else */


              if (get$1(hiddenApiNames, "ConsentVersionCd.apiName", "")) {
                emailPayload.data[hiddenApiNames.ConsentVersionCd.apiName] = hiddenApiTextData[hiddenApiNames.ConsentVersionCd.apiName];
              }
              /* istanbul ignore else */


              if (payload.data.hasOwnProperty("consentCheckBox")) {
                emailPayload.data.consentMsg = payload.data.consentMsg = emailPayload.data.consentCheckBox;
                removeTag(emailPayload.data.consentMsg);
                emailPayload.data.consentCheckBox = "true";
                payload.data.consentCheckBox = "Y";
              } //not required anymore in saveLead


              delete payload.data.consentMsg;
              emailPayload.data.hasOwnProperty("preferredTime") && setUserPrefferedTime(emailPayload.data.preferredTime);
              emailPayload.data.hasOwnProperty("preferredDay") && setUserPrefferedDay(emailPayload.data.preferredDay);
              emailPayload.data.hasOwnProperty("email") && setUserEmail(emailPayload.data.email);
              /**
               * Google Analytics Start
               */

              dataLayer = {
                event: get$1(sitecore, "route.fields.gtmEventType.fields.key.value", "") || GTMdataLayerProperties.ENQUIRY_GROUP
              };
              filteredGtmValues = _objectSpread2({}, emailPayload.data);
              Object.keys(filteredGtmValues).forEach(function (key) {
                if (filteredGtmValues[key] === undefined) {
                  delete filteredGtmValues[key];
                }
              });
              Object.assign(dataLayer, setFormDataForGTM(filteredGtmValues));
              PushEvent(_objectSpread2({}, dataLayer));
              /**
               * Google Analytics End
               */

              payload.email.templateUrl = edmTemplateUrl;
              payload.email.parameters = emailPayload.data;
              payload.data.cellPhone = payload.data.cellPhone && payload.data.cellPhone.replace(" ", "");
              Object.assign(payload.data, _objectSpread2({}, dynamicFormParams));
              Object.assign(payload.data, _objectSpread2({}, utmParams)); //Putting this at last to give priority to author filled hiddenApiField texts

              Object.assign(payload.data, hiddenApiTextData);
              payload.lead = payload.data;
              delete payload.data; //removing empty properties if any

              for (property in payload.lead) {
                if (isEmpty(payload.lead[property])) delete payload.lead[property];
              }

              entity = locationType === null || locationType === void 0 ? void 0 : (_locationType$split$ = locationType.split("-")[1]) === null || _locationType$split$ === void 0 ? void 0 : _locationType$split$.toUpperCase();
              _context.t1 = apiToQuery;
              _context.next = _context.t1 === API.SAVE_LEAD ? 62 : _context.t1 === API.SEND_EMAIL ? 64 : 66;
              break;

            case 62:
              props.saveLeadAPI({
                apiUrl: SaveLeadURL,
                authorizationKey: SaveLeadKey,
                data: _objectSpread2({}, getPayloadData(payload)),
                entity: entity,
                dataValue: emailPayload.data
              });
              return _context.abrupt("break", 67);

            case 64:
              props.saveLeadAPI({
                apiUrl: MailURL,
                authorizationKey: MailURLKey,
                dataValue: emailPayload.data,
                data: {
                  user: {
                    profile: {
                      contact: {
                        email: {
                          templateUrl: edmTemplateUrl,
                          parameters: emailPayload.data
                        }
                      }
                    }
                  }
                },
                entity: entity,
                factorType: "EMAIL"
              });
              return _context.abrupt("break", 67);

            case 66:
              return _context.abrupt("break", 67);

            case 67:
              setModalDarkMode(false);
              _context.next = 73;
              break;

            case 70:
              _context.prev = 70;
              _context.t2 = _context["catch"](12);
              return _context.abrupt("return");

            case 73:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[12, 70]]);
    }));

    return function handleOnNextClick(_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }();

  var findValueFromArray = function findValueFromArray(array, key) {
    for (var i = 0, len = array.length; i < len; i++) {
      /* istanbul ignore else */
      if (Object.keys(array[i])[1] === key) {
        return array[i][key].value;
      }
    }

    return null;
  };
  /**
   * Conditionally render PageRenderer & SectionRenderer & FieldRenderer
   *  based no eval condition and show hide
   * {
      "4238ED94AA024B399222A8CD8D0CA23D": { - any thing
      "depends": "3C4023E8B86445F9BC50AEB6652C54B4",  - filed id to - handle item
      "value": "meetAnAgent",
      "operator": "!=",
      "show": false
    }
  },
  */


  var evalCondition = function evalCondition(_actionItems, fieldKey) {
    var watcherValue = "";
    var formFieldValue = Object.values(formValues);
    /* istanbul ignore else */

    if (_actionItems[fieldKey]) {
      if (watchers[_actionItems[fieldKey].depends]) {
        watcherValue = watchers[_actionItems[fieldKey].depends];
      } else {
        watcherValue = findValueFromArray(formFieldValue, _actionItems[fieldKey].depends);
      }
    } //A simple parser to evaluate [==] && [!=]


    var condition = "";

    if (_actionItems[fieldKey].operator === "==" && (watcherValue === _actionItems[fieldKey].value || watcherValue && watcherValue.includes(_actionItems[fieldKey].value)) || _actionItems[fieldKey].operator === "!=" && (watcherValue !== _actionItems[fieldKey].value || watcherValue && !watcherValue.includes(_actionItems[fieldKey].value))) {
      condition = true;
      /* istanbul ignore else */
    } else if (_actionItems[fieldKey].operator === "==" && watcherValue !== _actionItems[fieldKey].value || _actionItems[fieldKey].operator === "!=" && watcherValue === _actionItems[fieldKey].value) {
      condition = false;
    }
    /* istanbul ignore else */


    if (condition === _actionItems[fieldKey].show) {
      return true;
    }

    return false;
  };

  var editModeList = false;

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      showLoader = _useState24[0],
      setShowLoader = _useState24[1];

  useEffect(function () {
    if (errorCode && errorCode === 200) {
      setTimeout(function () {
        setShowLoader(loading);
      }, 5000);
    } else {
      setShowLoader(loading);
    }
  }, [loading]);
  useEffect(function () {
    /* istanbul ignore else */
    if (errorCode && errorCode === 200) {
      redirectURL && navigate(redirectURL);
      props.resetAPIStatus();
    }
  }, [errorCode]);
  var loaderBgcolor = get$1(params, "loaderBackgroundColor", "orange") || "orange";
  /* istanbul ignore else */

  if (!isRecurssionDone) return null;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(modalDarkMode && classes.modalBackgroundColor, modalDarkMode && "modalDarkMode")
  }, /*#__PURE__*/React__default.createElement("form", {
    id: "groupEnquiryForm",
    className: clsx("regularForm", classes.regularFormWrapper),
    autoComplete: "off",
    noValidate: true,
    "data-locator": CALLBACKFORM_PAGE_WRAPPER,
    onSubmit: function onSubmit(e) {
      return e.preventDefault();
    }
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    sm: 12
  }, /*#__PURE__*/React__default.createElement("div", null, errorCode && errorCode !== 200 && /*#__PURE__*/React__default.createElement(ApiErrorForms, {
    title: t("apiErrorMessageForm"),
    errors: apiStatus,
    formtype: params.formType
  }), showLoader && /*#__PURE__*/React__default.createElement("div", {
    className: classes.apiProgressWrapper
  }, /*#__PURE__*/React__default.createElement(Progress, {
    background: loaderBgcolor,
    title: t("sending"),
    pageCentered: true,
    showInModal: false
  })), /*#__PURE__*/React__default.createElement("ul", {
    className: classes.formListCon
  }, fields && fields.items && fields.items.map(function (item, index) {
    var PageRenderContent = activePage === item.id && [/*#__PURE__*/React__default.createElement("li", {
      key: index,
      "data-locator": CALLBACKFORM_FORMVALUE_LIST,
      ref: activePageList,
      className: clsx(classes.activeInputList, classes.sectionActiveInputList, "page-i".concat(index), "activeList", item.name, pagesClassname[item.id], editModeList , {
        conditionalPage: conditionalPages.indexOf(item.id) !== -1 || pagesClassname[item.id].indexOf("darkMode") !== -1
      })
    }, /*#__PURE__*/React__default.createElement(PageRenderer, {
      items: item.items,
      displayName: item.displayName,
      register: register,
      key: item.id,
      watchers: watchers,
      actionItems: actionItems,
      activePage: activePage,
      onNextClick: handleOnNextClick,
      errors: errors,
      formtype: props.params.formType,
      clearError: clearError,
      enterKeyInfo: t("enterKeyInfo"),
      mode: modalDarkMode ? "dark" : "light",
      pageValue: formValues[activePage] ? formValues[activePage] : undefined,
      isShowNext: isShowNext,
      setIsShowNext: setIsShowNext,
      data: {
        isSubmitDisable: isSubmitDisable
      },
      handleOnFormValueChange: handleOnFormValueChange,
      evalCondition: evalCondition,
      triggerValidation: triggerValidation,
      setError: setError,
      defaultCountryCode: defaultCountryCode,
      siteName: locationType
    }))];
    var thankyouPageId = getKeyByValue(pageNames, "thankYouPage");

    if (PageRenderContent[0] && PageRenderContent[0].ref.current && item.id === thankyouPageId) {
      PageRenderContent[0].props.children.props.items[1].fields.Text.value = PageRenderContent[0].props.children.props.items[1].fields.Text.value.replace("{weekday}", userPrefferedDay).replace("{time}", userPrefferedTime).replace("{email}", userEmail);
    }

    return PageRenderContent;
  })))))));
}; // const mapStateToProps = createStructuredSelector({

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$n = function styles(theme) {
  var colors = theme.palette.colors || {};
  var backgrounds = {};
  Object.keys(colors).forEach(function (color) {
    backgrounds["bgcolor-".concat(color)] = {
      backgroundColor: colors[color].main,
      color: colors[color].contrastText
    };
  });
  return _objectSpread2(_objectSpread2({
    wrapper: {
      '& section.MuiContainer-sectionRoot, & $containerWrapper': {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }
  }, backgrounds), {}, {
    containerWrapper: _defineProperty({
      height: 'auto',
      paddingTop: theme.typography.pxToRem(273),
      paddingBottom: theme.typography.pxToRem(201)
    }, theme.breakpoints.down('md'), {
      paddingTop: theme.typography.pxToRem(200),
      paddingBottom: theme.typography.pxToRem(144)
    }),
    contentWrapper: {
      maxWidth: theme.typography.pxToRem(600),
      width: '100%',
      '& .MuiTypography-h3 span': {
        fontWeight: theme.typography.fontWeights.bolder
      }
    },
    title: _defineProperty({
      marginBottom: theme.spacing(3)
    }, theme.breakpoints.down('md'), {
      fontSize: theme.typography.T3,
      lineHeight: theme.typography.lineHeight.L3
    }),
    linkWrapper: _defineProperty({
      textAlign: 'center',
      paddingTop: theme.spacing(8)
    }, theme.breakpoints.down('md'), {
      paddingTop: theme.spacing(6)
    })
  });
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var COMPONENT_CONTAINER$2 = 'Result-Container';
var COMPONENT_TITLE$5 = 'Result-Title';
var COMPONENT_DESCRIPTION$2 = 'Result-Description';
var COMPONENT_LINK$3 = 'Result-Link';
var COMPONENT_BUTTON$3 = 'Result-Button';

/**
 *
 * @param {object} field - contains a value that is to be truncated
 * @param {string} ellipsis -It is added to the end of the text in case it is truncated and default value is '...'
 */

var TruncateText = function TruncateText(props) {
  var field = props.field,
      content = props.content,
      _props$onResize = props.onResize,
      _onResize = _props$onResize === void 0 ? null : _props$onResize,
      _props$truncateProps = props.truncateProps,
      truncateProps = _props$truncateProps === void 0 ? null : _props$truncateProps,
      _props$ellipsis = props.ellipsis,
      ellipsis = _props$ellipsis === void 0 ? "..." : _props$ellipsis;

  var data = "";

  if (props.type && props.type.toLowerCase() === "richtext") {
    data =
    /*#__PURE__*/

    /**
     * ReactResizeDetector -help to handle the element resizes.
     *
     * @param {function} onResize -Function that will be invoked with width and height arguments
     * @param {boolean} handleWidth - Trigger onResize on width change and default value is false
     * @param {boolean} handleHeight -Trigger onResize on height change and default value is false
     */
    React__default.createElement(ReactResizeDetector, {
      handleWidth: true,
      handleHeight: true,
      onResize: function onResize() {
        _onResize && _onResize();
      }
      /**
      * Truncate - use HTML5 canvas for measuring text width to determine whether the provided text should be truncated.
      *
      @ param {number} lines - Specifies how many lines of text should be preserved until it gets truncated and default value is 1
      @ param {string} ellipsis -It is added to the end of the text in case it is truncated and default value is '...'
      @ param {string} className
      @ param {boolean} trimWhitespace -If true, whitespace will be removed from before the ellipsis and default value is `true`
       */
      ,
      render: function render() {
        return /*#__PURE__*/React__default.createElement(Truncate, _extends({
          lines: props.lines,
          ellipsis: "...",
          className: get$1(props, "className", ""),
          trimWhitespace: true
        }, truncateProps), /*#__PURE__*/React__default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: content
          }
        }));
      }
    });
  } else {
    if (field) {
      content = field.value;
    }

    data =
    /*#__PURE__*/

    /**
     * TruncateMarkup -it works for JSX markup and by using a binary search approach depending on the size of the markup, it usually takes only a few rerenders to get the final, truncated markup. 
     * 
      @ param {number} lines - Specifies how many lines of text should be preserved until it gets truncated and default value is 1
      @ param {string} ellipsis -It is added to the end of the text in case it is truncated and default value is '...'
      @ param {string} className
        */
    React__default.createElement(TruncateMarkup, {
      lines: props.lines,
      ellipsis: ellipsis
    }, /*#__PURE__*/React__default.createElement("div", {
      className: get$1(props, "className", "")
    }, content));
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, data);
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var useStyles$r = makeStyles(styles$n);
var Result$1 = function Result(props) {
  var groupEnquiryAPIName = props.groupEnquiryAPINameMapper || {};
  var flexiCol = parseInt(props.flexiCol) || null;
  var color = get$1(props, "params.backgroundColor", "") || "white";
  var surfaceColor = getColors(color).bgColor;
  var backgroundColor = getColors(color);
  var classes = useStyles$r();
  var link = get$1(props, "fields.link", null) || null;
  var linkType = link && link.value.linktype || null;
  var linkHref = link && link.value.href || null;
  var title = get$1(props, "fields.title", "") || "";
  var buttonMode = get$1(props, "fields.buttonMode.fields,key,value", "") || "Primary";
  var description = get$1(props, "fields.description", "") || "";
  var descriptionValue = get$1(description, "value", "") || "";
  var GTMSharedKey = get$1(props, "fields.linkGALabelName.value", "");
  var pageEditing = get$1(props, "sitecoreContext.pageEditing", false);

  for (var ApiName in groupEnquiryAPIName) {
    descriptionValue = descriptionValue.replace("{".concat(ApiName, "}"), groupEnquiryAPIName[ApiName]);
  }

  descriptionValue && (description.value = descriptionValue);

  var linkHandler = function linkHandler(e) {
    PushEvent({
      event: "buttonClick",
      buttonTitle: GTMSharedKey || getGTMSharedKeyVal(linkHref, COMPONENT_LINK$3),
      componentName: get$1(props, "fields.gaCategoryName.value", COMPONENT_LINK$3) || COMPONENT_LINK$3,
      destinationUrl: linkHref
    });

    if (linkType === "internal") {
      e.preventDefault();
      navigate(linkHref);
      /* istanbul ignore else */
    } else if (linkType === "external") {
      /* istanbul ignore else */
      if (typeof window !== "undefined") {
        window.open(linkHref, "_blank");
      }
    }
  };

  return pageEditing || title && title.value || description && description.value ? /*#__PURE__*/React__default.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React__default.createElement(Container$1, {
    useContainer: !flexiCol,
    "data-locator": COMPONENT_CONTAINER$2,
    background: surfaceColor,
    className: clsx(classes.containerWrapper, backgroundColor && classes["bgcolor-".concat(backgroundColor.bgColor)])
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.contentWrapper
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h3",
    component: "h3",
    className: classes.title,
    "data-locator": COMPONENT_TITLE$5,
    color: surfaceColor
  }, pageEditing ? title : /*#__PURE__*/React__default.createElement(TruncateText, {
    lines: 3,
    field: title
  })), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    "data-locator": COMPONENT_DESCRIPTION$2,
    color: surfaceColor,
    type: "richtext"
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description.value
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: classes.linkWrapper
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
    color: surfaceColor,
    outlined: buttonMode === "Primary" ? false : true,
    variant: buttonMode,
    alt: link.value.text,
    onClick: linkHandler,
    "data-locator": COMPONENT_BUTTON$3
  }, link.value.text))))) : null;
}; // const mapStateToProps = createStructuredSelector({

var style$5 = function style(theme) {
  var _slickPrev, _slickNext, _sliderWrap, _h, _MuiContainerRoot, _h2;

  var colors = theme.palette.colors || {};
  var theming = {};
  Object.keys(colors).forEach(function (color) {
    theming["articlecardlist-".concat(color)] = {
      '& .slick-prev, .slick-next': {
        color: theme.palette.colors[color].contrastTextAction,
        '&:hover': {
          color: theme.palette.colors[color].contrastTextAction
        }
      }
    };
  });
  return _objectSpread2(_objectSpread2({}, theming), {}, {
    dotMargin: _defineProperty({
      marginBottom: theme.spacing(2)
    }, theme.breakpoints.up('sm'), {
      marginBottom: 0
    }),
    sliderWrap: {
      '& h4': {
        marginBottom: theme.spacing(1)
      },
      '& .MuiTypography-gutterBottom': {
        marginBottom: theme.spacing(1)
      },
      '& .slick-list ': {
        margin: 0
      },
      '& .slick-slide ': {
        padding: '0'
      },
      '& .slick-prev, .slick-next': {
        width: theme.typography.pxToRem(32),
        height: theme.typography.pxToRem(32),
        zIndex: '1'
      },
      '& .slick-prev': (_slickPrev = {
        transform: 'translate(0, -50%) rotate(180deg)',
        left: theme.spacing(-2)
      }, _defineProperty(_slickPrev, theme.breakpoints.up('xl'), {
        left: theme.spacing(-4)
      }), _defineProperty(_slickPrev, '&:hover', {
        backgroundColor: alpha(fwdColors.orange, 0.2),
        borderRadius: theme.spacing(0.5)
      }), _slickPrev),
      '& .slick-next': (_slickNext = {
        right: theme.spacing(-2)
      }, _defineProperty(_slickNext, theme.breakpoints.up('xl'), {
        right: theme.spacing(-4)
      }), _defineProperty(_slickNext, '&:hover', {
        backgroundColor: alpha(fwdColors.orange, 0.2),
        borderRadius: theme.spacing(0.5)
      }), _slickNext),
      '& .slick-dots': {
        width: 'auto',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1,
        bottom: theme.spacing(-1.95),
        paddingLeft: theme.spacing(0.25),
        paddingRight: theme.spacing(0.25)
      },
      '& .slick-disabled ': {
        opacity: '0',
        pointerEvents: 'none'
      },
      '& .MuiContainer-maxWidthXl': {
        padding: 0
      }
    },
    sliderWrap2: (_sliderWrap = {
      marginBottom: theme.spacing(3),
      width: 'calc(100% + 24px)',
      marginLeft: theme.spacing(-1.5)
    }, _defineProperty(_sliderWrap, theme.breakpoints.down('sm'), {
      marginLeft: theme.spacing(0)
    }), _defineProperty(_sliderWrap, '& .slick-list ', _defineProperty({
      marginTop: theme.spacing(-3),
      paddingTop: theme.spacing(3),
      marginBottom: theme.spacing(-3),
      paddingBottom: theme.spacing(3),
      margin: 0,
      overflow: 'hidden'
    }, theme.breakpoints.down('sm'), {
      overflow: 'visible',
      marginLeft: theme.spacing(-0.5)
    })), _defineProperty(_sliderWrap, '& .slick-track', _defineProperty({}, theme.breakpoints.down('sm'), {
      display: 'flex',
      '& .slick-slide': {
        height: 'auto',
        '&>div': {
          height: '100%',
          '&>section,>div': {
            height: '100%'
          }
        }
      },
      '& [data-locator=PrivilegeCard-Button-Wrapper]': {
        bottom: '0'
      },
      '& [data-locator=PrivilegeCard-Title]': {
        height: 'unset'
      }
    })), _defineProperty(_sliderWrap, '& .slick-slide', _defineProperty({
      paddingRight: theme.spacing(1.5),
      paddingLeft: theme.spacing(1.5)
    }, theme.breakpoints.down('sm'), {
      paddingRight: 0,
      paddingLeft: 0,
      marginLeft: theme.typography.pxToRem(1),
      minWidth: theme.typography.pxToRem(296)
    })), _defineProperty(_sliderWrap, '& .slick-active, .slick-current', {
      width: 'unset'
    }), _defineProperty(_sliderWrap, '& .slick-prev, .slick-next', {
      width: theme.spacing(4),
      height: theme.spacing(4),
      zIndex: '7',
      '&:hover': {
        backgroundColor: alpha(fwdColors.orange, 0.2),
        borderRadius: theme.spacing(0.5)
      }
    }), _defineProperty(_sliderWrap, '& .slick-prev', {
      left: theme.spacing(-4.5),
      transform: 'translate(0, -50%) rotate(180deg)'
    }), _defineProperty(_sliderWrap, '& .slick-next', {
      right: theme.spacing(-4.5)
    }), _defineProperty(_sliderWrap, '& .slick-disabled ', {
      opacity: '0',
      pointerEvents: 'none'
    }), _sliderWrap),
    gridCardMargin: {
      paddingBottom: theme.spacing(3)
    },
    customMargin: {
      marginBottom: theme.spacing(-3)
    },
    privilegeCard: {
      width: '100%',
      height: '100%',
      position: 'relative',
      '&.MuiContainer-root': {
        padding: 0
      }
    },
    root: {
      '& h2': (_h = {
        marginBottom: theme.spacing(3),
        paddingBottom: '0'
      }, _defineProperty(_h, theme.breakpoints.up('sm'), {
        marginBottom: theme.spacing(6)
      }), _defineProperty(_h, "fontWeight", theme.typography.fontWeights.bolder), _h)
    },
    rootPrivilege: {
      '&.MuiContainer-root': (_MuiContainerRoot = {}, _defineProperty(_MuiContainerRoot, theme.breakpoints.down('lg'), {
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6)
      }), _defineProperty(_MuiContainerRoot, theme.breakpoints.down('sm'), {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
      }), _MuiContainerRoot),
      '& h2': (_h2 = {
        marginBottom: theme.spacing(3),
        paddingBottom: '0'
      }, _defineProperty(_h2, theme.breakpoints.up('sm'), {
        marginBottom: theme.spacing(6)
      }), _defineProperty(_h2, "fontWeight", theme.typography.fontWeights.bolder), _h2),
      '& [data-locator=ArticleCardList-Slider]': {
        margin: '0'
      }
    },
    gridCard: _defineProperty({
      padding: '0',
      marginBottom: theme.spacing(6)
    }, theme.breakpoints.down('sm'), {
      marginBottom: theme.spacing(3)
    }),
    linkWrapper: {
      display: 'flex',
      margin: '0',
      '& .startIcon': {
        marginRight: theme.spacing(0.5)
      },
      '& a': {
        textDecoration: 'none',
        fontWeight: theme.typography.fontWeights.bolder,
        fontSize: theme.spacing(2),
        lineHeight: theme.typography.lineHeight.L9
      },
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        __expression__: 'all and (-ms-high-contrast: none), (-ms-high-contrast: active)',
        '& a': {
          top: theme.spacing(0.25),
          position: 'relative'
        }
      }
    },
    title: {
      maxWidth: theme.spacing(101)
    },
    slideWrap: _defineProperty({}, theme.breakpoints.down('sm'), {
      display: 'flex',
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5)
    })
  });
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var ARTICLE_CARD_LIST_CONTAINER = 'ArticleCardList-Container';
var ARTICLE_CARD_LIST_NEXT_BUTTON = 'ArticleCardList-next-button';
var ARTICLE_CARD_LIST_PREV_BUTTON = 'ArticleCardList-prev-button';
var ARTICLE_CARD_LIST_TITLE = 'ArticleCardList-Title';
var ARTICLE_CARD_SLIDER = 'ArticleCardList-Slider';
var ARTICLE_CARD_LINK = 'ArticleCardList-Link';

var styles$m = function styles(theme) {
  var _cardVariantMedium, _$cardContent, _cardTitleVariantMedi, _cardDescriptionVaria;

  var colors = theme.palette.colors || {};
  var cardBackgrounds = {};
  Object.keys(colors).forEach(function (color) {
    cardBackgrounds["cardContentColored-".concat(color)] = {
      backgroundColor: colors[color].main
    };
  });
  return _objectSpread2(_objectSpread2({
    hasMargin: {
      margin: theme.spacing(2),
      width: "calc(100% - ".concat(theme.spacing(4), "px)")
    },
    card: {
      width: "100%",
      overflow: "hidden",
      "&:hover": {
        boxShadow: theme.shadows[4]
      }
    },
    cardVariantLarge: _defineProperty({
      "& $cardTitle": _defineProperty({}, theme.breakpoints.down("md"), {
        fontSize: theme.typography.pxToRem(20),
        lineHeight: "25px"
      }),
      "& $cardKeywords": {
        maxHeight: theme.spacing(8),
        overflow: "hidden"
      }
    }, theme.breakpoints.up("md"), {
      "& $cardContentWrapper": {
        width: "34%",
        height: "455px",
        display: "flex"
      },
      "& $cardActions": {
        display: "flex"
      },
      "& $cardMedia": {
        width: "66%",
        height: "455px",
        position: "relative",
        "& picture": {
          height: "100%"
        }
      },
      "& $cardContent": {
        padding: theme.spacing(6, 3),
        position: "relative"
      },
      "& $cardDescription": {
        display: "block",
        maxHeight: theme.spacing(15)
      },
      "& $cardKeywords": {
        position: "absolute",
        bottom: theme.spacing(6)
      },
      "& $cardTitle": {
        flex: "none"
      }
    }),
    easingInOut: {
      transitionTimingFunction: "".concat(transitionFunction.easeInOut)
    },
    easingOut: _defineProperty({
      transitionTimingFunction: "".concat(transitionFunction.easeOut)
    }, theme.breakpoints.down("sm"), {
      display: "none"
    }),
    cardVariantMedium: (_cardVariantMedium = {
      position: "relative",
      "& $cardContentWrapper": {
        display: "flex",
        flexDirection: "column"
      },
      "& $cardKeywords": {
        maxHeight: theme.spacing(8),
        overflow: "hidden"
      }
    }, _defineProperty(_cardVariantMedium, theme.breakpoints.up("md"), {
      "& $cardContent": {
        // padding: theme.spacing(2, 3, 3, 3),
        // ONEWEB-38, update padding for Medium CardVariant based on new design
        padding: theme.spacing(3, 3, 3, 3),
        height: "auto",
        display: "flex",
        flexDirection: "column"
      },
      "& $cardDescription": {
        opacity: 0,
        display: "block"
      },
      "& $cardActions": {
        "&:hover": {
          "& $cardDescription": {
            opacity: 1
          }
        }
      },
      "& $cardKeywords": {
        "& span": {
          /* IE11 fix text-misalignent, might be due to half pixel rendering */
          overflow: "visible"
        }
      }
    }), _defineProperty(_cardVariantMedium, theme.breakpoints.down("sm"), {
      "& $cardActions": {
        paddingBottom: 0
      }
    }), _cardVariantMedium),
    cardVariantSmall: {
      "& $cardActions": {
        display: "flex"
      },
      "& $cardMedia": {
        width: theme.spacing(15),
        height: "auto",
        overflow: "unset",
        "& picture": {
          height: "100%",
          width: theme.spacing(15),
          "&.fallbackPic": {
            backgroundSize: "80%"
          }
        }
      },
      "& $cardContent": (_$cardContent = {
        position: "relative",
        flex: "1 1 auto",
        padding: theme.spacing(2),
        paddingBottom: theme.spacing(1)
      }, _defineProperty(_$cardContent, theme.breakpoints.up("md"), {
        padding: theme.spacing(2, 2, 1, 2)
      }), _defineProperty(_$cardContent, "& .MuiCardContent-root:last-child", {
        paddingBottom: theme.spacing(2)
      }), _defineProperty(_$cardContent, "& $cardTitle", _defineProperty({
        marginBottom: theme.spacing(0),
        fontSize: theme.typography.pxToRem(16),
        lineHeight: "20px",
        maxHeight: "40px"
      }, theme.breakpoints.only("xs"), {
        maxHeight: "60px"
      })), _$cardContent),
      "& + $cardVariantSmall": {
        marginTop: theme.spacing(1)
      },
      // ONEWEB-38, CSS to hide chip when using Small CardVariant and mobile view
      "& $cardKeywordsWrapper": _defineProperty({}, theme.breakpoints.down("md"), {
        display: "none"
      }),
      "& $cardKeywords": _defineProperty({
        maxHeight: theme.spacing(4),
        bottom: theme.spacing(2),
        overflow: "hidden"
      }, theme.breakpoints.up("sm"), {
        maxHeight: theme.spacing(4)
      })
    },
    cardActions: {
      lineHeight: 0,
      cursor: "pointer"
    },
    cardMedia: {
      height: "100%",
      overflow: "hidden"
    },
    cardContentWrapper: {
      width: "100%",
      bottom: 0
    },
    cardContent: _defineProperty({
      width: "100%",
      display: "flex",
      flexDirection: "column"
    }, theme.breakpoints.down("md"), {
      // padding: theme.spacing(2, 2, 3, 2),
      // ONEWEB-38, update padding for Small CardVariant based on new design
      padding: theme.spacing(3, 2, 3, 2)
    })
  }, cardBackgrounds), {}, {
    // ONEWEB-38, wrapper for article category and SocialShare icon
    cardCategoryWrapper: {
      display: "flex",
      alignItems: "flex-start"
    },
    cardCategory: {
      marginBottom: theme.spacing(1)
    },
    cardTitle: {
      marginBottom: theme.spacing(1),
      overflow: "hidden"
    },
    cardTitleVariantMedium: (_cardTitleVariantMedi = {
      fontSize: '1.25rem',
      lineHeight: '1.5625rem',
      marginRight: theme.spacing(1)
    }, _defineProperty(_cardTitleVariantMedi, theme.breakpoints.down("lg"), {
      marginRight: theme.spacing(2)
    }), _defineProperty(_cardTitleVariantMedi, theme.breakpoints.down("sm"), {
      marginRight: theme.spacing(3)
    }), _cardTitleVariantMedi),
    cardDescription: {
      display: "none",
      overflow: "hidden",
      marginBottom: theme.spacing(1)
    },
    cardDescriptionVariantMedium: (_cardDescriptionVaria = {
      marginRight: theme.spacing(1)
    }, _defineProperty(_cardDescriptionVaria, theme.breakpoints.down("lg"), {
      marginRight: theme.spacing(2)
    }), _defineProperty(_cardDescriptionVaria, theme.breakpoints.down("sm"), {
      marginRight: theme.spacing(3)
    }), _cardDescriptionVaria),
    // ONEWEB-38, ArrowButton styling
    cardLink: {
      position: "absolute",
      padding: theme.spacing(1),
      right: 0,
      bottom: 0,
      height: "unset!important",
      "& button": {
        width: theme.spacing(4),
        height: theme.spacing(4),
        minWidth: theme.spacing(4),
        maxWidth: theme.spacing(4),
        padding: 0,
        lineHeight: 0
      }
    },
    cardKeywordsWrapper: _defineProperty({
      display: "flex",
      flex: "1 1 auto",
      alignItems: "flex-end",
      paddingBottom: "0 !important"
    }, theme.breakpoints.up("md"), {
      paddingRight: theme.spacing(5)
    }),
    cardKeywords: {
      "& span": {
        display: "inline-flex"
      }
    },
    chip: {
      "&.MuiChip-root": {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1)
      }
    },
    heightAuto: {
      height: "auto!important"
    },
    // New css design for ONEWEB-38, SocialShare button
    share: _defineProperty({
      height: theme.spacing(3),
      width: theme.spacing(3),
      padding: theme.spacing(0),
      minWidth: theme.spacing(3),
      marginTop: theme.spacing(-1.25),
      position: "relative",
      zIndex: "1",
      marginLeft: theme.spacing(3)
    }, theme.breakpoints.down("md"), {
      marginLeft: theme.spacing(8)
    })
  });
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$l = function styles(theme) {
  var colors = theme.palette.colors || {};
  var backgrounds = {};
  Object.keys(colors).forEach(function (color) {
    backgrounds["bgColor-".concat(color)] = {
      backgroundColor: colors[color].main
    };
  });
  return _objectSpread2({}, backgrounds);
};

var useStyles$q = makeStyles(styles$l);
/**
 * Used as a child of Card component to provide the content.
 * @param {object} classes - To override or extend the styles applied to the component
 * @param {string} color - Provides the color pallete for styling
 */

var FwdCardContent = function FwdCardContent(props) {
  var classes = useStyles$q();
  return /*#__PURE__*/React__default.createElement(CardContent, _extends({
    className: clsx(classes["bgColor-".concat(props.color)], props.classes)
  }, props));
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var COMPONENT_WRAPPER_LARGE$1 = 'ArticleCard-Wrapper-Large';
var COMPONENT_WRAPPER_MEDIUM$1 = 'ArticleCard-Wrapper-Medium';
var COMPONENT_WRAPPER_SMALL$1 = 'ArticleCard-Wrapper-Small';
var COMPONENT_LINK$2 = 'ArticleCard-Link';
var COMPONENT_IMAGE$1 = 'ArticleCard-Image';
var COMPONENT_CATEGORY_WRAPPER = 'ArticleCard-Category-Wrapper';
var COMPONENT_CATEGORY = 'ArticleCard-Category';
var COMPONENT_TITLE$4 = 'ArticleCard-Title';
var COMPONENT_DESCRIPTION$1 = 'ArticleCard-Description';
var COMPONENT_TAGS = 'ArticleCard-Tags';
var COMPONENT_TAG = 'ArticleCard-Tag';
var COMPONENT_BUTTON$2 = 'ArticleCard-Button';
var COMPONENT_BUTTON_WRAPPER$1 = 'ArticleCard-Button-Wrapper';
var COMPONENT_PRODUCT_SHARE_ICON = 'ArticleCard-ShareIcon';

var locators$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  COMPONENT_WRAPPER_LARGE: COMPONENT_WRAPPER_LARGE$1,
  COMPONENT_WRAPPER_MEDIUM: COMPONENT_WRAPPER_MEDIUM$1,
  COMPONENT_WRAPPER_SMALL: COMPONENT_WRAPPER_SMALL$1,
  COMPONENT_LINK: COMPONENT_LINK$2,
  COMPONENT_IMAGE: COMPONENT_IMAGE$1,
  COMPONENT_CATEGORY_WRAPPER: COMPONENT_CATEGORY_WRAPPER,
  COMPONENT_CATEGORY: COMPONENT_CATEGORY,
  COMPONENT_TITLE: COMPONENT_TITLE$4,
  COMPONENT_DESCRIPTION: COMPONENT_DESCRIPTION$1,
  COMPONENT_TAGS: COMPONENT_TAGS,
  COMPONENT_TAG: COMPONENT_TAG,
  COMPONENT_BUTTON: COMPONENT_BUTTON$2,
  COMPONENT_BUTTON_WRAPPER: COMPONENT_BUTTON_WRAPPER$1,
  COMPONENT_PRODUCT_SHARE_ICON: COMPONENT_PRODUCT_SHARE_ICON
});

var useStyles$p = makeStyles(styles$m);
/**
 * Card component for articles such as press release.
 * @param {number} flexiCol - Use container if undefined/null/0. Set to null by default
 * @pararm {string} bgColor - background color for styling class. Set to `white` if no value recieved
 * @param {boolean} hasMargin - Set to false by default
 * @param {object[]} keywords - List of tags featured in the article. Set to [] by default.
 * @param {string} cardVariant - Card variant. Set to `medium` by default.
 * @param {object} image - Contains source path of image for card along with alt text. Set to null by default
 * @param {object} mobileImage - Contains image object for mobile view
 * @param {object} subtype - Component subtype. Set to null by default
 * @param {string} articleTitle - Article title. Set to '' by default
 * @param {string} shortDescription - Set '' by default
 * @param {string} metadataDescription - Set '' by default
 * @param {string} gaCategoryName - GA category name. Drives the category/action pair to be logged for statistics
 * @param {function} onClick - Event handler function. Set null by default
 * @param {boolean} hasParent - Set to false by default
 */

var ArticleCard = function ArticleCard(props) {
  var flexiCol = props.flexiCol || null; // const { bgColor: bgColorForNonFlexiContainer } = getColors(
  //   get(props, "params.backgroundColor", "white")
  // );
  // ONEWEB-38, remove fixed backgroundColor

  var _getColors = getColors(get$1(props, "params.backgroundColor", "white")),
      bgColor = _getColors.surfaceColor; // const bgColor = "orange";


  var hasMargin = get$1(props, "hasMargin", false);
  var classes = useStyles$p();
  var keywords = props.fields && props.fields.featuredTags ? props.fields.featuredTags : [];
  var cardVariant = props.params && props.params.cardVariant ? props.params.cardVariant : "Medium";

  if (cardVariant === "Small" && keywords.length > 1) {
    keywords = keywords.slice(0, 1);
  }

  var image = get$1(props, "fields.image", null);
  var mobileImage = get$1(props, "fields.mobileImage", null);
  var subtype = props.fields && props.fields.subtype ? props.fields.subtype : null;
  var articleTitle = get$1(props, "fields.articleTitle", "");
  var gaLabelName = get$1(props, "fields.gaLabelName.value", "");
  var shortDescription = get$1(props, "fields.shortDescription", "");
  var metadataDescription = get$1(props, "fields.metadataDescription", "");
  var gaCategoryName = props.gaCategoryName;
  var onClick = get$1(props, "onClick", null);
  var hasParent = get$1(props, "hasParent", false);
  var pageEditing = get$1(props, "pageEditing", false);
  var isMobileWidth = useMediaQuery("(max-width:".concat(breakpoints.values.sm, "px)"));
  var descriptionTruncationMapping = {
    Large: 5,
    Medium: 5,
    Small: null
  };
  var navigate = get$1(props, "navigate", function (href) {
    if (typeof window !== "undefined") {
      window.open(href);
    }
  });
  var navigateChip = get$1(props, "navigateChip", function (href) {
    if (typeof window !== "undefined") {
      window.open(href);
    }
  }); // ref

  var cardRef = /*#__PURE__*/createRef(); // state

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hoverState = _useState2[0],
      setHoverState = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isReady = _useState4[0],
      setIsReady = _useState4[1];

  var description = "";

  if (shortDescription && shortDescription.value) {
    description = shortDescription;
  } else if (metadataDescription && metadataDescription.value) {
    description = metadataDescription;
  }

  var aspectRatio = {
    Large: {
      mobile: "1-1",
      desktop: "16-9"
    },
    Medium: {
      mobile: "16-9",
      desktop: "16-9"
    },
    Small: {
      mobile: "1-1",
      desktop: "1-1"
    }
  }; // methods

  var articleClickHandler = function articleClickHandler(e) {
    var targetId = get$1(e, 'target.id', '');

    if (targetId !== 'Share') {
      e.preventDefault();
      e.stopPropagation();
      var href = get$1(props, "fields.link.value.href", "");
      gtm();

      if (onClick) {
        onClick(e);
      } else {
        navigate(href);
      }
    }
  };

  function gtm(e) {
    var targetId = get$1(e, 'target.id', '');

    if (targetId !== 'Share') {
      var href = get$1(props, "fields.link.value.href", "");
      PushEvent({
        event: "buttonClick",
        buttonTitle: gaLabelName || getGTMSharedKeyVal(href, COMPONENT_LINK$2),
        componentName: gaCategoryName ? gaCategoryName : COMPONENT_LINK$2,
        destinationUrl: href,
        articleName: get$1(props, "fields.articleTitle.value", "")
      }, props.gtmPushEvent);
    }
  }

  function renderTruncateText(paramCardVariant, paramArticleTitle) {
    switch (paramCardVariant) {
      case "Large":
      case "Medium":
        return pageEditing ? // <Text field={paramArticleTitle} />
        paramArticleTitle.value : /*#__PURE__*/React__default.createElement(TruncateText, {
          lines: 3,
          field: paramArticleTitle
        });

      case "Small":
        return pageEditing ? // <Text field={paramArticleTitle} />
        paramArticleTitle.value : /*#__PURE__*/React__default.createElement(TruncateText, {
          lines: isMobileWidth ? 3 : 2,
          field: paramArticleTitle
        });

      default:
        // return <Text field={paramArticleTitle} />;
        return paramArticleTitle.value;
    }
  }

  var fixHeightForNoParent = debounce$1(function () {
    if (!hasParent && cardRef.current && cardVariant === "Medium") {
      // reset first
      cardRef.current.style.height = "";
      cardRef.current.querySelector(".cardContentWrapper").style.position = "";
      cardRef.current.style.height = "".concat(cardRef.current.getBoundingClientRect().height, "px");
      cardRef.current.querySelector(".cardContentWrapper").style.position = "absolute";
    }
  }, 200); // effects

  useEffect(function () {
    setTimeout(function () {
      return setIsReady(true);
    }, 500);
    fixHeightForNoParent();
  }, []);

  var onCardResize = function onCardResize() {
    setIsReady(false);
    setTimeout(function () {
      return setIsReady(true);
    }, 500);
  };

  return /*#__PURE__*/React__default.createElement(Container$1, {
    useContainer: !flexiCol // background={bgColorForNonFlexiContainer}
    ,
    background: bgColor,
    className: clsx(_defineProperty({}, classes.hasMargin, hasMargin)),
    section: false
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    onClick: onClick === "onlyGTM" ? gtm : articleClickHandler,
    href: get$1(props, "fields.link.value.href", ""),
    "data-locator": COMPONENT_LINK$2,
    underline: "none"
  }, /*#__PURE__*/React__default.createElement(FwdCard, {
    ref: cardRef,
    color: bgColor,
    elevation: 0,
    classes: clsx("articlecard", "articlecard--".concat(cardVariant), classes.card, classes["cardVariant".concat(cardVariant)]),
    "data-locator": locators$1["COMPONENT_WRAPPER_".concat(cardVariant.toUpperCase())]
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.cardActions),
    onMouseEnter: function onMouseEnter() {
      return isReady && setHoverState(true);
    },
    onMouseLeave: function onMouseLeave() {
      return isReady && setHoverState(false);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.cardMedia
  }, /*#__PURE__*/React__default.createElement(Picture, {
    media: {
      image: image && defaultsDeep({
        value: _objectSpread2(_objectSpread2({}, image.value), image.value[cardVariant])
      }, image),
      mobileImage: mobileImage && defaultsDeep({
        value: _objectSpread2(_objectSpread2({}, mobileImage.value), mobileImage.value[cardVariant])
      }, mobileImage),
      aspectRatio: aspectRatio[cardVariant]
    },
    width: "100%",
    height: "100%",
    "data-locator": COMPONENT_IMAGE$1,
    hasBorderRadius: false
  })), /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.cardContentWrapper, "cardContentWrapper")
  }, /*#__PURE__*/React__default.createElement(FwdCardContent, {
    component: "section",
    className: clsx(classes["cardContentColored-".concat(bgColor)], classes.cardContent, "cardContent", _defineProperty({}, classes.heightAuto, isReady && hoverState && cardVariant === "Medium"))
  }, /*#__PURE__*/React__default.createElement(ReactResizeDetector, {
    handleWidth: true,
    onResize: onCardResize
  }, cardVariant === "Medium" ? /*#__PURE__*/React__default.createElement(Box$2, {
    display: "flex",
    justifyContent: "space-between",
    className: classes.cardCategoryWrapper,
    "data-locator": COMPONENT_CATEGORY_WRAPPER
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    className: classes.cardCategory,
    gutterBottom: true,
    variant: "h10",
    component: "p",
    color: bgColor,
    type: "label",
    "data-locator": COMPONENT_CATEGORY
  }, subtype.fields.name.value), props.shareOptions && props.shareOptions.length ? /*#__PURE__*/React__default.createElement(SocialShare$1, {
    gaCategoryName: gaCategoryName,
    sharedItemName: articleTitle,
    className: classes.share,
    dataLocator: COMPONENT_PRODUCT_SHARE_ICON,
    shareOptions: props.shareOptions,
    disablePortal: false,
    dataLocatorIdentifier: get$1(props, "dataLocatorIdentifier", ""),
    bgColor: bgColor,
    tabIndex: "0",
    transparent: true,
    sharedUrl: get$1(props, "fields.link.value.href", ""),
    gaLabelName: gaLabelName,
    extraGAData: {
      articleName: gaLabelName || articleTitle
    }
  }) : null) : /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    className: classes.cardCategory,
    gutterBottom: true,
    variant: "h10",
    component: "p",
    color: bgColor,
    type: "label",
    "data-locator": COMPONENT_CATEGORY
  }, subtype.fields.name.value), !isEmpty(get$1(articleTitle, "value", "")) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: cardVariant === "Small" ? "h6" : "h4",
    component: "h3",
    className: clsx(classes.cardTitle, _defineProperty({}, classes.cardTitleVariantMedium, cardVariant === "Medium")),
    color: bgColor,
    "data-locator": COMPONENT_TITLE$4,
    fontWeight: "bolder"
  }, renderTruncateText(cardVariant, articleTitle)), !isEmpty(description.value) && (cardVariant === "Medium" ? pageEditing ? /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    className: clsx(classes.cardDescription, "motionExpand", _defineProperty({}, classes.cardDescriptionVariantMedium, cardVariant === "Medium")),
    color: bgColor,
    "data-locator": COMPONENT_DESCRIPTION$1,
    type: "richtext"
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description.value
    }
  })) : /*#__PURE__*/React__default.createElement(Collapse$1, {
    in: isReady && hoverState,
    collapsedHeight: 0,
    className: hoverState ? classes.easingInOut : classes.easingOut,
    timeout: {
      enter: 300,
      exit: 200
    }
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    className: clsx(classes.cardDescription, _defineProperty({}, classes.cardDescriptionVariantMedium, cardVariant === "Medium")),
    color: bgColor,
    "data-locator": COMPONENT_DESCRIPTION$1,
    type: "richtext"
  }, /*#__PURE__*/React__default.createElement(TruncateText, {
    lines: descriptionTruncationMapping[cardVariant],
    content: get$1(description, "value", ""),
    type: isRichText(get$1(description, "value", "")) ? "richtext" : null
  }))) : /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    className: clsx(classes.cardDescription, "motionExpand", _defineProperty({}, classes.cardDescriptionVariantMedium, cardVariant === "Medium")),
    color: bgColor,
    "data-locator": COMPONENT_DESCRIPTION$1,
    type: "richtext"
  }, /*#__PURE__*/React__default.createElement(TruncateText, {
    lines: descriptionTruncationMapping[cardVariant],
    content: get$1(description, "value", ""),
    type: isRichText(get$1(description, "value", "")) ? "richtext" : null
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: classes.cardKeywordsWrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.cardKeywords,
    "data-locator": COMPONENT_TAGS
  }, keywords.map(function (item) {
    var url = get$1(item, "fields.link.value.href", "").concat(get$1(item, "fields.link.value.querystring", "") !== "" ? "?".concat(get$1(item, "fields.link.value.querystring")) : "");
    return /*#__PURE__*/React__default.createElement(FwdChip, {
      key: item.fields.name.value,
      size: "small",
      label: item.fields.name.value,
      classes: classes.chip,
      "data-locator": COMPONENT_TAG,
      component: "a",
      color: bgColor,
      href: url ? url : undefined,
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        PushEvent({
          event: "buttonClick",
          buttonTitle: get$1(item, "fields.searchName.value", "") || getGTMSharedKeyVal(url, COMPONENT_TAG),
          componentName: gaCategoryName ? gaCategoryName : COMPONENT_TAG,
          destinationUrl: url
        }, props.gtmPushEvent);

        if ((e.ctrlKey || e.metaKey) && typeof window !== "undefined") {
          window.open(url, "_blank");
        } else if (get$1(item, "fields.link.value.linktype", "") === "external") {
          window.open(url, "_blank");
        } else {
          if (props.setIsFeaturedTagClicked) {
            props.setIsFeaturedTagClicked(true);
          }

          navigateChip(url);
        }
      }
    });
  }))), cardVariant === "Medium" && get$1(props, "fields.isArrowButton.value", false) && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.cardLink, getBorderRadius("small")),
    "data-locator": COMPONENT_BUTTON_WRAPPER$1
  }, /*#__PURE__*/React__default.createElement(BrandingIcon, {
    icon: "arrow-right",
    color: bgColor,
    size: "md",
    shape: "square",
    hasHoverEffect: false,
    hasShadowEffect: false,
    "data-locator": COMPONENT_BUTTON$2,
    className: getBorderRadius("small"),
    "aria-label": articleTitle ? articleTitle.value : ""
  })))))))));
};

var ArticleCard$1 = /*#__PURE__*/React__default.memo(ArticleCard);

var styles$k = function styles(theme) {
  var _$cardLabel, _cardContentWrap, _cardTitle, _cardDescription;

  return {
    container: {
      overflow: 'visible'
    },
    card: _defineProperty({
      width: '100%',
      height: '100%'
    }, theme.breakpoints.up('sm'), {
      '& $cardDescription': {
        transition: "all ".concat(timings.smaller, " ").concat(transitionFunction.easeOut)
      },
      '&:hover': {
        '& $cardDescription': {
          opacity: 1,
          transition: "all ".concat(timings.small, " ").concat(transitionFunction.easeInOut),
          maxHeight: theme.spacing(9),
          marginTop: theme.spacing(1)
        }
      }
    }),
    cardVariantLarge: {
      '& $cardContent': _defineProperty({}, theme.breakpoints.down('md'), {
        padding: theme.spacing(3, 6, 3, 2)
      }),
      '& $cardLabel': (_$cardLabel = {
        top: 32
      }, _defineProperty(_$cardLabel, theme.breakpoints.down('md'), {
        top: 16
      }), _defineProperty(_$cardLabel, '& span', _defineProperty({}, theme.breakpoints.down('md'), {
        fontSize: theme.typography.pxToRem(13),
        lineHeight: theme.typography.pxToRem(16)
      })), _$cardLabel)
    },
    cardVariantSmall: {
      '& + $cardVariantSmall': {
        marginTop: theme.spacing(3)
      }
    },
    cardActions: {
      lineHeight: 0,
      height: '100%',
      cursor: 'pointer',
      '& a': {
        width: '100%'
      }
    },
    cardContentWrap: (_cardContentWrap = {}, _defineProperty(_cardContentWrap, theme.breakpoints.up('lg'), {
      position: 'absolute',
      bottom: 0,
      left: 0
    }), _defineProperty(_cardContentWrap, "width", '100%'), _cardContentWrap),
    cardContent: _defineProperty({
      boxSizing: 'border-box',
      padding: theme.spacing(3, 6, 3, 3),
      position: 'relative'
    }, theme.breakpoints.down('md'), {
      position: 'static',
      padding: theme.spacing(3, 6, 3, 2)
    }),
    cardTitle: (_cardTitle = {
      paddingTop: theme.spacing(1),
      marginBottom: theme.spacing(0)
    }, _defineProperty(_cardTitle, theme.breakpoints.down('md'), {
      fontSize: theme.typography.pxToRem(20),
      lineHeight: theme.typography.pxToRem(25),
      marginBottom: theme.spacing(1)
    }), _defineProperty(_cardTitle, "overflow", 'hidden'), _defineProperty(_cardTitle, '&.noTopPadding', {
      paddingTop: 0
    }), _cardTitle),
    cardTiers: {
      '& span': {
        fontWeight: theme.typography.fontWeights.bold,
        fontSize: theme.typography.T11,
        lineHeight: theme.typography.lineHeight.L15
      }
    },
    cardDescription: (_cardDescription = {
      maxWidth: '100%'
    }, _defineProperty(_cardDescription, theme.breakpoints.up('lg'), {
      marginRight: '0',
      marginTop: 0,
      opacity: 0,
      maxHeight: 0,
      maxWidth: 'none'
    }), _defineProperty(_cardDescription, "marginRight", theme.spacing(1)), _defineProperty(_cardDescription, "overflow", 'hidden'), _defineProperty(_cardDescription, "maxHeight", theme.spacing(9)), _cardDescription),
    cardLink: {
      position: 'absolute',
      padding: theme.spacing(1),
      right: 0,
      bottom: 0,
      height: 'unset!important',
      '& button': {
        width: theme.spacing(4),
        height: theme.spacing(4),
        minWidth: theme.spacing(4),
        maxWidth: theme.spacing(4),
        padding: 0,
        lineHeight: 0
      }
    },
    link: {
      display: 'block',
      position: 'static',
      height: '100%',
      '& img': _defineProperty({}, theme.breakpoints.down('sm'), {
        borderBottomLeftRadius: '0',
        borderBottomRightRadius: '0'
      })
    }
  };
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var COMPONENT_WRAPPER_LARGE = 'PrivilegeCard-Wrapper-Large';
var COMPONENT_WRAPPER_MEDIUM = 'PrivilegeCard-Wrapper-Medium';
var COMPONENT_WRAPPER_SMALL = 'PrivilegeCard-Wrapper-Small';
var COMPONENT_LINK$1 = 'PrivilegeCard-Link';
var COMPONENT_IMAGE = 'PrivilegeCard-Image';
var COMPONENT_TITLE$3 = 'PrivilegeCard-Title';
var COMPONENT_TIERS = 'PrivilegeCard-Tiers';
var COMPONENT_TIERS_ICON = 'PrivilegeCard-Tiers-Icon';
var COMPONENT_DESCRIPTION = 'PrivilegeCard-Description';
var COMPONENT_BUTTON$1 = 'PrivilegeCard-Button';
var COMPONENT_BUTTON_WRAPPER = 'PrivilegeCard-Button-Wrapper';

var locators = /*#__PURE__*/Object.freeze({
  __proto__: null,
  COMPONENT_WRAPPER_LARGE: COMPONENT_WRAPPER_LARGE,
  COMPONENT_WRAPPER_MEDIUM: COMPONENT_WRAPPER_MEDIUM,
  COMPONENT_WRAPPER_SMALL: COMPONENT_WRAPPER_SMALL,
  COMPONENT_LINK: COMPONENT_LINK$1,
  COMPONENT_IMAGE: COMPONENT_IMAGE,
  COMPONENT_TITLE: COMPONENT_TITLE$3,
  COMPONENT_TIERS: COMPONENT_TIERS,
  COMPONENT_TIERS_ICON: COMPONENT_TIERS_ICON,
  COMPONENT_DESCRIPTION: COMPONENT_DESCRIPTION,
  COMPONENT_BUTTON: COMPONENT_BUTTON$1,
  COMPONENT_BUTTON_WRAPPER: COMPONENT_BUTTON_WRAPPER
});

var useStyles$o = makeStyles(styles$k);

var PrivilegeCard = function PrivilegeCard(props) {
  var _clsx;

  var anchorText = get$1(props, "params.anchorText", null);

  if (anchorText !== null) {
    anchorText = anchorText.replace(/\s+/g, "-");
  }

  var flexiCol = parseInt(props.flexiCol) || null;
  var color = get$1(props, "params.backgroundColor", "orange-orange");

  var _getColors = getColors(color),
      bgColor = _getColors.bgColor;

  var classes = useStyles$o();
  var hasDividerLine = !!parseInt(get$1(props, "params.divider", "0"), 10);
  var cardVariant = get$1(props, "params.cardVariant", "Small") || "Small";
  var link = get$1(props, "fields.link") || null;
  var image = get$1(props, "fields.image") || null;
  var mobileImage = get$1(props, "fields.mobileImage") || null;
  var articleTitle = get$1(props, "fields.articleTitle") || null;
  var shortDescription = get$1(props, "fields.shortDescription") || null;
  var rewardText = get$1(props, "fields.rewardText") || null;
  var GTMSharedKey = get$1(props, "fields.gaLabelName.value", "");
  var navigate = get$1(props, "navigate", function (href) {
    if (typeof window !== "undefined") {
      window.open(href);
    }
  });
  var linkType = link && link.value.linktype || null;
  var linkHref = link && link.value.href || null;
  var gaCategoryName = props.gaCategoryName;
  var aspectRatio = {
    Large: {
      mobile: "1-1",
      desktop: "3-1"
    },
    Medium: {
      mobile: "2-1",
      desktop: "1-1"
    },
    Small: {
      mobile: "2-1",
      desktop: "2-1"
    }
  };
  var isDesktop = useMediaQuery("(min-width:".concat(breakpoints.values.lg, "px)"));

  var linkHandler = function linkHandler(e) {
    e.preventDefault();
    PushEvent({
      event: "buttonClick",
      buttonTitle: GTMSharedKey || getGTMSharedKeyVal(linkHref, COMPONENT_LINK$1),
      componentName: gaCategoryName ? gaCategoryName : COMPONENT_LINK$1,
      destinationUrl: linkHref
    });

    if ((e.ctrlKey || e.metaKey) && typeof window !== "undefined") {
      window.open(linkHref, "_blank");
    } else if (linkType === "internal") {
      navigate(linkHref);
    } else if (linkType === "external") {
      if (typeof window !== "undefined") {
        window.open(linkHref, "_blank");
      }
    }
  };

  return /*#__PURE__*/React__default.createElement(Container$1, {
    id: anchorText,
    useContainer: !flexiCol,
    color: bgColor,
    className:
    /** FWDS-5299 Fix: Move divider line class to clsx function
     *  Divider class is misplaced outside clsx function, which caused misalignment issue if divider class is empty.
     */
    clsx(get$1(props, "className"), classes.container, getBorderRadius("medium"), hasDividerLine ? "component-divider-".concat(bgColor) : ""),
    "data-sectionProps": {
      className: clsx(get$1(props, "className"), getBorderRadius("medium"))
    }
  }, /*#__PURE__*/React__default.createElement(FwdCard, {
    elevation: 0,
    color: bgColor,
    classes: clsx(classes.card, classes["cardVariant".concat(cardVariant)]),
    "data-locator": "".concat(locators["COMPONENT_WRAPPER_".concat(cardVariant.toUpperCase())])
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.cardActions
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    underline: "none",
    onClick: linkHandler,
    "data-locator": COMPONENT_LINK$1,
    href: linkHref,
    className: classes.link
  }, /*#__PURE__*/React__default.createElement(Picture, {
    "data-locator": COMPONENT_IMAGE,
    media: {
      image: defaultsDeep({
        value: _objectSpread2(_objectSpread2({}, get$1(image, "value")), get$1(image, "value.".concat(cardVariant)))
      }, image),
      mobileImage: get$1(mobileImage, "value.".concat(cardVariant), null) && defaultsDeep({
        value: _objectSpread2(_objectSpread2({}, get$1(mobileImage, "value")), get$1(mobileImage, "value.".concat(cardVariant)))
      }, mobileImage),
      aspectRatio: aspectRatio[cardVariant]
    },
    hasBorderRadius: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classes.cardContentWrap
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 12,
    lg: cardVariant === "Large" ? 6 : 8
  }, /*#__PURE__*/React__default.createElement(FwdCardContent, {
    className: clsx((_clsx = {}, _defineProperty(_clsx, getBorderRadius("medium"), isDesktop), _defineProperty(_clsx, getBorderRadius("none", "none", "medium", "medium"), !isDesktop), _clsx), "bg-color-".concat(bgColor), classes.cardContent)
  }, get$1(rewardText, "value") && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body2",
    component: "span",
    className: classes.cardTiers,
    color: bgColor,
    "data-locator": COMPONENT_TIERS
  }, /*#__PURE__*/React__default.createElement("span", null, rewardText.value)), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: cardVariant === "Small" ? "h5" : "h4",
    component: "h3",
    className: clsx(_defineProperty({}, "noTopPadding", !get$1(rewardText, "value")), classes.cardTitle),
    color: bgColor,
    "data-locator": COMPONENT_TITLE$3,
    fontWeight: "bolder"
  }, /*#__PURE__*/React__default.createElement(TruncateText, {
    lines: 2,
    field: articleTitle
  })), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    className: clsx(classes.cardDescription),
    color: bgColor,
    "data-locator": COMPONENT_DESCRIPTION,
    type: "richtext"
  }, /*#__PURE__*/React__default.createElement(TruncateText, {
    lines: 3,
    field: shortDescription
  })), /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.cardLink, getBorderRadius("small")),
    "data-locator": COMPONENT_BUTTON_WRAPPER
  }, /*#__PURE__*/React__default.createElement(BrandingIcon, {
    icon: "arrow-right",
    color: bgColor,
    size: "md",
    shape: "square",
    hasHoverEffect: false,
    hasShadowEffect: false,
    "data-locator": COMPONENT_BUTTON$1,
    className: getBorderRadius("small"),
    "aria-label": articleTitle ? articleTitle.value : ""
  }))))))))));
};

var useStyles$n = makeStyles(function (theme) {
  return style$5(theme);
});

var ArticleCardList$1 = function ArticleCardList(props) {
  var _clsx;

  var gaCategoryName = get$1(props, 'fields.sitecoreData.gaCategoryName.value', null);
  var flexiCol = props.flexiCol || null,
      featuredListItems = props.fields && props.fields.sitecoreData.linkItems || [],
      title = get$1(props, 'fields.sitecoreData.title', '') || '';
  var link = get$1(props, 'fields.sitecoreData.link', null) || null;
  var GTMSharedKey = get$1(props, 'fields.sitecoreData.linkGALabelName.value', '');
  var pageEditing = get$1(props, 'sitecoreContext.pageEditing', false);
  var articleOverlineText = get$1(props, 'sitecoreContext.siteSettings.articleOverlineText', false);

  var _get = get$1(props, 'params', {}),
      _get$cardVariant = _get.cardVariant,
      cardVariant = _get$cardVariant === void 0 ? '' : _get$cardVariant,
      _get$cardType = _get.cardType,
      cardType = _get$cardType === void 0 ? '' : _get$cardType,
      _get$backgroundColor = _get.backgroundColor,
      backgroundColor = _get$backgroundColor === void 0 ? 'white-orange' : _get$backgroundColor,
      _get$paddingTop = _get.paddingTop,
      paddingTop = _get$paddingTop === void 0 ? '' : _get$paddingTop,
      _get$paddingBottom = _get.paddingBottom,
      paddingBottom = _get$paddingBottom === void 0 ? '' : _get$paddingBottom;

  var hasDividerLine = !!parseInt(get$1(props, 'params.divider', '0'), 10);

  var _getColors = getColors(backgroundColor),
      bgColor = _getColors.bgColor,
      surfaceColor = _getColors.surfaceColor;

  var slidesToShow = {
    desktop: {
      Article: {
        Large: 1,
        Medium: 3,
        Small: 3
      },
      Privilege: {
        LargeMedium: 2,
        Large: 2,
        Medium: 2
      }
    },
    tablet: {
      Article: {
        Large: 1,
        Medium: 2,
        Small: 2
      },
      Privilege: {
        LargeMedium: 2,
        Large: 2,
        Medium: 2
      }
    },
    mobile: {
      Article: {
        Large: 1,
        Medium: 1,
        Small: 1
      },
      Privilege: {
        LargeMedium: 1.2,
        Large: 1.2,
        Medium: 1.2
      }
    }
  };
  var navigate = get$1(props, 'navigate', function (href) {
    if (typeof window !== 'undefined') {
      window.open(href);
    }
  });
  var navigateChip = get$1(props, 'navigateChip', function (href) {
    if (typeof window !== 'undefined') {
      window.open(href);
    }
  });
  var classes = useStyles$n(); // ref

  var sliderWrapperRef = /*#__PURE__*/createRef(); // states

  var isMobileWidth = useMediaQuery("(max-width:".concat(breakpoints.values.sm, "px)")); // dispatch action if it's contains more then

  featuredListItems.reduce(function (accumulator, item) {
    return [].concat(_toConsumableArray(accumulator), [item.id]);
  }, []); // it's handle feature article list
  // useEffect(() => {
  //   // subscribe : add feature article id store
  //   if (featuredItemId.length) {
  //     props.updateArticlesList(featuredItemId);
  //   }
  //   return () => {
  //     // unsubscribe : remove feature article from store
  //     props.resetArticlesList();
  //   };
  // }, []);

  useEffect(function () {
    /* istanbul ignore else */
    if (sliderWrapperRef.current) {
      var cardContentElms = sliderWrapperRef.current.querySelectorAll('.articlecard .cardContent');

      _toConsumableArray(cardContentElms).forEach(function (elm) {
        return elm.style.height = '';
      });

      if (isMobileWidth) {
        var mh = getMaxHeight(cardContentElms);

        _toConsumableArray(cardContentElms).forEach(function (elm) {
          return elm.style.height = "".concat(mh, "px");
        });
      }
    }
  }, [isMobileWidth]);
  var currentSlide = 0;
  var settings = {
    dots: cardType === 'Article',
    infinite: false,
    speed: 500,
    slidesToShow: get$1(slidesToShow, "desktop.".concat(cardType, ".").concat(cardVariant), 2),
    slidesToScroll: 1,
    cssEase: transitionFunction.easeInOut,
    beforeChange: function beforeChange(current, next) {
      next < currentSlide ? PushEvent({
        event: 'buttonClick',
        buttonTitle: ARTICLE_CARD_LIST_PREV_BUTTON,
        destinationUrl: undefined,
        componentName: gaCategoryName ? gaCategoryName : ARTICLE_CARD_LIST_CONTAINER
      }) : PushEvent({
        event: 'buttonClick',
        buttonTitle: ARTICLE_CARD_LIST_NEXT_BUTTON,
        destinationUrl: undefined,
        componentName: gaCategoryName ? gaCategoryName : ARTICLE_CARD_LIST_CONTAINER
      });
      currentSlide = next;
    },
    nextArrow: /*#__PURE__*/React__default.createElement(ArrowForward, {
      "data-locator": ARTICLE_CARD_LIST_NEXT_BUTTON,
      "aria-label": ARTICLE_CARD_LIST_NEXT_BUTTON
    }),
    prevArrow: /*#__PURE__*/React__default.createElement(ArrowForward, {
      "data-locator": ARTICLE_CARD_LIST_PREV_BUTTON,
      "aria-label": ARTICLE_CARD_LIST_PREV_BUTTON
    }),
    responsive: [{
      breakpoint: 1288,
      settings: {
        dots: false,
        infinite: false,
        centerMode: false,
        slidesToShow: get$1(slidesToShow, "tablet.".concat(cardType, ".").concat(cardVariant), 2),
        slidesToScroll: 1,
        swipeToSlide: true,
        centerPadding: cardType === 'Privilege' ? '48px' : '0',
        arrows: true
      }
    }, {
      breakpoint: 600,
      settings: {
        dots: cardType === 'Article',
        infinite: false,
        centerMode: cardType === 'Article',
        slidesToShow: get$1(slidesToShow, "mobile.".concat(cardType, ".").concat(cardVariant), 1),
        slidesToScroll: 1,
        swipeToSlide: true,
        centerPadding: cardType === 'Privilege' ? '48px' : '0',
        arrows: false
      }
    }]
  };

  var getMutatedData = function getMutatedData(cardData, variant) {
    var _cardData$fields, _cardData$fields$topi, _cardData$fields$topi2, _cardData$fields$subt, _cardData$fields$subt2;

    var featuredTags = [];
    cardData.fields.featuredTags.forEach(function (tag) {
      featuredTags.push({
        fields: {
          name: {
            value: tag.fields.name.value
          },
          link: {
            value: {
              href: tag.fields.link && "".concat(tag.fields.link.value.href, "?").concat(tag.fields.link.value.querystring)
            }
          }
        }
      });
    });
    var mutatedData = {
      fields: {
        image: {
          value: cardData.fields.image && cardData.fields.image.value
        },
        mobileImage: {
          value: cardData.fields.mobileImage && cardData.fields.mobileImage.value
        },
        subtype: {
          fields: {
            name: {
              value: articleOverlineText ? ((_cardData$fields = cardData.fields) === null || _cardData$fields === void 0 ? void 0 : (_cardData$fields$topi = _cardData$fields.topics) === null || _cardData$fields$topi === void 0 ? void 0 : _cardData$fields$topi.length) > 0 ? (_cardData$fields$topi2 = cardData.fields.topics[0]) === null || _cardData$fields$topi2 === void 0 ? void 0 : _cardData$fields$topi2.fields.name.value : (_cardData$fields$subt = cardData.fields.subtype) === null || _cardData$fields$subt === void 0 ? void 0 : _cardData$fields$subt.fields.name.value : (_cardData$fields$subt2 = cardData.fields.subtype) === null || _cardData$fields$subt2 === void 0 ? void 0 : _cardData$fields$subt2.fields.name.value
            }
          },
          featuredTags: featuredTags,
          link: cardData.fields.link
        },
        articleTitle: {
          value: cardData.fields.articleTitle && cardData.fields.articleTitle.value
        },
        shortDescription: {
          value: cardData.fields.shortDescription && cardData.fields.shortDescription.value
        },
        metadataDescription: {
          value: cardData.fields.metadataDescription && cardData.fields.metadataDescription.value
        },
        featuredTags: featuredTags,
        link: {
          value: cardData.fields.link && cardData.fields.link.value
        },
        rewardText: {
          value: cardData.fields.rewardText && cardData.fields.rewardText.value
        },
        gaLabelName: {
          value: cardData.fields.gaLabelName && cardData.fields.gaLabelName.value
        }
      },
      params: {
        cardVariant: cardType === 'Privilege' && cardVariant === 'Medium' ? 'Small' : variant
      }
    };
    return mutatedData;
  };

  var makeCard = function makeCard() {
    return featuredListItems.map(function (cardData, index) {
      var mutatedData = getMutatedData(cardData, cardVariant);
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: cardData.id
      }, cardType === 'Article' ? /*#__PURE__*/React__default.createElement(ArticleCard$1, _extends({
        key: index,
        gaCategoryName: gaCategoryName
      }, mutatedData, {
        hasMargin: true,
        color: surfaceColor,
        pageEditing: pageEditing,
        navigate: navigate,
        navigateChip: navigateChip
      })) : /*#__PURE__*/React__default.createElement("div", {
        className: classes.slideWrap
      }, /*#__PURE__*/React__default.createElement(PrivilegeCard, _extends({
        key: index,
        gaCategoryName: gaCategoryName
      }, mutatedData, {
        className: classes.privilegeCard,
        navigate: navigate
      }))));
    });
  };

  var linkHandler = function linkHandler(e) {
    e.preventDefault();
    PushEvent({
      event: 'buttonClick',
      buttonTitle: GTMSharedKey || getGTMSharedKeyVal(link.value.href, ARTICLE_CARD_LINK),
      componentName: get$1(props, 'gaCategoryName.value', ARTICLE_CARD_LINK),
      destinationUrl: link.value.href
    });
    /* istanbul ignore else */

    if ((e.ctrlKey || e.metaKey) && typeof window !== 'undefined') {
      window.open(link.value.href, '_blank');
    } else if (link.value.linktype === 'internal') {
      navigate(link.value.href);
    } else if (link.value.linktype === 'external') {
      if (typeof window !== 'undefined') {
        window.open(link.value.href, '_blank');
      }
    }
  };

  var linkTmpl = link && get$1(link, 'value.href', null) && /*#__PURE__*/React__default.createElement("div", {
    className: classes.linkWrapper
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    "data-locator": ARTICLE_CARD_LINK,
    component: "div",
    variant: "h7",
    underline: "none",
    size: "small",
    icon: "arrow-right",
    color: bgColor,
    type: "caption",
    link: link,
    onClick: linkHandler
  }));
  return pageEditing || title && title.value || featuredListItems.length > 0 ? /*#__PURE__*/React__default.createElement(Container$1, {
    useContainer: !flexiCol,
    background: bgColor,
    className: clsx(getPaddingString({
      paddingTop: paddingTop,
      paddingBottom: paddingBottom
    }), (_clsx = {}, _defineProperty(_clsx, classes.root, cardType === 'Article'), _defineProperty(_clsx, classes.rootPrivilege, cardType === 'Privilege'), _defineProperty(_clsx, classes.dotMargin, cardType === 'Article' && cardVariant === 'Large' && featuredListItems.length > 1), _defineProperty(_clsx, "hasDividerLine", hasDividerLine), _clsx)),
    "data-locator": ARTICLE_CARD_LIST_CONTAINER,
    overflowHidden: true
  }, title && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: 'h2',
    component: 'h2',
    color: bgColor,
    className: classes.title,
    "data-locator": ARTICLE_CARD_LIST_TITLE,
    id: title.value && title.value.split(' ').join('-').toLowerCase()
  }, title.value), (cardType === 'Article' || cardType === 'Privilege' && cardVariant !== 'LargeMedium') && featuredListItems && /*#__PURE__*/React__default.createElement(Box, {
    ref: sliderWrapperRef,
    "data-locator": ARTICLE_CARD_SLIDER,
    m: -2
  }, /*#__PURE__*/React__default.createElement(Carousel$1, {
    settings: settings,
    className: cardType === 'Article' ? classes.sliderWrap : clsx(classes.sliderWrap2, classes["articlecardlist-".concat(bgColor)]),
    color: bgColor
  }, makeCard())), cardVariant === 'LargeMedium' && featuredListItems && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(PrivilegeCard, _extends({}, getMutatedData(featuredListItems[0], 'Large'), {
    className: classes.gridCard,
    navigate: navigate
  })), cardType === 'Privilege' && cardVariant === 'LargeMedium' && featuredListItems && /*#__PURE__*/React__default.createElement("div", {
    "data-locator": ARTICLE_CARD_SLIDER,
    className: classes.gridCardMargin
  }, /*#__PURE__*/React__default.createElement(Carousel$1, {
    settings: settings,
    className: clsx(classes.sliderWrap2, classes["articlecardlist-".concat(bgColor)], classes.customMargin)
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: 0
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.slideWrap
  }, /*#__PURE__*/React__default.createElement(PrivilegeCard, _extends({}, getMutatedData(featuredListItems[1], 'Small'), {
    className: clsx(classes.privilegeCard),
    navigate: navigate
  })))), /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: 1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.slideWrap
  }, /*#__PURE__*/React__default.createElement(PrivilegeCard, _extends({}, getMutatedData(featuredListItems[2], 'Small'), {
    className: clsx(classes.privilegeCard),
    navigate: navigate
  }))))))), linkTmpl) : null;
}; // const mapDispatchToProps = dispatch => {

/*9fbef606107a605d69c0edbcd8029e5d*/
var style$4 = function style(theme) {
  return {
    horizontal: {
      opacity: '0.30'
    },
    title: {
      marginBottom: theme.spacing(3)
    },
    description: {
      marginBottom: theme.spacing(8)
    },
    supportButton: _defineProperty({
      marginTop: '66px'
    }, theme.breakpoints.down('md'), {
      marginTop: theme.spacing(3),
      justifyContent: 'center'
    })
  };
};

var style$3 = function style(theme) {
  var _stackedListItem, _dialogLink;

  var colors = theme.palette.colors || {};
  var borderColors = {};
  Object.keys(colors).forEach(function (color) {
    borderColors["border-".concat(color)] = {
      borderColor: colors[color].line.textFieldFocus,
      '& span:nth-child(1)': {
        color: colors[color].contrastText
      },
      '& path': {
        fill: colors[color].contrastTextAction
      },
      '&:hover': {
        borderColor: colors[color].contrastTextAction,
        backgroundColor: colors[color].contrastTextAction,
        '& span:nth-child(1)': {
          color: colors[color].main
        },
        '& path': {
          fill: colors[color].main
        }
      }
    };
  });
  return _objectSpread2({
    stackedListItem: (_stackedListItem = {
      '&[role="link"]': {
        display: 'flex'
      },
      width: '100%',
      padding: theme.spacing(3, 2, 3, 3),
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 0,
      marginRight: theme.spacing(1),
      height: '100%',
      borderWidth: '1px',
      borderStyle: 'solid'
    }, _defineProperty(_stackedListItem, theme.breakpoints.down('sm'), {
      padding: theme.spacing(1, 1, 2, 2),
      flexDirection: 'column-reverse',
      alignItems: 'flex-end',
      minHeight: theme.spacing(13)
    }), _defineProperty(_stackedListItem, '&:hover', {
      cursor: 'pointer'
    }), _defineProperty(_stackedListItem, '& svg', {
      width: theme.spacing(3),
      height: theme.spacing(3)
    }), _stackedListItem),
    linkListContainer: {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    listItemTitle: {
      width: '100%',
      margin: '0',
      fontWeight: theme.typography.fontWeights.bolder
    },
    listItemIcon: {
      lineHeight: 0
    },
    dialogTitle: {
      fontWeight: theme.typography.fontWeights.bolder,
      marginBottom: theme.spacing(3)
    },
    dialogLink: (_dialogLink = {
      fontWeight: theme.typography.fontWeights.bolder,
      lineHeight: theme.typography.lineHeight.L9,
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(8),
      '&:hover': {
        textDecoration: 'none'
      }
    }, _defineProperty(_dialogLink, theme.breakpoints.down('sm'), {
      marginTop: 0,
      marginBottom: theme.spacing(6)
    }), _defineProperty(_dialogLink, '& a', {
      textDecoration: 'none'
    }), _dialogLink),
    dialogDescription: _defineProperty({
      marginBottom: theme.spacing(12)
    }, theme.breakpoints.down('sm'), {
      marginBottom: theme.spacing(8)
    }),
    modalDialog: {
      animation: animations.fadeIn,
      '& .MuiDialog-container, & .MuiDialog-paper, & .MuiBackdrop-root': {
        transition: 'none !important'
      },
      '&.modalDialogClosing': {
        animation: animations.fadeOut
      }
    }
  }, borderColors);
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var COMPONENT_CONTAINER$1 = 'LinkList-Container';
var COMPONENT_TITLE$2 = 'LinkList-Title';
var COMPONENT_LIST_ITEM = 'LinkList-List-Item';
var COMPONENT_LIST_ITEM_TITLE = 'LinkList-List-Item-Title';
var COMPONENT_LIST_ITEM_ICON = 'LinkList-List-Item-Icon';
var COMPONENT_DIALOG_TITLE = 'Dialog-Title';
var COMPONENT_DIALOG_LINK = 'Dialog-Link';
var COMPONENT_DIALOG_DESCRIPTION = 'Dialog-Description';

var useStyles$m = makeStyles(function (theme) {
  return style$3(theme);
});
/**
 * ListItem
 */

var ListItem = function ListItem(props) {
  var classes = useStyles$m();
  var link = Object.keys(get$1(props, "fields.link.value", {}) || {}).length ? get$1(props, "fields.link", null) : null;

  if (link && link.value.linktype === "anchor" && link.value.href) {
    link.value.href = link.value.href.replace(/\s+/g, "-");
  }

  var endIcon = get$1(props, "fields.buttonIcon.fields.value.value", "info");
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, link && /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    component: link.value.linktype === "modelpopup" ? "div" : "a",
    href: link.value.linktype !== "modelpopup" ? link.value.href : undefined,
    variant: "h6",
    underline: "none",
    className: clsx(getBorderRadius("small"), classes.stackedListItem, _defineProperty({}, classes["border-".concat(props.color)], props.color !== "initial")),
    "data-locator": COMPONENT_LIST_ITEM_TITLE,
    tabIndex: "0",
    role: "link",
    onClick: function onClick(e) {
      return props.listItemClickHandler(e, link.value);
    },
    onKeyPress: function onKeyPress(e) {
      if (e.key === "Enter") {
        props.listItemClickHandler(e, link.value);
      }
    },
    linktype: link.value.linktype
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    component: "span",
    variant: "h5A",
    className: classes.listItemTitle
  }, link.value.text), /*#__PURE__*/React__default.createElement("span", {
    className: classes.listItemIcon,
    "data-locator": COMPONENT_LIST_ITEM_ICON
  }, /*#__PURE__*/React__default.createElement(NamedIcon$1, {
    icon: endIcon
  }))));
};

var StackedList = function StackedList(props) {
  var anchorText = get$1(props, "params.anchorText", "Stacked-List").replace(/\s+/g, "-");
  var classes = useStyles$m(); // const { setDisclosurePopupList } = useDisclosure();

  var setDisclosurePopupList = props.setDisclosurePopupList;
  var listItems = props.fields && props.fields.listItems || [];
  var color = props.color || "white";
  var pageEditing = get$1(props, "pageEditing", false);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalState = _useState2[0],
      setModalState = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      modalContent = _useState4[0],
      setModalContent = _useState4[1];

  var openModalHandler = function openModalHandler(e, linkDetails) {
    e.preventDefault();

    if (linkDetails.linktype === "modelpopup") {
      /* istanbul ignore else */
      if (!isEmpty(linkDetails.modelpopupcontent)) {
        setModalState(true);
        setModalContent(linkDetails.modelpopupcontent);
      } else if (get$1(linkDetails, "disclosurepopupcontent.disclosure.value", null)) {
        setDisclosurePopupList({
          isRoutedDirectly: false,
          activePopupKey: linkDetails.disclosurepopupcontent.disclosure.value,
          eligiblePopupList: [linkDetails.disclosurepopupcontent.disclosure.value]
        });
      }
    } else if ((e.ctrlKey || e.metaKey) && typeof window !== "undefined") {
      window.open(linkDetails.href, "_blank");
    } else if (linkDetails.linktype === "internal") {
      /* istanbul ignore else */
      if (typeof window !== "undefined") {
        navigate(linkDetails.href);
      }
    } else if (["external", "media"].includes(linkDetails.linkType)) {
      /* istanbul ignore else */
      if (typeof window !== "undefined") {
        window.open(linkDetails.href, "_blank");
      }
    } else if (linkDetails.linkType === "mailto") {
      /* istanbul ignore else */
      if (typeof window !== "undefined") {
        window.open(linkDetails.href, "_self");
      }
    } else {
      window.open(linkDetails.href, "_blank"); //default behaviour
    }
  };

  var modalRef = useRef();

  var closeModalHandler = function closeModalHandler() {
    if (modalRef && modalRef.current) {
      modalRef.current.classList.add("modalDialogClosing");
    }
  };

  var onAnimationEnd = function onAnimationEnd() {
    if (modalRef && modalRef.current && modalRef.current.classList.contains("modalDialogClosing")) {
      setModalState(false);
      setModalContent(null);
    }
  };

  return /*#__PURE__*/React__default.createElement(SimpleDiv, {
    className: classes.linkListContainer,
    id: anchorText,
    color: color
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    className: clsx(_defineProperty({}, classes.list, props.flexiCol)),
    spacing: 1
  }, listItems.length > 0 && listItems.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      "data-locator": COMPONENT_LIST_ITEM,
      item: true,
      key: "stacklist-".concat(index),
      xs: 6,
      md: props.flexiCol ? 6 : 3
    }, /*#__PURE__*/React__default.createElement(ListItem, {
      gaCategoryName: props.gaCategoryName,
      fields: item.fields,
      flexiCol: props.flexiCol,
      listItemClickHandler: function listItemClickHandler(e, link) {
        PushEvent(_objectSpread2({
          event: "buttonClick",
          buttonTitle: get$1(item, "fields.linkGALabelName.value", "") || getGTMSharedKeyVal(link.href, COMPONENT_LIST_ITEM_TITLE),
          componentName: get$1(props, "gaCategoryName.value", COMPONENT_LIST_ITEM_TITLE) || COMPONENT_LIST_ITEM_TITLE,
          destinationUrl: link.href
        }, (link === null || link === void 0 ? void 0 : link.linktype) === "media" && {
          brochure: {
            name: getGTMSharedKeyVal(link.href, COMPONENT_LIST_ITEM_TITLE),
            url: link.href
          }
        }));
        openModalHandler(e, link);
      },
      color: color
    }));
  }), modalState ? /*#__PURE__*/React__default.createElement(Dialog$1, {
    fullScreen: true,
    open: modalState,
    onClose: closeModalHandler,
    className: classes.modalDialog,
    ref: modalRef,
    onAnimationEnd: onAnimationEnd
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    component: "h2",
    variant: "h2",
    "data-locator": COMPONENT_DIALOG_TITLE,
    className: classes.dialogTitle,
    color: props.color
  }, modalContent.title.value), get$1(modalContent, "link.value.text", false) && /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    component: "div",
    variant: "span",
    underline: "hover",
    size: "small",
    icon: "arrow-right",
    className: classes.dialogLink,
    color: props.color,
    linkMode: buttonModes.SIMPLEPRIMARYLINK
  }, pageEditing ? get$1(modalContent, "link.value.text", null) :
  /*#__PURE__*/
  // <SitecoreLink
  //   data-locator={locators.COMPONENT_DIALOG_LINK}
  //   field={}
  //   onClick={
  //     get(modalContent, "link.value.text", null)
  //       ? (e) => openModalHandler(e, modalContent.link.value)
  //       : undefined
  //   }
  // />
  React__default.createElement("div", {
    "data-locator": COMPONENT_DIALOG_LINK,
    onClick: get$1(modalContent, "link.value.text", null) ? function (e) {
      return openModalHandler(e, modalContent.link.value);
    } : undefined
  }, modalContent.link.value)), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body4",
    component: "div",
    className: classes.dialogDescription,
    color: props.color,
    type: "richtext"
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: modalContent.description.value
    },
    "data-locator": COMPONENT_DIALOG_DESCRIPTION
  }))) : null));
};

var useStyles$l = makeStyles(function (theme) {
  return style$4(theme);
});

var LinkList$1 = function LinkList(props) {
  var _clsx;

  var classes = useStyles$l();
  var params = props.params ? props.params : {
    paddingTop: 'none',
    paddingBottom: 'none'
  };
  var dividerLine = get$1(props, 'params.divider', '0');
  var flexiCol = parseInt(props.flexiCol) || null;
  var color = props.params && props.params.backgroundColor || 'white-white';

  var _getColors = getColors(color),
      bgColor = _getColors.bgColor,
      surfaceColor = _getColors.surfaceColor;

  var title = get$1(props, 'fields.title.value', null) || null;
  var listItems = get$1(props, 'fields.listItems', []) || [];
  var pageEditing = get$1(props, 'sitecoreContext.pageEditing', false);
  return pageEditing || title || listItems.length > 0 ? /*#__PURE__*/React__default.createElement(Container$1, {
    useContainer: !flexiCol,
    background: bgColor,
    params: props.params,
    className: clsx(getPaddingString(params), dividerLine === '1' ? "component-divider-".concat(bgColor) : '')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, (_clsx = {}, _defineProperty(_clsx, classes.sectionRoot, !flexiCol && dividerLine), _defineProperty(_clsx, getPaddingString(params), flexiCol), _clsx)),
    "data-locator": COMPONENT_CONTAINER$1
  }, title && /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    md: 8,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: 'h5',
    component: 'h3',
    color: bgColor,
    className: classes.title,
    "data-locator": COMPONENT_TITLE$2
  }, title))), /*#__PURE__*/React__default.createElement(StackedList, {
    gaCategoryName: props.gaCategoryName,
    fields: _objectSpread2({}, props.fields),
    color: surfaceColor,
    flexiCol: flexiCol,
    pageEditing: pageEditing,
    params: params,
    setDisclosurePopupList: props.setDisclosurePopupList
  }))) : null;
}; // export default withSitecoreContext()(LinkList);

var scrollbarWidth = isWindows ? 16 : 15;
var styles$j = function styles(theme) {
  var _slickPrev, _slickNext, _isScrollable, _isScrollable2, _wrapper, _inner, _inner2;

  var colors = theme.palette.colors || {};
  var theming = {};
  Object.keys(colors).forEach(function (color) {
    theming["theming-".concat(color)] = {
      '& $table': {
        '&.customScrollbar': {
          '& .wrapper': {
            '&::-webkit-scrollbar-track': {
              backgroundColor: colors[color].line.divider
            },
            '&::-webkit-scrollbar-thumb': {
              background: colors[color].line.textFieldDefault
            }
          }
        },
        '& table': {
          backgroundColor: colors[color].main
        },
        '& td': {
          '& .inner': {
            '&:before, &:after': {
              backgroundColor: colors[color].line.divider
            }
          },
          '&.header': {
            backgroundColor: colors[color].contrastTextAction,
            color: colors[color].main,
            '& .inner': {
              '&:before, &:after': {
                backgroundColor: colors[color].main
              }
            }
          },
          '&.subHeading': {
            backgroundColor: colors[color].line.divider,
            '& .inner': {
              '&:before, &:after': {
                backgroundColor: colors[color].main
              }
            }
          }
        },
        '&.isScrollable': {
          '&.isTallTable': {
            '&:not(.isFatTable)': {
              '& .wrapper': {
                borderLeft: "1px solid ".concat(colors[color].line.divider),
                borderBottom: "1px solid ".concat(colors[color].line.divider)
              }
            }
          }
        },
        '& .mainTable': {
          border: "1px solid ".concat(colors[color].line.divider)
        },
        '& .stickyColumn': {
          '& table': {
            borderColor: colors[color].line.divider,
            borderRight: "1px solid ".concat(colors[color].main)
          }
        },
        '& .stickyHeader': {
          backgroundColor: colors[color].contrastTextAction,
          '& table': {
            backgroundColor: colors[color].contrastTextAction
          }
        },
        '& .stickyIntersect': {
          borderRight: "1px solid ".concat(colors[color].contrastTextAction)
        }
      }
    };
  });
  return _objectSpread2({
    mainWrapper: {
      position: 'relative',
      '& .slick-arrow': {
        top: '50vh',
        // overriding global body .carouselarrowbutton
        zIndex: '3 !important'
      },
      '& .slick-prev': (_slickPrev = {
        left: theme.spacing(-2.5)
      }, _defineProperty(_slickPrev, theme.breakpoints.up('sm'), {
        left: theme.spacing(-2.5)
      }), _defineProperty(_slickPrev, theme.breakpoints.up('xl'), {
        left: theme.spacing(-6)
      }), _slickPrev),
      '& .slick-next': (_slickNext = {
        right: theme.spacing(-1)
      }, _defineProperty(_slickNext, theme.breakpoints.up('sm'), {
        right: theme.spacing(-2.5)
      }), _defineProperty(_slickNext, theme.breakpoints.up('xl'), {
        right: theme.spacing(-6)
      }), _slickNext),
      '&.isGated': {
        '& .moreContentOnRight': {
          '&:after': {
            zIndex: 0
          }
        },
        '& .moreContentOnLeft': {
          '&:before': {
            zIndex: 0
          }
        },
        '& .slick-arrow': {
          display: 'none'
        }
      },
      '&.isArticleBody': _defineProperty({
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(6)
      }, theme.breakpoints.up('lg'), {
        marginTop: theme.spacing(8),
        marginBottom: theme.spacing(8)
      })
    },
    table: {
      display: 'flex',
      flexDirection: 'column',
      '&.customScrollbar': {
        '& .wrapper': {
          '&::-webkit-scrollbar': {
            appearance: 'none',
            '-webkit-appearance': 'none'
          },
          '&::-webkit-scrollbar:vertical': {
            width: theme.spacing(1),
            visibility: 'visible',
            display: 'block !important'
          },
          '&::-webkit-scrollbar:horizontal': {
            height: theme.spacing(1),
            visibility: 'visible',
            display: 'block !important'
          },
          '&::-webkit-scrollbar-track': {
            borderRadius: theme.spacing(0.5),
            display: 'block !important'
          },
          '&::-webkit-scrollbar-thumb': {
            borderRadius: theme.spacing(0.5)
          }
        },
        '&.isScrollable': (_isScrollable = {}, _defineProperty(_isScrollable, theme.breakpoints.up('sm'), {
          '&:after': {
            bottom: theme.spacing(1)
          }
        }), _defineProperty(_isScrollable, '&.moreContentOnRight', {
          '&:not(.isTouchDevice)': _defineProperty({}, theme.breakpoints.up('sm'), {
            '&:after': {
              right: theme.spacing(1)
            }
          })
        }), _isScrollable),
        '&.moreContentOnRight': {
          '&.verticalScrollEnd': {
            '&:after': _defineProperty({}, theme.breakpoints.up('sm'), {
              bottom: theme.spacing(3)
            })
          },
          '&:after': _defineProperty({}, theme.breakpoints.up('sm'), {
            bottom: theme.spacing(1)
          })
        },
        '&.moreContentOnLeft': {
          '&.verticalScrollEnd': {
            '&:before': _defineProperty({}, theme.breakpoints.up('sm'), {
              bottom: theme.spacing(3)
            })
          },
          '&:before': _defineProperty({}, theme.breakpoints.up('sm'), {
            bottom: theme.spacing(1)
          })
        }
      },
      '&.isFatTable': {
        '&.isTouchDevice': {
          '& .wrapper': {
            overflowX: 'inherit'
          },
          '&.moreContentOnRight': {
            '&:after': _defineProperty({
              bottom: theme.spacing(1)
            }, theme.breakpoints.up('sm'), {
              bottom: theme.spacing(3)
            })
          },
          '&.moreContentOnLeft': {
            '&:after': _defineProperty({
              bottom: theme.spacing(1)
            }, theme.breakpoints.up('sm'), {
              bottom: theme.spacing(3)
            })
          }
        },
        '& .mainTable': {
          marginBottom: theme.spacing(2)
        },
        '&.moreContentOnRight': {
          '& .wrapper': {
            borderTopRightRadius: '0 !important',
            '& .mainTable': {
              borderTopRightRadius: '0 !important'
            }
          },
          '&.verticalScrollEnd': {
            '&:after': _defineProperty({}, theme.breakpoints.up('sm'), {
              bottom: theme.spacing(4)
            })
          },
          '&:after': _defineProperty({}, theme.breakpoints.up('sm'), {
            bottom: theme.typography.pxToRem(scrollbarWidth)
          })
        },
        '&.moreContentOnLeft': {
          '& .wrapper': {
            borderTopLeftRadius: '0 !important',
            '& .mainTable': {
              borderTopLeftRadius: '0 !important'
            }
          },
          '&.verticalScrollEnd': {
            '&:before': _defineProperty({}, theme.breakpoints.up('sm'), {
              bottom: theme.spacing(4)
            })
          },
          '&:before': _defineProperty({}, theme.breakpoints.up('sm'), {
            bottom: theme.typography.pxToRem(scrollbarWidth)
          })
        }
      },
      '&.isScrollable': (_isScrollable2 = {
        '&.isTallTable': {
          '& .mainTable': {
            borderRadius: theme.spacing(2, 0, 0, 2)
          },
          '&:not(.isFatTable)': {
            '& .wrapper': {
              '& .mainTable': {
                border: 'none',
                borderRadius: theme.spacing(2, 0, 0, 2)
              }
            }
          },
          '&:not(.isStickyHeader)': {
            '&:not(.isColumnSticky)': {
              '& .wrapper': {
                borderRadius: theme.spacing(2, 0, 0, 2),
                '& .mainTable': {
                  borderRadius: theme.spacing(2, 0, 0, 2)
                }
              }
            },
            '& .stickyColumn': {
              '& table': {
                borderTop: 0
              }
            },
            '& .mainTable': {
              borderTop: 'none'
            }
          }
        },
        '& .wrapper': {
          height: "calc(100vh - ".concat(theme.spacing(24), "px)"),

          /* magic value from UX */
          minHeight: theme.spacing(70)
        }
      }, _defineProperty(_isScrollable2, theme.breakpoints.up('sm'), {
        '&:after': {
          bottom: theme.typography.pxToRem(scrollbarWidth)
        }
      }), _defineProperty(_isScrollable2, '&.moreContentOnRight', {
        '&:not(.isTouchDevice)': _defineProperty({}, theme.breakpoints.up('sm'), {
          '&:after': {
            right: theme.typography.pxToRem(scrollbarWidth)
          }
        })
      }), _defineProperty(_isScrollable2, '&.moreContentOnLeft', _defineProperty({}, theme.breakpoints.up('sm'), {
        '&:before': {
          bottom: theme.typography.pxToRem(scrollbarWidth)
        }
      })), _isScrollable2),
      '&.moreContentOnRight': {
        '&:after': _defineProperty({
          pointerEvents: 'none',
          zIndex: 2,
          content: '""',
          background: 'linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)',
          width: theme.spacing(7),
          position: 'absolute',
          right: theme.spacing(-2),
          top: 0,
          bottom: theme.spacing(2)
        }, theme.breakpoints.up('sm'), {
          right: 0,
          width: theme.spacing(1),
          background: 'linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,0.2) 100%)'
        })
      },
      '&.moreContentOnLeft': {
        '&:before': _defineProperty({
          pointerEvents: 'none',
          display: 'none',
          zIndex: 2,
          content: '""',
          background: 'linear-gradient(to left, rgba(0,0,0,0) 0%, rgba(0,0,0,0.2) 100%)',
          width: theme.spacing(1),
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: theme.spacing(2)
        }, theme.breakpoints.up('sm'), {
          display: 'block'
        })
      },
      '& .wrapper': (_wrapper = {
        overflowY: 'hidden',
        position: 'relative',
        scrollBehavior: 'smooth',
        margin: theme.spacing(0, -2),
        overflowX: 'hidden',
        '-webkit-overflow-scrolling': 'auto'
      }, _defineProperty(_wrapper, theme.breakpoints.up('sm'), {
        margin: theme.spacing(0)
      }), _defineProperty(_wrapper, theme.breakpoints.up('lg'), {
        margin: theme.spacing(0),
        overflowY: 'auto',
        overflowX: 'auto'
      }), _wrapper),
      '& table': {
        borderCollapse: 'collapse',
        borderSpacing: 0,
        display: 'block',
        position: 'relative',
        overflow: 'hidden'
      },
      '& td': {
        '-webkit-text-size-adjust': 'none',
        position: 'relative',
        padding: 0,
        border: 0,
        '& .link-action-white': {
          margin: theme.spacing(-0.75, -0.5)
        },
        '&:last-child': {
          '& .inner': {
            '&:before': _defineProperty({}, theme.breakpoints.up('sm'), {
              width: "calc(100% - ".concat(theme.spacing(3), "px)")
            })
          }
        },
        '&:only-child': {
          '& .inner': {
            '&:before': _defineProperty({}, theme.breakpoints.down('xs'), {
              width: '100%!important'
            })
          }
        },
        '&:first-child': {
          '& .inner': {
            '&:before': _defineProperty({
              left: 0,
              width: '100%'
            }, theme.breakpoints.up('sm'), {
              left: 'auto',
              width: "calc(100% - ".concat(theme.spacing(3), "px)")
            })
          }
        },
        '&:first-child:last-child': {
          '& .inner': {
            '&:before': _defineProperty({}, theme.breakpoints.up('sm'), {
              width: "calc(100% - ".concat(theme.spacing(6), "px)")
            })
          }
        },
        '& .inner': (_inner = {
          width: '100%',
          height: '100%',
          padding: theme.spacing(2),
          position: 'relative',
          display: 'block'
        }, _defineProperty(_inner, theme.breakpoints.up('sm'), {
          padding: theme.spacing(2, 3)
        }), _defineProperty(_inner, '&:before, &:after', {
          content: '""',
          display: 'block',
          position: 'absolute'
        }), _defineProperty(_inner, '&:after', {
          width: '1px',
          height: "calc(100% - ".concat(theme.spacing(4), "px)"),
          top: theme.spacing(2),
          bottom: theme.spacing(2),
          right: 0
        }), _defineProperty(_inner, '&:before', {
          width: '100%',
          height: '1px',
          bottom: '-1px',
          left: 0
        }), _inner),
        '&.header': {
          /* exception declaration of inline lineHeight due to whole take is dynamically generated */
          lineHeight: theme.typography.pxToRem(20),
          fontWeight: 700,
          '& .inner': (_inner2 = {}, _defineProperty(_inner2, theme.breakpoints.down('sm'), {
            padding: theme.spacing(1, 2)
          }), _defineProperty(_inner2, '&:after', _defineProperty({
            height: "calc(100% - ".concat(theme.spacing(2), "px)"),
            top: theme.spacing(1),
            bottom: theme.spacing(1)
          }, theme.breakpoints.up('sm'), {
            top: theme.spacing(2),
            bottom: theme.spacing(2),
            height: "calc(100% - ".concat(theme.spacing(4), "px)")
          })), _inner2),
          '&:last-child': {
            '& .inner': {
              '&:before': {
                display: 'none'
              }
            }
          }
        }
      },
      '& tr': {
        '&:last-child': {
          '& td': {
            '& .inner': {
              '&:before': {
                display: 'none'
              }
            }
          }
        }
      },
      '& .mainTable': _defineProperty({
        borderRadius: theme.spacing(2),
        margin: theme.spacing(0, 2)
      }, theme.breakpoints.up('sm'), {
        margin: theme.spacing(0)
      }),
      '& .stickyWrapper': {
        position: 'absolute',
        left: 0,
        top: 0,
        border: 'none',
        overflow: 'hidden',
        display: 'none'
      },
      '& .isSticky': {
        position: 'fixed',
        display: 'block',
        zIndex: 1
      },
      '& .stickyHeader': {
        boxShadow: theme.shadows[5],
        transition: "top 400ms ".concat(transitionFunction.easeIn),
        '.headerVisible &': _defineProperty({
          top: theme.spacing(7)
        }, theme.breakpoints.up('xl'), {
          top: theme.spacing(9)
        }),
        '&.isSticky': _defineProperty({
          padding: theme.spacing(0, 2),
          borderLeft: '1px solid transparent'
        }, theme.breakpoints.up('sm'), {
          padding: theme.spacing(0)
        })
      },
      '&.isIE': {
        '& .stickyHeader': {
          '&.isSticky': {
            zIndex: 1000
          }
        }
      },
      '& .stickyColumn': {
        paddingRight: theme.spacing(1),
        position: 'absolute',
        '& .header': {
          '&:before': {
            display: 'none'
          }
        },
        '& table': {
          borderWidth: '1px',
          borderStyle: 'solid',
          boxShadow: theme.shadows[6],
          marginBottom: theme.spacing(2),
          '& td': {
            '&:only-child': {
              '& .inner': {
                '&:after': {
                  display: 'none!important'
                }
              }
            },
            '& .inner': {
              '&:before': {
                width: '100%'
              }
            }
          }
        }
      },
      '& .stickyIntersect': {
        transition: "top 400ms ".concat(transitionFunction.easeIn),
        '.headerVisible &': _defineProperty({
          top: theme.spacing(7)
        }, theme.breakpoints.up('xl'), {
          top: theme.spacing(9)
        }),
        '& .header': {
          '&:before': {
            display: 'none'
          }
        },
        '& table': {
          '& td': {
            '&:only-child': {
              '& .inner': {
                '&:after': {
                  display: 'none!important'
                }
              }
            }
          }
        }
      },
      '& .tableWithIcons div.inner a img': {
        width: theme.spacing(3),
        height: theme.spacing(3),
        filter: 'none'
      },
      '& .tableWithIcons div.inner img': _defineProperty({
        width: theme.spacing(3),
        height: theme.spacing(3),
        filter: 'brightness(0) saturate(100%) invert(11%) sepia(53%) saturate(505%) hue-rotate(109deg) brightness(95%) contrast(86%);'
      }, theme.breakpoints.up('sm'), {
        height: theme.spacing(4),
        width: theme.spacing(4)
      })
    }
  }, theming);
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var COMPONENT_NAME = 'TableComponent';
var COMPONENT_TABLE_BUTTON_PREV = 'TableComponent-Prev';
var COMPONENT_TABLE_BUTTON_NEXT = 'TableComponent-Next';
var COMPONENT_STICKY_HEADER = 'TableComponent-Sticky-Header';
var COMPONENT_STICKY_COLUMN = 'TableComponent-Sticky-Column';
var COMPONENT_STICKY_INTERSECT = 'TableComponent-Sticky-intersect';

/*9fbef606107a605d69c0edbcd8029e5d*/
/**
 * Arrow button for Slick slider Carousel
 * Following props used in this component
 * @param {string} className - CSS Class name
 * @param {string} color - Color palette for slick arrow theme - default value is 'white'
 * @param {string} dataLocator - Data locator name
 * @param {function} onClick - Function to handle onClick event
 * @param {string} ariaLabel - Used to define a string that labels the current element. Use it in cases where a text label is not visible on the screen
 *                             default value is 'carousel-dir-buttons'
 */

var CarouselArrowButton = function CarouselArrowButton(props) {
  var dataLocator = props.dataLocator,
      _props$color = props.color,
      color = _props$color === void 0 ? 'white' : _props$color,
      className = props.className,
      onClick = props.onClick,
      style = props.style,
      _props$ariaLabel = props.ariaLabel,
      ariaLabel = _props$ariaLabel === void 0 ? 'carousel-dir-buttons' : _props$ariaLabel;
  return className ? /*#__PURE__*/React__default.createElement("button", {
    className: "".concat(className, " carouselarrowbuttonCommon carouselarrowbutton-").concat(color),
    role: 'button',
    onClick: onClick,
    "data-locator": dataLocator,
    "aria-label": ariaLabel,
    style: style
  }, /*#__PURE__*/React__default.createElement(ArrowForward, null)) : null;
};

var useStyles$k = makeStyles$1(styles$j);
var defaultAnchorText = "Table-" + getRandomValues();

function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
}

var sendGAEvents = function sendGAEvents(isLeft, componentName) {
  PushEvent({
    event: "swipe",
    swipeGesture: isLeft ? "left" : "right",
    componentName: componentName
  });
};

var mSendGAEvents = debounce(sendGAEvents, 3000).bind(undefined);

function TableComponent$1(props) {
  var _clsx;

  var classes = useStyles$k();
  var gaCategoryName = get$1(props, "fields.gaCategoryName.value", null);
  var anchorText = get$1(props, "params.anchorText", defaultAnchorText).replace(/\s+/g, "-");
  var flexiCol = parseInt(props.flexiCol, 10) || null;
  var isArticleBody = !!parseInt(get$1(props, "params.isArticleBody", "0"), 10);
  var hasDividerLine = !!parseInt(get$1(props, "params.divider", "0"), 10);
  var isStickyHeaderFlag = get$1(props, "fields.stickyHeaderFlag.value", false);
  var isStickyColumnFlag = get$1(props, "fields.stickyFirstColumnFlag.value", false);
  var isScrollableFlag = get$1(props, "fields.scrollableButton.value", false);
  var isGated = get$1(props, "isGated", false);
  var isFitToContainer = get$1(props, "fields.fitToContainer.value", false);

  var _getColors = getColors(get$1(props, "params.backgroundColor", "white-orange")),
      bgColor = _getColors.bgColor;

  var params = get$1(props, "params", {});
  var headerVisible = get$1(props, "headerVisible", null);
  var isTouchDevice = getIsTouchDevice(); // refs

  var mainContainerRef = useRef(); // states

  var isMobileWidth = useMediaQuery("(max-width:".concat(breakpoints.values.sm, "px)"));
  var isDesktopWidth = useMediaQuery("(min-width:".concat(breakpoints.values.lg, "px)"));

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      arrowTopPos = _useState2[0],
      setArrowTopPos = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      tableMarkup = _useState4[0],
      setTableMarkup = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      wrapperRect = _useState6[0],
      setWrapperRect = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      disableSlickNext = _useState8[0],
      setDisableSlickNext = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      verticalScrollEnd = _useState10[0],
      setVerticalScrollEnd = _useState10[1];

  var _useState11 = useState({
    left: 0,
    top: 0
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      wrapperScrollPos = _useState12[0],
      setWrapperScrollPos = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      mobileHasScrolledRight = _useState14[0],
      setMobileHasScrolledRight = _useState14[1];

  var _useState15 = useState(),
      _useState16 = _slicedToArray(_useState15, 2),
      isScrollable = _useState16[0],
      setIsScrollable = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      isHeaderSticky = _useState18[0],
      setIsHeaderSticky = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      isColumnSticky = _useState20[0],
      setIsColumnSticky = _useState20[1];

  var _useState21 = useState(null),
      _useState22 = _slicedToArray(_useState21, 2),
      isTallTable = _useState22[0],
      setIsTallTable = _useState22[1];

  var _useState23 = useState(null),
      _useState24 = _slicedToArray(_useState23, 2),
      isFatTable = _useState24[0],
      setIsFatTable = _useState24[1];

  var _useState25 = useState(null),
      _useState26 = _slicedToArray(_useState25, 2),
      prefixContent = _useState26[0],
      setPrefixContent = _useState26[1];

  var _useState27 = useState(null),
      _useState28 = _slicedToArray(_useState27, 2),
      suffixContent = _useState28[0],
      setSuffixContent = _useState28[1];

  var prevWrapperScrollPos = usePrevious(wrapperScrollPos); // settings

  var inlineStylesToIgnore = ["border", "border-top", "border-right", "border-bottom", "border-left", "color", "background", "background-color", "padding-top", "padding-bottom", "padding-left", "padding-right", "margin-top", "margin-bottom", "margin-left", "margin-right", "font-size", "font-family"]; // methods

  var onWindowScroll = useCallback(function () {
    /* istanbul ignore else */
    if (isGated) {
      return;
    }

    var mainContainer = mainContainerRef.current;
    var wrapper = mainContainer.querySelector(".wrapper");
    setWrapperRect(wrapper.getBoundingClientRect());
  }, [isGated]);

  var initSticky = function initSticky() {
    var tableContainer = mainContainerRef.current.querySelector(".tableContainer");

    if (tableContainer.querySelector(".wrapper")) {
      return;
    }

    var mainTable = mainContainerRef.current.querySelector(".mainTable").cloneNode(true);
    var wrapper = document.createElement("div");
    wrapper.classList.add("wrapper");
    wrapper.appendChild(mainTable);
    tableContainer.replaceChild(wrapper, mainContainerRef.current.querySelector(".mainTable"));

    var _wrapperRect = wrapper.getBoundingClientRect();
    /* istanbul ignore else */


    if (isStickyHeaderFlag) {
      var stickyHeaderTbody = document.createElement("tbody");
      stickyHeaderTbody.appendChild(mainTable.querySelector("thead tr").cloneNode(true));
      mainTable.querySelectorAll("thead td").forEach(function (td, i) {
        var width = td.getBoundingClientRect().width;
        Object.assign(stickyHeaderTbody.querySelectorAll("td")[i].style, {
          width: "".concat(width, "px"),
          minWidth: "".concat(width, "px"),
          maxWidth: "".concat(width, "px")
        });
      });
      var table = document.createElement("table");
      table.appendChild(stickyHeaderTbody);
      Object.assign(table.style, {
        width: mainTable.style.width
      });
      var stickyHeader = document.createElement("div"); // adding multiple class in classList is not support in ie11, adding one at a time.

      stickyHeader.classList.add("stickyHeader");
      stickyHeader.classList.add("stickyWrapper");
      stickyHeader.appendChild(table);
      stickyHeader.setAttribute("data-locator", COMPONENT_STICKY_HEADER);
      wrapper.appendChild(stickyHeader);
    }
    /* istanbul ignore else */


    if (isStickyColumnFlag) {
      var stickyColumnTbody = document.createElement("tbody");
      var trs = mainTable.cloneNode(true).querySelectorAll("tr");
      var rowspan = 0;
      trs.forEach(function (tr) {
        if (rowspan) {
          _toConsumableArray(tr.children).forEach(function (child) {
            return tr.removeChild(child);
          });

          rowspan--;
        } else {
          var _tr$querySelector;

          _toConsumableArray(tr.children).slice(1).forEach(function (child) {
            return tr.removeChild(child);
          });

          rowspan = tr !== null && tr !== void 0 && (_tr$querySelector = tr.querySelector("td")) !== null && _tr$querySelector !== void 0 && _tr$querySelector.getAttribute("rowspan") ? tr.querySelector("td").getAttribute("rowspan") - 1 : 0;
        }

        stickyColumnTbody.appendChild(tr);
      });

      var _table = document.createElement("table");

      _table.appendChild(stickyColumnTbody);

      var stickyColumn = document.createElement("div"); // adding multiple class in classList is not support in ie11, adding one at a time.

      stickyColumn.classList.add("stickyColumn");
      stickyColumn.classList.add("stickyWrapper");
      stickyColumn.appendChild(_table);
      stickyColumn.setAttribute("data-locator", COMPONENT_STICKY_COLUMN);
      wrapper.appendChild(stickyColumn);
    }
    /* istanbul ignore else */


    if (isStickyColumnFlag && isStickyHeaderFlag) {
      var stickyIntersectTbody = document.createElement("tbody");
      /* istanbul ignore else */

      if (mainTable.querySelector("thead tr:first-child td:first-child")) {
        stickyIntersectTbody.appendChild(mainTable.querySelector("thead tr:first-child td:first-child").cloneNode(true));
      }

      var _table2 = document.createElement("table");

      _table2.appendChild(stickyIntersectTbody);

      var stickyintersect = document.createElement("div"); // adding multiple class in classList is not support in ie11, adding one at a time.

      stickyintersect.classList.add("stickyIntersect");
      stickyintersect.classList.add("stickyWrapper");
      stickyintersect.appendChild(_table2);
      stickyintersect.setAttribute("data-locator", COMPONENT_STICKY_INTERSECT);
      wrapper.appendChild(stickyintersect);
    } // hacky mobile-only div to extend .wrapper with 16px on the right when table scrolled to extreme right


    if (wrapper.querySelector("invisibleMobileWidth")) {
      wrapper.removeChild(wrapper.querySelector("invisibleMobileWidth"));
    }

    if (isMobileWidth) {
      // ignoring condition as getBoundingClientRect within cannot be jest simulated

      /* istanbul ignore if */
      var invisibleMobileWidthElm = document.createElement("div");
      invisibleMobileWidthElm.classList.add("invisibleMobileWidth");
      Object.assign(invisibleMobileWidthElm.style, {
        width: "".concat(parseInt(mainTable.getBoundingClientRect().width, 10) + 32, "px"),
        height: "1px"
      });
      wrapper.appendChild(invisibleMobileWidthElm);
    }
    /* istanbul ignore else */


    if (typeof window !== "undefined") {
      setIsScrollable(_wrapperRect.height > window.innerHeight - 192 && isScrollableFlag && !isMobileWidth && !isTouchDevice); // set default arrow position

      setArrowTopPos(_wrapperRect.height > window.innerHeight ? window.innerHeight / 2 : _wrapperRect.height / 2);
    }
  }; // when tableContainer is scrolled


  var scrollHandle = function scrollHandle() {
    var mainContainer = mainContainerRef.current;
    var wrapper = mainContainer.querySelector(".wrapper");
    setWrapperScrollPos(function (wrapperScrollLeft) {
      return {
        left: wrapper.scrollLeft,
        top: wrapper.scrollTop,
        horzVector: wrapperScrollLeft > wrapper.scrollLeft
      };
    });
  };

  var onClickedPrev = function onClickedPrev(e) {
    animateScroll.scrollMore(-240, {
      delay: 0,
      container: mainContainerRef.current.querySelector(".wrapper"),
      duration: 400,
      smooth: "easeInOutQuint",
      horizontal: true
    });
    PushEvent({
      event: "buttonClick",
      buttonTitle: COMPONENT_TABLE_BUTTON_PREV,
      destinationUrl: undefined,
      componentName: gaCategoryName || COMPONENT_NAME
    });
    e.currentTarget.blur();
  };

  var onClickedNext = function onClickedNext(e) {
    animateScroll.scrollMore(240, {
      delay: 0,
      container: mainContainerRef.current.querySelector(".wrapper"),
      duration: 400,
      smooth: "easeInOutQuint",
      horizontal: true
    });
    PushEvent({
      event: "buttonClick",
      buttonTitle: COMPONENT_TABLE_BUTTON_NEXT,
      destinationUrl: undefined,
      componentName: gaCategoryName || COMPONENT_NAME
    });
    e.currentTarget.blur();
  };

  var updateFatTall = function updateFatTall() {
    /* istanbul ignore else */
    if (mainContainerRef && mainContainerRef.current) {
      var mainTable = mainContainerRef.current.querySelector(".mainTable");
      var wrapper = mainContainerRef.current.querySelector(".wrapper");
      /* istanbul ignore else */

      if (mainTable && wrapper) {
        var _mainTableRect = mainTable.getBoundingClientRect();

        var _wrapperRect = wrapper.getBoundingClientRect();

        setIsTallTable(_mainTableRect.height > isScrollable ? _wrapperRect.height : window.innerHeight);
        setIsFatTable(_mainTableRect.width + (isMobileWidth ? 16 : 0) > _wrapperRect.width);
      }
    }
  }; // effects
  // init


  useEffect(function () {
    if (get$1(props, "fields.text.value", "").indexOf("<table") !== -1) {
      // bring prefix and suffix content outside of main container
      var text = get$1(props, "fields.text.value", "");
      setPrefixContent(text.slice(0, Math.max(text.indexOf("<table"), 0)));
      setSuffixContent(text.slice(text.indexOf("</table>") + 8));
      var isTableWithIcons = text.indexOf("FWD-custom-table-with-icons") !== -1; // add class for identification purposes

      setTableMarkup(text.slice(Math.max(text.indexOf("<table"), 0), text.indexOf("</table>") + 8).replace(/<table/g, "<table class=\"mainTable ".concat(isTableWithIcons ? "tableWithIcons" : "", "\"")));
    }
  }, []); // after setTableMarkup, mainly preformatting

  useEffect(function () {
    /* istanbul ignore else */
    if (mainContainerRef.current && tableMarkup) {
      var mainContainer = mainContainerRef.current; // -2 due to border 1px each side

      var mainTable = mainContainer.querySelector(".mainTable");
      var tableContainer = mainContainer.querySelector(".tableContainer");
      var tableContainerWidth = Math.floor(tableContainer.getBoundingClientRect().width); // strip all td height

      mainTable.querySelectorAll("td[style]").forEach(function (td) {
        return td.style.removeProperty("height");
      }); // strip and moved table initial width & height to data-initialwidth data-initialheight

      mainTable.setAttribute("data-initialheight", mainTable.style.height);
      mainTable.setAttribute("data-initialwidth", mainTable.style.width);
      Object.assign(mainTable.style, {
        height: "",
        width: "",
        border: "",
        "margin-top": "",
        "margin-right": "",
        "margin-bottom": "",
        "margin-left": "",
        margin: "",
        "padding-top": "",
        "padding-right": "",
        "padding-bottom": "",
        "padding-left": "",
        padding: ""
      });
      var trs = mainTable.querySelectorAll("tr");
      /* istanbul ignore else */

      if (trs) {
        trs.forEach(function (tr) {
          tr.removeAttribute("height");
          tr.style.removeProperty("height");
        });
      } // wrap all td with inner wrapper, fixes IE border issues


      mainTable.querySelectorAll("td").forEach(function (td) {
        if (!td.querySelector(".inner")) {
          var inner = document.createElement("div");
          inner.classList.add("inner");
          inner.innerHTML = td.innerHTML;
          td.innerHTML = "";
          td.appendChild(inner);
        }
      }); // strip colgroup

      mainTable.querySelectorAll("colgroup").forEach(function (colgroup) {
        return colgroup.parentNode.removeChild(colgroup);
      }); // update cell width if isFitToContainer === true, onload only
      // ignoring condition as getBoundingClientRect within cannot be jest simulated

      /* istanbul ignore if */

      if (isFitToContainer && mainTable.querySelector("tbody").getBoundingClientRect().width < tableContainerWidth) {
        // extract the widths from the first row of td, interpolate with mainContainer's width
        var tds = _toConsumableArray(mainContainer.querySelectorAll(".mainTable *:first-child tr:first-child td"));

        if (tds) {
          tds.map(function (td) {
            return td.setAttribute("data-initialwidth", parseInt(td.getBoundingClientRect().width, 10));
          });
          var totalCellWidth = sumOfArray(tds.map(function (td) {
            return Number(td.getAttribute("data-initialwidth"));
          }));
          tds.forEach(function (td) {
            Object.assign(td.style, {
              width: "".concat(Math.round(Number(td.getAttribute("data-initialwidth")) / totalCellWidth * tableContainerWidth), "px")
            });
          });
        } // re-define the table width with parent ref


        Object.assign(mainTable.style, {
          width: "".concat(tableContainerWidth, "px")
        });
      } // check if table already has thead, if not manipulate the table to have one.


      if (!mainTable.querySelector("thead")) {
        var thead = document.createElement("thead");
        thead.appendChild(mainTable.querySelector("tr:first-child"));
        mainTable.insertBefore(thead, mainTable.childNodes[0]);
        mainTable.querySelectorAll("thead td").forEach(function (node) {
          return node.classList.add("header");
        });
      } // remove ignored inline styles


      mainTable.querySelectorAll("td, td span").forEach(function (td) {
        inlineStylesToIgnore.forEach(function (style) {
          return td.style.removeProperty("".concat(style));
        });
      }); // set width to all cells

      mainTable.querySelectorAll("td").forEach(function (td) {
        var tdWidth = td.style.width || "".concat(td.getBoundingClientRect().width, "px");
        !td.hasAttribute("data-initialwidth") && td.setAttribute("data-initialwidth", tdWidth);
        Object.assign(td.style, {
          width: tdWidth,
          minWidth: tdWidth,
          maxWidth: tdWidth
        });
      }); // update mainTable width

      Object.assign(mainTable.style, {
        width: "".concat(mainTable.querySelector("tbody").getBoundingClientRect().width, "px")
      }); // set height to all cells, only after width and main table above are updated.

      mainTable.querySelectorAll("tr").forEach(function (tr) {
        var tds = _toConsumableArray(tr.querySelectorAll("td"));

        var hasRowSpan = _toConsumableArray(tr.querySelectorAll("td")).some(function (td) {
          return td.getAttribute("rowspan");
        });

        var height = getMaxHeight(tds);
        tr.querySelectorAll("td").forEach(function (td) {
          /* istanbul ignore else */
          if (hasRowSpan) {
            height = td.getBoundingClientRect().height;
          }

          Object.assign(td.style, {
            height: "".concat(height, "px"),
            minHeight: "".concat(height, "px"),
            maxHeight: "".concat(height, "px")
          }); // we're not using display: table-cell due to safari bug and IE11 compatibility
          // so we're using default display:block for RTE formatting, but inline-flex for specific alignment from CMS

          Object.assign(td.querySelector(".inner").style, _objectSpread2({}, _toConsumableArray(new Array(td.style.length)).reduce(function (acc, v, k) {
            var key = td.style[k];
            var value = td.style.getPropertyValue(key);

            if (key === "text-align" && value !== "left") {
              /* istanbul ignore else */
              if (value === "right") {
                value = "flex-end";
              }

              key = "justifyContent";
              acc["display"] = "inline-flex";
            } else if (key === "vertical-align" && value !== "top") {
              /* istanbul ignore else */
              if (value === "top") {
                value = "flex-start";
              } else if (value === "middle") {
                value = "center";
              } else if (value === "bottom") {
                value = "flex-end";
              }

              key = "alignItems";
              acc["display"] = "inline-flex";
            }

            acc[key] = value;
            return acc;
          }, {})));
        });
      });
      initSticky();
      onWindowScroll(); // extract the wrapper created in initSticky()

      var wrapper = mainContainer.querySelector(".wrapper"); // add class to all </a> with img within

      /* istanbul ignore else */

      if (wrapper) {
        _toConsumableArray(wrapper.querySelectorAll("a")).filter(function (node) {
          return node.querySelector("img");
        }).forEach(function (node) {
          return node.classList.add("link-action-".concat(bgColor));
        });
      }
      /* istanbul ignore else */


      if (typeof window !== "undefined") {
        if (isGated) {
          window.removeEventListener("scroll", onWindowScroll);
        } else {
          /* istanbul ignore else */
          if (wrapper) {
            window.removeEventListener("scroll", onWindowScroll);
            window.addEventListener("scroll", onWindowScroll);
          }
        }
      }

      return function () {
        /* istanbul ignore else */
        if (typeof window !== "undefined") {
          window.removeEventListener("scroll", onWindowScroll);
        }
      };
    }
  }, [tableMarkup, mainContainerRef, isGated]); // when window / tableContainer is scrolled

  useEffect(function () {
    var mainContainer = mainContainerRef.current;
    /* istanbul ignore else */

    if (mainContainer) {
      var wrapper = mainContainer.querySelector(".wrapper");
      if (!wrapper || !wrapperRect) return;

      var _headerVisible = headerVisible && wrapperRect && wrapperRect.top < 0;

      var mainTable = mainContainer.querySelector(".mainTable");
      var stickyHeader = mainContainer.querySelector(".stickyHeader");
      var stickyColumn = mainContainer.querySelector(".stickyColumn");
      var stickyIntersect = mainContainer.querySelector(".stickyIntersect");
      var bottomThreshold = 32;
      var _isHeaderSticky = false;
      var _isColumnSticky = false;
      var stickyHeaderHeight = 0;
      /* istanbul ignore else */

      if (stickyHeader && isStickyHeaderFlag) {
        stickyHeaderHeight = stickyHeader.getBoundingClientRect().height || Number(stickyHeader.getAttribute("data-initialHeight"));
        stickyHeaderHeight && stickyHeader.setAttribute("data-initialHeight", stickyHeaderHeight);
        _isHeaderSticky = wrapperRect.bottom < 0 ? false : !!wrapperScrollPos.top && wrapperRect.bottom > stickyHeaderHeight + bottomThreshold || wrapperRect.top < 0 && wrapperRect.bottom > stickyHeaderHeight + bottomThreshold;
        _isHeaderSticky ? stickyHeader.classList.add("isSticky") : stickyHeader.classList.remove("isSticky");
        Object.assign(stickyHeader.style, {
          marginTop: "".concat(wrapperRect.top < 0 ? 0 : wrapperRect.top + (_headerVisible ? isDesktopWidth ? -72 : -56 : 0), "px"),
          left: isMobileWidth ? 0 : "".concat(_isHeaderSticky ? wrapperRect.left : 0, "px"),
          width: isMobileWidth ? "100%" : "".concat(Math.min(wrapperRect.width, parseInt(mainTable.style.width, 10)) + (!isTouchDevice && isScrollable ? -(Math.min(wrapperRect.width, parseInt(mainTable.style.width, 10)) - wrapper.clientWidth) : 0), "px")
        });
        Object.assign(stickyHeader.querySelector("table").style, {
          width: "".concat(parseInt(mainTable.style.width, 10) + (isMobileWidth ? 16 : 0), "px")
        });
        stickyHeader.scrollLeft = wrapperScrollPos.left;
        setIsHeaderSticky(_isHeaderSticky);
      }
      /* istanbul ignore else */


      if (stickyColumn && isStickyColumnFlag) {
        _isColumnSticky = !!wrapperScrollPos.left;
        _isColumnSticky ? stickyColumn.classList.add("isSticky") : stickyColumn.classList.remove("isSticky");
        Object.assign(stickyColumn.style, {
          left: "".concat(_isColumnSticky ? wrapperScrollPos.left : 0, "px")
        });
        stickyColumn.scrollTop = wrapperScrollPos.top;
        setIsColumnSticky(_isColumnSticky);
      }
      /* istanbul ignore else */


      if (isStickyHeaderFlag && isStickyColumnFlag) {
        _isHeaderSticky && _isColumnSticky ? stickyIntersect.classList.add("isSticky") : stickyIntersect.classList.remove("isSticky");
        Object.assign(stickyIntersect.style, {
          marginTop: "".concat(wrapperRect.top < 0 ? 0 : wrapperRect.top + (_headerVisible ? isMobileWidth ? -56 : -72 : 0), "px"),
          left: "".concat(_isColumnSticky ? wrapperRect.left : 0, "px")
        });
      }

      if (!mobileHasScrolledRight && wrapperScrollPos.left) {
        setMobileHasScrolledRight(true);
      }

      var verticalScrollbarWidth = Math.max(wrapperRect.width - wrapper.clientWidth, 0);
      setDisableSlickNext(wrapper.scrollWidth - Math.ceil(wrapperRect.width) + verticalScrollbarWidth - 2 <= wrapper.scrollLeft);
      var verticalScrollbarheight = Math.max(Math.round(wrapperRect.height - wrapper.clientHeight), 0);
      setVerticalScrollEnd(wrapper.scrollHeight - Math.ceil(wrapperRect.height) + verticalScrollbarheight === wrapper.scrollTop); // ignoring condition as getBoundingClientRect within cannot be jest simulated

      /* istanbul ignore next */

      if (typeof window !== "undefined") {
        var feedbackButton = document.querySelector(".kampyle_button");
        var feedbackButtonRect = feedbackButton && feedbackButton.getBoundingClientRect ? feedbackButton.getBoundingClientRect() : {
          height: 0,
          bottom: 0
        };
        var nextArrowOffset = isTallTable && (isMobileWidth || !isArticleBody) && !isScrollable && feedbackButton ? 0.45 * window.innerHeight - Math.ceil(feedbackButtonRect.height / 2) + (isMobileWidth ? -40 : -24) : 0;
        var top; // with fix for next button under "feedback" button

        if (wrapperRect.height > window.innerHeight || isFatTable) {
          // when table height is larger than viewport height
          if (wrapperRect.top < 0) {
            // when top of table has scrolled pass the top of the page
            if (wrapperRect.bottom > window.innerHeight) {
              // when there still more content beyond the page
              if (feedbackButton && nextArrowOffset) {
                top = Math.abs(wrapperRect.top) + nextArrowOffset;
              } else {
                top = Math.abs(wrapperRect.top) + window.innerHeight / 2;
              }
            } else {
              // when the bottom of the table is visible in the page
              if (feedbackButton && nextArrowOffset) {
                top = Math.min(Math.abs(wrapperRect.top) + wrapperRect.bottom / 2, Math.abs(wrapperRect.top) + nextArrowOffset);
              } else {
                top = Math.abs(wrapperRect.top) + wrapperRect.bottom / 2;
              }
            }
          } else {
            // when top of table is still visible in page
            top = Math.min(window.innerHeight, wrapperRect.height) / 2;
          }
        } else {
          // when table height is smaller than viewport height
          top = wrapperRect.height / 2;
        }

        if (prevWrapperScrollPos.left !== wrapperScrollPos.left) {
          mSendGAEvents(prevWrapperScrollPos.left > wrapperScrollPos.left, gaCategoryName || COMPONENT_NAME);
        } // 40 - height of button
        // Max.min to prevent button from going beyond (below) the table


        setArrowTopPos(Math.min(wrapperRect.height - 40, top));
      }
    }
  }, [wrapperScrollPos, wrapperRect, isMobileWidth, isScrollable, headerVisible, isFatTable]);
  useEffect(updateFatTall, [isScrollable, mainContainerRef]);
  useEffect(function () {
    var mainContainer = mainContainerRef.current;
    /* istanbul ignore else */

    if (mainContainer) {
      var wrapper = mainContainer.querySelector(".wrapper");
      /* istanbul ignore else */

      if (wrapper && typeof window !== "undefined") {
        var _wrapperRect = wrapper.getBoundingClientRect();

        setIsScrollable(_wrapperRect.height > window.innerHeight - 192 && isScrollableFlag && !isMobileWidth && !isTouchDevice);
      }
    }
  }, [isMobileWidth, isScrollableFlag, mainContainerRef]);
  return !!tableMarkup ? /*#__PURE__*/React__default.createElement(Container$1, {
    id: anchorText,
    useContainer: !isArticleBody && !flexiCol,
    background: bgColor,
    className: clsx(getPaddingString(params), {
      hasDividerLine: hasDividerLine
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    "data-locator": COMPONENT_NAME,
    ref: mainContainerRef,
    className: clsx(classes.mainWrapper, (_clsx = {}, _defineProperty(_clsx, classes["theming-".concat(bgColor)], bgColor), _defineProperty(_clsx, "headerVisible", headerVisible && wrapperRect && wrapperRect.top < 0), _defineProperty(_clsx, "isArticleBody", isArticleBody), _defineProperty(_clsx, "isGated", isGated), _clsx))
  }, prefixContent && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    color: bgColor,
    className: clsx("richtext-link-common", "richtext-link-".concat(bgColor)),
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: prefixContent
    }
  })), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    color: bgColor,
    className: clsx("richtext-link-common", "richtext-link-".concat(bgColor)),
    style: _objectSpread2({
      position: "relative"
    }, isFatTable === false ? {
      display: "inline-block"
    } : {})
  }, /*#__PURE__*/React__default.createElement(CarouselArrowButton, {
    className: clsx("slick-arrow", "slick-prev", {
      "slick-disabled": isMobileWidth ? true : !wrapperScrollPos.left
    }),
    dataLocator: COMPONENT_TABLE_BUTTON_PREV,
    color: bgColor,
    onClick: onClickedPrev,
    style: {
      top: arrowTopPos
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    onScroll: scrollHandle,
    dangerouslySetInnerHTML: {
      __html: tableMarkup
    },
    className: clsx(classes.table, "tableContainer", {
      moreContentOnRight: isMobileWidth ? isFatTable && !mobileHasScrolledRight : isFatTable && !disableSlickNext,
      moreContentOnLeft: isMobileWidth ? false : !!wrapperScrollPos.left && !isColumnSticky,
      isScrollable: isScrollable,
      isTouchDevice: isTouchDevice,
      isHeaderSticky: isHeaderSticky,
      isColumnSticky: isColumnSticky,
      isFatTable: isFatTable,
      isTallTable: isTallTable,
      verticalScrollEnd: verticalScrollEnd,
      customScrollbar: isChrome && isWebkit || isSafari && isWebkit || isFatTable && isTouchDevice && !isIEorEdge,
      isIE: isIE11$1()
    })
  }), /*#__PURE__*/React__default.createElement(CarouselArrowButton, {
    className: clsx("slick-arrow", "slick-next", {
      "slick-disabled": !!!tableMarkup || isGated || (isMobileWidth ? !isFatTable || mobileHasScrolledRight : !isFatTable || disableSlickNext)
    }),
    dataLocator: COMPONENT_TABLE_BUTTON_NEXT,
    color: bgColor,
    onClick: onClickedNext,
    style: {
      top: arrowTopPos
    }
  })), suffixContent && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    color: bgColor,
    className: clsx("richtext-link-common", "richtext-link-".concat(bgColor)),
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: suffixContent
    }
  })))) : null;
} // const mapStateToProps = createStructuredSelector({

var locatorStyles = makeStyles(function (theme) {
  var _mapContainer, _dropdown, _provinceWrapper, _labeltitle;

  var colors = theme.palette.colors || {};
  var dropdownUlColor = {};
  var chipColors = {};
  var facilityDropdown = {};
  var bullet = {};
  var containerBorder = {};
  var mapCardElem = {};
  var provinceStyle = {};
  var showHideBtnStyle = {};
  var googleMapStyle = {};
  var svgStyle = {};
  var itemListWrap = {};
  var filterContainerStyle = {};
  var placeholderColor = {};
  var distinctMsg = {};
  var sliderStyle = {};
  var getLocation = {};
  var containerStyle = {};
  Object.keys(colors).forEach(function (color) {
    /** For Default */
    facilityDropdown["facility-dropdown-".concat(color)] = {
      '& .MuiMenu-list': {
        '& .MuiMenu-list .Mui-selected': {
          color: get$1(colors[color], 'contrastTextAction', '#E87722')
        },
        '& .MuiListItem-button:hover': {
          backgroundColor: get$1(colors[color], 'contrastTextAction', '#E87722'),
          color: get$1(colors[color], 'main', '#FFFFFF')
        },
        '& .Mui-selected': {
          color: get$1(colors[color], 'contrastTextAction', '#E87722'),
          background: get$1(colors[color], 'main', '#FFFFFF')
        },
        '& .MuiSelect-selectMenu': {
          color: get$1(colors[color], 'contrastText', '#333333')
        }
      }
    };
  });
  Object.keys(colors).forEach(function (color) {
    /** For Default */
    bullet["bullet-".concat(color)] = {
      '&::before': {
        background: get$1(colors[color], 'contrastTextCaption', '#666666')
      }
    };
  });
  Object.keys(colors).forEach(function (color) {
    /** For Default */
    containerBorder["containerBorder-".concat(color)] = {
      border: "1px solid ".concat(get$1(colors[color], 'line.divider', '#E5E5E5'))
    };
  });
  Object.keys(colors).forEach(function (color) {
    var _selected, _mapCardElem$mapCardE;

    mapCardElem["mapCardElem-".concat(color)] = (_mapCardElem$mapCardE = {
      border: '3px solid transparent',
      borderBottom: "1px solid ".concat(get$1(colors[color], 'line.divider', '#E5E5E5'))
    }, _defineProperty(_mapCardElem$mapCardE, theme.breakpoints.up('sm'), {
      '&:hover': {
        borderColor: fwdColors.orangeLight,
        borderBottomWidth: '1px',
        '& .mapCardInnerContainer': {
          backgroundColor: fwdColors.orangeLight
        }
      }
    }), _defineProperty(_mapCardElem$mapCardE, '&.lastCardMarginBotton', {
      marginBottom: theme.spacing(20 / 8)
    }), _defineProperty(_mapCardElem$mapCardE, '&.selected', (_selected = {
      borderColor: get$1(colors[color], 'contrastTextAction', '#E87722'),
      borderBottomWidth: '3px',
      backgroundColor: get$1(colors[color], 'contrastTextAction', '#E87722')
    }, _defineProperty(_selected, theme.breakpoints.up('sm'), {
      '&:hover': {
        '& .mapCardInnerContainer': {
          borderBottomWidth: '3px',
          backgroundColor: fwdColors.orangeLight,
          '&.mapCardBorder': {
            borderTopLeftRadius: theme.spacing(3)
          }
        }
      }
    }), _defineProperty(_selected, '& .mapCardInnerContainer', _defineProperty({
      padding: "".concat(theme.spacing(21 / 8), "px ").concat(theme.spacing(13 / 8), "px"),
      borderRadius: '4px',
      backgroundColor: get$1(colors[color], 'main', '#FFFFFF')
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing(21 / 8),
      '&.mapCardBorder': {
        borderTopLeftRadius: theme.spacing(3)
      }
    })), _selected)), _mapCardElem$mapCardE);
  });
  Object.keys(colors).forEach(function (color) {
    provinceStyle["provinceWrapper-".concat(color)] = {
      background: get$1(colors[color], 'main', '#FFFFFF'),
      '& .MuiInputBase-root': {
        color: get$1(colors[color], 'contrastText', '#333333')
      }
    };
  });
  Object.keys(colors).forEach(function (color) {
    showHideBtnStyle["showHideWrapper-".concat(color)] = {
      color: get$1(colors[color], 'contrastTextAction', '#E87722'),
      // Added this for underline color of link
      '& svg': {
        '& path': {
          fill: get$1(colors[color], 'contrastTextAction', '#E87722')
        }
      }
    };
  });
  Object.keys(colors).forEach(function (color) {
    getLocation["getLocation-".concat(color)] = {
      '& path': {
        fill: get$1(colors[color], 'contrastTextAction', '#E87722')
      }
    };
  });
  Object.keys(colors).forEach(function (color) {
    googleMapStyle["googleMapStyle-".concat(color)] = {
      color: get$1(colors[color], 'main', '#FFFFFF'),
      // To override Google Map's InfoWindow text color
      '& .gm-style-iw-c': {
        background: get$1(colors[color], 'contrastTextAction', '#E87722')
      },
      '& .gm-style-iw-t::after': {
        background: get$1(colors[color], 'contrastTextAction', '#E87722')
      }
    };
  });
  Object.keys(colors).forEach(function (color) {
    svgStyle["svg-color-".concat(color)] = {
      '& svg': {
        '& g path': {
          fill: get$1(colors[color], 'contrastTextAction', '#E87722')
        }
      },
      '& .MuiAutocomplete-popupIndicator.MuiIconButton-root:hover': {
        backgroundColor: 'transparent'
      }
    };
  });
  Object.keys(colors).forEach(function (color) {
    itemListWrap["gMapBorder-".concat(color)] = {
      borderLeft: "1px solid ".concat(get$1(colors[color], 'line.divider', '#E5E5E5'))
    };
  });
  Object.keys(colors).forEach(function (color) {
    filterContainerStyle["filterContainer-".concat(color)] = _defineProperty({}, theme.breakpoints.up('sm'), {
      borderLeft: "1px solid ".concat(get$1(colors[color], 'line.divider', '#E5E5E5'))
    });
  });
  Object.keys(colors).forEach(function (color) {
    containerStyle["container-".concat(color)] = {
      borderBottom: "1px solid ".concat(get$1(colors[color], 'line.divider', '#E5E5E5'))
    };
  });
  Object.keys(colors).forEach(function (color) {
    placeholderColor["placeholderColor-".concat(color)] = {
      color: get$1(colors[color], 'contrastTextCaption', '#666666')
    };
  });
  Object.keys(colors).forEach(function (color) {
    distinctMsg["distinctMsg-".concat(color)] = {
      background: get$1(colors[color], 'main', '#FFFFFF')
    };
  });
  Object.keys(colors).forEach(function (color) {
    sliderStyle["slider-".concat(color)] = {
      '& .slick-active': _defineProperty({
        '&:first-child': {
          '&::before': {
            display: 'none'
          }
        }
      }, theme.breakpoints.up('sm'), {
        '&::before': {
          background: "linear-gradient(90deg, ".concat(get$1(colors[color], 'main', '#FFFFFF'), " 0%, rgba(255,255,255,0) 100%)")
        }
      }),
      '& .slick-slide, .slick-slide *': {
        outline: 'none !important'
      },
      '& .slick-prev, .slick-next': {
        '& path': {
          fill: get$1(colors[color], 'contrastTextAction', '#E87722')
        },
        background: get$1(colors[color], 'main', ''),
        boxShadow: "-6px 0px 4px 5px ".concat(get$1(colors[color], 'main', '#FFFFFF')),
        '&:hover': {
          background: get$1(colors[color], 'main', '')
        }
      }
    };
  });
  Object.keys(colors).forEach(function (color) {
    dropdownUlColor["dropdownUl-".concat(color)] = {
      '&.MuiAutocomplete-option[data-focus="true"]': {
        backgroundColor: get$1(colors[color], 'contrastTextAction', '#E87722'),
        color: get$1(colors[color], 'main', '#FFFFFF')
      },
      '&.MuiAutocomplete-option[aria-selected="true"]': {
        color: get$1(colors[color], 'contrastTextAction', '#E87722'),
        background: get$1(colors[color], 'main', '#FFFFFF'),
        '& svg g path': {
          fill: get$1(colors[color], 'contrastTextAction', '#E87722')
        },
        '&:hover': {
          backgroundColor: get$1(colors[color], 'contrastTextAction', '#E87722'),
          color: get$1(colors[color], 'main', '#FFFFFF'),
          '& svg g path': {
            fill: get$1(colors[color], 'main', '#FFFFFF')
          }
        }
      }
    };
  });
  return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, chipColors), dropdownUlColor), facilityDropdown), bullet), containerBorder), mapCardElem), provinceStyle), showHideBtnStyle), googleMapStyle), svgStyle), itemListWrap), filterContainerStyle), placeholderColor), distinctMsg), sliderStyle), getLocation), containerStyle), {}, {
    mapContainer: (_mapContainer = {}, _defineProperty(_mapContainer, theme.breakpoints.down('sm'), {
      paddingRight: '0',
      paddingLeft: '0'
    }), _defineProperty(_mapContainer, '&.error', _defineProperty({}, theme.breakpoints.down('xs'), {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2)
    })), _mapContainer),
    hidePaddingBottom: {
      paddingBottom: 0
    },
    dropdownWrapper: _defineProperty({}, theme.breakpoints.down('sm'), {
      padding: "0 ".concat(theme.spacing(2), "px")
    }),
    dropdown: (_dropdown = {
      marginBottom: theme.spacing(3),
      '& .MuiSelect-selectMenu': _defineProperty({
        fontSize: theme.typography.pxToRem(20),
        lineHeight: theme.typography.pxToRem(40)
      }, theme.breakpoints.up('sm'), {
        fontSize: theme.typography.pxToRem(25),
        lineHeight: theme.typography.pxToRem(42)
      })
    }, _defineProperty(_dropdown, theme.breakpoints.up('sm'), {
      marginBottom: theme.spacing(6)
    }), _defineProperty(_dropdown, '& .MuiInputBase-input', {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0
    }), _defineProperty(_dropdown, '&.MuiInputBase-root', {
      width: 'auto'
    }), _defineProperty(_dropdown, '& .MuiSelect-select', {
      paddingRight: theme.spacing(3.5)
    }), _dropdown),
    container: {
      display: 'flex',
      scrollBehavior: 'smooth'
    },
    hide: {
      display: 'none'
    },
    mapCard: {
      boxSizing: 'border-box',
      cursor: 'pointer',
      '&.mapCardInnerContainer': _defineProperty({
        padding: "".concat(theme.spacing(21 / 8), "px ").concat(theme.spacing(13 / 8), "px ").concat(theme.spacing(23 / 8), "px ").concat(theme.spacing(13 / 8), "px")
      }, theme.breakpoints.up('sm'), {
        padding: "".concat(theme.spacing(21 / 8), "px ").concat(theme.spacing(21 / 8), "px ").concat(theme.spacing(23 / 8), "px ").concat(theme.spacing(21 / 8), "px")
      })
    },
    justifyContent: {
      justifyContent: 'space-between',
      paddingBottom: theme.spacing(1)
    },
    telephoneWrapper: {
      display: 'table'
    },
    flexWrapper: {
      display: 'flex',
      alignItems: 'flex-start',
      '&.MuiTypography-h10': {
        fontWeight: theme.typography.fontWeights.normal
      }
    },
    mapCardTitle: {
      marginBottom: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(20)
    },
    mapCardLocationIcon: {
      height: '32px',
      width: '32px',
      marginLeft: theme.spacing(2)
    },
    mapCardInfo: {
      fontWeight: theme.typography.fontWeights.normal,
      display: 'inline-block'
    },
    mapCardAddress: {
      paddingTop: theme.spacing(1),
      '& svg': {
        marginRight: theme.spacing(0.5)
      }
    },
    truncateTextAlignment: {
      verticalAlign: 'top'
    },
    normalFontWeight: {
      fontWeight: theme.typography.fontWeights.normal
    },
    noResultWrapper: {
      display: 'flex',
      alignItems: 'center',
      '& .MuiTypography-root': {
        padding: theme.spacing(0, 2)
      },
      '& div': _defineProperty({
        marginLeft: 'auto',
        marginRight: 'auto'
      }, theme.breakpoints.up('sm'), {
        marginTop: 0
      })
    },
    showHideWrapper: {
      display: 'inline-flex',
      paddingTop: 0,
      marginTop: theme.spacing(1),
      '& .seeContactBtn': {
        fontWeight: theme.typography.fontWeights.bolder
      }
    },
    upArrow: {
      height: theme.spacing(2),
      transform: 'translate(0, 10%) rotate(270deg)'
    },
    downArrow: {
      transform: 'translate(0, 10%) rotate(90deg)'
    },
    freeze: {
      pointerEvents: 'none'
    },
    gMapDefault: function gMapDefault(pageLanguage) {
      var _gmStyleIwC, _ref;

      return _ref = {
        height: '300px',
        width: '100%'
      }, _defineProperty(_ref, theme.breakpoints.up('sm'), {
        height: '240px'
      }), _defineProperty(_ref, '& .gm-style-cc', {
        marginRight: theme.spacing(1.25)
      }), _defineProperty(_ref, '& .gm-ui-hover-effect', {
        display: 'none !important' // Added important to override Google Maps inline CSS

      }), _defineProperty(_ref, '& .pulseDiv', {
        transform: 'translate(2px, 2px)'
      }), _defineProperty(_ref, '& .pulseSpan', {
        position: 'absolute',
        width: '44px',
        height: '44px',
        borderRadius: '50%',
        animation: animations.pulse,
        backgroundColor: fwdColors.orange
      }), _defineProperty(_ref, '& .gm-style-iw-c', (_gmStyleIwC = {
        maxWidth: '260px !important',
        borderRadius: '4px',
        boxShadow: 'none',
        padding: "".concat(theme.spacing(12 / 8), "px ").concat(theme.spacing(1), "px  ").concat(theme.spacing(12 / 8), "px ").concat(theme.spacing(2), "px !important")
      }, _defineProperty(_gmStyleIwC, theme.breakpoints.up('sm'), {
        padding: "".concat(theme.spacing(10 / 8), "px ").concat(theme.spacing(1), "px  ").concat(theme.spacing(10 / 8), "px ").concat(theme.spacing(2), "px !important"),
        maxWidth: '320px !important'
      }), _defineProperty(_gmStyleIwC, '& .gm-style-iw-d', {
        overflow: 'auto !important'
      }), _defineProperty(_gmStyleIwC, '& .markerContent', _defineProperty({
        fontFamily: getMapFont(pageLanguage),
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(18),
        fontWeight: 700,
        padding: "".concat(theme.spacing(0.5), "px ").concat(theme.spacing(2), "px  ").concat(theme.spacing(0.5), "px 0")
      }, theme.breakpoints.up('sm'), {
        fontSize: "".concat(theme.typography.pxToRem(16), " !important"),
        lineHeight: "".concat(theme.typography.pxToRem(20), " !important"),
        padding: "".concat(theme.spacing(0.75), "px ").concat(theme.spacing(2), "px  ").concat(theme.spacing(0.75), "px 0 !important")
      })), _gmStyleIwC)), _defineProperty(_ref, '& .gm-style-iw-t::after', {
        height: theme.spacing(12 / 8),
        width: theme.spacing(12 / 8),
        boxShadow: 'none'
      }), _ref;
    },
    gMap: function gMap() {
      return _defineProperty({}, theme.breakpoints.up('sm'), {
        minHeight: '560px',
        height: '100%'
      });
    },
    provineMaplistWrapper: _defineProperty({
      width: '100%'
    }, theme.breakpoints.up('sm'), {
      width: '33.333%'
    }),
    chipsMapWrapper: {
      width: '66.666%'
    },
    itemListsWrap: _defineProperty({
      height: 'auto',
      width: '100%',
      scrollBehavior: 'smooth'
    }, theme.breakpoints.up('sm'), {
      height: '560px',
      overflowY: 'auto',
      width: '33.333%'
    }),
    showMoreIcon: {
      marginRight: theme.spacing(0.5),
      display: 'flex'
    },
    showMoreButton: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      marginBottom: '0'
    },
    cardListWrapper: _defineProperty({
      minWidth: '100%',
      height: '100%'
    }, theme.breakpoints.up('sm'), {
      height: '560px'
    }),
    mapWrapper: {
      minWidth: '100%'
    },
    chipsTopWrapper: {
      height: 'min-content',
      minWidth: '100%'
    },
    provinceWrapper: (_provinceWrapper = {
      padding: "".concat(theme.spacing(3), "px ").concat(theme.spacing(2), "px"),
      minWidth: '100%',
      height: 'min-content',
      '& .MuiInputBase-root': _defineProperty({
        fontWeight: theme.typography.fontWeights.bolder,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: theme.typography.pxToRem(40)
      }, theme.breakpoints.up('sm'), {
        fontSize: theme.typography.pxToRem(25),
        lineHeight: theme.typography.pxToRem(42)
      })
    }, _defineProperty(_provinceWrapper, theme.breakpoints.up('sm'), {
      padding: "".concat(theme.spacing(11 / 8), "px ").concat(theme.spacing(3), "px")
    }), _defineProperty(_provinceWrapper, '& .MuiInputBase-input', {
      height: theme.typography.pxToRem(30),
      '&::-ms-clear': {
        display: 'none'
      }
    }), _defineProperty(_provinceWrapper, '& .MuiFormControl-marginNormal', {
      margin: '0'
    }), _provinceWrapper),
    distinctMsgContainer: {
      display: 'flex',
      padding: "0 ".concat(theme.spacing(2), "px ").concat(theme.spacing(3), "px ").concat(theme.spacing(2), "px "),
      '& svg': {
        marginRight: theme.spacing(0.5),
        '& g path': {
          fill: fwdColors.greyDarker
        }
      }
    },
    relativeDiv: {
      position: 'relative'
    },
    distinctMsgContainerPositioned: {
      position: 'absolute',
      top: '0',
      margin: "".concat(theme.spacing(1), "px ").concat(theme.spacing(3), "px"),
      display: 'flex',
      padding: "".concat(theme.spacing(1), "px ").concat(theme.spacing(3), "px "),
      zIndex: '999',
      minWidth: 'calc( 100% - 48px)',
      boxShadow: '0 2px 8px 0 rgba(0,0,0,0.16)',
      '& svg': {
        marginRight: theme.spacing(0.5),
        '& g path': {
          fill: fwdColors.greyDarker
        }
      }
    },
    labeltitle: (_labeltitle = {
      display: 'block',
      padding: "0 0 ".concat(theme.spacing(1), "px 0"),
      fontWeight: theme.typography.fontWeights.bolder
    }, _defineProperty(_labeltitle, theme.breakpoints.up('sm'), {
      display: 'inline-block',
      padding: "".concat(theme.spacing(1), "px ").concat(theme.spacing(2), "px") //IMP: This has an impact on Plan Type Carousel behaviour: setShowCarousel2

    }), _defineProperty(_labeltitle, "whiteSpace", 'nowrap'), _labeltitle),
    TagItem: {
      display: 'inline-block',
      padding: theme.spacing(0.5, 2),
      marginRight: theme.spacing(1),
      //IMP: This has an impact on Filter By Carousel behaviour: setShowCarousel1
      cursor: 'pointer',
      backgroundColor: 'transparent',
      whiteSpace: 'nowrap',
      '&.active': {
        color: theme.palette.colors.white.main
      }
    },
    filterContainer: _defineProperty({
      display: 'block',
      padding: "".concat(theme.spacing(1), "px 0  ").concat(theme.spacing(2), "px  ").concat(theme.spacing(2), "px"),
      justifyContent: 'space-between',
      alignItems: 'center',
      overflow: 'hidden'
    }, theme.breakpoints.up('sm'), {
      display: 'inline-flex',
      padding: "".concat(theme.spacing(2), "px 0 ").concat(theme.spacing(2), "px ").concat(theme.spacing(1), "px")
    }),
    leftFilterWrapper: _defineProperty({
      padding: "0 ".concat(theme.spacing(2), "px ").concat(theme.spacing(2), "px ").concat(theme.spacing(2), "px")
    }, theme.breakpoints.up('sm'), {
      padding: "".concat(theme.spacing(2), "px ").concat(theme.spacing(2), "px ").concat(theme.spacing(2), "px ").concat(theme.spacing(1), "px"),
      justifyContent: 'flex-start'
    }),
    chipsWrapper: {
      display: 'flex',
      whiteSpace: 'nowrap'
    },
    bullet: {
      '&::before': {
        content: '" "',
        borderRadius: '50%',
        display: 'inline-block',
        height: '0.5em',
        marginLeft: theme.spacing(0.5),
        width: '0.5em',
        marginBottom: '0.1em'
      }
    },
    fullWidth: {
      width: '100%'
    },
    disableNextBtn: {
      '& .slick-next': {
        opacity: '0!important',
        pointerEvents: 'none'
      }
    },
    sliderWrap: {
      width: '100%',
      height: '100%',
      '& .slick-active': _defineProperty({
        '&:first-child': {
          '&::before': {
            display: 'none'
          }
        }
      }, theme.breakpoints.up('sm'), {
        '&::before': {
          height: "".concat(theme.spacing(4), "px"),
          width: "".concat(theme.spacing(4), "px"),
          background: 'linear-gradient(90deg, #FFFFFF 0%, rgba(255,255,255,0) 100%)',
          zIndex: '1',
          content: '" "'
        }
      }),
      '& .slick-slide, .slick-slide *': {
        outline: 'none !important'
      },
      '& .slick-prev, .slick-next': {
        '& path': {},
        width: "".concat(theme.spacing(4), "px"),
        height: "".concat(theme.spacing(4), "px"),
        zIndex: '7',
        opacity: 1,
        transition: motionTypes.fade.in
      },
      '& .slick-prev': {
        left: 0,
        transform: 'translate(0, -50%) rotate(180deg)'
      },
      '& .slick-next': {
        right: 0
      },
      '& .slick-disabled ': {
        opacity: '0',
        pointerEvents: 'none'
      },
      '& .slick-list ': {
        height: '100%'
      },
      '& .slick-track ': {
        display: 'flex',
        height: '100%',
        alignItems: 'center'
      },
      '& .slick-slide ': {
        height: 'auto'
      }
    },
    selected: {
      '& .showTickIcon': {
        display: 'none'
      },
      '&.MuiMenuItem-root.Mui-selected': {
        '& .showTickIcon': {
          display: 'inline-flex',
          paddingLeft: theme.spacing(1)
        }
      }
    },
    motionFade: {
      animation: animations.fadeIn
    },
    easingInOut: {
      transitionTimingFunction: "".concat(transitionFunction.easeInOut)
    },
    easingOut: {
      transitionTimingFunction: "".concat(transitionFunction.easeOut)
    }
  });
});

/*9fbef606107a605d69c0edbcd8029e5d*/
var MAPS_FACILITY_TYPE = 'MAPS_FACILITY_TYPE';
var MAPS_FACILITY_TYPE_DD_LIST_ITEM = 'MAPS_FACILITY_TYPE_DD_LIST_ITEM';
var MAPS_PROVINCE_TYPE = 'MAPS_PROVINCE_TYPE';
var MAPS_PROVINCE_SIDE_WRAPPER = 'MAPS_PROVINCE_SIDE_WRAPPER';
var GOOGLE_MAP = 'GOOGLE_MAP';
var MAPS_FACET_CHIP_WRAPPER = 'MAPS_FACET_CHIP_WRAPPER';
var MAPS_FACET_CHIP = 'MAPS_FACET_CHIP';
var MAPS_PLAN_TYPE_WRAPPER = 'MAPS_PLAN_TYPE_WRAPPER';
var MAPS_PLAN_TYPE = 'MAPS_PLAN_TYPE';
var MAPS_ITEM_CARD_WRAPPER = 'MAPS_ITEM_CARD_WRAPPER';
var MAPS_ITEM_CARD = 'MAPS_ITEM_CARD';
var MAPS_CARD_HEADING = 'MAPS_CARD_HEADING';
var MAPS_CARD_LOCATION = 'MAPS_CARD_LOCATION';
var MAPS_CARD_ADDRESS = 'MAPS_CARD_ADDRESS';
var MAPS_CARD_SEARCH_KEYS = 'MAPS_CARD_SEARCH_KEYS';
var MAPS_CARD_TELEPHONE_LINK = 'MAPS_CARD_TELEPHONE_LINK';
var MAPS_CARD_MOBILE_LINK = 'MAPS_CARD_MOBILE_LINK';
var MAPS_CARD_FAX_LINK = 'MAPS_CARD_FAX_LINK';
var MAPS_CARD_OPERATING_HOURS = 'MAPS_CARD_OPERATING_HOURS';
var MAPS_CARD_SHOW_CONTENT = 'MAPS_CARD_SHOW_CONTENT';
var MAPS_CARD_HIDE_CONTENT = 'MAPS_CARD_HIDE_CONTENT';
var MAPS_SHOWMORE_BUTTON = 'MAPS_SHOWMORE_BUTTON';
var MAPS_NO_DATA_WRAPPER = 'MAPS_NO_DATA_WRAPPER';

/*9fbef606107a605d69c0edbcd8029e5d*/
/*eslint-disable */

var GetDirection = createSvgIcon( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Get-Direction",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("rect", {
  id: "Box",
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M24.0001,39.9994 C15.1781,39.9994 8.0001,32.8224 8.0001,24.0004 C8.0001,15.1784 15.1781,8.0004 24.0001,8.0004 C32.8221,8.0004 40.0001,15.1784 40.0001,24.0004 C40.0001,32.8224 32.8221,39.9994 24.0001,39.9994 M24.0001,4.0004 C12.9721,4.0004 4.0001,12.9724 4.0001,24.0004 C4.0001,35.0274 12.9721,43.9994 24.0001,43.9994 C35.0281,43.9994 44.0001,35.0274 44.0001,24.0004 C44.0001,12.9724 35.0281,4.0004 24.0001,4.0004 M15.2984,24.6596 L22.0004,25.9996 L23.3404,32.7006 C23.5354,33.6756 24.8804,33.7996 25.2494,32.8756 L31.9984,15.9986 L15.1234,22.7506 C14.1994,23.1196 14.3224,24.4646 15.2984,24.6596",
  id: "Fill-3",
  fill: "#333333"
}))), 'GetDirection');

/*9fbef606107a605d69c0edbcd8029e5d*/
var MapCardTelephone = function MapCardTelephone(_ref) {
  var card = _ref.card,
      classes = _ref.classes,
      t = _ref.t,
      truncateTextHandler = _ref.truncateTextHandler,
      showHideContact = _ref.showHideContact,
      cardId = _ref.cardId,
      currentFacility = _ref.currentFacility,
      surfaceColor = _ref.surfaceColor,
      gaLabelFacility = _ref.gaLabelFacility,
      isLastCard = _ref.isLastCard;
  var telephone = get$1(card, 'telephone', '').split(',');
  var mobile = get$1(card, 'mobile', '').split(',');
  var fax = get$1(card, 'fax', '').split(',');

  if (!card || !card.telephone && !card.mobile && !card.fax) {
    return null;
  }

  var shiftLastCard = function shiftLastCard(cardID) {
    if (isLastCard === cardID) {
      setTimeout(function () {
        var mapCardElem = document.getElementById('mapCardsList');
        mapCardElem.scrollTop = mapCardElem.scrollHeight;
      }, 100);
    }
  };

  var generateContent = function generateContent() {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, telephone && telephone.map(function (item) {
      return (
        /* To avoid blank data rendering */
        item && /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
          key: "tel-".concat(item),
          className: clsx(classes.telephoneWrapper, classes.mapCardAddress, classes["svg-color-".concat(surfaceColor)]),
          "data-locator": MAPS_CARD_TELEPHONE_LINK,
          href: "tel:".concat(item),
          onClick: function onClick(e) {
            e.stopPropagation();
            PushEvent({
              event: gaLabelFacility || get$1(card, 'name', ''),
              buttonTitle: get$1(card, 'gaLabelName', '') || getGTMSharedKeyVal(undefined, MAPS_CARD_TELEPHONE_LINK),
              location_name: get$1(card, 'name', ''),
              contactMethod: 'call'
            });
          },
          type: "hyperlink",
          color: surfaceColor,
          variant: 'body2'
        }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
          component: 'p',
          variant: 'h10',
          color: surfaceColor,
          className: classes.flexWrapper
        }, /*#__PURE__*/React__default.createElement(Call, null), item))
      );
    }), mobile && mobile.map(function (item) {
      return item && /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
        key: "mob-".concat(item),
        "data-locator": MAPS_CARD_MOBILE_LINK,
        href: "tel:".concat(item),
        onClick: function onClick(e) {
          e.stopPropagation();
          PushEvent({
            event: gaLabelFacility || get$1(card, 'name', ''),
            location_name: get$1(card, 'name', ''),
            buttonTitle: get$1(card, 'gaLabelName', '') || getGTMSharedKeyVal(undefined, MAPS_CARD_MOBILE_LINK),
            contactMethod: 'mobile'
          });
        },
        className: clsx(classes.telephoneWrapper, classes.mapCardAddress, classes["svg-color-".concat(surfaceColor)]),
        color: surfaceColor,
        type: "hyperlink",
        variant: 'body2'
      }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        component: 'p',
        variant: 'h10',
        color: surfaceColor,
        className: classes.flexWrapper
      }, /*#__PURE__*/React__default.createElement(Mobile, null), item));
    }), fax && fax.map(function (item) {
      return item && /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
        key: "fax-".concat(item),
        className: clsx(classes.telephoneWrapper, classes.mapCardAddress, classes["svg-color-".concat(surfaceColor)]),
        "data-locator": MAPS_CARD_FAX_LINK,
        href: "fax:".concat(item),
        onClick: function onClick(e) {
          e.stopPropagation();
          PushEvent({
            event: gaLabelFacility || get$1(card, 'name', ''),
            buttonTitle: get$1(card, 'gaLabelName', '') || getGTMSharedKeyVal(undefined, MAPS_CARD_FAX_LINK),
            location_name: get$1(card, 'name', ''),
            contactMethod: 'fax'
          });
        },
        color: surfaceColor,
        type: "hyperlink",
        variant: 'body2'
      }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        component: 'p',
        variant: 'h10',
        color: surfaceColor,
        className: classes.flexWrapper
      }, /*#__PURE__*/React__default.createElement(Fax, null), item));
    }), /*#__PURE__*/React__default.createElement("div", {
      className: clsx(classes.mapCardAddress, classes.showHideWrapper, classes["showHideWrapper-".concat(surfaceColor)], classes.flexWrapper),
      onClick: function onClick(e) {
        e.stopPropagation();
        truncateTextHandler(false, card);
        PushEvent({
          event: 'mapSeeContact',
          buttonTitle: 'hideContact',
          location_name: get$1(card, 'name', ''),
          type: currentFacility
        });
        shiftLastCard(card.id);
      }
    }, /*#__PURE__*/React__default.createElement(ArrowForward, {
      className: classes.upArrow
    }), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      component: 'span',
      variant: 'h10',
      color: surfaceColor,
      type: 'label',
      "data-locator": MAPS_CARD_HIDE_CONTENT,
      className: 'seeContactBtn'
    }, t('hideContact'))));
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !(showHideContact && cardId === card.id) && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.showHideWrapper, classes["showHideWrapper-".concat(surfaceColor)], classes.mapCardAddress, classes.flexWrapper),
    onClick: function onClick(e) {
      e.stopPropagation();
      PushEvent({
        event: 'mapSeeContact',
        buttonTitle: 'seeContact',
        location_name: get$1(card, 'name', ''),
        type: currentFacility
      });
      truncateTextHandler(true, card);
      shiftLastCard(card.id);
    }
  }, /*#__PURE__*/React__default.createElement(ArrowForward, {
    className: classes.downArrow
  }), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    component: 'span',
    variant: 'h10',
    color: surfaceColor,
    type: 'label',
    "data-locator": MAPS_CARD_SHOW_CONTENT,
    className: 'seeContactBtn'
  }, t('seeContact'))), /*#__PURE__*/React__default.createElement(Collapse$1, {
    in: showHideContact && cardId === card.id,
    collapsedHeight: 0,
    className: showHideContact && cardId === card.id ? classes.easingInOut : classes.easingOut,
    timeout: {
      enter: 300,
      exit: 200
    }
  }, generateContent()));
};

var img$9 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 62 (91390) - https://sketch.com --%3e %3ctitle%3eic_location%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='Map-Listing-/-Locator' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Locator/Hospital%26amp%3bClinic-5-(D)' transform='translate(-1249.000000%2c -1064.000000)' fill='%23656565'%3e %3cg id='Group-3' transform='translate(71.000000%2c 609.000000)'%3e %3cg id='Group-5' transform='translate(392.000000%2c 1.000000)'%3e %3cg id='Group-2' transform='translate(779.000000%2c 447.000000)'%3e %3cg id='Location'%3e %3cg id='ic_location' transform='translate(7.000000%2c 7.000000)'%3e %3cg id='Group'%3e %3cpath d='M9%2c0 L9.00080686%2c2.08309386 C11.5129932%2c2.50491217 13.495669%2c4.48786487 13.9170737%2c7.00019152 L16%2c7 L16%2c9 L13.9169061%2c9.00080686 C13.4951437%2c11.5126605 11.5126605%2c13.4951437 9.00080686%2c13.9169061 L9%2c16 L7%2c16 L7.00019152%2c13.9170737 C4.48786487%2c13.495669 2.50491217%2c11.5129932 2.08309386%2c9.00080686 L0%2c9 L0%2c7 L2.08292631%2c7.00019152 C2.50438683%2c4.48753206 4.48753206%2c2.50438683 7.00019152%2c2.08292631 L7%2c0 L9%2c0 Z M8%2c3 C5.23857625%2c3 3%2c5.23857625 3%2c8 C3%2c10.7614237 5.23857625%2c13 8%2c13 C10.7614237%2c13 13%2c10.7614237 13%2c8 C13%2c5.23857625 10.7614237%2c3 8%2c3 Z M8%2c5 C9.65685425%2c5 11%2c6.34314575 11%2c8 C11%2c9.65685425 9.65685425%2c11 8%2c11 C6.34314575%2c11 5%2c9.65685425 5%2c8 C5%2c6.34314575 6.34314575%2c5 8%2c5 Z' id='Combined-Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$8 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='48px' height='48px' viewBox='0 0 63 64' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3eMisc/Map/*My Location%3c/title%3e %3cg id='Section' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Section---Locator' transform='translate(-464.000000%2c -8043.000000)'%3e %3cg id='Misc/Map/*My-Location' transform='translate(464.000000%2c 8043.000000)'%3e %3cellipse id='Oval' fill='%23E87722' opacity='0.2' cx='31.5' cy='32' rx='31.5' ry='32'%3e%3c/ellipse%3e %3cellipse id='Oval' fill='%23E87722' opacity='0.2' cx='31.5' cy='32' rx='19.6875' ry='20'%3e%3c/ellipse%3e %3cellipse id='Oval' fill='%23E87722' cx='31.5' cy='32' rx='12.796875' ry='13'%3e%3c/ellipse%3e %3cellipse id='Oval' fill='white' cx='31.5' cy='32' rx='7.875' ry='8'%3e%3c/ellipse%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$7 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='24px' height='24px' viewBox='0 0 33 42' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3eIcon/Location - Fill (Map)%3c/title%3e %3cg id='Section' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Section---Locator' transform='translate(-1095.000000%2c -7806.000000)'%3e %3cg id='Group-8' transform='translate(992.000000%2c 7719.000000)'%3e %3cg id='Icon/Location---Fill-(Map)' transform='translate(96.000000%2c 84.000000)'%3e %3ccircle id='Oval' fill='white' cx='23.5' cy='19.5833333' r='5.875'%3e%3c/circle%3e %3cpath d='M29.3745104%2c19.5828438 C29.3745104%2c22.8268229 26.7434896%2c25.4578438 23.5004896%2c25.4578438 C20.2555312%2c25.4578438 17.6254896%2c22.8268229 17.6254896%2c19.5828438 C17.6254896%2c16.3388646 20.2555312%2c13.7088229 23.5004896%2c13.7088229 C26.7434896%2c13.7088229 29.3745104%2c16.3388646 29.3745104%2c19.5828438 M7.83382292%2c19.5828438 C7.83382292%2c30.1539271 21.6390937%2c42.1066146 22.2256146%2c42.6108854 L23.5004896%2c43.7036354 L24.7753646%2c42.6108854 C25.3618854%2c42.1066146 39.1661771%2c30.1539271 39.1661771%2c19.5828438 C39.1661771%2c10.9446354 32.1386979%2c3.91617708 23.5004896%2c3.91617708 C14.8622812%2c3.91617708 7.83382292%2c10.9446354 7.83382292%2c19.5828438 Z' id='Location' stroke='white' stroke-width='1' fill='%23E87722'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$6 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='47px' height='47px' viewBox='0 0 33 42' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3eIcon/Location - Fill (Map)%3c/title%3e %3cg id='Section' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Section---Locator' transform='translate(-1095.000000%2c -7806.000000)'%3e %3cg id='Group-8' transform='translate(992.000000%2c 7719.000000)'%3e %3cg id='Icon/Location---Fill-(Map)' transform='translate(96.000000%2c 84.000000)'%3e %3ccircle id='Oval' fill='white' cx='23.5' cy='19.5833333' r='5.875'%3e%3c/circle%3e %3cpath d='M29.3745104%2c19.5828438 C29.3745104%2c22.8268229 26.7434896%2c25.4578438 23.5004896%2c25.4578438 C20.2555312%2c25.4578438 17.6254896%2c22.8268229 17.6254896%2c19.5828438 C17.6254896%2c16.3388646 20.2555312%2c13.7088229 23.5004896%2c13.7088229 C26.7434896%2c13.7088229 29.3745104%2c16.3388646 29.3745104%2c19.5828438 M7.83382292%2c19.5828438 C7.83382292%2c30.1539271 21.6390937%2c42.1066146 22.2256146%2c42.6108854 L23.5004896%2c43.7036354 L24.7753646%2c42.6108854 C25.3618854%2c42.1066146 39.1661771%2c30.1539271 39.1661771%2c19.5828438 C39.1661771%2c10.9446354 32.1386979%2c3.91617708 23.5004896%2c3.91617708 C14.8622812%2c3.91617708 7.83382292%2c10.9446354 7.83382292%2c19.5828438 Z' id='Location' stroke='white' stroke-width='1' fill='%23E87722'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='48px' height='48px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 62 (91390) - https://sketch.com --%3e %3ctitle%3eIcon/Tier-3/*Get Direction%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='Icon/Get-Direction' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3crect id='Box' x='0' y='0' width='48' height='48'%3e%3c/rect%3e %3cpath d='M24.0001%2c39.9994 C15.1781%2c39.9994 8.0001%2c32.8224 8.0001%2c24.0004 C8.0001%2c15.1784 15.1781%2c8.0004 24.0001%2c8.0004 C32.8221%2c8.0004 40.0001%2c15.1784 40.0001%2c24.0004 C40.0001%2c32.8224 32.8221%2c39.9994 24.0001%2c39.9994 M24.0001%2c4.0004 C12.9721%2c4.0004 4.0001%2c12.9724 4.0001%2c24.0004 C4.0001%2c35.0274 12.9721%2c43.9994 24.0001%2c43.9994 C35.0281%2c43.9994 44.0001%2c35.0274 44.0001%2c24.0004 C44.0001%2c12.9724 35.0281%2c4.0004 24.0001%2c4.0004 M15.2984%2c24.6596 L22.0004%2c25.9996 L23.3404%2c32.7006 C23.5354%2c33.6756 24.8804%2c33.7996 25.2494%2c32.8756 L31.9984%2c15.9986 L15.1234%2c22.7506 C14.1994%2c23.1196 14.3224%2c24.4646 15.2984%2c24.6596' id='Fill-3' fill='white'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$4 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAb1BMVEUAAACAgIBmZmZVVVVdXV1qampiYmJtbW1iYmJoaGhlZWVkZGRmZmZkZGRmZmZlZWVlZWVkZGRlZWVkZGRlZWVlZWVlZWVkZGRlZWVlZWVlZWVlZWVlZWVlZWVkZGRlZWVlZWVlZWVkZGRlZWX////AbMxzAAAAI3RSTlMABAUGCwwNDhobP0BBQmdod3p8h4iJsLKztL/AxMXG5OXm50p1NZsAAAABYktHRCS0BvmZAAAAgklEQVQYGQXBCWKCQAAEsKyIUg/QuvUAUXT+/8cmAAkAIAGAMkzJ1BeAn9d1t17vb3MHrF4n4DwXMFw1f5+lNu49mHZqklSHEUlanyT52iSRpLUkyds2Cca9miQXxxEMN01dltp49KDMZ+D3WYBuvh/a9vh4dgBlmJKxLwCQAAASwD/bGwsH82rxAQAAAABJRU5ErkJggg==";

var img$3 = "data:image/png;base64,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";

var img$2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAABaFBMVEUAAAD/////////////////////////////////////////+PL/////+fL/8+3/+vX/////9vH77ub/9/P/+/f78OT78OX87d787eH/8OX/8eX66t/66t/97N366tz67OP67eP86dr86dr66Nn65tn75dT75NP75tX75tX63sr64s/74s/65NP649L64tL649L64s/649D538r64Mz528X30rf407f528X3zrD3z7H41bn2y6r2y6r2y6v1x6b2x6T0v5f1xaL53MX0vJL407b428T538v538z0vJH1v5j86Nr86dv86t387OD0u5L0vZXyt4rzt4n87+XztYfztonzuIvzuY7zuo7ztonxrnvxrnzwqXLxqHHxqnbwqXTsjkfsj0fsj0jsikLtlVPtlVTrij/ri0D//v7odyLoeCPoeCToeSXpeyjpeynpfCrpfCvpfSzpfi7pfy/pgDDqgDHqgTLriT/////CqYWhAAAAaHRSTlMAAwcICQ8UGSMkJicnKCo0Nzg9Pj9DRFVWV1hfYGpsbm+foKOms7W1tr/BwcbHysvQ0NXV2tvb297e3+Dh4+Xl5ubm5+fn5+fo6Ojo6Ojp6erq6uvr7e3t7u/w8vLz9Pz8/P39/f7+/o7++igAAAABYktHRHdGZPnXAAABA0lEQVQYGW3BhULCYBQG0IsIqKhgYSu22B0YGNhgYLdYfEwHBnOv793PNoZyDhmc/v5AoK/dSfkcHQtPEiA9L3Y6yMI98QPdy6SbTK6pFEypWRcZhjOwUIZI13QDIfMN4bqRsgaTYPGtWGzzHiw5QIJ9DkyJqCyigM0Xkab0COxcFc7ADktI470DC6tCGOzWS5ryY7DThMoSF2AnZaSxzYB97als9xNs2kZCbxrscS0a3XgF++ihrNpLCLIM4aqGdKPvsJBHyOBZh8VBFZm6H2CKd1GOfSwNnTxeTBaVQQnCW7CC8lQvQViuoz8aVsB26umftn1gu5UKaAmtNlNBPh/l/AL4kHNuB/zkaQAAAABJRU5ErkJggg==";

var img$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAvCAYAAABzJ5OsAAAABmJLR0QA/wD/AP+gvaeTAAAFRUlEQVRo3tVZWWyVRRSuUeODMcYHtxjcECXgFgXRGBUTK2pc4qNRXzRGIhg1KK0UKi0tlgbLEokBHiTdsKUFW7HWYrRNTC/0ahrQ2qqplkXau3S5yz/LP//MeE6l2pC0nbn3v7d1ksnkX+acb86cc+acMzk5Pjat9VXQc6Gvhl4AvezcuOrc+ytz5lIDQDdpKYsUS/6hlVLe2KDDf+9M0u4mTrrqBI74LGNDSaWkUizRD/9vxHmzCfo2xclBJYXH+trpWM2bOlx8rx7Ku3nKjt/xP/5rB8F5ML8B6CzIJuiLpOClyhMuOfaZiJQ9PC3gqXpkyyOaButdpKMFL0a6mQZ+tXJpUEQGyPDOZ1ICfX4f3vms9iIDVHGnC20mY7qtBD3DTnzJQusX+QJ8oofWL9bsRAsHNToNfG70G/g1APwvEqgRQ/nzfQX+b8+/RZNArQA+p33bASB0sXZJNz3+Bc8Y8EkLwB0AfkFfbACMqUyE+qnfqjKdCnnRAQJOoSRdqS/S0nOj25/KCvCJHt3xtB73QlovTBm8Yk4L6awS2QQ+0cnR/UJz0pyq1BeC1EW49AE7xu8v0CN7X9KJ1q3a6dgzPo7seXH8vdU5sPlBjfwBx6324KUoZz+1MhuGo1VvaBkPcTgLXCUYA8ZauYzhM7xno5UrrRbAetoo4CizVxnuDI7ue82YUfLIdqE9FyU1dYPvybYKYzUcrXxdA44ztipzg5KeDBXeYcQE4xUl+PTAJy1grHqVmecpvBO2TkqYNc8G/PPgrhJGDArANJwRri2aTEQ5zjOh7w2fTMCU52zA59Gfv6ZGWwuqBTrNbMDj/6Ofvmqm9798Q2DKezbgy51AlTTS9e8+mfAKFqIXIvntLiPwTqAa1WaLhafxdiXBzZkQpz8ccHUKjQQPGBkuulvEYyP5UsyCjCSPxMG67SQvvWT7brPDqqsed7XEBvw7vLfdMfI01avBnRFqp/OE4plgQp/3dTgw5W0b8CtkLGQEPrThdg35q5XOQx7r4jwT+jIRQfC5NuCvwGQ6vGmpEYPYoQ1KC2bkLuHkdeMH1ykTuuGSZRpxwLTLLYOyRG/swFrzQCpYx2dcgODcOVrrmtKMNeTjLvWkENvIPLc/4NjEIvHmIgU+XIBOEz0uMBS1wiMeclQiYp8XKht67p9BVJk1qUSV12N5IlL2kF0ysfFuHat/F1K6Go/1HKE4jtWt0aEP7rKuLmBQDziuSy0s5qTJ+X7f7MTznZUCdqsxnUxqGRpYuHhJVoGHN92HgR4efkvTSgWV67SRQJWbVakfq3XBTlr8qB4sBtUT0a252clfK1ZgOJBe/jq5SY99LE51k8yXPuZr99RxKgXb5mfR6TIoBoXjhwpUJsHHmwrhsKODwO9Sv6tmj6ERRSueyIy6bHsSPKOL6vJoZuqVUnzoRU8SLAz5WmiCOAcypvQLTTOVt7EUB7G4r96H/tiI3iWYjTL3PEiiE7GGtb7of6whTwG9uFWSneYClqN+jux9OS3gI7tfwJSQW4W8vizA817RLuVoaCkZ6EePY8DGIQBcOTv3UlJshkoYwbjb6vgvuR8raxRC5NLZvFS7AKS/H69lZrpM++9SbQmWsKl0aQ3On+2rzAsVZ40i3E/CRffMGC6Lod8IJC3NGfcsNrcnitNWcbaXTrUAfC/O9kFSQr/C/+faZfIlED4fxkPs/LI4PqOqAPDD+F/OXGyoQtLl1WjEkfLl/2REMMr4EOp4NX7Pmctt3IgF26FonMUa12kc8XnWjdNuEfItqKQJHHP+jw2kfW0m6f8Nh23vKCEeSXcAAAAASUVORK5CYII=";

var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAD2UlEQVRoge2ZT29VRRjGn6G3JeVPIsU2odUu3Lh00VIU3IBrN4YQPgBcm/gBiCbs+LOVADH1A9io0RA1suMLSDfCQiWQ8MdyK2VD0V43/lzMaTi8Z+bemXNPIdE+yVmcc+Z93uedM+/MO3OkLWzh/w3XBAmwTdKcpCOSZiS9KWlS0q6iyVNJy5J+kbQk6Zqkn5xz/zThvzaA14DzwAPycR84B0y9DOF7gc+Av2sIt+gCl4GxFyX+OLDagHCLR8CxzRTewvd6DE+AL4CTwH5gHBgurnFgrni3WLSN4RLQalr8KPB9xOEyMA/syODbAZwAbkU4vwNGmxLfiojvAqeBnQNwDwOnCq5QEIN/CcLD5iHwzsDkz3wcBDoBPxcHJT4eIL0BvN6Q9rKv6YLb4mhdwjH8zFBGZzPEl3xOB77EKrC3DpkdOutNDpsefg9RzYm8oYRfYe0idXqTNIf8f2x8d4HJHILzhmCZAWabAP9uoA0sRN6PALeNhrOp5ENUa5v5hoTPAAs8W8jaPdq2jYa7+KKxr5O3jeETMhapAN9Gb18P8O7uYbcTWDM2c7ZdKKIj5v4H59xfNYTPFEPkd0kL8mV2GYvOubWYvXPuT0k/mseHUxx/Y6I+mSE61tsh2IBCfB8am69TRNw0RvsTbOzY7ofriR1ywNj9nGL02Bi9Gmk3hK8uU3rbIpq8xseEsXuUYmTn/5FIu49qCIc+yWt8bDe2Xdum/7QUx1VJVyQ9zLTrmby5qGzqgceSytu7cefcai8S/Co5Y659keazzrmlFHHAhKSV0qNV59x4PyObxJW5N9H5cmD4JCVvicOuSZUkDg2hX839WzlOSwj18ueZHNa31RYMwPaSXdhSYQNYk7SYyfGeue//BanOvbVKCeB9wxMs3HrY7wKeGo7ZFMNt+EOnMk7UCGDScPRdeY19vWKuMD5njG8BwzWC2Ejk3OTdDtwxGs7kEExR3RWdqhHAt4Vtcj1V2H1ifK+Ts6EpSC4bki5wMJPjDXxBNpRh8y7VauBClviCaAz4wxB1gOlssnSfoU39CrCnLuExqrixGUEU4u0iCvDBoMSXAqQd4FBD2jeGzUrAz6dNkLfwx3wWXfzpQbBaTeQewSds6Jj+Chm508/RaCQI8KcHbTJOLfCLVJvqVFkW38zhbslpC7gYcQh+A/4lftY5gN+MjBTXRPFsHviK6gpbxoXGej4SyFHC43VQdBg0YTOC2IP/GqFj8Vys43v9lRci3gQyCZwF7tUQfhc4A8Q2Pklo8jfrrJ7/zTql53+zPpD0m3xJfE3S0kv/zbqFLfwH8C/LvTjFkw/d3gAAAABJRU5ErkJggg==";

/*9fbef606107a605d69c0edbcd8029e5d*/
var mapStyle = [{
  featureType: 'administrative',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#183028'
  }]
}, {
  featureType: 'landscape',
  elementType: 'all',
  stylers: [{
    color: '#edeff0'
  }, {
    visibility: 'simplified'
  }]
}, {
  featureType: 'landscape',
  elementType: 'labels.text',
  stylers: [{
    color: '#183028'
  }, {
    visibility: 'simplified'
  }]
}, {
  featureType: 'poi',
  elementType: 'all',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'road',
  elementType: 'all',
  stylers: [{
    saturation: -100
  }, {
    lightness: 45
  }, {
    visibility: 'simplified'
  }]
}, {
  featureType: 'road',
  elementType: 'labels',
  stylers: [{
    visibility: 'simplified'
  }]
}, {
  featureType: 'road',
  elementType: 'labels.text',
  stylers: [{
    weight: '1.00'
  }, {
    color: '#183028'
  }, {
    visibility: 'simplified'
  }]
}, {
  featureType: 'road',
  elementType: 'labels.text.fill',
  stylers: [{
    hue: '#ff0000'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'all',
  stylers: [{
    visibility: 'simplified'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'geometry',
  stylers: [{
    visibility: 'simplified'
  }, {
    color: '#ffffff'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'labels',
  stylers: [{
    visibility: 'simplified'
  }]
}, {
  featureType: 'road.arterial',
  elementType: 'labels.icon',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'transit',
  elementType: 'all',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'water',
  elementType: 'all',
  stylers: [{
    color: '#7fcbd4'
  }, {
    visibility: 'on'
  }]
}];

/*9fbef606107a605d69c0edbcd8029e5d*/
var getBrowserIcon = function getBrowserIcon(iconKey) {
  if (typeof window !== 'undefined' && window.navigator) {
    //ieFlag will be true for IE browser
    var ieFlag = window.navigator.userAgent.indexOf('Trident') !== -1;
    var iconKeys = {
      getDirection: {
        true: img,
        // For IE icon
        false: img$5
      },
      marker_hover: {
        true: img$1,
        // For IE icon
        false: img$6
      },
      gmLocation: {
        true: img$4,
        // For IE icon
        false: img$9
      },
      myLocation: {
        true: img$3,
        // For IE icon
        false: img$8
      },
      marker: {
        true: img$2,
        // For IE icon
        false: img$7
      }
    };
    return iconKeys[iconKey][ieFlag];
  }
};
var currGeoLocation = {
  lat: '',
  lon: ''
};
var bounds;

var mapUri = function mapUri(lat, lon) {
  return encodeURI(generateGoogleMapUrl(currGeoLocation.lat, currGeoLocation.lon, lat, lon));
};

var setCurrGeoLocation = function setCurrGeoLocation() {
  if (typeof window !== 'undefined' && window.navigator && window.navigator.geolocation) {
    window.navigator.geolocation.getCurrentPosition(function (position) {
      currGeoLocation.lat = position.coords.latitude;
      currGeoLocation.lon = position.coords.longitude;
    });
  }
};
var launchDirectionOnMap = function launchDirectionOnMap(lat, lon) {
  if (typeof window !== 'undefined') {
    window.open(mapUri(lat, lon), '_blank');
  }
};
var mapDistance = function mapDistance(lat2, lon2, t) {
  if (!currGeoLocation.lat || !currGeoLocation.lon) {
    return '';
  }

  var R = 6371; // km (change this constant to get miles)

  var dLat = (lat2 - currGeoLocation.lat) * Math.PI / 180;
  var dLon = (lon2 - currGeoLocation.lon) * Math.PI / 180;
  var a = Math.abs(Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(currGeoLocation.lat * Math.PI / 180) * Math.cos(currGeoLocation.lon * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2));
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  if (d > 1) return Math.round(d) + t('km');else return Math.round(d * 1000) + t('meter');
};
var makeMapLocationCenter = function makeMapLocationCenter(map, alignCenter, marker, mapCardList) {
  if (typeof window !== 'undefined' && window.navigator && window.navigator.geolocation) {
    window.navigator.geolocation.getCurrentPosition(function () {
      if (typeof window !== 'undefined' && window.google && window.google.maps) {
        marker && marker.setMap(map);
        var pulseDivPresent = document.getElementsByClassName('pulseDiv');
        var pulseDivLength = 0;

        if (pulseDivPresent) {
          pulseDivLength = marker ? pulseDivPresent.length : pulseDivPresent.length - 1;
        }

        for (var j = 0; j < pulseDivLength; j++) {
          pulseDivPresent[j] && pulseDivPresent[j].remove();
        }

        marker && setTimeout(function () {
          var animatedMarker = [];
          var mapDiv = document.getElementById('googleMap');
          var myLocationTags = mapDiv && mapDiv.getElementsByTagName('img');

          if (myLocationTags) {
            for (var i = 0; i < myLocationTags.length; i++) {
              myLocationTags[i].src.includes('myLocation') && animatedMarker.push(myLocationTags[i]);
            }
          }

          var innerBG = document.createElement('div');
          var pulseSpan = document.createElement('span');
          innerBG.className = 'pulseDiv';
          innerBG.appendChild(pulseSpan);
          pulseSpan.className = 'pulseSpan';

          if (animatedMarker.length) {
            animatedMarker[0].parentElement.appendChild(innerBG);
            animatedMarker[0].parentElement.style.overflow = 'visible';
            animatedMarker[0].style.position = 'absolute';
            animatedMarker[0].style.borderRadius = '50%';
          }
        }, 500);
      }
    });

    if (alignCenter) {
      mapCardList.forEach(function (item) {
        var latLng = new window.google.maps.LatLng(parseFloat(item.latitude), parseFloat(item.longitude));

        if (currGeoLocation.lat && currGeoLocation.lon) {
          var currLatLng = new window.google.maps.LatLng(parseFloat(currGeoLocation.lat), parseFloat(currGeoLocation.lon));
          bounds.extend(currLatLng);
        }

        bounds.extend(latLng);
      });

      if (mapCardList.length === 1 && !currGeoLocation.lat && !currGeoLocation.lon) {
        map.setZoom(14);
      } else map.fitBounds(bounds);
    }
  }
};
var addCenterControl = function addCenterControl(controlDiv, map, mapCardList) {
  // Set CSS for the control border.
  var controlUI = document.createElement('div');
  controlUI.style.backgroundColor = '#fff';
  controlUI.style.border = '2px solid #fff';
  controlUI.style.borderRadius = '3px';
  controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
  controlUI.style.cursor = 'pointer';
  controlUI.style.marginRight = '10px';
  controlUI.style.textAlign = 'center';
  controlUI.title = 'Click to recenter the map';
  var controlText = document.createElement('div');
  controlText.style.color = 'rgb(25,25,25)';
  controlText.style.padding = '10px';
  controlText.innerHTML = "<img src= ".concat(getBrowserIcon('gmLocation'), "></img >");
  controlUI.appendChild(controlText);
  controlDiv.appendChild(controlUI); // Set CSS for the control interior.

  controlUI.addEventListener('click', function () {
    return makeMapLocationCenter(map, true, false, mapCardList);
  });
  return controlUI;
};
var googleMapInstance = null;
var getMapInstance = function getMapInstance(defaultProvince, showCurrLocation, t, mapCardList) {
  if (typeof window !== 'undefined' && document.getElementById('googleMap') && window.google && window.google.maps) {
    // TODO we should refer to only one instance of the map, but some how this is not working if only
    // one instance is being passed
    // if(googleMapInstance == null ){
    googleMapInstance = new window.google.maps.Map(document.getElementById('googleMap'), {
      center: {
        lat: parseFloat(get$1(defaultProvince, 'fields.latitude.value', '13.7563')),
        lng: parseFloat(get$1(defaultProvince, 'fields.longitude.value', '100.5018'))
      },
      zoom: 12,
      styles: mapStyle,
      disableDefaultUI: true,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      clickableIcons: false
    });
    var centerControlDiv = document.createElement('div');
    centerControlDiv.index = 1;
    addCenterControl(centerControlDiv, googleMapInstance, mapCardList);
    googleMapInstance.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(centerControlDiv); //}

    var image = {
      url: getBrowserIcon('myLocation')
    };
    var marker = new window.google.maps.Marker({
      position: new window.google.maps.LatLng(parseFloat(currGeoLocation.lat), parseFloat(currGeoLocation.lon)),
      icon: image
    });

    if (currGeoLocation.lat && currGeoLocation.lon && showCurrLocation) {
      makeMapLocationCenter(googleMapInstance, false, marker, mapCardList);
    }

    window.google.maps.event.addListener(googleMapInstance, 'tilesloaded', function () {
      setTimeout(function () {
        var images = document.querySelectorAll('#googleMap img');
        t && images.forEach(function (img) {
          img.alt = t('googleMapsAltImage');
        });

        if (currGeoLocation.lat && currGeoLocation.lon && showCurrLocation) {
          makeMapLocationCenter(googleMapInstance, false, marker, mapCardList);
        }
      }, 10);
    });
    return googleMapInstance;
  } else return null;
};
var createMarkers = function createMarkers(mapCardList, currMap, callback) {
  var infoMap = {};
  bounds = new window.google.maps.LatLngBounds();
  var markers = mapCardList.map(function (item) {
    var latLng = new window.google.maps.LatLng(parseFloat(item.latitude), parseFloat(item.longitude));
    var marker = new window.google.maps.Marker({
      position: latLng,
      title: item.name
    });
    marker.setIcon(getBrowserIcon('marker'));
    marker.setMap(currMap);

    if (currGeoLocation.lat && currGeoLocation.lon) {
      var currLatLng = new window.google.maps.LatLng(parseFloat(currGeoLocation.lat), parseFloat(currGeoLocation.lon));
      bounds.extend(currLatLng);
    }

    bounds.extend(latLng);
    var contentString = "\n    <div style=\"display: flex;align-items: center;justify-content: space-between; min-width: fit-content;\">\n    <div class=\"markerContent\" style=\"display:inline-block; border-right:1px solid rgba(255, 255, 255, 0.2);\">".concat(item.name, "</div>\n        <div style=\"padding-left:8px;\">\n          <a href=\"").concat(mapUri(item.latitude, item.longitude), "\" target=\"_blank\" style=\"display: flex;align-items: center;\"}>\n           <img src=\"").concat(getBrowserIcon('getDirection'), "\" style=\"width:32px\" />\n          </a>\n        </div>\n      </div>\n    ");
    var infowindow = new window.google.maps.InfoWindow({
      content: contentString
    });
    infoMap[item.id] = {
      infowindow: infowindow,
      marker: marker
    };
    marker.addListener('click', function () {
      if (callback) {
        callback(item, true);
      }

      for (var key in infoMap) {
        if (infoMap.hasOwnProperty(key)) {
          var el = infoMap[key];
          el.infowindow.close();
          marker.open = false;
          el.marker.setIcon(getBrowserIcon('marker'));
        }
      }

      if (!marker.open) {
        currMap.setCenter(new window.google.maps.LatLng(parseFloat(item.latitude), parseFloat(item.longitude)));
        currMap.setZoom(14);
        infowindow.open(currMap, marker);
        marker.open = true;
        marker.setIcon(getBrowserIcon('marker_hover'));
      }

      typeof window !== 'undefined' && window.google.maps.event.addListener(currMap, 'click', function () {
        infowindow.close();
        marker.open = false;
        marker.setIcon(getBrowserIcon('marker'));
      });
    });
    marker.addListener('mouseover', function () {
      marker.setIcon(getBrowserIcon('marker_hover'));
    });
    marker.addListener('mouseout', function () {
      if (!infowindow.anchor) {
        marker.setIcon(getBrowserIcon('marker'));
      }
    });
    return marker;
  });

  if (mapCardList.length === 1 && !currGeoLocation.lat && !currGeoLocation.lon) {
    currMap.setZoom(14);
  } else currMap.fitBounds(bounds);

  return {
    infoMap: infoMap,
    markers: markers
  };
};
var googleScript = null;
var isGoogleMapLoaded = false;
var loadMapScripts = function loadMapScripts(callback, defaultProvince, key, showCurrLocation, t, mapCardList, pageLanguage) {
  if (typeof window !== 'undefined') {
    if (googleScript === null) {
      googleScript = document.createElement('script');
      googleScript.src = generateGoogleMapScript(key, pageLanguage);
      window.document.body.appendChild(googleScript);
    }

    if (isGoogleMapLoaded) {
      callback(getMapInstance(defaultProvince, showCurrLocation, t, mapCardList));
    }

    if (googleScript.readyState) {
      googleScript.onreadystatechange = function () {
        if (googleScript.readyState === 'loaded' || googleScript.readyState === 'complete') {
          isGoogleMapLoaded = true;
          googleScript.onreadystatechange = null;
          callback(getMapInstance(defaultProvince, showCurrLocation, t, mapCardList));
        }
      };
    } else {
      googleScript.onload = function () {
        isGoogleMapLoaded = true;
        callback(getMapInstance(defaultProvince, showCurrLocation, t, mapCardList));
      };
    }

    return googleScript;
  }
};

var styles$i = function styles(theme) {
  var colors = theme.palette.colors || {};
  var bgColors = {};
  Object.keys(colors).forEach(function (color) {
    /** For Default */
    bgColors["icon-".concat(color)] = {
      color: colors[color].contrastTextAction
    };
  });
  return _objectSpread2(_objectSpread2({}, bgColors), {}, {
    noResult: _defineProperty({
      textAlign: 'center',
      marginLeft: '16px',
      marginRight: '16px',
      marginTop: '64px',
      maxWidth: '600px'
    }, theme.breakpoints.down('md'), {
      marginTop: '48px'
    }),
    noResultIcon: {
      width: '64px',
      height: '64px',
      marginBottom: '4px'
    },
    noResultTitle: {
      marginBottom: '8px'
    },
    noResultDescription: _defineProperty({
      padding: '0 70px'
    }, theme.breakpoints.down('sm'), {
      padding: '0'
    }),
    fallbackPic: {
      objectFit: 'scale-down',
      backgroundColor: '#F2F2F2',
      backgroundImage: FWD_LOGO_FALLBACK,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      height: '48px',
      backgroundSize: '100%',
      width: theme.spacing(6),
      margin: '0 auto',
      '& img': {
        visibility: 'hidden'
      }
    },
    resetLink: {
      textDecoration: 'underline',
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  });
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var COMPONENT_NO_RESULT_ICON = 'No-Search-Results-Search-Icon';
var COMPONENT_NO_RESULT_TEXT = 'No-Search-Results-Text';
var COMPONENT_NO_RESULT_DESCRIPTION = 'No-Search-Results-Description';
var COMPONENT_NO_RESULT_WRAPPER = 'No-Search-Results-Wrapper';

var useStyles$j = makeStyles(function (theme) {
  return styles$i(theme);
});

var Description = function Description(props) {
  var description = props.description,
      dataLocator = props.dataLocator,
      replaceToken = props.replaceToken,
      clickHandler = props.clickHandler,
      className = props.className,
      _props$resetFilterLab = props.resetFilterLabel,
      resetFilterLabel = _props$resetFilterLab === void 0 ? "" : _props$resetFilterLab;

  if (clickHandler && description.indexOf(replaceToken) !== -1) {
    return /*#__PURE__*/React__default.createElement("span", null, description.split(replaceToken).reduce(function (prev, current, i) {
      if (!i) {
        return [current];
      }

      return prev.concat( /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
        key: replaceToken + i,
        component: "div",
        linkMode: "Secondary",
        type: "hyperlink",
        color: props.color,
        className: className,
        "data-locator": dataLocator,
        onClick: function onClick(e) {
          e.preventDefault();
          clickHandler();
        }
      }, resetFilterLabel.toLowerCase()), current);
    }, []));
  } else {
    return description;
  }
};

var NoResult = function NoResult(props) {
  var classes = useStyles$j();
  var titleText = get$1(props, "title", "No result");
  var descText = get$1(props, "desc", "");
  var suggestionText = get$1(props, "suggestion", "");
  var noDataIcon = get$1(props, "icon");
  var color = get$1(props, "color", "grey");
  var clickHandler = get$1(props, "resetHandler", null);
  var replaceToken = get$1(props, "replaceToken", "{resetFilters}");
  var dataLocator = get$1(props, "dataLocator", "");

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.noResult, props.className),
    "data-locator": COMPONENT_NO_RESULT_WRAPPER
  }, noDataIcon && Object.keys(noDataIcon).length > 0 ? /*#__PURE__*/React__default.createElement("div", {
    className: error && classes.fallbackPic
  }, /*#__PURE__*/React__default.createElement("img", {
    src: noDataIcon,
    className: classes.noResultIcon,
    "data-locator": COMPONENT_NO_RESULT_ICON,
    alt: titleText,
    onError: function onError() {
      setError(true);
    }
  })) : /*#__PURE__*/React__default.createElement(NoResultIcon, {
    "data-locator": COMPONENT_NO_RESULT_ICON,
    className: clsx(classes.noResultIcon, _defineProperty({}, classes["icon-".concat(color)], color !== "initial"))
  }), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h3A",
    component: "div",
    className: classes.noResultTitle,
    "data-locator": COMPONENT_NO_RESULT_TEXT,
    color: color
  }, titleText), descText && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    className: classes.noResultDescription,
    "data-locator": COMPONENT_NO_RESULT_DESCRIPTION,
    color: color
  }, /*#__PURE__*/React__default.createElement(Description, {
    color: color,
    className: classes.resetLink,
    description: descText,
    resetFilterLabel: props.resetFilterLabel,
    replaceToken: replaceToken,
    dataLocator: dataLocator,
    clickHandler: clickHandler
  })), props.suggestion && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "div",
    className: classes.noResultDescription,
    color: color
  }, suggestionText));
};

var MapCardsList = function MapCardsList(props) {
  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      activeCard = _useState2[0],
      setActiveCard = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showHideContact = _useState4[0],
      setShowHideContact = _useState4[1]; // Assuming the Card full address will not go beyond 20 lines


  var showFullAddressLines = 20;

  var truncateTextHandler = function truncateTextHandler(showHideContactTruncateText, card) {
    setActiveCard(card.id);
    setShowHideContact(showHideContactTruncateText);

    if (props.fromMap && props.selected === card.id) {
      props.onMapCardClick(card, true);
    } else {
      props.onMapCardClick(card, false);
      showHideContactTruncateText && setShowHideContact(true);
    }
  };

  if (!props.mapData || !props.mapData.mapCardList) {
    return null;
  }

  var _props$mapData = props.mapData,
      mapCardList = _props$mapData.mapCardList,
      totalCount = _props$mapData.totalCount;

  if (props.fromMap && props.selected !== activeCard) {
    setActiveCard(props.selected);
    setShowHideContact(false);
  }

  var getAddress = function getAddress(card) {
    var _card$streetNumber, _card$road, _card$county, _card$district, _card$province, _card$postalCode;

    var fields = [(_card$streetNumber = card.streetNumber) === null || _card$streetNumber === void 0 ? void 0 : _card$streetNumber.trim(), (_card$road = card.road) === null || _card$road === void 0 ? void 0 : _card$road.trim(), (_card$county = card.county) === null || _card$county === void 0 ? void 0 : _card$county.trim(), (_card$district = card.district) === null || _card$district === void 0 ? void 0 : _card$district.trim(), (_card$province = card.province) === null || _card$province === void 0 ? void 0 : _card$province.trim(), (_card$postalCode = card.postalCode) === null || _card$postalCode === void 0 ? void 0 : _card$postalCode.trim()];
    return fields.filter(Boolean).join(", ");
  };

  var mapCard = function mapCard(card, isSelected, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      id: card.id,
      key: card.id,
      className: clsx(props.classes["mapCardElem-".concat(props.surfaceColor)], "motionColorTransition", props.selected === card.id ? "selected" : "", index === mapCardList.length - 1 && !props.isMobile && totalCount === mapCardList.length ? "lastCardMarginBotton" : ""),
      "data-locator": MAPS_ITEM_CARD,
      onClick: function onClick(e) {
        e.stopPropagation();
        props.onMapCardClick(card, false);
        PushEvent({
          event: "mapLocate",
          buttonTitle: get$1(card, "gaLabelName", "") || getGTMSharedKeyVal(undefined, MAPS_ITEM_CARD),
          location_name: get$1(card, "name", ""),
          type: props.currentFacility
        });
        setActiveCard(card.id);
        props.selected !== card.id && setShowHideContact(false);
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: clsx(props.classes.mapCard, "mapCardInnerContainer", "motionColorTransition", props.filterHidden && index === 0 && "mapCardBorder")
    }, /*#__PURE__*/React__default.createElement("div", {
      className: clsx(props.classes.flexWrapper, props.classes.justifyContent)
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      component: "h3",
      variant: "h5",
      className: props.classes.mapCardTitle,
      color: props.surfaceColor,
      "data-locator": MAPS_CARD_HEADING
    }, card.name), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, card.facilities.length ? /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "h10",
      component: "span",
      className: props.classes.mapCardInfo,
      "data-locator": MAPS_CARD_SEARCH_KEYS,
      color: props.surfaceColor,
      type: "caption"
    }, card.facilities.join(", ")) : null, mapDistance(card.latitude, card.longitude, props.t) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "h10",
      component: "span",
      className: clsx(props.classes.mapCardInfo, props.classes.bullet, props.classes["bullet-".concat(props.surfaceColor)]),
      "data-locator": MAPS_CARD_SEARCH_KEYS,
      color: props.surfaceColor,
      type: "caption"
    }, " " + mapDistance(card.latitude, card.longitude, props.t)))), /*#__PURE__*/React__default.createElement(GetDirection, {
      className: clsx(props.classes.mapCardLocationIcon, props.classes["getLocation-".concat(props.surfaceColor)]),
      "data-locator": MAPS_CARD_LOCATION,
      onClick: function onClick(e) {
        e.stopPropagation();
        PushEvent({
          event: "mapLocate",
          buttonTitle: get$1(card, "gaLabelName", "") || getGTMSharedKeyVal(undefined, MAPS_CARD_LOCATION),
          location_name: get$1(card, "name", ""),
          type: props.currentFacility
        });
        launchDirectionOnMap(card.latitude, card.longitude);
      }
    })), (card.streetNumber || card.province || card.district || card.postalCode || card.county) && /*#__PURE__*/React__default.createElement("div", {
      className: props.classes.mapCardAddress
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      component: "p",
      variant: "h10",
      className: props.classes.flexWrapper,
      color: props.surfaceColor,
      "data-locator": MAPS_CARD_ADDRESS
    }, /*#__PURE__*/React__default.createElement(Location, null), /*#__PURE__*/React__default.createElement(TruncateText, {
      className: props.classes.truncateTextAlignment,
      lines: activeCard === true ? 1 : activeCard === card.id && showHideContact || card.telephone === "" && card.fax === "" && card.mobile === "" ? showFullAddressLines : 1,
      content: getAddress(card)
    }))), get$1(card, "openingHours") && card.openingHours.trim() ? /*#__PURE__*/React__default.createElement("div", {
      className: clsx(props.classes.mapCardAddress, props.classes["svg-color-".concat(props.surfaceColor)], props.classes.flexWrapper),
      "data-locator": MAPS_CARD_OPERATING_HOURS
    }, /*#__PURE__*/React__default.createElement(Time, null), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      component: "p",
      variant: "h10",
      className: props.classes.normalFontWeight,
      color: props.surfaceColor
    }, card.openingHours)) : null, /*#__PURE__*/React__default.createElement(MapCardTelephone, {
      card: card,
      classes: props.classes,
      t: props.t,
      truncateTextHandler: truncateTextHandler,
      cardId: props.selected,
      showHideContact: isSelected && showHideContact,
      surfaceColor: props.surfaceColor,
      currentFacility: props.currentFacility,
      gaLabelFacility: props.gaLabelFacility,
      isLastCard: index === mapCardList.length - 1 ? card.id : ""
    })));
  };

  var firstCard = null;

  if (props.firstCard && props.selected) {
    var card = mapCardList.find(function (el) {
      return props.selected === el.id;
    });

    if (card) {
      firstCard = mapCard(card, true);
    }
  }

  return /*#__PURE__*/React__default.createElement(StyledGrid, {
    md: 4,
    xs: 12,
    className: clsx(props.classes.motionFade, !props.isMobile && (props.filterHidden ? getBorderRadius("large", 0, 0, "large") : getBorderRadius(0, 0, 0, "large")), mapCardList.length === 0 ? props.classes.noResultWrapper : props.classes.itemListsWrap, props.classes.cardListWrapper, {
      customScrollbarDesign: customScrollbarDesign
    }),
    id: "mapCardsList",
    "data-locator": MAPS_ITEM_CARD_WRAPPER
  }, mapCardList.length === 0 && !props.loading ? get$1(props.noResultFoundData, "fields.title", "") && /*#__PURE__*/React__default.createElement(NoResult, {
    title: props.noResultFoundData.fields.title.value,
    desc: get$1(props.noResultFoundData, "fields.subTitle.value", ""),
    icon: get$1(props.noResultFoundData, "fields.icon.value", ""),
    "data-locator": MAPS_NO_DATA_WRAPPER,
    color: props.surfaceColor
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, firstCard, mapCardList.map(function (card, i) {
    return card.id === props.selected && props.firstCard ? null : mapCard(card, true, i);
  }), totalCount > mapCardList.length && !props.loading && /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    component: "span",
    variant: "h6",
    underline: "none",
    className: props.classes.showMoreButton,
    "data-locator": MAPS_SHOWMORE_BUTTON,
    onClick: props.seeMoreClickHandler
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    className: props.classes.showMoreIcon,
    color: props.surfaceColor,
    type: "label",
    component: "span"
  }, /*#__PURE__*/React__default.createElement(NamedIcon$1, {
    icon: "plus"
  })), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "button",
    component: "span",
    color: props.surfaceColor
  }, props.t("show-more-maps")))));
};

var settings = function settings(flag) {
  return {
    infinite: false,
    arrows: flag,
    centerPadding: '0px',
    variableWidth: true,
    swipeToSlide: false,
    swipe: false,
    nextArrow: /*#__PURE__*/React__default.createElement(ArrowForward, null),
    prevArrow: /*#__PURE__*/React__default.createElement(ArrowForward, null),
    responsive: [{
      breakpoint: 600,
      settings: {
        variableWidth: true,
        centerPadding: '0px',
        swipeToSlide: true,
        swipe: flag,
        arrows: false,
        speed: 900
      }
    }]
  };
};
var generateDistinctMsg = function generateDistinctMsg(currLocator, selectedFilter, serviceName, isMobile, hospitalServiceMsg) {
  var serviceArray = [];
  var distinctMsgContent = hospitalServiceMsg.includes('{planType}') && hospitalServiceMsg.split('{planType}');
  var distinctMsgContent2 = distinctMsgContent[1] && distinctMsgContent[1].includes('{services}') && distinctMsgContent[1].split('{services}');
  var planType = '';
  get$1(currLocator, 'fields.primaryLocatorFilter', []).map(function (filter) {
    if (get$1(filter, 'fields.searchName.value', '') === 'Group-Hospitals-and-Clinics' && serviceName === 'groupServices' || get$1(filter, 'fields.searchName.value', '') === 'Individual-Hospitals-and-Clinics' && serviceName === 'individualServices') {
      planType = filter.fields.name.value;
    }

    return planType;
  });
  get$1(currLocator, "fields.".concat(serviceName), []).map(function (service) {
    return selectedFilter.map(function (filter) {
      return get$1(service, 'fields.name.value', '') === filter ? serviceArray.push(filter) : '';
    });
  });
  return serviceArray.length && distinctMsgContent2[0] && distinctMsgContent[0] && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, distinctMsgContent[0], /*#__PURE__*/React__default.createElement("b", null, planType), distinctMsgContent2[0], " ", serviceArray.join(', '), ".");
};
var handleQueryParameter = function handleQueryParameter(locatorType) {
  var url, queryLongitude, queryLatitude, filterType;
  var queryFacilityTypes = [];
  var queryProvince = [];

  if (typeof window !== 'undefined') {
    url = new URLSearchParams(window.location.search);
    url.forEach(function (val, key) {
      switch (key.toLowerCase()) {
        case 'province':
          queryProvince = get$1(locatorType[0], 'fields.provinceList', []).filter(function (item) {
            return get$1(item, 'fields.name.value', '').toLowerCase() === val.toLowerCase();
          });
          break;

        case 'lat':
          queryLatitude = val;
          break;

        case 'long':
          queryLongitude = val;
          break;

        case 'facilitytype':
          filterType = _toConsumableArray(val.split(','));
          filterType = get$1(locatorType[0], 'fields.primaryLocatorFilter', []).map(function (item) {
            if (filterType.includes(get$1(item, 'fields.name.value', '').toLowerCase()) || filterType.includes(get$1(item, 'fields.name.value', ''))) {
              return queryFacilityTypes.push(get$1(item, 'fields.name.value', ''));
            } else return;
          });
          break;
      }
    });
  }

  return {
    queryProvince: queryProvince,
    queryLatitude: queryLatitude,
    queryLongitude: queryLongitude,
    queryFacilityTypes: queryFacilityTypes
  };
};
var calculateChipsWidth = function calculateChipsWidth(slider) {
  var sliderChips = _toConsumableArray(slider.getElementsByClassName('slick-slide'));

  var chipsWidth = 0;
  sliderChips.map(function (chip) {
    return chipsWidth += chip.getBoundingClientRect().width;
  });
  return chipsWidth;
};
var calculateChipsContainerWidth = function calculateChipsContainerWidth(parentWrapper, filterType, padding) {
  return "".concat(parentWrapper.offsetWidth / 2 - filterType.offsetWidth - padding, "px"); // 24px is the right padding of container
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$h = function styles(theme) {
  return {
    card: {
      width: '100%',
      borderRadius: '16px',
      '&:hover': {
        boxShadow: theme.shadows[1]
      },
      '& a:hover': {
        textDecoration: 'none'
      }
    },
    cardVariant: _defineProperty({
      marginBottom: theme.spacing(2)
    }, theme.breakpoints.down('sm'), {
      marginBottom: theme.spacing(2)
    }),
    pdfContainer: {
      display: 'flex',
      '& span': {
        '&:nth-child(2)': {
          marginLeft: 'auto'
        }
      }
    },
    cardContent: _defineProperty({
      marginTop: theme.spacing(2),
      position: 'relative',
      overflow: 'auto',
      padding: theme.spacing(0, 2, 3, 2),
      paddingRight: theme.spacing(5)
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing(0, 3, 3, 3)
    }),
    searchCardSkeleton: _defineProperty({
      margin: "0 ".concat(theme.spacing(-2), "px")
    }, theme.breakpoints.up('sm'), {
      margin: '0'
    })
  };
};

var _excluded = ["animation", "classes", "className", "component", "height", "variant", "width", "color"];
var styles$g = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      backgroundColor: fwdColors.grey,
      height: '1.2em'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {
      marginTop: 0,
      marginBottom: 0,
      height: 'auto',
      transformOrigin: '0 60%',
      transform: 'scale(1, 0.60)',
      borderRadius: theme.shape.borderRadius,
      '&:empty:before': {
        content: '"\\00a0"'
      }
    },

    /* Styles applied to the root element if `variant="rect"`. */
    rect: {},

    /* Styles applied to the root element if `variant="circle"`. */
    circle: {
      borderRadius: '50%'
    },

    /* Styles applied to the root element if `animation="pulse"`. */
    pulse: {
      animation: '$pulse 1.5s ease-in-out 0.5s infinite'
    },
    '@keyframes pulse': {
      '0%': {
        opacity: 1
      },
      '50%': {
        opacity: 0.4
      },
      '100%': {
        opacity: 1
      }
    },

    /* Styles applied to the root element if `animation="wave"`. */
    wave: {
      position: 'relative',
      overflow: 'hidden',
      '&::after': {
        animation: '$wave 1.6s linear 0.5s infinite',
        background: 'linear-gradient(90deg, rgba(255,255,255,0), rgba(255, 255, 255, 0.7), rgba(255,255,255,0))',
        content: '""',
        position: 'absolute',
        transform: 'translateX(-100%)',
        // Avoid flash during server-side hydration
        bottom: 0,
        left: 0,
        right: 0,
        top: 0,
        zIndex: 1
      },
      '&.color-white': {
        background: 'white',
        '&::after': {
          background: 'linear-gradient(90deg, rgba(255,255,255,0), rgba(219, 223, 225, 0.4), rgba(255,255,255,0))'
        }
      }
    },
    '@keyframes wave': {
      '0%': {
        transform: 'translateX(-100%)'
      },
      '60%': {
        // +0.5s of delay between each loop
        transform: 'translateX(100%)'
      },
      '100%': {
        transform: 'translateX(100%)'
      }
    }
  };
};
/**
 * @param {string or false} animation - If `false` the animation effect is disabled.
 * @param {object} classes -Override or extend the styles applied to the component.
 * @param {string} className
 * @param {elementType} component - default value is span.
 * @param {string} variant - The type of content that will be rendered and default value is text.
 * @param {number or string} height - Height of the skeleton.
 * @param {number or string} width - Width of the skeleton.
 */

var Skeleton = /*#__PURE__*/React.forwardRef(function Skeleton(props, ref) {
  var _clsx;

  var _props$animation = props.animation,
      animation = _props$animation === void 0 ? 'pulse' : _props$animation,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'span' : _props$component,
      height = props.height,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      width = props.width,
      color = props.color,
      other = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref,
    className: clsx(classes.root, classes[variant], (_clsx = {}, _defineProperty(_clsx, classes[animation], animation !== false), _defineProperty(_clsx, "color-".concat(color), color), _clsx), className)
  }, other, {
    style: _objectSpread2({
      width: width,
      height: height
    }, other.style)
  }));
});
Skeleton.propTypes = {
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   */
  animation: PropTypes.oneOf(['pulse', 'wave', false]),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * The type of content that will be rendered.
   */
  variant: PropTypes.oneOf(['text', 'rect', 'circle']),

  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  color: PropTypes.string
};
var Skeleton$1 = withStyles$1(styles$g, {
  name: 'MuiSkeleton'
})(Skeleton);

var useStyles$i = makeStyles(styles$h);

var SearchCardSkeleton = function SearchCardSkeleton(props) {
  var classes = useStyles$i();

  var items = _toConsumableArray(Array(props.count || 1).keys());

  return /*#__PURE__*/React__default.createElement("div", {
    "data-locator": props['data-locator'],
    className: props.showMoreSkelton ? classes.searchCardSkeleton : ''
  }, !props.showMoreSkelton ? /*#__PURE__*/React__default.createElement("div", {
    width: 150,
    style: {
      marginTop: 102
    }
  }) : null, items.map(function (i) {
    return /*#__PURE__*/React__default.createElement(FwdCard, {
      key: i,
      elevation: 0,
      className: clsx(classes.card, classes.cardVariant)
    }, /*#__PURE__*/React__default.createElement(FwdCardContent, {
      className: classes.cardContent
    }, /*#__PURE__*/React__default.createElement("div", {
      className: classes.pdfContainer
    }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "text",
      width: 60,
      height: 30,
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "text",
      width: 20,
      height: 35,
      animation: "wave"
    })), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "text",
      width: 200,
      height: 62,
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "text",
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "text",
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "text",
      animation: "wave"
    })));
  }));
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$f = function styles(theme) {
  var _bottomLinkWrapper, _cardContent;

  return {
    container: _defineProperty({
      padding: theme.spacing(0, 0, 0, 2)
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing(0, 4)
    }),
    title: _defineProperty({
      margin: theme.spacing(8, 2, 3, 0),
      fontWeight: theme.typography.fontWeights.bolder
    }, theme.breakpoints.up('sm'), {
      margin: theme.spacing(12, 0, 6, 0)
    }),
    link: _defineProperty({
      margin: theme.spacing(3, 0, 8, 0)
    }, theme.breakpoints.up('sm'), {
      margin: theme.spacing(6, 0, 12, 0)
    }),
    bottomLinkWrapper: (_bottomLinkWrapper = {
      margin: theme.spacing(3, 0, 8, 0)
    }, _defineProperty(_bottomLinkWrapper, theme.breakpoints.up('sm'), {
      margin: theme.spacing(3, 0, 12, 0)
    }), _defineProperty(_bottomLinkWrapper, '& a', {
      color: theme.palette.primary.dark,
      textDecoration: 'none',
      fontWeight: theme.typography.fontWeights.bold
    }), _bottomLinkWrapper),
    cardContent: (_cardContent = {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: theme.spacing(2, 2, 3, 2),
      color: theme.palette.primary.main
    }, _defineProperty(_cardContent, theme.breakpoints.up('sm'), {
      padding: theme.spacing(2, 3, 3, 3)
    }), _defineProperty(_cardContent, '& .$category', {
      marginBottom: theme.spacing(1)
    }), _defineProperty(_cardContent, '& .$heading', _defineProperty({
      marginBottom: theme.spacing(1)
    }, theme.breakpoints.up('sm'), {
      marginBottom: theme.spacing(1)
    })), _cardContent)
  };
};

var useStyles$h = makeStyles(styles$f);

var DynamicCardListSkeleton = function DynamicCardListSkeleton(props) {
  var classes = useStyles$h();

  var items = _toConsumableArray(Array(props.count || 1).keys());

  return /*#__PURE__*/React__default.createElement("div", {
    "data-locator": props['data-locator']
  }, /*#__PURE__*/React__default.createElement(Carousel$1, {
    settings: props.settings
  }, items.map(function (i) {
    return /*#__PURE__*/React__default.createElement(FwdCard, {
      key: i,
      elevation: 0,
      className: 'card allBorderRadiusMedium'
    }, /*#__PURE__*/React__default.createElement(FwdCardContent, {
      className: classes.cardContent
    }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "text",
      width: 60
    }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "text"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "text"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "text"
    })), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "text",
      width: 60
    })));
  })));
};

var styles$e = function styles(theme) {
  var _productBox, _productCard;

  return {
    card: {
      width: '100%',
      '&:hover': {
        boxShadow: theme.shadows[1]
      },
      '& a:hover': {
        textDecoration: 'none'
      }
    },
    cardVariant: _defineProperty({
      marginBottom: theme.spacing(2)
    }, theme.breakpoints.down('sm'), {
      marginBottom: theme.spacing(1)
    }),
    cardContent: _defineProperty({
      marginTop: theme.spacing(2),
      position: 'relative',
      overflow: 'auto',
      padding: theme.spacing(0, 2, 3, 2),
      paddingRight: theme.spacing(5)
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing(0, 3, 3, 3)
    }),
    image: {
      borderRadius: theme.spacing(1),
      marginTop: '24px',
      '&.MuiSkeleton-root': {
        backgroundColor: fwdColors.greyLight
      }
    },
    productBox: (_productBox = {
      width: '90%',
      marginBottom: theme.spacing(6),
      display: 'inline-block'
    }, _defineProperty(_productBox, theme.breakpoints.down('sm'), {
      marginBottom: theme.spacing(3),
      paddingTop: theme.spacing(1.3),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      width: '100%'
    }), _defineProperty(_productBox, theme.breakpoints.up('md'), {
      paddingTop: theme.spacing(2.3),
      paddingRight: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      paddingLeft: theme.spacing(1.5)
    }), _productBox),
    productCard: (_productCard = {
      height: '100%',
      borderRadius: '16px',
      overflow: 'visible',
      padding: theme.spacing(1 / 8),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(3),
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      transition: 'all .3s cubic-bezier(0.230, 1.000, 0.320, 1.000)',
      '&:hover': {
        boxShadow: theme.shadows[4]
      },
      '& $categoryColor+$cardContent': _defineProperty({}, theme.breakpoints.down('sm'), {
        marginTop: theme.spacing(2)
      })
    }, _defineProperty(_productCard, theme.breakpoints.up('md'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }), _defineProperty(_productCard, theme.breakpoints.down('sm'), {
      width: '100%'
    }), _defineProperty(_productCard, '& .MuiCardContent-root:last-child', {
      paddingBottom: '0'
    }), _productCard),
    productContainer: {
      width: '100%',
      '& .MuiSkeleton-text': {
        transform: 'none'
      }
    },
    shareContainer: {
      display: 'flex',
      marginTop: theme.spacing(2),
      '& span': {
        '&:nth-child(2)': {
          marginLeft: 'auto'
        }
      }
    },
    category: {
      marginTop: theme.spacing(1)
    },
    marginTop: {
      marginTop: theme.spacing(2)
    },
    chipContainer: {
      display: 'flex',
      marginTop: theme.spacing(3),
      '& span': {
        marginRight: theme.spacing(1),
        border: '1px solid #E5E5E5',
        backgroundColor: 'transparent',
        borderRadius: theme.spacing(0.5)
      }
    },
    text: _defineProperty({
      width: '100%'
    }, theme.breakpoints.up('sm'), {
      width: '85%',
      '&:nth-child(6)': {
        width: '81%'
      }
    })
  };
};

var useStyles$g = makeStyles(styles$e);
/**
 * @param {number} numberItems - Number of Skeleton cards to be displayed while fetching data from the API
 */

var ProductCardListSkeleton = function ProductCardListSkeleton(props) {
  var classes = useStyles$g();
  var numberItems = props.count;

  var items = _toConsumableArray(Array(numberItems).keys());

  return /*#__PURE__*/React__default.createElement("div", {
    "data-locator": props['data-locator'],
    className: classes.productContainer
  }, items.map(function (i) {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      key: i,
      className: classes.productBox,
      sm: 6,
      xs: 12,
      md: 4
    }, /*#__PURE__*/React__default.createElement(FwdCard, {
      key: i,
      elevation: 0,
      className: classes.productCard
    }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      className: classes.image,
      height: 115,
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: classes.shareContainer
    }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      width: 62,
      className: classes.category,
      height: 16,
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      width: 24,
      height: 24,
      animation: "wave"
    })), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      width: "100%",
      height: 39,
      className: classes.category,
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      width: 92,
      height: 16,
      className: classes.category,
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 16,
      className: clsx(classes.marginTop, classes.text),
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 16,
      className: clsx(classes.category, classes.text),
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      width: 133,
      height: 16,
      className: classes.category,
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: classes.chipContainer
    }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
      width: 90,
      height: 24,
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      width: 74,
      height: 24,
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      width: 86,
      height: 24,
      animation: "wave"
    }))));
  }));
};

var styles$d = function styles(theme) {
  return {
    card: {
      width: '100%',
      '&:hover': {
        boxShadow: theme.shadows[1]
      },
      '& a:hover': {
        textDecoration: 'none'
      }
    },
    productChips: {
      display: 'flex',
      marginTop: theme.spacing(3),
      boxSizing: 'content-box',
      '& span': {
        margin: theme.spacing(0, 0.5),
        border: '1px solid #E5E5E5',
        backgroundColor: 'transparent',
        borderRadius: theme.spacing(0.5),
        '&:first-of-type': {
          marginLeft: 0
        }
      }
    },
    cardContainer: {
      borderRadius: theme.spacing(2),
      marginLeft: 0
    },
    cardVariant: _defineProperty({
      marginBottom: theme.spacing(2)
    }, theme.breakpoints.down('sm'), {
      marginBottom: theme.spacing(1)
    }),
    cardContent: _defineProperty({
      marginTop: theme.spacing(2),
      position: 'relative',
      overflow: 'auto',
      padding: theme.spacing(0, 2, 3, 2),
      paddingRight: theme.spacing(5)
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing(0, 3, 3, 3)
    }),
    productBox: _defineProperty({
      marginBottom: theme.spacing(3)
    }, theme.breakpoints.down('sm'), {
      marginBottom: '0px'
    }),
    productContainer: _defineProperty({
      display: 'flex',
      width: '100%'
    }, theme.breakpoints.down('sm'), {
      paddingLeft: theme.spacing(1)
    }),
    cardDescription: _defineProperty({
      padding: theme.spacing(3, 2)
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing(3)
    }),
    centerContainer: {
      justifyContent: 'center'
    },
    image: {
      borderRadius: theme.spacing(1, 1, 0, 0),
      '&.MuiSkeleton-root': {
        backgroundColor: fwdColors.greyLight
      }
    },
    sliderWrap: {
      width: '100%'
    },
    slideWrap: _defineProperty({
      paddingLeft: theme.spacing(1)
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5)
    })
  };
};

var useStyles$f = makeStyles(styles$d);

var RelatedArticlesListsSkeleton = function RelatedArticlesListsSkeleton(props) {
  var classes = useStyles$f();

  var items = _toConsumableArray(Array(props.count || 1).keys());

  var _ref = props || {},
      _ref$settings = _ref.settings,
      settings = _ref$settings === void 0 ? {} : _ref$settings;

  return /*#__PURE__*/React__default.createElement("div", {
    "data-locator": props['data-locator'],
    className: clsx(classes.productContainer, _defineProperty({}, classes.centerContainer, props && props.variant === 'center'))
  }, /*#__PURE__*/React__default.createElement(Carousel$1, {
    settings: settings,
    className: classes.sliderWrap
  }, items.map(function (i) {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      key: i,
      className: classes.slideWrap,
      sm: 12
    }, /*#__PURE__*/React__default.createElement(FwdCard, {
      key: i,
      elevation: 0,
      className: classes.cardContainer
    }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      width: "100%",
      height: 220,
      className: classes.image
    }), /*#__PURE__*/React__default.createElement("div", {
      className: classes.cardDescription
    }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 16,
      width: 62
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 16,
      style: {
        marginTop: '8px'
      }
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 16,
      style: {
        marginTop: '8px'
      }
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 16,
      style: {
        marginTop: '8px'
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      className: classes.productChips
    }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 24,
      width: 90
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 24,
      width: 74
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 24,
      width: 86
    })))));
  })));
};

var styles$c = function styles(theme) {
  var _slideWrap;

  return {
    sliderWrapCon: _defineProperty({
      marginTop: 0
    }, theme.breakpoints.down('sm'), {
      marginLeft: theme.spacing(-1)
    }),
    cardContainer: _defineProperty({
      borderRadius: theme.spacing(2),
      marginBottom: theme.spacing(3),
      padding: theme.spacing(3, 2)
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing(3)
    }),
    sliderWrap: {
      width: '100%',
      '& .slick-prev, .slick-next': {
        width: theme.spacing(3),
        height: theme.spacing(3),
        color: '#fff',
        zIndex: '7',
        '&:hover': {
          color: theme.palette.colors.white.main
        }
      },
      '& .slick-track': {
        display: 'flex',
        '& .slick-slide': {
          height: 'auto',
          '&>div': {
            height: '100%',
            '&>div': {
              height: '100%'
            }
          }
        }
      },
      '& .slick-prev': {
        transform: 'translate(0, -50%) rotate(180deg)',
        left: theme.spacing(-2)
      },
      '& .slick-disabled ': {
        opacity: '0',
        pointerEvents: 'none'
      },
      '& .slick-next': {
        right: theme.spacing(-2)
      }
    },
    slideWrap: (_slideWrap = {
      paddingLeft: theme.spacing(1)
    }, _defineProperty(_slideWrap, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5)
    }), _defineProperty(_slideWrap, '&:first', {
      paddingLeft: 0
    }), _slideWrap),
    card: {
      width: '100%',
      '&:hover': {
        boxShadow: theme.shadows[1]
      },
      '& a:hover': {
        textDecoration: 'none'
      }
    },
    cardImage: {
      borderRadius: theme.spacing(1),
      marginBottom: theme.spacing(2),
      '&.MuiSkeleton-root': {
        backgroundColor: fwdColors.greyLight
      }
    },
    productChips: {
      display: 'flex',
      marginTop: theme.spacing(3),
      boxSizing: 'content-box',
      '& span': {
        margin: theme.spacing(0, 0.5),
        border: '1px solid #E5E5E5',
        backgroundColor: 'transparent',
        borderRadius: theme.spacing(0.5),
        '&:first-of-type': {
          marginLeft: 0
        }
      }
    },
    cardVariant: _defineProperty({
      marginBottom: theme.spacing(2)
    }, theme.breakpoints.down('sm'), {
      marginBottom: theme.spacing(1)
    }),
    cardContent: _defineProperty({
      marginTop: theme.spacing(2),
      position: 'relative',
      overflow: 'auto',
      padding: theme.spacing(0, 2, 3, 2),
      paddingRight: theme.spacing(5)
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing(0, 3, 3, 3)
    }),
    productBox: _defineProperty({
      marginBottom: theme.spacing(3)
    }, theme.breakpoints.down('sm'), {
      marginBottom: '0px'
    }),
    productContainer: {
      display: 'flex',
      width: '100%'
    },
    text: _defineProperty({
      width: '100%'
    }, theme.breakpoints.up('sm'), {
      width: '85%',
      '&:nth-child(6)': {
        width: '81%'
      }
    })
  };
};

var useStyles$e = makeStyles(styles$c);

var RelatedProductsListSkeleton = function RelatedProductsListSkeleton(props) {
  var classes = useStyles$e();

  var items = _toConsumableArray(Array(props.count || 1).keys());

  var _ref = props || {},
      _ref$settings = _ref.settings,
      settings = _ref$settings === void 0 ? {} : _ref$settings;

  return /*#__PURE__*/React__default.createElement("div", {
    "data-locator": props['data-locator'],
    className: classes.productContainer
  }, /*#__PURE__*/React__default.createElement(Carousel$1, {
    settings: settings,
    className: classes.sliderWrap
  }, items.map(function (i) {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      key: i,
      sm: 12,
      item: true,
      className: classes.slideWrap
    }, /*#__PURE__*/React__default.createElement(FwdCard, {
      key: i,
      elevation: 0,
      className: classes.cardContainer
    }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      width: "100%",
      height: 140,
      className: classes.cardImage
    }), /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'flex'
      }
    }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 16,
      width: 62,
      style: {
        marginTop: '8px'
      }
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 24,
      width: 24,
      style: {
        marginLeft: 'auto'
      }
    })), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 39,
      style: {
        marginTop: '8px'
      }
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 16,
      width: "26.75%",
      style: {
        marginTop: '8px'
      }
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 16,
      style: {
        marginTop: '16px'
      },
      className: classes.text
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 16,
      style: {
        marginTop: '8px'
      },
      className: classes.text
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      width: "38.67%",
      height: 16,
      style: {
        marginTop: '8px'
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      className: classes.productChips
    }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 24,
      width: 90
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 24,
      width: 74
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 24,
      width: 86
    }))));
  })));
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$b = function styles(theme) {
  return {
    tagContainer: {
      display: 'flex',
      '& span': {
        marginRight: theme.spacing(1),
        border: '1px solid #E5E5E5'
      }
    }
  };
};

var useStyles$d = makeStyles(styles$b);

var DynamicTagListSkeleton = function DynamicTagListSkeleton(props) {
  var classes = useStyles$d();

  var items = _toConsumableArray(Array(props.count || 1).keys());

  return /*#__PURE__*/React__default.createElement("div", {
    "data-locator": props['data-locator'],
    className: classes.tagContainer
  }, items.map(function (i) {
    return /*#__PURE__*/React__default.createElement(Skeleton$1, {
      key: i,
      width: "100%",
      height: 40
    });
  }));
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$a = function styles(theme) {
  return {
    mapCard: {
      boxSizing: 'border-box',
      cursor: 'pointer',
      padding: theme.spacing(22 / 8),
      paddingTop: 0,
      borderRadius: '2px'
    },
    mapSurface: {
      borderBottom: '1px solid #E5E5E5',
      backgroundColor: '#fff'
    },
    justifyContent: {
      justifyContent: 'space-between',
      display: 'flex',
      alignItems: 'flex-start',
      paddingTop: '16px',
      paddingBottpm: '16px',
      flexDirection: 'column'
    }
  };
};

var useStyles$c = makeStyles(styles$a);

var MapCardSkeleton = function MapCardSkeleton(props) {
  var classes = useStyles$c();

  var items = _toConsumableArray(Array(props.count || 1).keys());

  return /*#__PURE__*/React__default.createElement("div", {
    "data-locator": props['data-locator']
  }, items.map(function (i) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: clsx(classes.mapCard, classes.mapSurface),
      "data-locator": props['data-locator'],
      key: i
    }, /*#__PURE__*/React__default.createElement("div", {
      className: clsx(classes.flexWrapper, classes.justifyContent)
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: '100%',
        display: 'flex'
      }
    }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      height: 20,
      width: "95%",
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "circle",
      height: 20,
      style: {
        marginLeft: '5px'
      },
      width: "20px",
      animation: "wave"
    })), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      style: {
        marginTop: '10px'
      },
      height: 10,
      width: "40px",
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      style: {
        marginTop: '10px'
      },
      height: 10,
      width: "100px",
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      style: {
        marginTop: '10px'
      },
      height: 10,
      width: "100%",
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      style: {
        marginTop: '10px'
      },
      height: 10,
      width: "80%",
      animation: "wave"
    }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      style: {
        marginTop: '20px'
      },
      height: 15,
      width: "40px",
      animation: "wave"
    })));
  }));
};

var styles$9 = function styles(theme) {
  var _productChips;

  return {
    root: _defineProperty({
      '& .MuiSkeleton-root': {
        height: theme.spacing(3.75),
        '&:last-child': {
          height: theme.spacing(1.25)
        }
      }
    }, theme.breakpoints.down('sm'), {
      '& .MuiSkeleton-root': {
        height: theme.spacing(3),
        '&:last-child': {
          height: theme.spacing(2)
        }
      }
    }),
    events: {
      width: '100%',
      position: 'relative'
    },
    cardItems: _defineProperty({
      margin: theme.spacing(1, 0.5, 0, 0.5),
      '&:last-child': {
        marginTop: theme.spacing(1.25)
      }
    }, theme.breakpoints.down('sm'), {
      '&:first-child': {
        marginTop: 0
      }
    }),
    image: _defineProperty({
      position: 'relative',
      '&.MuiSkeleton-root': {
        backgroundColor: fwdColors.greyLight
      },
      height: theme.spacing(20.5)
    }, theme.breakpoints.up('sm'), {
      height: theme.spacing(36),
      maxHeight: theme.spacing(36)
    }),
    date: _defineProperty({
      height: theme.spacing(2),
      margin: theme.spacing(3, 0, 1.25, 2),
      width: '32.14%'
    }, theme.breakpoints.up('sm'), {
      margin: theme.spacing(3, 0, 1.25, 3)
    }),
    title: _defineProperty({
      margin: theme.spacing(0, 3, 1, 2),
      height: theme.spacing(6.25)
    }, theme.breakpoints.up('sm'), {
      margin: theme.spacing(0, 6, 3, 3)
    }),
    description: _defineProperty({
      height: theme.spacing(2),
      margin: theme.spacing(1, 3, 1, 2)
    }, theme.breakpoints.up('sm'), {
      display: 'none'
    }),
    descriptionEnd: _defineProperty({
      height: theme.spacing(2),
      width: '53.66%',
      margin: theme.spacing(1, 0, 4, 2)
    }, theme.breakpoints.up('sm'), {
      display: 'none'
    }),
    cardDetail: _defineProperty({}, theme.breakpoints.up('sm'), {
      position: 'absolute',
      left: theme.spacing(1.5),
      bottom: theme.spacing(1.5),
      borderRadius: theme.spacing(2),
      width: '62.8%',
      height: theme.spacing(15.5),
      backgroundColor: fwdColors.white
    }),
    nextButton: _defineProperty({
      position: 'absolute',
      right: theme.spacing(2.5),
      bottom: theme.spacing(2.5),
      width: theme.spacing(4),
      height: theme.spacing(4),
      borderRadius: theme.spacing(0.5)
    }, theme.breakpoints.up('sm'), {
      right: theme.spacing(1),
      bottom: theme.spacing(1)
    }),
    totalCountTitle: _defineProperty({
      '& .MuiSkeleton-root': {
        background: fwdColors.white,
        maxWidth: '288px'
      }
    }, theme.breakpoints.up('sm'), {
      marginBottom: theme.spacing(3)
    }),
    articleGrid: _defineProperty({}, theme.breakpoints.up('sm'), {
      padding: theme.spacing(0, 1, 0, 1)
    }),
    productChips: (_productChips = {
      display: 'flex',
      boxSizing: 'content-box',
      marginLeft: theme.spacing(2),
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(2.5)
    }, _defineProperty(_productChips, theme.breakpoints.up('sm'), {
      marginLeft: theme.spacing(3),
      marginTop: theme.spacing(4.5)
    }), _defineProperty(_productChips, '& span', {
      margin: theme.spacing(0, 0.5),
      border: '1px solid #E5E5E5',
      backgroundColor: 'transparent',
      borderRadius: theme.spacing(0.5),
      '&:first-of-type': {
        marginLeft: 0
      }
    }), _productChips),
    cardContainer: _defineProperty({
      borderRadius: '16px',
      width: '100%'
    }, theme.breakpoints.up('sm'), {
      marginBottom: theme.spacing(3)
    }),
    imagelive: _defineProperty({
      height: '185px',
      minWidth: '328px',
      '&.MuiSkeleton-root': {
        backgroundColor: fwdColors.greyLight
      }
    }, theme.breakpoints.up('sm'), {
      height: '221px',
      minWidth: '392px'
    }),
    text: _defineProperty({
      height: theme.spacing(1.25),
      width: 'calc(100%-32px)',
      margin: theme.spacing(1, 2, 0, 2),
      '&:last-of-type': {
        width: '52.44%'
      }
    }, theme.breakpoints.up('sm'), {
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
      width: 'calc(100%-48px)',
      '&:last-of-type': {
        width: '50%'
      }
    }),
    datelive: _defineProperty({
      width: '24.39%',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1.5)
    }, theme.breakpoints.up('sm'), {
      width: '20.41%'
    })
  };
};

var useStyles$b = makeStyles(styles$9);

var ArticleSubtypeGridView = function ArticleSubtypeGridView(props) {
  var items = _toConsumableArray(Array(props.count || 1).keys());

  var designVariation = get$1(props, 'designVariation', '');
  var classes = useStyles$b();

  var RenderTotalCountField = function RenderTotalCountField() {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      item: true,
      xs: 8,
      md: 12,
      className: classes.totalCountTitle
    }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      animation: false
    }));
  };

  var RenderCsrGridVariant = function RenderCsrGridVariant() {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      container: true,
      spacing: 3,
      "data-locator": props['data-locator'],
      className: classes.articleGrid
    }, /*#__PURE__*/React__default.createElement(RenderTotalCountField, null), items.map(function (i) {
      return /*#__PURE__*/React__default.createElement(StyledGrid, {
        item: true,
        xs: 12,
        md: 6,
        key: i,
        className: classes.events
      }, /*#__PURE__*/React__default.createElement(FwdCard, {
        elevation: 0
      }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.image,
        animation: "wave"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: classes.cardDetail
      }, props.hasDate ? /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.date,
        animation: "wave"
      }) : /*#__PURE__*/React__default.createElement("span", {
        className: classes.date
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.title,
        animation: "wave"
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.description,
        animation: "wave"
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.description,
        animation: "wave"
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.descriptionEnd,
        animation: "wave"
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.nextButton,
        animation: "wave"
      }))));
    }));
  };

  var RenderLiveGridVariant = function RenderLiveGridVariant() {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      container: true,
      spacing: 3,
      "data-locator": props['data-locator'],
      className: classes.articleGrid
    }, /*#__PURE__*/React__default.createElement(RenderTotalCountField, null), items.map(function (i) {
      return /*#__PURE__*/React__default.createElement(StyledGrid, {
        item: true,
        sm: 12,
        md: 4,
        key: i,
        className: classes.cardContainer
      }, /*#__PURE__*/React__default.createElement(FwdCard, {
        elevation: 0
      }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.imagelive
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: clsx(classes.text, classes.datelive)
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.text
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.text
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.text
      }), /*#__PURE__*/React__default.createElement("div", {
        className: classes.productChips
      }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        height: 24,
        width: 90
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        height: 24,
        width: 74
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        height: 24,
        width: 86
      }))));
    }));
  };

  var RenderDefaultGridVariant = function RenderDefaultGridVariant() {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      container: true,
      spacing: 3,
      "data-locator": props['data-locator'],
      className: classes.articleGrid
    }, /*#__PURE__*/React__default.createElement(RenderTotalCountField, null), items.map(function (i) {
      return /*#__PURE__*/React__default.createElement(StyledGrid, {
        item: true,
        xs: 12,
        md: 4,
        key: i,
        className: classes.root
      }, /*#__PURE__*/React__default.createElement(FwdCard, {
        elevation: 0
      }, /*#__PURE__*/React__default.createElement(FwdCardContent, null, /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.cardItems,
        animation: "wave"
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.cardItems,
        animation: "wave"
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.cardItems,
        width: '50%',
        animation: "wave"
      }))));
    }));
  };

  return designVariation === articleListingDesign.CSR ? /*#__PURE__*/React__default.createElement(RenderCsrGridVariant, null) : designVariation === articleListingDesign.LIVE ? /*#__PURE__*/React__default.createElement(RenderLiveGridVariant, null) : /*#__PURE__*/React__default.createElement(RenderDefaultGridVariant, null);
};

var styles$8 = function styles(theme) {
  var _productChips;

  return {
    root: _defineProperty({
      padding: theme.spacing(2, 2, 0),
      borderRadius: '4px',
      backgroundColor: fwdColors.white,
      '& .MuiSkeleton-root': {
        height: theme.spacing(2)
      }
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing(6, 0),
      '& .MuiSkeleton-root': {
        height: theme.spacing(3)
      }
    }),
    link: _defineProperty({
      display: 'flex',
      position: 'relative',
      justifyContent: 'space-between',
      paddingBottom: theme.spacing(3),
      paddingTop: theme.spacing(3),
      '&:first-child': {
        paddingTop: 0
      }
    }, theme.breakpoints.up('md'), {
      margin: "0 ".concat(theme.spacing(6), "px")
    }),
    linkImage: _defineProperty({}, theme.breakpoints.up('sm'), {
      display: 'flex',
      position: 'relative',
      justifyContent: 'space-between',
      cursor: 'pointer',
      paddingBottom: theme.spacing(2),
      paddingTop: theme.spacing(1.875),
      margin: "0 ".concat(theme.spacing(6), "px"),
      '&:first-child': {
        paddingTop: 0
      }
    }),
    content: _defineProperty({
      marginTop: theme.spacing(1)
    }, theme.breakpoints.up('sm'), {
      marginTop: 0,
      width: '100%',
      marginRight: theme.spacing(14)
    }),
    contentMobile: _defineProperty({
      marginTop: theme.spacing(1),
      width: '84%'
    }, theme.breakpoints.up('sm'), {
      display: 'none'
    }),
    contentWithoutDateImage: _defineProperty({
      width: '87.5%'
    }, theme.breakpoints.up('sm'), {
      marginRight: 0,
      width: '78.3%'
    }),
    contentWithDateImage: _defineProperty({
      width: '84%',
      maxHeight: theme.spacing(3)
    }, theme.breakpoints.up('sm'), {
      marginBottom: theme.spacing(2.5),
      width: '83.6%'
    }),
    contentWithoutDate: _defineProperty({
      marginBottom: 0
    }, theme.breakpoints.up('sm'), {
      marginBottom: theme.spacing(5.5)
    }),
    contentlive: {
      '&.MuiSkeleton-root': _defineProperty({
        height: theme.spacing(1.25)
      }, theme.breakpoints.up('sm'), {
        height: theme.spacing(2)
      })
    },
    dateMobileView: _defineProperty({
      marginBottom: theme.spacing(2)
    }, theme.breakpoints.up('sm'), {
      display: 'none'
    }),
    withoutDateMobileView: _defineProperty({
      marginBottom: 0
    }, theme.breakpoints.up('sm'), {
      display: 'none'
    }),
    dateWithImageView: _defineProperty({
      marginBottom: theme.spacing(1),
      maxHeight: theme.spacing(2),
      width: '64%'
    }, theme.breakpoints.up('sm'), {
      marginBottom: theme.spacing(1),
      width: '19%'
    }),
    totalCountTitle: _defineProperty({
      marginBottom: theme.spacing(3),
      '& .MuiSkeleton-root': {
        background: fwdColors.white,
        maxWidth: '288px'
      }
    }, theme.breakpoints.up('sm'), {
      marginBottom: theme.spacing(4.5)
    }),
    iconWrapper: {
      borderRadius: theme.spacing(0.5),
      position: 'absolute',
      top: 0,
      right: 0
    },
    image: {
      borderRadius: theme.spacing(1),
      width: '40%',
      '&.MuiSkeleton-root': _defineProperty({
        backgroundColor: fwdColors.greyLight,
        height: theme.spacing(10)
      }, theme.breakpoints.up('sm'), {
        height: theme.spacing(8.5),
        width: '14%'
      })
    },
    productChips: (_productChips = {
      display: 'flex',
      marginTop: theme.spacing(2)
    }, _defineProperty(_productChips, theme.breakpoints.up('sm'), {
      marginTop: theme.spacing(-1.5),
      marginBottom: theme.spacing(3)
    }), _defineProperty(_productChips, '& span', {
      margin: '0 6px 0 6px',
      border: '1px solid #E5E5E5',
      backgroundColor: 'transparent',
      borderRadius: '4px',
      '& :first-of-type': {
        marginLeft: 0
      }
    }), _productChips),
    event: _defineProperty({}, theme.breakpoints.down('sm'), {
      position: 'relative',
      marginBottom: theme.spacing(3.75)
    }),
    contentBox: _defineProperty({
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      marginLeft: theme.spacing(2),
      width: '100%'
    }, theme.breakpoints.up('sm'), {
      marginLeft: theme.spacing(3)
    }),
    contentBoxLive: _defineProperty({}, theme.breakpoints.down('sm'), {
      width: '67.5%'
    }),
    linkDesktop: _defineProperty({}, theme.breakpoints.down('sm'), {
      display: 'none'
    }),
    linkMobile: _defineProperty({
      marginBottom: theme.spacing(3)
    }, theme.breakpoints.up('sm'), {
      display: 'none'
    })
  };
};

var styles$7 = function styles(theme) {
  var _$descriptionDiv, _contentWrapper, _featuredTagsWrapper;

  var colors = theme.palette.colors || {};
  var linkBackground = {};
  Object.keys(colors).forEach(function (color) {
    var _linkBackground$linkB;

    linkBackground["linkBg-".concat(color)] = (_linkBackground$linkB = {
      backgroundColor: color,
      borderBottom: "1px solid ".concat(colors[color].line.divider),
      '&:last-child': _defineProperty({}, theme.breakpoints.down('sm'), {
        borderBottom: 'none'
      }),
      '& $icon': {
        color: colors[color].contrastTextAction
      },
      '& $iconWrapper': {
        '&:before': {
          maxHeight: theme.spacing(28 / 8),
          backgroundColor: alpha$1(colors[color].contrastTextAction, 0)
        }
      }
    }, _defineProperty(_linkBackground$linkB, theme.breakpoints.up('lg'), {
      '&:hover': {
        '& $iconWrapper': {
          '&:before': {
            backgroundColor: alpha$1(colors[color].contrastTextAction, 0.2)
          }
        },
        '& $imageTypeIconWrapper': {
          '& svg': {
            backgroundColor: alpha$1(colors[color].contrastTextAction, 0.2),
            borderRadius: theme.spacing(0.5)
          }
        }
      }
    }), _defineProperty(_linkBackground$linkB, theme.breakpoints.up('md'), {
      '& $contentContainer': {
        borderBottom: "1px solid ".concat(colors[color].line.divider)
      },
      '&.itemWithImage': {
        borderBottom: 'none'
      }
    }), _linkBackground$linkB);
  });
  return _objectSpread2(_objectSpread2({}, linkBackground), {}, {
    link: _defineProperty({
      display: 'flex',
      position: 'relative',
      justifyContent: 'space-between',
      cursor: 'pointer',
      paddingBottom: theme.spacing(3),
      paddingTop: theme.spacing(3),
      margin: "0 ".concat(theme.spacing(2), "px"),
      '&:first-child': {
        paddingTop: 0
      }
    }, theme.breakpoints.up('md'), {
      margin: "0 ".concat(theme.spacing(6), "px"),
      '&.itemWithImage': {
        paddingBottom: theme.spacing(2.5),
        paddingTop: theme.spacing(2.5),
        '&.liveTypeItem': {
          paddingBottom: theme.spacing(1.5),
          paddingTop: theme.spacing(1.5)
        },
        '&:first-child': {
          paddingTop: 0
        },
        '&:last-child': {
          paddingBottom: 0
        }
      }
    }),
    imageWrapper: _defineProperty({
      width: theme.spacing(17),
      minWidth: theme.spacing(17),
      marginRight: theme.spacing(3)
    }, theme.breakpoints.down('sm'), {
      width: theme.spacing(10),
      minWidth: theme.spacing(10)
    }),
    contentContainer: {
      display: 'flex',
      width: '100%'
    },
    contentWrapper: (_contentWrapper = {
      width: '100%'
    }, _defineProperty(_contentWrapper, theme.breakpoints.down('sm'), {
      marginRight: theme.spacing(1)
    }), _defineProperty(_contentWrapper, '& $description div', (_$descriptionDiv = {
      marginTop: theme.spacing(0.5),
      marginRight: theme.spacing(17),
      marginBottom: theme.spacing(3)
    }, _defineProperty(_$descriptionDiv, theme.breakpoints.down('sm'), {
      marginRight: theme.spacing(1),
      marginBottom: 0
    }), _defineProperty(_$descriptionDiv, '.liveTypeWithTags&', {
      marginBottom: 0
    }), _$descriptionDiv)), _contentWrapper),
    featuredTagsWrapper: (_featuredTagsWrapper = {
      margin: theme.spacing(1, 0, 3, 0)
    }, _defineProperty(_featuredTagsWrapper, theme.breakpoints.down('sm'), {
      marginBottom: 0,
      marginRight: theme.spacing(-3)
    }), _defineProperty(_featuredTagsWrapper, '& $chip', {
      margin: theme.spacing(0, 0.5, 0, 0.5),
      '&:first-child': {
        marginLeft: 0
      },
      '&:last-child': {
        marginRight: 0
      }
    }), _featuredTagsWrapper),
    date: _defineProperty({
      fontWeight: theme.typography.fontWeights.bold
    }, theme.breakpoints.up('md'), {
      minWidth: theme.typography.pxToRem(160),
      marginRight: theme.spacing(3)
    }),
    description: {
      maxWidth: theme.spacing(101)
    },
    icon: {
      height: theme.spacing(3),
      width: theme.spacing(3)
    },
    iconWrapper: {
      '&:before': {
        content: 'close-quote',
        top: theme.spacing(-0.25),
        bottom: theme.spacing(-0.25),
        right: theme.spacing(-0.25),
        left: theme.spacing(-0.25),
        borderRadius: theme.spacing(0.5),
        transition: motionTypes.colorTransition,
        position: 'absolute'
      }
    },
    imageTypeIconWrapper: {},
    chip: {}
  });
};

var useStyles$a = makeStyles(styles$8);
var useListStyles = makeStyles(styles$7);

var ArticleSubtypeListView = function ArticleSubtypeListView(props) {
  var classes = useStyles$a();
  var listClasses = useListStyles();

  var items = _toConsumableArray(Array(props.count || 1).keys());

  var designVariation = get$1(props, 'designVariation', '');

  var RenderTotalCountField = function RenderTotalCountField() {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      item: true,
      xs: 8,
      md: 12,
      className: classes.totalCountTitle
    }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
      variant: "rect",
      animation: false
    }));
  };

  var RenderListWithoutImage = function RenderListWithoutImage() {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      container: true,
      "data-locator": props['data-locator']
    }, /*#__PURE__*/React__default.createElement(RenderTotalCountField, null), /*#__PURE__*/React__default.createElement(StyledGrid, {
      item: true,
      xs: 12,
      className: clsx(classes.root)
    }, items.map(function (i) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: i,
        className: clsx(classes.link, listClasses["linkBg-".concat(props.bgColor)])
      }, /*#__PURE__*/React__default.createElement(Box, {
        display: 'flex',
        flexDirection: {
          xs: 'column',
          lg: 'row'
        },
        flex: 1,
        position: 'relative'
      }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: clsx(props.hasDate ? classes.dateMobileView : classes.withoutDateMobileView),
        height: 16,
        width: props.hasDate ? '54%' : '87.5%',
        animation: "wave"
      }), props.hasDate ? /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: listClasses.date,
        animation: "wave"
      }) : null, props.hasDate ? /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.content,
        animation: "wave"
      }) : null, !props.hasDate ? /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: clsx(classes.content, classes.contentWithoutDateImage),
        animation: "wave"
      }) : null, /*#__PURE__*/React__default.createElement(Box, {
        className: classes.iconWrapper
      }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        width: 24,
        height: 24,
        animation: "wave"
      }))));
    })));
  };

  var RenderListWithImage = function RenderListWithImage() {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      container: true,
      "data-locator": props['data-locator']
    }, /*#__PURE__*/React__default.createElement(RenderTotalCountField, null), /*#__PURE__*/React__default.createElement(StyledGrid, {
      item: true,
      xs: 12,
      className: clsx(classes.root)
    }, items.map(function (i) {
      var _clsx3;

      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        key: i,
        className: classes.linkImage
      }, /*#__PURE__*/React__default.createElement(Box, {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        className: classes.event
      }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: classes.image,
        animation: "wave"
      }), /*#__PURE__*/React__default.createElement(Box, {
        className: clsx(classes.contentBox, _defineProperty({}, classes.contentBoxLive, designVariation === articleListingDesign.LIVE))
      }, props.hasDate || designVariation === articleListingDesign.LIVE ? /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: clsx(classes.dateWithImageView, _defineProperty({}, classes.contentlive, designVariation === articleListingDesign.LIVE)),
        animation: "wave"
      }) : null, /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: clsx(classes.contentWithDateImage, (_clsx3 = {}, _defineProperty(_clsx3, classes.content, props.hasDate), _defineProperty(_clsx3, classes.contentWithoutDate, !props.hasDate), _defineProperty(_clsx3, classes.contentlive, designVariation === articleListingDesign.LIVE), _clsx3)),
        animation: "wave"
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        className: clsx(classes.contentMobile, _defineProperty({}, classes.contentlive, designVariation === articleListingDesign.LIVE)),
        animation: "wave"
      }), designVariation === articleListingDesign.LIVE ? /*#__PURE__*/React__default.createElement("div", {
        className: classes.productChips
      }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        height: 24,
        width: 90,
        style: {
          marginLeft: '0'
        }
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        height: 24,
        width: 74
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        height: 24,
        width: 86
      })) : null, /*#__PURE__*/React__default.createElement("div", {
        className: clsx(listClasses["linkBg-".concat(props.bgColor)], classes.linkDesktop)
      }), /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        width: 24,
        height: 24,
        animation: "wave",
        className: classes.iconWrapper,
        style: {
          position: 'absolute',
          top: '0px',
          right: '0px'
        }
      })))), /*#__PURE__*/React__default.createElement("div", {
        className: clsx(listClasses["linkBg-".concat(props.bgColor)], classes.linkMobile)
      }));
    })));
  };

  return designVariation === articleListingDesign.CSR ? props.hasImage ? /*#__PURE__*/React__default.createElement(RenderListWithImage, null) : /*#__PURE__*/React__default.createElement(RenderListWithoutImage, null) : designVariation === articleListingDesign.LIVE ? /*#__PURE__*/React__default.createElement(RenderListWithImage, null) : /*#__PURE__*/React__default.createElement(RenderListWithoutImage, null);
};

var styles$6 = function styles(theme) {
  var _inner, _inner2;

  return {
    root: {
      width: '100%',
      display: 'table',
      borderCollapse: 'separate',
      borderSpacing: 0,
      border: "1px solid ".concat(fwdColors.grey),
      overflow: 'hidden',
      '& tr': {
        color: fwdColors.grey,
        background: fwdColors.white,
        '&.header': {
          background: fwdColors.grey,
          color: fwdColors.white,
          '& .inner': (_inner = {
            padding: theme.spacing(1, 2)
          }, _defineProperty(_inner, theme.breakpoints.up('sm'), {
            padding: theme.spacing(2, 3)
          }), _defineProperty(_inner, '&:before,&:after', {
            backgroundColor: fwdColors.white
          }), _defineProperty(_inner, '&:before', {
            display: 'none'
          }), _defineProperty(_inner, '&:after', _defineProperty({
            top: theme.spacing(1),
            height: "calc(100% - ".concat(theme.spacing(2), "px)")
          }, theme.breakpoints.up('sm'), {
            top: theme.spacing(2),
            height: "calc(100% - ".concat(theme.spacing(4), "px)")
          })), _inner)
        },
        '&:last-child': {
          '& .inner': {
            '&:before': {
              display: 'none'
            }
          }
        }
      },
      '& td': {
        border: 0,
        padding: 0,
        position: 'relative',
        '& .inner': (_inner2 = {
          padding: theme.spacing(2)
        }, _defineProperty(_inner2, theme.breakpoints.up('sm'), {
          padding: theme.spacing(2, 3)
        }), _defineProperty(_inner2, '&:before,&:after', {
          position: 'absolute',
          content: 'close-quote',
          backgroundColor: fwdColors.grey
        }), _defineProperty(_inner2, '&:before', {
          width: '100%',
          height: '1px',
          bottom: 0,
          left: 0
        }), _defineProperty(_inner2, '&:after', _defineProperty({
          width: '1px',
          height: "calc(100% - ".concat(theme.spacing(4), "px)"),
          right: 0,
          top: theme.spacing(2)
        }, theme.breakpoints.up('sm'), {
          top: theme.spacing(2),
          height: "calc(100% - ".concat(theme.spacing(4), "px)")
        })), _inner2),
        '&:first-child': {
          '& .inner': {
            '&:before': _defineProperty({}, theme.breakpoints.up('sm'), {
              width: "calc(100% - ".concat(theme.spacing(3), "px)"),
              left: theme.spacing(3)
            })
          }
        },
        '&:last-child': {
          '& .inner': {
            '&:before': _defineProperty({}, theme.breakpoints.up('sm'), {
              width: "calc(100% - ".concat(theme.spacing(3), "px)")
            }),
            '&:after': {
              display: 'none'
            }
          }
        }
      }
    }
  };
};

var useStyles$9 = makeStyles(styles$6);

var TableSkeleton = function TableSkeleton(props) {
  var _props$numOfRows = props.numOfRows,
      numOfRows = _props$numOfRows === void 0 ? 7 : _props$numOfRows,
      _props$columns = props.columns,
      columns = _props$columns === void 0 ? '100' : _props$columns;
  var classes = useStyles$9();

  var rowsArr = _toConsumableArray(Array(numOfRows).keys());

  var columnsPercArr = columns.split(',').map(Number);
  var largestColumn = Math.max.apply(Math, _toConsumableArray(columnsPercArr)); // state

  var isMobileWidth = useMediaQuery("(max-width:".concat(breakpoints.values.sm, "px)"));
  return /*#__PURE__*/React__default.createElement("table", {
    "data-locator": props['data-locator'],
    className: clsx(classes.root, getBorderRadius('medium'))
  }, rowsArr.map(function (rowIndex) {
    return /*#__PURE__*/React__default.createElement("tr", {
      key: "table-skeleton-".concat(rowIndex),
      className: rowIndex ? '' : 'header'
    }, (isMobileWidth ? [60, 40] : columnsPercArr).map(function (columnPerc, columnPercIndex) {
      return /*#__PURE__*/React__default.createElement("td", {
        width: "".concat(columnPerc, "%"),
        key: "table-skeleton-".concat(rowIndex, "-").concat(columnPercIndex)
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "inner"
      }, /*#__PURE__*/React__default.createElement(Skeleton$1, {
        variant: "rect",
        height: 20,
        width: rowIndex ? isMobileWidth ? '70%' : largestColumn === columnPerc ? '70%' : '20%' : '100%',
        animation: "wave",
        color: rowIndex ? undefined : 'white'
      })));
    }));
  }));
};

/**
 * On the basis of type different skeleton body is returned
 */

var SkeletonView = function SkeletonView(props) {
  var locator = "".concat(props.type, "-skeleton-wrapper");

  switch (props.type) {
    case 'SearchCard':
      return /*#__PURE__*/React__default.createElement(SearchCardSkeleton, _extends({
        count: props.count,
        "data-locator": locator
      }, props));

    case 'DynamicCardList':
      return /*#__PURE__*/React__default.createElement(DynamicCardListSkeleton, _extends({
        count: props.count,
        "data-locator": locator
      }, props));

    case 'ProductCardList':
      return /*#__PURE__*/React__default.createElement(ProductCardListSkeleton, _extends({
        count: props.count,
        "data-locator": locator
      }, props));

    case 'RelatedArticlesList':
      return /*#__PURE__*/React__default.createElement(RelatedArticlesListsSkeleton, _extends({
        count: props.count,
        variant: props.variant,
        "data-locator": locator
      }, props));

    case 'RelatedProductList':
      return /*#__PURE__*/React__default.createElement(RelatedProductsListSkeleton, _extends({
        count: props.count,
        "data-locator": locator
      }, props));

    case 'DynamicTagList':
      return /*#__PURE__*/React__default.createElement(DynamicTagListSkeleton, _extends({
        count: props.count,
        "data-locator": locator
      }, props));

    case 'MapCardSkeleton':
      return /*#__PURE__*/React__default.createElement(MapCardSkeleton, _extends({
        count: props.count,
        "data-locator": locator
      }, props));

    case 'ArticleSubtypeGridView':
      return /*#__PURE__*/React__default.createElement(ArticleSubtypeGridView, _extends({
        count: props.count,
        "data-locator": locator,
        designVariation: props.designVariation,
        hasDate: props.hasDate
      }, props));

    case 'ArticleSubtypeListView':
      return /*#__PURE__*/React__default.createElement(ArticleSubtypeListView, _extends({
        count: props.count,
        "data-locator": locator,
        designVariation: props.designVariation,
        hasDate: props.hasDate,
        hasImage: props.hasImage
      }, props));

    case 'TableSkeleton':
      return /*#__PURE__*/React__default.createElement(TableSkeleton, _extends({
        "data-locator": locator
      }, props));
  }
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$5 = function styles(theme) {
  return {
    tagItem: {
      display: 'inline-block',
      padding: theme.spacing(0.5, 2),
      marginRight: theme.spacing(1),
      //IMP: This has an impact on Filter By Carousel behaviour: setShowCarousel1
      cursor: 'pointer',
      backgroundColor: 'transparent',
      whiteSpace: 'nowrap',
      '&.active': {
        color: theme.palette.colors.white.main
      }
    }
  };
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var useStyles$8 = makeStyles(styles$5);

var FilterTag = function FilterTag(props) {
  var classes = useStyles$8();
  var tagState = props.isActive ? true : false;
  var tagName = props.tag ? props.tag : '';
  var className = props.className || '';
  return /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body1",
    component: "span",
    "data-locator": props.dataLocator,
    className: clsx("chipColor-".concat(props.color), getBorderRadius('small'), classes.tagItem, tagState && 'active', 'motionColorTransition', className),
    onClick: props.onClick
  }, tagName);
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$4 = function styles(theme) {
  return {
    root: {
      maxWidth: theme.spacing(62),
      backgroundColor: fwdColors.redLight,
      padding: theme.spacing(2),
      display: 'inline-flex',
      flexDirection: 'row',
      margin: '0 auto',
      '& svg': {
        marginTop: '3px'
      }
    },
    content: {
      flexGrow: 1,
      paddingLeft: theme.spacing(0.5),
      color: fwdColors.red,
      '& a': {
        color: fwdColors.red,
        fontWeight: 'bold'
      }
    }
  };
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var API_ERROR = 'Api-Error';

var useStyles$7 = makeStyles(styles$4);
/**
 * To display the API related errors using FieldMessage atom. Uses are such as displaying errors on form submit actions
 * @param {string} title - The error message to be displayed
 * @param {string} error - Api error status
 * @param {string} type - Provides formtype for FieldMessage
 */

var ApiError = function ApiError(props) {
  var classes = useStyles$7(); // const { t } = useTranslation();

  var dictionary = {
    apiErrorMessage: "Sorry, we’ve encountered an error when loading this content. Please refresh this page or try again later."
  };

  var t = function t(key) {
    return dictionary[key];
  };

  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: clsx(classes.root, "allBorderRadiusMedium")
  }, props), /*#__PURE__*/React__default.createElement(NamedIcon$1, {
    icon: "warning"
  }), /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "body3",
    component: "div",
    "data-locator": API_ERROR,
    color: props.bgColor,
    className: classes.content
  }, t("apiErrorMessage")));
};

var _this = undefined;
/**
 * get cached language attribute
 * // TODO probably we can take this to locator-Utils file later and write test cases
 */

var getLanguageObject = function getLanguageObject(t) {
  var language = {};

  if (t) {
    language["pleaseselectfacilitytype"] = t("pleaseselectfacilitytype");
    language["filterby"] = t("filterby");
    language["plantype"] = t("plantype");
    language["hospitalServiceMsg"] = t("hospital-service-message");
    language["province"] = t("province");
    return language;
  } else {
    return null;
  }
};
var Locator$1 = function Locator(props) {
  var flexiCol = parseInt(props.flexiCol) || null;
  var color = props.params && props.params.backgroundColor || "white-white";

  var _getColors = getColors(color),
      bgColor = _getColors.bgColor,
      surfaceColor = _getColors.surfaceColor;

  var _ref = props.fields || {},
      apiContentType = _ref.apiContentType,
      apiSortBy = _ref.apiSortBy;

  var _get = get$1(apiContentType, "fields", {}),
      key = _get.key,
      value = _get.value;

  var pageLanguage = get$1(props, "sitecoreContext.language", "en");
  var apiUrl = get$1(value, "value", "").replace("{language}", pageLanguage);
  var classes = locatorStyles({
    pageLanguage: pageLanguage
  });
  var authorizationKey = get$1(key, "value", "");
  var locatorType = get$1(props, "fields.locatorType", []);
  var apiConfig = get$1(props, "fields.api", []);
  var locationType = get$1(props, "sitecoreContext.site.name", "fwd-th");
  var pageSizeOnDesktop = get$1(props, "fields.apiPageSize.value", 40) || 40;
  var pageSizeOnMobile = get$1(props, "fields.apiMobilePageSize.value", 3) || 3;
  var dataLayerFilter = [];
  var params = props.params ? props.params : {};
  var dividerLine = params.divider ? params.divider : "0";
  var gaCategoryName = get$1(props, "fields.gaCategoryName.value", "");
  apiConfig.filter(function (config) {
    return get$1(config, "fields.key.value", "") === "google-map-api";
  });

  var _ref2 = props.mapData || {
    error: null
  },
      error = _ref2.error; // switch to local development key if local environment is detected.


  var GOOGLE_MAP_API_KEY = get$1(apiConfig[0], "fields.value.value", ""); // refs

  var filterByWrapperRef = /*#__PURE__*/createRef();
  var isMobileWidth = useMediaQuery("(max-width:".concat(breakpoints.values.md, "px)"));
  var pageSize = isMobileWidth ? pageSizeOnMobile : pageSizeOnDesktop;
  var facilityType = locatorType && locatorType.map(function (item) {
    return {
      name: get$1(item, "fields.locatorLabel.value", "")
    };
  }); // const { t } = useTranslation();

  var dictionary = get$1(props, "dictionary", {
    hideContact: "Hide contact",
    seeContact: "See contact",
    pleaseselectfacilitytype: "Select facility",
    filterby: "Filter by",
    plantype: "Plan Type",
    "hospital-service-message": "Certain services are only available for {planType} plan type i.e. {services}",
    province: "Province"
  });

  var t = function t(key) {
    return dictionary[key];
  };

  var language = getLanguageObject(t);

  var _locatorComponentUtil = handleQueryParameter(locatorType),
      queryProvince = _locatorComponentUtil.queryProvince,
      queryLatitude = _locatorComponentUtil.queryLatitude,
      queryLongitude = _locatorComponentUtil.queryLongitude,
      queryFacilityTypes = _locatorComponentUtil.queryFacilityTypes;

  var _useState = useState(language.pleaseselectfacilitytype),
      _useState2 = _slicedToArray(_useState, 2),
      currFacility = _useState2[0],
      setCurrFacility = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      currFacilityGaLabel = _useState4[0],
      setCurrFacilityGaLabel = _useState4[1];

  var _useState5 = useState(queryProvince[0] ? queryProvince[0] : {}),
      _useState6 = _slicedToArray(_useState5, 2),
      currProvice = _useState6[0],
      setCurrProvince = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      currPlanType = _useState8[0],
      setCurrPlanType = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      currPrimaryLocationFilter = _useState10[0],
      setCurrPrimaryLocationFilter = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      currFacetType = _useState12[0],
      setCurrFacetType = _useState12[1];

  var _useState13 = useState(queryLatitude ? queryLatitude : ""),
      _useState14 = _slicedToArray(_useState13, 2),
      latitude = _useState14[0],
      setLatitude = _useState14[1];

  var _useState15 = useState(queryLongitude ? queryLongitude : ""),
      _useState16 = _slicedToArray(_useState15, 2),
      longitude = _useState16[0],
      setLongitude = _useState16[1];

  var _useState17 = useState(null),
      _useState18 = _slicedToArray(_useState17, 2),
      currMap = _useState18[0],
      setCurrMap = _useState18[1];

  var _useState19 = useState([]),
      _useState20 = _slicedToArray(_useState19, 2),
      currMarkers = _useState20[0],
      setCurrMarkers = _useState20[1];

  var _useState21 = useState([]),
      _useState22 = _slicedToArray(_useState21, 2),
      infoWindowMap = _useState22[0],
      setInfoWindowMap = _useState22[1];

  var _useState23 = useState([]),
      _useState24 = _slicedToArray(_useState23, 2),
      currSelectedFilter = _useState24[0],
      setCurrSelectedValues = _useState24[1];

  var _useState25 = useState(null),
      _useState26 = _slicedToArray(_useState25, 2),
      currLocator = _useState26[0],
      setCurrLocator = _useState26[1];

  var _useState27 = useState(1),
      _useState28 = _slicedToArray(_useState27, 2),
      currentPageNumber = _useState28[0],
      setCurrentPageNumber = _useState28[1];

  var _useState29 = useState({}),
      _useState30 = _slicedToArray(_useState29, 2),
      secondaryFacets = _useState30[0],
      setSecondaryFacets = _useState30[1];

  var _useState31 = useState(false),
      _useState32 = _slicedToArray(_useState31, 2),
      fromMapFlag = _useState32[0],
      setFromMapFlag = _useState32[1];

  var _useState33 = useState(true),
      _useState34 = _slicedToArray(_useState33, 2),
      showCarousel1 = _useState34[0],
      setShowCarousel1 = _useState34[1];

  var _useState35 = useState(true),
      _useState36 = _slicedToArray(_useState35, 2),
      showCarousel2 = _useState36[0],
      setShowCarousel2 = _useState36[1];

  var _useState37 = useState([]),
      _useState38 = _slicedToArray(_useState37, 2),
      distinctServiceMsg = _useState38[0],
      setDistinctServiceMsg = _useState38[1];

  var _useState39 = useState("100%"),
      _useState40 = _slicedToArray(_useState39, 2),
      facetWidth = _useState40[0],
      setFacetWidth = _useState40[1];

  var _useState41 = useState(true),
      _useState42 = _slicedToArray(_useState41, 2),
      enableApiCall = _useState42[0],
      setEnableApiCall = _useState42[1];

  var _useState43 = useState(true),
      _useState44 = _slicedToArray(_useState43, 2),
      updateFacets = _useState44[0],
      setUpdateFacets = _useState44[1];

  var _useState45 = useState(""),
      _useState46 = _slicedToArray(_useState45, 2),
      highlighCard = _useState46[0],
      setHighlighCard = _useState46[1];

  var _useState47 = useState("100%"),
      _useState48 = _slicedToArray(_useState47, 2),
      secondaryFacetWidth = _useState48[0],
      setSecondaryFacetWidth = _useState48[1];

  var _useState49 = useState(false),
      _useState50 = _slicedToArray(_useState49, 2),
      mapFirstCard = _useState50[0],
      setMapFirstCard = _useState50[1];

  var _useState51 = useState(""),
      _useState52 = _slicedToArray(_useState51, 2),
      carousel1Key = _useState52[0],
      setCarousel1Key = _useState52[1];

  var _useState53 = useState(""),
      _useState54 = _slicedToArray(_useState53, 2),
      carousel2Key = _useState54[0],
      setCarousel2Key = _useState54[1];

  var _useState55 = useState(false),
      _useState56 = _slicedToArray(_useState55, 2),
      isMapDataLoading = _useState56[0],
      setMapDataLoading = _useState56[1];

  var _useState57 = useState(false),
      _useState58 = _slicedToArray(_useState57, 2),
      isFacetReset = _useState58[0],
      setIsFacetReset = _useState58[1];

  var _useState59 = useState(false),
      _useState60 = _slicedToArray(_useState59, 2),
      hideFilters = _useState60[0],
      setHideFilters = _useState60[1];

  var _useState61 = useState(false),
      _useState62 = _slicedToArray(_useState61, 2),
      hideChipFilters = _useState62[0],
      setHideChipFilters = _useState62[1];

  useEffect(function () {
    setCurrGeoLocation();
  }, []);
  useEffect(function () {
    var wrapper = document.querySelector('[data-locator="MAPS_PROVINCE_SIDE_WRAPPER"]');
    var planTypeWrapper = document.querySelector('[data-locator="MAPS_PLAN_TYPE_WRAPPER"]');
    var planTypeID = document.getElementById("planType-js");
    var filterByID = document.getElementById("filterBy-js");
    var planTypeSlider = document.getElementById("planTypeSider-js");
    var filterBySlider = document.getElementById("filterBySider-js");
    var planTypeChipsWidth = 0;
    var filterByChipsWidth = 0;
    planTypeChipsWidth = planTypeSlider && calculateChipsWidth(planTypeSlider);
    filterByChipsWidth = filterBySlider && calculateChipsWidth(filterBySlider);

    if (!isMobileWidth) {
      if (planTypeSlider && planTypeID && planTypeChipsWidth + planTypeID.offsetWidth > wrapper.offsetWidth / 2 && get$1(secondaryFacets["locationfacilitiesfield_sm"], "length", 0) !== 0) {
        planTypeWrapper.style.width = "".concat(wrapper.offsetWidth / 2, "px");
        setFacetWidth(calculateChipsContainerWidth(wrapper, planTypeID, 24));
        setShowCarousel2(true);

        if (filterBySlider && filterByID && filterByChipsWidth + filterByID.offsetWidth > wrapper.offsetWidth / 2) {
          setSecondaryFacetWidth(calculateChipsContainerWidth(wrapper, filterByID, 8));
          setShowCarousel1(true);
        } else setShowCarousel1(false);
      } else {
        if (planTypeSlider && planTypeID) {
          // This is for full width scenario when secondary filters are null however Plan Type Slider is present in DOM
          if (get$1(secondaryFacets["locationfacilitiesfield_sm"], "length", 0) === 0) {
            planTypeWrapper.style.width = "".concat(wrapper.offsetWidth, "px");
            setFacetWidth(wrapper.offsetWidth);
            setShowCarousel2(false);
          } else {
            planTypeWrapper.style.width = "".concat(planTypeChipsWidth + planTypeID.offsetWidth + 24, "px");

            if (planTypeChipsWidth + planTypeID.offsetWidth + 24 > wrapper.offsetWidth / 2) {
              setFacetWidth("".concat(wrapper.offsetWidth / 2, "px"));
              setShowCarousel2(true);
              setSecondaryFacetWidth("".concat(wrapper.offsetWidth / 2, "px"));

              if (filterBySlider && filterByID && filterByChipsWidth + filterByID.offsetWidth + 24 > wrapper.offsetWidth / 2) {
                setShowCarousel1(true);
              } else {
                setShowCarousel1(false);
              }
            } else {
              setFacetWidth("".concat(planTypeChipsWidth + planTypeID.offsetWidth + 24, "px"));
              setShowCarousel2(false);
              filterBySlider && filterByID && setSecondaryFacetWidth("".concat(wrapper.offsetWidth - planTypeChipsWidth - planTypeID.offsetWidth - filterByID.offsetWidth - 24 - 8, "px"));

              if (filterBySlider && filterByID && filterByChipsWidth + filterByID.offsetWidth + 24 > wrapper.offsetWidth - planTypeChipsWidth - planTypeID.offsetWidth) {
                setShowCarousel1(true);
              } else {
                setShowCarousel1(false);
              }
            }
          }
        }
      }
    } else {
      if (planTypeWrapper && filterByChipsWidth && filterByChipsWidth > planTypeWrapper.offsetWidth) {
        setSecondaryFacetWidth("100%");
        setShowCarousel1(true);
      } else setSecondaryFacetWidth("100%");

      if (planTypeWrapper && planTypeChipsWidth && planTypeChipsWidth > planTypeWrapper.offsetWidth) {
        setShowCarousel2(true);
        setFacetWidth("100%");
      } else setFacetWidth("100%");
    }
  }, [secondaryFacets, currFacility, isMobileWidth]);

  var callAPI = function callAPI(selectedType, currFilters) {
    if (selectedType[0] || currFilters[0]) {
      setMapDataLoading(true);
    }

    get$1(currLocator, "fields", null) && props.setMapListFilter({
      province: currProvice ? get$1(currProvice, "fields.name.value", "") : get$1(currLocator, "fields.defaultProvince.fields.name.value", ""),
      facilitytype: currPlanType.length ? currPlanType : [selectedType.map(function (e) {
        return e.key;
      }).join("|")],
      filters: currFilters,
      PageNumber: currentPageNumber,
      apiUrl: apiUrl,
      authorizationKey: authorizationKey,
      locationType: locationType,
      pageSize: pageSize,
      longitude: longitude,
      latitude: latitude,
      facet: currFacetType,
      sortby: latitude || longitude ? null : get$1(apiSortBy, "fields.value.value", null),
      changeFacets: updateFacets
    });
  };

  useEffect(function () {
    /*currMarkers.forEach(mark => {
      mark.setMap(null);
    });*/
    if (currFacility !== language.pleaseselectfacilitytype) {
      var curfacilityType = get$1(currLocator, "fields", {});
      var selectedType = get$1(curfacilityType, "primaryLocatorFilter", []).map(function (type) {
        return {
          key: type.fields.name.value,
          facet: get$1(type.fields, "filterBy.fields.key.value", null)
        };
      });
      setCurrPrimaryLocationFilter(selectedType);
      dataLayerFilter = [];
      dataLayerFilter = dataLayerFilter.concat(currPlanType);
      dataLayerFilter = dataLayerFilter.concat(currSelectedFilter);
      !isEmpty(dataLayerFilter) && PushEvent({
        filters_selected: dataLayerFilter
      });
      enableApiCall && callAPI(selectedType, currSelectedFilter);
    }
  }, [currentPageNumber, currSelectedFilter]);
  useEffect(function () {
    if (currFacility !== language.pleaseselectfacilitytype) {
      var curfacilityType = get$1(currLocator, "fields", {});
      var selectedType = get$1(curfacilityType, "primaryLocatorFilter", []).map(function (type) {
        return {
          key: type.fields.name.value,
          facet: get$1(type.fields, "filterBy.fields.key.value", null)
        };
      });
      setCurrPrimaryLocationFilter(selectedType);
      callAPI(selectedType, []);
    }
  }, [currPlanType, currFacility]);
  useEffect(function () {
    var cardsList = props.mapData && props.mapData.mapCardList || [];
    setMapDataLoading(false);

    if (currMap && cardsList.length && currFacility !== language.pleaseselectfacilitytype) {
      currMarkers.map(function (item) {
        return item.setMap(null);
      });

      var _createMarkers = createMarkers(cardsList, currMap, onMapCardClick.bind(_this)),
          infoMap = _createMarkers.infoMap,
          markers = _createMarkers.markers;

      setInfoWindowMap(infoMap);
      setCurrMarkers(markers);
      typeof window !== "undefined" && get$1(window, "google.maps.event.addListener", function () {})(currMap, "click", function () {
        setHighlighCard("");
        isMobileWidth ? setFromMapFlag(true) : setFromMapFlag(false);
      });
    }
  }, [props.mapData && props.mapData.mapCardList, currMap, isMobileWidth]);
  useEffect(function () {
    if (get$1(props, "mapData.mapCardList", []).length > 0) if (latitude && longitude) {
      onMapCardClick(props.mapData.mapCardList[0], false);
      setHighlighCard(props.mapData.mapCardList[0].id);
    }
  }, [infoWindowMap]);
  /**
   * This effect creates map instance on each map card list change
   * TODO : do we really need to create new instance on each data change? - probably we can avoid it.
   */

  useLayoutEffect(function () {
    if (!error && locatorType.length) {
      var showCurrLocation = props.mapData.mapCardList && props.mapData.mapCardList.length === 0 ? false : true;

      if (!get$1(currProvice, "fields.latitude") && !get$1(currProvice, "fields.longitude")) {
        loadMapScripts(setCurrMap, get$1(locatorType[0], "fields.defaultProvince"), GOOGLE_MAP_API_KEY, showCurrLocation, t, props.mapData && props.mapData.mapCardList || [], pageLanguage);
      } else {
        loadMapScripts(setCurrMap, currProvice, GOOGLE_MAP_API_KEY, showCurrLocation, t, props.mapData && props.mapData.mapCardList || [], pageLanguage);
      }

      setIsFacetReset(false);
    }
  }, [props.mapData && props.mapData.mapCardList, isMobileWidth]); // To handle Language Switching scenario and the else part is also being used for /branch-locator and /hospital-locator page

  useLayoutEffect(function () {
    if (locatorType.length > 1) {
      setCurrFacility(language.pleaseselectfacilitytype);
      setCurrFacilityGaLabel(null);
      setCurrLocator(null);
      setCurrProvince(get$1(locatorType[0], "fields.defaultProvince", {}));
    } else if (locatorType.length === 1) {
      setUpdateFacets(true);
      setCurrLocator(locatorType[0]);
      queryProvince[0] ? setCurrProvince(queryProvince[0]) : setCurrProvince(get$1(locatorType[0], "fields.defaultProvince", {}));
      setCurrFacility(get$1(locatorType[0], "fields.locatorLabel.value", ""));
      setCurrFacilityGaLabel(get$1(locatorType[0], "fields.gaLabelName.value", "") || get$1(locatorType[0], "fields.locatorKey.value", ""));
      setCurrPlanType(queryFacilityTypes ? queryFacilityTypes : []);
      setHideFilters(get$1(locatorType[0], "fields.disableSearchFilters.value", false));
      setHideChipFilters(get$1(locatorType[0], "fields.disableChipsFilters.value", false));
    }
  }, [locatorType]);
  useEffect(function () {
    if (props.mapData && props.mapData.facetResult && props.mapData.facetResult["locationfacilitiesfield_sm"]) {
      // To block setting secondary filters while we are not updating the facet list from Redux store
      if (updateFacets) {
        setSecondaryFacets(props.mapData.facetResult);
      }
    }
  }, [props.mapData && props.mapData.facetResult, currPlanType]);
  useEffect(function () {
    var selectedFilters = [];
    props.mapData && props.mapData.facetResult && props.mapData.facetResult["locationfacilitiesfield_sm"].map(function (filter) {
      return currSelectedFilter.includes(filter.value) && selectedFilters.push(filter.value);
    });
    selectedFilters.length && setUpdateFacets(false);
    selectedFilters.length === 0 ? setEnableApiCall(false) : setEnableApiCall(true);
    setCurrSelectedValues(selectedFilters);
  }, [secondaryFacets]);

  var seeMoreClickHandler = function seeMoreClickHandler() {
    var nextPageNumber = currentPageNumber + 1;
    setEnableApiCall(true);
    setHighlighCard("");
    setCurrentPageNumber(nextPageNumber);
  };

  var resetSelections = function resetSelections() {
    setCurrFacetType(null);
    setIsFacetReset(true);
    setSecondaryFacets({});
    setUpdateFacets(true);
    setCurrPlanType([]);
    setCurrSelectedValues([]);
    resetLatLong();
  };

  var resetLatLong = function resetLatLong() {
    if (latitude) setLatitude("");
    if (longitude) setLongitude("");
    setHighlighCard("");
    setFromMapFlag(false);
    setCurrentPageNumber(1);
  };

  var setCurrSelectedFilter = function setCurrSelectedFilter(filterVal) {
    resetLatLong();

    var selectedFilters = _toConsumableArray(currSelectedFilter);

    if (selectedFilters.includes(filterVal)) {
      selectedFilters.splice(selectedFilters.indexOf(filterVal), 1);
    } else {
      selectedFilters.push(filterVal);
    }

    setEnableApiCall(true);
    selectedFilters.length === 0 ? setUpdateFacets(true) : setUpdateFacets(false);
    setCurrSelectedValues(selectedFilters);
  };

  var setPlanType = function setPlanType(planType) {
    setUpdateFacets(updateFacets ? updateFacets : !updateFacets);
    resetLatLong();

    var selectedPlans = _toConsumableArray(currPlanType);

    if (selectedPlans.includes(planType)) {
      selectedPlans = selectedPlans.filter(function (item) {
        return item !== planType;
      });
    } else {
      selectedPlans.push(planType);
    }

    if (selectedPlans.length === 1) {
      setCurrFacetType(currPrimaryLocationFilter.filter(function (item) {
        return item.key === selectedPlans[0];
      })[0].facet);
    } else {
      setCurrFacetType(null);
    }

    setEnableApiCall(true);
    setCarousel1Key(Date.now());
    setCurrPlanType(selectedPlans);
  };

  var handleFacilityChange = function handleFacilityChange(facilityVal) {
    if (facilityVal !== language.pleaseselectfacilitytype) {
      resetSelections();
      setCurrFacility(facilityVal);
      var locator = locatorType.find(function (el) {
        el.fields.locatorLabel.value === facilityVal && setCurrFacilityGaLabel(get$1(el, "fields.gaLabelName.value", "") || get$1(el, "fields.locatorKey.value", ""));
        return el.fields.locatorLabel.value === facilityVal;
      });

      if (!locator) {
        return;
      }

      setHideFilters(get$1(locator, "fields.disableSearchFilters.value", false));
      setHideChipFilters(get$1(locator, "fields.disableChipsFilters.value", false));
      setCurrLocator(locator);
      setCurrProvince(get$1(locator, "fields.defaultProvince", {}));
      setCarousel1Key(Date.now());
      setCarousel2Key(Date.now());
    }
  };

  var onMapCardClick = useCallback(function (card, fromMap) {
    var mapCardElem = document.getElementById("mapCardsList");
    var cardElem = document.getElementById(card.id);
    setHighlighCard(card.id);

    if (cardElem && mapCardElem) {
      if (fromMap) {
        PushEvent({
          event: "mapPinClick",
          location_name: get$1(card, "name", ""),
          buttonTitle: get$1(card, "gaLabelName", "") || getGTMSharedKeyVal(undefined, MAPS_ITEM_CARD),
          type: currFacility
        });
        setFromMapFlag(true);

        if (isMobileWidth) {
          setMapFirstCard(true);
        } else {
          setMapFirstCard(false); // To move the card in the viewport on selection of any map pin

          mapCardElem.scrollTop = cardElem.offsetTop - mapCardElem.offsetTop - 2; // substracted 2 for border width
        }
      } else {
        mapCardElem.scrollTop = cardElem.offsetTop - mapCardElem.offsetTop;
        setMapFirstCard(false);
        setFromMapFlag(false);
      }
    }

    if (currMap && !fromMap) {
      for (var infoKey in infoWindowMap) {
        if (infoWindowMap[infoKey] && infoWindowMap[infoKey].infowindow) {
          var el = infoWindowMap[infoKey];
          el.infowindow.close();
          el.marker.setIcon(getBrowserIcon("marker"));
        }
      }

      infoWindowMap[card.id].infowindow.open(currMap, infoWindowMap[card.id].marker);
      infoWindowMap[card.id].marker.setIcon(getBrowserIcon("marker_hover"));
      currMap.setZoom(14);
      currMap.setCenter(new window.google.maps.LatLng(parseFloat(card.latitude), parseFloat(card.longitude)));
      typeof window !== "undefined" && get$1(window, "google.maps.event.addListener", function () {})(currMap, "click", function () {
        setHighlighCard("");
        setFromMapFlag(true);
        infoWindowMap[card.id].marker.setIcon(getBrowserIcon("marker"));
        infoWindowMap[card.id].infowindow.close();
      });
    }
  }, [isMobileWidth, infoWindowMap, currMap]);

  var handleProvinceChange = function handleProvinceChange(newProv) {
    resetSelections();

    if (newProv) {
      var provinceList = _toConsumableArray(currLocator.fields.provinceList);

      var currProv = provinceList.filter(function (item) {
        return item.fields.name.value === newProv.trim();
      })[0];

      if (currProv) {
        var pos = {
          lat: parseFloat(currProv.fields.latitude.value),
          lng: parseFloat(currProv.fields.longitude.value)
        };
        currMap.setCenter(pos);
        setCurrProvince(currProv);
        setCarousel1Key(Date.now());
        setCarousel2Key(Date.now());
      }

      PushEvent({
        event: "dropdownChange",
        buttonTitle: get$1(currProv, "fields.searchName.value", "") || getGTMSharedKeyVal(undefined, MAPS_PROVINCE_TYPE),
        componentName: isEmpty(gaCategoryName) ? MAPS_PROVINCE_TYPE : gaCategoryName,
        destinationUrl: undefined
      });
    } else {
      setCurrProvince({
        fields: {
          name: ""
        }
      });
      var _pos = {
        lat: parseFloat(get$1(locatorType[0], "fields.defaultProvince.fields.latitude.value", "")),
        lng: parseFloat(get$1(locatorType[0], "fields.defaultProvince.fields.longitude.value", ""))
      };
      currMap.setCenter(_pos);
    }
  };

  useEffect(function () {
    var distinctMsgList = [];

    if (get$1(currLocator, "fields.individualServices", []).length || get$1(currLocator, "fields.groupServices", []).length) {
      var individualServices = [],
          groupServices = [];
      individualServices = generateDistinctMsg(currLocator, currSelectedFilter, "individualServices", isMobileWidth, language.hospitalServiceMsg);
      groupServices = generateDistinctMsg(currLocator, currSelectedFilter, "groupServices", isMobileWidth, language.hospitalServiceMsg);
      individualServices && distinctMsgList.push(individualServices);
      groupServices && distinctMsgList.push(groupServices);
      setDistinctServiceMsg(distinctMsgList);
    } else setDistinctServiceMsg([]);
  }, [currSelectedFilter, isMobileWidth]);

  var setPrimaryFilters = function setPrimaryFilters() {
    return get$1(currLocator, "fields.primaryLocatorFilter", []).map(function (item, index) {
      return /*#__PURE__*/React__default.createElement(FilterTag, {
        tag: item.fields.name.value,
        color: surfaceColor,
        isActive: currPlanType && currPlanType.includes(item.fields.name.value),
        classes: classes,
        dataLocator: MAPS_PLAN_TYPE,
        key: item.fields.name.value,
        onClick: function onClick() {
          PushEvent({
            event: "buttonClick",
            buttonTitle: get$1(item, "fields.searchName.value", "") || getGTMSharedKeyVal(undefined, MAPS_PLAN_TYPE),
            componentName: isEmpty(gaCategoryName) ? MAPS_PLAN_TYPE : gaCategoryName,
            destinationUrl: undefined,
            position: index + 1
          });
          setPlanType(item.fields.name.value);
          setCurrentPageNumber(1);
        }
      });
    });
  };

  var distinctMsgHTML = function distinctMsgHTML() {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InfoFilled, null), /*#__PURE__*/React__default.createElement("div", null, distinctServiceMsg.map(function (msg, index) {
      return /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
        mb: 0,
        key: index,
        component: "p",
        variant: "h10",
        color: surfaceColor,
        type: "caption",
        className: classes.normalFontWeight
      }, msg);
    })));
  };

  var renderFilterTags = function renderFilterTags(chipItem, index) {
    return /*#__PURE__*/React__default.createElement(FilterTag, {
      key: index,
      tag: chipItem.value,
      color: surfaceColor,
      isActive: currSelectedFilter && currSelectedFilter.includes(chipItem.value),
      classes: classes,
      dataLocator: MAPS_FACET_CHIP,
      onClick: function onClick() {
        PushEvent({
          event: "buttonClick",
          buttonTitle: get$1(chipItem, "searchName", "") || getGTMSharedKeyVal(undefined, MAPS_FACET_CHIP),
          componentName: isEmpty(gaCategoryName) ? MAPS_FACET_CHIP : gaCategoryName,
          destinationUrl: undefined,
          position: index + 1
        });
        setCurrSelectedFilter(chipItem.value);
        setCurrentPageNumber(1);
      }
    });
  };

  var sliderCheck = function sliderCheck() {
    return secondaryFacets["locationfacilitiesfield_sm"].map(renderFilterTags);
  };

  return /*#__PURE__*/React__default.createElement(Container$1, {
    useContainer: !flexiCol,
    className: clsx(classes.mapContainer, getPaddingString(params), isMobileWidth && currFacility === language.pleaseselectfacilitytype && classes.hidePaddingBottom, dividerLine === "1" ? "component-divider-".concat(bgColor) : "", {
      error: error
    }),
    background: bgColor,
    sectionId: "locatorComponentSection"
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true
  }, locatorType.length > 1 ? /*#__PURE__*/React__default.createElement(StyledGrid, {
    xs: 12,
    md: 6,
    className: classes.dropdownWrapper
  }, /*#__PURE__*/React__default.createElement(Dropdown$1, {
    value: currFacility,
    onChange: function onChange(e) {
      var GTMSharedKey = "";
      locatorType.forEach(function (item) {
        if (get$1(item, "fields.locatorLabel.value", "") === e.target.value) {
          GTMSharedKey = get$1(item, "fields.gaLabelName.value", "");
        }
      });
      PushEvent({
        event: "dropdownChange",
        buttonTitle: GTMSharedKey || getGTMSharedKeyVal(undefined, MAPS_FACILITY_TYPE),
        componentName: isEmpty(gaCategoryName) ? MAPS_FACILITY_TYPE : gaCategoryName,
        destinationUrl: undefined
      });
      handleFacilityChange(e.target.value);
    },
    "data-locator": MAPS_FACILITY_TYPE,
    className: clsx(classes.dropdown, classes["svg-color-".concat(surfaceColor)], _defineProperty({}, classes["facility-dropdown-".concat(surfaceColor)], surfaceColor !== "initial")),
    disablePortal: true
  }, /*#__PURE__*/React__default.createElement(MenuItem, {
    value: language.pleaseselectfacilitytype,
    className: classes.hide,
    disabled: true
  }, /*#__PURE__*/React__default.createElement("span", {
    className: classes["placeholderColor-".concat(surfaceColor)]
  }, language.pleaseselectfacilitytype)), facilityType.length && facilityType.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(MenuItem, {
      key: index,
      value: item.name,
      "data-locator": MAPS_FACILITY_TYPE_DD_LIST_ITEM,
      className: clsx("icon-action-dropDown-".concat(surfaceColor), "showTickIcon", classes.selected)
    }, item.name, /*#__PURE__*/React__default.createElement("span", {
      className: clsx("icon-action-dropDown-".concat(surfaceColor), "showTickIcon")
    }, /*#__PURE__*/React__default.createElement(Tick, null)));
  }))) : "", !error && /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    className: clsx(classes.container, !isMobileWidth && getBorderRadius("large"), !isMobileWidth && classes["containerBorder-".concat(surfaceColor)], isMapDataLoading && classes["freeze"]),
    id: "locatorComponent"
  }, isMobileWidth && /*#__PURE__*/React__default.createElement(StyledGrid, {
    xs: 12,
    className: clsx(classes.gMapDefault, classes["googleMapStyle-".concat(surfaceColor)], classes["svg-color-".concat(surfaceColor)], currFacility !== language.pleaseselectfacilitytype ? classes.gMap : ""),
    id: "googleMap",
    "data-locator": GOOGLE_MAP
  }), !isMobileWidth && locatorType.length !== 1 && props.mapData && !props.mapData.mapCardList && !props.mapData.loading || !isMobileWidth && currFacility === language.pleaseselectfacilitytype ? /*#__PURE__*/React__default.createElement(StyledGrid, {
    md: 12,
    className: clsx(getBorderRadius("large"), classes.gMapDefault, classes["googleMapStyle-".concat(surfaceColor)]),
    id: "googleMap",
    "data-locator": GOOGLE_MAP
  }) : null, currLocator && get$1(currLocator, "fields.primaryLocatorFilter.length", 0) && /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    className: classes.provineMaplistWrapper,
    id: "container-1"
  }, currLocator && get$1(currLocator, "fields.primaryLocatorFilter.length", 0) ? props.mapData && props.mapData.mapCardList && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !hideFilters && /*#__PURE__*/React__default.createElement(StyledGrid, {
    md: 4,
    xs: 12,
    className: clsx(classes["provinceWrapper-".concat(surfaceColor)], classes.provinceWrapper, !isMobileWidth && classes["container-".concat(surfaceColor)], classes["svg-color-".concat(surfaceColor)], !isMobileWidth && getBorderRadius("large", 0, 0, 0))
  }, /*#__PURE__*/React__default.createElement(Autocomplete$1, {
    value: currProvice && get$1(currProvice, "fields.name.value", ""),
    onChange: function onChange(e) {
      return handleProvinceChange(e.target.innerText);
    },
    "data-locator": MAPS_PROVINCE_TYPE,
    options: currLocator.fields.provinceList.map(function (item) {
      return item.fields.name.value;
    }),
    classes: {
      option: classes["dropdownUl-".concat(surfaceColor)]
    },
    inputTitle: language.province,
    ariaLabel: language.province,
    renderInput: function renderInput(param) {
      return /*#__PURE__*/React__default.createElement(TextField$1, _extends({}, param, {
        placeholder: language.province,
        margin: "normal",
        fullWidth: true
      }));
    },
    enableCrossIcon: currProvice && currProvice.fields.name && currProvice.fields.name.value.length > 0,
    ListboxProps: {
      className: "autoDropdown customScrollbarDesign"
    }
  })), isMobileWidth && !hideChipFilters && !hideFilters && /*#__PURE__*/React__default.createElement(StyledGrid, {
    xs: 12,
    md: 8,
    className: clsx(!isMobileWidth && classes.container, classes["container-".concat(surfaceColor)], classes.chipsTopWrapper),
    "data-locator": MAPS_PROVINCE_SIDE_WRAPPER
  }, get$1(currLocator, "fields.primaryLocatorFilter", []).length ? /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.filterContainer, classes["filterContainer-".concat(surfaceColor)], classes.leftFilterWrapper, get$1(secondaryFacets["locationfacilitiesfield_sm"], "length", 0) !== 0 ? "" : getBorderRadius(0, "large", 0, 0)),
    "data-locator": MAPS_PLAN_TYPE_WRAPPER
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    id: "planType-js",
    mb: 0,
    className: classes.labeltitle,
    component: "span",
    variant: "h10",
    color: surfaceColor
  }, get$1(currLocator, "fields.primaryLocatorFilterLabel.value", language.plantype)), /*#__PURE__*/React__default.createElement("div", {
    className: classes.chipsWrapper,
    id: "planTypeSider-js",
    style: {
      width: facetWidth
    }
  }, /*#__PURE__*/React__default.createElement(Carousel$1, {
    key: carousel2Key // To force re-render Slider
    ,
    settings: settings(showCarousel2),
    className: clsx(classes.sliderWrap, classes["slider-".concat(surfaceColor)])
  }, setPrimaryFilters()))) : null, secondaryFacets && secondaryFacets["locationfacilitiesfield_sm"] && secondaryFacets["locationfacilitiesfield_sm"].length !== 0 && !isFacetReset && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.filterContainer, classes["filterContainer-".concat(surfaceColor)]),
    "data-locator": MAPS_FACET_CHIP_WRAPPER
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    id: "filterBy-js",
    mb: 0,
    className: classes.labeltitle,
    component: "span",
    variant: "h10",
    color: surfaceColor
  }, get$1(currLocator, "fields.secondaryLocatorFilterLabel.value", language.filterby)), /*#__PURE__*/React__default.createElement("div", {
    className: classes.chipsWrapper,
    id: "filterBySider-js",
    style: {
      width: secondaryFacetWidth
    },
    ref: filterByWrapperRef
  }, /*#__PURE__*/React__default.createElement(Carousel$1, {
    key: carousel1Key // To force re-render Slider
    ,
    settings: _objectSpread2({}, settings(showCarousel1)),
    className: clsx(classes.sliderWrap, classes["slider-".concat(surfaceColor)])
  }, sliderCheck())))), distinctServiceMsg.length && isMobileWidth ? /*#__PURE__*/React__default.createElement(StyledGrid, {
    xs: 12,
    className: classes.distinctMsgContainer
  }, distinctMsgHTML()) : null) : null, props.mapData && !props.mapData.loading && /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    className: classes.cardListWrapper
  }, props.mapData.mapCardList && (!props.mapData.loading || currentPageNumber > 1 && isMobileWidth) && currFacility !== language.pleaseselectfacilitytype && /*#__PURE__*/React__default.createElement(MapCardsList, {
    mapData: props.mapData,
    classes: classes,
    onMapCardClick: onMapCardClick,
    t: t,
    seeMoreClickHandler: seeMoreClickHandler,
    selected: highlighCard,
    noResultFoundData: get$1(currLocator, "fields.noResultFoundSource", {}),
    fromMap: fromMapFlag,
    surfaceColor: surfaceColor,
    isMobile: isMobileWidth,
    currentFacility: currFacility,
    firstCard: mapFirstCard,
    loading: props.mapData.loading,
    filterHidden: hideFilters,
    gaLabelFacility: currFacilityGaLabel
  })), props.mapData.loading && /*#__PURE__*/React__default.createElement(StyledGrid, {
    md: 4,
    xs: 12,
    className: classes.mapWrapper
  }, /*#__PURE__*/React__default.createElement(SkeletonView, {
    count: 3,
    type: "MapCardSkeleton"
  }))), !isMobileWidth && props.mapData && /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    className: classes.chipsMapWrapper,
    id: "container-2"
  }, currFacility !== language.pleaseselectfacilitytype && !hideChipFilters && !hideFilters && /*#__PURE__*/React__default.createElement(StyledGrid, {
    xs: 12,
    md: 8,
    className: clsx(!isMobileWidth && classes.container, classes["container-".concat(surfaceColor)], classes.chipsTopWrapper),
    "data-locator": MAPS_PROVINCE_SIDE_WRAPPER
  }, get$1(currLocator, "fields.primaryLocatorFilter", []).length ? /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.filterContainer, classes["filterContainer-".concat(surfaceColor)], classes.leftFilterWrapper, get$1(secondaryFacets["locationfacilitiesfield_sm"], "length", 0) !== 0 ? "" : getBorderRadius(0, "large", 0, 0)),
    "data-locator": MAPS_PLAN_TYPE_WRAPPER
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    id: "planType-js",
    mb: 0,
    className: classes.labeltitle,
    component: "span",
    variant: "h10",
    color: surfaceColor
  }, get$1(currLocator, "fields.primaryLocatorFilterLabel.value", language.plantype)), /*#__PURE__*/React__default.createElement("div", {
    className: classes.chipsWrapper,
    id: "planTypeSider-js",
    style: {
      width: facetWidth
    }
  }, /*#__PURE__*/React__default.createElement(Carousel$1, {
    key: carousel2Key // To force re-render Slider
    ,
    settings: settings(showCarousel2),
    className: clsx(classes.sliderWrap, classes["slider-".concat(surfaceColor)])
  }, setPrimaryFilters()))) : null, secondaryFacets && secondaryFacets["locationfacilitiesfield_sm"] && secondaryFacets["locationfacilitiesfield_sm"].length !== 0 && !isFacetReset && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.filterContainer, classes["filterContainer-".concat(surfaceColor)]),
    "data-locator": MAPS_FACET_CHIP_WRAPPER
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    id: "filterBy-js",
    mb: 0,
    className: classes.labeltitle,
    component: "span",
    variant: "h10",
    color: surfaceColor
  }, get$1(currLocator, "fields.secondaryLocatorFilterLabel.value", language.filterby)), /*#__PURE__*/React__default.createElement("div", {
    className: classes.chipsWrapper,
    id: "filterBySider-js",
    style: {
      width: secondaryFacetWidth
    },
    ref: filterByWrapperRef
  }, /*#__PURE__*/React__default.createElement(Carousel$1, {
    key: carousel1Key // To force re-render Slider
    ,
    settings: _objectSpread2({}, settings(showCarousel1)),
    className: clsx(classes.sliderWrap, classes["slider-".concat(surfaceColor)])
  }, sliderCheck())))), !isMobileWidth && props.mapData && props.mapData.mapCardList && currFacility !== language.pleaseselectfacilitytype ? /*#__PURE__*/React__default.createElement(StyledGrid, {
    md: 8,
    "data-locator": GOOGLE_MAP,
    className: clsx(classes.relativeDiv, classes.mapWrapper)
  }, /*#__PURE__*/React__default.createElement("div", {
    id: "googleMap",
    className: clsx(classes.gMapDefault, classes["googleMapStyle-".concat(surfaceColor)], hideFilters || hideChipFilters ? getBorderRadius(0, "large", "large", 0) : getBorderRadius(0, 0, "large", 0), currFacility !== language.pleaseselectfacilitytype ? classes.gMap : "", currFacility !== language.pleaseselectfacilitytype && classes["gMapBorder-".concat(surfaceColor)])
  }), distinctServiceMsg.length ? /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.distinctMsgContainerPositioned, getBorderRadius("small"), classes["distinctMsg-".concat(surfaceColor)])
  }, distinctMsgHTML()) : null) : null))), error && /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    item: true,
    xs: 12,
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(ApiError, null)));
}; // const mapDispatchToProps = (dispatch) => {

var styles$3 = function styles(theme) {
  var _dataIndex2, _ref;

  return _ref = {
    mainContainer: {
      '&.flexiContainer.paddingBottomMedium .slick-slide .contentBlock': _defineProperty({
        paddingBottom: theme.spacing(11)
      }, theme.breakpoints.down('xs'), {
        paddingBottom: 0
      }),
      '&.flexiContainer.paddingBottomLarge .slick-slide .contentBlock': _defineProperty({
        paddingBottom: theme.spacing(11)
      }, theme.breakpoints.down('xs'), {
        paddingBottom: 0
      }),
      '&.flexiContainer': {
        '& .slick-next,& .slick-prev': {
          '&:hover': {
            backgroundColor: alpha(theme.palette.colors.orange.main, 0.2),
            borderRadius: theme.spacing(0.5)
          }
        }
      },
      // Deprecated. Below styling is only supported up to 2 columns layout
      // '&.flexiContainer.paddingBottomMedium .contentBlock0': {
      //   [`${theme.breakpoints.down('xs')} and (orientation: portrait)`]: {
      //     paddingBottom: theme.spacing(6),
      //   },
      // },
      // '&.flexiContainer.paddingBottomLarge .contentBlock0': {
      //   [theme.breakpoints.down('xs')]: {
      //     paddingBottom: theme.spacing(8),
      //   },
      // },
      // '&.flexiContainer.paddingTopMedium .contentBlock1': {
      //   [`${theme.breakpoints.down('xs')} and (orientation: portrait)`]: {
      //     paddingTop: theme.spacing(6),
      //   },
      // },
      // '&.flexiContainer.paddingTopLarge .contentBlock1': {
      //   [theme.breakpoints.down('xs')]: {
      //     paddingTop: theme.spacing(8),
      //   },
      // },
      // FWDS-2934 Investify flexi container with 3 columns
      // Adding >= 3 columns layout (first, middle, last) for mobile view
      '&.flexiContainer.paddingBottomMedium .contentBlockFirst': _defineProperty({}, "".concat(theme.breakpoints.down('xs'), " and (orientation: portrait)"), {
        paddingBottom: theme.spacing(6)
      }),
      '&.flexiContainer.paddingBottomLarge .contentBlockFirst': _defineProperty({}, theme.breakpoints.down('xs'), {
        paddingBottom: theme.spacing(8)
      }),
      '&.flexiContainer.paddingBottomMedium .contentBlockMiddle': _defineProperty({}, "".concat(theme.breakpoints.down('xs'), " and (orientation: portrait)"), {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6)
      }),
      '&.flexiContainer.paddingBottomLarge .contentBlockMiddle': _defineProperty({}, theme.breakpoints.down('xs'), {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8)
      }),
      '&.flexiContainer.paddingTopMedium .contentBlockLast': _defineProperty({}, "".concat(theme.breakpoints.down('xs'), " and (orientation: portrait)"), {
        paddingTop: theme.spacing(6)
      }),
      '&.flexiContainer.paddingTopLarge .contentBlockLast': _defineProperty({}, theme.breakpoints.down('xs'), {
        paddingTop: theme.spacing(8)
      }),
      '&.flexiContainer.overflowBlock': _defineProperty({}, theme.breakpoints.down('sm'), {
        overflow: 'hidden'
      }),
      '&.flexiContainer.paddingBottomMedium': _defineProperty({
        '& .flexiBlock1': {
          '& [data-locator="Support-Description"]': {
            width: '100%'
          }
        }
      }, theme.breakpoints.down('sm'), {
        '& .flexiBlock0': {
          paddingBottom: theme.spacing(6)
        },
        '& .flexiBlock1': {
          paddingTop: theme.spacing(6),
          paddingBottom: theme.spacing(6)
        }
      }),
      '&.flexiContainer.paddingBottomLarge': _defineProperty({
        '& .flexiBlock1': {
          '& [data-locator="Support-Description"]': {
            width: '100%'
          }
        }
      }, theme.breakpoints.down('xs'), {
        '& .flexiBlock0': {
          paddingBottom: theme.spacing(8)
        },
        '& .flexiBlock1': {
          paddingTop: theme.spacing(8),
          paddingBottom: theme.spacing(8)
        }
      })
    },
    root: {
      flexGrow: 1,
      '&.isArticleDetail': {
        '& .flexiBlock0': {
          paddingBottom: '0 !important'
        }
      }
    },
    container: {
      padding: theme.spacing(3)
    },
    title: _defineProperty({
      fontWeight: theme.typography.fontWeights.bolder,
      //fwd-3216
      marginBottom: theme.spacing(4.5)
    }, theme.breakpoints.down('sm'), {
      paddingBottom: theme.spacing(3),
      marginBottom: theme.spacing(0)
    }),
    bottomLinkWrapper: {
      '& .startIcon': {
        marginRight: theme.spacing(0.5)
      }
    },
    link: {
      marginTop: theme.typography.pxToRem(20),
      marginBottom: theme.spacing(-0.5),
      fontWeight: theme.typography.fontWeights.bolder,
      marginLeft: theme.spacing(-0.5),
      '& a': {
        textDecoration: 'none'
      }
    }
  }, _defineProperty(_ref, 'grid-0', {
    '&[data-index="0"]': _defineProperty({}, theme.breakpoints.down('xs'), {
      paddingBottom: 0
    })
  }), _defineProperty(_ref, 'grid-1', {
    '&[data-index="1"]': (_dataIndex2 = {}, _defineProperty(_dataIndex2, theme.breakpoints.down('xs'), {
      paddingTop: 0
    }), _defineProperty(_dataIndex2, "".concat(theme.breakpoints.down('xs'), " and (orientation: landscape)"), {
      '& .containerWrapper': {
        marginTop: theme.spacing(1.5)
      }
    }), _dataIndex2)
  }), _ref;
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var CAROUSEL_SLIDER = 'Carousel-Slider';
var COMPONENT_TITLE$1 = 'FlexiContainer-Title';
var COMPONENT_LINK = 'FlexiContainer-Link';

var Placeholder = function Placeholder(props) {
  var _rendering$placeholde;

  var name = get$1(props, "name", "jss-col");
  var rendering = get$1(props, "rendering", {
    placeholders: {
      "jss-col": []
    }
  });
  get$1(props, "flexiCol", 6);
  get$1(props, "color", "white");
  var key = get$1(props, "key", "jss-col");
  var colComponents = rendering === null || rendering === void 0 ? void 0 : (_rendering$placeholde = rendering.placeholders) === null || _rendering$placeholde === void 0 ? void 0 : _rendering$placeholde[name];

  if (colComponents && colComponents.length > 0) {
    var componentProps = colComponents[0];
    var componentName = componentProps.componentName;

    switch (componentName) {
      case "ContentBlock":
        return /*#__PURE__*/React__default.createElement(ContentBlock$1, _extends({}, componentProps, props, {
          key: key,
          sitecoreContext: props.sitecoreContext
        }));

      case "CustomerSupport":
        return /*#__PURE__*/React__default.createElement(CustomerSupport$1, _extends({}, componentProps, props, {
          key: key,
          sitecoreContext: props.sitecoreContext,
          updateGroupEnquiryData: function updateGroupEnquiryData() {},
          updateFormLinks: function updateFormLinks() {},
          updateFormInitializer: function updateFormInitializer() {}
        }));

      case "FAQsAccordion":
        return /*#__PURE__*/React__default.createElement(FAQsAccordion$1, _extends({}, componentProps, props, {
          key: key,
          sitecoreContext: props.sitecoreContext
        }));
    }
  }
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles$2 = function styles(theme) {
  return _objectSpread2(_objectSpread2({}, theme.backgrounds), {}, {
    root: {
      '& .stickyContainer': {
        position: 'sticky',
        top: theme.spacing(9),
        '&.headerVisible': _defineProperty({
          top: theme.spacing(18)
        }, theme.breakpoints.down('xl'), {
          top: theme.spacing(16)
        })
      }
    },
    wrapper: {
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        __expression__: 'all and (-ms-high-contrast: none), (-ms-high-contrast: active)',
        '& [data-locator=CampaignCard-Link]': {
          position: 'static !important'
        }
      }
    }
  });
};

var useStyles$6 = makeStyles(function (theme) {
  return styles$2(theme);
});

var GridContainer = function GridContainer(props) {
  var _props$sitecoreContex, _props$sitecoreContex2, _props$sitecoreContex3, _props$headerVisible;

  var classes = useStyles$6();
  var templateName = (_props$sitecoreContex = props === null || props === void 0 ? void 0 : (_props$sitecoreContex2 = props.sitecoreContext) === null || _props$sitecoreContex2 === void 0 ? void 0 : (_props$sitecoreContex3 = _props$sitecoreContex2.route) === null || _props$sitecoreContex3 === void 0 ? void 0 : _props$sitecoreContex3.templateName) !== null && _props$sitecoreContex !== void 0 ? _props$sitecoreContex : '';
  var addSeperator = props.addSeperator;
  var headerVisible = (_props$headerVisible = props === null || props === void 0 ? void 0 : props.headerVisible) !== null && _props$headerVisible !== void 0 ? _props$headerVisible : null;

  var placeholder = function placeholder(col, index) {
    return /*#__PURE__*/React__default.createElement(Placeholder, {
      name: "jss-col-".concat(index + 1),
      rendering: props.rendering,
      flexiCol: parseInt(col),
      color: props.backgrounds[index],
      colIndex: index,
      addSeperator: index >= 1 && addSeperator === true,
      isFirst: index === 0,
      isMiddle: index > 0 && index < props.columns.length - 1,
      isLast: index === props.columns.length - 1,
      sitecoreContext: props.sitecoreContext,
      gtmPushEvent: props.gtmPushEvent,
      navigate: props.navigate,
      updateFormModalState: props.updateFormModalState,
      handleChatBotToggle: props.handleChatBotToggle
    });
  };

  var GridContainerMemo = /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    spacing: 3,
    className: classes.root
  }, get$1(props, 'columns.length', 0) > 0 && props.columns.map(function (col, index) {
    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      key: index,
      item: true,
      xs: 12,
      sm: parseInt(col),
      lg: parseInt(col),
      "data-index": index,
      className: clsx(props.classes.gridbg, classes["grid-".concat(index + 1, "-").concat(col, "-").concat(props.backgrounds[index])], props.classes["grid-".concat(index)], _defineProperty({}, classes.wrapper, col === '6'))
    }, index === 1 && (templateName === 'ArticlePage' || templateName === 'PrivilegePage') ? /*#__PURE__*/React__default.createElement("div", {
      className: clsx('stickyContainer', headerVisible && 'headerVisible')
    }, placeholder(col, index)) : placeholder(col, index));
  }));

  if (props.columns === undefined) {
    return '';
  } else {
    return GridContainerMemo;
  }
}; // const mapStateToProps = createStructuredSelector({

var styles$1 = function styles(theme) {
  var _slickList, _slickList2, _slickPrev, _slickNext;

  var colors = theme.palette.colors || {};
  var icon = theme.palette;
  var iconColors = {};
  Object.keys(colors).forEach(function (color) {
    var carouselIcon = icon[colors[color].icon].icon.carousel;
    iconColors["carouselIcon-".concat(color)] = {
      '& .slick-prev, .slick-next': {
        color: carouselIcon.background.default,
        transition: motionTypes.colorTransition,
        transitionProperty: 'background-color',
        '&:hover': {
          background: alpha(fwdColors.orange, 0.2),
          borderRadius: theme.spacing(0.5),
          color: carouselIcon.background.default
        }
      }
    };
  });
  return {
    carousel: {
      '& .slick-list': (_slickList = {
        margin: '0px -12px',
        height: 'auto'
      }, _defineProperty(_slickList, theme.breakpoints.down('xs'), {
        marginLeft: '-54px'
      }), _defineProperty(_slickList, theme.breakpoints.between('sm', 'md'), {
        marginLeft: '-4px',
        marginRight: '-4px'
      }), _defineProperty(_slickList, theme.breakpoints.down('sm'), {
        overflow: 'visible'
      }), _slickList),
      '& .slick-slide': _defineProperty({
        padding: '0px 12px'
      }, theme.breakpoints.down('xs'), {
        padding: '0px 4px'
      }),
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        __expression__: 'all and (-ms-high-contrast: none), (-ms-high-contrast: active)',
        '& [data-locator=CampaignCard-Link]': {
          position: 'static !important'
        }
      }
    },
    desktopPadding: {
      '& .slick-list': {
        paddingTop: '30px',
        paddingBottom: '30px',
        marginTop: '-30px',
        marginBottom: '-30px'
      }
    },
    sliderWrap: {
      '& .slick-list': (_slickList2 = {
        marginLeft: theme.spacing(-1.5),
        marginTop: theme.typography.pxToRem(-20),
        marginBottom: theme.typography.pxToRem(-20)
      }, _defineProperty(_slickList2, theme.breakpoints.down('sm'), {
        marginLeft: theme.spacing(-0.5)
      }), _defineProperty(_slickList2, theme.breakpoints.between('sm', 'lg'), {
        marginLeft: theme.spacing(-1.5)
      }), _slickList2),
      '& .slick-track': {
        paddingBottom: theme.typography.pxToRem(20),
        paddingTop: theme.typography.pxToRem(20),
        display: 'flex'
      },
      '& .slick-disabled ': {
        opacity: '0',
        pointerEvents: 'none'
      },
      '& .slick-prev, .slick-next': {
        width: '32px',
        height: '32px',
        zIndex: '7'
      },
      '& .slick-prev': (_slickPrev = {
        left: '-42px',
        transform: 'translate(0, -50%) rotate(180deg)'
      }, _defineProperty(_slickPrev, theme.breakpoints.down('sm'), {
        left: theme.spacing(-3)
      }), _defineProperty(_slickPrev, theme.breakpoints.between('sm', 'lg'), {
        left: '-30px'
      }), _slickPrev),
      '& .slick-next': (_slickNext = {
        right: '-42px'
      }, _defineProperty(_slickNext, theme.breakpoints.down('sm'), {
        right: theme.spacing(-3)
      }), _defineProperty(_slickNext, theme.breakpoints.between('sm', 'lg'), {
        right: '-33px'
      }), _slickNext)
    },
    campaignCarousel: {
      /* Handles carousel of Campaigncards in mobile view */
      '& .slick-track': _defineProperty({
        '& .slick-slide': _defineProperty({}, theme.breakpoints.down('sm'), {
          minWidth: theme.typography.pxToRem(296)
        })
      }, theme.breakpoints.down('xs'), {
        display: 'flex',
        '& .slick-slide': {
          height: 'auto',
          '&>div': {
            height: '100%',
            '&>section': {
              height: '100%'
            }
          },
          '& .campaignCard, & .cardContentWrap, & .cardActions, & .cardContent': {
            height: '100%'
          },
          '& .cardActions': {
            '&>.MuiTypography-root': {
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              '& .MuiGrid-container': {
                height: 'calc(100% + 24px)'
              }
            }
          },
          '& [data-locator=CampaignCard-Label]': {
            height: 'unset'
          },
          '& [data-locator=CampaignCard-Description]': {
            marginRight: theme.spacing(4)
          },
          '& [data-locator=CampaignCard-Wrapper-Medium]': {
            marginBottom: 'unset'
          }
        }
      })
    }
  };
};

var useStyles$5 = makeStyles(styles$1);
/** CarousalContainer */

var CarouselContainer = function CarouselContainer(props) {
  var classes = useStyles$5();
  var isCampaignCard = false;
  var isMobile = props.isMobile;
  var column1 = get$1(props, 'rendering.placeholders.jss-col-1');

  if (column1.length > 0 && column1[0].componentName === 'CampaignCard') {
    isCampaignCard = true;
  }

  var settings = {
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    centerPadding: '0px',
    nextArrow: /*#__PURE__*/React__default.createElement(ArrowForward, {
      "data-locator": 'Carousel-Items-Next-Button',
      "aria-label": 'Carousel-Items-Next-Button'
    }),
    prevArrow: /*#__PURE__*/React__default.createElement(ArrowForward, {
      "data-locator": 'Carousel-Items-Previous-Button',
      "aria-label": 'Carousel-Items-Previous-Button'
    }),
    responsive: [{
      breakpoint: 600,
      settings: {
        centerMode: true,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '50px',
        swipeToSlide: true,
        arrows: false
      }
    }]
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isMobile && /*#__PURE__*/React__default.createElement("div", {
    "data-locator": CAROUSEL_SLIDER
  }, /*#__PURE__*/React__default.createElement(Carousel$1, {
    settings: settings,
    className: clsx(classes.carousel, classes.desktopPadding, classes.sliderWrap, classes["carouselIcon-".concat(props.backgrounds[0])]),
    color: props.backgrounds[0]
  }, props.columns.length > 0 && props.columns.map(function (col, index) {
    return /*#__PURE__*/React__default.createElement(Placeholder, {
      name: "jss-col-".concat(index + 1),
      rendering: props.rendering,
      flexiCol: parseInt(col),
      color: props.backgrounds[index],
      key: "jss-col-".concat(index + 1),
      sitecoreContext: props.sitecoreContext,
      navigate: props.navigate,
      updateFormModalState: props.updateFormModalState,
      handleChatBotToggle: props.handleChatBotToggle
    });
  }))), isMobile &&
  /*#__PURE__*/

  /** Handles assymetrical grids in carousel mode */
  React__default.createElement("div", {
    "data-locator": CAROUSEL_SLIDER
  }, /*#__PURE__*/React__default.createElement(Carousel$1, {
    settings: settings,
    className: clsx(classes.carousel, _defineProperty({}, classes.campaignCarousel, isCampaignCard))
  }, Object.values(props.rendering.placeholders).map(function (item) {
    return item.map(function (element) {
      return /*#__PURE__*/React__default.createElement(Placeholder, {
        name: 'jss-col',
        rendering: {
          placeholders: {
            'jss-col': [element]
          }
        },
        flexiCol: 6,
        key: 'jss-col',
        gtmPushEvent: props.gtmPushEvent,
        navigate: props.navigate,
        updateFormModalState: props.updateFormModalState,
        handleChatBotToggle: props.handleChatBotToggle
      });
    });
  }))));
};

var useStyles$4 = makeStyles(function (theme) {
  return styles$3(theme);
});

var FlexiContainer$1 = function FlexiContainer(props) {
  var _props$params, _params$divider, _props$params$anchorT, _props$params2, _props$params$numberO, _props$params3, _props$params3$number, _props$params$backgro, _props$params4, _props$params4$backgr, _props$fields, _props$fields$title, _props$fields$link$va, _props$fields2, _props$fields2$link;

  var params = (_props$params = props === null || props === void 0 ? void 0 : props.params) !== null && _props$params !== void 0 ? _props$params : {
    paddingTop: "large",
    paddingBottom: "large"
  };
  var dividerLine = (_params$divider = params === null || params === void 0 ? void 0 : params.divider) !== null && _params$divider !== void 0 ? _params$divider : "0";
  var isMobile = useMediaQuery("(max-width:".concat(breakpoints.values.sm, "px)"));
  var classes = useStyles$4();
  var anchorText = ((_props$params$anchorT = props === null || props === void 0 ? void 0 : (_props$params2 = props.params) === null || _props$params2 === void 0 ? void 0 : _props$params2.anchorText) !== null && _props$params$anchorT !== void 0 ? _props$params$anchorT : "Flexi-Container-".concat(getRandomValues())).replace(/\s+/g, "-");
  /** Get the no of columns from props for grid */

  var columns = (_props$params$numberO = props === null || props === void 0 ? void 0 : (_props$params3 = props.params) === null || _props$params3 === void 0 ? void 0 : (_props$params3$number = _props$params3.numberOfColumns) === null || _props$params3$number === void 0 ? void 0 : _props$params3$number.split("-")) !== null && _props$params$numberO !== void 0 ? _props$params$numberO : [];
  var backgrounds = (_props$params$backgro = props === null || props === void 0 ? void 0 : (_props$params4 = props.params) === null || _props$params4 === void 0 ? void 0 : (_props$params4$backgr = _props$params4.backgroundColor) === null || _props$params4$backgr === void 0 ? void 0 : _props$params4$backgr.split("|")) !== null && _props$params$backgro !== void 0 ? _props$params$backgro : ["white"];
  /* istanbul ignore else */

  if (backgrounds[0] && backgrounds[0].indexOf("-") !== -1) {
    var _getColors = getColors(backgrounds[0]),
        bgColor = _getColors.bgColor;

    backgrounds[0] = bgColor;
  }

  if (backgrounds[1] && backgrounds[1].indexOf("-") !== -1) {
    var _getColors2 = getColors(backgrounds[1]),
        _bgColor = _getColors2.bgColor;

    backgrounds[1] = _bgColor;
  }

  var carouselMode = ["Mobile", "Desktop", "Both"].includes(props.params.carouselMode) ? props.params.carouselMode : null;
  var title = props !== null && props !== void 0 && (_props$fields = props.fields) !== null && _props$fields !== void 0 && (_props$fields$title = _props$fields.title) !== null && _props$fields$title !== void 0 && _props$fields$title.value ? props.fields.title : null;
  var link = Object.keys((_props$fields$link$va = props === null || props === void 0 ? void 0 : (_props$fields2 = props.fields) === null || _props$fields2 === void 0 ? void 0 : (_props$fields2$link = _props$fields2.link) === null || _props$fields2$link === void 0 ? void 0 : _props$fields2$link.value) !== null && _props$fields$link$va !== void 0 ? _props$fields$link$va : {}).length ? props.fields.link : null;
  var titleTmpl = /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    md: 8,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h2",
    component: "h2",
    className: classes.title,
    "data-locator": COMPONENT_TITLE$1,
    color: backgrounds[0]
  }, title && title.value)));
  var linkTmpl = /*#__PURE__*/React__default.createElement("div", {
    className: classes.bottomLinkWrapper,
    "data-locator": COMPONENT_LINK
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    component: "div",
    variant: "body1",
    underline: "none",
    size: "small",
    icon: "arrow-right",
    className: classes.link,
    color: backgrounds[0],
    link: link,
    linkMode: buttonModes.SIMPLEPRIMARYLINK,
    disableTabIndex: "true",
    onClick: function onClick() {
      var _link$value, _props$fields$gaCateg, _props$fields3, _props$fields3$gaCate, _link$value2;

      //TODO: need modification after <Link> fix
      PushEvent({
        event: "buttonClick",
        buttonTitle: get$1(props, "fields.linkGALabelName.value", "") || getGTMSharedKeyVal(link === null || link === void 0 ? void 0 : (_link$value = link.value) === null || _link$value === void 0 ? void 0 : _link$value.href, COMPONENT_LINK),
        componentName: (_props$fields$gaCateg = props === null || props === void 0 ? void 0 : (_props$fields3 = props.fields) === null || _props$fields3 === void 0 ? void 0 : (_props$fields3$gaCate = _props$fields3.gaCategoryName) === null || _props$fields3$gaCate === void 0 ? void 0 : _props$fields3$gaCate.value) !== null && _props$fields$gaCateg !== void 0 ? _props$fields$gaCateg : COMPONENT_LINK,
        destinationUrl: link === null || link === void 0 ? void 0 : (_link$value2 = link.value) === null || _link$value2 === void 0 ? void 0 : _link$value2.href
      }, props.gtmPushEvent);
    }
  }));
  var isSameColor = backgrounds[0] === backgrounds[1];
  var isArticleDetail = !!get$1(props, "rendering.placeholders.jss-col-1", []).find(function (item) {
    return item.componentName === "ArticleDetails";
  });
  return /*#__PURE__*/React__default.createElement(Container$1, {
    spacing: 0,
    id: anchorText,
    className: clsx("flexiContainer", classes.mainContainer, getPaddingString(params), dividerLine === "1" ? "component-divider-".concat(backgrounds[0]) : "", {
      gridMode: !carouselMode,
      overflowBlock: carouselMode
    }),
    background: columns.length === 1 && backgrounds[0] || isSameColor || carouselMode ? backgrounds[0] : null
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    className: clsx(classes.root, {
      isArticleDetail: isArticleDetail
    })
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 12
  }, title && titleTmpl, carouselMode === "Both" || carouselMode === "Mobile" && isMobile || carouselMode === "Desktop" && !isMobile ? /*#__PURE__*/React__default.createElement(CarouselContainer, _extends({
    classes: classes,
    columns: columns,
    backgrounds: backgrounds,
    isMobile: isMobile,
    rendering: _objectSpread2({}, props)
  }, props)) : /*#__PURE__*/React__default.createElement(GridContainer, _extends({
    classes: classes,
    columns: columns,
    backgrounds: backgrounds,
    addSeperator: columns.length > 1 && isSameColor === true,
    rendering: _objectSpread2({}, props)
  }, props)), link && linkTmpl)));
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var style$2 = function style(theme) {
  var _rootContainer, _makeStylesFlexiRo, _flexiRoot, _description;

  return {
    rootContainer: (_rootContainer = {}, _defineProperty(_rootContainer, theme.breakpoints.down('md'), {
      maxWidth: '515px'
    }), _defineProperty(_rootContainer, theme.breakpoints.down('xs'), {
      maxWidth: 'unset'
    }), _rootContainer),
    tabCardList: {
      '&.makeStyles-flexiRoot': (_makeStylesFlexiRo = {
        paddingTop: 0,
        paddingBottom: 0
      }, _defineProperty(_makeStylesFlexiRo, theme.breakpoints.up('md'), {
        paddingTop: theme.spacing(2.5),
        paddingBottom: theme.spacing(0)
      }), _defineProperty(_makeStylesFlexiRo, '& p.MuiTypography-root.MuiTypography-body1', _defineProperty({
        marginBottom: theme.spacing(3.5)
      }, theme.breakpoints.up('md'), {
        marginBottom: theme.spacing(6)
      })), _makeStylesFlexiRo)
    },
    flexiRoot: (_flexiRoot = {
      paddingTop: theme.spacing(12),
      paddingBottom: theme.spacing(12)
    }, _defineProperty(_flexiRoot, theme.breakpoints.up('md'), {
      paddingLeft: theme.spacing(8),
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
      marginBottom: 0
    }), _defineProperty(_flexiRoot, theme.breakpoints.down('sm'), {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
      marginBottom: 0
    }), _flexiRoot),
    text: {
      marginTop: theme.spacing(3),
      '&:first-child': {
        marginTop: 0
      }
    },
    title: {
      marginBottom: theme.spacing(3),
      fontWeight: theme.typography.fontWeights.bolder,
      '&.withoutDesc': _defineProperty({
        marginBottom: theme.spacing(6)
      }, theme.breakpoints.down('sm'), {
        marginBottom: theme.spacing(3)
      })
    },
    description: (_description = {
      width: '100%',
      marginBottom: theme.spacing(6)
    }, _defineProperty(_description, theme.breakpoints.down('sm'), {
      marginBottom: theme.spacing(3)
    }), _defineProperty(_description, '& div', {
      // TODO: Need to check with Manisha for this change
      // display: 'flex',
      '& p': {
        margin: 0
      }
    }), _description),
    smallCardPadding: _defineProperty({
      marginBottom: theme.spacing(6.5)
    }, theme.breakpoints.down('sm'), {
      marginBottom: theme.spacing(3)
    }),
    link: {
      fontWeight: theme.typography.fontWeights.bold
    },
    linkWrapper: {
      display: 'flex',
      marginTop: theme.spacing(6),
      '& a.MuiLink-root': {
        display: 'inline-flex'
      }
    }
  };
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var CARDLIST_CONTAINER = 'CardList-Container';
var CARDLIST_TITLE = 'CardList-Title';
var CARDLIST_SUBTITLE = 'CardList-Subtitle';
var CARDLIST_DESCRIPTION = 'CardList-Description';
var CARDLIST_ITEM_WRAPPER = 'CardList-Item-Wrapper';
var CARDLIST_ITEM = 'CardList-Item';
var CARDLIST_ITEM_IMAGE = 'CardList-Item-Image';
var CARDLIST_ITEMS_PREV_BUTTON = 'CardList-Items-Prev-Button';
var CARDLIST_ITEMS_NEXT_BUTTON = 'CardList-Items-Next-Button';
var CARDLIST_PRIMARY_CTA = 'CardList-Primary-Cta';

var style$1 = function style(theme) {
  var _slickPrev, _slickNext;

  var colors = theme.palette.colors || {};
  var icon = theme.palette;
  var iconColors = {};
  Object.keys(colors).forEach(function (color) {
    var carouselIcon = icon[colors[color].icon].icon.carousel;
    iconColors["carouselIcon-".concat(color)] = {
      '& .slick-prev, .slick-next': {
        color: carouselIcon.background.default,
        '&:hover': {
          color: carouselIcon.background.default
        }
      }
    };
  });
  return _objectSpread2(_objectSpread2({
    itemRoot: {
      alignItems: 'center',
      width: '100%',
      '& .fallbackPic': {
        borderRadius: theme.spacing(2)
      }
    },
    cardItemLink: {
      width: '100%',
      height: '100%',
      '& div': {
        width: '100%'
      }
    },
    cardlistItemWrapper: _defineProperty({
      marginTop: theme.spacing(3)
    }, theme.breakpoints.up('md'), {
      marginTop: theme.spacing(8)
    })
  }, iconColors), {}, {
    sliderWrap: {
      '& .slick-arrow': {
        transition: motionTypes.colorTransition,
        transitionProperty: 'background-color',
        '&:hover': {
          background: alpha(fwdColors.orange, 0.2),
          borderRadius: theme.spacing(0.5)
        }
      },
      '& .slick-list ': {
        marginLeft: '-12px',
        marginRight: '-12px'
      },
      '& .slick-list> div': {
        marginLeft: 0
      },
      '& .slick-slide ': {
        padding: '0 12px'
      },
      '& .slick-slide>div:first-child ': _defineProperty({}, theme.breakpoints.down('sm'), {
        paddingBottom: theme.spacing(1.5)
      }),
      '& .slick-slide>div:last-child ': _defineProperty({}, theme.breakpoints.down('sm'), {
        paddingTop: theme.spacing(1.5)
      }),
      '& .slick-prev, .slick-next': _defineProperty({
        width: '32px',
        height: '32px',
        zIndex: '7'
      }, theme.breakpoints.down('sm'), {
        width: theme.spacing(3),
        height: theme.spacing(3)
      }),
      '& .slick-disabled ': {
        opacity: '0',
        pointerEvents: 'none'
      },
      '& .slick-prev': (_slickPrev = {
        left: theme.spacing(-6),
        transform: 'translate(0, -50%) rotate(180deg)'
      }, _defineProperty(_slickPrev, theme.breakpoints.down('sm'), {
        left: theme.spacing(-2)
      }), _defineProperty(_slickPrev, theme.breakpoints.between('sm', 'lg'), {
        left: '-30px'
      }), _slickPrev),
      '& .slick-next': (_slickNext = {
        right: theme.spacing(-6)
      }, _defineProperty(_slickNext, theme.breakpoints.down('sm'), {
        right: theme.spacing(-2)
      }), _defineProperty(_slickNext, theme.breakpoints.between('sm', 'lg'), {
        right: '-33px'
      }), _slickNext)
    }
  });
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var useStyles$3 = makeStyles(function (theme) {
  return style$1(theme);
});
/**
 * CardItem
 */

var CardItem = function CardItem(props) {
  var classes = useStyles$3();

  var _get = get$1(props, 'fields', {}),
      title = _get.title,
      image = _get.image,
      mobileImage = _get.mobileImage,
      link = _get.link;

  var gaCategoryName = props.gaCategoryName;
  var url = get$1(link, 'value.href', '#') || '#';
  var linkType = get$1(link, 'value.linktype', '');

  var onClickLinkHandler = function onClickLinkHandler(e) {
    e.preventDefault();
    PushEvent({
      event: 'buttonClick',
      buttonTitle: get$1(props, 'fields.gaLabelName.value', '') || getGTMSharedKeyVal(undefined, CARDLIST_ITEM),
      position: props.index + 1,
      componentName: gaCategoryName ? gaCategoryName : CARDLIST_ITEM,
      destinationUrl: undefined
    }, props.gtmPushEvent);
    /* istanbul ignore else */

    if ((e.ctrlKey || e.metaKey) && typeof window !== 'undefined') {
      window.open(url, '_blank');
    } else if (linkType === 'internal') {
      props.navigate(url);
    } else if (linkType === 'external') {
      if (typeof window !== 'undefined') {
        window.open(url, '_blank');
      }
    }
  };

  return /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    component: url === '#' ? 'span' : 'a',
    underline: "none",
    className: classes.cardItemLink,
    "data-locator": CARDLIST_ITEM,
    alt: title,
    onClick: onClickLinkHandler,
    disablePointer: url === '#',
    href: url
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.itemRoot
  }, /*#__PURE__*/React__default.createElement(Picture, {
    media: {
      image: image,
      mobileImage: mobileImage,
      aspectRatio: {
        mobile: '2-1',
        desktop: '2-1',
        tablet: '2-1'
      }
    },
    hasBorderRadius: true,
    "data-locator": CARDLIST_ITEM_IMAGE
  })));
};
/**
 * CardItems
 */


var Carousel = function Carousel(props) {
  var classes = useStyles$3();
  var cardItems = get$1(props, 'fields.linkItems', []);
  var gaCategoryName = props.gaCategoryName;
  var color = get$1(props, 'color', 'white');
  var navigate = get$1(props, 'navigate', function (href) {
    if (typeof window !== 'undefined') {
      window.open(href);
    }
  });
  var currentSlide = 0;
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    beforeChange: function beforeChange(current, next) {
      next < currentSlide ? PushEvent({
        event: 'buttonClick',
        buttonTitle: CARDLIST_ITEMS_PREV_BUTTON,
        destinationUrl: undefined,
        componentName: gaCategoryName ? gaCategoryName : CARDLIST_ITEM_WRAPPER
      }, props.gtmPushEvent) : PushEvent({
        event: 'buttonClick',
        buttonTitle: CARDLIST_ITEMS_NEXT_BUTTON,
        destinationUrl: undefined,
        componentName: gaCategoryName ? gaCategoryName : CARDLIST_ITEM_WRAPPER
      }, props.gtmPushEvent);
      currentSlide = next;
    },
    nextArrow: /*#__PURE__*/React__default.createElement(ArrowForward, {
      "data-locator": CARDLIST_ITEMS_NEXT_BUTTON,
      "aria-label": CARDLIST_ITEMS_NEXT_BUTTON
    }),
    prevArrow: /*#__PURE__*/React__default.createElement(ArrowForward, {
      "data-locator": CARDLIST_ITEMS_PREV_BUTTON,
      "aria-label": CARDLIST_ITEMS_PREV_BUTTON
    }),
    responsive: [{
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        rows: 2,
        slidesPerRow: 1
      }
    }]
  };
  return /*#__PURE__*/React__default.createElement("div", {
    "data-locator": CARDLIST_ITEM_WRAPPER,
    className: classes.cardlistItemWrapper
  }, /*#__PURE__*/React__default.createElement(Carousel$1, {
    settings: settings,
    className: clsx(classes.sliderWrap, classes["carouselIcon-".concat(color)])
  }, cardItems && cardItems.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(CardItem, {
      gaCategoryName: gaCategoryName,
      index: index,
      key: item.id,
      fields: item.fields,
      className: classes.cardItem,
      flexiCol: props.flexiCol,
      color: color,
      navigate: navigate,
      gtmPushEvent: props.gtmPushEvent
    });
  })));
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var GRID_WRAPPER = 'Grid-Wrapper';
var GRID_ITEM = 'Grid-Item';
var COMPONENT_INFO_IMAGE = 'Info-Image';
var COMPONENT_INFO_TITLE = 'Info-Title';
var COMPONENT_INFO_DESCRIPTION = 'Info-Description';
var COMPONENT_BUTTON = 'Info-Button';
var COMPONENT_CTA = 'Info-CTA';

/*9fbef606107a605d69c0edbcd8029e5d*/
var style = function style(theme) {
  var _imageWrapSmallVarian, _imageWrapLargeVarian, _buttonWrapper;

  var colors = theme.palette.colors || {};
  var iconColors = {};
  Object.keys(colors).forEach(function (color) {
    iconColors["icon-".concat(color)] = {
      '& g': {
        '& path': {
          fill: colors[color].contrastTextLabel
        }
      }
    };
  });
  return _objectSpread2(_objectSpread2({}, iconColors), {}, {
    smallVarientPadding: _defineProperty({
      padding: theme.spacing(1.5)
    }, theme.breakpoints.down('sm'), {
      padding: 0
    }),
    infoDescription: _defineProperty({
      marginTop: theme.spacing(1),
      '& p': {
        margin: '0'
      },
      '& div': {
        '& ul': {
          margin: '0px',
          paddingLeft: theme.spacing(2)
        }
      }
    }, theme.breakpoints.down('sm'), {
      width: '100%'
    }),
    infoTitle: _defineProperty({
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(0),
      fontWeight: theme.typography.fontWeights.bolder
    }, theme.breakpoints.down('xs'), {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(20)
    }),
    gridItemDynamic: _defineProperty({}, theme.breakpoints.down('sm'), {
      paddingTop: "".concat(theme.typography.pxToRem(12), " !important"),
      paddingBottom: "".concat(theme.typography.pxToRem(12), " !important")
    }),
    gridCard: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    },
    gridItem: _defineProperty({
      display: 'none'
    }, theme.breakpoints.down('sm'), {
      paddingTop: "".concat(theme.typography.pxToRem(12), " !important"),
      paddingBottom: "".concat(theme.typography.pxToRem(12), " !important")
    }),
    cardWithLink: {
      cursor: 'pointer'
    },
    imageWrapSmallVariant: (_imageWrapSmallVarian = {
      width: theme.typography.pxToRem(62),
      height: theme.typography.pxToRem(62)
    }, _defineProperty(_imageWrapSmallVarian, theme.breakpoints.down('sm'), {
      width: theme.typography.pxToRem(51),
      height: theme.typography.pxToRem(51)
    }), _defineProperty(_imageWrapSmallVarian, '& .fallbackPic', {
      backgroundSize: '80%',
      borderRadius: theme.spacing(0.5)
    }), _imageWrapSmallVarian),
    imageWrapLargeVariant: (_imageWrapLargeVarian = {
      width: theme.typography.pxToRem(120),
      height: theme.typography.pxToRem(120)
    }, _defineProperty(_imageWrapLargeVarian, theme.breakpoints.up('sm'), {
      width: theme.typography.pxToRem(104),
      height: theme.typography.pxToRem(104)
    }), _defineProperty(_imageWrapLargeVarian, '& .fallbackPic', {
      backgroundSize: '80%',
      borderRadius: theme.spacing(0.5)
    }), _imageWrapLargeVarian),
    icon: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-400%, -50%)'
    },
    expandButton: {
      textAlign: 'center',
      fontWeight: theme.typography.fontWeights.bold,
      textTransform: 'initial',
      position: 'relative',
      cursor: 'pointer',
      '& svg': {
        verticalAlign: 'middle',
        marginBottom: theme.typography.pxToRem(3)
      }
    },
    buttonWrapper: (_buttonWrapper = {
      paddingTop: theme.spacing(5.5),
      marginBottom: theme.spacing(-0.5),
      textAlign: 'center'
    }, _defineProperty(_buttonWrapper, theme.breakpoints.down('sm'), {
      paddingTop: theme.spacing(3)
    }), _defineProperty(_buttonWrapper, '& a', {
      position: 'relative'
    }), _defineProperty(_buttonWrapper, '& svg', {
      display: 'inline-flex',
      marginRight: theme.spacing(0.5)
    }), _defineProperty(_buttonWrapper, '& span', {
      fontWeight: theme.typography.fontWeights.bolder,
      lineHeight: theme.typography.lineHeight.L9
    }), _buttonWrapper),
    gridWrapper: _defineProperty({
      '&.MuiGrid-spacing-xs-3': {
        '& .MuiGrid-item': _defineProperty({
          padding: theme.spacing(3)
        }, theme.breakpoints.down('sm'), {
          padding: theme.spacing(1.5)
        })
      }
    }, theme.breakpoints.down('sm'), {
      '&.MuiGrid-root': {
        marginTop: theme.spacing(-1.5),
        marginBottom: theme.spacing(-1.5)
      }
    }),
    ctaLinkWrapper: {
      marginTop: theme.spacing(3),
      marginLeft: theme.spacing(-0.5),
      '& a.MuiLink-root': {
        display: 'inline-flex'
      },
      '& a .MuiLink-startIcon': {
        marginRight: theme.spacing(0.75)
      },
      '& div': {
        display: 'inline-flex'
      }
    },
    ctaLink: {
      fontWeight: theme.typography.fontWeights.bolder
    },
    button: {
      height: 'auto'
    }
  });
};

var useStyle = makeStyles(function (theme) {
  return style(theme);
});

var List = function List(props) {
  var classes = useStyle();
  var color = get$1(props, "color", "white");
  var isMobile = useMediaQuery("(max-width:".concat(breakpoints.values.sm, "px)"));
  var isTablet = useMediaQuery("(max-width:".concat(breakpoints.values.lg, "px)"));

  var _useState = useState(3),
      _useState2 = _slicedToArray(_useState, 2),
      showBox = _useState2[0],
      setBoxval = _useState2[1];

  var cardVariant = get$1(props, "cardVariant", "");
  var cardCategory = get$1(props, "cardType", "").split("-");
  var cardType = cardCategory[0] || "";
  var cardSubType = cardCategory[1] || "";
  var imageVariant = get$1(props, "imageVariant", "Small"); // const { t: dict } = useTranslation();

  var dictionary = get$1(props, "dictionary", {
    seeMore: "See more"
  });

  var dict = function dict(key) {
    return dictionary[key];
  };

  var dictKey = "seeMore";
  var seeAllText = dict && dict(dictKey) !== dictKey ? dict(dictKey) : "See all";
  var gaCategoryName = props.gaCategoryName;
  var sizes = {
    Large: 4,
    Medium: 6,
    VerySmall: 8,
    Small: 8
  };
  var gridVariant = {
    mobile: {
      Large: 12,
      Medium: 12,
      Small: 12,
      VerySmall: 12
    },
    tablet: {
      Large: 12,
      Medium: 12,
      Small: 12,
      VerySmall: 12
    },
    desktop: {
      Large: 6,
      Medium: 4,
      Small: 3,
      VerySmall: 3
    }
  };
  var spacingVariant = {
    Large: 6,
    Medium: 6,
    VerySmall: 0,
    Small: 6
  };
  var linkItems = get$1(props, "fields.linkItems", []) || [];
  var navigate = get$1(props, "navigate", function (href) {
    if (typeof window !== "undefined") {
      window.open(href);
    }
  });

  var variantCheck = function variantCheck(variantName) {
    if (isMobile) {
      return gridVariant.mobile[variantName];
    } else if (isTablet) {
      return gridVariant.tablet[variantName];
    } else {
      return gridVariant.desktop[variantName];
    }
  };

  var getGridSpacing = function getGridSpacing(variantName) {
    return spacingVariant[variantName];
  }; //Update the SetBox value based on device type


  var size = sizes[cardVariant];

  var _AddMouseListener = AddMouseListener(),
      useKeyBoard = _AddMouseListener.useKeyBoard;

  useEffect(function () {
    if (isMobile) {
      setBoxval(size / 2);
    } else {
      setBoxval(size);
    }
  }, [isMobile]);

  var gridChecker = function gridChecker() {
    return isMobile ? size / 2 : size;
  };

  var showMoreDataHandler = function showMoreDataHandler() {
    var showCount = isMobile ? size / 2 : size;
    PushEvent({
      event: "buttonClick",
      buttonTitle: dictKey,
      componentName: gaCategoryName ? gaCategoryName : COMPONENT_BUTTON,
      destinationUrl: undefined
    }, props.gtmPushEvent);
    setBoxval(showBox + showCount);
  };

  var linkHandler = function linkHandler(link) {
    /* istanbul ignore else */
    if (link.value.linktype === "internal") {
      navigate(link.value.href);
    } else if (link.value.linktype === "external") {
      if (typeof window !== "undefined") {
        window.open(link.value.href, "_blank");
      }
    }
  };

  var handleKeyPress = function handleKeyPress(e, link) {
    var pressedKey = e.keyCode || e.which;

    if (pressedKey === 13) {
      linkHandler(link);
    }
  };
  /**
   * This function is to push dataLayer event when component is rendered for the first time.
   * Only runs when enableOptimize360 is enabled from the CMS.
   * FWDS-1513 & FWDS-1846
   */


  useEffect(function () {
    var enableOptimize360 = get$1(props, "sitecoreContext.siteSettings.optimize360", false);
    enableOptimize360 && PushEvent({
      event: "cardInfo_loaded",
      content: {}
    }, props.gtmPushEvent);
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    spacing: getGridSpacing(cardVariant),
    "data-locator": GRID_WRAPPER,
    className: classes.gridWrapper
  }, linkItems && linkItems.length > 0 && linkItems.slice(0, showBox).map(function (item, index) {
    var _clsx4;

    return /*#__PURE__*/React__default.createElement(StyledGrid, {
      item: true,
      sm: variantCheck(cardVariant),
      xs: 12,
      key: index,
      className: clsx(classes.gridCard, _defineProperty({}, classes.gridItemDynamic, showBox || index < gridChecker()), _defineProperty({}, classes.gridItem, !showBox && index >= gridChecker()), _defineProperty({}, classes.smallVarientPadding, cardVariant === "Small" || cardVariant === "VerySmall")),
      "data-locator": GRID_ITEM,
      "data-locator-after-show-all": index < gridChecker() ? false : true
    }, /*#__PURE__*/React__default.createElement("div", {
      onClick: cardType !== "InfoCard" && get$1(item, "fields.link.value.href", null) ? function () {
        return linkHandler(get$1(item, "fields.link", null));
      } : undefined,
      onKeyPress: cardType !== "InfoCard" && get$1(item, "fields.link.value.href", null) ? function (e) {
        return handleKeyPress(e, get$1(item, "fields.link", null));
      } : undefined,
      className: cardType !== "InfoCard" && clsx(classes.divClass, (_clsx4 = {}, _defineProperty(_clsx4, classes.cardWithLink, get$1(item, "fields.link.value.href", null)), _defineProperty(_clsx4, "hideFocusonClick", !useKeyBoard), _clsx4)),
      tabIndex: cardType !== "InfoCard" && get$1(item, "fields.link.value.href", null) ? "0" : undefined
    }, get$1(item, "fields.image", false) && get$1(item, "fields.mobileImage", false) && /*#__PURE__*/React__default.createElement("div", {
      className: imageVariant === "Large" ? classes.imageWrapLargeVariant : classes.imageWrapSmallVariant
    }, /*#__PURE__*/React__default.createElement(Picture, {
      media: {
        image: defaultsDeep({
          value: _objectSpread2(_objectSpread2({}, get$1(item, "fields.image.value", "")), get$1(item, "fields.image.value.".concat(imageVariant), ""))
        }, get$1(item, "fields.image", "")),
        mobileImage: defaultsDeep({
          value: _objectSpread2(_objectSpread2({}, get$1(item, "fields.mobileImage.value", "")), get$1(item, "fields.mobileImage.value.".concat(imageVariant), ""))
        }, get$1(item, "fields.mobileImage", "")),
        minWidth: 720,
        aspectRatio: {
          mobile: "1-1",
          desktop: "1-1",
          tablet: "1-1"
        }
      },
      "data-locator": COMPONENT_INFO_IMAGE,
      borderRadiusOption: "small",
      hasBorderRadius: cardSubType.toUpperCase() === infoCardVariation.ESG ? false : true
    })), get$1(item, "fields.title", false) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "h5",
      component: "h3",
      className: classes.infoTitle,
      "data-locator": COMPONENT_INFO_TITLE,
      color: color
    }, item.fields.title.value), !isEmpty(get$1(item, "fields.description.value", "")) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
      variant: "body1",
      component: "div",
      className: classes.infoDescription,
      "data-locator": COMPONENT_INFO_DESCRIPTION,
      color: color,
      type: "richtext"
    }, /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: item.fields.description.value
      }
    }))), !isEmpty(get$1(item, "fields.link.value", {})) && cardType === "InfoCard" && get$1(item, "fields.buttonMode.fields.value.value") === "SimpleLink" && /*#__PURE__*/React__default.createElement("div", {
      className: classes.ctaLinkWrapper
    }, /*#__PURE__*/React__default.createElement(DynamicLink$1, _extends({}, get$1(item, "fields.link", {}), {
      color: color,
      typographyProps: {
        type: "action",
        variant: "h10",
        className: classes.ctaLink
      },
      icon: get$1(item, "fields.buttonIcon.fields.value.value", null),
      "data-locator": COMPONENT_CTA,
      GTMSharedKey: get$1(item, "fields.linkGALabelName", ""),
      gaCategoryName: get$1(item, "fields.gaCategoryName", "")
    }))), !isEmpty(get$1(item, "fields.link.value", {})) && cardType === "InfoCard" && (get$1(item, "fields.buttonMode.fields.value.value") === "Primary" || get$1(item, "fields.buttonMode.fields.value.value") === "Secondary") && /*#__PURE__*/React__default.createElement(Box$2, {
      className: classes.ctaLinkWrapper
    }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, _extends({}, get$1(item, "fields.link", {}), {
      color: color,
      typographyProps: {
        type: "action",
        variant: "h10",
        className: classes.ctaLink
      },
      id: "link",
      role: "link",
      component: "a",
      target: get$1(item, "fields.link.value.linktype", "") === "internal" ? "_self" : "_blank",
      onClick: function onClick() {
        linkHandler(get$1(item, "fields.link", null));
      },
      "data-locator": COMPONENT_CTA,
      GTMSharedKey: get$1(item, "fields.linkGALabelName", ""),
      gaCategoryName: get$1(item, "fields.gaCategoryName", "")
    }), get$1(item, "fields.buttonMode.fields.value.value") === "Primary" && /*#__PURE__*/React__default.createElement(StyledMemoizedButton, {
      icon: get$1(item, "fields.buttonIcon.fields.value.value", null),
      className: "button",
      color: color
    }, get$1(item, "fields.link.value.text", "")), get$1(item, "fields.buttonMode.fields.value.value") === "Secondary" && /*#__PURE__*/React__default.createElement(StyledMemoizedButton, _extends({
      icon: get$1(item, "fields.buttonIcon.fields.value.value", null),
      color: color
    }, {
      outlined: true
    }), get$1(item, "fields.link.value.text", "")))));
  })), linkItems && linkItems.length > showBox && /*#__PURE__*/React__default.createElement("div", {
    item: true,
    className: classes.buttonWrapper,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedLink, {
    underline: "none",
    component: "div",
    size: "small",
    variant: "body1",
    "data-locator": COMPONENT_BUTTON,
    className: classes.expandButton,
    onClick: showMoreDataHandler,
    color: color,
    icon: "plus",
    linkMode: "SimplePrimaryLink"
  }, seeAllText)));
}; // export default withSitecoreContext()(List);

var useStyles$2 = makeStyles(function (theme) {
  return style$2(theme);
});

var CardList$1 = function CardList(props) {
  var anchorText = get$1(props, 'params.anchorText', "Card-List + ".concat(getRandomValues())).replace(/\s+/g, '-'); // To be used in future for Usefull components
  // Get the grid column from FlexiContainer component

  var flexiCol = props.flexiCol && parseInt(props.flexiCol) || null;
  var description = get$1(props, 'fields.description', {});
  var title = get$1(props, 'fields.title', {});
  var subTitle = get$1(props, 'fields.subTitle', {});
  var gaCategoryName = get$1(props, 'fields.gaCategoryName.value', null);
  var _props$params = props.params;
  _props$params = _props$params === void 0 ? {} : _props$params;
  var _props$params$cardVar = _props$params.cardVariant,
      cardVariant = _props$params$cardVar === void 0 ? 'base' : _props$params$cardVar,
      _props$params$imageVa = _props$params.imageVariant,
      imageVariant = _props$params$imageVa === void 0 ? 'Small' : _props$params$imageVa,
      _props$params$cardSty = _props$params.cardStyle,
      cardStyle = _props$params$cardSty === void 0 ? '' : _props$params$cardSty,
      _props$params$cardTyp = _props$params.cardType,
      cardType = _props$params$cardTyp === void 0 ? '' : _props$params$cardTyp;

  var _getColors = getColors(get$1(props, 'params.backgroundColor', 'white-white')),
      bgColor = _getColors.bgColor;

  var linkItems = get$1(props, 'fields.linkItems', []);
  var pageEditing = get$1(props, 'pageEditing', false); // Bacground color of the component

  var classes = useStyles$2();
  var primaryCta = get$1(props, 'fields.link.value', null) ? get$1(props, 'fields.link', null) : null;
  var primaryCtaGTM = get$1(props, 'fields.linkGALabelName.value', '');
  var params = props.params ? props.params : {};
  var dividerLine = params.divider ? params.divider : '0';
  var navigate = get$1(props, 'navigate', function (href) {
    if (typeof window !== 'undefined') {
      window.open(href);
    }
  });
  return pageEditing || title && title.value || linkItems && linkItems.length > 0 ? /*#__PURE__*/React__default.createElement(Container$1, {
    className: clsx(classes.root, classes.rootContainer, getPaddingString(params), dividerLine === '1' ? "component-divider-".concat(bgColor) : ''),
    id: anchorText,
    useContainer: !flexiCol,
    background: bgColor,
    overflowHidden: true
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(flexiCol ? getPaddingString(params) : '', _defineProperty({}, classes.tabCardList, props.className === 'tabCardList'), _defineProperty({}, classes.flexiRoot, flexiCol && props.className !== 'tabCardList')),
    "data-locator": CARDLIST_CONTAINER
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    xs: 12,
    lg: 9
  }, !isEmpty(title.value) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: 'h2',
    component: 'h2',
    color: bgColor,
    className: clsx(classes.title, _defineProperty({}, 'withoutDesc', isEmpty(description.value))),
    "data-locator": CARDLIST_TITLE,
    fontWeight: 'bolder'
  }, title.value), !isEmpty(subTitle.value) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: 'body1',
    component: 'div',
    color: bgColor,
    className: classes.text,
    "data-locator": CARDLIST_SUBTITLE
  }, subTitle.value), !isEmpty(description.value) && /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: 'body1',
    component: 'div',
    color: bgColor,
    className: clsx(classes.description, _defineProperty({}, classes.smallCardPadding, cardVariant === 'Small' || cardVariant === 'VerySmall')),
    "data-locator": CARDLIST_DESCRIPTION,
    type: 'richtext'
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description.value
    }
  }))), cardStyle === 'Carousel' && /*#__PURE__*/React__default.createElement(Carousel, {
    gaCategoryName: gaCategoryName,
    fields: _objectSpread2({}, props.fields),
    color: bgColor,
    alignItem: "left",
    flexiCol: flexiCol,
    navigate: navigate
  }), cardStyle === 'Stage' && /*#__PURE__*/React__default.createElement(List, {
    fields: _objectSpread2({}, props.fields),
    color: bgColor,
    alignItem: "left",
    flexiCol: flexiCol,
    cardVariant: cardVariant,
    cardType: cardType,
    imageVariant: imageVariant,
    gaCategoryName: gaCategoryName,
    navigate: navigate,
    gtmPushEvent: props.gtmPushEvent
  }), !isEmpty(get$1(primaryCta, 'value', {})) && /*#__PURE__*/React__default.createElement("div", {
    className: classes.linkWrapper
  }, /*#__PURE__*/React__default.createElement(DynamicLink$1, _extends({}, primaryCta, {
    className: classes.link,
    gaCategoryName: gaCategoryName,
    color: bgColor,
    type: 'caption',
    icon: get$1(props, 'fields.buttonIcon.fields.value.value', null),
    "data-locator": CARDLIST_PRIMARY_CTA,
    GTMSharedKey: primaryCtaGTM,
    gtmPushEvent: props.gtmPushEvent
  }))))) : null;
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var styles = function styles(theme) {
  var _slider, _slickList, _slideWrap;

  return {
    ctitle: _defineProperty({
      paddingBottom: theme.spacing(6),
      //'48px',
      marginBottom: '0px'
    }, theme.breakpoints.down('xs'), {
      paddingBottom: theme.spacing(3) //'24px',

    }),
    slider: (_slider = {
      marginLeft: theme.spacing(-2),
      marginRight: theme.spacing(-2)
    }, _defineProperty(_slider, theme.breakpoints.up('sm'), {
      marginLeft: theme.spacing(-1.5),
      marginRight: theme.spacing(-1.5)
    }), _defineProperty(_slider, '&.error', _defineProperty({}, theme.breakpoints.down('xs'), {
      marginLeft: theme.spacing(0),
      marginRight: theme.spacing(0)
    })), _slider),
    sliderWrap: _defineProperty({
      '& .slick-list': (_slickList = {}, _defineProperty(_slickList, theme.breakpoints.down('sm'), {
        paddingLeft: "".concat(theme.spacing(1.5), "px !important")
      }), _defineProperty(_slickList, theme.breakpoints.up('sm'), {
        paddingBottom: theme.spacing(1.5),
        marginBottom: theme.spacing(-2)
      }), _defineProperty(_slickList, '& img', {
        height: '100%'
      }), _slickList),
      '& .slick-prev, .slick-next': {
        width: theme.spacing(4),
        height: theme.spacing(4),
        zIndex: '1'
      },
      '& .slick-prev': _defineProperty({
        transform: 'translate(0, -50%) rotate(180deg)',
        left: theme.spacing(-2.5)
      }, theme.breakpoints.up('xl'), {
        left: theme.spacing(-4.5)
      }),
      '& .slick-next': _defineProperty({
        right: theme.spacing(-2.5)
      }, theme.breakpoints.up('xl'), {
        right: theme.spacing(-4.5)
      }),
      '& .slick-disabled ': {
        opacity: '0',
        pointerEvents: 'none'
      }
    }, theme.breakpoints.down('sm'), {
      marginBottom: theme.spacing(-0.5)
    }),
    slideWrap: (_slideWrap = {
      height: '100%',
      outline: 'none',
      padding: "0 ".concat(theme.spacing(0.5), "px")
    }, _defineProperty(_slideWrap, theme.breakpoints.up('sm'), {
      padding: "0 ".concat(theme.spacing(1.5), "px")
    }), _defineProperty(_slideWrap, '& .MuiContainer-root', {
      paddingLeft: '0px',
      paddingRight: '0px'
    }), _slideWrap)
  };
};

/*9fbef606107a605d69c0edbcd8029e5d*/
var COMPONENT_CONTAINER = 'RelatedArticles';
var COMPONENT_TITLE = 'RelatedArticles-Title';
var COMPONENT_NEXT_BUTTON = 'RelatedArticles-Next-Button';
var COMPONENT_PREV_BUTTON = 'RelatedArticles-Prev-Button';

var useStyles$1 = makeStyles(function (theme) {
  return styles(theme);
});

var RelatedArticles$1 = function RelatedArticles(props) {
  var params = get$1(props, 'params', {});
  var anchorText = get$1(props, 'params.anchorText', 'Related-Articles').replace(/\s+/g, '-');
  var flexiCol = parseInt(props.flexiCol) || null;
  var color = get$1(props, 'params.backgroundColor', 'white-white');

  var _getColors = getColors(color),
      bgColor = _getColors.bgColor,
      surfaceColor = _getColors.surfaceColor;

  var classes = useStyles$1();
  var apiContentType = get$1(props, 'fields.apiContentType.fields', {});
  var apiPageSize = get$1(props, 'fields.apiPageSize.value', '');
  var apiUrl = get$1(apiContentType, 'value.value', '');
  var authorizationKey = get$1(apiContentType, 'key.value', '');
  var apiSortBy = get$1(props, 'fields.apiSortBy.fields.value.value', '');
  var topics = get$1(props, 'sitecoreContext.route.fields.topics', []);
  var subTopics = get$1(props, 'sitecoreContext.route.fields.subTopics', []);
  var itemLanguage = get$1(props, 'sitecoreContext.route.itemLanguage', 'en') || 'en';
  apiUrl = apiUrl.replace('{language}', itemLanguage);
  var topicList = topics.map(function (topic) {
    return get$1(topic, 'fields.name.value', '');
  });
  var subtopicList = subTopics.map(function (subTopic) {
    return get$1(subTopic, 'fields.name.value', '');
  });

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      articles = _useState2[0],
      setArticles = _useState2[1];

  var searchLink = get$1(props, 'fields.SearchLink.href', '');
  var contentType = get$1(props, 'sitecoreContext.route.fields.contentType.fields.name.value', '');
  var itemId = get$1(props, 'sitecoreContext.route.itemId', '');
  var subType = get$1(props, 'sitecoreContext.route.fields.subtype.fields.name.value', '');
  var linkItems = get$1(props, 'fields.linkItems', []) || [];
  var hasDividerLine = !!parseInt(get$1(props, 'params.divider', '0'), 10);
  var filteredLinkItems = linkItems.filter(function (item) {
    return get$1(item, 'fields.isPageSearchableWithoutDisclosureAcceptance.value', true) || !get$1(item, 'fields.riskDisclosure.value', '') || getAcceptedRiskDisclosureKeyList(disclosurePopups.ACCEPTED_DISCLOSURES).includes(get$1(item, 'fields.riskDisclosure.value', ''));
  });
  var title = get$1(props, 'fields.title');
  var locationType = get$1(props, 'sitecoreContext.site.name', 'fwd-th');
  var isManualSelection = filteredLinkItems && filteredLinkItems.length > 0; // const {
  //   relatedArticles: { loading, error = false },
  // } = props;

  var loading = get$1(props, 'relatedArticles.loading', false);
  var error = get$1(props, 'relatedArticles.error', false);
  var exclusionList = [itemId].concat(_toConsumableArray(get$1(props, 'relatedArticles.exclusionList', [])));
  var gaCategoryName = get$1(props, 'fields.gaCategoryName.value', null);
  var pageEditing = get$1(props, 'sitecoreContext.pageEditing', false);
  var articleOverlineText = get$1(props, 'sitecoreContext.siteSettings.articleOverlineText', false);
  var shareOptions = get$1(props, 'sitecoreContext.share.socialApps', []);
  var navigate = get$1(props, 'navigate', function (href) {
    if (typeof window !== 'undefined') {
      window.open(href);
    }
  });
  var navigateChip = get$1(props, 'navigateChip', function (href) {
    if (typeof window !== 'undefined') {
      window.open(href);
    }
  }); // refs

  var sliderWrapperRef = /*#__PURE__*/createRef(); // methods

  var updateMaxHeight = function updateMaxHeight() {
    /* istanbul ignore else */
    if (sliderWrapperRef.current) {
      var cardElms = sliderWrapperRef.current.querySelectorAll('.articlecard--Medium');
      var cardContentWrapperElms = sliderWrapperRef.current.querySelectorAll('.articlecard--Medium .cardContentWrapper');
      var cardContentElms = sliderWrapperRef.current.querySelectorAll('.articlecard--Medium .cardContent');
      /* istanbul ignore else */

      if (cardElms.length) {
        // reset
        _toConsumableArray(cardElms).forEach(function (elm) {
          elm.style.height = '';
          elm.querySelector('.cardContentWrapper').style.position = '';
          elm.querySelector('.cardContent').style.minHeight = '';
        }); // get and apply maxHeight of .cardContent


        var mh = getMaxHeight(cardContentElms);

        _toConsumableArray(cardContentElms).forEach(function (elm) {
          elm.style.minHeight = "".concat(mh, "px");
        }); // get and apply maxHeight of .articlecard--Medium


        mh = getMaxHeight(cardElms);

        _toConsumableArray(cardElms).forEach(function (elm) {
          return elm.style.height = "".concat(mh, "px");
        }); // apply position absolute to align bottom


        _toConsumableArray(cardContentWrapperElms).forEach(function (elm) {
          elm.style.position = 'absolute';
        });
      }
    }
  }; // effects


  useEffect(function () {
    !isManualSelection && props.getRelatedArticles({
      apiUrl: apiUrl,
      authorizationKey: authorizationKey,
      itemId: exclusionList,
      apiSortBy: apiSortBy,
      topics: topicList,
      subTopics: subtopicList,
      contentType: contentType,
      contentSubType: subType,
      pageSize: apiPageSize,
      locationType: locationType
    });
  }, [exclusionList.length]);
  useEffect(function () {
    var mutatedArticles = isManualSelection ? filteredLinkItems : get$1(props, 'relatedArticles.data', []).map(function (item) {
      var _item$topics;

      var keywords = [];
      item.featuredTags.forEach(function (tag) {
        keywords.push({
          fields: {
            name: {
              value: tag
            },
            link: {
              value: {
                href: "".concat(searchLink, "?contenttype=").concat(item.contentType, "&subType=").concat(item.contentSubType, "&tag=").concat(tag)
              }
            }
          }
        });
      });
      return {
        params: {
          cardVariant: 'Medium',
          backgroundColor: surfaceColor
        },
        fields: {
          image: get$1(item, 'image.image', null),
          mobileImage: get$1(item, 'mobileImage.mobileImage', null),
          subtype: {
            fields: {
              name: {
                value: !articleOverlineText ? item.contentSubType : ((_item$topics = item.topics) === null || _item$topics === void 0 ? void 0 : _item$topics.length) > 0 ? item.topics[0] : item.contentSubType
              }
            }
          },
          articleTitle: {
            value: item.title
          },
          shortDescription: {
            value: item.shortDescription
          },
          metadataDescription: {
            value: item.metadataDescription
          },
          featuredTags: keywords,
          link: {
            value: {
              href: item.pageUrl
            }
          }
        },
        color: color
      };
    });
    setArticles(mutatedArticles);
  }, [props]);
  useEffect(function () {
    setTimeout(function () {
      updateMaxHeight();
    }, 1500);
  }, [sliderWrapperRef]);
  var currentSlide = 0;
  var skeletonSlickSettings = {
    slidesToShow: 3,
    infinite: false,
    responsive: [{
      breakpoint: 480,
      settings: {
        slidesToShow: 1.2
      }
    }]
  };
  var settings = {
    slidesToShow: 3,
    infinite: false,
    arrows: true,
    centerPadding: '0px',
    cssEase: transitionFunction.easeInOut,
    beforeChange: function beforeChange(current, next) {
      /* istanbul ignore if */
      if (next < currentSlide) {
        PushEvent({
          event: 'buttonClick',
          buttonTitle: COMPONENT_PREV_BUTTON,
          destinationUrl: undefined,
          componentName: gaCategoryName ? gaCategoryName : COMPONENT_CONTAINER
        }, props.gtmPushEvent);
      } else {
        PushEvent({
          event: 'buttonClick',
          buttonTitle: COMPONENT_NEXT_BUTTON,
          destinationUrl: undefined,
          componentName: gaCategoryName ? gaCategoryName : COMPONENT_CONTAINER
        }, props.gtmPushEvent);
      }

      currentSlide = next;
    },
    nextArrow: /*#__PURE__*/React__default.createElement(ArrowForward, {
      "data-locator": COMPONENT_NEXT_BUTTON,
      "aria-label": COMPONENT_NEXT_BUTTON
    }),
    prevArrow: /*#__PURE__*/React__default.createElement(ArrowForward, {
      "data-locator": COMPONENT_PREV_BUTTON,
      "aria-label": COMPONENT_PREV_BUTTON
    }),
    responsive: [{
      breakpoint: 1288,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerPadding: '32px',
        swipeToSlide: true,
        arrows: true
      }
    }, {
      breakpoint: 600,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '32px',
        swipeToSlide: true,
        arrows: false,
        dots: true
      }
    }]
  };
  return (pageEditing || articles && (isManualSelection ? articles.length > 0 : true)) && /*#__PURE__*/React__default.createElement(Container$1, {
    id: anchorText,
    useContainer: !flexiCol,
    background: bgColor,
    className: clsx(classes.container, getPaddingString(params), hasDividerLine ? "component-divider-".concat(bgColor) : ''),
    "data-locator": COMPONENT_CONTAINER
  }, /*#__PURE__*/React__default.createElement(StyledGrid, {
    item: true,
    md: 8,
    xs: 12,
    className: clsx(flexiCol ? getPaddingString(params) : ''),
    "data-locator": COMPONENT_TITLE
  }, /*#__PURE__*/React__default.createElement(StyledMemoizedTypography, {
    variant: "h2",
    component: "h2",
    className: classes.ctitle,
    color: bgColor,
    fontWeight: 'bolder'
  }, title.value)), /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.slider, {
      error: error
    }),
    ref: sliderWrapperRef
  }, loading && !error && /*#__PURE__*/React__default.createElement(SkeletonView, {
    count: 3,
    type: 'RelatedArticlesList',
    settings: skeletonSlickSettings
  }), error && /*#__PURE__*/React__default.createElement(StyledGrid, {
    container: true,
    item: true,
    xs: 12,
    justifyContent: "center",
    alignItems: 'center'
  }, /*#__PURE__*/React__default.createElement(ApiError, null)), /*#__PURE__*/React__default.createElement(Carousel$1, {
    settings: settings,
    className: classes.sliderWrap,
    color: bgColor
  }, articles && _toConsumableArray(articles).filter(function (item) {
    return item.fields && item.fields.articleTitle && item.fields.articleTitle.value;
  }).map(function (item, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: classes.slideWrap,
      key: index
    }, /*#__PURE__*/React__default.createElement(ArticleCard$1, _extends({}, item, {
      params: props.params,
      shareOptions: shareOptions,
      gaCategoryName: gaCategoryName,
      onClick: function onClick(e) {
        if ((e.ctrlKey || e.metaKey) && typeof window !== 'undefined') {
          window.open(item.fields.link.value.href, '_blank');
        } else if (item.fields.link.value.linktype === 'external') {
          if (typeof window !== 'undefined') {
            window.open(item.fields.link.value.href, '_blank');
          }
        } else {
          navigate(item.fields.link.value.href);
        }
      },
      hasParent: true,
      onResize: updateMaxHeight,
      pageEditing: pageEditing,
      navigate: navigate,
      navigateChip: navigateChip,
      gtmPushEvent: props.gtmPushEvent
    })));
  }))));
}; // export const mapStateToProps = createStructuredSelector({

/*9fbef606107a605d69c0edbcd8029e5d*/
(function () {
  /**
   * Manage Session Timeout
   */
  if (typeof window !== 'undefined' && typeof window.Storage !== 'undefined') {
    var elm = document.querySelector('[data-timeout]');
    var totalSessionTime = elm && elm.dataset ? elm.dataset.timeout : '20';
    var sessionTimeInMilliSeconds = 1000 * 60 * parseInt(totalSessionTime);
    var sessionTimeout = null;
    var events = ['keydown', 'mousedown', 'touchstart'];

    for (var event in events) {
      window.addEventListener(events[event], resetTimeout);
    }
  }

  function resetTimeout() {
    if (sessionTimeout) clearTimeout(sessionTimeout);
    setSessionTimeout();
  }

  function setSessionTimeout() {
    sessionTimeout = setTimeout(sessionExpired, sessionTimeInMilliSeconds);
  }

  function sessionExpired() {
    if (typeof window !== 'undefined') {
      window.sessionStorage.clear();
      window.location.reload();
    }
  }
  /**
   * Code for Mobile Detection
   */


  if (typeof window !== 'undefined') {
    var ua = navigator.userAgent.toLowerCase();

    var detect = function detect(s) {
      if (s !== undefined) ua = s.toLowerCase();
      if (/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(ua)) return 'TABLET';else if (/(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(ua)) return 'MOBILE';else return 'DESKTOP';
    };

    window.DeviceDetection = {
      device: detect(),
      detect: detect,
      isMobile: detect() === 'MOBILE',
      isTablet: detect() === 'TABLET',
      isDesktop: detect() === 'DESKTOP',
      userAgent: ua
    };
  }
})();

var e=[],t=[];function n(n,r){if(n&&"undefined"!=typeof document){var a,s=!0===r.prepend?"prepend":"append",d=!0===r.singleTag,i="string"==typeof r.container?document.querySelector(r.container):document.getElementsByTagName("head")[0];if(d){var u=e.indexOf(i);-1===u&&(u=e.push(i)-1,t[u]={}),a=t[u]&&t[u][s]?t[u][s]:t[u][s]=c();}else a=c();65279===n.charCodeAt(0)&&(n=n.substring(1)),a.styleSheet?a.styleSheet.cssText+=n:a.appendChild(document.createTextNode(n));}function c(){var e=document.createElement("style");if(e.setAttribute("type","text/css"),r.attributes)for(var t=Object.keys(r.attributes),n=0;n<t.length;n++)e.setAttribute(t[n],r.attributes[t[n]]);var a="prepend"===s?"afterbegin":"beforeend";return i.insertAdjacentElement(a,e),e}}

var css$6 = "/**\r\n * Slick slider common css rules\r\n */\r\n.slick-slider {\r\n  box-sizing: border-box;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  -webkit-touch-callout: none;\r\n  -khtml-user-select: none;\r\n  touch-action: pan-y;\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n.slick-list,\r\n.slick-slider {\r\n  position: relative;\r\n  display: block;\r\n}\r\n.slick-list {\r\n  overflow: hidden;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n.slick-list:focus {\r\n  outline: none;\r\n}\r\n.slick-list.dragging {\r\n  cursor: pointer;\r\n  cursor: hand;\r\n}\r\n.slick-slider .slick-list,\r\n.slick-slider .slick-track {\r\n  transform: translateZ(0);\r\n}\r\n.slick-track {\r\n  position: relative;\r\n  top: 0;\r\n  left: 0;\r\n  display: block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n.slick-track:after,\r\n.slick-track:before {\r\n  display: table;\r\n  content: '';\r\n}\r\n.slick-track:after {\r\n  clear: both;\r\n}\r\n.slick-loading .slick-track {\r\n  visibility: hidden;\r\n}\r\n.slick-slide {\r\n  display: none;\r\n  float: left;\r\n  height: 100%;\r\n  min-height: 1px;\r\n}\r\n[dir='rtl'] .slick-slide {\r\n  float: right;\r\n}\r\n.slick-slide img {\r\n  display: block;\r\n}\r\n.slick-slide.slick-loading img {\r\n  display: none;\r\n}\r\n.slick-slide.dragging img {\r\n  pointer-events: none;\r\n}\r\n.slick-initialized .slick-slide {\r\n  display: block;\r\n}\r\n.slick-loading .slick-slide {\r\n  visibility: hidden;\r\n}\r\n.slick-vertical .slick-slide {\r\n  display: block;\r\n  height: auto;\r\n  border: 1px solid transparent;\r\n}\r\n.slick-arrow.slick-hidden {\r\n  display: none;\r\n}\r\n.slick-next,\r\n.slick-prev {\r\n  font-size: 0;\r\n  line-height: 0;\r\n  position: absolute;\r\n  top: 50%;\r\n  display: block;\r\n  width: 20px;\r\n  height: 20px;\r\n  padding: 0;\r\n  transform: translateY(-50%);\r\n  cursor: pointer;\r\n  border: none;\r\n}\r\n.slick-next,\r\n.slick-next:focus,\r\n.slick-next:hover,\r\n.slick-prev,\r\n.slick-prev:focus,\r\n.slick-prev:hover {\r\n  color: transparent;\r\n  outline: none;\r\n  background: transparent;\r\n}\r\n.slick-next:focus:before,\r\n.slick-next:hover:before,\r\n.slick-prev:focus:before,\r\n.slick-prev:hover:before {\r\n  opacity: 1;\r\n}\r\n.slick-next.slick-disabled:before,\r\n.slick-prev.slick-disabled:before {\r\n  opacity: 0.25;\r\n}\r\n.slick-next:before,\r\n.slick-prev:before {\r\n  font-size: 20px;\r\n  line-height: 1;\r\n  opacity: 0.75;\r\n  color: #fff;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n.slick-prev {\r\n  left: -25px;\r\n}\r\n.slick-next {\r\n  right: -25px;\r\n}\r\n.slick-dotted.slick-slider {\r\n  margin-bottom: 30px;\r\n}\r\n.slick-dots {\r\n  position: absolute;\r\n  bottom: -25px;\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0;\r\n  margin: 0;\r\n  list-style: none;\r\n  text-align: center;\r\n}\r\n.slick-dots li {\r\n  position: relative;\r\n  display: inline-block;\r\n  margin: 0 5px;\r\n  padding: 0;\r\n}\r\n.slick-dots li,\r\n.slick-dots li button {\r\n  width: 20px;\r\n  height: 20px;\r\n  cursor: pointer;\r\n}\r\n.slick-dots li button {\r\n  font-size: 0;\r\n  line-height: 0;\r\n  display: block;\r\n  padding: 5px;\r\n  color: transparent;\r\n  border: 0;\r\n  outline: none;\r\n  background: transparent;\r\n}\r\n.slick-dots li button:focus,\r\n.slick-dots li button:hover {\r\n  outline: none;\r\n}\r\n.slick-dots li button:focus:before,\r\n.slick-dots li button:hover:before {\r\n  opacity: 1;\r\n}\r\n.slick-dots li button:before {\r\n  font-size: 24px;\r\n  line-height: 24px;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 20px;\r\n  height: 20px;\r\n  content: '•';\r\n  text-align: center;\r\n  opacity: 0.25;\r\n  color: #000;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n.slick-dots li.slick-active button:before {\r\n  opacity: 0.75;\r\n  color: #000;\r\n}\r\n";
n(css$6,{});

var css$5 = ".fallbackPic {\r\n  background-image: url(data:image/png;base64,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);\r\n  background-color: #edeff0;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  object-fit: scale-down;\r\n  height: auto;\r\n  width: 100%;\r\n}\r\n";
n(css$5,{});

var css$4 = "@keyframes buttonMouseIn {\r\n  0% {\r\n    left: -100%;\r\n  }\r\n  50% {\r\n    left: 0;\r\n  }\r\n  51% {\r\n    left: 0;\r\n  }\r\n  100% {\r\n    left: -100%;\r\n  }\r\n}\r\n\r\n@keyframes buttonMouseOut {\r\n  0% {\r\n    left: -100%;\r\n  }\r\n  50% {\r\n    left: 0;\r\n  }\r\n  51% {\r\n    left: 0;\r\n  }\r\n  100% {\r\n    left: -100%;\r\n  }\r\n}\r\n\r\n@keyframes modalOpening {\r\n  0% {\r\n    opacity: 0;\r\n    transform: scale(0.5, 0.5);\r\n  }\r\n  75% {\r\n    opacity: 1;\r\n    transform: scale(1, 1);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1, 1);\r\n  }\r\n}\r\n\r\n@keyframes modalClosing {\r\n  0% {\r\n    opacity: 1;\r\n    transform: scale(1, 1);\r\n  }\r\n  25% {\r\n    opacity: 1;\r\n    transform: scale(1, 1);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: scale(0.5, 0.5);\r\n  }\r\n}\r\n\r\n@keyframes moveDownAndFadeIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(-50px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes moveDownAndFadeInTop {\r\n  0% {\r\n    opacity: 0;\r\n    top: -40px;\r\n    pointer-events: none;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    top: 0;\r\n    pointer-events: auto;\r\n  }\r\n}\r\n\r\n@keyframes moveUpAndFadeOut {\r\n  0% {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translateY(-50px);\r\n  }\r\n}\r\n\r\n@keyframes moveUpAndFadeIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(50px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes moveDownAndFadeOut {\r\n  0% {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translateY(50px);\r\n  }\r\n}\r\n\r\n@keyframes scaleUpAndFadeIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform: scale(0.5, 0.5);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1, 1);\r\n  }\r\n}\r\n\r\n@keyframes scaleDownAndFadeOut {\r\n  0% {\r\n    opacity: 1;\r\n    transform: scale(1, 1);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: scale(0.5, 0.5);\r\n  }\r\n}\r\n\r\n@keyframes fadeOut {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes pulse {\r\n  0% {\r\n    transform: scale(1, 1);\r\n  }\r\n  50% {\r\n    opacity: 0.3;\r\n  }\r\n  100% {\r\n    transform: scale(1.5);\r\n    opacity: 0;\r\n  }\r\n}\r\n";
n(css$4,{});

var css$3 = ".radioBtn-common-conversation .icon {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.radioBtn-common-conversation.rippleEffect {\r\n  background-size: 200% 100%;\r\n  background-color: unset;\r\n  background-position: right bottom;\r\n}\r\n.radioBtn-common-conversation.rippleEffect:hover {\r\n  background-color: unset;\r\n  background-position: -1px bottom;\r\n}\r\ninput:disabled ~ .radioBtn-common-conversation .icon {\r\n  background: rgba(206, 217, 224, 0.5);\r\n  box-shadow: none;\r\n}\r\n\r\n.radioBtn-common-regular .icon {\r\n  width: 1.25rem;\r\n  height: 1.25rem;\r\n  border-radius: 50%;\r\n}\r\n.radioBtn-common-regular.rippleEffect {\r\n  transition: all 0.5s ease-out;\r\n  background-size: 200% 100%;\r\n  background-color: unset;\r\n  background-position: right bottom;\r\n}\r\n.radioBtn-common-regular.rippleEffect:hover {\r\n  background-color: unset;\r\n  background-position: -1px bottom;\r\n}\r\n.radioBtn-common-regular .checkedIcon:before {\r\n  top: 0.25rem;\r\n  left: 0.25rem;\r\n  width: 0.75rem;\r\n  height: 0.75rem;\r\n  content: '';\r\n  display: block;\r\n  position: relative;\r\n  border-radius: 50%;\r\n}\r\n\r\n.checkbox-common {\r\n  background: transparent;\r\n}\r\n.checkbox-common .icon {\r\n  border-radius: 0.25rem;\r\n}\r\n.checkbox-common .checkedIcon {\r\n  width: 1.25rem;\r\n  height: 1.25rem;\r\n  overflow: hidden;\r\n  border-radius: 0.25rem;\r\n}\r\n.checkbox-common.rippleEffect {\r\n  background-size: 200% 100%;\r\n  background-color: unset;\r\n  background-position: right bottom;\r\n}\r\n.checkbox-common.rippleEffect:hover {\r\n  background-color: unset;\r\n  background-position: -1px bottom;\r\n}\r\n.checkbox-common .checkedIcon svg {\r\n  display: block;\r\n}\r\n.checkbox-common .checkedIcon .icon {\r\n  border: none;\r\n}\r\n\r\n.dropdown-form-common-conversation.rippleEffect {\r\n  background-size: 200% 100%;\r\n  background-color: unset;\r\n  background-position: right bottom;\r\n}\r\n.dropdown-form-common-conversation.rippleEffect:hover {\r\n  background-color: unset;\r\n  background-position: -1px bottom;\r\n}\r\n\r\n.dropdown-form-common-regular {\r\n  height: 40px;\r\n  border-radius: 0;\r\n}\r\n.dropdown-form-common-regular.rippleEffect {\r\n  background-size: 200% 100%;\r\n  background-color: unset;\r\n  background-position: right bottom;\r\n}\r\n.dropdown-form-common-regular.rippleEffect:hover {\r\n  background-color: unset;\r\n  background-position: -1px bottom;\r\n}\r\n.dropdown-form-common-regular.nonEmptyField:before {\r\n  display: none;\r\n}\r\n.dropdown-form-common-regular.nonEmptyField svg {\r\n  top: calc(50% - 8px);\r\n  right: 8px;\r\n}\r\n.dropdown-form-common-regular.nonEmptyField .MuiSelect-select {\r\n  font-weight: 300;\r\n  line-height: 1.25rem;\r\n  padding-top: 0.625rem;\r\n  padding-bottom: 0.625rem;\r\n}\r\n\r\n.datalist-common-conversation.rippleEffect {\r\n  background-size: 200% 100%;\r\n  background-color: unset;\r\n  background-position: right bottom;\r\n}\r\n.datalist-common-conversation.rippleEffect:hover {\r\n  background-color: unset;\r\n  background-position: -1px bottom;\r\n}\r\n\r\n.datalist-common-regular.rippleEffect {\r\n  transition: all 0.5s ease-out;\r\n  background-size: 200% 100%;\r\n  background-color: unset;\r\n  background-position: right bottom;\r\n}\r\n.datalist-common-regular.rippleEffect:hover {\r\n  background-color: unset;\r\n  background-position: -1px bottom;\r\n}\r\n\r\n.carouselarrowbuttonCommon.slick-arrow {\r\n  width: 40px;\r\n  height: 40px;\r\n  display: inline-flex !important;\r\n  z-index: 2;\r\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\r\n  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);\r\n  align-items: center;\r\n  border-radius: 50%;\r\n  justify-content: center;\r\n}\r\n.carouselarrowbuttonCommon.slick-arrow svg {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n.carouselarrowbuttonCommon.slick-arrow:before {\r\n  display: none;\r\n}\r\n.carouselarrowbuttonCommon.slick-arrow.slick-disabled {\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n.carouselarrowbuttonCommon.slick-arrow:hover {\r\n  border-radius: 50% !important;\r\n}\r\n.carouselarrowbuttonCommon.slick-arrow.slick-prev svg {\r\n  transform: rotate(180deg);\r\n}\r\n";
n(css$3,{});

var css$2 = ".branding-icon {\r\n  display: inline-block;\r\n  position: relative;\r\n}\r\n.branding-icon svg {\r\n  top: 50%;\r\n  left: 50%;\r\n  position: absolute;\r\n  transform: translate(-50%, -50%);\r\n}\r\n.branding-icon circle {\r\n  display: none;\r\n}\r\n.branding-icon rect {\r\n  display: none;\r\n}\r\n.branding-icon svg path {\r\n  fill: currentColor;\r\n}\r\n.branding-icon-default {\r\n  border: 2px solid transparent;\r\n  box-sizing: content-box;\r\n}\r\n\r\n.branding-icon-sm {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n.branding-icon-sm svg {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n.branding-icon-md {\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n.branding-icon-md svg {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n.branding-icon-lg {\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n.branding-icon-lg svg {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n.branding-icon-xl {\r\n  width: 48px;\r\n  height: 48px;\r\n}\r\n.branding-icon-xl svg {\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n.branding-icon-xxl {\r\n  width: 64px;\r\n  height: 64px;\r\n}\r\n.branding-icon-xxl svg {\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n.branding-icon-sm-default {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n.branding-icon-sm-default svg {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.branding-icon-md-default {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n.branding-icon-md-default svg {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.branding-icon-lg-default {\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n.branding-icon-lg-default svg {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.branding-icon-xl-default {\r\n  width: 48px;\r\n  height: 48px;\r\n}\r\n.branding-icon-xl-default svg {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.branding-icon-xxl-default {\r\n  width: 64px;\r\n  height: 64px;\r\n}\r\n.branding-icon-xxl-default svg {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.icon-action-common svg {\r\n  border: 2px solid transparent;\r\n  box-sizing: content-box;\r\n  margin: -2px;\r\n  background-color: transparent;\r\n}\r\n.icon-action-common svg:hover {\r\n  border-radius: 4px;\r\n}\r\n\r\n.icon-close-common .MuiDialog-closeButton svg {\r\n  border: 2px solid transparent;\r\n  box-sizing: content-box;\r\n  margin: -2px;\r\n  background-color: transparent;\r\n}\r\n.icon-close-common .MuiDialog-closeButton svg:hover {\r\n  border-radius: 4px;\r\n}\r\n";
n(css$2,{});

var css$1 = ".gradientOverlayDefault::before {\r\n  content: ' ';\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 1;\r\n  pointer-events: none;\r\n  background: none;\r\n}\r\n.gradientOverlayVertical::before {\r\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 50%);\r\n}\r\n.gradientOverlayHorizontal::before {\r\n  background: linear-gradient(90deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 50%);\r\n}\r\n.gradientOverlayNone::before {\r\n  background: none;\r\n}\r\n@media screen and (min-width: 600px) {\r\n  .gradientOverlayVerticalTablet::before {\r\n    background: linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 50%);\r\n  }\r\n  .gradientOverlayHorizontalTablet::before {\r\n    background: linear-gradient(90deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 50%);\r\n  }\r\n  .gradientOverlayNoneTablet::before {\r\n    background: none;\r\n  }\r\n}\r\n@media screen and (min-width: 960px) {\r\n  .gradientOverlayVerticalDesktop::before {\r\n    background: linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 50%);\r\n  }\r\n  .gradientOverlayHorizontalDesktop::before {\r\n    background: linear-gradient(90deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 50%);\r\n  }\r\n  .gradientOverlayNoneDesktop::before {\r\n    background: none;\r\n  }\r\n}\r\n";
n(css$1,{});

var css = ".showFocusonTab .MuiSelect-select:focus,\r\n.showFocusonTab:focus {\r\n  outline: auto;\r\n}\r\n\r\n.showFocusOnButton:focus,\r\n.showFocusOnDiv + .Mui-focused {\r\n  outline: auto;\r\n  outline-color: #005fcc;\r\n  outline-style: solid;\r\n  outline-width: 2px;\r\n}\r\n\r\n.hidefocusonclick .Muiselect-select:focus,\r\n.hidefocusonclick svg:focus,\r\n.hidefocusonclick span:focus,\r\n.hideFocusonClick:focus {\r\n  outline: none;\r\n}\r\n.zopim {\r\n  z-index: 9 !important;\r\n}\r\n\r\n.hasDividerLine:after {\r\n  left: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  bottom: 0;\r\n  height: 1px;\r\n  margin: auto;\r\n  content: '';\r\n  position: absolute;\r\n  max-width: 1224px;\r\n  background-color: #dbdfe1;\r\n}\r\n@media (max-width: 1279px) {\r\n  .hasDividerLine:after {\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    margin: auto;\r\n    max-width: calc(100vw - 64px);\r\n  }\r\n}\r\n@media (max-width: 600px) {\r\n  .hasDividerLine:after {\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    margin: auto;\r\n    max-width: calc(100vw - 32px);\r\n  }\r\n}\r\n";
n(css,{});

var theme = theme$1();
var useStyles = makeStyles(theme.globals);

var withTheme = function withTheme(Component) {
  var themedComponent = function themedComponent(props) {
    useStyles();
    return (
      /*#__PURE__*/
      // <StylesProvider injectFirst>
      React__default.createElement(StylesProvider, null, /*#__PURE__*/React__default.createElement(ThemeProvider, {
        theme: theme
      }, /*#__PURE__*/React__default.createElement(Component, props)))
    );
  };

  return themedComponent;
};

var injectFontClassName = function injectFontClassName(lang) {
  var _document, _document$body, _document$body$classN;

  var classLang = "lang-".concat(lang.toUpperCase());

  if (typeof document !== "undefined" && ((_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : (_document$body$classN = _document$body.className) === null || _document$body$classN === void 0 ? void 0 : _document$body$classN.indexOf(classLang)) === -1) {
    var classes = document.body.className.split(" ").filter(function (cls) {
      return !cls.startsWith("lang-");
    });
    classes.push(classLang);
    document.body.className = classes.join(" ");
  }
};
var Header = withTheme(Header$1);
var DisclosurePopup = withTheme(DisclosurePopup$1);
var Footer = withTheme(Footer$1);
var FormsHOC = withTheme(NextGenFormsHOC);
var CookieBanner = withTheme(NextGenCookieBanner);
var Button = withTheme(StyledMemoizedButton);
var Chip = withTheme(FwdChip);
var NamedIcon = withTheme(NamedIcon$1);
var Dropdown = withTheme(Dropdown$1);
var SocialShare = withTheme(SocialShare$1);
var ContentBlock = withTheme(ContentBlock$1);
var ProductPlanList = withTheme(ProductPlanList$1);
var ContentSnippet = withTheme(ContentSnippet$1);
var TabContentFilter = withTheme(TabContentFilter$1);
var FAQsAccordion = withTheme(FAQsAccordion$1);
var CustomerSupport = withTheme(CustomerSupport$1);
var GroupEnquiryForm = withTheme(GroupEnquiryForm$1);
var Result = withTheme(Result$1);
var ArticleCardList = withTheme(ArticleCardList$1);
var LinkList = withTheme(LinkList$1);
var TableComponent = withTheme(TableComponent$1);
var Locator = withTheme(Locator$1);
var FlexiContainer = withTheme(FlexiContainer$1);
var CardList = withTheme(CardList$1);
var RelatedArticles = withTheme(RelatedArticles$1);

export { ArticleCardList, Button, CardList, Chip, ContentBlock, ContentSnippet, CookieBanner, CustomerSupport, DisclosurePopup, Dropdown, FAQsAccordion, FlexiContainer, Footer, FormsHOC, GroupEnquiryForm, Header, LinkList, Locator, NamedIcon, ProductPlanList, RelatedArticles, Result, SocialShare, TabContentFilter, TableComponent, injectFontClassName };
